(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(global, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 298);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __rest; });
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __generator; });
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __spreadArrays */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return sym; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TASK; });
/* unused harmony export HELPER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAGA_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SELF_CANCELLATION; });
/* unused harmony export konst */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return kTrue; });
/* unused harmony export kFalse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ident; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return check; });
/* unused harmony export hasOwn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return is; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return object; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return remove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return array; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return deferred; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return arrayOfDeffered; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return delay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return createMockTask; });
/* unused harmony export autoInc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return uid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return makeIterator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return log; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return deprecate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return updateIncentive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return internalErr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return createSetContextWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return wrapSagaDispatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return cloneableGenerator; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var sym = function sym(id) {
  return '@@redux-saga/' + id;
};

var TASK = /*#__PURE__*/sym('TASK');
var HELPER = /*#__PURE__*/sym('HELPER');
var MATCH = /*#__PURE__*/sym('MATCH');
var CANCEL = /*#__PURE__*/sym('CANCEL_PROMISE');
var SAGA_ACTION = /*#__PURE__*/sym('SAGA_ACTION');
var SELF_CANCELLATION = /*#__PURE__*/sym('SELF_CANCELLATION');
var konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue = /*#__PURE__*/konst(true);
var kFalse = /*#__PURE__*/konst(false);
var noop = function noop() {};
var ident = function ident(v) {
  return v;
};

function check(value, predicate, error) {
  if (!predicate(value)) {
    log('error', 'uncaught at check', error);
    throw new Error(error);
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(object, property) {
  return is.notUndef(object) && hasOwnProperty.call(object, property);
}

var is = {
  undef: function undef(v) {
    return v === null || v === undefined;
  },
  notUndef: function notUndef(v) {
    return v !== null && v !== undefined;
  },
  func: function func(f) {
    return typeof f === 'function';
  },
  number: function number(n) {
    return typeof n === 'number';
  },
  string: function string(s) {
    return typeof s === 'string';
  },
  array: Array.isArray,
  object: function object(obj) {
    return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
  },
  promise: function promise(p) {
    return p && is.func(p.then);
  },
  iterator: function iterator(it) {
    return it && is.func(it.next) && is.func(it.throw);
  },
  iterable: function iterable(it) {
    return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
  },
  task: function task(t) {
    return t && t[TASK];
  },
  observable: function observable(ob) {
    return ob && is.func(ob.subscribe);
  },
  buffer: function buffer(buf) {
    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
  },
  pattern: function pattern(pat) {
    return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
  },
  channel: function channel(ch) {
    return ch && is.func(ch.take) && is.func(ch.close);
  },
  helper: function helper(it) {
    return it && it[HELPER];
  },
  stringableFunc: function stringableFunc(f) {
    return is.func(f) && hasOwn(f, 'toString');
  }
};

var object = {
  assign: function assign(target, source) {
    for (var i in source) {
      if (hasOwn(source, i)) {
        target[i] = source[i];
      }
    }
  }
};

function remove(array, item) {
  var index = array.indexOf(item);
  if (index >= 0) {
    array.splice(index, 1);
  }
}

var array = {
  from: function from(obj) {
    var arr = Array(obj.length);
    for (var i in obj) {
      if (hasOwn(obj, i)) {
        arr[i] = obj[i];
      }
    }
    return arr;
  }
};

function deferred() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var def = _extends({}, props);
  var promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  def.promise = promise;
  return def;
}

function arrayOfDeffered(length) {
  var arr = [];
  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }
  return arr;
}

function delay(ms) {
  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var timeoutId = void 0;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(function () {
      return resolve(val);
    }, ms);
  });

  promise[CANCEL] = function () {
    return clearTimeout(timeoutId);
  };

  return promise;
}

function createMockTask() {
  var _ref;

  var running = true;
  var _result = void 0,
      _error = void 0;

  return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
    return running;
  }, _ref.result = function result() {
    return _result;
  }, _ref.error = function error() {
    return _error;
  }, _ref.setRunning = function setRunning(b) {
    return running = b;
  }, _ref.setResult = function setResult(r) {
    return _result = r;
  }, _ref.setError = function setError(e) {
    return _error = e;
  }, _ref;
}

function autoInc() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return function () {
    return ++seed;
  };
}

var uid = /*#__PURE__*/autoInc();

var kThrow = function kThrow(err) {
  throw err;
};
var kReturn = function kReturn(value) {
  return { value: value, done: true };
};
function makeIterator(next) {
  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var isHelper = arguments[3];

  var iterator = { name: name, next: next, throw: thro, return: kReturn };

  if (isHelper) {
    iterator[HELPER] = true;
  }
  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }
  return iterator;
}

/**
  Print error in a useful way whether in a browser environment
  (with expandable error stack traces), or in a node.js environment
  (text-only log output)
 **/
function log(level, message) {
  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  /*eslint-disable no-console*/
  if (typeof window === 'undefined') {
    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
  } else {
    console[level](message, error);
  }
}

function deprecate(fn, deprecationWarning) {
  return function () {
    if (false) {}
    return fn.apply(undefined, arguments);
  };
}

var updateIncentive = function updateIncentive(deprecated, preferred) {
  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
};

var internalErr = function internalErr(err) {
  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
};

var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
};

var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    return dispatch(Object.defineProperty(action, SAGA_ACTION, { value: true }));
  };
};

var cloneableGenerator = function cloneableGenerator(generatorFunc) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var history = [];
    var gen = generatorFunc.apply(undefined, args);
    return {
      next: function next(arg) {
        history.push(arg);
        return gen.next(arg);
      },
      clone: function clone() {
        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
        history.forEach(function (arg) {
          return clonedGen.next(arg);
        });
        return clonedGen;
      },
      return: function _return(value) {
        return gen.return(value);
      },
      throw: function _throw(exception) {
        return gen.throw(exception);
      }
    };
  };
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONTACT_RECORDS_PARTIAL_LOAD = exports.CONTACT_RECORDS_LOADED = exports.CONTACT_MANUAL_LOAD = exports.DIRECTORY_SEARCH_RESULTS = exports.DIRECTORY_SERVICE_ENDPOINT = exports.WAMP_REMOVE_CONFERENCE_TOPIC = exports.WAMP_ADD_CONFERENCE_TOPIC = exports.VERIFY_WAMP_FAILURE = exports.VERIFY_WAMP_SUCCESS = exports.VERIFY_WAMP_REQUEST = exports.WAMP_SEND_TIMEOUT = exports.WAMP_UNSUBSCRIBE_SUCCESS = exports.WAMP_UNSUBSCRIBE_ERROR = exports.WAMP_UNSUBSCRIBE_BEGIN = exports.WAMP_SUBSCRIBE_SUCCESS = exports.WAMP_SUBSCRIBE_ERROR = exports.WAMP_SUBSCRIBE_BEGIN = exports.WAMP_SEND_SUCCESS = exports.WAMP_SEND_ERROR = exports.WAMP_SEND_BEGIN = exports.WAMP_CONNECTION_DISPOSED_UNEXPECTED = exports.WAMP_CONNECTION_DISPOSED_JWT_ERROR = exports.WAMP_CONNECTION_DISPOSED_HEALTHY = exports.WAMP_CONNECT_ERROR = exports.WAMP_CONNECT_SUCCESS = exports.WAMP_CONNECT_BEGIN = exports.TOKEN_REFRESH_FAILURE = exports.TOKEN_REFRESH_BEGIN = exports.NEW_TOKEN_OBTAINED = exports.TOKEN_REQUEST_FAILURE = exports.TOKEN_REQUEST_SUCCESS = exports.TOKEN_REQUEST_BEGIN = exports.LOGIN_SUPPORT_TYPE_BOTH = exports.LOGIN_SUPPORT_TYPE_SSO = exports.LOGIN_SUPPORT_TYPE_PASSWORD = exports.SSO_CHECK_FAILURE = exports.SSO_CHECK_SUCCESS = exports.SSO_CHECK_BEGIN = exports.LOGOUT_FINISHED = exports.LOGOUT_BEGIN = exports.GET_ACCOUNT_FEATURE_FLAGS_FAILURE = exports.UNAUTHORIZED = exports.AUTH_LOGOUT = exports.FEATUREFLAG_ENABLE_NOISE_SUPPRESSION = exports.FEATUREFLAG_AUTO_RESOLUTION_CHANGE = exports.FEATUREFLAG_GRAPHQL_CHAT = exports.FEATUREFLAG_ENABLE_LANGUAGE_ZH_HANT = exports.FEATUREFLAG_ENABLE_LANGUAGE_RU_RU = exports.FEATUREFLAG_ENABLE_NEW_FAVORITE_API = exports.FEATUREFLAG_ENABLE_NEW_MEETING_API = exports.FEATUREFLAG_ENABLE_ONE_TIME_MEETINGS = exports.FEATUREFLAG_CHAT_ENHANCEMENTS = exports.FEATUREFLAG_ENABLE_FECC = exports.FEATUREFLAG_ENABLE_OFFLINE_CALLING = exports.FEATUREFLAG_FORCE_TCP_TUNNELING = exports.FEATUREFLAG_USE_USER_SETTINGS_SERVICE = exports.FEATUREFLAG_DISABLE_END_AND_ANSWER = exports.FEATUREFLAG_SHOW_CUSTOMIZED_CONFERENCE_SLIDES = exports.FEATUREFLAG_SHOW_LOCAL_CONFERENCE_SLIDES = exports.FEATUREFLAG_USE_DIRECTORY_SERVICE = exports.SET_FEATURE_FLAGS = exports.CLIENT_ID_DASH_REMOTE = exports.CLIENT_ID_DASH_DISPLAY = exports.CLIENT_ID_GEMS = exports.CLIENT_ID_MOBILE_ANDROID = exports.CLIENT_ID_MOBILE_IOS = exports.CLIENT_ID_ELECTRON_WINDOWS = exports.CLIENT_ID_ELECTRON_MAC = exports.MIXPANEL_STAGE = exports.MIXPANEL_PREVIEW = exports.MIXPANEL_PROD = exports.APP_BACKGROUNDED = exports.APP_FOREGROUNDED = exports.NETWORK_OFFLINE_CALL_TIMEOUT_MS = exports.NETWORK_STATUS_OFFLINE = exports.NETWORK_STATUS_ONLINE = exports.NETWORK_OFFLINE = exports.NETWORK_ONLINE = exports.DEV_CLUSTER_URL = exports.STAGING_CLUSTER_URL = exports.PROD_CLUSTER_URL = exports.GEMS_SOFTWARE_UPDATE = exports.GEMS_SOFTWARE_UPDATE_TOPIC = exports.BROWSER_TYPE_IE11 = exports.BROWSER_TYPE_CHROME = exports.PLATFORM_DASH = exports.PLATFORM_ICON_900 = exports.PLATFORM_ICON_700 = exports.PLATFORM_ICON_500 = exports.PLATFORM_ICON_300 = exports.PLATFORM_OSX = exports.PLATFORM_WINDOWS = exports.PLATFORM_ANDROID = exports.PLATFORM_IOS = exports.PLATFORM_WEB = exports.rtcSignalingState = exports.rtcDataChannelState = exports.rtcIceConnectionState = exports.Logger = exports.dataChannel = void 0;
exports.ACQUIRE_LOCAL_PRIMARY_STREAM_SUCCESS = exports.ACQUIRE_LOCAL_PRIMARY_STREAM_BEGIN = exports.VIDEO_PLAYBACK_STARTED = exports.VIDEO_PLAYBACK_BLOCKED = exports.SET_SELECTED_AUDIO_SOURCE_ID = exports.SET_SELECTED_VIDEO_SOURCE_ID = exports.SET_PRIMARY_AUDIO_OUTPUT_ID = exports.SET_PRIMARY_AUDIO_SOURCE_ID = exports.SET_VIDEO_SOURCE_QUALITY = exports.SET_PRIMARY_VIDEO_SOURCE_ID = exports.SET_DEFAULT_AUDIO = exports.SET_DEFAULT_VIDEO = exports.MEDIA_DEVICES_UPDATED = exports.SOCKET_SLIDE_PARTICIPANTKICK = exports.MEETING_LAYOUT_TYPES = exports.GET_CUSTOMINVITE_PREVIEW_SUCCESS = exports.GET_CUSTOMINVITE_PREVIEW_REQUEST = exports.GET_CUSTOMINVITE_PREVIEW_FAILURE = exports.GET_CUSTOMINVITE_PREVIEW_URI_SUFFIX = exports.SET_ACCOUNT_SETTINGS_FAILURE = exports.SET_ACCOUNT_SETTINGS_SUCCESS = exports.SET_ACCOUNT_SETTINGS_REQUEST = exports.GET_ACCOUNT_SETTINGS_FAILURE = exports.GET_ACCOUNT_SETTINGS_SUCCESS = exports.GET_ACCOUNT_SETTINGS_REQUEST = exports.ACCOUNT_SETTINGS_URI_SUFFIX = exports.ACCOUNT_SETTINGS_ENDPOINT = exports.MEETING_TYPE_ONE_TIME = exports.MEETING_TYPE_VMR = exports.CONFERENCE_STOP_RECORDING = exports.CONFERENCE_START_RECORDING = exports.VALIDATE_REQUIRED = exports.VALIDATE_MINLENGTH = exports.VALIDATE_MAXLENGTH = exports.VALIDATE_DUPLICATE = exports.VALIDATE_PATTERN = exports.RESET_CONTACT_ERROR_STATE = exports.DELETE_CONTACT = exports.VALIDATE_CONTACT_ERROR = exports.VALIDATE_CONTACT_SUCCESS = exports.SAVE_CONTACT_ERROR = exports.SAVE_CONTACT_SUCCESS = exports.SAVE_CONTACT_BEGIN = exports.SERVER_PUSH_DELETE_CALLHISTORY = exports.SERVER_PUSH_ADD_CALLHISTORY = exports.SET_LOCALE = exports.SEARCHSTRING_UPDATE = exports.CALL_HISTORY_VIEWED = exports.CALL_HISTORY_BATCH_DELETE_FAILED = exports.CALL_HISTORY_BATCH_DELETE_SUCCESS = exports.CALL_HISTORY_BATCH_DELETE_BEGIN = exports.CALL_HISTORY_MISSED = exports.CALL_HISTORY_OUTGOING = exports.CALL_HISTORY_INCOMING = exports.USAGE_TYPE_SHARED = exports.USAGE_TYPE_PERSONAL = exports.CONTACT_CATEGORY_GROUP = exports.CONTACT_CATEGORY_PERSONAL = exports.CONTACT_TYPE_GROUP_CONTACT = exports.CONTACT_TYPE_PERSONAL_CONTACT = exports.CONTACT_TYPE_ROOMSYSTEM = exports.CONTACT_TYPE_USER = exports.CONTACT_TYPE_MEETING = exports.CONTACT_TYPE_STANDARD = exports.CONTACT_DO_NOT_DISTURB = exports.CONTACT_AVAILABLE = exports.CONTACT_NOTIFICATION_DELETED = exports.CONTACT_NOTIFICATION_UPDATED = exports.CONTACT_NOTIFICATION_CREATED = exports.CONTACT_PARTICIPANT_COUNT_UPDATE = exports.CONTACT_ACTION_DELETED = exports.CONTACT_ACTION_UPDATED = exports.CONTACT_ACTION_CREATED = exports.CONTACT_NOTIFICATION = exports.CONTACT_TOPIC = exports.AVAILABILITY_BATCH_DELAY_WEB = exports.AVAILABILITY_BATCH_DELAY_MOBILE = exports.AVAILABILITY_STATUS_AWAY = exports.AVAILABILITY_STATUS_UNAVAILABLE = exports.AVAILABILITY_STATUS_AVAILABLE = exports.AVAILABILITY_STATUS_SUFFIX = exports.AVAILABILITY_POST_SUCCESS = exports.AVAILABILITY_POST_ERROR = exports.AVAILABILITY_POST_BEGIN = exports.AVAILABILITY_UPDATE = exports.AVAILABILITY_TOPIC = exports.AVAILABILITY_ENDPOINT = exports.CONTACTS_DEFAULT_SMALL_PAGE_SIZE = exports.CONTACTS_DEFAULT_PAGE_SIZE = exports.CONTACTS_PAGE_FETCHED = exports.CONTACTS_FETCH_PAGINATED_FAILURE = exports.CONTACTS_FETCH_PAGINATED_SUCCESS = exports.CONTACTS_FETCH_PAGINATED_REQUEST = exports.BATCHED_USER_PRESENCE_UPDATE = exports.BATCHED_CONTACT_PRESENCE_UPDATE = exports.CONTACT_PRESENCE_UPDATE = exports.CONTACTS_LOADED_FROM_CACHE = exports.CONTACTS_FETCH_NEXT_FAILED = exports.CONTACTS_FETCH_NEXT_RESULT = exports.CONTACTS_FETCH_NEXT_BEGIN = void 0;
exports.ACTIVE_CONFERENCE_TOPIC = exports.ACCOUNT_SETTING_UPDATED = exports.ACCOUNT_TOPIC = exports.ACCOUNT_FEATURE_STREAMING = exports.ACCOUNT_FEATURE_SSO = exports.ACCOUNT_FEATURE_RECORDING = exports.ACCOUNT_FEATURE_GALAXY = exports.ACCOUNT_FEATURE_ONE_TIME_MEETING = exports.ACCOUNT_FEATURE_DIRECT_MEDIA = exports.ACCOUNT_FEATURES = exports.FEATURE_SERVICE_ENDPOINT = exports.MONITORING_PUT_GROUP_SETTINGS_FAILURE = exports.MONITORING_PUT_GROUP_SETTINGS_SUCCESS = exports.MONITORING_PUT_GROUP_SETTINGS_BEGIN = exports.MONITORING_GET_GROUP_SETTINGS_FAILURE = exports.MONITORING_GET_GROUP_SETTINGS_SUCCESS = exports.MONITORING_GET_GROUP_SETTINGS_BEGIN = exports.MONITORING_GROUP_SETTINGS_URL_SUFFIX = exports.MONITORING_CHANGE_FAILURE = exports.MONITORING_CHANGE_SUCCESS = exports.MONITORING_CHANGE_BEGIN = exports.MONITORING_CHANGE_URL_SUFFIX = exports.MONITORING_CHECKIN_FAILURE = exports.MONITORING_CHECKIN_SUCCESS = exports.MONITORING_CHECKIN_BEGIN = exports.MONITORING_CHECKIN_URL_SUFFIX = exports.MONITORING_SERVICE_ENDPOINT = exports.SELECT_COUNTRY_NUMBER = exports.PERMISSION_DISMISSED_ERROR = exports.PERMISSION_DENIED_ERROR = exports.UNKNOWN_NAVIGATORUSERMEDIAERROR = exports.MISSING_PRESENTATION_TRACK = exports.MISSING_VIDEO_TRACK = exports.MISSING_AUDIO_TRACK = exports.ERROR_GENERATING_RTC_CERTIFICATE = exports.CHAT_TOPIC = exports.CHAT_EVENT = exports.CHAT_LAST_READ_AT = exports.CHAT_RECEIVED_MESSAGE = exports.CHAT_GET_MESSAGES_FAILURE = exports.CHAT_GET_MESSAGES_SUCCESS = exports.CHAT_GET_MESSAGES_BEGIN = exports.CHAT_GET_ROOMS_FAILURE = exports.CHAT_GET_ROOMS_SUCCESS = exports.CHAT_GET_ROOMS_BEGIN = exports.CHAT_POST_MESSAGE_FAILURE = exports.CHAT_POST_MESSAGE_SUCCESS = exports.CHAT_POST_MESSAGE_BEGIN = exports.CHAT_USER_LEFT_ROOM = exports.CHAT_USER_JOINED_ROOM = exports.CHAT_LEFT_ROOM = exports.CHAT_JOINED_ROOM = exports.CHAT_EVENT_MESSAGE = exports.CHAT_EVENT_USER_JOINED_ROOM = exports.CHAT_EVENT_USER_LEFT_ROOM = exports.CHAT_EVENT_JOINED_ROOM = exports.WAMP_SUBSCRIPTION_NOT_FOUND = exports.WAMP_JWT_ERROR_REASON = exports.CONFERENCE_SLIDE_UPDATE = exports.CALL_STATE_LOCAL_RINGING = exports.CALL_STATE_CALLING = exports.CALL_STATE_CONNECTING = exports.CALL_STATE_CONNECTED = exports.CALL_STATE_FAILED = exports.CALL_STATE_DISCONNECTED = exports.WIRELESS_PRESENTATION_STREAM_ENDED = exports.WIRELESS_PRESENTATION_ON_STREAM = exports.REMOTE_PRESENTATION_STREAM_AVAILABLE = exports.RESET_LOCAL_SSRCS = exports.UPDATE_LOCAL_SSRCS = exports.RTC_REMOTE_PRESENTATION_STREAM_REMOVED = exports.RTC_REMOTE_PRESENTATION_STREAM_ADDED = exports.RTC_REMOTE_STREAM_REMOVED = exports.RTC_REMOTE_STREAM_UPDATED = exports.RTC_REMOTE_STREAM_ADDED = exports.ACTIVE_PEER_CONNECTION = exports.LOCAL_AUDIO_UNMUTED = exports.LOCAL_AUDIO_MUTED = exports.LOCAL_VIDEO_UNMUTED = exports.LOCAL_VIDEO_MUTED = exports.SWITCH_VIDEO_CAMERA = exports.TOGGLE_AUDIO_MUTE = exports.DISABLE_WEB_CONFERENCE_MODE = exports.ENABLE_WEB_CONFERENCE_MODE = exports.LOCAL_STREAM_ENDED = exports.LOCAL_STREAM_UPDATED = exports.END_LOCAL_STREAM = exports.SET_LOCAL_STREAM = exports.CALLSTATSIO_STATS_UPDATE = exports.RTCSTATS_STOPPED = exports.RTCSTATS_STARTED = exports.UPDATE_SSRC_RECEIVE_STATS = exports.UPDATE_SSRC_SEND_STATS = exports.UPDATE_AVAILABLE_BANDWIDTH = exports.UPDATE_ROUND_TRIP_TIME_AVERAGE = exports.GETUSERMEDIA_PENDING_PERMISSIONS = exports.ACQUIRE_LOCAL_SECONDARY_STREAM_FAILURE = exports.ACQUIRE_LOCAL_SECONDARY_STREAM_SUCCESS = exports.ACQUIRE_LOCAL_SECONDARY_STREAM_BEGIN = exports.ACQUIRE_LOCAL_PRIMARY_STREAM_FAILURE = void 0;
exports.DELETE_PERSONAL_CONTACT_SUCCESS = exports.DELETE_PERSONAL_CONTACT_BEGIN = exports.DELETE_PERSONAL_CONTACT_URL_SUFFIX = exports.UPDATE_PERSONAL_CONTACT_FAILURE = exports.UPDATE_PERSONAL_CONTACT_SUCCESS = exports.UPDATE_PERSONAL_CONTACT_BEGIN = exports.UPDATE_PERSONAL_CONTACT_URL_SUFFIX = exports.CREATE_PERSONAL_CONTACT_FAILURE = exports.CREATE_PERSONAL_CONTACT_SUCCESS = exports.CREATE_PERSONAL_CONTACT_BEGIN = exports.CREATE_PERSONAL_CONTACT_URL_SUFFIX = exports.PERSONAL_CONTACTS_HANDLER_ENDPOINT = exports.PUSH_INVITATION_PATH = exports.PUSH_SERVICE_ENDPOINT = exports.USER_INVITE_TOKEN_FAILURE = exports.USER_INVITE_TOKEN_SUCCESS = exports.USER_INVITE_TOKEN_BEGIN = exports.USER_INVITE_TOKEN_ENDPOINT = exports.MEETING_HANDLER_ENDPOINT = exports.CALENDAR_NO_SUBSCRIPTION = exports.CALENDAR_TOPIC = exports.CALENDAR_ENDPOINT = exports.GET_EXTENSION_INVITE_TEXT_FAILURE = exports.GET_EXTENSION_INVITE_TEXT_SUCCESS = exports.GET_EXTENSION_INVITE_TEXT_REQUEST = exports.GET_EXTENSION_INVITE_TEXT_URI = exports.CALLHISTORY_ADD_EXTERNAL_ENTRY_FAILURE = exports.CALLHISTORY_ADD_EXTERNAL_ENTRY_SUCCESS = exports.CALLHISTORY_ADD_EXTERNAL_ENTRY_REQUEST = exports.CALLHISTORY_DELETE_FAILURE = exports.CALLHISTORY_DELETE_SUCCESS = exports.CALLHISTORY_DELETE_BEGIN = exports.CALLHISTORY_DELETEALL_FAILURE = exports.CALLHISTORY_DELETEALL_SUCCESS = exports.CALLHISTORY_DELETEALL_BEGIN = exports.CALLHISTORY_LOAD_FAILURE = exports.CALLHISTORY_LOAD_SUCCESS = exports.CALLHISTORY_LOAD_BEGIN = exports.CALLHISTORY_URL_SUFFIX = exports.CALLHISTORY_RPC_ENDPOINT = exports.WAMP_SUBSCRIPTION_CALLHISTORY_EVENT = exports.CALLHISTORY_TOPIC = exports.WAMP_SUBSCRIPTION_PHONEHD_CUSTOMIZATION_EVENT = exports.PHONEHD_CUSTOMIZATION_ENDPOINT = exports.PHONEHD_CUSTOMIZATION_TOPIC = exports.USER_SERVICE_ERROR_RESET = exports.USER_SERVICE_UPDATE_FAILURE = exports.USER_SERVICE_UPDATE_SUCCESS = exports.USER_SERVICE_UPDATE_REQUEST = exports.USER_SERVICE_DELETE_LIST_FAILURE = exports.USER_SERVICE_DELETE_LIST_SUCCESS = exports.USER_SERVICE_DELETE_LIST_REQUEST = exports.USER_SERVICE_DELETE_FAILURE = exports.USER_SERVICE_DELETE_SUCCESS = exports.USER_SERVICE_DELETE_REQUEST = exports.USER_SERVICE_CREATE_FAILURE = exports.USER_SERVICE_CREATE_SUCCESS = exports.USER_SERVICE_CREATE_REQUEST = exports.USER_SERVICE_URI_SUFFIX_UPDATE = exports.USER_SERVICE_URI_SUFFIX_DELETE_LIST = exports.USER_SERVICE_URI_SUFFIX_DELETE = exports.USER_SERVICE_URI_SUFFIX_CREATE = exports.USER_SERVICE_NAME = exports.NAME_UPDATED = exports.DEVICE_INFO_NAME_CHANGE = exports.PAIRING_SUCCESSFUL = exports.GET_INVITATION_LINK = exports.API_STREAMING_SETTINGS_SUFFIX = exports.API_STREAMING_SETTINGS = exports.GET_QNA_TRANSCRIPT_SUFFIX = exports.GET_QNA_TRANSCRIPT = exports.GET_ALL_STREAMS = exports.GET_PAIRING_STATUS_AND_DETAILS = exports.GET_PAIRING_CODE = exports.MMS_API_FAILURE = exports.MMS_API_SUCCESS = exports.MMS_API_BEGIN = exports.GET_CURRENT_USER_SETTINGS_FAILURE = exports.GET_CURRENT_USER_SETTINGS_SUCCESS = exports.GET_CURRENT_USER_SETTINGS_BEGIN = exports.UPDATE_CURRENT_USER_SETTINGS_FAILURE = exports.UPDATE_CURRENT_USER_SETTINGS_SUCCESS = exports.UPDATE_CURRENT_USER_SETTINGS_BEGIN = exports.USER_SETTINGS_ENDPOINT = exports.WAMP_SUBSCRIPTION_ACTION_ME_TOPIC = exports.ME_TOPIC = exports.USER_ROLE_GUEST = exports.USER_ROLE_USER = exports.USER_ROLE_SUPER_USER = exports.USER_ROLE_DEVICE = exports.USER_ROLE_ADMIN = exports.USER_CONTEXT_REMOTE = exports.USER_CONTEXT_USER = exports.USER_CONTEXT_DEVICE = exports.GET_SESSION_FAILURE = exports.GET_SESSION_SUCCESS = exports.GET_SESSION_REQUEST = exports.CHECKIN_SERVICE_ATTRIBUTES_SUFFIX = exports.CHECKIN_SERVICE_ENDPOINT = exports.ACTIVE_CONFERENCE_NOTIFICATION = void 0;
exports.VC_HOST_ENDPOINT_PROD = exports.MEETING_RECORDING_PROPS_ENDPOINT = exports.SHARE_URLS_ENDPOINT = exports.VIDEO_PROPERTIES_ENDPOINT = exports.VIDEO_LIKE_ENDPOINT = exports.RECORDINGS_FETCH_RELATED_ENDPOINT = exports.RECORDINGS_DELETE_ENDPOINT = exports.RECORDINGS_ADD_TO_WATCH_ENDPOINT = exports.SEARCH_CLOUD_MEETINGS_ENDPOINT = exports.SEARCH_CLOUD_USERS_ENDPOINT = exports.RECORDINGS_FETCH_SINGLE_ENDPOINT = exports.RECORDINGS_FETCH_ENDPOINT = exports.VC_SETTINGS_UPDATE_SUCCESS = exports.VC_SETTINGS_UPDATE_FAILED = exports.VC_SETTINGS_UPDATE_BEGIN = exports.VC_SETTINGS_FETCH_SUCCESS = exports.VC_SETTINGS_FETCH_FAILED = exports.VC_SETTINGS_FETCH_BEGIN = exports.RECORDING_AUTH_SET_URI_SUFFIX = exports.RECORDING_AUTH_URI_SUFFIX = exports.RECORDING_AUTH_ENDPOINT = exports.ALEXA_SET_USERCODE = exports.ALEXA_UNREGISTER = exports.ALEXA_GENERATE_USERCODE = exports.WAMP_ALEXA_DEVICE_EVENT = exports.ALEXA_ENDPOINT = exports.ALEXA_TOPIC = exports.SEND_CORONER_URL_SUFFIX = exports.SEND_CORONER_URL_FAILURE = exports.SEND_CORONER_URL_SUCCESS = exports.SEND_CORONER_URL_BEGIN = exports.SEND_CORONER_URL_ENDPOINT = exports.GET_UPLOAD_URL = exports.SET_DEVICE_INFO = exports.SET_DEVICE_CAMERA_CAPABILITIES = exports.SET_DEVICE_SCREEN_COUNT = exports.WAMP_SUBSCRIPTION_DEVICE_EVENT = exports.DEVICE_TOPIC = exports.SET_CUSTOM_PRESENTATION_BW_PERCENTAGE = exports.SET_CUSTOM_CALL_BANDWIDTH = exports.SET_CUSTOM_GROUP_UUID = exports.FECC_TYPE_CAMERA_CONTROL = exports.FECC_ACTION_FOCUS_IN = exports.FECC_ACTION_FOCUS_OUT = exports.FECC_ACTION_ZOOM_IN = exports.FECC_ACTION_ZOOM_OUT = exports.FECC_ACTION_TILT_UP = exports.FECC_ACTION_TILT_DOWN = exports.FECC_ACTION_PAN_RIGHT = exports.FECC_ACTION_PAN_LEFT = exports.FECC_ACTION_TYPE_STOP = exports.FECC_ACTION_TYPE_CONTINUE = exports.FECC_ACTION_TYPE_START = exports.FECC_ENABLED = exports.NUCLEUS_PRESENTATION_STREAM_LABEL = exports.NUCLEUS_VIDEO_STREAM_LABEL = exports.GQL_MUTATION = exports.GQL_QUERY = exports.GQL_GET_CLIENT = exports.REDUX_STORAGE_SAVE = exports.REDUX_STORAGE_LOAD = exports.LOCAL_PRESENTATION_STREAM_ENDED = exports.LOCAL_PRESENTATION_STREAM_UPDATED = exports.LOCAL_PRESENTATION_STREAM_ACQUIRED = exports.X_LIFESIZE_PRES_ATTR = exports.VIDEO_LABEL = exports.PRESENTATION_LABEL = exports.REATTACH_PRESENTATION = exports.TOGGLE_DO_NOT_DISTURB = exports.INIT_NUCLEUS = exports.PARTICIPANT_KICKED = exports.PARTICIPANT_SEARCHING = exports.PARTICIPANT_CONNECTED = exports.PARTICIPANT_IVR = exports.CLOCK_TICK_SEC = exports.CLOCK_TICK_MIN = exports.DELETE_FAVORITES_FAILURE = exports.DELETE_FAVORITES_SUCCESS = exports.DELETE_FAVORITES_BEGIN = exports.ADD_FAVORITES_FAILURE = exports.ADD_FAVORITES_SUCCESS = exports.ADD_FAVORITES_BEGIN = exports.GET_FAVORITES_FAILURE = exports.GET_FAVORITES_SUCCESS = exports.GET_FAVORITES_BEGIN = exports.FAVORITE_HANDLER_ENDPOINT = exports.DELETE_GROUP_CONTACT_FAILURE = exports.DELETE_GROUP_CONTACT_SUCCESS = exports.DELETE_GROUP_CONTACT_BEGIN = exports.DELETE_GROUP_CONTACT_URL_SUFFIX = exports.UPDATE_GROUP_CONTACT_FAILURE = exports.UPDATE_GROUP_CONTACT_SUCCESS = exports.UPDATE_GROUP_CONTACT_BEGIN = exports.UPDATE_GROUP_CONTACT_URL_SUFFIX = exports.CREATE_GROUP_CONTACT_FAILURE = exports.CREATE_GROUP_CONTACT_SUCCESS = exports.CREATE_GROUP_CONTACT_BEGIN = exports.CREATE_GROUP_CONTACT_URL_SUFFIX = exports.GROUP_CONTACTS_HANDLER_ENDPOINT = exports.DELETE_PERSONAL_CONTACT_FAILURE = void 0;
exports.DWH_FETCH_USERS_GROUP_CALLS_ROOMS_FAILED = exports.DWH_FETCH_USERS_GROUP_CALLS_ROOMS_BEGIN = exports.DWH_FETCH_USERS_GROUP_CALLS_PERSONAL_SUCCESS = exports.DWH_FETCH_USERS_GROUP_CALLS_PERSONAL_FAILED = exports.DWH_FETCH_USERS_GROUP_CALLS_PERSONAL_BEGIN = exports.DWH_FETCH_SUMMARY_SUCCESS = exports.DWH_FETCH_SUMMARY_FAILED = exports.DWH_FETCH_SUMMARY_BEGIN = exports.DWH_FETCH_CONFERENCES_SUCCESS = exports.DWH_FETCH_CONFERENCES_FAILED = exports.DWH_FETCH_CONFERENCES_BEGIN = exports.DWH_FETCH_CALLS_SUCCESS_PLAN = exports.DWH_FETCH_CALLS_FAILED_PLAN = exports.DWH_FETCH_CALLS_BEGIN_PLAN = exports.DWH_FETCH_CALLS_SUCCESS_DAYS_DEVICES = exports.DWH_FETCH_CALLS_FAILED_DAYS_DEVICES = exports.DWH_FETCH_CALLS_BEGIN_DAYS_DEVICES = exports.DWH_FETCH_CALLS_SUCCESS_DAYS = exports.DWH_FETCH_CALLS_FAILED_DAYS = exports.DWH_FETCH_CALLS_BEGIN_DAYS = exports.DATA_WAREHOUSE_PRODUCTION_ENDPOINT = exports.DATA_WAREHOUSE_STAGING_ENDPOINT = exports.SEND_WALLPAPER_URL_SUFFIX = exports.SEND_WALLPAPER_URL_FAILURE = exports.SEND_WALLPAPER_URL_SUCCESS = exports.SEND_WALLPAPER_URL_BEGIN = exports.SEND_WALLPAPER_URL_ENDPOINT = exports.GET_EXISTING_WALLPAPER_URL_SUFFIX = exports.GET_EXISTING_WALLPAPER_URL_FAILURE = exports.GET_EXISTING_WALLPAPER_URL_SUCCESS = exports.GET_EXISTING_WALLPAPER_URL_BEGIN = exports.GET_EXISTING_WALLPAPER_URL_ENDPOINT = exports.GET_UPLOAD_WALLPAPER_URL_SUFFIX = exports.GET_UPLOAD_WALLPAPER_URL_FAILURE = exports.GET_UPLOAD_WALLPAPER_URL_SUCCESS = exports.GET_UPLOAD_WALLPAPER_URL_BEGIN = exports.GET_UPLOAD_WALLPAPER_URL_ENDPOINT = exports.VIDEO_POST_MEETING_SHARE_PROPS_SUCCESS = exports.VIDEO_POST_MEETING_SHARE_PROPS_FAILED = exports.VIDEO_POST_MEETING_SHARE_PROPS_BEGIN = exports.VIDEO_GET_MEETING_SHARE_PROPS_SUCCESS = exports.VIDEO_GET_MEETING_SHARE_PROPS_FAILED = exports.VIDEO_GET_MEETING_SHARE_PROPS_BEGIN = exports.VIDEO_UPDATE_SHARE_PROPS_SUCCESS = exports.VIDEO_UPDATE_SHARE_PROPS_FAILED = exports.VIDEO_UPDATE_SHARE_PROPS_BEGIN = exports.VIDEO_GET_SHARE_LINK_GLOBAL_SUCCESS = exports.VIDEO_GET_SHARE_LINK_GLOBAL_FAILED = exports.VIDEO_GET_SHARE_LINK_GLOBAL_BEGIN = exports.VIDEO_GET_SHARE_LINK_GROUP_SUCCESS = exports.VIDEO_GET_SHARE_LINK_GROUP_FAILED = exports.VIDEO_GET_SHARE_LINK_GROUP_BEGIN = exports.VIDEO_GET_SHARE_PROPS_SUCCESS = exports.VIDEO_GET_SHARE_PROPS_FAILED = exports.VIDEO_GET_SHARE_PROPS_BEGIN = exports.VIDEO_GET_CLOUD_MEETINGS_SUCCESS = exports.VIDEO_GET_CLOUD_MEETINGS_FAILED = exports.VIDEO_GET_CLOUD_MEETINGS_BEGIN = exports.VIDEO_GET_CLOUD_USERS_SUCCESS = exports.VIDEO_GET_CLOUD_USERS_FAILED = exports.VIDEO_GET_CLOUD_USERS_BEGIN = exports.RESET_VIDEO_PROPS_ERROR_STATE = exports.VIDEO_SET_PROPS_SUCCESS = exports.VIDEO_SET_PROPS_FAILED = exports.VIDEO_SET_PROPS_BEGIN = exports.VIDEO_GET_PROPS_SUCCESS = exports.VIDEO_GET_PROPS_FAILED = exports.VIDEO_GET_PROPS_BEGIN = exports.VIDEO_LIKE_SUCCESS = exports.VIDEO_LIKE_FAILED = exports.VIDEO_LIKE_BEGIN = exports.RECORDINGS_LOOKUP_USER_SUCCESS = exports.RECORDINGS_LOOKUP_USER_FAILED = exports.RECORDINGS_LOOKUP_USER_BEGIN = exports.RESET_RECORDINGS_DELETE_ERROR_STATE = exports.RECORDINGS_DELETE_RECORDING_SUCCESS = exports.RECORDINGS_DELETE_RECORDING_FAILED = exports.RECORDINGS_DELETE_RECORDING_BEGIN = exports.RECORDINGS_REMOVE_FROM_WATCHLIST_SUCCESS = exports.RECORDINGS_REMOVE_FROM_WATCHLIST_FAILED = exports.RECORDINGS_REMOVE_FROM_WATCHLIST_BEGIN = exports.RECORDINGS_ADD_TO_WATCHLIST_SUCCESS = exports.RECORDINGS_ADD_TO_WATCHLIST_FAILED = exports.RECORDINGS_ADD_TO_WATCHLIST_BEGIN = exports.RECORDINGS_FETCH_RELATED_SUCCESS = exports.RECORDINGS_FETCH_RELATED_FAILED = exports.RECORDINGS_FETCH_RELATED_BEGIN = exports.RECORDINGS_FETCH_SINGLE_SUCCESS = exports.RECORDINGS_FETCH_SINGLE_FAILED = exports.RECORDINGS_FETCH_SINGLE_BEGIN = exports.RECORDINGS_FETCH_MY_RECORDINGS_SUCCESS = exports.RECORDINGS_FETCH_MY_RECORDINGS_FAILED = exports.RECORDINGS_FETCH_MY_RECORDINGS_BEGIN = exports.RECORDINGS_FETCH_WATCH_LIST_SUCCESS = exports.RECORDINGS_FETCH_WATCH_LIST_FAILED = exports.RECORDINGS_FETCH_WATCH_LIST_BEGIN = exports.RECORDINGS_FETCH_FEED_SUCCESS = exports.RECORDINGS_FETCH_FEED_FAILED = exports.RECORDINGS_FETCH_FEED_BEGIN = exports.VC_HOST_ENDPOINT_NON_PROD = void 0;
exports.RESET_MEETING_ERROR_STATE = exports.DELETE_MEETING_FAILURE = exports.DELETE_MEETING_SUCCESS = exports.DELETE_MEETING_BEGIN = exports.UPDATE_MEETING_SUFFIX = exports.UPDATE_MEETING_FAILURE = exports.UPDATE_MEETING_SUCCESS = exports.UPDATE_MEETING_BEGIN = exports.CREATE_MEETING_SUFFIX = exports.CREATE_MEETING_FAILURE = exports.CREATE_MEETING_SUCCESS = exports.CREATE_MEETING_BEGIN = exports.MEETINGS_ENDPOINT = exports.PSTN_SERVICE_ADMIN_ENDPOINT = exports.PSTN_SERVICE_ENDPOINT = exports.SET_MEETING_INACTIVE_DAYS_OTM_FAILURE = exports.SET_MEETING_INACTIVE_DAYS_OTM_SUCCESS = exports.SET_MEETING_INACTIVE_DAYS_OTM_BEGIN = exports.SET_MEETING_INACTIVE_DAYS_FAILURE = exports.SET_MEETING_INACTIVE_DAYS_SUCCESS = exports.SET_MEETING_INACTIVE_DAYS_BEGIN = exports.GET_MEETING_INACTIVE_DAYS_FAILURE = exports.GET_MEETING_INACTIVE_DAYS_SUCCESS = exports.GET_MEETING_INACTIVE_DAYS_BEGIN = exports.GET_MEETING_SETTINGS_FAILURE = exports.GET_MEETING_SETTINGS_SUCCESS = exports.GET_MEETING_SETTINGS_BEGIN = exports.MEETING_SETTINGS_ENDPOINT = exports.RENAME_DEVICE_SUFFIX = exports.RENAME_DEVICE_FAILURE = exports.RENAME_DEVICE_SUCCESS = exports.RENAME_DEVICE_BEGIN = exports.DEVICE_PAIRING_RESET_ERROR_STATE = exports.DEVICE_SHARED_PAIRING_SUFFIX = exports.DEVICE_PAIRING_SUFFIX = exports.DEVICE_PAIRING_FAILURE = exports.DEVICE_PAIRING_SUCCESS = exports.DEVICE_PAIRING_BEGIN = exports.GET_PAIRED_DEVICE_LICENSE_COUNT_FAILURE = exports.GET_PAIRED_DEVICE_LICENSE_COUNT_SUCCESS = exports.GET_PAIRED_DEVICE_LICENSE_COUNT_BEGIN = exports.REMOVE_DEVICE_SUFFIX = exports.REMOVE_DEVICE_FAILURE = exports.REMOVE_DEVICE_SUCCESS = exports.REMOVE_DEVICE_BEGIN = exports.DELETE_DEVICE_PAIRING_SUFFIX = exports.DELETE_DEVICE_PAIRING_FAILURE = exports.DELETE_DEVICE_PAIRING_SUCCESS = exports.DELETE_DEVICE_PAIRING_BEGIN = exports.GET_PAIRED_DEVICES_SUFFIX = exports.GET_PAIRED_DEVICES_FAILURE = exports.GET_PAIRED_DEVICES_SUCCESS = exports.GET_PAIRED_DEVICES_BEGIN = exports.PAIRED_DEVICE_LICENSES_COUNT_SUFFIX = exports.PAIRED_DEVICE_LICENSES_ENDPOINT = exports.PAIRED_DEVICES_ENDPOINT = exports.DWH_USAGEDETAILS_TYPES = exports.DWH_USAGEDETAILS_USER_SUCCESS = exports.DWH_USAGEDETAILS_USER_REQUEST = exports.DWH_USAGEDETAILS_USER_FAILURE = exports.DWH_USAGEDETAILS_ROOM_SUCCESS = exports.DWH_USAGEDETAILS_ROOM_REQUEST = exports.DWH_USAGEDETAILS_ROOM_FAILURE = exports.DWH_STREAM_VIEWERS_SUCCESS = exports.DWH_STREAM_VIEWERS_REQUEST = exports.DWH_STREAM_VIEWERS_FAILURE = exports.DWH_STREAM_SETTINGS_SET_SUCCESS = exports.DWH_STREAM_SETTINGS_SET_REQUEST = exports.DWH_STREAM_SETTINGS_SET_FAILURE = exports.DWH_STREAM_SETTINGS_SUCCESS = exports.DWH_STREAM_SETTINGS_REQUEST = exports.DWH_STREAM_SETTINGS_FAILURE = exports.DWH_STREAM_QUESTIONS_SUCCESS = exports.DWH_STREAM_QUESTIONS_REQUEST = exports.DWH_STREAM_QUESTIONS_FAILURE = exports.DWH_STREAM_METADATA_SUCCESS = exports.DWH_STREAM_METADATA_REQUEST = exports.DWH_STREAM_METADATA_FAILURE = exports.DWH_STREAM_HISTORY_SUCCESS = exports.DWH_STREAM_HISTORY_REQUEST = exports.DWH_STREAM_HISTORY_FAILURE = exports.DWH_ALL_STREAMS_SUCCESS = exports.DWH_ALL_STREAMS_REQUEST = exports.DWH_ALL_STREAMS_FAILURE = exports.DWH_FETCH_STREAMS_SUCCESS_USAGE = exports.DWH_FETCH_STREAMS_FAILED_USAGE = exports.DWH_FETCH_STREAMS_BEGIN_USAGE = exports.DWH_FETCH_STREAMS_SUCCESS_LIST = exports.DWH_FETCH_STREAMS_FAILED_LIST = exports.DWH_FETCH_STREAMS_BEGIN_LIST = exports.DWH_FETCH_USERS_FILTER_ACTIVE_TOTAL_SUCCESS = exports.DWH_FETCH_USERS_FILTER_ACTIVE_TOTAL_FAILED = exports.DWH_FETCH_USERS_FILTER_ACTIVE_TOTAL_BEGIN = exports.DWH_FETCH_USERS_GROUP_MINUTES_ROOMS_SUCCESS = exports.DWH_FETCH_USERS_GROUP_MINUTES_ROOMS_FAILED = exports.DWH_FETCH_USERS_GROUP_MINUTES_ROOMS_BEGIN = exports.DWH_FETCH_USERS_GROUP_MINUTES_PERSONAL_SUCCESS = exports.DWH_FETCH_USERS_GROUP_MINUTES_PERSONAL_FAILED = exports.DWH_FETCH_USERS_GROUP_MINUTES_PERSONAL_BEGIN = exports.DWH_FETCH_USERS_GROUP_CALLS_ROOMS_SUCCESS = void 0;
exports.GALAXY_ADD_RESPONSE_ACTION_TIMEOUT = exports.GALAXY_ADD_RESPONSE_ACTION_CONNECTED = exports.GALAXY_INVITEE_STATE_FAILED = exports.GALAXY_INVITEE_STATE_CONNECTED = exports.GALAXY_INVITEE_STATE_RINGING = exports.GALAXY_INVITEE_STATE_TRYING = exports.GALAXY_ACTION_CLEAR_INVITED = exports.GALAXY_ACTION_ADD_HUNGUP = exports.GALAXY_ACTION_ADD_FAILED = exports.GALAXY_ACTION_ADD_SUCCESS = exports.GALAXY_ACTION_ADD_TO_CALL = exports.GALAXY_ACTION_REPLACE_CALL = exports.GALAXY_ACTION_CALL_WAITING_RESPONSE = exports.GALAXY_ACTION_CALL_WAITING_CANCELLED = exports.GALAXY_ACTION_CALL_WAITING = exports.GALAXY_ACTION_CONFERENCE_UNLOCKED = exports.GALAXY_ACTION_CONFERENCE_LOCKED = exports.GALAXY_ACTION_EJECT_SUCCESS = exports.GALAXY_ACTION_FECC_INCOMING = exports.GALAXY_ACTION_RECORDING_STOP_ERROR = exports.GALAXY_ACTION_RECORDING_STOPPED = exports.GALAXY_ACTION_RECORDING_STOP = exports.GALAXY_ACTION_RECORDING_START_ERROR = exports.GALAXY_ACTION_RECORDING_UPDATED = exports.GALAXY_ACTION_RECORDING_STARTED = exports.GALAXY_ACTION_RECORDING_START = exports.GALAXY_ACTION_PUSH_CALL_CANCELLED = exports.GALAXY_ACTION_CALL_PICKUP_FAILED = exports.GALAXY_ACTION_CALL_PICKUP = exports.GALAXY_ACTION_CONFERENCE_ESCALATED = exports.GALAXY_ACTION_CONFERENCE_UNMUTED = exports.GALAXY_ACTION_CONFERENCE_MUTED = exports.GALAXY_ACTION_PARTICIPANT_UNMUTED = exports.GALAXY_ACTION_PARTICIPANT_MUTED = exports.GALAXY_ACTION_PIN_SENT = exports.GALAXY_ACTION_PIN_REQUESTED = exports.GALAXY_ACTION_PARTICIPANT_LOCAL_VIDEO_UNMUTED = exports.GALAXY_ACTION_PARTICIPANT_LOCAL_VIDEO_MUTED = exports.GALAXY_ACTION_PARTICIPANT_LOCAL_UNMUTED = exports.GALAXY_ACTION_PARTICIPANT_LOCAL_MUTED = exports.GALAXY_ACTION_PARTICIPANT_LEFT = exports.GALAXY_ACTION_PARTICIPANT_JOINED = exports.GALAXY_ACTION_CONFERENCE_JOINED = exports.GALAXY_ACTION_REMOTE_MODERATOR_LEFT = exports.GALAXY_ACTION_REMOTE_MODERATOR_JOINED = exports.MODERATOR_LEFT = exports.MODERATOR_JOINED = exports.GALAXY_ACTION_FIRST_PARTICIPANT_READY_IN_IVR = exports.GALAXY_ACTION_INCOMING_CALL_ENDED = exports.GALAXY_ACTION_IGNORE = exports.GALAXY_ACTION_END = exports.GALAXY_ACTION_FAILED = exports.GALAXY_ACTION_CALL_CONNECTED = exports.GALAXY_ACTION_ADD_RINGING = exports.GALAXY_ACTION_RINGING = exports.GALAXY_ACTION_TRYING = exports.GALAXY_ACTION_QUEUE_CANCEL_CALL = exports.GALAXY_ACTION_CLEAR_CALL = exports.GALAXY_ACTION_INCOMING_ANSWER = exports.GALAXY_ACTION_ANSWER = exports.GALAXY_ACTION_BEGIN_ANSWER = exports.GALAXY_ACTION_INCOMING_CALL = exports.GALAXY_ACTION_CALLING = exports.GALAXY_ACTION_BEGIN_CALL_OFFER = exports.GALAXY_ACTION_BEGIN_CALL = exports.GALAXY_POST_CAPABILITIES_FAILED_REASON_DEFAULT = exports.GALAXY_ACTION_POST_CAPABILITIES_FAILED = exports.GALAXY_ACTION_POST_CAPABILITIES_SUCCESS = exports.GALAXY_ACTION_POST_CAPABILITIES_BEGIN = exports.GALAXY_ACTION_GET_RELAY_SERVERS_FAILED = exports.GALAXY_ACTION_GET_RELAY_SERVERS_SUCCESS = exports.GALAXY_ACTION_GET_RELAY_SERVERS_BEGIN = exports.GALAXY_EVENT_GET_RELAY_SERVERS_FAILED = exports.GALAXY_EVENT_GET_RELAY_SERVERS_SUCCESS = exports.GALAXY_COMMAND_GET_RELAY_SERVERS = exports.WAMP_SUBSCRIPTION_ACTION_CALENDAR_TOPIC = exports.GALAXY_WAMP_SUBSCRIPTION_EVENT_TURN = exports.GALAXY_WAMP_SUBSCRIPTION_EVENT_CALL = exports.GALAXY_SUBSCRIPTION_CAPABILITIES_SERVER = exports.GALAXY_HTTP_METHOD_CAPABILITIES_SERVER = exports.GALAXY_WAMP_ACTION_CAPABILITIES_SERVER = exports.GALAXY_TOPIC_CAPABILITIES_SERVER = exports.GALAXY_SUBSCRIPTION_TURN_SERVER = exports.GALAXY_HTTP_METHOD_TURN_SERVER = exports.GALAXY_WAMP_ACTION_TURN_SERVER = exports.GALAXY_TOPIC_TURN_SERVER = exports.GALAXY_SUBSCRIPTION_CALL_MANAGER = exports.GALAXY_HTTP_METHOD_CALL_MANAGER = exports.GALAXY_WAMP_ACTION_CALL_MANAGER = exports.GALAXY_HTTP_METHOD_DEFAULT = exports.GALAXY_WAMP_URI_SUFFIX_DEFAULT = exports.GALAXY_TOPIC_USER_ACTIONS = exports.GALAXY_TOPIC_MODERATOR_ACTIONS = exports.GALAXY_TOPIC_CONFERENCE = exports.GALAXY_TOPIC_CALL_MANAGER = exports.GET_MEETINGS_FAILURE = exports.GET_MEETINGS_SUCCESS = exports.GET_MEETINGS_BEGIN = exports.DELETE_MEETING_LIST_SUFFIX = exports.DELETE_MEETING_SUFFIX = void 0;
exports.GALAXY_REASON_DEFAULT = exports.GALAXY_ERROR_UPDATE = exports.GALAXY_CALL_STATE_CONNECTED = exports.GALAXY_CALL_STATE_ANSWERING = exports.GALAXY_CALL_STATE_RINGING = exports.GALAXY_CALL_STATE_TRYING = exports.GALAXY_CALL_STATE_INCOMING = exports.GALAXY_CALL_STATE_CALLING = exports.GALAXY_CALL_STATE_DISCONNECTED = exports.GALAXY_CALL_STATE_BEGIN = exports.GALAXY_CONNECTION_PRESENTATION = exports.GALAXY_CONNECTION_PRIMARY = exports.GALAXY_COMMAND_ICE_STATE_NOTIFICATION = exports.GALAXY_COMMAND_MODERATOR_STOP_PRESENTATION = exports.GALAXY_COMMAND_STOP_RECORDING = exports.GALAXY_COMMAND_RECORD = exports.GALAXY_COMMAND_CALL_PICKUP = exports.GALAXY_COMMAND_CHANGE_LAYOUT = exports.GALAXY_COMMAND_DTMF = exports.GALAXY_COMMAND_END = exports.GALAXY_COMMAND_CALL = exports.GALAXY_COMMAND_HEARTBEAT = exports.GALAXY_COMMAND_PASSTHROUGH = exports.GALAXY_COMMAND_NO_ANSWER = exports.GALAXY_COMMAND_BUSY = exports.GALAXY_COMMAND_CANCEL_ADD = exports.GALAXY_COMMAND_ADD = exports.GALAXY_COMMAND_REJECTED = exports.GALAXY_COMMAND_CALL_REPLACED = exports.GALAXY_COMMAND_CALL_WAITING_RESPONSE = exports.GALAXY_COMMAND_CALL_WAITING_IGNORE = exports.GALAXY_COMMAND_CALL_WAITING_END_AND_ANSWER = exports.GALAXY_COMMAND_CALL_WAITING_RINGING = exports.GALAXY_COMMAND_CALL_WAITING_ADD = exports.GALAXY_COMMAND_LOCAL_UN_MUTE = exports.GALAXY_COMMAND_LOCAL_MUTE = exports.GALAXY_COMMAND_UN_MUTE_ALL = exports.GALAXY_COMMAND_UN_MUTE_PARTICIPANT = exports.GALAXY_COMMAND_MUTE_ALL = exports.GALAXY_COMMAND_MUTE_PARTICIPANT = exports.GALAXY_COMMAND_EJECT_ALL = exports.GALAXY_COMMAND_EJECT = exports.GALAXY_CONFERENCE_TYPE_VMR = exports.GALAXY_CONFERENCE_TYPE_ADHOC = exports.GALAXY_CONFERENCE_STATE_ESCALATED = exports.GALAXY_CONFERENCE_STATE_ACTIVE = exports.GALAXY_EVENT_CONFERENCE_UNLOCKED = exports.GALAXY_EVENT_CONFERENCE_LOCKED = exports.GALAXY_EVENT_EJECT_SUCCESS = exports.GALAXY_EVENT_RECORDING_STOP_INITIATED = exports.GALAXY_EVENT_RECORDING_INITIATED = exports.GALAXY_EVENT_RECORDING_STOP_FAILED = exports.GALAXY_EVENT_RECORDING_FAILED = exports.GALAXY_EVENT_RECORDING_STOPPED = exports.GALAXY_EVENT_RECORDING_STARTED = exports.GALAXY_EVENT_CALL_PICKUP_FAILED = exports.GALAXY_EVENT_CHANGE_LAYOUT_RESPONSE = exports.GALAXY_EVENT_UN_MUTE_PARTICIPANT = exports.GALAXY_EVENT_MUTE_PARTICIPANT = exports.GALAXY_EVENT_PRESENTATION_FLOOR_RELEASED = exports.GALAXY_EVENT_PRESENTATION_FLOOR_GRANTED = exports.GALAXY_EVENT_UN_MUTE_ALL = exports.GALAXY_EVENT_MUTE_ALL = exports.GALAXY_EVENT_REQUEST_PIN = exports.GALAXY_PASSTHROUGH_LOCAL_VIDEO_UNMUTE = exports.GALAXY_PASSTHROUGH_LOCAL_VIDEO_MUTE = exports.GALAXY_EVENT_REMOTE_MODERATOR_LEFT = exports.GALAXY_EVENT_REMOTE_MODERATOR_JOINED = exports.GALAXY_EVENT_MODERATOR_LEFT = exports.GALAXY_EVENT_MODERATOR_JOINED = exports.GALAXY_EVENT_PARTICIPANT_LOCAL_VIDEO_UNMUTED = exports.GALAXY_EVENT_PARTICIPANT_LOCAL_VIDEO_MUTED = exports.GALAXY_EVENT_PARTICIPANT_LOCAL_UN_MUTE = exports.GALAXY_EVENT_PARTICIPANT_LOCAL_MUTE = exports.GALAXY_EVENT_PARTICIPANT_LEFT = exports.GALAXY_EVENT_PARTICIPANT_JOINED = exports.GALAXY_EVENT_PARTICIPANT_IGNORED = exports.GALAXY_EVENT_CONFERENCE_ESCALATED = exports.GALAXY_EVENT_CONFERENCE_NOTIFICATION = exports.GALAXY_EVENT_CONFERENCE_ENDED = exports.GALAXY_EVENT_CONFERENCE_JOINED = exports.GALAXY_EVENT_FIRST_PARTICIPANT_READY_IN_IVR = exports.GALAXY_EVENT_PARTICIPANT_MIGRATED = exports.GALAXY_EVENT_PARTICIPANT_EJECTED = exports.GALAXY_EVENT_ADD_RINGING = exports.GALAXY_EVENT_ADD_RESPONSE = exports.GALAXY_EVENT_REPLACE_CALL = exports.GALAXY_EVENT_CALL_WAITING_CANCELLED = exports.GALAXY_EVENT_CALL_WAITING = exports.GALAXY_EVENT_REDIRECT_TO_LEGACY = exports.GALAXY_EVENT_END = exports.GALAXY_EVENT_FAILED = exports.GALAXY_EVENT_CONNECTED = exports.GALAXY_EVENT_RINGING = exports.GALAXY_EVENT_TRYING = exports.GALAXY_EVENT_CALL = exports.GALAXY_ADD_RESPONSE_ACTION_CANCELLED = exports.GALAXY_ADD_RESPONSE_ACTION_BUSY = exports.GALAXY_ADD_RESPONSE_ACTION_USERNOTFOUND = exports.GALAXY_ADD_RESPONSE_ACTION_REJECTED = void 0;
exports.GALAXY_COMMAND_PRESENTATION_TOKEN_RELEASE = exports.GALAXY_EVENT_PASSTHROUGH = exports.GALAXY_EVENT_UPDATE = exports.GALAXY_ACTION_UPDATE = exports.GALAXY_COMMAND_UPDATE = exports.GALAXY_ACTION_PRESENTATION_FAILED = exports.GALAXY_ACTION_LOCAL_PRESENTATION_STOPPED = exports.GALAXY_ACTION_PRESENTATION_TOKEN_REVOKED = exports.GALAXY_ACTION_PRESENTATION_TOKEN_DENIED = exports.GALAXY_ACTION_PRESENTATION_TOKEN_GRANTED = exports.GALAXY_ACTION_PRESENTATION_TOKEN_REQUEST = exports.GALAXY_EVENT_PRESENTATION_TOKEN_REVOKED = exports.GALAXY_EVENT_PRESENTATION_TOKEN_DENIED = exports.GALAXY_EVENT_PRESENTATION_TOKEN_GRANTED = exports.GALAXY_COMMAND_PRESENTATION_TOKEN_REQUEST = exports.GALAXY_ACTION_UPDATE_SDP_FAILURE = exports.GALAXY_ACTION_UPDATE_SDP_SUCCESS = exports.GALAXY_ACTION_OFFER_ANSWERED = exports.GALAXY_ACTION_IN_CALL_OFFER = exports.GALAXY_ACTION_CREATE_OFFER = exports.GALAXY_COMMAND_IN_CALL_ANSWER = exports.GALAXY_COMMAND_OFFER_CREATED = exports.GALAXY_ACTION_TRICKLE_ICE = exports.GALAXY_COMMAND_TRICKLE_ICE = exports.GALAXY_EVENT_TRICKLE_ICE = exports.GALAXY_EVENT_OFFER_ANSWERED = exports.GALAXY_EVENT_IN_CALL_OFFER = exports.GALAXY_EVENT_CREATE_OFFER = exports.GALAXY_RECORDING_STATE_STOPPING = exports.GALAXY_RECORDING_STATE_STARTED = exports.GALAXY_RECORDING_STATE_STARTING = exports.GALAXY_RECORDING_STATE_STOPPED = exports.GALAXY_PRESENTATION_STATE_STOPPED = exports.GALAXY_PRESENTATION_STATE_RX_STOPPING = exports.GALAXY_PRESENTATION_STATE_RX_STARTED = exports.GALAXY_PRESENTATION_STATE_RX_STARTING = exports.GALAXY_PRESENTATION_STATE_TX_STOPPED = exports.GALAXY_PRESENTATION_STATE_TX_STOPPING = exports.GALAXY_PRESENTATION_STATE_TX_STARTED = exports.GALAXY_PRESENTATION_STATE_TX_STARTING = exports.GALAXY_ACTION_AWAIT_PRESENTATION_TIMEOUT = exports.GALAXY_ACTION_UPDATE_PRIMARY_SOURCE = exports.GALAXY_ACTION_STOP_AWAIT_PRESENTATION_ANSWER = exports.GALAXY_ACTION_AWAIT_PRESENTATION_ANSWER = exports.GALAXY_ACTION_RX_STOPPED_PRESENTATION = exports.GALAXY_ACTION_TX_STOPPED_PRESENTATION = exports.GALAXY_ACTION_STOP_PRESENTATION = exports.GALAXY_ACTION_UPDATE_PRESENTATION_TRACKID = exports.GALAXY_ACTION_PRESENTATION_FAIL = exports.GALAXY_ACTION_PRESENTATION_SUCCESS = exports.GALAXY_ACTION_PRESENTATION_ANSWER = exports.GALAXY_ACTION_PRESENTATION_FLOOR_RELEASED = exports.GALAXY_ACTION_PRESENTATION_FLOOR_GRANTED = exports.GALAXY_ACTION_BEGIN_PRESENTATION = exports.GALAXY_ACTION_ON_UPDATE_SDP_ANSWER = exports.GALAXY_ACTION_ON_UPDATE_SDP_OFFER = exports.GALAXY_OFFER_PRIORITY_MAX = exports.GALAXY_PRESENTATION_STOP_OFFER_PRIORITY = exports.GALAXY_PRESENTATION_START_OFFER_PRIORITY = exports.GALAXY_API_VERSION_V3 = exports.GALAXY_API_VERSION = exports.WEBRTC_SDP_SEMANTICS_PLAN_B = exports.WEBRTC_SDP_TYPE_ANSWER = exports.WEBRTC_SDP_TYPE_OFFER = exports.GALAXY_PASSTHROUGH_FECC = exports.GALAXY_ERROR_TIMEOUT = exports.GALAXY_ERROR_DEFAULT = exports.GALAXY_REASON_VIDEO_BANDWIDTH_UPDATE = exports.GALAXY_REASON_VIDEO_MUTE_DONE = exports.GALAXY_REASON_VIDEO_UNMUTE_UPDATE = exports.GALAXY_REASON_VIDEO_MUTE_UPDATE = exports.GALAXY_REASON_DATA_CHANNEL = exports.GALAXY_REASON_SDP_DONE = exports.GALAXY_REASON_SDP_UPDATE = exports.GALAXY_REASON_PRESENTATION_TOKEN_DENIED = exports.GALAXY_REASON_PARTICIPANT_EJECTED = exports.GALAXY_REASON_REDIRECT_IVR = exports.GALAXY_REASON_PRESENTATION_RECEIVE = exports.GALAXY_REASON_ICE_RESTART_DONE = exports.GALAXY_REASON_ICE_RESTART = exports.GALAXY_REASON_WAMP_DISCONNECTED = exports.GALAXY_REASON_PRESENTATION_SEND = exports.GALAXY_REASON_PRESENTATION_STOP = exports.GALAXY_REASON_SERVER_ERROR = exports.GALAXY_REASON_USER_NOT_FOUND = exports.GALAXY_REASON_UNREACHABLE = exports.GALAXY_REASON_TIMED_OUT = exports.GALAXY_REASON_NO_MEDIA = exports.GALAXY_REASON_NO_ANSWER = exports.GALAXY_REASON_DO_NOT_DISTURB = exports.GALAXY_REASON_REJECTED = exports.GALAXY_REASON_BUSY = exports.GALAXY_REASON_NETWORK_ERROR = exports.GALAXY_REASON_HUNGUP = exports.GALAXY_REASON_HANGUP = exports.GALAXY_REASON_CLIENT_EXCEPTION = exports.GALAXY_REASON_CANCELED = exports.GALAXY_REASON_BAD_INITIAL_DIAL_STATE = exports.GALAXY_REASON_INVALID_CAPABILITY = exports.GALAXY_REASON_NOT_IN_CALL = void 0;
exports.PAIRING_TOPIC = exports.GRAPHITE_TOPIC = exports.GRAPHITE_EVENT_RECEIVED = exports.WAMP_SUBSCRIPTION_LINKING_EVENT = exports.GET_DEVICE_LOGIN_SUCCESS = exports.SERVICE_STATUS_VERIFYING = exports.SERVICE_STATUS_CONNECTED = exports.SERVICE_STATUS_CONNECTING = exports.SERVICE_STATUS_DISCONNECTED = exports.INITIALIZE_SERVICES_FAILURE = exports.INITIALIZE_SERVICES_SUCCESS = exports.INITIALIZE_SERVICES_REQUEST = exports.GALAXY_RESET_SCALED_RESOLUTION = exports.GALAXY_SET_SCALED_RESOLUTION = exports.DOWNSCALE_WIDTH = exports.DOWNSCALE_HEIGHT = exports.RESOLUTION_UPSCALE_THRESHOLD = exports.RESOLUTION_DOWNSCALE_THRESHOLD = exports.AWAIT_ACTION_TIMEOUT = exports.AWAIT_ACTION = exports.CAN_ADD = exports.HTTP_DELETE = exports.HTTP_PUT = exports.HTTP_GET = exports.HTTP_POST = exports.GALAXY_ACTION_CONFERENCE_ALL_HANDS_LOWERED = exports.GALAXY_ACTION_CONFERENCE_PARTICIPANT_HAND_LOWERED = exports.GALAXY_ACTION_CONFERENCE_PARTICIPANT_HAND_RAISED = exports.GALAXY_EVENT_ALL_HANDS_LOWERED = exports.GALAXY_EVENT_HAND_LOWERED = exports.GALAXY_EVENT_HAND_RAISED = exports.GALAXY_COMMAND_LOWER_ALL_HANDS = exports.GALAXY_COMMAND_LOWER_HAND = exports.GALAXY_COMMAND_RAISE_HAND = exports.LOWER_ALL_HANDS_FAILURE = exports.LOWER_ALL_HANDS_SUCCESS = exports.LOWER_ALL_HANDS_REQUEST = exports.SELF_LOWER_HAND_FAILURE = exports.SELF_LOWER_HAND_SUCCESS = exports.SELF_LOWER_HAND_REQUEST = exports.SELF_RAISE_HAND_FAILURE = exports.SELF_RAISE_HAND_SUCCESS = exports.SELF_RAISE_HAND_REQUEST = exports.LOWER_HAND_FAILURE = exports.LOWER_HAND_SUCCESS = exports.LOWER_HAND_REQUEST = exports.GALAXY_REASON_REPLACE_CALL = exports.GALAXY_OFFER_TIMER = exports.GALAXY_DEFAULT_PRESENTATION_BW_PERCENTAGE = exports.GALAXY_DEFAULT_H264_BANDWIDTH_KBPS = exports.GALAXY_DEFAULT_CALL_BANDWIDTH_KBPS = exports.GALAXY_ACTION_CHANGE_LAYOUT_RESPONSE = exports.GALAXY_ACTION_UPDATE_SDP_ANSWERED = exports.GALAXY_ACTION_TOGGLE_VIDEO_MUTE = exports.ICE_RESTART_OFFER = exports.GALAXY_PC_SIGNALING_STATE_STABLE = exports.GALAXY_MAX_ICE_RETRIES = exports.GALAXY_ICE_STATE_COMPLETED = exports.GALAXY_ICE_STATE_FAILED = exports.GALAXY_ICE_STATE_DISCONNECTED = exports.GALAXY_ICE_STATE_CONNECTED = exports.GALAXY_ICE_STATE_CLOSED = exports.GALAXY_ACTION_ICE_STATE_UPDATED = exports.CHANGE_VIDEO_SOURCE_OFFER = exports.VIDEO_MUTE_OFFER = exports.END_PRESENTATION_OFFER = exports.PRESENTATION_OFFER = exports.GALAXY_ACTION_PRESENTATION_CONNECTED = exports.GALAXY_ACTION_INCOMING_PRESENTATION = exports.GALAXY_ACTION_PRESENTATION_TOKEN_RELEASE = void 0;

var _RTCIceConnectionState = _interopRequireDefault(__webpack_require__(206));

var _RTCDataChannelState = _interopRequireDefault(__webpack_require__(164));

var _RTCSignalingState = _interopRequireDefault(__webpack_require__(207));

var _logger = _interopRequireDefault(__webpack_require__(165));

var DataChannel = _interopRequireWildcard(__webpack_require__(166));

var dataChannel = DataChannel;
exports.dataChannel = dataChannel;
var Logger = _logger.default;
exports.Logger = Logger;
var rtcIceConnectionState = _RTCIceConnectionState.default;
exports.rtcIceConnectionState = rtcIceConnectionState;
var rtcDataChannelState = _RTCDataChannelState.default;
exports.rtcDataChannelState = rtcDataChannelState;
var rtcSignalingState = _RTCSignalingState.default;
exports.rtcSignalingState = rtcSignalingState;
var PLATFORM_WEB = 'WEB';
exports.PLATFORM_WEB = PLATFORM_WEB;
var PLATFORM_IOS = 'IOS_IPHONE';
exports.PLATFORM_IOS = PLATFORM_IOS;
var PLATFORM_ANDROID = 'ANDROID';
exports.PLATFORM_ANDROID = PLATFORM_ANDROID;
var PLATFORM_WINDOWS = 'WIN';
exports.PLATFORM_WINDOWS = PLATFORM_WINDOWS;
var PLATFORM_OSX = 'OSX';
exports.PLATFORM_OSX = PLATFORM_OSX;
var PLATFORM_ICON_300 = 'ICON_300';
exports.PLATFORM_ICON_300 = PLATFORM_ICON_300;
var PLATFORM_ICON_500 = 'ICON_500';
exports.PLATFORM_ICON_500 = PLATFORM_ICON_500;
var PLATFORM_ICON_700 = 'ICON_700';
exports.PLATFORM_ICON_700 = PLATFORM_ICON_700;
var PLATFORM_ICON_900 = 'ICON_900';
exports.PLATFORM_ICON_900 = PLATFORM_ICON_900;
var PLATFORM_DASH = 'GRAPHITE';
exports.PLATFORM_DASH = PLATFORM_DASH;
var BROWSER_TYPE_CHROME = 'CHROME';
exports.BROWSER_TYPE_CHROME = BROWSER_TYPE_CHROME;
var BROWSER_TYPE_IE11 = 'IE11';
exports.BROWSER_TYPE_IE11 = BROWSER_TYPE_IE11;
var GEMS_SOFTWARE_UPDATE_TOPIC = 'ls.softwareUpdate_gems';
exports.GEMS_SOFTWARE_UPDATE_TOPIC = GEMS_SOFTWARE_UPDATE_TOPIC;
var GEMS_SOFTWARE_UPDATE = 'GEMS_SOFTWARE_UPDATE';
exports.GEMS_SOFTWARE_UPDATE = GEMS_SOFTWARE_UPDATE;
var PROD_CLUSTER_URL = 'lifesizecloud.com';
exports.PROD_CLUSTER_URL = PROD_CLUSTER_URL;
var STAGING_CLUSTER_URL = 'lifesizecloudbeta.com';
exports.STAGING_CLUSTER_URL = STAGING_CLUSTER_URL;
var DEV_CLUSTER_URL = 'lifesizeclouddev.com'; // Network status

exports.DEV_CLUSTER_URL = DEV_CLUSTER_URL;
var NETWORK_ONLINE = 'NETWORK_ONLINE';
exports.NETWORK_ONLINE = NETWORK_ONLINE;
var NETWORK_OFFLINE = 'NETWORK_OFFLINE';
exports.NETWORK_OFFLINE = NETWORK_OFFLINE;
var NETWORK_STATUS_ONLINE = 'NETWORK_STATUS_ONLINE';
exports.NETWORK_STATUS_ONLINE = NETWORK_STATUS_ONLINE;
var NETWORK_STATUS_OFFLINE = 'NETWORK_STATUS_OFFLINE';
exports.NETWORK_STATUS_OFFLINE = NETWORK_STATUS_OFFLINE;
var NETWORK_OFFLINE_CALL_TIMEOUT_MS = 2 * 60 * 1000; // Application status

exports.NETWORK_OFFLINE_CALL_TIMEOUT_MS = NETWORK_OFFLINE_CALL_TIMEOUT_MS;
var APP_FOREGROUNDED = 'APP_FOREGROUNDED';
exports.APP_FOREGROUNDED = APP_FOREGROUNDED;
var APP_BACKGROUNDED = 'APP_BACKGROUNDED'; // Mixpanel bucket tokens

exports.APP_BACKGROUNDED = APP_BACKGROUNDED;
var MIXPANEL_PROD = 'a12b40d382e14bbf23164ec7dc1eaa6b';
exports.MIXPANEL_PROD = MIXPANEL_PROD;
var MIXPANEL_PREVIEW = '90223db9838e30f5cdce79b93edd52de';
exports.MIXPANEL_PREVIEW = MIXPANEL_PREVIEW;
var MIXPANEL_STAGE = '1e20676b5097aa22804efb631817073f'; // login service client ids

exports.MIXPANEL_STAGE = MIXPANEL_STAGE;
var CLIENT_ID_ELECTRON_MAC = '5d955ff9-8848-4c3c-8915-b83831bf62e2';
exports.CLIENT_ID_ELECTRON_MAC = CLIENT_ID_ELECTRON_MAC;
var CLIENT_ID_ELECTRON_WINDOWS = '666a1d68-d99c-448b-a13d-c524525c4b21';
exports.CLIENT_ID_ELECTRON_WINDOWS = CLIENT_ID_ELECTRON_WINDOWS;
var CLIENT_ID_MOBILE_IOS = 'd3791321-ff26-45c6-8a0b-1fa90d34ce5c';
exports.CLIENT_ID_MOBILE_IOS = CLIENT_ID_MOBILE_IOS;
var CLIENT_ID_MOBILE_ANDROID = 'c812222b-dbf1-456c-b14f-ff4702168009';
exports.CLIENT_ID_MOBILE_ANDROID = CLIENT_ID_MOBILE_ANDROID;
var CLIENT_ID_GEMS = 'cfacebc8-ba83-4958-96a6-a11223652dfd';
exports.CLIENT_ID_GEMS = CLIENT_ID_GEMS;
var CLIENT_ID_DASH_DISPLAY = '93b5913f-a319-4221-a217-7646e481ca03';
exports.CLIENT_ID_DASH_DISPLAY = CLIENT_ID_DASH_DISPLAY;
var CLIENT_ID_DASH_REMOTE = 'a978530c-bdb2-43ce-85de-dc698999ce0d'; // feature flag key for checking flag on splitio service

exports.CLIENT_ID_DASH_REMOTE = CLIENT_ID_DASH_REMOTE;
var SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS';
exports.SET_FEATURE_FLAGS = SET_FEATURE_FLAGS;
var FEATUREFLAG_USE_DIRECTORY_SERVICE = 'CNUC_UseElasticSearchDirectoryService';
exports.FEATUREFLAG_USE_DIRECTORY_SERVICE = FEATUREFLAG_USE_DIRECTORY_SERVICE;
var FEATUREFLAG_SHOW_LOCAL_CONFERENCE_SLIDES = 'CNUC_ShowLocalConferenceSlides';
exports.FEATUREFLAG_SHOW_LOCAL_CONFERENCE_SLIDES = FEATUREFLAG_SHOW_LOCAL_CONFERENCE_SLIDES;
var FEATUREFLAG_SHOW_CUSTOMIZED_CONFERENCE_SLIDES = 'CNUC_ShowCustomizedConferenceSlides';
exports.FEATUREFLAG_SHOW_CUSTOMIZED_CONFERENCE_SLIDES = FEATUREFLAG_SHOW_CUSTOMIZED_CONFERENCE_SLIDES;
var FEATUREFLAG_DISABLE_END_AND_ANSWER = 'CNUC_DisableEndAndAnswer';
exports.FEATUREFLAG_DISABLE_END_AND_ANSWER = FEATUREFLAG_DISABLE_END_AND_ANSWER;
var FEATUREFLAG_USE_USER_SETTINGS_SERVICE = 'CNUC_UseUserSettingsService';
exports.FEATUREFLAG_USE_USER_SETTINGS_SERVICE = FEATUREFLAG_USE_USER_SETTINGS_SERVICE;
var FEATUREFLAG_FORCE_TCP_TUNNELING = 'CNUC_ForceTCPTunneling';
exports.FEATUREFLAG_FORCE_TCP_TUNNELING = FEATUREFLAG_FORCE_TCP_TUNNELING;
var FEATUREFLAG_ENABLE_OFFLINE_CALLING = 'CNUC_EnableOfflineCalling';
exports.FEATUREFLAG_ENABLE_OFFLINE_CALLING = FEATUREFLAG_ENABLE_OFFLINE_CALLING;
var FEATUREFLAG_ENABLE_FECC = 'CNUC_EnableFarEndCameraControls';
exports.FEATUREFLAG_ENABLE_FECC = FEATUREFLAG_ENABLE_FECC;
var FEATUREFLAG_CHAT_ENHANCEMENTS = 'CNUC_ChatEnhancements';
exports.FEATUREFLAG_CHAT_ENHANCEMENTS = FEATUREFLAG_CHAT_ENHANCEMENTS;
var FEATUREFLAG_ENABLE_ONE_TIME_MEETINGS = 'CNUC_EnableOneTimeMeetings';
exports.FEATUREFLAG_ENABLE_ONE_TIME_MEETINGS = FEATUREFLAG_ENABLE_ONE_TIME_MEETINGS;
var FEATUREFLAG_ENABLE_NEW_MEETING_API = 'CNUC_EnableNewMeetingsAPI';
exports.FEATUREFLAG_ENABLE_NEW_MEETING_API = FEATUREFLAG_ENABLE_NEW_MEETING_API;
var FEATUREFLAG_ENABLE_NEW_FAVORITE_API = 'CNUC_EnableFavoritesService';
exports.FEATUREFLAG_ENABLE_NEW_FAVORITE_API = FEATUREFLAG_ENABLE_NEW_FAVORITE_API;
var FEATUREFLAG_ENABLE_LANGUAGE_RU_RU = 'CNUC_EnableLanguageRussian';
exports.FEATUREFLAG_ENABLE_LANGUAGE_RU_RU = FEATUREFLAG_ENABLE_LANGUAGE_RU_RU;
var FEATUREFLAG_ENABLE_LANGUAGE_ZH_HANT = 'CNUC_EnableLanguageTraditionalChinese';
exports.FEATUREFLAG_ENABLE_LANGUAGE_ZH_HANT = FEATUREFLAG_ENABLE_LANGUAGE_ZH_HANT;
var FEATUREFLAG_GRAPHQL_CHAT = 'CNUC_GraphQLChat';
exports.FEATUREFLAG_GRAPHQL_CHAT = FEATUREFLAG_GRAPHQL_CHAT;
var FEATUREFLAG_AUTO_RESOLUTION_CHANGE = 'CNUC_AutoResolutionChange';
exports.FEATUREFLAG_AUTO_RESOLUTION_CHANGE = FEATUREFLAG_AUTO_RESOLUTION_CHANGE;
var FEATUREFLAG_ENABLE_NOISE_SUPPRESSION = 'CNUC_EnableNoiseSuppression'; // Login and auth actions

exports.FEATUREFLAG_ENABLE_NOISE_SUPPRESSION = FEATUREFLAG_ENABLE_NOISE_SUPPRESSION;
var AUTH_LOGOUT = 'AUTH_LOGOUT';
exports.AUTH_LOGOUT = AUTH_LOGOUT;
var UNAUTHORIZED = 'UNAUTHORIZED';
exports.UNAUTHORIZED = UNAUTHORIZED;
var GET_ACCOUNT_FEATURE_FLAGS_FAILURE = 'GET_ACCOUNT_FEATURE_FLAGS_FAILURE';
exports.GET_ACCOUNT_FEATURE_FLAGS_FAILURE = GET_ACCOUNT_FEATURE_FLAGS_FAILURE;
var LOGOUT_BEGIN = 'LOGOUT_BEGIN';
exports.LOGOUT_BEGIN = LOGOUT_BEGIN;
var LOGOUT_FINISHED = 'LOGOUT_FINISHED';
exports.LOGOUT_FINISHED = LOGOUT_FINISHED;
var SSO_CHECK_BEGIN = 'SSO_CHECK_BEGIN';
exports.SSO_CHECK_BEGIN = SSO_CHECK_BEGIN;
var SSO_CHECK_SUCCESS = 'SSO_CHECK_SUCCESS';
exports.SSO_CHECK_SUCCESS = SSO_CHECK_SUCCESS;
var SSO_CHECK_FAILURE = 'SSO_CHECK_FAILURE';
exports.SSO_CHECK_FAILURE = SSO_CHECK_FAILURE;
var LOGIN_SUPPORT_TYPE_PASSWORD = 'password';
exports.LOGIN_SUPPORT_TYPE_PASSWORD = LOGIN_SUPPORT_TYPE_PASSWORD;
var LOGIN_SUPPORT_TYPE_SSO = 'sso';
exports.LOGIN_SUPPORT_TYPE_SSO = LOGIN_SUPPORT_TYPE_SSO;
var LOGIN_SUPPORT_TYPE_BOTH = 'both';
exports.LOGIN_SUPPORT_TYPE_BOTH = LOGIN_SUPPORT_TYPE_BOTH;
var TOKEN_REQUEST_BEGIN = 'TOKEN_REQUEST_BEGIN';
exports.TOKEN_REQUEST_BEGIN = TOKEN_REQUEST_BEGIN;
var TOKEN_REQUEST_SUCCESS = 'TOKEN_REQUEST_SUCCESS';
exports.TOKEN_REQUEST_SUCCESS = TOKEN_REQUEST_SUCCESS;
var TOKEN_REQUEST_FAILURE = 'TOKEN_REQUEST_FAILURE';
exports.TOKEN_REQUEST_FAILURE = TOKEN_REQUEST_FAILURE;
var NEW_TOKEN_OBTAINED = 'NEW_TOKEN_OBTAINED';
exports.NEW_TOKEN_OBTAINED = NEW_TOKEN_OBTAINED;
var TOKEN_REFRESH_BEGIN = 'TOKEN_REFRESH_BEGIN';
exports.TOKEN_REFRESH_BEGIN = TOKEN_REFRESH_BEGIN;
var TOKEN_REFRESH_FAILURE = 'TOKEN_REFRESH_FAILURE';
exports.TOKEN_REFRESH_FAILURE = TOKEN_REFRESH_FAILURE;
var WAMP_CONNECT_BEGIN = 'WAMP_CONNECT_BEGIN';
exports.WAMP_CONNECT_BEGIN = WAMP_CONNECT_BEGIN;
var WAMP_CONNECT_SUCCESS = 'WAMP_CONNECT_SUCCESS';
exports.WAMP_CONNECT_SUCCESS = WAMP_CONNECT_SUCCESS;
var WAMP_CONNECT_ERROR = 'WAMP_CONNECT_ERROR';
exports.WAMP_CONNECT_ERROR = WAMP_CONNECT_ERROR;
var WAMP_CONNECTION_DISPOSED_HEALTHY = 'WAMP_CONNECTION_DISPOSED_HEALTHY';
exports.WAMP_CONNECTION_DISPOSED_HEALTHY = WAMP_CONNECTION_DISPOSED_HEALTHY;
var WAMP_CONNECTION_DISPOSED_JWT_ERROR = 'WAMP_CONNECTION_DISPOSED_JWT_ERROR';
exports.WAMP_CONNECTION_DISPOSED_JWT_ERROR = WAMP_CONNECTION_DISPOSED_JWT_ERROR;
var WAMP_CONNECTION_DISPOSED_UNEXPECTED = 'WAMP_CONNECTION_DISPOSED_UNEXPECTED';
exports.WAMP_CONNECTION_DISPOSED_UNEXPECTED = WAMP_CONNECTION_DISPOSED_UNEXPECTED;
var WAMP_SEND_BEGIN = 'WAMP_SEND_BEGIN';
exports.WAMP_SEND_BEGIN = WAMP_SEND_BEGIN;
var WAMP_SEND_ERROR = 'WAMP_SEND_ERROR';
exports.WAMP_SEND_ERROR = WAMP_SEND_ERROR;
var WAMP_SEND_SUCCESS = 'WAMP_SEND_SUCCESS';
exports.WAMP_SEND_SUCCESS = WAMP_SEND_SUCCESS;
var WAMP_SUBSCRIBE_BEGIN = 'WAMP_SUBSCRIBE_BEGIN';
exports.WAMP_SUBSCRIBE_BEGIN = WAMP_SUBSCRIBE_BEGIN;
var WAMP_SUBSCRIBE_ERROR = 'WAMP_SUBSCRIBE_ERROR';
exports.WAMP_SUBSCRIBE_ERROR = WAMP_SUBSCRIBE_ERROR;
var WAMP_SUBSCRIBE_SUCCESS = 'WAMP_SUBSCRIBE_SUCCESS';
exports.WAMP_SUBSCRIBE_SUCCESS = WAMP_SUBSCRIBE_SUCCESS;
var WAMP_UNSUBSCRIBE_BEGIN = 'WAMP_UNSUBSCRIBE_BEGIN';
exports.WAMP_UNSUBSCRIBE_BEGIN = WAMP_UNSUBSCRIBE_BEGIN;
var WAMP_UNSUBSCRIBE_ERROR = 'WAMP_UNSUBSCRIBE_ERROR';
exports.WAMP_UNSUBSCRIBE_ERROR = WAMP_UNSUBSCRIBE_ERROR;
var WAMP_UNSUBSCRIBE_SUCCESS = 'WAMP_UNSUBSCRIBE_SUCCESS';
exports.WAMP_UNSUBSCRIBE_SUCCESS = WAMP_UNSUBSCRIBE_SUCCESS;
var WAMP_SEND_TIMEOUT = 30000;
exports.WAMP_SEND_TIMEOUT = WAMP_SEND_TIMEOUT;
var VERIFY_WAMP_REQUEST = 'VERIFY_WAMP_REQUEST';
exports.VERIFY_WAMP_REQUEST = VERIFY_WAMP_REQUEST;
var VERIFY_WAMP_SUCCESS = 'VERIFY_WAMP_SUCCESS';
exports.VERIFY_WAMP_SUCCESS = VERIFY_WAMP_SUCCESS;
var VERIFY_WAMP_FAILURE = 'VERIFY_WAMP_FAILURE';
exports.VERIFY_WAMP_FAILURE = VERIFY_WAMP_FAILURE;
var WAMP_ADD_CONFERENCE_TOPIC = 'WAMP_ADD_CONFERENCE_TOPIC';
exports.WAMP_ADD_CONFERENCE_TOPIC = WAMP_ADD_CONFERENCE_TOPIC;
var WAMP_REMOVE_CONFERENCE_TOPIC = 'WAMP_REMOVE_CONFERENCE_TOPIC';
exports.WAMP_REMOVE_CONFERENCE_TOPIC = WAMP_REMOVE_CONFERENCE_TOPIC;
var DIRECTORY_SERVICE_ENDPOINT = 'lifesize.directory.contacts';
exports.DIRECTORY_SERVICE_ENDPOINT = DIRECTORY_SERVICE_ENDPOINT;
var DIRECTORY_SEARCH_RESULTS = 'DIRECTORY_SEARCH_RESULTS';
exports.DIRECTORY_SEARCH_RESULTS = DIRECTORY_SEARCH_RESULTS;
var CONTACT_MANUAL_LOAD = 'CONTACT_MANUAL_LOAD';
exports.CONTACT_MANUAL_LOAD = CONTACT_MANUAL_LOAD;
var CONTACT_RECORDS_LOADED = 'CONTACT_RECORDS_LOADED';
exports.CONTACT_RECORDS_LOADED = CONTACT_RECORDS_LOADED;
var CONTACT_RECORDS_PARTIAL_LOAD = 'CONTACT_RECORDS_PARTIAL_LOAD';
exports.CONTACT_RECORDS_PARTIAL_LOAD = CONTACT_RECORDS_PARTIAL_LOAD;
var CONTACTS_FETCH_NEXT_BEGIN = 'CONTACTS_FETCH_NEXT_BEGIN';
exports.CONTACTS_FETCH_NEXT_BEGIN = CONTACTS_FETCH_NEXT_BEGIN;
var CONTACTS_FETCH_NEXT_RESULT = 'CONTACTS_FETCH_NEXT_RESULT';
exports.CONTACTS_FETCH_NEXT_RESULT = CONTACTS_FETCH_NEXT_RESULT;
var CONTACTS_FETCH_NEXT_FAILED = 'CONTACTS_FETCH_NEXT_FAILED';
exports.CONTACTS_FETCH_NEXT_FAILED = CONTACTS_FETCH_NEXT_FAILED;
var CONTACTS_LOADED_FROM_CACHE = 'CONTACTS_LOADED_FROM_CACHE';
exports.CONTACTS_LOADED_FROM_CACHE = CONTACTS_LOADED_FROM_CACHE;
var CONTACT_PRESENCE_UPDATE = 'CONTACT_PRESENCE_UPDATE';
exports.CONTACT_PRESENCE_UPDATE = CONTACT_PRESENCE_UPDATE;
var BATCHED_CONTACT_PRESENCE_UPDATE = 'BATCHED_CONTACT_PRESENCE_UPDATE';
exports.BATCHED_CONTACT_PRESENCE_UPDATE = BATCHED_CONTACT_PRESENCE_UPDATE;
var BATCHED_USER_PRESENCE_UPDATE = 'BATCHED_USER_PRESENCE_UPDATE';
exports.BATCHED_USER_PRESENCE_UPDATE = BATCHED_USER_PRESENCE_UPDATE;
var CONTACTS_FETCH_PAGINATED_REQUEST = 'CONTACTS_FETCH_PAGINATED_REQUEST';
exports.CONTACTS_FETCH_PAGINATED_REQUEST = CONTACTS_FETCH_PAGINATED_REQUEST;
var CONTACTS_FETCH_PAGINATED_SUCCESS = 'CONTACTS_FETCH_PAGINATED_SUCCESS';
exports.CONTACTS_FETCH_PAGINATED_SUCCESS = CONTACTS_FETCH_PAGINATED_SUCCESS;
var CONTACTS_FETCH_PAGINATED_FAILURE = 'CONTACTS_FETCH_PAGINATED_FAILURE';
exports.CONTACTS_FETCH_PAGINATED_FAILURE = CONTACTS_FETCH_PAGINATED_FAILURE;
var CONTACTS_PAGE_FETCHED = 'CONTACTS_PAGE_FETCHED';
exports.CONTACTS_PAGE_FETCHED = CONTACTS_PAGE_FETCHED;
var CONTACTS_DEFAULT_PAGE_SIZE = 5000;
exports.CONTACTS_DEFAULT_PAGE_SIZE = CONTACTS_DEFAULT_PAGE_SIZE;
var CONTACTS_DEFAULT_SMALL_PAGE_SIZE = 50; // Availability Service

exports.CONTACTS_DEFAULT_SMALL_PAGE_SIZE = CONTACTS_DEFAULT_SMALL_PAGE_SIZE;
var AVAILABILITY_ENDPOINT = 'lifesize.availability';
exports.AVAILABILITY_ENDPOINT = AVAILABILITY_ENDPOINT;
var AVAILABILITY_TOPIC = 'ls.availability';
exports.AVAILABILITY_TOPIC = AVAILABILITY_TOPIC;
var AVAILABILITY_UPDATE = 'AVAILABILITY_UPDATE';
exports.AVAILABILITY_UPDATE = AVAILABILITY_UPDATE;
var AVAILABILITY_POST_BEGIN = 'AVAILABILITY_POST_BEGIN';
exports.AVAILABILITY_POST_BEGIN = AVAILABILITY_POST_BEGIN;
var AVAILABILITY_POST_ERROR = 'AVAILABILITY_POST_ERROR';
exports.AVAILABILITY_POST_ERROR = AVAILABILITY_POST_ERROR;
var AVAILABILITY_POST_SUCCESS = 'AVAILABILITY_POST_SUCCESS';
exports.AVAILABILITY_POST_SUCCESS = AVAILABILITY_POST_SUCCESS;
var AVAILABILITY_STATUS_SUFFIX = 'status';
exports.AVAILABILITY_STATUS_SUFFIX = AVAILABILITY_STATUS_SUFFIX;
var AVAILABILITY_STATUS_AVAILABLE = 'available';
exports.AVAILABILITY_STATUS_AVAILABLE = AVAILABILITY_STATUS_AVAILABLE;
var AVAILABILITY_STATUS_UNAVAILABLE = 'unavailable';
exports.AVAILABILITY_STATUS_UNAVAILABLE = AVAILABILITY_STATUS_UNAVAILABLE;
var AVAILABILITY_STATUS_AWAY = 'away';
exports.AVAILABILITY_STATUS_AWAY = AVAILABILITY_STATUS_AWAY;
var AVAILABILITY_BATCH_DELAY_MOBILE = 7000;
exports.AVAILABILITY_BATCH_DELAY_MOBILE = AVAILABILITY_BATCH_DELAY_MOBILE;
var AVAILABILITY_BATCH_DELAY_WEB = 1000; // contact constants

exports.AVAILABILITY_BATCH_DELAY_WEB = AVAILABILITY_BATCH_DELAY_WEB;
var CONTACT_TOPIC = 'ls.directory';
exports.CONTACT_TOPIC = CONTACT_TOPIC;
var CONTACT_NOTIFICATION = 'CONTACT_NOTIFICATION';
exports.CONTACT_NOTIFICATION = CONTACT_NOTIFICATION;
var CONTACT_ACTION_CREATED = 'CREATED';
exports.CONTACT_ACTION_CREATED = CONTACT_ACTION_CREATED;
var CONTACT_ACTION_UPDATED = 'UPDATED';
exports.CONTACT_ACTION_UPDATED = CONTACT_ACTION_UPDATED;
var CONTACT_ACTION_DELETED = 'DELETED';
exports.CONTACT_ACTION_DELETED = CONTACT_ACTION_DELETED;
var CONTACT_PARTICIPANT_COUNT_UPDATE = 'CONTACT_PARTICIPANT_COUNT_UPDATE';
exports.CONTACT_PARTICIPANT_COUNT_UPDATE = CONTACT_PARTICIPANT_COUNT_UPDATE;
var CONTACT_NOTIFICATION_CREATED = 'CONTACT_NOTIFICATION_CREATED';
exports.CONTACT_NOTIFICATION_CREATED = CONTACT_NOTIFICATION_CREATED;
var CONTACT_NOTIFICATION_UPDATED = 'CONTACT_NOTIFICATION_UPDATED';
exports.CONTACT_NOTIFICATION_UPDATED = CONTACT_NOTIFICATION_UPDATED;
var CONTACT_NOTIFICATION_DELETED = 'CONTACT_NOTIFICATION_DELETED'; //  - presence

exports.CONTACT_NOTIFICATION_DELETED = CONTACT_NOTIFICATION_DELETED;
var CONTACT_AVAILABLE = 'AVAILABLE';
exports.CONTACT_AVAILABLE = CONTACT_AVAILABLE;
var CONTACT_DO_NOT_DISTURB = 'DO_NOT_DISTURB'; // - types

exports.CONTACT_DO_NOT_DISTURB = CONTACT_DO_NOT_DISTURB;
var CONTACT_TYPE_STANDARD = 'STANDARD';
exports.CONTACT_TYPE_STANDARD = CONTACT_TYPE_STANDARD;
var CONTACT_TYPE_MEETING = 'MEETING';
exports.CONTACT_TYPE_MEETING = CONTACT_TYPE_MEETING;
var CONTACT_TYPE_USER = 'USER';
exports.CONTACT_TYPE_USER = CONTACT_TYPE_USER;
var CONTACT_TYPE_ROOMSYSTEM = 'ROOMSYSTEM';
exports.CONTACT_TYPE_ROOMSYSTEM = CONTACT_TYPE_ROOMSYSTEM;
var CONTACT_TYPE_PERSONAL_CONTACT = 'PERSONAL_CONTACT';
exports.CONTACT_TYPE_PERSONAL_CONTACT = CONTACT_TYPE_PERSONAL_CONTACT;
var CONTACT_TYPE_GROUP_CONTACT = 'GROUP_CONTACT';
exports.CONTACT_TYPE_GROUP_CONTACT = CONTACT_TYPE_GROUP_CONTACT;
var CONTACT_CATEGORY_PERSONAL = 'PERSONAL';
exports.CONTACT_CATEGORY_PERSONAL = CONTACT_CATEGORY_PERSONAL;
var CONTACT_CATEGORY_GROUP = 'GROUP'; // usage types

exports.CONTACT_CATEGORY_GROUP = CONTACT_CATEGORY_GROUP;
var USAGE_TYPE_PERSONAL = 'PERSONAL';
exports.USAGE_TYPE_PERSONAL = USAGE_TYPE_PERSONAL;
var USAGE_TYPE_SHARED = 'SHARED'; // recent / call history call type constants

exports.USAGE_TYPE_SHARED = USAGE_TYPE_SHARED;
var CALL_HISTORY_INCOMING = 'incoming';
exports.CALL_HISTORY_INCOMING = CALL_HISTORY_INCOMING;
var CALL_HISTORY_OUTGOING = 'outgoing';
exports.CALL_HISTORY_OUTGOING = CALL_HISTORY_OUTGOING;
var CALL_HISTORY_MISSED = 'missed'; // call history batch delete constants

exports.CALL_HISTORY_MISSED = CALL_HISTORY_MISSED;
var CALL_HISTORY_BATCH_DELETE_BEGIN = 'CALL_HISTORY_BATCH_DELETE_BEGIN';
exports.CALL_HISTORY_BATCH_DELETE_BEGIN = CALL_HISTORY_BATCH_DELETE_BEGIN;
var CALL_HISTORY_BATCH_DELETE_SUCCESS = 'CALL_HISTORY_BATCH_DELETE_SUCCESS';
exports.CALL_HISTORY_BATCH_DELETE_SUCCESS = CALL_HISTORY_BATCH_DELETE_SUCCESS;
var CALL_HISTORY_BATCH_DELETE_FAILED = 'CALL_HISTORY_BATCH_DELETE_FAILED';
exports.CALL_HISTORY_BATCH_DELETE_FAILED = CALL_HISTORY_BATCH_DELETE_FAILED;
var CALL_HISTORY_VIEWED = 'CALL_HISTORY_VIEWED'; // search
//  - actions

exports.CALL_HISTORY_VIEWED = CALL_HISTORY_VIEWED;
var SEARCHSTRING_UPDATE = 'SEARCHSTRING_UPDATE'; // localization

exports.SEARCHSTRING_UPDATE = SEARCHSTRING_UPDATE;
var SET_LOCALE = 'SET_LOCALE';
exports.SET_LOCALE = SET_LOCALE;
var SERVER_PUSH_ADD_CALLHISTORY = 'SERVER_PUSH_ADD_CALLHISTORY';
exports.SERVER_PUSH_ADD_CALLHISTORY = SERVER_PUSH_ADD_CALLHISTORY;
var SERVER_PUSH_DELETE_CALLHISTORY = 'SERVER_PUSH_DELETE_CALLHISTORY';
exports.SERVER_PUSH_DELETE_CALLHISTORY = SERVER_PUSH_DELETE_CALLHISTORY;
var SAVE_CONTACT_BEGIN = 'SAVE_CONTACT_BEGIN';
exports.SAVE_CONTACT_BEGIN = SAVE_CONTACT_BEGIN;
var SAVE_CONTACT_SUCCESS = 'SAVE_CONTACT_SUCCESS';
exports.SAVE_CONTACT_SUCCESS = SAVE_CONTACT_SUCCESS;
var SAVE_CONTACT_ERROR = 'SAVE_CONTACT_ERROR';
exports.SAVE_CONTACT_ERROR = SAVE_CONTACT_ERROR;
var VALIDATE_CONTACT_SUCCESS = 'VALIDATE_CONTACT_SUCCESS';
exports.VALIDATE_CONTACT_SUCCESS = VALIDATE_CONTACT_SUCCESS;
var VALIDATE_CONTACT_ERROR = 'VALIDATE_CONTACT_ERROR';
exports.VALIDATE_CONTACT_ERROR = VALIDATE_CONTACT_ERROR;
var DELETE_CONTACT = 'DELETE_CONTACT';
exports.DELETE_CONTACT = DELETE_CONTACT;
var RESET_CONTACT_ERROR_STATE = 'RESET_CONTACT_ERROR_STATE'; // validation error types

exports.RESET_CONTACT_ERROR_STATE = RESET_CONTACT_ERROR_STATE;
var VALIDATE_PATTERN = 'VALIDATE_PATTERN';
exports.VALIDATE_PATTERN = VALIDATE_PATTERN;
var VALIDATE_DUPLICATE = 'VALIDATE_DUPLICATE';
exports.VALIDATE_DUPLICATE = VALIDATE_DUPLICATE;
var VALIDATE_MAXLENGTH = 'VALIDATE_MAXLENGTH';
exports.VALIDATE_MAXLENGTH = VALIDATE_MAXLENGTH;
var VALIDATE_MINLENGTH = 'VALIDATE_MINLENGTH';
exports.VALIDATE_MINLENGTH = VALIDATE_MINLENGTH;
var VALIDATE_REQUIRED = 'VALIDATE_REQUIRED'; // socket commands

exports.VALIDATE_REQUIRED = VALIDATE_REQUIRED;
var CONFERENCE_START_RECORDING = 'conferenceStartRecording';
exports.CONFERENCE_START_RECORDING = CONFERENCE_START_RECORDING;
var CONFERENCE_STOP_RECORDING = 'conferenceStopRecording'; // Meeting types

exports.CONFERENCE_STOP_RECORDING = CONFERENCE_STOP_RECORDING;
var MEETING_TYPE_VMR = 'NORMAL';
exports.MEETING_TYPE_VMR = MEETING_TYPE_VMR;
var MEETING_TYPE_ONE_TIME = 'TEMP'; // Account/Group Settings

exports.MEETING_TYPE_ONE_TIME = MEETING_TYPE_ONE_TIME;
var ACCOUNT_SETTINGS_ENDPOINT = 'lifesize.account.settings';
exports.ACCOUNT_SETTINGS_ENDPOINT = ACCOUNT_SETTINGS_ENDPOINT;
var ACCOUNT_SETTINGS_URI_SUFFIX = 'admin/';
exports.ACCOUNT_SETTINGS_URI_SUFFIX = ACCOUNT_SETTINGS_URI_SUFFIX;
var GET_ACCOUNT_SETTINGS_REQUEST = 'GET_ACCOUNT_SETTINGS_REQUEST';
exports.GET_ACCOUNT_SETTINGS_REQUEST = GET_ACCOUNT_SETTINGS_REQUEST;
var GET_ACCOUNT_SETTINGS_SUCCESS = 'GET_ACCOUNT_SETTINGS_SUCCESS';
exports.GET_ACCOUNT_SETTINGS_SUCCESS = GET_ACCOUNT_SETTINGS_SUCCESS;
var GET_ACCOUNT_SETTINGS_FAILURE = 'GET_ACCOUNT_SETTINGS_FAILURE';
exports.GET_ACCOUNT_SETTINGS_FAILURE = GET_ACCOUNT_SETTINGS_FAILURE;
var SET_ACCOUNT_SETTINGS_REQUEST = 'SET_ACCOUNT_SETTINGS_REQUEST';
exports.SET_ACCOUNT_SETTINGS_REQUEST = SET_ACCOUNT_SETTINGS_REQUEST;
var SET_ACCOUNT_SETTINGS_SUCCESS = 'SET_ACCOUNT_SETTINGS_SUCCESS';
exports.SET_ACCOUNT_SETTINGS_SUCCESS = SET_ACCOUNT_SETTINGS_SUCCESS;
var SET_ACCOUNT_SETTINGS_FAILURE = 'SET_ACCOUNT_SETTINGS_FAILURE';
exports.SET_ACCOUNT_SETTINGS_FAILURE = SET_ACCOUNT_SETTINGS_FAILURE;
var GET_CUSTOMINVITE_PREVIEW_URI_SUFFIX = 'admin/customInvite/preview';
exports.GET_CUSTOMINVITE_PREVIEW_URI_SUFFIX = GET_CUSTOMINVITE_PREVIEW_URI_SUFFIX;
var GET_CUSTOMINVITE_PREVIEW_FAILURE = 'GET_CUSTOMINVITE_PREVIEW_FAILURE';
exports.GET_CUSTOMINVITE_PREVIEW_FAILURE = GET_CUSTOMINVITE_PREVIEW_FAILURE;
var GET_CUSTOMINVITE_PREVIEW_REQUEST = 'GET_CUSTOMINVITE_PREVIEW_REQUEST';
exports.GET_CUSTOMINVITE_PREVIEW_REQUEST = GET_CUSTOMINVITE_PREVIEW_REQUEST;
var GET_CUSTOMINVITE_PREVIEW_SUCCESS = 'GET_CUSTOMINVITE_PREVIEW_SUCCESS'; // give context to mcuLayout values

exports.GET_CUSTOMINVITE_PREVIEW_SUCCESS = GET_CUSTOMINVITE_PREVIEW_SUCCESS;
var MEETING_LAYOUT_TYPES = {
  DEFAULT: 1,
  ALTERNATIVE: 2
}; // slides

exports.MEETING_LAYOUT_TYPES = MEETING_LAYOUT_TYPES;
var SOCKET_SLIDE_PARTICIPANTKICK = 'SOCKET_SLIDE_PARTICIPANTKICK'; // media actions

exports.SOCKET_SLIDE_PARTICIPANTKICK = SOCKET_SLIDE_PARTICIPANTKICK;
var MEDIA_DEVICES_UPDATED = 'MEDIA_DEVICES_UPDATED';
exports.MEDIA_DEVICES_UPDATED = MEDIA_DEVICES_UPDATED;
var SET_DEFAULT_VIDEO = 'SET_DEFAULT_VIDEO';
exports.SET_DEFAULT_VIDEO = SET_DEFAULT_VIDEO;
var SET_DEFAULT_AUDIO = 'SET_DEFAULT_AUDIO';
exports.SET_DEFAULT_AUDIO = SET_DEFAULT_AUDIO;
var SET_PRIMARY_VIDEO_SOURCE_ID = 'SET_PRIMARY_VIDEO_SOURCE_ID';
exports.SET_PRIMARY_VIDEO_SOURCE_ID = SET_PRIMARY_VIDEO_SOURCE_ID;
var SET_VIDEO_SOURCE_QUALITY = 'SET_VIDEO_SOURCE_QUALITY';
exports.SET_VIDEO_SOURCE_QUALITY = SET_VIDEO_SOURCE_QUALITY;
var SET_PRIMARY_AUDIO_SOURCE_ID = 'SET_PRIMARY_AUDIO_SOURCE_ID';
exports.SET_PRIMARY_AUDIO_SOURCE_ID = SET_PRIMARY_AUDIO_SOURCE_ID;
var SET_PRIMARY_AUDIO_OUTPUT_ID = 'SET_PRIMARY_AUDIO_OUTPUT_ID';
exports.SET_PRIMARY_AUDIO_OUTPUT_ID = SET_PRIMARY_AUDIO_OUTPUT_ID;
var SET_SELECTED_VIDEO_SOURCE_ID = 'SET_SELECTED_VIDEO_SOURCE_ID';
exports.SET_SELECTED_VIDEO_SOURCE_ID = SET_SELECTED_VIDEO_SOURCE_ID;
var SET_SELECTED_AUDIO_SOURCE_ID = 'SET_SELECTED_AUDIO_SOURCE_ID';
exports.SET_SELECTED_AUDIO_SOURCE_ID = SET_SELECTED_AUDIO_SOURCE_ID;
var VIDEO_PLAYBACK_BLOCKED = 'VIDEO_PLAYBACK_BLOCKED';
exports.VIDEO_PLAYBACK_BLOCKED = VIDEO_PLAYBACK_BLOCKED;
var VIDEO_PLAYBACK_STARTED = 'VIDEO_PLAYBACK_STARTED'; // stream actions

exports.VIDEO_PLAYBACK_STARTED = VIDEO_PLAYBACK_STARTED;
var ACQUIRE_LOCAL_PRIMARY_STREAM_BEGIN = 'ACQUIRE_LOCAL_PRIMARY_STREAM_BEGIN';
exports.ACQUIRE_LOCAL_PRIMARY_STREAM_BEGIN = ACQUIRE_LOCAL_PRIMARY_STREAM_BEGIN;
var ACQUIRE_LOCAL_PRIMARY_STREAM_SUCCESS = 'ACQUIRE_LOCAL_PRIMARY_STREAM_SUCCESS';
exports.ACQUIRE_LOCAL_PRIMARY_STREAM_SUCCESS = ACQUIRE_LOCAL_PRIMARY_STREAM_SUCCESS;
var ACQUIRE_LOCAL_PRIMARY_STREAM_FAILURE = 'ACQUIRE_LOCAL_PRIMARY_STREAM_FAILURE';
exports.ACQUIRE_LOCAL_PRIMARY_STREAM_FAILURE = ACQUIRE_LOCAL_PRIMARY_STREAM_FAILURE;
var ACQUIRE_LOCAL_SECONDARY_STREAM_BEGIN = 'ACQUIRE_LOCAL_SECONDARY_STREAM_BEGIN';
exports.ACQUIRE_LOCAL_SECONDARY_STREAM_BEGIN = ACQUIRE_LOCAL_SECONDARY_STREAM_BEGIN;
var ACQUIRE_LOCAL_SECONDARY_STREAM_SUCCESS = 'ACQUIRE_LOCAL_SECONDARY_STREAM_SUCCESS';
exports.ACQUIRE_LOCAL_SECONDARY_STREAM_SUCCESS = ACQUIRE_LOCAL_SECONDARY_STREAM_SUCCESS;
var ACQUIRE_LOCAL_SECONDARY_STREAM_FAILURE = 'ACQUIRE_LOCAL_SECONDARY_STREAM_FAILURE';
exports.ACQUIRE_LOCAL_SECONDARY_STREAM_FAILURE = ACQUIRE_LOCAL_SECONDARY_STREAM_FAILURE;
var GETUSERMEDIA_PENDING_PERMISSIONS = 'GETUSERMEDIA_PENDING_PERMISSIONS';
exports.GETUSERMEDIA_PENDING_PERMISSIONS = GETUSERMEDIA_PENDING_PERMISSIONS;
var UPDATE_ROUND_TRIP_TIME_AVERAGE = 'UPDATE_ROUND_TRIP_TIME_AVERAGE';
exports.UPDATE_ROUND_TRIP_TIME_AVERAGE = UPDATE_ROUND_TRIP_TIME_AVERAGE;
var UPDATE_AVAILABLE_BANDWIDTH = 'UPDATE_AVAILABLE_BANDWIDTH';
exports.UPDATE_AVAILABLE_BANDWIDTH = UPDATE_AVAILABLE_BANDWIDTH;
var UPDATE_SSRC_SEND_STATS = 'UPDATE_SSRC_SEND_STATS';
exports.UPDATE_SSRC_SEND_STATS = UPDATE_SSRC_SEND_STATS;
var UPDATE_SSRC_RECEIVE_STATS = 'UPDATE_SSRC_RECEIVE_STATS';
exports.UPDATE_SSRC_RECEIVE_STATS = UPDATE_SSRC_RECEIVE_STATS;
var RTCSTATS_STARTED = 'RTCSTATS_STARTED';
exports.RTCSTATS_STARTED = RTCSTATS_STARTED;
var RTCSTATS_STOPPED = 'RTCSTATS_STOPPED';
exports.RTCSTATS_STOPPED = RTCSTATS_STOPPED;
var CALLSTATSIO_STATS_UPDATE = 'CALLSTATSIO_STATS_UPDATE';
exports.CALLSTATSIO_STATS_UPDATE = CALLSTATSIO_STATS_UPDATE;
var SET_LOCAL_STREAM = 'SET_LOCAL_STREAM';
exports.SET_LOCAL_STREAM = SET_LOCAL_STREAM;
var END_LOCAL_STREAM = 'END_LOCAL_STREAM';
exports.END_LOCAL_STREAM = END_LOCAL_STREAM;
var LOCAL_STREAM_UPDATED = 'LOCAL_STREAM_UPDATED';
exports.LOCAL_STREAM_UPDATED = LOCAL_STREAM_UPDATED;
var LOCAL_STREAM_ENDED = 'LOCAL_STREAM_ENDED';
exports.LOCAL_STREAM_ENDED = LOCAL_STREAM_ENDED;
var ENABLE_WEB_CONFERENCE_MODE = 'ENABLE_WEB_CONFERENCE_MODE';
exports.ENABLE_WEB_CONFERENCE_MODE = ENABLE_WEB_CONFERENCE_MODE;
var DISABLE_WEB_CONFERENCE_MODE = 'DISABLE_WEB_CONFERENCE_MODE';
exports.DISABLE_WEB_CONFERENCE_MODE = DISABLE_WEB_CONFERENCE_MODE;
var TOGGLE_AUDIO_MUTE = 'TOGGLE_AUDIO_MUTE';
exports.TOGGLE_AUDIO_MUTE = TOGGLE_AUDIO_MUTE;
var SWITCH_VIDEO_CAMERA = 'SWITCH_VIDEO_CAMERA';
exports.SWITCH_VIDEO_CAMERA = SWITCH_VIDEO_CAMERA;
var LOCAL_VIDEO_MUTED = 'LOCAL_VIDEO_MUTED';
exports.LOCAL_VIDEO_MUTED = LOCAL_VIDEO_MUTED;
var LOCAL_VIDEO_UNMUTED = 'LOCAL_VIDEO_UNMUTED';
exports.LOCAL_VIDEO_UNMUTED = LOCAL_VIDEO_UNMUTED;
var LOCAL_AUDIO_MUTED = 'LOCAL_AUDIO_MUTED';
exports.LOCAL_AUDIO_MUTED = LOCAL_AUDIO_MUTED;
var LOCAL_AUDIO_UNMUTED = 'LOCAL_AUDIO_UNMUTED';
exports.LOCAL_AUDIO_UNMUTED = LOCAL_AUDIO_UNMUTED;
var ACTIVE_PEER_CONNECTION = 'ACTIVE_PEER_CONNECTION'; // rtc actions

exports.ACTIVE_PEER_CONNECTION = ACTIVE_PEER_CONNECTION;
var RTC_REMOTE_STREAM_ADDED = 'RTC_REMOTE_STREAM_ADDED';
exports.RTC_REMOTE_STREAM_ADDED = RTC_REMOTE_STREAM_ADDED;
var RTC_REMOTE_STREAM_UPDATED = 'RTC_REMOTE_STREAM_UPDATED';
exports.RTC_REMOTE_STREAM_UPDATED = RTC_REMOTE_STREAM_UPDATED;
var RTC_REMOTE_STREAM_REMOVED = 'RTC_REMOTE_STREAM_REMOVED';
exports.RTC_REMOTE_STREAM_REMOVED = RTC_REMOTE_STREAM_REMOVED;
var RTC_REMOTE_PRESENTATION_STREAM_ADDED = 'RTC_REMOTE_PRESENTATION_STREAM_ADDED';
exports.RTC_REMOTE_PRESENTATION_STREAM_ADDED = RTC_REMOTE_PRESENTATION_STREAM_ADDED;
var RTC_REMOTE_PRESENTATION_STREAM_REMOVED = 'RTC_REMOTE_PRESENTATION_STREAM_REMOVED';
exports.RTC_REMOTE_PRESENTATION_STREAM_REMOVED = RTC_REMOTE_PRESENTATION_STREAM_REMOVED;
var UPDATE_LOCAL_SSRCS = 'UPDATE_LOCAL_SSRCS';
exports.UPDATE_LOCAL_SSRCS = UPDATE_LOCAL_SSRCS;
var RESET_LOCAL_SSRCS = 'RESET_LOCAL_SSRCS';
exports.RESET_LOCAL_SSRCS = RESET_LOCAL_SSRCS;
var REMOTE_PRESENTATION_STREAM_AVAILABLE = 'REMOTE_PRESENTATION_STREAM_AVAILABLE';
exports.REMOTE_PRESENTATION_STREAM_AVAILABLE = REMOTE_PRESENTATION_STREAM_AVAILABLE;
var WIRELESS_PRESENTATION_ON_STREAM = 'WIRELESS_PRESENTATION_ON_STREAM';
exports.WIRELESS_PRESENTATION_ON_STREAM = WIRELESS_PRESENTATION_ON_STREAM;
var WIRELESS_PRESENTATION_STREAM_ENDED = 'WIRELESS_PRESENTATION_STREAM_ENDED'; // call states

exports.WIRELESS_PRESENTATION_STREAM_ENDED = WIRELESS_PRESENTATION_STREAM_ENDED;
var CALL_STATE_DISCONNECTED = 'disconnected';
exports.CALL_STATE_DISCONNECTED = CALL_STATE_DISCONNECTED;
var CALL_STATE_FAILED = 'failed';
exports.CALL_STATE_FAILED = CALL_STATE_FAILED;
var CALL_STATE_CONNECTED = 'connected';
exports.CALL_STATE_CONNECTED = CALL_STATE_CONNECTED;
var CALL_STATE_CONNECTING = 'connecting';
exports.CALL_STATE_CONNECTING = CALL_STATE_CONNECTING;
var CALL_STATE_CALLING = 'calling';
exports.CALL_STATE_CALLING = CALL_STATE_CALLING;
var CALL_STATE_LOCAL_RINGING = 'local_ringing';
exports.CALL_STATE_LOCAL_RINGING = CALL_STATE_LOCAL_RINGING;
var CONFERENCE_SLIDE_UPDATE = 'CONFERENCE_SLIDE_UPDATE'; // ? Can this be removed?
// error constants

exports.CONFERENCE_SLIDE_UPDATE = CONFERENCE_SLIDE_UPDATE;
var WAMP_JWT_ERROR_REASON = 'wamp.error.jwt_error';
exports.WAMP_JWT_ERROR_REASON = WAMP_JWT_ERROR_REASON;
var WAMP_SUBSCRIPTION_NOT_FOUND = 'WAMP_SUBSCRIPTION_NOT_FOUND'; // graphql chat

exports.WAMP_SUBSCRIPTION_NOT_FOUND = WAMP_SUBSCRIPTION_NOT_FOUND;
var CHAT_EVENT_JOINED_ROOM = 'joinedRoom';
exports.CHAT_EVENT_JOINED_ROOM = CHAT_EVENT_JOINED_ROOM;
var CHAT_EVENT_USER_LEFT_ROOM = 'userLeftRoom';
exports.CHAT_EVENT_USER_LEFT_ROOM = CHAT_EVENT_USER_LEFT_ROOM;
var CHAT_EVENT_USER_JOINED_ROOM = 'userJoinedRoom';
exports.CHAT_EVENT_USER_JOINED_ROOM = CHAT_EVENT_USER_JOINED_ROOM;
var CHAT_EVENT_MESSAGE = 'chatMessage';
exports.CHAT_EVENT_MESSAGE = CHAT_EVENT_MESSAGE;
var CHAT_JOINED_ROOM = 'CHAT_JOINED_ROOM';
exports.CHAT_JOINED_ROOM = CHAT_JOINED_ROOM;
var CHAT_LEFT_ROOM = 'CHAT_LEFT_ROOM';
exports.CHAT_LEFT_ROOM = CHAT_LEFT_ROOM;
var CHAT_USER_JOINED_ROOM = 'CHAT_USER_JOINED_ROOM';
exports.CHAT_USER_JOINED_ROOM = CHAT_USER_JOINED_ROOM;
var CHAT_USER_LEFT_ROOM = 'CHAT_USER_LEFT_ROOM';
exports.CHAT_USER_LEFT_ROOM = CHAT_USER_LEFT_ROOM;
var CHAT_POST_MESSAGE_BEGIN = 'CHAT_POST_MESSAGE_BEGIN';
exports.CHAT_POST_MESSAGE_BEGIN = CHAT_POST_MESSAGE_BEGIN;
var CHAT_POST_MESSAGE_SUCCESS = 'CHAT_POST_MESSAGE_SUCCESS';
exports.CHAT_POST_MESSAGE_SUCCESS = CHAT_POST_MESSAGE_SUCCESS;
var CHAT_POST_MESSAGE_FAILURE = 'CHAT_POST_MESSAGE_FAILURE';
exports.CHAT_POST_MESSAGE_FAILURE = CHAT_POST_MESSAGE_FAILURE;
var CHAT_GET_ROOMS_BEGIN = 'CHAT_GET_ROOMS_BEGIN';
exports.CHAT_GET_ROOMS_BEGIN = CHAT_GET_ROOMS_BEGIN;
var CHAT_GET_ROOMS_SUCCESS = 'CHAT_GET_ROOMS_SUCCESS';
exports.CHAT_GET_ROOMS_SUCCESS = CHAT_GET_ROOMS_SUCCESS;
var CHAT_GET_ROOMS_FAILURE = 'CHAT_GET_ROOMS_FAILURE';
exports.CHAT_GET_ROOMS_FAILURE = CHAT_GET_ROOMS_FAILURE;
var CHAT_GET_MESSAGES_BEGIN = 'CHAT_GET_MESSAGES_BEGIN';
exports.CHAT_GET_MESSAGES_BEGIN = CHAT_GET_MESSAGES_BEGIN;
var CHAT_GET_MESSAGES_SUCCESS = 'CHAT_GET_MESSAGES_SUCCESS';
exports.CHAT_GET_MESSAGES_SUCCESS = CHAT_GET_MESSAGES_SUCCESS;
var CHAT_GET_MESSAGES_FAILURE = 'CHAT_GET_MESSAGES_FAILURE';
exports.CHAT_GET_MESSAGES_FAILURE = CHAT_GET_MESSAGES_FAILURE;
var CHAT_RECEIVED_MESSAGE = 'CHAT_RECEIVED_MESSAGE';
exports.CHAT_RECEIVED_MESSAGE = CHAT_RECEIVED_MESSAGE;
var CHAT_LAST_READ_AT = 'CHAT_LAST_READ_AT';
exports.CHAT_LAST_READ_AT = CHAT_LAST_READ_AT;
var CHAT_EVENT = 'CHAT_EVENT';
exports.CHAT_EVENT = CHAT_EVENT;
var CHAT_TOPIC = 'ls.gqlChat';
exports.CHAT_TOPIC = CHAT_TOPIC;
var ERROR_GENERATING_RTC_CERTIFICATE = 'ERROR_GENERATING_RTC_CERTIFICATE'; // errors for acquiring local primary stream

exports.ERROR_GENERATING_RTC_CERTIFICATE = ERROR_GENERATING_RTC_CERTIFICATE;
var MISSING_AUDIO_TRACK = 'MISSING_AUDIO_TRACK';
exports.MISSING_AUDIO_TRACK = MISSING_AUDIO_TRACK;
var MISSING_VIDEO_TRACK = 'MISSING_VIDEO_TRACK';
exports.MISSING_VIDEO_TRACK = MISSING_VIDEO_TRACK;
var MISSING_PRESENTATION_TRACK = 'MISSING_PRESENTATION_TRACK';
exports.MISSING_PRESENTATION_TRACK = MISSING_PRESENTATION_TRACK;
var UNKNOWN_NAVIGATORUSERMEDIAERROR = 'UNKNOWN_NAVIGATORUSERMEDIAERROR';
exports.UNKNOWN_NAVIGATORUSERMEDIAERROR = UNKNOWN_NAVIGATORUSERMEDIAERROR;
var PERMISSION_DENIED_ERROR = 'PermissionDeniedError';
exports.PERMISSION_DENIED_ERROR = PERMISSION_DENIED_ERROR;
var PERMISSION_DISMISSED_ERROR = 'PermissionDismissedError'; // custom numbers

exports.PERMISSION_DISMISSED_ERROR = PERMISSION_DISMISSED_ERROR;
var SELECT_COUNTRY_NUMBER = 'SELECT_COUNTRY_NUMBER'; // Monitoring Service

exports.SELECT_COUNTRY_NUMBER = SELECT_COUNTRY_NUMBER;
var MONITORING_SERVICE_ENDPOINT = 'lifesize.monitoring';
exports.MONITORING_SERVICE_ENDPOINT = MONITORING_SERVICE_ENDPOINT;
var MONITORING_CHECKIN_URL_SUFFIX = 'health/check-in';
exports.MONITORING_CHECKIN_URL_SUFFIX = MONITORING_CHECKIN_URL_SUFFIX;
var MONITORING_CHECKIN_BEGIN = 'MONITORING_CHECKIN_BEGIN';
exports.MONITORING_CHECKIN_BEGIN = MONITORING_CHECKIN_BEGIN;
var MONITORING_CHECKIN_SUCCESS = 'MONITORING_CHECKIN_SUCCESS';
exports.MONITORING_CHECKIN_SUCCESS = MONITORING_CHECKIN_SUCCESS;
var MONITORING_CHECKIN_FAILURE = 'MONITORING_CHECKIN_FAILURE';
exports.MONITORING_CHECKIN_FAILURE = MONITORING_CHECKIN_FAILURE;
var MONITORING_CHANGE_URL_SUFFIX = 'health/change';
exports.MONITORING_CHANGE_URL_SUFFIX = MONITORING_CHANGE_URL_SUFFIX;
var MONITORING_CHANGE_BEGIN = 'MONITORING_CHANGE_BEGIN';
exports.MONITORING_CHANGE_BEGIN = MONITORING_CHANGE_BEGIN;
var MONITORING_CHANGE_SUCCESS = 'MONITORING_CHANGE_SUCCESS';
exports.MONITORING_CHANGE_SUCCESS = MONITORING_CHANGE_SUCCESS;
var MONITORING_CHANGE_FAILURE = 'MONITORING_CHANGE_FAILURE';
exports.MONITORING_CHANGE_FAILURE = MONITORING_CHANGE_FAILURE;
var MONITORING_GROUP_SETTINGS_URL_SUFFIX = 'settings/group';
exports.MONITORING_GROUP_SETTINGS_URL_SUFFIX = MONITORING_GROUP_SETTINGS_URL_SUFFIX;
var MONITORING_GET_GROUP_SETTINGS_BEGIN = 'MONITORING_GET_GROUP_SETTINGS_BEGIN';
exports.MONITORING_GET_GROUP_SETTINGS_BEGIN = MONITORING_GET_GROUP_SETTINGS_BEGIN;
var MONITORING_GET_GROUP_SETTINGS_SUCCESS = 'MONITORING_GET_GROUP_SETTINGS_SUCCESS';
exports.MONITORING_GET_GROUP_SETTINGS_SUCCESS = MONITORING_GET_GROUP_SETTINGS_SUCCESS;
var MONITORING_GET_GROUP_SETTINGS_FAILURE = 'MONITORING_GET_GROUP_SETTINGS_FAILURE';
exports.MONITORING_GET_GROUP_SETTINGS_FAILURE = MONITORING_GET_GROUP_SETTINGS_FAILURE;
var MONITORING_PUT_GROUP_SETTINGS_BEGIN = 'MONITORING_PUT_GROUP_SETTINGS_BEGIN';
exports.MONITORING_PUT_GROUP_SETTINGS_BEGIN = MONITORING_PUT_GROUP_SETTINGS_BEGIN;
var MONITORING_PUT_GROUP_SETTINGS_SUCCESS = 'MONITORING_PUT_GROUP_SETTINGS_SUCCESS';
exports.MONITORING_PUT_GROUP_SETTINGS_SUCCESS = MONITORING_PUT_GROUP_SETTINGS_SUCCESS;
var MONITORING_PUT_GROUP_SETTINGS_FAILURE = 'MONITORING_PUT_GROUP_SETTINGS_FAILURE'; // Feature Service

exports.MONITORING_PUT_GROUP_SETTINGS_FAILURE = MONITORING_PUT_GROUP_SETTINGS_FAILURE;
var FEATURE_SERVICE_ENDPOINT = 'lifesize.account.features';
exports.FEATURE_SERVICE_ENDPOINT = FEATURE_SERVICE_ENDPOINT;
var ACCOUNT_FEATURES = 'ACCOUNT_FEATURES'; // Account Features

exports.ACCOUNT_FEATURES = ACCOUNT_FEATURES;
var ACCOUNT_FEATURE_DIRECT_MEDIA = 'directMedia';
exports.ACCOUNT_FEATURE_DIRECT_MEDIA = ACCOUNT_FEATURE_DIRECT_MEDIA;
var ACCOUNT_FEATURE_ONE_TIME_MEETING = 'oneTimeMeeting';
exports.ACCOUNT_FEATURE_ONE_TIME_MEETING = ACCOUNT_FEATURE_ONE_TIME_MEETING;
var ACCOUNT_FEATURE_GALAXY = 'galaxy';
exports.ACCOUNT_FEATURE_GALAXY = ACCOUNT_FEATURE_GALAXY;
var ACCOUNT_FEATURE_RECORDING = 'recording';
exports.ACCOUNT_FEATURE_RECORDING = ACCOUNT_FEATURE_RECORDING;
var ACCOUNT_FEATURE_SSO = 'sso';
exports.ACCOUNT_FEATURE_SSO = ACCOUNT_FEATURE_SSO;
var ACCOUNT_FEATURE_STREAMING = 'streaming';
exports.ACCOUNT_FEATURE_STREAMING = ACCOUNT_FEATURE_STREAMING;
var ACCOUNT_TOPIC = 'ls.account';
exports.ACCOUNT_TOPIC = ACCOUNT_TOPIC;
var ACCOUNT_SETTING_UPDATED = 'ACCOUNT_SETTING_UPDATED';
exports.ACCOUNT_SETTING_UPDATED = ACCOUNT_SETTING_UPDATED;
var ACTIVE_CONFERENCE_TOPIC = 'ls.activeconferences';
exports.ACTIVE_CONFERENCE_TOPIC = ACTIVE_CONFERENCE_TOPIC;
var ACTIVE_CONFERENCE_NOTIFICATION = 'activeConferencesNotification'; // User Attributes (Replaces User Profile)

exports.ACTIVE_CONFERENCE_NOTIFICATION = ACTIVE_CONFERENCE_NOTIFICATION;
var CHECKIN_SERVICE_ENDPOINT = 'lifesize.checkin';
exports.CHECKIN_SERVICE_ENDPOINT = CHECKIN_SERVICE_ENDPOINT;
var CHECKIN_SERVICE_ATTRIBUTES_SUFFIX = '';
exports.CHECKIN_SERVICE_ATTRIBUTES_SUFFIX = CHECKIN_SERVICE_ATTRIBUTES_SUFFIX;
var GET_SESSION_REQUEST = 'GET_SESSION_REQUEST';
exports.GET_SESSION_REQUEST = GET_SESSION_REQUEST;
var GET_SESSION_SUCCESS = 'GET_SESSION_SUCCESS';
exports.GET_SESSION_SUCCESS = GET_SESSION_SUCCESS;
var GET_SESSION_FAILURE = 'GET_SESSION_FAILURE';
exports.GET_SESSION_FAILURE = GET_SESSION_FAILURE;
var USER_CONTEXT_DEVICE = 'DEVICE';
exports.USER_CONTEXT_DEVICE = USER_CONTEXT_DEVICE;
var USER_CONTEXT_USER = 'USER';
exports.USER_CONTEXT_USER = USER_CONTEXT_USER;
var USER_CONTEXT_REMOTE = 'REMOTE';
exports.USER_CONTEXT_REMOTE = USER_CONTEXT_REMOTE;
var USER_ROLE_ADMIN = 'ADMIN';
exports.USER_ROLE_ADMIN = USER_ROLE_ADMIN;
var USER_ROLE_DEVICE = 'DEVICE';
exports.USER_ROLE_DEVICE = USER_ROLE_DEVICE;
var USER_ROLE_SUPER_USER = 'SUPER_USER';
exports.USER_ROLE_SUPER_USER = USER_ROLE_SUPER_USER;
var USER_ROLE_USER = 'USER';
exports.USER_ROLE_USER = USER_ROLE_USER;
var USER_ROLE_GUEST = 'GUEST'; // User Profile

exports.USER_ROLE_GUEST = USER_ROLE_GUEST;
var ME_TOPIC = 'ls.me';
exports.ME_TOPIC = ME_TOPIC;
var WAMP_SUBSCRIPTION_ACTION_ME_TOPIC = 'WAMP_SUBSCRIPTION_ACTION_ME_TOPIC';
exports.WAMP_SUBSCRIPTION_ACTION_ME_TOPIC = WAMP_SUBSCRIPTION_ACTION_ME_TOPIC;
var USER_SETTINGS_ENDPOINT = 'lifesize.usersettings';
exports.USER_SETTINGS_ENDPOINT = USER_SETTINGS_ENDPOINT;
var UPDATE_CURRENT_USER_SETTINGS_BEGIN = 'UPDATE_CURRENT_USER_SETTINGS_BEGIN';
exports.UPDATE_CURRENT_USER_SETTINGS_BEGIN = UPDATE_CURRENT_USER_SETTINGS_BEGIN;
var UPDATE_CURRENT_USER_SETTINGS_SUCCESS = 'UPDATE_CURRENT_USER_SETTINGS_SUCCESS';
exports.UPDATE_CURRENT_USER_SETTINGS_SUCCESS = UPDATE_CURRENT_USER_SETTINGS_SUCCESS;
var UPDATE_CURRENT_USER_SETTINGS_FAILURE = 'UPDATE_CURRENT_USER_SETTINGS_FAILURE';
exports.UPDATE_CURRENT_USER_SETTINGS_FAILURE = UPDATE_CURRENT_USER_SETTINGS_FAILURE;
var GET_CURRENT_USER_SETTINGS_BEGIN = 'GET_CURRENT_USER_SETTINGS_BEGIN';
exports.GET_CURRENT_USER_SETTINGS_BEGIN = GET_CURRENT_USER_SETTINGS_BEGIN;
var GET_CURRENT_USER_SETTINGS_SUCCESS = 'GET_CURRENT_USER_SETTINGS_SUCCESS';
exports.GET_CURRENT_USER_SETTINGS_SUCCESS = GET_CURRENT_USER_SETTINGS_SUCCESS;
var GET_CURRENT_USER_SETTINGS_FAILURE = 'GET_CURRENT_USER_SETTINGS_FAILURE';
exports.GET_CURRENT_USER_SETTINGS_FAILURE = GET_CURRENT_USER_SETTINGS_FAILURE;
var MMS_API_BEGIN = 'MMS_API_BEGIN';
exports.MMS_API_BEGIN = MMS_API_BEGIN;
var MMS_API_SUCCESS = 'MMS_API_SUCCESS';
exports.MMS_API_SUCCESS = MMS_API_SUCCESS;
var MMS_API_FAILURE = 'MMS_API_FAILURE';
exports.MMS_API_FAILURE = MMS_API_FAILURE;
var GET_PAIRING_CODE = 'getPairingCode';
exports.GET_PAIRING_CODE = GET_PAIRING_CODE;
var GET_PAIRING_STATUS_AND_DETAILS = 'getPairingStatusAndDetails';
exports.GET_PAIRING_STATUS_AND_DETAILS = GET_PAIRING_STATUS_AND_DETAILS;
var GET_ALL_STREAMS = 'v1/meeting/streaming/';
exports.GET_ALL_STREAMS = GET_ALL_STREAMS;
var GET_QNA_TRANSCRIPT = 'v1/meeting/';
exports.GET_QNA_TRANSCRIPT = GET_QNA_TRANSCRIPT;
var GET_QNA_TRANSCRIPT_SUFFIX = '/qna/transcript';
exports.GET_QNA_TRANSCRIPT_SUFFIX = GET_QNA_TRANSCRIPT_SUFFIX;
var API_STREAMING_SETTINGS = 'v1/meeting/';
exports.API_STREAMING_SETTINGS = API_STREAMING_SETTINGS;
var API_STREAMING_SETTINGS_SUFFIX = '/streaming';
exports.API_STREAMING_SETTINGS_SUFFIX = API_STREAMING_SETTINGS_SUFFIX;
var GET_INVITATION_LINK = 'getInvitationToken';
exports.GET_INVITATION_LINK = GET_INVITATION_LINK;
var PAIRING_SUCCESSFUL = 'PAIRING_SUCCESSFUL';
exports.PAIRING_SUCCESSFUL = PAIRING_SUCCESSFUL;
var DEVICE_INFO_NAME_CHANGE = 'DEVICE_INFO_NAME_CHANGE';
exports.DEVICE_INFO_NAME_CHANGE = DEVICE_INFO_NAME_CHANGE;
var NAME_UPDATED = 'NAME_UPDATED'; // User

exports.NAME_UPDATED = NAME_UPDATED;
var USER_SERVICE_NAME = 'lifesize.user';
exports.USER_SERVICE_NAME = USER_SERVICE_NAME;
var USER_SERVICE_URI_SUFFIX_CREATE = 'user/create';
exports.USER_SERVICE_URI_SUFFIX_CREATE = USER_SERVICE_URI_SUFFIX_CREATE;
var USER_SERVICE_URI_SUFFIX_DELETE = 'user/delete';
exports.USER_SERVICE_URI_SUFFIX_DELETE = USER_SERVICE_URI_SUFFIX_DELETE;
var USER_SERVICE_URI_SUFFIX_DELETE_LIST = 'user/deletelist';
exports.USER_SERVICE_URI_SUFFIX_DELETE_LIST = USER_SERVICE_URI_SUFFIX_DELETE_LIST;
var USER_SERVICE_URI_SUFFIX_UPDATE = 'user/update';
exports.USER_SERVICE_URI_SUFFIX_UPDATE = USER_SERVICE_URI_SUFFIX_UPDATE;
var USER_SERVICE_CREATE_REQUEST = 'USER_SERVICE_CREATE_REQUEST';
exports.USER_SERVICE_CREATE_REQUEST = USER_SERVICE_CREATE_REQUEST;
var USER_SERVICE_CREATE_SUCCESS = 'USER_SERVICE_CREATE_SUCCESS';
exports.USER_SERVICE_CREATE_SUCCESS = USER_SERVICE_CREATE_SUCCESS;
var USER_SERVICE_CREATE_FAILURE = 'USER_SERVICE_CREATE_FAILURE';
exports.USER_SERVICE_CREATE_FAILURE = USER_SERVICE_CREATE_FAILURE;
var USER_SERVICE_DELETE_REQUEST = 'USER_SERVICE_DELETE_REQUEST';
exports.USER_SERVICE_DELETE_REQUEST = USER_SERVICE_DELETE_REQUEST;
var USER_SERVICE_DELETE_SUCCESS = 'USER_SERVICE_DELETE_SUCCESS';
exports.USER_SERVICE_DELETE_SUCCESS = USER_SERVICE_DELETE_SUCCESS;
var USER_SERVICE_DELETE_FAILURE = 'USER_SERVICE_DELETE_FAILURE';
exports.USER_SERVICE_DELETE_FAILURE = USER_SERVICE_DELETE_FAILURE;
var USER_SERVICE_DELETE_LIST_REQUEST = 'USER_SERVICE_DELETE_LIST_REQUEST';
exports.USER_SERVICE_DELETE_LIST_REQUEST = USER_SERVICE_DELETE_LIST_REQUEST;
var USER_SERVICE_DELETE_LIST_SUCCESS = 'USER_SERVICE_DELETE_LIST_SUCCESS';
exports.USER_SERVICE_DELETE_LIST_SUCCESS = USER_SERVICE_DELETE_LIST_SUCCESS;
var USER_SERVICE_DELETE_LIST_FAILURE = 'USER_SERVICE_DELETE_LIST_FAILURE';
exports.USER_SERVICE_DELETE_LIST_FAILURE = USER_SERVICE_DELETE_LIST_FAILURE;
var USER_SERVICE_UPDATE_REQUEST = 'USER_SERVICE_UPDATE_REQUEST';
exports.USER_SERVICE_UPDATE_REQUEST = USER_SERVICE_UPDATE_REQUEST;
var USER_SERVICE_UPDATE_SUCCESS = 'USER_SERVICE_UPDATE_SUCCESS';
exports.USER_SERVICE_UPDATE_SUCCESS = USER_SERVICE_UPDATE_SUCCESS;
var USER_SERVICE_UPDATE_FAILURE = 'USER_SERVICE_UPDATE_FAILURE';
exports.USER_SERVICE_UPDATE_FAILURE = USER_SERVICE_UPDATE_FAILURE;
var USER_SERVICE_ERROR_RESET = 'USER_SERVICE_ERROR_RESET'; // PhoneHD Service

exports.USER_SERVICE_ERROR_RESET = USER_SERVICE_ERROR_RESET;
var PHONEHD_CUSTOMIZATION_TOPIC = 'ls.dsc';
exports.PHONEHD_CUSTOMIZATION_TOPIC = PHONEHD_CUSTOMIZATION_TOPIC;
var PHONEHD_CUSTOMIZATION_ENDPOINT = 'lifesize.device';
exports.PHONEHD_CUSTOMIZATION_ENDPOINT = PHONEHD_CUSTOMIZATION_ENDPOINT;
var WAMP_SUBSCRIPTION_PHONEHD_CUSTOMIZATION_EVENT = 'WAMP_SUBSCRIPTION_PHONEHD_CUSTOMIZATION_EVENT'; // Call History Service

exports.WAMP_SUBSCRIPTION_PHONEHD_CUSTOMIZATION_EVENT = WAMP_SUBSCRIPTION_PHONEHD_CUSTOMIZATION_EVENT;
var CALLHISTORY_TOPIC = 'ls.ch';
exports.CALLHISTORY_TOPIC = CALLHISTORY_TOPIC;
var WAMP_SUBSCRIPTION_CALLHISTORY_EVENT = 'WAMP_SUBSCRIPTION_CALLHISTORY_EVENT';
exports.WAMP_SUBSCRIPTION_CALLHISTORY_EVENT = WAMP_SUBSCRIPTION_CALLHISTORY_EVENT;
var CALLHISTORY_RPC_ENDPOINT = 'lifesize.callhistory';
exports.CALLHISTORY_RPC_ENDPOINT = CALLHISTORY_RPC_ENDPOINT;
var CALLHISTORY_URL_SUFFIX = 'callhistory';
exports.CALLHISTORY_URL_SUFFIX = CALLHISTORY_URL_SUFFIX;
var CALLHISTORY_LOAD_BEGIN = 'CALLHISTORY_LOAD_BEGIN';
exports.CALLHISTORY_LOAD_BEGIN = CALLHISTORY_LOAD_BEGIN;
var CALLHISTORY_LOAD_SUCCESS = 'CALLHISTORY_LOAD_SUCCESS';
exports.CALLHISTORY_LOAD_SUCCESS = CALLHISTORY_LOAD_SUCCESS;
var CALLHISTORY_LOAD_FAILURE = 'CALLHISTORY_LOAD_FAILURE';
exports.CALLHISTORY_LOAD_FAILURE = CALLHISTORY_LOAD_FAILURE;
var CALLHISTORY_DELETEALL_BEGIN = 'CALLHISTORY_DELETEALL_BEGIN';
exports.CALLHISTORY_DELETEALL_BEGIN = CALLHISTORY_DELETEALL_BEGIN;
var CALLHISTORY_DELETEALL_SUCCESS = 'CALLHISTORY_DELETEALL_SUCCESS';
exports.CALLHISTORY_DELETEALL_SUCCESS = CALLHISTORY_DELETEALL_SUCCESS;
var CALLHISTORY_DELETEALL_FAILURE = 'CALLHISTORY_DELETEALL_FAILURE';
exports.CALLHISTORY_DELETEALL_FAILURE = CALLHISTORY_DELETEALL_FAILURE;
var CALLHISTORY_DELETE_BEGIN = 'CALLHISTORY_DELETE_BEGIN';
exports.CALLHISTORY_DELETE_BEGIN = CALLHISTORY_DELETE_BEGIN;
var CALLHISTORY_DELETE_SUCCESS = 'CALLHISTORY_DELETE_SUCCESS';
exports.CALLHISTORY_DELETE_SUCCESS = CALLHISTORY_DELETE_SUCCESS;
var CALLHISTORY_DELETE_FAILURE = 'CALLHISTORY_DELETE_FAILURE';
exports.CALLHISTORY_DELETE_FAILURE = CALLHISTORY_DELETE_FAILURE;
var CALLHISTORY_ADD_EXTERNAL_ENTRY_REQUEST = 'CALLHISTORY_ADD_EXTERNAL_ENTRY_REQUEST';
exports.CALLHISTORY_ADD_EXTERNAL_ENTRY_REQUEST = CALLHISTORY_ADD_EXTERNAL_ENTRY_REQUEST;
var CALLHISTORY_ADD_EXTERNAL_ENTRY_SUCCESS = 'CALLHISTORY_ADD_EXTERNAL_ENTRY_SUCCESS';
exports.CALLHISTORY_ADD_EXTERNAL_ENTRY_SUCCESS = CALLHISTORY_ADD_EXTERNAL_ENTRY_SUCCESS;
var CALLHISTORY_ADD_EXTERNAL_ENTRY_FAILURE = 'CALLHISTORY_ADD_EXTERNAL_ENTRY_FAILURE';
exports.CALLHISTORY_ADD_EXTERNAL_ENTRY_FAILURE = CALLHISTORY_ADD_EXTERNAL_ENTRY_FAILURE;
var GET_EXTENSION_INVITE_TEXT_URI = 'customInvite';
exports.GET_EXTENSION_INVITE_TEXT_URI = GET_EXTENSION_INVITE_TEXT_URI;
var GET_EXTENSION_INVITE_TEXT_REQUEST = 'GET_EXTENSION_INVITE_TEXT_REQUEST';
exports.GET_EXTENSION_INVITE_TEXT_REQUEST = GET_EXTENSION_INVITE_TEXT_REQUEST;
var GET_EXTENSION_INVITE_TEXT_SUCCESS = 'GET_EXTENSION_INVITE_TEXT_SUCCESS';
exports.GET_EXTENSION_INVITE_TEXT_SUCCESS = GET_EXTENSION_INVITE_TEXT_SUCCESS;
var GET_EXTENSION_INVITE_TEXT_FAILURE = 'GET_EXTENSION_INVITE_TEXT_FAILURE'; // Calendaring microservice

exports.GET_EXTENSION_INVITE_TEXT_FAILURE = GET_EXTENSION_INVITE_TEXT_FAILURE;
var CALENDAR_ENDPOINT = 'lifesize.calendar';
exports.CALENDAR_ENDPOINT = CALENDAR_ENDPOINT;
var CALENDAR_TOPIC = 'ls.calendar';
exports.CALENDAR_TOPIC = CALENDAR_TOPIC;
var CALENDAR_NO_SUBSCRIPTION = 'NO_SUBSCRIPTION'; // Meeting microservice

exports.CALENDAR_NO_SUBSCRIPTION = CALENDAR_NO_SUBSCRIPTION;
var MEETING_HANDLER_ENDPOINT = 'lifesize.meeting'; // user token microservice

exports.MEETING_HANDLER_ENDPOINT = MEETING_HANDLER_ENDPOINT;
var USER_INVITE_TOKEN_ENDPOINT = 'lifesize.inviteToken';
exports.USER_INVITE_TOKEN_ENDPOINT = USER_INVITE_TOKEN_ENDPOINT;
var USER_INVITE_TOKEN_BEGIN = 'USER_INVITE_TOKEN_BEGIN';
exports.USER_INVITE_TOKEN_BEGIN = USER_INVITE_TOKEN_BEGIN;
var USER_INVITE_TOKEN_SUCCESS = 'USER_INVITE_TOKEN_SUCCESS';
exports.USER_INVITE_TOKEN_SUCCESS = USER_INVITE_TOKEN_SUCCESS;
var USER_INVITE_TOKEN_FAILURE = 'USER_INVITE_TOKEN_FAILURE'; // push service

exports.USER_INVITE_TOKEN_FAILURE = USER_INVITE_TOKEN_FAILURE;
var PUSH_SERVICE_ENDPOINT = 'lifesize.push';
exports.PUSH_SERVICE_ENDPOINT = PUSH_SERVICE_ENDPOINT;
var PUSH_INVITATION_PATH = 'invite'; // personal contacts microservice

exports.PUSH_INVITATION_PATH = PUSH_INVITATION_PATH;
var PERSONAL_CONTACTS_HANDLER_ENDPOINT = 'lifesize.personalContacts';
exports.PERSONAL_CONTACTS_HANDLER_ENDPOINT = PERSONAL_CONTACTS_HANDLER_ENDPOINT;
var CREATE_PERSONAL_CONTACT_URL_SUFFIX = 'personalContacts/create';
exports.CREATE_PERSONAL_CONTACT_URL_SUFFIX = CREATE_PERSONAL_CONTACT_URL_SUFFIX;
var CREATE_PERSONAL_CONTACT_BEGIN = 'CREATE_PERSONAL_CONTACT_BEGIN';
exports.CREATE_PERSONAL_CONTACT_BEGIN = CREATE_PERSONAL_CONTACT_BEGIN;
var CREATE_PERSONAL_CONTACT_SUCCESS = 'CREATE_PERSONAL_CONTACT_SUCCESS';
exports.CREATE_PERSONAL_CONTACT_SUCCESS = CREATE_PERSONAL_CONTACT_SUCCESS;
var CREATE_PERSONAL_CONTACT_FAILURE = 'CREATE_PERSONAL_CONTACT_FAILURE';
exports.CREATE_PERSONAL_CONTACT_FAILURE = CREATE_PERSONAL_CONTACT_FAILURE;
var UPDATE_PERSONAL_CONTACT_URL_SUFFIX = 'personalContacts/update';
exports.UPDATE_PERSONAL_CONTACT_URL_SUFFIX = UPDATE_PERSONAL_CONTACT_URL_SUFFIX;
var UPDATE_PERSONAL_CONTACT_BEGIN = 'UPDATE_PERSONAL_CONTACT_BEGIN';
exports.UPDATE_PERSONAL_CONTACT_BEGIN = UPDATE_PERSONAL_CONTACT_BEGIN;
var UPDATE_PERSONAL_CONTACT_SUCCESS = 'UPDATE_PERSONAL_CONTACT_SUCCESS';
exports.UPDATE_PERSONAL_CONTACT_SUCCESS = UPDATE_PERSONAL_CONTACT_SUCCESS;
var UPDATE_PERSONAL_CONTACT_FAILURE = 'UPDATE_PERSONAL_CONTACT_FAILURE';
exports.UPDATE_PERSONAL_CONTACT_FAILURE = UPDATE_PERSONAL_CONTACT_FAILURE;
var DELETE_PERSONAL_CONTACT_URL_SUFFIX = 'personalContacts/delete';
exports.DELETE_PERSONAL_CONTACT_URL_SUFFIX = DELETE_PERSONAL_CONTACT_URL_SUFFIX;
var DELETE_PERSONAL_CONTACT_BEGIN = 'DELETE_PERSONAL_CONTACT_BEGIN';
exports.DELETE_PERSONAL_CONTACT_BEGIN = DELETE_PERSONAL_CONTACT_BEGIN;
var DELETE_PERSONAL_CONTACT_SUCCESS = 'DELETE_PERSONAL_CONTACT_SUCCESS';
exports.DELETE_PERSONAL_CONTACT_SUCCESS = DELETE_PERSONAL_CONTACT_SUCCESS;
var DELETE_PERSONAL_CONTACT_FAILURE = 'DELETE_PERSONAL_CONTACT_FAILURE'; // group contacts microservice

exports.DELETE_PERSONAL_CONTACT_FAILURE = DELETE_PERSONAL_CONTACT_FAILURE;
var GROUP_CONTACTS_HANDLER_ENDPOINT = 'lifesize.groupContacts';
exports.GROUP_CONTACTS_HANDLER_ENDPOINT = GROUP_CONTACTS_HANDLER_ENDPOINT;
var CREATE_GROUP_CONTACT_URL_SUFFIX = 'groupContacts/create';
exports.CREATE_GROUP_CONTACT_URL_SUFFIX = CREATE_GROUP_CONTACT_URL_SUFFIX;
var CREATE_GROUP_CONTACT_BEGIN = 'CREATE_GROUP_CONTACT_BEGIN';
exports.CREATE_GROUP_CONTACT_BEGIN = CREATE_GROUP_CONTACT_BEGIN;
var CREATE_GROUP_CONTACT_SUCCESS = 'CREATE_GROUP_CONTACT_SUCCESS';
exports.CREATE_GROUP_CONTACT_SUCCESS = CREATE_GROUP_CONTACT_SUCCESS;
var CREATE_GROUP_CONTACT_FAILURE = 'CREATE_GROUP_CONTACT_FAILURE';
exports.CREATE_GROUP_CONTACT_FAILURE = CREATE_GROUP_CONTACT_FAILURE;
var UPDATE_GROUP_CONTACT_URL_SUFFIX = 'groupContacts/update';
exports.UPDATE_GROUP_CONTACT_URL_SUFFIX = UPDATE_GROUP_CONTACT_URL_SUFFIX;
var UPDATE_GROUP_CONTACT_BEGIN = 'UPDATE_GROUP_CONTACT_BEGIN';
exports.UPDATE_GROUP_CONTACT_BEGIN = UPDATE_GROUP_CONTACT_BEGIN;
var UPDATE_GROUP_CONTACT_SUCCESS = 'UPDATE_GROUP_CONTACT_SUCCESS';
exports.UPDATE_GROUP_CONTACT_SUCCESS = UPDATE_GROUP_CONTACT_SUCCESS;
var UPDATE_GROUP_CONTACT_FAILURE = 'UPDATE_GROUP_CONTACT_FAILURE';
exports.UPDATE_GROUP_CONTACT_FAILURE = UPDATE_GROUP_CONTACT_FAILURE;
var DELETE_GROUP_CONTACT_URL_SUFFIX = 'groupContacts/delete';
exports.DELETE_GROUP_CONTACT_URL_SUFFIX = DELETE_GROUP_CONTACT_URL_SUFFIX;
var DELETE_GROUP_CONTACT_BEGIN = 'DELETE_GROUP_CONTACT_BEGIN';
exports.DELETE_GROUP_CONTACT_BEGIN = DELETE_GROUP_CONTACT_BEGIN;
var DELETE_GROUP_CONTACT_SUCCESS = 'DELETE_GROUP_CONTACT_SUCCESS';
exports.DELETE_GROUP_CONTACT_SUCCESS = DELETE_GROUP_CONTACT_SUCCESS;
var DELETE_GROUP_CONTACT_FAILURE = 'DELETE_GROUP_CONTACT_FAILURE'; // Favorite microservice

exports.DELETE_GROUP_CONTACT_FAILURE = DELETE_GROUP_CONTACT_FAILURE;
var FAVORITE_HANDLER_ENDPOINT = 'lifesize.favorites';
exports.FAVORITE_HANDLER_ENDPOINT = FAVORITE_HANDLER_ENDPOINT;
var GET_FAVORITES_BEGIN = 'GET_FAVORITES_BEGIN';
exports.GET_FAVORITES_BEGIN = GET_FAVORITES_BEGIN;
var GET_FAVORITES_SUCCESS = 'GET_FAVORITES_SUCCESS';
exports.GET_FAVORITES_SUCCESS = GET_FAVORITES_SUCCESS;
var GET_FAVORITES_FAILURE = 'GET_FAVORITES_FAILURE';
exports.GET_FAVORITES_FAILURE = GET_FAVORITES_FAILURE;
var ADD_FAVORITES_BEGIN = 'ADD_FAVORITES_BEGIN';
exports.ADD_FAVORITES_BEGIN = ADD_FAVORITES_BEGIN;
var ADD_FAVORITES_SUCCESS = 'ADD_FAVORITES_SUCCESS';
exports.ADD_FAVORITES_SUCCESS = ADD_FAVORITES_SUCCESS;
var ADD_FAVORITES_FAILURE = 'ADD_FAVORITES_FAILURE';
exports.ADD_FAVORITES_FAILURE = ADD_FAVORITES_FAILURE;
var DELETE_FAVORITES_BEGIN = 'DELETE_FAVORITES_BEGIN';
exports.DELETE_FAVORITES_BEGIN = DELETE_FAVORITES_BEGIN;
var DELETE_FAVORITES_SUCCESS = 'DELETE_FAVORITES_SUCCESS';
exports.DELETE_FAVORITES_SUCCESS = DELETE_FAVORITES_SUCCESS;
var DELETE_FAVORITES_FAILURE = 'DELETE_FAVORITES_FAILURE'; // Timer

exports.DELETE_FAVORITES_FAILURE = DELETE_FAVORITES_FAILURE;
var CLOCK_TICK_MIN = 'CLOCK_TICK_MIN';
exports.CLOCK_TICK_MIN = CLOCK_TICK_MIN;
var CLOCK_TICK_SEC = 'CLOCK_TICK_SEC'; // Call parameters

exports.CLOCK_TICK_SEC = CLOCK_TICK_SEC;
var PARTICIPANT_IVR = 'VOROOMIVR';
exports.PARTICIPANT_IVR = PARTICIPANT_IVR;
var PARTICIPANT_CONNECTED = 'CONNECTED';
exports.PARTICIPANT_CONNECTED = PARTICIPANT_CONNECTED;
var PARTICIPANT_SEARCHING = 'SEARCHING';
exports.PARTICIPANT_SEARCHING = PARTICIPANT_SEARCHING;
var PARTICIPANT_KICKED = 'KICKED'; // Nucleus Init

exports.PARTICIPANT_KICKED = PARTICIPANT_KICKED;
var INIT_NUCLEUS = 'INIT_NUCLEUS'; // Call config

exports.INIT_NUCLEUS = INIT_NUCLEUS;
var TOGGLE_DO_NOT_DISTURB = 'TOGGLE_DO_NOT_DISTURB'; // Presentation related

exports.TOGGLE_DO_NOT_DISTURB = TOGGLE_DO_NOT_DISTURB;
var REATTACH_PRESENTATION = 'REATTACH_PRESENTATION';
exports.REATTACH_PRESENTATION = REATTACH_PRESENTATION;
var PRESENTATION_LABEL = 'video_h239_label';
exports.PRESENTATION_LABEL = PRESENTATION_LABEL;
var VIDEO_LABEL = 'video_label';
exports.VIDEO_LABEL = VIDEO_LABEL;
var X_LIFESIZE_PRES_ATTR = 'x-lifesize-VIDEO_H239:';
exports.X_LIFESIZE_PRES_ATTR = X_LIFESIZE_PRES_ATTR;
var LOCAL_PRESENTATION_STREAM_ACQUIRED = 'LOCAL_PRESENTATION_STREAM_ACQUIRED';
exports.LOCAL_PRESENTATION_STREAM_ACQUIRED = LOCAL_PRESENTATION_STREAM_ACQUIRED;
var LOCAL_PRESENTATION_STREAM_UPDATED = 'LOCAL_PRESENTATION_STREAM_UPDATED';
exports.LOCAL_PRESENTATION_STREAM_UPDATED = LOCAL_PRESENTATION_STREAM_UPDATED;
var LOCAL_PRESENTATION_STREAM_ENDED = 'LOCAL_PRESENTATION_STREAM_ENDED'; // Redux-storage constants

exports.LOCAL_PRESENTATION_STREAM_ENDED = LOCAL_PRESENTATION_STREAM_ENDED;
var REDUX_STORAGE_LOAD = 'REDUX_STORAGE_LOAD';
exports.REDUX_STORAGE_LOAD = REDUX_STORAGE_LOAD;
var REDUX_STORAGE_SAVE = 'REDUX_STORAGE_SAVE'; // GQL

exports.REDUX_STORAGE_SAVE = REDUX_STORAGE_SAVE;
var GQL_GET_CLIENT = 'GQL_GET_CLIENT';
exports.GQL_GET_CLIENT = GQL_GET_CLIENT;
var GQL_QUERY = 'GQL_QUERY';
exports.GQL_QUERY = GQL_QUERY;
var GQL_MUTATION = 'GQL_MUTATION'; // Video change type

exports.GQL_MUTATION = GQL_MUTATION;
var NUCLEUS_VIDEO_STREAM_LABEL = 'nucleus_video_stream_label';
exports.NUCLEUS_VIDEO_STREAM_LABEL = NUCLEUS_VIDEO_STREAM_LABEL;
var NUCLEUS_PRESENTATION_STREAM_LABEL = 'nucleus_presentation_stream_label'; // Far End Camera Control (FECC)

exports.NUCLEUS_PRESENTATION_STREAM_LABEL = NUCLEUS_PRESENTATION_STREAM_LABEL;
var FECC_ENABLED = 'RX,TX';
exports.FECC_ENABLED = FECC_ENABLED;
var FECC_ACTION_TYPE_START = 'start';
exports.FECC_ACTION_TYPE_START = FECC_ACTION_TYPE_START;
var FECC_ACTION_TYPE_CONTINUE = 'continue';
exports.FECC_ACTION_TYPE_CONTINUE = FECC_ACTION_TYPE_CONTINUE;
var FECC_ACTION_TYPE_STOP = 'stop';
exports.FECC_ACTION_TYPE_STOP = FECC_ACTION_TYPE_STOP;
var FECC_ACTION_PAN_LEFT = 'pan_left';
exports.FECC_ACTION_PAN_LEFT = FECC_ACTION_PAN_LEFT;
var FECC_ACTION_PAN_RIGHT = 'pan_right';
exports.FECC_ACTION_PAN_RIGHT = FECC_ACTION_PAN_RIGHT;
var FECC_ACTION_TILT_DOWN = 'tilt_down';
exports.FECC_ACTION_TILT_DOWN = FECC_ACTION_TILT_DOWN;
var FECC_ACTION_TILT_UP = 'tilt_up';
exports.FECC_ACTION_TILT_UP = FECC_ACTION_TILT_UP;
var FECC_ACTION_ZOOM_OUT = 'zoom_out';
exports.FECC_ACTION_ZOOM_OUT = FECC_ACTION_ZOOM_OUT;
var FECC_ACTION_ZOOM_IN = 'zoom_in';
exports.FECC_ACTION_ZOOM_IN = FECC_ACTION_ZOOM_IN;
var FECC_ACTION_FOCUS_OUT = 'focus_out';
exports.FECC_ACTION_FOCUS_OUT = FECC_ACTION_FOCUS_OUT;
var FECC_ACTION_FOCUS_IN = 'focus_in';
exports.FECC_ACTION_FOCUS_IN = FECC_ACTION_FOCUS_IN;
var FECC_TYPE_CAMERA_CONTROL = 'cameraControl'; // hacks

exports.FECC_TYPE_CAMERA_CONTROL = FECC_TYPE_CAMERA_CONTROL;
var SET_CUSTOM_GROUP_UUID = 'SET_CUSTOM_GROUP_UUID';
exports.SET_CUSTOM_GROUP_UUID = SET_CUSTOM_GROUP_UUID;
var SET_CUSTOM_CALL_BANDWIDTH = 'SET_CUSTOM_CALL_BANDWIDTH';
exports.SET_CUSTOM_CALL_BANDWIDTH = SET_CUSTOM_CALL_BANDWIDTH;
var SET_CUSTOM_PRESENTATION_BW_PERCENTAGE = 'SET_CUSTOM_PRESENTATION_BW_PERCENTAGE'; //device actions

exports.SET_CUSTOM_PRESENTATION_BW_PERCENTAGE = SET_CUSTOM_PRESENTATION_BW_PERCENTAGE;
var DEVICE_TOPIC = 'ls.device';
exports.DEVICE_TOPIC = DEVICE_TOPIC;
var WAMP_SUBSCRIPTION_DEVICE_EVENT = 'WAMP_SUBSCRIPTION_DEVICE_EVENT';
exports.WAMP_SUBSCRIPTION_DEVICE_EVENT = WAMP_SUBSCRIPTION_DEVICE_EVENT;
var SET_DEVICE_SCREEN_COUNT = 'SET_DEVICE_SCREEN_COUNT';
exports.SET_DEVICE_SCREEN_COUNT = SET_DEVICE_SCREEN_COUNT;
var SET_DEVICE_CAMERA_CAPABILITIES = 'SET_DEVICE_CAMERA_CAPABILITIES';
exports.SET_DEVICE_CAMERA_CAPABILITIES = SET_DEVICE_CAMERA_CAPABILITIES;
var SET_DEVICE_INFO = 'SET_DEVICE_INFO';
exports.SET_DEVICE_INFO = SET_DEVICE_INFO;
var GET_UPLOAD_URL = 'GET_UPLOAD_URL';
exports.GET_UPLOAD_URL = GET_UPLOAD_URL;
var SEND_CORONER_URL_ENDPOINT = 'lifesize.deviceHealth';
exports.SEND_CORONER_URL_ENDPOINT = SEND_CORONER_URL_ENDPOINT;
var SEND_CORONER_URL_BEGIN = 'SEND_CORONER_URL_BEGIN';
exports.SEND_CORONER_URL_BEGIN = SEND_CORONER_URL_BEGIN;
var SEND_CORONER_URL_SUCCESS = 'SEND_CORONER_URL_SUCCESS';
exports.SEND_CORONER_URL_SUCCESS = SEND_CORONER_URL_SUCCESS;
var SEND_CORONER_URL_FAILURE = 'SEND_CORONER_URL_FAILURE';
exports.SEND_CORONER_URL_FAILURE = SEND_CORONER_URL_FAILURE;
var SEND_CORONER_URL_SUFFIX = 'health/upload'; //alexa actions

exports.SEND_CORONER_URL_SUFFIX = SEND_CORONER_URL_SUFFIX;
var ALEXA_TOPIC = 'ls.alexaIntegration';
exports.ALEXA_TOPIC = ALEXA_TOPIC;
var ALEXA_ENDPOINT = 'lifesize.alexaIntegration';
exports.ALEXA_ENDPOINT = ALEXA_ENDPOINT;
var WAMP_ALEXA_DEVICE_EVENT = 'WAMP_ALEXA_DEVICE_EVENT';
exports.WAMP_ALEXA_DEVICE_EVENT = WAMP_ALEXA_DEVICE_EVENT;
var ALEXA_GENERATE_USERCODE = 'CREATE_CODE_PAIR';
exports.ALEXA_GENERATE_USERCODE = ALEXA_GENERATE_USERCODE;
var ALEXA_UNREGISTER = 'UNREGISTER';
exports.ALEXA_UNREGISTER = ALEXA_UNREGISTER;
var ALEXA_SET_USERCODE = 'SET_USERCODE'; // VC Lambda - lifesizeRecordingAuth

exports.ALEXA_SET_USERCODE = ALEXA_SET_USERCODE;
var RECORDING_AUTH_ENDPOINT = 'lifesize.videoRecordingAuth';
exports.RECORDING_AUTH_ENDPOINT = RECORDING_AUTH_ENDPOINT;
var RECORDING_AUTH_URI_SUFFIX = 'auth/getVCSettings';
exports.RECORDING_AUTH_URI_SUFFIX = RECORDING_AUTH_URI_SUFFIX;
var RECORDING_AUTH_SET_URI_SUFFIX = 'auth/setVCSettings'; // VC Constants - Actions

exports.RECORDING_AUTH_SET_URI_SUFFIX = RECORDING_AUTH_SET_URI_SUFFIX;
var VC_SETTINGS_FETCH_BEGIN = 'VC_SETTINGS_FETCH_BEGIN';
exports.VC_SETTINGS_FETCH_BEGIN = VC_SETTINGS_FETCH_BEGIN;
var VC_SETTINGS_FETCH_FAILED = 'VC_SETTINGS_FETCH_FAILED';
exports.VC_SETTINGS_FETCH_FAILED = VC_SETTINGS_FETCH_FAILED;
var VC_SETTINGS_FETCH_SUCCESS = 'VC_SETTINGS_FETCH_SUCCESS';
exports.VC_SETTINGS_FETCH_SUCCESS = VC_SETTINGS_FETCH_SUCCESS;
var VC_SETTINGS_UPDATE_BEGIN = 'VC_SETTINGS_UPDATE_BEGIN';
exports.VC_SETTINGS_UPDATE_BEGIN = VC_SETTINGS_UPDATE_BEGIN;
var VC_SETTINGS_UPDATE_FAILED = 'VC_SETTINGS_UPDATE_FAILED';
exports.VC_SETTINGS_UPDATE_FAILED = VC_SETTINGS_UPDATE_FAILED;
var VC_SETTINGS_UPDATE_SUCCESS = 'VC_SETTINGS_UPDATE_SUCCESS'; // Recordings Constants

exports.VC_SETTINGS_UPDATE_SUCCESS = VC_SETTINGS_UPDATE_SUCCESS;
var RECORDINGS_ENDPOINT_PREFIX = '/api/v1/cloud-api';
var RECORDINGS_FETCH_ENDPOINT = "".concat(RECORDINGS_ENDPOINT_PREFIX, "/cloudvideos/");
exports.RECORDINGS_FETCH_ENDPOINT = RECORDINGS_FETCH_ENDPOINT;
var RECORDINGS_FETCH_SINGLE_ENDPOINT = "".concat(RECORDINGS_ENDPOINT_PREFIX, "/cloudvideo/");
exports.RECORDINGS_FETCH_SINGLE_ENDPOINT = RECORDINGS_FETCH_SINGLE_ENDPOINT;
var SEARCH_CLOUD_USERS_ENDPOINT = "".concat(RECORDINGS_ENDPOINT_PREFIX, "/getcloudusers/");
exports.SEARCH_CLOUD_USERS_ENDPOINT = SEARCH_CLOUD_USERS_ENDPOINT;
var SEARCH_CLOUD_MEETINGS_ENDPOINT = "".concat(RECORDINGS_ENDPOINT_PREFIX, "/getcloudmeetings/");
exports.SEARCH_CLOUD_MEETINGS_ENDPOINT = SEARCH_CLOUD_MEETINGS_ENDPOINT;
var RECORDINGS_ADD_TO_WATCH_ENDPOINT = "".concat(RECORDINGS_ENDPOINT_PREFIX, "/wlater/");
exports.RECORDINGS_ADD_TO_WATCH_ENDPOINT = RECORDINGS_ADD_TO_WATCH_ENDPOINT;
var RECORDINGS_DELETE_ENDPOINT = "".concat(RECORDINGS_ENDPOINT_PREFIX, "/clouddelete/");
exports.RECORDINGS_DELETE_ENDPOINT = RECORDINGS_DELETE_ENDPOINT;
var RECORDINGS_FETCH_RELATED_ENDPOINT = "".concat(RECORDINGS_ENDPOINT_PREFIX, "/cloudrelated/");
exports.RECORDINGS_FETCH_RELATED_ENDPOINT = RECORDINGS_FETCH_RELATED_ENDPOINT;
var VIDEO_LIKE_ENDPOINT = "".concat(RECORDINGS_ENDPOINT_PREFIX, "/cloudlike/");
exports.VIDEO_LIKE_ENDPOINT = VIDEO_LIKE_ENDPOINT;
var VIDEO_PROPERTIES_ENDPOINT = "".concat(RECORDINGS_ENDPOINT_PREFIX, "/videoprops/");
exports.VIDEO_PROPERTIES_ENDPOINT = VIDEO_PROPERTIES_ENDPOINT;
var SHARE_URLS_ENDPOINT = "".concat(RECORDINGS_ENDPOINT_PREFIX, "/getshareurls/");
exports.SHARE_URLS_ENDPOINT = SHARE_URLS_ENDPOINT;
var MEETING_RECORDING_PROPS_ENDPOINT = "".concat(RECORDINGS_ENDPOINT_PREFIX, "/meetingprops/");
exports.MEETING_RECORDING_PROPS_ENDPOINT = MEETING_RECORDING_PROPS_ENDPOINT;
var VC_HOST_ENDPOINT_PROD = 'vc.lifesizecloud.com';
exports.VC_HOST_ENDPOINT_PROD = VC_HOST_ENDPOINT_PROD;
var VC_HOST_ENDPOINT_NON_PROD = 'vc.lifesizecloudbeta.com'; // Recordings Constants - Actions

exports.VC_HOST_ENDPOINT_NON_PROD = VC_HOST_ENDPOINT_NON_PROD;
var RECORDINGS_FETCH_FEED_BEGIN = 'RECORDINGS_FETCH_FEED_BEGIN';
exports.RECORDINGS_FETCH_FEED_BEGIN = RECORDINGS_FETCH_FEED_BEGIN;
var RECORDINGS_FETCH_FEED_FAILED = 'RECORDINGS_FETCH_FEED_FAILED';
exports.RECORDINGS_FETCH_FEED_FAILED = RECORDINGS_FETCH_FEED_FAILED;
var RECORDINGS_FETCH_FEED_SUCCESS = 'RECORDINGS_FETCH_FEED_SUCCESS';
exports.RECORDINGS_FETCH_FEED_SUCCESS = RECORDINGS_FETCH_FEED_SUCCESS;
var RECORDINGS_FETCH_WATCH_LIST_BEGIN = 'RECORDINGS_FETCH_WATCH_LIST_BEGIN';
exports.RECORDINGS_FETCH_WATCH_LIST_BEGIN = RECORDINGS_FETCH_WATCH_LIST_BEGIN;
var RECORDINGS_FETCH_WATCH_LIST_FAILED = 'RECORDINGS_FETCH_WATCH_LIST_FAILED';
exports.RECORDINGS_FETCH_WATCH_LIST_FAILED = RECORDINGS_FETCH_WATCH_LIST_FAILED;
var RECORDINGS_FETCH_WATCH_LIST_SUCCESS = 'RECORDINGS_FETCH_WATCH_LIST_SUCCESS';
exports.RECORDINGS_FETCH_WATCH_LIST_SUCCESS = RECORDINGS_FETCH_WATCH_LIST_SUCCESS;
var RECORDINGS_FETCH_MY_RECORDINGS_BEGIN = 'RECORDINGS_FETCH_MY_RECORDINGS_BEGIN';
exports.RECORDINGS_FETCH_MY_RECORDINGS_BEGIN = RECORDINGS_FETCH_MY_RECORDINGS_BEGIN;
var RECORDINGS_FETCH_MY_RECORDINGS_FAILED = 'RECORDINGS_FETCH_MY_RECORDINGS_FAILED';
exports.RECORDINGS_FETCH_MY_RECORDINGS_FAILED = RECORDINGS_FETCH_MY_RECORDINGS_FAILED;
var RECORDINGS_FETCH_MY_RECORDINGS_SUCCESS = 'RECORDINGS_FETCH_MY_RECORDINGS_SUCCESS';
exports.RECORDINGS_FETCH_MY_RECORDINGS_SUCCESS = RECORDINGS_FETCH_MY_RECORDINGS_SUCCESS;
var RECORDINGS_FETCH_SINGLE_BEGIN = 'RECORDINGS_FETCH_SINGLE_BEGIN';
exports.RECORDINGS_FETCH_SINGLE_BEGIN = RECORDINGS_FETCH_SINGLE_BEGIN;
var RECORDINGS_FETCH_SINGLE_FAILED = 'RECORDINGS_FETCH_SINGLE_FAILED';
exports.RECORDINGS_FETCH_SINGLE_FAILED = RECORDINGS_FETCH_SINGLE_FAILED;
var RECORDINGS_FETCH_SINGLE_SUCCESS = 'RECORDINGS_FETCH_SINGLE_SUCCESS';
exports.RECORDINGS_FETCH_SINGLE_SUCCESS = RECORDINGS_FETCH_SINGLE_SUCCESS;
var RECORDINGS_FETCH_RELATED_BEGIN = 'RECORDINGS_FETCH_RELATED_BEGIN';
exports.RECORDINGS_FETCH_RELATED_BEGIN = RECORDINGS_FETCH_RELATED_BEGIN;
var RECORDINGS_FETCH_RELATED_FAILED = 'RECORDINGS_FETCH_RELATED_FAILED';
exports.RECORDINGS_FETCH_RELATED_FAILED = RECORDINGS_FETCH_RELATED_FAILED;
var RECORDINGS_FETCH_RELATED_SUCCESS = 'RECORDINGS_FETCH_RELATED_SUCCESS';
exports.RECORDINGS_FETCH_RELATED_SUCCESS = RECORDINGS_FETCH_RELATED_SUCCESS;
var RECORDINGS_ADD_TO_WATCHLIST_BEGIN = 'RECORDINGS_ADD_TO_WATCHLIST_BEGIN';
exports.RECORDINGS_ADD_TO_WATCHLIST_BEGIN = RECORDINGS_ADD_TO_WATCHLIST_BEGIN;
var RECORDINGS_ADD_TO_WATCHLIST_FAILED = 'RECORDINGS_ADD_TO_WATCHLIST_FAILED';
exports.RECORDINGS_ADD_TO_WATCHLIST_FAILED = RECORDINGS_ADD_TO_WATCHLIST_FAILED;
var RECORDINGS_ADD_TO_WATCHLIST_SUCCESS = 'RECORDINGS_ADD_TO_WATCHLIST_SUCCESS';
exports.RECORDINGS_ADD_TO_WATCHLIST_SUCCESS = RECORDINGS_ADD_TO_WATCHLIST_SUCCESS;
var RECORDINGS_REMOVE_FROM_WATCHLIST_BEGIN = 'RECORDINGS_REMOVE_FROM_WATCHLIST_BEGIN';
exports.RECORDINGS_REMOVE_FROM_WATCHLIST_BEGIN = RECORDINGS_REMOVE_FROM_WATCHLIST_BEGIN;
var RECORDINGS_REMOVE_FROM_WATCHLIST_FAILED = 'RECORDINGS_REMOVE_FROM_WATCHLIST_FAILED';
exports.RECORDINGS_REMOVE_FROM_WATCHLIST_FAILED = RECORDINGS_REMOVE_FROM_WATCHLIST_FAILED;
var RECORDINGS_REMOVE_FROM_WATCHLIST_SUCCESS = 'RECORDINGS_REMOVE_FROM_WATCHLIST_SUCCESS';
exports.RECORDINGS_REMOVE_FROM_WATCHLIST_SUCCESS = RECORDINGS_REMOVE_FROM_WATCHLIST_SUCCESS;
var RECORDINGS_DELETE_RECORDING_BEGIN = 'RECORDINGS_DELETE_RECORDING_BEGIN';
exports.RECORDINGS_DELETE_RECORDING_BEGIN = RECORDINGS_DELETE_RECORDING_BEGIN;
var RECORDINGS_DELETE_RECORDING_FAILED = 'RECORDINGS_DELETE_RECORDING_FAILED';
exports.RECORDINGS_DELETE_RECORDING_FAILED = RECORDINGS_DELETE_RECORDING_FAILED;
var RECORDINGS_DELETE_RECORDING_SUCCESS = 'RECORDINGS_DELETE_RECORDING_SUCCESS';
exports.RECORDINGS_DELETE_RECORDING_SUCCESS = RECORDINGS_DELETE_RECORDING_SUCCESS;
var RESET_RECORDINGS_DELETE_ERROR_STATE = 'RESET_RECORDINGS_DELETE_ERROR_STATE';
exports.RESET_RECORDINGS_DELETE_ERROR_STATE = RESET_RECORDINGS_DELETE_ERROR_STATE;
var RECORDINGS_LOOKUP_USER_BEGIN = 'RECORDINGS_LOOKUP_USER_BEGIN';
exports.RECORDINGS_LOOKUP_USER_BEGIN = RECORDINGS_LOOKUP_USER_BEGIN;
var RECORDINGS_LOOKUP_USER_FAILED = 'RECORDINGS_LOOKUP_USER_FAILED';
exports.RECORDINGS_LOOKUP_USER_FAILED = RECORDINGS_LOOKUP_USER_FAILED;
var RECORDINGS_LOOKUP_USER_SUCCESS = 'RECORDINGS_LOOKUP_USER_SUCCESS';
exports.RECORDINGS_LOOKUP_USER_SUCCESS = RECORDINGS_LOOKUP_USER_SUCCESS;
var VIDEO_LIKE_BEGIN = 'VIDEO_LIKE_BEGIN';
exports.VIDEO_LIKE_BEGIN = VIDEO_LIKE_BEGIN;
var VIDEO_LIKE_FAILED = 'VIDEO_LIKE_FAILED';
exports.VIDEO_LIKE_FAILED = VIDEO_LIKE_FAILED;
var VIDEO_LIKE_SUCCESS = 'VIDEO_LIKE_SUCCESS';
exports.VIDEO_LIKE_SUCCESS = VIDEO_LIKE_SUCCESS;
var VIDEO_GET_PROPS_BEGIN = 'VIDEO_GET_PROPS_BEGIN';
exports.VIDEO_GET_PROPS_BEGIN = VIDEO_GET_PROPS_BEGIN;
var VIDEO_GET_PROPS_FAILED = 'VIDEO_GET_PROPS_FAILED';
exports.VIDEO_GET_PROPS_FAILED = VIDEO_GET_PROPS_FAILED;
var VIDEO_GET_PROPS_SUCCESS = 'VIDEO_GET_PROPS_SUCCESS';
exports.VIDEO_GET_PROPS_SUCCESS = VIDEO_GET_PROPS_SUCCESS;
var VIDEO_SET_PROPS_BEGIN = 'VIDEO_SET_PROPS_BEGIN';
exports.VIDEO_SET_PROPS_BEGIN = VIDEO_SET_PROPS_BEGIN;
var VIDEO_SET_PROPS_FAILED = 'VIDEO_SET_PROPS_FAILED';
exports.VIDEO_SET_PROPS_FAILED = VIDEO_SET_PROPS_FAILED;
var VIDEO_SET_PROPS_SUCCESS = 'VIDEO_SET_PROPS_SUCCESS';
exports.VIDEO_SET_PROPS_SUCCESS = VIDEO_SET_PROPS_SUCCESS;
var RESET_VIDEO_PROPS_ERROR_STATE = 'RESET_VIDEO_PROPS_ERROR_STATE';
exports.RESET_VIDEO_PROPS_ERROR_STATE = RESET_VIDEO_PROPS_ERROR_STATE;
var VIDEO_GET_CLOUD_USERS_BEGIN = 'VIDEO_GET_CLOUD_USERS_BEGIN';
exports.VIDEO_GET_CLOUD_USERS_BEGIN = VIDEO_GET_CLOUD_USERS_BEGIN;
var VIDEO_GET_CLOUD_USERS_FAILED = 'VIDEO_GET_CLOUD_USERS_FAILED';
exports.VIDEO_GET_CLOUD_USERS_FAILED = VIDEO_GET_CLOUD_USERS_FAILED;
var VIDEO_GET_CLOUD_USERS_SUCCESS = 'VIDEO_GET_CLOUD_USERS_SUCCESS';
exports.VIDEO_GET_CLOUD_USERS_SUCCESS = VIDEO_GET_CLOUD_USERS_SUCCESS;
var VIDEO_GET_CLOUD_MEETINGS_BEGIN = 'VIDEO_GET_CLOUD_MEETINGS_BEGIN';
exports.VIDEO_GET_CLOUD_MEETINGS_BEGIN = VIDEO_GET_CLOUD_MEETINGS_BEGIN;
var VIDEO_GET_CLOUD_MEETINGS_FAILED = 'VIDEO_GET_CLOUD_MEETINGS_FAILED';
exports.VIDEO_GET_CLOUD_MEETINGS_FAILED = VIDEO_GET_CLOUD_MEETINGS_FAILED;
var VIDEO_GET_CLOUD_MEETINGS_SUCCESS = 'VIDEO_GET_CLOUD_MEETINGS_SUCCESS';
exports.VIDEO_GET_CLOUD_MEETINGS_SUCCESS = VIDEO_GET_CLOUD_MEETINGS_SUCCESS;
var VIDEO_GET_SHARE_PROPS_BEGIN = 'VIDEO_GET_SHARE_PROPS_BEGIN';
exports.VIDEO_GET_SHARE_PROPS_BEGIN = VIDEO_GET_SHARE_PROPS_BEGIN;
var VIDEO_GET_SHARE_PROPS_FAILED = 'VIDEO_GET_SHARE_PROPS_FAILED';
exports.VIDEO_GET_SHARE_PROPS_FAILED = VIDEO_GET_SHARE_PROPS_FAILED;
var VIDEO_GET_SHARE_PROPS_SUCCESS = 'VIDEO_GET_SHARE_PROPS_SUCCESS';
exports.VIDEO_GET_SHARE_PROPS_SUCCESS = VIDEO_GET_SHARE_PROPS_SUCCESS;
var VIDEO_GET_SHARE_LINK_GROUP_BEGIN = 'VIDEO_GET_SHARE_LINK_GROUP_BEGIN';
exports.VIDEO_GET_SHARE_LINK_GROUP_BEGIN = VIDEO_GET_SHARE_LINK_GROUP_BEGIN;
var VIDEO_GET_SHARE_LINK_GROUP_FAILED = 'VIDEO_GET_SHARE_LINK_GROUP_FAILED';
exports.VIDEO_GET_SHARE_LINK_GROUP_FAILED = VIDEO_GET_SHARE_LINK_GROUP_FAILED;
var VIDEO_GET_SHARE_LINK_GROUP_SUCCESS = 'VIDEO_GET_SHARE_LINK_GROUP_SUCCESS';
exports.VIDEO_GET_SHARE_LINK_GROUP_SUCCESS = VIDEO_GET_SHARE_LINK_GROUP_SUCCESS;
var VIDEO_GET_SHARE_LINK_GLOBAL_BEGIN = 'VIDEO_GET_SHARE_LINK_GLOBAL_BEGIN';
exports.VIDEO_GET_SHARE_LINK_GLOBAL_BEGIN = VIDEO_GET_SHARE_LINK_GLOBAL_BEGIN;
var VIDEO_GET_SHARE_LINK_GLOBAL_FAILED = 'VIDEO_GET_SHARE_LINK_GLOBAL_FAILED';
exports.VIDEO_GET_SHARE_LINK_GLOBAL_FAILED = VIDEO_GET_SHARE_LINK_GLOBAL_FAILED;
var VIDEO_GET_SHARE_LINK_GLOBAL_SUCCESS = 'VIDEO_GET_SHARE_LINK_GLOBAL_SUCCESS';
exports.VIDEO_GET_SHARE_LINK_GLOBAL_SUCCESS = VIDEO_GET_SHARE_LINK_GLOBAL_SUCCESS;
var VIDEO_UPDATE_SHARE_PROPS_BEGIN = 'VIDEO_UPDATE_SHARE_PROPS_BEGIN';
exports.VIDEO_UPDATE_SHARE_PROPS_BEGIN = VIDEO_UPDATE_SHARE_PROPS_BEGIN;
var VIDEO_UPDATE_SHARE_PROPS_FAILED = 'VIDEO_UPDATE_SHARE_PROPS_FAILED';
exports.VIDEO_UPDATE_SHARE_PROPS_FAILED = VIDEO_UPDATE_SHARE_PROPS_FAILED;
var VIDEO_UPDATE_SHARE_PROPS_SUCCESS = 'VIDEO_UPDATE_SHARE_PROPS_SUCCESS';
exports.VIDEO_UPDATE_SHARE_PROPS_SUCCESS = VIDEO_UPDATE_SHARE_PROPS_SUCCESS;
var VIDEO_GET_MEETING_SHARE_PROPS_BEGIN = 'VIDEO_GET_MEETING_SHARE_PROPS_BEGIN';
exports.VIDEO_GET_MEETING_SHARE_PROPS_BEGIN = VIDEO_GET_MEETING_SHARE_PROPS_BEGIN;
var VIDEO_GET_MEETING_SHARE_PROPS_FAILED = 'VIDEO_GET_MEETING_SHARE_PROPS_FAILED';
exports.VIDEO_GET_MEETING_SHARE_PROPS_FAILED = VIDEO_GET_MEETING_SHARE_PROPS_FAILED;
var VIDEO_GET_MEETING_SHARE_PROPS_SUCCESS = 'VIDEO_GET_MEETING_SHARE_PROPS_SUCCESS';
exports.VIDEO_GET_MEETING_SHARE_PROPS_SUCCESS = VIDEO_GET_MEETING_SHARE_PROPS_SUCCESS;
var VIDEO_POST_MEETING_SHARE_PROPS_BEGIN = 'VIDEO_POST_MEETING_SHARE_PROPS_BEGIN';
exports.VIDEO_POST_MEETING_SHARE_PROPS_BEGIN = VIDEO_POST_MEETING_SHARE_PROPS_BEGIN;
var VIDEO_POST_MEETING_SHARE_PROPS_FAILED = 'VIDEO_POST_MEETING_SHARE_PROPS_FAILED';
exports.VIDEO_POST_MEETING_SHARE_PROPS_FAILED = VIDEO_POST_MEETING_SHARE_PROPS_FAILED;
var VIDEO_POST_MEETING_SHARE_PROPS_SUCCESS = 'VIDEO_POST_MEETING_SHARE_PROPS_SUCCESS'; // WallPaper constants

exports.VIDEO_POST_MEETING_SHARE_PROPS_SUCCESS = VIDEO_POST_MEETING_SHARE_PROPS_SUCCESS;
var GET_UPLOAD_WALLPAPER_URL_ENDPOINT = 'lifesize.createroomsystemwallpaper';
exports.GET_UPLOAD_WALLPAPER_URL_ENDPOINT = GET_UPLOAD_WALLPAPER_URL_ENDPOINT;
var GET_UPLOAD_WALLPAPER_URL_BEGIN = 'GET_UPLOAD_WALLPAPER_URL_BEGIN';
exports.GET_UPLOAD_WALLPAPER_URL_BEGIN = GET_UPLOAD_WALLPAPER_URL_BEGIN;
var GET_UPLOAD_WALLPAPER_URL_SUCCESS = 'GET_UPLOAD_WALLPAPER_URL_SUCCESS';
exports.GET_UPLOAD_WALLPAPER_URL_SUCCESS = GET_UPLOAD_WALLPAPER_URL_SUCCESS;
var GET_UPLOAD_WALLPAPER_URL_FAILURE = 'GET_UPLOAD_WALLPAPER_URL_FAILURE';
exports.GET_UPLOAD_WALLPAPER_URL_FAILURE = GET_UPLOAD_WALLPAPER_URL_FAILURE;
var GET_UPLOAD_WALLPAPER_URL_SUFFIX = '';
exports.GET_UPLOAD_WALLPAPER_URL_SUFFIX = GET_UPLOAD_WALLPAPER_URL_SUFFIX;
var GET_EXISTING_WALLPAPER_URL_ENDPOINT = 'lifesize.getroomsystemwallpaper';
exports.GET_EXISTING_WALLPAPER_URL_ENDPOINT = GET_EXISTING_WALLPAPER_URL_ENDPOINT;
var GET_EXISTING_WALLPAPER_URL_BEGIN = 'GET_EXISTING_WALLPAPER_URL_BEGIN';
exports.GET_EXISTING_WALLPAPER_URL_BEGIN = GET_EXISTING_WALLPAPER_URL_BEGIN;
var GET_EXISTING_WALLPAPER_URL_SUCCESS = 'GET_EXISTING_WALLPAPER_URL_SUCCESS';
exports.GET_EXISTING_WALLPAPER_URL_SUCCESS = GET_EXISTING_WALLPAPER_URL_SUCCESS;
var GET_EXISTING_WALLPAPER_URL_FAILURE = 'GET_EXISTING_WALLPAPER_URL_FAILURE';
exports.GET_EXISTING_WALLPAPER_URL_FAILURE = GET_EXISTING_WALLPAPER_URL_FAILURE;
var GET_EXISTING_WALLPAPER_URL_SUFFIX = '';
exports.GET_EXISTING_WALLPAPER_URL_SUFFIX = GET_EXISTING_WALLPAPER_URL_SUFFIX;
var SEND_WALLPAPER_URL_ENDPOINT = 'lifesize.applyroomsystemwallpaper';
exports.SEND_WALLPAPER_URL_ENDPOINT = SEND_WALLPAPER_URL_ENDPOINT;
var SEND_WALLPAPER_URL_BEGIN = 'SEND_WALLPAPER_URL_BEGIN';
exports.SEND_WALLPAPER_URL_BEGIN = SEND_WALLPAPER_URL_BEGIN;
var SEND_WALLPAPER_URL_SUCCESS = 'SEND_WALLPAPER_URL_SUCCESS';
exports.SEND_WALLPAPER_URL_SUCCESS = SEND_WALLPAPER_URL_SUCCESS;
var SEND_WALLPAPER_URL_FAILURE = 'SEND_WALLPAPER_URL_FAILURE';
exports.SEND_WALLPAPER_URL_FAILURE = SEND_WALLPAPER_URL_FAILURE;
var SEND_WALLPAPER_URL_SUFFIX = ''; // Data Warehouse Constants

exports.SEND_WALLPAPER_URL_SUFFIX = SEND_WALLPAPER_URL_SUFFIX;
var DATA_WAREHOUSE_STAGING_ENDPOINT = 'https://manage.lifesizecloudbeta.com/DWH/accounts';
exports.DATA_WAREHOUSE_STAGING_ENDPOINT = DATA_WAREHOUSE_STAGING_ENDPOINT;
var DATA_WAREHOUSE_PRODUCTION_ENDPOINT = 'https://manage.lifesizecloud.com/DWH/accounts'; // Data Warehouse Constants - Actions

exports.DATA_WAREHOUSE_PRODUCTION_ENDPOINT = DATA_WAREHOUSE_PRODUCTION_ENDPOINT;
var DWH_FETCH_CALLS_BEGIN_DAYS = 'DWH_FETCH_CALLS_BEGIN_DAYS';
exports.DWH_FETCH_CALLS_BEGIN_DAYS = DWH_FETCH_CALLS_BEGIN_DAYS;
var DWH_FETCH_CALLS_FAILED_DAYS = 'DWH_FETCH_CALLS_FAILED_DAYS';
exports.DWH_FETCH_CALLS_FAILED_DAYS = DWH_FETCH_CALLS_FAILED_DAYS;
var DWH_FETCH_CALLS_SUCCESS_DAYS = 'DWH_FETCH_CALLS_SUCCESS_DAYS';
exports.DWH_FETCH_CALLS_SUCCESS_DAYS = DWH_FETCH_CALLS_SUCCESS_DAYS;
var DWH_FETCH_CALLS_BEGIN_DAYS_DEVICES = 'DWH_FETCH_CALLS_BEGIN_DAYS_DEVICES';
exports.DWH_FETCH_CALLS_BEGIN_DAYS_DEVICES = DWH_FETCH_CALLS_BEGIN_DAYS_DEVICES;
var DWH_FETCH_CALLS_FAILED_DAYS_DEVICES = 'DWH_FETCH_CALLS_FAILED_DAYS_DEVICES';
exports.DWH_FETCH_CALLS_FAILED_DAYS_DEVICES = DWH_FETCH_CALLS_FAILED_DAYS_DEVICES;
var DWH_FETCH_CALLS_SUCCESS_DAYS_DEVICES = 'DWH_FETCH_CALLS_SUCCESS_DAYS_DEVICES';
exports.DWH_FETCH_CALLS_SUCCESS_DAYS_DEVICES = DWH_FETCH_CALLS_SUCCESS_DAYS_DEVICES;
var DWH_FETCH_CALLS_BEGIN_PLAN = 'DWH_FETCH_CALLS_BEGIN_PLAN';
exports.DWH_FETCH_CALLS_BEGIN_PLAN = DWH_FETCH_CALLS_BEGIN_PLAN;
var DWH_FETCH_CALLS_FAILED_PLAN = 'DWH_FETCH_CALLS_FAILED_PLAN';
exports.DWH_FETCH_CALLS_FAILED_PLAN = DWH_FETCH_CALLS_FAILED_PLAN;
var DWH_FETCH_CALLS_SUCCESS_PLAN = 'DWH_FETCH_CALLS_SUCCESS_PLAN';
exports.DWH_FETCH_CALLS_SUCCESS_PLAN = DWH_FETCH_CALLS_SUCCESS_PLAN;
var DWH_FETCH_CONFERENCES_BEGIN = 'DWH_FETCH_CONFERENCES_BEGIN';
exports.DWH_FETCH_CONFERENCES_BEGIN = DWH_FETCH_CONFERENCES_BEGIN;
var DWH_FETCH_CONFERENCES_FAILED = 'DWH_FETCH_CONFERENCES_FAILED';
exports.DWH_FETCH_CONFERENCES_FAILED = DWH_FETCH_CONFERENCES_FAILED;
var DWH_FETCH_CONFERENCES_SUCCESS = 'DWH_FETCH_CONFERENCES_SUCCESS';
exports.DWH_FETCH_CONFERENCES_SUCCESS = DWH_FETCH_CONFERENCES_SUCCESS;
var DWH_FETCH_SUMMARY_BEGIN = 'DWH_FETCH_SUMMARY_BEGIN';
exports.DWH_FETCH_SUMMARY_BEGIN = DWH_FETCH_SUMMARY_BEGIN;
var DWH_FETCH_SUMMARY_FAILED = 'DWH_FETCH_SUMMARY_FAILED';
exports.DWH_FETCH_SUMMARY_FAILED = DWH_FETCH_SUMMARY_FAILED;
var DWH_FETCH_SUMMARY_SUCCESS = 'DWH_FETCH_SUMMARY_SUCCESS';
exports.DWH_FETCH_SUMMARY_SUCCESS = DWH_FETCH_SUMMARY_SUCCESS;
var DWH_FETCH_USERS_GROUP_CALLS_PERSONAL_BEGIN = 'DWH_FETCH_USERS_GROUP_CALLS_PERSONAL_BEGIN';
exports.DWH_FETCH_USERS_GROUP_CALLS_PERSONAL_BEGIN = DWH_FETCH_USERS_GROUP_CALLS_PERSONAL_BEGIN;
var DWH_FETCH_USERS_GROUP_CALLS_PERSONAL_FAILED = 'DWH_FETCH_USERS_GROUP_CALLS_PERSONAL_FAILED';
exports.DWH_FETCH_USERS_GROUP_CALLS_PERSONAL_FAILED = DWH_FETCH_USERS_GROUP_CALLS_PERSONAL_FAILED;
var DWH_FETCH_USERS_GROUP_CALLS_PERSONAL_SUCCESS = 'DWH_FETCH_USERS_GROUP_CALLS_PERSONAL_SUCCESS';
exports.DWH_FETCH_USERS_GROUP_CALLS_PERSONAL_SUCCESS = DWH_FETCH_USERS_GROUP_CALLS_PERSONAL_SUCCESS;
var DWH_FETCH_USERS_GROUP_CALLS_ROOMS_BEGIN = 'DWH_FETCH_USERS_GROUP_CALLS_ROOMS_BEGIN';
exports.DWH_FETCH_USERS_GROUP_CALLS_ROOMS_BEGIN = DWH_FETCH_USERS_GROUP_CALLS_ROOMS_BEGIN;
var DWH_FETCH_USERS_GROUP_CALLS_ROOMS_FAILED = 'DWH_FETCH_USERS_GROUP_CALLS_ROOMS_FAILED';
exports.DWH_FETCH_USERS_GROUP_CALLS_ROOMS_FAILED = DWH_FETCH_USERS_GROUP_CALLS_ROOMS_FAILED;
var DWH_FETCH_USERS_GROUP_CALLS_ROOMS_SUCCESS = 'DWH_FETCH_USERS_GROUP_CALLS_ROOMS_SUCCESS';
exports.DWH_FETCH_USERS_GROUP_CALLS_ROOMS_SUCCESS = DWH_FETCH_USERS_GROUP_CALLS_ROOMS_SUCCESS;
var DWH_FETCH_USERS_GROUP_MINUTES_PERSONAL_BEGIN = 'DWH_FETCH_USERS_GROUP_MINUTES_PERSONAL_BEGIN';
exports.DWH_FETCH_USERS_GROUP_MINUTES_PERSONAL_BEGIN = DWH_FETCH_USERS_GROUP_MINUTES_PERSONAL_BEGIN;
var DWH_FETCH_USERS_GROUP_MINUTES_PERSONAL_FAILED = 'DWH_FETCH_USERS_GROUP_MINUTES_PERSONAL_FAILED';
exports.DWH_FETCH_USERS_GROUP_MINUTES_PERSONAL_FAILED = DWH_FETCH_USERS_GROUP_MINUTES_PERSONAL_FAILED;
var DWH_FETCH_USERS_GROUP_MINUTES_PERSONAL_SUCCESS = 'DWH_FETCH_USERS_GROUP_MINUTES_PERSONAL_SUCCESS';
exports.DWH_FETCH_USERS_GROUP_MINUTES_PERSONAL_SUCCESS = DWH_FETCH_USERS_GROUP_MINUTES_PERSONAL_SUCCESS;
var DWH_FETCH_USERS_GROUP_MINUTES_ROOMS_BEGIN = 'DWH_FETCH_USERS_GROUP_MINUTES_ROOMS_BEGIN';
exports.DWH_FETCH_USERS_GROUP_MINUTES_ROOMS_BEGIN = DWH_FETCH_USERS_GROUP_MINUTES_ROOMS_BEGIN;
var DWH_FETCH_USERS_GROUP_MINUTES_ROOMS_FAILED = 'DWH_FETCH_USERS_GROUP_MINUTES_ROOMS_FAILED';
exports.DWH_FETCH_USERS_GROUP_MINUTES_ROOMS_FAILED = DWH_FETCH_USERS_GROUP_MINUTES_ROOMS_FAILED;
var DWH_FETCH_USERS_GROUP_MINUTES_ROOMS_SUCCESS = 'DWH_FETCH_USERS_GROUP_MINUTES_ROOMS_SUCCESS';
exports.DWH_FETCH_USERS_GROUP_MINUTES_ROOMS_SUCCESS = DWH_FETCH_USERS_GROUP_MINUTES_ROOMS_SUCCESS;
var DWH_FETCH_USERS_FILTER_ACTIVE_TOTAL_BEGIN = 'DWH_FETCH_USERS_FILTER_ACTIVE_TOTAL_BEGIN';
exports.DWH_FETCH_USERS_FILTER_ACTIVE_TOTAL_BEGIN = DWH_FETCH_USERS_FILTER_ACTIVE_TOTAL_BEGIN;
var DWH_FETCH_USERS_FILTER_ACTIVE_TOTAL_FAILED = 'DWH_FETCH_USERS_FILTER_ACTIVE_TOTAL_FAILED';
exports.DWH_FETCH_USERS_FILTER_ACTIVE_TOTAL_FAILED = DWH_FETCH_USERS_FILTER_ACTIVE_TOTAL_FAILED;
var DWH_FETCH_USERS_FILTER_ACTIVE_TOTAL_SUCCESS = 'DWH_FETCH_USERS_FILTER_ACTIVE_TOTAL_SUCCESS';
exports.DWH_FETCH_USERS_FILTER_ACTIVE_TOTAL_SUCCESS = DWH_FETCH_USERS_FILTER_ACTIVE_TOTAL_SUCCESS;
var DWH_FETCH_STREAMS_BEGIN_LIST = 'DWH_FETCH_STREAMS_BEGIN_LIST';
exports.DWH_FETCH_STREAMS_BEGIN_LIST = DWH_FETCH_STREAMS_BEGIN_LIST;
var DWH_FETCH_STREAMS_FAILED_LIST = 'DWH_FETCH_STREAMS_FAILED_LIST';
exports.DWH_FETCH_STREAMS_FAILED_LIST = DWH_FETCH_STREAMS_FAILED_LIST;
var DWH_FETCH_STREAMS_SUCCESS_LIST = 'DWH_FETCH_STREAMS_SUCCESS_LIST';
exports.DWH_FETCH_STREAMS_SUCCESS_LIST = DWH_FETCH_STREAMS_SUCCESS_LIST;
var DWH_FETCH_STREAMS_BEGIN_USAGE = 'DWH_FETCH_STREAMS_BEGIN_USAGE';
exports.DWH_FETCH_STREAMS_BEGIN_USAGE = DWH_FETCH_STREAMS_BEGIN_USAGE;
var DWH_FETCH_STREAMS_FAILED_USAGE = 'DWH_FETCH_STREAMS_FAILED_USAGE';
exports.DWH_FETCH_STREAMS_FAILED_USAGE = DWH_FETCH_STREAMS_FAILED_USAGE;
var DWH_FETCH_STREAMS_SUCCESS_USAGE = 'DWH_FETCH_STREAMS_SUCCESS_USAGE';
exports.DWH_FETCH_STREAMS_SUCCESS_USAGE = DWH_FETCH_STREAMS_SUCCESS_USAGE;
var DWH_ALL_STREAMS_FAILURE = 'DWH_ALL_STREAMS_FAILURE';
exports.DWH_ALL_STREAMS_FAILURE = DWH_ALL_STREAMS_FAILURE;
var DWH_ALL_STREAMS_REQUEST = 'DWH_ALL_STREAMS_REQUEST';
exports.DWH_ALL_STREAMS_REQUEST = DWH_ALL_STREAMS_REQUEST;
var DWH_ALL_STREAMS_SUCCESS = 'DWH_ALL_STREAMS_SUCCESS';
exports.DWH_ALL_STREAMS_SUCCESS = DWH_ALL_STREAMS_SUCCESS;
var DWH_STREAM_HISTORY_FAILURE = 'DWH_STREAM_HISTORY_FAILURE';
exports.DWH_STREAM_HISTORY_FAILURE = DWH_STREAM_HISTORY_FAILURE;
var DWH_STREAM_HISTORY_REQUEST = 'DWH_STREAM_HISTORY_REQUEST';
exports.DWH_STREAM_HISTORY_REQUEST = DWH_STREAM_HISTORY_REQUEST;
var DWH_STREAM_HISTORY_SUCCESS = 'DWH_STREAM_HISTORY_SUCCESS';
exports.DWH_STREAM_HISTORY_SUCCESS = DWH_STREAM_HISTORY_SUCCESS;
var DWH_STREAM_METADATA_FAILURE = 'DWH_STREAM_METADATA_FAILURE';
exports.DWH_STREAM_METADATA_FAILURE = DWH_STREAM_METADATA_FAILURE;
var DWH_STREAM_METADATA_REQUEST = 'DWH_STREAM_METADATA_REQUEST';
exports.DWH_STREAM_METADATA_REQUEST = DWH_STREAM_METADATA_REQUEST;
var DWH_STREAM_METADATA_SUCCESS = 'DWH_STREAM_METADATA_SUCCESS';
exports.DWH_STREAM_METADATA_SUCCESS = DWH_STREAM_METADATA_SUCCESS;
var DWH_STREAM_QUESTIONS_FAILURE = 'DWH_STREAM_QUESTIONS_FAILURE';
exports.DWH_STREAM_QUESTIONS_FAILURE = DWH_STREAM_QUESTIONS_FAILURE;
var DWH_STREAM_QUESTIONS_REQUEST = 'DWH_STREAM_QUESTIONS_REQUEST';
exports.DWH_STREAM_QUESTIONS_REQUEST = DWH_STREAM_QUESTIONS_REQUEST;
var DWH_STREAM_QUESTIONS_SUCCESS = 'DWH_STREAM_QUESTIONS_SUCCESS';
exports.DWH_STREAM_QUESTIONS_SUCCESS = DWH_STREAM_QUESTIONS_SUCCESS;
var DWH_STREAM_SETTINGS_FAILURE = 'DWH_STREAM_SETTINGS_FAILURE';
exports.DWH_STREAM_SETTINGS_FAILURE = DWH_STREAM_SETTINGS_FAILURE;
var DWH_STREAM_SETTINGS_REQUEST = 'DWH_STREAM_SETTINGS_REQUEST';
exports.DWH_STREAM_SETTINGS_REQUEST = DWH_STREAM_SETTINGS_REQUEST;
var DWH_STREAM_SETTINGS_SUCCESS = 'DWH_STREAM_SETTINGS_SUCCESS';
exports.DWH_STREAM_SETTINGS_SUCCESS = DWH_STREAM_SETTINGS_SUCCESS;
var DWH_STREAM_SETTINGS_SET_FAILURE = 'DWH_STREAM_SETTINGS_SET_FAILURE';
exports.DWH_STREAM_SETTINGS_SET_FAILURE = DWH_STREAM_SETTINGS_SET_FAILURE;
var DWH_STREAM_SETTINGS_SET_REQUEST = 'DWH_STREAM_SETTINGS_SET_REQUEST';
exports.DWH_STREAM_SETTINGS_SET_REQUEST = DWH_STREAM_SETTINGS_SET_REQUEST;
var DWH_STREAM_SETTINGS_SET_SUCCESS = 'DWH_STREAM_SETTINGS_SET_SUCCESS';
exports.DWH_STREAM_SETTINGS_SET_SUCCESS = DWH_STREAM_SETTINGS_SET_SUCCESS;
var DWH_STREAM_VIEWERS_FAILURE = 'DWH_STREAM_VIEWERS_FAILURE';
exports.DWH_STREAM_VIEWERS_FAILURE = DWH_STREAM_VIEWERS_FAILURE;
var DWH_STREAM_VIEWERS_REQUEST = 'DWH_STREAM_VIEWERS_REQUEST';
exports.DWH_STREAM_VIEWERS_REQUEST = DWH_STREAM_VIEWERS_REQUEST;
var DWH_STREAM_VIEWERS_SUCCESS = 'DWH_STREAM_VIEWERS_SUCCESS';
exports.DWH_STREAM_VIEWERS_SUCCESS = DWH_STREAM_VIEWERS_SUCCESS;
var DWH_USAGEDETAILS_ROOM_FAILURE = 'DWH_USAGEDETAILS_ROOM_FAILURE';
exports.DWH_USAGEDETAILS_ROOM_FAILURE = DWH_USAGEDETAILS_ROOM_FAILURE;
var DWH_USAGEDETAILS_ROOM_REQUEST = 'DWH_USAGEDETAILS_ROOM_REQUEST';
exports.DWH_USAGEDETAILS_ROOM_REQUEST = DWH_USAGEDETAILS_ROOM_REQUEST;
var DWH_USAGEDETAILS_ROOM_SUCCESS = 'DWH_USAGEDETAILS_ROOM_SUCCESS';
exports.DWH_USAGEDETAILS_ROOM_SUCCESS = DWH_USAGEDETAILS_ROOM_SUCCESS;
var DWH_USAGEDETAILS_USER_FAILURE = 'DWH_USAGEDETAILS_USER_FAILURE';
exports.DWH_USAGEDETAILS_USER_FAILURE = DWH_USAGEDETAILS_USER_FAILURE;
var DWH_USAGEDETAILS_USER_REQUEST = 'DWH_USAGEDETAILS_USER_REQUEST';
exports.DWH_USAGEDETAILS_USER_REQUEST = DWH_USAGEDETAILS_USER_REQUEST;
var DWH_USAGEDETAILS_USER_SUCCESS = 'DWH_USAGEDETAILS_USER_SUCCESS';
exports.DWH_USAGEDETAILS_USER_SUCCESS = DWH_USAGEDETAILS_USER_SUCCESS;
var DWH_USAGEDETAILS_TYPES = {
  ROOM: 'ROOM',
  USER: 'USER'
}; // Room System Service

exports.DWH_USAGEDETAILS_TYPES = DWH_USAGEDETAILS_TYPES;
var PAIRED_DEVICES_ENDPOINT = 'lifesize.devicePairing';
exports.PAIRED_DEVICES_ENDPOINT = PAIRED_DEVICES_ENDPOINT;
var PAIRED_DEVICE_LICENSES_ENDPOINT = 'lifesize.device.license';
exports.PAIRED_DEVICE_LICENSES_ENDPOINT = PAIRED_DEVICE_LICENSES_ENDPOINT;
var PAIRED_DEVICE_LICENSES_COUNT_SUFFIX = '-count';
exports.PAIRED_DEVICE_LICENSES_COUNT_SUFFIX = PAIRED_DEVICE_LICENSES_COUNT_SUFFIX;
var GET_PAIRED_DEVICES_BEGIN = 'GET_PAIRED_DEVICES_BEGIN';
exports.GET_PAIRED_DEVICES_BEGIN = GET_PAIRED_DEVICES_BEGIN;
var GET_PAIRED_DEVICES_SUCCESS = 'GET_PAIRED_DEVICES_SUCCESS';
exports.GET_PAIRED_DEVICES_SUCCESS = GET_PAIRED_DEVICES_SUCCESS;
var GET_PAIRED_DEVICES_FAILURE = 'GET_PAIRED_DEVICES_FAILURE';
exports.GET_PAIRED_DEVICES_FAILURE = GET_PAIRED_DEVICES_FAILURE;
var GET_PAIRED_DEVICES_SUFFIX = 'pairing/getdevices';
exports.GET_PAIRED_DEVICES_SUFFIX = GET_PAIRED_DEVICES_SUFFIX;
var DELETE_DEVICE_PAIRING_BEGIN = 'DELETE_DEVICE_PAIRING_BEGIN';
exports.DELETE_DEVICE_PAIRING_BEGIN = DELETE_DEVICE_PAIRING_BEGIN;
var DELETE_DEVICE_PAIRING_SUCCESS = 'DELETE_DEVICE_PAIRING_SUCCESS';
exports.DELETE_DEVICE_PAIRING_SUCCESS = DELETE_DEVICE_PAIRING_SUCCESS;
var DELETE_DEVICE_PAIRING_FAILURE = 'DELETE_DEVICE_PAIRING_FAILURE';
exports.DELETE_DEVICE_PAIRING_FAILURE = DELETE_DEVICE_PAIRING_FAILURE;
var DELETE_DEVICE_PAIRING_SUFFIX = 'pairing/deletelist';
exports.DELETE_DEVICE_PAIRING_SUFFIX = DELETE_DEVICE_PAIRING_SUFFIX;
var REMOVE_DEVICE_BEGIN = 'REMOVE_DEVICE_BEGIN';
exports.REMOVE_DEVICE_BEGIN = REMOVE_DEVICE_BEGIN;
var REMOVE_DEVICE_SUCCESS = 'REMOVE_DEVICE_SUCCESS';
exports.REMOVE_DEVICE_SUCCESS = REMOVE_DEVICE_SUCCESS;
var REMOVE_DEVICE_FAILURE = 'REMOVE_DEVICE_FAILURE';
exports.REMOVE_DEVICE_FAILURE = REMOVE_DEVICE_FAILURE;
var REMOVE_DEVICE_SUFFIX = 'pairing/removelist';
exports.REMOVE_DEVICE_SUFFIX = REMOVE_DEVICE_SUFFIX;
var GET_PAIRED_DEVICE_LICENSE_COUNT_BEGIN = 'GET_PAIRED_DEVICE_LICENSE_COUNT_BEGIN';
exports.GET_PAIRED_DEVICE_LICENSE_COUNT_BEGIN = GET_PAIRED_DEVICE_LICENSE_COUNT_BEGIN;
var GET_PAIRED_DEVICE_LICENSE_COUNT_SUCCESS = 'GET_PAIRED_DEVICE_LICENSE_COUNT_SUCCESS';
exports.GET_PAIRED_DEVICE_LICENSE_COUNT_SUCCESS = GET_PAIRED_DEVICE_LICENSE_COUNT_SUCCESS;
var GET_PAIRED_DEVICE_LICENSE_COUNT_FAILURE = 'GET_PAIRED_DEVICE_LICENSE_COUNT_FAILURE';
exports.GET_PAIRED_DEVICE_LICENSE_COUNT_FAILURE = GET_PAIRED_DEVICE_LICENSE_COUNT_FAILURE;
var DEVICE_PAIRING_BEGIN = 'DEVICE_PAIRING_BEGIN';
exports.DEVICE_PAIRING_BEGIN = DEVICE_PAIRING_BEGIN;
var DEVICE_PAIRING_SUCCESS = 'DEVICE_PAIRING_SUCCESS';
exports.DEVICE_PAIRING_SUCCESS = DEVICE_PAIRING_SUCCESS;
var DEVICE_PAIRING_FAILURE = 'DEVICE_PAIRING_FAILURE';
exports.DEVICE_PAIRING_FAILURE = DEVICE_PAIRING_FAILURE;
var DEVICE_PAIRING_SUFFIX = 'pairing/create';
exports.DEVICE_PAIRING_SUFFIX = DEVICE_PAIRING_SUFFIX;
var DEVICE_SHARED_PAIRING_SUFFIX = 'pairing/createshared';
exports.DEVICE_SHARED_PAIRING_SUFFIX = DEVICE_SHARED_PAIRING_SUFFIX;
var DEVICE_PAIRING_RESET_ERROR_STATE = 'DEVICE_PAIRING_RESET_ERROR_STATE';
exports.DEVICE_PAIRING_RESET_ERROR_STATE = DEVICE_PAIRING_RESET_ERROR_STATE;
var RENAME_DEVICE_BEGIN = 'RENAME_DEVICE_BEGIN';
exports.RENAME_DEVICE_BEGIN = RENAME_DEVICE_BEGIN;
var RENAME_DEVICE_SUCCESS = 'RENAME_DEVICE_SUCCESS';
exports.RENAME_DEVICE_SUCCESS = RENAME_DEVICE_SUCCESS;
var RENAME_DEVICE_FAILURE = 'RENAME_DEVICE_FAILURE';
exports.RENAME_DEVICE_FAILURE = RENAME_DEVICE_FAILURE;
var RENAME_DEVICE_SUFFIX = 'pairing/renamedevice';
exports.RENAME_DEVICE_SUFFIX = RENAME_DEVICE_SUFFIX;
var MEETING_SETTINGS_ENDPOINT = 'lifesize.meetingSettings';
exports.MEETING_SETTINGS_ENDPOINT = MEETING_SETTINGS_ENDPOINT;
var GET_MEETING_SETTINGS_BEGIN = 'GET_MEETING_SETTINGS_BEGIN';
exports.GET_MEETING_SETTINGS_BEGIN = GET_MEETING_SETTINGS_BEGIN;
var GET_MEETING_SETTINGS_SUCCESS = 'GET_MEETING_SETTINGS_SUCCESS';
exports.GET_MEETING_SETTINGS_SUCCESS = GET_MEETING_SETTINGS_SUCCESS;
var GET_MEETING_SETTINGS_FAILURE = 'GET_MEETING_SETTINGS_FAILURE';
exports.GET_MEETING_SETTINGS_FAILURE = GET_MEETING_SETTINGS_FAILURE;
var GET_MEETING_INACTIVE_DAYS_BEGIN = 'GET_MEETING_INACTIVE_DAYS_BEGIN';
exports.GET_MEETING_INACTIVE_DAYS_BEGIN = GET_MEETING_INACTIVE_DAYS_BEGIN;
var GET_MEETING_INACTIVE_DAYS_SUCCESS = 'GET_MEETING_INACTIVE_DAYS_SUCCESS';
exports.GET_MEETING_INACTIVE_DAYS_SUCCESS = GET_MEETING_INACTIVE_DAYS_SUCCESS;
var GET_MEETING_INACTIVE_DAYS_FAILURE = 'GET_MEETING_INACTIVE_DAYS_FAILURE';
exports.GET_MEETING_INACTIVE_DAYS_FAILURE = GET_MEETING_INACTIVE_DAYS_FAILURE;
var SET_MEETING_INACTIVE_DAYS_BEGIN = 'SET_MEETING_INACTIVE_DAYS_BEGIN';
exports.SET_MEETING_INACTIVE_DAYS_BEGIN = SET_MEETING_INACTIVE_DAYS_BEGIN;
var SET_MEETING_INACTIVE_DAYS_SUCCESS = 'SET_MEETING_INACTIVE_DAYS_SUCCESS';
exports.SET_MEETING_INACTIVE_DAYS_SUCCESS = SET_MEETING_INACTIVE_DAYS_SUCCESS;
var SET_MEETING_INACTIVE_DAYS_FAILURE = 'SET_MEETING_INACTIVE_DAYS_FAILURE';
exports.SET_MEETING_INACTIVE_DAYS_FAILURE = SET_MEETING_INACTIVE_DAYS_FAILURE;
var SET_MEETING_INACTIVE_DAYS_OTM_BEGIN = 'SET_MEETING_INACTIVE_DAYS_OTM_BEGIN';
exports.SET_MEETING_INACTIVE_DAYS_OTM_BEGIN = SET_MEETING_INACTIVE_DAYS_OTM_BEGIN;
var SET_MEETING_INACTIVE_DAYS_OTM_SUCCESS = 'SET_MEETING_INACTIVE_DAYS_OTM_SUCCESS';
exports.SET_MEETING_INACTIVE_DAYS_OTM_SUCCESS = SET_MEETING_INACTIVE_DAYS_OTM_SUCCESS;
var SET_MEETING_INACTIVE_DAYS_OTM_FAILURE = 'SET_MEETING_INACTIVE_DAYS_OTM_FAILURE';
exports.SET_MEETING_INACTIVE_DAYS_OTM_FAILURE = SET_MEETING_INACTIVE_DAYS_OTM_FAILURE;
var PSTN_SERVICE_ENDPOINT = 'lifesize.pstnNumberService';
exports.PSTN_SERVICE_ENDPOINT = PSTN_SERVICE_ENDPOINT;
var PSTN_SERVICE_ADMIN_ENDPOINT = 'lifesize.pstnNumberService.admin'; // Meetings Service

exports.PSTN_SERVICE_ADMIN_ENDPOINT = PSTN_SERVICE_ADMIN_ENDPOINT;
var MEETINGS_ENDPOINT = 'lifesize.meeting';
exports.MEETINGS_ENDPOINT = MEETINGS_ENDPOINT;
var CREATE_MEETING_BEGIN = 'CREATE_MEETING_BEGIN';
exports.CREATE_MEETING_BEGIN = CREATE_MEETING_BEGIN;
var CREATE_MEETING_SUCCESS = 'CREATE_MEETING_SUCCESS';
exports.CREATE_MEETING_SUCCESS = CREATE_MEETING_SUCCESS;
var CREATE_MEETING_FAILURE = 'CREATE_MEETING_FAILURE';
exports.CREATE_MEETING_FAILURE = CREATE_MEETING_FAILURE;
var CREATE_MEETING_SUFFIX = 'meeting/create';
exports.CREATE_MEETING_SUFFIX = CREATE_MEETING_SUFFIX;
var UPDATE_MEETING_BEGIN = 'UPDATE_MEETING_BEGIN';
exports.UPDATE_MEETING_BEGIN = UPDATE_MEETING_BEGIN;
var UPDATE_MEETING_SUCCESS = 'UPDATE_MEETING_SUCCESS';
exports.UPDATE_MEETING_SUCCESS = UPDATE_MEETING_SUCCESS;
var UPDATE_MEETING_FAILURE = 'UPDATE_MEETING_FAILURE';
exports.UPDATE_MEETING_FAILURE = UPDATE_MEETING_FAILURE;
var UPDATE_MEETING_SUFFIX = 'meeting/update';
exports.UPDATE_MEETING_SUFFIX = UPDATE_MEETING_SUFFIX;
var DELETE_MEETING_BEGIN = ' DELETE_MEETING_BEGIN';
exports.DELETE_MEETING_BEGIN = DELETE_MEETING_BEGIN;
var DELETE_MEETING_SUCCESS = ' DELETE_MEETING_SUCCESS';
exports.DELETE_MEETING_SUCCESS = DELETE_MEETING_SUCCESS;
var DELETE_MEETING_FAILURE = ' DELETE_MEETING_FAILURE';
exports.DELETE_MEETING_FAILURE = DELETE_MEETING_FAILURE;
var RESET_MEETING_ERROR_STATE = 'RESET_MEETING_ERROR_STATE';
exports.RESET_MEETING_ERROR_STATE = RESET_MEETING_ERROR_STATE;
var DELETE_MEETING_SUFFIX = 'meeting/delete';
exports.DELETE_MEETING_SUFFIX = DELETE_MEETING_SUFFIX;
var DELETE_MEETING_LIST_SUFFIX = 'meeting/deletelist';
exports.DELETE_MEETING_LIST_SUFFIX = DELETE_MEETING_LIST_SUFFIX;
var GET_MEETINGS_BEGIN = 'GET_MEETINGS_DEVICES_BEGIN';
exports.GET_MEETINGS_BEGIN = GET_MEETINGS_BEGIN;
var GET_MEETINGS_SUCCESS = 'GET_MEETINGS_DEVICES_SUCCESS';
exports.GET_MEETINGS_SUCCESS = GET_MEETINGS_SUCCESS;
var GET_MEETINGS_FAILURE = 'GET_MEETINGS_DEVICES_FAILURE'; // Galaxy WAMP Constants

exports.GET_MEETINGS_FAILURE = GET_MEETINGS_FAILURE;
var GALAXY_TOPIC_CALL_MANAGER = 'lifesize.callmanager';
exports.GALAXY_TOPIC_CALL_MANAGER = GALAXY_TOPIC_CALL_MANAGER;
var GALAXY_TOPIC_CONFERENCE = 'ls.conference_';
exports.GALAXY_TOPIC_CONFERENCE = GALAXY_TOPIC_CONFERENCE;
var GALAXY_TOPIC_MODERATOR_ACTIONS = 'lifesize.moderatorActions';
exports.GALAXY_TOPIC_MODERATOR_ACTIONS = GALAXY_TOPIC_MODERATOR_ACTIONS;
var GALAXY_TOPIC_USER_ACTIONS = 'lifesize.userActions';
exports.GALAXY_TOPIC_USER_ACTIONS = GALAXY_TOPIC_USER_ACTIONS;
var GALAXY_WAMP_URI_SUFFIX_DEFAULT = '';
exports.GALAXY_WAMP_URI_SUFFIX_DEFAULT = GALAXY_WAMP_URI_SUFFIX_DEFAULT;
var GALAXY_HTTP_METHOD_DEFAULT = 'POST';
exports.GALAXY_HTTP_METHOD_DEFAULT = GALAXY_HTTP_METHOD_DEFAULT;
var GALAXY_WAMP_ACTION_CALL_MANAGER = 'call';
exports.GALAXY_WAMP_ACTION_CALL_MANAGER = GALAXY_WAMP_ACTION_CALL_MANAGER;
var GALAXY_HTTP_METHOD_CALL_MANAGER = 'POST';
exports.GALAXY_HTTP_METHOD_CALL_MANAGER = GALAXY_HTTP_METHOD_CALL_MANAGER;
var GALAXY_SUBSCRIPTION_CALL_MANAGER = 'ls.call';
exports.GALAXY_SUBSCRIPTION_CALL_MANAGER = GALAXY_SUBSCRIPTION_CALL_MANAGER;
var GALAXY_TOPIC_TURN_SERVER = 'lifesize.turnserver';
exports.GALAXY_TOPIC_TURN_SERVER = GALAXY_TOPIC_TURN_SERVER;
var GALAXY_WAMP_ACTION_TURN_SERVER = 'turnserver';
exports.GALAXY_WAMP_ACTION_TURN_SERVER = GALAXY_WAMP_ACTION_TURN_SERVER;
var GALAXY_HTTP_METHOD_TURN_SERVER = 'POST';
exports.GALAXY_HTTP_METHOD_TURN_SERVER = GALAXY_HTTP_METHOD_TURN_SERVER;
var GALAXY_SUBSCRIPTION_TURN_SERVER = 'ls.turn';
exports.GALAXY_SUBSCRIPTION_TURN_SERVER = GALAXY_SUBSCRIPTION_TURN_SERVER;
var GALAXY_TOPIC_CAPABILITIES_SERVER = 'lifesize.capabilities';
exports.GALAXY_TOPIC_CAPABILITIES_SERVER = GALAXY_TOPIC_CAPABILITIES_SERVER;
var GALAXY_WAMP_ACTION_CAPABILITIES_SERVER = 'capabilities';
exports.GALAXY_WAMP_ACTION_CAPABILITIES_SERVER = GALAXY_WAMP_ACTION_CAPABILITIES_SERVER;
var GALAXY_HTTP_METHOD_CAPABILITIES_SERVER = 'POST';
exports.GALAXY_HTTP_METHOD_CAPABILITIES_SERVER = GALAXY_HTTP_METHOD_CAPABILITIES_SERVER;
var GALAXY_SUBSCRIPTION_CAPABILITIES_SERVER = 'ls.capabilities'; // These are the WAMP Subscription actions that are broadcast on receipt of an event.

exports.GALAXY_SUBSCRIPTION_CAPABILITIES_SERVER = GALAXY_SUBSCRIPTION_CAPABILITIES_SERVER;
var GALAXY_WAMP_SUBSCRIPTION_EVENT_CALL = 'GALAXY_WAMP_SUBSCRIPTION_EVENT_CALL';
exports.GALAXY_WAMP_SUBSCRIPTION_EVENT_CALL = GALAXY_WAMP_SUBSCRIPTION_EVENT_CALL;
var GALAXY_WAMP_SUBSCRIPTION_EVENT_TURN = 'GALAXY_WAMP_SUBSCRIPTION_EVENT_TURN';
exports.GALAXY_WAMP_SUBSCRIPTION_EVENT_TURN = GALAXY_WAMP_SUBSCRIPTION_EVENT_TURN;
var WAMP_SUBSCRIPTION_ACTION_CALENDAR_TOPIC = 'WAMP_SUBSCRIPTION_ACTION_CALENDAR_TOPIC'; // Galaxy Turn Constants

exports.WAMP_SUBSCRIPTION_ACTION_CALENDAR_TOPIC = WAMP_SUBSCRIPTION_ACTION_CALENDAR_TOPIC;
var GALAXY_COMMAND_GET_RELAY_SERVERS = 'getRelayServers';
exports.GALAXY_COMMAND_GET_RELAY_SERVERS = GALAXY_COMMAND_GET_RELAY_SERVERS;
var GALAXY_EVENT_GET_RELAY_SERVERS_SUCCESS = 'getRelayServersSuccess';
exports.GALAXY_EVENT_GET_RELAY_SERVERS_SUCCESS = GALAXY_EVENT_GET_RELAY_SERVERS_SUCCESS;
var GALAXY_EVENT_GET_RELAY_SERVERS_FAILED = 'getRelayServersFailed';
exports.GALAXY_EVENT_GET_RELAY_SERVERS_FAILED = GALAXY_EVENT_GET_RELAY_SERVERS_FAILED;
var GALAXY_ACTION_GET_RELAY_SERVERS_BEGIN = 'GALAXY_ACTION_GET_RELAY_SERVERS_BEGIN';
exports.GALAXY_ACTION_GET_RELAY_SERVERS_BEGIN = GALAXY_ACTION_GET_RELAY_SERVERS_BEGIN;
var GALAXY_ACTION_GET_RELAY_SERVERS_SUCCESS = 'GALAXY_ACTION_GET_RELAY_SERVERS_SUCCESS';
exports.GALAXY_ACTION_GET_RELAY_SERVERS_SUCCESS = GALAXY_ACTION_GET_RELAY_SERVERS_SUCCESS;
var GALAXY_ACTION_GET_RELAY_SERVERS_FAILED = 'GALAXY_ACTION_GET_RELAY_SERVERS_FAILED'; // Galaxy Capabilities Constants

exports.GALAXY_ACTION_GET_RELAY_SERVERS_FAILED = GALAXY_ACTION_GET_RELAY_SERVERS_FAILED;
var GALAXY_ACTION_POST_CAPABILITIES_BEGIN = 'GALAXY_ACTION_POST_CAPABILITIES_BEGIN';
exports.GALAXY_ACTION_POST_CAPABILITIES_BEGIN = GALAXY_ACTION_POST_CAPABILITIES_BEGIN;
var GALAXY_ACTION_POST_CAPABILITIES_SUCCESS = 'GALAXY_ACTION_POST_CAPABILITIES_SUCCESS';
exports.GALAXY_ACTION_POST_CAPABILITIES_SUCCESS = GALAXY_ACTION_POST_CAPABILITIES_SUCCESS;
var GALAXY_ACTION_POST_CAPABILITIES_FAILED = 'GALAXY_ACTION_POST_CAPABILITIES_FAILED';
exports.GALAXY_ACTION_POST_CAPABILITIES_FAILED = GALAXY_ACTION_POST_CAPABILITIES_FAILED;
var GALAXY_POST_CAPABILITIES_FAILED_REASON_DEFAULT = 'Failed to post capabilities.'; // Galaxy Call and Conference Constants

exports.GALAXY_POST_CAPABILITIES_FAILED_REASON_DEFAULT = GALAXY_POST_CAPABILITIES_FAILED_REASON_DEFAULT;
var GALAXY_ACTION_BEGIN_CALL = 'GALAXY_ACTION_BEGIN_CALL';
exports.GALAXY_ACTION_BEGIN_CALL = GALAXY_ACTION_BEGIN_CALL;
var GALAXY_ACTION_BEGIN_CALL_OFFER = 'GALAXY_ACTION_BEGIN_CALL_OFFER';
exports.GALAXY_ACTION_BEGIN_CALL_OFFER = GALAXY_ACTION_BEGIN_CALL_OFFER;
var GALAXY_ACTION_CALLING = 'GALAXY_ACTION_CALLING';
exports.GALAXY_ACTION_CALLING = GALAXY_ACTION_CALLING;
var GALAXY_ACTION_INCOMING_CALL = 'GALAXY_ACTION_INCOMING_CALL';
exports.GALAXY_ACTION_INCOMING_CALL = GALAXY_ACTION_INCOMING_CALL;
var GALAXY_ACTION_BEGIN_ANSWER = 'GALAXY_ACTION_BEGIN_ANSWER';
exports.GALAXY_ACTION_BEGIN_ANSWER = GALAXY_ACTION_BEGIN_ANSWER;
var GALAXY_ACTION_ANSWER = 'GALAXY_ACTION_ANSWER';
exports.GALAXY_ACTION_ANSWER = GALAXY_ACTION_ANSWER;
var GALAXY_ACTION_INCOMING_ANSWER = 'GALAXY_ACTION_INCOMING_ANSWER';
exports.GALAXY_ACTION_INCOMING_ANSWER = GALAXY_ACTION_INCOMING_ANSWER;
var GALAXY_ACTION_CLEAR_CALL = 'GALAXY_ACTION_CLEAR_CALL';
exports.GALAXY_ACTION_CLEAR_CALL = GALAXY_ACTION_CLEAR_CALL;
var GALAXY_ACTION_QUEUE_CANCEL_CALL = 'GALAXY_ACTION_QUEUE_CANCEL_CALL';
exports.GALAXY_ACTION_QUEUE_CANCEL_CALL = GALAXY_ACTION_QUEUE_CANCEL_CALL;
var GALAXY_ACTION_TRYING = 'GALAXY_ACTION_TRYING';
exports.GALAXY_ACTION_TRYING = GALAXY_ACTION_TRYING;
var GALAXY_ACTION_RINGING = 'GALAXY_ACTION_RINGING';
exports.GALAXY_ACTION_RINGING = GALAXY_ACTION_RINGING;
var GALAXY_ACTION_ADD_RINGING = 'GALAXY_ACTION_ADD_RINGING';
exports.GALAXY_ACTION_ADD_RINGING = GALAXY_ACTION_ADD_RINGING;
var GALAXY_ACTION_CALL_CONNECTED = 'GALAXY_ACTION_CALL_CONNECTED';
exports.GALAXY_ACTION_CALL_CONNECTED = GALAXY_ACTION_CALL_CONNECTED;
var GALAXY_ACTION_FAILED = 'GALAXY_ACTION_FAILED';
exports.GALAXY_ACTION_FAILED = GALAXY_ACTION_FAILED;
var GALAXY_ACTION_END = 'GALAXY_ACTION_END';
exports.GALAXY_ACTION_END = GALAXY_ACTION_END;
var GALAXY_ACTION_IGNORE = 'GALAXY_ACTION_IGNORE';
exports.GALAXY_ACTION_IGNORE = GALAXY_ACTION_IGNORE;
var GALAXY_ACTION_INCOMING_CALL_ENDED = 'GALAXY_ACTION_INCOMING_CALL_ENDED';
exports.GALAXY_ACTION_INCOMING_CALL_ENDED = GALAXY_ACTION_INCOMING_CALL_ENDED;
var GALAXY_ACTION_FIRST_PARTICIPANT_READY_IN_IVR = 'GALAXY_ACTION_FIRST_PARTICIPANT_READY_IN_IVR';
exports.GALAXY_ACTION_FIRST_PARTICIPANT_READY_IN_IVR = GALAXY_ACTION_FIRST_PARTICIPANT_READY_IN_IVR;
var MODERATOR_JOINED = 'MODERATOR_JOINED';
exports.MODERATOR_JOINED = MODERATOR_JOINED;
var MODERATOR_LEFT = 'MODERATOR_LEFT';
exports.MODERATOR_LEFT = MODERATOR_LEFT;
var GALAXY_ACTION_REMOTE_MODERATOR_JOINED = 'GALAXY_ACTION_REMOTE_MODERATOR_JOINED';
exports.GALAXY_ACTION_REMOTE_MODERATOR_JOINED = GALAXY_ACTION_REMOTE_MODERATOR_JOINED;
var GALAXY_ACTION_REMOTE_MODERATOR_LEFT = 'GALAXY_ACTION_REMOTE_MODERATOR_LEFT';
exports.GALAXY_ACTION_REMOTE_MODERATOR_LEFT = GALAXY_ACTION_REMOTE_MODERATOR_LEFT;
var GALAXY_ACTION_CONFERENCE_JOINED = 'GALAXY_ACTION_CONFERENCE_JOINED';
exports.GALAXY_ACTION_CONFERENCE_JOINED = GALAXY_ACTION_CONFERENCE_JOINED;
var GALAXY_ACTION_PARTICIPANT_JOINED = 'GALAXY_ACTION_PARTICIPANT_JOINED';
exports.GALAXY_ACTION_PARTICIPANT_JOINED = GALAXY_ACTION_PARTICIPANT_JOINED;
var GALAXY_ACTION_PARTICIPANT_LEFT = 'GALAXY_ACTION_PARTICIPANT_LEFT';
exports.GALAXY_ACTION_PARTICIPANT_LEFT = GALAXY_ACTION_PARTICIPANT_LEFT;
var GALAXY_ACTION_PARTICIPANT_LOCAL_MUTED = 'GALAXY_ACTION_PARTICIPANT_LOCAL_MUTED';
exports.GALAXY_ACTION_PARTICIPANT_LOCAL_MUTED = GALAXY_ACTION_PARTICIPANT_LOCAL_MUTED;
var GALAXY_ACTION_PARTICIPANT_LOCAL_UNMUTED = 'GALAXY_ACTION_PARTICIPANT_LOCAL_UNMUTED';
exports.GALAXY_ACTION_PARTICIPANT_LOCAL_UNMUTED = GALAXY_ACTION_PARTICIPANT_LOCAL_UNMUTED;
var GALAXY_ACTION_PARTICIPANT_LOCAL_VIDEO_MUTED = 'GALAXY_ACTION_PARTICIPANT_LOCAL_VIDEO_MUTED';
exports.GALAXY_ACTION_PARTICIPANT_LOCAL_VIDEO_MUTED = GALAXY_ACTION_PARTICIPANT_LOCAL_VIDEO_MUTED;
var GALAXY_ACTION_PARTICIPANT_LOCAL_VIDEO_UNMUTED = 'GALAXY_ACTION_PARTICIPANT_LOCAL_VIDEO_UNMUTED';
exports.GALAXY_ACTION_PARTICIPANT_LOCAL_VIDEO_UNMUTED = GALAXY_ACTION_PARTICIPANT_LOCAL_VIDEO_UNMUTED;
var GALAXY_ACTION_PIN_REQUESTED = 'GALAXY_ACTION_PIN_REQUESTED';
exports.GALAXY_ACTION_PIN_REQUESTED = GALAXY_ACTION_PIN_REQUESTED;
var GALAXY_ACTION_PIN_SENT = 'GALAXY_ACTION_PIN_SENT';
exports.GALAXY_ACTION_PIN_SENT = GALAXY_ACTION_PIN_SENT;
var GALAXY_ACTION_PARTICIPANT_MUTED = 'GALAXY_ACTION_PARTICIPANT_MUTED';
exports.GALAXY_ACTION_PARTICIPANT_MUTED = GALAXY_ACTION_PARTICIPANT_MUTED;
var GALAXY_ACTION_PARTICIPANT_UNMUTED = 'GALAXY_ACTION_PARTICIPANT_UNMUTED';
exports.GALAXY_ACTION_PARTICIPANT_UNMUTED = GALAXY_ACTION_PARTICIPANT_UNMUTED;
var GALAXY_ACTION_CONFERENCE_MUTED = 'GALAXY_ACTION_CONFERENCE_MUTED';
exports.GALAXY_ACTION_CONFERENCE_MUTED = GALAXY_ACTION_CONFERENCE_MUTED;
var GALAXY_ACTION_CONFERENCE_UNMUTED = 'GALAXY_ACTION_CONFERENCE_UNMUTED';
exports.GALAXY_ACTION_CONFERENCE_UNMUTED = GALAXY_ACTION_CONFERENCE_UNMUTED;
var GALAXY_ACTION_CONFERENCE_ESCALATED = 'GALAXY_ACTION_CONFERENCE_ESCALATED';
exports.GALAXY_ACTION_CONFERENCE_ESCALATED = GALAXY_ACTION_CONFERENCE_ESCALATED;
var GALAXY_ACTION_CALL_PICKUP = 'GALAXY_ACTION_CALL_PICKUP';
exports.GALAXY_ACTION_CALL_PICKUP = GALAXY_ACTION_CALL_PICKUP;
var GALAXY_ACTION_CALL_PICKUP_FAILED = 'GALAXY_ACTION_CALL_PICKUP_FAILED';
exports.GALAXY_ACTION_CALL_PICKUP_FAILED = GALAXY_ACTION_CALL_PICKUP_FAILED;
var GALAXY_ACTION_PUSH_CALL_CANCELLED = 'GALAXY_ACTION_PUSH_CALL_CANCELLED';
exports.GALAXY_ACTION_PUSH_CALL_CANCELLED = GALAXY_ACTION_PUSH_CALL_CANCELLED;
var GALAXY_ACTION_RECORDING_START = 'GALAXY_ACTION_RECORDING_START';
exports.GALAXY_ACTION_RECORDING_START = GALAXY_ACTION_RECORDING_START;
var GALAXY_ACTION_RECORDING_STARTED = 'GALAXY_ACTION_RECORDING_STARTED';
exports.GALAXY_ACTION_RECORDING_STARTED = GALAXY_ACTION_RECORDING_STARTED;
var GALAXY_ACTION_RECORDING_UPDATED = 'GALAXY_ACTION_RECORDING_UPDATED';
exports.GALAXY_ACTION_RECORDING_UPDATED = GALAXY_ACTION_RECORDING_UPDATED;
var GALAXY_ACTION_RECORDING_START_ERROR = 'GALAXY_ACTION_RECORDING_START_ERROR';
exports.GALAXY_ACTION_RECORDING_START_ERROR = GALAXY_ACTION_RECORDING_START_ERROR;
var GALAXY_ACTION_RECORDING_STOP = 'GALAXY_ACTION_RECORDING_STOP';
exports.GALAXY_ACTION_RECORDING_STOP = GALAXY_ACTION_RECORDING_STOP;
var GALAXY_ACTION_RECORDING_STOPPED = 'GALAXY_ACTION_RECORDING_STOPPED';
exports.GALAXY_ACTION_RECORDING_STOPPED = GALAXY_ACTION_RECORDING_STOPPED;
var GALAXY_ACTION_RECORDING_STOP_ERROR = 'GALAXY_ACTION_RECORDING_STOP_ERROR';
exports.GALAXY_ACTION_RECORDING_STOP_ERROR = GALAXY_ACTION_RECORDING_STOP_ERROR;
var GALAXY_ACTION_FECC_INCOMING = 'GALAXY_ACTION_FECC_INCOMING';
exports.GALAXY_ACTION_FECC_INCOMING = GALAXY_ACTION_FECC_INCOMING;
var GALAXY_ACTION_EJECT_SUCCESS = 'GALAXY_ACTION_EJECT_SUCCESS';
exports.GALAXY_ACTION_EJECT_SUCCESS = GALAXY_ACTION_EJECT_SUCCESS;
var GALAXY_ACTION_CONFERENCE_LOCKED = 'GALAXY_ACTION_CONFERENCE_LOCKED';
exports.GALAXY_ACTION_CONFERENCE_LOCKED = GALAXY_ACTION_CONFERENCE_LOCKED;
var GALAXY_ACTION_CONFERENCE_UNLOCKED = 'GALAXY_ACTION_CONFERENCE_UNLOCKED'; // Galaxy Escalation

exports.GALAXY_ACTION_CONFERENCE_UNLOCKED = GALAXY_ACTION_CONFERENCE_UNLOCKED;
var GALAXY_ACTION_CALL_WAITING = 'GALAXY_ACTION_CALL_WAITING';
exports.GALAXY_ACTION_CALL_WAITING = GALAXY_ACTION_CALL_WAITING;
var GALAXY_ACTION_CALL_WAITING_CANCELLED = 'GALAXY_ACTION_CALL_WAITING_CANCELLED';
exports.GALAXY_ACTION_CALL_WAITING_CANCELLED = GALAXY_ACTION_CALL_WAITING_CANCELLED;
var GALAXY_ACTION_CALL_WAITING_RESPONSE = 'GALAXY_ACTION_CALL_WAITING_RESPONSE';
exports.GALAXY_ACTION_CALL_WAITING_RESPONSE = GALAXY_ACTION_CALL_WAITING_RESPONSE;
var GALAXY_ACTION_REPLACE_CALL = 'GALAXY_ACTION_REPLACE_CALL';
exports.GALAXY_ACTION_REPLACE_CALL = GALAXY_ACTION_REPLACE_CALL;
var GALAXY_ACTION_ADD_TO_CALL = 'GALAXY_ACTION_ADD_TO_CALL';
exports.GALAXY_ACTION_ADD_TO_CALL = GALAXY_ACTION_ADD_TO_CALL;
var GALAXY_ACTION_ADD_SUCCESS = 'GALAXY_ACTION_ADD_SUCCESS';
exports.GALAXY_ACTION_ADD_SUCCESS = GALAXY_ACTION_ADD_SUCCESS;
var GALAXY_ACTION_ADD_FAILED = 'GALAXY_ACTION_ADD_FAILED';
exports.GALAXY_ACTION_ADD_FAILED = GALAXY_ACTION_ADD_FAILED;
var GALAXY_ACTION_ADD_HUNGUP = 'GALAXY_ACTION_ADD_HUNGUP';
exports.GALAXY_ACTION_ADD_HUNGUP = GALAXY_ACTION_ADD_HUNGUP;
var GALAXY_ACTION_CLEAR_INVITED = 'GALAXY_ACTION_CLEAR_INVITED';
exports.GALAXY_ACTION_CLEAR_INVITED = GALAXY_ACTION_CLEAR_INVITED;
var GALAXY_INVITEE_STATE_TRYING = 'trying';
exports.GALAXY_INVITEE_STATE_TRYING = GALAXY_INVITEE_STATE_TRYING;
var GALAXY_INVITEE_STATE_RINGING = 'ringing';
exports.GALAXY_INVITEE_STATE_RINGING = GALAXY_INVITEE_STATE_RINGING;
var GALAXY_INVITEE_STATE_CONNECTED = 'connected';
exports.GALAXY_INVITEE_STATE_CONNECTED = GALAXY_INVITEE_STATE_CONNECTED;
var GALAXY_INVITEE_STATE_FAILED = 'failed';
exports.GALAXY_INVITEE_STATE_FAILED = GALAXY_INVITEE_STATE_FAILED;
var GALAXY_ADD_RESPONSE_ACTION_CONNECTED = 'connected';
exports.GALAXY_ADD_RESPONSE_ACTION_CONNECTED = GALAXY_ADD_RESPONSE_ACTION_CONNECTED;
var GALAXY_ADD_RESPONSE_ACTION_TIMEOUT = 'timeout';
exports.GALAXY_ADD_RESPONSE_ACTION_TIMEOUT = GALAXY_ADD_RESPONSE_ACTION_TIMEOUT;
var GALAXY_ADD_RESPONSE_ACTION_REJECTED = 'rejected';
exports.GALAXY_ADD_RESPONSE_ACTION_REJECTED = GALAXY_ADD_RESPONSE_ACTION_REJECTED;
var GALAXY_ADD_RESPONSE_ACTION_USERNOTFOUND = 'userNotFound';
exports.GALAXY_ADD_RESPONSE_ACTION_USERNOTFOUND = GALAXY_ADD_RESPONSE_ACTION_USERNOTFOUND;
var GALAXY_ADD_RESPONSE_ACTION_BUSY = 'busy';
exports.GALAXY_ADD_RESPONSE_ACTION_BUSY = GALAXY_ADD_RESPONSE_ACTION_BUSY;
var GALAXY_ADD_RESPONSE_ACTION_CANCELLED = 'cancelled';
exports.GALAXY_ADD_RESPONSE_ACTION_CANCELLED = GALAXY_ADD_RESPONSE_ACTION_CANCELLED;
var GALAXY_EVENT_CALL = 'call';
exports.GALAXY_EVENT_CALL = GALAXY_EVENT_CALL;
var GALAXY_EVENT_TRYING = 'trying';
exports.GALAXY_EVENT_TRYING = GALAXY_EVENT_TRYING;
var GALAXY_EVENT_RINGING = 'ringing';
exports.GALAXY_EVENT_RINGING = GALAXY_EVENT_RINGING;
var GALAXY_EVENT_CONNECTED = 'connected';
exports.GALAXY_EVENT_CONNECTED = GALAXY_EVENT_CONNECTED;
var GALAXY_EVENT_FAILED = 'failed';
exports.GALAXY_EVENT_FAILED = GALAXY_EVENT_FAILED;
var GALAXY_EVENT_END = 'end';
exports.GALAXY_EVENT_END = GALAXY_EVENT_END;
var GALAXY_EVENT_REDIRECT_TO_LEGACY = 'redirectToLegacy';
exports.GALAXY_EVENT_REDIRECT_TO_LEGACY = GALAXY_EVENT_REDIRECT_TO_LEGACY;
var GALAXY_EVENT_CALL_WAITING = 'callWaiting';
exports.GALAXY_EVENT_CALL_WAITING = GALAXY_EVENT_CALL_WAITING;
var GALAXY_EVENT_CALL_WAITING_CANCELLED = 'callWaitingCancelled';
exports.GALAXY_EVENT_CALL_WAITING_CANCELLED = GALAXY_EVENT_CALL_WAITING_CANCELLED;
var GALAXY_EVENT_REPLACE_CALL = 'replaceCall';
exports.GALAXY_EVENT_REPLACE_CALL = GALAXY_EVENT_REPLACE_CALL;
var GALAXY_EVENT_ADD_RESPONSE = 'addResponse';
exports.GALAXY_EVENT_ADD_RESPONSE = GALAXY_EVENT_ADD_RESPONSE;
var GALAXY_EVENT_ADD_RINGING = 'addRinging';
exports.GALAXY_EVENT_ADD_RINGING = GALAXY_EVENT_ADD_RINGING;
var GALAXY_EVENT_PARTICIPANT_EJECTED = 'participantEjected';
exports.GALAXY_EVENT_PARTICIPANT_EJECTED = GALAXY_EVENT_PARTICIPANT_EJECTED;
var GALAXY_EVENT_PARTICIPANT_MIGRATED = 'participantMigrated';
exports.GALAXY_EVENT_PARTICIPANT_MIGRATED = GALAXY_EVENT_PARTICIPANT_MIGRATED;
var GALAXY_EVENT_FIRST_PARTICIPANT_READY_IN_IVR = 'firstParticipantReadyInIVR';
exports.GALAXY_EVENT_FIRST_PARTICIPANT_READY_IN_IVR = GALAXY_EVENT_FIRST_PARTICIPANT_READY_IN_IVR;
var GALAXY_EVENT_CONFERENCE_JOINED = 'conferenceJoined';
exports.GALAXY_EVENT_CONFERENCE_JOINED = GALAXY_EVENT_CONFERENCE_JOINED;
var GALAXY_EVENT_CONFERENCE_ENDED = 'conferenceEnded';
exports.GALAXY_EVENT_CONFERENCE_ENDED = GALAXY_EVENT_CONFERENCE_ENDED;
var GALAXY_EVENT_CONFERENCE_NOTIFICATION = 'conferenceNotification';
exports.GALAXY_EVENT_CONFERENCE_NOTIFICATION = GALAXY_EVENT_CONFERENCE_NOTIFICATION;
var GALAXY_EVENT_CONFERENCE_ESCALATED = 'conferenceEscalated';
exports.GALAXY_EVENT_CONFERENCE_ESCALATED = GALAXY_EVENT_CONFERENCE_ESCALATED;
var GALAXY_EVENT_PARTICIPANT_IGNORED = 'participantIgnored';
exports.GALAXY_EVENT_PARTICIPANT_IGNORED = GALAXY_EVENT_PARTICIPANT_IGNORED;
var GALAXY_EVENT_PARTICIPANT_JOINED = 'participantJoined';
exports.GALAXY_EVENT_PARTICIPANT_JOINED = GALAXY_EVENT_PARTICIPANT_JOINED;
var GALAXY_EVENT_PARTICIPANT_LEFT = 'participantLeft';
exports.GALAXY_EVENT_PARTICIPANT_LEFT = GALAXY_EVENT_PARTICIPANT_LEFT;
var GALAXY_EVENT_PARTICIPANT_LOCAL_MUTE = 'participantLocalMute';
exports.GALAXY_EVENT_PARTICIPANT_LOCAL_MUTE = GALAXY_EVENT_PARTICIPANT_LOCAL_MUTE;
var GALAXY_EVENT_PARTICIPANT_LOCAL_UN_MUTE = 'participantLocalUnMute';
exports.GALAXY_EVENT_PARTICIPANT_LOCAL_UN_MUTE = GALAXY_EVENT_PARTICIPANT_LOCAL_UN_MUTE;
var GALAXY_EVENT_PARTICIPANT_LOCAL_VIDEO_MUTED = 'participantLocalVideoMuted';
exports.GALAXY_EVENT_PARTICIPANT_LOCAL_VIDEO_MUTED = GALAXY_EVENT_PARTICIPANT_LOCAL_VIDEO_MUTED;
var GALAXY_EVENT_PARTICIPANT_LOCAL_VIDEO_UNMUTED = 'participantLocalVideoUnmuted';
exports.GALAXY_EVENT_PARTICIPANT_LOCAL_VIDEO_UNMUTED = GALAXY_EVENT_PARTICIPANT_LOCAL_VIDEO_UNMUTED;
var GALAXY_EVENT_MODERATOR_JOINED = 'moderatorJoined';
exports.GALAXY_EVENT_MODERATOR_JOINED = GALAXY_EVENT_MODERATOR_JOINED;
var GALAXY_EVENT_MODERATOR_LEFT = 'moderatorLeft';
exports.GALAXY_EVENT_MODERATOR_LEFT = GALAXY_EVENT_MODERATOR_LEFT;
var GALAXY_EVENT_REMOTE_MODERATOR_JOINED = 'remoteModeratorJoined';
exports.GALAXY_EVENT_REMOTE_MODERATOR_JOINED = GALAXY_EVENT_REMOTE_MODERATOR_JOINED;
var GALAXY_EVENT_REMOTE_MODERATOR_LEFT = 'remoteModeratorLeft';
exports.GALAXY_EVENT_REMOTE_MODERATOR_LEFT = GALAXY_EVENT_REMOTE_MODERATOR_LEFT;
var GALAXY_PASSTHROUGH_LOCAL_VIDEO_MUTE = 'localVideoMute';
exports.GALAXY_PASSTHROUGH_LOCAL_VIDEO_MUTE = GALAXY_PASSTHROUGH_LOCAL_VIDEO_MUTE;
var GALAXY_PASSTHROUGH_LOCAL_VIDEO_UNMUTE = 'localVideoUnmute';
exports.GALAXY_PASSTHROUGH_LOCAL_VIDEO_UNMUTE = GALAXY_PASSTHROUGH_LOCAL_VIDEO_UNMUTE;
var GALAXY_EVENT_REQUEST_PIN = 'requestPin';
exports.GALAXY_EVENT_REQUEST_PIN = GALAXY_EVENT_REQUEST_PIN;
var GALAXY_EVENT_MUTE_ALL = 'muteAll';
exports.GALAXY_EVENT_MUTE_ALL = GALAXY_EVENT_MUTE_ALL;
var GALAXY_EVENT_UN_MUTE_ALL = 'unMuteAll';
exports.GALAXY_EVENT_UN_MUTE_ALL = GALAXY_EVENT_UN_MUTE_ALL;
var GALAXY_EVENT_PRESENTATION_FLOOR_GRANTED = 'presentationFloorGranted';
exports.GALAXY_EVENT_PRESENTATION_FLOOR_GRANTED = GALAXY_EVENT_PRESENTATION_FLOOR_GRANTED;
var GALAXY_EVENT_PRESENTATION_FLOOR_RELEASED = 'presentationFloorReleased';
exports.GALAXY_EVENT_PRESENTATION_FLOOR_RELEASED = GALAXY_EVENT_PRESENTATION_FLOOR_RELEASED;
var GALAXY_EVENT_MUTE_PARTICIPANT = 'participantRemoteMute';
exports.GALAXY_EVENT_MUTE_PARTICIPANT = GALAXY_EVENT_MUTE_PARTICIPANT;
var GALAXY_EVENT_UN_MUTE_PARTICIPANT = 'participantRemoteUnMute';
exports.GALAXY_EVENT_UN_MUTE_PARTICIPANT = GALAXY_EVENT_UN_MUTE_PARTICIPANT;
var GALAXY_EVENT_CHANGE_LAYOUT_RESPONSE = 'changeLayoutResponse';
exports.GALAXY_EVENT_CHANGE_LAYOUT_RESPONSE = GALAXY_EVENT_CHANGE_LAYOUT_RESPONSE;
var GALAXY_EVENT_CALL_PICKUP_FAILED = 'callPickupFailed';
exports.GALAXY_EVENT_CALL_PICKUP_FAILED = GALAXY_EVENT_CALL_PICKUP_FAILED;
var GALAXY_EVENT_RECORDING_STARTED = 'recordingStarted';
exports.GALAXY_EVENT_RECORDING_STARTED = GALAXY_EVENT_RECORDING_STARTED;
var GALAXY_EVENT_RECORDING_STOPPED = 'recordingStopped';
exports.GALAXY_EVENT_RECORDING_STOPPED = GALAXY_EVENT_RECORDING_STOPPED;
var GALAXY_EVENT_RECORDING_FAILED = 'recordingFailed';
exports.GALAXY_EVENT_RECORDING_FAILED = GALAXY_EVENT_RECORDING_FAILED;
var GALAXY_EVENT_RECORDING_STOP_FAILED = 'recordingStopFailed';
exports.GALAXY_EVENT_RECORDING_STOP_FAILED = GALAXY_EVENT_RECORDING_STOP_FAILED;
var GALAXY_EVENT_RECORDING_INITIATED = 'recordingInitiating';
exports.GALAXY_EVENT_RECORDING_INITIATED = GALAXY_EVENT_RECORDING_INITIATED;
var GALAXY_EVENT_RECORDING_STOP_INITIATED = 'recordingStopInitiating';
exports.GALAXY_EVENT_RECORDING_STOP_INITIATED = GALAXY_EVENT_RECORDING_STOP_INITIATED;
var GALAXY_EVENT_EJECT_SUCCESS = 'ejectSuccess';
exports.GALAXY_EVENT_EJECT_SUCCESS = GALAXY_EVENT_EJECT_SUCCESS;
var GALAXY_EVENT_CONFERENCE_LOCKED = 'meetingLocked';
exports.GALAXY_EVENT_CONFERENCE_LOCKED = GALAXY_EVENT_CONFERENCE_LOCKED;
var GALAXY_EVENT_CONFERENCE_UNLOCKED = 'meetingUnlocked'; // Galaxy conference states and types

exports.GALAXY_EVENT_CONFERENCE_UNLOCKED = GALAXY_EVENT_CONFERENCE_UNLOCKED;
var GALAXY_CONFERENCE_STATE_ACTIVE = 'active';
exports.GALAXY_CONFERENCE_STATE_ACTIVE = GALAXY_CONFERENCE_STATE_ACTIVE;
var GALAXY_CONFERENCE_STATE_ESCALATED = 'escalated';
exports.GALAXY_CONFERENCE_STATE_ESCALATED = GALAXY_CONFERENCE_STATE_ESCALATED;
var GALAXY_CONFERENCE_TYPE_ADHOC = 'ADHOC';
exports.GALAXY_CONFERENCE_TYPE_ADHOC = GALAXY_CONFERENCE_TYPE_ADHOC;
var GALAXY_CONFERENCE_TYPE_VMR = 'VMR';
exports.GALAXY_CONFERENCE_TYPE_VMR = GALAXY_CONFERENCE_TYPE_VMR;
var GALAXY_COMMAND_EJECT = 'eject';
exports.GALAXY_COMMAND_EJECT = GALAXY_COMMAND_EJECT;
var GALAXY_COMMAND_EJECT_ALL = 'ejectAll';
exports.GALAXY_COMMAND_EJECT_ALL = GALAXY_COMMAND_EJECT_ALL;
var GALAXY_COMMAND_MUTE_PARTICIPANT = 'muteParticipant';
exports.GALAXY_COMMAND_MUTE_PARTICIPANT = GALAXY_COMMAND_MUTE_PARTICIPANT;
var GALAXY_COMMAND_MUTE_ALL = 'muteAll';
exports.GALAXY_COMMAND_MUTE_ALL = GALAXY_COMMAND_MUTE_ALL;
var GALAXY_COMMAND_UN_MUTE_PARTICIPANT = 'unMuteParticipant';
exports.GALAXY_COMMAND_UN_MUTE_PARTICIPANT = GALAXY_COMMAND_UN_MUTE_PARTICIPANT;
var GALAXY_COMMAND_UN_MUTE_ALL = 'unMuteAll';
exports.GALAXY_COMMAND_UN_MUTE_ALL = GALAXY_COMMAND_UN_MUTE_ALL;
var GALAXY_COMMAND_LOCAL_MUTE = 'localMute';
exports.GALAXY_COMMAND_LOCAL_MUTE = GALAXY_COMMAND_LOCAL_MUTE;
var GALAXY_COMMAND_LOCAL_UN_MUTE = 'localUnMute';
exports.GALAXY_COMMAND_LOCAL_UN_MUTE = GALAXY_COMMAND_LOCAL_UN_MUTE;
var GALAXY_COMMAND_CALL_WAITING_ADD = 'add';
exports.GALAXY_COMMAND_CALL_WAITING_ADD = GALAXY_COMMAND_CALL_WAITING_ADD;
var GALAXY_COMMAND_CALL_WAITING_RINGING = 'callWaitingRinging';
exports.GALAXY_COMMAND_CALL_WAITING_RINGING = GALAXY_COMMAND_CALL_WAITING_RINGING;
var GALAXY_COMMAND_CALL_WAITING_END_AND_ANSWER = 'endAndAnswer';
exports.GALAXY_COMMAND_CALL_WAITING_END_AND_ANSWER = GALAXY_COMMAND_CALL_WAITING_END_AND_ANSWER;
var GALAXY_COMMAND_CALL_WAITING_IGNORE = 'ignore';
exports.GALAXY_COMMAND_CALL_WAITING_IGNORE = GALAXY_COMMAND_CALL_WAITING_IGNORE;
var GALAXY_COMMAND_CALL_WAITING_RESPONSE = 'callWaitingResponse';
exports.GALAXY_COMMAND_CALL_WAITING_RESPONSE = GALAXY_COMMAND_CALL_WAITING_RESPONSE;
var GALAXY_COMMAND_CALL_REPLACED = 'callReplaced';
exports.GALAXY_COMMAND_CALL_REPLACED = GALAXY_COMMAND_CALL_REPLACED;
var GALAXY_COMMAND_REJECTED = 'rejected';
exports.GALAXY_COMMAND_REJECTED = GALAXY_COMMAND_REJECTED;
var GALAXY_COMMAND_ADD = 'add';
exports.GALAXY_COMMAND_ADD = GALAXY_COMMAND_ADD;
var GALAXY_COMMAND_CANCEL_ADD = 'cancelAdd';
exports.GALAXY_COMMAND_CANCEL_ADD = GALAXY_COMMAND_CANCEL_ADD;
var GALAXY_COMMAND_BUSY = 'busy';
exports.GALAXY_COMMAND_BUSY = GALAXY_COMMAND_BUSY;
var GALAXY_COMMAND_NO_ANSWER = 'noAnswer';
exports.GALAXY_COMMAND_NO_ANSWER = GALAXY_COMMAND_NO_ANSWER;
var GALAXY_COMMAND_PASSTHROUGH = 'passThrough';
exports.GALAXY_COMMAND_PASSTHROUGH = GALAXY_COMMAND_PASSTHROUGH;
var GALAXY_COMMAND_HEARTBEAT = 'heartBeat';
exports.GALAXY_COMMAND_HEARTBEAT = GALAXY_COMMAND_HEARTBEAT;
var GALAXY_COMMAND_CALL = 'call';
exports.GALAXY_COMMAND_CALL = GALAXY_COMMAND_CALL;
var GALAXY_COMMAND_END = 'end';
exports.GALAXY_COMMAND_END = GALAXY_COMMAND_END;
var GALAXY_COMMAND_DTMF = 'dtmf';
exports.GALAXY_COMMAND_DTMF = GALAXY_COMMAND_DTMF;
var GALAXY_COMMAND_CHANGE_LAYOUT = 'changeLayout';
exports.GALAXY_COMMAND_CHANGE_LAYOUT = GALAXY_COMMAND_CHANGE_LAYOUT;
var GALAXY_COMMAND_CALL_PICKUP = 'callPickup';
exports.GALAXY_COMMAND_CALL_PICKUP = GALAXY_COMMAND_CALL_PICKUP;
var GALAXY_COMMAND_RECORD = 'record';
exports.GALAXY_COMMAND_RECORD = GALAXY_COMMAND_RECORD;
var GALAXY_COMMAND_STOP_RECORDING = 'stopRecording';
exports.GALAXY_COMMAND_STOP_RECORDING = GALAXY_COMMAND_STOP_RECORDING;
var GALAXY_COMMAND_MODERATOR_STOP_PRESENTATION = 'presentationFloorRevoke';
exports.GALAXY_COMMAND_MODERATOR_STOP_PRESENTATION = GALAXY_COMMAND_MODERATOR_STOP_PRESENTATION;
var GALAXY_COMMAND_ICE_STATE_NOTIFICATION = 'iceStateNotification';
exports.GALAXY_COMMAND_ICE_STATE_NOTIFICATION = GALAXY_COMMAND_ICE_STATE_NOTIFICATION;
var GALAXY_CONNECTION_PRIMARY = 'primary';
exports.GALAXY_CONNECTION_PRIMARY = GALAXY_CONNECTION_PRIMARY;
var GALAXY_CONNECTION_PRESENTATION = 'presentation';
exports.GALAXY_CONNECTION_PRESENTATION = GALAXY_CONNECTION_PRESENTATION;
var GALAXY_CALL_STATE_BEGIN = 'GALAXY_CALL_STATE_BEGIN';
exports.GALAXY_CALL_STATE_BEGIN = GALAXY_CALL_STATE_BEGIN;
var GALAXY_CALL_STATE_DISCONNECTED = 'GALAXY_CALL_STATE_DISCONNECTED';
exports.GALAXY_CALL_STATE_DISCONNECTED = GALAXY_CALL_STATE_DISCONNECTED;
var GALAXY_CALL_STATE_CALLING = 'GALAXY_CALL_STATE_CALLING';
exports.GALAXY_CALL_STATE_CALLING = GALAXY_CALL_STATE_CALLING;
var GALAXY_CALL_STATE_INCOMING = 'GALAXY_CALL_STATE_INCOMING';
exports.GALAXY_CALL_STATE_INCOMING = GALAXY_CALL_STATE_INCOMING;
var GALAXY_CALL_STATE_TRYING = 'GALAXY_CALL_STATE_TRYING';
exports.GALAXY_CALL_STATE_TRYING = GALAXY_CALL_STATE_TRYING;
var GALAXY_CALL_STATE_RINGING = 'GALAXY_CALL_STATE_RINGING';
exports.GALAXY_CALL_STATE_RINGING = GALAXY_CALL_STATE_RINGING;
var GALAXY_CALL_STATE_ANSWERING = 'GALAXY_CALL_STATE_ANSWERING';
exports.GALAXY_CALL_STATE_ANSWERING = GALAXY_CALL_STATE_ANSWERING;
var GALAXY_CALL_STATE_CONNECTED = 'GALAXY_CALL_STATE_CONNECTED';
exports.GALAXY_CALL_STATE_CONNECTED = GALAXY_CALL_STATE_CONNECTED;
var GALAXY_ERROR_UPDATE = 'GALAXY_ERROR_UPDATE';
exports.GALAXY_ERROR_UPDATE = GALAXY_ERROR_UPDATE;
var GALAXY_REASON_DEFAULT = null;
exports.GALAXY_REASON_DEFAULT = GALAXY_REASON_DEFAULT;
var GALAXY_REASON_NOT_IN_CALL = 'notInCall';
exports.GALAXY_REASON_NOT_IN_CALL = GALAXY_REASON_NOT_IN_CALL;
var GALAXY_REASON_INVALID_CAPABILITY = 'GALAXY_REASON_INVALID_CAPABILITY';
exports.GALAXY_REASON_INVALID_CAPABILITY = GALAXY_REASON_INVALID_CAPABILITY;
var GALAXY_REASON_BAD_INITIAL_DIAL_STATE = 'badInitialDialState';
exports.GALAXY_REASON_BAD_INITIAL_DIAL_STATE = GALAXY_REASON_BAD_INITIAL_DIAL_STATE;
var GALAXY_REASON_CANCELED = 'cancelled';
exports.GALAXY_REASON_CANCELED = GALAXY_REASON_CANCELED;
var GALAXY_REASON_CLIENT_EXCEPTION = 'clientException';
exports.GALAXY_REASON_CLIENT_EXCEPTION = GALAXY_REASON_CLIENT_EXCEPTION;
var GALAXY_REASON_HANGUP = 'userHangup';
exports.GALAXY_REASON_HANGUP = GALAXY_REASON_HANGUP;
var GALAXY_REASON_HUNGUP = 'userHungup';
exports.GALAXY_REASON_HUNGUP = GALAXY_REASON_HUNGUP;
var GALAXY_REASON_NETWORK_ERROR = 'networkError';
exports.GALAXY_REASON_NETWORK_ERROR = GALAXY_REASON_NETWORK_ERROR;
var GALAXY_REASON_BUSY = 'busy';
exports.GALAXY_REASON_BUSY = GALAXY_REASON_BUSY;
var GALAXY_REASON_REJECTED = 'rejected';
exports.GALAXY_REASON_REJECTED = GALAXY_REASON_REJECTED;
var GALAXY_REASON_DO_NOT_DISTURB = 'doNotDisturb';
exports.GALAXY_REASON_DO_NOT_DISTURB = GALAXY_REASON_DO_NOT_DISTURB;
var GALAXY_REASON_NO_ANSWER = 'noAnswer';
exports.GALAXY_REASON_NO_ANSWER = GALAXY_REASON_NO_ANSWER;
var GALAXY_REASON_NO_MEDIA = 'noMedia';
exports.GALAXY_REASON_NO_MEDIA = GALAXY_REASON_NO_MEDIA;
var GALAXY_REASON_TIMED_OUT = 'timedOut';
exports.GALAXY_REASON_TIMED_OUT = GALAXY_REASON_TIMED_OUT;
var GALAXY_REASON_UNREACHABLE = 'unreachable';
exports.GALAXY_REASON_UNREACHABLE = GALAXY_REASON_UNREACHABLE;
var GALAXY_REASON_USER_NOT_FOUND = 'userNotFound';
exports.GALAXY_REASON_USER_NOT_FOUND = GALAXY_REASON_USER_NOT_FOUND;
var GALAXY_REASON_SERVER_ERROR = 'serverError';
exports.GALAXY_REASON_SERVER_ERROR = GALAXY_REASON_SERVER_ERROR;
var GALAXY_REASON_PRESENTATION_STOP = 'presentationStop';
exports.GALAXY_REASON_PRESENTATION_STOP = GALAXY_REASON_PRESENTATION_STOP;
var GALAXY_REASON_PRESENTATION_SEND = 'presentationSend';
exports.GALAXY_REASON_PRESENTATION_SEND = GALAXY_REASON_PRESENTATION_SEND;
var GALAXY_REASON_WAMP_DISCONNECTED = 'GALAXY_REASON_WAMP_DISCONNECTED';
exports.GALAXY_REASON_WAMP_DISCONNECTED = GALAXY_REASON_WAMP_DISCONNECTED;
var GALAXY_REASON_ICE_RESTART = 'iceRestart';
exports.GALAXY_REASON_ICE_RESTART = GALAXY_REASON_ICE_RESTART;
var GALAXY_REASON_ICE_RESTART_DONE = 'iceRestartDone';
exports.GALAXY_REASON_ICE_RESTART_DONE = GALAXY_REASON_ICE_RESTART_DONE;
var GALAXY_REASON_PRESENTATION_RECEIVE = 'presentationRecv';
exports.GALAXY_REASON_PRESENTATION_RECEIVE = GALAXY_REASON_PRESENTATION_RECEIVE;
var GALAXY_REASON_REDIRECT_IVR = 'redirectIVR';
exports.GALAXY_REASON_REDIRECT_IVR = GALAXY_REASON_REDIRECT_IVR;
var GALAXY_REASON_PARTICIPANT_EJECTED = 'participantEjected';
exports.GALAXY_REASON_PARTICIPANT_EJECTED = GALAXY_REASON_PARTICIPANT_EJECTED;
var GALAXY_REASON_PRESENTATION_TOKEN_DENIED = 'GALAXY_REASON_PRESENTATION_TOKEN_DENIED';
exports.GALAXY_REASON_PRESENTATION_TOKEN_DENIED = GALAXY_REASON_PRESENTATION_TOKEN_DENIED;
var GALAXY_REASON_SDP_UPDATE = 'GALAXY_REASON_SDP_UPDATE';
exports.GALAXY_REASON_SDP_UPDATE = GALAXY_REASON_SDP_UPDATE;
var GALAXY_REASON_SDP_DONE = 'GALAXY_REASON_SDP_DONE';
exports.GALAXY_REASON_SDP_DONE = GALAXY_REASON_SDP_DONE;
var GALAXY_REASON_DATA_CHANNEL = 'GALAXY_REASON_DATA_CHANNEL';
exports.GALAXY_REASON_DATA_CHANNEL = GALAXY_REASON_DATA_CHANNEL;
var GALAXY_REASON_VIDEO_MUTE_UPDATE = 'GALAXY_REASON_VIDEO_MUTE_UPDATE';
exports.GALAXY_REASON_VIDEO_MUTE_UPDATE = GALAXY_REASON_VIDEO_MUTE_UPDATE;
var GALAXY_REASON_VIDEO_UNMUTE_UPDATE = 'GALAXY_REASON_VIDEO_UNMUTE_UPDATE';
exports.GALAXY_REASON_VIDEO_UNMUTE_UPDATE = GALAXY_REASON_VIDEO_UNMUTE_UPDATE;
var GALAXY_REASON_VIDEO_MUTE_DONE = 'GALAXY_REASON_VIDEO_MUTE_DONE';
exports.GALAXY_REASON_VIDEO_MUTE_DONE = GALAXY_REASON_VIDEO_MUTE_DONE;
var GALAXY_REASON_VIDEO_BANDWIDTH_UPDATE = 'GALAXY_REASON_VIDEO_BANDWIDTH_UPDATE';
exports.GALAXY_REASON_VIDEO_BANDWIDTH_UPDATE = GALAXY_REASON_VIDEO_BANDWIDTH_UPDATE;
var GALAXY_ERROR_DEFAULT = 'defaultFail';
exports.GALAXY_ERROR_DEFAULT = GALAXY_ERROR_DEFAULT;
var GALAXY_ERROR_TIMEOUT = 'Client Side Timeout: No Server Response';
exports.GALAXY_ERROR_TIMEOUT = GALAXY_ERROR_TIMEOUT;
var GALAXY_PASSTHROUGH_FECC = 'FECC';
exports.GALAXY_PASSTHROUGH_FECC = GALAXY_PASSTHROUGH_FECC;
var WEBRTC_SDP_TYPE_OFFER = 'offer';
exports.WEBRTC_SDP_TYPE_OFFER = WEBRTC_SDP_TYPE_OFFER;
var WEBRTC_SDP_TYPE_ANSWER = 'answer';
exports.WEBRTC_SDP_TYPE_ANSWER = WEBRTC_SDP_TYPE_ANSWER;
var WEBRTC_SDP_SEMANTICS_PLAN_B = 'plan-b';
exports.WEBRTC_SDP_SEMANTICS_PLAN_B = WEBRTC_SDP_SEMANTICS_PLAN_B;
var GALAXY_API_VERSION = 2;
exports.GALAXY_API_VERSION = GALAXY_API_VERSION;
var GALAXY_API_VERSION_V3 = 3;
exports.GALAXY_API_VERSION_V3 = GALAXY_API_VERSION_V3;
var GALAXY_PRESENTATION_START_OFFER_PRIORITY = 0x800000;
exports.GALAXY_PRESENTATION_START_OFFER_PRIORITY = GALAXY_PRESENTATION_START_OFFER_PRIORITY;
var GALAXY_PRESENTATION_STOP_OFFER_PRIORITY = 0x400000;
exports.GALAXY_PRESENTATION_STOP_OFFER_PRIORITY = GALAXY_PRESENTATION_STOP_OFFER_PRIORITY;
var GALAXY_OFFER_PRIORITY_MAX = 0x10000;
exports.GALAXY_OFFER_PRIORITY_MAX = GALAXY_OFFER_PRIORITY_MAX;
var GALAXY_ACTION_ON_UPDATE_SDP_OFFER = 'GALAXY_ACTION_ON_UPDATE_SDP_OFFER';
exports.GALAXY_ACTION_ON_UPDATE_SDP_OFFER = GALAXY_ACTION_ON_UPDATE_SDP_OFFER;
var GALAXY_ACTION_ON_UPDATE_SDP_ANSWER = 'GALAXY_ACTION_ON_UPDATE_SDP_ANSWER';
exports.GALAXY_ACTION_ON_UPDATE_SDP_ANSWER = GALAXY_ACTION_ON_UPDATE_SDP_ANSWER;
var GALAXY_ACTION_BEGIN_PRESENTATION = 'GALAXY_ACTION_BEGIN_PRESENTATION';
exports.GALAXY_ACTION_BEGIN_PRESENTATION = GALAXY_ACTION_BEGIN_PRESENTATION;
var GALAXY_ACTION_PRESENTATION_FLOOR_GRANTED = 'GALAXY_ACTION_PRESENTATION_FLOOR_GRANTED';
exports.GALAXY_ACTION_PRESENTATION_FLOOR_GRANTED = GALAXY_ACTION_PRESENTATION_FLOOR_GRANTED;
var GALAXY_ACTION_PRESENTATION_FLOOR_RELEASED = 'GALAXY_ACTION_PRESENTATION_FLOOR_RELEASED';
exports.GALAXY_ACTION_PRESENTATION_FLOOR_RELEASED = GALAXY_ACTION_PRESENTATION_FLOOR_RELEASED;
var GALAXY_ACTION_PRESENTATION_ANSWER = 'GALAXY_ACTION_PRESENTATION_ANSWER';
exports.GALAXY_ACTION_PRESENTATION_ANSWER = GALAXY_ACTION_PRESENTATION_ANSWER;
var GALAXY_ACTION_PRESENTATION_SUCCESS = 'GALAXY_ACTION_PRESENTATION_SUCCESS';
exports.GALAXY_ACTION_PRESENTATION_SUCCESS = GALAXY_ACTION_PRESENTATION_SUCCESS;
var GALAXY_ACTION_PRESENTATION_FAIL = 'GALAXY_ACTION_PRESENTATION_FAIL';
exports.GALAXY_ACTION_PRESENTATION_FAIL = GALAXY_ACTION_PRESENTATION_FAIL;
var GALAXY_ACTION_UPDATE_PRESENTATION_TRACKID = 'GALAXY_ACTION_UPDATE_PRESENTATION_TRACKID';
exports.GALAXY_ACTION_UPDATE_PRESENTATION_TRACKID = GALAXY_ACTION_UPDATE_PRESENTATION_TRACKID;
var GALAXY_ACTION_STOP_PRESENTATION = 'GALAXY_ACTION_STOP_PRESENTATION';
exports.GALAXY_ACTION_STOP_PRESENTATION = GALAXY_ACTION_STOP_PRESENTATION;
var GALAXY_ACTION_TX_STOPPED_PRESENTATION = 'GALAXY_ACTION_TX_STOPPED_PRESENTATION';
exports.GALAXY_ACTION_TX_STOPPED_PRESENTATION = GALAXY_ACTION_TX_STOPPED_PRESENTATION;
var GALAXY_ACTION_RX_STOPPED_PRESENTATION = 'GALAXY_ACTION_RX_STOPPED_PRESENTATION';
exports.GALAXY_ACTION_RX_STOPPED_PRESENTATION = GALAXY_ACTION_RX_STOPPED_PRESENTATION;
var GALAXY_ACTION_AWAIT_PRESENTATION_ANSWER = 'GALAXY_ACTION_AWAIT_PRESENTATION_ANSWER';
exports.GALAXY_ACTION_AWAIT_PRESENTATION_ANSWER = GALAXY_ACTION_AWAIT_PRESENTATION_ANSWER;
var GALAXY_ACTION_STOP_AWAIT_PRESENTATION_ANSWER = 'GALAXY_ACTION_STOP_AWAIT_PRESENTATION_ANSWER';
exports.GALAXY_ACTION_STOP_AWAIT_PRESENTATION_ANSWER = GALAXY_ACTION_STOP_AWAIT_PRESENTATION_ANSWER;
var GALAXY_ACTION_UPDATE_PRIMARY_SOURCE = 'GALAXY_ACTION_UPDATE_PRIMARY_SOURCE';
exports.GALAXY_ACTION_UPDATE_PRIMARY_SOURCE = GALAXY_ACTION_UPDATE_PRIMARY_SOURCE;
var GALAXY_ACTION_AWAIT_PRESENTATION_TIMEOUT = 30000;
exports.GALAXY_ACTION_AWAIT_PRESENTATION_TIMEOUT = GALAXY_ACTION_AWAIT_PRESENTATION_TIMEOUT;
var GALAXY_PRESENTATION_STATE_TX_STARTING = 'GALAXY_PRESENTATION_STATE_TX_STARTING';
exports.GALAXY_PRESENTATION_STATE_TX_STARTING = GALAXY_PRESENTATION_STATE_TX_STARTING;
var GALAXY_PRESENTATION_STATE_TX_STARTED = 'GALAXY_PRESENTATION_STATE_TX_STARTED';
exports.GALAXY_PRESENTATION_STATE_TX_STARTED = GALAXY_PRESENTATION_STATE_TX_STARTED;
var GALAXY_PRESENTATION_STATE_TX_STOPPING = 'GALAXY_PRESENTATION_STATE_TX_STOPPING';
exports.GALAXY_PRESENTATION_STATE_TX_STOPPING = GALAXY_PRESENTATION_STATE_TX_STOPPING;
var GALAXY_PRESENTATION_STATE_TX_STOPPED = 'GALAXY_PRESENTATION_STATE_TX_STOPPED';
exports.GALAXY_PRESENTATION_STATE_TX_STOPPED = GALAXY_PRESENTATION_STATE_TX_STOPPED;
var GALAXY_PRESENTATION_STATE_RX_STARTING = 'GALAXY_PRESENTATION_STATE_RX_STARTING';
exports.GALAXY_PRESENTATION_STATE_RX_STARTING = GALAXY_PRESENTATION_STATE_RX_STARTING;
var GALAXY_PRESENTATION_STATE_RX_STARTED = 'GALAXY_PRESENTATION_STATE_RX_STARTED';
exports.GALAXY_PRESENTATION_STATE_RX_STARTED = GALAXY_PRESENTATION_STATE_RX_STARTED;
var GALAXY_PRESENTATION_STATE_RX_STOPPING = 'GALAXY_PRESENTATION_STATE_RX_STOPPING';
exports.GALAXY_PRESENTATION_STATE_RX_STOPPING = GALAXY_PRESENTATION_STATE_RX_STOPPING;
var GALAXY_PRESENTATION_STATE_STOPPED = 'GALAXY_PRESENTATION_STATE_STOPPED';
exports.GALAXY_PRESENTATION_STATE_STOPPED = GALAXY_PRESENTATION_STATE_STOPPED;
var GALAXY_RECORDING_STATE_STOPPED = 'stopped';
exports.GALAXY_RECORDING_STATE_STOPPED = GALAXY_RECORDING_STATE_STOPPED;
var GALAXY_RECORDING_STATE_STARTING = 'starting';
exports.GALAXY_RECORDING_STATE_STARTING = GALAXY_RECORDING_STATE_STARTING;
var GALAXY_RECORDING_STATE_STARTED = 'started';
exports.GALAXY_RECORDING_STATE_STARTED = GALAXY_RECORDING_STATE_STARTED;
var GALAXY_RECORDING_STATE_STOPPING = 'stopping';
exports.GALAXY_RECORDING_STATE_STOPPING = GALAXY_RECORDING_STATE_STOPPING;
var GALAXY_EVENT_CREATE_OFFER = 'createOffer';
exports.GALAXY_EVENT_CREATE_OFFER = GALAXY_EVENT_CREATE_OFFER;
var GALAXY_EVENT_IN_CALL_OFFER = 'inCallOffer';
exports.GALAXY_EVENT_IN_CALL_OFFER = GALAXY_EVENT_IN_CALL_OFFER;
var GALAXY_EVENT_OFFER_ANSWERED = 'answered';
exports.GALAXY_EVENT_OFFER_ANSWERED = GALAXY_EVENT_OFFER_ANSWERED;
var GALAXY_EVENT_TRICKLE_ICE = 'iceCandidate';
exports.GALAXY_EVENT_TRICKLE_ICE = GALAXY_EVENT_TRICKLE_ICE;
var GALAXY_COMMAND_TRICKLE_ICE = 'iceCandidate';
exports.GALAXY_COMMAND_TRICKLE_ICE = GALAXY_COMMAND_TRICKLE_ICE;
var GALAXY_ACTION_TRICKLE_ICE = 'GALAXY_ACTION_TRICKLE_ICE';
exports.GALAXY_ACTION_TRICKLE_ICE = GALAXY_ACTION_TRICKLE_ICE;
var GALAXY_COMMAND_OFFER_CREATED = 'offerCreated';
exports.GALAXY_COMMAND_OFFER_CREATED = GALAXY_COMMAND_OFFER_CREATED;
var GALAXY_COMMAND_IN_CALL_ANSWER = 'inCallAnswer';
exports.GALAXY_COMMAND_IN_CALL_ANSWER = GALAXY_COMMAND_IN_CALL_ANSWER;
var GALAXY_ACTION_CREATE_OFFER = 'GALAXY_ACTION_CREATE_OFFER';
exports.GALAXY_ACTION_CREATE_OFFER = GALAXY_ACTION_CREATE_OFFER;
var GALAXY_ACTION_IN_CALL_OFFER = 'GALAXY_ACTION_IN_CALL_OFFER';
exports.GALAXY_ACTION_IN_CALL_OFFER = GALAXY_ACTION_IN_CALL_OFFER;
var GALAXY_ACTION_OFFER_ANSWERED = 'GALAXY_ACTION_OFFER_ANSWERED';
exports.GALAXY_ACTION_OFFER_ANSWERED = GALAXY_ACTION_OFFER_ANSWERED;
var GALAXY_ACTION_UPDATE_SDP_SUCCESS = 'GALAXY_ACTION_UPDATE_SDP_SUCCESS';
exports.GALAXY_ACTION_UPDATE_SDP_SUCCESS = GALAXY_ACTION_UPDATE_SDP_SUCCESS;
var GALAXY_ACTION_UPDATE_SDP_FAILURE = 'GALAXY_ACTION_UPDATE_SDP_FAILURE';
exports.GALAXY_ACTION_UPDATE_SDP_FAILURE = GALAXY_ACTION_UPDATE_SDP_FAILURE;
var GALAXY_COMMAND_PRESENTATION_TOKEN_REQUEST = 'presentationTokenRequest';
exports.GALAXY_COMMAND_PRESENTATION_TOKEN_REQUEST = GALAXY_COMMAND_PRESENTATION_TOKEN_REQUEST;
var GALAXY_EVENT_PRESENTATION_TOKEN_GRANTED = 'presentationTokenGranted';
exports.GALAXY_EVENT_PRESENTATION_TOKEN_GRANTED = GALAXY_EVENT_PRESENTATION_TOKEN_GRANTED;
var GALAXY_EVENT_PRESENTATION_TOKEN_DENIED = 'presentationTokenDenied';
exports.GALAXY_EVENT_PRESENTATION_TOKEN_DENIED = GALAXY_EVENT_PRESENTATION_TOKEN_DENIED;
var GALAXY_EVENT_PRESENTATION_TOKEN_REVOKED = 'presentationTokenRevoked';
exports.GALAXY_EVENT_PRESENTATION_TOKEN_REVOKED = GALAXY_EVENT_PRESENTATION_TOKEN_REVOKED;
var GALAXY_ACTION_PRESENTATION_TOKEN_REQUEST = 'GALAXY_ACTION_PRESENTATION_TOKEN_REQUEST';
exports.GALAXY_ACTION_PRESENTATION_TOKEN_REQUEST = GALAXY_ACTION_PRESENTATION_TOKEN_REQUEST;
var GALAXY_ACTION_PRESENTATION_TOKEN_GRANTED = 'GALAXY_ACTION_PRESENTATION_TOKEN_GRANTED';
exports.GALAXY_ACTION_PRESENTATION_TOKEN_GRANTED = GALAXY_ACTION_PRESENTATION_TOKEN_GRANTED;
var GALAXY_ACTION_PRESENTATION_TOKEN_DENIED = 'GALAXY_ACTION_PRESENTATION_TOKEN_DENIED';
exports.GALAXY_ACTION_PRESENTATION_TOKEN_DENIED = GALAXY_ACTION_PRESENTATION_TOKEN_DENIED;
var GALAXY_ACTION_PRESENTATION_TOKEN_REVOKED = 'GALAXY_ACTION_PRESENTATION_TOKEN_REVOKED';
exports.GALAXY_ACTION_PRESENTATION_TOKEN_REVOKED = GALAXY_ACTION_PRESENTATION_TOKEN_REVOKED;
var GALAXY_ACTION_LOCAL_PRESENTATION_STOPPED = 'GALAXY_ACTION_LOCAL_PRESENTATION_STOPPED';
exports.GALAXY_ACTION_LOCAL_PRESENTATION_STOPPED = GALAXY_ACTION_LOCAL_PRESENTATION_STOPPED;
var GALAXY_ACTION_PRESENTATION_FAILED = 'GALAXY_ACTION_PRESENTATION_FAILED';
exports.GALAXY_ACTION_PRESENTATION_FAILED = GALAXY_ACTION_PRESENTATION_FAILED;
var GALAXY_COMMAND_UPDATE = 'update';
exports.GALAXY_COMMAND_UPDATE = GALAXY_COMMAND_UPDATE;
var GALAXY_ACTION_UPDATE = 'GALAXY_ACTION_COMMAND_UPDATE';
exports.GALAXY_ACTION_UPDATE = GALAXY_ACTION_UPDATE;
var GALAXY_EVENT_UPDATE = 'update';
exports.GALAXY_EVENT_UPDATE = GALAXY_EVENT_UPDATE;
var GALAXY_EVENT_PASSTHROUGH = 'passThrough';
exports.GALAXY_EVENT_PASSTHROUGH = GALAXY_EVENT_PASSTHROUGH;
var GALAXY_COMMAND_PRESENTATION_TOKEN_RELEASE = 'presentationTokenRelease';
exports.GALAXY_COMMAND_PRESENTATION_TOKEN_RELEASE = GALAXY_COMMAND_PRESENTATION_TOKEN_RELEASE;
var GALAXY_ACTION_PRESENTATION_TOKEN_RELEASE = 'GALAXY_ACTION_PRESENTATION_TOKEN_RELEASE';
exports.GALAXY_ACTION_PRESENTATION_TOKEN_RELEASE = GALAXY_ACTION_PRESENTATION_TOKEN_RELEASE;
var GALAXY_ACTION_INCOMING_PRESENTATION = 'GALAXY_ACTION_INCOMING_PRESENTATION';
exports.GALAXY_ACTION_INCOMING_PRESENTATION = GALAXY_ACTION_INCOMING_PRESENTATION;
var GALAXY_ACTION_PRESENTATION_CONNECTED = 'GALAXY_ACTION_PRESENTATION_CONNECTED';
exports.GALAXY_ACTION_PRESENTATION_CONNECTED = GALAXY_ACTION_PRESENTATION_CONNECTED;
var PRESENTATION_OFFER = 'PRESENTATION_OFFER';
exports.PRESENTATION_OFFER = PRESENTATION_OFFER;
var END_PRESENTATION_OFFER = 'END_PRESENTATION_OFFER';
exports.END_PRESENTATION_OFFER = END_PRESENTATION_OFFER;
var VIDEO_MUTE_OFFER = 'VIDEO_MUTE_OFFER';
exports.VIDEO_MUTE_OFFER = VIDEO_MUTE_OFFER;
var CHANGE_VIDEO_SOURCE_OFFER = 'CHANGE_VIDEO_SOURCE_OFFER';
exports.CHANGE_VIDEO_SOURCE_OFFER = CHANGE_VIDEO_SOURCE_OFFER;
var GALAXY_ACTION_ICE_STATE_UPDATED = 'GALAXY_ACTION_ICE_STATE_UPDATED';
exports.GALAXY_ACTION_ICE_STATE_UPDATED = GALAXY_ACTION_ICE_STATE_UPDATED;
var GALAXY_ICE_STATE_CLOSED = 'closed';
exports.GALAXY_ICE_STATE_CLOSED = GALAXY_ICE_STATE_CLOSED;
var GALAXY_ICE_STATE_CONNECTED = 'connected';
exports.GALAXY_ICE_STATE_CONNECTED = GALAXY_ICE_STATE_CONNECTED;
var GALAXY_ICE_STATE_DISCONNECTED = 'disconnected';
exports.GALAXY_ICE_STATE_DISCONNECTED = GALAXY_ICE_STATE_DISCONNECTED;
var GALAXY_ICE_STATE_FAILED = 'failed';
exports.GALAXY_ICE_STATE_FAILED = GALAXY_ICE_STATE_FAILED;
var GALAXY_ICE_STATE_COMPLETED = 'completed';
exports.GALAXY_ICE_STATE_COMPLETED = GALAXY_ICE_STATE_COMPLETED;
var GALAXY_MAX_ICE_RETRIES = 1;
exports.GALAXY_MAX_ICE_RETRIES = GALAXY_MAX_ICE_RETRIES;
var GALAXY_PC_SIGNALING_STATE_STABLE = 'stable';
exports.GALAXY_PC_SIGNALING_STATE_STABLE = GALAXY_PC_SIGNALING_STATE_STABLE;
var ICE_RESTART_OFFER = 'ICE_RESTART_OFFER';
exports.ICE_RESTART_OFFER = ICE_RESTART_OFFER;
var GALAXY_ACTION_TOGGLE_VIDEO_MUTE = 'GALAXY_ACTION_TOGGLE_VIDEO_MUTE';
exports.GALAXY_ACTION_TOGGLE_VIDEO_MUTE = GALAXY_ACTION_TOGGLE_VIDEO_MUTE;
var GALAXY_ACTION_UPDATE_SDP_ANSWERED = 'GALAXY_ACTION_UPDATE_SDP_ANSWERED';
exports.GALAXY_ACTION_UPDATE_SDP_ANSWERED = GALAXY_ACTION_UPDATE_SDP_ANSWERED;
var GALAXY_ACTION_CHANGE_LAYOUT_RESPONSE = 'GALAXY_ACTION_CHANGE_LAYOUT_RESPONSE';
exports.GALAXY_ACTION_CHANGE_LAYOUT_RESPONSE = GALAXY_ACTION_CHANGE_LAYOUT_RESPONSE;
var GALAXY_DEFAULT_CALL_BANDWIDTH_KBPS = 2048; // In Kbps

exports.GALAXY_DEFAULT_CALL_BANDWIDTH_KBPS = GALAXY_DEFAULT_CALL_BANDWIDTH_KBPS;
var GALAXY_DEFAULT_H264_BANDWIDTH_KBPS = 2048;
exports.GALAXY_DEFAULT_H264_BANDWIDTH_KBPS = GALAXY_DEFAULT_H264_BANDWIDTH_KBPS;
var GALAXY_DEFAULT_PRESENTATION_BW_PERCENTAGE = 0.5; //50%

exports.GALAXY_DEFAULT_PRESENTATION_BW_PERCENTAGE = GALAXY_DEFAULT_PRESENTATION_BW_PERCENTAGE;
var GALAXY_OFFER_TIMER = 30 * 1000;
exports.GALAXY_OFFER_TIMER = GALAXY_OFFER_TIMER;
var GALAXY_REASON_REPLACE_CALL = 'replaceCall'; // "Raise Hand" feature

exports.GALAXY_REASON_REPLACE_CALL = GALAXY_REASON_REPLACE_CALL;
var LOWER_HAND_REQUEST = 'LOWER_HAND_REQUEST';
exports.LOWER_HAND_REQUEST = LOWER_HAND_REQUEST;
var LOWER_HAND_SUCCESS = 'LOWER_HAND_SUCCESS';
exports.LOWER_HAND_SUCCESS = LOWER_HAND_SUCCESS;
var LOWER_HAND_FAILURE = 'LOWER_HAND_FAILURE ';
exports.LOWER_HAND_FAILURE = LOWER_HAND_FAILURE;
var SELF_RAISE_HAND_REQUEST = 'SELF_RAISE_HAND_REQUEST';
exports.SELF_RAISE_HAND_REQUEST = SELF_RAISE_HAND_REQUEST;
var SELF_RAISE_HAND_SUCCESS = 'SELF_RAISE_HAND_SUCCESS';
exports.SELF_RAISE_HAND_SUCCESS = SELF_RAISE_HAND_SUCCESS;
var SELF_RAISE_HAND_FAILURE = 'SELF_RAISE_HAND_FAILURE ';
exports.SELF_RAISE_HAND_FAILURE = SELF_RAISE_HAND_FAILURE;
var SELF_LOWER_HAND_REQUEST = 'SELF_LOWER_HAND_REQUEST';
exports.SELF_LOWER_HAND_REQUEST = SELF_LOWER_HAND_REQUEST;
var SELF_LOWER_HAND_SUCCESS = 'SELF_LOWER_HAND_SUCCESS';
exports.SELF_LOWER_HAND_SUCCESS = SELF_LOWER_HAND_SUCCESS;
var SELF_LOWER_HAND_FAILURE = 'SELF_LOWER_HAND_FAILURE ';
exports.SELF_LOWER_HAND_FAILURE = SELF_LOWER_HAND_FAILURE;
var LOWER_ALL_HANDS_REQUEST = 'LOWER_ALL_HANDS_REQUEST';
exports.LOWER_ALL_HANDS_REQUEST = LOWER_ALL_HANDS_REQUEST;
var LOWER_ALL_HANDS_SUCCESS = 'LOWER_ALL_HANDS_SUCCESS';
exports.LOWER_ALL_HANDS_SUCCESS = LOWER_ALL_HANDS_SUCCESS;
var LOWER_ALL_HANDS_FAILURE = 'LOWER_ALL_HANDS_FAILURE ';
exports.LOWER_ALL_HANDS_FAILURE = LOWER_ALL_HANDS_FAILURE;
var GALAXY_COMMAND_RAISE_HAND = 'raiseHand';
exports.GALAXY_COMMAND_RAISE_HAND = GALAXY_COMMAND_RAISE_HAND;
var GALAXY_COMMAND_LOWER_HAND = 'lowerHand';
exports.GALAXY_COMMAND_LOWER_HAND = GALAXY_COMMAND_LOWER_HAND;
var GALAXY_COMMAND_LOWER_ALL_HANDS = 'lowerAllHands';
exports.GALAXY_COMMAND_LOWER_ALL_HANDS = GALAXY_COMMAND_LOWER_ALL_HANDS;
var GALAXY_EVENT_HAND_RAISED = 'handRaised';
exports.GALAXY_EVENT_HAND_RAISED = GALAXY_EVENT_HAND_RAISED;
var GALAXY_EVENT_HAND_LOWERED = 'lowerRaisedHand';
exports.GALAXY_EVENT_HAND_LOWERED = GALAXY_EVENT_HAND_LOWERED;
var GALAXY_EVENT_ALL_HANDS_LOWERED = 'lowerAllHands';
exports.GALAXY_EVENT_ALL_HANDS_LOWERED = GALAXY_EVENT_ALL_HANDS_LOWERED;
var GALAXY_ACTION_CONFERENCE_PARTICIPANT_HAND_RAISED = 'GALAXY_ACTION_CONFERENCE_PARTICIPANT_HAND_RAISED';
exports.GALAXY_ACTION_CONFERENCE_PARTICIPANT_HAND_RAISED = GALAXY_ACTION_CONFERENCE_PARTICIPANT_HAND_RAISED;
var GALAXY_ACTION_CONFERENCE_PARTICIPANT_HAND_LOWERED = 'GALAXY_ACTION_CONFERENCE_PARTICIPANT_HAND_LOWERED';
exports.GALAXY_ACTION_CONFERENCE_PARTICIPANT_HAND_LOWERED = GALAXY_ACTION_CONFERENCE_PARTICIPANT_HAND_LOWERED;
var GALAXY_ACTION_CONFERENCE_ALL_HANDS_LOWERED = 'GALAXY_ACTION_CONFERENCE_ALL_HANDS_LOWERED';
exports.GALAXY_ACTION_CONFERENCE_ALL_HANDS_LOWERED = GALAXY_ACTION_CONFERENCE_ALL_HANDS_LOWERED;
var HTTP_POST = 'POST';
exports.HTTP_POST = HTTP_POST;
var HTTP_GET = 'GET';
exports.HTTP_GET = HTTP_GET;
var HTTP_PUT = 'PUT';
exports.HTTP_PUT = HTTP_PUT;
var HTTP_DELETE = 'DELETE';
exports.HTTP_DELETE = HTTP_DELETE;
var CAN_ADD = 'canAdd';
exports.CAN_ADD = CAN_ADD;
var AWAIT_ACTION = 'AWAIT_ACTION';
exports.AWAIT_ACTION = AWAIT_ACTION;
var AWAIT_ACTION_TIMEOUT = 'AWAIT_ACTION_TIMEOUT';
exports.AWAIT_ACTION_TIMEOUT = AWAIT_ACTION_TIMEOUT;
var RESOLUTION_DOWNSCALE_THRESHOLD = 3;
exports.RESOLUTION_DOWNSCALE_THRESHOLD = RESOLUTION_DOWNSCALE_THRESHOLD;
var RESOLUTION_UPSCALE_THRESHOLD = 2;
exports.RESOLUTION_UPSCALE_THRESHOLD = RESOLUTION_UPSCALE_THRESHOLD;
var DOWNSCALE_HEIGHT = 540;
exports.DOWNSCALE_HEIGHT = DOWNSCALE_HEIGHT;
var DOWNSCALE_WIDTH = 960;
exports.DOWNSCALE_WIDTH = DOWNSCALE_WIDTH;
var GALAXY_SET_SCALED_RESOLUTION = 'GALAXY_SET_SCALED_RESOLUTION';
exports.GALAXY_SET_SCALED_RESOLUTION = GALAXY_SET_SCALED_RESOLUTION;
var GALAXY_RESET_SCALED_RESOLUTION = 'GALAXY_RESET_SCALED_RESOLUTION';
exports.GALAXY_RESET_SCALED_RESOLUTION = GALAXY_RESET_SCALED_RESOLUTION;
var INITIALIZE_SERVICES_REQUEST = 'INITIALIZE_SERVICES_REQUEST';
exports.INITIALIZE_SERVICES_REQUEST = INITIALIZE_SERVICES_REQUEST;
var INITIALIZE_SERVICES_SUCCESS = 'INITIALIZE_SERVICES_SUCCESS';
exports.INITIALIZE_SERVICES_SUCCESS = INITIALIZE_SERVICES_SUCCESS;
var INITIALIZE_SERVICES_FAILURE = 'INITIALIZE_SERVICES_FAILURE';
exports.INITIALIZE_SERVICES_FAILURE = INITIALIZE_SERVICES_FAILURE;
var SERVICE_STATUS_DISCONNECTED = 'DISCONNECTED';
exports.SERVICE_STATUS_DISCONNECTED = SERVICE_STATUS_DISCONNECTED;
var SERVICE_STATUS_CONNECTING = 'CONNECTING';
exports.SERVICE_STATUS_CONNECTING = SERVICE_STATUS_CONNECTING;
var SERVICE_STATUS_CONNECTED = 'CONNECTED';
exports.SERVICE_STATUS_CONNECTED = SERVICE_STATUS_CONNECTED;
var SERVICE_STATUS_VERIFYING = 'VERIFYING';
exports.SERVICE_STATUS_VERIFYING = SERVICE_STATUS_VERIFYING;
var GET_DEVICE_LOGIN_SUCCESS = 'GET_DEVICE_LOGIN_SUCCESS';
exports.GET_DEVICE_LOGIN_SUCCESS = GET_DEVICE_LOGIN_SUCCESS;
var WAMP_SUBSCRIPTION_LINKING_EVENT = 'WAMP_SUBSCRIPTION_LINKING_EVENT';
exports.WAMP_SUBSCRIPTION_LINKING_EVENT = WAMP_SUBSCRIPTION_LINKING_EVENT;
var GRAPHITE_EVENT_RECEIVED = 'GRAPHITE_EVENT_RECEIVED';
exports.GRAPHITE_EVENT_RECEIVED = GRAPHITE_EVENT_RECEIVED;
var GRAPHITE_TOPIC = 'ls.deviceMessaging';
exports.GRAPHITE_TOPIC = GRAPHITE_TOPIC;
var PAIRING_TOPIC = 'ls.pairing';
exports.PAIRING_TOPIC = PAIRING_TOPIC;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

module.exports = _interopRequireWildcard;

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscriber; });
/* unused harmony export SafeSubscriber */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var _util_isFunction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61);
/* harmony import */ var _Observer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(117);
/* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20);
/* harmony import */ var _internal_symbol_rxSubscriber__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41);
/* harmony import */ var _util_hostReportError__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77);
/** PURE_IMPORTS_START tslib,_util_isFunction,_Observer,_Subscription,_internal_symbol_rxSubscriber,_config,_util_hostReportError PURE_IMPORTS_END */







var Subscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"](Subscriber, _super);
    function Subscriber(destinationOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this.syncErrorValue = null;
        _this.syncErrorThrown = false;
        _this.syncErrorThrowable = false;
        _this.isStopped = false;
        switch (arguments.length) {
            case 0:
                _this.destination = _Observer__WEBPACK_IMPORTED_MODULE_2__[/* empty */ "a"];
                break;
            case 1:
                if (!destinationOrNext) {
                    _this.destination = _Observer__WEBPACK_IMPORTED_MODULE_2__[/* empty */ "a"];
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    if (destinationOrNext instanceof Subscriber) {
                        _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
                        _this.destination = destinationOrNext;
                        destinationOrNext.add(_this);
                    }
                    else {
                        _this.syncErrorThrowable = true;
                        _this.destination = new SafeSubscriber(_this, destinationOrNext);
                    }
                    break;
                }
            default:
                _this.syncErrorThrowable = true;
                _this.destination = new SafeSubscriber(_this, destinationOrNext, error, complete);
                break;
        }
        return _this;
    }
    Subscriber.prototype[_internal_symbol_rxSubscriber__WEBPACK_IMPORTED_MODULE_4__[/* rxSubscriber */ "a"]] = function () { return this; };
    Subscriber.create = function (next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    Subscriber.prototype.next = function (value) {
        if (!this.isStopped) {
            this._next(value);
        }
    };
    Subscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function () {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function () {
        this.destination.complete();
        this.unsubscribe();
    };
    Subscriber.prototype._unsubscribeAndRecycle = function () {
        var _parentOrParents = this._parentOrParents;
        this._parentOrParents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parentOrParents = _parentOrParents;
        return this;
    };
    return Subscriber;
}(_Subscription__WEBPACK_IMPORTED_MODULE_3__[/* Subscription */ "a"]));

var SafeSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"](SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this._parentSubscriber = _parentSubscriber;
        var next;
        var context = _this;
        if (Object(_util_isFunction__WEBPACK_IMPORTED_MODULE_1__[/* isFunction */ "a"])(observerOrNext)) {
            next = observerOrNext;
        }
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== _Observer__WEBPACK_IMPORTED_MODULE_2__[/* empty */ "a"]) {
                context = Object.create(observerOrNext);
                if (Object(_util_isFunction__WEBPACK_IMPORTED_MODULE_1__[/* isFunction */ "a"])(context.unsubscribe)) {
                    _this.add(context.unsubscribe.bind(context));
                }
                context.unsubscribe = _this.unsubscribe.bind(_this);
            }
        }
        _this._context = context;
        _this._next = next;
        _this._error = error;
        _this._complete = complete;
        return _this;
    }
    SafeSubscriber.prototype.next = function (value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!_config__WEBPACK_IMPORTED_MODULE_5__[/* config */ "a"].useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                this.__tryOrUnsub(this._next, value);
            }
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            var useDeprecatedSynchronousErrorHandling = _config__WEBPACK_IMPORTED_MODULE_5__[/* config */ "a"].useDeprecatedSynchronousErrorHandling;
            if (this._error) {
                if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            }
            else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                if (useDeprecatedSynchronousErrorHandling) {
                    throw err;
                }
                Object(_util_hostReportError__WEBPACK_IMPORTED_MODULE_6__[/* hostReportError */ "a"])(err);
            }
            else {
                if (useDeprecatedSynchronousErrorHandling) {
                    _parentSubscriber.syncErrorValue = err;
                    _parentSubscriber.syncErrorThrown = true;
                }
                else {
                    Object(_util_hostReportError__WEBPACK_IMPORTED_MODULE_6__[/* hostReportError */ "a"])(err);
                }
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function () {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function () { return _this._complete.call(_this._context); };
                if (!_config__WEBPACK_IMPORTED_MODULE_5__[/* config */ "a"].useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            }
            else {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            this.unsubscribe();
            if (_config__WEBPACK_IMPORTED_MODULE_5__[/* config */ "a"].useDeprecatedSynchronousErrorHandling) {
                throw err;
            }
            else {
                Object(_util_hostReportError__WEBPACK_IMPORTED_MODULE_6__[/* hostReportError */ "a"])(err);
            }
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
        if (!_config__WEBPACK_IMPORTED_MODULE_5__[/* config */ "a"].useDeprecatedSynchronousErrorHandling) {
            throw new Error('bad call');
        }
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            if (_config__WEBPACK_IMPORTED_MODULE_5__[/* config */ "a"].useDeprecatedSynchronousErrorHandling) {
                parent.syncErrorValue = err;
                parent.syncErrorThrown = true;
                return true;
            }
            else {
                Object(_util_hostReportError__WEBPACK_IMPORTED_MODULE_6__[/* hostReportError */ "a"])(err);
                return true;
            }
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function () {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber));

//# sourceMappingURL=Subscriber.js.map


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addTypenameToDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return argumentsObjectFromField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return buildQueryFromSelectionSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return canUseWeakMap; });
/* unused harmony export checkDocument */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return cloneDeep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return createFragmentMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getDefaultValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getDirectiveInfoFromField; });
/* unused harmony export getDirectiveNames */
/* unused harmony export getDirectivesFromDocument */
/* unused harmony export getEnv */
/* unused harmony export getFragmentDefinition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getFragmentDefinitions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getFragmentQueryDocument; });
/* unused harmony export getInclusionDirectives */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getMainDefinition; });
/* unused harmony export getMutationDefinition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getOperationDefinition; });
/* unused harmony export getOperationDefinitionOrDie */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getOperationName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getQueryDefinition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getStoreKeyName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return graphQLResultHasError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return hasClientExports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return hasDirectives; });
/* unused harmony export isDevelopment */
/* unused harmony export isEnv */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return isField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return isIdValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return isInlineFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return isJsonValue; });
/* unused harmony export isNumberValue */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return isProduction; });
/* unused harmony export isScalarValue */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return isTest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return maybeDeepFreeze; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return mergeDeep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return mergeDeepArray; });
/* unused harmony export removeArgumentsFromDocument */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return removeClientSetsFromDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return removeConnectionDirectiveFromDocument; });
/* unused harmony export removeDirectivesFromDocument */
/* unused harmony export removeFragmentSpreadFromDocument */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return resultKeyNameFromField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return shouldInclude; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return storeKeyNameFromField; });
/* unused harmony export stripSymbols */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return toIdValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return tryFunctionOrLogError; });
/* unused harmony export valueFromNode */
/* unused harmony export valueToObjectRepresentation */
/* unused harmony export variablesInOperation */
/* unused harmony export warnOnceInDevelopment */
/* harmony import */ var graphql_language_visitor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49);
/* harmony import */ var graphql_language_visitor__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_language_visitor__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ts_invariant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
/* harmony import */ var fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(296);
/* harmony import */ var fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _wry_equality__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78);






function isScalarValue(value) {
    return ['StringValue', 'BooleanValue', 'EnumValue'].indexOf(value.kind) > -1;
}
function isNumberValue(value) {
    return ['IntValue', 'FloatValue'].indexOf(value.kind) > -1;
}
function isStringValue(value) {
    return value.kind === 'StringValue';
}
function isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function isIntValue(value) {
    return value.kind === 'IntValue';
}
function isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function isVariable(value) {
    return value.kind === 'Variable';
}
function isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function isListValue(value) {
    return value.kind === 'ListValue';
}
function isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function isNullValue(value) {
    return value.kind === 'NullValue';
}
function valueToObjectRepresentation(argObj, name, value, variables) {
    if (isIntValue(value) || isFloatValue(value)) {
        argObj[name.value] = Number(value.value);
    }
    else if (isBooleanValue(value) || isStringValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function (obj) {
            return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    }
    else if (isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    }
    else if (isListValue(value)) {
        argObj[name.value] = value.values.map(function (listValue) {
            var nestedArgArrayObj = {};
            valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
        });
    }
    else if (isEnumValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isNullValue(value)) {
        argObj[name.value] = null;
    }
    else {
        throw  true ? new ts_invariant__WEBPACK_IMPORTED_MODULE_1__[/* InvariantError */ "a"](17) : undefined;
    }
}
function storeKeyNameFromField(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function (directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) {
                directive.arguments.forEach(function (_a) {
                    var name = _a.name, value = _a.value;
                    return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
                });
            }
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj, name, value, variables);
        });
    }
    return getStoreKeyName(field.name.value, argObj, directivesObj);
}
var KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export',
];
function getStoreKeyName(fieldName, args, directives) {
    if (directives &&
        directives['connection'] &&
        directives['connection']['key']) {
        if (directives['connection']['filter'] &&
            directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter']
                ? directives['connection']['filter']
                : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function (key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        }
        else {
            return directives['connection']['key'];
        }
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_3___default()(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) {
        Object.keys(directives).forEach(function (key) {
            if (KNOWN_DIRECTIVES.indexOf(key) !== -1)
                return;
            if (directives[key] && Object.keys(directives[key]).length) {
                completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
            }
            else {
                completeFieldName += "@" + key;
            }
        });
    }
    return completeFieldName;
}
function argumentsObjectFromField(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function resultKeyNameFromField(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function isField(selection) {
    return selection.kind === 'Field';
}
function isInlineFragment(selection) {
    return selection.kind === 'InlineFragment';
}
function isIdValue(idObject) {
    return idObject &&
        idObject.type === 'id' &&
        typeof idObject.generated === 'boolean';
}
function toIdValue(idConfig, generated) {
    if (generated === void 0) { generated = false; }
    return Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __assign */ "a"])({ type: 'id', generated: generated }, (typeof idConfig === 'string'
        ? { id: idConfig, typename: undefined }
        : idConfig));
}
function isJsonValue(jsonObject) {
    return (jsonObject != null &&
        typeof jsonObject === 'object' &&
        jsonObject.type === 'json');
}
function defaultValueFromVariable(node) {
    throw  true ? new ts_invariant__WEBPACK_IMPORTED_MODULE_1__[/* InvariantError */ "a"](18) : undefined;
}
function valueFromNode(node, onVariable) {
    if (onVariable === void 0) { onVariable = defaultValueFromVariable; }
    switch (node.kind) {
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function (v) { return valueFromNode(v, onVariable); });
        case 'ObjectValue': {
            var value = {};
            for (var _i = 0, _a = node.fields; _i < _a.length; _i++) {
                var field = _a[_i];
                value[field.name.value] = valueFromNode(field.value, onVariable);
            }
            return value;
        }
        default:
            return node.value;
    }
}

function getDirectiveInfoFromField(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function (directive) {
            directiveObj_1[directive.name.value] = argumentsObjectFromField(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function shouldInclude(selection, variables) {
    if (variables === void 0) { variables = {}; }
    return getInclusionDirectives(selection.directives).every(function (_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
             true ? Object(ts_invariant__WEBPACK_IMPORTED_MODULE_1__[/* invariant */ "b"])(evaledValue !== void 0, 3) : undefined;
        }
        else {
            evaledValue = ifArgument.value.value;
        }
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function getDirectiveNames(doc) {
    var names = [];
    Object(graphql_language_visitor__WEBPACK_IMPORTED_MODULE_0__["visit"])(doc, {
        Directive: function (node) {
            names.push(node.name.value);
        },
    });
    return names;
}
function hasDirectives(names, doc) {
    return getDirectiveNames(doc).some(function (name) { return names.indexOf(name) > -1; });
}
function hasClientExports(document) {
    return (document &&
        hasDirectives(['client'], document) &&
        hasDirectives(['export'], document));
}
function isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function getInclusionDirectives(directives) {
    return directives ? directives.filter(isInclusionDirective).map(function (directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
         true ? Object(ts_invariant__WEBPACK_IMPORTED_MODULE_1__[/* invariant */ "b"])(directiveArguments && directiveArguments.length === 1, 4) : undefined;
        var ifArgument = directiveArguments[0];
         true ? Object(ts_invariant__WEBPACK_IMPORTED_MODULE_1__[/* invariant */ "b"])(ifArgument.name && ifArgument.name.value === 'if', 5) : undefined;
        var ifValue = ifArgument.value;
         true ? Object(ts_invariant__WEBPACK_IMPORTED_MODULE_1__[/* invariant */ "b"])(ifValue &&
            (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 6) : undefined;
        return { directive: directive, ifArgument: ifArgument };
    }) : [];
}

function getFragmentQueryDocument(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function (definition) {
        if (definition.kind === 'OperationDefinition') {
            throw  true ? new ts_invariant__WEBPACK_IMPORTED_MODULE_1__[/* InvariantError */ "a"](1) : undefined;
        }
        if (definition.kind === 'FragmentDefinition') {
            fragments.push(definition);
        }
    });
    if (typeof actualFragmentName === 'undefined') {
         true ? Object(ts_invariant__WEBPACK_IMPORTED_MODULE_1__[/* invariant */ "b"])(fragments.length === 1, 2) : undefined;
        actualFragmentName = fragments[0].name.value;
    }
    var query = Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __assign */ "a"])({}, document, { definitions: [
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName,
                            },
                        },
                    ],
                },
            }
        ].concat(document.definitions) });
    return query;
}

function assign(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    sources.forEach(function (source) {
        if (typeof source === 'undefined' || source === null) {
            return;
        }
        Object.keys(source).forEach(function (key) {
            target[key] = source[key];
        });
    });
    return target;
}

function getMutationDefinition(doc) {
    checkDocument(doc);
    var mutationDef = doc.definitions.filter(function (definition) {
        return definition.kind === 'OperationDefinition' &&
            definition.operation === 'mutation';
    })[0];
     true ? Object(ts_invariant__WEBPACK_IMPORTED_MODULE_1__[/* invariant */ "b"])(mutationDef, 7) : undefined;
    return mutationDef;
}
function checkDocument(doc) {
     true ? Object(ts_invariant__WEBPACK_IMPORTED_MODULE_1__[/* invariant */ "b"])(doc && doc.kind === 'Document', 8) : undefined;
    var operations = doc.definitions
        .filter(function (d) { return d.kind !== 'FragmentDefinition'; })
        .map(function (definition) {
        if (definition.kind !== 'OperationDefinition') {
            throw  true ? new ts_invariant__WEBPACK_IMPORTED_MODULE_1__[/* InvariantError */ "a"](9) : undefined;
        }
        return definition;
    });
     true ? Object(ts_invariant__WEBPACK_IMPORTED_MODULE_1__[/* invariant */ "b"])(operations.length <= 1, 10) : undefined;
    return doc;
}
function getOperationDefinition(doc) {
    checkDocument(doc);
    return doc.definitions.filter(function (definition) { return definition.kind === 'OperationDefinition'; })[0];
}
function getOperationDefinitionOrDie(document) {
    var def = getOperationDefinition(document);
     true ? Object(ts_invariant__WEBPACK_IMPORTED_MODULE_1__[/* invariant */ "b"])(def, 11) : undefined;
    return def;
}
function getOperationName(doc) {
    return (doc.definitions
        .filter(function (definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    })
        .map(function (x) { return x.name.value; })[0] || null);
}
function getFragmentDefinitions(doc) {
    return doc.definitions.filter(function (definition) { return definition.kind === 'FragmentDefinition'; });
}
function getQueryDefinition(doc) {
    var queryDef = getOperationDefinition(doc);
     true ? Object(ts_invariant__WEBPACK_IMPORTED_MODULE_1__[/* invariant */ "b"])(queryDef && queryDef.operation === 'query', 12) : undefined;
    return queryDef;
}
function getFragmentDefinition(doc) {
     true ? Object(ts_invariant__WEBPACK_IMPORTED_MODULE_1__[/* invariant */ "b"])(doc.kind === 'Document', 13) : undefined;
     true ? Object(ts_invariant__WEBPACK_IMPORTED_MODULE_1__[/* invariant */ "b"])(doc.definitions.length <= 1, 14) : undefined;
    var fragmentDef = doc.definitions[0];
     true ? Object(ts_invariant__WEBPACK_IMPORTED_MODULE_1__[/* invariant */ "b"])(fragmentDef.kind === 'FragmentDefinition', 15) : undefined;
    return fragmentDef;
}
function getMainDefinition(queryDoc) {
    checkDocument(queryDoc);
    var fragmentDefinition;
    for (var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++) {
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' ||
                operation === 'mutation' ||
                operation === 'subscription') {
                return definition;
            }
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) {
            fragmentDefinition = definition;
        }
    }
    if (fragmentDefinition) {
        return fragmentDefinition;
    }
    throw  true ? new ts_invariant__WEBPACK_IMPORTED_MODULE_1__[/* InvariantError */ "a"](16) : undefined;
}
function createFragmentMap(fragments) {
    if (fragments === void 0) { fragments = []; }
    var symTable = {};
    fragments.forEach(function (fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function getDefaultValues(definition) {
    if (definition &&
        definition.variableDefinitions &&
        definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions
            .filter(function (_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        })
            .map(function (_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            valueToObjectRepresentation(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return assign.apply(void 0, [{}].concat(defaultValues));
    }
    return {};
}
function variablesInOperation(operation) {
    var names = new Set();
    if (operation.variableDefinitions) {
        for (var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++) {
            var definition = _a[_i];
            names.add(definition.variable.name.value);
        }
    }
    return names;
}

function filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function (elem, i) {
        if (test.call(this, elem, i, array)) {
            array[target++] = elem;
        }
    }, context);
    array.length = target;
    return array;
}

var TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename',
    },
};
function isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function (selection) {
        return selection.kind === 'FragmentSpread' &&
            isEmpty(fragments[selection.name.value], fragments);
    });
}
function nullIfDocIsEmpty(doc) {
    return isEmpty(getOperationDefinition(doc) || getFragmentDefinition(doc), createFragmentMap(getFragmentDefinitions(doc)))
        ? null
        : doc;
}
function getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function (dir) {
            return (dir.name && dir.name === directive.name.value) ||
                (dir.test && dir.test(directive));
        });
    };
}
function removeDirectivesFromDocument(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = nullIfDocIsEmpty(Object(graphql_language_visitor__WEBPACK_IMPORTED_MODULE_0__["visit"])(doc, {
        Variable: {
            enter: function (node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') {
                    variablesInUse[node.name.value] = true;
                }
            },
        },
        Field: {
            enter: function (node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function (directive) { return directive.remove; });
                    if (shouldRemoveField &&
                        node.directives &&
                        node.directives.some(getDirectiveMatcher(directives))) {
                        if (node.arguments) {
                            node.arguments.forEach(function (arg) {
                                if (arg.value.kind === 'Variable') {
                                    variablesToRemove.push({
                                        name: arg.value.name.value,
                                    });
                                }
                            });
                        }
                        if (node.selectionSet) {
                            getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function (frag) {
                                fragmentSpreadsToRemove.push({
                                    name: frag.name.value,
                                });
                            });
                        }
                        return null;
                    }
                }
            },
        },
        FragmentSpread: {
            enter: function (node) {
                fragmentSpreadsInUse[node.name.value] = true;
            },
        },
        Directive: {
            enter: function (node) {
                if (getDirectiveMatcher(directives)(node)) {
                    return null;
                }
            },
        },
    }));
    if (modifiedDoc &&
        filterInPlace(variablesToRemove, function (v) { return !variablesInUse[v.name]; }).length) {
        modifiedDoc = removeArgumentsFromDocument(variablesToRemove, modifiedDoc);
    }
    if (modifiedDoc &&
        filterInPlace(fragmentSpreadsToRemove, function (fs) { return !fragmentSpreadsInUse[fs.name]; })
            .length) {
        modifiedDoc = removeFragmentSpreadFromDocument(fragmentSpreadsToRemove, modifiedDoc);
    }
    return modifiedDoc;
}
function addTypenameToDocument(doc) {
    return Object(graphql_language_visitor__WEBPACK_IMPORTED_MODULE_0__["visit"])(checkDocument(doc), {
        SelectionSet: {
            enter: function (node, _key, parent) {
                if (parent &&
                    parent.kind === 'OperationDefinition') {
                    return;
                }
                var selections = node.selections;
                if (!selections) {
                    return;
                }
                var skip = selections.some(function (selection) {
                    return (isField(selection) &&
                        (selection.name.value === '__typename' ||
                            selection.name.value.lastIndexOf('__', 0) === 0));
                });
                if (skip) {
                    return;
                }
                var field = parent;
                if (isField(field) &&
                    field.directives &&
                    field.directives.some(function (d) { return d.name.value === 'export'; })) {
                    return;
                }
                return Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __assign */ "a"])({}, node, { selections: selections.concat([TYPENAME_FIELD]) });
            },
        },
    });
}
var connectionRemoveConfig = {
    test: function (directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) {
            if (!directive.arguments ||
                !directive.arguments.some(function (arg) { return arg.name.value === 'key'; })) {
                 true || false;
            }
        }
        return willRemove;
    },
};
function removeConnectionDirectiveFromDocument(doc) {
    return removeDirectivesFromDocument([connectionRemoveConfig], checkDocument(doc));
}
function hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    return (selectionSet &&
        selectionSet.selections &&
        selectionSet.selections.some(function (selection) {
            return hasDirectivesInSelection(directives, selection, nestedCheck);
        }));
}
function hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    if (!isField(selection)) {
        return true;
    }
    if (!selection.directives) {
        return false;
    }
    return (selection.directives.some(getDirectiveMatcher(directives)) ||
        (nestedCheck &&
            hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck)));
}
function getDirectivesFromDocument(directives, doc) {
    checkDocument(doc);
    var parentPath;
    return nullIfDocIsEmpty(Object(graphql_language_visitor__WEBPACK_IMPORTED_MODULE_0__["visit"])(doc, {
        SelectionSet: {
            enter: function (node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath ||
                    currentPath === parentPath ||
                    !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function (selection) { return hasDirectivesInSelection(directives, selection); });
                        if (hasDirectivesInSelectionSet(directives, node, false)) {
                            parentPath = currentPath;
                        }
                        return Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __assign */ "a"])({}, node, { selections: selectionsWithDirectives });
                    }
                    else {
                        return null;
                    }
                }
            },
        },
    }));
}
function getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function (aConfig) {
            return argument.value &&
                argument.value.kind === 'Variable' &&
                argument.value.name &&
                (aConfig.name === argument.value.name.value ||
                    (aConfig.test && aConfig.test(argument)));
        });
    };
}
function removeArgumentsFromDocument(config, doc) {
    var argMatcher = getArgumentMatcher(config);
    return nullIfDocIsEmpty(Object(graphql_language_visitor__WEBPACK_IMPORTED_MODULE_0__["visit"])(doc, {
        OperationDefinition: {
            enter: function (node) {
                return Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __assign */ "a"])({}, node, { variableDefinitions: node.variableDefinitions.filter(function (varDef) {
                        return !config.some(function (arg) { return arg.name === varDef.variable.name.value; });
                    }) });
            },
        },
        Field: {
            enter: function (node) {
                var shouldRemoveField = config.some(function (argConfig) { return argConfig.remove; });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function (arg) {
                        if (argMatcher(arg)) {
                            argMatchCount_1 += 1;
                        }
                    });
                    if (argMatchCount_1 === 1) {
                        return null;
                    }
                }
            },
        },
        Argument: {
            enter: function (node) {
                if (argMatcher(node)) {
                    return null;
                }
            },
        },
    }));
}
function removeFragmentSpreadFromDocument(config, doc) {
    function enter(node) {
        if (config.some(function (def) { return def.name === node.name.value; })) {
            return null;
        }
    }
    return nullIfDocIsEmpty(Object(graphql_language_visitor__WEBPACK_IMPORTED_MODULE_0__["visit"])(doc, {
        FragmentSpread: { enter: enter },
        FragmentDefinition: { enter: enter },
    }));
}
function getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function (selection) {
        if ((isField(selection) || isInlineFragment(selection)) &&
            selection.selectionSet) {
            getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function (frag) { return allFragments.push(frag); });
        }
        else if (selection.kind === 'FragmentSpread') {
            allFragments.push(selection);
        }
    });
    return allFragments;
}
function buildQueryFromSelectionSet(document) {
    var definition = getMainDefinition(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') {
        return document;
    }
    var modifiedDoc = Object(graphql_language_visitor__WEBPACK_IMPORTED_MODULE_0__["visit"])(document, {
        OperationDefinition: {
            enter: function (node) {
                return Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __assign */ "a"])({}, node, { operation: 'query' });
            },
        },
    });
    return modifiedDoc;
}
function removeClientSetsFromDocument(document) {
    checkDocument(document);
    var modifiedDoc = removeDirectivesFromDocument([
        {
            test: function (directive) { return directive.name.value === 'client'; },
            remove: true,
        },
    ], document);
    if (modifiedDoc) {
        modifiedDoc = Object(graphql_language_visitor__WEBPACK_IMPORTED_MODULE_0__["visit"])(modifiedDoc, {
            FragmentDefinition: {
                enter: function (node) {
                    if (node.selectionSet) {
                        var isTypenameOnly = node.selectionSet.selections.every(function (selection) {
                            return isField(selection) && selection.name.value === '__typename';
                        });
                        if (isTypenameOnly) {
                            return null;
                        }
                    }
                },
            },
        });
    }
    return modifiedDoc;
}

var canUseWeakMap = typeof WeakMap === 'function' && !(typeof navigator === 'object' &&
    navigator.product === 'ReactNative');

var toString = Object.prototype.toString;
function cloneDeep(value) {
    return cloneDeepHelper(value, new Map());
}
function cloneDeepHelper(val, seen) {
    switch (toString.call(val)) {
        case "[object Array]": {
            if (seen.has(val))
                return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function (child, i) {
                copy_1[i] = cloneDeepHelper(child, seen);
            });
            return copy_1;
        }
        case "[object Object]": {
            if (seen.has(val))
                return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function (key) {
                copy_2[key] = cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        }
        default:
            return val;
    }
}

function getEnv() {
    if (typeof process !== 'undefined' && "production") {
        return "production";
    }
    return 'development';
}
function isEnv(env) {
    return getEnv() === env;
}
function isProduction() {
    return isEnv('production') === true;
}
function isDevelopment() {
    return isEnv('development') === true;
}
function isTest() {
    return isEnv('test') === true;
}

function tryFunctionOrLogError(f) {
    try {
        return f();
    }
    catch (e) {
        if (console.error) {
            console.error(e);
        }
    }
}
function graphQLResultHasError(result) {
    return result.errors && result.errors.length;
}

function deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function (prop) {
        if (o[prop] !== null &&
            (typeof o[prop] === 'object' || typeof o[prop] === 'function') &&
            !Object.isFrozen(o[prop])) {
            deepFreeze(o[prop]);
        }
    });
    return o;
}
function maybeDeepFreeze(obj) {
    if (isDevelopment() || isTest()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) {
            return deepFreeze(obj);
        }
    }
    return obj;
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function mergeDeep() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    return mergeDeepArray(sources);
}
function mergeDeepArray(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = shallowCopyForMerge(target, pastCopies);
        for (var i = 1; i < count; ++i) {
            target = mergeHelper(target, sources[i], pastCopies);
        }
    }
    return target;
}
function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function mergeHelper(target, source, pastCopies) {
    if (isObject(source) && isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) {
            target = shallowCopyForMerge(target, pastCopies);
        }
        Object.keys(source).forEach(function (sourceKey) {
            var sourceValue = source[sourceKey];
            if (hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) {
                    target[sourceKey] = mergeHelper(shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
                }
            }
            else {
                target[sourceKey] = sourceValue;
            }
        });
        return target;
    }
    return source;
}
function shallowCopyForMerge(value, pastCopies) {
    if (value !== null &&
        typeof value === 'object' &&
        pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) {
            value = value.slice(0);
        }
        else {
            value = Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __assign */ "a"])({ __proto__: Object.getPrototypeOf(value) }, value);
        }
        pastCopies.push(value);
    }
    return value;
}

var haveWarned = Object.create({});
function warnOnceInDevelopment(msg, type) {
    if (type === void 0) { type = 'warn'; }
    if (!isProduction() && !haveWarned[msg]) {
        if (!isTest()) {
            haveWarned[msg] = true;
        }
        if (type === 'error') {
            console.error(msg);
        }
        else {
            console.warn(msg);
        }
    }
}

function stripSymbols(data) {
    return JSON.parse(JSON.stringify(data));
}


//# sourceMappingURL=bundle.esm.js.map


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(9);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

module.exports = _objectSpread;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = function access(obj, accessStr) {
  // auto-curry here
  if (isUndefined(accessStr)) {
    return access.bind(null, obj);
  }

  var funcArgs = Array.prototype.slice.call(arguments, 2);
  return helper(obj, tokenize(accessStr), null, funcArgs);
};

function helper(obj, tokens, ctx, fnArgs) {
  if (tokens.length === 0) {
    return obj;
  }

  var currentToken = tokens[0];

  if (isUndefined(obj) || isNull(obj) ||
    (isTokenFunctionCall(currentToken) && !isFunction(obj))) {
    return undefined;
  }

  if (isTokenFunctionCall(currentToken)) {

    return helper(obj[isArray(fnArgs[0]) ? 'apply' : 'call'](ctx, fnArgs[0]),
      tokens.slice(1),
      // clear context because consecutive fn calls execute in global context
      // e.g. `a.b()()`
      null,
      fnArgs.slice(1));

  } else if (isTokenArrayAccess(currentToken)) {

    return helper(obj[parseInt(currentToken.substr(1), 10)],
      tokens.slice(1),
      // lookahead two tokens for function calls
      isTokenFunctionCall(tokens[1]) ? obj : ctx,
      fnArgs);

  } else {

    return helper(obj[currentToken],
      tokens.slice(1),
      // lookahead two tokens for function calls
      isTokenFunctionCall(tokens[1]) ? obj : ctx,
      fnArgs);

  }
}

function isUndefined(a) {
  return a === void 0;
}

function isNull(a) {
  return a === null;
}

function isArray(a) {
  return Array.isArray(a);
}

function isFunction(a) {
  return typeof a === 'function';
}

function isTokenFunctionCall(token) {
  return token === '()';
}

function isTokenArrayAccess(token) {
  return /^\[\d+\]$/.test(token);
}

function tokenize(str) {
  return str.split(/\.|(\(\))|(\[\d+?])/).filter(function(t) { return t; });
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/canReportError.js
var canReportError = __webpack_require__(114);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Subscriber.js
var Subscriber = __webpack_require__(5);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/symbol/rxSubscriber.js
var rxSubscriber = __webpack_require__(95);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Observer.js
var Observer = __webpack_require__(117);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/util/toSubscriber.js
/** PURE_IMPORTS_START _Subscriber,_symbol_rxSubscriber,_Observer PURE_IMPORTS_END */



function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof Subscriber["a" /* Subscriber */]) {
            return nextOrObserver;
        }
        if (nextOrObserver[rxSubscriber["a" /* rxSubscriber */]]) {
            return nextOrObserver[rxSubscriber["a" /* rxSubscriber */]]();
        }
    }
    if (!nextOrObserver && !error && !complete) {
        return new Subscriber["a" /* Subscriber */](Observer["a" /* empty */]);
    }
    return new Subscriber["a" /* Subscriber */](nextOrObserver, error, complete);
}
//# sourceMappingURL=toSubscriber.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/symbol/observable.js
var observable = __webpack_require__(55);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/pipe.js
var pipe = __webpack_require__(94);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/config.js
var config = __webpack_require__(41);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/Observable.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Observable_Observable; });
/** PURE_IMPORTS_START _util_canReportError,_util_toSubscriber,_symbol_observable,_util_pipe,_config PURE_IMPORTS_END */





var Observable_Observable = /*@__PURE__*/ (function () {
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = toSubscriber(observerOrNext, error, complete);
        if (operator) {
            sink.add(operator.call(sink, this.source));
        }
        else {
            sink.add(this.source || (config["a" /* config */].useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable) ?
                this._subscribe(sink) :
                this._trySubscribe(sink));
        }
        if (config["a" /* config */].useDeprecatedSynchronousErrorHandling) {
            if (sink.syncErrorThrowable) {
                sink.syncErrorThrowable = false;
                if (sink.syncErrorThrown) {
                    throw sink.syncErrorValue;
                }
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            if (config["a" /* config */].useDeprecatedSynchronousErrorHandling) {
                sink.syncErrorThrown = true;
                sink.syncErrorValue = err;
            }
            if (Object(canReportError["a" /* canReportError */])(sink)) {
                sink.error(err);
            }
            else {
                console.warn(err);
            }
        }
    };
    Observable.prototype.forEach = function (next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var subscription;
            subscription = _this.subscribe(function (value) {
                try {
                    next(value);
                }
                catch (err) {
                    reject(err);
                    if (subscription) {
                        subscription.unsubscribe();
                    }
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function (subscriber) {
        var source = this.source;
        return source && source.subscribe(subscriber);
    };
    Observable.prototype[observable["a" /* observable */]] = function () {
        return this;
    };
    Observable.prototype.pipe = function () {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operations[_i] = arguments[_i];
        }
        if (operations.length === 0) {
            return this;
        }
        return Object(pipe["b" /* pipeFromArray */])(operations)(this);
    };
    Observable.prototype.toPromise = function (promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var value;
            _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
        });
    };
    Observable.create = function (subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}());

function getPromiseCtor(promiseCtor) {
    if (!promiseCtor) {
        promiseCtor = config["a" /* config */].Promise || Promise;
    }
    if (!promiseCtor) {
        throw new Error('no Promise impl found');
    }
    return promiseCtor;
}
//# sourceMappingURL=Observable.js.map


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(132);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(300);


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createReducer = createReducer;

function createReducer(initialState, handlers) {
  return function reducer(state, action) {
    if (state === undefined) {
      state = initialState;
    }

    if (Object.hasOwnProperty.call(handlers, action.type)) {
      return handlers[action.type](state, action);
    } else {
      return state;
    }
  };
}

/***/ }),
/* 14 */
/***/ (function(module, exports) {

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

module.exports = _asyncToGenerator;

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return subscribeToResult; });
/* harmony import */ var _InnerSubscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39);
/* harmony import */ var _subscribeTo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97);
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10);
/** PURE_IMPORTS_START _InnerSubscriber,_subscribeTo,_Observable PURE_IMPORTS_END */



function subscribeToResult(outerSubscriber, result, outerValue, outerIndex, innerSubscriber) {
    if (innerSubscriber === void 0) {
        innerSubscriber = new _InnerSubscriber__WEBPACK_IMPORTED_MODULE_0__[/* InnerSubscriber */ "a"](outerSubscriber, outerValue, outerIndex);
    }
    if (innerSubscriber.closed) {
        return undefined;
    }
    if (result instanceof _Observable__WEBPACK_IMPORTED_MODULE_2__[/* Observable */ "a"]) {
        return result.subscribe(innerSubscriber);
    }
    return Object(_subscribeTo__WEBPACK_IMPORTED_MODULE_1__[/* subscribeTo */ "a"])(result)(innerSubscriber);
}
//# sourceMappingURL=subscribeToResult.js.map


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OuterSubscriber; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


var OuterSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"](OuterSubscriber, _super);
    function OuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function (error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function (innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__[/* Subscriber */ "a"]));

//# sourceMappingURL=OuterSubscriber.js.map


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InvariantError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return invariant; });
/* unused harmony export process */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);


var genericMessage = "Invariant Violation";
var _a = Object.setPrototypeOf, setPrototypeOf = _a === void 0 ? function (obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : _a;
var InvariantError = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"])(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) { message = genericMessage; }
        var _this = _super.call(this, typeof message === "number"
            ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)"
            : message) || this;
        _this.framesToPop = 1;
        _this.name = genericMessage;
        setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error));
function invariant(condition, message) {
    if (!condition) {
        throw new InvariantError(message);
    }
}
function wrapConsoleMethod(method) {
    return function () {
        return console[method].apply(console, arguments);
    };
}
(function (invariant) {
    invariant.warn = wrapConsoleMethod("warn");
    invariant.error = wrapConsoleMethod("error");
})(invariant || (invariant = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var processStub = { env: {} };
if (typeof process === "object") {
    processStub = process;
}
else
    try {
        // Using Function to evaluate this assignment in global scope also escapes
        // the strict mode of the current module, thereby allowing the assignment.
        // Inspired by https://github.com/facebook/regenerator/pull/369.
        Function("stub", "process = stub")(processStub);
    }
    catch (atLeastWeTried) {
        // The assignment can fail if a Content Security Policy heavy-handedly
        // forbids Function usage. In those environments, developers should take
        // extra care to replace process.env.NODE_ENV in their production builds,
        // or define an appropriate global.process polyfill.
    }
var invariant$1 = invariant;

/* unused harmony default export */ var _unused_webpack_default_export = (invariant$1);

//# sourceMappingURL=invariant.esm.js.map


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return detach; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return take; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return takem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return put; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return all; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return race; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return call; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return apply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return cps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return fork; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return spawn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return join; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return cancel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return select; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actionChannel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return cancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return flush; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return setContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return asEffect; });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);


var IO = /*#__PURE__*/Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* sym */ "x"])('IO');
var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';

var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';

var effect = function effect(type, payload) {
  var _ref;

  return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
};

var detach = function detach(eff) {
  Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* check */ "h"])(asEffect.fork(eff), _utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].object, 'detach(eff): argument must be a fork effect');
  eff[FORK].detached = true;
  return eff;
};

function take() {
  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

  if (arguments.length) {
    Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* check */ "h"])(arguments[0], _utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }
  if (_utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].pattern(patternOrChannel)) {
    return effect(TAKE, { pattern: patternOrChannel });
  }
  if (_utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].channel(patternOrChannel)) {
    return effect(TAKE, { channel: patternOrChannel });
  }
  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
}

take.maybe = function () {
  var eff = take.apply(undefined, arguments);
  eff[TAKE].maybe = true;
  return eff;
};

var takem = /*#__PURE__*/Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* deprecate */ "n"])(take.maybe, /*#__PURE__*/Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* updateIncentive */ "z"])('takem', 'take.maybe'));

function put(channel, action) {
  if (arguments.length > 1) {
    Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* check */ "h"])(channel, _utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].notUndef, 'put(channel, action): argument channel is undefined');
    Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* check */ "h"])(channel, _utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
    Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* check */ "h"])(action, _utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].notUndef, 'put(channel, action): argument action is undefined');
  } else {
    Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* check */ "h"])(channel, _utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].notUndef, 'put(action): argument action is undefined');
    action = channel;
    channel = null;
  }
  return effect(PUT, { channel: channel, action: action });
}

put.resolve = function () {
  var eff = put.apply(undefined, arguments);
  eff[PUT].resolve = true;
  return eff;
};

put.sync = /*#__PURE__*/Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* deprecate */ "n"])(put.resolve, /*#__PURE__*/Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* updateIncentive */ "z"])('put.sync', 'put.resolve'));

function all(effects) {
  return effect(ALL, effects);
}

function race(effects) {
  return effect(RACE, effects);
}

function getFnCallDesc(meth, fn, args) {
  Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* check */ "h"])(fn, _utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].notUndef, meth + ': argument fn is undefined');

  var context = null;
  if (_utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].array(fn)) {
    var _fn = fn;
    context = _fn[0];
    fn = _fn[1];
  } else if (fn.fn) {
    var _fn2 = fn;
    context = _fn2.context;
    fn = _fn2.fn;
  }
  if (context && _utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].string(fn) && _utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].func(context[fn])) {
    fn = context[fn];
  }
  Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* check */ "h"])(fn, _utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].func, meth + ': argument ' + fn + ' is not a function');

  return { context: context, fn: fn, args: args };
}

function call(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return effect(CALL, getFnCallDesc('call', fn, args));
}

function apply(context, fn) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
}

function cps(fn) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return effect(CPS, getFnCallDesc('cps', fn, args));
}

function fork(fn) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return effect(FORK, getFnCallDesc('fork', fn, args));
}

function spawn(fn) {
  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  return detach(fork.apply(undefined, [fn].concat(args)));
}

function join() {
  for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    tasks[_key5] = arguments[_key5];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return join(t);
    }));
  }
  var task = tasks[0];
  Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* check */ "h"])(task, _utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].notUndef, 'join(task): argument task is undefined');
  Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* check */ "h"])(task, _utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  return effect(JOIN, task);
}

function cancel() {
  for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    tasks[_key6] = arguments[_key6];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return cancel(t);
    }));
  }
  var task = tasks[0];
  if (tasks.length === 1) {
    Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* check */ "h"])(task, _utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].notUndef, 'cancel(task): argument task is undefined');
    Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* check */ "h"])(task, _utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  }
  return effect(CANCEL, task || _utils__WEBPACK_IMPORTED_MODULE_0__[/* SELF_CANCELLATION */ "d"]);
}

function select(selector) {
  for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    args[_key7 - 1] = arguments[_key7];
  }

  if (arguments.length === 0) {
    selector = _utils__WEBPACK_IMPORTED_MODULE_0__[/* ident */ "o"];
  } else {
    Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* check */ "h"])(selector, _utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].notUndef, 'select(selector,[...]): argument selector is undefined');
    Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* check */ "h"])(selector, _utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].func, 'select(selector,[...]): argument ' + selector + ' is not a function');
  }
  return effect(SELECT, { selector: selector, args: args });
}

/**
  channel(pattern, [buffer])    => creates an event channel for store actions
**/
function actionChannel(pattern, buffer) {
  Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* check */ "h"])(pattern, _utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
  if (arguments.length > 1) {
    Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* check */ "h"])(buffer, _utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
    Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* check */ "h"])(buffer, _utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
  }
  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
}

function cancelled() {
  return effect(CANCELLED, {});
}

function flush(channel) {
  Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* check */ "h"])(channel, _utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].channel, 'flush(channel): argument ' + channel + ' is not valid channel');
  return effect(FLUSH, channel);
}

function getContext(prop) {
  Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* check */ "h"])(prop, _utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].string, 'getContext(prop): argument ' + prop + ' is not a string');
  return effect(GET_CONTEXT, prop);
}

function setContext(props) {
  Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* check */ "h"])(props, _utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].object, Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* createSetContextWarning */ "k"])(null, props));
  return effect(SET_CONTEXT, props);
}

var createAsEffectType = function createAsEffectType(type) {
  return function (effect) {
    return effect && effect[IO] && effect[type];
  };
};

var asEffect = {
  take: /*#__PURE__*/createAsEffectType(TAKE),
  put: /*#__PURE__*/createAsEffectType(PUT),
  all: /*#__PURE__*/createAsEffectType(ALL),
  race: /*#__PURE__*/createAsEffectType(RACE),
  call: /*#__PURE__*/createAsEffectType(CALL),
  cps: /*#__PURE__*/createAsEffectType(CPS),
  fork: /*#__PURE__*/createAsEffectType(FORK),
  join: /*#__PURE__*/createAsEffectType(JOIN),
  cancel: /*#__PURE__*/createAsEffectType(CANCEL),
  select: /*#__PURE__*/createAsEffectType(SELECT),
  actionChannel: /*#__PURE__*/createAsEffectType(ACTION_CHANNEL),
  cancelled: /*#__PURE__*/createAsEffectType(CANCELLED),
  flush: /*#__PURE__*/createAsEffectType(FLUSH),
  getContext: /*#__PURE__*/createAsEffectType(GET_CONTEXT),
  setContext: /*#__PURE__*/createAsEffectType(SET_CONTEXT)
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * js-logger - http://github.com/jonnyreeves/js-logger
 * Jonny Reeves, http://jonnyreeves.co.uk/
 * js-logger may be freely distributed under the MIT license.
 */
(function (global) {
	"use strict";

	// Top level module for the global, static logger instance.
	var Logger = { };

	// For those that are at home that are keeping score.
	Logger.VERSION = "1.6.0";

	// Function which handles all incoming log messages.
	var logHandler;

	// Map of ContextualLogger instances by name; used by Logger.get() to return the same named instance.
	var contextualLoggersByNameMap = {};

	// Polyfill for ES5's Function.bind.
	var bind = function(scope, func) {
		return function() {
			return func.apply(scope, arguments);
		};
	};

	// Super exciting object merger-matron 9000 adding another 100 bytes to your download.
	var merge = function () {
		var args = arguments, target = args[0], key, i;
		for (i = 1; i < args.length; i++) {
			for (key in args[i]) {
				if (!(key in target) && args[i].hasOwnProperty(key)) {
					target[key] = args[i][key];
				}
			}
		}
		return target;
	};

	// Helper to define a logging level object; helps with optimisation.
	var defineLogLevel = function(value, name) {
		return { value: value, name: name };
	};

	// Predefined logging levels.
	Logger.TRACE = defineLogLevel(1, 'TRACE');
	Logger.DEBUG = defineLogLevel(2, 'DEBUG');
	Logger.INFO = defineLogLevel(3, 'INFO');
	Logger.TIME = defineLogLevel(4, 'TIME');
	Logger.WARN = defineLogLevel(5, 'WARN');
	Logger.ERROR = defineLogLevel(8, 'ERROR');
	Logger.OFF = defineLogLevel(99, 'OFF');

	// Inner class which performs the bulk of the work; ContextualLogger instances can be configured independently
	// of each other.
	var ContextualLogger = function(defaultContext) {
		this.context = defaultContext;
		this.setLevel(defaultContext.filterLevel);
		this.log = this.info;  // Convenience alias.
	};

	ContextualLogger.prototype = {
		// Changes the current logging level for the logging instance.
		setLevel: function (newLevel) {
			// Ensure the supplied Level object looks valid.
			if (newLevel && "value" in newLevel) {
				this.context.filterLevel = newLevel;
			}
		},
		
		// Gets the current logging level for the logging instance
		getLevel: function () {
			return this.context.filterLevel;
		},

		// Is the logger configured to output messages at the supplied level?
		enabledFor: function (lvl) {
			var filterLevel = this.context.filterLevel;
			return lvl.value >= filterLevel.value;
		},

		trace: function () {
			this.invoke(Logger.TRACE, arguments);
		},

		debug: function () {
			this.invoke(Logger.DEBUG, arguments);
		},

		info: function () {
			this.invoke(Logger.INFO, arguments);
		},

		warn: function () {
			this.invoke(Logger.WARN, arguments);
		},

		error: function () {
			this.invoke(Logger.ERROR, arguments);
		},

		time: function (label) {
			if (typeof label === 'string' && label.length > 0) {
				this.invoke(Logger.TIME, [ label, 'start' ]);
			}
		},

		timeEnd: function (label) {
			if (typeof label === 'string' && label.length > 0) {
				this.invoke(Logger.TIME, [ label, 'end' ]);
			}
		},

		// Invokes the logger callback if it's not being filtered.
		invoke: function (level, msgArgs) {
			if (logHandler && this.enabledFor(level)) {
				logHandler(msgArgs, merge({ level: level }, this.context));
			}
		}
	};

	// Protected instance which all calls to the to level `Logger` module will be routed through.
	var globalLogger = new ContextualLogger({ filterLevel: Logger.OFF });

	// Configure the global Logger instance.
	(function() {
		// Shortcut for optimisers.
		var L = Logger;

		L.enabledFor = bind(globalLogger, globalLogger.enabledFor);
		L.trace = bind(globalLogger, globalLogger.trace);
		L.debug = bind(globalLogger, globalLogger.debug);
		L.time = bind(globalLogger, globalLogger.time);
		L.timeEnd = bind(globalLogger, globalLogger.timeEnd);
		L.info = bind(globalLogger, globalLogger.info);
		L.warn = bind(globalLogger, globalLogger.warn);
		L.error = bind(globalLogger, globalLogger.error);

		// Don't forget the convenience alias!
		L.log = L.info;
	}());

	// Set the global logging handler.  The supplied function should expect two arguments, the first being an arguments
	// object with the supplied log messages and the second being a context object which contains a hash of stateful
	// parameters which the logging function can consume.
	Logger.setHandler = function (func) {
		logHandler = func;
	};

	// Sets the global logging filter level which applies to *all* previously registered, and future Logger instances.
	// (note that named loggers (retrieved via `Logger.get`) can be configured independently if required).
	Logger.setLevel = function(level) {
		// Set the globalLogger's level.
		globalLogger.setLevel(level);

		// Apply this level to all registered contextual loggers.
		for (var key in contextualLoggersByNameMap) {
			if (contextualLoggersByNameMap.hasOwnProperty(key)) {
				contextualLoggersByNameMap[key].setLevel(level);
			}
		}
	};

	// Gets the global logging filter level
	Logger.getLevel = function() {
		return globalLogger.getLevel();
	};

	// Retrieve a ContextualLogger instance.  Note that named loggers automatically inherit the global logger's level,
	// default context and log handler.
	Logger.get = function (name) {
		// All logger instances are cached so they can be configured ahead of use.
		return contextualLoggersByNameMap[name] ||
			(contextualLoggersByNameMap[name] = new ContextualLogger(merge({ name: name }, globalLogger.context)));
	};

	// CreateDefaultHandler returns a handler function which can be passed to `Logger.setHandler()` which will
	// write to the window's console object (if present); the optional options object can be used to customise the
	// formatter used to format each log message.
	Logger.createDefaultHandler = function (options) {
		options = options || {};

		options.formatter = options.formatter || function defaultMessageFormatter(messages, context) {
			// Prepend the logger's name to the log message for easy identification.
			if (context.name) {
				messages.unshift("[" + context.name + "]");
			}
		};

		// Map of timestamps by timer labels used to track `#time` and `#timeEnd()` invocations in environments
		// that don't offer a native console method.
		var timerStartTimeByLabelMap = {};

		// Support for IE8+ (and other, slightly more sane environments)
		var invokeConsoleMethod = function (hdlr, messages) {
			Function.prototype.apply.call(hdlr, console, messages);
		};

		// Check for the presence of a logger.
		if (typeof console === "undefined") {
			return function () { /* no console */ };
		}

		return function(messages, context) {
			// Convert arguments object to Array.
			messages = Array.prototype.slice.call(messages);

			var hdlr = console.log;
			var timerLabel;

			if (context.level === Logger.TIME) {
				timerLabel = (context.name ? '[' + context.name + '] ' : '') + messages[0];

				if (messages[1] === 'start') {
					if (console.time) {
						console.time(timerLabel);
					}
					else {
						timerStartTimeByLabelMap[timerLabel] = new Date().getTime();
					}
				}
				else {
					if (console.timeEnd) {
						console.timeEnd(timerLabel);
					}
					else {
						invokeConsoleMethod(hdlr, [ timerLabel + ': ' +
							(new Date().getTime() - timerStartTimeByLabelMap[timerLabel]) + 'ms' ]);
					}
				}
			}
			else {
				// Delegate through to custom warn/error loggers if present on the console.
				if (context.level === Logger.WARN && console.warn) {
					hdlr = console.warn;
				} else if (context.level === Logger.ERROR && console.error) {
					hdlr = console.error;
				} else if (context.level === Logger.INFO && console.info) {
					hdlr = console.info;
				} else if (context.level === Logger.DEBUG && console.debug) {
					hdlr = console.debug;
				} else if (context.level === Logger.TRACE && console.trace) {
					hdlr = console.trace;
				}

				options.formatter(messages, context);
				invokeConsoleMethod(hdlr, messages);
			}
		};
	};

	// Configure and example a Default implementation which writes to the `window.console` (if present).  The
	// `options` hash can be used to configure the default logLevel and provide a custom message formatter.
	Logger.useDefaults = function(options) {
		Logger.setLevel(options && options.defaultLevel || Logger.DEBUG);
		Logger.setHandler(Logger.createDefaultHandler(options));
	};

	// Export to popular environments boilerplate.
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (Logger),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else {}
}(this));


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
/* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24);
/* harmony import */ var _util_isObject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(113);
/* harmony import */ var _util_isFunction__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61);
/* harmony import */ var _util_UnsubscriptionError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96);
/** PURE_IMPORTS_START _util_isArray,_util_isObject,_util_isFunction,_util_UnsubscriptionError PURE_IMPORTS_END */




var Subscription = /*@__PURE__*/ (function () {
    function Subscription(unsubscribe) {
        this.closed = false;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._unsubscribe = unsubscribe;
        }
    }
    Subscription.prototype.unsubscribe = function () {
        var errors;
        if (this.closed) {
            return;
        }
        var _a = this, _parentOrParents = _a._parentOrParents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (_parentOrParents instanceof Subscription) {
            _parentOrParents.remove(this);
        }
        else if (_parentOrParents !== null) {
            for (var index = 0; index < _parentOrParents.length; ++index) {
                var parent_1 = _parentOrParents[index];
                parent_1.remove(this);
            }
        }
        if (Object(_util_isFunction__WEBPACK_IMPORTED_MODULE_2__[/* isFunction */ "a"])(_unsubscribe)) {
            try {
                _unsubscribe.call(this);
            }
            catch (e) {
                errors = e instanceof _util_UnsubscriptionError__WEBPACK_IMPORTED_MODULE_3__[/* UnsubscriptionError */ "a"] ? flattenUnsubscriptionErrors(e.errors) : [e];
            }
        }
        if (Object(_util_isArray__WEBPACK_IMPORTED_MODULE_0__[/* isArray */ "a"])(_subscriptions)) {
            var index = -1;
            var len = _subscriptions.length;
            while (++index < len) {
                var sub = _subscriptions[index];
                if (Object(_util_isObject__WEBPACK_IMPORTED_MODULE_1__[/* isObject */ "a"])(sub)) {
                    try {
                        sub.unsubscribe();
                    }
                    catch (e) {
                        errors = errors || [];
                        if (e instanceof _util_UnsubscriptionError__WEBPACK_IMPORTED_MODULE_3__[/* UnsubscriptionError */ "a"]) {
                            errors = errors.concat(flattenUnsubscriptionErrors(e.errors));
                        }
                        else {
                            errors.push(e);
                        }
                    }
                }
            }
        }
        if (errors) {
            throw new _util_UnsubscriptionError__WEBPACK_IMPORTED_MODULE_3__[/* UnsubscriptionError */ "a"](errors);
        }
    };
    Subscription.prototype.add = function (teardown) {
        var subscription = teardown;
        if (!teardown) {
            return Subscription.EMPTY;
        }
        switch (typeof teardown) {
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== 'function') {
                    return subscription;
                }
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                }
                else if (!(subscription instanceof Subscription)) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [tmp];
                }
                break;
            default: {
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
            }
        }
        var _parentOrParents = subscription._parentOrParents;
        if (_parentOrParents === null) {
            subscription._parentOrParents = this;
        }
        else if (_parentOrParents instanceof Subscription) {
            if (_parentOrParents === this) {
                return subscription;
            }
            subscription._parentOrParents = [_parentOrParents, this];
        }
        else if (_parentOrParents.indexOf(this) === -1) {
            _parentOrParents.push(this);
        }
        else {
            return subscription;
        }
        var subscriptions = this._subscriptions;
        if (subscriptions === null) {
            this._subscriptions = [subscription];
        }
        else {
            subscriptions.push(subscription);
        }
        return subscription;
    };
    Subscription.prototype.remove = function (subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) {
                subscriptions.splice(subscriptionIndex, 1);
            }
        }
    };
    Subscription.EMPTY = (function (empty) {
        empty.closed = true;
        return empty;
    }(new Subscription()));
    return Subscription;
}());

function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function (errs, err) { return errs.concat((err instanceof _util_UnsubscriptionError__WEBPACK_IMPORTED_MODULE_3__[/* UnsubscriptionError */ "a"]) ? err.errors : err); }, []);
}
//# sourceMappingURL=Subscription.js.map


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(CONFIG) {

var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAutoRetry = setAutoRetry;
exports.verifyCurrentConnection = verifyCurrentConnection;
exports.openConnection = openConnection;
exports.closeConnection = closeConnection;
exports.forceCloseConnection = forceCloseConnection;
exports.subscribe = subscribe;
exports.unsubscribe = unsubscribe;
exports.proxyApiCall = proxyApiCall;
exports.proxyGqlFetch = proxyGqlFetch;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _clients = __webpack_require__(172);

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _qs = _interopRequireDefault(__webpack_require__(212));

var _services = __webpack_require__(179);

var _token = __webpack_require__(196);

var c = _interopRequireWildcard(__webpack_require__(3));

var _contacts = __webpack_require__(35);

var _currentUser = __webpack_require__(37);

var _token2 = __webpack_require__(269);

var _proxy = __webpack_require__(493);

var _auth = __webpack_require__(31);

var _guid = _interopRequireDefault(__webpack_require__(72));

var realm = 'lifesize';

function setAutoRetry(autoRetry) {
  return (
    /*#__PURE__*/
    (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _clients.connection.setAutoRetry(autoRetry);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))
  );
}

function verifyCurrentConnection() {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dispatch({
                  type: c.VERIFY_WAMP_REQUEST
                });
                _context2.next = 3;
                return _clients.connection.setAutoRetry(false);

              case 3:
                _context2.prev = 3;
                _context2.next = 6;
                return _clients.rpc.echo(2500);

              case 6:
                _context2.next = 8;
                return _clients.connection.setAutoRetry(true);

              case 8:
                dispatch({
                  type: c.VERIFY_WAMP_SUCCESS
                });
                _context2.next = 16;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](3);
                dispatch({
                  type: c.VERIFY_WAMP_FAILURE
                });
                _context2.next = 16;
                return dispatch(forceCloseConnection());

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[3, 11]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}

function openConnection(providedJwt) {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(dispatch, getState) {
        var state, domain, clientType, jwt, url, response, willRetry, newToken;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                state = getState();
                domain = (0, _contacts.getDomain)(state);
                clientType = (0, _currentUser.getClientType)(state);
                jwt = providedJwt ? providedJwt : (0, _auth.getPrimaryJwt)(state);
                url = (0, _proxy.getUrl)(jwt, domain, clientType);
                dispatch({
                  type: c.WAMP_CONNECT_BEGIN,
                  payload: {
                    url: url,
                    realm: realm
                  }
                });
                _context3.prev = 6;
                _context3.next = 9;
                return _clients.connection.open({
                  url: url,
                  realm: realm
                });

              case 9:
                response = _context3.sent;

                // subscribe to connection handlers for connection drops & auto-reconnects
                _clients.connection.onOpen = function (payload) {
                  return dispatch(onConnectionOpened(payload));
                };

                _clients.connection.onDispose = function (payload) {
                  return dispatch(onConnectionDisposed(payload));
                };

                dispatch({
                  type: c.WAMP_CONNECT_SUCCESS,
                  payload: {
                    sessionId: (0, _safeAccess.default)(response, 'session.id')
                  }
                });
                _context3.next = 27;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](6);

                _jsLogger.default.error('Could not open connection to NP:', _context3.t0);

                willRetry = (0, _proxy.verifyJwtDispose)(_context3.t0) && (0, _token2.selectCanRefreshToken)(state);
                dispatch({
                  type: c.WAMP_CONNECT_ERROR,
                  payload: {
                    error: _context3.t0,
                    willRetry: willRetry
                  }
                }); // throw if not attempting reconnect

                if (willRetry) {
                  _context3.next = 22;
                  break;
                }

                throw _context3.t0;

              case 22:
                _context3.next = 24;
                return dispatch((0, _token.refreshToken)());

              case 24:
                newToken = (0, _token2.selectRefreshableToken)(getState());
                _context3.next = 27;
                return dispatch(openConnection(newToken));

              case 27:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[6, 15]]);
      }));

      return function (_x2, _x3) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
}

function closeConnection() {
  return (
    /*#__PURE__*/
    (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee4() {
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return _clients.connection.close();

            case 3:
              _context4.next = 8;
              break;

            case 5:
              _context4.prev = 5;
              _context4.t0 = _context4["catch"](0);

              _jsLogger.default.debug('error closing connection:', _context4.t0);

            case 8:
              _context4.prev = 8;
              _clients.connection.onOpen = null;
              _clients.connection.onDispose = null;
              return _context4.finish(8);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 5, 8, 12]]);
    }))
  );
}

function forceCloseConnection() {
  return (
    /*#__PURE__*/
    (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee5() {
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return _clients.connection.forceClose();

            case 3:
              _context5.next = 8;
              break;

            case 5:
              _context5.prev = 5;
              _context5.t0 = _context5["catch"](0);

              _jsLogger.default.debug('error force closing connection:', _context5.t0);

            case 8:
              _context5.prev = 8;
              _clients.connection.onOpen = null;
              _clients.connection.onDispose = null;
              return _context5.finish(8);

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 5, 8, 12]]);
    }))
  );
}
/**
 * Called when the wamp client manages to automatically reconnect after connection is lost.
 * @param {*} payload Payload object that includes the new session information.
 */


function onConnectionOpened(payload) {
  return (
    /*#__PURE__*/
    function () {
      var _ref6 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(dispatch) {
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                dispatch({
                  type: c.WAMP_CONNECT_SUCCESS,
                  payload: {
                    sessionId: (0, _safeAccess.default)(payload, 'session.id')
                  }
                });
                _context6.prev = 1;
                _context6.next = 4;
                return dispatch((0, _services.initializeServices)());

              case 4:
                dispatch((0, _services.initializeNonEssentialServices)());
                _context6.next = 10;
                break;

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6["catch"](1);

                _jsLogger.default.info('Failed to initialize services after reconnecting.');

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[1, 7]]);
      }));

      return function (_x4) {
        return _ref6.apply(this, arguments);
      };
    }()
  );
}
/**
 * Called when the current wamp connection is disposed.
 * @param {*} payload Payload object that includes details about the connection disposal.
 */


function onConnectionDisposed(payload) {
  return function (dispatch) {
    if ((0, _proxy.verifyHealthyDispose)(payload)) dispatch(handleHealthyDispose());else if ((0, _proxy.verifyJwtDispose)(payload)) dispatch(handleJwtDispose(payload));else dispatch(handleUnexpectedDispose(payload));
  };
}

function handleHealthyDispose() {
  return function (dispatch) {
    _clients.connection.onOpen = undefined;
    _clients.connection.onDispose = undefined;
    dispatch({
      type: c.WAMP_CONNECTION_DISPOSED_HEALTHY
    });
  };
}

function handleJwtDispose(payload) {
  return (
    /*#__PURE__*/
    function () {
      var _ref7 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(dispatch, getState) {
        var willRefreshToken;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                willRefreshToken = (0, _token2.selectCanRefreshToken)(getState());
                dispatch({
                  type: c.WAMP_CONNECTION_DISPOSED_JWT_ERROR,
                  payload: {
                    error: payload,
                    willRefreshToken: willRefreshToken
                  }
                });

                if (willRefreshToken) {
                  _context7.next = 6;
                  break;
                }

                _clients.connection.onOpen = undefined;
                _clients.connection.onDispose = undefined;
                return _context7.abrupt("return");

              case 6:
                _context7.prev = 6;

                // otherwise refresh the token and connect from scratch
                _jsLogger.default.info('Attempting to refresh token and re-establish connection.');

                _context7.next = 10;
                return dispatch((0, _token.refreshToken)());

              case 10:
                _context7.next = 12;
                return dispatch((0, _services.internalConnect)());

              case 12:
                _context7.next = 17;
                break;

              case 14:
                _context7.prev = 14;
                _context7.t0 = _context7["catch"](6);

                _jsLogger.default.info('Failed to refresh token and re-establish connection:', _context7.t0);

              case 17:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[6, 14]]);
      }));

      return function (_x5, _x6) {
        return _ref7.apply(this, arguments);
      };
    }()
  );
}

function handleUnexpectedDispose(payload) {
  return function (dispatch) {
    var willRetry = (0, _safeAccess.default)(payload, 'willRetry');

    if (!willRetry) {
      _clients.connection.onOpen = undefined;
      _clients.connection.onDispose = undefined;
    }

    dispatch({
      type: c.WAMP_CONNECTION_DISPOSED_UNEXPECTED,
      payload: payload
    });
  };
}

function subscribe(topic) {
  return {
    type: c.WAMP_SUBSCRIBE_BEGIN,
    payload: topic
  };
}

function unsubscribe(topic) {
  return {
    type: c.WAMP_UNSUBSCRIBE_BEGIN,
    payload: topic
  };
}

function proxyApiCall(service, uriSuffix, httpMethod) {
  var inputParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var queryParams = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var args = {
    uriSuffix: uriSuffix,
    httpMethod: httpMethod,
    inputParams: inputParams,
    queryParams: queryParams
  };
  return {
    type: c.WAMP_SEND_BEGIN,
    payload: {
      id: _guid.default.create(),
      command: service,
      args: [JSON.stringify(args)]
    }
  };
}
/**
 * Browser Fetch API  'compatible' function that clients can use to proxy
 * GraphQL requests through nucleus/nucleus proxy;
 *
 * TODO: Investigate Error Handling:  Would need nucleus proxy to pass back the
 * more error info... I think.
 */


function proxyGqlFetch(dispatch) {
  return (
    /*#__PURE__*/
    function () {
      var _ref8 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee8(uri) {
        var fetchArgs,
            queryString,
            response,
            _args8 = arguments;
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                fetchArgs = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : {};
                queryString = _qs.default.stringify({
                  clientType: CONFIG.clientType,
                  clientVersion: CONFIG.clientVersion,
                  nucleusVersion: "7.0.1"
                });
                _context8.next = 4;
                return dispatch(proxyApiCall(CONFIG.graphql.rpc, "?".concat(queryString), fetchArgs.method || 'GET', JSON.parse(fetchArgs.body)));

              case 4:
                response = _context8.sent;
                return _context8.abrupt("return", new Response(response, {
                  status: 200,
                  statusText: 'OK'
                }));

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      return function (_x7) {
        return _ref8.apply(this, arguments);
      };
    }()
  );
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(29)["default"]))

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SubjectSubscriber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subject; });
/* unused harmony export AnonymousSubject */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10);
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
/* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20);
/* harmony import */ var _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56);
/* harmony import */ var _SubjectSubscription__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(162);
/* harmony import */ var _internal_symbol_rxSubscriber__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95);
/** PURE_IMPORTS_START tslib,_Observable,_Subscriber,_Subscription,_util_ObjectUnsubscribedError,_SubjectSubscription,_internal_symbol_rxSubscriber PURE_IMPORTS_END */







var SubjectSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"](SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        return _this;
    }
    return SubjectSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_2__[/* Subscriber */ "a"]));

var Subject = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"](Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.observers = [];
        _this.closed = false;
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype[_internal_symbol_rxSubscriber__WEBPACK_IMPORTED_MODULE_6__[/* rxSubscriber */ "a"]] = function () {
        return new SubjectSubscriber(this);
    };
    Subject.prototype.lift = function (operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function (value) {
        if (this.closed) {
            throw new _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_4__[/* ObjectUnsubscribedError */ "a"]();
        }
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for (var i = 0; i < len; i++) {
                copy[i].next(value);
            }
        }
    };
    Subject.prototype.error = function (err) {
        if (this.closed) {
            throw new _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_4__[/* ObjectUnsubscribedError */ "a"]();
        }
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].error(err);
        }
        this.observers.length = 0;
    };
    Subject.prototype.complete = function () {
        if (this.closed) {
            throw new _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_4__[/* ObjectUnsubscribedError */ "a"]();
        }
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].complete();
        }
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function () {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function (subscriber) {
        if (this.closed) {
            throw new _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_4__[/* ObjectUnsubscribedError */ "a"]();
        }
        else {
            return _super.prototype._trySubscribe.call(this, subscriber);
        }
    };
    Subject.prototype._subscribe = function (subscriber) {
        if (this.closed) {
            throw new _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_4__[/* ObjectUnsubscribedError */ "a"]();
        }
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return _Subscription__WEBPACK_IMPORTED_MODULE_3__[/* Subscription */ "a"].EMPTY;
        }
        else if (this.isStopped) {
            subscriber.complete();
            return _Subscription__WEBPACK_IMPORTED_MODULE_3__[/* Subscription */ "a"].EMPTY;
        }
        else {
            this.observers.push(subscriber);
            return new _SubjectSubscription__WEBPACK_IMPORTED_MODULE_5__[/* SubjectSubscription */ "a"](this, subscriber);
        }
    };
    Subject.prototype.asObservable = function () {
        var observable = new _Observable__WEBPACK_IMPORTED_MODULE_1__[/* Observable */ "a"]();
        observable.source = this;
        return observable;
    };
    Subject.create = function (destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}(_Observable__WEBPACK_IMPORTED_MODULE_1__[/* Observable */ "a"]));

var AnonymousSubject = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"](AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function (value) {
        var destination = this.destination;
        if (destination && destination.next) {
            destination.next(value);
        }
    };
    AnonymousSubject.prototype.error = function (err) {
        var destination = this.destination;
        if (destination && destination.error) {
            this.destination.error(err);
        }
    };
    AnonymousSubject.prototype.complete = function () {
        var destination = this.destination;
        if (destination && destination.complete) {
            this.destination.complete();
        }
    };
    AnonymousSubject.prototype._subscribe = function (subscriber) {
        var source = this.source;
        if (source) {
            return this.source.subscribe(subscriber);
        }
        else {
            return _Subscription__WEBPACK_IMPORTED_MODULE_3__[/* Subscription */ "a"].EMPTY;
        }
    };
    return AnonymousSubject;
}(Subject));

//# sourceMappingURL=Subject.js.map


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultMemoize", function() { return defaultMemoize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSelectorCreator", function() { return createSelectorCreator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSelector", function() { return createSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createStructuredSelector", function() { return createStructuredSelector; });
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = memoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isArray; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var isArray = /*@__PURE__*/ (function () { return Array.isArray || (function (x) { return x && typeof x.length === 'number'; }); })();
//# sourceMappingURL=isArray.js.map


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return async; });
/* harmony import */ var _AsyncAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68);
/* harmony import */ var _AsyncScheduler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65);
/** PURE_IMPORTS_START _AsyncAction,_AsyncScheduler PURE_IMPORTS_END */


var async = /*@__PURE__*/ new _AsyncScheduler__WEBPACK_IMPORTED_MODULE_1__[/* AsyncScheduler */ "a"](_AsyncAction__WEBPACK_IMPORTED_MODULE_0__[/* AsyncAction */ "a"]);
//# sourceMappingURL=async.js.map


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
/* unused harmony export MapOperator */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function map(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== 'function') {
            throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
        }
        return source.lift(new MapOperator(project, thisArg));
    };
}
var MapOperator = /*@__PURE__*/ (function () {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}());

var MapSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"](MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.count = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    MapSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__[/* Subscriber */ "a"]));
//# sourceMappingURL=map.js.map


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isScheduler; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
//# sourceMappingURL=isScheduler.js.map


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EMPTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return empty; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10);
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */

var EMPTY = /*@__PURE__*/ new _Observable__WEBPACK_IMPORTED_MODULE_0__[/* Observable */ "a"](function (subscriber) { return subscriber.complete(); });
function empty(scheduler) {
    return scheduler ? emptyScheduled(scheduler) : EMPTY;
}
function emptyScheduled(scheduler) {
    return new _Observable__WEBPACK_IMPORTED_MODULE_0__[/* Observable */ "a"](function (subscriber) { return scheduler.schedule(function () { return subscriber.complete(); }); });
}
//# sourceMappingURL=empty.js.map


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.setClientConfig = exports.setRuntimeConfig = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(98));

var _get2 = _interopRequireDefault(__webpack_require__(11));

var _deepmerge = _interopRequireDefault(__webpack_require__(330));

var _qs = _interopRequireDefault(__webpack_require__(212));

var _debug = _interopRequireDefault(__webpack_require__(333));

__webpack_require__(339);

var debug = (0, _debug.default)('lifesize:config');
/**
 * The query string store allows getting config values from the query string.
 * The same dot notation used for local storage can be used in the qs. If window
 *  or location.search isn't defined, we bail out of this store.
 *
 * Optionally if a query string value of __PERSIST is specified, URL values
 * will be written to local storage. Fancy!
 */

var queryStringStore = {
  getFromStore: function getFromStore(path) {
    var _window, _window$location;

    if (typeof window === 'undefined' || !((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.search)) return undefined; // .search includes a `?` prefix on the first term

    var parsedQueryString = _qs.default.parse(window.location.search.slice(1));

    var queryVal = (0, _get2.default)(parsedQueryString, path);
    if (queryVal === undefined) return queryVal;

    var parsedQueryVal = function () {
      try {
        return JSON.parse(decodeURIComponent(queryVal));
      } catch (_unused) {
        return queryVal;
      }
    }();

    if ((parsedQueryString === null || parsedQueryString === void 0 ? void 0 : parsedQueryString.__PERSIST) && typeof localStorage !== 'undefined') {
      debug("Persisting config from query to local storage: ".concat(path, "=").concat(parsedQueryVal)), localStorage[path] = parsedQueryVal;
    }

    return parsedQueryVal;
  },
  name: 'Querystring'
};
/**
 * Reads config values from local storage.  Nested values can be overridden
 * using dot notation.
 */

var localStorageStore = {
  getFromStore: function getFromStore(path) {
    if (typeof localStorage === 'undefined') return undefined;
    var localVal = (0, _get2.default)(localStorage, path);

    try {
      return JSON.parse(localVal);
    } catch (_unused2) {
      return localVal;
    }
  },
  name: 'Local Storage'
};
/**
 * A place to read and set values at runtime. NOTE: localStorage/querystring
 * will still supersede runtime settings which may cause undefined behavior
 */

var runtimeSettings = {};
var runtimeStore = {
  getFromStore: function getFromStore(path) {
    return (0, _get2.default)(runtimeSettings, path);
  },
  name: 'Runtime Settings'
};

var setRuntimeConfig = function setRuntimeConfig(obj) {
  runtimeSettings = (0, _deepmerge.default)(runtimeSettings, obj || {}, {
    arrayMerge: function arrayMerge(destination, source) {
      return source;
    }
  });
};

exports.setRuntimeConfig = setRuntimeConfig;

var getAndLog = function getAndLog(_ref) {
  var getFromStore = _ref.getFromStore,
      name = _ref.name;
  return function (path, property) {
    // Extra safety for bad overrides or stores
    var override = function () {
      try {
        return getFromStore(path);
      } catch (_unused3) {
        debug('Failed to get value for %O from %O', path, name);
        return undefined;
      }
    }();

    if (override !== undefined && (0, _typeof2.default)(override) !== 'object') {
      debug("Overriding config value \x1B[31m".concat(property, "\x1B[30m with \x1B[32m").concat(override, "\x1B[30m from \x1B[34m").concat(name, "\x1B[30m"));
    }

    return override;
  };
};
/**
 * This sets the precedence for our overrides.   QueryString overrides local
 * storage. Both override the built in client/nuc config files. We iterate
 * through our stores and find the first one that returns a non-undefined value
 * for a given key.
 */


var overrideStores = [queryStringStore, localStorageStore, runtimeStore].map(getAndLog);

var getOverride = function getOverride(path, property) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = overrideStores[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var getter = _step.value;
      var override = getter(path, property);
      if (override !== undefined) return override;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return undefined;
}; // We cache config values that we've retrieved to prevent repeated access/parsing
// of our stores.


var cache = {};

var _get = function get() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var parent = arguments.length > 1 ? arguments[1] : undefined;
  return function (target, property) {
    if (cache[property] !== undefined) return cache[property]; // If the property being accessed is a symbol, it means the caller is trying
    // to access the object directly instead of a specific property on a config
    // obj.

    if ((0, _typeof2.default)(property) === 'symbol') return parent; // We keep track of the requested obj path so we can look up replacements from
    // our overrideStores.

    var currentPath = path && property ? "".concat(path, ".").concat(property) : property;
    var override = getOverride(currentPath, property); // If the config value is an object itself, we need to proxy it in case
    // on of its keys are specifically overridden.

    if (target[property] && (0, _typeof2.default)(target[property]) === 'object') {
      return new Proxy(override || target[property] || {}, {
        get: _get(currentPath, override)
      });
    }

    var configVal = override === undefined ? target[property] : override;
    cache[property] = configVal;
    return configVal;
  };
};

var proxiedConfig;
/**
 * Merges a client configuration object in to the base configuration provided
 * by nuclues. This is an init or reset func.  It'll override/unset any
 * values previously set by setClientConfig or setRuntimeConfig;
 */

var setClientConfig = function setClientConfig(obj) {
  proxiedConfig = new Proxy( // BASE_CONFIG is injected by webpack from the nucleus config file at build
  // time.  This should be the only place we reference it directly.
  // eslint-disable-next-line no-undef
  (0, _deepmerge.default)({"environment":"lifesizecloud.com","graphql":{"metaHeaderOverride":null,"logging":false,"rpc":"lifesize.graphql","URLOverride":null,"chat":false},"reduxDevtoolsEnabled":false,"wampConnectOptions":{"openTimeout":10000,"proxyUri":"wss://nucleusproxy.","contactLoadAll":true,"enableSleepMonitor":false},"calls":{"useDataChannel":false,"enforcePlanB":true,"enforcePlanBPresentation":true,"useVideoMuteSlide":true,"useOnTrack":false,"useGalaxySignalingMiddleware":false,"collectMediaStats":false,"autoResolutionChange":false,"rtcPeerConnectionEnableChromiumDscp":false,"rtcRtpSenderEncodingParams":null},"persistence":{"enabled":true},"remoting":{"enableDataChannel":false,"send":null,"isDisplay":false}}, obj || {}, {
    arrayMerge: function arrayMerge(destination, source) {
      return source;
    }
  }), {
    get: function get(target, property) {
      return _get('', target)(target, property);
    }
  });
  cache = {};
  runtimeSettings = {};
  return proxiedConfig;
}; // Initilize the config with the defaults.


exports.setClientConfig = setClientConfig;
setClientConfig();

var _default = new Proxy( // eslint-disable-next-line no-undef
{"environment":"lifesizecloud.com","graphql":{"metaHeaderOverride":null,"logging":false,"rpc":"lifesize.graphql","URLOverride":null,"chat":false},"reduxDevtoolsEnabled":false,"wampConnectOptions":{"openTimeout":10000,"proxyUri":"wss://nucleusproxy.","contactLoadAll":true,"enableSleepMonitor":false},"calls":{"useDataChannel":false,"enforcePlanB":true,"enforcePlanBPresentation":true,"useVideoMuteSlide":true,"useOnTrack":false,"useGalaxySignalingMiddleware":false,"collectMediaStats":false,"autoResolutionChange":false,"rtcPeerConnectionEnableChromiumDscp":false,"rtcRtpSenderEncodingParams":null},"persistence":{"enabled":true},"remoting":{"enableDataChannel":false,"send":null,"isDisplay":false}}, {
  get: function get(target, property) {
    var _proxiedConfig;

    return (0, _typeof2.default)(property) === 'symbol' ? proxiedConfig : (_proxiedConfig = proxiedConfig) === null || _proxiedConfig === void 0 ? void 0 : _proxiedConfig[property];
  }
});

exports.default = _default;

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return from; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10);
/* harmony import */ var _util_subscribeTo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97);
/* harmony import */ var _scheduled_scheduled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(157);
/** PURE_IMPORTS_START _Observable,_util_subscribeTo,_scheduled_scheduled PURE_IMPORTS_END */



function from(input, scheduler) {
    if (!scheduler) {
        if (input instanceof _Observable__WEBPACK_IMPORTED_MODULE_0__[/* Observable */ "a"]) {
            return input;
        }
        return new _Observable__WEBPACK_IMPORTED_MODULE_0__[/* Observable */ "a"](Object(_util_subscribeTo__WEBPACK_IMPORTED_MODULE_1__[/* subscribeTo */ "a"])(input));
    }
    else {
        return Object(_scheduled_scheduled__WEBPACK_IMPORTED_MODULE_2__[/* scheduled */ "a"])(input, scheduler);
    }
}
//# sourceMappingURL=from.js.map


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPrimaryJwt = exports.getPlatform = exports.oneTimeJwt = exports.aToken = exports.cnucJwt = exports.authError = void 0;

var _get = _interopRequireDefault(__webpack_require__(11));

var authError = function authError(state) {
  return (0, _get.default)(state, 'nucleus.auth.error');
};

exports.authError = authError;

var cnucJwt = function cnucJwt(state) {
  return (0, _get.default)(state, 'nucleus.auth.credentials.jwt');
};

exports.cnucJwt = cnucJwt;

var aToken = function aToken(state) {
  return (0, _get.default)(state, 'nucleus.token.A');
};

exports.aToken = aToken;

var oneTimeJwt = function oneTimeJwt(state) {
  return (0, _get.default)(state, 'nucleus.token.oneTimeJwt');
};

exports.oneTimeJwt = oneTimeJwt;

var getPlatform = function getPlatform(state) {
  return (0, _get.default)(state, 'nucleus.auth.platform');
}; // priority of jwt to use:
// 1) persisted jwt in nucleus.token.A
// 2) saved jwt in nucleus.auth.credentials.jwt (e.g. during login)


exports.getPlatform = getPlatform;

var getPrimaryJwt = function getPrimaryJwt(state) {
  return aToken(state) || oneTimeJwt(state) || cnucJwt(state);
};

exports.getPrimaryJwt = getPrimaryJwt;

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return emitter; });
/* unused harmony export INVALID_BUFFER */
/* unused harmony export UNDEFINED_INPUT_ERROR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return channel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return eventChannel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stdChannel; });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _buffers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76);
/* harmony import */ var _scheduler__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(118);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
var END = { type: CHANNEL_END_TYPE };
var isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};

function emitter() {
  var subscribers = [];

  function subscribe(sub) {
    subscribers.push(sub);
    return function () {
      return Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* remove */ "w"])(subscribers, sub);
    };
  }

  function emit(item) {
    var arr = subscribers.slice();
    for (var i = 0, len = arr.length; i < len; i++) {
      arr[i](item);
    }
  }

  return {
    subscribe: subscribe,
    emit: emit
  };
}

var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';

if (false) {}

function channel() {
  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _buffers__WEBPACK_IMPORTED_MODULE_1__[/* buffers */ "a"].fixed();

  var closed = false;
  var takers = [];

  Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* check */ "h"])(buffer, _utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].buffer, INVALID_BUFFER);

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* internalErr */ "p"])('Cannot have a closed channel with pending takers');
    }
    if (takers.length && !buffer.isEmpty()) {
      throw Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* internalErr */ "p"])('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    checkForbiddenStates();
    Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* check */ "h"])(input, _utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].notUndef, UNDEFINED_INPUT_ERROR);
    if (closed) {
      return;
    }
    if (!takers.length) {
      return buffer.put(input);
    }
    for (var i = 0; i < takers.length; i++) {
      var cb = takers[i];
      if (!cb[_utils__WEBPACK_IMPORTED_MODULE_0__[/* MATCH */ "b"]] || cb[_utils__WEBPACK_IMPORTED_MODULE_0__[/* MATCH */ "b"]](input)) {
        takers.splice(i, 1);
        return cb(input);
      }
    }
  }

  function take(cb) {
    checkForbiddenStates();
    Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* check */ "h"])(cb, _utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].func, "channel.take's callback must be a function");

    if (closed && buffer.isEmpty()) {
      cb(END);
    } else if (!buffer.isEmpty()) {
      cb(buffer.take());
    } else {
      takers.push(cb);
      cb.cancel = function () {
        return Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* remove */ "w"])(takers, cb);
      };
    }
  }

  function flush(cb) {
    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
    Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* check */ "h"])(cb, _utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].func, "channel.flush' callback must be a function");
    if (closed && buffer.isEmpty()) {
      cb(END);
      return;
    }
    cb(buffer.flush());
  }

  function close() {
    checkForbiddenStates();
    if (!closed) {
      closed = true;
      if (takers.length) {
        var arr = takers;
        takers = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          arr[i](END);
        }
      }
    }
  }

  return {
    take: take,
    put: put,
    flush: flush,
    close: close,
    get __takers__() {
      return takers;
    },
    get __closed__() {
      return closed;
    }
  };
}

function eventChannel(subscribe) {
  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _buffers__WEBPACK_IMPORTED_MODULE_1__[/* buffers */ "a"].none();
  var matcher = arguments[2];

  /**
    should be if(typeof matcher !== undefined) instead?
    see PR #273 for a background discussion
  **/
  if (arguments.length > 2) {
    Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* check */ "h"])(matcher, _utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].func, 'Invalid match function passed to eventChannel');
  }

  var chan = channel(buffer);
  var close = function close() {
    if (!chan.__closed__) {
      if (unsubscribe) {
        unsubscribe();
      }
      chan.close();
    }
  };
  var unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      close();
      return;
    }
    if (matcher && !matcher(input)) {
      return;
    }
    chan.put(input);
  });
  if (chan.__closed__) {
    unsubscribe();
  }

  if (!_utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].func(unsubscribe)) {
    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: close
  };
}

function stdChannel(subscribe) {
  var chan = eventChannel(function (cb) {
    return subscribe(function (input) {
      if (input[_utils__WEBPACK_IMPORTED_MODULE_0__[/* SAGA_ACTION */ "c"]]) {
        cb(input);
        return;
      }
      Object(_scheduler__WEBPACK_IMPORTED_MODULE_2__[/* asap */ "a"])(function () {
        return cb(input);
      });
    });
  });

  return _extends({}, chan, {
    take: function take(cb, matcher) {
      if (arguments.length > 1) {
        Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* check */ "h"])(matcher, _utils__WEBPACK_IMPORTED_MODULE_0__[/* is */ "q"].func, "channel.take's matcher argument must be a function");
        cb[_utils__WEBPACK_IMPORTED_MODULE_0__[/* MATCH */ "b"]] = matcher;
      }
      chan.take(cb);
    }
  });
}

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Observable */
/* harmony import */ var zen_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(295);
/* harmony import */ var zen_observable__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(zen_observable__WEBPACK_IMPORTED_MODULE_0__);


var Observable = zen_observable__WEBPACK_IMPORTED_MODULE_0___default.a;

/* harmony default export */ __webpack_exports__["a"] = (Observable);

//# sourceMappingURL=bundle.esm.js.map


/***/ }),
/* 34 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.potentialModeratorsFilter = potentialModeratorsFilter;
exports.potentialLecturersFilter = potentialLecturersFilter;
exports.availableContactsFilter = availableContactsFilter;
exports.availableUsersFilter = availableUsersFilter;
exports.chattableUsersFilter = chattableUsersFilter;
exports.usersAndRoomSystemsFilter = usersAndRoomSystemsFilter;
exports.usersAndContactsFilter = usersAndContactsFilter;
exports.usersFilter = usersFilter;
exports.availableUsersAndRoomSystemsFilter = availableUsersAndRoomSystemsFilter;
exports.meetingsFilter = meetingsFilter;
exports.roomSystemsAndMeetingsFilter = roomSystemsAndMeetingsFilter;
exports.favoritesFilter = favoritesFilter;
exports.nonFavoritesFilter = nonFavoritesFilter;
exports.getContactsByDialStringOrEmailGenerator = exports.getContactsByDialStringsGenerator = exports.getContactByUuidGenerator = exports.getContactByChatIdGenerator = exports.getContactByDialStringGenerator = exports.getContactsByIdsGenerator = exports.nonFavoritesSelector = exports.favoritesSelector = exports.roomSystemsAndMeetingsSelector = exports.isActiveMeeting = exports.activeMeetings = exports.myMeetings = exports.meetingsSelector = exports.availableRoomSystems = exports.roomSystemsSelector = exports.availableUsersAndRoomSystems = exports.usersAndRoomSystemsOutsideCallSelectorFilter = exports.usersAndRoomSystemsOutsideCallSelector = exports.usersAndRoomSystemsSelector = exports.chattableUsers = exports.availableUsers = exports.availableContacts = exports.myPersonalContacts = exports.potentialLecturers = exports.potentialModerators = exports.usersSelector = exports.mapIndividualContact = exports.initialContactsSelector = exports.mapInCallContacts = exports.rawFavoritesSelector = exports.contactsSelector = exports.getInviteUrlForExtension = exports.getDomain = exports.selectPagedLoads = exports.selectLoadContactsPageSize = exports.selectLoadContactsOnLogin = exports.selectErrorFetching = exports.selectContactsLoaded = void 0;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(81));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _get = _interopRequireDefault(__webpack_require__(11));

var _reselect = __webpack_require__(23);

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var C = _interopRequireWildcard(__webpack_require__(3));

var _feature = __webpack_require__(74);

var _account = __webpack_require__(91);

var _conferenceUtils = __webpack_require__(236);

var _contactUtils = __webpack_require__(144);

var _localeUtils = __webpack_require__(187);

var _partition4 = _interopRequireDefault(__webpack_require__(239));

var _schedulingUtils = __webpack_require__(188);

/** @module selectors/contacts */
var selectContactsLoaded = function selectContactsLoaded(state) {
  return (0, _safeAccess.default)(state, 'nucleus.contacts.contactsLoaded');
};

exports.selectContactsLoaded = selectContactsLoaded;

var selectErrorFetching = function selectErrorFetching(state) {
  return (0, _safeAccess.default)(state, 'nucleus.contacts.errorFetching');
};

exports.selectErrorFetching = selectErrorFetching;

var selectLoadContactsOnLogin = function selectLoadContactsOnLogin(state) {
  return (0, _safeAccess.default)(state, 'nucleus.contacts.loadContactsOnLogin');
};

exports.selectLoadContactsOnLogin = selectLoadContactsOnLogin;

var selectLoadContactsPageSize = function selectLoadContactsPageSize(state) {
  return (0, _safeAccess.default)(state, 'nucleus.contacts.loadContactsPageSize');
};

exports.selectLoadContactsPageSize = selectLoadContactsPageSize;

var selectPagedLoads = function selectPagedLoads(state) {
  return (0, _safeAccess.default)(state, 'nucleus.contacts.pagedLoads');
};

exports.selectPagedLoads = selectPagedLoads;

var userUUID = function userUUID(state) {
  var _state$nucleus, _state$nucleus$userPr;

  return (state === null || state === void 0 ? void 0 : (_state$nucleus = state.nucleus) === null || _state$nucleus === void 0 ? void 0 : (_state$nucleus$userPr = _state$nucleus.userProfile) === null || _state$nucleus$userPr === void 0 ? void 0 : _state$nucleus$userPr.uuid) || null;
};

var contactRecords = function contactRecords(state) {
  return (0, _safeAccess.default)(state, 'nucleus.contacts.records') || [];
};

var recordsRevision = function recordsRevision(state) {
  return (0, _safeAccess.default)(state, 'nucleus.contacts.recordsRevision') || 0;
};

var inCallStatusRevision = function inCallStatusRevision(state) {
  return (0, _safeAccess.default)(state, 'nucleus.contacts.inCallStatusRevision') || 0;
};

var sortFavorites = function sortFavorites(state) {
  return (0, _safeAccess.default)(state, 'nucleus.contacts.sortFavoritesFirst');
};

var galaxyConference = function galaxyConference(state) {
  return (0, _safeAccess.default)(state, 'nucleus.galaxy.conference') || {};
};

var getDomain = function getDomain(state) {
  return (0, _safeAccess.default)(state, 'nucleus.cluster.url') || '';
};

exports.getDomain = getDomain;

var favoriteRecords = function favoriteRecords(state) {
  return (0, _safeAccess.default)(state, 'nucleus.favorites.records') || [];
};

var favoriteOptimisticAdd = function favoriteOptimisticAdd(state) {
  return (0, _safeAccess.default)(state, 'nucleus.favorites.optimisticAdd') || [];
};

var favoriteOptimisticDelete = function favoriteOptimisticDelete(state) {
  return (0, _safeAccess.default)(state, 'nucleus.favorites.optimisticDelete') || [];
};

var favoriteRecordsRevision = function favoriteRecordsRevision(state) {
  return (0, _safeAccess.default)(state, 'nucleus.favorites.recordsRevision') || 0;
};

var getInviteUrlForExtension = function getInviteUrlForExtension(state, extension) {
  var domain = getDomain(state);
  var inviteUrl = (0, _schedulingUtils.getCallLink)(domain, extension);
  return inviteUrl;
};
/**
 * Selects all contacts from the redux store sorted alphabetically
 * @example
 * Returns...
 *  [
 *    { id: X, name: 'A' },
 *    { id: Y, name: 'B' },
 *    { id: Z, name: 'C' }
 *  ]
 */


exports.getInviteUrlForExtension = getInviteUrlForExtension;
var contactsSelector = (0, _reselect.createSelector)(contactRecords, inCallStatusRevision, recordsRevision, function (c) {
  return c;
});
exports.contactsSelector = contactsSelector;
var rawFavoritesSelector = (0, _reselect.createSelector)(favoriteRecords, favoriteOptimisticAdd, favoriteOptimisticDelete, favoriteRecordsRevision, function (records, addRecords, deleteRecords) {
  return records.concat(addRecords).filter(function (r) {
    return deleteRecords.findIndex(function (d) {
      return d.favoriteUUID === r.favoriteUUID;
    }) === -1;
  });
});
exports.rawFavoritesSelector = rawFavoritesSelector;
var mapInCallContacts = (0, _reselect.createSelector)(contactRecords, _feature.getFeatureFlags, function (contacts, featureFlags) {
  return (0, _reselect.defaultMemoize)(function (participants) {
    return contacts.map(function (contact) {
      return Object.assign({}, contact, (0, _contactUtils.getContactWithInCall)(contact, participants, featureFlags));
    });
  });
});
/** @todo figure out why this selector is so big. Candidate for splitting */

exports.mapInCallContacts = mapInCallContacts;
var initialContactsSelector = (0, _reselect.createSelector)(getDomain, _feature.getFeatureFlags, _account.getAccountSettings, userUUID, sortFavorites, function (domain, featureFlags, accountSettings, userUUID, sortFavoritesFirst) {
  return (0, _reselect.defaultMemoize)(function (contacts) {
    var _contacts;

    var sort = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var participants = (0, _conferenceUtils.callParticipants)(galaxyConference);
    var enableOfflineCalling = !!(featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags[C.FEATUREFLAG_ENABLE_OFFLINE_CALLING]);

    var legacyMapContact = function legacyMapContact(contact) {
      var _contact$owner, _contact$contactType, _contact$availability, _contact$moderator, _contact$lecturer, _contact$participants, _contact$owner2, _contact$availability2, _contact$availability3, _contact$availability4;

      if (!contact) return null;
      var contactOwnedByUser = !!(userUUID && userUUID === (contact === null || contact === void 0 ? void 0 : (_contact$owner = contact.owner) === null || _contact$owner === void 0 ? void 0 : _contact$owner.uuid));
      return (0, _objectSpread2.default)({}, contact, {
        hidden: (0, _get.default)(contact, 'hidden', false),
        contactType: contact === null || contact === void 0 ? void 0 : (_contact$contactType = contact.contactType) === null || _contact$contactType === void 0 ? void 0 : _contact$contactType.toUpperCase(),
        id: contact.uuid,
        jid: (accountSettings === null || accountSettings === void 0 ? void 0 : accountSettings.chatEnabled) && contact.jid || '',
        // This is true if this particular contact in the currently active call
        inCall: participants.some(function (p) {
          return p.dialString === contact.dialString;
        }),
        isChattable: !!((accountSettings === null || accountSettings === void 0 ? void 0 : accountSettings.chatEnabled) && contact.jid && !contact.isPinProtected),
        isMyMeeting: contactOwnedByUser,
        isMeeting: contact.type === 'Meeting',
        isUser: contact.type === 'User',
        isRoomSystem: contact.type === 'RoomSystem',
        isGroupContact: contact.type === 'GroupContact',
        isPersonalContact: contact.type === 'PersonalContact',
        isPinProtected: contact.isPinProtected || false,
        isOnline: ((_contact$availability = contact.availability) === null || _contact$availability === void 0 ? void 0 : _contact$availability.status) === 'AVAILABLE',
        moderatorID: (_contact$moderator = contact.moderator) === null || _contact$moderator === void 0 ? void 0 : _contact$moderator.uuid,
        lecturerID: (_contact$lecturer = contact.lecturer) === null || _contact$lecturer === void 0 ? void 0 : _contact$lecturer.uuid,
        participantsCount: ((_contact$participants = contact.participants) === null || _contact$participants === void 0 ? void 0 : _contact$participants.total) || 0,
        name: contact.displayName || contact.name,
        ownerID: (contact === null || contact === void 0 ? void 0 : (_contact$owner2 = contact.owner) === null || _contact$owner2 === void 0 ? void 0 : _contact$owner2.uuid) || null
      }, domain && contact.dialString ? {
        inviteURL: (0, _schedulingUtils.getCallLink)(domain, contact.dialString),
        otherWaysToCallURL: "https://call.".concat(domain, "/otherways/").concat(contact.dialString),
        sipUri: ['PersonalContact', 'GroupContact'].includes(contact.type) ? contact.dialString : "".concat(contact.dialString, "@").concat(domain)
      } : {}, {
        isEditable: !!(contact.meetingType !== 'TEMP' && (contact.type === 'PersonalContact' || contactOwnedByUser)),
        isDeletable: !!(contact.type === 'PersonalContact' || contactOwnedByUser),
        isCallable: participants.every(function (p) {
          return p.dialString !== contact.dialString;
        }) && (((_contact$availability2 = contact.availability) === null || _contact$availability2 === void 0 ? void 0 : _contact$availability2.status) === 'AVAILABLE' || enableOfflineCalling && contact.type === 'User'),
        presence: ((_contact$availability3 = contact.availability) === null || _contact$availability3 === void 0 ? void 0 : _contact$availability3.status) === 'UNAVAILABLE' ? 'NOT_AVAILABLE' : (_contact$availability4 = contact.availability) === null || _contact$availability4 === void 0 ? void 0 : _contact$availability4.status
      });
    };

    var contactsWithFlags = ((_contacts = contacts) !== null && _contacts !== void 0 ? _contacts : []).map(function (c) {
      return (0, _objectSpread2.default)({}, legacyMapContact(c), {
        owner: legacyMapContact(c.owner),
        lecturer: legacyMapContact(c.lecturer),
        moderator: legacyMapContact(c.moderator)
      });
    }); // if not sorting, return array as is

    if (!sort) return contactsWithFlags; // if not sorting favorites first, return the fully sorted array

    if (!sortFavoritesFirst) return (0, _localeUtils.localeSort)(contactsWithFlags); // if sorting favorites first, split into two arrays: favorites and the rest

    var _partition2 = (0, _partition4.default)(contactsWithFlags, function (c) {
      return !!c.favorite;
    }),
        _partition3 = (0, _slicedToArray2.default)(_partition2, 2),
        favorites = _partition3[0],
        rest = _partition3[1]; // sort arrays separately


    (0, _localeUtils.localeSort)(favorites);
    (0, _localeUtils.localeSort)(rest); // return concatenated arrays

    return favorites.concat(rest);
  });
});
exports.initialContactsSelector = initialContactsSelector;
var mapIndividualContact = (0, _reselect.createSelector)(initialContactsSelector, function (initialContactsSelector) {
  return (0, _reselect.defaultMemoize)(function (contact) {
    return initialContactsSelector([contact])[0];
  });
});
/**
 * Selects the users from the redux store sorted alphabetically
 * @example
 * Returns...
 * [
 *    { id: X, name: 'A' },
 *    { id: Y, name: 'B' },
 *    { id: Z, name: 'C' }
 *  ]
 */

exports.mapIndividualContact = mapIndividualContact;
var usersSelector = (0, _reselect.createSelector)(contactsSelector, function (contacts) {
  return contacts.filter(function (c) {
    return c.isUser || c.isGroupContact || c.isPersonalContact;
  });
});
/**
 * Potential Moderators selector
 * Selects the users and room systems who may be moderators of a VMR
 * @example
 * Returns...
 * [
 *    { id: X, name: 'A' },
 *    { id: Y, name: 'B' },
 *    { id: Z, name: 'C' }
 *  ]
 */

exports.usersSelector = usersSelector;
var potentialModerators = (0, _reselect.createSelector)(contactsSelector, function (contacts) {
  return contacts.filter(potentialModeratorsFilter);
});
exports.potentialModerators = potentialModerators;

function potentialModeratorsFilter(c) {
  return (c.isRoomSystem || c.isUser) && c.category !== 'PERSONAL' && c.category !== 'GROUP';
}
/**
 * Potential Lecturers selector
 * Selects the users or room systems who may be lecturers of a VMR
 * @example
 * Returns...
 * [
 *    { id: X, name: 'A' },
 *    { id: Y, name: 'B' },
 *    { id: Z, name: 'C' }
 *  ]
 */


var potentialLecturers = (0, _reselect.createSelector)(contactsSelector, function (contacts) {
  return contacts.filter(potentialLecturersFilter);
});
exports.potentialLecturers = potentialLecturers;

function potentialLecturersFilter(c) {
  return (c.isRoomSystem || c.isUser) && c.category !== 'PERSONAL' && c.category !== 'GROUP';
}
/**
 * Selects the personal contacts owned by the current user from the redux store sorted alphabetically
 * @example
 * Returns...
 * [
 *    { id: X, name: 'A' },
 *    { id: Y, name: 'B' },
 *    { id: Z, name: 'C' }
 *  ]
 */


var myPersonalContacts = (0, _reselect.createSelector)(contactsSelector, function (contacts) {
  return contacts.filter(function (c) {
    return c.isPersonalContact;
  });
});
/**
 * Selects the available contacts from the redux store sorted alphabetically
 * @example
 * Returns...
 * [
 *    { id: X, name: 'A' },
 *    { id: Y, name: 'B' },
 *    { id: Z, name: 'C' }
 *  ]
 */

exports.myPersonalContacts = myPersonalContacts;
var availableContacts = (0, _reselect.createSelector)(contactsSelector, function (contacts) {
  return contacts.filter(availableContactsFilter);
});
exports.availableContacts = availableContacts;

function availableContactsFilter(c) {
  return c.presence === C.CONTACT_AVAILABLE;
}
/**
 * Selects the available users from the redux store sorted alphabetically
 * @example
 * Returns...
 * [
 *    { id: X, name: 'A' },
 *    { id: Y, name: 'B' },
 *    { id: Z, name: 'C' }
 *  ]
 */


var availableUsers = (0, _reselect.createSelector)(contactsSelector, function (contacts) {
  return contacts.filter(availableUsersFilter);
});
exports.availableUsers = availableUsers;

function availableUsersFilter(c) {
  return c.isUser && c.presence === C.CONTACT_AVAILABLE;
}
/**
 * Selects the users who can be chatted with from the redux store sorted alphabetically
 * @example
 * Returns...
 * [
 *    { id: X, name: 'A' },
 *    { id: Y, name: 'B' },
 *    { id: Z, name: 'C' }
 *  ]
 */


var chattableUsers = (0, _reselect.createSelector)(contactsSelector, function (contacts) {
  return contacts.filter(chattableUsersFilter);
});
exports.chattableUsers = chattableUsers;

function chattableUsersFilter(c) {
  return c.isChattable;
}
/**
 * Selects the users and room systems from the redux store sorted alphabetically
 * @example
 * Returns...
 * [
 *    { id: X, name: 'A' },
 *    { id: Y, name: 'B' },
 *    { id: Z, name: 'C' }
 *  ]
 */


var usersAndRoomSystemsSelector = (0, _reselect.createSelector)(contactsSelector, function (contacts) {
  return contacts.filter(usersAndRoomSystemsFilter);
});
exports.usersAndRoomSystemsSelector = usersAndRoomSystemsSelector;

function usersAndRoomSystemsFilter(c) {
  return c.contactType !== C.CONTACT_TYPE_MEETING;
}

function usersAndContactsFilter(c) {
  return c.isUser || c.isPersonalContact || c.isGroupContact;
}

function usersFilter(c) {
  return c.isUser === true;
}
/**
 * Selects the users and room systems that are outside of the current call
 * from the redux store sorted alphabetically
 * @example
 * Returns...
 * [
 *    { id: X, name: 'A' },
 *    { id: Y, name: 'B' },
 *    { id: Z, name: 'C' }
 *  ]
 */


var usersAndRoomSystemsOutsideCallSelector = (0, _reselect.createSelector)(contactsSelector, function (contacts) {
  return contacts.filter(usersAndRoomSystemsOutsideCallSelectorFilter);
});
exports.usersAndRoomSystemsOutsideCallSelector = usersAndRoomSystemsOutsideCallSelector;

var usersAndRoomSystemsOutsideCallSelectorFilter = function usersAndRoomSystemsOutsideCallSelectorFilter(c) {
  return c.isCallable && !meetingsFilter(c);
};
/**
 * Selects the available users and room systems from the redux store sorted alphabetically
 * @example
 * Returns...
 * [
 *    { id: X, name: 'A' },
 *    { id: Y, name: 'B' },
 *    { id: Z, name: 'C' }
 *  ]
 */


exports.usersAndRoomSystemsOutsideCallSelectorFilter = usersAndRoomSystemsOutsideCallSelectorFilter;
var availableUsersAndRoomSystems = (0, _reselect.createSelector)(contactsSelector, function (contacts) {
  return contacts.filter(availableUsersAndRoomSystemsFilter);
});
exports.availableUsersAndRoomSystems = availableUsersAndRoomSystems;

function availableUsersAndRoomSystemsFilter(c) {
  return c.contactType !== C.CONTACT_TYPE_MEETING && c.isCallable;
}
/**
 * Selects the roomSystems from the redux store sorted alphabetically
 * @example
 * Returns...
 * [
 *    { id: X, name: 'A' },
 *    { id: Y, name: 'B' },
 *    { id: Z, name: 'C' }
 * ]
 */


var roomSystemsSelector = (0, _reselect.createSelector)(contactsSelector, function (contacts) {
  return contacts.filter(function (c) {
    return c.isRoomSystem;
  });
});
/**
 * Selects the available room systems from the redux store sorted alphabetically
 * @example
 * Returns...
 * [
 *    { id: X, name: 'A' },
 *    { id: Y, name: 'B' },
 *    { id: Z, name: 'C' }
 * ]
 */

exports.roomSystemsSelector = roomSystemsSelector;
var availableRoomSystems = (0, _reselect.createSelector)(contactsSelector, function (contacts) {
  return contacts.filter(function (c) {
    return c.isRoomSystem && c.isCallable;
  });
});
/**
 * Selects the meetings from the redux store sorted alphabetically
 * @example
 * Returns...
 * [
 *    { id: X, name: 'A' },
 *    { id: Y, name: 'B' },
 *    { id: Z, name: 'C' }
 *  ]
 */

exports.availableRoomSystems = availableRoomSystems;
var meetingsSelector = (0, _reselect.createSelector)(contactsSelector, function (contacts) {
  return contacts.filter(meetingsFilter);
});
exports.meetingsSelector = meetingsSelector;

var myMeetingFilter = function myMeetingFilter(c) {
  return c.isMyMeeting;
};

function meetingsFilter(c) {
  return c.isMeeting;
}
/**
 * Selects the meetings owned by the current user from the redux store sorted alphabetically
 * @example
 * Returns...
 * [
 *    { id: X, name: 'A' },
 *    { id: Y, name: 'B' },
 *    { id: Z, name: 'C' }
 *  ]
 */


var myMeetings = (0, _reselect.createSelector)(contactsSelector, function (contacts) {
  return contacts.filter(function (c) {
    return meetingsFilter(c) && myMeetingFilter(c);
  });
});
/**
 * Selects the active meetings (meetings with active participants) from the redux store sorted alphabetically
 * @example
 * Returns...
 * [
 *    { id: X, name: 'A' },
 *    { id: Y, name: 'B' },
 *    { id: Z, name: 'C' }
 *  ]
 */

exports.myMeetings = myMeetings;
var activeMeetings = (0, _reselect.createSelector)(contactsSelector, function (contacts) {
  return contacts.filter(function (c) {
    return meetingsFilter(c) && isActiveMeeting(c);
  });
});
exports.activeMeetings = activeMeetings;

var isActiveMeeting = function isActiveMeeting(c) {
  return meetingsFilter(c) && c.participantsCount > 0;
};
/**
 * Selects the roomSystems and meetings from the redux store sorted alphabetically
 * @example
 * Returns...
 * [
 *    { id: X, name: 'A' },
 *    { id: Y, name: 'B' },
 *    { id: Z, name: 'C' }
 * ]
 */


exports.isActiveMeeting = isActiveMeeting;
var roomSystemsAndMeetingsSelector = (0, _reselect.createSelector)(contactsSelector, function (contacts) {
  return contacts.filter(function (c) {
    return meetingsFilter(c) && roomSystemsAndMeetingsFilter(c);
  });
});
exports.roomSystemsAndMeetingsSelector = roomSystemsAndMeetingsSelector;

function roomSystemsAndMeetingsFilter(c) {
  return meetingsFilter(c) || c.isRoomSystem;
}
/**
 * Selects the favorites from the redux store sorted alphabetically
 * @example
 * Returns...
 * [
 *    { id: X, name: 'A' },
 *    { id: Y, name: 'B' },
 *    { id: Z, name: 'C' }
 * ]
 */


var favoritesSelector = (0, _reselect.createSelector)(contactsSelector, function (contacts) {
  return contacts.filter(favoritesFilter);
});
exports.favoritesSelector = favoritesSelector;

function favoritesFilter(c) {
  return c.favorite;
}
/**
 * Selects the non-favorites from the redux store sorted alphabetically
 * @example
 * Returns...
 * [
 *    { id: X, name: 'A' },
 *    { id: Y, name: 'B' },
 *    { id: Z, name: 'C' }
 * ]
 */


var nonFavoritesSelector = (0, _reselect.createSelector)(contactsSelector, function (contacts) {
  return contacts.filter(nonFavoritesFilter);
});
exports.nonFavoritesSelector = nonFavoritesSelector;

function nonFavoritesFilter(c) {
  return !c.favorite && c.meetingType !== C.MEETING_TYPE_ONE_TIME;
}
/**
 * getContactsByIdsGenerator -
 * Returns a function that accepts the ids of contacts you wish to retrieve.
 * @param {object} state - state of the application
 * @param {Array} ids - contact Ids to select using
 * @example
 * import { contactSelectors } from 'lifesize-sky-nucleus'
 *
 * function mapStateToProps(state) {
 *   const getContactsByIds = contactSelectors.getContactsByIdsGenerator(state);
 *   const selectedContacts = getContactsByIds(['X', 'Y']);
 * }
 *
 * // ShortHand:
 * function mapStateToProps(state) {
 *   const selectedContacts = contactSelectors.getContactsByIdsGenerator(state)(['X', 'Y']);
 * }
 *
 * // Returns...
 * // [{
 * //   id: 'X',
 * //   name: 'A'
 * // },
 * // {
 * //   id: 'Y',
 * //   name: 'B'
 * // }]
 */


var getContactsByIdsGenerator = (0, _reselect.createSelector)(contactsSelector, function (contacts) {
  return (0, _reselect.defaultMemoize)(function (ids) {
    if (!ids) return [];
    if (!Array.isArray(ids)) ids = [ids];
    return contacts.filter(function (c) {
      return ids.indexOf(c.uuid) > -1;
    });
  });
});
/**
 * getContactByDialStringGenerator -
 * Returns a function that accepts the dial string of contacts you wish to retrieve.
 * @param {object} state - contact Id to select using
 * @param {string} dialString - contact dialString to select using
 * @example
 * import { contactSelectors } from 'lifesize-sky-nucleus'
 *
 * function mapStateToProps(state) {
 *   const getContactByDialString = contactSelectors.getContactByDialStringGenerator(state);
 *   const selectedContact = getContactByDialString('X');
 * }
 *
 * // ShortHand:
 * function mapStateToProps(state) {
 *   const selectedContacts = contactSelectors.getContactByDialStringGenerator(state)('X');
 * }
 *
 * // Returns...
 * // {
 * //   dialString: 'X',
 * //   name: 'A'
 * // }
 */

exports.getContactsByIdsGenerator = getContactsByIdsGenerator;
var getContactByDialStringGenerator = (0, _reselect.createSelector)(contactsSelector, function (contacts) {
  return (0, _reselect.defaultMemoize)(function (dialString) {
    if (!dialString) return undefined;
    return contacts.find(function (c) {
      return c.dialString === dialString;
    });
  });
});
/**
 * getContactByChatIdGenerator -
 * Returns a function that accepts the chat id of the contact you wish to
 * retrieve. This ID only exists for meeting contacts
 * @param {object} state - contact Id to select using
 * @param {string} chatId - the chat id
 * @example
 * import { contactSelectors } from 'lifesize-sky-nucleus'
 *
 * function mapStateToProps(state) {
 *   const getMeeting = contactSelectors.getContactByChatIdGenerator(state);
 *   const meeting = getMeeting('X');
 * }
 *
 * // Returns...
 * // {
 * //   dialString: 'X',
 * //   name: 'A'
 * // }
 */

exports.getContactByDialStringGenerator = getContactByDialStringGenerator;
var getContactByChatIdGenerator = (0, _reselect.createSelector)(contactsSelector, function (contacts) {
  return (0, _reselect.defaultMemoize)(function (chatId) {
    if (!chatId) return null;
    return contacts.find(function (c) {
      return c.jid === chatId;
    });
  });
});
/**
 * getContactByUuidGenerator -
 * Returns a function that accepts the uuid of the contact you wish to retrieve.
 * @param {object} state - contact Id to select using
 * @param {string} uuid - the user's uuid
 * @example
 * import { contactSelectors } from `@lifesize/nucleus`;
 *
 * function mapStateToProps(state, ownProps) {
 *   const getUser = contactSelectors.getContactByUuidGenerator(state);
 *   const user = getUser(ownProps.uuid);
 * }
 */

exports.getContactByChatIdGenerator = getContactByChatIdGenerator;

var getContactByUuidGenerator = function getContactByUuidGenerator(state) {
  return function (uuid) {
    if (!uuid) return null;
    var contacts = contactsSelector(state);
    return contacts.find(function (c) {
      return c.uuid === uuid;
    });
  };
};
/**
 * getContactsByDialStringsGenerator -
 * Returns a function that accepts the ids of contacts you wish to retrieve.
 * @param {object} state - state of the application
 * @param {Array} dialStrings - contact dial strings to select using
 * @example
 * import { contactSelectors } from 'lifesize-sky-nucleus'
 *
 * function mapStateToProps(state) {
 *   const getContactsByDialStrings = contactSelectors.getContactsByDialStringsGenerator(state);
 *   const selectedContacts = getContactsByDialStrings(['X', 'Y']);
 * }
 *
 * // ShortHand:
 * function mapStateToProps(state) {
 *   const selectedContacts = contactSelectors.getContactsByDialStringsGenerator(state)(['X', 'Y']);
 * }
 *
 * // Returns...
 * // [{
 * //   dialString: 'X',
 * //   name: 'A'
 * // },
 * // {
 * //   dialString: 'Y',
 * //   name: 'B'
 * // }]
 */


exports.getContactByUuidGenerator = getContactByUuidGenerator;
var getContactsByDialStringsGenerator = (0, _reselect.createSelector)(contactsSelector, function (contacts) {
  return (0, _reselect.defaultMemoize)(function (dialStrings) {
    if (!dialStrings) return [];
    if (!Array.isArray(dialStrings)) dialStrings = [dialStrings];
    return contacts.filter(function (c) {
      return dialStrings.indexOf(c.dialString) > -1;
    });
  });
});
exports.getContactsByDialStringsGenerator = getContactsByDialStringsGenerator;
var getContactsByDialStringOrEmailGenerator = (0, _reselect.createSelector)(contactsSelector, function (contacts) {
  return (0, _reselect.defaultMemoize)(function (ids) {
    if (!ids) return [];
    if (!Array.isArray(ids)) ids = [ids]; // Using a 'reduce' here to preserve the order of the ids provided.
    // The 'contacts' is an alpha sorted list, so applying a 'filter'
    // would return an alpha sorted list of contacts with matching ids.

    return ids.reduce(function (results, id) {
      var found = contacts.find(function (c) {
        // most common
        var foundDialString = id === c.dialString || id === c.extension;
        if (foundDialString) return true; // less common

        var foundEmail = id === c.email;
        if (foundEmail) return true;
        return false;
      });
      if (found) results.push(found);
      return results;
    }, []);
  });
});
exports.getContactsByDialStringOrEmailGenerator = getContactsByDialStringOrEmailGenerator;

/***/ }),
/* 36 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.myInfo = exports.getClientType = exports.getUserUUID = exports.isUnauthorized = exports.selectUserProfile = void 0;

var _get2 = _interopRequireDefault(__webpack_require__(11));

var _reselect = __webpack_require__(23);

var _countryNumbers = __webpack_require__(428);

var _pstnNumbers = __webpack_require__(242);

var _userProfile = __webpack_require__(52);

var c = _interopRequireWildcard(__webpack_require__(3));

var utils = _interopRequireWildcard(__webpack_require__(188));

/** @module selectors/currentUser */
var provisioning = function provisioning(state) {
  return (0, _get2.default)(state, 'nucleus.provisioning') || {};
};

var selectUserProfile = function selectUserProfile(state) {
  return (0, _get2.default)(state, 'nucleus.userProfile') || {};
};

exports.selectUserProfile = selectUserProfile;

var userSettings = function userSettings(state) {
  return (0, _get2.default)(state, 'nucleus.userSettings') || {};
};

var getAccount = function getAccount(state) {
  return (0, _get2.default)(state, 'nucleus.account') || {};
};

var doNotDisturb = function doNotDisturb(state) {
  return (0, _get2.default)(state, 'nucleus.doNotDisturb') || false;
};

var domain = function domain(state) {
  return (0, _get2.default)(state, 'nucleus.cluster.url') || '';
};

var isUnauthorized = function isUnauthorized(state) {
  return (0, _get2.default)(selectUserProfile(state), 'error') === c.UNAUTHORIZED;
};

exports.isUnauthorized = isUnauthorized;

var getUserUUID = function getUserUUID(state) {
  return (0, _get2.default)(selectUserProfile(state), 'uuid') || {};
};

exports.getUserUUID = getUserUUID;

var getClientType = function getClientType(state) {
  return (0, _get2.default)(selectUserProfile(state), 'clientInfo.clientType') || '';
};
/**
 * Determines the presence for the current user if connected to Galaxy.
 * @todo Make this the default call when PSEMS is deprecated.
 * @param {boolean} doNotDisturb
 */


exports.getClientType = getClientType;

var getGalaxyPresence = function getGalaxyPresence(doNotDisturb) {
  return doNotDisturb ? c.CONTACT_DO_NOT_DISTURB : c.CONTACT_AVAILABLE;
};
/**
 * myInfo selector - Selects the relevant information for the current user
 * This is an amalgamation of CSS provisioning data, MMS user profile, and datawarehouse values.
 * @todo figure out why we are adding pstn numbers to this when there are selectors specifically for them
 * @todo figure out why this selector has so many things in general.
 * @example
 * Returns...
 * {
 *  context: 'USER' // USER, DEVICE
 *  dialString: '1234',
 *  doNotDisturb: ,
 *  email: 'user@domain.com',
 *  groupId: '456',
 *  id: 'CONTACTID',
 *  isSuperUser: true,
 *  name: 'display name',
 *  phoneNumbers: [{ phoneNumber: '1 800-555-5555', countryCode: 'US', countryName: 'United States' }],
 *  role: 'ADMIN', // ADMIN, SUPER_USER, USER, DEVICE
 *  video: '1234@lifesizecloud.com'
 * }
 */


var myInfo = (0, _reselect.createSelector)(provisioning, domain, selectUserProfile, userSettings, _pstnNumbers.pstnNumbersWithCountryName, doNotDisturb, _countryNumbers.additionalNumbersPrefix, getAccount, _userProfile.selectIsGuest, function (provisioning, domain, userProfile, userSettings, pstnNumbers, doNotDisturb, prefix, account, isGuest) {
  var extension = provisioning.defExtension || userProfile.extension;
  var sipAlias = provisioning.defSip_Alias || extension && "".concat(extension, "@").concat(domain);
  var recordingUrl = (0, _get2.default)(account, 'settings.recordingUrl') || (0, _get2.default)(provisioning, 'vcRecordingURL');
  return {
    additionalNumbersURL: utils.getAdditionalNumbersUrl(domain, prefix) || '',
    canCreateOneTimeMeetings: !isGuest,
    context: userProfile.context,
    dialString: extension,
    doNotDisturb: doNotDisturb,
    email: userProfile.email,
    groupId: userProfile.groupUuid,
    id: userProfile.uuid,
    inviteURL: utils.getCallLink(domain, extension),
    isDevice: userProfile.context === c.USER_CONTEXT_DEVICE,
    // also available in userProfile.role
    isGuest: isGuest,
    isSuperUser: userProfile.role === c.USER_ROLE_ADMIN || userProfile.role === c.USER_ROLE_SUPER_USER,
    joinedAt: userProfile.joinedAt,
    localeCode: userProfile.localeCode,
    name: userProfile.name,
    otherWaysToCallURL: utils.getOtherWaysToCallLink(domain, extension),
    phoneNumbers: pstnNumbers,
    presence: getGalaxyPresence(doNotDisturb),
    recordingUrl: recordingUrl,
    role: userProfile.role,
    subscriptionTier: account.tier,
    userProfileError: userProfile.error,
    userSettings: userSettings,
    userUUID: userProfile.uuid,
    userUuid: userProfile.uuid,
    video: sipAlias
  };
});
exports.myInfo = myInfo;

/***/ }),
/* 38 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Record"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"contactType"},"name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"uuid"},"name":{"kind":"Name","value":"UUID"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallableFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Callable"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hidden"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"displayName"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"displayName"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"dialString"},"name":{"kind":"Name","value":"dialstring"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"extension"},"name":{"kind":"Name","value":"dialstring"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"availability"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"isFavoritable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isCloudAccount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"jid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"favorite"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":325}};
    doc.loc.source = {"body":"fragment IdFields on Record {\n  type: __typename\n  contactType: __typename\n  uuid: UUID\n}\n\nfragment CallableFields on Callable {\n  hidden\n  displayName\n  name: displayName\n  dialString: dialstring\n  extension: dialstring\n  availability {\n    status\n  }\n  isFavoritable\n  isCloudAccount\n  jid\n  favorite {\n    createdAt\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InnerSubscriber; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


var InnerSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"](InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        _this.index = 0;
        return _this;
    }
    InnerSubscriber.prototype._next = function (value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function (error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function () {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__[/* Subscriber */ "a"]));

//# sourceMappingURL=InnerSubscriber.js.map


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApolloLink", function() { return ApolloLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "concat", function() { return concat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createOperation", function() { return createOperation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "empty", function() { return empty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "execute", function() { return execute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "from", function() { return from; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromError", function() { return fromError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromPromise", function() { return fromPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makePromise", function() { return makePromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "split", function() { return split; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toPromise", function() { return toPromise; });
/* harmony import */ var zen_observable_ts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Observable", function() { return zen_observable_ts__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var ts_invariant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
/* harmony import */ var apollo_utilities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getOperationName", function() { return apollo_utilities__WEBPACK_IMPORTED_MODULE_3__["n"]; });








function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context',
    ];
    for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) {
            throw  true ? new ts_invariant__WEBPACK_IMPORTED_MODULE_1__[/* InvariantError */ "a"](2) : undefined;
        }
    }
    return operation;
}
var LinkError = (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __extends */ "c"])(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error));
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function (resolve, reject) {
        observable.subscribe({
            next: function (data) {
                if (completed) {
                     true || false;
                }
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject,
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new zen_observable_ts__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"](function (observer) {
        promise
            .then(function (value) {
            observer.next(value);
            observer.complete();
        })
            .catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new zen_observable_ts__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"](function (observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query,
    };
    if (!transformedOperation.operationName) {
        transformedOperation.operationName =
            typeof transformedOperation.query !== 'string'
                ? Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_3__[/* getOperationName */ "n"])(transformedOperation.query)
                : '';
    }
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __assign */ "a"])({}, starting);
    var setContext = function (next) {
        if (typeof next === 'function') {
            context = Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __assign */ "a"])({}, context, next(context));
        }
        else {
            context = Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __assign */ "a"])({}, context, next);
        }
    };
    var getContext = function () { return (Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __assign */ "a"])({}, context)); };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext,
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext,
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function () { return getKey(operation); },
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([operationName, query, variables]);
}

function passthrough(op, forward) {
    return forward ? forward(op) : zen_observable_ts__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function () { return zen_observable_ts__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].of(); });
}
function from(links) {
    if (links.length === 0)
        return empty();
    return links.map(toLink).reduce(function (x, y) { return x.concat(y); });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) {
        return new ApolloLink(function (operation) {
            return test(operation)
                ? leftLink.request(operation) || zen_observable_ts__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].of()
                : rightLink.request(operation) || zen_observable_ts__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].of();
        });
    }
    else {
        return new ApolloLink(function (operation, forward) {
            return test(operation)
                ? leftLink.request(operation, forward) || zen_observable_ts__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].of()
                : rightLink.request(operation, forward) || zen_observable_ts__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].of();
        });
    }
}
var concat = function (first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) {
         true || false;
        return firstLink;
    }
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) {
        return new ApolloLink(function (operation) {
            return firstLink.request(operation, function (op) { return nextLink.request(op) || zen_observable_ts__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].of(); }) || zen_observable_ts__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].of();
        });
    }
    else {
        return new ApolloLink(function (operation, forward) {
            return (firstLink.request(operation, function (op) {
                return nextLink.request(op, forward) || zen_observable_ts__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].of();
            }) || zen_observable_ts__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].of());
        });
    }
};
var ApolloLink = (function () {
    function ApolloLink(request) {
        if (request)
            this.request = request;
    }
    ApolloLink.prototype.split = function (test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function (next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function (operation, forward) {
        throw  true ? new ts_invariant__WEBPACK_IMPORTED_MODULE_1__[/* InvariantError */ "a"](1) : undefined;
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}());
function execute(link, operation) {
    return (link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || zen_observable_ts__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].of());
}


//# sourceMappingURL=bundle.esm.js.map


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return config; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var _enable_super_gross_mode_that_will_cause_bad_things = false;
var config = {
    Promise: undefined,
    set useDeprecatedSynchronousErrorHandling(value) {
        if (value) {
            var error = /*@__PURE__*/ new Error();
            /*@__PURE__*/ console.warn('DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n' + error.stack);
        }
        else if (_enable_super_gross_mode_that_will_cause_bad_things) {
            /*@__PURE__*/ console.log('RxJS: Back to a better error behavior. Thank you. <3');
        }
        _enable_super_gross_mode_that_will_cause_bad_things = value;
    },
    get useDeprecatedSynchronousErrorHandling() {
        return _enable_super_gross_mode_that_will_cause_bad_things;
    },
};
//# sourceMappingURL=config.js.map


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return identity; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function identity(x) {
    return x;
}
//# sourceMappingURL=identity.js.map


/***/ }),
/* 43 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDesktop = isDesktop;
exports.isMobile = isMobile;
exports.isGems = isGems;
exports.isWebRtcNative = isWebRtcNative;
exports.isIE11 = isIE11;
exports.getChromeDesktopConstraints = getChromeDesktopConstraints;
exports.getChromeDisplayConstraints = getChromeDisplayConstraints;
exports.getMobileVideoMuteConstraints = getMobileVideoMuteConstraints;
exports.isWindows = isWindows;

var _get = _interopRequireDefault(__webpack_require__(11));

var c = _interopRequireWildcard(__webpack_require__(3));

function isDesktop(platform) {
  return [c.PLATFORM_WINDOWS, c.PLATFORM_OSX].indexOf(platform) > -1;
}

function isMobile(platform) {
  return [c.PLATFORM_IOS, c.PLATFORM_ANDROID].indexOf(platform) > -1;
}

function isGems(platform) {
  return [c.PLATFORM_ICON_300, c.PLATFORM_ICON_500, c.PLATFORM_ICON_700, c.PLATFORM_ICON_900].includes(platform);
}

function isWebRtcNative(platform) {
  return isMobile(platform) || isGems(platform);
}

function isIE11() {
  return !window.ActiveXObject && 'ActiveXObject' in window;
}

function getChromeDesktopConstraints(sourceId) {
  return {
    audio: false,
    video: {
      mandatory: {
        chromeMediaSource: 'desktop',
        chromeMediaSourceId: sourceId,
        maxWidth: 1920,
        maxHeight: 1080,
        maxFrameRate: 30
      }
    }
  };
}

function getChromeDisplayConstraints() {
  return {
    audio: false,
    video: {
      width: {
        max: 1920,
        ideal: 1920
      },
      height: {
        max: 1080,
        ideal: 1080
      },
      frameRate: {
        max: 30,
        ideal: 30
      }
    }
  };
}

function getMobileVideoMuteConstraints() {
  return {
    audio: false,
    video: {
      mandatory: {
        videoMuteMobile: true
      }
    }
  };
}

function isWindows() {
  return ((0, _get.default)(navigator, 'appVersion') || '').indexOf('Win') != -1;
}

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filter; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new FilterOperator(predicate, thisArg));
    };
}
var FilterOperator = /*@__PURE__*/ (function () {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}());
var FilterSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"](FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.count = 0;
        return _this;
    }
    FilterSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this.destination.next(value);
        }
    };
    return FilterSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__[/* Subscriber */ "a"]));
//# sourceMappingURL=filter.js.map


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NotificationKind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Notification; });
/* harmony import */ var _observable_empty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28);
/* harmony import */ var _observable_of__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86);
/* harmony import */ var _observable_throwError__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(108);
/** PURE_IMPORTS_START _observable_empty,_observable_of,_observable_throwError PURE_IMPORTS_END */



var NotificationKind;
/*@__PURE__*/ (function (NotificationKind) {
    NotificationKind["NEXT"] = "N";
    NotificationKind["ERROR"] = "E";
    NotificationKind["COMPLETE"] = "C";
})(NotificationKind || (NotificationKind = {}));
var Notification = /*@__PURE__*/ (function () {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    Notification.prototype.observe = function (observer) {
        switch (this.kind) {
            case 'N':
                return observer.next && observer.next(this.value);
            case 'E':
                return observer.error && observer.error(this.error);
            case 'C':
                return observer.complete && observer.complete();
        }
    };
    Notification.prototype.do = function (next, error, complete) {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return next && next(this.value);
            case 'E':
                return error && error(this.error);
            case 'C':
                return complete && complete();
        }
    };
    Notification.prototype.accept = function (nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === 'function') {
            return this.observe(nextOrObserver);
        }
        else {
            return this.do(nextOrObserver, error, complete);
        }
    };
    Notification.prototype.toObservable = function () {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return Object(_observable_of__WEBPACK_IMPORTED_MODULE_1__[/* of */ "a"])(this.value);
            case 'E':
                return Object(_observable_throwError__WEBPACK_IMPORTED_MODULE_2__[/* throwError */ "a"])(this.error);
            case 'C':
                return Object(_observable_empty__WEBPACK_IMPORTED_MODULE_0__[/* empty */ "b"])();
        }
        throw new Error('unexpected notification kind value');
    };
    Notification.createNext = function (value) {
        if (typeof value !== 'undefined') {
            return new Notification('N', value);
        }
        return Notification.undefinedValueNotification;
    };
    Notification.createError = function (err) {
        return new Notification('E', undefined, err);
    };
    Notification.createComplete = function () {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    Notification.undefinedValueNotification = new Notification('N', undefined);
    return Notification;
}());

//# sourceMappingURL=Notification.js.map


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getSymbolIterator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return iterator; });
/* unused harmony export $$iterator */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function getSymbolIterator() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) {
        return '@@iterator';
    }
    return Symbol.iterator;
}
var iterator = /*@__PURE__*/ getSymbolIterator();
var $$iterator = iterator;
//# sourceMappingURL=iterator.js.map


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return noop; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function noop() { }
//# sourceMappingURL=noop.js.map


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.visit = visit;
exports.visitInParallel = visitInParallel;
exports.visitWithTypeInfo = visitWithTypeInfo;
exports.getVisitFn = getVisitFn;
exports.BREAK = exports.QueryDocumentKeys = void 0;

var _inspect = _interopRequireDefault(__webpack_require__(255));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: ['name', // Note: fragment variable definitions are experimental and may be changed
  // or removed in the future.
  'variableDefinitions', 'typeCondition', 'directives', 'selectionSet'],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: ['description', 'name', 'type', 'defaultValue', 'directives'],
  InterfaceTypeDefinition: ['description', 'name', 'directives', 'fields'],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields']
};
exports.QueryDocumentKeys = QueryDocumentKeys;
var BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */

exports.BREAK = BREAK;

function visit(root, visitor) {
  var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QueryDocumentKeys;

  /* eslint-disable no-undef-init */
  var stack = undefined;
  var inArray = Array.isArray(root);
  var keys = [root];
  var index = -1;
  var edits = [];
  var node = undefined;
  var key = undefined;
  var parent = undefined;
  var path = [];
  var ancestors = [];
  var newRoot = root;
  /* eslint-enable no-undef-init */

  do {
    index++;
    var isLeaving = index === keys.length;
    var isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
        } else {
          var clone = {};

          for (var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++) {
            var k = _Object$keys2[_i2];
            clone[k] = node[k];
          }

          node = clone;
        }

        var editOffset = 0;

        for (var ii = 0; ii < edits.length; ii++) {
          var editKey = edits[ii][0];
          var editValue = edits[ii][1];

          if (inArray) {
            editKey -= editOffset;
          }

          if (inArray && editValue === null) {
            node.splice(editKey, 1);
            editOffset++;
          } else {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else {
      key = parent ? inArray ? index : keys[index] : undefined;
      node = parent ? parent[key] : newRoot;

      if (node === null || node === undefined) {
        continue;
      }

      if (parent) {
        path.push(key);
      }
    }

    var result = void 0;

    if (!Array.isArray(node)) {
      if (!isNode(node)) {
        throw new Error('Invalid AST Node: ' + (0, _inspect.default)(node));
      }

      var visitFn = getVisitFn(visitor, node.kind, isLeaving);

      if (visitFn) {
        result = visitFn.call(visitor, node, key, parent, path, ancestors);

        if (result === BREAK) {
          break;
        }

        if (result === false) {
          if (!isLeaving) {
            path.pop();
            continue;
          }
        } else if (result !== undefined) {
          edits.push([key, result]);

          if (!isLeaving) {
            if (isNode(result)) {
              node = result;
            } else {
              path.pop();
              continue;
            }
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      stack = {
        inArray: inArray,
        index: index,
        keys: keys,
        edits: edits,
        prev: stack
      };
      inArray = Array.isArray(node);
      keys = inArray ? node : visitorKeys[node.kind] || [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    newRoot = edits[edits.length - 1][1];
  }

  return newRoot;
}

function isNode(maybeNode) {
  return Boolean(maybeNode && typeof maybeNode.kind === 'string');
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */


function visitInParallel(visitors) {
  var skipping = new Array(visitors.length);
  return {
    enter: function enter(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (!skipping[i]) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          false);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      }
    },
    leave: function leave(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (!skipping[i]) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          true);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          }
        } else if (skipping[i] === node) {
          skipping[i] = null;
        }
      }
    }
  };
}
/**
 * Creates a new visitor instance which maintains a provided TypeInfo instance
 * along with visiting visitor.
 */


function visitWithTypeInfo(typeInfo, visitor) {
  return {
    enter: function enter(node) {
      typeInfo.enter(node);
      var fn = getVisitFn(visitor, node.kind,
      /* isLeaving */
      false);

      if (fn) {
        var result = fn.apply(visitor, arguments);

        if (result !== undefined) {
          typeInfo.leave(node);

          if (isNode(result)) {
            typeInfo.enter(result);
          }
        }

        return result;
      }
    },
    leave: function leave(node) {
      var fn = getVisitFn(visitor, node.kind,
      /* isLeaving */
      true);
      var result;

      if (fn) {
        result = fn.apply(visitor, arguments);
      }

      typeInfo.leave(node);
      return result;
    }
  };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */


function getVisitFn(visitor, kind, isLeaving) {
  var kindVisitor = visitor[kind];

  if (kindVisitor) {
    if (!isLeaving && typeof kindVisitor === 'function') {
      // { Kind() {} }
      return kindVisitor;
    }

    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;

    if (typeof kindSpecificVisitor === 'function') {
      // { Kind: { enter() {}, leave() {} } }
      return kindSpecificVisitor;
    }
  } else {
    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;

    if (specificVisitor) {
      if (typeof specificVisitor === 'function') {
        // { enter() {}, leave() {} }
        return specificVisitor;
      }

      var specificKindVisitor = specificVisitor[kind];

      if (typeof specificKindVisitor === 'function') {
        // { enter: { Kind() {} }, leave: { Kind() {} } }
        return specificKindVisitor;
      }
    }
  }
}


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.call = call;
exports.webConferenceCall = webConferenceCall;
exports.enableFarEndAudio = enableFarEndAudio;
exports.clearCall = clearCall;
exports.cancel = cancel;
exports.answer = answer;
exports.add = add;
exports.endAndAnswer = endAndAnswer;
exports.kick = kick;
exports.kickAll = kickAll;
exports.startRecording = startRecording;
exports.stopRecording = stopRecording;
exports.recordingStartedNotification = recordingStartedNotification;
exports.recordingStarted = recordingStarted;
exports.recordingStartError = recordingStartError;
exports.recordingStopped = recordingStopped;
exports.recordingStopError = recordingStopError;
exports.muteAll = muteAll;
exports.muteParticipant = muteParticipant;
exports.getRelayServersGalaxy = getRelayServersGalaxy;
exports.postCapabilitiesGalaxy = postCapabilitiesGalaxy;
exports.sendMeetingPinGalaxy = sendMeetingPinGalaxy;
exports.sendDtmfGalaxy = sendDtmfGalaxy;
exports.sendChangeLayoutGalaxy = sendChangeLayoutGalaxy;
exports.moderatorMuteAll = moderatorMuteAll;
exports.moderatorMute = moderatorMute;
exports.ejectAll = ejectAll;
exports.ejectParticipant = ejectParticipant;
exports.galaxyAdd = galaxyAdd;
exports.galaxyCancelAdd = galaxyCancelAdd;
exports.sendRingingResponse = sendRingingResponse;
exports.answerGalaxy = answerGalaxy;
exports.callWaitingResponse = callWaitingResponse;
exports.callRingingResponse = callRingingResponse;
exports.callPickup = callPickup;
exports.pushCallCancelled = pushCallCancelled;
exports.callPickupFailed = callPickupFailed;
exports.ignoreGalaxy = ignoreGalaxy;
exports.endGalaxy = endGalaxy;
exports.sendEndGalaxy = sendEndGalaxy;
exports.sendHeartBeatGalaxy = sendHeartBeatGalaxy;
exports.sendTrickleIceCandidates = sendTrickleIceCandidates;
exports.postTurnCommandGalaxy = postTurnCommandGalaxy;
exports.postCapabilitiesCommandGalaxy = postCapabilitiesCommandGalaxy;
exports.postCallCommandGalaxy = postCallCommandGalaxy;
exports.reportIceStateChange = reportIceStateChange;
exports.incomingCallGalaxy = incomingCallGalaxy;
exports.callAnsweredGalaxy = callAnsweredGalaxy;
exports.tryingCallGalaxy = tryingCallGalaxy;
exports.conferenceJoined = conferenceJoined;
exports.conferenceEnded = conferenceEnded;
exports.conferenceEscalated = conferenceEscalated;
exports.participantJoined = participantJoined;
exports.ejectSuccess = ejectSuccess;
exports.participantLeft = participantLeft;
exports.participantLocalMuted = participantLocalMuted;
exports.participantLocalUnmuted = participantLocalUnmuted;
exports.participantLocalVideoMuted = participantLocalVideoMuted;
exports.participantLocalVideoUnmuted = participantLocalVideoUnmuted;
exports.generateSelfLocalVideoEvent = generateSelfLocalVideoEvent;
exports.participantMuted = participantMuted;
exports.participantUnmuted = participantUnmuted;
exports.conferenceMuted = conferenceMuted;
exports.conferenceUnmuted = conferenceUnmuted;
exports.presentationFloorGranted = presentationFloorGranted;
exports.presentationFloorReleased = presentationFloorReleased;
exports.pinRequested = pinRequested;
exports.incomingFECC = incomingFECC;
exports.subscribeToConference = subscribeToConference;
exports.unsubscribeFromConference = unsubscribeFromConference;
exports.ringingCallGalaxy = ringingCallGalaxy;
exports.addRinging = addRinging;
exports.failedCallGalaxy = failedCallGalaxy;
exports.endCallGalaxy = endCallGalaxy;
exports.ignoreCallGalaxy = ignoreCallGalaxy;
exports.incomingCallEndedGalaxy = incomingCallEndedGalaxy;
exports.remoteIceCandidates = remoteIceCandidates;
exports.toggleDoNotDisturb = toggleDoNotDisturb;
exports.sendChangeLayout = exports.sendDtmf = exports.sendMeetingPin = exports.end = exports.ignore = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var c = _interopRequireWildcard(__webpack_require__(3));

var _guid = _interopRequireDefault(__webpack_require__(72));

var _galaxyUtils = __webpack_require__(73);

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var proxyActions = _interopRequireWildcard(__webpack_require__(21));

var _stream = __webpack_require__(80);

var _call = __webpack_require__(51);

var _contacts = __webpack_require__(35);

var _currentUser = __webpack_require__(37);

var _directory = __webpack_require__(84);

var _deviceUtils = __webpack_require__(251);

var _localization = __webpack_require__(125);

var _environment = __webpack_require__(193);

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _conference = __webpack_require__(53);

var _services = __webpack_require__(83);

/** @module actions/call */

/**
 * Call
 * This action will call the provided contact, in call or out of call
 * You may set the enabled state of the audio and video capture using the optional media parameter,
 * You may also set the selected video and audio sourceIds
 *    (please use the mediaSelectors audioDevices and videoDevices selectors and pass in one of the deviceIds)
 *   This specified source will attempt to be captured, and if it does not exist, we will use the default.
 * @param {Object} contact - contact or dialstring to call
 * @param {Object} media - what media settings to use { audio: bool, video: bool, primaryVideoSourceId: string, primaryAudioSourceId: string }
 */
function call(contact, media) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch, getState) {
        var state, dialString, storedContact;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                state = getState(); // load contact (fire and forget) if we don't have them

                dialString = typeof contact === 'string' ? contact : (0, _safeAccess.default)(contact, 'dialString');
                storedContact = (0, _contacts.getContactByDialStringGenerator)(state)(dialString);
                if (!storedContact && dialString) dispatch((0, _directory.loadByExtensions)([dialString]));

                if (!(0, _services.selectConnected)(state)) {
                  _context.next = 8;
                  break;
                }

                _context.next = 7;
                return dispatch(callGalaxy(contact, media));

              case 7:
                return _context.abrupt("return", _context.sent);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}
/**
 * webConferenceCall
 * This action will start a call to the provided contact (or dialstring),
 *  in a "web conferencing" mode. That is, audio down and audio up will be
 *  muted, and those settings may not be changed by normal means.
 * A client may "end" this web conferencing mode by dispatching the call action
 *  "unmuteCallAudio", which unmutes the far end audio stream, but leaves the
 *  user's audio "muted". The user can then "unmute" themselves.
 * The usual media settings apply for which streams are captured.
 * @param {Object} contact - contact or dialstring to call
 * @param {Object} media - what media settings to use { audio: bool, video: bool }
 */


function webConferenceCall(contact, media) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch, getState) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(0, _services.selectConnected)(getState())) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 3;
                return dispatch(callGalaxy(contact, media));

              case 3:
                return _context2.abrupt("return", dispatch({
                  type: c.ENABLE_WEB_CONFERENCE_MODE
                }));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}
/**
 * enableFarEndAudio
 * This function stops the "web conferencing mode" of the current active call,
 * enabling the far end audio. The client's local audio will still be muted, but
 * the ability to unmute will then be enabled.
 */


function enableFarEndAudio() {
  return {
    type: c.DISABLE_WEB_CONFERENCE_MODE
  };
}
/**
 * clearCall
 * Returns the active call reducer (and selector) to their original states
 * Only while out of a call
 */


function clearCall() {
  return function (dispatch, getState) {
    var state = getState();

    if ((0, _safeAccess.default)(state, 'nucleus.galaxy.call.state') === c.GALAXY_CALL_STATE_DISCONNECTED) {
      dispatch({
        type: c.GALAXY_ACTION_CLEAR_CALL
      });
    }
  };
}
/**
 * Cancel
 * This action will cancel the call to the provided participant,
 *  or if no participant is provided, the currently outgoing call.
 * @param {Object} participant - participant or dialstring to cancel calling
 */


function cancel(participant) {
  return function (dispatch, getState) {
    var state = getState();
    var galaxyCallState = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.state') || c.GALAXY_CALL_STATE_DISCONNECTED;
    var galaxyInviteeState = (0, _safeAccess.default)(state, 'nucleus.galaxy.invited.state');

    if (participant && galaxyCallState == c.GALAXY_CALL_STATE_CONNECTED) {
      // allow cancel if in trying or ringing state (we currently do not receive ringing from call manager)
      if ([c.GALAXY_INVITEE_STATE_TRYING, c.GALAXY_INVITEE_STATE_RINGING].includes(galaxyInviteeState)) {
        return dispatch(galaxyCancelAdd());
      } else if (galaxyInviteeState === c.GALAXY_INVITEE_STATE_FAILED) {
        return dispatch({
          type: c.GALAXY_ACTION_CLEAR_INVITED
        });
      }
    } // galaxy call is disconnected, send a clear galaxy call to help UI


    if (galaxyCallState === c.GALAXY_CALL_STATE_DISCONNECTED) {
      dispatch({
        type: c.GALAXY_ACTION_CLEAR_CALL
      });
    } // we're dialing a galaxy call, cancel as soon as we can


    var isDialing = (0, _call.isDialingGalaxy)(state);
    if (isDialing) return dispatch({
      type: c.GALAXY_ACTION_QUEUE_CANCEL_CALL
    }); // we're calling a galaxy call, cancel now

    var isCalling = (0, _call.isCallingGalaxy)(state);
    if (isCalling) return dispatch(endGalaxy());
  };
}
/**
 * Answer
 * This action creator will dispatch an action to answer the call Id provided
 * You may set the enabled state of the audio and video capture using the optional media parameter,
 * You may also set the selected video and audio sourceIds
 *    (please use the mediaSelectors audioDevices and videoDevices selectors and pass in one of the deviceIds)
 *   This specified source will attempt to be captured, and if it does not exist, we will use the default.
 * @param {Object} incomingCall - the incoming call to answer from the incoming call selector
 * @param {Object} media - what media settings to use { audio: bool, video: bool, primaryVideoSourceId: string, primaryAudioSourceId: string }
 */


function answer(incomingCall, media) {
  return function (dispatch) {
    return dispatch(answerGalaxy(incomingCall, media));
  };
}
/**
 * add
 * This action will add an incoming call to the current active call
 * @param {Object} incomingCall - the incoming call from the incoming call selector
 */


function add(incomingCall) {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(dispatch, getState) {
        var state, activeCall, callWaitingCallId;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                state = getState();
                activeCall = (0, _call.activeCallSelector)(state);
                callWaitingCallId = (0, _safeAccess.default)(state, 'nucleus.galaxy.callWaiting.callId'); // do not do anything if not in a connected call

                if (!(activeCall.state !== c.CALL_STATE_CONNECTED)) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return");

              case 5:
                if (!(callWaitingCallId && callWaitingCallId === (0, _safeAccess.default)(incomingCall, 'id'))) {
                  _context3.next = 9;
                  break;
                }

                _context3.next = 8;
                return dispatch(callWaitingResponse(c.GALAXY_COMMAND_CALL_WAITING_ADD));

              case 8:
                return _context3.abrupt("return", _context3.sent);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
}
/**
 * endAndAnswer
 * This action will end the current active call and answer the specified incoming call
 * @param {Object} incomingCall - incoming call object from the incoming call selector
 */


function endAndAnswer(incomingCall) {
  return (
    /*#__PURE__*/
    function () {
      var _ref4 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(dispatch, getState) {
        var state, callWaitingCallId;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                state = getState();
                callWaitingCallId = (0, _safeAccess.default)(state, 'nucleus.galaxy.callWaiting.callId'); // handle end and answering in galaxy callWaiting scenario

                if (!(callWaitingCallId && callWaitingCallId === (0, _safeAccess.default)(incomingCall, 'id'))) {
                  _context4.next = 6;
                  break;
                }

                _context4.next = 5;
                return dispatch(callWaitingResponse(c.GALAXY_COMMAND_CALL_WAITING_END_AND_ANSWER));

              case 5:
                return _context4.abrupt("return", _context4.sent);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x7, _x8) {
        return _ref4.apply(this, arguments);
      };
    }()
  );
}
/**
 * ignore
 * This action ignores an incoming call (while in or out of a call)
 * @param {Object} incomingCall - the incoming call object from the incoming call selector
 */


var ignore = function ignore(incomingCall) {
  return function (dispatch) {
    return dispatch(ignoreGalaxy(incomingCall));
  };
};
/**
 * kick
 * This action kicks a participant from the current call
 * @param {Object} participant - the participant object from the active call selector
 */


exports.ignore = ignore;

function kick(participant) {
  return function (dispatch, getState) {
    if ((0, _galaxyUtils.isGalaxyCallConnected)(getState())) {
      return dispatch(ejectParticipant(participant));
    }
  };
}
/**
 * kickAll
 * This action kicks all participants from the current call
 */


function kickAll() {
  return (
    /*#__PURE__*/
    function () {
      var _ref5 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(dispatch, getState) {
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(0, _galaxyUtils.isGalaxyCallConnected)(getState())) {
                  _context5.next = 4;
                  break;
                }

                _context5.next = 3;
                return dispatch(ejectAll());

              case 3:
                // This prevents the kicker from seeing the "ejected" IVR
                dispatch(end());

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x9, _x10) {
        return _ref5.apply(this, arguments);
      };
    }()
  );
}
/**
 * end
 * This action ends the current active call, whether connected or not
 */


var end = function end() {
  return function (dispatch) {
    return dispatch(endGalaxy());
  };
};
/**
 * sendMeetingPin
 * This action creator will dispatch sendDtmf actions for each character
 * in the provided pin, automatically adding a '#' dtmf action at the end.
 * It will reject and set the property invalidPin in the activeCallSelector
 * if it thinks your pin is invalid (this will only work on meetings in your group).
 * @param {String} pin - The pin for the meeting. Do not include a # character.
 */


exports.end = end;

var sendMeetingPin = function sendMeetingPin(pin) {
  return function (dispatch) {
    return dispatch(sendMeetingPinGalaxy(pin));
  };
};
/**
 * sendDtmf
 * This action creator will dispatch an action to the socket to send a call
 * command to send the given DTMF key.
 * @param {String} key - DTMF key
 */


exports.sendMeetingPin = sendMeetingPin;

var sendDtmf = function sendDtmf(key) {
  return function (dispatch) {
    return dispatch(sendDtmfGalaxy(key));
  };
};
/**
 * sendChangeLayout
 * This action creator will dispatch an action to galaxy mcu to change the layout
 * Supported only for galaxy.
 * @param {String} layout - hiddenReverseL|reverseL|progression.
 */


exports.sendDtmf = sendDtmf;

var sendChangeLayout = function sendChangeLayout(layout) {
  return function (dispatch) {
    return dispatch(sendChangeLayoutGalaxy(layout));
  };
};
/**
 * startRecording
 * This action creator will dispatch an action to the socket to send a conference
 * command to start recording.
 * @param {Object} owner - a contact object used to set the owner of the recording.
 */


exports.sendChangeLayout = sendChangeLayout;

function startRecording() {
  var owner = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return (
    /*#__PURE__*/
    function () {
      var _ref6 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(dispatch, getState) {
        var state, conferenceId, data, ownerUUID;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                state = getState();
                conferenceId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.conferenceId');
                data = {
                  messageId: _guid.default.create(),
                  event: c.GALAXY_COMMAND_RECORD,
                  conferenceId: conferenceId
                };
                ownerUUID = (0, _safeAccess.default)(owner, 'uuid');
                if (ownerUUID) data.ownerUUID = ownerUUID;
                _context6.prev = 5;
                dispatch({
                  type: c.GALAXY_ACTION_RECORDING_START
                });
                _context6.next = 9;
                return dispatch(proxyActions.proxyApiCall(c.GALAXY_TOPIC_USER_ACTIONS, c.GALAXY_WAMP_URI_SUFFIX_DEFAULT, c.GALAXY_HTTP_METHOD_DEFAULT, data));

              case 9:
                return _context6.abrupt("return", _context6.sent);

              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6["catch"](5);
                dispatch(recordingStartError(_context6.t0));

              case 15:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[5, 12]]);
      }));

      return function (_x11, _x12) {
        return _ref6.apply(this, arguments);
      };
    }()
  );
}
/**
 * stopRecording
 * This action creator will dispatch an action to the socket to send a conference
 * command to stop recording.
 */


function stopRecording() {
  return (
    /*#__PURE__*/
    function () {
      var _ref7 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(dispatch, getState) {
        var state, conferenceId, data;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                state = getState();
                conferenceId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.conferenceId');
                data = {
                  messageId: _guid.default.create(),
                  event: c.GALAXY_COMMAND_STOP_RECORDING,
                  conferenceId: conferenceId
                };
                _context7.prev = 3;
                dispatch({
                  type: c.GALAXY_ACTION_RECORDING_STOP
                });
                _context7.next = 7;
                return dispatch(proxyActions.proxyApiCall(c.GALAXY_TOPIC_USER_ACTIONS, c.GALAXY_WAMP_URI_SUFFIX_DEFAULT, c.GALAXY_HTTP_METHOD_DEFAULT, data));

              case 7:
                return _context7.abrupt("return", _context7.sent);

              case 10:
                _context7.prev = 10;
                _context7.t0 = _context7["catch"](3);
                dispatch(recordingStopError(_context7.t0));

              case 13:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[3, 10]]);
      }));

      return function (_x13, _x14) {
        return _ref7.apply(this, arguments);
      };
    }()
  );
}

function recordingStartedNotification(data) {
  return function (dispatch, getState) {
    var state = getState();
    var startedBy = (0, _safeAccess.default)(data, 'conferenceState.recordingProperties.startedBy');
    var owner = (0, _safeAccess.default)(data, 'conferenceState.recordingProperties.owner');
    var actionType = c.GALAXY_ACTION_RECORDING_STARTED; // check against existing state, and do not fire a "started" action again if we already know we are recording
    // the way notifications work, if we are the starter of the recording,
    //  we will receive this event from the response to our command, and notifications
    // this way we can update the state without throwing off any clients listening for this
    // action (for say, notification purposes)

    var isRecording = (0, _safeAccess.default)(state, 'nucleus.galaxy.recording.state') === c.GALAXY_RECORDING_STATE_STARTED;

    if (isRecording) {
      actionType = c.GALAXY_ACTION_RECORDING_UPDATED;
    }

    return dispatch({
      type: actionType,
      payload: {
        startedBy: startedBy,
        owner: owner
      }
    });
  };
} // when the current user starts the recording
// TODO: account for being able to start recordings outside of a call


function recordingStarted() {
  return function (dispatch, getState) {
    // we fired the action and got the response, we must be the starter of the recording
    var currentUser = (0, _currentUser.myInfo)(getState());
    var startedBy = {
      uuid: currentUser.userUuid,
      displayName: currentUser.name
    };
    return dispatch({
      type: c.GALAXY_ACTION_RECORDING_STARTED,
      payload: {
        startedBy: startedBy
      }
    });
  };
}

function recordingStartError(error) {
  return {
    type: c.GALAXY_ACTION_RECORDING_START_ERROR,
    payload: error
  };
}

function recordingStopped() {
  return {
    type: c.GALAXY_ACTION_RECORDING_STOPPED
  };
}

function recordingStopError(error) {
  return {
    type: c.GALAXY_ACTION_RECORDING_STOP_ERROR,
    payload: error
  };
}
/**
 * muteAll - Moderator Only
 * This action creator will dispatch an action to the socket to send a conference
 * command to set the mute all for all participants to the given value.
 * @param {Bool} value - true to muteAll, false to un-muteAll
 */


function muteAll(value) {
  return function (dispatch, getState) {
    if ((0, _galaxyUtils.isGalaxyCallConnected)(getState())) {
      return dispatch(moderatorMuteAll(value));
    }
  };
}
/**
 * muteParticipant
 * This action creator will dispatch an action to the socket to send a conference
 * command to set or unset the mute for a particular participant.
 * @param {Object} participant - the participant to mute or un mute
 * @param {Bool} muted - true to mute, false to unmute
 */


function muteParticipant(participant, muted) {
  return function (dispatch, getState) {
    if ((0, _galaxyUtils.isGalaxyCallConnected)(getState())) {
      return dispatch(moderatorMute(participant, muted));
    }
  };
} //////////////////////////////////////////////////////////////////////////////////////////////////////////
// Galaxy WAMP Command Actions - Currently only fire if direct media is enabled.
//////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * getRelayServersGalaxy
 * Sends a command to the Galaxy Call Manager to get local IP, STUN, and TURN addresses.
 * Async Responses are getRelayServersGalaxySuccess and getRelayServersGalaxyFailed.
 * @param {Array} preferredMediaServers - Previously known media servers. Usually received from the caller.
 * @param {String} clientRegion - The preferred aws region for the client. Received in a successful getRelayServers response.
 */


function getRelayServersGalaxy() {
  var preferredMediaServers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var clientRegion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return function (dispatch) {
    var localStorageClientRegion = window.localStorage && window.localStorage.getItem('clientRegion');
    var actionType = c.GALAXY_COMMAND_GET_RELAY_SERVERS;

    var messageId = _guid.default.create();

    var data = {
      command: actionType,
      messageId: messageId,
      preferredMediaServers: preferredMediaServers,
      clientRegion: localStorageClientRegion || clientRegion || ''
    };
    dispatch({
      type: c.GALAXY_ACTION_GET_RELAY_SERVERS_BEGIN,
      payload: {
        messageId: messageId
      }
    });
    return dispatch(postTurnCommandGalaxy(data)).then(function (response) {
      return dispatch({
        type: c.GALAXY_ACTION_GET_RELAY_SERVERS_SUCCESS,
        payload: JSON.parse(response)
      });
    }).catch(function (err) {
      return dispatch({
        type: c.GALAXY_ACTION_GET_RELAY_SERVERS_FAILED,
        payload: err
      });
    });
  };
}
/**
 * postCapabilitiesGalaxy
 * Sends a payload indicating whether direct media is enabled or not to the Capabilities server.
 * Success means that we are successfully registered to the Galaxy call services infrastructure.
 */


function postCapabilitiesGalaxy() {
  var shouldUseDirectMedia = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return (
    /*#__PURE__*/
    function () {
      var _ref8 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee8(dispatch, getState) {
        var data;
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                data = {
                  directMedia: shouldUseDirectMedia,
                  galaxy: true,
                  version: (0, _galaxyUtils.getGalaxyApiVersion)(getState())
                };
                dispatch({
                  type: c.GALAXY_ACTION_POST_CAPABILITIES_BEGIN,
                  payload: data
                });
                _context8.prev = 2;
                _context8.next = 5;
                return dispatch(postCapabilitiesCommandGalaxy(data));

              case 5:
                dispatch({
                  type: c.GALAXY_ACTION_POST_CAPABILITIES_SUCCESS,
                  payload: data
                });
                _context8.next = 13;
                break;

              case 8:
                _context8.prev = 8;
                _context8.t0 = _context8["catch"](2);
                dispatch({
                  type: c.GALAXY_ACTION_POST_CAPABILITIES_FAILED,
                  payload: _context8.t0
                });

                _jsLogger.default.info('Unable to post capabilities into Galaxy', _context8.t0);

                throw _context8.t0;

              case 13:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[2, 8]]);
      }));

      return function (_x15, _x16) {
        return _ref8.apply(this, arguments);
      };
    }()
  );
}
/**
 * sendMeetingPinGalaxy
 * Send a string of numbers to the galaxy call manager to be played as dtmf tones to the ivr.
 * This helper function also marks the call has having sent the pin to the IVR
 * @param {String} pin - The pin for the meeting as a string. Do not include a # character.
 */


function sendMeetingPinGalaxy(pin) {
  return (
    /*#__PURE__*/
    function () {
      var _ref9 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee9(dispatch) {
        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return dispatch(sendDtmfGalaxy(pin));

              case 2:
                dispatch({
                  type: c.GALAXY_ACTION_PIN_SENT,
                  payload: pin
                });

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      return function (_x17) {
        return _ref9.apply(this, arguments);
      };
    }()
  );
}
/**
 * sendDtmfGalaxy
 * Send a string of numbers to the galaxy call manager to be played as dtmf tones to the ivr.
 * @param {String} keys - The key or keys to send as a string
 */


function sendDtmfGalaxy(keys) {
  return (
    /*#__PURE__*/
    function () {
      var _ref10 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee10(dispatch, getState) {
        var state, callId, sourceId, conferenceId, data;
        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                state = getState();
                callId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.callId');
                sourceId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.sourceId');
                conferenceId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.conferenceId');
                data = {
                  command: c.GALAXY_COMMAND_DTMF,
                  dtmfDigits: keys,
                  callId: callId,
                  conferenceId: conferenceId,
                  sourceId: sourceId
                };
                _context10.next = 7;
                return dispatch(proxyActions.proxyApiCall(c.GALAXY_TOPIC_CALL_MANAGER, c.GALAXY_WAMP_ACTION_CALL_MANAGER, c.GALAXY_HTTP_METHOD_CALL_MANAGER, data));

              case 7:
                return _context10.abrupt("return", _context10.sent);

              case 8:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      return function (_x18, _x19) {
        return _ref10.apply(this, arguments);
      };
    }()
  );
}
/**
 * sendChangeLayoutGalaxy
 * Send layout change request to Galaxy MCU.
 * @param {String} layout - hiddenReverseL|reverseL|progression.
 */


function sendChangeLayoutGalaxy(layout) {
  return (
    /*#__PURE__*/
    function () {
      var _ref11 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee11(dispatch, getState) {
        var state, callId, sourceId, conferenceId, data;
        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                state = getState();
                callId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.callId');
                sourceId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.sourceId');
                conferenceId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.conferenceId');
                data = {
                  command: c.GALAXY_COMMAND_CHANGE_LAYOUT,
                  layout: layout,
                  callId: callId,
                  conferenceId: conferenceId,
                  sourceId: sourceId
                };
                _context11.next = 7;
                return dispatch(proxyActions.proxyApiCall(c.GALAXY_TOPIC_CALL_MANAGER, c.GALAXY_WAMP_ACTION_CALL_MANAGER, c.GALAXY_HTTP_METHOD_CALL_MANAGER, data));

              case 7:
                return _context11.abrupt("return", _context11.sent);

              case 8:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      return function (_x20, _x21) {
        return _ref11.apply(this, arguments);
      };
    }()
  );
}

function moderatorMuteAll(value) {
  return (
    /*#__PURE__*/
    function () {
      var _ref12 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee12(dispatch, getState) {
        var conferenceId, data;
        return _regenerator.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                conferenceId = (0, _conference.selectConferenceId)(getState());
                data = {
                  messageId: _guid.default.create(),
                  event: value ? c.GALAXY_COMMAND_MUTE_ALL : c.GALAXY_COMMAND_UN_MUTE_ALL,
                  conferenceId: conferenceId
                };
                _context12.next = 4;
                return dispatch(proxyActions.proxyApiCall(c.GALAXY_TOPIC_MODERATOR_ACTIONS, c.GALAXY_WAMP_URI_SUFFIX_DEFAULT, c.GALAXY_HTTP_METHOD_DEFAULT, data));

              case 4:
                return _context12.abrupt("return", _context12.sent);

              case 5:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      return function (_x22, _x23) {
        return _ref12.apply(this, arguments);
      };
    }()
  );
}

function moderatorMute(participant, value) {
  return (
    /*#__PURE__*/
    function () {
      var _ref13 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee13(dispatch, getState) {
        var conferenceId, data;
        return _regenerator.default.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                conferenceId = (0, _conference.selectConferenceId)(getState());
                data = {
                  messageId: _guid.default.create(),
                  event: value ? c.GALAXY_COMMAND_MUTE_PARTICIPANT : c.GALAXY_COMMAND_UN_MUTE_PARTICIPANT,
                  participantId: participant.participantId,
                  conferenceId: conferenceId
                };
                _context13.next = 4;
                return dispatch(proxyActions.proxyApiCall(c.GALAXY_TOPIC_MODERATOR_ACTIONS, c.GALAXY_WAMP_URI_SUFFIX_DEFAULT, c.GALAXY_HTTP_METHOD_DEFAULT, data));

              case 4:
                return _context13.abrupt("return", _context13.sent);

              case 5:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      return function (_x24, _x25) {
        return _ref13.apply(this, arguments);
      };
    }()
  );
}

function ejectAll() {
  return (
    /*#__PURE__*/
    function () {
      var _ref14 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee14(dispatch, getState) {
        var conferenceId, data;
        return _regenerator.default.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                conferenceId = (0, _conference.selectConferenceId)(getState());
                data = {
                  messageId: _guid.default.create(),
                  event: c.GALAXY_COMMAND_EJECT_ALL,
                  conferenceId: conferenceId
                };
                _context14.next = 4;
                return dispatch(proxyActions.proxyApiCall(c.GALAXY_TOPIC_MODERATOR_ACTIONS, c.GALAXY_WAMP_URI_SUFFIX_DEFAULT, c.GALAXY_HTTP_METHOD_DEFAULT, data));

              case 4:
                return _context14.abrupt("return", _context14.sent);

              case 5:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      return function (_x26, _x27) {
        return _ref14.apply(this, arguments);
      };
    }()
  );
}

function ejectParticipant(participant) {
  return (
    /*#__PURE__*/
    function () {
      var _ref15 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee15(dispatch, getState) {
        var conferenceId, data;
        return _regenerator.default.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                conferenceId = (0, _conference.selectConferenceId)(getState());
                data = {
                  messageId: _guid.default.create(),
                  event: c.GALAXY_COMMAND_EJECT,
                  participantId: participant.participantId,
                  conferenceId: conferenceId
                };
                _context15.next = 4;
                return dispatch(proxyActions.proxyApiCall(c.GALAXY_TOPIC_MODERATOR_ACTIONS, c.GALAXY_WAMP_URI_SUFFIX_DEFAULT, c.GALAXY_HTTP_METHOD_DEFAULT, data));

              case 4:
                return _context15.abrupt("return", _context15.sent);

              case 5:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));

      return function (_x28, _x29) {
        return _ref15.apply(this, arguments);
      };
    }()
  );
}

function galaxyAdd(contact) {
  return (
    /*#__PURE__*/
    function () {
      var _ref16 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee16(dispatch, getState) {
        var state, dialString, sourceId, callId, data, result, error;
        return _regenerator.default.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                state = getState();
                dialString = typeof contact === 'string' ? contact : (0, _safeAccess.default)(contact, 'dialString');
                sourceId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.sourceId');
                callId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.callId');
                data = {
                  command: c.GALAXY_COMMAND_ADD,
                  to: dialString,
                  from: (0, _currentUser.myInfo)(state).dialString || (0, _currentUser.myInfo)(state).name,
                  callId: callId,
                  sourceId: sourceId,
                  version: (0, _galaxyUtils.getGalaxyApiVersion)(state)
                };
                _context16.prev = 5;
                _context16.next = 8;
                return dispatch(postCallCommandGalaxy(data));

              case 8:
                result = _context16.sent;
                dispatch({
                  type: c.GALAXY_ACTION_ADD_TO_CALL,
                  payload: {
                    invitedId: _guid.default.create(),
                    contact: contact
                  }
                });
                return _context16.abrupt("return", result);

              case 13:
                _context16.prev = 13;
                _context16.t0 = _context16["catch"](5);
                error = {
                  callId: callId,
                  error: _context16.t0,
                  reason: c.GALAXY_REASON_SERVER_ERROR
                };
                dispatch({
                  type: c.GALAXY_ACTION_ADD_FAILED,
                  payload: error
                });
                throw error;

              case 18:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, null, [[5, 13]]);
      }));

      return function (_x30, _x31) {
        return _ref16.apply(this, arguments);
      };
    }()
  );
}

function galaxyCancelAdd() {
  return (
    /*#__PURE__*/
    function () {
      var _ref17 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee17(dispatch, getState) {
        var state, sourceId, callId, data, result, error;
        return _regenerator.default.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                state = getState();
                sourceId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.sourceId');
                callId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.callId');
                data = {
                  command: c.GALAXY_COMMAND_CANCEL_ADD,
                  callId: callId,
                  sourceId: sourceId,
                  version: (0, _galaxyUtils.getGalaxyApiVersion)(state)
                };
                _context17.prev = 4;
                _context17.next = 7;
                return dispatch(postCallCommandGalaxy(data));

              case 7:
                result = _context17.sent;
                dispatch({
                  type: c.GALAXY_ACTION_ADD_FAILED,
                  payload: {
                    reason: c.GALAXY_ADD_RESPONSE_ACTION_CANCELLED
                  }
                });
                return _context17.abrupt("return", result);

              case 12:
                _context17.prev = 12;
                _context17.t0 = _context17["catch"](4);
                error = {
                  callId: callId,
                  error: _context17.t0,
                  reason: c.GALAXY_REASON_SERVER_ERROR
                };
                throw error;

              case 16:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, null, [[4, 12]]);
      }));

      return function (_x32, _x33) {
        return _ref17.apply(this, arguments);
      };
    }()
  );
}
/**
 * callGalaxy
 * Action chain that dispatches the beginning of a call into Galaxy and then dials the other endpoint.
 * The RTC middleware is listening for the GALAXY_ACTION_BEGIN_CALL_OFFER action so it can generate a WebRTC offer.
 *
 * @param {Object} contact - The contact object that we are calling. Can be an object or a manual dial string
 * @param {Object} media - Media parameters object that indicates what kind of call this will be.
 */


function callGalaxy(contact, media) {
  return function (dispatch, getState) {
    var state = getState();
    var activeCall = (0, _call.activeCallSelector)(state);
    var activeCallState = (0, _safeAccess.default)(activeCall, 'state'); // prevent calling (do nothing) if we're not either disconnected or connected

    if (activeCallState !== c.CALL_STATE_CONNECTED && activeCallState !== c.CALL_STATE_DISCONNECTED && activeCallState !== c.CALL_STATE_FAILED) {
      _jsLogger.default.info('Cancelling galaxy call due to activeCallState', activeCallState);

      return Promise.resolve();
    }

    if (activeCallState === c.CALL_STATE_CONNECTED) {
      return dispatch(galaxyAdd(contact));
    }

    var callId = _guid.default.create();

    var dialString = typeof contact === 'string' ? contact : (0, _safeAccess.default)(contact, 'dialString');
    var clientRegion = (0, _safeAccess.default)(state, 'nucleus.galaxy.capabilities.clientRegion');
    dispatch({
      type: c.GALAXY_ACTION_BEGIN_CALL,
      payload: {
        callId: callId,
        dialString: dialString,
        media: media,
        contact: contact
      }
    });
    return dispatch((0, _stream.acquireLocalPrimaryStream)(media)).catch(function () {}) // do not fail call if no media available
    .then(function () {
      return dispatch(getRelayServersGalaxy([], clientRegion));
    }).then(function () {
      return dispatch({
        type: c.GALAXY_ACTION_BEGIN_CALL_OFFER
      });
    }).then(function (responses) {
      return dispatch(dialGalaxy(contact, dialString, media, (0, _safeAccess.default)(responses, '[0].sdp'), (0, _safeAccess.default)(responses, '[1].sdp'), callId));
    }).catch(function (err) {
      var error = {
        callId: callId,
        error: err,
        reason: c.GALAXY_REASON_SERVER_ERROR
      };
      dispatch(failedCallGalaxy(error));
      return Promise.reject(error);
    });
  };
}
/**
 * dialGalaxy
 * Action chain that dispatches the call command to the call manager server. On successful receipt of that command,
 * and internal redux action will fire indicating that the call has begun.
 *
 * @param {Object} contact - The contact object that we are calling. Can be an object or a manual dial string
 * @param {Object} media - Media parameters object that indicates what kind of call this will be.
 * @param {String} sdp - Offer SDP
 * @param {Array} iceCandidates - Array of local ice candidates

 */


function dialGalaxy(contact, dialString, media, sdp, presSdp, callId) {
  return function (dispatch, getState) {
    var state = getState();
    var tracks = {}; //{'presentation' : trackId}}

    var preferredMediaServers = [];

    try {
      var iceServers = (0, _safeAccess.default)(state, 'nucleus.galaxy.capabilities.iceServers') || [];
      preferredMediaServers = iceServers.map(function (s) {
        return s.urls.find(function (u) {
          return u.includes('=udp');
        });
      });
    } catch (ex) {
      _jsLogger.default.info('Could not get preferred media servers', ex);
    }

    var clientRegion = window.localStorage && window.localStorage.getItem('clientRegion') || (0, _safeAccess.default)(state, 'nucleus.galaxy.capabilities.clientRegion') || '';
    var capability = {
      type: c.WEBRTC_SDP_TYPE_OFFER,
      sdp: sdp,
      tracks: tracks,
      presSdp: presSdp
    };
    var cameraCapabilities = (0, _deviceUtils.getCallCameraCapabilities)(state);

    if (cameraCapabilities) {
      capability.cameraCapabilities = cameraCapabilities;
    }

    var endpointInfo = (0, _galaxyUtils.getEndpointInfo)(state);
    var preferredMCUs = window.localStorage && window.localStorage.getItem('preferredMCUs') || '';
    var sourceId = window.localStorage && window.localStorage.getItem('preferredCallMgr') || '';
    var data = {
      command: c.GALAXY_COMMAND_CALL,
      capability: capability,
      to: dialString,
      from: (0, _currentUser.myInfo)(state).dialString || (0, _currentUser.myInfo)(state).name || 'Guest',
      callId: callId,
      endpointInfo: endpointInfo,
      preferredMediaServers: preferredMediaServers,
      clientRegion: clientRegion,
      preferredMCUs: preferredMCUs,
      localeCode: (0, _localization.languageId)(state) || (0, _localization.localeCode)(state),
      version: (0, _galaxyUtils.getGalaxyApiVersion)(state),
      galaxy: true
    }; // If there is a preferredCallMgr use that. Used only to test

    if (sourceId.length !== 0) {
      data.sourceId = sourceId;
    } //For GEMS send screen count and RCA connected state


    var platform = (0, _environment.platform)(state);

    if (platform.isGems) {
      var screenCount = (0, _safeAccess.default)(state, 'nucleus.device.screenCount');
      var rcaConnected = (0, _safeAccess.default)(state, 'nucleus.dataChannel.open');
      data.deviceCapability = {
        screenCount: screenCount,
        rcaConnected: rcaConnected
      };
    } // check if the user already wants to cancel the call, if so, do so silently.


    if ((0, _safeAccess.default)(state, 'nucleus.galaxy.call.cancelQueued')) {
      dispatch(endCallGalaxy(data));
      return Promise.resolve();
    }

    if ((0, _safeAccess.default)(state, 'nucleus.galaxy.call.state') !== c.GALAXY_CALL_STATE_BEGIN) {
      _jsLogger.default.info('Unable to call out to galaxy due to call state === ', (0, _safeAccess.default)(state, 'nucleus.galaxy.call.state'));

      var error = {
        callId: callId,
        error: null,
        reason: c.GALAXY_REASON_BAD_INITIAL_DIAL_STATE
      };
      dispatch(failedCallGalaxy(error));
      return Promise.reject(error);
    }

    dispatch({
      type: c.GALAXY_ACTION_CALLING,
      payload: {
        data: data,
        contact: contact,
        media: media
      }
    });
    return dispatch(postCallCommandGalaxy(data)).catch(function (err) {
      var error = {
        callId: callId,
        error: err,
        reason: c.GALAXY_REASON_SERVER_ERROR
      };
      dispatch(failedCallGalaxy(error));
      return Promise.reject(error);
    });
  };
}
/**
 * sendRingingResponse
 * Sends a response back to the call manager indicating that the client has received an incoming call and
 * that the local call state is ringing.
 * @param {String} payload - payload with incoming call information
 */


function sendRingingResponse(payload) {
  return function (dispatch, getState) {
    var callId = (0, _safeAccess.default)(payload, 'callId');
    var sourceId = (0, _safeAccess.default)(payload, 'sourceId');
    var endpointInfo = (0, _galaxyUtils.getEndpointInfo)(getState());
    var actionType = c.GALAXY_EVENT_RINGING;
    var data = {
      command: actionType,
      sourceId: sourceId,
      callId: callId,
      endpointInfo: endpointInfo
    };
    return dispatch(postCallCommandGalaxy(data)).catch(function (err) {
      var error = {
        callId: callId,
        error: err,
        reason: c.GALAXY_REASON_SERVER_ERROR
      };
      dispatch(failedCallGalaxy(error));
      return Promise.reject(error);
    });
  };
}
/**
 * answerGalaxy
 * Action chain for handling an incoming call from galaxy.
 * The RTC middleware is listening for the GALAXY_ACTION_BEGIN_ANSWER action so it can generate a WebRTC answer.
 * @param {*} incomingCall - Incoming call state from the selector.
 * @param {*} media - Media parameters object that indicates what kind of call this will be.
 */


function answerGalaxy(incomingCall, media) {
  return function (dispatch, getState) {
    if (incomingCall) {
      var state = getState();
      var clientRegion = window.localStorage && window.localStorage.getItem('clientRegion') || (0, _safeAccess.default)(state, 'nucleus.galaxy.capabilities.clientRegion') || '';
      return dispatch((0, _stream.acquireLocalPrimaryStream)(media)).catch(function () {}) // do not fail call if no media available
      .then(function () {
        return dispatch(getRelayServersGalaxy((0, _safeAccess.default)(incomingCall, 'galaxyCall.preferredMediaServers'), clientRegion));
      }).then(function () {
        return dispatch({
          type: c.GALAXY_ACTION_BEGIN_ANSWER,
          payload: incomingCall.galaxyCall
        });
      }).then(function (responses) {
        return dispatch(sendAnswerResponseGalaxy(incomingCall, (0, _safeAccess.default)(responses, '[0].sdp'), (0, _safeAccess.default)(responses, '[1].sdp')));
      }).catch(function (err) {
        var error = {
          callId: (0, _safeAccess.default)(incomingCall, 'galaxyCall.callId'),
          error: err,
          reason: c.GALAXY_REASON_SERVER_ERROR
        };
        dispatch(failedCallGalaxy(error));
        return Promise.reject(error);
      });
    }

    _jsLogger.default.info('Unable to answer call to galaxy due to no incoming call ', incomingCall);

    var error = {
      error: null,
      reason: c.GALAXY_REASON_BAD_INITIAL_DIAL_STATE
    };
    dispatch(failedCallGalaxy(error));
    return Promise.reject(error);
  };
}
/**
 * sendAnswerResponseGalaxy
 * Action chain that dispatches the galaxy call answer data to the call manager server.. On successful receipt of that command,
 * and internal redux action will fire indicating that the answer has begun.
 * @param {*} incomingCall - Incoming call state from the selector.
 * @param {String} sdp - Answer SDP
 * @param {Array} iceCandidates - Array of local ice candidates
 */


function sendAnswerResponseGalaxy(incomingCall, sdp, presSdp) {
  return function (dispatch, getState) {
    var tracks = {}; //{'presentation' : trackId}}

    var capability = {
      type: c.WEBRTC_SDP_TYPE_ANSWER,
      sdp: sdp,
      tracks: tracks,
      presSdp: presSdp
    };
    var state = getState();
    var endpointInfo = (0, _galaxyUtils.getEndpointInfo)(state);
    var clientRegion = (0, _safeAccess.default)(state, 'nucleus.galaxy.capabilities.clientRegion');
    var preferredMCUs = window.localStorage && window.localStorage.getItem('preferredMCUs') || ''; //GEMS fecc camera caps

    var cameraCapabilities = (0, _deviceUtils.getCallCameraCapabilities)(state);

    if (cameraCapabilities) {
      capability.cameraCapabilities = cameraCapabilities;
    }

    var data = {
      command: c.GALAXY_EVENT_CONNECTED,
      capability: capability,
      callId: (0, _safeAccess.default)(incomingCall, 'galaxyCall.callId'),
      sourceId: (0, _safeAccess.default)(incomingCall, 'galaxyCall.sourceId'),
      endpointInfo: endpointInfo,
      clientRegion: clientRegion,
      preferredMCUs: preferredMCUs,
      version: (0, _galaxyUtils.getGalaxyApiVersion)(state)
    }; //For GEMS send screen count and RCA connected state

    var platform = (0, _environment.platform)(state);

    if (platform.isGems) {
      var screenCount = (0, _safeAccess.default)(state, 'nucleus.device.screenCount');
      var rcaConnected = (0, _safeAccess.default)(state, 'nucleus.dataChannel.open');
      data.deviceCapability = {
        screenCount: screenCount,
        rcaConnected: rcaConnected
      };
    }

    dispatch({
      type: c.GALAXY_ACTION_ANSWER,
      payload: {
        data: data,
        galaxyCall: incomingCall.galaxyCall
      }
    });
    return dispatch(postCallCommandGalaxy(data)).catch(function (err) {
      var error = {
        callId: (0, _safeAccess.default)(incomingCall, 'galaxyCall.callId'),
        error: err,
        reason: c.GALAXY_REASON_SERVER_ERROR
      };
      dispatch(failedCallGalaxy(error));
      return Promise.reject(error);
    });
  };
}
/**
 * The client's response to a callWaiting event.
 * @param {String} action callWaiting action to perform, one of: 'add', 'ignore', or 'endAndAnswer'
 */


function callWaitingResponse(action) {
  return (
    /*#__PURE__*/
    function () {
      var _ref18 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee18(dispatch, getState) {
        var state, sourceId, callId, data;
        return _regenerator.default.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                state = getState();
                sourceId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.sourceId');
                callId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.callId');
                data = {
                  command: c.GALAXY_COMMAND_CALL_WAITING_RESPONSE,
                  sourceId: sourceId,
                  callId: callId,
                  action: action
                };
                dispatch({
                  type: c.GALAXY_ACTION_CALL_WAITING_RESPONSE,
                  payload: data
                });
                _context18.next = 7;
                return dispatch(postCallCommandGalaxy(data));

              case 7:
                return _context18.abrupt("return", _context18.sent);

              case 8:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }));

      return function (_x34, _x35) {
        return _ref18.apply(this, arguments);
      };
    }()
  );
}
/**
 * The client's notification to the call manager that the call is pending response.
 */


function callRingingResponse() {
  return (
    /*#__PURE__*/
    function () {
      var _ref19 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee19(dispatch, getState) {
        var state, sourceId, callId, data;
        return _regenerator.default.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                state = getState();
                sourceId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.sourceId');
                callId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.callId');
                data = {
                  command: c.GALAXY_COMMAND_CALL_WAITING_RINGING,
                  sourceId: sourceId,
                  callId: callId
                };
                _context19.next = 6;
                return dispatch(postCallCommandGalaxy(data));

              case 6:
                return _context19.abrupt("return", _context19.sent);

              case 7:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19);
      }));

      return function (_x36, _x37) {
        return _ref19.apply(this, arguments);
      };
    }()
  );
}
/**
 * callPickup
 * Action that signals Call Manager that we will be answering a call that we were told about via the push
 * service. This will result in an incomingCall being sent to us, which we will auto-answer.
 * @param {string} callId - Call Id of call received via push notification
 * @param {string} sourceId - Call Manager Source Id of call received via push notifications
 */


function callPickup(callId, sourceId) {
  return (
    /*#__PURE__*/
    function () {
      var _ref20 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee20(dispatch) {
        var data;
        return _regenerator.default.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                data = {
                  command: c.GALAXY_COMMAND_CALL_PICKUP,
                  sourceId: sourceId,
                  callId: callId
                };
                _context20.next = 3;
                return dispatch(postCallCommandGalaxy(data));

              case 3:
                dispatch({
                  type: c.GALAXY_ACTION_CALL_PICKUP,
                  payload: {
                    sourceId: sourceId,
                    callId: callId
                  }
                });

              case 4:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20);
      }));

      return function (_x38) {
        return _ref20.apply(this, arguments);
      };
    }()
  );
}
/**
 * pushCallCancelled
 * Action that the client can dispatch to let nucleus know if a call coming via the push service was cancelled
 * @param {string} callId - Call Id of call received via push notification
 */


function pushCallCancelled(callId) {
  return {
    type: c.GALAXY_ACTION_PUSH_CALL_CANCELLED,
    payload: {
      callId: callId
    }
  };
}
/**
 * callPickupFailed
 * Call manager may inform us that our attempt to answer a push service call has failed.
 * This action creator will check to make sure the callId we're expecting is the same,
 * and clear out our galaxy/pushService reducer if so.
 * @param {string} callId
 */


function callPickupFailed(callId) {
  return (
    /*#__PURE__*/
    function () {
      var _ref21 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee21(dispatch, getState) {
        var state;
        return _regenerator.default.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                state = getState();

                if (callId === (0, _safeAccess.default)(state, 'nucleus.galaxy.pushService.callId')) {
                  dispatch({
                    type: c.GALAXY_ACTION_CALL_PICKUP_FAILED
                  });
                }

              case 2:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21);
      }));

      return function (_x39, _x40) {
        return _ref21.apply(this, arguments);
      };
    }()
  );
}
/**
 * ignoreGalaxy
 * Action chain that is used when we want to ignore a galaxy call. Determines whether the call has been handed off
 * from an incoming call to an in progress answer. If the incoming call is still in the incoming call queue, then
 * the command is different than if we've sent the command to the galaxy server.
 * @param {Object} incomingCall - Incoming call state from the selector.
 */


function ignoreGalaxy(incomingCall) {
  return (
    /*#__PURE__*/
    function () {
      var _ref22 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee22(dispatch, getState) {
        var state, incomingState, activeCallId, incomingCallId, doNotDisturb, reason, callWaitingCallId, data, error;
        return _regenerator.default.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                state = getState();
                incomingState = (0, _safeAccess.default)(incomingCall, 'galaxyCall');
                activeCallId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.callId');
                incomingCallId = (0, _safeAccess.default)(incomingState, 'callId');
                doNotDisturb = (0, _safeAccess.default)(state, 'nucleus.doNotDisturb') || false;
                reason = doNotDisturb ? c.GALAXY_REASON_DO_NOT_DISTURB : c.GALAXY_REASON_REJECTED;
                callWaitingCallId = (0, _safeAccess.default)(state, 'nucleus.galaxy.callWaiting.callId'); // handle ignore call waiting in call:

                if (!(callWaitingCallId && callWaitingCallId === (0, _safeAccess.default)(incomingCall, 'id'))) {
                  _context22.next = 11;
                  break;
                }

                _context22.next = 10;
                return dispatch(callWaitingResponse(c.GALAXY_COMMAND_CALL_WAITING_IGNORE));

              case 10:
                return _context22.abrupt("return", _context22.sent);

              case 11:
                if (!(incomingCallId === activeCallId || !incomingState)) {
                  _context22.next = 15;
                  break;
                }

                _context22.next = 14;
                return dispatch(endGalaxy(reason));

              case 14:
                return _context22.abrupt("return", _context22.sent);

              case 15:
                data = {
                  command: c.GALAXY_COMMAND_REJECTED,
                  callId: incomingCallId,
                  sourceId: (0, _safeAccess.default)(incomingState, 'sourceId'),
                  reason: reason
                };
                _context22.prev = 16;
                dispatch(ignoreCallGalaxy(data));
                _context22.next = 20;
                return dispatch(postCallCommandGalaxy(data));

              case 20:
                return _context22.abrupt("return", _context22.sent);

              case 23:
                _context22.prev = 23;
                _context22.t0 = _context22["catch"](16);
                error = {
                  callId: incomingCallId,
                  error: _context22.t0,
                  reason: c.GALAXY_REASON_SERVER_ERROR
                };
                dispatch(failedCallGalaxy(error));
                throw error;

              case 28:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, null, [[16, 23]]);
      }));

      return function (_x41, _x42) {
        return _ref22.apply(this, arguments);
      };
    }()
  );
}
/**
 * endGalaxy
 * Action chain to end a galaxy call.
 * The command type varies depending on whether the call is connected or not or whether this is the caller or callee.
 * @param {*} reason - The reason for the ending of the galaxy call.
 */


function endGalaxy() {
  var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : c.GALAXY_REASON_HANGUP;
  var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  return function (dispatch, getState) {
    var state = getState();
    var callState = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.state');
    var isCaller = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.isCaller'); // We want to send a reject command if we are not yet connected.

    var actionType = callState === c.GALAXY_CALL_STATE_CONNECTED || isCaller ? c.GALAXY_COMMAND_END : c.GALAXY_COMMAND_REJECTED;
    var data = {
      command: actionType,
      callId: (0, _safeAccess.default)(state, 'nucleus.galaxy.call.callId'),
      sourceId: (0, _safeAccess.default)(state, 'nucleus.galaxy.call.sourceId'),
      reason: reason,
      detail: detail
    };
    return dispatch(sendEndGalaxy(data));
  };
}
/**
 * sendEndGalaxy
 * Action chain to send the end command for a galaxy call. Split as we want to prehandle ignore incoming calls vs ending
 * current calls.
 * The command type varies depending on whether the call is connected or not or whether this is the caller or callee.
 * @param {Object} data - The payload for an end call command to send to galaxy.
 */


function sendEndGalaxy(data) {
  return function (dispatch, getState) {
    var state = getState();
    var callState = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.state'); // If the call command has not yet been sent to Galaxy, just cancel the call locally.

    if (callState === c.GALAXY_CALL_STATE_BEGIN) return dispatch(endCallGalaxy(data));
    dispatch(endCallGalaxy(data));
    return dispatch(postCallCommandGalaxy(data)).catch(function (err) {
      var error = {
        error: err,
        reason: c.GALAXY_REASON_SERVER_ERROR
      };
      dispatch(failedCallGalaxy(error));
      return Promise.reject(error);
    });
  };
}

function sendHeartBeatGalaxy(sourceId, callId) {
  var reconnected = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var iceStats = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return function (dispatch) {
    var data = (0, _objectSpread2.default)({}, iceStats, {
      command: c.GALAXY_COMMAND_HEARTBEAT,
      sourceId: sourceId,
      callId: callId,
      callStats: {}
    }); // inform call manager / logs that this is a post-reconnect heartbeat.

    if (reconnected) {
      data['reconnected'] = true;
    } // tell the other side to join our conference id, then disconnect the galaxy call


    return dispatch(postCallCommandGalaxy(data));
  };
}
/**
 * Send Trickle Ice Candidates to Other client
 * Only fire if there are ice or presentation candidates.
 * @param {Array} iceCandidates - Array of main peer connection ice candidates
 * @param {Array} presIceCandidates - Array of presentation peer connection ice candidates
 */


function sendTrickleIceCandidates() {
  var iceCandidates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var presIceCandidates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return function (dispatch, getState) {
    var state = getState();
    var data = {
      command: c.GALAXY_COMMAND_TRICKLE_ICE,
      sourceId: (0, _safeAccess.default)(state, 'nucleus.galaxy.call.sourceId'),
      callId: (0, _safeAccess.default)(state, 'nucleus.galaxy.call.callId'),
      iceCandidates: iceCandidates,
      presIceCandidates: presIceCandidates
    };
    if ((!iceCandidates || !iceCandidates.length) && (!presIceCandidates || !presIceCandidates.length)) return;
    return dispatch(postCallCommandGalaxy(data));
  };
} //////////////////////////////////////////////////////////////////////////////////////////////////////////
// Galaxy WAMP Subscription Calls - Currently only fire if direct media is enabled.
//////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * postTurnCommandGalaxy
 * This function is used anytime the client needs to send a command to the turn manager server.
 *
 * @param {Object} data - A JS object payload
 */


function postTurnCommandGalaxy(data) {
  return proxyActions.proxyApiCall(c.GALAXY_TOPIC_TURN_SERVER, c.GALAXY_WAMP_ACTION_TURN_SERVER, c.GALAXY_HTTP_METHOD_TURN_SERVER, data);
}
/**
 * postCapabilitiesCommandGalaxy
 * This function is used anytime the client needs to send a command to the capabilites registration server.
 *
 * @param {Object} data - A JS object payload
 */


function postCapabilitiesCommandGalaxy(data) {
  return proxyActions.proxyApiCall(c.GALAXY_TOPIC_CAPABILITIES_SERVER, c.GALAXY_WAMP_ACTION_CAPABILITIES_SERVER, c.GALAXY_HTTP_METHOD_CAPABILITIES_SERVER, data);
}
/**
 * postCallCommandGalaxy
 * This function is used anytime the client needs to send a command to the call manager server.
 *
 * @param {Object} data - A JS object payload
 */


function postCallCommandGalaxy(data) {
  return proxyActions.proxyApiCall(c.GALAXY_TOPIC_CALL_MANAGER, c.GALAXY_WAMP_ACTION_CALL_MANAGER, c.GALAXY_HTTP_METHOD_CALL_MANAGER, data);
}

function reportIceStateChange(iceStateChange, isPresentation) {
  return (
    /*#__PURE__*/
    function () {
      var _ref23 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee23(dispatch, getState) {
        var state, sourceId, callId, conferenceId, data;
        return _regenerator.default.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                state = getState();
                sourceId = (0, _call.activeGalaxySourceId)(state);
                callId = (0, _call.activeGalaxyCallId)(state);
                conferenceId = (0, _conference.selectConferenceId)(state);
                data = {
                  callId: callId,
                  conferenceId: conferenceId,
                  sourceId: sourceId,
                  command: c.GALAXY_COMMAND_ICE_STATE_NOTIFICATION,
                  connection: isPresentation ? c.GALAXY_CONNECTION_PRESENTATION : c.GALAXY_CONNECTION_PRIMARY,
                  iceStateChange: iceStateChange
                };
                return _context23.abrupt("return", dispatch(postCallCommandGalaxy(data)));

              case 6:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23);
      }));

      return function (_x43, _x44) {
        return _ref23.apply(this, arguments);
      };
    }()
  );
}
/**
 * Convenience action creator used to pass incoming call payload from the call manager as a redux action.
 * @param {Object} data
 */


function incomingCallGalaxy(data) {
  return function (dispatch) {
    dispatch({
      type: c.GALAXY_ACTION_INCOMING_CALL,
      payload: data
    });
    dispatch(sendRingingResponse(data));
  };
}
/**
 * Convenience action creator used to pass call answered payload from the call manager as a redux action.
 * @param {Object} data
 */


function callAnsweredGalaxy(data) {
  return function (dispatch, getState) {
    // Ignore call connected event if call has already ended
    if ((0, _galaxyUtils.isGalaxyCallDisconnected)(getState(), data)) return;
    dispatch({
      type: c.GALAXY_ACTION_CALL_CONNECTED,
      payload: data
    });
  };
}
/**
 * Convenience action creator used to pass trying call payload from the call manager as a redux action.
 * @param {Object} data
 */


function tryingCallGalaxy(data) {
  return {
    type: c.GALAXY_ACTION_TRYING,
    payload: data
  };
}
/**
 * Action creator for conference joined event.
 * @param {*} data
 */


function conferenceJoined(data) {
  return function (dispatch, getState) {
    dispatch({
      type: c.GALAXY_ACTION_CONFERENCE_JOINED,
      payload: data
    });
    var state = getState();
    var currentUser = (0, _currentUser.myInfo)(state);
    var getContact = (0, _contacts.getContactByUuidGenerator)(state);
    var participants = ((0, _safeAccess.default)(data, 'participants') || []).filter(function (p) {
      return !p.guest && p.uuid !== currentUser.userUuid && !getContact(p.uuid);
    });
    dispatch((0, _directory.loadByUUIDs)(participants.map(function (p) {
      return p.uuid;
    })));
  };
}

function conferenceEnded(data) {
  return {
    type: c.GALAXY_ACTION_END,
    payload: (0, _objectSpread2.default)({}, data, {
      reason: (0, _safeAccess.default)(data, 'reason') || c.GALAXY_EVENT_CONFERENCE_ENDED
    })
  };
}

function conferenceEscalated(data) {
  return {
    type: c.GALAXY_ACTION_CONFERENCE_ESCALATED,
    payload: data
  };
}

function participantJoined(data) {
  return function (dispatch, getState) {
    dispatch({
      type: c.GALAXY_ACTION_PARTICIPANT_JOINED,
      payload: data
    });
    var state = getState();
    var currentUser = (0, _currentUser.myInfo)(state);
    var getContact = (0, _contacts.getContactByUuidGenerator)(state);
    var participants = ((0, _safeAccess.default)(data, 'participants') || [(0, _safeAccess.default)(data, 'participant')]).filter(function (p) {
      return !p.guest && p.uuid !== currentUser.userUuid && !getContact(p.uuid);
    });
    dispatch((0, _directory.loadByUUIDs)(participants.map(function (p) {
      return p.uuid;
    })));
  };
}

function ejectSuccess(data) {
  return {
    type: c.GALAXY_ACTION_EJECT_SUCCESS,
    payload: data
  };
}

function participantLeft(data) {
  return {
    type: c.GALAXY_ACTION_PARTICIPANT_LEFT,
    payload: data
  };
}

function participantLocalMuted(data) {
  return {
    type: c.GALAXY_ACTION_PARTICIPANT_LOCAL_MUTED,
    payload: data
  };
}

function participantLocalUnmuted(data) {
  return {
    type: c.GALAXY_ACTION_PARTICIPANT_LOCAL_UNMUTED,
    payload: data
  };
}

function participantLocalVideoMuted(data) {
  return {
    type: c.GALAXY_ACTION_PARTICIPANT_LOCAL_VIDEO_MUTED,
    payload: data
  };
}

function participantLocalVideoUnmuted(data) {
  return {
    type: c.GALAXY_ACTION_PARTICIPANT_LOCAL_VIDEO_UNMUTED,
    payload: data
  };
}

function generateSelfLocalVideoEvent(state, muted) {
  try {
    var conferenceId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.conferenceId');
    var callId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.callId');
    var participant = (0, _safeAccess.default)(state, 'nucleus.galaxy.conference.participants').find(function (p) {
      return p.participantId === callId;
    });
    if (!participant) return;
    participant.videoMuted = muted;
    var event = muted ? c.GALAXY_EVENT_PARTICIPANT_LOCAL_VIDEO_MUTED : c.GALAXY_EVENT_PARTICIPANT_LOCAL_VIDEO_UNMUTED;
    return {
      event: event,
      conferenceId: conferenceId,
      participant: participant
    };
  } catch (ex) {
    _jsLogger.default.info('exception in generateSelfLocalVideoEvent', ex);
  }
}

function participantMuted(data) {
  return {
    type: c.GALAXY_ACTION_PARTICIPANT_MUTED,
    payload: data
  };
}

function participantUnmuted(data) {
  return {
    type: c.GALAXY_ACTION_PARTICIPANT_UNMUTED,
    payload: data
  };
}

function conferenceMuted(data) {
  return {
    type: c.GALAXY_ACTION_CONFERENCE_MUTED,
    payload: data
  };
}

function conferenceUnmuted(data) {
  return {
    type: c.GALAXY_ACTION_CONFERENCE_UNMUTED,
    payload: data
  };
}

function presentationFloorGranted(data) {
  return {
    type: c.GALAXY_ACTION_PRESENTATION_FLOOR_GRANTED,
    payload: data
  };
}

function presentationFloorReleased(data) {
  return {
    type: c.GALAXY_ACTION_PRESENTATION_FLOOR_RELEASED,
    payload: data
  };
}

function pinRequested(data) {
  return {
    type: c.GALAXY_ACTION_PIN_REQUESTED,
    payload: data
  };
} // Broadcast the incoming FECC messages. Currently being used by FECC devices.


function incomingFECC(data) {
  return {
    type: c.GALAXY_ACTION_FECC_INCOMING,
    payload: data
  };
}

function subscribeToConference(conferenceId) {
  return function (dispatch) {
    var conferenceTopic = "".concat(c.GALAXY_TOPIC_CONFERENCE).concat(conferenceId);
    dispatch({
      type: c.WAMP_ADD_CONFERENCE_TOPIC,
      payload: conferenceTopic
    });
    return dispatch(proxyActions.subscribe(conferenceTopic));
  };
}

function unsubscribeFromConference(conferenceId) {
  return (
    /*#__PURE__*/
    function () {
      var _ref24 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee24(dispatch) {
        var conferenceTopic;
        return _regenerator.default.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                conferenceTopic = "".concat(c.GALAXY_TOPIC_CONFERENCE).concat(conferenceId);
                _context24.next = 3;
                return dispatch(proxyActions.unsubscribe(conferenceTopic));

              case 3:
                dispatch({
                  type: c.WAMP_REMOVE_CONFERENCE_TOPIC,
                  payload: conferenceTopic
                });

              case 4:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24);
      }));

      return function (_x45) {
        return _ref24.apply(this, arguments);
      };
    }()
  );
}
/**
 * Convenience action creator used to pass ringing call payload from the call manager as a redux action.
 * @param {Object} data
 */


function ringingCallGalaxy(data) {
  return function (dispatch, getState) {
    // Don't ring if this leg of the call is already canceled
    if ((0, _galaxyUtils.isGalaxyCallDisconnected)(getState(), data)) return;
    dispatch({
      type: c.GALAXY_ACTION_RINGING,
      payload: data
    });
  };
}
/**
 * Convenience action creator used to pass ringing add call payload from the call manager as a redux action.
 * @param {Object} data
 */


function addRinging(data) {
  return function (dispatch, getState) {
    // Don't ring if this leg of the call is already canceled
    if ((0, _galaxyUtils.isGalaxyCallDisconnected)(getState(), data)) return;
    dispatch({
      type: c.GALAXY_ACTION_ADD_RINGING,
      payload: data
    });
  };
}
/**
 * Convenience action creator used to pass failed call payload from the call manager as a redux action.
 * @param {Object} data
 */


function failedCallGalaxy(data) {
  return {
    type: c.GALAXY_ACTION_FAILED,
    payload: data
  };
}
/**
 * Convenience action creator used to pass end call payload from the call manager as a redux action.
 * @param {Object} data
 */


function endCallGalaxy(data) {
  return {
    type: c.GALAXY_ACTION_END,
    payload: data
  };
}

function ignoreCallGalaxy(data) {
  return {
    type: c.GALAXY_ACTION_IGNORE,
    payload: data
  };
}

function incomingCallEndedGalaxy(data) {
  return {
    type: c.GALAXY_ACTION_INCOMING_CALL_ENDED,
    payload: data
  };
}

function remoteIceCandidates(data) {
  return {
    type: c.GALAXY_ACTION_TRICKLE_ICE,
    payload: data
  };
}
/**
 * toggleDoNotDisturb
 * This action will toggle the current doNotDisturb(dnd) state or set a given dnd state
 * @param {bool} mode - Bool indicating if dnd should be enabled or disabled.
 *                      If mode is not set the current state will be toggled
 */


function toggleDoNotDisturb(mode) {
  return function (dispatch) {
    return dispatch({
      type: c.TOGGLE_DO_NOT_DISTURB,
      payload: mode
    });
  };
}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activeCallDuration = exports.usersAndRoomSystemsOutsideCallSelector = exports.isDialingGalaxy = exports.isCallingGalaxy = exports.activeCallSelector = exports.incomingCallsSelector = exports.incomingGalaxyCalls = exports.selectPlatform = exports.nucleusMedia = exports.activeGalaxySourceId = exports.activeGalaxyCallId = exports.activeGalaxyCallState = exports.activeGalaxyCall = exports.activeCall = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _get = _interopRequireDefault(__webpack_require__(11));

var _reselect = __webpack_require__(23);

var _dateUtils = __webpack_require__(124);

var c = _interopRequireWildcard(__webpack_require__(3));

var _isEqual = _interopRequireDefault(__webpack_require__(180));

var conferenceUtils = _interopRequireWildcard(__webpack_require__(236));

var _contacts = __webpack_require__(35);

var _currentUser = __webpack_require__(37);

var _account = __webpack_require__(91);

var _localize = _interopRequireDefault(__webpack_require__(190));

var _auth = __webpack_require__(31);

var _conference = __webpack_require__(53);

var _participants = __webpack_require__(92);

var _moderator = __webpack_require__(93);

var _services = __webpack_require__(83);

var _this = void 0;

/** @module selectors/call */
// create a "selector creator" that uses lodash.isEqual instead of ===
var createDeepEqualSelector = (0, _reselect.createSelectorCreator)(_reselect.defaultMemoize, _isEqual.default);

var accountSettings = function accountSettings(state) {
  return (0, _get.default)(state, 'nucleus.account.settings') || {};
};

var acquiringCamera = function acquiringCamera(state) {
  return (0, _get.default)(state, 'nucleus.media.isAcquiringPrimaryStream') || false;
};

var activeCall = function activeCall(state) {
  return (0, _get.default)(state, 'nucleus.call.active') || {};
};

exports.activeCall = activeCall;

var activeGalaxyCall = function activeGalaxyCall(state) {
  return (0, _get.default)(state, 'nucleus.galaxy.call') || {};
};

exports.activeGalaxyCall = activeGalaxyCall;

var activeGalaxyCallState = function activeGalaxyCallState(state) {
  return (0, _get.default)(activeGalaxyCall(state), 'state');
};

exports.activeGalaxyCallState = activeGalaxyCallState;

var activeGalaxyCallId = function activeGalaxyCallId(state) {
  return (0, _get.default)(activeGalaxyCall(state), 'callId');
};

exports.activeGalaxyCallId = activeGalaxyCallId;

var activeGalaxySourceId = function activeGalaxySourceId(state) {
  return (0, _get.default)(activeGalaxyCall(state), 'sourceId');
};

exports.activeGalaxySourceId = activeGalaxySourceId;

var galaxyPresentation = function galaxyPresentation(state) {
  return (0, _get.default)(state, 'nucleus.galaxy.presentation') || {};
};

var galaxyRtc = function galaxyRtc(state) {
  return (0, _get.default)(state, 'nucleus.galaxy.rtc') || {};
};

var galaxyInvited = function galaxyInvited(state) {
  return (0, _get.default)(state, 'nucleus.galaxy.invited') || {};
};

var galaxyCallWaiting = function galaxyCallWaiting(state) {
  return (0, _get.default)(state, 'nucleus.galaxy.callWaiting') || {};
};

var galaxyConference = function galaxyConference(state) {
  return (0, _get.default)(state, 'nucleus.galaxy.conference') || {};
};

var galaxyRecording = function galaxyRecording(state) {
  return (0, _get.default)(state, 'nucleus.galaxy.recording') || {};
};

var incomingGalaxyCallQueue = function incomingGalaxyCallQueue(state) {
  return (0, _get.default)(state, 'nucleus.galaxy.incoming') || [];
};

var localeCode = function localeCode(state) {
  return (0, _get.default)(state, 'nucleus.localization.localeCode') || '';
};

var nucleusMedia = function nucleusMedia(state) {
  return (0, _get.default)(state, 'nucleus.media') || {};
};

exports.nucleusMedia = nucleusMedia;

var pendingPermission = function pendingPermission(state) {
  return (0, _get.default)(state, 'nucleus.media.isPendingPermissions') || false;
};

var selectPlatform = function selectPlatform(state) {
  return (0, _auth.getPlatform)(state) || c.PLATFORM_WEB;
};

exports.selectPlatform = selectPlatform;

var directorySearchResults = function directorySearchResults(state) {
  return (0, _get.default)(state, 'nucleus.directory.searchResults') || [];
};

var activeCallStartTime = function activeCallStartTime(state) {
  return (0, _get.default)(state, 'nucleus.galaxy.call.startTime');
};

var incomingGalaxyCalls = createDeepEqualSelector(activeGalaxyCall, galaxyCallWaiting, incomingGalaxyCallQueue, acquiringCamera, pendingPermission, _account.galaxyCallsEnabled, function (activeGalaxyCall, callWaiting, incomingGalaxyCallQueue, acquiringCamera, pendingPermission, galaxyCallsEnabled) {
  if (!galaxyCallsEnabled) return [];

  if (activeGalaxyCall.state === c.GALAXY_CALL_STATE_CONNECTED && (0, _get.default)(callWaiting, 'callId')) {
    return [{
      id: callWaiting.callId,
      dialString: callWaiting.dialString,
      displayString: callWaiting.displayName || callWaiting.dialString,
      galaxyCall: callWaiting,
      isGalaxyCall: true,
      canAnswer: true,
      canAdd: (0, _get.default)(callWaiting, 'canAdd', true),
      canEndAndAnswer: true
    }];
  } // Do not allow the user to answer the call until the camera source while
  // camera is being acquired


  var allowAnswer = !acquiringCamera || acquiringCamera && pendingPermission;
  return incomingGalaxyCallQueue.filter(function (i) {
    return !i.isMigrating;
  }).map(function (call) {
    var dialString = (0, _get.default)(call, 'dialString');
    return {
      id: call.conferenceId,
      dialString: dialString,
      displayString: (0, _get.default)(call, 'callerProperties.display_name') || dialString,
      isGalaxyCall: true,
      galaxyCall: call,
      canAnswer: allowAnswer,
      canAdd: false,
      canEndAndAnswer: false
    };
  });
});
exports.incomingGalaxyCalls = incomingGalaxyCalls;

/**
 * Retrieves all incoming calls
 * @example
 * Returns an array of incoming calls
 * [
 *  {
 *    id: 'A',
 *    conference: { id: 'A', participants: [...] }
 *    displayString: 'remoteDisplayName',
 *    participantId. 'remoteId123',
 *    selfParticipantId: 'self123',
 *    context: 'remoteContext'
 *    canAdd: bool,
 *    canEndAndAnswer: bool,
 *    canAnswer: bool
 *  },
 *  { id: X, displayString: 'Bob',  },
 * ]
 */
var incomingCallsSelector = createDeepEqualSelector(_services.selectConnected, activeGalaxyCall, incomingGalaxyCalls, galaxyCallWaiting, function (connected, activeGalaxyCall, incomingGalaxyCalls, galaxyCallWaiting) {
  if (!connected) return [];
  var galaxyState = (0, _get.default)(activeGalaxyCall, 'state') || c.GALAXY_CALL_STATE_DISCONNECTED;
  var galaxyCallActive = galaxyState !== c.GALAXY_CALL_STATE_DISCONNECTED;

  if (galaxyCallActive) {
    return incomingGalaxyCalls.map(function (incomingCall) {
      return (0, _objectSpread2.default)({}, incomingCall, {
        canAdd: (0, _get.default)(galaxyCallWaiting, c.CAN_ADD),
        canAnswer: false,
        canEndAndAnswer: true
      });
    });
  }

  return incomingGalaxyCalls;
});
exports.incomingCallsSelector = incomingCallsSelector;

/**
 * @todo Candidate for splitting.
 * Retrieves active call and its properties
 * @example
 * Returns a call object with call related details
 *  {
 *    id: 'WEB123',
 *    conferenceId: '1234-1234-1234-1234',
 *    isModerator: true,
 *    participants: [ { id: '1', name: abc123', dialString: '1234', isAudioOnly: false }... ]
 *    dialString: 'remoteExtension',
 *    name: 'remoteUserName',
 *    remoteContact: { id: '1'... },
 *    startTime: 12345678,
 *    endTime: 12345678,
 *    state: 'disconnected', // one of: 'disconnected', 'calling', 'connecting', 'connected',
 *    reason: 'dropped' // to be localized
 *    isManualDial: false, // true if there is no matching remoteContact
 *    isPresenting: false, // true if local user is presenting
 *    isAudioMuted: false,
 *    isVideoMuted: false
 *  }
 */
var activeCallSelector = createDeepEqualSelector(nucleusMedia, galaxyRtc, activeGalaxyCall, galaxyConference, galaxyInvited, galaxyPresentation, function (state) {
  return (0, _contacts.getContactByUuidGenerator)(state);
}, function (state) {
  return (0, _contacts.getContactByDialStringGenerator)(state);
}, _currentUser.myInfo, accountSettings, localeCode, galaxyRecording, _moderator.selectModeratorsMap, _moderator.selectIsCurrentUserModerator, _conference.selectCanCurrentUserKickParticipants, _conference.selectOwnerUuid, _conference.selectLecturerUuid, function (nucleusMedia, galaxyRtc, activeGalaxyCall, galaxyConference, galaxyInvited, galaxyPresentation, contactByUuidFinder, contactFinder, currentUser, accountSettings, localeCode, galaxyRecording, moderatorsMap, isCurrentUserModerator, canCurrentUserKickParticipants, ownerUuid, lecturerUuid) {
  var localizeWithCode = _localize.default.bind(_this, localeCode);

  var call = conferenceUtils.galaxyActiveCallUtil(activeGalaxyCall, galaxyConference, (0, _get.default)(galaxyConference, 'participants'), galaxyInvited, contactByUuidFinder, contactFinder, galaxyRtc, galaxyPresentation, currentUser, nucleusMedia, accountSettings, localizeWithCode, galaxyRecording, isCurrentUserModerator);
  call.participants = call.participants.map(function (p) {
    return (0, _participants.assignParticipantRoles)(p, ownerUuid, lecturerUuid, moderatorsMap);
  }).map(function (p) {
    return assignCurrentUserParticipantPermissions(p, isCurrentUserModerator, canCurrentUserKickParticipants);
  });
  return call;
});
exports.activeCallSelector = activeCallSelector;

function assignCurrentUserParticipantPermissions(participant, isCurrentUserMod, canCurrentUserKickParticipants) {
  return (0, _objectSpread2.default)({}, participant, {
    canKick: participant.isSelf ? false : canCurrentUserKickParticipants,
    canMute: participant.isSelf ? false : isCurrentUserMod
  });
} // galaxy call state helpers
// are we in the calling phase (we can cancel)


var isCallingGalaxy = createDeepEqualSelector(activeGalaxyCall, function (call) {
  return [c.GALAXY_CALL_STATE_TRYING, c.GALAXY_CALL_STATE_RINGING].indexOf(call.state) > -1;
});
exports.isCallingGalaxy = isCallingGalaxy;
// are we in the dialing phase (unable to cancel)
var isDialingGalaxy = createDeepEqualSelector(activeGalaxyCall, function (call) {
  return [c.GALAXY_CALL_STATE_BEGIN, c.GALAXY_CALL_STATE_CALLING].indexOf(call.state) > -1;
});
exports.isDialingGalaxy = isDialingGalaxy;
var usersAndRoomSystemsOutsideCallSelector = createDeepEqualSelector(directorySearchResults, galaxyConference, function (results, galaxyConference) {
  var conference = galaxyConference;
  return results.filter(function (contact) {
    return !contact.isMeeting && (!(0, _get.default)(conference, 'participants') || !conference.participants.find(function (participant) {
      return participant.uuid === contact.uuid;
    }));
  });
});
exports.usersAndRoomSystemsOutsideCallSelector = usersAndRoomSystemsOutsideCallSelector;

/**
 * Retrieves active call duration as a string in the form: hh:mm:ss
 *
 * @example
 * '1:55' for 1 minute, 55 seconds
 * '2:01:55' for 2 hours, 1 minute, 55 seconds
 * '0:55' for 55 seconds
 */
var activeCallDuration = createDeepEqualSelector(activeCallStartTime, function (activeCallStartTime) {
  var secondsElapsed = activeCallStartTime ? Math.floor((Date.now() - activeCallStartTime) / 1000) : 0;
  return (0, _dateUtils.formatElapsedCallTime)(secondsElapsed);
});
exports.activeCallDuration = activeCallDuration;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectIsGuest = exports.selectRole = void 0;

var _get = _interopRequireDefault(__webpack_require__(11));

var _constants = __webpack_require__(3);

var selectRole = function selectRole(state) {
  return (0, _get.default)(state, 'nucleus.userProfile.role');
};

exports.selectRole = selectRole;

var selectIsGuest = function selectIsGuest(state) {
  return selectRole(state) === _constants.USER_ROLE_GUEST;
};

exports.selectIsGuest = selectIsGuest;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectConference = selectConference;
exports.selectConferenceInfo = selectConferenceInfo;
exports.selectConferenceId = selectConferenceId;
exports.selectConferenceDisplayName = selectConferenceDisplayName;
exports.selectIsLocked = selectIsLocked;
exports.selectOwnerUuid = selectOwnerUuid;
exports.selectLecturerUuid = selectLecturerUuid;
exports.selectServerAudioMuteState = selectServerAudioMuteState;
exports.selectConferenceState = selectConferenceState;
exports.selectConferenceType = selectConferenceType;
exports.selectCanLockConference = selectCanLockConference;
exports.selectCanUnlockConference = selectCanUnlockConference;
exports.selectCanCurrentUserKickParticipants = selectCanCurrentUserKickParticipants;
exports.selectPresenterParticipantId = selectPresenterParticipantId;
exports.selectIsProcessingHandCommand = selectIsProcessingHandCommand;
exports.selectCanIssueHandCommand = exports.selectConferencePresenterParticipantId = void 0;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(71));

var _get = _interopRequireDefault(__webpack_require__(11));

var _reselect = __webpack_require__(23);

var C = _interopRequireWildcard(__webpack_require__(3));

var _participants = __webpack_require__(92);

var _call = __webpack_require__(51);

var _moderator = __webpack_require__(93);

function selectConference(state) {
  return (0, _get.default)(state, 'nucleus.conference');
}

function selectConferenceInfo(state) {
  return (0, _get.default)(selectConference(state), 'info');
}

function selectConferenceId(state) {
  return (0, _get.default)(selectConferenceInfo(state), 'id');
}

function selectConferenceDisplayName(state) {
  return (0, _get.default)(selectConferenceInfo(state), 'displayName');
}

function selectIsLocked(state) {
  return (0, _get.default)(selectConferenceInfo(state), 'isLocked');
}

function selectOwnerUuid(state) {
  return (0, _get.default)(selectConferenceInfo(state), 'ownerUuid');
}

function selectLecturerUuid(state) {
  return (0, _get.default)(selectConferenceInfo(state), 'lecturerUuid');
}

function selectServerAudioMuteState(state) {
  return (0, _get.default)(selectConferenceInfo(state), 'serverMuteState');
}

function selectConferenceState(state) {
  return (0, _get.default)(selectConferenceInfo(state), 'state');
}

function selectConferenceType(state) {
  return (0, _get.default)(selectConferenceInfo(state), 'type');
}

var specialCasePlatforms = new Set([C.PLATFORM_DASH, C.PLATFORM_ICON_300, C.PLATFORM_ICON_500, C.PLATFORM_ICON_700, C.PLATFORM_ICON_900]);

function selectCanLockConference(state) {
  return (0, _moderator.selectIsCurrentUserModerator)(state) && !selectIsLocked(state) && !selectIsProcessingLock(state);
}

function selectCanUnlockConference(state) {
  return (0, _moderator.selectIsCurrentUserModerator)(state) && selectIsLocked(state) && !selectIsProcessingLock(state);
}

function selectCanCurrentUserKickParticipants(state) {
  if ((0, _moderator.selectIsCurrentUserModerator)(state)) return true;
  var participantsMap = (0, _participants.selectParticipantsMap)(state);
  if (!participantsMap || participantsMap.size <= 2) return false;
  if (selectConferenceState(state) !== C.GALAXY_CONFERENCE_STATE_ESCALATED) return false;
  if (selectConferenceType(state) !== C.GALAXY_CONFERENCE_TYPE_ADHOC) return false;
  var platform = (0, _call.selectPlatform)(state);
  return specialCasePlatforms.has(platform);
}

var selectConferencePresenterParticipantId = (0, _reselect.createSelector)(_participants.selectParticipantsMap, selectPresenterParticipantId);
exports.selectConferencePresenterParticipantId = selectConferencePresenterParticipantId;

function selectPresenterParticipantId(participants) {
  var participantsArray = (0, _toConsumableArray2.default)(participants.values());
  var presenter = participantsArray.find(function (p) {
    return p.isPresenting;
  });
  return (0, _get.default)(presenter, 'participantId');
}

function selectIsProcessingHandCommand(state) {
  return (0, _get.default)(selectConferenceInfo(state), 'isProcessingHandCommand');
} // We will eventually also check a hand locked state, if admins have locked hand raise


var selectCanIssueHandCommand = function selectCanIssueHandCommand(state) {
  var conferenceInitialized = !!selectConferenceId(state);
  var processingHandCommand = selectIsProcessingHandCommand(state);
  return conferenceInitialized && !processingHandCommand;
};

exports.selectCanIssueHandCommand = selectCanIssueHandCommand;

function selectIsProcessingLock(state) {
  return (0, _get.default)(selectConferenceInfo(state), 'isProcessingLock');
}

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MeetingFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Meeting"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallableFields"},"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"meetingType"},"name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isPinProtected"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"owner"},"name":{"kind":"Name","value":"ownerCallable"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"displayName"},"arguments":[],"directives":[]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Record"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uuid"},"name":{"kind":"Name","value":"UUID"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lecturer"},"name":{"kind":"Name","value":"lecturerCallable"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"displayName"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"dialString"},"name":{"kind":"Name","value":"dialstring"},"arguments":[],"directives":[]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Record"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"UUID"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"uuid"},"name":{"kind":"Name","value":"UUID"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"moderator"},"name":{"kind":"Name","value":"moderatorCallable"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"displayName"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"dialString"},"name":{"kind":"Name","value":"dialstring"},"arguments":[],"directives":[]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Record"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"UUID"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"uuid"},"name":{"kind":"Name","value":"UUID"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"total"},"name":{"kind":"Name","value":"totalRecordCount"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":627}};
    doc.loc.source = {"body":"#import \"./callable-fragments.gql\"\n\nfragment MeetingFields on Meeting {\n  ...IdFields\n  ...CallableFields\n  meetingType: type\n  pin\n  isPinProtected\n  description\n  owner: ownerCallable {\n    name: displayName\n    ... on Record {\n      uuid: UUID\n    }\n  }\n  lecturer: lecturerCallable {\n    name: displayName\n    dialString: dialstring\n    ... on Record {\n      id: UUID\n      uuid: UUID\n    }\n  }\n  moderator: moderatorCallable {\n    name: displayName\n    dialString: dialstring\n    ... on Record {\n      id: UUID\n      uuid: UUID\n    }\n  },\n  participants {\n    total: totalRecordCount\n  }\n  # lastUsedAt\n  # lastCallDate\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(38).definitions));


      module.exports = doc;
    


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return observable; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var observable = /*@__PURE__*/ (function () { return typeof Symbol === 'function' && Symbol.observable || '@@observable'; })();
//# sourceMappingURL=observable.js.map


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ObjectUnsubscribedError; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var ObjectUnsubscribedErrorImpl = /*@__PURE__*/ (function () {
    function ObjectUnsubscribedErrorImpl() {
        Error.call(this);
        this.message = 'object unsubscribed';
        this.name = 'ObjectUnsubscribedError';
        return this;
    }
    ObjectUnsubscribedErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return ObjectUnsubscribedErrorImpl;
})();
var ObjectUnsubscribedError = ObjectUnsubscribedErrorImpl;
//# sourceMappingURL=ObjectUnsubscribedError.js.map


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(208);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 58 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mergeMap; });
/* unused harmony export MergeMapOperator */
/* unused harmony export MergeMapSubscriber */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15);
/* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16);
/* harmony import */ var _InnerSubscriber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39);
/* harmony import */ var _map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26);
/* harmony import */ var _observable_from__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30);
/** PURE_IMPORTS_START tslib,_util_subscribeToResult,_OuterSubscriber,_InnerSubscriber,_map,_observable_from PURE_IMPORTS_END */






function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    if (typeof resultSelector === 'function') {
        return function (source) { return source.pipe(mergeMap(function (a, i) { return Object(_observable_from__WEBPACK_IMPORTED_MODULE_5__[/* from */ "a"])(project(a, i)).pipe(Object(_map__WEBPACK_IMPORTED_MODULE_4__[/* map */ "a"])(function (b, ii) { return resultSelector(a, b, i, ii); })); }, concurrent)); };
    }
    else if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
    }
    return function (source) { return source.lift(new MergeMapOperator(project, concurrent)); };
}
var MergeMapOperator = /*@__PURE__*/ (function () {
    function MergeMapOperator(project, concurrent) {
        if (concurrent === void 0) {
            concurrent = Number.POSITIVE_INFINITY;
        }
        this.project = project;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function (observer, source) {
        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.concurrent));
    };
    return MergeMapOperator;
}());

var MergeMapSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"](MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, concurrent) {
        if (concurrent === void 0) {
            concurrent = Number.POSITIVE_INFINITY;
        }
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.concurrent = concurrent;
        _this.hasCompleted = false;
        _this.buffer = [];
        _this.active = 0;
        _this.index = 0;
        return _this;
    }
    MergeMapSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            this._tryNext(value);
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeMapSubscriber.prototype._tryNext = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result, value, index);
    };
    MergeMapSubscriber.prototype._innerSub = function (ish, value, index) {
        var innerSubscriber = new _InnerSubscriber__WEBPACK_IMPORTED_MODULE_3__[/* InnerSubscriber */ "a"](this, value, index);
        var destination = this.destination;
        destination.add(innerSubscriber);
        var innerSubscription = Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_1__[/* subscribeToResult */ "a"])(this, ish, undefined, undefined, innerSubscriber);
        if (innerSubscription !== innerSubscriber) {
            destination.add(innerSubscription);
        }
    };
    MergeMapSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            this.destination.complete();
        }
        this.unsubscribe();
    };
    MergeMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            this.destination.complete();
        }
    };
    return MergeMapSubscriber;
}(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_2__[/* OuterSubscriber */ "a"]));

//# sourceMappingURL=mergeMap.js.map


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArgumentOutOfRangeError; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var ArgumentOutOfRangeErrorImpl = /*@__PURE__*/ (function () {
    function ArgumentOutOfRangeErrorImpl() {
        Error.call(this);
        this.message = 'argument out of range';
        this.name = 'ArgumentOutOfRangeError';
        return this;
    }
    ArgumentOutOfRangeErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return ArgumentOutOfRangeErrorImpl;
})();
var ArgumentOutOfRangeError = ArgumentOutOfRangeErrorImpl;
//# sourceMappingURL=ArgumentOutOfRangeError.js.map


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isFunction; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isFunction(x) {
    return typeof x === 'function';
}
//# sourceMappingURL=isFunction.js.map


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(0);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/OuterSubscriber.js
var OuterSubscriber = __webpack_require__(16);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js
var subscribeToResult = __webpack_require__(15);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/audit.js
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



function audit(durationSelector) {
    return function auditOperatorFunction(source) {
        return source.lift(new AuditOperator(durationSelector));
    };
}
var AuditOperator = /*@__PURE__*/ (function () {
    function AuditOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    AuditOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new audit_AuditSubscriber(subscriber, this.durationSelector));
    };
    return AuditOperator;
}());
var audit_AuditSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](AuditSubscriber, _super);
    function AuditSubscriber(destination, durationSelector) {
        var _this = _super.call(this, destination) || this;
        _this.durationSelector = durationSelector;
        _this.hasValue = false;
        return _this;
    }
    AuditSubscriber.prototype._next = function (value) {
        this.value = value;
        this.hasValue = true;
        if (!this.throttled) {
            var duration = void 0;
            try {
                var durationSelector = this.durationSelector;
                duration = durationSelector(value);
            }
            catch (err) {
                return this.destination.error(err);
            }
            var innerSubscription = Object(subscribeToResult["a" /* subscribeToResult */])(this, duration);
            if (!innerSubscription || innerSubscription.closed) {
                this.clearThrottle();
            }
            else {
                this.add(this.throttled = innerSubscription);
            }
        }
    };
    AuditSubscriber.prototype.clearThrottle = function () {
        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
        if (hasValue) {
            this.value = null;
            this.hasValue = false;
            this.destination.next(value);
        }
    };
    AuditSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex) {
        this.clearThrottle();
    };
    AuditSubscriber.prototype.notifyComplete = function () {
        this.clearThrottle();
    };
    return AuditSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));
//# sourceMappingURL=audit.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/async.js
var scheduler_async = __webpack_require__(25);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/timer.js
var timer = __webpack_require__(149);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/auditTime.js
/** PURE_IMPORTS_START _scheduler_async,_audit,_observable_timer PURE_IMPORTS_END */



function auditTime(duration, scheduler) {
    if (scheduler === void 0) {
        scheduler = scheduler_async["a" /* async */];
    }
    return audit(function () { return Object(timer["a" /* timer */])(duration, scheduler); });
}
//# sourceMappingURL=auditTime.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/buffer.js
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



function buffer_buffer(closingNotifier) {
    return function bufferOperatorFunction(source) {
        return source.lift(new BufferOperator(closingNotifier));
    };
}
var BufferOperator = /*@__PURE__*/ (function () {
    function BufferOperator(closingNotifier) {
        this.closingNotifier = closingNotifier;
    }
    BufferOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new buffer_BufferSubscriber(subscriber, this.closingNotifier));
    };
    return BufferOperator;
}());
var buffer_BufferSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](BufferSubscriber, _super);
    function BufferSubscriber(destination, closingNotifier) {
        var _this = _super.call(this, destination) || this;
        _this.buffer = [];
        _this.add(Object(subscribeToResult["a" /* subscribeToResult */])(_this, closingNotifier));
        return _this;
    }
    BufferSubscriber.prototype._next = function (value) {
        this.buffer.push(value);
    };
    BufferSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var buffer = this.buffer;
        this.buffer = [];
        this.destination.next(buffer);
    };
    return BufferSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));
//# sourceMappingURL=buffer.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Subscriber.js
var Subscriber = __webpack_require__(5);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/bufferCount.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) {
        startBufferEvery = null;
    }
    return function bufferCountOperatorFunction(source) {
        return source.lift(new BufferCountOperator(bufferSize, startBufferEvery));
    };
}
var BufferCountOperator = /*@__PURE__*/ (function () {
    function BufferCountOperator(bufferSize, startBufferEvery) {
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        if (!startBufferEvery || bufferSize === startBufferEvery) {
            this.subscriberClass = bufferCount_BufferCountSubscriber;
        }
        else {
            this.subscriberClass = bufferCount_BufferSkipCountSubscriber;
        }
    }
    BufferCountOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new this.subscriberClass(subscriber, this.bufferSize, this.startBufferEvery));
    };
    return BufferCountOperator;
}());
var bufferCount_BufferCountSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](BufferCountSubscriber, _super);
    function BufferCountSubscriber(destination, bufferSize) {
        var _this = _super.call(this, destination) || this;
        _this.bufferSize = bufferSize;
        _this.buffer = [];
        return _this;
    }
    BufferCountSubscriber.prototype._next = function (value) {
        var buffer = this.buffer;
        buffer.push(value);
        if (buffer.length == this.bufferSize) {
            this.destination.next(buffer);
            this.buffer = [];
        }
    };
    BufferCountSubscriber.prototype._complete = function () {
        var buffer = this.buffer;
        if (buffer.length > 0) {
            this.destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    return BufferCountSubscriber;
}(Subscriber["a" /* Subscriber */]));
var bufferCount_BufferSkipCountSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](BufferSkipCountSubscriber, _super);
    function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
        var _this = _super.call(this, destination) || this;
        _this.bufferSize = bufferSize;
        _this.startBufferEvery = startBufferEvery;
        _this.buffers = [];
        _this.count = 0;
        return _this;
    }
    BufferSkipCountSubscriber.prototype._next = function (value) {
        var _a = this, bufferSize = _a.bufferSize, startBufferEvery = _a.startBufferEvery, buffers = _a.buffers, count = _a.count;
        this.count++;
        if (count % startBufferEvery === 0) {
            buffers.push([]);
        }
        for (var i = buffers.length; i--;) {
            var buffer = buffers[i];
            buffer.push(value);
            if (buffer.length === bufferSize) {
                buffers.splice(i, 1);
                this.destination.next(buffer);
            }
        }
    };
    BufferSkipCountSubscriber.prototype._complete = function () {
        var _a = this, buffers = _a.buffers, destination = _a.destination;
        while (buffers.length > 0) {
            var buffer = buffers.shift();
            if (buffer.length > 0) {
                destination.next(buffer);
            }
        }
        _super.prototype._complete.call(this);
    };
    return BufferSkipCountSubscriber;
}(Subscriber["a" /* Subscriber */]));
//# sourceMappingURL=bufferCount.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isScheduler.js
var isScheduler = __webpack_require__(27);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/bufferTime.js
/** PURE_IMPORTS_START tslib,_scheduler_async,_Subscriber,_util_isScheduler PURE_IMPORTS_END */




function bufferTime(bufferTimeSpan) {
    var length = arguments.length;
    var scheduler = scheduler_async["a" /* async */];
    if (Object(isScheduler["a" /* isScheduler */])(arguments[arguments.length - 1])) {
        scheduler = arguments[arguments.length - 1];
        length--;
    }
    var bufferCreationInterval = null;
    if (length >= 2) {
        bufferCreationInterval = arguments[1];
    }
    var maxBufferSize = Number.POSITIVE_INFINITY;
    if (length >= 3) {
        maxBufferSize = arguments[2];
    }
    return function bufferTimeOperatorFunction(source) {
        return source.lift(new BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler));
    };
}
var BufferTimeOperator = /*@__PURE__*/ (function () {
    function BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        this.bufferTimeSpan = bufferTimeSpan;
        this.bufferCreationInterval = bufferCreationInterval;
        this.maxBufferSize = maxBufferSize;
        this.scheduler = scheduler;
    }
    BufferTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new bufferTime_BufferTimeSubscriber(subscriber, this.bufferTimeSpan, this.bufferCreationInterval, this.maxBufferSize, this.scheduler));
    };
    return BufferTimeOperator;
}());
var Context = /*@__PURE__*/ (function () {
    function Context() {
        this.buffer = [];
    }
    return Context;
}());
var bufferTime_BufferTimeSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](BufferTimeSubscriber, _super);
    function BufferTimeSubscriber(destination, bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.bufferTimeSpan = bufferTimeSpan;
        _this.bufferCreationInterval = bufferCreationInterval;
        _this.maxBufferSize = maxBufferSize;
        _this.scheduler = scheduler;
        _this.contexts = [];
        var context = _this.openContext();
        _this.timespanOnly = bufferCreationInterval == null || bufferCreationInterval < 0;
        if (_this.timespanOnly) {
            var timeSpanOnlyState = { subscriber: _this, context: context, bufferTimeSpan: bufferTimeSpan };
            _this.add(context.closeAction = scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        }
        else {
            var closeState = { subscriber: _this, context: context };
            var creationState = { bufferTimeSpan: bufferTimeSpan, bufferCreationInterval: bufferCreationInterval, subscriber: _this, scheduler: scheduler };
            _this.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, closeState));
            _this.add(scheduler.schedule(dispatchBufferCreation, bufferCreationInterval, creationState));
        }
        return _this;
    }
    BufferTimeSubscriber.prototype._next = function (value) {
        var contexts = this.contexts;
        var len = contexts.length;
        var filledBufferContext;
        for (var i = 0; i < len; i++) {
            var context_1 = contexts[i];
            var buffer = context_1.buffer;
            buffer.push(value);
            if (buffer.length == this.maxBufferSize) {
                filledBufferContext = context_1;
            }
        }
        if (filledBufferContext) {
            this.onBufferFull(filledBufferContext);
        }
    };
    BufferTimeSubscriber.prototype._error = function (err) {
        this.contexts.length = 0;
        _super.prototype._error.call(this, err);
    };
    BufferTimeSubscriber.prototype._complete = function () {
        var _a = this, contexts = _a.contexts, destination = _a.destination;
        while (contexts.length > 0) {
            var context_2 = contexts.shift();
            destination.next(context_2.buffer);
        }
        _super.prototype._complete.call(this);
    };
    BufferTimeSubscriber.prototype._unsubscribe = function () {
        this.contexts = null;
    };
    BufferTimeSubscriber.prototype.onBufferFull = function (context) {
        this.closeContext(context);
        var closeAction = context.closeAction;
        closeAction.unsubscribe();
        this.remove(closeAction);
        if (!this.closed && this.timespanOnly) {
            context = this.openContext();
            var bufferTimeSpan = this.bufferTimeSpan;
            var timeSpanOnlyState = { subscriber: this, context: context, bufferTimeSpan: bufferTimeSpan };
            this.add(context.closeAction = this.scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        }
    };
    BufferTimeSubscriber.prototype.openContext = function () {
        var context = new Context();
        this.contexts.push(context);
        return context;
    };
    BufferTimeSubscriber.prototype.closeContext = function (context) {
        this.destination.next(context.buffer);
        var contexts = this.contexts;
        var spliceIndex = contexts ? contexts.indexOf(context) : -1;
        if (spliceIndex >= 0) {
            contexts.splice(contexts.indexOf(context), 1);
        }
    };
    return BufferTimeSubscriber;
}(Subscriber["a" /* Subscriber */]));
function dispatchBufferTimeSpanOnly(state) {
    var subscriber = state.subscriber;
    var prevContext = state.context;
    if (prevContext) {
        subscriber.closeContext(prevContext);
    }
    if (!subscriber.closed) {
        state.context = subscriber.openContext();
        state.context.closeAction = this.schedule(state, state.bufferTimeSpan);
    }
}
function dispatchBufferCreation(state) {
    var bufferCreationInterval = state.bufferCreationInterval, bufferTimeSpan = state.bufferTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler;
    var context = subscriber.openContext();
    var action = this;
    if (!subscriber.closed) {
        subscriber.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, { subscriber: subscriber, context: context }));
        action.schedule(state, bufferCreationInterval);
    }
}
function dispatchBufferClose(arg) {
    var subscriber = arg.subscriber, context = arg.context;
    subscriber.closeContext(context);
}
//# sourceMappingURL=bufferTime.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Subscription.js
var Subscription = __webpack_require__(20);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/bufferToggle.js
/** PURE_IMPORTS_START tslib,_Subscription,_util_subscribeToResult,_OuterSubscriber PURE_IMPORTS_END */




function bufferToggle(openings, closingSelector) {
    return function bufferToggleOperatorFunction(source) {
        return source.lift(new BufferToggleOperator(openings, closingSelector));
    };
}
var BufferToggleOperator = /*@__PURE__*/ (function () {
    function BufferToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    BufferToggleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new bufferToggle_BufferToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return BufferToggleOperator;
}());
var bufferToggle_BufferToggleSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](BufferToggleSubscriber, _super);
    function BufferToggleSubscriber(destination, openings, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.openings = openings;
        _this.closingSelector = closingSelector;
        _this.contexts = [];
        _this.add(Object(subscribeToResult["a" /* subscribeToResult */])(_this, openings));
        return _this;
    }
    BufferToggleSubscriber.prototype._next = function (value) {
        var contexts = this.contexts;
        var len = contexts.length;
        for (var i = 0; i < len; i++) {
            contexts[i].buffer.push(value);
        }
    };
    BufferToggleSubscriber.prototype._error = function (err) {
        var contexts = this.contexts;
        while (contexts.length > 0) {
            var context_1 = contexts.shift();
            context_1.subscription.unsubscribe();
            context_1.buffer = null;
            context_1.subscription = null;
        }
        this.contexts = null;
        _super.prototype._error.call(this, err);
    };
    BufferToggleSubscriber.prototype._complete = function () {
        var contexts = this.contexts;
        while (contexts.length > 0) {
            var context_2 = contexts.shift();
            this.destination.next(context_2.buffer);
            context_2.subscription.unsubscribe();
            context_2.buffer = null;
            context_2.subscription = null;
        }
        this.contexts = null;
        _super.prototype._complete.call(this);
    };
    BufferToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        outerValue ? this.closeBuffer(outerValue) : this.openBuffer(innerValue);
    };
    BufferToggleSubscriber.prototype.notifyComplete = function (innerSub) {
        this.closeBuffer(innerSub.context);
    };
    BufferToggleSubscriber.prototype.openBuffer = function (value) {
        try {
            var closingSelector = this.closingSelector;
            var closingNotifier = closingSelector.call(this, value);
            if (closingNotifier) {
                this.trySubscribe(closingNotifier);
            }
        }
        catch (err) {
            this._error(err);
        }
    };
    BufferToggleSubscriber.prototype.closeBuffer = function (context) {
        var contexts = this.contexts;
        if (contexts && context) {
            var buffer = context.buffer, subscription = context.subscription;
            this.destination.next(buffer);
            contexts.splice(contexts.indexOf(context), 1);
            this.remove(subscription);
            subscription.unsubscribe();
        }
    };
    BufferToggleSubscriber.prototype.trySubscribe = function (closingNotifier) {
        var contexts = this.contexts;
        var buffer = [];
        var subscription = new Subscription["a" /* Subscription */]();
        var context = { buffer: buffer, subscription: subscription };
        contexts.push(context);
        var innerSubscription = Object(subscribeToResult["a" /* subscribeToResult */])(this, closingNotifier, context);
        if (!innerSubscription || innerSubscription.closed) {
            this.closeBuffer(context);
        }
        else {
            innerSubscription.context = context;
            this.add(innerSubscription);
            subscription.add(innerSubscription);
        }
    };
    return BufferToggleSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));
//# sourceMappingURL=bufferToggle.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/bufferWhen.js
/** PURE_IMPORTS_START tslib,_Subscription,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */




function bufferWhen(closingSelector) {
    return function (source) {
        return source.lift(new BufferWhenOperator(closingSelector));
    };
}
var BufferWhenOperator = /*@__PURE__*/ (function () {
    function BufferWhenOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    BufferWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new bufferWhen_BufferWhenSubscriber(subscriber, this.closingSelector));
    };
    return BufferWhenOperator;
}());
var bufferWhen_BufferWhenSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](BufferWhenSubscriber, _super);
    function BufferWhenSubscriber(destination, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.closingSelector = closingSelector;
        _this.subscribing = false;
        _this.openBuffer();
        return _this;
    }
    BufferWhenSubscriber.prototype._next = function (value) {
        this.buffer.push(value);
    };
    BufferWhenSubscriber.prototype._complete = function () {
        var buffer = this.buffer;
        if (buffer) {
            this.destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    BufferWhenSubscriber.prototype._unsubscribe = function () {
        this.buffer = null;
        this.subscribing = false;
    };
    BufferWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openBuffer();
    };
    BufferWhenSubscriber.prototype.notifyComplete = function () {
        if (this.subscribing) {
            this.complete();
        }
        else {
            this.openBuffer();
        }
    };
    BufferWhenSubscriber.prototype.openBuffer = function () {
        var closingSubscription = this.closingSubscription;
        if (closingSubscription) {
            this.remove(closingSubscription);
            closingSubscription.unsubscribe();
        }
        var buffer = this.buffer;
        if (this.buffer) {
            this.destination.next(buffer);
        }
        this.buffer = [];
        var closingNotifier;
        try {
            var closingSelector = this.closingSelector;
            closingNotifier = closingSelector();
        }
        catch (err) {
            return this.error(err);
        }
        closingSubscription = new Subscription["a" /* Subscription */]();
        this.closingSubscription = closingSubscription;
        this.add(closingSubscription);
        this.subscribing = true;
        closingSubscription.add(Object(subscribeToResult["a" /* subscribeToResult */])(this, closingNotifier));
        this.subscribing = false;
    };
    return BufferWhenSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));
//# sourceMappingURL=bufferWhen.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/InnerSubscriber.js
var InnerSubscriber = __webpack_require__(39);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/catchError.js
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_InnerSubscriber,_util_subscribeToResult PURE_IMPORTS_END */




function catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new CatchOperator(selector);
        var caught = source.lift(operator);
        return (operator.caught = caught);
    };
}
var CatchOperator = /*@__PURE__*/ (function () {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new catchError_CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}());
var catchError_CatchSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        var _this = _super.call(this, destination) || this;
        _this.selector = selector;
        _this.caught = caught;
        return _this;
    }
    CatchSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            }
            catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            var innerSubscriber = new InnerSubscriber["a" /* InnerSubscriber */](this, undefined, undefined);
            this.add(innerSubscriber);
            var innerSubscription = Object(subscribeToResult["a" /* subscribeToResult */])(this, result, undefined, undefined, innerSubscriber);
            if (innerSubscription !== innerSubscriber) {
                this.add(innerSubscription);
            }
        }
    };
    return CatchSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));
//# sourceMappingURL=catchError.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/combineLatest.js
var combineLatest = __webpack_require__(106);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/combineAll.js
/** PURE_IMPORTS_START _observable_combineLatest PURE_IMPORTS_END */

function combineAll(project) {
    return function (source) { return source.lift(new combineLatest["a" /* CombineLatestOperator */](project)); };
}
//# sourceMappingURL=combineAll.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isArray.js
var isArray = __webpack_require__(24);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/from.js
var from = __webpack_require__(30);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/combineLatest.js
/** PURE_IMPORTS_START _util_isArray,_observable_combineLatest,_observable_from PURE_IMPORTS_END */



var none = {};
function combineLatest_combineLatest() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var project = null;
    if (typeof observables[observables.length - 1] === 'function') {
        project = observables.pop();
    }
    if (observables.length === 1 && Object(isArray["a" /* isArray */])(observables[0])) {
        observables = observables[0].slice();
    }
    return function (source) { return source.lift.call(Object(from["a" /* from */])([source].concat(observables)), new combineLatest["a" /* CombineLatestOperator */](project)); };
}
//# sourceMappingURL=combineLatest.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/concat.js
var concat = __webpack_require__(75);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/concat.js
/** PURE_IMPORTS_START _observable_concat PURE_IMPORTS_END */

function concat_concat() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return function (source) { return source.lift.call(concat["a" /* concat */].apply(void 0, [source].concat(observables))); };
}
//# sourceMappingURL=concat.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/concatAll.js
var concatAll = __webpack_require__(150);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/mergeMap.js
var mergeMap = __webpack_require__(59);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/concatMap.js
/** PURE_IMPORTS_START _mergeMap PURE_IMPORTS_END */

function concatMap(project, resultSelector) {
    return Object(mergeMap["a" /* mergeMap */])(project, resultSelector, 1);
}
//# sourceMappingURL=concatMap.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/concatMapTo.js
/** PURE_IMPORTS_START _concatMap PURE_IMPORTS_END */

function concatMapTo(innerObservable, resultSelector) {
    return concatMap(function () { return innerObservable; }, resultSelector);
}
//# sourceMappingURL=concatMapTo.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/count.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function count_count(predicate) {
    return function (source) { return source.lift(new CountOperator(predicate, source)); };
}
var CountOperator = /*@__PURE__*/ (function () {
    function CountOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    CountOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new count_CountSubscriber(subscriber, this.predicate, this.source));
    };
    return CountOperator;
}());
var count_CountSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](CountSubscriber, _super);
    function CountSubscriber(destination, predicate, source) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.source = source;
        _this.count = 0;
        _this.index = 0;
        return _this;
    }
    CountSubscriber.prototype._next = function (value) {
        if (this.predicate) {
            this._tryPredicate(value);
        }
        else {
            this.count++;
        }
    };
    CountSubscriber.prototype._tryPredicate = function (value) {
        var result;
        try {
            result = this.predicate(value, this.index++, this.source);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this.count++;
        }
    };
    CountSubscriber.prototype._complete = function () {
        this.destination.next(this.count);
        this.destination.complete();
    };
    return CountSubscriber;
}(Subscriber["a" /* Subscriber */]));
//# sourceMappingURL=count.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/debounce.js
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



function debounce(durationSelector) {
    return function (source) { return source.lift(new DebounceOperator(durationSelector)); };
}
var DebounceOperator = /*@__PURE__*/ (function () {
    function DebounceOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    DebounceOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new debounce_DebounceSubscriber(subscriber, this.durationSelector));
    };
    return DebounceOperator;
}());
var debounce_DebounceSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](DebounceSubscriber, _super);
    function DebounceSubscriber(destination, durationSelector) {
        var _this = _super.call(this, destination) || this;
        _this.durationSelector = durationSelector;
        _this.hasValue = false;
        _this.durationSubscription = null;
        return _this;
    }
    DebounceSubscriber.prototype._next = function (value) {
        try {
            var result = this.durationSelector.call(this, value);
            if (result) {
                this._tryNext(value, result);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    DebounceSubscriber.prototype._complete = function () {
        this.emitValue();
        this.destination.complete();
    };
    DebounceSubscriber.prototype._tryNext = function (value, duration) {
        var subscription = this.durationSubscription;
        this.value = value;
        this.hasValue = true;
        if (subscription) {
            subscription.unsubscribe();
            this.remove(subscription);
        }
        subscription = Object(subscribeToResult["a" /* subscribeToResult */])(this, duration);
        if (subscription && !subscription.closed) {
            this.add(this.durationSubscription = subscription);
        }
    };
    DebounceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.emitValue();
    };
    DebounceSubscriber.prototype.notifyComplete = function () {
        this.emitValue();
    };
    DebounceSubscriber.prototype.emitValue = function () {
        if (this.hasValue) {
            var value = this.value;
            var subscription = this.durationSubscription;
            if (subscription) {
                this.durationSubscription = null;
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.value = null;
            this.hasValue = false;
            _super.prototype._next.call(this, value);
        }
    };
    return DebounceSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));
//# sourceMappingURL=debounce.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/debounceTime.js
/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async PURE_IMPORTS_END */



function debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) {
        scheduler = scheduler_async["a" /* async */];
    }
    return function (source) { return source.lift(new DebounceTimeOperator(dueTime, scheduler)); };
}
var DebounceTimeOperator = /*@__PURE__*/ (function () {
    function DebounceTimeOperator(dueTime, scheduler) {
        this.dueTime = dueTime;
        this.scheduler = scheduler;
    }
    DebounceTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new debounceTime_DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
    };
    return DebounceTimeOperator;
}());
var debounceTime_DebounceTimeSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](DebounceTimeSubscriber, _super);
    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.dueTime = dueTime;
        _this.scheduler = scheduler;
        _this.debouncedSubscription = null;
        _this.lastValue = null;
        _this.hasValue = false;
        return _this;
    }
    DebounceTimeSubscriber.prototype._next = function (value) {
        this.clearDebounce();
        this.lastValue = value;
        this.hasValue = true;
        this.add(this.debouncedSubscription = this.scheduler.schedule(dispatchNext, this.dueTime, this));
    };
    DebounceTimeSubscriber.prototype._complete = function () {
        this.debouncedNext();
        this.destination.complete();
    };
    DebounceTimeSubscriber.prototype.debouncedNext = function () {
        this.clearDebounce();
        if (this.hasValue) {
            var lastValue = this.lastValue;
            this.lastValue = null;
            this.hasValue = false;
            this.destination.next(lastValue);
        }
    };
    DebounceTimeSubscriber.prototype.clearDebounce = function () {
        var debouncedSubscription = this.debouncedSubscription;
        if (debouncedSubscription !== null) {
            this.remove(debouncedSubscription);
            debouncedSubscription.unsubscribe();
            this.debouncedSubscription = null;
        }
    };
    return DebounceTimeSubscriber;
}(Subscriber["a" /* Subscriber */]));
function dispatchNext(subscriber) {
    subscriber.debouncedNext();
}
//# sourceMappingURL=debounceTime.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/defaultIfEmpty.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) {
        defaultValue = null;
    }
    return function (source) { return source.lift(new DefaultIfEmptyOperator(defaultValue)); };
}
var DefaultIfEmptyOperator = /*@__PURE__*/ (function () {
    function DefaultIfEmptyOperator(defaultValue) {
        this.defaultValue = defaultValue;
    }
    DefaultIfEmptyOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new defaultIfEmpty_DefaultIfEmptySubscriber(subscriber, this.defaultValue));
    };
    return DefaultIfEmptyOperator;
}());
var defaultIfEmpty_DefaultIfEmptySubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](DefaultIfEmptySubscriber, _super);
    function DefaultIfEmptySubscriber(destination, defaultValue) {
        var _this = _super.call(this, destination) || this;
        _this.defaultValue = defaultValue;
        _this.isEmpty = true;
        return _this;
    }
    DefaultIfEmptySubscriber.prototype._next = function (value) {
        this.isEmpty = false;
        this.destination.next(value);
    };
    DefaultIfEmptySubscriber.prototype._complete = function () {
        if (this.isEmpty) {
            this.destination.next(this.defaultValue);
        }
        this.destination.complete();
    };
    return DefaultIfEmptySubscriber;
}(Subscriber["a" /* Subscriber */]));
//# sourceMappingURL=defaultIfEmpty.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/util/isDate.js
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
//# sourceMappingURL=isDate.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Notification.js
var Notification = __webpack_require__(46);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/delay.js
/** PURE_IMPORTS_START tslib,_scheduler_async,_util_isDate,_Subscriber,_Notification PURE_IMPORTS_END */





function delay_delay(delay, scheduler) {
    if (scheduler === void 0) {
        scheduler = scheduler_async["a" /* async */];
    }
    var absoluteDelay = isDate(delay);
    var delayFor = absoluteDelay ? (+delay - scheduler.now()) : Math.abs(delay);
    return function (source) { return source.lift(new DelayOperator(delayFor, scheduler)); };
}
var DelayOperator = /*@__PURE__*/ (function () {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new delay_DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}());
var delay_DelaySubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.delay = delay;
        _this.scheduler = scheduler;
        _this.queue = [];
        _this.active = false;
        _this.errored = false;
        return _this;
    }
    DelaySubscriber.dispatch = function (state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while (queue.length > 0 && (queue[0].time - scheduler.now()) <= 0) {
            queue.shift().notification.observe(destination);
        }
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        }
        else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function (scheduler) {
        this.active = true;
        var destination = this.destination;
        destination.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this, destination: this.destination, scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function (notification) {
        if (this.errored === true) {
            return;
        }
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) {
            this._schedule(scheduler);
        }
    };
    DelaySubscriber.prototype._next = function (value) {
        this.scheduleNotification(Notification["a" /* Notification */].createNext(value));
    };
    DelaySubscriber.prototype._error = function (err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
        this.unsubscribe();
    };
    DelaySubscriber.prototype._complete = function () {
        this.scheduleNotification(Notification["a" /* Notification */].createComplete());
        this.unsubscribe();
    };
    return DelaySubscriber;
}(Subscriber["a" /* Subscriber */]));
var DelayMessage = /*@__PURE__*/ (function () {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}());
//# sourceMappingURL=delay.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Observable.js + 1 modules
var Observable = __webpack_require__(10);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/delayWhen.js
/** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */





function delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) {
        return function (source) {
            return new delayWhen_SubscriptionDelayObservable(source, subscriptionDelay)
                .lift(new DelayWhenOperator(delayDurationSelector));
        };
    }
    return function (source) { return source.lift(new DelayWhenOperator(delayDurationSelector)); };
}
var DelayWhenOperator = /*@__PURE__*/ (function () {
    function DelayWhenOperator(delayDurationSelector) {
        this.delayDurationSelector = delayDurationSelector;
    }
    DelayWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new delayWhen_DelayWhenSubscriber(subscriber, this.delayDurationSelector));
    };
    return DelayWhenOperator;
}());
var delayWhen_DelayWhenSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](DelayWhenSubscriber, _super);
    function DelayWhenSubscriber(destination, delayDurationSelector) {
        var _this = _super.call(this, destination) || this;
        _this.delayDurationSelector = delayDurationSelector;
        _this.completed = false;
        _this.delayNotifierSubscriptions = [];
        _this.index = 0;
        return _this;
    }
    DelayWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(outerValue);
        this.removeSubscription(innerSub);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    DelayWhenSubscriber.prototype.notifyComplete = function (innerSub) {
        var value = this.removeSubscription(innerSub);
        if (value) {
            this.destination.next(value);
        }
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype._next = function (value) {
        var index = this.index++;
        try {
            var delayNotifier = this.delayDurationSelector(value, index);
            if (delayNotifier) {
                this.tryDelay(delayNotifier, value);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    DelayWhenSubscriber.prototype._complete = function () {
        this.completed = true;
        this.tryComplete();
        this.unsubscribe();
    };
    DelayWhenSubscriber.prototype.removeSubscription = function (subscription) {
        subscription.unsubscribe();
        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
        if (subscriptionIdx !== -1) {
            this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
        }
        return subscription.outerValue;
    };
    DelayWhenSubscriber.prototype.tryDelay = function (delayNotifier, value) {
        var notifierSubscription = Object(subscribeToResult["a" /* subscribeToResult */])(this, delayNotifier, value);
        if (notifierSubscription && !notifierSubscription.closed) {
            var destination = this.destination;
            destination.add(notifierSubscription);
            this.delayNotifierSubscriptions.push(notifierSubscription);
        }
    };
    DelayWhenSubscriber.prototype.tryComplete = function () {
        if (this.completed && this.delayNotifierSubscriptions.length === 0) {
            this.destination.complete();
        }
    };
    return DelayWhenSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));
var delayWhen_SubscriptionDelayObservable = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](SubscriptionDelayObservable, _super);
    function SubscriptionDelayObservable(source, subscriptionDelay) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subscriptionDelay = subscriptionDelay;
        return _this;
    }
    SubscriptionDelayObservable.prototype._subscribe = function (subscriber) {
        this.subscriptionDelay.subscribe(new delayWhen_SubscriptionDelaySubscriber(subscriber, this.source));
    };
    return SubscriptionDelayObservable;
}(Observable["a" /* Observable */]));
var delayWhen_SubscriptionDelaySubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](SubscriptionDelaySubscriber, _super);
    function SubscriptionDelaySubscriber(parent, source) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.source = source;
        _this.sourceSubscribed = false;
        return _this;
    }
    SubscriptionDelaySubscriber.prototype._next = function (unused) {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype._error = function (err) {
        this.unsubscribe();
        this.parent.error(err);
    };
    SubscriptionDelaySubscriber.prototype._complete = function () {
        this.unsubscribe();
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype.subscribeToSource = function () {
        if (!this.sourceSubscribed) {
            this.sourceSubscribed = true;
            this.unsubscribe();
            this.source.subscribe(this.parent);
        }
    };
    return SubscriptionDelaySubscriber;
}(Subscriber["a" /* Subscriber */]));
//# sourceMappingURL=delayWhen.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/dematerialize.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function dematerialize() {
    return function dematerializeOperatorFunction(source) {
        return source.lift(new DeMaterializeOperator());
    };
}
var DeMaterializeOperator = /*@__PURE__*/ (function () {
    function DeMaterializeOperator() {
    }
    DeMaterializeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new dematerialize_DeMaterializeSubscriber(subscriber));
    };
    return DeMaterializeOperator;
}());
var dematerialize_DeMaterializeSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](DeMaterializeSubscriber, _super);
    function DeMaterializeSubscriber(destination) {
        return _super.call(this, destination) || this;
    }
    DeMaterializeSubscriber.prototype._next = function (value) {
        value.observe(this.destination);
    };
    return DeMaterializeSubscriber;
}(Subscriber["a" /* Subscriber */]));
//# sourceMappingURL=dematerialize.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/distinct.js
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



function distinct(keySelector, flushes) {
    return function (source) { return source.lift(new DistinctOperator(keySelector, flushes)); };
}
var DistinctOperator = /*@__PURE__*/ (function () {
    function DistinctOperator(keySelector, flushes) {
        this.keySelector = keySelector;
        this.flushes = flushes;
    }
    DistinctOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new distinct_DistinctSubscriber(subscriber, this.keySelector, this.flushes));
    };
    return DistinctOperator;
}());
var distinct_DistinctSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](DistinctSubscriber, _super);
    function DistinctSubscriber(destination, keySelector, flushes) {
        var _this = _super.call(this, destination) || this;
        _this.keySelector = keySelector;
        _this.values = new Set();
        if (flushes) {
            _this.add(Object(subscribeToResult["a" /* subscribeToResult */])(_this, flushes));
        }
        return _this;
    }
    DistinctSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values.clear();
    };
    DistinctSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    DistinctSubscriber.prototype._next = function (value) {
        if (this.keySelector) {
            this._useKeySelector(value);
        }
        else {
            this._finalizeNext(value, value);
        }
    };
    DistinctSubscriber.prototype._useKeySelector = function (value) {
        var key;
        var destination = this.destination;
        try {
            key = this.keySelector(value);
        }
        catch (err) {
            destination.error(err);
            return;
        }
        this._finalizeNext(key, value);
    };
    DistinctSubscriber.prototype._finalizeNext = function (key, value) {
        var values = this.values;
        if (!values.has(key)) {
            values.add(key);
            this.destination.next(value);
        }
    };
    return DistinctSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));

//# sourceMappingURL=distinct.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/distinctUntilChanged.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function distinctUntilChanged(compare, keySelector) {
    return function (source) { return source.lift(new DistinctUntilChangedOperator(compare, keySelector)); };
}
var DistinctUntilChangedOperator = /*@__PURE__*/ (function () {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new distinctUntilChanged_DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}());
var distinctUntilChanged_DistinctUntilChangedSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        var _this = _super.call(this, destination) || this;
        _this.keySelector = keySelector;
        _this.hasKey = false;
        if (typeof compare === 'function') {
            _this.compare = compare;
        }
        return _this;
    }
    DistinctUntilChangedSubscriber.prototype.compare = function (x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function (value) {
        var key;
        try {
            var keySelector = this.keySelector;
            key = keySelector ? keySelector(value) : value;
        }
        catch (err) {
            return this.destination.error(err);
        }
        var result = false;
        if (this.hasKey) {
            try {
                var compare = this.compare;
                result = compare(this.key, key);
            }
            catch (err) {
                return this.destination.error(err);
            }
        }
        else {
            this.hasKey = true;
        }
        if (!result) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}(Subscriber["a" /* Subscriber */]));
//# sourceMappingURL=distinctUntilChanged.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/distinctUntilKeyChanged.js
/** PURE_IMPORTS_START _distinctUntilChanged PURE_IMPORTS_END */

function distinctUntilKeyChanged(key, compare) {
    return distinctUntilChanged(function (x, y) { return compare ? compare(x[key], y[key]) : x[key] === y[key]; });
}
//# sourceMappingURL=distinctUntilKeyChanged.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/ArgumentOutOfRangeError.js
var ArgumentOutOfRangeError = __webpack_require__(60);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/filter.js
var filter = __webpack_require__(45);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/EmptyError.js
var EmptyError = __webpack_require__(64);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/throwIfEmpty.js
/** PURE_IMPORTS_START tslib,_util_EmptyError,_Subscriber PURE_IMPORTS_END */



function throwIfEmpty(errorFactory) {
    if (errorFactory === void 0) {
        errorFactory = defaultErrorFactory;
    }
    return function (source) {
        return source.lift(new ThrowIfEmptyOperator(errorFactory));
    };
}
var ThrowIfEmptyOperator = /*@__PURE__*/ (function () {
    function ThrowIfEmptyOperator(errorFactory) {
        this.errorFactory = errorFactory;
    }
    ThrowIfEmptyOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new throwIfEmpty_ThrowIfEmptySubscriber(subscriber, this.errorFactory));
    };
    return ThrowIfEmptyOperator;
}());
var throwIfEmpty_ThrowIfEmptySubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](ThrowIfEmptySubscriber, _super);
    function ThrowIfEmptySubscriber(destination, errorFactory) {
        var _this = _super.call(this, destination) || this;
        _this.errorFactory = errorFactory;
        _this.hasValue = false;
        return _this;
    }
    ThrowIfEmptySubscriber.prototype._next = function (value) {
        this.hasValue = true;
        this.destination.next(value);
    };
    ThrowIfEmptySubscriber.prototype._complete = function () {
        if (!this.hasValue) {
            var err = void 0;
            try {
                err = this.errorFactory();
            }
            catch (e) {
                err = e;
            }
            this.destination.error(err);
        }
        else {
            return this.destination.complete();
        }
    };
    return ThrowIfEmptySubscriber;
}(Subscriber["a" /* Subscriber */]));
function defaultErrorFactory() {
    return new EmptyError["a" /* EmptyError */]();
}
//# sourceMappingURL=throwIfEmpty.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/empty.js
var empty = __webpack_require__(28);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/take.js
/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError,_observable_empty PURE_IMPORTS_END */




function take(count) {
    return function (source) {
        if (count === 0) {
            return Object(empty["b" /* empty */])();
        }
        else {
            return source.lift(new take_TakeOperator(count));
        }
    };
}
var take_TakeOperator = /*@__PURE__*/ (function () {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) {
            throw new ArgumentOutOfRangeError["a" /* ArgumentOutOfRangeError */];
        }
    }
    TakeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new take_TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}());
var take_TakeSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.count = 0;
        return _this;
    }
    TakeSubscriber.prototype._next = function (value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}(Subscriber["a" /* Subscriber */]));
//# sourceMappingURL=take.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/elementAt.js
/** PURE_IMPORTS_START _util_ArgumentOutOfRangeError,_filter,_throwIfEmpty,_defaultIfEmpty,_take PURE_IMPORTS_END */





function elementAt(index, defaultValue) {
    if (index < 0) {
        throw new ArgumentOutOfRangeError["a" /* ArgumentOutOfRangeError */]();
    }
    var hasDefaultValue = arguments.length >= 2;
    return function (source) {
        return source.pipe(Object(filter["a" /* filter */])(function (v, i) { return i === index; }), take(1), hasDefaultValue
            ? defaultIfEmpty(defaultValue)
            : throwIfEmpty(function () { return new ArgumentOutOfRangeError["a" /* ArgumentOutOfRangeError */](); }));
    };
}
//# sourceMappingURL=elementAt.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/of.js
var of = __webpack_require__(86);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/endWith.js
/** PURE_IMPORTS_START _observable_concat,_observable_of PURE_IMPORTS_END */


function endWith() {
    var array = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        array[_i] = arguments[_i];
    }
    return function (source) { return Object(concat["a" /* concat */])(source, of["a" /* of */].apply(void 0, array)); };
}
//# sourceMappingURL=endWith.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/every.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function every(predicate, thisArg) {
    return function (source) { return source.lift(new EveryOperator(predicate, thisArg, source)); };
}
var EveryOperator = /*@__PURE__*/ (function () {
    function EveryOperator(predicate, thisArg, source) {
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
    }
    EveryOperator.prototype.call = function (observer, source) {
        return source.subscribe(new every_EverySubscriber(observer, this.predicate, this.thisArg, this.source));
    };
    return EveryOperator;
}());
var every_EverySubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](EverySubscriber, _super);
    function EverySubscriber(destination, predicate, thisArg, source) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.source = source;
        _this.index = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    EverySubscriber.prototype.notifyComplete = function (everyValueMatch) {
        this.destination.next(everyValueMatch);
        this.destination.complete();
    };
    EverySubscriber.prototype._next = function (value) {
        var result = false;
        try {
            result = this.predicate.call(this.thisArg, value, this.index++, this.source);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (!result) {
            this.notifyComplete(false);
        }
    };
    EverySubscriber.prototype._complete = function () {
        this.notifyComplete(true);
    };
    return EverySubscriber;
}(Subscriber["a" /* Subscriber */]));
//# sourceMappingURL=every.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/exhaust.js
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



function exhaust() {
    return function (source) { return source.lift(new SwitchFirstOperator()); };
}
var SwitchFirstOperator = /*@__PURE__*/ (function () {
    function SwitchFirstOperator() {
    }
    SwitchFirstOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new exhaust_SwitchFirstSubscriber(subscriber));
    };
    return SwitchFirstOperator;
}());
var exhaust_SwitchFirstSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](SwitchFirstSubscriber, _super);
    function SwitchFirstSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasCompleted = false;
        _this.hasSubscription = false;
        return _this;
    }
    SwitchFirstSubscriber.prototype._next = function (value) {
        if (!this.hasSubscription) {
            this.hasSubscription = true;
            this.add(Object(subscribeToResult["a" /* subscribeToResult */])(this, value));
        }
    };
    SwitchFirstSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (!this.hasSubscription) {
            this.destination.complete();
        }
    };
    SwitchFirstSubscriber.prototype.notifyComplete = function (innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) {
            this.destination.complete();
        }
    };
    return SwitchFirstSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));
//# sourceMappingURL=exhaust.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/map.js
var map = __webpack_require__(26);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/exhaustMap.js
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_InnerSubscriber,_util_subscribeToResult,_map,_observable_from PURE_IMPORTS_END */






function exhaustMap(project, resultSelector) {
    if (resultSelector) {
        return function (source) { return source.pipe(exhaustMap(function (a, i) { return Object(from["a" /* from */])(project(a, i)).pipe(Object(map["a" /* map */])(function (b, ii) { return resultSelector(a, b, i, ii); })); })); };
    }
    return function (source) {
        return source.lift(new ExhaustMapOperator(project));
    };
}
var ExhaustMapOperator = /*@__PURE__*/ (function () {
    function ExhaustMapOperator(project) {
        this.project = project;
    }
    ExhaustMapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new exhaustMap_ExhaustMapSubscriber(subscriber, this.project));
    };
    return ExhaustMapOperator;
}());
var exhaustMap_ExhaustMapSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](ExhaustMapSubscriber, _super);
    function ExhaustMapSubscriber(destination, project) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.hasSubscription = false;
        _this.hasCompleted = false;
        _this.index = 0;
        return _this;
    }
    ExhaustMapSubscriber.prototype._next = function (value) {
        if (!this.hasSubscription) {
            this.tryNext(value);
        }
    };
    ExhaustMapSubscriber.prototype.tryNext = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.hasSubscription = true;
        this._innerSub(result, value, index);
    };
    ExhaustMapSubscriber.prototype._innerSub = function (result, value, index) {
        var innerSubscriber = new InnerSubscriber["a" /* InnerSubscriber */](this, value, index);
        var destination = this.destination;
        destination.add(innerSubscriber);
        var innerSubscription = Object(subscribeToResult["a" /* subscribeToResult */])(this, result, undefined, undefined, innerSubscriber);
        if (innerSubscription !== innerSubscriber) {
            destination.add(innerSubscription);
        }
    };
    ExhaustMapSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (!this.hasSubscription) {
            this.destination.complete();
        }
        this.unsubscribe();
    };
    ExhaustMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    ExhaustMapSubscriber.prototype.notifyError = function (err) {
        this.destination.error(err);
    };
    ExhaustMapSubscriber.prototype.notifyComplete = function (innerSub) {
        var destination = this.destination;
        destination.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) {
            this.destination.complete();
        }
    };
    return ExhaustMapSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));
//# sourceMappingURL=exhaustMap.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/expand.js
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



function expand(project, concurrent, scheduler) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    if (scheduler === void 0) {
        scheduler = undefined;
    }
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return function (source) { return source.lift(new ExpandOperator(project, concurrent, scheduler)); };
}
var ExpandOperator = /*@__PURE__*/ (function () {
    function ExpandOperator(project, concurrent, scheduler) {
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
    }
    ExpandOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new expand_ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
    };
    return ExpandOperator;
}());

var expand_ExpandSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](ExpandSubscriber, _super);
    function ExpandSubscriber(destination, project, concurrent, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.concurrent = concurrent;
        _this.scheduler = scheduler;
        _this.index = 0;
        _this.active = 0;
        _this.hasCompleted = false;
        if (concurrent < Number.POSITIVE_INFINITY) {
            _this.buffer = [];
        }
        return _this;
    }
    ExpandSubscriber.dispatch = function (arg) {
        var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
        subscriber.subscribeToProjection(result, value, index);
    };
    ExpandSubscriber.prototype._next = function (value) {
        var destination = this.destination;
        if (destination.closed) {
            this._complete();
            return;
        }
        var index = this.index++;
        if (this.active < this.concurrent) {
            destination.next(value);
            try {
                var project = this.project;
                var result = project(value, index);
                if (!this.scheduler) {
                    this.subscribeToProjection(result, value, index);
                }
                else {
                    var state = { subscriber: this, result: result, value: value, index: index };
                    var destination_1 = this.destination;
                    destination_1.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
                }
            }
            catch (e) {
                destination.error(e);
            }
        }
        else {
            this.buffer.push(value);
        }
    };
    ExpandSubscriber.prototype.subscribeToProjection = function (result, value, index) {
        this.active++;
        var destination = this.destination;
        destination.add(Object(subscribeToResult["a" /* subscribeToResult */])(this, result, value, index));
    };
    ExpandSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.hasCompleted && this.active === 0) {
            this.destination.complete();
        }
        this.unsubscribe();
    };
    ExpandSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this._next(innerValue);
    };
    ExpandSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        var destination = this.destination;
        destination.remove(innerSub);
        this.active--;
        if (buffer && buffer.length > 0) {
            this._next(buffer.shift());
        }
        if (this.hasCompleted && this.active === 0) {
            this.destination.complete();
        }
    };
    return ExpandSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));

//# sourceMappingURL=expand.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/finalize.js
/** PURE_IMPORTS_START tslib,_Subscriber,_Subscription PURE_IMPORTS_END */



function finalize(callback) {
    return function (source) { return source.lift(new FinallyOperator(callback)); };
}
var FinallyOperator = /*@__PURE__*/ (function () {
    function FinallyOperator(callback) {
        this.callback = callback;
    }
    FinallyOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new finalize_FinallySubscriber(subscriber, this.callback));
    };
    return FinallyOperator;
}());
var finalize_FinallySubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](FinallySubscriber, _super);
    function FinallySubscriber(destination, callback) {
        var _this = _super.call(this, destination) || this;
        _this.add(new Subscription["a" /* Subscription */](callback));
        return _this;
    }
    return FinallySubscriber;
}(Subscriber["a" /* Subscriber */]));
//# sourceMappingURL=finalize.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/find.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function find(predicate, thisArg) {
    if (typeof predicate !== 'function') {
        throw new TypeError('predicate is not a function');
    }
    return function (source) { return source.lift(new FindValueOperator(predicate, source, false, thisArg)); };
}
var FindValueOperator = /*@__PURE__*/ (function () {
    function FindValueOperator(predicate, source, yieldIndex, thisArg) {
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
    }
    FindValueOperator.prototype.call = function (observer, source) {
        return source.subscribe(new find_FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
    };
    return FindValueOperator;
}());

var find_FindValueSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](FindValueSubscriber, _super);
    function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.source = source;
        _this.yieldIndex = yieldIndex;
        _this.thisArg = thisArg;
        _this.index = 0;
        return _this;
    }
    FindValueSubscriber.prototype.notifyComplete = function (value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
        this.unsubscribe();
    };
    FindValueSubscriber.prototype._next = function (value) {
        var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
        var index = this.index++;
        try {
            var result = predicate.call(thisArg || this, value, index, this.source);
            if (result) {
                this.notifyComplete(this.yieldIndex ? index : value);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    FindValueSubscriber.prototype._complete = function () {
        this.notifyComplete(this.yieldIndex ? -1 : undefined);
    };
    return FindValueSubscriber;
}(Subscriber["a" /* Subscriber */]));

//# sourceMappingURL=find.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/findIndex.js
/** PURE_IMPORTS_START _operators_find PURE_IMPORTS_END */

function findIndex(predicate, thisArg) {
    return function (source) { return source.lift(new FindValueOperator(predicate, source, true, thisArg)); };
}
//# sourceMappingURL=findIndex.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/identity.js
var identity = __webpack_require__(42);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/first.js
/** PURE_IMPORTS_START _util_EmptyError,_filter,_take,_defaultIfEmpty,_throwIfEmpty,_util_identity PURE_IMPORTS_END */






function first(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function (source) { return source.pipe(predicate ? Object(filter["a" /* filter */])(function (v, i) { return predicate(v, i, source); }) : identity["a" /* identity */], take(1), hasDefaultValue ? defaultIfEmpty(defaultValue) : throwIfEmpty(function () { return new EmptyError["a" /* EmptyError */](); })); };
}
//# sourceMappingURL=first.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/groupBy.js
var groupBy = __webpack_require__(137);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/ignoreElements.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function ignoreElements() {
    return function ignoreElementsOperatorFunction(source) {
        return source.lift(new IgnoreElementsOperator());
    };
}
var IgnoreElementsOperator = /*@__PURE__*/ (function () {
    function IgnoreElementsOperator() {
    }
    IgnoreElementsOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ignoreElements_IgnoreElementsSubscriber(subscriber));
    };
    return IgnoreElementsOperator;
}());
var ignoreElements_IgnoreElementsSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](IgnoreElementsSubscriber, _super);
    function IgnoreElementsSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IgnoreElementsSubscriber.prototype._next = function (unused) {
    };
    return IgnoreElementsSubscriber;
}(Subscriber["a" /* Subscriber */]));
//# sourceMappingURL=ignoreElements.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/isEmpty.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function isEmpty() {
    return function (source) { return source.lift(new IsEmptyOperator()); };
}
var IsEmptyOperator = /*@__PURE__*/ (function () {
    function IsEmptyOperator() {
    }
    IsEmptyOperator.prototype.call = function (observer, source) {
        return source.subscribe(new isEmpty_IsEmptySubscriber(observer));
    };
    return IsEmptyOperator;
}());
var isEmpty_IsEmptySubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](IsEmptySubscriber, _super);
    function IsEmptySubscriber(destination) {
        return _super.call(this, destination) || this;
    }
    IsEmptySubscriber.prototype.notifyComplete = function (isEmpty) {
        var destination = this.destination;
        destination.next(isEmpty);
        destination.complete();
    };
    IsEmptySubscriber.prototype._next = function (value) {
        this.notifyComplete(false);
    };
    IsEmptySubscriber.prototype._complete = function () {
        this.notifyComplete(true);
    };
    return IsEmptySubscriber;
}(Subscriber["a" /* Subscriber */]));
//# sourceMappingURL=isEmpty.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/takeLast.js
/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError,_observable_empty PURE_IMPORTS_END */




function takeLast(count) {
    return function takeLastOperatorFunction(source) {
        if (count === 0) {
            return Object(empty["b" /* empty */])();
        }
        else {
            return source.lift(new takeLast_TakeLastOperator(count));
        }
    };
}
var takeLast_TakeLastOperator = /*@__PURE__*/ (function () {
    function TakeLastOperator(total) {
        this.total = total;
        if (this.total < 0) {
            throw new ArgumentOutOfRangeError["a" /* ArgumentOutOfRangeError */];
        }
    }
    TakeLastOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new takeLast_TakeLastSubscriber(subscriber, this.total));
    };
    return TakeLastOperator;
}());
var takeLast_TakeLastSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](TakeLastSubscriber, _super);
    function TakeLastSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.ring = new Array();
        _this.count = 0;
        return _this;
    }
    TakeLastSubscriber.prototype._next = function (value) {
        var ring = this.ring;
        var total = this.total;
        var count = this.count++;
        if (ring.length < total) {
            ring.push(value);
        }
        else {
            var index = count % total;
            ring[index] = value;
        }
    };
    TakeLastSubscriber.prototype._complete = function () {
        var destination = this.destination;
        var count = this.count;
        if (count > 0) {
            var total = this.count >= this.total ? this.total : this.count;
            var ring = this.ring;
            for (var i = 0; i < total; i++) {
                var idx = (count++) % total;
                destination.next(ring[idx]);
            }
        }
        destination.complete();
    };
    return TakeLastSubscriber;
}(Subscriber["a" /* Subscriber */]));
//# sourceMappingURL=takeLast.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/last.js
/** PURE_IMPORTS_START _util_EmptyError,_filter,_takeLast,_throwIfEmpty,_defaultIfEmpty,_util_identity PURE_IMPORTS_END */






function last(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function (source) { return source.pipe(predicate ? Object(filter["a" /* filter */])(function (v, i) { return predicate(v, i, source); }) : identity["a" /* identity */], takeLast(1), hasDefaultValue ? defaultIfEmpty(defaultValue) : throwIfEmpty(function () { return new EmptyError["a" /* EmptyError */](); })); };
}
//# sourceMappingURL=last.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/mapTo.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function mapTo(value) {
    return function (source) { return source.lift(new MapToOperator(value)); };
}
var MapToOperator = /*@__PURE__*/ (function () {
    function MapToOperator(value) {
        this.value = value;
    }
    MapToOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new mapTo_MapToSubscriber(subscriber, this.value));
    };
    return MapToOperator;
}());
var mapTo_MapToSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](MapToSubscriber, _super);
    function MapToSubscriber(destination, value) {
        var _this = _super.call(this, destination) || this;
        _this.value = value;
        return _this;
    }
    MapToSubscriber.prototype._next = function (x) {
        this.destination.next(this.value);
    };
    return MapToSubscriber;
}(Subscriber["a" /* Subscriber */]));
//# sourceMappingURL=mapTo.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/materialize.js
/** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */



function materialize() {
    return function materializeOperatorFunction(source) {
        return source.lift(new MaterializeOperator());
    };
}
var MaterializeOperator = /*@__PURE__*/ (function () {
    function MaterializeOperator() {
    }
    MaterializeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new materialize_MaterializeSubscriber(subscriber));
    };
    return MaterializeOperator;
}());
var materialize_MaterializeSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](MaterializeSubscriber, _super);
    function MaterializeSubscriber(destination) {
        return _super.call(this, destination) || this;
    }
    MaterializeSubscriber.prototype._next = function (value) {
        this.destination.next(Notification["a" /* Notification */].createNext(value));
    };
    MaterializeSubscriber.prototype._error = function (err) {
        var destination = this.destination;
        destination.next(Notification["a" /* Notification */].createError(err));
        destination.complete();
    };
    MaterializeSubscriber.prototype._complete = function () {
        var destination = this.destination;
        destination.next(Notification["a" /* Notification */].createComplete());
        destination.complete();
    };
    return MaterializeSubscriber;
}(Subscriber["a" /* Subscriber */]));
//# sourceMappingURL=materialize.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/scan.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function scan(accumulator, seed) {
    var hasSeed = false;
    if (arguments.length >= 2) {
        hasSeed = true;
    }
    return function scanOperatorFunction(source) {
        return source.lift(new ScanOperator(accumulator, seed, hasSeed));
    };
}
var ScanOperator = /*@__PURE__*/ (function () {
    function ScanOperator(accumulator, seed, hasSeed) {
        if (hasSeed === void 0) {
            hasSeed = false;
        }
        this.accumulator = accumulator;
        this.seed = seed;
        this.hasSeed = hasSeed;
    }
    ScanOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new scan_ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
    };
    return ScanOperator;
}());
var scan_ScanSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](ScanSubscriber, _super);
    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
        var _this = _super.call(this, destination) || this;
        _this.accumulator = accumulator;
        _this._seed = _seed;
        _this.hasSeed = hasSeed;
        _this.index = 0;
        return _this;
    }
    Object.defineProperty(ScanSubscriber.prototype, "seed", {
        get: function () {
            return this._seed;
        },
        set: function (value) {
            this.hasSeed = true;
            this._seed = value;
        },
        enumerable: true,
        configurable: true
    });
    ScanSubscriber.prototype._next = function (value) {
        if (!this.hasSeed) {
            this.seed = value;
            this.destination.next(value);
        }
        else {
            return this._tryNext(value);
        }
    };
    ScanSubscriber.prototype._tryNext = function (value) {
        var index = this.index++;
        var result;
        try {
            result = this.accumulator(this.seed, value, index);
        }
        catch (err) {
            this.destination.error(err);
        }
        this.seed = result;
        this.destination.next(result);
    };
    return ScanSubscriber;
}(Subscriber["a" /* Subscriber */]));
//# sourceMappingURL=scan.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/pipe.js
var pipe = __webpack_require__(94);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/reduce.js
/** PURE_IMPORTS_START _scan,_takeLast,_defaultIfEmpty,_util_pipe PURE_IMPORTS_END */




function reduce(accumulator, seed) {
    if (arguments.length >= 2) {
        return function reduceOperatorFunctionWithSeed(source) {
            return Object(pipe["a" /* pipe */])(scan(accumulator, seed), takeLast(1), defaultIfEmpty(seed))(source);
        };
    }
    return function reduceOperatorFunction(source) {
        return Object(pipe["a" /* pipe */])(scan(function (acc, value, index) { return accumulator(acc, value, index + 1); }), takeLast(1))(source);
    };
}
//# sourceMappingURL=reduce.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/max.js
/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */

function max_max(comparer) {
    var max = (typeof comparer === 'function')
        ? function (x, y) { return comparer(x, y) > 0 ? x : y; }
        : function (x, y) { return x > y ? x : y; };
    return reduce(max);
}
//# sourceMappingURL=max.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/merge.js
var merge = __webpack_require__(151);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/merge.js
/** PURE_IMPORTS_START _observable_merge PURE_IMPORTS_END */

function merge_merge() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return function (source) { return source.lift.call(merge["a" /* merge */].apply(void 0, [source].concat(observables))); };
}
//# sourceMappingURL=merge.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/mergeAll.js
var mergeAll = __webpack_require__(107);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/mergeMapTo.js
/** PURE_IMPORTS_START _mergeMap PURE_IMPORTS_END */

function mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    if (typeof resultSelector === 'function') {
        return Object(mergeMap["a" /* mergeMap */])(function () { return innerObservable; }, resultSelector, concurrent);
    }
    if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
    }
    return Object(mergeMap["a" /* mergeMap */])(function () { return innerObservable; }, concurrent);
}
//# sourceMappingURL=mergeMapTo.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/mergeScan.js
/** PURE_IMPORTS_START tslib,_util_subscribeToResult,_OuterSubscriber,_InnerSubscriber PURE_IMPORTS_END */




function mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    return function (source) { return source.lift(new MergeScanOperator(accumulator, seed, concurrent)); };
}
var MergeScanOperator = /*@__PURE__*/ (function () {
    function MergeScanOperator(accumulator, seed, concurrent) {
        this.accumulator = accumulator;
        this.seed = seed;
        this.concurrent = concurrent;
    }
    MergeScanOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new mergeScan_MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
    };
    return MergeScanOperator;
}());

var mergeScan_MergeScanSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](MergeScanSubscriber, _super);
    function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
        var _this = _super.call(this, destination) || this;
        _this.accumulator = accumulator;
        _this.acc = acc;
        _this.concurrent = concurrent;
        _this.hasValue = false;
        _this.hasCompleted = false;
        _this.buffer = [];
        _this.active = 0;
        _this.index = 0;
        return _this;
    }
    MergeScanSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            var index = this.index++;
            var destination = this.destination;
            var ish = void 0;
            try {
                var accumulator = this.accumulator;
                ish = accumulator(this.acc, value, index);
            }
            catch (e) {
                return destination.error(e);
            }
            this.active++;
            this._innerSub(ish, value, index);
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeScanSubscriber.prototype._innerSub = function (ish, value, index) {
        var innerSubscriber = new InnerSubscriber["a" /* InnerSubscriber */](this, value, index);
        var destination = this.destination;
        destination.add(innerSubscriber);
        var innerSubscription = Object(subscribeToResult["a" /* subscribeToResult */])(this, ish, undefined, undefined, innerSubscriber);
        if (innerSubscription !== innerSubscriber) {
            destination.add(innerSubscription);
        }
    };
    MergeScanSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            if (this.hasValue === false) {
                this.destination.next(this.acc);
            }
            this.destination.complete();
        }
        this.unsubscribe();
    };
    MergeScanSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var destination = this.destination;
        this.acc = innerValue;
        this.hasValue = true;
        destination.next(innerValue);
    };
    MergeScanSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        var destination = this.destination;
        destination.remove(innerSub);
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            if (this.hasValue === false) {
                this.destination.next(this.acc);
            }
            this.destination.complete();
        }
    };
    return MergeScanSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));

//# sourceMappingURL=mergeScan.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/min.js
/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */

function min_min(comparer) {
    var min = (typeof comparer === 'function')
        ? function (x, y) { return comparer(x, y) < 0 ? x : y; }
        : function (x, y) { return x < y ? x : y; };
    return reduce(min);
}
//# sourceMappingURL=min.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/ConnectableObservable.js
var ConnectableObservable = __webpack_require__(152);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/multicast.js
/** PURE_IMPORTS_START _observable_ConnectableObservable PURE_IMPORTS_END */

function multicast(subjectOrSubjectFactory, selector) {
    return function multicastOperatorFunction(source) {
        var subjectFactory;
        if (typeof subjectOrSubjectFactory === 'function') {
            subjectFactory = subjectOrSubjectFactory;
        }
        else {
            subjectFactory = function subjectFactory() {
                return subjectOrSubjectFactory;
            };
        }
        if (typeof selector === 'function') {
            return source.lift(new MulticastOperator(subjectFactory, selector));
        }
        var connectable = Object.create(source, ConnectableObservable["b" /* connectableObservableDescriptor */]);
        connectable.source = source;
        connectable.subjectFactory = subjectFactory;
        return connectable;
    };
}
var MulticastOperator = /*@__PURE__*/ (function () {
    function MulticastOperator(subjectFactory, selector) {
        this.subjectFactory = subjectFactory;
        this.selector = selector;
    }
    MulticastOperator.prototype.call = function (subscriber, source) {
        var selector = this.selector;
        var subject = this.subjectFactory();
        var subscription = selector(subject).subscribe(subscriber);
        subscription.add(source.subscribe(subject));
        return subscription;
    };
    return MulticastOperator;
}());

//# sourceMappingURL=multicast.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/observeOn.js
var observeOn = __webpack_require__(153);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/onErrorResumeNext.js
/** PURE_IMPORTS_START tslib,_observable_from,_util_isArray,_OuterSubscriber,_InnerSubscriber,_util_subscribeToResult PURE_IMPORTS_END */






function onErrorResumeNext() {
    var nextSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nextSources[_i] = arguments[_i];
    }
    if (nextSources.length === 1 && Object(isArray["a" /* isArray */])(nextSources[0])) {
        nextSources = nextSources[0];
    }
    return function (source) { return source.lift(new OnErrorResumeNextOperator(nextSources)); };
}
function onErrorResumeNextStatic() {
    var nextSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nextSources[_i] = arguments[_i];
    }
    var source = null;
    if (nextSources.length === 1 && Object(isArray["a" /* isArray */])(nextSources[0])) {
        nextSources = nextSources[0];
    }
    source = nextSources.shift();
    return Object(from["a" /* from */])(source, null).lift(new OnErrorResumeNextOperator(nextSources));
}
var OnErrorResumeNextOperator = /*@__PURE__*/ (function () {
    function OnErrorResumeNextOperator(nextSources) {
        this.nextSources = nextSources;
    }
    OnErrorResumeNextOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new onErrorResumeNext_OnErrorResumeNextSubscriber(subscriber, this.nextSources));
    };
    return OnErrorResumeNextOperator;
}());
var onErrorResumeNext_OnErrorResumeNextSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](OnErrorResumeNextSubscriber, _super);
    function OnErrorResumeNextSubscriber(destination, nextSources) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.nextSources = nextSources;
        return _this;
    }
    OnErrorResumeNextSubscriber.prototype.notifyError = function (error, innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.notifyComplete = function (innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._error = function (err) {
        this.subscribeToNextSource();
        this.unsubscribe();
    };
    OnErrorResumeNextSubscriber.prototype._complete = function () {
        this.subscribeToNextSource();
        this.unsubscribe();
    };
    OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function () {
        var next = this.nextSources.shift();
        if (!!next) {
            var innerSubscriber = new InnerSubscriber["a" /* InnerSubscriber */](this, undefined, undefined);
            var destination = this.destination;
            destination.add(innerSubscriber);
            var innerSubscription = Object(subscribeToResult["a" /* subscribeToResult */])(this, next, undefined, undefined, innerSubscriber);
            if (innerSubscription !== innerSubscriber) {
                destination.add(innerSubscription);
            }
        }
        else {
            this.destination.complete();
        }
    };
    return OnErrorResumeNextSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));
//# sourceMappingURL=onErrorResumeNext.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/pairwise.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function pairwise() {
    return function (source) { return source.lift(new PairwiseOperator()); };
}
var PairwiseOperator = /*@__PURE__*/ (function () {
    function PairwiseOperator() {
    }
    PairwiseOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new pairwise_PairwiseSubscriber(subscriber));
    };
    return PairwiseOperator;
}());
var pairwise_PairwiseSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](PairwiseSubscriber, _super);
    function PairwiseSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasPrev = false;
        return _this;
    }
    PairwiseSubscriber.prototype._next = function (value) {
        var pair;
        if (this.hasPrev) {
            pair = [this.prev, value];
        }
        else {
            this.hasPrev = true;
        }
        this.prev = value;
        if (pair) {
            this.destination.next(pair);
        }
    };
    return PairwiseSubscriber;
}(Subscriber["a" /* Subscriber */]));
//# sourceMappingURL=pairwise.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/not.js
var not = __webpack_require__(163);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/partition.js
/** PURE_IMPORTS_START _util_not,_filter PURE_IMPORTS_END */


function partition(predicate, thisArg) {
    return function (source) {
        return [
            Object(filter["a" /* filter */])(predicate, thisArg)(source),
            Object(filter["a" /* filter */])(Object(not["a" /* not */])(predicate, thisArg))(source)
        ];
    };
}
//# sourceMappingURL=partition.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/pluck.js
/** PURE_IMPORTS_START _map PURE_IMPORTS_END */

function pluck() {
    var properties = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        properties[_i] = arguments[_i];
    }
    var length = properties.length;
    if (length === 0) {
        throw new Error('list of properties cannot be empty.');
    }
    return function (source) { return Object(map["a" /* map */])(plucker(properties, length))(source); };
}
function plucker(props, length) {
    var mapper = function (x) {
        var currentProp = x;
        for (var i = 0; i < length; i++) {
            var p = currentProp[props[i]];
            if (typeof p !== 'undefined') {
                currentProp = p;
            }
            else {
                return undefined;
            }
        }
        return currentProp;
    };
    return mapper;
}
//# sourceMappingURL=pluck.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Subject.js
var Subject = __webpack_require__(22);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/publish.js
/** PURE_IMPORTS_START _Subject,_multicast PURE_IMPORTS_END */


function publish(selector) {
    return selector ?
        multicast(function () { return new Subject["a" /* Subject */](); }, selector) :
        multicast(new Subject["a" /* Subject */]());
}
//# sourceMappingURL=publish.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/BehaviorSubject.js
var BehaviorSubject = __webpack_require__(154);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/publishBehavior.js
/** PURE_IMPORTS_START _BehaviorSubject,_multicast PURE_IMPORTS_END */


function publishBehavior(value) {
    return function (source) { return multicast(new BehaviorSubject["a" /* BehaviorSubject */](value))(source); };
}
//# sourceMappingURL=publishBehavior.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/AsyncSubject.js
var AsyncSubject = __webpack_require__(67);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/publishLast.js
/** PURE_IMPORTS_START _AsyncSubject,_multicast PURE_IMPORTS_END */


function publishLast() {
    return function (source) { return multicast(new AsyncSubject["a" /* AsyncSubject */]())(source); };
}
//# sourceMappingURL=publishLast.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/ReplaySubject.js
var ReplaySubject = __webpack_require__(110);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/publishReplay.js
/** PURE_IMPORTS_START _ReplaySubject,_multicast PURE_IMPORTS_END */


function publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    if (selectorOrScheduler && typeof selectorOrScheduler !== 'function') {
        scheduler = selectorOrScheduler;
    }
    var selector = typeof selectorOrScheduler === 'function' ? selectorOrScheduler : undefined;
    var subject = new ReplaySubject["a" /* ReplaySubject */](bufferSize, windowTime, scheduler);
    return function (source) { return multicast(function () { return subject; }, selector)(source); };
}
//# sourceMappingURL=publishReplay.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/race.js
var race = __webpack_require__(155);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/race.js
/** PURE_IMPORTS_START _util_isArray,_observable_race PURE_IMPORTS_END */


function race_race() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return function raceOperatorFunction(source) {
        if (observables.length === 1 && Object(isArray["a" /* isArray */])(observables[0])) {
            observables = observables[0];
        }
        return source.lift.call(race["a" /* race */].apply(void 0, [source].concat(observables)));
    };
}
//# sourceMappingURL=race.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/repeat.js
/** PURE_IMPORTS_START tslib,_Subscriber,_observable_empty PURE_IMPORTS_END */



function repeat(count) {
    if (count === void 0) {
        count = -1;
    }
    return function (source) {
        if (count === 0) {
            return Object(empty["b" /* empty */])();
        }
        else if (count < 0) {
            return source.lift(new RepeatOperator(-1, source));
        }
        else {
            return source.lift(new RepeatOperator(count - 1, source));
        }
    };
}
var RepeatOperator = /*@__PURE__*/ (function () {
    function RepeatOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RepeatOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new repeat_RepeatSubscriber(subscriber, this.count, this.source));
    };
    return RepeatOperator;
}());
var repeat_RepeatSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](RepeatSubscriber, _super);
    function RepeatSubscriber(destination, count, source) {
        var _this = _super.call(this, destination) || this;
        _this.count = count;
        _this.source = source;
        return _this;
    }
    RepeatSubscriber.prototype.complete = function () {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) {
                return _super.prototype.complete.call(this);
            }
            else if (count > -1) {
                this.count = count - 1;
            }
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RepeatSubscriber;
}(Subscriber["a" /* Subscriber */]));
//# sourceMappingURL=repeat.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/repeatWhen.js
/** PURE_IMPORTS_START tslib,_Subject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */




function repeatWhen(notifier) {
    return function (source) { return source.lift(new RepeatWhenOperator(notifier)); };
}
var RepeatWhenOperator = /*@__PURE__*/ (function () {
    function RepeatWhenOperator(notifier) {
        this.notifier = notifier;
    }
    RepeatWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new repeatWhen_RepeatWhenSubscriber(subscriber, this.notifier, source));
    };
    return RepeatWhenOperator;
}());
var repeatWhen_RepeatWhenSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](RepeatWhenSubscriber, _super);
    function RepeatWhenSubscriber(destination, notifier, source) {
        var _this = _super.call(this, destination) || this;
        _this.notifier = notifier;
        _this.source = source;
        _this.sourceIsBeingSubscribedTo = true;
        return _this;
    }
    RepeatWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.sourceIsBeingSubscribedTo = true;
        this.source.subscribe(this);
    };
    RepeatWhenSubscriber.prototype.notifyComplete = function (innerSub) {
        if (this.sourceIsBeingSubscribedTo === false) {
            return _super.prototype.complete.call(this);
        }
    };
    RepeatWhenSubscriber.prototype.complete = function () {
        this.sourceIsBeingSubscribedTo = false;
        if (!this.isStopped) {
            if (!this.retries) {
                this.subscribeToRetries();
            }
            if (!this.retriesSubscription || this.retriesSubscription.closed) {
                return _super.prototype.complete.call(this);
            }
            this._unsubscribeAndRecycle();
            this.notifications.next();
        }
    };
    RepeatWhenSubscriber.prototype._unsubscribe = function () {
        var _a = this, notifications = _a.notifications, retriesSubscription = _a.retriesSubscription;
        if (notifications) {
            notifications.unsubscribe();
            this.notifications = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function () {
        var _unsubscribe = this._unsubscribe;
        this._unsubscribe = null;
        _super.prototype._unsubscribeAndRecycle.call(this);
        this._unsubscribe = _unsubscribe;
        return this;
    };
    RepeatWhenSubscriber.prototype.subscribeToRetries = function () {
        this.notifications = new Subject["a" /* Subject */]();
        var retries;
        try {
            var notifier = this.notifier;
            retries = notifier(this.notifications);
        }
        catch (e) {
            return _super.prototype.complete.call(this);
        }
        this.retries = retries;
        this.retriesSubscription = Object(subscribeToResult["a" /* subscribeToResult */])(this, retries);
    };
    return RepeatWhenSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));
//# sourceMappingURL=repeatWhen.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/retry.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function retry(count) {
    if (count === void 0) {
        count = -1;
    }
    return function (source) { return source.lift(new RetryOperator(count, source)); };
}
var RetryOperator = /*@__PURE__*/ (function () {
    function RetryOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RetryOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new retry_RetrySubscriber(subscriber, this.count, this.source));
    };
    return RetryOperator;
}());
var retry_RetrySubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](RetrySubscriber, _super);
    function RetrySubscriber(destination, count, source) {
        var _this = _super.call(this, destination) || this;
        _this.count = count;
        _this.source = source;
        return _this;
    }
    RetrySubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) {
                return _super.prototype.error.call(this, err);
            }
            else if (count > -1) {
                this.count = count - 1;
            }
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RetrySubscriber;
}(Subscriber["a" /* Subscriber */]));
//# sourceMappingURL=retry.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/retryWhen.js
/** PURE_IMPORTS_START tslib,_Subject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */




function retryWhen(notifier) {
    return function (source) { return source.lift(new RetryWhenOperator(notifier, source)); };
}
var RetryWhenOperator = /*@__PURE__*/ (function () {
    function RetryWhenOperator(notifier, source) {
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new retryWhen_RetryWhenSubscriber(subscriber, this.notifier, this.source));
    };
    return RetryWhenOperator;
}());
var retryWhen_RetryWhenSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](RetryWhenSubscriber, _super);
    function RetryWhenSubscriber(destination, notifier, source) {
        var _this = _super.call(this, destination) || this;
        _this.notifier = notifier;
        _this.source = source;
        return _this;
    }
    RetryWhenSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var errors = this.errors;
            var retries = this.retries;
            var retriesSubscription = this.retriesSubscription;
            if (!retries) {
                errors = new Subject["a" /* Subject */]();
                try {
                    var notifier = this.notifier;
                    retries = notifier(errors);
                }
                catch (e) {
                    return _super.prototype.error.call(this, e);
                }
                retriesSubscription = Object(subscribeToResult["a" /* subscribeToResult */])(this, retries);
            }
            else {
                this.errors = null;
                this.retriesSubscription = null;
            }
            this._unsubscribeAndRecycle();
            this.errors = errors;
            this.retries = retries;
            this.retriesSubscription = retriesSubscription;
            errors.next(err);
        }
    };
    RetryWhenSubscriber.prototype._unsubscribe = function () {
        var _a = this, errors = _a.errors, retriesSubscription = _a.retriesSubscription;
        if (errors) {
            errors.unsubscribe();
            this.errors = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    RetryWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _unsubscribe = this._unsubscribe;
        this._unsubscribe = null;
        this._unsubscribeAndRecycle();
        this._unsubscribe = _unsubscribe;
        this.source.subscribe(this);
    };
    return RetryWhenSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));
//# sourceMappingURL=retryWhen.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/refCount.js
var operators_refCount = __webpack_require__(109);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/sample.js
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



function sample(notifier) {
    return function (source) { return source.lift(new sample_SampleOperator(notifier)); };
}
var sample_SampleOperator = /*@__PURE__*/ (function () {
    function SampleOperator(notifier) {
        this.notifier = notifier;
    }
    SampleOperator.prototype.call = function (subscriber, source) {
        var sampleSubscriber = new sample_SampleSubscriber(subscriber);
        var subscription = source.subscribe(sampleSubscriber);
        subscription.add(Object(subscribeToResult["a" /* subscribeToResult */])(sampleSubscriber, this.notifier));
        return subscription;
    };
    return SampleOperator;
}());
var sample_SampleSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](SampleSubscriber, _super);
    function SampleSubscriber() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasValue = false;
        return _this;
    }
    SampleSubscriber.prototype._next = function (value) {
        this.value = value;
        this.hasValue = true;
    };
    SampleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.emitValue();
    };
    SampleSubscriber.prototype.notifyComplete = function () {
        this.emitValue();
    };
    SampleSubscriber.prototype.emitValue = function () {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.value);
        }
    };
    return SampleSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));
//# sourceMappingURL=sample.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/sampleTime.js
/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async PURE_IMPORTS_END */



function sampleTime(period, scheduler) {
    if (scheduler === void 0) {
        scheduler = scheduler_async["a" /* async */];
    }
    return function (source) { return source.lift(new SampleTimeOperator(period, scheduler)); };
}
var SampleTimeOperator = /*@__PURE__*/ (function () {
    function SampleTimeOperator(period, scheduler) {
        this.period = period;
        this.scheduler = scheduler;
    }
    SampleTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new sampleTime_SampleTimeSubscriber(subscriber, this.period, this.scheduler));
    };
    return SampleTimeOperator;
}());
var sampleTime_SampleTimeSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](SampleTimeSubscriber, _super);
    function SampleTimeSubscriber(destination, period, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.period = period;
        _this.scheduler = scheduler;
        _this.hasValue = false;
        _this.add(scheduler.schedule(dispatchNotification, period, { subscriber: _this, period: period }));
        return _this;
    }
    SampleTimeSubscriber.prototype._next = function (value) {
        this.lastValue = value;
        this.hasValue = true;
    };
    SampleTimeSubscriber.prototype.notifyNext = function () {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.lastValue);
        }
    };
    return SampleTimeSubscriber;
}(Subscriber["a" /* Subscriber */]));
function dispatchNotification(state) {
    var subscriber = state.subscriber, period = state.period;
    subscriber.notifyNext();
    this.schedule(state, period);
}
//# sourceMappingURL=sampleTime.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/sequenceEqual.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function sequenceEqual(compareTo, comparator) {
    return function (source) { return source.lift(new SequenceEqualOperator(compareTo, comparator)); };
}
var SequenceEqualOperator = /*@__PURE__*/ (function () {
    function SequenceEqualOperator(compareTo, comparator) {
        this.compareTo = compareTo;
        this.comparator = comparator;
    }
    SequenceEqualOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new sequenceEqual_SequenceEqualSubscriber(subscriber, this.compareTo, this.comparator));
    };
    return SequenceEqualOperator;
}());

var sequenceEqual_SequenceEqualSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](SequenceEqualSubscriber, _super);
    function SequenceEqualSubscriber(destination, compareTo, comparator) {
        var _this = _super.call(this, destination) || this;
        _this.compareTo = compareTo;
        _this.comparator = comparator;
        _this._a = [];
        _this._b = [];
        _this._oneComplete = false;
        _this.destination.add(compareTo.subscribe(new sequenceEqual_SequenceEqualCompareToSubscriber(destination, _this)));
        return _this;
    }
    SequenceEqualSubscriber.prototype._next = function (value) {
        if (this._oneComplete && this._b.length === 0) {
            this.emit(false);
        }
        else {
            this._a.push(value);
            this.checkValues();
        }
    };
    SequenceEqualSubscriber.prototype._complete = function () {
        if (this._oneComplete) {
            this.emit(this._a.length === 0 && this._b.length === 0);
        }
        else {
            this._oneComplete = true;
        }
        this.unsubscribe();
    };
    SequenceEqualSubscriber.prototype.checkValues = function () {
        var _c = this, _a = _c._a, _b = _c._b, comparator = _c.comparator;
        while (_a.length > 0 && _b.length > 0) {
            var a = _a.shift();
            var b = _b.shift();
            var areEqual = false;
            try {
                areEqual = comparator ? comparator(a, b) : a === b;
            }
            catch (e) {
                this.destination.error(e);
            }
            if (!areEqual) {
                this.emit(false);
            }
        }
    };
    SequenceEqualSubscriber.prototype.emit = function (value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    SequenceEqualSubscriber.prototype.nextB = function (value) {
        if (this._oneComplete && this._a.length === 0) {
            this.emit(false);
        }
        else {
            this._b.push(value);
            this.checkValues();
        }
    };
    SequenceEqualSubscriber.prototype.completeB = function () {
        if (this._oneComplete) {
            this.emit(this._a.length === 0 && this._b.length === 0);
        }
        else {
            this._oneComplete = true;
        }
    };
    return SequenceEqualSubscriber;
}(Subscriber["a" /* Subscriber */]));

var sequenceEqual_SequenceEqualCompareToSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](SequenceEqualCompareToSubscriber, _super);
    function SequenceEqualCompareToSubscriber(destination, parent) {
        var _this = _super.call(this, destination) || this;
        _this.parent = parent;
        return _this;
    }
    SequenceEqualCompareToSubscriber.prototype._next = function (value) {
        this.parent.nextB(value);
    };
    SequenceEqualCompareToSubscriber.prototype._error = function (err) {
        this.parent.error(err);
        this.unsubscribe();
    };
    SequenceEqualCompareToSubscriber.prototype._complete = function () {
        this.parent.completeB();
        this.unsubscribe();
    };
    return SequenceEqualCompareToSubscriber;
}(Subscriber["a" /* Subscriber */]));
//# sourceMappingURL=sequenceEqual.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/share.js
/** PURE_IMPORTS_START _multicast,_refCount,_Subject PURE_IMPORTS_END */



function shareSubjectFactory() {
    return new Subject["a" /* Subject */]();
}
function share() {
    return function (source) { return Object(operators_refCount["a" /* refCount */])()(multicast(shareSubjectFactory)(source)); };
}
//# sourceMappingURL=share.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/shareReplay.js
/** PURE_IMPORTS_START _ReplaySubject PURE_IMPORTS_END */

function shareReplay(configOrBufferSize, windowTime, scheduler) {
    var config;
    if (configOrBufferSize && typeof configOrBufferSize === 'object') {
        config = configOrBufferSize;
    }
    else {
        config = {
            bufferSize: configOrBufferSize,
            windowTime: windowTime,
            refCount: false,
            scheduler: scheduler
        };
    }
    return function (source) { return source.lift(shareReplayOperator(config)); };
}
function shareReplayOperator(_a) {
    var _b = _a.bufferSize, bufferSize = _b === void 0 ? Number.POSITIVE_INFINITY : _b, _c = _a.windowTime, windowTime = _c === void 0 ? Number.POSITIVE_INFINITY : _c, useRefCount = _a.refCount, scheduler = _a.scheduler;
    var subject;
    var refCount = 0;
    var subscription;
    var hasError = false;
    var isComplete = false;
    return function shareReplayOperation(source) {
        refCount++;
        if (!subject || hasError) {
            hasError = false;
            subject = new ReplaySubject["a" /* ReplaySubject */](bufferSize, windowTime, scheduler);
            subscription = source.subscribe({
                next: function (value) { subject.next(value); },
                error: function (err) {
                    hasError = true;
                    subject.error(err);
                },
                complete: function () {
                    isComplete = true;
                    subscription = undefined;
                    subject.complete();
                },
            });
        }
        var innerSub = subject.subscribe(this);
        this.add(function () {
            refCount--;
            innerSub.unsubscribe();
            if (subscription && !isComplete && useRefCount && refCount === 0) {
                subscription.unsubscribe();
                subscription = undefined;
                subject = undefined;
            }
        });
    };
}
//# sourceMappingURL=shareReplay.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/single.js
/** PURE_IMPORTS_START tslib,_Subscriber,_util_EmptyError PURE_IMPORTS_END */



function single(predicate) {
    return function (source) { return source.lift(new SingleOperator(predicate, source)); };
}
var SingleOperator = /*@__PURE__*/ (function () {
    function SingleOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    SingleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new single_SingleSubscriber(subscriber, this.predicate, this.source));
    };
    return SingleOperator;
}());
var single_SingleSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](SingleSubscriber, _super);
    function SingleSubscriber(destination, predicate, source) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.source = source;
        _this.seenValue = false;
        _this.index = 0;
        return _this;
    }
    SingleSubscriber.prototype.applySingleValue = function (value) {
        if (this.seenValue) {
            this.destination.error('Sequence contains more than one element');
        }
        else {
            this.seenValue = true;
            this.singleValue = value;
        }
    };
    SingleSubscriber.prototype._next = function (value) {
        var index = this.index++;
        if (this.predicate) {
            this.tryNext(value, index);
        }
        else {
            this.applySingleValue(value);
        }
    };
    SingleSubscriber.prototype.tryNext = function (value, index) {
        try {
            if (this.predicate(value, index, this.source)) {
                this.applySingleValue(value);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    SingleSubscriber.prototype._complete = function () {
        var destination = this.destination;
        if (this.index > 0) {
            destination.next(this.seenValue ? this.singleValue : undefined);
            destination.complete();
        }
        else {
            destination.error(new EmptyError["a" /* EmptyError */]);
        }
    };
    return SingleSubscriber;
}(Subscriber["a" /* Subscriber */]));
//# sourceMappingURL=single.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/skip.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function skip(count) {
    return function (source) { return source.lift(new SkipOperator(count)); };
}
var SkipOperator = /*@__PURE__*/ (function () {
    function SkipOperator(total) {
        this.total = total;
    }
    SkipOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new skip_SkipSubscriber(subscriber, this.total));
    };
    return SkipOperator;
}());
var skip_SkipSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](SkipSubscriber, _super);
    function SkipSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.count = 0;
        return _this;
    }
    SkipSubscriber.prototype._next = function (x) {
        if (++this.count > this.total) {
            this.destination.next(x);
        }
    };
    return SkipSubscriber;
}(Subscriber["a" /* Subscriber */]));
//# sourceMappingURL=skip.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/skipLast.js
/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError PURE_IMPORTS_END */



function skipLast(count) {
    return function (source) { return source.lift(new skipLast_SkipLastOperator(count)); };
}
var skipLast_SkipLastOperator = /*@__PURE__*/ (function () {
    function SkipLastOperator(_skipCount) {
        this._skipCount = _skipCount;
        if (this._skipCount < 0) {
            throw new ArgumentOutOfRangeError["a" /* ArgumentOutOfRangeError */];
        }
    }
    SkipLastOperator.prototype.call = function (subscriber, source) {
        if (this._skipCount === 0) {
            return source.subscribe(new Subscriber["a" /* Subscriber */](subscriber));
        }
        else {
            return source.subscribe(new skipLast_SkipLastSubscriber(subscriber, this._skipCount));
        }
    };
    return SkipLastOperator;
}());
var skipLast_SkipLastSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](SkipLastSubscriber, _super);
    function SkipLastSubscriber(destination, _skipCount) {
        var _this = _super.call(this, destination) || this;
        _this._skipCount = _skipCount;
        _this._count = 0;
        _this._ring = new Array(_skipCount);
        return _this;
    }
    SkipLastSubscriber.prototype._next = function (value) {
        var skipCount = this._skipCount;
        var count = this._count++;
        if (count < skipCount) {
            this._ring[count] = value;
        }
        else {
            var currentIndex = count % skipCount;
            var ring = this._ring;
            var oldValue = ring[currentIndex];
            ring[currentIndex] = value;
            this.destination.next(oldValue);
        }
    };
    return SkipLastSubscriber;
}(Subscriber["a" /* Subscriber */]));
//# sourceMappingURL=skipLast.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/skipUntil.js
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_InnerSubscriber,_util_subscribeToResult PURE_IMPORTS_END */




function skipUntil(notifier) {
    return function (source) { return source.lift(new SkipUntilOperator(notifier)); };
}
var SkipUntilOperator = /*@__PURE__*/ (function () {
    function SkipUntilOperator(notifier) {
        this.notifier = notifier;
    }
    SkipUntilOperator.prototype.call = function (destination, source) {
        return source.subscribe(new skipUntil_SkipUntilSubscriber(destination, this.notifier));
    };
    return SkipUntilOperator;
}());
var skipUntil_SkipUntilSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](SkipUntilSubscriber, _super);
    function SkipUntilSubscriber(destination, notifier) {
        var _this = _super.call(this, destination) || this;
        _this.hasValue = false;
        var innerSubscriber = new InnerSubscriber["a" /* InnerSubscriber */](_this, undefined, undefined);
        _this.add(innerSubscriber);
        _this.innerSubscription = innerSubscriber;
        var innerSubscription = Object(subscribeToResult["a" /* subscribeToResult */])(_this, notifier, undefined, undefined, innerSubscriber);
        if (innerSubscription !== innerSubscriber) {
            _this.add(innerSubscription);
            _this.innerSubscription = innerSubscription;
        }
        return _this;
    }
    SkipUntilSubscriber.prototype._next = function (value) {
        if (this.hasValue) {
            _super.prototype._next.call(this, value);
        }
    };
    SkipUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.hasValue = true;
        if (this.innerSubscription) {
            this.innerSubscription.unsubscribe();
        }
    };
    SkipUntilSubscriber.prototype.notifyComplete = function () {
    };
    return SkipUntilSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));
//# sourceMappingURL=skipUntil.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/skipWhile.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function skipWhile(predicate) {
    return function (source) { return source.lift(new SkipWhileOperator(predicate)); };
}
var SkipWhileOperator = /*@__PURE__*/ (function () {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new skipWhile_SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}());
var skipWhile_SkipWhileSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.skipping = true;
        _this.index = 0;
        return _this;
    }
    SkipWhileSubscriber.prototype._next = function (value) {
        var destination = this.destination;
        if (this.skipping) {
            this.tryCallPredicate(value);
        }
        if (!this.skipping) {
            destination.next(value);
        }
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function (value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}(Subscriber["a" /* Subscriber */]));
//# sourceMappingURL=skipWhile.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/startWith.js
/** PURE_IMPORTS_START _observable_concat,_util_isScheduler PURE_IMPORTS_END */


function startWith() {
    var array = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        array[_i] = arguments[_i];
    }
    var scheduler = array[array.length - 1];
    if (Object(isScheduler["a" /* isScheduler */])(scheduler)) {
        array.pop();
        return function (source) { return Object(concat["a" /* concat */])(array, source, scheduler); };
    }
    else {
        return function (source) { return Object(concat["a" /* concat */])(array, source); };
    }
}
//# sourceMappingURL=startWith.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/asap.js + 3 modules
var asap = __webpack_require__(116);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isNumeric.js
var isNumeric = __webpack_require__(69);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/SubscribeOnObservable.js
/** PURE_IMPORTS_START tslib,_Observable,_scheduler_asap,_util_isNumeric PURE_IMPORTS_END */




var SubscribeOnObservable_SubscribeOnObservable = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](SubscribeOnObservable, _super);
    function SubscribeOnObservable(source, delayTime, scheduler) {
        if (delayTime === void 0) {
            delayTime = 0;
        }
        if (scheduler === void 0) {
            scheduler = asap["a" /* asap */];
        }
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.delayTime = delayTime;
        _this.scheduler = scheduler;
        if (!Object(isNumeric["a" /* isNumeric */])(delayTime) || delayTime < 0) {
            _this.delayTime = 0;
        }
        if (!scheduler || typeof scheduler.schedule !== 'function') {
            _this.scheduler = asap["a" /* asap */];
        }
        return _this;
    }
    SubscribeOnObservable.create = function (source, delay, scheduler) {
        if (delay === void 0) {
            delay = 0;
        }
        if (scheduler === void 0) {
            scheduler = asap["a" /* asap */];
        }
        return new SubscribeOnObservable(source, delay, scheduler);
    };
    SubscribeOnObservable.dispatch = function (arg) {
        var source = arg.source, subscriber = arg.subscriber;
        return this.add(source.subscribe(subscriber));
    };
    SubscribeOnObservable.prototype._subscribe = function (subscriber) {
        var delay = this.delayTime;
        var source = this.source;
        var scheduler = this.scheduler;
        return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
            source: source, subscriber: subscriber
        });
    };
    return SubscribeOnObservable;
}(Observable["a" /* Observable */]));

//# sourceMappingURL=SubscribeOnObservable.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/subscribeOn.js
/** PURE_IMPORTS_START _observable_SubscribeOnObservable PURE_IMPORTS_END */

function subscribeOn(scheduler, delay) {
    if (delay === void 0) {
        delay = 0;
    }
    return function subscribeOnOperatorFunction(source) {
        return source.lift(new subscribeOn_SubscribeOnOperator(scheduler, delay));
    };
}
var subscribeOn_SubscribeOnOperator = /*@__PURE__*/ (function () {
    function SubscribeOnOperator(scheduler, delay) {
        this.scheduler = scheduler;
        this.delay = delay;
    }
    SubscribeOnOperator.prototype.call = function (subscriber, source) {
        return new SubscribeOnObservable_SubscribeOnObservable(source, this.delay, this.scheduler).subscribe(subscriber);
    };
    return SubscribeOnOperator;
}());
//# sourceMappingURL=subscribeOn.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/switchMap.js
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_InnerSubscriber,_util_subscribeToResult,_map,_observable_from PURE_IMPORTS_END */






function switchMap(project, resultSelector) {
    if (typeof resultSelector === 'function') {
        return function (source) { return source.pipe(switchMap(function (a, i) { return Object(from["a" /* from */])(project(a, i)).pipe(Object(map["a" /* map */])(function (b, ii) { return resultSelector(a, b, i, ii); })); })); };
    }
    return function (source) { return source.lift(new SwitchMapOperator(project)); };
}
var SwitchMapOperator = /*@__PURE__*/ (function () {
    function SwitchMapOperator(project) {
        this.project = project;
    }
    SwitchMapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new switchMap_SwitchMapSubscriber(subscriber, this.project));
    };
    return SwitchMapOperator;
}());
var switchMap_SwitchMapSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.index = 0;
        return _this;
    }
    SwitchMapSubscriber.prototype._next = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result, value, index);
    };
    SwitchMapSubscriber.prototype._innerSub = function (result, value, index) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) {
            innerSubscription.unsubscribe();
        }
        var innerSubscriber = new InnerSubscriber["a" /* InnerSubscriber */](this, value, index);
        var destination = this.destination;
        destination.add(innerSubscriber);
        this.innerSubscription = Object(subscribeToResult["a" /* subscribeToResult */])(this, result, undefined, undefined, innerSubscriber);
        if (this.innerSubscription !== innerSubscriber) {
            destination.add(this.innerSubscription);
        }
    };
    SwitchMapSubscriber.prototype._complete = function () {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) {
            _super.prototype._complete.call(this);
        }
        this.unsubscribe();
    };
    SwitchMapSubscriber.prototype._unsubscribe = function () {
        this.innerSubscription = null;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function (innerSub) {
        var destination = this.destination;
        destination.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) {
            _super.prototype._complete.call(this);
        }
    };
    SwitchMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    return SwitchMapSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));
//# sourceMappingURL=switchMap.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/switchAll.js
/** PURE_IMPORTS_START _switchMap,_util_identity PURE_IMPORTS_END */


function switchAll() {
    return switchMap(identity["a" /* identity */]);
}
//# sourceMappingURL=switchAll.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/switchMapTo.js
/** PURE_IMPORTS_START _switchMap PURE_IMPORTS_END */

function switchMapTo(innerObservable, resultSelector) {
    return resultSelector ? switchMap(function () { return innerObservable; }, resultSelector) : switchMap(function () { return innerObservable; });
}
//# sourceMappingURL=switchMapTo.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/takeUntil.js
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



function takeUntil(notifier) {
    return function (source) { return source.lift(new takeUntil_TakeUntilOperator(notifier)); };
}
var takeUntil_TakeUntilOperator = /*@__PURE__*/ (function () {
    function TakeUntilOperator(notifier) {
        this.notifier = notifier;
    }
    TakeUntilOperator.prototype.call = function (subscriber, source) {
        var takeUntilSubscriber = new takeUntil_TakeUntilSubscriber(subscriber);
        var notifierSubscription = Object(subscribeToResult["a" /* subscribeToResult */])(takeUntilSubscriber, this.notifier);
        if (notifierSubscription && !takeUntilSubscriber.seenValue) {
            takeUntilSubscriber.add(notifierSubscription);
            return source.subscribe(takeUntilSubscriber);
        }
        return takeUntilSubscriber;
    };
    return TakeUntilOperator;
}());
var takeUntil_TakeUntilSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](TakeUntilSubscriber, _super);
    function TakeUntilSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.seenValue = false;
        return _this;
    }
    TakeUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.seenValue = true;
        this.complete();
    };
    TakeUntilSubscriber.prototype.notifyComplete = function () {
    };
    return TakeUntilSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));
//# sourceMappingURL=takeUntil.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/takeWhile.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function takeWhile(predicate, inclusive) {
    if (inclusive === void 0) {
        inclusive = false;
    }
    return function (source) {
        return source.lift(new TakeWhileOperator(predicate, inclusive));
    };
}
var TakeWhileOperator = /*@__PURE__*/ (function () {
    function TakeWhileOperator(predicate, inclusive) {
        this.predicate = predicate;
        this.inclusive = inclusive;
    }
    TakeWhileOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new takeWhile_TakeWhileSubscriber(subscriber, this.predicate, this.inclusive));
    };
    return TakeWhileOperator;
}());
var takeWhile_TakeWhileSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](TakeWhileSubscriber, _super);
    function TakeWhileSubscriber(destination, predicate, inclusive) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.inclusive = inclusive;
        _this.index = 0;
        return _this;
    }
    TakeWhileSubscriber.prototype._next = function (value) {
        var destination = this.destination;
        var result;
        try {
            result = this.predicate(value, this.index++);
        }
        catch (err) {
            destination.error(err);
            return;
        }
        this.nextOrComplete(value, result);
    };
    TakeWhileSubscriber.prototype.nextOrComplete = function (value, predicateResult) {
        var destination = this.destination;
        if (Boolean(predicateResult)) {
            destination.next(value);
        }
        else {
            if (this.inclusive) {
                destination.next(value);
            }
            destination.complete();
        }
    };
    return TakeWhileSubscriber;
}(Subscriber["a" /* Subscriber */]));
//# sourceMappingURL=takeWhile.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/noop.js
var noop = __webpack_require__(48);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isFunction.js
var isFunction = __webpack_require__(61);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/tap.js
/** PURE_IMPORTS_START tslib,_Subscriber,_util_noop,_util_isFunction PURE_IMPORTS_END */




function tap(nextOrObserver, error, complete) {
    return function tapOperatorFunction(source) {
        return source.lift(new DoOperator(nextOrObserver, error, complete));
    };
}
var DoOperator = /*@__PURE__*/ (function () {
    function DoOperator(nextOrObserver, error, complete) {
        this.nextOrObserver = nextOrObserver;
        this.error = error;
        this.complete = complete;
    }
    DoOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new tap_TapSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
    };
    return DoOperator;
}());
var tap_TapSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](TapSubscriber, _super);
    function TapSubscriber(destination, observerOrNext, error, complete) {
        var _this = _super.call(this, destination) || this;
        _this._tapNext = noop["a" /* noop */];
        _this._tapError = noop["a" /* noop */];
        _this._tapComplete = noop["a" /* noop */];
        _this._tapError = error || noop["a" /* noop */];
        _this._tapComplete = complete || noop["a" /* noop */];
        if (Object(isFunction["a" /* isFunction */])(observerOrNext)) {
            _this._context = _this;
            _this._tapNext = observerOrNext;
        }
        else if (observerOrNext) {
            _this._context = observerOrNext;
            _this._tapNext = observerOrNext.next || noop["a" /* noop */];
            _this._tapError = observerOrNext.error || noop["a" /* noop */];
            _this._tapComplete = observerOrNext.complete || noop["a" /* noop */];
        }
        return _this;
    }
    TapSubscriber.prototype._next = function (value) {
        try {
            this._tapNext.call(this._context, value);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(value);
    };
    TapSubscriber.prototype._error = function (err) {
        try {
            this._tapError.call(this._context, err);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.error(err);
    };
    TapSubscriber.prototype._complete = function () {
        try {
            this._tapComplete.call(this._context);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        return this.destination.complete();
    };
    return TapSubscriber;
}(Subscriber["a" /* Subscriber */]));
//# sourceMappingURL=tap.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/throttle.js
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



var defaultThrottleConfig = {
    leading: true,
    trailing: false
};
function throttle(durationSelector, config) {
    if (config === void 0) {
        config = defaultThrottleConfig;
    }
    return function (source) { return source.lift(new ThrottleOperator(durationSelector, config.leading, config.trailing)); };
}
var ThrottleOperator = /*@__PURE__*/ (function () {
    function ThrottleOperator(durationSelector, leading, trailing) {
        this.durationSelector = durationSelector;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new throttle_ThrottleSubscriber(subscriber, this.durationSelector, this.leading, this.trailing));
    };
    return ThrottleOperator;
}());
var throttle_ThrottleSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](ThrottleSubscriber, _super);
    function ThrottleSubscriber(destination, durationSelector, _leading, _trailing) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.durationSelector = durationSelector;
        _this._leading = _leading;
        _this._trailing = _trailing;
        _this._hasValue = false;
        return _this;
    }
    ThrottleSubscriber.prototype._next = function (value) {
        this._hasValue = true;
        this._sendValue = value;
        if (!this._throttled) {
            if (this._leading) {
                this.send();
            }
            else {
                this.throttle(value);
            }
        }
    };
    ThrottleSubscriber.prototype.send = function () {
        var _a = this, _hasValue = _a._hasValue, _sendValue = _a._sendValue;
        if (_hasValue) {
            this.destination.next(_sendValue);
            this.throttle(_sendValue);
        }
        this._hasValue = false;
        this._sendValue = null;
    };
    ThrottleSubscriber.prototype.throttle = function (value) {
        var duration = this.tryDurationSelector(value);
        if (!!duration) {
            this.add(this._throttled = Object(subscribeToResult["a" /* subscribeToResult */])(this, duration));
        }
    };
    ThrottleSubscriber.prototype.tryDurationSelector = function (value) {
        try {
            return this.durationSelector(value);
        }
        catch (err) {
            this.destination.error(err);
            return null;
        }
    };
    ThrottleSubscriber.prototype.throttlingDone = function () {
        var _a = this, _throttled = _a._throttled, _trailing = _a._trailing;
        if (_throttled) {
            _throttled.unsubscribe();
        }
        this._throttled = null;
        if (_trailing) {
            this.send();
        }
    };
    ThrottleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.throttlingDone();
    };
    ThrottleSubscriber.prototype.notifyComplete = function () {
        this.throttlingDone();
    };
    return ThrottleSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));
//# sourceMappingURL=throttle.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/throttleTime.js
/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async,_throttle PURE_IMPORTS_END */




function throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) {
        scheduler = scheduler_async["a" /* async */];
    }
    if (config === void 0) {
        config = defaultThrottleConfig;
    }
    return function (source) { return source.lift(new ThrottleTimeOperator(duration, scheduler, config.leading, config.trailing)); };
}
var ThrottleTimeOperator = /*@__PURE__*/ (function () {
    function ThrottleTimeOperator(duration, scheduler, leading, trailing) {
        this.duration = duration;
        this.scheduler = scheduler;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new throttleTime_ThrottleTimeSubscriber(subscriber, this.duration, this.scheduler, this.leading, this.trailing));
    };
    return ThrottleTimeOperator;
}());
var throttleTime_ThrottleTimeSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](ThrottleTimeSubscriber, _super);
    function ThrottleTimeSubscriber(destination, duration, scheduler, leading, trailing) {
        var _this = _super.call(this, destination) || this;
        _this.duration = duration;
        _this.scheduler = scheduler;
        _this.leading = leading;
        _this.trailing = trailing;
        _this._hasTrailingValue = false;
        _this._trailingValue = null;
        return _this;
    }
    ThrottleTimeSubscriber.prototype._next = function (value) {
        if (this.throttled) {
            if (this.trailing) {
                this._trailingValue = value;
                this._hasTrailingValue = true;
            }
        }
        else {
            this.add(this.throttled = this.scheduler.schedule(throttleTime_dispatchNext, this.duration, { subscriber: this }));
            if (this.leading) {
                this.destination.next(value);
            }
            else if (this.trailing) {
                this._trailingValue = value;
                this._hasTrailingValue = true;
            }
        }
    };
    ThrottleTimeSubscriber.prototype._complete = function () {
        if (this._hasTrailingValue) {
            this.destination.next(this._trailingValue);
            this.destination.complete();
        }
        else {
            this.destination.complete();
        }
    };
    ThrottleTimeSubscriber.prototype.clearThrottle = function () {
        var throttled = this.throttled;
        if (throttled) {
            if (this.trailing && this._hasTrailingValue) {
                this.destination.next(this._trailingValue);
                this._trailingValue = null;
                this._hasTrailingValue = false;
            }
            throttled.unsubscribe();
            this.remove(throttled);
            this.throttled = null;
        }
    };
    return ThrottleTimeSubscriber;
}(Subscriber["a" /* Subscriber */]));
function throttleTime_dispatchNext(arg) {
    var subscriber = arg.subscriber;
    subscriber.clearThrottle();
}
//# sourceMappingURL=throttleTime.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/defer.js
var defer = __webpack_require__(111);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/timeInterval.js
/** PURE_IMPORTS_START _scheduler_async,_scan,_observable_defer,_map PURE_IMPORTS_END */




function timeInterval(scheduler) {
    if (scheduler === void 0) {
        scheduler = scheduler_async["a" /* async */];
    }
    return function (source) {
        return Object(defer["a" /* defer */])(function () {
            return source.pipe(scan(function (_a, value) {
                var current = _a.current;
                return ({ value: value, current: scheduler.now(), last: current });
            }, { current: scheduler.now(), value: undefined, last: undefined }), Object(map["a" /* map */])(function (_a) {
                var current = _a.current, last = _a.last, value = _a.value;
                return new TimeInterval(value, current - last);
            }));
        });
    };
}
var TimeInterval = /*@__PURE__*/ (function () {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}());

//# sourceMappingURL=timeInterval.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/TimeoutError.js
var TimeoutError = __webpack_require__(156);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/timeoutWith.js
/** PURE_IMPORTS_START tslib,_scheduler_async,_util_isDate,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */





function timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) {
        scheduler = scheduler_async["a" /* async */];
    }
    return function (source) {
        var absoluteTimeout = isDate(due);
        var waitFor = absoluteTimeout ? (+due - scheduler.now()) : Math.abs(due);
        return source.lift(new TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
    };
}
var TimeoutWithOperator = /*@__PURE__*/ (function () {
    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
    }
    TimeoutWithOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new timeoutWith_TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
    };
    return TimeoutWithOperator;
}());
var timeoutWith_TimeoutWithSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](TimeoutWithSubscriber, _super);
    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.absoluteTimeout = absoluteTimeout;
        _this.waitFor = waitFor;
        _this.withObservable = withObservable;
        _this.scheduler = scheduler;
        _this.action = null;
        _this.scheduleTimeout();
        return _this;
    }
    TimeoutWithSubscriber.dispatchTimeout = function (subscriber) {
        var withObservable = subscriber.withObservable;
        subscriber._unsubscribeAndRecycle();
        subscriber.add(Object(subscribeToResult["a" /* subscribeToResult */])(subscriber, withObservable));
    };
    TimeoutWithSubscriber.prototype.scheduleTimeout = function () {
        var action = this.action;
        if (action) {
            this.action = action.schedule(this, this.waitFor);
        }
        else {
            this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
        }
    };
    TimeoutWithSubscriber.prototype._next = function (value) {
        if (!this.absoluteTimeout) {
            this.scheduleTimeout();
        }
        _super.prototype._next.call(this, value);
    };
    TimeoutWithSubscriber.prototype._unsubscribe = function () {
        this.action = null;
        this.scheduler = null;
        this.withObservable = null;
    };
    return TimeoutWithSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));
//# sourceMappingURL=timeoutWith.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/throwError.js
var throwError = __webpack_require__(108);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/timeout.js
/** PURE_IMPORTS_START _scheduler_async,_util_TimeoutError,_timeoutWith,_observable_throwError PURE_IMPORTS_END */




function timeout(due, scheduler) {
    if (scheduler === void 0) {
        scheduler = scheduler_async["a" /* async */];
    }
    return timeoutWith(due, Object(throwError["a" /* throwError */])(new TimeoutError["a" /* TimeoutError */]()), scheduler);
}
//# sourceMappingURL=timeout.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/timestamp.js
/** PURE_IMPORTS_START _scheduler_async,_map PURE_IMPORTS_END */


function timestamp(scheduler) {
    if (scheduler === void 0) {
        scheduler = scheduler_async["a" /* async */];
    }
    return Object(map["a" /* map */])(function (value) { return new Timestamp(value, scheduler.now()); });
}
var Timestamp = /*@__PURE__*/ (function () {
    function Timestamp(value, timestamp) {
        this.value = value;
        this.timestamp = timestamp;
    }
    return Timestamp;
}());

//# sourceMappingURL=timestamp.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/toArray.js
/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */

function toArrayReducer(arr, item, index) {
    if (index === 0) {
        return [item];
    }
    arr.push(item);
    return arr;
}
function toArray() {
    return reduce(toArrayReducer, []);
}
//# sourceMappingURL=toArray.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/window.js
/** PURE_IMPORTS_START tslib,_Subject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */




function window_window(windowBoundaries) {
    return function windowOperatorFunction(source) {
        return source.lift(new window_WindowOperator(windowBoundaries));
    };
}
var window_WindowOperator = /*@__PURE__*/ (function () {
    function WindowOperator(windowBoundaries) {
        this.windowBoundaries = windowBoundaries;
    }
    WindowOperator.prototype.call = function (subscriber, source) {
        var windowSubscriber = new window_WindowSubscriber(subscriber);
        var sourceSubscription = source.subscribe(windowSubscriber);
        if (!sourceSubscription.closed) {
            windowSubscriber.add(Object(subscribeToResult["a" /* subscribeToResult */])(windowSubscriber, this.windowBoundaries));
        }
        return sourceSubscription;
    };
    return WindowOperator;
}());
var window_WindowSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](WindowSubscriber, _super);
    function WindowSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.window = new Subject["a" /* Subject */]();
        destination.next(_this.window);
        return _this;
    }
    WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow();
    };
    WindowSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function (innerSub) {
        this._complete();
    };
    WindowSubscriber.prototype._next = function (value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function (err) {
        this.window.error(err);
        this.destination.error(err);
    };
    WindowSubscriber.prototype._complete = function () {
        this.window.complete();
        this.destination.complete();
    };
    WindowSubscriber.prototype._unsubscribe = function () {
        this.window = null;
    };
    WindowSubscriber.prototype.openWindow = function () {
        var prevWindow = this.window;
        if (prevWindow) {
            prevWindow.complete();
        }
        var destination = this.destination;
        var newWindow = this.window = new Subject["a" /* Subject */]();
        destination.next(newWindow);
    };
    return WindowSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));
//# sourceMappingURL=window.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/windowCount.js
/** PURE_IMPORTS_START tslib,_Subscriber,_Subject PURE_IMPORTS_END */



function windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) {
        startWindowEvery = 0;
    }
    return function windowCountOperatorFunction(source) {
        return source.lift(new WindowCountOperator(windowSize, startWindowEvery));
    };
}
var WindowCountOperator = /*@__PURE__*/ (function () {
    function WindowCountOperator(windowSize, startWindowEvery) {
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
    }
    WindowCountOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new windowCount_WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
    };
    return WindowCountOperator;
}());
var windowCount_WindowCountSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](WindowCountSubscriber, _super);
    function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.windowSize = windowSize;
        _this.startWindowEvery = startWindowEvery;
        _this.windows = [new Subject["a" /* Subject */]()];
        _this.count = 0;
        destination.next(_this.windows[0]);
        return _this;
    }
    WindowCountSubscriber.prototype._next = function (value) {
        var startWindowEvery = (this.startWindowEvery > 0) ? this.startWindowEvery : this.windowSize;
        var destination = this.destination;
        var windowSize = this.windowSize;
        var windows = this.windows;
        var len = windows.length;
        for (var i = 0; i < len && !this.closed; i++) {
            windows[i].next(value);
        }
        var c = this.count - windowSize + 1;
        if (c >= 0 && c % startWindowEvery === 0 && !this.closed) {
            windows.shift().complete();
        }
        if (++this.count % startWindowEvery === 0 && !this.closed) {
            var window_1 = new Subject["a" /* Subject */]();
            windows.push(window_1);
            destination.next(window_1);
        }
    };
    WindowCountSubscriber.prototype._error = function (err) {
        var windows = this.windows;
        if (windows) {
            while (windows.length > 0 && !this.closed) {
                windows.shift().error(err);
            }
        }
        this.destination.error(err);
    };
    WindowCountSubscriber.prototype._complete = function () {
        var windows = this.windows;
        if (windows) {
            while (windows.length > 0 && !this.closed) {
                windows.shift().complete();
            }
        }
        this.destination.complete();
    };
    WindowCountSubscriber.prototype._unsubscribe = function () {
        this.count = 0;
        this.windows = null;
    };
    return WindowCountSubscriber;
}(Subscriber["a" /* Subscriber */]));
//# sourceMappingURL=windowCount.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/windowTime.js
/** PURE_IMPORTS_START tslib,_Subject,_scheduler_async,_Subscriber,_util_isNumeric,_util_isScheduler PURE_IMPORTS_END */






function windowTime_windowTime(windowTimeSpan) {
    var scheduler = scheduler_async["a" /* async */];
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if (Object(isScheduler["a" /* isScheduler */])(arguments[3])) {
        scheduler = arguments[3];
    }
    if (Object(isScheduler["a" /* isScheduler */])(arguments[2])) {
        scheduler = arguments[2];
    }
    else if (Object(isNumeric["a" /* isNumeric */])(arguments[2])) {
        maxWindowSize = arguments[2];
    }
    if (Object(isScheduler["a" /* isScheduler */])(arguments[1])) {
        scheduler = arguments[1];
    }
    else if (Object(isNumeric["a" /* isNumeric */])(arguments[1])) {
        windowCreationInterval = arguments[1];
    }
    return function windowTimeOperatorFunction(source) {
        return source.lift(new WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
    };
}
var WindowTimeOperator = /*@__PURE__*/ (function () {
    function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
    }
    WindowTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new windowTime_WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
    };
    return WindowTimeOperator;
}());
var windowTime_CountedSubject = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](CountedSubject, _super);
    function CountedSubject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._numberOfNextedValues = 0;
        return _this;
    }
    CountedSubject.prototype.next = function (value) {
        this._numberOfNextedValues++;
        _super.prototype.next.call(this, value);
    };
    Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
        get: function () {
            return this._numberOfNextedValues;
        },
        enumerable: true,
        configurable: true
    });
    return CountedSubject;
}(Subject["a" /* Subject */]));
var windowTime_WindowTimeSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](WindowTimeSubscriber, _super);
    function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.windowTimeSpan = windowTimeSpan;
        _this.windowCreationInterval = windowCreationInterval;
        _this.maxWindowSize = maxWindowSize;
        _this.scheduler = scheduler;
        _this.windows = [];
        var window = _this.openWindow();
        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
            var closeState = { subscriber: _this, window: window, context: null };
            var creationState = { windowTimeSpan: windowTimeSpan, windowCreationInterval: windowCreationInterval, subscriber: _this, scheduler: scheduler };
            _this.add(scheduler.schedule(dispatchWindowClose, windowTimeSpan, closeState));
            _this.add(scheduler.schedule(dispatchWindowCreation, windowCreationInterval, creationState));
        }
        else {
            var timeSpanOnlyState = { subscriber: _this, window: window, windowTimeSpan: windowTimeSpan };
            _this.add(scheduler.schedule(dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
        }
        return _this;
    }
    WindowTimeSubscriber.prototype._next = function (value) {
        var windows = this.windows;
        var len = windows.length;
        for (var i = 0; i < len; i++) {
            var window_1 = windows[i];
            if (!window_1.closed) {
                window_1.next(value);
                if (window_1.numberOfNextedValues >= this.maxWindowSize) {
                    this.closeWindow(window_1);
                }
            }
        }
    };
    WindowTimeSubscriber.prototype._error = function (err) {
        var windows = this.windows;
        while (windows.length > 0) {
            windows.shift().error(err);
        }
        this.destination.error(err);
    };
    WindowTimeSubscriber.prototype._complete = function () {
        var windows = this.windows;
        while (windows.length > 0) {
            var window_2 = windows.shift();
            if (!window_2.closed) {
                window_2.complete();
            }
        }
        this.destination.complete();
    };
    WindowTimeSubscriber.prototype.openWindow = function () {
        var window = new windowTime_CountedSubject();
        this.windows.push(window);
        var destination = this.destination;
        destination.next(window);
        return window;
    };
    WindowTimeSubscriber.prototype.closeWindow = function (window) {
        window.complete();
        var windows = this.windows;
        windows.splice(windows.indexOf(window), 1);
    };
    return WindowTimeSubscriber;
}(Subscriber["a" /* Subscriber */]));
function dispatchWindowTimeSpanOnly(state) {
    var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
    if (window) {
        subscriber.closeWindow(window);
    }
    state.window = subscriber.openWindow();
    this.schedule(state, windowTimeSpan);
}
function dispatchWindowCreation(state) {
    var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
    var window = subscriber.openWindow();
    var action = this;
    var context = { action: action, subscription: null };
    var timeSpanState = { subscriber: subscriber, window: window, context: context };
    context.subscription = scheduler.schedule(dispatchWindowClose, windowTimeSpan, timeSpanState);
    action.add(context.subscription);
    action.schedule(state, windowCreationInterval);
}
function dispatchWindowClose(state) {
    var subscriber = state.subscriber, window = state.window, context = state.context;
    if (context && context.action && context.subscription) {
        context.action.remove(context.subscription);
    }
    subscriber.closeWindow(window);
}
//# sourceMappingURL=windowTime.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/windowToggle.js
/** PURE_IMPORTS_START tslib,_Subject,_Subscription,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */





function windowToggle(openings, closingSelector) {
    return function (source) { return source.lift(new WindowToggleOperator(openings, closingSelector)); };
}
var WindowToggleOperator = /*@__PURE__*/ (function () {
    function WindowToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    WindowToggleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new windowToggle_WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return WindowToggleOperator;
}());
var windowToggle_WindowToggleSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](WindowToggleSubscriber, _super);
    function WindowToggleSubscriber(destination, openings, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.openings = openings;
        _this.closingSelector = closingSelector;
        _this.contexts = [];
        _this.add(_this.openSubscription = Object(subscribeToResult["a" /* subscribeToResult */])(_this, openings, openings));
        return _this;
    }
    WindowToggleSubscriber.prototype._next = function (value) {
        var contexts = this.contexts;
        if (contexts) {
            var len = contexts.length;
            for (var i = 0; i < len; i++) {
                contexts[i].window.next(value);
            }
        }
    };
    WindowToggleSubscriber.prototype._error = function (err) {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while (++index < len) {
                var context_1 = contexts[index];
                context_1.window.error(err);
                context_1.subscription.unsubscribe();
            }
        }
        _super.prototype._error.call(this, err);
    };
    WindowToggleSubscriber.prototype._complete = function () {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while (++index < len) {
                var context_2 = contexts[index];
                context_2.window.complete();
                context_2.subscription.unsubscribe();
            }
        }
        _super.prototype._complete.call(this);
    };
    WindowToggleSubscriber.prototype._unsubscribe = function () {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while (++index < len) {
                var context_3 = contexts[index];
                context_3.window.unsubscribe();
                context_3.subscription.unsubscribe();
            }
        }
    };
    WindowToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (outerValue === this.openings) {
            var closingNotifier = void 0;
            try {
                var closingSelector = this.closingSelector;
                closingNotifier = closingSelector(innerValue);
            }
            catch (e) {
                return this.error(e);
            }
            var window_1 = new Subject["a" /* Subject */]();
            var subscription = new Subscription["a" /* Subscription */]();
            var context_4 = { window: window_1, subscription: subscription };
            this.contexts.push(context_4);
            var innerSubscription = Object(subscribeToResult["a" /* subscribeToResult */])(this, closingNotifier, context_4);
            if (innerSubscription.closed) {
                this.closeWindow(this.contexts.length - 1);
            }
            else {
                innerSubscription.context = context_4;
                subscription.add(innerSubscription);
            }
            this.destination.next(window_1);
        }
        else {
            this.closeWindow(this.contexts.indexOf(outerValue));
        }
    };
    WindowToggleSubscriber.prototype.notifyError = function (err) {
        this.error(err);
    };
    WindowToggleSubscriber.prototype.notifyComplete = function (inner) {
        if (inner !== this.openSubscription) {
            this.closeWindow(this.contexts.indexOf(inner.context));
        }
    };
    WindowToggleSubscriber.prototype.closeWindow = function (index) {
        if (index === -1) {
            return;
        }
        var contexts = this.contexts;
        var context = contexts[index];
        var window = context.window, subscription = context.subscription;
        contexts.splice(index, 1);
        window.complete();
        subscription.unsubscribe();
    };
    return WindowToggleSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));
//# sourceMappingURL=windowToggle.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/windowWhen.js
/** PURE_IMPORTS_START tslib,_Subject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */




function windowWhen(closingSelector) {
    return function windowWhenOperatorFunction(source) {
        return source.lift(new windowWhen_WindowOperator(closingSelector));
    };
}
var windowWhen_WindowOperator = /*@__PURE__*/ (function () {
    function WindowOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    WindowOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new windowWhen_WindowSubscriber(subscriber, this.closingSelector));
    };
    return WindowOperator;
}());
var windowWhen_WindowSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](WindowSubscriber, _super);
    function WindowSubscriber(destination, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.closingSelector = closingSelector;
        _this.openWindow();
        return _this;
    }
    WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function (innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype._next = function (value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function (err) {
        this.window.error(err);
        this.destination.error(err);
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype._complete = function () {
        this.window.complete();
        this.destination.complete();
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype.unsubscribeClosingNotification = function () {
        if (this.closingNotification) {
            this.closingNotification.unsubscribe();
        }
    };
    WindowSubscriber.prototype.openWindow = function (innerSub) {
        if (innerSub === void 0) {
            innerSub = null;
        }
        if (innerSub) {
            this.remove(innerSub);
            innerSub.unsubscribe();
        }
        var prevWindow = this.window;
        if (prevWindow) {
            prevWindow.complete();
        }
        var window = this.window = new Subject["a" /* Subject */]();
        this.destination.next(window);
        var closingNotifier;
        try {
            var closingSelector = this.closingSelector;
            closingNotifier = closingSelector();
        }
        catch (e) {
            this.destination.error(e);
            this.window.error(e);
            return;
        }
        this.add(this.closingNotification = Object(subscribeToResult["a" /* subscribeToResult */])(this, closingNotifier));
    };
    return WindowSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));
//# sourceMappingURL=windowWhen.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/withLatestFrom.js
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



function withLatestFrom() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return function (source) {
        var project;
        if (typeof args[args.length - 1] === 'function') {
            project = args.pop();
        }
        var observables = args;
        return source.lift(new WithLatestFromOperator(observables, project));
    };
}
var WithLatestFromOperator = /*@__PURE__*/ (function () {
    function WithLatestFromOperator(observables, project) {
        this.observables = observables;
        this.project = project;
    }
    WithLatestFromOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new withLatestFrom_WithLatestFromSubscriber(subscriber, this.observables, this.project));
    };
    return WithLatestFromOperator;
}());
var withLatestFrom_WithLatestFromSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](WithLatestFromSubscriber, _super);
    function WithLatestFromSubscriber(destination, observables, project) {
        var _this = _super.call(this, destination) || this;
        _this.observables = observables;
        _this.project = project;
        _this.toRespond = [];
        var len = observables.length;
        _this.values = new Array(len);
        for (var i = 0; i < len; i++) {
            _this.toRespond.push(i);
        }
        for (var i = 0; i < len; i++) {
            var observable = observables[i];
            _this.add(Object(subscribeToResult["a" /* subscribeToResult */])(_this, observable, observable, i));
        }
        return _this;
    }
    WithLatestFromSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values[outerIndex] = innerValue;
        var toRespond = this.toRespond;
        if (toRespond.length > 0) {
            var found = toRespond.indexOf(outerIndex);
            if (found !== -1) {
                toRespond.splice(found, 1);
            }
        }
    };
    WithLatestFromSubscriber.prototype.notifyComplete = function () {
    };
    WithLatestFromSubscriber.prototype._next = function (value) {
        if (this.toRespond.length === 0) {
            var args = [value].concat(this.values);
            if (this.project) {
                this._tryProject(args);
            }
            else {
                this.destination.next(args);
            }
        }
    };
    WithLatestFromSubscriber.prototype._tryProject = function (args) {
        var result;
        try {
            result = this.project.apply(this, args);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return WithLatestFromSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));
//# sourceMappingURL=withLatestFrom.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/zip.js
var zip = __webpack_require__(112);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/zip.js
/** PURE_IMPORTS_START _observable_zip PURE_IMPORTS_END */

function zip_zip() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return function zipOperatorFunction(source) {
        return source.lift.call(zip["b" /* zip */].apply(void 0, [source].concat(observables)));
    };
}
//# sourceMappingURL=zip.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/zipAll.js
/** PURE_IMPORTS_START _observable_zip PURE_IMPORTS_END */

function zipAll(project) {
    return function (source) { return source.lift(new zip["a" /* ZipOperator */](project)); };
}
//# sourceMappingURL=zipAll.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/operators/index.js
/* concated harmony reexport audit */__webpack_require__.d(__webpack_exports__, "audit", function() { return audit; });
/* concated harmony reexport auditTime */__webpack_require__.d(__webpack_exports__, "auditTime", function() { return auditTime; });
/* concated harmony reexport buffer */__webpack_require__.d(__webpack_exports__, "buffer", function() { return buffer_buffer; });
/* concated harmony reexport bufferCount */__webpack_require__.d(__webpack_exports__, "bufferCount", function() { return bufferCount; });
/* concated harmony reexport bufferTime */__webpack_require__.d(__webpack_exports__, "bufferTime", function() { return bufferTime; });
/* concated harmony reexport bufferToggle */__webpack_require__.d(__webpack_exports__, "bufferToggle", function() { return bufferToggle; });
/* concated harmony reexport bufferWhen */__webpack_require__.d(__webpack_exports__, "bufferWhen", function() { return bufferWhen; });
/* concated harmony reexport catchError */__webpack_require__.d(__webpack_exports__, "catchError", function() { return catchError; });
/* concated harmony reexport combineAll */__webpack_require__.d(__webpack_exports__, "combineAll", function() { return combineAll; });
/* concated harmony reexport combineLatest */__webpack_require__.d(__webpack_exports__, "combineLatest", function() { return combineLatest_combineLatest; });
/* concated harmony reexport concat */__webpack_require__.d(__webpack_exports__, "concat", function() { return concat_concat; });
/* concated harmony reexport concatAll */__webpack_require__.d(__webpack_exports__, "concatAll", function() { return concatAll["a" /* concatAll */]; });
/* concated harmony reexport concatMap */__webpack_require__.d(__webpack_exports__, "concatMap", function() { return concatMap; });
/* concated harmony reexport concatMapTo */__webpack_require__.d(__webpack_exports__, "concatMapTo", function() { return concatMapTo; });
/* concated harmony reexport count */__webpack_require__.d(__webpack_exports__, "count", function() { return count_count; });
/* concated harmony reexport debounce */__webpack_require__.d(__webpack_exports__, "debounce", function() { return debounce; });
/* concated harmony reexport debounceTime */__webpack_require__.d(__webpack_exports__, "debounceTime", function() { return debounceTime; });
/* concated harmony reexport defaultIfEmpty */__webpack_require__.d(__webpack_exports__, "defaultIfEmpty", function() { return defaultIfEmpty; });
/* concated harmony reexport delay */__webpack_require__.d(__webpack_exports__, "delay", function() { return delay_delay; });
/* concated harmony reexport delayWhen */__webpack_require__.d(__webpack_exports__, "delayWhen", function() { return delayWhen; });
/* concated harmony reexport dematerialize */__webpack_require__.d(__webpack_exports__, "dematerialize", function() { return dematerialize; });
/* concated harmony reexport distinct */__webpack_require__.d(__webpack_exports__, "distinct", function() { return distinct; });
/* concated harmony reexport distinctUntilChanged */__webpack_require__.d(__webpack_exports__, "distinctUntilChanged", function() { return distinctUntilChanged; });
/* concated harmony reexport distinctUntilKeyChanged */__webpack_require__.d(__webpack_exports__, "distinctUntilKeyChanged", function() { return distinctUntilKeyChanged; });
/* concated harmony reexport elementAt */__webpack_require__.d(__webpack_exports__, "elementAt", function() { return elementAt; });
/* concated harmony reexport endWith */__webpack_require__.d(__webpack_exports__, "endWith", function() { return endWith; });
/* concated harmony reexport every */__webpack_require__.d(__webpack_exports__, "every", function() { return every; });
/* concated harmony reexport exhaust */__webpack_require__.d(__webpack_exports__, "exhaust", function() { return exhaust; });
/* concated harmony reexport exhaustMap */__webpack_require__.d(__webpack_exports__, "exhaustMap", function() { return exhaustMap; });
/* concated harmony reexport expand */__webpack_require__.d(__webpack_exports__, "expand", function() { return expand; });
/* concated harmony reexport filter */__webpack_require__.d(__webpack_exports__, "filter", function() { return filter["a" /* filter */]; });
/* concated harmony reexport finalize */__webpack_require__.d(__webpack_exports__, "finalize", function() { return finalize; });
/* concated harmony reexport find */__webpack_require__.d(__webpack_exports__, "find", function() { return find; });
/* concated harmony reexport findIndex */__webpack_require__.d(__webpack_exports__, "findIndex", function() { return findIndex; });
/* concated harmony reexport first */__webpack_require__.d(__webpack_exports__, "first", function() { return first; });
/* concated harmony reexport groupBy */__webpack_require__.d(__webpack_exports__, "groupBy", function() { return groupBy["b" /* groupBy */]; });
/* concated harmony reexport ignoreElements */__webpack_require__.d(__webpack_exports__, "ignoreElements", function() { return ignoreElements; });
/* concated harmony reexport isEmpty */__webpack_require__.d(__webpack_exports__, "isEmpty", function() { return isEmpty; });
/* concated harmony reexport last */__webpack_require__.d(__webpack_exports__, "last", function() { return last; });
/* concated harmony reexport map */__webpack_require__.d(__webpack_exports__, "map", function() { return map["a" /* map */]; });
/* concated harmony reexport mapTo */__webpack_require__.d(__webpack_exports__, "mapTo", function() { return mapTo; });
/* concated harmony reexport materialize */__webpack_require__.d(__webpack_exports__, "materialize", function() { return materialize; });
/* concated harmony reexport max */__webpack_require__.d(__webpack_exports__, "max", function() { return max_max; });
/* concated harmony reexport merge */__webpack_require__.d(__webpack_exports__, "merge", function() { return merge_merge; });
/* concated harmony reexport mergeAll */__webpack_require__.d(__webpack_exports__, "mergeAll", function() { return mergeAll["a" /* mergeAll */]; });
/* concated harmony reexport mergeMap */__webpack_require__.d(__webpack_exports__, "mergeMap", function() { return mergeMap["a" /* mergeMap */]; });
/* concated harmony reexport flatMap */__webpack_require__.d(__webpack_exports__, "flatMap", function() { return mergeMap["a" /* mergeMap */]; });
/* concated harmony reexport mergeMapTo */__webpack_require__.d(__webpack_exports__, "mergeMapTo", function() { return mergeMapTo; });
/* concated harmony reexport mergeScan */__webpack_require__.d(__webpack_exports__, "mergeScan", function() { return mergeScan; });
/* concated harmony reexport min */__webpack_require__.d(__webpack_exports__, "min", function() { return min_min; });
/* concated harmony reexport multicast */__webpack_require__.d(__webpack_exports__, "multicast", function() { return multicast; });
/* concated harmony reexport observeOn */__webpack_require__.d(__webpack_exports__, "observeOn", function() { return observeOn["b" /* observeOn */]; });
/* concated harmony reexport onErrorResumeNext */__webpack_require__.d(__webpack_exports__, "onErrorResumeNext", function() { return onErrorResumeNext; });
/* concated harmony reexport pairwise */__webpack_require__.d(__webpack_exports__, "pairwise", function() { return pairwise; });
/* concated harmony reexport partition */__webpack_require__.d(__webpack_exports__, "partition", function() { return partition; });
/* concated harmony reexport pluck */__webpack_require__.d(__webpack_exports__, "pluck", function() { return pluck; });
/* concated harmony reexport publish */__webpack_require__.d(__webpack_exports__, "publish", function() { return publish; });
/* concated harmony reexport publishBehavior */__webpack_require__.d(__webpack_exports__, "publishBehavior", function() { return publishBehavior; });
/* concated harmony reexport publishLast */__webpack_require__.d(__webpack_exports__, "publishLast", function() { return publishLast; });
/* concated harmony reexport publishReplay */__webpack_require__.d(__webpack_exports__, "publishReplay", function() { return publishReplay; });
/* concated harmony reexport race */__webpack_require__.d(__webpack_exports__, "race", function() { return race_race; });
/* concated harmony reexport reduce */__webpack_require__.d(__webpack_exports__, "reduce", function() { return reduce; });
/* concated harmony reexport repeat */__webpack_require__.d(__webpack_exports__, "repeat", function() { return repeat; });
/* concated harmony reexport repeatWhen */__webpack_require__.d(__webpack_exports__, "repeatWhen", function() { return repeatWhen; });
/* concated harmony reexport retry */__webpack_require__.d(__webpack_exports__, "retry", function() { return retry; });
/* concated harmony reexport retryWhen */__webpack_require__.d(__webpack_exports__, "retryWhen", function() { return retryWhen; });
/* concated harmony reexport refCount */__webpack_require__.d(__webpack_exports__, "refCount", function() { return operators_refCount["a" /* refCount */]; });
/* concated harmony reexport sample */__webpack_require__.d(__webpack_exports__, "sample", function() { return sample; });
/* concated harmony reexport sampleTime */__webpack_require__.d(__webpack_exports__, "sampleTime", function() { return sampleTime; });
/* concated harmony reexport scan */__webpack_require__.d(__webpack_exports__, "scan", function() { return scan; });
/* concated harmony reexport sequenceEqual */__webpack_require__.d(__webpack_exports__, "sequenceEqual", function() { return sequenceEqual; });
/* concated harmony reexport share */__webpack_require__.d(__webpack_exports__, "share", function() { return share; });
/* concated harmony reexport shareReplay */__webpack_require__.d(__webpack_exports__, "shareReplay", function() { return shareReplay; });
/* concated harmony reexport single */__webpack_require__.d(__webpack_exports__, "single", function() { return single; });
/* concated harmony reexport skip */__webpack_require__.d(__webpack_exports__, "skip", function() { return skip; });
/* concated harmony reexport skipLast */__webpack_require__.d(__webpack_exports__, "skipLast", function() { return skipLast; });
/* concated harmony reexport skipUntil */__webpack_require__.d(__webpack_exports__, "skipUntil", function() { return skipUntil; });
/* concated harmony reexport skipWhile */__webpack_require__.d(__webpack_exports__, "skipWhile", function() { return skipWhile; });
/* concated harmony reexport startWith */__webpack_require__.d(__webpack_exports__, "startWith", function() { return startWith; });
/* concated harmony reexport subscribeOn */__webpack_require__.d(__webpack_exports__, "subscribeOn", function() { return subscribeOn; });
/* concated harmony reexport switchAll */__webpack_require__.d(__webpack_exports__, "switchAll", function() { return switchAll; });
/* concated harmony reexport switchMap */__webpack_require__.d(__webpack_exports__, "switchMap", function() { return switchMap; });
/* concated harmony reexport switchMapTo */__webpack_require__.d(__webpack_exports__, "switchMapTo", function() { return switchMapTo; });
/* concated harmony reexport take */__webpack_require__.d(__webpack_exports__, "take", function() { return take; });
/* concated harmony reexport takeLast */__webpack_require__.d(__webpack_exports__, "takeLast", function() { return takeLast; });
/* concated harmony reexport takeUntil */__webpack_require__.d(__webpack_exports__, "takeUntil", function() { return takeUntil; });
/* concated harmony reexport takeWhile */__webpack_require__.d(__webpack_exports__, "takeWhile", function() { return takeWhile; });
/* concated harmony reexport tap */__webpack_require__.d(__webpack_exports__, "tap", function() { return tap; });
/* concated harmony reexport throttle */__webpack_require__.d(__webpack_exports__, "throttle", function() { return throttle; });
/* concated harmony reexport throttleTime */__webpack_require__.d(__webpack_exports__, "throttleTime", function() { return throttleTime; });
/* concated harmony reexport throwIfEmpty */__webpack_require__.d(__webpack_exports__, "throwIfEmpty", function() { return throwIfEmpty; });
/* concated harmony reexport timeInterval */__webpack_require__.d(__webpack_exports__, "timeInterval", function() { return timeInterval; });
/* concated harmony reexport timeout */__webpack_require__.d(__webpack_exports__, "timeout", function() { return timeout; });
/* concated harmony reexport timeoutWith */__webpack_require__.d(__webpack_exports__, "timeoutWith", function() { return timeoutWith; });
/* concated harmony reexport timestamp */__webpack_require__.d(__webpack_exports__, "timestamp", function() { return timestamp; });
/* concated harmony reexport toArray */__webpack_require__.d(__webpack_exports__, "toArray", function() { return toArray; });
/* concated harmony reexport window */__webpack_require__.d(__webpack_exports__, "window", function() { return window_window; });
/* concated harmony reexport windowCount */__webpack_require__.d(__webpack_exports__, "windowCount", function() { return windowCount; });
/* concated harmony reexport windowTime */__webpack_require__.d(__webpack_exports__, "windowTime", function() { return windowTime_windowTime; });
/* concated harmony reexport windowToggle */__webpack_require__.d(__webpack_exports__, "windowToggle", function() { return windowToggle; });
/* concated harmony reexport windowWhen */__webpack_require__.d(__webpack_exports__, "windowWhen", function() { return windowWhen; });
/* concated harmony reexport withLatestFrom */__webpack_require__.d(__webpack_exports__, "withLatestFrom", function() { return withLatestFrom; });
/* concated harmony reexport zip */__webpack_require__.d(__webpack_exports__, "zip", function() { return zip_zip; });
/* concated harmony reexport zipAll */__webpack_require__.d(__webpack_exports__, "zipAll", function() { return zipAll; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */








































































































//# sourceMappingURL=index.js.map


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Observable.js + 1 modules
var Observable = __webpack_require__(10);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/ConnectableObservable.js
var ConnectableObservable = __webpack_require__(152);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/groupBy.js
var groupBy = __webpack_require__(137);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/symbol/observable.js
var observable = __webpack_require__(55);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Subject.js
var Subject = __webpack_require__(22);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/BehaviorSubject.js
var BehaviorSubject = __webpack_require__(154);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/ReplaySubject.js
var ReplaySubject = __webpack_require__(110);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/AsyncSubject.js
var AsyncSubject = __webpack_require__(67);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/asap.js + 3 modules
var asap = __webpack_require__(116);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/async.js
var scheduler_async = __webpack_require__(25);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/queue.js + 2 modules
var queue = __webpack_require__(158);

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(0);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/AsyncAction.js + 1 modules
var AsyncAction = __webpack_require__(68);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/AnimationFrameAction.js
/** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */


var AnimationFrameAction_AnimationFrameAction = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        scheduler.actions.push(this);
        return scheduler.scheduled || (scheduler.scheduled = requestAnimationFrame(function () { return scheduler.flush(null); }));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        if (scheduler.actions.length === 0) {
            cancelAnimationFrame(id);
            scheduler.scheduled = undefined;
        }
        return undefined;
    };
    return AnimationFrameAction;
}(AsyncAction["a" /* AsyncAction */]));

//# sourceMappingURL=AnimationFrameAction.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/AsyncScheduler.js
var AsyncScheduler = __webpack_require__(65);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/AnimationFrameScheduler.js
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */


var AnimationFrameScheduler_AnimationFrameScheduler = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnimationFrameScheduler.prototype.flush = function (action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while (++index < count && (action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AnimationFrameScheduler;
}(AsyncScheduler["a" /* AsyncScheduler */]));

//# sourceMappingURL=AnimationFrameScheduler.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/animationFrame.js
/** PURE_IMPORTS_START _AnimationFrameAction,_AnimationFrameScheduler PURE_IMPORTS_END */


var animationFrame = /*@__PURE__*/ new AnimationFrameScheduler_AnimationFrameScheduler(AnimationFrameAction_AnimationFrameAction);
//# sourceMappingURL=animationFrame.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/VirtualTimeScheduler.js
/** PURE_IMPORTS_START tslib,_AsyncAction,_AsyncScheduler PURE_IMPORTS_END */



var VirtualTimeScheduler_VirtualTimeScheduler = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](VirtualTimeScheduler, _super);
    function VirtualTimeScheduler(SchedulerAction, maxFrames) {
        if (SchedulerAction === void 0) {
            SchedulerAction = VirtualTimeScheduler_VirtualAction;
        }
        if (maxFrames === void 0) {
            maxFrames = Number.POSITIVE_INFINITY;
        }
        var _this = _super.call(this, SchedulerAction, function () { return _this.frame; }) || this;
        _this.maxFrames = maxFrames;
        _this.frame = 0;
        _this.index = -1;
        return _this;
    }
    VirtualTimeScheduler.prototype.flush = function () {
        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
        var error, action;
        while ((action = actions[0]) && action.delay <= maxFrames) {
            actions.shift();
            this.frame = action.delay;
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        }
        if (error) {
            while (action = actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    VirtualTimeScheduler.frameTimeFactor = 10;
    return VirtualTimeScheduler;
}(AsyncScheduler["a" /* AsyncScheduler */]));

var VirtualTimeScheduler_VirtualAction = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](VirtualAction, _super);
    function VirtualAction(scheduler, work, index) {
        if (index === void 0) {
            index = scheduler.index += 1;
        }
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.index = index;
        _this.active = true;
        _this.index = scheduler.index = index;
        return _this;
    }
    VirtualAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (!this.id) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.active = false;
        var action = new VirtualAction(this.scheduler, this.work);
        this.add(action);
        return action.schedule(state, delay);
    };
    VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        this.delay = scheduler.frame + delay;
        var actions = scheduler.actions;
        actions.push(this);
        actions.sort(VirtualAction.sortActions);
        return true;
    };
    VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        return undefined;
    };
    VirtualAction.prototype._execute = function (state, delay) {
        if (this.active === true) {
            return _super.prototype._execute.call(this, state, delay);
        }
    };
    VirtualAction.sortActions = function (a, b) {
        if (a.delay === b.delay) {
            if (a.index === b.index) {
                return 0;
            }
            else if (a.index > b.index) {
                return 1;
            }
            else {
                return -1;
            }
        }
        else if (a.delay > b.delay) {
            return 1;
        }
        else {
            return -1;
        }
    };
    return VirtualAction;
}(AsyncAction["a" /* AsyncAction */]));

//# sourceMappingURL=VirtualTimeScheduler.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Scheduler.js
var Scheduler = __webpack_require__(130);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Subscription.js
var Subscription = __webpack_require__(20);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Subscriber.js
var Subscriber = __webpack_require__(5);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Notification.js
var Notification = __webpack_require__(46);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/pipe.js
var pipe = __webpack_require__(94);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/noop.js
var noop = __webpack_require__(48);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/identity.js
var identity = __webpack_require__(42);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/util/isObservable.js
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */

function isObservable(obj) {
    return !!obj && (obj instanceof Observable["a" /* Observable */] || (typeof obj.lift === 'function' && typeof obj.subscribe === 'function'));
}
//# sourceMappingURL=isObservable.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/ArgumentOutOfRangeError.js
var ArgumentOutOfRangeError = __webpack_require__(60);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/EmptyError.js
var EmptyError = __webpack_require__(64);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/ObjectUnsubscribedError.js
var ObjectUnsubscribedError = __webpack_require__(56);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/UnsubscriptionError.js
var UnsubscriptionError = __webpack_require__(96);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/TimeoutError.js
var TimeoutError = __webpack_require__(156);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/map.js
var map = __webpack_require__(26);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/canReportError.js
var canReportError = __webpack_require__(114);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isArray.js
var isArray = __webpack_require__(24);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isScheduler.js
var isScheduler = __webpack_require__(27);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/bindCallback.js
/** PURE_IMPORTS_START _Observable,_AsyncSubject,_operators_map,_util_canReportError,_util_isArray,_util_isScheduler PURE_IMPORTS_END */






function bindCallback(callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if (Object(isScheduler["a" /* isScheduler */])(resultSelector)) {
            scheduler = resultSelector;
        }
        else {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return bindCallback(callbackFunc, scheduler).apply(void 0, args).pipe(Object(map["a" /* map */])(function (args) { return Object(isArray["a" /* isArray */])(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
            };
        }
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var context = this;
        var subject;
        var params = {
            context: context,
            subject: subject,
            callbackFunc: callbackFunc,
            scheduler: scheduler,
        };
        return new Observable["a" /* Observable */](function (subscriber) {
            if (!scheduler) {
                if (!subject) {
                    subject = new AsyncSubject["a" /* AsyncSubject */]();
                    var handler = function () {
                        var innerArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            innerArgs[_i] = arguments[_i];
                        }
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    };
                    try {
                        callbackFunc.apply(context, args.concat([handler]));
                    }
                    catch (err) {
                        if (Object(canReportError["a" /* canReportError */])(subject)) {
                            subject.error(err);
                        }
                        else {
                            console.warn(err);
                        }
                    }
                }
                return subject.subscribe(subscriber);
            }
            else {
                var state = {
                    args: args, subscriber: subscriber, params: params,
                };
                return scheduler.schedule(dispatch, 0, state);
            }
        });
    };
}
function dispatch(state) {
    var _this = this;
    var self = this;
    var args = state.args, subscriber = state.subscriber, params = state.params;
    var callbackFunc = params.callbackFunc, context = params.context, scheduler = params.scheduler;
    var subject = params.subject;
    if (!subject) {
        subject = params.subject = new AsyncSubject["a" /* AsyncSubject */]();
        var handler = function () {
            var innerArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                innerArgs[_i] = arguments[_i];
            }
            var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
            _this.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
        };
        try {
            callbackFunc.apply(context, args.concat([handler]));
        }
        catch (err) {
            subject.error(err);
        }
    }
    this.add(subject.subscribe(subscriber));
}
function dispatchNext(state) {
    var value = state.value, subject = state.subject;
    subject.next(value);
    subject.complete();
}
function dispatchError(state) {
    var err = state.err, subject = state.subject;
    subject.error(err);
}
//# sourceMappingURL=bindCallback.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/bindNodeCallback.js
/** PURE_IMPORTS_START _Observable,_AsyncSubject,_operators_map,_util_canReportError,_util_isScheduler,_util_isArray PURE_IMPORTS_END */






function bindNodeCallback(callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if (Object(isScheduler["a" /* isScheduler */])(resultSelector)) {
            scheduler = resultSelector;
        }
        else {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return bindNodeCallback(callbackFunc, scheduler).apply(void 0, args).pipe(Object(map["a" /* map */])(function (args) { return Object(isArray["a" /* isArray */])(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
            };
        }
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var params = {
            subject: undefined,
            args: args,
            callbackFunc: callbackFunc,
            scheduler: scheduler,
            context: this,
        };
        return new Observable["a" /* Observable */](function (subscriber) {
            var context = params.context;
            var subject = params.subject;
            if (!scheduler) {
                if (!subject) {
                    subject = params.subject = new AsyncSubject["a" /* AsyncSubject */]();
                    var handler = function () {
                        var innerArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            innerArgs[_i] = arguments[_i];
                        }
                        var err = innerArgs.shift();
                        if (err) {
                            subject.error(err);
                            return;
                        }
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    };
                    try {
                        callbackFunc.apply(context, args.concat([handler]));
                    }
                    catch (err) {
                        if (Object(canReportError["a" /* canReportError */])(subject)) {
                            subject.error(err);
                        }
                        else {
                            console.warn(err);
                        }
                    }
                }
                return subject.subscribe(subscriber);
            }
            else {
                return scheduler.schedule(bindNodeCallback_dispatch, 0, { params: params, subscriber: subscriber, context: context });
            }
        });
    };
}
function bindNodeCallback_dispatch(state) {
    var _this = this;
    var params = state.params, subscriber = state.subscriber, context = state.context;
    var callbackFunc = params.callbackFunc, args = params.args, scheduler = params.scheduler;
    var subject = params.subject;
    if (!subject) {
        subject = params.subject = new AsyncSubject["a" /* AsyncSubject */]();
        var handler = function () {
            var innerArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                innerArgs[_i] = arguments[_i];
            }
            var err = innerArgs.shift();
            if (err) {
                _this.add(scheduler.schedule(bindNodeCallback_dispatchError, 0, { err: err, subject: subject }));
            }
            else {
                var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                _this.add(scheduler.schedule(bindNodeCallback_dispatchNext, 0, { value: value, subject: subject }));
            }
        };
        try {
            callbackFunc.apply(context, args.concat([handler]));
        }
        catch (err) {
            this.add(scheduler.schedule(bindNodeCallback_dispatchError, 0, { err: err, subject: subject }));
        }
    }
    this.add(subject.subscribe(subscriber));
}
function bindNodeCallback_dispatchNext(arg) {
    var value = arg.value, subject = arg.subject;
    subject.next(value);
    subject.complete();
}
function bindNodeCallback_dispatchError(arg) {
    var err = arg.err, subject = arg.subject;
    subject.error(err);
}
//# sourceMappingURL=bindNodeCallback.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/combineLatest.js
var combineLatest = __webpack_require__(106);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/concat.js
var concat = __webpack_require__(75);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/defer.js
var defer = __webpack_require__(111);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/empty.js
var empty = __webpack_require__(28);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isObject.js
var isObject = __webpack_require__(113);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/from.js
var from = __webpack_require__(30);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/forkJoin.js
/** PURE_IMPORTS_START _Observable,_util_isArray,_operators_map,_util_isObject,_from PURE_IMPORTS_END */





function forkJoin() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    if (sources.length === 1) {
        var first_1 = sources[0];
        if (Object(isArray["a" /* isArray */])(first_1)) {
            return forkJoinInternal(first_1, null);
        }
        if (Object(isObject["a" /* isObject */])(first_1) && Object.getPrototypeOf(first_1) === Object.prototype) {
            var keys = Object.keys(first_1);
            return forkJoinInternal(keys.map(function (key) { return first_1[key]; }), keys);
        }
    }
    if (typeof sources[sources.length - 1] === 'function') {
        var resultSelector_1 = sources.pop();
        sources = (sources.length === 1 && Object(isArray["a" /* isArray */])(sources[0])) ? sources[0] : sources;
        return forkJoinInternal(sources, null).pipe(Object(map["a" /* map */])(function (args) { return resultSelector_1.apply(void 0, args); }));
    }
    return forkJoinInternal(sources, null);
}
function forkJoinInternal(sources, keys) {
    return new Observable["a" /* Observable */](function (subscriber) {
        var len = sources.length;
        if (len === 0) {
            subscriber.complete();
            return;
        }
        var values = new Array(len);
        var completed = 0;
        var emitted = 0;
        var _loop_1 = function (i) {
            var source = Object(from["a" /* from */])(sources[i]);
            var hasValue = false;
            subscriber.add(source.subscribe({
                next: function (value) {
                    if (!hasValue) {
                        hasValue = true;
                        emitted++;
                    }
                    values[i] = value;
                },
                error: function (err) { return subscriber.error(err); },
                complete: function () {
                    completed++;
                    if (completed === len || !hasValue) {
                        if (emitted === len) {
                            subscriber.next(keys ?
                                keys.reduce(function (result, key, i) { return (result[key] = values[i], result); }, {}) :
                                values);
                        }
                        subscriber.complete();
                    }
                }
            }));
        };
        for (var i = 0; i < len; i++) {
            _loop_1(i);
        }
    });
}
//# sourceMappingURL=forkJoin.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isFunction.js
var isFunction = __webpack_require__(61);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/fromEvent.js
/** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */




var fromEvent_toString = /*@__PURE__*/ (function () { return Object.prototype.toString; })();
function fromEvent(target, eventName, options, resultSelector) {
    if (Object(isFunction["a" /* isFunction */])(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) {
        return fromEvent(target, eventName, options).pipe(Object(map["a" /* map */])(function (args) { return Object(isArray["a" /* isArray */])(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
    }
    return new Observable["a" /* Observable */](function (subscriber) {
        function handler(e) {
            if (arguments.length > 1) {
                subscriber.next(Array.prototype.slice.call(arguments));
            }
            else {
                subscriber.next(e);
            }
        }
        setupSubscription(target, eventName, handler, subscriber, options);
    });
}
function setupSubscription(sourceObj, eventName, handler, subscriber, options) {
    var unsubscribe;
    if (isEventTarget(sourceObj)) {
        var source_1 = sourceObj;
        sourceObj.addEventListener(eventName, handler, options);
        unsubscribe = function () { return source_1.removeEventListener(eventName, handler, options); };
    }
    else if (isJQueryStyleEventEmitter(sourceObj)) {
        var source_2 = sourceObj;
        sourceObj.on(eventName, handler);
        unsubscribe = function () { return source_2.off(eventName, handler); };
    }
    else if (isNodeStyleEventEmitter(sourceObj)) {
        var source_3 = sourceObj;
        sourceObj.addListener(eventName, handler);
        unsubscribe = function () { return source_3.removeListener(eventName, handler); };
    }
    else if (sourceObj && sourceObj.length) {
        for (var i = 0, len = sourceObj.length; i < len; i++) {
            setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
        }
    }
    else {
        throw new TypeError('Invalid event target');
    }
    subscriber.add(unsubscribe);
}
function isNodeStyleEventEmitter(sourceObj) {
    return sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
}
function isJQueryStyleEventEmitter(sourceObj) {
    return sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
}
function isEventTarget(sourceObj) {
    return sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
}
//# sourceMappingURL=fromEvent.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/fromEventPattern.js
/** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */




function fromEventPattern(addHandler, removeHandler, resultSelector) {
    if (resultSelector) {
        return fromEventPattern(addHandler, removeHandler).pipe(Object(map["a" /* map */])(function (args) { return Object(isArray["a" /* isArray */])(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
    }
    return new Observable["a" /* Observable */](function (subscriber) {
        var handler = function () {
            var e = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                e[_i] = arguments[_i];
            }
            return subscriber.next(e.length === 1 ? e[0] : e);
        };
        var retValue;
        try {
            retValue = addHandler(handler);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        if (!Object(isFunction["a" /* isFunction */])(removeHandler)) {
            return undefined;
        }
        return function () { return removeHandler(handler, retValue); };
    });
}
//# sourceMappingURL=fromEventPattern.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/generate.js
/** PURE_IMPORTS_START _Observable,_util_identity,_util_isScheduler PURE_IMPORTS_END */



function generate(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
    var resultSelector;
    var initialState;
    if (arguments.length == 1) {
        var options = initialStateOrOptions;
        initialState = options.initialState;
        condition = options.condition;
        iterate = options.iterate;
        resultSelector = options.resultSelector || identity["a" /* identity */];
        scheduler = options.scheduler;
    }
    else if (resultSelectorOrObservable === undefined || Object(isScheduler["a" /* isScheduler */])(resultSelectorOrObservable)) {
        initialState = initialStateOrOptions;
        resultSelector = identity["a" /* identity */];
        scheduler = resultSelectorOrObservable;
    }
    else {
        initialState = initialStateOrOptions;
        resultSelector = resultSelectorOrObservable;
    }
    return new Observable["a" /* Observable */](function (subscriber) {
        var state = initialState;
        if (scheduler) {
            return scheduler.schedule(generate_dispatch, 0, {
                subscriber: subscriber,
                iterate: iterate,
                condition: condition,
                resultSelector: resultSelector,
                state: state
            });
        }
        do {
            if (condition) {
                var conditionResult = void 0;
                try {
                    conditionResult = condition(state);
                }
                catch (err) {
                    subscriber.error(err);
                    return undefined;
                }
                if (!conditionResult) {
                    subscriber.complete();
                    break;
                }
            }
            var value = void 0;
            try {
                value = resultSelector(state);
            }
            catch (err) {
                subscriber.error(err);
                return undefined;
            }
            subscriber.next(value);
            if (subscriber.closed) {
                break;
            }
            try {
                state = iterate(state);
            }
            catch (err) {
                subscriber.error(err);
                return undefined;
            }
        } while (true);
        return undefined;
    });
}
function generate_dispatch(state) {
    var subscriber = state.subscriber, condition = state.condition;
    if (subscriber.closed) {
        return undefined;
    }
    if (state.needIterate) {
        try {
            state.state = state.iterate(state.state);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
    }
    else {
        state.needIterate = true;
    }
    if (condition) {
        var conditionResult = void 0;
        try {
            conditionResult = condition(state.state);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        if (!conditionResult) {
            subscriber.complete();
            return undefined;
        }
        if (subscriber.closed) {
            return undefined;
        }
    }
    var value;
    try {
        value = state.resultSelector(state.state);
    }
    catch (err) {
        subscriber.error(err);
        return undefined;
    }
    if (subscriber.closed) {
        return undefined;
    }
    subscriber.next(value);
    if (subscriber.closed) {
        return undefined;
    }
    return this.schedule(state);
}
//# sourceMappingURL=generate.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/iif.js
/** PURE_IMPORTS_START _defer,_empty PURE_IMPORTS_END */


function iif(condition, trueResult, falseResult) {
    if (trueResult === void 0) {
        trueResult = empty["a" /* EMPTY */];
    }
    if (falseResult === void 0) {
        falseResult = empty["a" /* EMPTY */];
    }
    return Object(defer["a" /* defer */])(function () { return condition() ? trueResult : falseResult; });
}
//# sourceMappingURL=iif.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isNumeric.js
var isNumeric = __webpack_require__(69);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/interval.js
/** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric PURE_IMPORTS_END */



function interval(period, scheduler) {
    if (period === void 0) {
        period = 0;
    }
    if (scheduler === void 0) {
        scheduler = scheduler_async["a" /* async */];
    }
    if (!Object(isNumeric["a" /* isNumeric */])(period) || period < 0) {
        period = 0;
    }
    if (!scheduler || typeof scheduler.schedule !== 'function') {
        scheduler = scheduler_async["a" /* async */];
    }
    return new Observable["a" /* Observable */](function (subscriber) {
        subscriber.add(scheduler.schedule(interval_dispatch, period, { subscriber: subscriber, counter: 0, period: period }));
        return subscriber;
    });
}
function interval_dispatch(state) {
    var subscriber = state.subscriber, counter = state.counter, period = state.period;
    subscriber.next(counter);
    this.schedule({ subscriber: subscriber, counter: counter + 1, period: period }, period);
}
//# sourceMappingURL=interval.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/merge.js
var merge = __webpack_require__(151);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/never.js
/** PURE_IMPORTS_START _Observable,_util_noop PURE_IMPORTS_END */


var NEVER = /*@__PURE__*/ new Observable["a" /* Observable */](noop["a" /* noop */]);
function never() {
    return NEVER;
}
//# sourceMappingURL=never.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/of.js
var of = __webpack_require__(86);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/onErrorResumeNext.js
/** PURE_IMPORTS_START _Observable,_from,_util_isArray,_empty PURE_IMPORTS_END */




function onErrorResumeNext() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    if (sources.length === 0) {
        return empty["a" /* EMPTY */];
    }
    var first = sources[0], remainder = sources.slice(1);
    if (sources.length === 1 && Object(isArray["a" /* isArray */])(first)) {
        return onErrorResumeNext.apply(void 0, first);
    }
    return new Observable["a" /* Observable */](function (subscriber) {
        var subNext = function () { return subscriber.add(onErrorResumeNext.apply(void 0, remainder).subscribe(subscriber)); };
        return Object(from["a" /* from */])(first).subscribe({
            next: function (value) { subscriber.next(value); },
            error: subNext,
            complete: subNext,
        });
    });
}
//# sourceMappingURL=onErrorResumeNext.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/pairs.js
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */


function pairs(obj, scheduler) {
    if (!scheduler) {
        return new Observable["a" /* Observable */](function (subscriber) {
            var keys = Object.keys(obj);
            for (var i = 0; i < keys.length && !subscriber.closed; i++) {
                var key = keys[i];
                if (obj.hasOwnProperty(key)) {
                    subscriber.next([key, obj[key]]);
                }
            }
            subscriber.complete();
        });
    }
    else {
        return new Observable["a" /* Observable */](function (subscriber) {
            var keys = Object.keys(obj);
            var subscription = new Subscription["a" /* Subscription */]();
            subscription.add(scheduler.schedule(pairs_dispatch, 0, { keys: keys, index: 0, subscriber: subscriber, subscription: subscription, obj: obj }));
            return subscription;
        });
    }
}
function pairs_dispatch(state) {
    var keys = state.keys, index = state.index, subscriber = state.subscriber, subscription = state.subscription, obj = state.obj;
    if (!subscriber.closed) {
        if (index < keys.length) {
            var key = keys[index];
            subscriber.next([key, obj[key]]);
            subscription.add(this.schedule({ keys: keys, index: index + 1, subscriber: subscriber, subscription: subscription, obj: obj }));
        }
        else {
            subscriber.complete();
        }
    }
}
//# sourceMappingURL=pairs.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/not.js
var not = __webpack_require__(163);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/subscribeTo.js + 3 modules
var subscribeTo = __webpack_require__(97);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/filter.js
var filter = __webpack_require__(45);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/partition.js
/** PURE_IMPORTS_START _util_not,_util_subscribeTo,_operators_filter,_Observable PURE_IMPORTS_END */




function partition(source, predicate, thisArg) {
    return [
        Object(filter["a" /* filter */])(predicate, thisArg)(new Observable["a" /* Observable */](Object(subscribeTo["a" /* subscribeTo */])(source))),
        Object(filter["a" /* filter */])(Object(not["a" /* not */])(predicate, thisArg))(new Observable["a" /* Observable */](Object(subscribeTo["a" /* subscribeTo */])(source)))
    ];
}
//# sourceMappingURL=partition.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/race.js
var race = __webpack_require__(155);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/range.js
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */

function range(start, count, scheduler) {
    if (start === void 0) {
        start = 0;
    }
    return new Observable["a" /* Observable */](function (subscriber) {
        if (count === undefined) {
            count = start;
            start = 0;
        }
        var index = 0;
        var current = start;
        if (scheduler) {
            return scheduler.schedule(range_dispatch, 0, {
                index: index, count: count, start: start, subscriber: subscriber
            });
        }
        else {
            do {
                if (index++ >= count) {
                    subscriber.complete();
                    break;
                }
                subscriber.next(current++);
                if (subscriber.closed) {
                    break;
                }
            } while (true);
        }
        return undefined;
    });
}
function range_dispatch(state) {
    var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
    if (index >= count) {
        subscriber.complete();
        return;
    }
    subscriber.next(start);
    if (subscriber.closed) {
        return;
    }
    state.index = index + 1;
    state.start = start + 1;
    this.schedule(state);
}
//# sourceMappingURL=range.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/throwError.js
var throwError = __webpack_require__(108);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/timer.js
var timer = __webpack_require__(149);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/using.js
/** PURE_IMPORTS_START _Observable,_from,_empty PURE_IMPORTS_END */



function using(resourceFactory, observableFactory) {
    return new Observable["a" /* Observable */](function (subscriber) {
        var resource;
        try {
            resource = resourceFactory();
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var result;
        try {
            result = observableFactory(resource);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var source = result ? Object(from["a" /* from */])(result) : empty["a" /* EMPTY */];
        var subscription = source.subscribe(subscriber);
        return function () {
            subscription.unsubscribe();
            if (resource) {
                resource.unsubscribe();
            }
        };
    });
}
//# sourceMappingURL=using.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/zip.js
var zip = __webpack_require__(112);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/scheduled/scheduled.js + 5 modules
var scheduled = __webpack_require__(157);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/config.js
var config = __webpack_require__(41);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/index.js
/* concated harmony reexport Observable */__webpack_require__.d(__webpack_exports__, "Observable", function() { return Observable["a" /* Observable */]; });
/* concated harmony reexport ConnectableObservable */__webpack_require__.d(__webpack_exports__, "ConnectableObservable", function() { return ConnectableObservable["a" /* ConnectableObservable */]; });
/* concated harmony reexport GroupedObservable */__webpack_require__.d(__webpack_exports__, "GroupedObservable", function() { return groupBy["a" /* GroupedObservable */]; });
/* concated harmony reexport observable */__webpack_require__.d(__webpack_exports__, "observable", function() { return observable["a" /* observable */]; });
/* concated harmony reexport Subject */__webpack_require__.d(__webpack_exports__, "Subject", function() { return Subject["a" /* Subject */]; });
/* concated harmony reexport BehaviorSubject */__webpack_require__.d(__webpack_exports__, "BehaviorSubject", function() { return BehaviorSubject["a" /* BehaviorSubject */]; });
/* concated harmony reexport ReplaySubject */__webpack_require__.d(__webpack_exports__, "ReplaySubject", function() { return ReplaySubject["a" /* ReplaySubject */]; });
/* concated harmony reexport AsyncSubject */__webpack_require__.d(__webpack_exports__, "AsyncSubject", function() { return AsyncSubject["a" /* AsyncSubject */]; });
/* concated harmony reexport asapScheduler */__webpack_require__.d(__webpack_exports__, "asapScheduler", function() { return asap["a" /* asap */]; });
/* concated harmony reexport asyncScheduler */__webpack_require__.d(__webpack_exports__, "asyncScheduler", function() { return scheduler_async["a" /* async */]; });
/* concated harmony reexport queueScheduler */__webpack_require__.d(__webpack_exports__, "queueScheduler", function() { return queue["a" /* queue */]; });
/* concated harmony reexport animationFrameScheduler */__webpack_require__.d(__webpack_exports__, "animationFrameScheduler", function() { return animationFrame; });
/* concated harmony reexport VirtualTimeScheduler */__webpack_require__.d(__webpack_exports__, "VirtualTimeScheduler", function() { return VirtualTimeScheduler_VirtualTimeScheduler; });
/* concated harmony reexport VirtualAction */__webpack_require__.d(__webpack_exports__, "VirtualAction", function() { return VirtualTimeScheduler_VirtualAction; });
/* concated harmony reexport Scheduler */__webpack_require__.d(__webpack_exports__, "Scheduler", function() { return Scheduler["a" /* Scheduler */]; });
/* concated harmony reexport Subscription */__webpack_require__.d(__webpack_exports__, "Subscription", function() { return Subscription["a" /* Subscription */]; });
/* concated harmony reexport Subscriber */__webpack_require__.d(__webpack_exports__, "Subscriber", function() { return Subscriber["a" /* Subscriber */]; });
/* concated harmony reexport Notification */__webpack_require__.d(__webpack_exports__, "Notification", function() { return Notification["a" /* Notification */]; });
/* concated harmony reexport NotificationKind */__webpack_require__.d(__webpack_exports__, "NotificationKind", function() { return Notification["b" /* NotificationKind */]; });
/* concated harmony reexport pipe */__webpack_require__.d(__webpack_exports__, "pipe", function() { return pipe["a" /* pipe */]; });
/* concated harmony reexport noop */__webpack_require__.d(__webpack_exports__, "noop", function() { return noop["a" /* noop */]; });
/* concated harmony reexport identity */__webpack_require__.d(__webpack_exports__, "identity", function() { return identity["a" /* identity */]; });
/* concated harmony reexport isObservable */__webpack_require__.d(__webpack_exports__, "isObservable", function() { return isObservable; });
/* concated harmony reexport ArgumentOutOfRangeError */__webpack_require__.d(__webpack_exports__, "ArgumentOutOfRangeError", function() { return ArgumentOutOfRangeError["a" /* ArgumentOutOfRangeError */]; });
/* concated harmony reexport EmptyError */__webpack_require__.d(__webpack_exports__, "EmptyError", function() { return EmptyError["a" /* EmptyError */]; });
/* concated harmony reexport ObjectUnsubscribedError */__webpack_require__.d(__webpack_exports__, "ObjectUnsubscribedError", function() { return ObjectUnsubscribedError["a" /* ObjectUnsubscribedError */]; });
/* concated harmony reexport UnsubscriptionError */__webpack_require__.d(__webpack_exports__, "UnsubscriptionError", function() { return UnsubscriptionError["a" /* UnsubscriptionError */]; });
/* concated harmony reexport TimeoutError */__webpack_require__.d(__webpack_exports__, "TimeoutError", function() { return TimeoutError["a" /* TimeoutError */]; });
/* concated harmony reexport bindCallback */__webpack_require__.d(__webpack_exports__, "bindCallback", function() { return bindCallback; });
/* concated harmony reexport bindNodeCallback */__webpack_require__.d(__webpack_exports__, "bindNodeCallback", function() { return bindNodeCallback; });
/* concated harmony reexport combineLatest */__webpack_require__.d(__webpack_exports__, "combineLatest", function() { return combineLatest["b" /* combineLatest */]; });
/* concated harmony reexport concat */__webpack_require__.d(__webpack_exports__, "concat", function() { return concat["a" /* concat */]; });
/* concated harmony reexport defer */__webpack_require__.d(__webpack_exports__, "defer", function() { return defer["a" /* defer */]; });
/* concated harmony reexport empty */__webpack_require__.d(__webpack_exports__, "empty", function() { return empty["b" /* empty */]; });
/* concated harmony reexport forkJoin */__webpack_require__.d(__webpack_exports__, "forkJoin", function() { return forkJoin; });
/* concated harmony reexport from */__webpack_require__.d(__webpack_exports__, "from", function() { return from["a" /* from */]; });
/* concated harmony reexport fromEvent */__webpack_require__.d(__webpack_exports__, "fromEvent", function() { return fromEvent; });
/* concated harmony reexport fromEventPattern */__webpack_require__.d(__webpack_exports__, "fromEventPattern", function() { return fromEventPattern; });
/* concated harmony reexport generate */__webpack_require__.d(__webpack_exports__, "generate", function() { return generate; });
/* concated harmony reexport iif */__webpack_require__.d(__webpack_exports__, "iif", function() { return iif; });
/* concated harmony reexport interval */__webpack_require__.d(__webpack_exports__, "interval", function() { return interval; });
/* concated harmony reexport merge */__webpack_require__.d(__webpack_exports__, "merge", function() { return merge["a" /* merge */]; });
/* concated harmony reexport never */__webpack_require__.d(__webpack_exports__, "never", function() { return never; });
/* concated harmony reexport of */__webpack_require__.d(__webpack_exports__, "of", function() { return of["a" /* of */]; });
/* concated harmony reexport onErrorResumeNext */__webpack_require__.d(__webpack_exports__, "onErrorResumeNext", function() { return onErrorResumeNext; });
/* concated harmony reexport pairs */__webpack_require__.d(__webpack_exports__, "pairs", function() { return pairs; });
/* concated harmony reexport partition */__webpack_require__.d(__webpack_exports__, "partition", function() { return partition; });
/* concated harmony reexport race */__webpack_require__.d(__webpack_exports__, "race", function() { return race["a" /* race */]; });
/* concated harmony reexport range */__webpack_require__.d(__webpack_exports__, "range", function() { return range; });
/* concated harmony reexport throwError */__webpack_require__.d(__webpack_exports__, "throwError", function() { return throwError["a" /* throwError */]; });
/* concated harmony reexport timer */__webpack_require__.d(__webpack_exports__, "timer", function() { return timer["a" /* timer */]; });
/* concated harmony reexport using */__webpack_require__.d(__webpack_exports__, "using", function() { return using; });
/* concated harmony reexport zip */__webpack_require__.d(__webpack_exports__, "zip", function() { return zip["b" /* zip */]; });
/* concated harmony reexport scheduled */__webpack_require__.d(__webpack_exports__, "scheduled", function() { return scheduled["a" /* scheduled */]; });
/* concated harmony reexport EMPTY */__webpack_require__.d(__webpack_exports__, "EMPTY", function() { return empty["a" /* EMPTY */]; });
/* concated harmony reexport NEVER */__webpack_require__.d(__webpack_exports__, "NEVER", function() { return NEVER; });
/* concated harmony reexport config */__webpack_require__.d(__webpack_exports__, "config", function() { return config["a" /* config */]; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */























































//# sourceMappingURL=index.js.map


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmptyError; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var EmptyErrorImpl = /*@__PURE__*/ (function () {
    function EmptyErrorImpl() {
        Error.call(this);
        this.message = 'no elements in sequence';
        this.name = 'EmptyError';
        return this;
    }
    EmptyErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return EmptyErrorImpl;
})();
var EmptyError = EmptyErrorImpl;
//# sourceMappingURL=EmptyError.js.map


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsyncScheduler; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var _Scheduler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(130);
/** PURE_IMPORTS_START tslib,_Scheduler PURE_IMPORTS_END */


var AsyncScheduler = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"](AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) {
            now = _Scheduler__WEBPACK_IMPORTED_MODULE_1__[/* Scheduler */ "a"].now;
        }
        var _this = _super.call(this, SchedulerAction, function () {
            if (AsyncScheduler.delegate && AsyncScheduler.delegate !== _this) {
                return AsyncScheduler.delegate.now();
            }
            else {
                return now();
            }
        }) || this;
        _this.actions = [];
        _this.active = false;
        _this.scheduled = undefined;
        return _this;
    }
    AsyncScheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) {
            delay = 0;
        }
        if (AsyncScheduler.delegate && AsyncScheduler.delegate !== this) {
            return AsyncScheduler.delegate.schedule(work, delay, state);
        }
        else {
            return _super.prototype.schedule.call(this, work, delay, state);
        }
    };
    AsyncScheduler.prototype.flush = function (action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (action = actions.shift());
        this.active = false;
        if (error) {
            while (action = actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsyncScheduler;
}(_Scheduler__WEBPACK_IMPORTED_MODULE_1__[/* Scheduler */ "a"]));

//# sourceMappingURL=AsyncScheduler.js.map


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fromArray; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10);
/* harmony import */ var _util_subscribeToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(160);
/* harmony import */ var _scheduled_scheduleArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(115);
/** PURE_IMPORTS_START _Observable,_util_subscribeToArray,_scheduled_scheduleArray PURE_IMPORTS_END */



function fromArray(input, scheduler) {
    if (!scheduler) {
        return new _Observable__WEBPACK_IMPORTED_MODULE_0__[/* Observable */ "a"](Object(_util_subscribeToArray__WEBPACK_IMPORTED_MODULE_1__[/* subscribeToArray */ "a"])(input));
    }
    else {
        return Object(_scheduled_scheduleArray__WEBPACK_IMPORTED_MODULE_2__[/* scheduleArray */ "a"])(input, scheduler);
    }
}
//# sourceMappingURL=fromArray.js.map


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsyncSubject; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22);
/* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20);
/** PURE_IMPORTS_START tslib,_Subject,_Subscription PURE_IMPORTS_END */



var AsyncSubject = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"](AsyncSubject, _super);
    function AsyncSubject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.value = null;
        _this.hasNext = false;
        _this.hasCompleted = false;
        return _this;
    }
    AsyncSubject.prototype._subscribe = function (subscriber) {
        if (this.hasError) {
            subscriber.error(this.thrownError);
            return _Subscription__WEBPACK_IMPORTED_MODULE_2__[/* Subscription */ "a"].EMPTY;
        }
        else if (this.hasCompleted && this.hasNext) {
            subscriber.next(this.value);
            subscriber.complete();
            return _Subscription__WEBPACK_IMPORTED_MODULE_2__[/* Subscription */ "a"].EMPTY;
        }
        return _super.prototype._subscribe.call(this, subscriber);
    };
    AsyncSubject.prototype.next = function (value) {
        if (!this.hasCompleted) {
            this.value = value;
            this.hasNext = true;
        }
    };
    AsyncSubject.prototype.error = function (error) {
        if (!this.hasCompleted) {
            _super.prototype.error.call(this, error);
        }
    };
    AsyncSubject.prototype.complete = function () {
        this.hasCompleted = true;
        if (this.hasNext) {
            _super.prototype.next.call(this, this.value);
        }
        _super.prototype.complete.call(this);
    };
    return AsyncSubject;
}(_Subject__WEBPACK_IMPORTED_MODULE_1__[/* Subject */ "a"]));

//# sourceMappingURL=AsyncSubject.js.map


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(0);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Subscription.js
var Subscription = __webpack_require__(20);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/Action.js
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */


var Action_Action = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        return this;
    };
    return Action;
}(Subscription["a" /* Subscription */]));

//# sourceMappingURL=Action.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/AsyncAction.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsyncAction_AsyncAction; });
/** PURE_IMPORTS_START tslib,_Action PURE_IMPORTS_END */


var AsyncAction_AsyncAction = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (this.closed) {
            return this;
        }
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, delay);
        }
        this.pending = true;
        this.delay = delay;
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        return setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay !== null && this.delay === delay && this.pending === false) {
            return id;
        }
        clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function (state, delay) {
        if (this.closed) {
            return new Error('executing a cancelled action');
        }
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) {
            return error;
        }
        else if (this.pending === false && this.id != null) {
            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
        }
    };
    AsyncAction.prototype._execute = function (state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        }
        catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype._unsubscribe = function () {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) {
            actions.splice(index, 1);
        }
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, null);
        }
        this.delay = null;
    };
    return AsyncAction;
}(Action_Action));

//# sourceMappingURL=AsyncAction.js.map


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isNumeric; });
/* harmony import */ var _isArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24);
/** PURE_IMPORTS_START _isArray PURE_IMPORTS_END */

function isNumeric(val) {
    return !Object(_isArray__WEBPACK_IMPORTED_MODULE_0__[/* isArray */ "a"])(val) && (val - parseFloat(val) + 1) >= 0;
}
//# sourceMappingURL=isNumeric.js.map


/***/ }),
/* 70 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(335);

var iterableToArray = __webpack_require__(336);

var nonIterableSpread = __webpack_require__(337);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  create: function create() {
    var date = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (character) {
      var random = (date + Math.random() * 16) % 16 | 0;
      date = Math.floor(date / 16);
      return (character === 'x' ? random : random & 0x7 | 0x8).toString(16);
    });
    return uuid;
  }
};
exports.default = _default;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(CONFIG) {

var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.directMediaEnabled = directMediaEnabled;
exports.getEndpointInfo = getEndpointInfo;
exports.relayOnlyMode = relayOnlyMode;
exports.isGalaxyCallConnected = isGalaxyCallConnected;
exports.isGalaxyCallDisconnected = isGalaxyCallDisconnected;
exports.getSdpUpdateReasonResponse = getSdpUpdateReasonResponse;
exports.isGalaxyCallOutgoing = isGalaxyCallOutgoing;
exports.commandForCall = commandForCall;
exports.isCurrentCallValid = isCurrentCallValid;
exports.modifyGalaxyCallSdp = modifyGalaxyCallSdp;
exports.isIceStateDisconnected = isIceStateDisconnected;
exports.isIceStateFailed = isIceStateFailed;
exports.isIceStateConnected = isIceStateConnected;
exports.isIceStateCompleted = isIceStateCompleted;
exports.shouldRetryIce = shouldRetryIce;
exports.iceTypeRelayTest = iceTypeRelayTest;
exports.isPresentationStateUpdating = isPresentationStateUpdating;
exports.isReceivingGalaxyPresentation = isReceivingGalaxyPresentation;
exports.generateOfferPriority = generateOfferPriority;
exports.shouldIgnoreOffer = shouldIgnoreOffer;
exports.getGalaxyApiVersion = getGalaxyApiVersion;
exports.isGalaxyV3Enabled = isGalaxyV3Enabled;
exports.isAutoResolutionChangeEnabled = isAutoResolutionChangeEnabled;

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _detectBrowser = __webpack_require__(373);

var c = _interopRequireWildcard(__webpack_require__(3));

var _galaxySdp = _interopRequireDefault(__webpack_require__(374));

var _account = __webpack_require__(91);

var _feature = __webpack_require__(74);

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

function directMediaEnabled(state) {
  return (0, _account.getAccountFeature)(state)(c.ACCOUNT_FEATURE_DIRECT_MEDIA);
}

function getEndpointInfo(state) {
  var overrideEndpointInfo = window.localStorage && window.localStorage.getItem('endpointInfo') || '';
  if (overrideEndpointInfo) return overrideEndpointInfo;
  var clientInfo = (0, _safeAccess.default)(state, 'nucleus.userProfile.clientInfo');
  var clientType = (0, _safeAccess.default)(clientInfo, 'clientType') || 'Webclient';
  var clientVersion = (0, _safeAccess.default)(clientInfo, 'clientVersion') || '1.0.0';
  var nucleusVersion = (0, _safeAccess.default)(clientInfo, 'nucleusVersion');
  var nucleusString = nucleusVersion ? " CNUC/".concat(nucleusVersion) : ''; // add browser info

  var browserString = '';

  try {
    var browser = (0, _detectBrowser.detect)();

    if (browser) {
      browserString = " ".concat(browser.name, "/").concat(browser.version, "/").concat(browser.os);
    }
  } catch (_unused) {
    _jsLogger.default.info('error detecting browser info for endpointInfo string');
  }

  return "".concat(clientType, "/").concat(clientVersion).concat(nucleusString).concat(browserString);
}
/**
 * relayOnlyMode
 * If galaxy is enabled and directMedia disabled then we will force all calls to
 * through relay. P2P will never be direct
 * @param {object} state - complete store state OR substate from: nucleus.account.features
 */


function relayOnlyMode(state) {
  return (0, _safeAccess.default)(state, 'nucleus.galaxy.options.supportRelayMode') && !directMediaEnabled(state);
}

function isGalaxyCallConnected(state) {
  var galaxyCallState = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.state');
  return galaxyCallState === c.GALAXY_CALL_STATE_CONNECTED;
}

function isGalaxyCallDisconnected(state, payload) {
  var galaxyCallState = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.state');
  var galaxyCallId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.callId');
  var callId = (0, _safeAccess.default)(payload, 'callId');
  return galaxyCallState === c.GALAXY_CALL_STATE_DISCONNECTED && galaxyCallId === callId;
}

function getSdpUpdateReasonResponse(reason) {
  if (reason === c.GALAXY_REASON_PRESENTATION_SEND) return c.GALAXY_REASON_PRESENTATION_RECEIVE;
  return reason;
}

function isGalaxyCallOutgoing(state) {
  var galaxyCallState = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.state'); // Note that the ringing state is also for incoming calls too.
  // May need to change this state to be directional in the reducer.

  var outgoingState = [c.GALAXY_CALL_STATE_BEGIN, c.GALAXY_CALL_STATE_CALLING, c.GALAXY_CALL_STATE_TRYING, c.GALAXY_CALL_STATE_RINGING];
  return outgoingState.indexOf(galaxyCallState) > -1;
}

function commandForCall(getState, commandType) {
  var state = getState();
  var sourceId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.sourceId');
  var callId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.callId');
  return {
    command: commandType,
    sourceId: sourceId,
    callId: callId
  };
}

function isCurrentCallValid() {
  var callState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : c.GALAXY_CALL_STATE_DISCONNECTED;
  var callId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var sourceId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return callState === c.GALAXY_CALL_STATE_CONNECTED && !!callId && !!sourceId;
}
/**
 * modifyGalaxyCallSdp
 * Modify the sdp for a Galaxy call.
 * @param {String} sdp - sdp string to be manipulated as an object
 * @param {boolean} isRemoteSdp - whether this sdp is from the remote or generated locally
 * @param {object} options - The options for setting the SDP. maxBandwidth, preferH264,
 * whether there is a presentation underway, and whether h264 high profile is enabled.
 */


function modifyGalaxyCallSdp(sdp, isRemoteSdp, options) {
  if (CONFIG.calls.useGalaxySignalingMiddleware) return (0, _safeAccess.default)(sdp, 'sdp') || sdp;
  var sdpObj;

  try {
    sdpObj = new _galaxySdp.default(sdp.sdp, isRemoteSdp);
  } catch (error) {
    _jsLogger.default.warn('Error modifying sdp for a Galaxy call.', error);

    return;
  }

  sdpObj.modifyBandwidth(options);
  var preferredProfile = (0, _safeAccess.default)(options, 'preferredProfile');

  if ((0, _safeAccess.default)(options, 'preferH264') || preferredProfile) {
    sdpObj.preferH264();
  }

  if (preferredProfile) {
    sdpObj.preferProfile(preferredProfile);
  }

  if (!isRemoteSdp && (0, _safeAccess.default)(options, 'enable1080Rx')) {
    sdpObj.upgradeProfile();
  }

  return sdpObj.toString();
}

function isIceStateDisconnected(iceState) {
  return iceState === c.GALAXY_ICE_STATE_DISCONNECTED;
}

function isIceStateFailed(iceState) {
  return iceState === c.GALAXY_ICE_STATE_FAILED;
}

function isIceStateConnected(iceState) {
  return iceState === c.GALAXY_ICE_STATE_CONNECTED;
}

function isIceStateCompleted(iceState) {
  return iceState === c.GALAXY_ICE_STATE_COMPLETED;
}

function shouldRetryIce(oldState, currState) {
  // This function will return true under either one of these conditions and
  // false otherwise
  // 1. The current state is disconnected
  // 2. The current state is failed and the old state is disconnected
  return isIceStateDisconnected(currState) || isIceStateFailed(currState) && (isIceStateDisconnected(oldState) || isIceStateConnected(oldState) || isIceStateCompleted(oldState));
} // returns true if the ice candidate (a string) contains both the text 'typ relay' and 'udp'


function iceTypeRelayTest() {
  var candidate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return typeof candidate === 'string' && candidate.indexOf('typ relay') > -1 && candidate.indexOf('udp') > -1;
}

function isPresentationStateUpdating(state) {
  return (0, _safeAccess.default)(state, 'nucleus.galaxy.presentation.state') === c.GALAXY_PRESENTATION_STATE_TX_STARTING || (0, _safeAccess.default)(state, 'nucleus.galaxy.presentation.state') === c.GALAXY_PRESENTATION_STATE_TX_STOPPING || (0, _safeAccess.default)(state, 'nucleus.galaxy.presentation.state') === c.GALAXY_PRESENTATION_STATE_RX_STARTING || (0, _safeAccess.default)(state, 'nucleus.galaxy.presentation.state') === c.GALAXY_PRESENTATION_STATE_RX_STOPPING;
}

function isReceivingGalaxyPresentation(state) {
  var presentationState = (0, _safeAccess.default)(state, 'nucleus.galaxy.presentation.state');
  return presentationState === c.GALAXY_PRESENTATION_STATE_RX_STARTING || presentationState === c.GALAXY_PRESENTATION_STATE_RX_STARTED || presentationState === c.GALAXY_PRESENTATION_STATE_RX_STOPPING;
} // 0 <= priority < 0x10000 (GALAXY_OFFER_PRIORITY_MAX)


function generateOfferPriority() {
  return Math.floor(Math.random() * (c.GALAXY_OFFER_PRIORITY_MAX - 1)) + 1;
}

function shouldIgnoreOffer(inFlightOffer, inFlightOfferPriority, priority) {
  // ignore a remote's update offer if we already have an in flight offer with a higher priority
  // no priority would mean old api, which would be a higher priority than ours
  return inFlightOffer && inFlightOfferPriority && // we have an inflight offer
  priority && priority < inFlightOfferPriority; // our in flight offer has a higher priority
}

function getGalaxyApiVersion(state) {
  // Check if the application has enabled the v3 support during initialization
  // or else the user has enabled it through the local storage. In either case
  // return v3 else return v2
  var app_enabled_v3 = (0, _safeAccess.default)(state, 'nucleus.galaxy.options.supportV3');
  var user_enabled_v3 = window.localStorage && window.localStorage.getItem('enableV3') || false;

  if (app_enabled_v3 || user_enabled_v3) {
    return c.GALAXY_API_VERSION_V3;
  }

  return c.GALAXY_API_VERSION;
}

function isGalaxyV3Enabled(state) {
  // Check if the application has enabled the v3 support during initialization
  // or else the user has enabled it through the local storage. In either case
  // return v3 else return v2
  var app_enabled_v3 = (0, _safeAccess.default)(state, 'nucleus.galaxy.options.supportV3');
  var user_enabled_v3 = window.localStorage && window.localStorage.getItem('enableV3') || false;
  return app_enabled_v3 || user_enabled_v3;
}

function isAutoResolutionChangeEnabled(state) {
  return CONFIG.calls.autoResolutionChange && (0, _feature.getFeatureFlag)(state)(c.FEATUREFLAG_AUTO_RESOLUTION_CHANGE);
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(29)["default"]))

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFeatureFlag = exports.getFeatureFlags = exports.isChatEnabled = void 0;

var _reselect = __webpack_require__(23);

var _account = __webpack_require__(91);

var access = __webpack_require__(8);

var featureFlags = function featureFlags(state) {
  return access(state, 'nucleus.featureFlags') || {};
};

var isChatEnabled = function isChatEnabled(state) {
  return access((0, _account.getAccountSettings)(state), 'chatEnabled');
};
/**
 * Returns all feature flags
 * @example
 * getFeatureFlags(state)
 * Returns...object with all feature flags
 */


exports.isChatEnabled = isChatEnabled;
var getFeatureFlags = (0, _reselect.createSelector)(featureFlags, function (flags) {
  return flags;
});
exports.getFeatureFlags = getFeatureFlags;

/**
 * Returns the value of a specific feature flag
 * @example
 * getFeatureFlag(state)('CNUC_myFeatureFlag')
 * Returns...true/false
 */
var getFeatureFlag = (0, _reselect.createSelector)(featureFlags, function (flags) {
  return (0, _reselect.defaultMemoize)(function (flag) {
    return access(flags, flag) || false;
  });
});
exports.getFeatureFlag = getFeatureFlag;

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return concat; });
/* harmony import */ var _of__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86);
/* harmony import */ var _operators_concatAll__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(150);
/** PURE_IMPORTS_START _of,_operators_concatAll PURE_IMPORTS_END */


function concat() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return Object(_operators_concatAll__WEBPACK_IMPORTED_MODULE_1__[/* concatAll */ "a"])()(_of__WEBPACK_IMPORTED_MODULE_0__[/* of */ "a"].apply(void 0, observables));
}
//# sourceMappingURL=concat.js.map


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BUFFER_OVERFLOW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buffers; });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);


var BUFFER_OVERFLOW = "Channel's Buffer overflow!";

var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

var zeroBuffer = { isEmpty: _utils__WEBPACK_IMPORTED_MODULE_0__[/* kTrue */ "r"], put: _utils__WEBPACK_IMPORTED_MODULE_0__[/* noop */ "u"], take: _utils__WEBPACK_IMPORTED_MODULE_0__[/* noop */ "u"] };

function ringBuffer() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var overflowAction = arguments[1];

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];
    while (length) {
      items.push(take());
    }
    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit = void 0;
        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);
          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;
          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;

            arr = flush();

            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;

            arr.length = doubledLimit;
            limit = doubledLimit;

            push(it);
            break;
          default:
          // DROP
        }
      }
    },
    take: take,
    flush: flush
  };
}

var buffers = {
  none: function none() {
    return zeroBuffer;
  },
  fixed: function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
  },
  dropping: function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
  },
  sliding: function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
  },
  expanding: function expanding(initialSize) {
    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
  }
};

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hostReportError; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function hostReportError(err) {
    setTimeout(function () { throw err; }, 0);
}
//# sourceMappingURL=hostReportError.js.map


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return equal; });
var _a = Object.prototype, toString = _a.toString, hasOwnProperty = _a.hasOwnProperty;
var previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */
function equal(a, b) {
    try {
        return check(a, b);
    }
    finally {
        previousComparisons.clear();
    }
}
function check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) {
        return true;
    }
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = toString.call(a);
    var bTag = toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) {
        return false;
    }
    switch (aTag) {
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length)
                return false;
        // Fall through to object case...
        case '[object Object]': {
            if (previouslyCompared(a, b))
                return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length)
                return false;
            // Now make sure they have the same keys.
            for (var k = 0; k < keyCount; ++k) {
                if (!hasOwnProperty.call(b, aKeys[k])) {
                    return false;
                }
            }
            // Finally, check deep equality of all child properties.
            for (var k = 0; k < keyCount; ++k) {
                var key = aKeys[k];
                if (!check(a[key], b[key])) {
                    return false;
                }
            }
            return true;
        }
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a)
                return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]': {
            if (a.size !== b.size)
                return false;
            if (previouslyCompared(a, b))
                return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while (true) {
                var info = aIterator.next();
                if (info.done)
                    break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) {
                    return false;
                }
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !check(aValue, b.get(aKey))) {
                    return false;
                }
            }
            return true;
        }
    }
    // Otherwise the values are not equal.
    return false;
}
function previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b))
            return true;
    }
    else {
        previousComparisons.set(a, bSet = new Set);
    }
    bSet.add(b);
    return false;
}

/* unused harmony default export */ var _unused_webpack_default_export = (equal);

//# sourceMappingURL=equality.esm.js.map


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = __webpack_require__(62);
var EventBus = /** @class */ (function () {
    function EventBus() {
    }
    Object.defineProperty(EventBus, "Subject", {
        get: function () {
            return this._subject;
        },
        enumerable: true,
        configurable: true
    });
    EventBus.initialize = function (subject) {
        EventBus._subject = subject;
    };
    return EventBus;
}());
exports.default = EventBus;
function throwOnEvent(observable, eventType) {
    return observable.pipe(operators_1.find(function (e) { return e.type === eventType; }), operators_1.map(function (e) {
        if (e)
            throwPayload(e);
    }));
}
exports.throwOnEvent = throwOnEvent;
function throwPayload(event) {
    throw event.payload;
}


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(CONFIG) {

var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setPrimaryVideoSourceId = setPrimaryVideoSourceId;
exports.setPrimaryAudioSourceId = setPrimaryAudioSourceId;
exports.setPrimaryAudioOutputId = setPrimaryAudioOutputId;
exports.setVideoSourceQuality = setVideoSourceQuality;
exports.setSelectedVideoSourceId = setSelectedVideoSourceId;
exports.setSelectedAudioSourceId = setSelectedAudioSourceId;
exports.setVideoEnabledDefault = setVideoEnabledDefault;
exports.setAudioEnabledDefault = setAudioEnabledDefault;
exports.acquireLocalPrimaryStream = acquireLocalPrimaryStream;
exports.acquireLocalSecondaryStream = acquireLocalSecondaryStream;
exports.endLocalStream = endLocalStream;
exports.setLocalPresentationStream = setLocalPresentationStream;
exports.startPresentation = startPresentation;
exports.stopPresentation = stopPresentation;
exports.reattachPresentation = reattachPresentation;
exports.switchVideoCamera = switchVideoCamera;
exports.toggleVideoMute = toggleVideoMute;
exports.setAudioMuteState = setAudioMuteState;
exports.updatePrimarySourceGalaxy = updatePrimarySourceGalaxy;
exports.toggleVideoMuteGalaxy = toggleVideoMuteGalaxy;
exports.startPresentationGalaxy = startPresentationGalaxy;
exports.stopPresentationGalaxy = stopPresentationGalaxy;
exports.sendUpdateSdpGalaxy = sendUpdateSdpGalaxy;
exports.presentationTokenGrantedGalaxy = presentationTokenGrantedGalaxy;
exports.presentationTokenDeniedGalaxy = presentationTokenDeniedGalaxy;
exports.presentationTokenRevoked = presentationTokenRevoked;
exports.galaxyLocalPresentationStopped = galaxyLocalPresentationStopped;
exports.failedPresentationGalaxy = failedPresentationGalaxy;
exports.createOfferEventGalaxy = createOfferEventGalaxy;
exports.inCallOfferEventGalaxy = inCallOfferEventGalaxy;
exports.offerAnsweredEventGalaxy = offerAnsweredEventGalaxy;
exports.videoPlaying = videoPlaying;
exports.videoBlocked = videoBlocked;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var c = _interopRequireWildcard(__webpack_require__(3));

var streamUtils = _interopRequireWildcard(__webpack_require__(105));

var mediaSelectors = _interopRequireWildcard(__webpack_require__(143));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _galaxyUtils = __webpack_require__(73);

var _call = __webpack_require__(50);

var BrowserUtils = _interopRequireWildcard(__webpack_require__(44));

var _call2 = __webpack_require__(51);

var _presentation = __webpack_require__(191);

var _auth = __webpack_require__(31);

var _moderator = __webpack_require__(192);

var _participants = __webpack_require__(92);

var _moderator2 = __webpack_require__(93);

/**
 * setPrimaryVideoSourceId
 * This action sets the default primary video source id. Retrieve deviceIds from media selector
 * @param {string} id - deviceId of the video source Id
 */
function setPrimaryVideoSourceId(id) {
  return {
    type: c.SET_PRIMARY_VIDEO_SOURCE_ID,
    payload: id
  };
}
/**
 * setPrimaryAudioSourceId
 * This action sets the default primary audio source id. Retrieve deviceIds from media selector
 * @param {string} id - deviceId of the audio source Id
 */


function setPrimaryAudioSourceId(id) {
  return {
    type: c.SET_PRIMARY_AUDIO_SOURCE_ID,
    payload: id
  };
}
/**
 * setPrimaryAudioOutputId
 * This action sets the default primary audio output device id. Retrieve deviceIds from media selector
 * @param {string} id - deviceId of the audio output device Id
 */


function setPrimaryAudioOutputId(id) {
  return {
    type: c.SET_PRIMARY_AUDIO_OUTPUT_ID,
    payload: id
  };
}
/**
 * setVideoSourceQuality
 * This action sets the default primary video source quality (width, height, and frameRate)
 * @param {Object} quality - what media settings to use { width: number, height: number, frameRate: number }
 */


function setVideoSourceQuality(quality) {
  return {
    type: c.SET_VIDEO_SOURCE_QUALITY,
    payload: quality
  };
}
/**
 * setSelectedVideoSourceId
 * This action sets the selected video source id.
 * @param {string} id - deviceId of the video source Id
 */


function setSelectedVideoSourceId(id) {
  return {
    type: c.SET_SELECTED_VIDEO_SOURCE_ID,
    payload: id
  };
}
/**
 * setSelectedAudioSourceId
 * This action sets the selected audio source id.
 * @param {string} id - deviceId of the audio source Id
 */


function setSelectedAudioSourceId(id) {
  return {
    type: c.SET_SELECTED_AUDIO_SOURCE_ID,
    payload: id
  };
}
/**
 * setVideoEnabledDefault
 * This action sets the default video setting (on or off)
 * @param {bool} value - true if we should capture the webcam video, false if not
 */


function setVideoEnabledDefault(value) {
  return {
    type: c.SET_DEFAULT_VIDEO,
    payload: value
  };
}
/**
 * setAudioEnabledDefault
 * This action sets the default audio setting (on or off)
 * @param {bool} value - true if we should capture the microphone audio, false if not
 */


function setAudioEnabledDefault(value) {
  return {
    type: c.SET_DEFAULT_AUDIO,
    payload: value
  };
}
/**
 * acquireLocalPrimaryStream
 * This action acquires the local stream
 * You may set the enabled state of the audio and video capture using the optional media parameter,
 * You may also set the selected video and audio sourceIds
 *    (please use the mediaSelectors audioDevices and videoDevices selectors and pass in one of the deviceIds)
 *   This specified source will attempt to be captured, and if it does not exist, we will use the default.
 * @param {Object} media - what media settings to use { audio: bool, video: bool, primaryVideoSourceId: string, primaryAudioSourceId: string }
 */


function acquireLocalPrimaryStream(media) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch, getState) {
        var state, videoNeeded, audioNeeded, defaultVideo, defaultAudio, mediaSources, videoDevices, defaultPrimaryVideoSourceId, audioDevices, defaultPrimaryAudioSourceId, audioOutput, pendingTimeout, result, error, payload, _error;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!CONFIG.calls.useGalaxySignalingMiddleware) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                state = getState();
                videoNeeded = (0, _galaxyUtils.isGalaxyCallConnected)(state) ? !(0, _safeAccess.default)(state, 'nucleus.media.isVideoMuted') : !!(0, _safeAccess.default)(state, 'nucleus.media.videoNeeded');
                audioNeeded = (0, _galaxyUtils.isGalaxyCallConnected)(state) ? !(0, _safeAccess.default)(state, 'nucleus.media.isAudioMuted') : !!(0, _safeAccess.default)(state, 'nucleus.media.audioNeeded');
                defaultVideo = typeof (0, _safeAccess.default)(media, 'video') !== 'undefined' ? (0, _safeAccess.default)(media, 'video') : (0, _safeAccess.default)(state, 'nucleus.media.video') && videoNeeded;
                defaultAudio = typeof (0, _safeAccess.default)(media, 'audio') !== 'undefined' ? (0, _safeAccess.default)(media, 'audio') : (0, _safeAccess.default)(state, 'nucleus.media.audio') && audioNeeded;
                mediaSources = {
                  video: defaultVideo,
                  audio: defaultAudio
                }; // if we want to grab the video source, check which device to use

                if (mediaSources.video) {
                  // either use the video source passed in, or the one saved in the state, if available
                  videoDevices = mediaSelectors.videoDevices(state);
                  defaultPrimaryVideoSourceId = (0, _safeAccess.default)(media, 'primaryVideoSourceId') || (0, _safeAccess.default)(state, 'nucleus.media.primaryVideoSourceId');

                  if (defaultPrimaryVideoSourceId && videoDevices.some(function (d) {
                    return d.deviceId === defaultPrimaryVideoSourceId;
                  })) {
                    mediaSources.primaryVideoSourceId = defaultPrimaryVideoSourceId;
                  }
                } // if we want to grab the audio source, check which device to use


                if (mediaSources.audio) {
                  // either use the audio source passed in, or the one saved in the state, if available
                  audioDevices = mediaSelectors.audioDevices(state);
                  defaultPrimaryAudioSourceId = (0, _safeAccess.default)(media, 'primaryAudioSourceId') || (0, _safeAccess.default)(state, 'nucleus.media.primaryAudioSourceId');

                  if (defaultPrimaryAudioSourceId && audioDevices.some(function (d) {
                    return d.deviceId === defaultPrimaryAudioSourceId;
                  })) {
                    mediaSources.primaryAudioSourceId = defaultPrimaryAudioSourceId;
                  }
                }

                audioOutput = (0, _safeAccess.default)(media, 'primaryAudioOutputId') || (0, _safeAccess.default)(state, 'nucleus.media.primaryAudioOutputId');

                if (audioOutput) {
                  mediaSources.primaryAudioOutputId = audioOutput;
                } // Set selected video/audio sources


                if (mediaSources.primaryVideoSourceId) {
                  dispatch(setSelectedVideoSourceId(mediaSources.primaryVideoSourceId));
                }

                if (mediaSources.primaryAudioSourceId) {
                  dispatch(setSelectedAudioSourceId(mediaSources.primaryAudioSourceId));
                }

                pendingTimeout = getPendingPermissionsTimer(dispatch, state);
                _context.prev = 15;
                _context.next = 18;
                return dispatch({
                  type: c.ACQUIRE_LOCAL_PRIMARY_STREAM_BEGIN,
                  payload: mediaSources
                });

              case 18:
                result = _context.sent;

                if (pendingTimeout) {
                  clearTimeout(pendingTimeout);
                }

                if (result) {
                  _context.next = 25;
                  break;
                }

                if (pendingTimeout) {
                  clearTimeout(pendingTimeout);
                }

                error = streamUtils.mapNavigatorUserMediaError('No stream found');
                dispatch({
                  type: c.ACQUIRE_LOCAL_PRIMARY_STREAM_FAILURE,
                  payload: error
                });
                throw error;

              case 25:
                payload = {
                  stream: result.stream,
                  isAudioMuted: !!((0, _safeAccess.default)(result, 'isAudioMuted') || !(0, _safeAccess.default)(result, 'audioTrack')),
                  hasAudioTrack: !!(0, _safeAccess.default)(result, 'audioTrack'),
                  hasVideoTrack: !!(0, _safeAccess.default)(result, 'videoTrack'),
                  audioSource: (0, _safeAccess.default)(result, 'audioSource'),
                  videoSource: (0, _safeAccess.default)(result, 'videoSource')
                };
                dispatch({
                  type: c.ACQUIRE_LOCAL_PRIMARY_STREAM_SUCCESS,
                  payload: payload
                });
                return _context.abrupt("return", payload);

              case 30:
                _context.prev = 30;
                _context.t0 = _context["catch"](15);

                if (pendingTimeout) {
                  clearTimeout(pendingTimeout);
                }

                _error = streamUtils.mapNavigatorUserMediaError(_context.t0);
                dispatch({
                  type: c.ACQUIRE_LOCAL_PRIMARY_STREAM_FAILURE,
                  payload: _error
                });
                throw _error;

              case 36:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[15, 30]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}

function getPendingPermissionsTimer(dispatch, state) {
  var platform = (0, _auth.getPlatform)(state) || c.PLATFORM_WEB; // On IE11 there is no permissions hence we needn't start this timer or
  // fire the event as its an irrelevant state

  if (!BrowserUtils.isIE11() && !BrowserUtils.isDesktop(platform)) {
    // set pending permissions if not resolved in 500 ms
    return setTimeout(function () {
      return dispatch({
        type: c.GETUSERMEDIA_PENDING_PERMISSIONS
      });
    }, 1000);
  }
}
/**
 * acquireLocalSecondaryStream
 * This action acquires the desktop stream
 * @param {string} sourceId - what media settings to use { audio: bool, video: bool }
 */


function acquireLocalSecondaryStream(sourceId) {
  return function (dispatch, getState) {
    var source = sourceId || (0, _safeAccess.default)(getState(), 'nucleus.media.secondarySourceId');
    return dispatch({
      type: c.ACQUIRE_LOCAL_SECONDARY_STREAM_BEGIN,
      payload: source
    }).then(function () {
      return dispatch({
        type: c.ACQUIRE_LOCAL_SECONDARY_STREAM_SUCCESS,
        payload: source
      });
    }).catch(function (err) {
      dispatch({
        type: c.ACQUIRE_LOCAL_SECONDARY_STREAM_FAILURE,
        payload: err
      });
      throw err;
    });
  };
}
/**
 * endLocalStream
 * This action ends all local streams
 */


function endLocalStream() {
  return function (dispatch, getState) {
    if ((0, _safeAccess.default)((0, _call2.activeCallSelector)(getState()), 'state') === c.CALL_STATE_DISCONNECTED) {
      dispatch({
        type: c.END_LOCAL_STREAM
      });
    }

    return Promise.resolve();
  };
}
/**
 * setLocalPresentationStream
 * This action takes a local presentation stream acquired by the client and passes it to nucleus
 * to override normal presentation stream acquisition steps
 * @param stream - the MediaStream from the client
 */


function setLocalPresentationStream(stream) {
  return {
    type: c.LOCAL_PRESENTATION_STREAM_ACQUIRED,
    payload: stream
  };
}
/**
 * startPresentation
 * This action should be used to send desktop stream in the primary peer connection instead
 * of the webcam stream. Used to achieve the current pinned mode presentation. Later can be
 * used with dual stream presentation as a special case while dealing with third party clients
 * that do not support compatible presentation mechanism
 * @param {string} sourceId - the source Id to capture for the desktop stream
 * @param {string} [sourceName] - the source name to capture for the desktop stream
 */


function startPresentation() {
  var sourceId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  var sourceName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch, getState) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(0, _galaxyUtils.isGalaxyCallConnected)(getState())) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", dispatch(startPresentationGalaxy(sourceId, sourceName)));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}
/**
 * stopPresentation
 * Action to be used to switch back to webcam stream from the desktop stream
 */


function stopPresentation() {
  return function (dispatch, getState) {
    if ((0, _galaxyUtils.isGalaxyCallConnected)(getState())) return dispatch(stopPresentationGalaxy());
  };
}

function reattachPresentation(id) {
  return {
    type: c.REATTACH_PRESENTATION,
    payload: id
  };
}
/**
 * switchVideoCamera
 * [Mobile] This action attempts to call _switchCamera on the webcam's
 * video MediaStreamTrack object, if the function exists. Currently no related
 * reducer state.
 */


function switchVideoCamera() {
  return {
    type: c.SWITCH_VIDEO_CAMERA
  };
}
/**
 * toggleVideoMute
 * Action to be used to toggle the current mute status of the video track in a give stream (by
 * default the webcamstream aka the local stream)
 * @param {Boolean} mute       - the mute value to be set. True indicates mute and false unmute. Not
 *                               passng any value would toggle the current mute status of the track
 */


function toggleVideoMute() {
  var mute = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return function (dispatch, getState) {
    if ((0, _galaxyUtils.isGalaxyCallConnected)(getState())) return dispatch(toggleVideoMuteGalaxy(mute));
  };
}
/**
 * Action that handles setting the audio mute state of the self participant including the possibility of a server mute.
 * If the user is server muted, they need to be a moderator of the conference in order to be unmuted. Otherwise, dispatching this action is a no-op.
 */


function setAudioMuteState(mute) {
  return function (dispatch, getState) {
    var state = getState(); // if a previous audio mute state change has not completed then no-op.

    if ((0, mediaSelectors.selectIsTogglingAudioMute)(state)) return;

    if (mute) {
      // if muting, dispatch the set local mute action and exit
      dispatch(setLocalAudioMuteState(true));
      return;
    } // otherwise, need to check if unmuting is possible


    var currentUserParticipant = (0, _participants.selectCurrentUserParticipant)(state);

    if (!(0, _safeAccess.default)(currentUserParticipant, 'serverMuteState')) {
      // if not server muted, unmute self locally and exit
      dispatch(setLocalAudioMuteState(false));
      return;
    } // if user is server muted, they can only unmute themselves if they are a mod


    if ((0, _moderator2.selectIsCurrentUserModerator)(state)) {
      // unmute self locally
      dispatch(setLocalAudioMuteState(false)); // dispatch moderator action to unmute self on server

      dispatch((0, _moderator.setParticipantMuteValue)((0, _safeAccess.default)(currentUserParticipant, 'participantId'), false));
    }
  };
}

function setLocalAudioMuteState(mute) {
  return function (dispatch, getState) {
    var state = getState(); // check if setting the local state is really needed.

    if (mute !== (0, mediaSelectors.selectIsLocalAudioMuted)(state)) {
      dispatch({
        type: c.TOGGLE_AUDIO_MUTE,
        payload: {
          mute: mute
        }
      });
    }
  };
}

function updatePrimarySourceGalaxy() {
  return {
    type: c.GALAXY_ACTION_UPDATE_PRIMARY_SOURCE
  };
}

function toggleVideoMuteGalaxy() {
  var mute = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return function (dispatch, getState) {
    if ((0, _safeAccess.default)(getState(), 'nucleus.media.togglingVideoMute') || (0, _safeAccess.default)(getState(), 'nucleus.galaxy.rtc.mediaProcessingInProgress')) return;
    return dispatch({
      type: c.GALAXY_ACTION_TOGGLE_VIDEO_MUTE,
      payload: {
        mute: mute
      }
    });
  };
}

function startPresentationGalaxy(presentationSourceId, presentationSourceName) {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(dispatch, getState) {
        var state, presentationStateUpdating, presentationStateRxStarted, mediaProcessingInProgress;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                state = getState();
                presentationStateUpdating = (0, _galaxyUtils.isPresentationStateUpdating)(state);
                presentationStateRxStarted = (0, _safeAccess.default)(state, 'nucleus.galaxy.presentation.state') === c.GALAXY_PRESENTATION_STATE_RX_STARTED;
                mediaProcessingInProgress = (0, _safeAccess.default)(state, 'nucleus.galaxy.rtc.mediaProcessingInProgress');

                if (!(presentationStateUpdating || presentationStateRxStarted || mediaProcessingInProgress)) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return");

              case 6:
                _context3.prev = 6;
                dispatch(startPresentationGalaxyAction(presentationSourceId, presentationSourceName));
                _context3.next = 10;
                return dispatch((0, _presentation.sendPresentationTokenRequestGalaxy)());

              case 10:
                return _context3.abrupt("return", _context3.sent);

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](6);
                return _context3.abrupt("return", dispatch(failedPresentationGalaxy({
                  reason: c.GALAXY_REASON_SERVER_ERROR,
                  error: _context3.t0
                })));

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[6, 13]]);
      }));

      return function (_x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
}

function stopPresentationGalaxy() {
  return function (dispatch, getState) {
    if ((0, _galaxyUtils.isPresentationStateUpdating)(getState()) || (0, _safeAccess.default)(getState(), 'nucleus.galaxy.rtc.mediaProcessingInProgress') || !(0, _safeAccess.default)(getState(), 'nucleus.galaxy.presentation.isTokenOwnerSelf')) return;
    dispatch({
      type: c.GALAXY_ACTION_STOP_PRESENTATION
    });
  };
}

function sendUpdateSdpGalaxy(type, reason) {
  var sdp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var tracks = arguments.length > 3 ? arguments[3] : undefined;
  var presSdp = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var priority = arguments.length > 5 ? arguments[5] : undefined;
  return (
    /*#__PURE__*/
    function () {
      var _ref4 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(dispatch, getState) {
        var state, callId, sourceId, capability, payload, error;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                state = getState();
                callId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.callId');
                sourceId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.sourceId');
                capability = {
                  type: type,
                  sdp: sdp,
                  tracks: tracks,
                  presSdp: presSdp,
                  priority: priority
                };
                payload = {
                  command: c.GALAXY_COMMAND_UPDATE,
                  capability: capability,
                  reason: reason,
                  callId: callId,
                  sourceId: sourceId,
                  version: c.GALAXY_API_VERSION
                }; // dispatch update begin

                _context4.prev = 5;
                _context4.next = 8;
                return dispatch((0, _call.postCallCommandGalaxy)(payload));

              case 8:
                dispatch({
                  type: c.GALAXY_ACTION_UPDATE_SDP_SUCCESS,
                  payload: payload
                });
                _context4.next = 16;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](5);
                error = {
                  error: _context4.t0,
                  reason: c.GALAXY_REASON_SERVER_ERROR,
                  data: payload
                }; // dispatch update failed

                dispatch({
                  type: c.GALAXY_ACTION_UPDATE_SDP_FAILURE,
                  payload: error
                }); // rethrow

                throw error;

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[5, 11]]);
      }));

      return function (_x7, _x8) {
        return _ref4.apply(this, arguments);
      };
    }()
  );
}

var startPresentationGalaxyAction = function startPresentationGalaxyAction(presentationSourceId, presentationSourceName) {
  return {
    type: c.GALAXY_ACTION_BEGIN_PRESENTATION,
    payload: {
      presentationSourceId: presentationSourceId,
      presentationSourceName: presentationSourceName
    }
  };
};

function presentationTokenGrantedGalaxy(data) {
  return {
    type: c.GALAXY_ACTION_PRESENTATION_TOKEN_GRANTED,
    payload: data
  };
}

function presentationTokenDeniedGalaxy(data) {
  return function (dispatch) {
    return dispatch({
      type: c.GALAXY_ACTION_PRESENTATION_TOKEN_DENIED,
      payload: data
    });
  };
}

function presentationTokenRevoked(data) {
  return function (dispatch) {
    return dispatch({
      type: c.GALAXY_ACTION_PRESENTATION_TOKEN_REVOKED,
      payload: data
    });
  };
}

function galaxyLocalPresentationStopped() {
  return function (dispatch) {
    return dispatch({
      type: c.GALAXY_ACTION_LOCAL_PRESENTATION_STOPPED
    });
  };
}

function failedPresentationGalaxy(data) {
  return function (dispatch) {
    return dispatch({
      type: c.GALAXY_ACTION_PRESENTATION_FAILED,
      payload: data
    });
  };
}

function createOfferEventGalaxy(data) {
  return {
    type: c.GALAXY_ACTION_CREATE_OFFER,
    payload: data
  };
}

function inCallOfferEventGalaxy(data) {
  return {
    type: c.GALAXY_ACTION_IN_CALL_OFFER,
    payload: data
  };
}

function offerAnsweredEventGalaxy(data) {
  return {
    type: c.GALAXY_ACTION_OFFER_ANSWERED,
    payload: data
  };
}

function videoPlaying(video) {
  return {
    type: c.VIDEO_PLAYBACK_STARTED,
    payload: video
  };
}

function videoBlocked(video) {
  return {
    type: c.VIDEO_PLAYBACK_BLOCKED,
    payload: video
  };
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(29)["default"]))

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(419);

var iterableToArrayLimit = __webpack_require__(420);

var nonIterableRest = __webpack_require__(421);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.15';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // with lookup (in case of e.g. prototype pollution), and strip newlines if any.
      // A newline wouldn't be a valid sourceURL anyway, and it'd enable code injection.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/[\r\n]/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      // Like with sourceURL, we take care to not check the option's prototype,
      // as this configuration is a code injection vector.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(103)(module)))

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectCanConnect = selectCanConnect;
exports.selectConnected = selectConnected;
exports.selectConnecting = selectConnecting;
exports.selectVerifyingConnection = selectVerifyingConnection;
exports.selectWillRetry = exports.selectProxyStatus = exports.selectRequiredServicesStatus = exports.selectServices = void 0;

var _get = _interopRequireDefault(__webpack_require__(11));

var _constants = __webpack_require__(3);

var selectServices = function selectServices(state) {
  return (0, _get.default)(state, 'nucleus.services');
};

exports.selectServices = selectServices;

var selectRequiredServicesStatus = function selectRequiredServicesStatus(state) {
  return (0, _get.default)(selectServices(state), 'requiredServicesStatus');
};

exports.selectRequiredServicesStatus = selectRequiredServicesStatus;

var selectProxyStatus = function selectProxyStatus(state) {
  return (0, _get.default)(selectServices(state), 'proxyStatus');
};

exports.selectProxyStatus = selectProxyStatus;

var selectWillRetry = function selectWillRetry(state) {
  return (0, _get.default)(selectServices(state), 'willRetry');
};

exports.selectWillRetry = selectWillRetry;

function selectCanConnect(state) {
  var essentialServicesStatus = selectRequiredServicesStatus(state);
  var proxyStatus = selectProxyStatus(state);
  var willRetry = selectWillRetry(state);
  if (essentialServicesStatus !== _constants.SERVICE_STATUS_DISCONNECTED) return false;
  if (proxyStatus !== _constants.SERVICE_STATUS_DISCONNECTED) return false;
  return !willRetry;
}

function selectConnected(state) {
  var proxyStatus = selectProxyStatus(state);
  var requiredServicesStatus = selectRequiredServicesStatus(state);
  if (proxyStatus !== _constants.SERVICE_STATUS_CONNECTED) return false;
  if (requiredServicesStatus !== _constants.SERVICE_STATUS_CONNECTED) return false;
  return true;
}

function selectConnecting(state) {
  var proxyStatus = selectProxyStatus(state);
  var requiredServicesStatus = selectRequiredServicesStatus(state);
  if (proxyStatus === _constants.SERVICE_STATUS_CONNECTING) return true;
  if (requiredServicesStatus === _constants.SERVICE_STATUS_CONNECTING) return true;
  return false;
}

function selectVerifyingConnection(state) {
  return selectProxyStatus(state) === _constants.SERVICE_STATUS_VERIFYING;
}

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribeToTopic = subscribeToTopic;
exports.loadActiveMeetings = loadActiveMeetings;
exports.loadUserMeetings = loadUserMeetings;
exports.partialLoad = partialLoad;
exports.fetchNext = fetchNext;
exports.search = search;
exports.loadContactIfNotPresent = loadContactIfNotPresent;
exports.loadByUUIDWithRetry = exports.loadByUUID = exports.loadByUUIDs = exports.loadByExtensions = exports.getMe = exports.loadAll = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(71));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(81));

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _delay = _interopRequireDefault(__webpack_require__(449));

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _debounce = _interopRequireDefault(__webpack_require__(247));

var _get = _interopRequireDefault(__webpack_require__(11));

var _contacts = __webpack_require__(35);

var _meQuery = _interopRequireDefault(__webpack_require__(451));

var _loadContactsQuery = _interopRequireDefault(__webpack_require__(452));

var _loadByUuidQuery = _interopRequireDefault(__webpack_require__(453));

var _loadByUuidsQuery = _interopRequireDefault(__webpack_require__(454));

var _loadByExtensionsQuery = _interopRequireDefault(__webpack_require__(455));

var _searchQuery = _interopRequireDefault(__webpack_require__(456));

var _proxy = __webpack_require__(21);

var c = _interopRequireWildcard(__webpack_require__(3));

var _activeMeetings = _interopRequireDefault(__webpack_require__(457));

var _userMeetings = _interopRequireDefault(__webpack_require__(458));

var _directory = __webpack_require__(459);

var _services = __webpack_require__(83);

var _callHistoryUtils = __webpack_require__(126);

function subscribeToTopic() {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return dispatch((0, _proxy.subscribe)(c.CONTACT_TOPIC));

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);

                _jsLogger.default.warn('directory topic: subscription failed:', _context.t0);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 5]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}

function loadActiveMeetings() {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch, getState) {
        var _ref3, _ref4, response, records, activeMeetings;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return dispatch({
                  type: c.GQL_QUERY,
                  payload: {
                    query: _activeMeetings.default,
                    fetchPolicy: 'network-only'
                  }
                });

              case 2:
                _ref3 = _context2.sent;
                _ref4 = (0, _slicedToArray2.default)(_ref3, 1);
                response = _ref4[0];
                records = (0, _get.default)(response, 'data.activeMeetings.records');
                activeMeetings = (0, _contacts.initialContactsSelector)(getState())(records.filter(function (r) {
                  return !!r;
                }), false);
                dispatch({
                  type: c.CONTACT_RECORDS_PARTIAL_LOAD,
                  payload: activeMeetings
                });

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}

function loadUserMeetings() {
  return (
    /*#__PURE__*/
    function () {
      var _ref5 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(dispatch, getState) {
        var _ref6, _ref7, response, records, userMeetings;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return dispatch({
                  type: c.GQL_QUERY,
                  payload: {
                    query: _userMeetings.default,
                    fetchPolicy: 'network-only'
                  }
                });

              case 2:
                _ref6 = _context3.sent;
                _ref7 = (0, _slicedToArray2.default)(_ref6, 1);
                response = _ref7[0];
                records = (0, _get.default)(response, 'data.userMeetings.records');
                userMeetings = (0, _contacts.initialContactsSelector)(getState())(records.filter(function (r) {
                  return !!r;
                }), false);
                dispatch({
                  type: c.CONTACT_RECORDS_PARTIAL_LOAD,
                  payload: userMeetings
                });

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x4, _x5) {
        return _ref5.apply(this, arguments);
      };
    }()
  );
}

var allContactTypes = ['MEETING', 'USER', 'PERSONAL', 'GROUP', 'ROOM'];

function partialLoad() {
  var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : allContactTypes;
  var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : c.CONTACTS_DEFAULT_PAGE_SIZE;
  return (
    /*#__PURE__*/
    function () {
      var _ref8 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(dispatch, getState) {
        var records, hasMoreRecords, cursor, variables, _ref9, _ref10, response, responseRecords, parsedRecords;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                records = [];
                hasMoreRecords = true;
                cursor = undefined;

              case 3:
                if (!hasMoreRecords) {
                  _context4.next = 17;
                  break;
                }

                variables = {
                  cursor: cursor,
                  filter: filter,
                  limit: pageSize
                };
                _context4.next = 7;
                return dispatch({
                  type: c.GQL_QUERY,
                  payload: {
                    query: _loadContactsQuery.default,
                    fetchPolicy: 'network-only',
                    variables: variables
                  }
                });

              case 7:
                _ref9 = _context4.sent;
                _ref10 = (0, _slicedToArray2.default)(_ref9, 1);
                response = _ref10[0];
                cursor = (0, _get.default)(response, 'data.directoryList.cursor');
                hasMoreRecords = (0, _get.default)(response, 'data.directoryList.hasMoreRecords');
                responseRecords = (0, _get.default)(response, 'data.directoryList.records');
                parsedRecords = (0, _contacts.initialContactsSelector)(getState())(responseRecords.filter(function (r) {
                  return !!r;
                }), false);
                records.push.apply(records, (0, _toConsumableArray2.default)(parsedRecords));
                _context4.next = 3;
                break;

              case 17:
                dispatch({
                  type: c.CONTACT_RECORDS_PARTIAL_LOAD,
                  payload: records
                });

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x6, _x7) {
        return _ref8.apply(this, arguments);
      };
    }()
  );
}

function fetchNext(filter) {
  var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : c.CONTACTS_DEFAULT_SMALL_PAGE_SIZE;
  return (
    /*#__PURE__*/
    function () {
      var _ref11 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(dispatch, getState) {
        var filterKey, _state$nucleus, _state$nucleus$contac, state, pagedLoads, currentCursor, variables, _ref12, _ref13, response, cursor, done, records;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                filterKey = JSON.stringify(filter);
                _context5.prev = 1;
                state = getState();
                pagedLoads = state === null || state === void 0 ? void 0 : (_state$nucleus = state.nucleus) === null || _state$nucleus === void 0 ? void 0 : (_state$nucleus$contac = _state$nucleus.contacts) === null || _state$nucleus$contac === void 0 ? void 0 : _state$nucleus$contac.pagedLoads[filterKey];

                if (!(pagedLoads === null || pagedLoads === void 0 ? void 0 : pagedLoads.done)) {
                  _context5.next = 6;
                  break;
                }

                return _context5.abrupt("return");

              case 6:
                if (!(pagedLoads === null || pagedLoads === void 0 ? void 0 : pagedLoads.isFetching)) {
                  _context5.next = 9;
                  break;
                }

                _jsLogger.default.info('fetchNext canceled, already fetching');

                return _context5.abrupt("return");

              case 9:
                dispatch({
                  type: c.CONTACTS_FETCH_NEXT_BEGIN,
                  payload: {
                    filterKey: filterKey
                  }
                });
                currentCursor = pagedLoads === null || pagedLoads === void 0 ? void 0 : pagedLoads.cursor;
                variables = {
                  cursor: currentCursor,
                  filter: filter,
                  limit: pageSize
                };
                _context5.next = 14;
                return dispatch({
                  type: c.GQL_QUERY,
                  payload: {
                    query: _loadContactsQuery.default,
                    fetchPolicy: 'network-only',
                    variables: variables
                  }
                });

              case 14:
                _ref12 = _context5.sent;
                _ref13 = (0, _slicedToArray2.default)(_ref12, 1);
                response = _ref13[0];
                cursor = (0, _get.default)(response, 'data.directoryList.cursor');
                done = !(0, _get.default)(response, 'data.directoryList.hasMoreRecords');
                records = (0, _contacts.initialContactsSelector)(getState())((0, _get.default)(response, 'data.directoryList.records', []).filter(function (r) {
                  return !!r;
                }), false);
                dispatch({
                  type: c.CONTACTS_FETCH_NEXT_RESULT,
                  payload: {
                    records: records,
                    done: done,
                    cursor: cursor,
                    filterKey: filterKey
                  }
                });
                _context5.next = 27;
                break;

              case 23:
                _context5.prev = 23;
                _context5.t0 = _context5["catch"](1);

                _jsLogger.default.warn('Error in directoryActions fetchNext:', _context5.t0);

                dispatch({
                  type: c.CONTACTS_FETCH_NEXT_FAILED,
                  payload: {
                    filterKey: filterKey
                  }
                });

              case 27:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[1, 23]]);
      }));

      return function (_x8, _x9) {
        return _ref11.apply(this, arguments);
      };
    }()
  );
}

var doSearch =
/*#__PURE__*/
function () {
  var _ref14 = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee6(dispatch, getState) {
    var _response$data, _response$data$direct;

    var contactTypes,
        searchString,
        sequenceNumber,
        _ref15,
        _ref16,
        response,
        currentSequenceNumber,
        records,
        contacts,
        _args6 = arguments;

    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            contactTypes = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : [];
            searchString = _args6.length > 3 ? _args6[3] : undefined;
            sequenceNumber = _args6.length > 4 ? _args6[4] : undefined;
            if (!contactTypes.length) contactTypes = allContactTypes;
            _context6.next = 6;
            return dispatch({
              type: c.GQL_QUERY,
              payload: {
                query: _searchQuery.default,
                variables: {
                  query: searchString,
                  filter: contactTypes
                },
                fetchPolicy: 'network-only'
              }
            });

          case 6:
            _ref15 = _context6.sent;
            _ref16 = (0, _slicedToArray2.default)(_ref15, 1);
            response = _ref16[0];
            // verify if the current sequence number is the same as it was before searching
            // if it has changed, it means a more recent search has been attempted
            // therefore results of this search can be safely ignored
            currentSequenceNumber = (0, _directory.selectSequenceNumber)(getState());

            if (!(sequenceNumber !== currentSequenceNumber)) {
              _context6.next = 12;
              break;
            }

            return _context6.abrupt("return");

          case 12:
            // otherwise, process the results
            records = (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$direct = _response$data.directoryList) === null || _response$data$direct === void 0 ? void 0 : _response$data$direct.records) || [];
            contacts = (0, _contacts.initialContactsSelector)(getState())(records.filter(function (r) {
              return !!r;
            }), false);
            dispatch({
              type: c.DIRECTORY_SEARCH_RESULTS,
              payload: contacts
            });

          case 15:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function doSearch(_x10, _x11) {
    return _ref14.apply(this, arguments);
  };
}();

var loadAll = function loadAll() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : c.CONTACTS_DEFAULT_PAGE_SIZE;
  return (
    /*#__PURE__*/
    function () {
      var _ref17 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(dispatch) {
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                dispatch({
                  type: c.CONTACTS_FETCH_PAGINATED_REQUEST
                });
                _context7.next = 4;
                return dispatch(fetchNextPage(filters, pageSize));

              case 4:
                dispatch({
                  type: c.CONTACTS_FETCH_PAGINATED_SUCCESS
                });
                _context7.next = 10;
                break;

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7["catch"](0);
                dispatch({
                  type: c.CONTACTS_FETCH_PAGINATED_FAILURE
                });

              case 10:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[0, 7]]);
      }));

      return function (_x12) {
        return _ref17.apply(this, arguments);
      };
    }()
  );
};

exports.loadAll = loadAll;

var fetchNextPage = function fetchNextPage(filter, pageSize) {
  var cursor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var cachePreviouslyLoaded = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return (
    /*#__PURE__*/
    function () {
      var _ref18 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee9(dispatch) {
        var variables, _ref19, _ref20, observable, cacheLoaded;

        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                variables = {
                  cursor: cursor,
                  filter: filter,
                  limit: pageSize
                }; // cache-and-network queries return a query observable

                _context9.next = 3;
                return dispatch({
                  type: c.GQL_QUERY,
                  payload: {
                    fetchPolicy: 'cache-and-network',
                    query: _loadContactsQuery.default,
                    variables: variables
                  }
                });

              case 3:
                _ref19 = _context9.sent;
                _ref20 = (0, _slicedToArray2.default)(_ref19, 1);
                observable = _ref20[0];
                cacheLoaded = cachePreviouslyLoaded;
                return _context9.abrupt("return", new Promise(function (resolve, reject) {
                  // subscribe to the observable events
                  var subscription = observable.subscribe({
                    error: reject,
                    next: function () {
                      var _next = (0, _asyncToGenerator2.default)(
                      /*#__PURE__*/
                      _regenerator.default.mark(function _callee8(response) {
                        var isCacheResponse;
                        return _regenerator.default.wrap(function _callee8$(_context8) {
                          while (1) {
                            switch (_context8.prev = _context8.next) {
                              case 0:
                                // This function is called every time an event is fired from the observable subscription.
                                // This happens under the following conditions:
                                // * When the query is resolved using the cache (If it can be resolved using the cache).
                                // * When the query is resolved using the network.
                                isCacheResponse = (0, _get.default)(response, 'loading');
                                cacheLoaded = cacheLoaded || isCacheResponse;
                                _context8.prev = 2;
                                _context8.next = 5;
                                return dispatch(handlePageFetch(response, filter, pageSize, cacheLoaded));

                              case 5:
                                if (!isCacheResponse) {
                                  _context8.next = 7;
                                  break;
                                }

                                return _context8.abrupt("return");

                              case 7:
                                subscription.unsubscribe();
                                resolve();
                                _context8.next = 14;
                                break;

                              case 11:
                                _context8.prev = 11;
                                _context8.t0 = _context8["catch"](2);
                                reject(_context8.t0);

                              case 14:
                              case "end":
                                return _context8.stop();
                            }
                          }
                        }, _callee8, null, [[2, 11]]);
                      }));

                      function next(_x14) {
                        return _next.apply(this, arguments);
                      }

                      return next;
                    }()
                  });
                }));

              case 8:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      return function (_x13) {
        return _ref18.apply(this, arguments);
      };
    }()
  );
};

function handlePageFetch(response, filter, pageSize, cacheLoaded) {
  return (
    /*#__PURE__*/
    function () {
      var _ref21 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee10(dispatch) {
        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!(0, _get.default)(response, 'loading')) {
                  _context10.next = 3;
                  break;
                }

                // handle cache response
                dispatch(handleCachePageFetch((0, _get.default)(response, 'data')));
                return _context10.abrupt("return");

              case 3:
                _context10.next = 5;
                return dispatch(handleNetworkPageFetch((0, _get.default)(response, 'data'), filter, pageSize, cacheLoaded));

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      return function (_x15) {
        return _ref21.apply(this, arguments);
      };
    }()
  );
}

function handleCachePageFetch(data) {
  return function (dispatch, getState) {
    var contacts = getContactsFromResponse(getState(), data);
    dispatch({
      type: c.CONTACTS_LOADED_FROM_CACHE,
      payload: contacts
    });
  };
}

function handleNetworkPageFetch(data, filter, pageSize, cacheLoaded) {
  return (
    /*#__PURE__*/
    function () {
      var _ref22 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee11(dispatch, getState) {
        var contacts, hasMoreRecords, nextPageCursor;
        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                contacts = getContactsFromResponse(getState(), data);
                dispatch({
                  type: c.CONTACTS_PAGE_FETCHED,
                  payload: {
                    cacheLoaded: cacheLoaded,
                    records: contacts
                  }
                });
                hasMoreRecords = (0, _get.default)(data, 'directoryList.hasMoreRecords');

                if (!hasMoreRecords) {
                  _context11.next = 7;
                  break;
                }

                // fetching next page of records
                nextPageCursor = (0, _get.default)(data, 'directoryList.cursor');
                _context11.next = 7;
                return dispatch(fetchNextPage(filter, pageSize, nextPageCursor, cacheLoaded));

              case 7:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      return function (_x16, _x17) {
        return _ref22.apply(this, arguments);
      };
    }()
  );
}

function getContactsFromResponse(state, data) {
  var records = (0, _get.default)(data, 'directoryList.records', []);
  return (0, _contacts.initialContactsSelector)(state)(records, false);
}

var loadCallHistoryFromMe = function loadCallHistoryFromMe(dispatch, response, state) {
  var _response$data2, _response$data2$me, _response$data2$me$ca;

  dispatch({
    type: c.CALLHISTORY_LOAD_BEGIN
  });
  var callHistory = ((response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$me = _response$data2.me) === null || _response$data2$me === void 0 ? void 0 : (_response$data2$me$ca = _response$data2$me.callHistory) === null || _response$data2$me$ca === void 0 ? void 0 : _response$data2$me$ca.records) || []).map((0, _callHistoryUtils.mapToLegacyCallHistory)(state));
  dispatch({
    type: c.CALLHISTORY_LOAD_SUCCESS,
    payload: callHistory
  });
  return callHistory;
};

var loadContactFavoritesFromMe = function loadContactFavoritesFromMe(dispatch, response, state, callHistory) {
  var _response$data3, _response$data3$me;

  dispatch({
    type: c.GET_FAVORITES_BEGIN
  });
  var favorites = ((response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : (_response$data3$me = _response$data3.me) === null || _response$data3$me === void 0 ? void 0 : _response$data3$me.favorites) || []).filter(function (f) {
    return !!f.favorited;
  }).map(function (f) {
    return (0, _objectSpread2.default)({}, f.favorited, {
      favoriteUUID: f.favorited.uuid
    });
  });
  var favoritedContacts = (0, _contacts.initialContactsSelector)(state)(favorites);
  dispatch({
    type: c.GET_FAVORITES_SUCCESS,
    payload: favoritedContacts
  });
  var contacts = favoritedContacts.concat(callHistory.map(function (c) {
    return c.contact;
  })).filter(function (c) {
    return !!c;
  });
  dispatch({
    type: c.CONTACT_RECORDS_PARTIAL_LOAD,
    payload: contacts
  });
};

var retrieveMeFromGql =
/*#__PURE__*/
function () {
  var _ref23 = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee12(dispatch) {
    var _ref24, _ref25, response;

    return _regenerator.default.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return dispatch({
              type: c.GQL_QUERY,
              payload: {
                query: _meQuery.default,
                fetchPolicy: 'network-only'
              }
            });

          case 2:
            _ref24 = _context12.sent;
            _ref25 = (0, _slicedToArray2.default)(_ref24, 1);
            response = _ref25[0];
            return _context12.abrupt("return", response);

          case 6:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));

  return function retrieveMeFromGql(_x18) {
    return _ref23.apply(this, arguments);
  };
}();

var getMe = function getMe() {
  return (
    /*#__PURE__*/
    function () {
      var _ref26 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee13(dispatch, getState) {
        var response, state, callHistory;
        return _regenerator.default.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return retrieveMeFromGql(dispatch);

              case 2:
                response = _context13.sent;
                state = getState();
                callHistory = loadCallHistoryFromMe(dispatch, response, state);
                loadContactFavoritesFromMe(dispatch, response, state, callHistory);

              case 6:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      return function (_x19, _x20) {
        return _ref26.apply(this, arguments);
      };
    }()
  );
};

exports.getMe = getMe;

var loadByExtensions = function loadByExtensions() {
  var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return (
    /*#__PURE__*/
    function () {
      var _ref27 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee14(dispatch, getState) {
        var _getState$nucleus, _getState$nucleus$con, _response$data4;

        var _ref28, _ref29, response, records, contacts;

        return _regenerator.default.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (!(!extensions.length || ((_getState$nucleus = getState().nucleus) === null || _getState$nucleus === void 0 ? void 0 : (_getState$nucleus$con = _getState$nucleus.contacts) === null || _getState$nucleus$con === void 0 ? void 0 : _getState$nucleus$con.contactsLoaded))) {
                  _context14.next = 2;
                  break;
                }

                return _context14.abrupt("return");

              case 2:
                _context14.next = 4;
                return dispatch({
                  type: c.GQL_QUERY,
                  payload: {
                    query: _loadByExtensionsQuery.default,
                    variables: {
                      extensions: extensions
                    }
                  }
                });

              case 4:
                _ref28 = _context14.sent;
                _ref29 = (0, _slicedToArray2.default)(_ref28, 1);
                response = _ref29[0];
                records = (response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.directoryByExtensions) || [];
                contacts = (0, _contacts.initialContactsSelector)(getState())(records.filter(function (r) {
                  return !!r;
                }));
                dispatch({
                  type: c.CONTACT_RECORDS_PARTIAL_LOAD,
                  payload: contacts
                });
                return _context14.abrupt("return", contacts);

              case 11:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      return function (_x21, _x22) {
        return _ref27.apply(this, arguments);
      };
    }()
  );
};

exports.loadByExtensions = loadByExtensions;

var loadByUUIDs = function loadByUUIDs() {
  var uuids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return (
    /*#__PURE__*/
    function () {
      var _ref30 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee15(dispatch, getState) {
        var _getState$nucleus2, _getState$nucleus2$co, _response$data5;

        var _ref31, _ref32, response, records, contacts;

        return _regenerator.default.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (!(!uuids.length || ((_getState$nucleus2 = getState().nucleus) === null || _getState$nucleus2 === void 0 ? void 0 : (_getState$nucleus2$co = _getState$nucleus2.contacts) === null || _getState$nucleus2$co === void 0 ? void 0 : _getState$nucleus2$co.contactsLoaded))) {
                  _context15.next = 2;
                  break;
                }

                return _context15.abrupt("return");

              case 2:
                _context15.next = 4;
                return dispatch({
                  type: c.GQL_QUERY,
                  payload: {
                    query: _loadByUuidsQuery.default,
                    variables: {
                      uuids: uuids
                    }
                  }
                });

              case 4:
                _ref31 = _context15.sent;
                _ref32 = (0, _slicedToArray2.default)(_ref31, 1);
                response = _ref32[0];
                records = (response === null || response === void 0 ? void 0 : (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.directoryByUUIDs) || [];
                contacts = (0, _contacts.initialContactsSelector)(getState())(records.filter(function (r) {
                  return !!r;
                }));
                dispatch({
                  type: c.CONTACT_RECORDS_PARTIAL_LOAD,
                  payload: contacts
                });
                return _context15.abrupt("return", contacts);

              case 11:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));

      return function (_x23, _x24) {
        return _ref30.apply(this, arguments);
      };
    }()
  );
};

exports.loadByUUIDs = loadByUUIDs;

var loadByUUID = function loadByUUID(uuid) {
  return (
    /*#__PURE__*/
    function () {
      var _ref33 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee16(dispatch, getState) {
        var _response$data6;

        var _ref34, _ref35, response, contact, populatedContact;

        return _regenerator.default.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return dispatch({
                  type: c.GQL_QUERY,
                  payload: {
                    query: _loadByUuidQuery.default,
                    variables: {
                      uuid: uuid
                    },
                    fetchPolicy: 'network-only'
                  }
                });

              case 2:
                _ref34 = _context16.sent;
                _ref35 = (0, _slicedToArray2.default)(_ref34, 1);
                response = _ref35[0];
                contact = response === null || response === void 0 ? void 0 : (_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.contact;
                populatedContact = contact && (0, _contacts.mapIndividualContact)(getState())(contact);

                if (populatedContact) {
                  dispatch({
                    type: c.CONTACT_RECORDS_PARTIAL_LOAD,
                    payload: [populatedContact]
                  });
                }

                return _context16.abrupt("return", populatedContact);

              case 9:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }));

      return function (_x25, _x26) {
        return _ref33.apply(this, arguments);
      };
    }()
  );
};

exports.loadByUUID = loadByUUID;

var loadByUUIDWithRetry = function loadByUUIDWithRetry(uuid) {
  var attemptLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  var delayMs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 250;
  return (
    /*#__PURE__*/
    function () {
      var _ref36 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee17(dispatch) {
        var contact, count;
        return _regenerator.default.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return dispatch(loadByUUID(uuid));

              case 2:
                contact = _context17.sent;
                count = 1;

              case 4:
                if (!(count < attemptLimit && !contact)) {
                  _context17.next = 13;
                  break;
                }

                _context17.next = 7;
                return (0, _delay.default)(delayMs + count * 150);

              case 7:
                _context17.next = 9;
                return dispatch(loadByUUID(uuid));

              case 9:
                contact = _context17.sent;
                count += 1;
                _context17.next = 4;
                break;

              case 13:
                return _context17.abrupt("return", contact);

              case 14:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }));

      return function (_x27) {
        return _ref36.apply(this, arguments);
      };
    }()
  );
}; // debounce search to 250 with search happening at trailing end of the debounce.


exports.loadByUUIDWithRetry = loadByUUIDWithRetry;
var debouncedSearch = (0, _debounce.default)(doSearch, 250, {
  trailing: true
});

function search(searchString) {
  var contactTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var debounce = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return (
    /*#__PURE__*/
    function () {
      var _ref37 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee18(dispatch, getState) {
        var state, isConnected, lastSearchString, sequenceNumber, searchFunction;
        return _regenerator.default.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                if (!(!searchString || typeof searchString !== 'string' || !searchString.trim())) {
                  _context18.next = 2;
                  break;
                }

                return _context18.abrupt("return");

              case 2:
                state = getState(); // exit early if wamp is not connected

                isConnected = (0, _services.selectConnected)(state);

                if (isConnected) {
                  _context18.next = 6;
                  break;
                }

                return _context18.abrupt("return");

              case 6:
                // exit early if searching previous string
                lastSearchString = (0, _get.default)(state, 'nucleus.directory.searchString');

                if (!(lastSearchString === searchString)) {
                  _context18.next = 9;
                  break;
                }

                return _context18.abrupt("return");

              case 9:
                dispatch({
                  type: c.SEARCHSTRING_UPDATE,
                  payload: searchString
                }); // obtain current sequence number, to be passed to the search function

                sequenceNumber = (0, _directory.selectSequenceNumber)(getState());
                searchFunction = debounce ? debouncedSearch : doSearch;
                _context18.next = 14;
                return searchFunction(dispatch, getState, contactTypes, searchString, sequenceNumber);

              case 14:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }));

      return function (_x28, _x29) {
        return _ref37.apply(this, arguments);
      };
    }()
  );
}

function loadContactIfNotPresent(uuid) {
  return (
    /*#__PURE__*/
    function () {
      var _ref38 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee19(dispatch, getState) {
        var contact;
        return _regenerator.default.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                contact = (0, _contacts.getContactByUuidGenerator)(getState())(uuid);

                if (!contact) {
                  _context19.next = 3;
                  break;
                }

                return _context19.abrupt("return");

              case 3:
                _context19.next = 5;
                return dispatch(loadByUUID(uuid));

              case 5:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19);
      }));

      return function (_x30, _x31) {
        return _ref38.apply(this, arguments);
      };
    }()
  );
}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearSession = clearSession;
exports.revoked = exports.leaveCurrentAndAnswer = exports.transitionToCall = exports.leaveCurrent = exports.leave = exports.join = exports.REMOTE_MOD_REVOKED_EVENT = exports.REMOTE_MOD_REVOKED = exports.REMOTE_MOD_TRANSITION_TO_CALL_FAILURE = exports.REMOTE_MOD_TRANSITION_TO_CALL_SUCCESS = exports.REMOTE_MOD_TRANSITION_TO_CALL_REQUEST = exports.REMOTE_MOD_LEAVE_FAILURE = exports.REMOTE_MOD_LEAVE_SUCCESS = exports.REMOTE_MOD_LEAVE_REQUEST = exports.REMOTE_MOD_JOIN_FAILURE = exports.REMOTE_MOD_JOIN_SUCCESS = exports.REMOTE_MOD_JOIN_REQUEST = exports.REMOTE_MOD_CLEAR_SESSION = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _get = _interopRequireDefault(__webpack_require__(11));

var C = _interopRequireWildcard(__webpack_require__(3));

var _guid = _interopRequireDefault(__webpack_require__(72));

var _call = __webpack_require__(50);

var _proxy = __webpack_require__(21);

var _awaitAction = __webpack_require__(145);

var _conference = __webpack_require__(53);

var _remoteModeration = __webpack_require__(276);

// Action Types
var REMOTE_MOD_CLEAR_SESSION = 'REMOTE_MOD_CLEAR_SESSION';
exports.REMOTE_MOD_CLEAR_SESSION = REMOTE_MOD_CLEAR_SESSION;
var REMOTE_MOD_JOIN_REQUEST = 'REMOTE_MOD_JOIN_REQUEST';
exports.REMOTE_MOD_JOIN_REQUEST = REMOTE_MOD_JOIN_REQUEST;
var REMOTE_MOD_JOIN_SUCCESS = 'REMOTE_MOD_JOIN_SUCCESS';
exports.REMOTE_MOD_JOIN_SUCCESS = REMOTE_MOD_JOIN_SUCCESS;
var REMOTE_MOD_JOIN_FAILURE = 'REMOTE_MOD_JOIN_FAILURE';
exports.REMOTE_MOD_JOIN_FAILURE = REMOTE_MOD_JOIN_FAILURE;
var REMOTE_MOD_LEAVE_REQUEST = 'REMOTE_MOD_LEAVE_REQUEST';
exports.REMOTE_MOD_LEAVE_REQUEST = REMOTE_MOD_LEAVE_REQUEST;
var REMOTE_MOD_LEAVE_SUCCESS = 'REMOTE_MOD_LEAVE_SUCCESS';
exports.REMOTE_MOD_LEAVE_SUCCESS = REMOTE_MOD_LEAVE_SUCCESS;
var REMOTE_MOD_LEAVE_FAILURE = 'REMOTE_MOD_LEAVE_FAILURE';
exports.REMOTE_MOD_LEAVE_FAILURE = REMOTE_MOD_LEAVE_FAILURE;
var REMOTE_MOD_TRANSITION_TO_CALL_REQUEST = 'REMOTE_MOD_TRANSITION_TO_CALL_REQUEST';
exports.REMOTE_MOD_TRANSITION_TO_CALL_REQUEST = REMOTE_MOD_TRANSITION_TO_CALL_REQUEST;
var REMOTE_MOD_TRANSITION_TO_CALL_SUCCESS = 'REMOTE_MOD_TRANSITION_TO_CALL_SUCCESS';
exports.REMOTE_MOD_TRANSITION_TO_CALL_SUCCESS = REMOTE_MOD_TRANSITION_TO_CALL_SUCCESS;
var REMOTE_MOD_TRANSITION_TO_CALL_FAILURE = 'REMOTE_MOD_TRANSITION_TO_CALL_FAILURE';
exports.REMOTE_MOD_TRANSITION_TO_CALL_FAILURE = REMOTE_MOD_TRANSITION_TO_CALL_FAILURE;
var REMOTE_MOD_REVOKED = 'REMOTE_MOD_REVOKED'; // Other Constants

exports.REMOTE_MOD_REVOKED = REMOTE_MOD_REVOKED;
var JOIN_COMMAND = 'remoteModeratorJoin';
var JOIN_SUCCESS_EVENT = 'remoteModeratorJoined';
var JOIN_FAILURE_EVENT = 'remoteModeratorJoinFailure';
var LEAVE_COMMAND = 'remoteModeratorLeave';
var LEAVE_SUCCESS_EVENT = 'remoteModeratorLeaveSuccess';
var LEAVE_FAILURE_EVENT = 'remoteModeratorLeaveFailure';
var REMOTE_MOD_REVOKED_EVENT = 'remoteModeratorRevoke';
exports.REMOTE_MOD_REVOKED_EVENT = REMOTE_MOD_REVOKED_EVENT;

function clearSession() {
  return {
    type: REMOTE_MOD_CLEAR_SESSION
  };
}

var join = function join(extension) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch) {
        var messageId, params, joinPromise, result;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                messageId = _guid.default.create();
                params = {
                  event: JOIN_COMMAND,
                  extension: extension,
                  messageId: messageId
                };
                _context.prev = 2;
                dispatch(joinRequest(extension, messageId));
                joinPromise = dispatch(awaitJoinResult(messageId));
                dispatch((0, _proxy.proxyApiCall)(C.GALAXY_TOPIC_MODERATOR_ACTIONS, C.GALAXY_WAMP_URI_SUFFIX_DEFAULT, C.GALAXY_HTTP_METHOD_DEFAULT, params));
                _context.next = 8;
                return joinPromise;

              case 8:
                result = _context.sent;
                dispatch(joinSuccess(result));
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](2);
                dispatch(joinFailure(_context.t0));

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 12]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

exports.join = join;

var leave = function leave(conferenceId) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch) {
        var messageId, params, promise, result;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                messageId = _guid.default.create();
                params = {
                  event: LEAVE_COMMAND,
                  conferenceId: conferenceId,
                  messageId: messageId
                };
                _context2.prev = 2;
                dispatch(leaveRequest(conferenceId, messageId));
                promise = dispatch(awaitLeaveResult(messageId));
                dispatch((0, _proxy.proxyApiCall)(C.GALAXY_TOPIC_MODERATOR_ACTIONS, C.GALAXY_WAMP_URI_SUFFIX_DEFAULT, C.GALAXY_HTTP_METHOD_DEFAULT, params));
                _context2.next = 8;
                return promise;

              case 8:
                result = _context2.sent;
                dispatch(leaveSuccess(result));
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](2);
                dispatch(leaveFailure(_context2.t0));

              case 15:
                _context2.prev = 15;
                _context2.next = 18;
                return dispatch((0, _call.unsubscribeFromConference)(conferenceId));

              case 18:
                return _context2.finish(15);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 12, 15, 19]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
};

exports.leave = leave;

var leaveCurrent = function leaveCurrent() {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(dispatch, getState) {
        var state, conferenceId;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                state = getState();
                conferenceId = (0, _conference.selectConferenceId)(state);

                if (!conferenceId) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 5;
                return dispatch(leave(conferenceId));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
};

exports.leaveCurrent = leaveCurrent;

var transitionToCall = function transitionToCall() {
  return (
    /*#__PURE__*/
    function () {
      var _ref4 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(dispatch, getState) {
        var state, extension;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                state = getState();
                extension = (0, _remoteModeration.selectExtension)(state);
                _context4.prev = 2;
                dispatch({
                  type: REMOTE_MOD_TRANSITION_TO_CALL_REQUEST
                });
                _context4.next = 6;
                return dispatch(leaveCurrent());

              case 6:
                _context4.next = 8;
                return dispatch((0, _call.call)(extension, {
                  audio: false,
                  video: false
                }));

              case 8:
                dispatch({
                  type: REMOTE_MOD_TRANSITION_TO_CALL_SUCCESS
                });
                _context4.next = 14;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](2);
                dispatch({
                  type: REMOTE_MOD_TRANSITION_TO_CALL_FAILURE,
                  payload: {
                    error: _context4.t0
                  }
                });

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[2, 11]]);
      }));

      return function (_x5, _x6) {
        return _ref4.apply(this, arguments);
      };
    }()
  );
};

exports.transitionToCall = transitionToCall;

var leaveCurrentAndAnswer = function leaveCurrentAndAnswer(incomingCall) {
  return (
    /*#__PURE__*/
    function () {
      var _ref5 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(dispatch) {
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return dispatch(leaveCurrent());

              case 2:
                dispatch((0, _call.answer)(incomingCall));

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x7) {
        return _ref5.apply(this, arguments);
      };
    }()
  );
};

exports.leaveCurrentAndAnswer = leaveCurrentAndAnswer;

var revoked = function revoked(payload) {
  return (
    /*#__PURE__*/
    function () {
      var _ref6 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(dispatch, getState) {
        var conferenceId, payloadConferenceId;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                conferenceId = (0, _conference.selectConferenceId)(getState());
                payloadConferenceId = (0, _get.default)(payload, 'conferenceId'); // confirm the revokation event is for the current conference

                if (!(conferenceId !== payloadConferenceId)) {
                  _context6.next = 4;
                  break;
                }

                return _context6.abrupt("return");

              case 4:
                _context6.next = 6;
                return dispatch((0, _call.unsubscribeFromConference)(conferenceId));

              case 6:
                dispatch({
                  type: REMOTE_MOD_REVOKED
                });

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x8, _x9) {
        return _ref6.apply(this, arguments);
      };
    }()
  );
};

exports.revoked = revoked;

function joinRequest(extension, messageId) {
  return {
    type: REMOTE_MOD_JOIN_REQUEST,
    payload: {
      extension: extension,
      messageId: messageId
    }
  };
}

function joinSuccess(payload) {
  return {
    type: REMOTE_MOD_JOIN_SUCCESS,
    payload: payload
  };
}

function joinFailure(payload) {
  return {
    type: REMOTE_MOD_JOIN_FAILURE,
    payload: payload
  };
}

function leaveRequest(conferenceId, messageId) {
  return {
    type: REMOTE_MOD_LEAVE_REQUEST,
    payload: {
      conferenceId: conferenceId,
      messageId: messageId
    }
  };
}

function leaveSuccess(payload) {
  return {
    type: REMOTE_MOD_LEAVE_SUCCESS,
    payload: payload
  };
}

function leaveFailure(payload) {
  return {
    type: REMOTE_MOD_LEAVE_FAILURE,
    payload: payload
  };
}

function awaitJoinResult(messageId) {
  return (0, _awaitAction.awaitAction)(shouldJoinResolve(messageId), shouldJoinReject(messageId));
}

function shouldJoinResolve(messageId) {
  return function (action) {
    return (0, _get.default)(action, 'payload.referenceId') === messageId && (0, _get.default)(action, 'payload.event') === JOIN_SUCCESS_EVENT;
  };
}

function shouldJoinReject(messageId) {
  return function (action) {
    return (0, _get.default)(action, 'payload.referenceId') === messageId && (0, _get.default)(action, 'payload.event') === JOIN_FAILURE_EVENT;
  };
}

function awaitLeaveResult(messageId) {
  return (0, _awaitAction.awaitAction)(shouldLeaveResolve(messageId), shouldLeaveReject(messageId));
}

function shouldLeaveResolve(messageId) {
  return function (action) {
    return (0, _get.default)(action, 'payload.referenceId') === messageId && (0, _get.default)(action, 'payload.event') === LEAVE_SUCCESS_EVENT;
  };
}

function shouldLeaveReject(messageId) {
  return function (action) {
    return (0, _get.default)(action, 'payload.referenceId') === messageId && (0, _get.default)(action, 'payload.event') === LEAVE_FAILURE_EVENT;
  };
}

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return of; });
/* harmony import */ var _util_isScheduler__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27);
/* harmony import */ var _fromArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66);
/* harmony import */ var _scheduled_scheduleArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(115);
/** PURE_IMPORTS_START _util_isScheduler,_fromArray,_scheduled_scheduleArray PURE_IMPORTS_END */



function of() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var scheduler = args[args.length - 1];
    if (Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_0__[/* isScheduler */ "a"])(scheduler)) {
        args.pop();
        return Object(_scheduled_scheduleArray__WEBPACK_IMPORTED_MODULE_2__[/* scheduleArray */ "a"])(args, scheduler);
    }
    else {
        return Object(_fromArray__WEBPACK_IMPORTED_MODULE_1__[/* fromArray */ "a"])(args);
    }
}
//# sourceMappingURL=of.js.map


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/redux-saga/es/internal/utils.js
var utils = __webpack_require__(2);

// CONCATENATED MODULE: ./node_modules/redux-saga/es/internal/sagaHelpers/fsmIterator.js


var done = { done: true, value: undefined };
var qEnd = {};

function safeName(patternOrChannel) {
  if (utils["q" /* is */].channel(patternOrChannel)) {
    return 'channel';
  } else if (Array.isArray(patternOrChannel)) {
    return String(patternOrChannel.map(function (entry) {
      return String(entry);
    }));
  } else {
    return String(patternOrChannel);
  }
}

function fsmIterator(fsm, q0) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';

  var updateState = void 0,
      qNext = q0;

  function next(arg, error) {
    if (qNext === qEnd) {
      return done;
    }

    if (error) {
      qNext = qEnd;
      throw error;
    } else {
      updateState && updateState(arg);

      var _fsm$qNext = fsm[qNext](),
          q = _fsm$qNext[0],
          output = _fsm$qNext[1],
          _updateState = _fsm$qNext[2];

      qNext = q;
      updateState = _updateState;
      return qNext === qEnd ? done : output;
    }
  }

  return Object(utils["t" /* makeIterator */])(next, function (error) {
    return next(null, error);
  }, name, true);
}
// EXTERNAL MODULE: ./node_modules/redux-saga/es/internal/io.js
var io = __webpack_require__(18);

// EXTERNAL MODULE: ./node_modules/redux-saga/es/internal/channel.js
var internal_channel = __webpack_require__(32);

// CONCATENATED MODULE: ./node_modules/redux-saga/es/internal/sagaHelpers/takeEvery.js




function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(io["s" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: io["k" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };

  var action = void 0,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === internal_channel["a" /* END */] ? [qEnd] : ['q1', yFork(action)];
    }
  }, 'q1', 'takeEvery(' + safeName(patternOrChannel) + ', ' + worker.name + ')');
}
// CONCATENATED MODULE: ./node_modules/redux-saga/es/internal/sagaHelpers/takeLatest.js




function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(io["s" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: io["k" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yCancel = function yCancel(task) {
    return { done: false, value: Object(io["f" /* cancel */])(task) };
  };

  var task = void 0,
      action = void 0;
  var setTask = function setTask(t) {
    return task = t;
  };
  var setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === internal_channel["a" /* END */] ? [qEnd] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
    },
    q3: function q3() {
      return ['q1', yFork(action), setTask];
    }
  }, 'q1', 'takeLatest(' + safeName(patternOrChannel) + ', ' + worker.name + ')');
}
// EXTERNAL MODULE: ./node_modules/redux-saga/es/internal/buffers.js
var buffers = __webpack_require__(76);

// CONCATENATED MODULE: ./node_modules/redux-saga/es/internal/sagaHelpers/throttle.js






function throttle(delayLength, pattern, worker) {
  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action = void 0,
      channel = void 0;

  var yActionChannel = { done: false, value: Object(io["a" /* actionChannel */])(pattern, buffers["a" /* buffers */].sliding(1)) };
  var yTake = function yTake() {
    return { done: false, value: Object(io["s" /* take */])(channel) };
  };
  var yFork = function yFork(ac) {
    return { done: false, value: io["k" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yDelay = { done: false, value: Object(io["e" /* call */])(utils["m" /* delay */], delayLength) };

  var setAction = function setAction(ac) {
    return action = ac;
  };
  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return fsmIterator({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === internal_channel["a" /* END */] ? [qEnd] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    }
  }, 'q1', 'throttle(' + safeName(pattern) + ', ' + worker.name + ')');
}
// CONCATENATED MODULE: ./node_modules/redux-saga/es/internal/sagaHelpers/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sagaHelpers_takeEvery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return sagaHelpers_takeLatest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return sagaHelpers_throttle; });
/* concated harmony reexport takeEveryHelper */__webpack_require__.d(__webpack_exports__, "b", function() { return takeEvery; });
/* concated harmony reexport takeLatestHelper */__webpack_require__.d(__webpack_exports__, "d", function() { return takeLatest; });
/* concated harmony reexport throttleHelper */__webpack_require__.d(__webpack_exports__, "f", function() { return throttle; });






var deprecationWarning = function deprecationWarning(helperName) {
  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
};

var sagaHelpers_takeEvery = /*#__PURE__*/Object(utils["n" /* deprecate */])(takeEvery, /*#__PURE__*/deprecationWarning('takeEvery'));
var sagaHelpers_takeLatest = /*#__PURE__*/Object(utils["n" /* deprecate */])(takeLatest, /*#__PURE__*/deprecationWarning('takeLatest'));
var sagaHelpers_throttle = /*#__PURE__*/Object(utils["n" /* deprecate */])(throttle, /*#__PURE__*/deprecationWarning('throttle'));



/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(99),
    getRawTag = __webpack_require__(302),
    objectToString = __webpack_require__(303);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(310),
    getValue = __webpack_require__(313);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(396),
    baseMatchesProperty = __webpack_require__(399),
    identity = __webpack_require__(177),
    isArray = __webpack_require__(43),
    property = __webpack_require__(400);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectDirectMediaEnabled = exports.galaxyCallsEnabled = exports.getAccountSettings = exports.getAccountFeature = exports.getAccountFeatures = void 0;

var _get = _interopRequireDefault(__webpack_require__(11));

var _reselect = __webpack_require__(23);

var c = _interopRequireWildcard(__webpack_require__(3));

var account = function account(state) {
  return (0, _get.default)(state, 'nucleus.account') || {};
};
/**
 * Returns all account features
 * @example
 * getAccountFeatures(state)
 * Returns...object with all account features
 */


var getAccountFeatures = (0, _reselect.createSelector)(account, function (a) {
  return a.features;
});
/**
 * Returns the value of a specific account feature
 * @example
 * getAccountFeature(state)('directMedia')
 * Returns...true/false
 */

exports.getAccountFeatures = getAccountFeatures;
var getAccountFeature = (0, _reselect.createSelector)(account, function (a) {
  return (0, _reselect.defaultMemoize)(function (feature) {
    return (0, _get.default)(a.features, feature) || false;
  });
});
exports.getAccountFeature = getAccountFeature;
var getAccountSettings = (0, _reselect.createSelector)(account, function (a) {
  return a.settings;
});
exports.getAccountSettings = getAccountSettings;

var galaxyCallsEnabled = function galaxyCallsEnabled(state) {
  var accountFeatures = getAccountFeatures(state);
  return (0, _get.default)(accountFeatures, c.ACCOUNT_FEATURE_GALAXY) || (0, _get.default)(accountFeatures, c.ACCOUNT_FEATURE_DIRECT_MEDIA);
};

exports.galaxyCallsEnabled = galaxyCallsEnabled;

var selectDirectMediaEnabled = function selectDirectMediaEnabled(state) {
  var accountFeatures = getAccountFeatures(state);
  return (0, _get.default)(accountFeatures, c.ACCOUNT_FEATURE_DIRECT_MEDIA);
};

exports.selectDirectMediaEnabled = selectDirectMediaEnabled;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectParticipantList = selectParticipantList;
exports.selectParticipantsMap = selectParticipantsMap;
exports.selectCurrentUserParticipant = selectCurrentUserParticipant;
exports.assignParticipantRoles = assignParticipantRoles;
exports.selectIsParticipantHandRaised = selectIsParticipantHandRaised;
exports.selectParticipantHandRaisedTimestamp = selectParticipantHandRaisedTimestamp;
exports.selectIsProcessingParticipantHandCommand = selectIsProcessingParticipantHandCommand;
exports.selectIsCurrentUserHandRaised = selectIsCurrentUserHandRaised;
exports.selectParticipantsWithRaisedHands = exports.selectParticipantListSorted = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _get = _interopRequireDefault(__webpack_require__(11));

var _reselect = __webpack_require__(23);

var _currentUser = __webpack_require__(37);

var conferenceSelectors = _interopRequireWildcard(__webpack_require__(53));

var _moderator = __webpack_require__(93);

var participantsFromMapSelector = (0, _reselect.createSelector)(conferenceSelectors.selectOwnerUuid, conferenceSelectors.selectLecturerUuid, selectParticipantsMap, _moderator.selectModeratorsMap, _currentUser.getUserUUID, _moderator.selectIsCurrentUserModerator, conferenceSelectors.selectCanCurrentUserKickParticipants, selectParticipantsFromMap);

function selectParticipantList(state) {
  return participantsFromMapSelector(state);
}
/**
 * Memoized selector that sorts by the participant's name prop.
 */


var selectParticipantListSorted = (0, _reselect.createSelector)(participantsFromMapSelector, function (participants) {
  return participants.sort(function (a, b) {
    return a.name > b.name ? 1 : -1;
  });
});
/**
 * Selects the conference's participant map as it is stored in the redux store.
 * @param {*} state The full state object from the redux store.
 * @returns {Map} An ES6 Map object that contains the conference participants keyed by their UUID
 */

exports.selectParticipantListSorted = selectParticipantListSorted;

function selectParticipantsMap(state) {
  return (0, _get.default)(state, 'nucleus.conference.participants');
}

function selectCurrentUserParticipant(state) {
  var map = selectParticipantsMap(state);
  var userUUID = (0, _currentUser.getUserUUID)(state);
  return Array.from(map.values()).find(function (p) {
    return p.uuid === userUUID;
  });
}

function selectParticipantsFromMap(ownerUuid, lecturerUuid, map, moderatorsMap, currentUserUUID, currentUserIsModerator, canCurrentUserKickParticipants) {
  var participants = Array.from(map.values(), function (p) {
    return parseParticipant(p, currentUserUUID);
  }).map(function (p) {
    return assignParticipantRoles(p, ownerUuid, lecturerUuid, moderatorsMap);
  }).map(function (p) {
    return assignCurrentUserParticipantPermissions(p, currentUserIsModerator, canCurrentUserKickParticipants);
  });
  moveSelfToFront(participants);
  return participants;
}

function parseParticipant(participant, currentUserUUID) {
  var uuid = (0, _get.default)(participant, 'uuid');
  var isSelf = uuid === currentUserUUID;
  return (0, _objectSpread2.default)({}, participant, {
    isSelf: isSelf,
    localAudioMuteState: !!(0, _get.default)(participant, 'localMuteState'),
    serverAudioMuteState: !!(0, _get.default)(participant, 'serverMuteState'),
    localVideoMuteState: false,
    serverVideoMuteState: false
  });
}

function assignParticipantRoles(participant, ownerUuid, lecturerUuid, moderators) {
  var uuid = (0, _get.default)(participant, 'uuid');
  return (0, _objectSpread2.default)({}, participant, {
    isLecturer: uuid === lecturerUuid,
    isModerator: moderators && moderators.has(uuid),
    isOwner: uuid === ownerUuid
  });
}

function selectIsParticipantHandRaised(state, participantId) {
  var participants = selectParticipantsMap(state);
  return (0, _get.default)(participants.get(participantId), 'handRaised');
}

function selectParticipantHandRaisedTimestamp(state, participantId) {
  var participants = selectParticipantsMap(state);
  return (0, _get.default)(participants.get(participantId), 'handRaisedTimestamp');
}

function selectIsProcessingParticipantHandCommand(state, participantId) {
  var participants = selectParticipantsMap(state);
  return !!(0, _get.default)(participants.get(participantId), 'processingModeratorHandCommand');
}

function selectIsCurrentUserHandRaised(state) {
  var selfParticipantId = (0, _get.default)(selectCurrentUserParticipant(state), 'participantId');
  return selectIsParticipantHandRaised(state, selfParticipantId);
}
/**
 * selectParticipantsWithRaisedHands
 * Returns a selector that provides a list of all participants with raised hands,
 * sorted by the oldest timestamp first. Ties are ordered by participant ID.
 * Results are memoized by default and only recalculated as necessary.
 * @param {object} state - current state to pull conference participants list from
 */


var selectParticipantsWithRaisedHands = (0, _reselect.createSelector)(selectParticipantList, function (participants) {
  var handRaisedParticipants = participants.filter(function (x) {
    return x.handRaised;
  });
  return handRaisedParticipants.sort(participantHandRaisedSort);
}); // Older timestamps have lower values and thus should come first.
// If two values have the same timestamp, we order by participant ID to keep consistent ordering.

exports.selectParticipantsWithRaisedHands = selectParticipantsWithRaisedHands;

var participantHandRaisedSort = function participantHandRaisedSort(a, b) {
  var aRaised = (0, _get.default)(a, 'handRaisedTimestamp');
  var bRaised = (0, _get.default)(b, 'handRaisedTimestamp');
  var aId = (0, _get.default)(a, 'participantId');
  var bId = (0, _get.default)(b, 'participantId'); // Only compare ID if timestamps equal

  var timestampSort = aRaised - bRaised;
  return timestampSort || aId && aId.localeCompare(bId);
};

function assignCurrentUserParticipantPermissions(participant, isCurrentUserMod, canCurrentUserKickParticipants) {
  var isSelf = (0, _get.default)(participant, 'isSelf');
  var isPresenting = (0, _get.default)(participant, 'isPresenting');
  return (0, _objectSpread2.default)({}, participant, {
    canBeMuted: !isSelf && isCurrentUserMod,
    canBeKicked: !isSelf && canCurrentUserKickParticipants,
    canPresentationBeStopped: !isSelf && isPresenting && isCurrentUserMod
  });
}

function moveSelfToFront(participants) {
  for (var i = 0; i < participants.length; i++) {
    var isSelf = (0, _get.default)(participants[i], 'isSelf');

    if (isSelf) {
      var self = participants.splice(i, 1);
      participants.unshift(self[0]);
      break;
    }
  }
}

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectCanCurrentUserKickAll = selectCanCurrentUserKickAll;
exports.selectCanLowerParticipantHand = exports.selectIsCurrentUserModerator = exports.selectCanLowerAllHands = exports.selectModeratorsMap = void 0;

var _lodash = __webpack_require__(82);

var C = _interopRequireWildcard(__webpack_require__(3));

var _currentUser = __webpack_require__(37);

var _conference = __webpack_require__(53);

var _remoteModerators = __webpack_require__(246);

var _participants = __webpack_require__(92);

var selectModeratorsMap = function selectModeratorsMap(state) {
  return (0, _lodash.get)(state, 'nucleus.conference.moderators');
};

exports.selectModeratorsMap = selectModeratorsMap;

var selectCanLowerAllHands = function selectCanLowerAllHands(state) {
  var currentUserModerator = selectIsCurrentUserModerator(state);
  var hasConferenceId = !!(0, _conference.selectConferenceId)(state);
  return currentUserModerator && hasConferenceId;
};

exports.selectCanLowerAllHands = selectCanLowerAllHands;

var selectGalaxyConferenceModerator = function selectGalaxyConferenceModerator(state) {
  return (0, _lodash.get)(state, 'nucleus.galaxy.conference.moderator');
};

var selectIsCurrentUserModerator = function selectIsCurrentUserModerator(state) {
  var userUuid = (0, _currentUser.getUserUUID)(state);
  var moderatorsMap = selectModeratorsMap(state);
  var remoteModeratorsMap = (0, _remoteModerators.selectRemoteModeratorsMap)(state);
  var galaxyConferenceModerator = selectGalaxyConferenceModerator(state);
  var userIsModerator = moderatorsMap && moderatorsMap.has(userUuid);
  var userIsRemoteModerator = remoteModeratorsMap && remoteModeratorsMap.has(userUuid);
  var userIsLegacyModerator = galaxyConferenceModerator === userUuid;
  return !!userIsModerator || !!userIsRemoteModerator || !!userIsLegacyModerator;
};

exports.selectIsCurrentUserModerator = selectIsCurrentUserModerator;

var selectCanLowerParticipantHand = function selectCanLowerParticipantHand(state, participantId) {
  var isInConference = !!(0, _conference.selectConferenceId)(state);
  var isModerator = selectIsCurrentUserModerator(state);
  var participantsMap = (0, _participants.selectParticipantsMap)(state);
  var participantInSameConference = !!participantsMap.get(participantId);
  var participantHandRaised = (0, _participants.selectIsParticipantHandRaised)(state, participantId);
  var isProcessingHand = (0, _participants.selectIsProcessingParticipantHandCommand)(state, participantId);
  return isInConference && isModerator && participantInSameConference && participantHandRaised && !isProcessingHand;
};

exports.selectCanLowerParticipantHand = selectCanLowerParticipantHand;

function selectCanCurrentUserKickAll(state) {
  // check if current user is moderator
  if (!selectIsCurrentUserModerator(state)) return false; // if conference type is VMR, moderator can always kick all

  if ((0, _conference.selectConferenceType)(state) === C.GALAXY_CONFERENCE_TYPE_VMR) return true; // otherwise, conference needs to be escalated in order to be able to kick all

  return (0, _conference.selectConferenceState)(state) === C.GALAXY_CONFERENCE_STATE_ESCALATED;
}

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pipeFromArray; });
/* harmony import */ var _identity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42);
/** PURE_IMPORTS_START _identity PURE_IMPORTS_END */

function pipe() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return pipeFromArray(fns);
}
function pipeFromArray(fns) {
    if (fns.length === 0) {
        return _identity__WEBPACK_IMPORTED_MODULE_0__[/* identity */ "a"];
    }
    if (fns.length === 1) {
        return fns[0];
    }
    return function piped(input) {
        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
    };
}
//# sourceMappingURL=pipe.js.map


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rxSubscriber; });
/* unused harmony export $$rxSubscriber */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var rxSubscriber = /*@__PURE__*/ (function () {
    return typeof Symbol === 'function'
        ? /*@__PURE__*/ Symbol('rxSubscriber')
        : '@@rxSubscriber_' + /*@__PURE__*/ Math.random();
})();
var $$rxSubscriber = rxSubscriber;
//# sourceMappingURL=rxSubscriber.js.map


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UnsubscriptionError; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var UnsubscriptionErrorImpl = /*@__PURE__*/ (function () {
    function UnsubscriptionErrorImpl(errors) {
        Error.call(this);
        this.message = errors ?
            errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) { return i + 1 + ") " + err.toString(); }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
        return this;
    }
    UnsubscriptionErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return UnsubscriptionErrorImpl;
})();
var UnsubscriptionError = UnsubscriptionErrorImpl;
//# sourceMappingURL=UnsubscriptionError.js.map


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/subscribeToArray.js
var subscribeToArray = __webpack_require__(160);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/hostReportError.js
var hostReportError = __webpack_require__(77);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/util/subscribeToPromise.js
/** PURE_IMPORTS_START _hostReportError PURE_IMPORTS_END */

var subscribeToPromise = function (promise) {
    return function (subscriber) {
        promise.then(function (value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function (err) { return subscriber.error(err); })
            .then(null, hostReportError["a" /* hostReportError */]);
        return subscriber;
    };
};
//# sourceMappingURL=subscribeToPromise.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/symbol/iterator.js
var symbol_iterator = __webpack_require__(47);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/util/subscribeToIterable.js
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */

var subscribeToIterable = function (iterable) {
    return function (subscriber) {
        var iterator = iterable[symbol_iterator["a" /* iterator */]]();
        do {
            var item = iterator.next();
            if (item.done) {
                subscriber.complete();
                break;
            }
            subscriber.next(item.value);
            if (subscriber.closed) {
                break;
            }
        } while (true);
        if (typeof iterator.return === 'function') {
            subscriber.add(function () {
                if (iterator.return) {
                    iterator.return();
                }
            });
        }
        return subscriber;
    };
};
//# sourceMappingURL=subscribeToIterable.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/symbol/observable.js
var observable = __webpack_require__(55);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/util/subscribeToObservable.js
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */

var subscribeToObservable = function (obj) {
    return function (subscriber) {
        var obs = obj[observable["a" /* observable */]]();
        if (typeof obs.subscribe !== 'function') {
            throw new TypeError('Provided object does not correctly implement Symbol.observable');
        }
        else {
            return obs.subscribe(subscriber);
        }
    };
};
//# sourceMappingURL=subscribeToObservable.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isArrayLike.js
var isArrayLike = __webpack_require__(159);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isPromise.js
var isPromise = __webpack_require__(161);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isObject.js
var isObject = __webpack_require__(113);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/util/subscribeTo.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return subscribeTo; });
/** PURE_IMPORTS_START _subscribeToArray,_subscribeToPromise,_subscribeToIterable,_subscribeToObservable,_isArrayLike,_isPromise,_isObject,_symbol_iterator,_symbol_observable PURE_IMPORTS_END */









var subscribeTo = function (result) {
    if (!!result && typeof result[observable["a" /* observable */]] === 'function') {
        return subscribeToObservable(result);
    }
    else if (Object(isArrayLike["a" /* isArrayLike */])(result)) {
        return Object(subscribeToArray["a" /* subscribeToArray */])(result);
    }
    else if (Object(isPromise["a" /* isPromise */])(result)) {
        return subscribeToPromise(result);
    }
    else if (!!result && typeof result[symbol_iterator["a" /* iterator */]] === 'function') {
        return subscribeToIterable(result);
    }
    else {
        var value = Object(isObject["a" /* isObject */])(result) ? 'an invalid object' : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected."
            + ' You can provide an Observable, Promise, Array, or Iterable.';
        throw new TypeError(msg);
    }
};
//# sourceMappingURL=subscribeTo.js.map


/***/ }),
/* 98 */
/***/ (function(module, exports) {

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(57);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(120);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.throwOnEvent = void 0;
var rxjs_1 = __webpack_require__(63);
var operators_1 = __webpack_require__(62);
var EventBus = /** @class */ (function () {
    function EventBus() {
    }
    Object.defineProperty(EventBus, "Subject", {
        get: function () {
            return this._subject;
        },
        enumerable: false,
        configurable: true
    });
    EventBus.initialize = function () {
        EventBus._subject = new rxjs_1.Subject();
    };
    return EventBus;
}());
exports.default = EventBus;
function throwOnEvent(observable, eventType) {
    return observable.pipe(operators_1.find(function (e) { return e.type === eventType; }), operators_1.map(function (e) {
        if (e)
            throwPayload(e);
    }));
}
exports.throwOnEvent = throwOnEvent;
function throwPayload(event) {
    throw event.payload;
}


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(228),
    baseKeys = __webpack_require__(229),
    isArrayLike = __webpack_require__(104);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(209),
    isLength = __webpack_require__(175);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.streamAcquisitionError = streamAcquisitionError;
exports.mapNavigatorUserMediaError = mapNavigatorUserMediaError;
exports.convertTrackToStream = convertTrackToStream;
exports.cleanUpTracks = cleanUpTracks;

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var c = _interopRequireWildcard(__webpack_require__(3));

function streamAcquisitionError(reason, error) {
  return {
    reason: reason,
    error: error
  };
}

function mapNavigatorUserMediaError(error) {
  if ((0, _safeAccess.default)(error, 'toString()') !== '[object NavigatorUserMediaError]') {
    return error;
  }

  switch ((0, _safeAccess.default)(error, 'name')) {
    case c.PERMISSION_DENIED_ERROR:
      return streamAcquisitionError(c.PERMISSION_DENIED_ERROR, error);

    case c.PERMISSION_DISMISSED_ERROR:
      return streamAcquisitionError(c.PERMISSION_DISMISSED_ERROR, error);

    default:
      return streamAcquisitionError(c.UNKNOWN_NAVIGATORUSERMEDIAERROR, error);
  }
}

function convertTrackToStream(stream, track) {
  if (!stream) {
    stream = new window.MediaStream();
  }

  var hasTrack = stream.getTracks().find(function (t) {
    return t.id === track && track.id;
  });

  if (track && !hasTrack) {
    stream.addTrack(track);
    cleanUpTracks(stream, track);
  } else if (!track && hasTrack) {
    stream.removeTrack(track);
  }

  return stream;
}

function cleanUpTracks(stream, track) {
  if (!stream) return;
  var tracks = stream.getTracks();
  tracks.forEach(function (t) {
    if (track && t.kind === track.kind && t.id !== track.id) {
      t.stop();
    }

    if (t.readyState === 'ended') {
      stream.removeTrack(t);
    }
  });
}

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return combineLatest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CombineLatestOperator; });
/* unused harmony export CombineLatestSubscriber */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var _util_isScheduler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27);
/* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24);
/* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16);
/* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15);
/* harmony import */ var _fromArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66);
/** PURE_IMPORTS_START tslib,_util_isScheduler,_util_isArray,_OuterSubscriber,_util_subscribeToResult,_fromArray PURE_IMPORTS_END */






var NONE = {};
function combineLatest() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var resultSelector = null;
    var scheduler = null;
    if (Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_1__[/* isScheduler */ "a"])(observables[observables.length - 1])) {
        scheduler = observables.pop();
    }
    if (typeof observables[observables.length - 1] === 'function') {
        resultSelector = observables.pop();
    }
    if (observables.length === 1 && Object(_util_isArray__WEBPACK_IMPORTED_MODULE_2__[/* isArray */ "a"])(observables[0])) {
        observables = observables[0];
    }
    return Object(_fromArray__WEBPACK_IMPORTED_MODULE_5__[/* fromArray */ "a"])(observables, scheduler).lift(new CombineLatestOperator(resultSelector));
}
var CombineLatestOperator = /*@__PURE__*/ (function () {
    function CombineLatestOperator(resultSelector) {
        this.resultSelector = resultSelector;
    }
    CombineLatestOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CombineLatestSubscriber(subscriber, this.resultSelector));
    };
    return CombineLatestOperator;
}());

var CombineLatestSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"](CombineLatestSubscriber, _super);
    function CombineLatestSubscriber(destination, resultSelector) {
        var _this = _super.call(this, destination) || this;
        _this.resultSelector = resultSelector;
        _this.active = 0;
        _this.values = [];
        _this.observables = [];
        return _this;
    }
    CombineLatestSubscriber.prototype._next = function (observable) {
        this.values.push(NONE);
        this.observables.push(observable);
    };
    CombineLatestSubscriber.prototype._complete = function () {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
            this.destination.complete();
        }
        else {
            this.active = len;
            this.toRespond = len;
            for (var i = 0; i < len; i++) {
                var observable = observables[i];
                this.add(Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_4__[/* subscribeToResult */ "a"])(this, observable, observable, i));
            }
        }
    };
    CombineLatestSubscriber.prototype.notifyComplete = function (unused) {
        if ((this.active -= 1) === 0) {
            this.destination.complete();
        }
    };
    CombineLatestSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var values = this.values;
        var oldVal = values[outerIndex];
        var toRespond = !this.toRespond
            ? 0
            : oldVal === NONE ? --this.toRespond : this.toRespond;
        values[outerIndex] = innerValue;
        if (toRespond === 0) {
            if (this.resultSelector) {
                this._tryResultSelector(values);
            }
            else {
                this.destination.next(values.slice());
            }
        }
    };
    CombineLatestSubscriber.prototype._tryResultSelector = function (values) {
        var result;
        try {
            result = this.resultSelector.apply(this, values);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return CombineLatestSubscriber;
}(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_3__[/* OuterSubscriber */ "a"]));

//# sourceMappingURL=combineLatest.js.map


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mergeAll; });
/* harmony import */ var _mergeMap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59);
/* harmony import */ var _util_identity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42);
/** PURE_IMPORTS_START _mergeMap,_util_identity PURE_IMPORTS_END */


function mergeAll(concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    return Object(_mergeMap__WEBPACK_IMPORTED_MODULE_0__[/* mergeMap */ "a"])(_util_identity__WEBPACK_IMPORTED_MODULE_1__[/* identity */ "a"], concurrent);
}
//# sourceMappingURL=mergeAll.js.map


/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return throwError; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10);
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */

function throwError(error, scheduler) {
    if (!scheduler) {
        return new _Observable__WEBPACK_IMPORTED_MODULE_0__[/* Observable */ "a"](function (subscriber) { return subscriber.error(error); });
    }
    else {
        return new _Observable__WEBPACK_IMPORTED_MODULE_0__[/* Observable */ "a"](function (subscriber) { return scheduler.schedule(dispatch, 0, { error: error, subscriber: subscriber }); });
    }
}
function dispatch(_a) {
    var error = _a.error, subscriber = _a.subscriber;
    subscriber.error(error);
}
//# sourceMappingURL=throwError.js.map


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return refCount; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function refCount() {
    return function refCountOperatorFunction(source) {
        return source.lift(new RefCountOperator(source));
    };
}
var RefCountOperator = /*@__PURE__*/ (function () {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function (subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) {
            refCounter.connection = connectable.connect();
        }
        return subscription;
    };
    return RefCountOperator;
}());
var RefCountSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"](RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    RefCountSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) {
            sharedConnection.unsubscribe();
        }
    };
    return RefCountSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__[/* Subscriber */ "a"]));
//# sourceMappingURL=refCount.js.map


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReplaySubject; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22);
/* harmony import */ var _scheduler_queue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(158);
/* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20);
/* harmony import */ var _operators_observeOn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(153);
/* harmony import */ var _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56);
/* harmony import */ var _SubjectSubscription__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(162);
/** PURE_IMPORTS_START tslib,_Subject,_scheduler_queue,_Subscription,_operators_observeOn,_util_ObjectUnsubscribedError,_SubjectSubscription PURE_IMPORTS_END */







var ReplaySubject = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"](ReplaySubject, _super);
    function ReplaySubject(bufferSize, windowTime, scheduler) {
        if (bufferSize === void 0) {
            bufferSize = Number.POSITIVE_INFINITY;
        }
        if (windowTime === void 0) {
            windowTime = Number.POSITIVE_INFINITY;
        }
        var _this = _super.call(this) || this;
        _this.scheduler = scheduler;
        _this._events = [];
        _this._infiniteTimeWindow = false;
        _this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
        _this._windowTime = windowTime < 1 ? 1 : windowTime;
        if (windowTime === Number.POSITIVE_INFINITY) {
            _this._infiniteTimeWindow = true;
            _this.next = _this.nextInfiniteTimeWindow;
        }
        else {
            _this.next = _this.nextTimeWindow;
        }
        return _this;
    }
    ReplaySubject.prototype.nextInfiniteTimeWindow = function (value) {
        var _events = this._events;
        _events.push(value);
        if (_events.length > this._bufferSize) {
            _events.shift();
        }
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype.nextTimeWindow = function (value) {
        this._events.push(new ReplayEvent(this._getNow(), value));
        this._trimBufferThenGetEvents();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function (subscriber) {
        var _infiniteTimeWindow = this._infiniteTimeWindow;
        var _events = _infiniteTimeWindow ? this._events : this._trimBufferThenGetEvents();
        var scheduler = this.scheduler;
        var len = _events.length;
        var subscription;
        if (this.closed) {
            throw new _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_5__[/* ObjectUnsubscribedError */ "a"]();
        }
        else if (this.isStopped || this.hasError) {
            subscription = _Subscription__WEBPACK_IMPORTED_MODULE_3__[/* Subscription */ "a"].EMPTY;
        }
        else {
            this.observers.push(subscriber);
            subscription = new _SubjectSubscription__WEBPACK_IMPORTED_MODULE_6__[/* SubjectSubscription */ "a"](this, subscriber);
        }
        if (scheduler) {
            subscriber.add(subscriber = new _operators_observeOn__WEBPACK_IMPORTED_MODULE_4__[/* ObserveOnSubscriber */ "a"](subscriber, scheduler));
        }
        if (_infiniteTimeWindow) {
            for (var i = 0; i < len && !subscriber.closed; i++) {
                subscriber.next(_events[i]);
            }
        }
        else {
            for (var i = 0; i < len && !subscriber.closed; i++) {
                subscriber.next(_events[i].value);
            }
        }
        if (this.hasError) {
            subscriber.error(this.thrownError);
        }
        else if (this.isStopped) {
            subscriber.complete();
        }
        return subscription;
    };
    ReplaySubject.prototype._getNow = function () {
        return (this.scheduler || _scheduler_queue__WEBPACK_IMPORTED_MODULE_2__[/* queue */ "a"]).now();
    };
    ReplaySubject.prototype._trimBufferThenGetEvents = function () {
        var now = this._getNow();
        var _bufferSize = this._bufferSize;
        var _windowTime = this._windowTime;
        var _events = this._events;
        var eventsCount = _events.length;
        var spliceCount = 0;
        while (spliceCount < eventsCount) {
            if ((now - _events[spliceCount].time) < _windowTime) {
                break;
            }
            spliceCount++;
        }
        if (eventsCount > _bufferSize) {
            spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
        }
        if (spliceCount > 0) {
            _events.splice(0, spliceCount);
        }
        return _events;
    };
    return ReplaySubject;
}(_Subject__WEBPACK_IMPORTED_MODULE_1__[/* Subject */ "a"]));

var ReplayEvent = /*@__PURE__*/ (function () {
    function ReplayEvent(time, value) {
        this.time = time;
        this.value = value;
    }
    return ReplayEvent;
}());
//# sourceMappingURL=ReplaySubject.js.map


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defer; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10);
/* harmony import */ var _from__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30);
/* harmony import */ var _empty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28);
/** PURE_IMPORTS_START _Observable,_from,_empty PURE_IMPORTS_END */



function defer(observableFactory) {
    return new _Observable__WEBPACK_IMPORTED_MODULE_0__[/* Observable */ "a"](function (subscriber) {
        var input;
        try {
            input = observableFactory();
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var source = input ? Object(_from__WEBPACK_IMPORTED_MODULE_1__[/* from */ "a"])(input) : Object(_empty__WEBPACK_IMPORTED_MODULE_2__[/* empty */ "b"])();
        return source.subscribe(subscriber);
    });
}
//# sourceMappingURL=defer.js.map


/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return zip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ZipOperator; });
/* unused harmony export ZipSubscriber */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var _fromArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66);
/* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24);
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16);
/* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15);
/* harmony import */ var _internal_symbol_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47);
/** PURE_IMPORTS_START tslib,_fromArray,_util_isArray,_Subscriber,_OuterSubscriber,_util_subscribeToResult,_.._internal_symbol_iterator PURE_IMPORTS_END */







function zip() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var resultSelector = observables[observables.length - 1];
    if (typeof resultSelector === 'function') {
        observables.pop();
    }
    return Object(_fromArray__WEBPACK_IMPORTED_MODULE_1__[/* fromArray */ "a"])(observables, undefined).lift(new ZipOperator(resultSelector));
}
var ZipOperator = /*@__PURE__*/ (function () {
    function ZipOperator(resultSelector) {
        this.resultSelector = resultSelector;
    }
    ZipOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ZipSubscriber(subscriber, this.resultSelector));
    };
    return ZipOperator;
}());

var ZipSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"](ZipSubscriber, _super);
    function ZipSubscriber(destination, resultSelector, values) {
        if (values === void 0) {
            values = Object.create(null);
        }
        var _this = _super.call(this, destination) || this;
        _this.iterators = [];
        _this.active = 0;
        _this.resultSelector = (typeof resultSelector === 'function') ? resultSelector : null;
        _this.values = values;
        return _this;
    }
    ZipSubscriber.prototype._next = function (value) {
        var iterators = this.iterators;
        if (Object(_util_isArray__WEBPACK_IMPORTED_MODULE_2__[/* isArray */ "a"])(value)) {
            iterators.push(new StaticArrayIterator(value));
        }
        else if (typeof value[_internal_symbol_iterator__WEBPACK_IMPORTED_MODULE_6__[/* iterator */ "a"]] === 'function') {
            iterators.push(new StaticIterator(value[_internal_symbol_iterator__WEBPACK_IMPORTED_MODULE_6__[/* iterator */ "a"]]()));
        }
        else {
            iterators.push(new ZipBufferIterator(this.destination, this, value));
        }
    };
    ZipSubscriber.prototype._complete = function () {
        var iterators = this.iterators;
        var len = iterators.length;
        this.unsubscribe();
        if (len === 0) {
            this.destination.complete();
            return;
        }
        this.active = len;
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            if (iterator.stillUnsubscribed) {
                var destination = this.destination;
                destination.add(iterator.subscribe(iterator, i));
            }
            else {
                this.active--;
            }
        }
    };
    ZipSubscriber.prototype.notifyInactive = function () {
        this.active--;
        if (this.active === 0) {
            this.destination.complete();
        }
    };
    ZipSubscriber.prototype.checkIterators = function () {
        var iterators = this.iterators;
        var len = iterators.length;
        var destination = this.destination;
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            if (typeof iterator.hasValue === 'function' && !iterator.hasValue()) {
                return;
            }
        }
        var shouldComplete = false;
        var args = [];
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            var result = iterator.next();
            if (iterator.hasCompleted()) {
                shouldComplete = true;
            }
            if (result.done) {
                destination.complete();
                return;
            }
            args.push(result.value);
        }
        if (this.resultSelector) {
            this._tryresultSelector(args);
        }
        else {
            destination.next(args);
        }
        if (shouldComplete) {
            destination.complete();
        }
    };
    ZipSubscriber.prototype._tryresultSelector = function (args) {
        var result;
        try {
            result = this.resultSelector.apply(this, args);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return ZipSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_3__[/* Subscriber */ "a"]));

var StaticIterator = /*@__PURE__*/ (function () {
    function StaticIterator(iterator) {
        this.iterator = iterator;
        this.nextResult = iterator.next();
    }
    StaticIterator.prototype.hasValue = function () {
        return true;
    };
    StaticIterator.prototype.next = function () {
        var result = this.nextResult;
        this.nextResult = this.iterator.next();
        return result;
    };
    StaticIterator.prototype.hasCompleted = function () {
        var nextResult = this.nextResult;
        return nextResult && nextResult.done;
    };
    return StaticIterator;
}());
var StaticArrayIterator = /*@__PURE__*/ (function () {
    function StaticArrayIterator(array) {
        this.array = array;
        this.index = 0;
        this.length = 0;
        this.length = array.length;
    }
    StaticArrayIterator.prototype[_internal_symbol_iterator__WEBPACK_IMPORTED_MODULE_6__[/* iterator */ "a"]] = function () {
        return this;
    };
    StaticArrayIterator.prototype.next = function (value) {
        var i = this.index++;
        var array = this.array;
        return i < this.length ? { value: array[i], done: false } : { value: null, done: true };
    };
    StaticArrayIterator.prototype.hasValue = function () {
        return this.array.length > this.index;
    };
    StaticArrayIterator.prototype.hasCompleted = function () {
        return this.array.length === this.index;
    };
    return StaticArrayIterator;
}());
var ZipBufferIterator = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"](ZipBufferIterator, _super);
    function ZipBufferIterator(destination, parent, observable) {
        var _this = _super.call(this, destination) || this;
        _this.parent = parent;
        _this.observable = observable;
        _this.stillUnsubscribed = true;
        _this.buffer = [];
        _this.isComplete = false;
        return _this;
    }
    ZipBufferIterator.prototype[_internal_symbol_iterator__WEBPACK_IMPORTED_MODULE_6__[/* iterator */ "a"]] = function () {
        return this;
    };
    ZipBufferIterator.prototype.next = function () {
        var buffer = this.buffer;
        if (buffer.length === 0 && this.isComplete) {
            return { value: null, done: true };
        }
        else {
            return { value: buffer.shift(), done: false };
        }
    };
    ZipBufferIterator.prototype.hasValue = function () {
        return this.buffer.length > 0;
    };
    ZipBufferIterator.prototype.hasCompleted = function () {
        return this.buffer.length === 0 && this.isComplete;
    };
    ZipBufferIterator.prototype.notifyComplete = function () {
        if (this.buffer.length > 0) {
            this.isComplete = true;
            this.parent.notifyInactive();
        }
        else {
            this.destination.complete();
        }
    };
    ZipBufferIterator.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.buffer.push(innerValue);
        this.parent.checkIterators();
    };
    ZipBufferIterator.prototype.subscribe = function (value, index) {
        return Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_5__[/* subscribeToResult */ "a"])(this, this.observable, this, index);
    };
    return ZipBufferIterator;
}(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_4__[/* OuterSubscriber */ "a"]));
//# sourceMappingURL=zip.js.map


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isObject; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isObject(x) {
    return x !== null && typeof x === 'object';
}
//# sourceMappingURL=isObject.js.map


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return canReportError; });
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/** PURE_IMPORTS_START _Subscriber PURE_IMPORTS_END */

function canReportError(observer) {
    while (observer) {
        var _a = observer, closed_1 = _a.closed, destination = _a.destination, isStopped = _a.isStopped;
        if (closed_1 || isStopped) {
            return false;
        }
        else if (destination && destination instanceof _Subscriber__WEBPACK_IMPORTED_MODULE_0__[/* Subscriber */ "a"]) {
            observer = destination;
        }
        else {
            observer = null;
        }
    }
    return true;
}
//# sourceMappingURL=canReportError.js.map


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return scheduleArray; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10);
/* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20);
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */


function scheduleArray(input, scheduler) {
    return new _Observable__WEBPACK_IMPORTED_MODULE_0__[/* Observable */ "a"](function (subscriber) {
        var sub = new _Subscription__WEBPACK_IMPORTED_MODULE_1__[/* Subscription */ "a"]();
        var i = 0;
        sub.add(scheduler.schedule(function () {
            if (i === input.length) {
                subscriber.complete();
                return;
            }
            subscriber.next(input[i++]);
            if (!subscriber.closed) {
                sub.add(this.schedule());
            }
        }));
        return sub;
    });
}
//# sourceMappingURL=scheduleArray.js.map


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(0);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/util/Immediate.js
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var nextHandle = 1;
var RESOLVED = /*@__PURE__*/ (function () { return /*@__PURE__*/ Promise.resolve(); })();
var activeHandles = {};
function findAndClearHandle(handle) {
    if (handle in activeHandles) {
        delete activeHandles[handle];
        return true;
    }
    return false;
}
var Immediate = {
    setImmediate: function (cb) {
        var handle = nextHandle++;
        activeHandles[handle] = true;
        RESOLVED.then(function () { return findAndClearHandle(handle) && cb(); });
        return handle;
    },
    clearImmediate: function (handle) {
        findAndClearHandle(handle);
    },
};
var TestTools = {
    pending: function () {
        return Object.keys(activeHandles).length;
    }
};
//# sourceMappingURL=Immediate.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/AsyncAction.js + 1 modules
var AsyncAction = __webpack_require__(68);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/AsapAction.js
/** PURE_IMPORTS_START tslib,_util_Immediate,_AsyncAction PURE_IMPORTS_END */



var AsapAction_AsapAction = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](AsapAction, _super);
    function AsapAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        scheduler.actions.push(this);
        return scheduler.scheduled || (scheduler.scheduled = Immediate.setImmediate(scheduler.flush.bind(scheduler, null)));
    };
    AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        if (scheduler.actions.length === 0) {
            Immediate.clearImmediate(id);
            scheduler.scheduled = undefined;
        }
        return undefined;
    };
    return AsapAction;
}(AsyncAction["a" /* AsyncAction */]));

//# sourceMappingURL=AsapAction.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/AsyncScheduler.js
var AsyncScheduler = __webpack_require__(65);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/AsapScheduler.js
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */


var AsapScheduler_AsapScheduler = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](AsapScheduler, _super);
    function AsapScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsapScheduler.prototype.flush = function (action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while (++index < count && (action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsapScheduler;
}(AsyncScheduler["a" /* AsyncScheduler */]));

//# sourceMappingURL=AsapScheduler.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/asap.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return asap; });
/** PURE_IMPORTS_START _AsapAction,_AsapScheduler PURE_IMPORTS_END */


var asap = /*@__PURE__*/ new AsapScheduler_AsapScheduler(AsapAction_AsapAction);
//# sourceMappingURL=asap.js.map


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return empty; });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41);
/* harmony import */ var _util_hostReportError__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77);
/** PURE_IMPORTS_START _config,_util_hostReportError PURE_IMPORTS_END */


var empty = {
    closed: true,
    next: function (value) { },
    error: function (err) {
        if (_config__WEBPACK_IMPORTED_MODULE_0__[/* config */ "a"].useDeprecatedSynchronousErrorHandling) {
            throw err;
        }
        else {
            Object(_util_hostReportError__WEBPACK_IMPORTED_MODULE_1__[/* hostReportError */ "a"])(err);
        }
    },
    complete: function () { }
};
//# sourceMappingURL=Observer.js.map


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return asap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return suspend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return flush; });
var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/
var semaphore = 0;

/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/
function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release();
  }
}

/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/
function asap(task) {
  queue.push(task);

  if (!semaphore) {
    suspend();
    flush();
  }
}

/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/
function suspend() {
  semaphore++;
}

/**
  Puts the scheduler in a `released` state.
**/
function release() {
  semaphore--;
}

/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/
function flush() {
  release();

  var task = void 0;
  while (!semaphore && (task = queue.shift()) !== undefined) {
    exec(task);
  }
}

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(43),
    isKey = __webpack_require__(167),
    stringToPath = __webpack_require__(304),
    toString = __webpack_require__(328);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(88),
    isObjectLike = __webpack_require__(70);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var get_1 = __importDefault(__webpack_require__(11));
var C = __importStar(__webpack_require__(214));
var EventBus_1 = __importDefault(__webpack_require__(79));
var sleepMonitor_1 = __importDefault(__webpack_require__(346));
var utils_1 = __webpack_require__(347);
var WampConnection = /** @class */ (function () {
    function WampConnection(wampClient) {
        var _this = this;
        this._autoRetry = false;
        this.open = function (openArgs) {
            _this.lastUsedOpenArgs = openArgs;
            _this.connection = new _this.wampClient.Connection(openArgs);
            _this.connection.onopen = _this.handleOpen;
            _this.connection.onclose = _this.handleClose;
            _this.connection.open();
        };
        this.close = function () {
            if (!_this.connection)
                return;
            sleepMonitor_1.default.stop();
            var pending = _this.connection;
            pending.onopen = null;
            pending.onclose = function () { return true; }; // returning true on onclose prevents the wamp client from retrying connection
            _this._autoRetry = false;
            _this.connection = null;
            _this.disposeSession();
            try {
                pending.close();
            }
            catch (error) {
                console.debug(error);
            }
            EventBus_1.default.Subject.next({
                type: 'CONNECTION_DISPOSED',
                payload: { event: 'closed', reason: 'wamp.goodbye_and_out', willRetry: false },
            });
        };
        this.forceClose = function (reason, willRetry) {
            if (reason === void 0) { reason = 'wamp.goodbye_and_out'; }
            if (willRetry === void 0) { willRetry = false; }
            if (!_this.connection)
                return;
            sleepMonitor_1.default.stop();
            var pending = _this.connection;
            pending.onopen = null;
            pending.onclose = function () { return true; }; // returning true on onclose prevents the wamp client from retrying connection
            _this._autoRetry = false;
            _this.connection = null;
            _this.disposeSession();
            try {
                pending.transport.close();
            }
            catch (error) {
                console.debug(error);
            }
            EventBus_1.default.Subject.next({
                type: 'CONNECTION_DISPOSED',
                payload: { event: 'closed', reason: reason, willRetry: willRetry },
            });
        };
        this.echo = function (timeout) {
            if (timeout === void 0) { timeout = 2500; }
            return __awaiter(_this, void 0, void 0, function () {
                var callParams;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            callParams = { procedure: C.TEST_ECHO, args: [''] };
                            return [4 /*yield*/, this.call(callParams, timeout)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        this.call = function (params, timeout) {
            if (timeout === void 0) { timeout = 10000; }
            return __awaiter(_this, void 0, void 0, function () {
                var procedure, args, timeoutPromise, response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.verifyConnectedWithSession();
                            procedure = params.procedure, args = params.args;
                            timeoutPromise = utils_1.createTimeoutPromise(timeout);
                            return [4 /*yield*/, Promise.race([this.wampSession.call(procedure, args), timeoutPromise])];
                        case 1:
                            response = _a.sent();
                            return [2 /*return*/, response];
                    }
                });
            });
        };
        this.subscribe = function (topic) { return __awaiter(_this, void 0, void 0, function () {
            var subscription;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.verifyConnectedWithSession();
                        if (this.subscriptions.has(topic))
                            throw { topic: topic, message: 'SUBSCRIPTION_ALREADY_EXISTS', subscription: this.subscriptions.get(topic) };
                        return [4 /*yield*/, this.wampSession.subscribe(topic, function (args) {
                                return _this.handleSubscriptionEvent(_this.wampSession.id, topic, args);
                            })];
                    case 1:
                        subscription = _a.sent();
                        this.subscriptions.set(topic, subscription);
                        return [2 /*return*/, { subscription: subscription, topic: topic }];
                }
            });
        }); };
        this.unsubscribe = function (topic) { return __awaiter(_this, void 0, void 0, function () {
            var subscription;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.verifyConnectedWithSession();
                        subscription = this.subscriptions.get(topic);
                        if (!subscription)
                            throw { topic: topic, message: C.SUBSCRIPTION_NOT_FOUND };
                        return [4 /*yield*/, this.wampSession.unsubscribe(subscription)];
                    case 1:
                        _a.sent();
                        this.subscriptions.delete(topic);
                        return [2 /*return*/, { topic: topic }];
                }
            });
        }); };
        this.disposeSession = function () {
            _this.subscriptions.clear();
            _this.wampSession = null;
        };
        this.handleOpen = function (session) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (WampConnection._enableSleepMonitor)
                    sleepMonitor_1.default.start(this.verifyConnection, 2500, 5000);
                this.wampSession = session;
                EventBus_1.default.Subject.next({
                    type: 'CONNECTION_OPENED',
                    payload: { session: { id: this.wampSession.id } },
                });
                return [2 /*return*/];
            });
        }); };
        this.handleClose = function (event, details) {
            sleepMonitor_1.default.stop();
            _this.disposeSession();
            var reason = get_1.default(details, 'reason');
            var willRetry = _this._autoRetry && get_1.default(details, 'will_retry');
            if (event === 'closed' || !willRetry) {
                // remove handlers on closed event as no automatic retries will occur.
                _this.connection.onopen = null;
                _this.connection.onclose = null;
                _this.connection = null;
            }
            EventBus_1.default.Subject.next({ type: 'CONNECTION_DISPOSED', payload: { event: event, reason: reason, willRetry: willRetry } });
            return !_this._autoRetry;
        };
        this.verifyConnection = function () { return __awaiter(_this, void 0, void 0, function () {
            var currentSessionId, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentSessionId = this.wampSession.id;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        // attempt echo, will throw on timeout
                        return [4 /*yield*/, this.echo()];
                    case 2:
                        // attempt echo, will throw on timeout
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        // check if wampSession exists and is the same as before awaiting for the echo timeout
                        // if it doesn't exist, it means the wamp client is already trying to re-establish connection
                        // if it does but is different, it means the wamp client already re-established connection
                        // both of these cases are no-op.
                        if (!this.wampSession || currentSessionId !== this.wampSession.id) {
                            console.debug('wamp client already re-established/re-establishing connection.');
                            return [2 /*return*/];
                        }
                        this.forceClose('timeout', !!this.lastUsedOpenArgs);
                        if (!this.lastUsedOpenArgs)
                            return [2 /*return*/];
                        this.open(this.lastUsedOpenArgs);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.verifyConnectedWithSession = function () {
            var result = _this.isConnectedWithSession();
            if (result)
                return;
            throw { message: C.CONNECTION_NOT_OPEN };
        };
        this.isConnectedWithSession = function () {
            return _this.wampSession && _this.connection && _this.connection.isConnected;
        };
        /** @todo validate wampClient? */
        this.connection = null;
        this.lastUsedOpenArgs = null;
        this.subscriptions = new Map();
        this.wampClient = wampClient;
        this.wampSession = null;
    }
    Object.defineProperty(WampConnection, "Instance", {
        get: function () {
            return this._instance;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WampConnection.prototype, "hasConnection", {
        get: function () {
            return this.connection !== null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WampConnection.prototype, "autoRetry", {
        set: function (value) {
            this._autoRetry = value;
        },
        enumerable: true,
        configurable: true
    });
    WampConnection.initialize = function (wampClient, enableSleepMonitor) {
        this._instance = new WampConnection(wampClient);
        this._enableSleepMonitor = enableSleepMonitor;
    };
    WampConnection.prototype.handleSubscriptionEvent = function (sessionId, topic, args) {
        // ignore events if handler session id is different than current session id
        if (this.wampSession.id !== sessionId)
            return;
        var payload = { topic: topic, args: args };
        EventBus_1.default.Subject.next({ type: 'SUBSCRIPTION_EVENT', payload: payload });
    };
    return WampConnection;
}());
exports.default = WampConnection;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(349),
    flatRest = __webpack_require__(355);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(392),
    Map = __webpack_require__(170),
    Promise = __webpack_require__(393),
    Set = __webpack_require__(231),
    WeakMap = __webpack_require__(394),
    baseGetTag = __webpack_require__(88),
    toSource = __webpack_require__(210);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatElapsedCallTime = formatElapsedCallTime;
exports.formatElapsedTime = formatElapsedTime;
exports.monthDiff = monthDiff;
exports.timeSinceStartOfDay = timeSinceStartOfDay;
exports.getDateFormat = getDateFormat;
exports.formatTSForChats = formatTSForChats;
exports.formatTSForCallHistory = formatTSForCallHistory;
exports.toISODate = toISODate;

var _sprintfJs = __webpack_require__(235);

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var elapsedFormats = {
  minutes_narrow_form: '%dm',
  hours_narrow_form: '%dh',
  week_narrow_form: '%dw'
};
var formatOptions = {
  chat: {
    today: {
      hour: 'numeric',
      hour12: true,
      minute: 'numeric'
    },
    lastWeek: {
      hour: 'numeric',
      hour12: true,
      minute: 'numeric',
      weekday: 'short'
    },
    sameYear: {
      hour: 'numeric',
      hour12: true,
      minute: 'numeric',
      day: 'numeric',
      month: 'short'
    },
    prevYear: {
      hour: 'numeric',
      hour12: true,
      minute: 'numeric',
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    },
    future: {
      hour: 'numeric',
      hour12: true,
      minute: 'numeric',
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    }
  },
  callHistory: {
    lastWeek: {
      weekday: 'short'
    },
    future: {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    }
  },
  activeCall: {
    hour: 'numeric',
    hour12: true,
    minute: 'numeric',
    second: 'numeric'
  }
};
/**
 * formatElapsedCallTime
 * Formats time to h:mm:SS / m:SS
 * @param {int} secondsElapsed
 * http://stackoverflow.com/questions/6312993/javascript-seconds-to-time-string-with-format-hhmmss
 */

function formatElapsedCallTime(secondsElapsed) {
  if (!secondsElapsed) return '';
  var hours = Math.floor(secondsElapsed / 3600);
  var minutes = Math.floor((secondsElapsed - hours * 3600) / 60);
  var seconds = secondsElapsed % 60;

  if (minutes < 10 && hours > 0) {
    minutes = '0' + minutes;
  }

  if (seconds < 10) {
    seconds = '0' + seconds;
  }

  var time = minutes + ':' + seconds;

  if (hours > 0) {
    time = hours + ':' + time;
  }

  return time;
}
/**
 * formatElapsedTime
 * Formats time to hh:mm:SS
 * @param {int} secondsElapsed
 */


function formatElapsedTime(secondsElapsed) {
  if (!secondsElapsed) return '';
  var hours = Math.floor(secondsElapsed / 3600);
  var minutes = Math.floor((secondsElapsed - hours * 3600) / 60);
  var seconds = secondsElapsed % 60;
  return "".concat(hours < 10 ? '0' : '').concat(hours, ":").concat(minutes < 10 ? '0' : '').concat(minutes, ":").concat(seconds < 10 ? '0' : '').concat(seconds);
}

function monthDiff(currDate, date) {
  var monthDiff = (currDate.getYear() - date.getYear()) * 12 + (currDate.getMonth() - date.getMonth());
  return monthDiff;
}

function timeSinceStartOfDay(date) {
  var timeSinceEpoch = date.getTime() / 1000;
  var adjustedForTZ = timeSinceEpoch - date.getTimezoneOffset() * 60;
  var secsSinceStart = adjustedForTZ % 86400;
  return secsSinceStart;
}

function getDateFormat(date) {
  var currDate = new Date();

  if (date > currDate) {
    _jsLogger.default.warn('Got a timestamp in the future, is the system clock behind?');

    return 'future';
  } // Algorithm:
  // 1. If difference between the two dates is less than the time elapsed since
  //    start of the day, then its 'today'
  // 2. If the passed date is before (mathematically lesser) than startOfWeek
  //    then its 'lastWeek'
  // 3. If the monthDiff is less than 12, then its 'sameYear'
  // 4. If the monthDiff is greater than 11, then its 'prevYear'


  var diffInSecs = (currDate - date) / 1000;
  var secsSinceStartOfDay = timeSinceStartOfDay(currDate);

  if (diffInSecs <= secsSinceStartOfDay) {
    return 'today';
  } // To know the time at which this week (same week here is the last 7 days)
  // started, go back by six full days and the number of seconds that has
  // elapsed this day


  var startOfWeek = currDate.getTime() / 1000 - (6 * 86400 + secsSinceStartOfDay);

  if (startOfWeek <= date.getTime() / 1000) {
    return 'lastWeek';
  }

  var diffInMonths = monthDiff(currDate, date);

  if (diffInMonths < 12) {
    return 'sameYear';
  }

  return 'prevYear';
}

function formatTSForChats(date) {
  var languageId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
  // Chat messages for web and mobile will the have following formats
  // Today              - 1:45 PM (12 hour format with leading zeros)
  // Last 6 days        - Wed 2:00 PM, Tue 1:50 PM, Mon 1:40 PM, Sun 1:30 PM,
  //                      Sat 1:20 PM, Fri 1:10 PM, Thu 1:00 PM
  // Earlier than 1 Wk  - Oct 8, 2:00 PM, Oct 7, 1:50 PM, Oct 6, 1:40 PM
  // A year back        - Oct 8 2014, 2:00 PM, Oct 7 2014, 1:50 PM
  var dateFormat = getDateFormat(date);
  var formatOption = formatOptions.chat[dateFormat];
  var formattedDate;

  try {
    formattedDate = new Intl.DateTimeFormat(languageId, formatOption).format(date);
  } catch (e) {
    if (date && date.toString) formattedDate = date.toString();

    _jsLogger.default.warn("Error formatting date with Intl.DateTimeFormat: ".concat(languageId, ", ").concat(formatOptions, ", ").concat(date, ". Error: ").concat(JSON.stringify(e)));

    _jsLogger.default.warn("Returning date in format: ".concat(formattedDate));

    return formattedDate;
  }

  if (dateFormat === 'future') {
    // Just return without relative formatting, client clock is wrong
    return formattedDate;
  }

  if (dateFormat === 'prevYear') {
    // The chrome, IE & node implementations of the format function seems to not
    // match the UX spec interms of comma placements. An ideal way to fix this
    // would be to use the Intl.formatToParts function which would return the
    // formated date in parts instead of a string and the implementations can
    // tweak it the way it wants. However, its not supported in most browsers
    // including chrome & IE. So for the time being we need to stick to this
    // ugly solution of taking out an extra comma if present
    var formatParts = formattedDate.split(',');
    /* istanbul ignore else */

    if (formatParts.length > 2) {
      formatParts[1] = formatParts[1] + ','; // add a comma to the year

      formattedDate = formatParts.join('');
    }
  }

  return formattedDate;
}

function formatTSForCallHistory(date) {
  var languageId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
  // Call history in the activity feed will have compact timestamps
  // Example:
  // 55m, 1h, Tue, Wed, 1w, 2w
  // Since the call history is stored only for the last 30 days we don't
  // worry beyond weeks. Everything earlier than a week will be represented
  // in weeks. DateTimeFormat doesn't support relative time formats. We can
  // use it here partially though for the lastWeek format. Rest of the stuff
  // will have to be managed by nucleus
  var dateFormat = getDateFormat(date);
  var formattedDate;

  if (dateFormat === 'lastWeek' || dateFormat === 'future') {
    var formatOption = formatOptions.callHistory[dateFormat];

    try {
      formattedDate = new Intl.DateTimeFormat(languageId, formatOption).format(date);
    } catch (e) {
      if (date && date.toString) formattedDate = date.toString();

      _jsLogger.default.warn('Error formatting date with Intl.DateTimeFormat:', languageId, formatOptions, date, 'Error:', e);

      _jsLogger.default.warn('Returning date in format:', formattedDate);
    }

    return formattedDate;
  } // We need to handle three formats
  // 1. date earlier than an hour should be in minutes - 1m to 59m rounded
  //    off to the nearest minute
  // 2. date earlier than start of he day should be in hours - 1h, 2h etc
  //    rounded off to the nearest hour
  // 3. date earlier than a week should be in weeks - rounded off to nearest
  //    week


  var currDate = new Date();

  if (dateFormat === 'today') {
    var _diffInSecs = (currDate - date) / 1000;

    var diffInMins = Math.round(_diffInSecs / 60);
    var diffInHours = Math.round(diffInMins / 60);

    if (!diffInMins) {
      diffInMins = 1;
    }

    if (diffInMins < 60) {
      // express relative time in mins
      formattedDate = (0, _sprintfJs.sprintf)(elapsedFormats.minutes_narrow_form, diffInMins);
    } else {
      // express relative time in hours
      formattedDate = (0, _sprintfJs.sprintf)(elapsedFormats.hours_narrow_form, diffInHours);
    }

    return formattedDate;
  } // Its not lastWeek and its not today. Rest all have to be expressed
  // in number of weeks


  var diffInSecs = (currDate - date) / 1000;
  var diffInWeeks = Math.round(diffInSecs / (86400 * 7));
  formattedDate = (0, _sprintfJs.sprintf)(elapsedFormats.week_narrow_form, diffInWeeks);
  return formattedDate;
} // convert a date to ISO format for query parameter


function toISODate(value) {
  var dateValue = new Date(value);
  var isoDate = (dateValue instanceof Date && !isNaN(dateValue) ? dateValue : new Date()).toISOString();
  return isoDate.split('T').shift(); // YYYY-MM-DDTHH:mm:ss.sssZ -> YYYY-MM-DD
}

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.languageId = exports.localization = exports.localeCode = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reselect = __webpack_require__(23);

var _clients = __webpack_require__(243);

var C = _interopRequireWildcard(__webpack_require__(3));

var _feature = __webpack_require__(74);

var _lodash = __webpack_require__(82);

var localeCode = function localeCode(state) {
  return (0, _lodash.get)(state, 'nucleus.localization.localeCode') || 'en';
};

exports.localeCode = localeCode;

var languageId = function languageId(state) {
  return (0, _lodash.get)(state, 'nucleus.localization.languageId');
};

exports.languageId = languageId;

var localizationState = function localizationState(state) {
  return (0, _lodash.get)(state, 'nucleus.localization') || {};
};

var localization = (0, _reselect.createSelector)(localizationState, _feature.getFeatureFlags, function (localizationState, featureFlags) {
  var filterLanguageIds = (0, _lodash.compact)([!featureFlags[C.FEATUREFLAG_ENABLE_LANGUAGE_RU_RU] && 'ru-RU', !featureFlags[C.FEATUREFLAG_ENABLE_LANGUAGE_ZH_HANT] && 'zh-Hant']);
  var languageOptions = (0, _lodash.reject)(_clients.localizationUtils.getLanguageOptions(), function (option) {
    return filterLanguageIds.includes(option.id);
  });
  return (0, _objectSpread2.default)({}, localizationState, {
    languageOptions: languageOptions
  });
});
exports.localization = localization;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupCallHistoryRecords = groupCallHistoryRecords;
exports.mapCallHistoryItem = mapCallHistoryItem;
exports.recentCalculatedProperties = recentCalculatedProperties;
exports.isMissed = isMissed;
exports.mapCallType = mapCallType;
exports.mapCallHistoryEventToActions = mapCallHistoryEventToActions;
exports.mapCallHistoryRecord = mapCallHistoryRecord;
exports.mapToLegacyCallHistory = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var DateUtils = _interopRequireWildcard(__webpack_require__(124));

var c = _interopRequireWildcard(__webpack_require__(3));

var _serverPush = __webpack_require__(460);

var _contacts = __webpack_require__(35);

var mapToLegacyCallHistory = function mapToLegacyCallHistory(state) {
  return function (c) {
    return (0, _objectSpread2.default)({}, c, {
      startTimestamp: c.callStartTime && +new Date(c.callStartTime),
      endTimestamp: c.callEndTime && +new Date(c.callEndTime),
      contact: c.contact ? (0, _contacts.mapIndividualContact)(state)(c.contact) : null
    });
  };
};

exports.mapToLegacyCallHistory = mapToLegacyCallHistory;

function groupCallHistoryRecords(recentRecords, contacts, languageId, lastViewed, isMobile) {
  var callHistory = [];
  recentRecords.sort(function (a, b) {
    return +new Date(b.callStartTime) - +new Date(a.callStartTime);
  });
  recentRecords.forEach(function (recentRecord) {
    var callHistoryItem = callHistory[callHistory.length - 1];

    if (!(callHistoryItem && callHistoryItem.callType === mapCallType(recentRecord.direction) && callHistoryItem.remoteParty === recentRecord.remoteParty)) {
      callHistoryItem = null;
    }

    if (!callHistoryItem) {
      callHistoryItem = mapCallHistoryItem(recentRecord, recentRecord.contact);
      callHistoryItem.recents = [];
      callHistoryItem.callType = mapCallType(recentRecord.direction);
      callHistory.push(callHistoryItem);
    }

    var computedRecentsProperties = recentCalculatedProperties(Object.assign({}, callHistoryItem, recentRecord), languageId, lastViewed, isMobile);
    callHistoryItem.recents.push(computedRecentsProperties);
  });
  return callHistory.map(function (chi) {
    chi.new = chi.recents.some(function (r) {
      return r.new;
    });
    return chi;
  });
} // TODO: Remove this


function mapCallHistoryItem(recentRecord, contact) {
  var callHistoryItem = {
    id: recentRecord.id
  };
  callHistoryItem.dialString = callHistoryItem.remoteParty = recentRecord.remoteParty;
  callHistoryItem.contact = contact;
  callHistoryItem.isManual = true;
  callHistoryItem.isCallable = true;
  callHistoryItem.isGuest = (0, _safeAccess.default)(recentRecord, 'isGuest') || (0, _safeAccess.default)(recentRecord, 'remoteIsGuest');
  callHistoryItem.isChattable = false;
  callHistoryItem.startTimestamp = recentRecord.startTimestamp;
  callHistoryItem.endTimestamp = recentRecord.endTimestamp;

  if (contact) {
    callHistoryItem.dialString = (0, _safeAccess.default)(contact, 'dialString') || recentRecord.remoteParty;
    callHistoryItem.isManual = false;
    callHistoryItem.isCallable = contact.isCallable;
    callHistoryItem.isChattable = contact.isChattable;
  } // displayName


  callHistoryItem.displayName = (0, _safeAccess.default)(callHistoryItem, 'contact.name') || recentRecord.remoteDisplayName || recentRecord.remoteParty || 'Guest';
  return callHistoryItem;
}

function recentCalculatedProperties(callHistory, languageId, lastViewed, isMobile) {
  var computedProperties = {};
  computedProperties.id = callHistory.id;
  computedProperties.start = new Date(callHistory.callStartTime);
  computedProperties.end = new Date(callHistory.callEndTime);
  computedProperties.timeElapsed = isMobile ? 'NotCalculatedForMobile' : DateUtils.formatTSForCallHistory(computedProperties.start, languageId);
  computedProperties.callType = mapCallType(callHistory.direction);
  computedProperties.new = computedProperties.callType === c.CALL_HISTORY_MISSED && lastViewed < computedProperties.start;
  return computedProperties;
}

function isMissed(callType) {
  return callType === '2' || callType === 'MISSED';
}

function mapCallType(callType) {
  switch (callType) {
    case '0':
    case 'INCOMING':
    case 'IN':
      {
        return c.CALL_HISTORY_INCOMING;
      }

    case '1':
    case 'OUTGOING':
    case 'OUT':
      {
        return c.CALL_HISTORY_OUTGOING;
      }

    case '2':
    case 'MISSED':
      {
        return c.CALL_HISTORY_MISSED;
      }

    default:
      {
        return callType;
      }
  }
}

function mapCallHistoryEventToActions(payload) {
  var created = (0, _safeAccess.default)(payload, 'body.created') || [];
  var deleted = (0, _safeAccess.default)(payload, 'body.deleted') || [];
  var createdActions = created.map(function (r) {
    return (0, _serverPush.serverPushAddCallHistory)(mapCallHistoryRecord(r));
  });
  var deletedActions = deleted.map(function (r) {
    return (0, _serverPush.serverPushDeleteCallHistory)(mapCallHistoryRecord(r));
  });
  return createdActions.concat(deletedActions);
}

function mapCallHistoryRecord(body) {
  return {
    callType: (0, _safeAccess.default)(body, 'type'),
    durationSeconds: (0, _safeAccess.default)(body, 'duration'),
    endTimestamp: (0, _safeAccess.default)(body, 'endTS'),
    id: (0, _safeAccess.default)(body, 'callHistoryUUID'),
    isGuest: (0, _safeAccess.default)(body, 'remoteIsGuest'),
    remoteDisplayName: (0, _safeAccess.default)(body, 'remoteDisplayString'),
    remoteParty: (0, _safeAccess.default)(body, 'remoteParty'),
    startTimestamp: (0, _safeAccess.default)(body, 'startTS')
  };
}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkHttpStatus = checkHttpStatus;
exports.objectToUrlParameters = objectToUrlParameters;
exports.urlParametersToObject = urlParametersToObject;

/** @module utils/http-utils */

/**
 * Interpret an http response from fetch for success or failure
 * @param {object} response - Response object from fetch
 * @throws {Object} If status of response is >= 400
 * @return response parameter untouched
 */
function checkHttpStatus(response) {
  if (!response) {
    throw {
      message: 'Received no response',
      response: {
        status: 500,
        statusText: 'No Response',
        url: null
      }
    };
  }

  if (response.status >= 400) {
    var error = {
      message: response.statusText,
      response: {
        status: response.status,
        statusText: response.statusText,
        url: response.url
      }
    };
    throw error;
  } else {
    return response;
  }
}
/**
 * Convert an object of key:value pairs to URL encoded string
 * @param {object} obj - Object of key: value pairs
 * @return {string} url parameter string
 */


function objectToUrlParameters(obj) {
  var urlParams = [];

  for (var prop in obj) {
    /* istanbul ignore else */
    if (Object.hasOwnProperty.call(obj, prop)) {
      urlParams.push(encodeURIComponent(prop) + '=' + encodeURIComponent(obj[prop]));
    }
  }

  return urlParams.length ? '?' + urlParams.join('&') : '';
}
/**
 * Convert a URL encoded string to an object of key:value pairs
 * @param {string} url parameter string
 * @return {object} obj - Object of key: value pairs
 */


function urlParametersToObject(url) {
  var result = {};
  var parameters = url.split('?');

  if (parameters.length < 2) {
    return result;
  }

  parameters[1].split('&').forEach(function (part) {
    var item = part.split('=');
    result[item[0]] = decodeURIComponent(item[1]);
  });
  return result;
}

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__DO_NOT_USE__ActionTypes", function() { return ActionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return applyMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return createStore; });
/* harmony import */ var symbol_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(131);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[symbol_observable__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[symbol_observable__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {}

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {}

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) { var warningMessage; }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {}




/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOAD = exports.LOAD = 'REDUX_STORAGE_LOAD';
var SAVE = exports.SAVE = 'REDUX_STORAGE_SAVE';

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Scheduler; });
var Scheduler = /*@__PURE__*/ (function () {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) {
            now = Scheduler.now;
        }
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    Scheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) {
            delay = 0;
        }
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = function () { return Date.now(); };
    return Scheduler;
}());

//# sourceMappingURL=Scheduler.js.map


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var _ponyfill_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(294);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {}

var result = Object(_ponyfill_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(582)(module)))

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(119),
    toKey = __webpack_require__(100);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(89);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(318),
    listCacheDelete = __webpack_require__(319),
    listCacheGet = __webpack_require__(320),
    listCacheHas = __webpack_require__(321),
    listCacheSet = __webpack_require__(322);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(169);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(324);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return groupBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GroupedObservable; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20);
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10);
/* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22);
/** PURE_IMPORTS_START tslib,_Subscriber,_Subscription,_Observable,_Subject PURE_IMPORTS_END */





function groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
    return function (source) {
        return source.lift(new GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector));
    };
}
var GroupByOperator = /*@__PURE__*/ (function () {
    function GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector) {
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
    }
    GroupByOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new GroupBySubscriber(subscriber, this.keySelector, this.elementSelector, this.durationSelector, this.subjectSelector));
    };
    return GroupByOperator;
}());
var GroupBySubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"](GroupBySubscriber, _super);
    function GroupBySubscriber(destination, keySelector, elementSelector, durationSelector, subjectSelector) {
        var _this = _super.call(this, destination) || this;
        _this.keySelector = keySelector;
        _this.elementSelector = elementSelector;
        _this.durationSelector = durationSelector;
        _this.subjectSelector = subjectSelector;
        _this.groups = null;
        _this.attemptedToUnsubscribe = false;
        _this.count = 0;
        return _this;
    }
    GroupBySubscriber.prototype._next = function (value) {
        var key;
        try {
            key = this.keySelector(value);
        }
        catch (err) {
            this.error(err);
            return;
        }
        this._group(value, key);
    };
    GroupBySubscriber.prototype._group = function (value, key) {
        var groups = this.groups;
        if (!groups) {
            groups = this.groups = new Map();
        }
        var group = groups.get(key);
        var element;
        if (this.elementSelector) {
            try {
                element = this.elementSelector(value);
            }
            catch (err) {
                this.error(err);
            }
        }
        else {
            element = value;
        }
        if (!group) {
            group = (this.subjectSelector ? this.subjectSelector() : new _Subject__WEBPACK_IMPORTED_MODULE_4__[/* Subject */ "a"]());
            groups.set(key, group);
            var groupedObservable = new GroupedObservable(key, group, this);
            this.destination.next(groupedObservable);
            if (this.durationSelector) {
                var duration = void 0;
                try {
                    duration = this.durationSelector(new GroupedObservable(key, group));
                }
                catch (err) {
                    this.error(err);
                    return;
                }
                this.add(duration.subscribe(new GroupDurationSubscriber(key, group, this)));
            }
        }
        if (!group.closed) {
            group.next(element);
        }
    };
    GroupBySubscriber.prototype._error = function (err) {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function (group, key) {
                group.error(err);
            });
            groups.clear();
        }
        this.destination.error(err);
    };
    GroupBySubscriber.prototype._complete = function () {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function (group, key) {
                group.complete();
            });
            groups.clear();
        }
        this.destination.complete();
    };
    GroupBySubscriber.prototype.removeGroup = function (key) {
        this.groups.delete(key);
    };
    GroupBySubscriber.prototype.unsubscribe = function () {
        if (!this.closed) {
            this.attemptedToUnsubscribe = true;
            if (this.count === 0) {
                _super.prototype.unsubscribe.call(this);
            }
        }
    };
    return GroupBySubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__[/* Subscriber */ "a"]));
var GroupDurationSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"](GroupDurationSubscriber, _super);
    function GroupDurationSubscriber(key, group, parent) {
        var _this = _super.call(this, group) || this;
        _this.key = key;
        _this.group = group;
        _this.parent = parent;
        return _this;
    }
    GroupDurationSubscriber.prototype._next = function (value) {
        this.complete();
    };
    GroupDurationSubscriber.prototype._unsubscribe = function () {
        var _a = this, parent = _a.parent, key = _a.key;
        this.key = this.parent = null;
        if (parent) {
            parent.removeGroup(key);
        }
    };
    return GroupDurationSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__[/* Subscriber */ "a"]));
var GroupedObservable = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"](GroupedObservable, _super);
    function GroupedObservable(key, groupSubject, refCountSubscription) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.groupSubject = groupSubject;
        _this.refCountSubscription = refCountSubscription;
        return _this;
    }
    GroupedObservable.prototype._subscribe = function (subscriber) {
        var subscription = new _Subscription__WEBPACK_IMPORTED_MODULE_2__[/* Subscription */ "a"]();
        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
        if (refCountSubscription && !refCountSubscription.closed) {
            subscription.add(new InnerRefCountSubscription(refCountSubscription));
        }
        subscription.add(groupSubject.subscribe(subscriber));
        return subscription;
    };
    return GroupedObservable;
}(_Observable__WEBPACK_IMPORTED_MODULE_3__[/* Observable */ "a"]));

var InnerRefCountSubscription = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"](InnerRefCountSubscription, _super);
    function InnerRefCountSubscription(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        parent.count++;
        return _this;
    }
    InnerRefCountSubscription.prototype.unsubscribe = function () {
        var parent = this.parent;
        if (!parent.closed && !this.closed) {
            _super.prototype.unsubscribe.call(this);
            parent.count -= 1;
            if (parent.count === 0 && parent.attemptedToUnsubscribe) {
                parent.unsubscribe();
            }
        }
    };
    return InnerRefCountSubscription;
}(_Subscription__WEBPACK_IMPORTED_MODULE_2__[/* Subscription */ "a"]));
//# sourceMappingURL=groupBy.js.map


/***/ }),
/* 138 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(354),
    isObjectLike = __webpack_require__(70);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(57),
    stubFalse = __webpack_require__(389);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(103)(module)))

/***/ }),
/* 141 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 142 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectedAudioOutputDevice = exports.primaryAudioDevice = exports.selectedAudioDevice = exports.primaryVideoDevice = exports.selectedVideoDevice = exports.videoDevices = exports.audioOutputDevices = exports.audioDevices = exports.selectIsTogglingAudioMute = exports.selectIsLocalAudioMuted = exports.selectMedia = void 0;

var _reselect = __webpack_require__(23);

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

/** @module selectors/media */
var selectMedia = function selectMedia(state) {
  return (0, _safeAccess.default)(state, 'nucleus.media') || {};
};

exports.selectMedia = selectMedia;

var selectIsLocalAudioMuted = function selectIsLocalAudioMuted(state) {
  return (0, _safeAccess.default)(selectMedia(state), 'isAudioMuted');
};

exports.selectIsLocalAudioMuted = selectIsLocalAudioMuted;

var selectIsTogglingAudioMute = function selectIsTogglingAudioMute(state) {
  return (0, _safeAccess.default)(selectMedia(state), 'togglingAudioMute');
};
/**
 * Selects the list of available audio device sources
 * @example
 * Returns...
 * [{
 *  deviceId: default,
 *  groupId: "1dc4ef2aa8a60a7b4dc4b1912761a50e6ee6e0e96942226922fce07a860ecd3a",
 *  kind: "audioinput",
 *  label: 'microphone 1'
 * }]
 */


exports.selectIsTogglingAudioMute = selectIsTogglingAudioMute;
var audioDevices = (0, _reselect.createSelector)(selectMedia, function (media) {
  return media.devices.filter(function (d) {
    return d.kind === 'audioinput';
  });
});
exports.audioDevices = audioDevices;

/**
 * Selects the list of available audio output devices
 * @example
 * Returns...
 * [{
 *  deviceId: default,
 *  groupId: "1dc4ef2aa8a60a7b4dc4b1912761a50e6ee6e0e96942226922fce07a860ecd3a",
 *  kind: "audiooutput",
 *  label: 'speaker 1'
 * }]
 */
var audioOutputDevices = (0, _reselect.createSelector)(selectMedia, function (media) {
  return media.devices.filter(function (d) {
    return d.kind === 'audiooutput';
  });
});
exports.audioOutputDevices = audioOutputDevices;

/**
 * Selects the list of available video device sources
 * @example
 * Returns...
 * [{
 *  deviceId: default,
 *  groupId: "1dc4ef2aa8a60a7b4dc4b1912761a50e6ee6e0e96942226922fce07a860ecd3a",
 *  kind: "videoinput",
 *  label: 'camera 1'
 * }]
 */
var videoDevices = (0, _reselect.createSelector)(selectMedia, function (media) {
  return media.devices.filter(function (d) {
    return d.kind === 'videoinput';
  });
});
exports.videoDevices = videoDevices;

/**
 * Returns the currently selected video device if one has been selected, and if it is available.
 * This may differ from the primaryVideoDevice if the primaryVideoDevice is not connected.
 * @example
 * Returns...
 * {
 *  deviceId: default,
 *  groupId: "1dc4ef2aa8a60a7b4dc4b1912761a50e6ee6e0e96942226922fce07a860ecd3a",
 *  kind: "videoinput",
 *  label: 'camera 1',
 *  available: true
 * }
 */
var selectedVideoDevice = (0, _reselect.createSelector)(selectMedia, function (media) {
  if (!media.selectedVideoSourceId) return null;
  var device = media.devices.find(function (d) {
    return d.deviceId === media.selectedVideoSourceId;
  });

  if (!device) {
    return {
      deviceId: media.selectedVideoSourceId,
      kind: 'videoinput',
      groupId: null,
      label: null,
      available: false
    };
  }

  return {
    deviceId: device.deviceId,
    kind: device.kind,
    groupId: device.groupId,
    label: device.label,
    available: true
  };
});
exports.selectedVideoDevice = selectedVideoDevice;

/**
 * Returns the primary video device if one has been selected, and with info if it is available
 * selected in the UI.
 * @example
 * Returns...
 * {
 *  deviceId: default,
 *  groupId: "1dc4ef2aa8a60a7b4dc4b1912761a50e6ee6e0e96942226922fce07a860ecd3a",
 *  kind: "videoinput",
 *  label: 'camera 1',
 *  available: true
 * }
 */
var primaryVideoDevice = (0, _reselect.createSelector)(selectMedia, function (media) {
  if (!media.primaryVideoSourceId) return null;
  var device = media.devices.find(function (d) {
    return d.deviceId === media.primaryVideoSourceId;
  });

  if (!device) {
    return {
      deviceId: media.primaryVideoSourceId,
      kind: 'videoinput',
      groupId: null,
      label: null,
      available: false
    };
  }

  return {
    deviceId: device.deviceId,
    kind: device.kind,
    groupId: device.groupId,
    label: device.label,
    available: true
  };
});
exports.primaryVideoDevice = primaryVideoDevice;

/**
 * Returns the currently selected audio device if one has been selected, and if it is available.
 * This may differ from the primaryAudioDevice if the primaryAudioDevice is not connected.
 * @example
 * Returns...
 * {
 *  deviceId: default,
 *  groupId: "1dc4ef2aa8a60a7b4dc4b1912761a50e6ee6e0e96942226922fce07a860ecd3a",
 *  kind: "audioinput",
 *  label: 'mic 1',
 *  available: true
 * }
 */
var selectedAudioDevice = (0, _reselect.createSelector)(selectMedia, function (media) {
  if (!media.selectedAudioSourceId) return null;
  var device = media.devices.find(function (d) {
    return d.deviceId === media.selectedAudioSourceId;
  });

  if (!device) {
    return {
      deviceId: media.selectedAudioSourceId,
      kind: 'audioinput',
      groupId: null,
      label: null,
      available: false
    };
  }

  return {
    deviceId: device.deviceId,
    kind: device.kind,
    groupId: device.groupId,
    label: device.label,
    available: true
  };
});
exports.selectedAudioDevice = selectedAudioDevice;

/**
 * Returns the primary audio device if one has been selected, and with info if it is available
 * selected in the UI
 * @example
 * Returns...
 * {
 *  deviceId: default,
 *  groupId: "1dc4ef2aa8a60a7b4dc4b1912761a50e6ee6e0e96942226922fce07a860ecd3a",
 *  kind: "audioinput",
 *  label: 'mic 1',
 *  available: true
 * }
 */
var primaryAudioDevice = (0, _reselect.createSelector)(selectMedia, function (media) {
  if (!media.primaryAudioSourceId) return null;
  var device = media.devices.find(function (d) {
    return d.deviceId === media.primaryAudioSourceId;
  });

  if (!device) {
    return {
      deviceId: media.primaryAudioSourceId,
      kind: 'audioinput',
      groupId: null,
      label: null,
      available: false
    };
  }

  return {
    deviceId: device.deviceId,
    kind: device.kind,
    groupId: device.groupId,
    label: device.label,
    available: true
  };
});
exports.primaryAudioDevice = primaryAudioDevice;

/**
 * Returns the currently user selected audio output device if one has been selected, and if it is available
 * @example
 * Returns...
 * {
 *  deviceId: default,
 *  groupId: "1dc4ef2aa8a60a7b4dc4b1912761a50e6ee6e0e96942226922fce07a860ecd3a",
 *  kind: "audiooutput",
 *  label: 'speaker 1',
 *  available: true
 * }
 */
var selectedAudioOutputDevice = (0, _reselect.createSelector)(selectMedia, function (media) {
  var device = media.devices.find(function (d) {
    return d.deviceId === media.primaryAudioOutputId && d.kind === 'audiooutput';
  });

  if (!device) {
    device = media.devices.find(function (d) {
      return d.deviceId === 'default' && d.kind === 'audiooutput';
    });
  }

  if (!device) return null;
  return {
    deviceId: device.deviceId,
    kind: device.kind,
    groupId: device.groupId,
    label: device.label,
    available: true
  };
});
exports.selectedAudioOutputDevice = selectedAudioOutputDevice;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userPresenceUpdate = userPresenceUpdate;
exports.favoritesFirstLocaleSort = favoritesFirstLocaleSort;
exports.getContactWithInCall = getContactWithInCall;
exports.createRawPersonalLifesizeContact = createRawPersonalLifesizeContact;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var C = _interopRequireWildcard(__webpack_require__(3));

var _localeUtils = __webpack_require__(187);

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

function userPresenceUpdate() {
  var records = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var batchedUpdates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return records.map(function (c) {
    var _c$availability;

    var status = batchedUpdates[c.uuid];
    if (!status) return c;
    var newStatus = status === 'unavailable' ? 'NOT_AVAILABLE' : status.toUpperCase();
    return (0, _objectSpread2.default)({}, c, {
      availability: {
        status: newStatus || ((_c$availability = c.availability) === null || _c$availability === void 0 ? void 0 : _c$availability.status)
      },
      isOnline: newStatus === 'AVAILABLE',
      presence: newStatus
    });
  });
}

function favoritesFirstLocaleSort(contacts) {
  var favorites = [];
  var nonFavorites = [];
  contacts.forEach(function (c) {
    if (c.favorite) return favorites.push(c);
    nonFavorites.push(c);
  });
  return (0, _localeUtils.localeSort)(favorites).concat((0, _localeUtils.localeSort)(nonFavorites));
}

function getContactWithInCall(contact, participants, featureFlags) {
  if (!contact) return null;
  var inCall = participants.some(function (p) {
    return p.dialString === contact.dialString;
  }); // contact is callable when:
  // - not in a call
  // AND
  //   - NOT a cloud account
  //   OR
  //   - presence is available
  //   OR
  //   - is a user (we want to allow calling offline users so that mobile devices will get a push
  //     notification of incoming call)

  var enableOfflineCalling = (0, _safeAccess.default)(featureFlags, C.FEATUREFLAG_ENABLE_OFFLINE_CALLING) || false;
  var isCallable = !inCall && (!contact.isCloudAccount || contact.presence === C.CONTACT_AVAILABLE || enableOfflineCalling && contact.isUser);
  var isDeletable = (contact.isPersonalContact || contact.isMyMeeting) && !inCall;
  return Object.assign({}, contact, {
    inCall: inCall,
    isCallable: isCallable,
    isDeletable: isDeletable
  });
}

function createRawPersonalLifesizeContact(name, dialString) {
  return {
    id: dialString,
    contactType: C.CONTACT_TYPE_STANDARD,
    category: C.CONTACT_CATEGORY_PERSONAL,
    name: name,
    extension: dialString,
    isLocallyCreated: true
  };
}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.awaitAction = void 0;

var _constants = __webpack_require__(3);

/**
 * @description Use this action when you need to wait for a different action to be dispatched
 * @param {Function} shouldResolve Function to determine if the incoming action resolves the promise
 * @param {Function} shouldReject Function to determine if the incoming action rejects the promise
 * @param {Number} timeout Maximum time in ms before automatically rejecting the promise
 * @example
 * // Calling an async API that potentially has multiple side-effects
 * dispatch(meetingsApi.createMeeting(params));
 * // Await action that gets dispatched when a notification is received indicating that the API work finished
 * await dispatch(awaitAction(a => a.type === MEETING_CREATION_SUCCESS));
 * @example
 * // shouldReject and timeout parameters can also be provided
 * await dispatch(awaitAction(a => a.type === MEETING_CREATION_SUCCESS, a => a.type === MEETING_CREATION_FAILURE, 10000));
 */
var awaitAction = function awaitAction(shouldResolve) {
  var shouldReject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return false;
  };
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10000;
  return {
    type: _constants.AWAIT_ACTION,
    payload: {
      shouldResolve: shouldResolve,
      shouldReject: shouldReject,
      timeout: timeout
    }
  };
};

exports.awaitAction = awaitAction;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addFavorite = addFavorite;
exports.deleteFavorite = deleteFavorite;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var c = _interopRequireWildcard(__webpack_require__(3));

var _proxy = __webpack_require__(21);

/**
 * Add Favorite
 * Adds a favorite
 * @param {string} type - contact type (CONTACT, USER, MEETING)
 * @param {string} uuid - favorite uuid
 */
function addFavorite(type, uuid) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch) {
        var params;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  favoriteType: type,
                  favoriteUUID: uuid
                };
                _context.prev = 1;
                dispatch({
                  type: c.ADD_FAVORITES_BEGIN,
                  payload: params
                });
                _context.next = 5;
                return dispatch((0, _proxy.proxyApiCall)(c.FAVORITE_HANDLER_ENDPOINT, 'favorite/add', c.HTTP_POST, params));

              case 5:
                dispatch({
                  type: c.ADD_FAVORITES_SUCCESS,
                  payload: params
                });
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                dispatch({
                  type: c.ADD_FAVORITES_FAILURE,
                  payload: {
                    params: params,
                    error: _context.t0
                  }
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 8]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}
/**
 * Delete Favorite
 * Deletes a favorite
 * @param {string} uuid - favorite uuid
 */


function deleteFavorite(uuid) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch) {
        var params;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = {
                  favoriteUUID: uuid
                };
                _context2.prev = 1;
                dispatch({
                  type: c.DELETE_FAVORITES_BEGIN,
                  payload: params
                });
                _context2.next = 5;
                return dispatch((0, _proxy.proxyApiCall)(c.FAVORITE_HANDLER_ENDPOINT, 'favorite/delete', c.HTTP_DELETE, params));

              case 5:
                dispatch({
                  type: c.DELETE_FAVORITES_SUCCESS,
                  payload: params
                });
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);
                dispatch({
                  type: c.DELETE_FAVORITES_FAILURE,
                  payload: {
                    params: params,
                    error: _context2.t0
                  }
                });

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 8]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(173),
    baseAssignValue = __webpack_require__(174);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/redux-saga/es/internal/io.js
var io = __webpack_require__(18);

// EXTERNAL MODULE: ./node_modules/redux-saga/es/internal/sagaHelpers/index.js + 4 modules
var sagaHelpers = __webpack_require__(87);

// CONCATENATED MODULE: ./node_modules/redux-saga/es/internal/io-helpers.js



function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return io["k" /* fork */].apply(undefined, [sagaHelpers["b" /* takeEveryHelper */], patternOrChannel, worker].concat(args));
}

function takeLatest(patternOrChannel, worker) {
  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  return io["k" /* fork */].apply(undefined, [sagaHelpers["d" /* takeLatestHelper */], patternOrChannel, worker].concat(args));
}

function throttle(ms, pattern, worker) {
  for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
    args[_key3 - 3] = arguments[_key3];
  }

  return io["k" /* fork */].apply(undefined, [sagaHelpers["f" /* throttleHelper */], ms, pattern, worker].concat(args));
}
// CONCATENATED MODULE: ./node_modules/redux-saga/es/effects.js
/* concated harmony reexport take */__webpack_require__.d(__webpack_exports__, "take", function() { return io["s" /* take */]; });
/* concated harmony reexport takem */__webpack_require__.d(__webpack_exports__, "takem", function() { return io["t" /* takem */]; });
/* concated harmony reexport put */__webpack_require__.d(__webpack_exports__, "put", function() { return io["n" /* put */]; });
/* concated harmony reexport all */__webpack_require__.d(__webpack_exports__, "all", function() { return io["b" /* all */]; });
/* concated harmony reexport race */__webpack_require__.d(__webpack_exports__, "race", function() { return io["o" /* race */]; });
/* concated harmony reexport call */__webpack_require__.d(__webpack_exports__, "call", function() { return io["e" /* call */]; });
/* concated harmony reexport apply */__webpack_require__.d(__webpack_exports__, "apply", function() { return io["c" /* apply */]; });
/* concated harmony reexport cps */__webpack_require__.d(__webpack_exports__, "cps", function() { return io["h" /* cps */]; });
/* concated harmony reexport fork */__webpack_require__.d(__webpack_exports__, "fork", function() { return io["k" /* fork */]; });
/* concated harmony reexport spawn */__webpack_require__.d(__webpack_exports__, "spawn", function() { return io["r" /* spawn */]; });
/* concated harmony reexport join */__webpack_require__.d(__webpack_exports__, "join", function() { return io["m" /* join */]; });
/* concated harmony reexport cancel */__webpack_require__.d(__webpack_exports__, "cancel", function() { return io["f" /* cancel */]; });
/* concated harmony reexport select */__webpack_require__.d(__webpack_exports__, "select", function() { return io["p" /* select */]; });
/* concated harmony reexport actionChannel */__webpack_require__.d(__webpack_exports__, "actionChannel", function() { return io["a" /* actionChannel */]; });
/* concated harmony reexport cancelled */__webpack_require__.d(__webpack_exports__, "cancelled", function() { return io["g" /* cancelled */]; });
/* concated harmony reexport flush */__webpack_require__.d(__webpack_exports__, "flush", function() { return io["j" /* flush */]; });
/* concated harmony reexport getContext */__webpack_require__.d(__webpack_exports__, "getContext", function() { return io["l" /* getContext */]; });
/* concated harmony reexport setContext */__webpack_require__.d(__webpack_exports__, "setContext", function() { return io["q" /* setContext */]; });
/* concated harmony reexport takeEvery */__webpack_require__.d(__webpack_exports__, "takeEvery", function() { return takeEvery; });
/* concated harmony reexport takeLatest */__webpack_require__.d(__webpack_exports__, "takeLatest", function() { return takeLatest; });
/* concated harmony reexport throttle */__webpack_require__.d(__webpack_exports__, "throttle", function() { return throttle; });




/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return timer; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10);
/* harmony import */ var _scheduler_async__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25);
/* harmony import */ var _util_isNumeric__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69);
/* harmony import */ var _util_isScheduler__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27);
/** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric,_util_isScheduler PURE_IMPORTS_END */




function timer(dueTime, periodOrScheduler, scheduler) {
    if (dueTime === void 0) {
        dueTime = 0;
    }
    var period = -1;
    if (Object(_util_isNumeric__WEBPACK_IMPORTED_MODULE_2__[/* isNumeric */ "a"])(periodOrScheduler)) {
        period = Number(periodOrScheduler) < 1 && 1 || Number(periodOrScheduler);
    }
    else if (Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_3__[/* isScheduler */ "a"])(periodOrScheduler)) {
        scheduler = periodOrScheduler;
    }
    if (!Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_3__[/* isScheduler */ "a"])(scheduler)) {
        scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_1__[/* async */ "a"];
    }
    return new _Observable__WEBPACK_IMPORTED_MODULE_0__[/* Observable */ "a"](function (subscriber) {
        var due = Object(_util_isNumeric__WEBPACK_IMPORTED_MODULE_2__[/* isNumeric */ "a"])(dueTime)
            ? dueTime
            : (+dueTime - scheduler.now());
        return scheduler.schedule(dispatch, due, {
            index: 0, period: period, subscriber: subscriber
        });
    });
}
function dispatch(state) {
    var index = state.index, period = state.period, subscriber = state.subscriber;
    subscriber.next(index);
    if (subscriber.closed) {
        return;
    }
    else if (period === -1) {
        return subscriber.complete();
    }
    state.index = index + 1;
    this.schedule(state, period);
}
//# sourceMappingURL=timer.js.map


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return concatAll; });
/* harmony import */ var _mergeAll__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(107);
/** PURE_IMPORTS_START _mergeAll PURE_IMPORTS_END */

function concatAll() {
    return Object(_mergeAll__WEBPACK_IMPORTED_MODULE_0__[/* mergeAll */ "a"])(1);
}
//# sourceMappingURL=concatAll.js.map


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return merge; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10);
/* harmony import */ var _util_isScheduler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27);
/* harmony import */ var _operators_mergeAll__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(107);
/* harmony import */ var _fromArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66);
/** PURE_IMPORTS_START _Observable,_util_isScheduler,_operators_mergeAll,_fromArray PURE_IMPORTS_END */




function merge() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if (Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_1__[/* isScheduler */ "a"])(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') {
            concurrent = observables.pop();
        }
    }
    else if (typeof last === 'number') {
        concurrent = observables.pop();
    }
    if (scheduler === null && observables.length === 1 && observables[0] instanceof _Observable__WEBPACK_IMPORTED_MODULE_0__[/* Observable */ "a"]) {
        return observables[0];
    }
    return Object(_operators_mergeAll__WEBPACK_IMPORTED_MODULE_2__[/* mergeAll */ "a"])(concurrent)(Object(_fromArray__WEBPACK_IMPORTED_MODULE_3__[/* fromArray */ "a"])(observables, scheduler));
}
//# sourceMappingURL=merge.js.map


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConnectableObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return connectableObservableDescriptor; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22);
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10);
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20);
/* harmony import */ var _operators_refCount__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(109);
/** PURE_IMPORTS_START tslib,_Subject,_Observable,_Subscriber,_Subscription,_operators_refCount PURE_IMPORTS_END */






var ConnectableObservable = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"](ConnectableObservable, _super);
    function ConnectableObservable(source, subjectFactory) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subjectFactory = subjectFactory;
        _this._refCount = 0;
        _this._isComplete = false;
        return _this;
    }
    ConnectableObservable.prototype._subscribe = function (subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    ConnectableObservable.prototype.getSubject = function () {
        var subject = this._subject;
        if (!subject || subject.isStopped) {
            this._subject = this.subjectFactory();
        }
        return this._subject;
    };
    ConnectableObservable.prototype.connect = function () {
        var connection = this._connection;
        if (!connection) {
            this._isComplete = false;
            connection = this._connection = new _Subscription__WEBPACK_IMPORTED_MODULE_4__[/* Subscription */ "a"]();
            connection.add(this.source
                .subscribe(new ConnectableSubscriber(this.getSubject(), this)));
            if (connection.closed) {
                this._connection = null;
                connection = _Subscription__WEBPACK_IMPORTED_MODULE_4__[/* Subscription */ "a"].EMPTY;
            }
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function () {
        return Object(_operators_refCount__WEBPACK_IMPORTED_MODULE_5__[/* refCount */ "a"])()(this);
    };
    return ConnectableObservable;
}(_Observable__WEBPACK_IMPORTED_MODULE_2__[/* Observable */ "a"]));

var connectableObservableDescriptor = /*@__PURE__*/ (function () {
    var connectableProto = ConnectableObservable.prototype;
    return {
        operator: { value: null },
        _refCount: { value: 0, writable: true },
        _subject: { value: null, writable: true },
        _connection: { value: null, writable: true },
        _subscribe: { value: connectableProto._subscribe },
        _isComplete: { value: connectableProto._isComplete, writable: true },
        getSubject: { value: connectableProto.getSubject },
        connect: { value: connectableProto.connect },
        refCount: { value: connectableProto.refCount }
    };
})();
var ConnectableSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"](ConnectableSubscriber, _super);
    function ConnectableSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    ConnectableSubscriber.prototype._error = function (err) {
        this._unsubscribe();
        _super.prototype._error.call(this, err);
    };
    ConnectableSubscriber.prototype._complete = function () {
        this.connectable._isComplete = true;
        this._unsubscribe();
        _super.prototype._complete.call(this);
    };
    ConnectableSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (connectable) {
            this.connectable = null;
            var connection = connectable._connection;
            connectable._refCount = 0;
            connectable._subject = null;
            connectable._connection = null;
            if (connection) {
                connection.unsubscribe();
            }
        }
    };
    return ConnectableSubscriber;
}(_Subject__WEBPACK_IMPORTED_MODULE_1__[/* SubjectSubscriber */ "b"]));
var RefCountOperator = /*@__PURE__*/ (function () {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function (subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) {
            refCounter.connection = connectable.connect();
        }
        return subscription;
    };
    return RefCountOperator;
}());
var RefCountSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"](RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    RefCountSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) {
            sharedConnection.unsubscribe();
        }
    };
    return RefCountSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_3__[/* Subscriber */ "a"]));
//# sourceMappingURL=ConnectableObservable.js.map


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return observeOn; });
/* unused harmony export ObserveOnOperator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ObserveOnSubscriber; });
/* unused harmony export ObserveOnMessage */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _Notification__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46);
/** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */



function observeOn(scheduler, delay) {
    if (delay === void 0) {
        delay = 0;
    }
    return function observeOnOperatorFunction(source) {
        return source.lift(new ObserveOnOperator(scheduler, delay));
    };
}
var ObserveOnOperator = /*@__PURE__*/ (function () {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}());

var ObserveOnSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"](ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        var _this = _super.call(this, destination) || this;
        _this.scheduler = scheduler;
        _this.delay = delay;
        return _this;
    }
    ObserveOnSubscriber.dispatch = function (arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
        var destination = this.destination;
        destination.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function (value) {
        this.scheduleMessage(_Notification__WEBPACK_IMPORTED_MODULE_2__[/* Notification */ "a"].createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function (err) {
        this.scheduleMessage(_Notification__WEBPACK_IMPORTED_MODULE_2__[/* Notification */ "a"].createError(err));
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype._complete = function () {
        this.scheduleMessage(_Notification__WEBPACK_IMPORTED_MODULE_2__[/* Notification */ "a"].createComplete());
        this.unsubscribe();
    };
    return ObserveOnSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__[/* Subscriber */ "a"]));

var ObserveOnMessage = /*@__PURE__*/ (function () {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}());

//# sourceMappingURL=observeOn.js.map


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BehaviorSubject; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22);
/* harmony import */ var _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56);
/** PURE_IMPORTS_START tslib,_Subject,_util_ObjectUnsubscribedError PURE_IMPORTS_END */



var BehaviorSubject = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"](BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function () {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function (subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) {
            subscriber.next(this._value);
        }
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function () {
        if (this.hasError) {
            throw this.thrownError;
        }
        else if (this.closed) {
            throw new _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_2__[/* ObjectUnsubscribedError */ "a"]();
        }
        else {
            return this._value;
        }
    };
    BehaviorSubject.prototype.next = function (value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}(_Subject__WEBPACK_IMPORTED_MODULE_1__[/* Subject */ "a"]));

//# sourceMappingURL=BehaviorSubject.js.map


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return race; });
/* unused harmony export RaceOperator */
/* unused harmony export RaceSubscriber */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24);
/* harmony import */ var _fromArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66);
/* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16);
/* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15);
/** PURE_IMPORTS_START tslib,_util_isArray,_fromArray,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */





function race() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    if (observables.length === 1) {
        if (Object(_util_isArray__WEBPACK_IMPORTED_MODULE_1__[/* isArray */ "a"])(observables[0])) {
            observables = observables[0];
        }
        else {
            return observables[0];
        }
    }
    return Object(_fromArray__WEBPACK_IMPORTED_MODULE_2__[/* fromArray */ "a"])(observables, undefined).lift(new RaceOperator());
}
var RaceOperator = /*@__PURE__*/ (function () {
    function RaceOperator() {
    }
    RaceOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RaceSubscriber(subscriber));
    };
    return RaceOperator;
}());

var RaceSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"](RaceSubscriber, _super);
    function RaceSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasFirst = false;
        _this.observables = [];
        _this.subscriptions = [];
        return _this;
    }
    RaceSubscriber.prototype._next = function (observable) {
        this.observables.push(observable);
    };
    RaceSubscriber.prototype._complete = function () {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
            this.destination.complete();
        }
        else {
            for (var i = 0; i < len && !this.hasFirst; i++) {
                var observable = observables[i];
                var subscription = Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_4__[/* subscribeToResult */ "a"])(this, observable, observable, i);
                if (this.subscriptions) {
                    this.subscriptions.push(subscription);
                }
                this.add(subscription);
            }
            this.observables = null;
        }
    };
    RaceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (!this.hasFirst) {
            this.hasFirst = true;
            for (var i = 0; i < this.subscriptions.length; i++) {
                if (i !== outerIndex) {
                    var subscription = this.subscriptions[i];
                    subscription.unsubscribe();
                    this.remove(subscription);
                }
            }
            this.subscriptions = null;
        }
        this.destination.next(innerValue);
    };
    return RaceSubscriber;
}(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_3__[/* OuterSubscriber */ "a"]));

//# sourceMappingURL=race.js.map


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimeoutError; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var TimeoutErrorImpl = /*@__PURE__*/ (function () {
    function TimeoutErrorImpl() {
        Error.call(this);
        this.message = 'Timeout has occurred';
        this.name = 'TimeoutError';
        return this;
    }
    TimeoutErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return TimeoutErrorImpl;
})();
var TimeoutError = TimeoutErrorImpl;
//# sourceMappingURL=TimeoutError.js.map


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Observable.js + 1 modules
var Observable = __webpack_require__(10);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Subscription.js
var Subscription = __webpack_require__(20);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/symbol/observable.js
var symbol_observable = __webpack_require__(55);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/scheduled/scheduleObservable.js
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_observable PURE_IMPORTS_END */



function scheduleObservable(input, scheduler) {
    return new Observable["a" /* Observable */](function (subscriber) {
        var sub = new Subscription["a" /* Subscription */]();
        sub.add(scheduler.schedule(function () {
            var observable = input[symbol_observable["a" /* observable */]]();
            sub.add(observable.subscribe({
                next: function (value) { sub.add(scheduler.schedule(function () { return subscriber.next(value); })); },
                error: function (err) { sub.add(scheduler.schedule(function () { return subscriber.error(err); })); },
                complete: function () { sub.add(scheduler.schedule(function () { return subscriber.complete(); })); },
            }));
        }));
        return sub;
    });
}
//# sourceMappingURL=scheduleObservable.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/scheduled/schedulePromise.js
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */


function schedulePromise(input, scheduler) {
    return new Observable["a" /* Observable */](function (subscriber) {
        var sub = new Subscription["a" /* Subscription */]();
        sub.add(scheduler.schedule(function () {
            return input.then(function (value) {
                sub.add(scheduler.schedule(function () {
                    subscriber.next(value);
                    sub.add(scheduler.schedule(function () { return subscriber.complete(); }));
                }));
            }, function (err) {
                sub.add(scheduler.schedule(function () { return subscriber.error(err); }));
            });
        }));
        return sub;
    });
}
//# sourceMappingURL=schedulePromise.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/scheduled/scheduleArray.js
var scheduleArray = __webpack_require__(115);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/symbol/iterator.js
var symbol_iterator = __webpack_require__(47);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/scheduled/scheduleIterable.js
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_iterator PURE_IMPORTS_END */



function scheduleIterable(input, scheduler) {
    if (!input) {
        throw new Error('Iterable cannot be null');
    }
    return new Observable["a" /* Observable */](function (subscriber) {
        var sub = new Subscription["a" /* Subscription */]();
        var iterator;
        sub.add(function () {
            if (iterator && typeof iterator.return === 'function') {
                iterator.return();
            }
        });
        sub.add(scheduler.schedule(function () {
            iterator = input[symbol_iterator["a" /* iterator */]]();
            sub.add(scheduler.schedule(function () {
                if (subscriber.closed) {
                    return;
                }
                var value;
                var done;
                try {
                    var result = iterator.next();
                    value = result.value;
                    done = result.done;
                }
                catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) {
                    subscriber.complete();
                }
                else {
                    subscriber.next(value);
                    this.schedule();
                }
            }));
        }));
        return sub;
    });
}
//# sourceMappingURL=scheduleIterable.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/util/isInteropObservable.js
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */

function isInteropObservable(input) {
    return input && typeof input[symbol_observable["a" /* observable */]] === 'function';
}
//# sourceMappingURL=isInteropObservable.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isPromise.js
var isPromise = __webpack_require__(161);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isArrayLike.js
var isArrayLike = __webpack_require__(159);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/util/isIterable.js
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */

function isIterable(input) {
    return input && typeof input[symbol_iterator["a" /* iterator */]] === 'function';
}
//# sourceMappingURL=isIterable.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/scheduled/scheduled.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return scheduled; });
/** PURE_IMPORTS_START _scheduleObservable,_schedulePromise,_scheduleArray,_scheduleIterable,_util_isInteropObservable,_util_isPromise,_util_isArrayLike,_util_isIterable PURE_IMPORTS_END */








function scheduled(input, scheduler) {
    if (input != null) {
        if (isInteropObservable(input)) {
            return scheduleObservable(input, scheduler);
        }
        else if (Object(isPromise["a" /* isPromise */])(input)) {
            return schedulePromise(input, scheduler);
        }
        else if (Object(isArrayLike["a" /* isArrayLike */])(input)) {
            return Object(scheduleArray["a" /* scheduleArray */])(input, scheduler);
        }
        else if (isIterable(input) || typeof input === 'string') {
            return scheduleIterable(input, scheduler);
        }
    }
    throw new TypeError((input !== null && typeof input || input) + ' is not observable');
}
//# sourceMappingURL=scheduled.js.map


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(0);

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/AsyncAction.js + 1 modules
var AsyncAction = __webpack_require__(68);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/QueueAction.js
/** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */


var QueueAction_QueueAction = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](QueueAction, _super);
    function QueueAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    QueueAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay > 0) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function (state, delay) {
        return (delay > 0 || this.closed) ?
            _super.prototype.execute.call(this, state, delay) :
            this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        return scheduler.flush(this);
    };
    return QueueAction;
}(AsyncAction["a" /* AsyncAction */]));

//# sourceMappingURL=QueueAction.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/AsyncScheduler.js
var AsyncScheduler = __webpack_require__(65);

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/QueueScheduler.js
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */


var QueueScheduler_QueueScheduler = /*@__PURE__*/ (function (_super) {
    tslib_es6["c" /* __extends */](QueueScheduler, _super);
    function QueueScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QueueScheduler;
}(AsyncScheduler["a" /* AsyncScheduler */]));

//# sourceMappingURL=QueueScheduler.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/queue.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return queue; });
/** PURE_IMPORTS_START _QueueAction,_QueueScheduler PURE_IMPORTS_END */


var queue = /*@__PURE__*/ new QueueScheduler_QueueScheduler(QueueAction_QueueAction);
//# sourceMappingURL=queue.js.map


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isArrayLike; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var isArrayLike = (function (x) { return x && typeof x.length === 'number' && typeof x !== 'function'; });
//# sourceMappingURL=isArrayLike.js.map


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return subscribeToArray; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var subscribeToArray = function (array) {
    return function (subscriber) {
        for (var i = 0, len = array.length; i < len && !subscriber.closed; i++) {
            subscriber.next(array[i]);
        }
        subscriber.complete();
    };
};
//# sourceMappingURL=subscribeToArray.js.map


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isPromise; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isPromise(value) {
    return !!value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
//# sourceMappingURL=isPromise.js.map


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SubjectSubscription; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20);
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */


var SubjectSubscription = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"](SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        var _this = _super.call(this) || this;
        _this.subject = subject;
        _this.subscriber = subscriber;
        _this.closed = false;
        return _this;
    }
    SubjectSubscription.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
            return;
        }
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) {
            observers.splice(subscriberIndex, 1);
        }
    };
    return SubjectSubscription;
}(_Subscription__WEBPACK_IMPORTED_MODULE_1__[/* Subscription */ "a"]));

//# sourceMappingURL=SubjectSubscription.js.map


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return not; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function not(pred, thisArg) {
    function notPred() {
        return !(notPred.pred.apply(notPred.thisArg, arguments));
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}
//# sourceMappingURL=not.js.map


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var RTCDataChannelState = {
  connecting: 'connecting',
  open: 'open',
  closing: 'closing',
  closed: 'closed'
};
var _default = RTCDataChannelState;
exports.default = _default;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var levels = {
  warning: _jsLogger.default.WARN,
  debug: _jsLogger.default.DEBUG,
  info: _jsLogger.default.INFO,
  error: _jsLogger.default.ERROR,
  off: _jsLogger.default.OFF
};
var actions = {
  setLevel: 'LOGGER_SET_LEVEL'
};
var _default = {
  levels: levels,
  actions: actions
};
exports.default = _default;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.service = exports.actions = void 0;
var actions = {
  DATA_CHANNEL_ANSWER_RECEIVED: 'DATA_CHANNEL_ANSWER_RECEIVED',
  DATA_CHANNEL_CLOSED: 'DATA_CHANNEL_CLOSED',
  DATA_CHANNEL_CLOSING: 'DATA_CHANNEL_CLOSING',
  DATA_CHANNEL_CREATE_OFFER: 'DATA_CHANNEL_CREATE_OFFER',
  DATA_CHANNEL_ICECANDIDATE: 'DATA_CHANNEL_ICECANDIDATE',
  DATA_CHANNEL_OFFER_RECEIVED: 'DATA_CHANNEL_OFFER_RECEIVED',
  DATA_CHANNEL_OPENED: 'DATA_CHANNEL_OPENED',
  DATA_CHANNEL_SEND_MESSAGE: 'DATA_CHANNEL_SEND_MESSAGE',
  DATA_CHANNEL_START_UP: 'DATA_CHANNEL_START_UP',
  DATA_CHANNEL_STREAM_ENDED: 'DATA_CHANNEL_STREAM_ENDED',
  DATA_CHANNEL_RECONNECT: 'DATA_CHANNEL_RECONNECT'
};
exports.actions = actions;
var service = {
  name: 'lifesize.deviceMessaging',
  actions: {
    sendAction: 'sendAction',
    sendState: 'sendState',
    requestState: 'requestState'
  },
  dataChannel: {
    ice: 'dataChannelIceCandidate',
    offer: 'dataChannelOffer',
    answer: 'dataChannelAnswer',
    end: 'dataChannelEnd'
  }
};
exports.service = service;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(43),
    isSymbol = __webpack_require__(120);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(307),
    mapCacheDelete = __webpack_require__(323),
    mapCacheGet = __webpack_require__(325),
    mapCacheHas = __webpack_require__(326),
    mapCacheSet = __webpack_require__(327);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 169 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(89),
    root = __webpack_require__(57);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    merge: merge
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sdk = __importStar(__webpack_require__(341));
var connection_1 = __webpack_require__(178);
Object.defineProperty(exports, "connection", { enumerable: true, get: function () { return connection_1.default; } });
__exportStar(__webpack_require__(217), exports);
exports.guest = __importStar(__webpack_require__(369));
exports.rpc = __importStar(__webpack_require__(370));
exports.subscription = __importStar(__webpack_require__(371));


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(174),
    eq = __webpack_require__(169);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(215);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 175 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 176 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 177 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var get_1 = __importDefault(__webpack_require__(11));
var rxjs_1 = __webpack_require__(63);
var operators_1 = __webpack_require__(62);
var EventBus_1 = __importStar(__webpack_require__(101));
var connection = {
    close: close,
    forceClose: forceClose,
    open: open,
    setAutoRetry: setAutoRetry,
};
exports.default = connection;
function open(params) {
    return __awaiter(this, void 0, void 0, function () {
        var success, failure, eventPromise, event, payload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    success = EventBus_1.default.Subject.pipe(operators_1.find(function (e) { return e.type === 'CONNECTION_OPEN_SUCCESS'; }));
                    failure = EventBus_1.throwOnEvent(EventBus_1.default.Subject, 'CONNECTION_OPEN_FAILURE');
                    eventPromise = rxjs_1.race(success, failure).toPromise();
                    EventBus_1.default.Subject.next({ type: 'CONNECTION_OPEN_REQUEST', payload: params });
                    return [4 /*yield*/, eventPromise];
                case 1:
                    event = _a.sent();
                    payload = get_1.default(event, 'payload');
                    return [2 /*return*/, payload];
            }
        });
    });
}
//#endregion
//#region close connection
function close() {
    return __awaiter(this, void 0, void 0, function () {
        var success, failure, promise;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    success = EventBus_1.default.Subject.pipe(operators_1.find(function (e) { return e.type === 'CONNECTION_CLOSE_SUCCESS'; }));
                    failure = EventBus_1.throwOnEvent(EventBus_1.default.Subject, 'CONNECTION_CLOSE_FAILURE');
                    promise = rxjs_1.race(success, failure).toPromise();
                    EventBus_1.default.Subject.next({ type: 'CONNECTION_CLOSE_REQUEST' });
                    return [4 /*yield*/, promise];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function forceClose() {
    return __awaiter(this, void 0, void 0, function () {
        var success, failure, promise;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    success = EventBus_1.default.Subject.pipe(operators_1.find(function (e) { return e.type === 'CONNECTION_FORCE_CLOSE_SUCCESS'; }));
                    failure = EventBus_1.throwOnEvent(EventBus_1.default.Subject, 'CONNECTION_FORCE_CLOSE_FAILURE');
                    promise = rxjs_1.race(success, failure).toPromise();
                    EventBus_1.default.Subject.next({ type: 'CONNECTION_FORCE_CLOSE_REQUEST' });
                    return [4 /*yield*/, promise];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//#endregion
function setAutoRetry(autoRetry) {
    return __awaiter(this, void 0, void 0, function () {
        var promise;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    promise = EventBus_1.default.Subject.pipe(operators_1.first(function (e) { return e.type === 'CONNECTION_SET_AUTO_RETRY_SUCCESS'; })).toPromise();
                    EventBus_1.default.Subject.next({ type: 'CONNECTION_SET_AUTO_RETRY_REQUEST', payload: { autoRetry: autoRetry } });
                    return [4 /*yield*/, promise];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connect = connect;
exports.internalConnect = internalConnect;
exports.disconnect = disconnect;
exports.forceDisconnect = forceDisconnect;
exports.initializeServices = initializeServices;
exports.initializeNonEssentialServices = initializeNonEssentialServices;
exports.servicesActions = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _clients = __webpack_require__(172);

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _activeConferences = __webpack_require__(372);

var _availability = __webpack_require__(219);

var _calendar = __webpack_require__(220);

var _call = __webpack_require__(50);

var _callHistory = __webpack_require__(252);

var _featureFlags = __webpack_require__(471);

var _directory = __webpack_require__(84);

var _chat = __webpack_require__(194);

var _contact = __webpack_require__(195);

var _galaxy = __webpack_require__(267);

var _gems = __webpack_require__(491);

var _phoneHD = __webpack_require__(268);

var _proxy = __webpack_require__(21);

var _token = __webpack_require__(196);

var _userProfile = __webpack_require__(197);

var _constants = __webpack_require__(3);

var _account = __webpack_require__(91);

var _services = __webpack_require__(83);

var _userProfile2 = __webpack_require__(52);

var _services2 = __webpack_require__(492);

// These are the actions exposed to clients
var servicesActions = {
  connect: connect,
  disconnect: disconnect,
  forceDisconnect: forceDisconnect
};
exports.servicesActions = servicesActions;

function connect(providedJwt) {
  var isOneTimeJwt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch, getState) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!((0, _services.selectProxyStatus)(getState()) === _constants.SERVICE_STATUS_CONNECTED)) {
                  _context.next = 7;
                  break;
                }

                _context.next = 3;
                return dispatch((0, _proxy.verifyCurrentConnection)());

              case 3:
                if (!((0, _services.selectProxyStatus)(getState()) === _constants.SERVICE_STATUS_CONNECTED)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                _context.next = 8;
                break;

              case 7:
                // this will throw if already connecting/reconnecting
                (0, _services2.verifyCanConnect)(getState());

              case 8:
                // store provided jwt
                dispatch((0, _token.storeJwt)(providedJwt, isOneTimeJwt));
                _context.next = 11;
                return dispatch(internalConnect());

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}

function internalConnect() {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return dispatch((0, _proxy.openConnection)());

              case 2:
                _context2.next = 4;
                return dispatch(initializeServices());

              case 4:
                // initialize non-essential services
                dispatch(initializeNonEssentialServices());

                _clients.connection.setAutoRetry(true);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}

function disconnect() {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(dispatch) {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _clients.connection.setAutoRetry(false);

                _context3.next = 3;
                return dispatch((0, _proxy.closeConnection)());

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x4) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
}

function forceDisconnect() {
  return (
    /*#__PURE__*/
    function () {
      var _ref4 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(dispatch) {
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _clients.connection.setAutoRetry(false);

                _context4.next = 3;
                return dispatch((0, _proxy.forceCloseConnection)());

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x5) {
        return _ref4.apply(this, arguments);
      };
    }()
  );
}

function initializeServices() {
  return (
    /*#__PURE__*/
    function () {
      var _ref5 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(dispatch, getState) {
        var state, canClose;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                dispatch({
                  type: _constants.INITIALIZE_SERVICES_REQUEST
                });
                _context5.next = 4;
                return dispatch((0, _userProfile.getUserProfile)());

              case 4:
                _context5.next = 6;
                return dispatch((0, _featureFlags.fetchAccountFeatureFlags)());

              case 6:
                _context5.next = 8;
                return dispatch((0, _galaxy.subscribeToCallManager)());

              case 8:
                _context5.next = 10;
                return dispatch((0, _galaxy.subscribeToTurnManager)());

              case 10:
                _context5.next = 12;
                return dispatch(postCapabilities());

              case 12:
                dispatch({
                  type: _constants.INITIALIZE_SERVICES_SUCCESS
                });
                _context5.next = 25;
                break;

              case 15:
                _context5.prev = 15;
                _context5.t0 = _context5["catch"](0);
                dispatch({
                  type: _constants.INITIALIZE_SERVICES_FAILURE,
                  payload: {
                    error: _context5.t0
                  }
                });
                state = getState();
                canClose = (0, _services.selectProxyStatus)(state) === _constants.SERVICE_STATUS_CONNECTED;

                if (!canClose) {
                  _context5.next = 24;
                  break;
                }

                _jsLogger.default.error('could not initialize essential services. wamp connection will be closed.', _context5.t0);

                _context5.next = 24;
                return dispatch((0, _proxy.closeConnection)());

              case 24:
                throw _context5.t0;

              case 25:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 15]]);
      }));

      return function (_x6, _x7) {
        return _ref5.apply(this, arguments);
      };
    }()
  );
}

function initializeNonEssentialServices() {
  return function (dispatch, getState) {
    var state = getState(); // Skip if user is guest

    var isGuest = (0, _userProfile2.selectIsGuest)(state);

    if (isGuest) {
      _jsLogger.default.info('Guest User: Skip Connecting Non-Essential Services');

      return;
    }

    dispatch((0, _callHistory.initialize)());
    dispatch((0, _userProfile.subscribeToUserTopic)());
    dispatch((0, _directory.subscribeToTopic)());
    dispatch((0, _userProfile.subscribeToAccountTopic)());
    dispatch((0, _availability.subscribeToTopic)());
    dispatch((0, _activeConferences.subscribeToTopic)());
    dispatch((0, _calendar.subscribeToTopic)());
    dispatch((0, _contact.initialize)());
    dispatch((0, _chat.initialize)());
    dispatch((0, _phoneHD.initialize)());
    dispatch((0, _gems.initialize)());
  };
}

function postCapabilities() {
  return (
    /*#__PURE__*/
    function () {
      var _ref6 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(dispatch, getState) {
        var state, isGuest, directMediaEnabled;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                state = getState(); // Skip if user is guest

                isGuest = (0, _userProfile2.selectIsGuest)(state);

                if (!isGuest) {
                  _context6.next = 5;
                  break;
                }

                _jsLogger.default.info('Guest User: Skip Posting Capabilities.');

                return _context6.abrupt("return");

              case 5:
                // Inform the registration service what capabilities this device has.
                directMediaEnabled = (0, _account.selectDirectMediaEnabled)(state);
                _context6.next = 8;
                return dispatch((0, _call.postCapabilitiesGalaxy)(directMediaEnabled));

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x8, _x9) {
        return _ref6.apply(this, arguments);
      };
    }()
  );
}

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(181);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(375),
    isObjectLike = __webpack_require__(70);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(134),
    stackClear = __webpack_require__(376),
    stackDelete = __webpack_require__(377),
    stackGet = __webpack_require__(378),
    stackHas = __webpack_require__(379),
    stackSet = __webpack_require__(380);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 183 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(387),
    stubArray = __webpack_require__(227);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(390),
    baseUnary = __webpack_require__(141),
    nodeUtil = __webpack_require__(186);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(208);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(103)(module)))

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localeSort = localeSort;
exports.alphaContactNameCompare = alphaContactNameCompare;

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

/**
 * Cannot figure out a clean way to do a proper localecompare with lodash sortBy.
 * For now, using a stupid inplace ECMA 2015 sort.
 * @param  {Array} arr array to sort. Needs to modifiable.
 * @return {Array}     the alpha localecompare sorted array.
 */
function localeSort(arr) {
  if (arr.length < 2) return arr;
  return arr.sort(function (a, b) {
    return alphaContactNameCompare(a, b);
  });
}

function alphaContactNameCompare(a, b) {
  // We default to something to sort to the bottom of the list if the contact
  // name does not exist.
  function cleanUp(obj) {
    // The object could either be a conversation or a contact
    var contact = (0, _safeAccess.default)(obj, 'contact') || obj;
    return (0, _safeAccess.default)(contact, 'name') ? contact.name : '########';
  }

  return cleanUp(a).localeCompare(cleanUp(b));
}

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAdditionalNumbersUrl = getAdditionalNumbersUrl;
exports.getCallLink = getCallLink;
exports.getOtherWaysToCallLink = getOtherWaysToCallLink;

function getAdditionalNumbersUrl(domain, additionalNumbersUrlPostfix) {
  var additionalNumbersUrl = "https://call.".concat(domain, "/pstn/numbers");

  if (additionalNumbersUrlPostfix) {
    return "".concat(additionalNumbersUrl, "/").concat(additionalNumbersUrlPostfix);
  }

  return additionalNumbersUrl;
} // override the invite url with one we've generated locally


function getCallLink(domain, extension) {
  if (domain && extension) {
    // MSB: for now, we are continuing to use lifesizecloud.com.  keeping these lines
    //      here for when we want to switch to lifesize.com
    // const domainWithoutCloud = domain.replace(/cloud/i, '');
    // return `https://call.${domainWithoutCloud}/${extension}`;
    return "https://call.".concat(domain, "/").concat(extension);
  }

  return '';
}

function getOtherWaysToCallLink(domain, extension) {
  if (domain && extension) {
    return "https://call.".concat(domain, "/otherways/").concat(extension);
  }

  return '';
}

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var supportedLanguageList = __webpack_require__(431);
var compliance_1 = __webpack_require__(432);
exports.complianceLinks = compliance_1.default;
exports.defaultLanguageId = 'en-US';
exports.platforms = {
    APPLE: 'apple',
    GOOGLE: 'google',
    MICROSOFT: 'microsoft',
    SMARTLING: 'smartling'
};
exports.supportedLanguages = supportedLanguageList;
exports.default = { defaultLanguageId: exports.defaultLanguageId, platforms: exports.platforms, supportedLanguages: exports.supportedLanguages };
//# sourceMappingURL=localization.js.map

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _sprintfJs = __webpack_require__(235);

var _csCz = _interopRequireDefault(__webpack_require__(433));

var _de = _interopRequireDefault(__webpack_require__(434));

var _en = _interopRequireDefault(__webpack_require__(435));

var _esEs = _interopRequireDefault(__webpack_require__(436));

var _fiFi = _interopRequireDefault(__webpack_require__(437));

var _frFr = _interopRequireDefault(__webpack_require__(438));

var _itIt = _interopRequireDefault(__webpack_require__(439));

var _jaJp = _interopRequireDefault(__webpack_require__(440));

var _koKr = _interopRequireDefault(__webpack_require__(441));

var _nlNl = _interopRequireDefault(__webpack_require__(442));

var _noNo = _interopRequireDefault(__webpack_require__(443));

var _pl = _interopRequireDefault(__webpack_require__(444));

var _ptBr = _interopRequireDefault(__webpack_require__(445));

var _svSe = _interopRequireDefault(__webpack_require__(446));

var _zhCn = _interopRequireDefault(__webpack_require__(447));

var locales = {
  cs: _csCz.default,
  de: _de.default,
  en: _en.default,
  es: _esEs.default,
  fi: _fiFi.default,
  fr: _frFr.default,
  it: _itIt.default,
  ja: _jaJp.default,
  ko: _koKr.default,
  nl: _nlNl.default,
  no: _noNo.default,
  pl: _pl.default,
  pt: _ptBr.default,
  sv: _svSe.default,
  zh: _zhCn.default
};

var localize = function localize(localeCode, localizationKey) {
  if (!localizationKey) return '';
  if (!localeCode || typeof localeCode !== 'string') localeCode = 'en';
  var langCode = localeCode.substring(0, 2);
  var locale = locales[localeCode.toLowerCase()] || locales[langCode.toLowerCase()] || locales['en'];
  if (!locale[localizationKey]) return localizationKey;

  for (var _len = arguments.length, values = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    values[_key - 2] = arguments[_key];
  }

  return _sprintfJs.sprintf.apply(void 0, [locale[localizationKey]].concat(values));
};

var _default = localize;
exports.default = _default;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendPresentationTokenRequestGalaxy = sendPresentationTokenRequestGalaxy;
exports.sendPresentationTokenReleaseGalaxy = sendPresentationTokenReleaseGalaxy;

var c = _interopRequireWildcard(__webpack_require__(3));

var _call = __webpack_require__(50);

var _galaxyUtils = __webpack_require__(73);

var _stream = __webpack_require__(80);

var _get = _interopRequireDefault(__webpack_require__(11));

function sendPresentationTokenRequestGalaxy() {
  return function (dispatch, getState) {
    var data = (0, _galaxyUtils.commandForCall)(getState, c.GALAXY_COMMAND_PRESENTATION_TOKEN_REQUEST);
    return dispatch((0, _call.postCallCommandGalaxy)(data)).then(function () {
      return dispatch({
        type: c.GALAXY_ACTION_PRESENTATION_TOKEN_REQUEST,
        payload: {
          data: data
        }
      });
    }).catch(function (err) {
      var error = {
        error: err,
        reason: c.GALAXY_REASON_SERVER_ERROR
      };
      return dispatch((0, _stream.failedPresentationGalaxy)(error));
    });
  };
}

function sendPresentationTokenReleaseGalaxy() {
  return function (dispatch, getState) {
    var data = (0, _galaxyUtils.commandForCall)(getState, c.GALAXY_COMMAND_PRESENTATION_TOKEN_RELEASE);
    return dispatch((0, _call.postCallCommandGalaxy)(data)).then(function () {
      var isTokenOwnerSelf = (0, _get.default)(getState(), 'nucleus.galaxy.presentation.isTokenOwnerSelf');

      if (isTokenOwnerSelf) {
        dispatch({
          type: c.GALAXY_ACTION_PRESENTATION_TOKEN_RELEASE,
          payload: {
            data: data
          }
        });
      }
    }).catch(function (err) {
      var error = {
        error: err,
        reason: c.GALAXY_REASON_SERVER_ERROR
      };
      return dispatch((0, _stream.failedPresentationGalaxy)(error));
    });
  };
}

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setParticipantMuteValue = setParticipantMuteValue;
exports.setAllParticipantsMuteValue = setAllParticipantsMuteValue;
exports.ejectParticipant = ejectParticipant;
exports.ejectAllParticipants = ejectAllParticipants;
exports.stopParticipantPresentation = stopParticipantPresentation;
exports.lowerParticipantHand = exports.lowerAllRaisedHands = exports.stopCurrentConferencePresentation = exports.unlockCurrentConference = exports.lockCurrentConference = exports.UNLOCK_CONFERENCE_FAILURE = exports.UNLOCK_CONFERENCE_SUCCESS = exports.UNLOCK_CONFERENCE_REQUEST = exports.LOCK_CONFERENCE_FAILURE = exports.LOCK_CONFERENCE_SUCCESS = exports.LOCK_CONFERENCE_REQUEST = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _get = _interopRequireDefault(__webpack_require__(11));

var _helpers = __webpack_require__(448);

var C = _interopRequireWildcard(__webpack_require__(3));

var _awaitAction = __webpack_require__(145);

var _conference = __webpack_require__(53);

var _guid = _interopRequireDefault(__webpack_require__(72));

var _moderator = __webpack_require__(93);

var _participants = __webpack_require__(92);

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var LOCK_CONFERENCE_REQUEST = 'LOCK_CONFERENCE_REQUEST';
exports.LOCK_CONFERENCE_REQUEST = LOCK_CONFERENCE_REQUEST;
var LOCK_CONFERENCE_SUCCESS = 'LOCK_CONFERENCE_SUCCESS';
exports.LOCK_CONFERENCE_SUCCESS = LOCK_CONFERENCE_SUCCESS;
var LOCK_CONFERENCE_FAILURE = 'LOCK_CONFERENCE_FAILURE';
exports.LOCK_CONFERENCE_FAILURE = LOCK_CONFERENCE_FAILURE;
var UNLOCK_CONFERENCE_REQUEST = 'UNLOCK_CONFERENCE_REQUEST';
exports.UNLOCK_CONFERENCE_REQUEST = UNLOCK_CONFERENCE_REQUEST;
var UNLOCK_CONFERENCE_SUCCESS = 'UNLOCK_CONFERENCE_SUCCESS';
exports.UNLOCK_CONFERENCE_SUCCESS = UNLOCK_CONFERENCE_SUCCESS;
var UNLOCK_CONFERENCE_FAILURE = 'UNLOCK_CONFERENCE_FAILURE';
exports.UNLOCK_CONFERENCE_FAILURE = UNLOCK_CONFERENCE_FAILURE;
var LOCK_CONFERENCE_COMMAND = 'lockMeeting';
var LOCK_CONFERENCE_SUCCESS_EVENT = 'lockMeetingSuccess';
var LOCK_CONFERENCE_FAILURE_EVENT = 'lockMeetingFailure';
var UNLOCK_CONFERENCE_COMMAND = 'unlockMeeting';
var UNLOCK_CONFERENCE_SUCCESS_EVENT = 'unlockMeetingSuccess';
var UNLOCK_CONFERENCE_FAILURE_EVENT = 'unlockMeetingFailure';

var lockCurrentConference = function lockCurrentConference() {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch, getState) {
        var state, conferenceId, messageId, params, lockResultPromise;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                state = getState();
                conferenceId = (0, _conference.selectConferenceId)(state);

                if (conferenceId) {
                  _context.next = 4;
                  break;
                }

                throw new Error('Cannot lock conference: No conferenceId.');

              case 4:
                if ((0, _conference.selectCanLockConference)(state)) {
                  _context.next = 6;
                  break;
                }

                throw new Error('Cannot lock conference: selectCanLockConference = false.');

              case 6:
                messageId = _guid.default.create();
                params = {
                  event: LOCK_CONFERENCE_COMMAND,
                  conferenceId: conferenceId,
                  messageId: messageId
                };
                _context.prev = 8;
                dispatch({
                  type: LOCK_CONFERENCE_REQUEST
                });
                lockResultPromise = dispatch(awaitLockResult(messageId));
                dispatch((0, _helpers.sendModeratorCommand)(params));
                _context.next = 14;
                return lockResultPromise;

              case 14:
                dispatch({
                  type: LOCK_CONFERENCE_SUCCESS
                });
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](8);
                dispatch({
                  type: LOCK_CONFERENCE_FAILURE,
                  payload: _context.t0
                });

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[8, 17]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

exports.lockCurrentConference = lockCurrentConference;

var unlockCurrentConference = function unlockCurrentConference() {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch, getState) {
        var state, conferenceId, messageId, params, unlockResultPromise;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                state = getState();
                conferenceId = (0, _conference.selectConferenceId)(state);

                if (conferenceId) {
                  _context2.next = 4;
                  break;
                }

                throw new Error('Cannot unlock conference: No conferenceId.');

              case 4:
                if ((0, _conference.selectCanUnlockConference)(state)) {
                  _context2.next = 6;
                  break;
                }

                throw new Error('Cannot unlock conference: selectCanUnlockConference = false.');

              case 6:
                messageId = _guid.default.create();
                params = {
                  event: UNLOCK_CONFERENCE_COMMAND,
                  conferenceId: conferenceId,
                  messageId: messageId
                };
                _context2.prev = 8;
                dispatch({
                  type: UNLOCK_CONFERENCE_REQUEST
                });
                unlockResultPromise = dispatch(awaitUnlockResult(messageId));
                dispatch((0, _helpers.sendModeratorCommand)(params));
                _context2.next = 14;
                return unlockResultPromise;

              case 14:
                dispatch({
                  type: UNLOCK_CONFERENCE_SUCCESS
                });
                _context2.next = 20;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](8);
                dispatch({
                  type: UNLOCK_CONFERENCE_FAILURE,
                  payload: _context2.t0
                });

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[8, 17]]);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
};

exports.unlockCurrentConference = unlockCurrentConference;

function setParticipantMuteValue(participantId, muteValue) {
  return function (dispatch) {
    var command = muteValue ? C.GALAXY_COMMAND_MUTE_PARTICIPANT : C.GALAXY_COMMAND_UN_MUTE_PARTICIPANT;
    dispatch((0, _helpers.sendConferenceCommand)(command, participantId));
  };
}

function setAllParticipantsMuteValue(muteValue) {
  return function (dispatch) {
    var command = muteValue ? C.GALAXY_COMMAND_MUTE_ALL : C.GALAXY_COMMAND_UN_MUTE_ALL;
    dispatch((0, _helpers.sendConferenceCommand)(command));
  };
}

function ejectParticipant(participantId) {
  return function (dispatch) {
    dispatch((0, _helpers.sendConferenceCommand)(C.GALAXY_COMMAND_EJECT, participantId));
  };
}

function ejectAllParticipants() {
  return function (dispatch) {
    dispatch((0, _helpers.sendConferenceCommand)(C.GALAXY_COMMAND_EJECT_ALL));
  };
}

function stopParticipantPresentation(participantId) {
  return function (dispatch) {
    dispatch((0, _helpers.sendConferenceCommand)(C.GALAXY_COMMAND_MODERATOR_STOP_PRESENTATION, participantId));
  };
}

var stopCurrentConferencePresentation = function stopCurrentConferencePresentation() {
  return function (dispatch, getState) {
    var state = getState(); // Obtain presenter participantId

    var participantId = (0, _conference.selectConferencePresenterParticipantId)(state);

    if (!participantId) {
      throw new Error('Cannot stop conference presentation: No presenter.');
    }

    dispatch((0, _helpers.sendConferenceCommand)(C.GALAXY_COMMAND_MODERATOR_STOP_PRESENTATION, participantId));
  };
};

exports.stopCurrentConferencePresentation = stopCurrentConferencePresentation;

function awaitLockResult(messageId) {
  return (0, _awaitAction.awaitAction)(shouldLockResolve(messageId), shouldLockReject(messageId));
}

function shouldLockResolve(messageId) {
  return function (action) {
    if ((0, _get.default)(action, 'payload.referenceId') !== messageId) return false;
    return (0, _get.default)(action, 'payload.event') === LOCK_CONFERENCE_SUCCESS_EVENT;
  };
}

function shouldLockReject(messageId) {
  return function (action) {
    if ((0, _get.default)(action, 'payload.referenceId') !== messageId) return false;
    return (0, _get.default)(action, 'payload.event') === LOCK_CONFERENCE_FAILURE_EVENT;
  };
}

function awaitUnlockResult(messageId) {
  return (0, _awaitAction.awaitAction)(shouldUnlockResolve(messageId), shouldUnlockReject(messageId));
}

function shouldUnlockResolve(messageId) {
  return function (action) {
    if ((0, _get.default)(action, 'payload.referenceId') !== messageId) return false;
    return (0, _get.default)(action, 'payload.event') === UNLOCK_CONFERENCE_SUCCESS_EVENT;
  };
}

function shouldUnlockReject(messageId) {
  return function (action) {
    if ((0, _get.default)(action, 'payload.referenceId') !== messageId) return false;
    return (0, _get.default)(action, 'payload.event') === UNLOCK_CONFERENCE_FAILURE_EVENT;
  };
} // Hand Raise
// Only moderators can lower all hands.


var lowerAllRaisedHands = function lowerAllRaisedHands() {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(dispatch, getState) {
        var state, conferenceId, isModerator, data, handPromise;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                state = getState();
                conferenceId = (0, _conference.selectConferenceId)(state); // Validation checks

                if (conferenceId) {
                  _context3.next = 4;
                  break;
                }

                throw new Error('Cannot lower all hands: No conferenceId.');

              case 4:
                isModerator = (0, _moderator.selectIsCurrentUserModerator)(state);

                if (isModerator) {
                  _context3.next = 7;
                  break;
                }

                throw new Error('Cannot send lower all hands command: Current user is not moderator.');

              case 7:
                data = {
                  messageId: _guid.default.create(),
                  event: C.GALAXY_COMMAND_LOWER_ALL_HANDS,
                  conferenceId: conferenceId
                };
                dispatch({
                  type: C.LOWER_ALL_HANDS_REQUEST
                });
                _context3.prev = 9;
                handPromise = dispatch((0, _awaitAction.awaitAction)(function (a) {
                  return a.type === C.GALAXY_ACTION_CONFERENCE_ALL_HANDS_LOWERED && (0, _get.default)(a, 'payload.conferenceId') === conferenceId;
                }));
                dispatch((0, _helpers.sendModeratorCommand)(data));
                _context3.next = 14;
                return handPromise;

              case 14:
                dispatch({
                  type: C.LOWER_ALL_HANDS_SUCCESS
                });
                _context3.next = 20;
                break;

              case 17:
                _context3.prev = 17;
                _context3.t0 = _context3["catch"](9);
                dispatch({
                  type: C.LOWER_ALL_HANDS_FAILURE,
                  payload: {
                    error: _context3.t0,
                    conferenceId: conferenceId
                  }
                });

              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[9, 17]]);
      }));

      return function (_x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
}; // Moderators can lower any hand


exports.lowerAllRaisedHands = lowerAllRaisedHands;

var lowerParticipantHand = function lowerParticipantHand(participantId) {
  return (
    /*#__PURE__*/
    function () {
      var _ref4 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(dispatch, getState) {
        var state, conferenceId, isModerator, data, handPromise;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                state = getState();
                conferenceId = (0, _conference.selectConferenceId)(state); // Validation checks

                if (conferenceId) {
                  _context4.next = 4;
                  break;
                }

                throw new Error('Cannot lower hand: No conferenceId.');

              case 4:
                isModerator = (0, _moderator.selectIsCurrentUserModerator)(state);

                if (isModerator) {
                  _context4.next = 7;
                  break;
                }

                throw new Error('Cannot send lower participant hand command: Current user is not moderator.');

              case 7:
                if (!(0, _participants.selectIsProcessingParticipantHandCommand)(state, participantId)) {
                  _context4.next = 10;
                  break;
                }

                _jsLogger.default.warn('Already processing a moderator hand command for this participant');

                return _context4.abrupt("return");

              case 10:
                if ((0, _participants.selectParticipantsMap)(state).has(participantId)) {
                  _context4.next = 13;
                  break;
                }

                _jsLogger.default.error('Participant does not exist in participants list!');

                return _context4.abrupt("return");

              case 13:
                data = {
                  messageId: _guid.default.create(),
                  event: C.GALAXY_COMMAND_LOWER_HAND,
                  participantId: participantId,
                  conferenceId: conferenceId
                };
                dispatch({
                  type: C.LOWER_HAND_REQUEST,
                  payload: {
                    participantId: participantId
                  }
                });
                _context4.prev = 15;
                handPromise = dispatch((0, _awaitAction.awaitAction)(function (a) {
                  return a.type === C.GALAXY_ACTION_CONFERENCE_PARTICIPANT_HAND_LOWERED && (0, _get.default)(a, 'payload.conferenceId') === conferenceId && (0, _get.default)(a, 'payload.participant.participantId') === participantId;
                }));
                dispatch((0, _helpers.sendModeratorCommand)(data));
                _context4.next = 20;
                return handPromise;

              case 20:
                dispatch({
                  type: C.LOWER_HAND_SUCCESS,
                  payload: {
                    participantId: participantId
                  }
                });
                _context4.next = 26;
                break;

              case 23:
                _context4.prev = 23;
                _context4.t0 = _context4["catch"](15);
                dispatch({
                  type: C.LOWER_HAND_FAILURE,
                  payload: {
                    error: _context4.t0,
                    participantId: participantId
                  }
                });

              case 26:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[15, 23]]);
      }));

      return function (_x7, _x8) {
        return _ref4.apply(this, arguments);
      };
    }()
  );
};

exports.lowerParticipantHand = lowerParticipantHand;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.platform = void 0;

var c = _interopRequireWildcard(__webpack_require__(3));

var _reselect = __webpack_require__(23);

var _browserUtils = __webpack_require__(44);

var _auth = __webpack_require__(31);

var platform = (0, _reselect.createSelector)(_auth.getPlatform, function (platformValue) {
  return {
    isDesktop: (0, _browserUtils.isDesktop)(platformValue),
    isMobile: (0, _browserUtils.isMobile)(platformValue),
    isWeb: platformValue === c.PLATFORM_WEB,
    isGems: (0, _browserUtils.isGems)(platformValue)
  };
});
exports.platform = platform;
var _default = {
  platform: platform
};
exports.default = _default;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chatEventHandler = chatEventHandler;
exports.sendMessage = sendMessage;
exports.receivedMessage = receivedMessage;
exports.joinedRoom = joinedRoom;
exports.userJoinedRoom = userJoinedRoom;
exports.getRooms = getRooms;
exports.getMessages = getMessages;
exports.enterConversation = enterConversation;
exports.getMoreMessagesForConversation = getMoreMessagesForConversation;
exports.leaveConversation = leaveConversation;
exports.markConversationMessagesAsRead = markConversationMessagesAsRead;
exports.initialize = initialize;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var C = _interopRequireWildcard(__webpack_require__(3));

var _guid = _interopRequireDefault(__webpack_require__(72));

var _chatUtils = __webpack_require__(264);

var _chat = __webpack_require__(265);

var _contacts = __webpack_require__(35);

var _directory = __webpack_require__(84);

var _currentUser = __webpack_require__(37);

var GQLChat = _interopRequireWildcard(__webpack_require__(478));

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _proxy = __webpack_require__(21);

var _chatEventMap;

_jsLogger.default.useDefaults();
/** @module actions/chat */


var chatEventMap = (_chatEventMap = {}, (0, _defineProperty2.default)(_chatEventMap, C.CHAT_EVENT_JOINED_ROOM, joinedRoom), (0, _defineProperty2.default)(_chatEventMap, C.CHAT_EVENT_MESSAGE, receivedMessage), (0, _defineProperty2.default)(_chatEventMap, C.CHAT_EVENT_USER_LEFT_ROOM, C.CHAT_USER_LEFT_ROOM), (0, _defineProperty2.default)(_chatEventMap, C.CHAT_EVENT_USER_JOINED_ROOM, userJoinedRoom), _chatEventMap);

function chatEventHandler() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (dispatch) {
    try {
      var action = chatEventMap[payload.event] || C.CHAT_EVENT;
      if (typeof action === 'function') return dispatch(action(payload));
      dispatch({
        type: action,
        payload: payload
      });
    } catch (ex) {
      _jsLogger.default.warn('Chat event handler exception:', ex);
    }
  };
}

var getSenderFromCurrentUser = function getSenderFromCurrentUser(currentUser) {
  return {
    uuid: currentUser.userUuid,
    dialString: currentUser.dialString,
    displayName: currentUser.name,
    name: currentUser.name
  };
};
/**
 * This function is used to send a message to either another user or a VMR.
 * Please note that this
 * @param  {string}  message   The text message to send.
 * @param  {object}  contact   The contact to send the message to.
 */


function sendMessage(message, contact) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch, getState) {
        var optimisticUUID, state, room, currentUser, result;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                optimisticUUID = _guid.default.create();
                _context.prev = 1;
                state = getState();
                room = (0, _chatUtils.getRoomByContact)(contact, (0, _chat.gqlChatRooms)(state));

                if (room) {
                  _context.next = 10;
                  break;
                }

                if (!(!contact || !contact.uuid)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", _jsLogger.default.error('Could not find contact to join room', contact));

              case 7:
                _context.next = 9;
                return dispatch(GQLChat.joinRoom(contact.uuid));

              case 9:
                room = _context.sent;

              case 10:
                currentUser = (0, _currentUser.myInfo)(state);
                dispatch({
                  type: C.CHAT_POST_MESSAGE_BEGIN,
                  payload: {
                    createdAt: Date.now(),
                    uuid: optimisticUUID,
                    sender: getSenderFromCurrentUser(currentUser),
                    roomUUID: room.uuid,
                    message: message,
                    optimisticUUID: optimisticUUID
                  }
                });
                _context.next = 14;
                return dispatch(GQLChat.postMessage(room.uuid, optimisticUUID, message));

              case 14:
                result = _context.sent;
                dispatch({
                  type: C.CHAT_POST_MESSAGE_SUCCESS,
                  payload: (0, _objectSpread2.default)({}, result, {
                    optimisticUUID: optimisticUUID
                  })
                });
                dispatch(markConversationMessagesAsRead(contact)); // fire and forget

                _context.next = 23;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](1);
                dispatch({
                  type: C.CHAT_POST_MESSAGE_FAILURE,
                  payload: {
                    contact: contact,
                    message: message,
                    optimisticUUID: optimisticUUID
                  }
                });

                _jsLogger.default.error('Error posting to chat room for contact:', contact, message, _context.t0);

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 19]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}

function receivedMessage(data) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch, getState) {
        var state, getContact, currentUser, sender, payload;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                state = getState();
                getContact = (0, _contacts.getContactByUuidGenerator)(state);
                currentUser = (0, _currentUser.myInfo)(state);

                if (data.userUUID === currentUser.userUuid) {
                  sender = getSenderFromCurrentUser(currentUser);
                }

                if (!sender) {
                  sender = getContact(data.userUUID);
                }

                if (sender) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 8;
                return dispatch((0, _directory.loadByUUID)(data.userUUID));

              case 8:
                sender = _context2.sent;

              case 9:
                payload = (0, _objectSpread2.default)({}, data, {
                  sender: sender
                });
                dispatch({
                  type: C.CHAT_RECEIVED_MESSAGE,
                  payload: payload
                });

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
} // current user was added to a room


function joinedRoom(data) {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(dispatch, getState) {
        var state, getContact, currentUser, meeting, members, payload;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                state = getState();
                getContact = (0, _contacts.getContactByUuidGenerator)(state);
                currentUser = (0, _currentUser.myInfo)(state);
                meeting = null;

                if (!data.room.meeting) {
                  _context4.next = 8;
                  break;
                }

                _context4.next = 7;
                return dispatch((0, _directory.loadByUUID)(data.room.meeting.UUID));

              case 7:
                meeting = _context4.sent;

              case 8:
                _context4.next = 10;
                return Promise.all((data.room.members || []).map(
                /*#__PURE__*/
                function () {
                  var _ref4 = (0, _asyncToGenerator2.default)(
                  /*#__PURE__*/
                  _regenerator.default.mark(function _callee3(m) {
                    var member, contact;
                    return _regenerator.default.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            member = (0, _objectSpread2.default)({}, m, {
                              uuid: m.UUID,
                              name: m.displayName,
                              dialString: m.dialstring
                            });
                            contact = getContact(m.uuid);

                            if (!contact) {
                              _context3.next = 4;
                              break;
                            }

                            return _context3.abrupt("return", contact);

                          case 4:
                            if (!(member.uuid === currentUser.userUuid)) {
                              _context3.next = 6;
                              break;
                            }

                            return _context3.abrupt("return", member);

                          case 6:
                            return _context3.abrupt("return", dispatch((0, _directory.loadByUUID)(m.UUID)));

                          case 7:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x7) {
                    return _ref4.apply(this, arguments);
                  };
                }()));

              case 10:
                members = _context4.sent;
                payload = (0, _objectSpread2.default)({}, data.room, {
                  meeting: meeting,
                  members: members
                });
                dispatch({
                  type: C.CHAT_JOINED_ROOM,
                  payload: payload
                });
                dispatch(getMessages(data.room));

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
} // another user has joined a room the current user is in


function userJoinedRoom(data) {
  return (
    /*#__PURE__*/
    function () {
      var _ref5 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(dispatch, getState) {
        var state, getContact, user, contact, payload;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                state = getState();
                getContact = (0, _contacts.getContactByUuidGenerator)(state);
                user = (0, _objectSpread2.default)({}, data.user, {
                  uuid: data.user.UUID,
                  name: data.user.displayName,
                  dialString: data.user.dialstring
                });
                contact = getContact(user.uuid);

                if (!(data.user && !contact)) {
                  _context5.next = 10;
                  break;
                }

                _context5.next = 7;
                return dispatch((0, _directory.loadByUUID)(data.user.UUID));

              case 7:
                user = _context5.sent;
                _context5.next = 11;
                break;

              case 10:
                user = contact;

              case 11:
                payload = {
                  room: data.room,
                  user: user
                };
                dispatch({
                  type: C.CHAT_USER_JOINED_ROOM,
                  payload: payload
                });

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x8, _x9) {
        return _ref5.apply(this, arguments);
      };
    }()
  );
}
/**
 * getRooms
 * gets the current user's rooms
 */


function getRooms() {
  return (
    /*#__PURE__*/
    function () {
      var _ref6 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(dispatch) {
        var rooms, roomsObject;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                dispatch({
                  type: C.CHAT_GET_ROOMS_BEGIN
                });
                _context6.next = 4;
                return dispatch(GQLChat.roomsForCurrentUser());

              case 4:
                _context6.t0 = _context6.sent;

                if (_context6.t0) {
                  _context6.next = 7;
                  break;
                }

                _context6.t0 = [];

              case 7:
                rooms = _context6.t0;
                roomsObject = {}; // gather first messages for each room (maintains backwards compatibility)
                // and arrange rooms in an object for the reducer

                if (rooms.length) {
                  rooms.forEach(function (r) {
                    dispatch(getMessages(r));
                    roomsObject[r.uuid] = r;
                  });
                }

                dispatch({
                  type: C.CHAT_GET_ROOMS_SUCCESS,
                  payload: roomsObject
                });
                _context6.next = 17;
                break;

              case 13:
                _context6.prev = 13;
                _context6.t1 = _context6["catch"](0);

                _jsLogger.default.error('error in getRooms:', _context6.t1);

                dispatch({
                  type: C.CHAT_GET_ROOMS_FAILURE,
                  payload: _context6.t1
                });

              case 17:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[0, 13]]);
      }));

      return function (_x10) {
        return _ref6.apply(this, arguments);
      };
    }()
  );
}

function getMessages(room) {
  var cursor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return (
    /*#__PURE__*/
    function () {
      var _ref7 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(dispatch) {
        var result, messages;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                dispatch({
                  type: C.CHAT_GET_MESSAGES_BEGIN,
                  payload: room
                });
                _context7.next = 4;
                return dispatch(GQLChat.getMessages(room.uuid, cursor));

              case 4:
                result = _context7.sent;
                messages = {};
                result.messages.forEach(function (m) {
                  messages[m.uuid] = m;
                });
                dispatch({
                  type: C.CHAT_GET_MESSAGES_SUCCESS,
                  payload: {
                    roomUUID: room.uuid,
                    messages: messages,
                    cursor: result.cursor
                  }
                });
                _context7.next = 14;
                break;

              case 10:
                _context7.prev = 10;
                _context7.t0 = _context7["catch"](0);

                _jsLogger.default.error('error in getMessages:', _context7.t0);

                dispatch({
                  type: C.CHAT_GET_MESSAGES_FAILURE,
                  payload: _context7.t0
                });

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[0, 10]]);
      }));

      return function (_x11) {
        return _ref7.apply(this, arguments);
      };
    }()
  );
}
/**
 * Wrapper function that builds the proper jid from the passed in extension
 * depending on whether the conversation is a VMR or P2P conversation.
 * It then dispatches the promise chain for entering a VMR or P2P conversation.
 *
 * @param  {object}  contact The contact object of the VMR or contact to load
 * @return {object}            dispatched promise action chain for entering a VMR or P2P conversation.
 */


function enterConversation(contact) {
  return (
    /*#__PURE__*/
    function () {
      var _ref8 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee8(dispatch, getState) {
        var state, room;
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                state = getState();
                _context8.prev = 1;
                room = (0, _chatUtils.getRoomByContact)(contact, (0, _chat.gqlChatRooms)(state));

                if (!room) {
                  _context8.next = 5;
                  break;
                }

                return _context8.abrupt("return");

              case 5:
                _context8.next = 7;
                return dispatch(GQLChat.joinRoom(contact.uuid));

              case 7:
                room = _context8.sent;
                dispatch({
                  type: C.CHAT_JOINED_ROOM,
                  payload: room
                });
                dispatch(getMessages(room));
                _context8.next = 15;
                break;

              case 12:
                _context8.prev = 12;
                _context8.t0 = _context8["catch"](1);

                _jsLogger.default.error('error joining room:', contact, _context8.t0);

              case 15:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[1, 12]]);
      }));

      return function (_x12, _x13) {
        return _ref8.apply(this, arguments);
      };
    }()
  );
}
/**
 * getMoreMessagesForConversation
 *
 * Wrapper function that will get more messages for a conversation. It builds
 * the proper jid from the passed in extension depending on whether the
 * conversation is a VMR or P2P conversation.
 * It then dispatches the getMoreConversations promise action chain.
 *
 * @param  {object}  contact     The contact object of the VMR or contact to get more messages for.
 * @return {object}                Dispatched promise action chain for getting more messages.
 */


function getMoreMessagesForConversation(contact) {
  return (
    /*#__PURE__*/
    function () {
      var _ref9 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee9(dispatch, getState) {
        var state, room, roomCursor;
        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                state = getState();
                room = (0, _chatUtils.getRoomByContact)(contact, (0, _chat.gqlChatRooms)(state));

                if (room) {
                  _context9.next = 4;
                  break;
                }

                return _context9.abrupt("return");

              case 4:
                // already at latest or loading
                roomCursor = state.nucleus.gqlChat.roomCursors[room.uuid] || {};

                if (!(roomCursor.loading || !roomCursor.cursor)) {
                  _context9.next = 7;
                  break;
                }

                return _context9.abrupt("return");

              case 7:
                dispatch(getMessages(room, roomCursor.cursor));

              case 8:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      return function (_x14, _x15) {
        return _ref9.apply(this, arguments);
      };
    }()
  );
}
/**
 * Wrapper function that builds the proper jid from the passed in extension
 * depending on whether the conversation is a VMR or P2P conversation.
 * It then dispatches the promise chain for leaving/unsubscribing from a VMR or
 * P2P conversation.
 *
 * @param  {object}  contact The contact object of the VMR or contact to leave.
 * @return {object}            dispatched promise action chain for leaving a VMR or P2P conversation.
 */


function leaveConversation(contact) {
  return (
    /*#__PURE__*/
    function () {
      var _ref10 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee10(dispatch, getState) {
        var state, room;
        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                state = getState();
                room = (0, _chatUtils.getRoomByContact)(contact, (0, _chat.gqlChatRooms)(state));

                if (room) {
                  _context10.next = 4;
                  break;
                }

                return _context10.abrupt("return", null);

              case 4:
                dispatch({
                  type: C.CHAT_LEFT_ROOM,
                  payload: room.uuid
                });
                _context10.next = 7;
                return dispatch(GQLChat.leaveRoom(room.uuid));

              case 7:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      return function (_x16, _x17) {
        return _ref10.apply(this, arguments);
      };
    }()
  );
}
/**
 * Wrapper function that will mark all messages as read for a conversation.
 * It builds the proper jid from the passed in extension depending on whether the
 * conversation is a VMR or P2P conversation.
 * It then dispatches the markMessagesAsRead promise action chain.
 *
 * @param  {object}  contact The contact object of the VMR or contact conversation to mark as read.
 * @return {object}            Dispatched promise action chain for marking all messages in a conversation as read.
 */


function markConversationMessagesAsRead(contact) {
  return (
    /*#__PURE__*/
    function () {
      var _ref11 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee11(dispatch, getState) {
        var state, room, lastReadAt;
        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                state = getState();
                room = (0, _chatUtils.getRoomByContact)(contact, (0, _chat.gqlChatRooms)(state));

                if (room) {
                  _context11.next = 5;
                  break;
                }

                return _context11.abrupt("return", null);

              case 5:
                lastReadAt = new Date().toString();
                dispatch({
                  type: C.CHAT_LAST_READ_AT,
                  payload: {
                    roomUUID: room.uuid,
                    lastReadAt: lastReadAt
                  }
                });
                _context11.next = 9;
                return dispatch(GQLChat.markLastReadAt(room.uuid, lastReadAt));

              case 9:
                _context11.next = 14;
                break;

              case 11:
                _context11.prev = 11;
                _context11.t0 = _context11["catch"](0);

                _jsLogger.default.error('error in markConversationMessagesAsRead:', _context11.t0);

              case 14:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, null, [[0, 11]]);
      }));

      return function (_x18, _x19) {
        return _ref11.apply(this, arguments);
      };
    }()
  );
}

function initialize() {
  return (
    /*#__PURE__*/
    function () {
      var _ref12 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee12(dispatch, getState) {
        return _regenerator.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if ((0, _chat.selectGqlChatEnabled)(getState())) {
                  _context12.next = 3;
                  break;
                }

                _jsLogger.default.info('gql chat: disabled. skipping subscription.');

                return _context12.abrupt("return");

              case 3:
                _context12.prev = 3;
                _context12.next = 6;
                return dispatch((0, _proxy.subscribe)(C.CHAT_TOPIC));

              case 6:
                _context12.next = 8;
                return dispatch(getRooms());

              case 8:
                _context12.next = 13;
                break;

              case 10:
                _context12.prev = 10;
                _context12.t0 = _context12["catch"](3);

                _jsLogger.default.warn('gql chat: load/subscription failed:', _context12.t0);

              case 13:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, null, [[3, 10]]);
      }));

      return function (_x20, _x21) {
        return _ref12.apply(this, arguments);
      };
    }()
  );
}

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(CONFIG) {

var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialize = initialize;
exports.contactNotificationHandler = exports.subscribe = exports.resetContactErrorState = exports.validateContact = exports.deleteContact = exports.saveContact = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(81));

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _get = _interopRequireDefault(__webpack_require__(11));

var _api = __webpack_require__(266);

var _validation = _interopRequireDefault(__webpack_require__(485));

var c = _interopRequireWildcard(__webpack_require__(3));

var _currentUser = __webpack_require__(37);

var _contacts = __webpack_require__(35);

var proxyActions = _interopRequireWildcard(__webpack_require__(21));

var _directory = __webpack_require__(84);

var meetingsApi = _interopRequireWildcard(__webpack_require__(486));

var externalContactsApi = _interopRequireWildcard(__webpack_require__(487));

var _awaitAction = __webpack_require__(145);

var _contactNotifications = __webpack_require__(490);

function initialize() {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch, getState) {
        var state, pageSize;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                state = getState();

                if (CONFIG.wampConnectOptions.contactLoadAll && (0, _contacts.selectLoadContactsOnLogin)(state)) {
                  pageSize = (0, _contacts.selectLoadContactsPageSize)(state);
                  dispatch((0, _api.contactLoadAll)(undefined, pageSize));
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}
/**
 * Save Contact
 * Validate and save a contact object (User or Meeting)
 * Allows favoriting at the same time
 * @param {Object} contact - A User or Meeting object
 */


var saveContact = function saveContact(contact) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(contact.contactType === c.CONTACT_TYPE_MEETING)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", dispatch(createOrUpdateMeeting(contact)));

              case 2:
                return _context2.abrupt("return", dispatch(upsertExternalContact(contact)));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
};
/**
 * Delete contact
 * @param {object} contact - contact object
 */


exports.saveContact = saveContact;

var deleteContact = function deleteContact(contact) {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(dispatch) {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.t0 = contact.contactType;
                _context3.next = _context3.t0 === c.CONTACT_TYPE_MEETING ? 3 : 6;
                break;

              case 3:
                _context3.next = 5;
                return dispatch(meetingsApi.deleteMeeting(contact.uuid));

              case 5:
                return _context3.abrupt("break", 8);

              case 6:
                _context3.next = 8;
                return dispatch(externalContactsApi.deleteExternalContact(contact));

              case 8:
                return _context3.abrupt("return", dispatch({
                  type: c.DELETE_CONTACT,
                  payload: {
                    uuid: contact.uuid
                  }
                }));

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x4) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
};
/**
 * Validate contact field
 */


exports.deleteContact = deleteContact;

var validateContact = function validateContact(contact) {
  return function (dispatch, getState) {
    var _result$errors;

    // TODO: All the different types of contacts don't need to be validated in a
    // single function I don't think.
    var state = getState();
    var contacts = (0, _get.default)(state, 'nucleus.contacts.records', []);
    var nameMaxLength = contact.contactType === c.CONTACT_TYPE_MEETING ? 32 : 64; // get existing names and extensions for the same contact type as that being saved

    var _contacts$filter$redu = contacts.filter(function (c) {
      return c.contactType === contact.contactType && c.uuid !== contact.uuid;
    }).reduce(function (_ref4, next) {
      var _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
          currNames = _ref5[0],
          currExtensions = _ref5[1];

      return [currNames.concat(next.name), currExtensions.concat(next.dialString)];
    }, [[], []]),
        _contacts$filter$redu2 = (0, _slicedToArray2.default)(_contacts$filter$redu, 2),
        names = _contacts$filter$redu2[0],
        extensions = _contacts$filter$redu2[1];

    var schema = contact.contactType === c.CONTACT_TYPE_STANDARD ? {
      name: new _validation.default(contact.name).maxLength(nameMaxLength).duplicate(names).required(),
      sipUri: new _validation.default(contact.sipUri).maxLength(255).duplicate(extensions).required()
    } : {
      name: new _validation.default(contact.name).maxLength(nameMaxLength).duplicate(names).required(),
      description: new _validation.default(contact.description).maxLength(250),
      pin: new _validation.default(contact.pin).maxLength(10).minLength(3).pattern(/^[0-9]*$/)
    };
    if (contact.meetingType === c.MEETING_TYPE_ONE_TIME) schema.name = new _validation.default(contact.name).maxLength(nameMaxLength).duplicate(names);
    var result = new _validation.default().validate(schema);

    if ((result === null || result === void 0 ? void 0 : (_result$errors = result.errors) === null || _result$errors === void 0 ? void 0 : _result$errors.length) > 0) {
      dispatch({
        type: c.VALIDATE_CONTACT_ERROR,
        payload: {
          contactType: contact.contactType,
          errors: result.errors
        }
      });
      throw result.errors;
    }

    dispatch({
      type: c.VALIDATE_CONTACT_SUCCESS
    });
    return true;
  };
};

exports.validateContact = validateContact;

var resetContactErrorState = function resetContactErrorState() {
  return {
    type: c.RESET_CONTACT_ERROR_STATE
  };
}; // contact notifications include all the information needed to populate a contact
// the only exception is for meetings owned by the current user that require a pin
// as the pin is never included in contact notifications


exports.resetContactErrorState = resetContactErrorState;

var shouldFetchContact = function shouldFetchContact(payload, state) {
  // return if not a meeting
  if ((0, _get.default)(payload, 'objectType') !== 'MEETING') return false;
  var ownerUUID = (0, _get.default)(payload, 'object.ownerUUID');
  var userUUID = (0, _currentUser.getUserUUID)(state); // return if current user is not owner

  if (userUUID !== ownerUUID) return false;
  return (0, _get.default)(payload, 'object.pinRequired');
};

var handleCreatedNotification = function handleCreatedNotification(payload) {
  return (
    /*#__PURE__*/
    function () {
      var _ref6 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(dispatch, getState) {
        var state, contact;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                state = getState(); // handle special case if contacts should be fetched

                if (!shouldFetchContact(payload, state)) {
                  _context4.next = 7;
                  break;
                }

                _context4.next = 4;
                return dispatch((0, _directory.loadByUUID)((0, _get.default)(payload, 'objectId')));

              case 4:
                _context4.t0 = _context4.sent;
                _context4.next = 8;
                break;

              case 7:
                _context4.t0 = (0, _contactNotifications.parseContactFromNotification)(payload, state);

              case 8:
                contact = _context4.t0;

                if (contact) {
                  _context4.next = 11;
                  break;
                }

                return _context4.abrupt("return");

              case 11:
                dispatch({
                  type: c.CONTACT_NOTIFICATION_CREATED,
                  payload: contact
                });

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x5, _x6) {
        return _ref6.apply(this, arguments);
      };
    }()
  );
};

var handleUpdatedNotification = function handleUpdatedNotification(payload) {
  return (
    /*#__PURE__*/
    function () {
      var _ref7 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(dispatch, getState) {
        var state, contactsLoaded, contactByUuid, previousContact, contact;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                state = getState(); // only process notifications for contacts if all contacts have been already loaded
                // or if the updated contact has been loaded before (favorites/recents)
                // otherwise the contact will be loaded when all contacts are loaded

                contactsLoaded = (0, _contacts.selectContactsLoaded)(state);
                contactByUuid = (0, _contacts.getContactByUuidGenerator)(state);
                previousContact = contactByUuid((0, _get.default)(payload, 'objectId'));

                if (!(!contactsLoaded && !previousContact)) {
                  _context5.next = 6;
                  break;
                }

                return _context5.abrupt("return");

              case 6:
                if (!shouldFetchContact(payload, state)) {
                  _context5.next = 12;
                  break;
                }

                _context5.next = 9;
                return dispatch((0, _directory.loadByUUID)((0, _get.default)(payload, 'objectId')));

              case 9:
                _context5.t0 = _context5.sent;
                _context5.next = 13;
                break;

              case 12:
                _context5.t0 = (0, _contactNotifications.parseContactFromNotification)(payload, state);

              case 13:
                contact = _context5.t0;

                if (contact) {
                  _context5.next = 16;
                  break;
                }

                return _context5.abrupt("return");

              case 16:
                dispatch({
                  type: c.CONTACT_NOTIFICATION_UPDATED,
                  payload: contact
                });

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x7, _x8) {
        return _ref7.apply(this, arguments);
      };
    }()
  );
};

var handleDeletedNotification = function handleDeletedNotification(payload) {
  return function (dispatch) {
    dispatch({
      type: c.CONTACT_NOTIFICATION_DELETED,
      payload: (0, _get.default)(payload, 'objectId')
    });
  };
};

var subscribe = function subscribe() {
  return proxyActions.subscribe(c.CONTACT_TOPIC);
};

exports.subscribe = subscribe;

var contactNotificationHandler = function contactNotificationHandler(payload) {
  return (
    /*#__PURE__*/
    function () {
      var _ref8 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(dispatch, getState) {
        var UUID, state, currentUserUUID, handler;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                // Obtain UUID from notification, exit if not found
                UUID = (0, _get.default)(payload, 'objectId');

                if (UUID) {
                  _context6.next = 4;
                  break;
                }

                _jsLogger.default.warn('contact nofitication with no objectId', payload);

                return _context6.abrupt("return");

              case 4:
                // Exit if UUID belongs to current user
                state = getState();
                currentUserUUID = (0, _currentUser.getUserUUID)(state);

                if (!(UUID === currentUserUUID)) {
                  _context6.next = 8;
                  break;
                }

                return _context6.abrupt("return");

              case 8:
                handler = notificationHandlerMap.get(payload.action);

                if (handler) {
                  _context6.next = 11;
                  break;
                }

                throw new Error("Unhandled contact notification type: ".concat(payload.action));

              case 11:
                dispatch(handler(payload));

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x9, _x10) {
        return _ref8.apply(this, arguments);
      };
    }()
  );
};

exports.contactNotificationHandler = contactNotificationHandler;

var upsertExternalContact = function upsertExternalContact(nextContact) {
  return (
    /*#__PURE__*/
    function () {
      var _ref9 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(dispatch, getState) {
        var state, prevContact, upsertedExternalContact;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                state = getState();
                prevContact = (0, _contacts.getContactByUuidGenerator)(state)(nextContact.uuid);
                _context7.prev = 2;
                // Dispatch begin action
                dispatch(saveContactBegin(nextContact)); // Validate contact

                dispatch(validateContact(nextContact)); // Make request to external contacts API and await response

                _context7.next = 7;
                return dispatch(externalContactsApi.saveExternalContact(nextContact));

              case 7:
                upsertedExternalContact = _context7.sent;
                _context7.next = 10;
                return dispatch((0, _awaitAction.awaitAction)(function (a) {
                  return (a.type === c.CONTACT_NOTIFICATION_CREATED || a.type === c.CONTACT_NOTIFICATION_UPDATED) && a.payload.uuid === upsertedExternalContact.uuid;
                }));

              case 10:
                _context7.next = 12;
                return dispatch(updateExternalContactFavorite(upsertedExternalContact.uuid, prevContact, nextContact));

              case 12:
                // Dispatch success action
                dispatch(saveContactSuccess(upsertedExternalContact));
                return _context7.abrupt("return", upsertedExternalContact);

              case 16:
                _context7.prev = 16;
                _context7.t0 = _context7["catch"](2);

                _jsLogger.default.error(_context7.t0);

                dispatch(saveContactFailure(_context7.t0));
                throw _context7.t0;

              case 21:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[2, 16]]);
      }));

      return function (_x11, _x12) {
        return _ref9.apply(this, arguments);
      };
    }()
  );
};

var updateExternalContactFavorite = function updateExternalContactFavorite(uuid, prevContact, nextContact) {
  return (
    /*#__PURE__*/
    function () {
      var _ref10 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee8(dispatch) {
        var prevFavorite, nextFavorite;
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                prevFavorite = (0, _get.default)(prevContact, 'favorite', false);
                nextFavorite = (0, _get.default)(nextContact, 'favorite', false); // Exit early if both values are the same

                if (!(prevFavorite === nextFavorite)) {
                  _context8.next = 4;
                  break;
                }

                return _context8.abrupt("return");

              case 4:
                return _context8.abrupt("return", dispatch(externalContactsApi.setFavorite(uuid, nextFavorite)));

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      return function (_x13) {
        return _ref10.apply(this, arguments);
      };
    }()
  );
};

var createOrUpdateMeeting = function createOrUpdateMeeting(meeting) {
  return (
    /*#__PURE__*/
    function () {
      var _ref11 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee9(dispatch) {
        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!meeting.uuid) {
                  _context9.next = 2;
                  break;
                }

                return _context9.abrupt("return", dispatch(updateMeetingAndFavorite(meeting)));

              case 2:
                return _context9.abrupt("return", dispatch(createMeeting(meeting)));

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      return function (_x14) {
        return _ref11.apply(this, arguments);
      };
    }()
  );
};

var createMeeting = function createMeeting(meeting) {
  return (
    /*#__PURE__*/
    function () {
      var _ref12 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee10(dispatch, getState) {
        var state, me, params, response, createdMeeting;
        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                state = getState();
                me = (0, _currentUser.myInfo)(state);
                _context10.prev = 2;
                dispatch(saveContactBegin(meeting));
                dispatch(validateContact(meeting));
                params = meetingsApi.getCreateMeetingParams(meeting, me);
                _context10.next = 8;
                return dispatch(meetingsApi.createMeeting(params));

              case 8:
                response = _context10.sent;
                createdMeeting = (0, _objectSpread2.default)({}, response.body);
                _context10.next = 12;
                return dispatch((0, _awaitAction.awaitAction)(function (a) {
                  return a.type === c.CONTACT_NOTIFICATION_CREATED && a.payload.uuid === createdMeeting.uuid;
                }));

              case 12:
                _context10.next = 14;
                return dispatch(updateFavoriteIfNecessary(createdMeeting.uuid, undefined, meeting));

              case 14:
                dispatch(saveContactSuccess(createdMeeting));
                return _context10.abrupt("return", createdMeeting);

              case 18:
                _context10.prev = 18;
                _context10.t0 = _context10["catch"](2);

                _jsLogger.default.error(_context10.t0);

                dispatch(saveContactFailure(_context10.t0));
                throw _context10.t0;

              case 23:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, null, [[2, 18]]);
      }));

      return function (_x15, _x16) {
        return _ref12.apply(this, arguments);
      };
    }()
  );
};

var updateMeetingAndFavorite = function updateMeetingAndFavorite(nextMeeting) {
  return (
    /*#__PURE__*/
    function () {
      var _ref13 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee11(dispatch, getState) {
        var state, prevMeeting, updatedMeeting;
        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                state = getState();
                prevMeeting = (0, _contacts.getContactByUuidGenerator)(state)(nextMeeting.uuid);
                _context11.prev = 2;
                dispatch(saveContactBegin(nextMeeting));
                dispatch(validateContact(nextMeeting));
                _context11.next = 7;
                return dispatch(updateMeeting(prevMeeting, nextMeeting));

              case 7:
                updatedMeeting = _context11.sent;
                _context11.next = 10;
                return dispatch(updateFavoriteIfNecessary(updatedMeeting.uuid, prevMeeting, nextMeeting));

              case 10:
                dispatch(saveContactSuccess(updatedMeeting));
                return _context11.abrupt("return", updatedMeeting);

              case 14:
                _context11.prev = 14;
                _context11.t0 = _context11["catch"](2);

                _jsLogger.default.error(_context11.t0);

                dispatch(saveContactFailure(_context11.t0));
                throw _context11.t0;

              case 19:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, null, [[2, 14]]);
      }));

      return function (_x17, _x18) {
        return _ref13.apply(this, arguments);
      };
    }()
  );
};

var updateFavoriteIfNecessary = function updateFavoriteIfNecessary(uuid, prevMeeting, nextMeeting) {
  return (
    /*#__PURE__*/
    function () {
      var _ref14 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee12(dispatch) {
        var prevFavorite, nextFavorite;
        return _regenerator.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                // prevMeeting comes from within CNUC, so the favorite should either be an object (is favorite) or null (is not)
                // We cast to a boolean for easy strict comparison
                prevFavorite = !!(0, _get.default)(prevMeeting, 'favorite', false); // nextMeeting is modified by the client, so if a meeting is altered to:
                // 1) Be a favorite, when it wasn't previously: 'favorite' is true (client doesn't know what object to store)
                // 2) Remove a favorite, when it was one previously: `favorite` is false or null
                // We cast to a boolean for easy strict comparison

                nextFavorite = !!(0, _get.default)(nextMeeting, 'favorite', false); // Exit early if both new and previous versions have favorite set

                if (!(prevFavorite === nextFavorite)) {
                  _context12.next = 4;
                  break;
                }

                return _context12.abrupt("return");

              case 4:
                if (!nextFavorite) {
                  _context12.next = 6;
                  break;
                }

                return _context12.abrupt("return", dispatch(meetingsApi.addToFavorites(uuid)));

              case 6:
                return _context12.abrupt("return", dispatch(meetingsApi.removeFromFavorites(uuid)));

              case 7:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      return function (_x19) {
        return _ref14.apply(this, arguments);
      };
    }()
  );
};

var updateMeeting = function updateMeeting(prevMeeting, nextMeeting) {
  return (
    /*#__PURE__*/
    function () {
      var _ref15 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee13(dispatch, getState) {
        var state, me, params, response, updatedMeeting;
        return _regenerator.default.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                state = getState();
                _context13.prev = 1;
                me = (0, _currentUser.myInfo)(state);
                params = meetingsApi.getBaseParams(nextMeeting, me);
                _context13.next = 6;
                return dispatch(meetingsApi.updateMeeting(params));

              case 6:
                response = _context13.sent;
                updatedMeeting = (0, _objectSpread2.default)({}, prevMeeting, nextMeeting, response.body);
                return _context13.abrupt("return", updatedMeeting);

              case 11:
                _context13.prev = 11;
                _context13.t0 = _context13["catch"](1);

                _jsLogger.default.error(_context13.t0);

              case 14:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, null, [[1, 11]]);
      }));

      return function (_x20, _x21) {
        return _ref15.apply(this, arguments);
      };
    }()
  );
};

var saveContactBegin = function saveContactBegin(payload) {
  return {
    type: c.SAVE_CONTACT_BEGIN,
    payload: payload
  };
};

var saveContactSuccess = function saveContactSuccess(payload) {
  return {
    type: c.SAVE_CONTACT_SUCCESS,
    payload: payload
  };
};

var saveContactFailure = function saveContactFailure(payload) {
  return {
    type: c.SAVE_CONTACT_ERROR,
    payload: payload
  };
};

var notificationHandlerMap = new Map([[c.CONTACT_ACTION_CREATED, handleCreatedNotification], [c.CONTACT_ACTION_UPDATED, handleUpdatedNotification], [c.CONTACT_ACTION_DELETED, handleDeletedNotification]]);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(29)["default"]))

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(CONFIG) {

var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getToken = getToken;
exports.getGuestToken = getGuestToken;
exports.storeJwt = storeJwt;
exports.refreshToken = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _get = _interopRequireDefault(__webpack_require__(11));

var C = _interopRequireWildcard(__webpack_require__(3));

var _auth = __webpack_require__(31);

var _token = __webpack_require__(269);

var _ssoUtils = __webpack_require__(270);

var _contacts = __webpack_require__(35);

/**
 * getToken
 * Asynchronous action that calls the login service token api, and returns a
 * promise with the result in the form of { A: 'jwt', CLIENT: 'cookie' }
 * rejects the promise if an error response is returned from the api
 * dispatches actions TOKEN_REQUEST_BEGIN, TOKEN_REQUEST_SUCCESS or TOKEN_REQUEST_FAILURE
 * @param {object} options - Its a dictionary of config parameters
 * @returns {Promise<object>} - API result in the form of { A: 'jwt', CLIENT: 'cookie' }
 */
function getToken() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch, getState) {
        var state, clientId, requestBody, uri, response, error;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                state = getState();

                if (Object.keys(options).length === 0) {
                  options.serialNumber = (0, _get.default)(state, 'nucleus.device.serialNumber');
                  options.pairingToken = (0, _get.default)(state, 'nucleus.device.pairingToken');
                  options.platform = (0, _auth.getPlatform)(state);
                }

                if (options.pairingToken || options.code || options.password && options.email) {
                  _context.next = 4;
                  break;
                }

                throw 'invalid options object';

              case 4:
                clientId = (0, _ssoUtils.getClientIdByPlatform)((0, _auth.getPlatform)(state));

                if (clientId) {
                  _context.next = 7;
                  break;
                }

                throw 'Invalid platform';

              case 7:
                // create the request body with:
                // client_id, grant_type, and code or email and password (from options param)
                requestBody = (0, _objectSpread2.default)({
                  client_id: clientId
                }, options);

                if (options.code) {
                  requestBody.grant_type = 'authorization_code';
                } else if (options.pairingToken) {
                  requestBody.grant_type = 'pairing_code';
                } else {
                  requestBody.grant_type = 'password';
                }

                _context.prev = 9;
                uri = (0, _ssoUtils.getLoginServiceTokenUri)((0, _get.default)(state, 'nucleus.cluster.url'));
                dispatch({
                  type: C.TOKEN_REQUEST_BEGIN,
                  payload: {
                    uri: uri,
                    requestBody: requestBody
                  }
                });
                _context.next = 14;
                return fetch(uri, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(requestBody)
                });

              case 14:
                _context.next = 16;
                return _context.sent.json();

              case 16:
                response = _context.sent;
                error = (0, _get.default)(response, 'ERROR');

                if (!error) {
                  _context.next = 20;
                  break;
                }

                throw error;

              case 20:
                dispatch({
                  type: C.TOKEN_REQUEST_SUCCESS,
                  payload: response
                });
                return _context.abrupt("return", response);

              case 24:
                _context.prev = 24;
                _context.t0 = _context["catch"](9);
                dispatch({
                  type: C.TOKEN_REQUEST_FAILURE,
                  payload: _context.t0
                });
                throw _context.t0;

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[9, 24]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}
/**
 * getGuestToken
 * Asynchronous action that calls the login service guest token api.
 * promise with the result in the form of { A: 'jwt' }
 * rejects the promise if an error response is returned from the api
 * dispatches actions TOKEN_REQUEST_BEGIN, TOKEN_REQUEST_SUCCESS or TOKEN_REQUEST_FAILURE
 * @param {string} displayName - Guest's chosen display name. Default: 'Guest'
 * @param {string} callExtension - Optional. Extension of the lifesize user this guest user is trying to call. Default: null
 * @param {string} displayName - Optional. Email of the guest user. Default: null
 * @returns {Promise<void>} Promise
 */


function getGuestToken() {
  var displayName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Guest';
  var callExtension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var email = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch, getState) {
        var state, domain, uri, requestBody, requestParams, rawResponse, response, error, newToken;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                state = getState();
                domain = (0, _contacts.getDomain)(state);
                uri = (0, _ssoUtils.getGuestTokenUri)(domain);
                requestBody = {
                  display_name: displayName
                };
                if (callExtension) requestBody['call_extension'] = callExtension;
                if (email) requestBody['email'] = email;
                _context2.prev = 6;
                dispatch({
                  type: C.TOKEN_REQUEST_BEGIN,
                  payload: {
                    uri: uri,
                    requestBody: requestBody
                  }
                });
                requestParams = {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(requestBody)
                };
                _context2.next = 11;
                return fetch(uri, requestParams);

              case 11:
                rawResponse = _context2.sent;
                _context2.next = 14;
                return rawResponse.json();

              case 14:
                response = _context2.sent;
                error = (0, _get.default)(response, 'ERROR');

                if (!error) {
                  _context2.next = 18;
                  break;
                }

                throw error;

              case 18:
                newToken = (0, _get.default)(response, 'A');

                if (newToken) {
                  _context2.next = 21;
                  break;
                }

                throw response;

              case 21:
                dispatch({
                  type: C.NEW_TOKEN_OBTAINED,
                  payload: {
                    isOneTime: true,
                    jwt: newToken
                  }
                });
                _context2.next = 28;
                break;

              case 24:
                _context2.prev = 24;
                _context2.t0 = _context2["catch"](6);
                dispatch({
                  type: C.TOKEN_REQUEST_FAILURE,
                  payload: _context2.t0
                });
                throw _context2.t0;

              case 28:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[6, 24]]);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
} // Refresh a token by submitting the old one and getting a new one back.
// We assume to have been gated so that if nucleus.token.updating === true we're not going to come in here.


var refreshToken = function refreshToken() {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(dispatch, getState) {
        var state, prevToken, domain, requestUri, requestOptions, result, response, newToken;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                state = getState();
                prevToken = (0, _token.selectRefreshableToken)(state);
                domain = (0, _get.default)(state, 'nucleus.cluster.url');
                requestUri = (0, _ssoUtils.getLoginServiceTokenRefreshUri)(CONFIG.environment || domain);

                if (prevToken) {
                  requestOptions = {
                    method: 'POST',
                    body: JSON.stringify({
                      A: prevToken
                    })
                  };
                } else {
                  requestOptions = {
                    method: 'GET'
                  };
                }

                _context3.prev = 5;
                dispatch({
                  type: C.TOKEN_REFRESH_BEGIN
                });
                _context3.next = 9;
                return fetch(requestUri, requestOptions);

              case 9:
                result = _context3.sent;
                _context3.t0 = result;

                if (!_context3.t0) {
                  _context3.next = 15;
                  break;
                }

                _context3.next = 14;
                return result.json();

              case 14:
                _context3.t0 = _context3.sent;

              case 15:
                response = _context3.t0;
                newToken = (0, _get.default)(response, 'A');

                if (newToken) {
                  _context3.next = 19;
                  break;
                }

                throw C.TOKEN_REFRESH_FAILURE;

              case 19:
                dispatch({
                  type: C.NEW_TOKEN_OBTAINED,
                  payload: {
                    isOneTime: false,
                    jwt: newToken
                  }
                });
                _context3.next = 26;
                break;

              case 22:
                _context3.prev = 22;
                _context3.t1 = _context3["catch"](5);
                dispatch({
                  type: C.TOKEN_REFRESH_FAILURE,
                  payload: {
                    error: _context3.t1 || C.TOKEN_REFRESH_FAILURE
                  }
                });
                throw _context3.t1;

              case 26:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[5, 22]]);
      }));

      return function (_x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
};

exports.refreshToken = refreshToken;

function storeJwt(jwt, isOneTimeJwt) {
  return function (dispatch) {
    if (!jwt) return;
    dispatch({
      type: C.NEW_TOKEN_OBTAINED,
      payload: {
        isOneTime: isOneTimeJwt,
        jwt: jwt
      }
    });
  };
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(29)["default"]))

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribeToAccountTopic = subscribeToAccountTopic;
exports.subscribeToUserTopic = subscribeToUserTopic;
exports.getUserProfile = getUserProfile;
exports.setCustomGroupUuid = setCustomGroupUuid;
exports.updateName = updateName;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _get = _interopRequireDefault(__webpack_require__(11));

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _proxy = __webpack_require__(21);

var c = _interopRequireWildcard(__webpack_require__(3));

function subscribeToAccountTopic() {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return dispatch((0, _proxy.subscribe)(c.ACCOUNT_TOPIC));

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);

                _jsLogger.default.warn('account topic: subscription failed:', _context.t0);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 5]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}

function subscribeToUserTopic() {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return dispatch((0, _proxy.subscribe)(c.ME_TOPIC));

              case 3:
                _context2.next = 8;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2["catch"](0);

                _jsLogger.default.warn('user topic: subscription failed:', _context2.t0);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 5]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}
/**
 * Returns a getUserProfile failure error
 * @param {Error} error An error describing why the request failed
 */


function getUserProfileFailed(error) {
  // { type: 'USER_NOT_FOUND'/'DEVICE_NOT_FOUND', description: 'Unable to find user'/'Unable to find device' }
  _jsLogger.default.error(error);

  var errorType = (0, _get.default)(error, 'type') || 'REQUEST_FAILED'; // a reliable string to be translated on the client

  return {
    type: c.GET_SESSION_FAILURE,
    payload: errorType
  };
}
/**
 * Returns a getUserProfile response action (even though the api call was successful, 'WAMP_SEND_SUCCESS' may actually
 * return an error in the response)
 * @param {Response} response An HTTP response object
 */


function getUserProfileResponse(response) {
  var parsedResponse = response && JSON.parse(response) || {};
  var body = parsedResponse.body,
      statusCode = parsedResponse.statusCode;

  if (statusCode && statusCode >= 400) {
    var error = (0, _get.default)(body, 'error', parsedResponse);
    throw error;
  }

  return {
    type: c.GET_SESSION_SUCCESS,
    payload: body
  };
}
/**
 * Gets the user profile / session which includes information such as UUID,
 * group UUID, role, context, etc.
 */


function getUserProfile() {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(dispatch, getState) {
        var clientInfo, response;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dispatch({
                  type: c.GET_SESSION_REQUEST
                });
                clientInfo = (0, _get.default)(getState(), 'nucleus.userProfile.clientInfo', null);
                _context3.prev = 2;
                _context3.next = 5;
                return dispatch((0, _proxy.proxyApiCall)(c.CHECKIN_SERVICE_ENDPOINT, c.CHECKIN_SERVICE_ATTRIBUTES_SUFFIX, c.HTTP_POST, clientInfo));

              case 5:
                response = _context3.sent;
                dispatch(getUserProfileResponse(response));
                _context3.next = 13;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](2);
                dispatch(getUserProfileFailed(_context3.t0));
                throw _context3.t0;

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[2, 9]]);
      }));

      return function (_x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
}

function setCustomGroupUuid(uuid) {
  return {
    type: c.SET_CUSTOM_GROUP_UUID,
    payload: uuid
  };
}

function updateName(newName) {
  return {
    type: c.NAME_UPDATED,
    payload: newName
  };
}

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.doSimpleAPIRequest = exports.doLicenseApiRequest = exports.doDeviceApiRequest = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _userProfile = __webpack_require__(52);

var c = _interopRequireWildcard(__webpack_require__(3));

var _proxy = __webpack_require__(21);

var _get2 = _interopRequireDefault(__webpack_require__(11));

/**
 * @param type - The Redux action constant name
 * @param error - The error object
 * @return {{type: *, payload: object}}
 */
var getErrorAction = function getErrorAction(type, error) {
  return {
    type: type,
    payload: error
  };
};
/**
 *
 * @param request
 * @param actionStartName - String for start action (read by reducer)
 * @param actionSuccessName- Success action (read by reducer)
 * @param actionFailureName - Failure action (read by reducer)
 * @param endpoint - Where to send the request
 * @param httpMethod - Get, Post...
 * @param inputParams - Optional payload for POST
 * @param queryParams - Optional params
 * @return {function(*, *): Promise<T>}
 */


var doDeviceApiRequest = function doDeviceApiRequest(request, actionStartName, actionSuccessName, actionFailureName) {
  var endpoint = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : c.PAIRED_DEVICES_ENDPOINT;
  var httpMethod = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : c.HTTP_GET;
  var uriSuffix = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
  var inputParams = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
  var queryParams = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch, getState) {
        var result, responseMessage;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(0, _userProfile.selectIsGuest)(getState())) {
                  _context.next = 3;
                  break;
                }

                dispatch(getErrorAction(actionFailureName, {
                  message: 'Guest user cannot use pairing api'
                }));
                return _context.abrupt("return");

              case 3:
                dispatch({
                  type: actionStartName
                });
                _context.prev = 4;
                _context.next = 7;
                return dispatch((0, _proxy.proxyApiCall)(endpoint, uriSuffix, httpMethod, inputParams, queryParams));

              case 7:
                result = _context.sent;
                // @see wamp-client.js middleware. Result is already parsed there
                // We need to leave the body as-is for now, for backwards compatibility of old Admin Console.
                responseMessage = JSON.parse(result.body); // throw error response from API not caught by fetch

                if (!((0, _get2.default)(responseMessage, 'RES') !== 'OK')) {
                  _context.next = 11;
                  break;
                }

                throw responseMessage;

              case 11:
                dispatch({
                  type: actionSuccessName,
                  payload: responseMessage
                });
                return _context.abrupt("return", Promise.resolve(responseMessage));

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](4);
                dispatch(getErrorAction(actionFailureName, (0, _get2.default)(_context.t0, 'MSG', _context.t0)));
                return _context.abrupt("return", Promise.reject(_context.t0));

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 15]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};
/**
 *
 * @param request
 * @param actionStartName - String for start action (read by reducer)
 * @param actionSuccessName- Success action (read by reducer)
 * @param actionFailureName - Failure action (read by reducer)
 * @param endpoint - Where to send the request
 * @param httpMethod - Get, Post...
 * @param inputParams - Optional payload for POST
 * @param queryParams - Optional params
 * @return {function(*, *): Promise<T>}
 */


exports.doDeviceApiRequest = doDeviceApiRequest;

var doLicenseApiRequest = function doLicenseApiRequest(actionStartName, actionSuccessName, actionFailureName) {
  var endpoint = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : c.PAIRED_DEVICES_ENDPOINT;
  var httpMethod = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : c.HTTP_GET;
  var uriSuffix = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
  var inputParams = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  var queryParams = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch, getState) {
        var result, parsedResult, responseMessage;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(0, _userProfile.selectIsGuest)(getState())) {
                  _context2.next = 3;
                  break;
                }

                dispatch(getErrorAction(actionFailureName, {
                  message: 'Guest user cannot use pairing api'
                }));
                return _context2.abrupt("return");

              case 3:
                dispatch({
                  type: actionStartName
                });
                _context2.prev = 4;
                _context2.next = 7;
                return dispatch((0, _proxy.proxyApiCall)(endpoint, uriSuffix, httpMethod, inputParams, queryParams));

              case 7:
                result = _context2.sent;
                // @see wamp-client.js middleware. Result is already parsed there
                // We need to leave the body as-is for now, for backwards compatibility of old Admin Console.
                parsedResult = JSON.parse(result);
                responseMessage = parsedResult.result; // throw error response from API not caught by fetch

                if (!(parsedResult.statusCode !== 200)) {
                  _context2.next = 12;
                  break;
                }

                throw responseMessage;

              case 12:
                dispatch({
                  type: actionSuccessName,
                  payload: responseMessage
                });
                _context2.next = 19;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](4);
                dispatch(getErrorAction(actionFailureName, (0, _get2.default)(_context2.t0, 'MSG', _context2.t0)));
                return _context2.abrupt("return", Promise.reject(_context2.t0));

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[4, 15]]);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
};
/**
 *
 * @param request
 * @param actionStartName - String for start action (read by reducer)
 * @param actionSuccessName- Success action (read by reducer)
 * @param actionFailureName - Failure action (read by reducer)
 * @param endpoint - Where to send the request
 * @param httpMethod - Get, Post...
 * @return {function(*, *): Promise<T>}
 */


exports.doLicenseApiRequest = doLicenseApiRequest;

var doSimpleAPIRequest = function doSimpleAPIRequest(actionStartName, actionSuccessName, actionFailureName) {
  var endpoint = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var httpMethod = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var uriSuffix = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
  var inputParams = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(dispatch, getState) {
        var result, responseMessage;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(0, _userProfile.selectIsGuest)(getState())) {
                  _context3.next = 3;
                  break;
                }

                dispatch(getErrorAction(actionFailureName, {
                  message: 'Guest user cannot use wallpaper api'
                }));
                return _context3.abrupt("return");

              case 3:
                dispatch({
                  type: actionStartName
                });
                _context3.prev = 4;
                _context3.next = 7;
                return dispatch((0, _proxy.proxyApiCall)(endpoint, uriSuffix, httpMethod, inputParams));

              case 7:
                result = _context3.sent;
                responseMessage = JSON.parse(result);
                dispatch({
                  type: actionSuccessName,
                  payload: responseMessage
                });
                return _context3.abrupt("return", Promise.resolve());

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](4);
                dispatch(getErrorAction(actionFailureName, (0, _get2.default)(_context3.t0, 'MSG', _context3.t0)));
                return _context3.abrupt("return", Promise.reject(_context3.t0));

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[4, 13]]);
      }));

      return function (_x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
};

exports.doSimpleAPIRequest = doSimpleAPIRequest;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.persistenceEnabled = exports.persistenceDisabled = exports.PERSISTENCE_ENABLED = exports.PERSISTENCE_DISABLED = void 0;
var PERSISTENCE_DISABLED = 'PERSISTENCE_DISABLED';
exports.PERSISTENCE_DISABLED = PERSISTENCE_DISABLED;
var PERSISTENCE_ENABLED = 'PERSISTENCE_ENABLED';
exports.PERSISTENCE_ENABLED = PERSISTENCE_ENABLED;

var persistenceDisabled = function persistenceDisabled() {
  return {
    type: PERSISTENCE_DISABLED
  };
};

exports.persistenceDisabled = persistenceDisabled;

var persistenceEnabled = function persistenceEnabled() {
  return {
    type: PERSISTENCE_ENABLED
  };
};

exports.persistenceEnabled = persistenceEnabled;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatStats = formatStats;
exports.getGenerateCertificate = getGenerateCertificate;
exports.getIceServers = getIceServers;
exports.getIceTransportPolicy = getIceTransportPolicy;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var c = _interopRequireWildcard(__webpack_require__(3));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _galaxyUtils = __webpack_require__(73);

var _feature = __webpack_require__(74);

function formatStats(prevStats, stats, startTime) {
  var objStats = {};
  var arrayStats = [];
  stats.forEach(function (stat) {
    objStats[stat.id] = stat;
    arrayStats.push(stat);
  });
  var transport = arrayStats.find(function (s) {
    return s.type === 'transport';
  }); // Chrome and Safari always have a transport,
  //   and it's the way we look up the other information about stats.
  // Firefox does not have this stat as of yet,
  //   and we will return null until we solve for Firefox's getStats implementation.
  // find and calculate

  var candidatePair = objStats[(0, _safeAccess.default)(transport, 'selectedCandidatePairId')] || {};
  var localId = candidatePair.localCandidateId || '';
  var remoteId = candidatePair.remoteCandidateId || '';
  var outboundVideo = arrayStats.find(function (s) {
    return s.type === 'outbound-rtp' && s.kind === 'video';
  }) || {};
  var inboundVideo = arrayStats.find(function (s) {
    return s.type === 'inbound-rtp' && s.kind === 'video';
  }) || {};
  var outboundAudio = arrayStats.find(function (s) {
    return s.type === 'outbound-rtp' && s.kind === 'audio';
  }) || {};
  var inboundAudio = arrayStats.find(function (s) {
    return s.type === 'inbound-rtp' && s.kind === 'audio';
  }) || {};
  var outboundVideoTrack = objStats[outboundVideo.trackId] || {};
  var inboundVideoTrack = objStats[inboundVideo.trackId] || {}; // calculations

  var outboundFrameRate = 0;
  var inboundFrameRate = 0;
  var videoBitrate = 0;
  var incomingBitrate = 0;
  var totalTime = (Date.now() - startTime) / 1000;
  var outgoingAudioBitrate = 0;
  var incomingAudioBitrate = 0;

  if (outboundVideo.id) {
    var prevOutboundVideo = prevStats[outboundVideo.id] || {};
    var timeDiff = prevOutboundVideo.timestamp ? (outboundVideo.timestamp - prevOutboundVideo.timestamp) / 1000 : outboundVideo.totalEncodeTime;
    var outFrameDifference = Math.max(0, outboundVideo.framesEncoded - (prevOutboundVideo.framesEncoded || 0));
    var outBytesDifference = Math.max(0, outboundVideo.bytesSent - (prevOutboundVideo.bytesSent || 0));
    outboundFrameRate = (timeDiff ? Math.floor(outFrameDifference / timeDiff) : outFrameDifference) || 0;
    videoBitrate = 8 * ((timeDiff ? Math.floor(outBytesDifference / timeDiff) : outBytesDifference) || 0);
  }

  if (inboundVideo.id) {
    var prevInboundVideo = prevStats[inboundVideo.id] || {};

    var _timeDiff = prevInboundVideo.timestamp ? (inboundVideo.timestamp - prevInboundVideo.timestamp) / 1000 : totalTime;

    var inBytesDifference = Math.max(0, inboundVideo.bytesReceived - (prevInboundVideo.bytesReceived || 0)) || 0;
    var inFrameDifference = Math.max(0, inboundVideo.framesDecoded - (prevInboundVideo.framesDecoded || 0)) || 0;
    inboundFrameRate = (_timeDiff ? Math.floor(inFrameDifference / _timeDiff) : inFrameDifference) || 0;
    incomingBitrate = 8 * ((_timeDiff ? Math.floor(inBytesDifference / _timeDiff) : inBytesDifference) || 0);
  }

  if (inboundAudio.id) {
    var prevInboundAudio = prevStats[inboundAudio.id] || {};

    var _timeDiff2 = prevInboundAudio.timestamp ? (inboundAudio.timestamp - prevInboundAudio.timestamp) / 1000 : totalTime;

    var _inBytesDifference = Math.max(0, inboundAudio.bytesReceived - (prevInboundAudio.bytesReceived || 0)) || 0;

    incomingAudioBitrate = 8 * ((_timeDiff2 ? Math.floor(_inBytesDifference / _timeDiff2) : _inBytesDifference) || 0);
  }

  if (outboundAudio.id) {
    var prevOutboundAudio = prevStats[outboundAudio.id] || {};

    var _timeDiff3 = prevOutboundAudio.timestamp ? (outboundAudio.timestamp - prevOutboundAudio.timestamp) / 1000 : totalTime;

    var _outBytesDifference = Math.max(0, outboundAudio.bytesSent - (prevOutboundAudio.bytesSent || 0)) || 0;

    outgoingAudioBitrate = 8 * ((_timeDiff3 ? Math.floor(_outBytesDifference / _timeDiff3) : _outBytesDifference) || 0);
  } // format


  var candidate_pair = {
    channel_id: candidatePair.id || '',
    local: {
      id: localId,
      type: (0, _safeAccess.default)(objStats[localId], 'candidateType') || ''
    },
    remote: {
      id: remoteId,
      type: (0, _safeAccess.default)(objStats[remoteId], 'candidateType') || ''
    }
  };
  var bwe = {
    target_enc_bitrate: candidatePair.availableOutgoingBitrate || 0,
    actual_enc_bitrate: videoBitrate || 0,
    available_bw: candidatePair.availableOutgoingBitrate || 0,
    transmit_bitrate: videoBitrate || 8 * ((totalTime ? Math.floor(candidatePair.bytesSent / totalTime) : candidatePair.bytesSent) || 0)
  };
  var videoSend = {
    bandwidth: videoBitrate || 0,
    codec: (0, _safeAccess.default)(objStats[(0, _safeAccess.default)(outboundVideo, 'codecId')], 'mimeType') || '',
    frame_rate: outboundFrameRate || 0,
    packets_lost: outboundVideo.nackCount || 0,
    packets_sent: outboundVideo.packetsSent || 0,
    bytes: outboundVideo.bytesSent || 0,
    resolution: {
      height: outboundVideoTrack.frameHeight || 0,
      width: outboundVideoTrack.frameWidth || 0
    }
  };
  var videoReceive = {
    bandwidth: incomingBitrate || 0,
    codec: (0, _safeAccess.default)(objStats[(0, _safeAccess.default)(inboundVideo, 'codecId')], 'mimeType') || '',
    frame_rate: inboundFrameRate || 0,
    packets_lost: inboundVideo.packetsLost || 0,
    packets_received: inboundVideo.packetsReceived || 0,
    bytes: inboundVideo.bytesReceived || 0,
    resolution: {
      height: inboundVideoTrack.frameHeight || 0,
      width: inboundVideoTrack.frameWidth || 0
    }
  };
  var audioSend = {
    bandwidth: outgoingAudioBitrate || 0,
    codec: (0, _safeAccess.default)(objStats[(0, _safeAccess.default)(outboundAudio, 'codecId')], 'mimeType') || '',
    packets_lost: outboundAudio.retransmittedPacketsSent || 0,
    packets_sent: outboundAudio.packetsSent || 0,
    jitter: 0,
    bytes: outboundAudio.bytesSent || 0
  };
  var audioReceive = {
    bandwidth: incomingAudioBitrate || 0,
    codec: (0, _safeAccess.default)(objStats[(0, _safeAccess.default)(inboundAudio, 'codecId')], 'mimeType') || '',
    packets_lost: inboundAudio.packetsLost || 0,
    packets_received: inboundAudio.packetsReceived || 0,
    jitter: Math.floor((inboundAudio.jitter || 0) * 1000),
    bytes: inboundAudio.bytesReceived || 0
  };
  var audio = {
    send: audioSend,
    receive: audioReceive
  };
  var formattedStats = {
    candidate_pair: candidate_pair,
    video: {
      bwe: bwe,
      send: videoSend,
      receive: videoReceive
    },
    audio: audio
  };
  return {
    objStats: objStats,
    formattedStats: formattedStats,
    timestamp: Math.floor(Date.now() / 1000)
  };
}

function getGenerateCertificate() {
  // chrome generateCertificate is not yet live, and thus
  // not included in our cross browser RTCPeerConnection object
  // generated by adapter.js
  if (window.RTCPeerConnection && window.RTCPeerConnection.generateCertificate) {
    return window.RTCPeerConnection.generateCertificate;
  } else if (window.webkitRTCPeerConnection && window.webkitRTCPeerConnection.generateCertificate) {
    return window.webkitRTCPeerConnection.generateCertificate;
  } else if (window.mozRTCPeerConnection && window.mozRTCPeerConnection.generateCertificate) {
    return window.mozRTCPeerConnection.generateCertificate;
  } else {
    // Stub generateCertificate for IE11
    return function (keygenAlgorithm) {
      return new Promise(function (resolve) {
        resolve({
          expires: new Date(2025, 1, 1, 1, 0, 0, 0).getTime(),
          getAlgorithm: function getAlgorithm() {
            return keygenAlgorithm;
          }
        });
      });
    };
  }
}

function getIceServers(state, iceServers) {
  // Check if the forceTcpTunneling flag is enabled. If so filter all the ice servers except the 443 tunnel server
  if ((0, _feature.getFeatureFlag)(state)(c.FEATUREFLAG_FORCE_TCP_TUNNELING)) {
    iceServers = iceServers.map(function (server) {
      // psems style
      if (typeof (0, _safeAccess.default)(server, 'urls') === 'string') {
        if (server.urls.indexOf(':443?transport=tcp') > -1) return server;
        return null;
      } // galaxy style


      var urls = server.urls.filter(function (url) {
        return url.indexOf(':443?transport=tcp') > -1;
      });
      if (urls.length) return (0, _objectSpread2.default)({}, server, {
        urls: urls
      });
      return null;
    }).filter(function (s) {
      return !!s;
    });
  }

  return iceServers;
}

function getIceTransportPolicy(state) {
  // If forceTcpTunneling is enabled force the policy to use only relay candiates.
  // Similarly, if directMedia is false and galxy is True then enforce relay mode
  var iceTransportPolicy = 'all';

  if ((0, _feature.getFeatureFlag)(state)(c.FEATUREFLAG_FORCE_TCP_TUNNELING) || (0, _galaxyUtils.relayOnlyMode)(state)) {
    iceTransportPolicy = 'relay';
  }

  return iceTransportPolicy;
}

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldReacquireOnMediaDevicesChanged = shouldReacquireOnMediaDevicesChanged;
exports.mediaDevicesChanged = mediaDevicesChanged;
exports.applyNoiseSuppressionConstraint = applyNoiseSuppressionConstraint;
exports.enumerateDevices = enumerateDevices;
exports.setTrackConstraints = setTrackConstraints;
exports.getHeightFromConstraints = getHeightFromConstraints;
exports.getWidthFromConstraints = getWidthFromConstraints;
exports.setHeightInConstraints = setHeightInConstraints;
exports.setWidthInConstraints = setWidthInConstraints;
exports.compareConstraints = compareConstraints;
exports.trackSupportsConstraints = trackSupportsConstraints;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _typeof2 = _interopRequireDefault(__webpack_require__(98));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _feature = __webpack_require__(74);

var _auth = __webpack_require__(31);

var _browserUtils = __webpack_require__(44);

var _constants = __webpack_require__(3);

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _media = __webpack_require__(143);

function shouldReacquireOnMediaDevicesChanged(nextState, action) {
  var isAcquiring = (0, _safeAccess.default)(nextState, 'nucleus.media.isAcquiringPrimaryStream');
  if (isAcquiring) return false; // do not start re-acquiring if already in the process of capturing the stream

  var hasOutgoingVideo = (0, _safeAccess.default)(nextState, 'nucleus.media.hasOutgoingVideo');
  var hasOutgoingAudio = (0, _safeAccess.default)(nextState, 'nucleus.media.hasOutgoingAudio');
  var selectedVideoSourceId = (0, _safeAccess.default)((0, _media.selectedVideoDevice)(nextState), 'deviceId') || null;
  var selectedAudioSourceId = (0, _safeAccess.default)((0, _media.selectedAudioDevice)(nextState), 'deviceId') || null;
  var primaryVideoSourceId = (0, _safeAccess.default)((0, _media.primaryVideoDevice)(nextState), 'deviceId') || null;
  var primaryAudioSourceId = (0, _safeAccess.default)((0, _media.primaryAudioDevice)(nextState), 'deviceId') || null;
  var isPrimaryVideoAvailable = ((0, _safeAccess.default)(action, 'payload') || []).find(function (d) {
    return d.deviceId === primaryVideoSourceId;
  });
  var isPrimaryAudioAvailable = ((0, _safeAccess.default)(action, 'payload') || []).find(function (d) {
    return d.deviceId === primaryAudioSourceId;
  }); // If the source doesn't exist and have outgoing video/audio
  // then acquire new stream

  if (selectedVideoSourceId === null && hasOutgoingVideo || selectedAudioSourceId === null && hasOutgoingAudio) {
    return true;
  }

  if (hasOutgoingVideo && isPrimaryVideoAvailable && selectedVideoSourceId !== primaryVideoSourceId || hasOutgoingAudio && isPrimaryAudioAvailable && selectedAudioSourceId !== primaryAudioSourceId) {
    return true;
  }

  if ((hasOutgoingAudio || hasOutgoingVideo) && (0, _safeAccess.default)(nextState, 'nucleus.media.localPrimaryStreamAcquisitionError')) {
    // If there was a acquisition error, then re-attempt
    return true;
  }

  return false;
}

function mediaDevicesChanged(currentDevices, devices) {
  if (!currentDevices || !currentDevices.length) {
    currentDevices = [];
  }

  if (!devices || !devices.length) {
    devices = [];
  }

  if (currentDevices.length !== devices.length) return true;
  currentDevices.sort(function (a, b) {
    return a.deviceId - b.deviceId;
  });
  devices.sort(function (a, b) {
    return a.deviceId - b.deviceId;
  });
  var changed = false;

  for (var i = 0; i < currentDevices.length; i++) {
    // CNUC-2027: Certain devices (older macs) have the same device ID and group ID, but
    // change labels when certain headsets are attached, necessitating a device refresh.
    if (currentDevices[i].deviceId !== devices[i].deviceId || (currentDevices[i].groupId || devices[i].groupId) && currentDevices[i].groupId !== devices[i].groupId || (currentDevices[i].label || devices[i].label) && currentDevices[i].label !== devices[i].label) {
      changed = true;
      break;
    }
  }

  return changed;
} // CNUC-2112 - noise suppression constraint


function applyNoiseSuppressionConstraint(state, currentConstraints) {
  if (!currentConstraints) return currentConstraints;
  var noiseSuppression = (0, _feature.getFeatureFlag)(state)(_constants.FEATUREFLAG_ENABLE_NOISE_SUPPRESSION);
  if (!noiseSuppression) return currentConstraints; // do not apply to webRTC native platforms, they handle this manually for now

  if ((0, _browserUtils.isWebRtcNative)((0, _auth.getPlatform)(state))) return currentConstraints; // audio constraints is either an object, or a boolean,
  //   if true, make it an object with noiseSuppression as the only property
  //   otherwise add it to the object

  if (currentConstraints === true) {
    return {
      noiseSuppression: noiseSuppression
    };
  }

  return (0, _objectSpread2.default)({}, currentConstraints, {
    noiseSuppression: noiseSuppression
  });
}

function enumerateDevices() {
  // handle case when doubango hasn't yet polyfilled navigator.mediaDevices
  if (!navigator.mediaDevices) return Promise.resolve([]);

  try {
    return navigator.mediaDevices.enumerateDevices();
  } catch (ex) {
    return Promise.resolve([]);
  }
}

function setTrackConstraints(_x, _x2, _x3) {
  return _setTrackConstraints.apply(this, arguments);
}

function _setTrackConstraints() {
  _setTrackConstraints = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee(track, height, width) {
    var retVal, constraints;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            retVal = false;

            if (!trackSupportsConstraints(track)) {
              _context.next = 13;
              break;
            }

            // The underlying peer connection implementation supports constraint changes
            constraints = track.getConstraints();
            setHeightInConstraints(constraints, height);
            setWidthInConstraints(constraints, width);
            _context.prev = 5;
            _context.next = 8;
            return track.applyConstraints(constraints);

          case 8:
            retVal = true;
            _context.next = 13;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](5);

          case 13:
            return _context.abrupt("return", retVal);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 11]]);
  }));
  return _setTrackConstraints.apply(this, arguments);
}

function getHeightFromConstraints(cons) {
  if ((0, _typeof2.default)(cons.height) === 'object') {
    return cons.height.max || cons.height.ideal;
  } else if (typeof cons.height === 'number') {
    return cons.height;
  } // In all other cases just return 0


  return 0;
}

function getWidthFromConstraints(cons) {
  if ((0, _typeof2.default)(cons.width) === 'object') {
    return cons.width.max || cons.width.ideal;
  } else if (typeof cons.width === 'number') {
    return cons.width;
  } // In all other cases just return 0


  return 0;
}

function setHeightInConstraints(cons, height) {
  if ((0, _typeof2.default)(cons.height) === 'object') {
    cons.height.max = height;
    cons.height.ideal = height;
  } else if (typeof cons.height === 'number') {
    cons.height = height;
  } // In all other cases constraint is unchanged


  return cons;
}

function setWidthInConstraints(cons, width) {
  if ((0, _typeof2.default)(cons.width) === 'object') {
    cons.width.max = width;
    cons.width.ideal = width;
  } else if (typeof cons.width === 'number') {
    cons.width = width;
  } // In all other cases constraint is unchanged


  return cons;
}

function compareConstraints(track, height, width) {
  var retVal = 0;
  var cons1 = {
    height: 0,
    width: 0
  };
  var cons2 = {
    height: height,
    width: width
  };

  if (trackSupportsConstraints(track)) {
    // The underlying peer connection implementation supports constraint api
    var trackConstraints = track.getConstraints(); // https://www.w3.org/TR/webrtc/#mediatracksupportedconstraints-mediatrackcapabilities-mediatrackconstraints-and-mediatracksettings
    // Ideally as per the spec the mediastreamTrack constraints should be a number
    // and it used to be the case. However, recently (not sure if its due to the new chrome version)
    // the constraints started appearing as an object. I believe the way we set the
    // constraints getUserMedia is now getting copied over to the track somehow.
    // Somethin in chrome's behavior has changed. Made changes to the code to
    // adapt to the same

    cons1.height = getHeightFromConstraints(trackConstraints);
    cons1.width = getWidthFromConstraints(trackConstraints);
  }

  if (!cons1.height || !cons1.width || !cons2.height || !cons2.width) {
    // If any  of the dimensions is unavailable then return zero indicating
    // in the context of when it gets used it should be an acceptable failure
    // handling
    retVal = 0;
  } else {
    if (cons1.height > cons2.height && cons1.width > cons2.width) {
      retVal = 1;
    } else if (cons1.height < cons2.height && cons1.width < cons2.width) {
      retVal = -1;
    } else if (cons1.height !== cons2.height && cons1.width !== cons2.width) {
      // return the difference of the aspect ratios
      retVal = cons1.width / cons1.height - cons2.width / cons2.height;
    }
  }

  return retVal;
}

function trackSupportsConstraints(track) {
  return track && typeof track.getConstraints === 'function' && typeof track.applyConstraints === 'function';
}

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(224);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMediaStream = createMediaStream;

function createMediaStream() {
  return Promise.resolve(new window.MediaStream());
}

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createLoader = __webpack_require__(285);

Object.defineProperty(exports, 'createLoader', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_createLoader)['default'];
    }
});

var _createMiddleware = __webpack_require__(288);

Object.defineProperty(exports, 'createMiddleware', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_createMiddleware)['default'];
    }
});

var _reducer = __webpack_require__(290);

Object.defineProperty(exports, 'reducer', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_reducer)['default'];
    }
});

var _constants = __webpack_require__(129);

Object.defineProperty(exports, 'LOAD', {
    enumerable: true,
    get: function get() {
        return _constants.LOAD;
    }
});
Object.defineProperty(exports, 'SAVE', {
    enumerable: true,
    get: function get() {
        return _constants.SAVE;
    }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// The full default export is required to be BC with redux-storage <= v1.3.2
exports['default'] = _extends({}, __webpack_require__(129), {
    createLoader: __webpack_require__(285)['default'],
    createMiddleware: __webpack_require__(288)['default'],
    reducer: __webpack_require__(290)['default']
});

/***/ }),
/* 205 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Internet Connectivity Establishment (ICE) Connection State
 * https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/iceConnectionState
 */
var _default = {
  new: 'new',
  checking: 'checking',
  connected: 'connected',
  completed: 'completed',
  failed: 'failed',
  disconnected: 'disconnected',

  /** The ICE agent for this RTCPeerConnection has shut down and is no longer handling requests. */
  closed: 'closed'
};
exports.default = _default;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  stable: 'stable',
  haveLocalOffer: 'have-local-offer',
  haveRemoteOffer: 'have-remote-offer',
  haveLocalAnswer: 'have-local-pranswer',
  haveRemoteAnswer: 'have-remote-pranswer',
  closed: 'closed'
};
exports.default = _default;

/***/ }),
/* 208 */
/***/ (function(module, exports) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(88),
    isObject = __webpack_require__(58);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 210 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 211 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(331);
var parse = __webpack_require__(332);
var formats = __webpack_require__(213);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var util = __webpack_require__(171);

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = util.assign(
    {
        'default': Format.RFC3986,
        formatters: {
            RFC1738: function (value) {
                return replace.call(value, percentTwenties, '+');
            },
            RFC3986: function (value) {
                return String(value);
            }
        }
    },
    Format
);


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// Errors
exports.ALREADY_INIT = 'ALREADY_INIT';
exports.CALL_TIMEOUT = 'CALL_TIMEOUT';
exports.CONNECTION_NOT_INIT = 'CONNECTION_NOT_INIT';
exports.CONNECTION_NOT_OPEN = 'CONNECTION_NOT_OPEN';
exports.SUBSCRIPTION_NOT_FOUND = 'SUBSCRIPTION_NOT_FOUND';
exports.WAMP_JWT_ERROR = 'wamp.error.jwt_error';
// HTTP
exports.POST = 'POST';
// Procedures
exports.CHECKIN = 'lifesize.checkin';
exports.TEST_ECHO = 'test.echo';
// Checkin values
exports.GUEST = 'GUEST';


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(89);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(352),
    hasPath = __webpack_require__(353);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkin = void 0;
var rxjs_1 = __webpack_require__(63);
var operators_1 = __webpack_require__(62);
var EventBus_1 = __importStar(__webpack_require__(101));
function checkin() {
    return __awaiter(this, void 0, void 0, function () {
        var success, failure, promise, event;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    success = EventBus_1.default.Subject.pipe(operators_1.find(function (e) { return e.type === 'CHECKIN_SUCCESS'; }));
                    failure = EventBus_1.throwOnEvent(EventBus_1.default.Subject, 'CHECKIN_FAILURE');
                    promise = rxjs_1.race(success, failure).toPromise();
                    EventBus_1.default.Subject.next({ type: 'CHECKIN_REQUEST' });
                    return [4 /*yield*/, promise];
                case 1:
                    event = _a.sent();
                    return [2 /*return*/, event.payload];
            }
        });
    });
}
exports.checkin = checkin;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function guid() {
    var date = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (character) {
        var random = (date + Math.random() * 16) % 16 | 0;
        date = Math.floor(date / 16);
        return (character === 'x' ? random : (random & 0x7) | 0x8).toString(16);
    });
    return uuid;
}
exports.default = guid;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribeToTopic = subscribeToTopic;
exports.default = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _proxy = __webpack_require__(21);

var c = _interopRequireWildcard(__webpack_require__(3));

function subscribeToTopic() {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return dispatch((0, _proxy.subscribe)(c.AVAILABILITY_TOPIC));

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);

                _jsLogger.default.warn('availability topic: subscription failed:', _context.t0);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 5]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}
/**
 * Set the availability status of the client.
 * @param {'available'|'away'|'unavailable'} status The availability status to be set
 */


var postAvailabilityStatus = function postAvailabilityStatus(status) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dispatch({
                  type: c.AVAILABILITY_POST_BEGIN,
                  payload: status
                });
                _context2.prev = 1;
                _context2.next = 4;
                return dispatch((0, _proxy.proxyApiCall)(c.AVAILABILITY_ENDPOINT, c.AVAILABILITY_STATUS_SUFFIX, c.HTTP_POST, JSON.stringify({
                  status: status
                })));

              case 4:
                return _context2.abrupt("return", dispatch({
                  type: c.AVAILABILITY_POST_SUCCESS
                }));

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](1);
                dispatch({
                  type: c.AVAILABILITY_POST_ERROR,
                  payload: {
                    e: _context2.t0
                  }
                });

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 7]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
};

var _default = {
  postAvailabilityStatus: postAvailabilityStatus
};
exports.default = _default;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribe = subscribe;
exports.unsubscribe = unsubscribe;
exports.subscribeToTopic = subscribeToTopic;
exports.postDeviceUpdate = postDeviceUpdate;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _get = _interopRequireDefault(__webpack_require__(11));

var c = _interopRequireWildcard(__webpack_require__(3));

var proxyActions = _interopRequireWildcard(__webpack_require__(21));

/** @module actions/calendar */
function subscribe() {
  return proxyActions.subscribe(c.CALENDAR_TOPIC);
}

function unsubscribe() {
  return proxyActions.unsubscribe(c.CALENDAR_TOPIC);
}

function subscribeToTopic() {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch, getState) {
        var state;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                state = getState();

                if ((0, _get.default)(state, 'nucleus.calendar.enabled')) {
                  _context.next = 4;
                  break;
                }

                _jsLogger.default.info('calendar: disabled. skipping subscription.');

                return _context.abrupt("return");

              case 4:
                _context.prev = 4;
                _context.next = 7;
                return dispatch(subscribe(c.CALENDAR_TOPIC));

              case 7:
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](4);

                _jsLogger.default.warn('calendar topic: subscription failed:', _context.t0);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 9]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}
/**
 * postDeviceUpdate
 * @param {string} timezone - Update timezone for device
 */


function postDeviceUpdate() {
  var timezone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'UTC';
  return function (dispatch) {
    return dispatch(proxyActions.proxyApiCall(c.CALENDAR_ENDPOINT, 'device_update', 'POST', {
      TZ: timezone
    })).then(function (res) {
      return dispatch({
        type: c.WAMP_SUBSCRIPTION_ACTION_CALENDAR_TOPIC,
        payload: res
      });
    });
  };
}

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(222),
    arraySome = __webpack_require__(383),
    cacheHas = __webpack_require__(223);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(168),
    setCacheAdd = __webpack_require__(381),
    setCacheHas = __webpack_require__(382);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 223 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(57);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(226),
    getSymbols = __webpack_require__(184),
    keys = __webpack_require__(102);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(176),
    isArray = __webpack_require__(43);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 227 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(388),
    isArguments = __webpack_require__(139),
    isArray = __webpack_require__(43),
    isBuffer = __webpack_require__(140),
    isIndex = __webpack_require__(138),
    isTypedArray = __webpack_require__(185);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(142),
    nativeKeys = __webpack_require__(391);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 230 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(89),
    root = __webpack_require__(57);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(58);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 233 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 234 */
/***/ (function(module, exports) {

var grammar = module.exports = {
  v: [{
    name: 'version',
    reg: /^(\d*)$/
  }],
  o: [{ //o=- 20518 0 IN IP4 203.0.113.1
    // NB: sessionId will be a String in most cases because it is huge
    name: 'origin',
    reg: /^(\S*) (\d*) (\d*) (\S*) IP(\d) (\S*)/,
    names: ['username', 'sessionId', 'sessionVersion', 'netType', 'ipVer', 'address'],
    format: '%s %s %d %s IP%d %s'
  }],
  // default parsing of these only (though some of these feel outdated)
  s: [{ name: 'name' }],
  i: [{ name: 'description' }],
  u: [{ name: 'uri' }],
  e: [{ name: 'email' }],
  p: [{ name: 'phone' }],
  z: [{ name: 'timezones' }], // TODO: this one can actually be parsed properly..
  r: [{ name: 'repeats' }],   // TODO: this one can also be parsed properly
  //k: [{}], // outdated thing ignored
  t: [{ //t=0 0
    name: 'timing',
    reg: /^(\d*) (\d*)/,
    names: ['start', 'stop'],
    format: '%d %d'
  }],
  c: [{ //c=IN IP4 10.47.197.26
    name: 'connection',
    reg: /^IN IP(\d) (\S*)/,
    names: ['version', 'ip'],
    format: 'IN IP%d %s'
  }],
  b: [{ //b=AS:4000
    push: 'bandwidth',
    reg: /^(TIAS|AS|CT|RR|RS):(\d*)/,
    names: ['type', 'limit'],
    format: '%s:%s'
  }],
  m: [{ //m=video 51744 RTP/AVP 126 97 98 34 31
    // NB: special - pushes to session
    // TODO: rtp/fmtp should be filtered by the payloads found here?
    reg: /^(\w*) (\d*) ([\w\/]*)(?: (.*))?/,
    names: ['type', 'port', 'protocol', 'payloads'],
    format: '%s %d %s %s'
  }],
  a: [
    { //a=rtpmap:110 opus/48000/2
      push: 'rtp',
      reg: /^rtpmap:(\d*) ([\w\-\.]*)(?:\s*\/(\d*)(?:\s*\/(\S*))?)?/,
      names: ['payload', 'codec', 'rate', 'encoding'],
      format: function (o) {
        return (o.encoding) ?
          'rtpmap:%d %s/%s/%s':
          o.rate ?
          'rtpmap:%d %s/%s':
          'rtpmap:%d %s';
      }
    },
    { //a=fmtp:108 profile-level-id=24;object=23;bitrate=64000
      //a=fmtp:111 minptime=10; useinbandfec=1
      push: 'fmtp',
      reg: /^fmtp:(\d*) ([\S| ]*)/,
      names: ['payload', 'config'],
      format: 'fmtp:%d %s'
    },
    { //a=control:streamid=0
      name: 'control',
      reg: /^control:(.*)/,
      format: 'control:%s'
    },
    { //a=rtcp:65179 IN IP4 193.84.77.194
      name: 'rtcp',
      reg: /^rtcp:(\d*)(?: (\S*) IP(\d) (\S*))?/,
      names: ['port', 'netType', 'ipVer', 'address'],
      format: function (o) {
        return (o.address != null) ?
          'rtcp:%d %s IP%d %s':
          'rtcp:%d';
      }
    },
    { //a=rtcp-fb:98 trr-int 100
      push: 'rtcpFbTrrInt',
      reg: /^rtcp-fb:(\*|\d*) trr-int (\d*)/,
      names: ['payload', 'value'],
      format: 'rtcp-fb:%d trr-int %d'
    },
    { //a=rtcp-fb:98 nack rpsi
      push: 'rtcpFb',
      reg: /^rtcp-fb:(\*|\d*) ([\w-_]*)(?: ([\w-_]*))?/,
      names: ['payload', 'type', 'subtype'],
      format: function (o) {
        return (o.subtype != null) ?
          'rtcp-fb:%s %s %s':
          'rtcp-fb:%s %s';
      }
    },
    { //a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
      //a=extmap:1/recvonly URI-gps-string
      push: 'ext',
      reg: /^extmap:(\d+)(?:\/(\w+))? (\S*)(?: (\S*))?/,
      names: ['value', 'direction', 'uri', 'config'],
      format: function (o) {
        return 'extmap:%d' + (o.direction ? '/%s' : '%v') + ' %s' + (o.config ? ' %s' : '');
      }
    },
    { //a=crypto:1 AES_CM_128_HMAC_SHA1_80 inline:PS1uQCVeeCFCanVmcjkpPywjNWhcYD0mXXtxaVBR|2^20|1:32
      push: 'crypto',
      reg: /^crypto:(\d*) ([\w_]*) (\S*)(?: (\S*))?/,
      names: ['id', 'suite', 'config', 'sessionConfig'],
      format: function (o) {
        return (o.sessionConfig != null) ?
          'crypto:%d %s %s %s':
          'crypto:%d %s %s';
      }
    },
    { //a=setup:actpass
      name: 'setup',
      reg: /^setup:(\w*)/,
      format: 'setup:%s'
    },
    { //a=mid:1
      name: 'mid',
      reg: /^mid:([^\s]*)/,
      format: 'mid:%s'
    },
    { //a=msid:0c8b064d-d807-43b4-b434-f92a889d8587 98178685-d409-46e0-8e16-7ef0db0db64a
      name: 'msid',
      reg: /^msid:(.*)/,
      format: 'msid:%s'
    },
    { //a=ptime:20
      name: 'ptime',
      reg: /^ptime:(\d*)/,
      format: 'ptime:%d'
    },
    { //a=maxptime:60
      name: 'maxptime',
      reg: /^maxptime:(\d*)/,
      format: 'maxptime:%d'
    },
    { //a=sendrecv
      name: 'direction',
      reg: /^(sendrecv|recvonly|sendonly|inactive)/
    },
    { //a=ice-lite
      name: 'icelite',
      reg: /^(ice-lite)/
    },
    { //a=ice-ufrag:F7gI
      name: 'iceUfrag',
      reg: /^ice-ufrag:(\S*)/,
      format: 'ice-ufrag:%s'
    },
    { //a=ice-pwd:x9cml/YzichV2+XlhiMu8g
      name: 'icePwd',
      reg: /^ice-pwd:(\S*)/,
      format: 'ice-pwd:%s'
    },
    { //a=fingerprint:SHA-1 00:11:22:33:44:55:66:77:88:99:AA:BB:CC:DD:EE:FF:00:11:22:33
      name: 'fingerprint',
      reg: /^fingerprint:(\S*) (\S*)/,
      names: ['type', 'hash'],
      format: 'fingerprint:%s %s'
    },
    { //a=candidate:0 1 UDP 2113667327 203.0.113.1 54400 typ host
      //a=candidate:1162875081 1 udp 2113937151 192.168.34.75 60017 typ host generation 0 network-id 3 network-cost 10
      //a=candidate:3289912957 2 udp 1845501695 193.84.77.194 60017 typ srflx raddr 192.168.34.75 rport 60017 generation 0 network-id 3 network-cost 10
      //a=candidate:229815620 1 tcp 1518280447 192.168.150.19 60017 typ host tcptype active generation 0 network-id 3 network-cost 10
      //a=candidate:3289912957 2 tcp 1845501695 193.84.77.194 60017 typ srflx raddr 192.168.34.75 rport 60017 tcptype passive generation 0 network-id 3 network-cost 10
      push:'candidates',
      reg: /^candidate:(\S*) (\d*) (\S*) (\d*) (\S*) (\d*) typ (\S*)(?: raddr (\S*) rport (\d*))?(?: tcptype (\S*))?(?: generation (\d*))?(?: network-id (\d*))?(?: network-cost (\d*))?/,
      names: ['foundation', 'component', 'transport', 'priority', 'ip', 'port', 'type', 'raddr', 'rport', 'tcptype', 'generation', 'network-id', 'network-cost'],
      format: function (o) {
        var str = 'candidate:%s %d %s %d %s %d typ %s';

        str += (o.raddr != null) ? ' raddr %s rport %d' : '%v%v';

        // NB: candidate has three optional chunks, so %void middles one if it's missing
        str += (o.tcptype != null) ? ' tcptype %s' : '%v';

        if (o.generation != null) {
          str += ' generation %d';
        }

        str += (o['network-id'] != null) ? ' network-id %d' : '%v';
        str += (o['network-cost'] != null) ? ' network-cost %d' : '%v';
        return str;
      }
    },
    { //a=end-of-candidates (keep after the candidates line for readability)
      name: 'endOfCandidates',
      reg: /^(end-of-candidates)/
    },
    { //a=remote-candidates:1 203.0.113.1 54400 2 203.0.113.1 54401 ...
      name: 'remoteCandidates',
      reg: /^remote-candidates:(.*)/,
      format: 'remote-candidates:%s'
    },
    { //a=ice-options:google-ice
      name: 'iceOptions',
      reg: /^ice-options:(\S*)/,
      format: 'ice-options:%s'
    },
    { //a=ssrc:2566107569 cname:t9YU8M1UxTF8Y1A1
      push: 'ssrcs',
      reg: /^ssrc:(\d*) ([\w_-]*)(?::(.*))?/,
      names: ['id', 'attribute', 'value'],
      format: function (o) {
        var str = 'ssrc:%d';
        if (o.attribute != null) {
          str += ' %s';
          if (o.value != null) {
            str += ':%s';
          }
        }
        return str;
      }
    },
    { //a=ssrc-group:FEC 1 2
      //a=ssrc-group:FEC-FR 3004364195 1080772241
      push: 'ssrcGroups',
      // token-char = %x21 / %x23-27 / %x2A-2B / %x2D-2E / %x30-39 / %x41-5A / %x5E-7E
      reg: /^ssrc-group:([\x21\x23\x24\x25\x26\x27\x2A\x2B\x2D\x2E\w]*) (.*)/,
      names: ['semantics', 'ssrcs'],
      format: 'ssrc-group:%s %s'
    },
    { //a=msid-semantic: WMS Jvlam5X3SX1OP6pn20zWogvaKJz5Hjf9OnlV
      name: 'msidSemantic',
      reg: /^msid-semantic:\s?(\w*) (\S*)/,
      names: ['semantic', 'token'],
      format: 'msid-semantic: %s %s' // space after ':' is not accidental
    },
    { //a=group:BUNDLE audio video
      push: 'groups',
      reg: /^group:(\w*) (.*)/,
      names: ['type', 'mids'],
      format: 'group:%s %s'
    },
    { //a=rtcp-mux
      name: 'rtcpMux',
      reg: /^(rtcp-mux)/
    },
    { //a=rtcp-rsize
      name: 'rtcpRsize',
      reg: /^(rtcp-rsize)/
    },
    { //a=sctpmap:5000 webrtc-datachannel 1024
      name: 'sctpmap',
      reg: /^sctpmap:([\w_\/]*) (\S*)(?: (\S*))?/,
      names: ['sctpmapNumber', 'app', 'maxMessageSize'],
      format: function (o) {
        return (o.maxMessageSize != null) ?
          'sctpmap:%s %s %s' :
          'sctpmap:%s %s';
      }
    },
    { //a=x-google-flag:conference
      name: 'xGoogleFlag',
      reg: /^x-google-flag:([^\s]*)/,
      format: 'x-google-flag:%s'
    },
    { //a=rid:1 send max-width=1280;max-height=720;max-fps=30;depend=0
      push: 'rids',
      reg: /^rid:([\d\w]+) (\w+)(?: ([\S| ]*))?/,
      names: ['id', 'direction', 'params'],
      format: function (o) {
        return (o.params) ? 'rid:%s %s %s' : 'rid:%s %s';
      }
    },
    { //a=imageattr:97 send [x=800,y=640,sar=1.1,q=0.6] [x=480,y=320] recv [x=330,y=250]
      //a=imageattr:* send [x=800,y=640] recv *
      //a=imageattr:100 recv [x=320,y=240]
      push: 'imageattrs',
      reg: new RegExp(
        //a=imageattr:97
        '^imageattr:(\\d+|\\*)' +
        //send [x=800,y=640,sar=1.1,q=0.6] [x=480,y=320]
        '[\\s\\t]+(send|recv)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*)' +
        //recv [x=330,y=250]
        '(?:[\\s\\t]+(recv|send)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*))?'
      ),
      names: ['pt', 'dir1', 'attrs1', 'dir2', 'attrs2'],
      format: function (o) {
        return 'imageattr:%s %s %s' + (o.dir2 ? ' %s %s' : '');
      }
    },
    { //a=simulcast:send 1,2,3;~4,~5 recv 6;~7,~8
      //a=simulcast:recv 1;4,5 send 6;7
      name: 'simulcast',
      reg: new RegExp(
        //a=simulcast:
        '^simulcast:' +
        //send 1,2,3;~4,~5
        '(send|recv) ([a-zA-Z0-9\\-_~;,]+)' +
        //space + recv 6;~7,~8
        '(?:\\s?(send|recv) ([a-zA-Z0-9\\-_~;,]+))?' +
        //end
        '$'
      ),
      names: ['dir1', 'list1', 'dir2', 'list2'],
      format: function (o) {
        return 'simulcast:%s %s' + (o.dir2 ? ' %s %s' : '');
      }
    },
    { //Old simulcast draft 03 (implemented by Firefox)
      //  https://tools.ietf.org/html/draft-ietf-mmusic-sdp-simulcast-03
      //a=simulcast: recv pt=97;98 send pt=97
      //a=simulcast: send rid=5;6;7 paused=6,7
      name: 'simulcast_03',
      reg: /^simulcast:[\s\t]+([\S+\s\t]+)$/,
      names: ['value'],
      format: 'simulcast: %s'
    },
    {
      //a=framerate:25
      //a=framerate:29.97
      name: 'framerate',
      reg: /^framerate:(\d+(?:$|\.\d+))/,
      format: 'framerate:%s'
    },
    { // RFC4570
      //a=source-filter: incl IN IP4 239.5.2.31 10.1.15.5
      name: 'sourceFilter',
      reg: /^source-filter: *(excl|incl) (\S*) (IP4|IP6|\*) (\S*) (.*)/,
      names: ['filterMode', 'netType', 'addressTypes', 'destAddress', 'srcList'],
      format: 'source-filter: %s %s %s %s %s'
    },
    { // any a= that we don't understand is kepts verbatim on media.invalid
      push: 'invalid',
      names: ['value']
    }
  ]
};

// set sensible defaults to avoid polluting the grammar with boring details
Object.keys(grammar).forEach(function (key) {
  var objs = grammar[key];
  objs.forEach(function (obj) {
    if (!obj.reg) {
      obj.reg = /(.*)/;
    }
    if (!obj.format) {
      obj.format = '%s';
    }
  });
});


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* global window, exports, define */

!function() {
    'use strict'

    var re = {
        not_string: /[^s]/,
        not_bool: /[^t]/,
        not_type: /[^T]/,
        not_primitive: /[^v]/,
        number: /[diefg]/,
        numeric_arg: /[bcdiefguxX]/,
        json: /[j]/,
        not_json: /[^j]/,
        text: /^[^\x25]+/,
        modulo: /^\x25{2}/,
        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
        key: /^([a-z_][a-z_\d]*)/i,
        key_access: /^\.([a-z_][a-z_\d]*)/i,
        index_access: /^\[(\d+)\]/,
        sign: /^[+-]/
    }

    function sprintf(key) {
        // `arguments` is not an array, but should be fine for this call
        return sprintf_format(sprintf_parse(key), arguments)
    }

    function vsprintf(fmt, argv) {
        return sprintf.apply(null, [fmt].concat(argv || []))
    }

    function sprintf_format(parse_tree, argv) {
        var cursor = 1, tree_length = parse_tree.length, arg, output = '', i, k, ph, pad, pad_character, pad_length, is_positive, sign
        for (i = 0; i < tree_length; i++) {
            if (typeof parse_tree[i] === 'string') {
                output += parse_tree[i]
            }
            else if (typeof parse_tree[i] === 'object') {
                ph = parse_tree[i] // convenience purposes only
                if (ph.keys) { // keyword argument
                    arg = argv[cursor]
                    for (k = 0; k < ph.keys.length; k++) {
                        if (arg == undefined) {
                            throw new Error(sprintf('[sprintf] Cannot access property "%s" of undefined value "%s"', ph.keys[k], ph.keys[k-1]))
                        }
                        arg = arg[ph.keys[k]]
                    }
                }
                else if (ph.param_no) { // positional argument (explicit)
                    arg = argv[ph.param_no]
                }
                else { // positional argument (implicit)
                    arg = argv[cursor++]
                }

                if (re.not_type.test(ph.type) && re.not_primitive.test(ph.type) && arg instanceof Function) {
                    arg = arg()
                }

                if (re.numeric_arg.test(ph.type) && (typeof arg !== 'number' && isNaN(arg))) {
                    throw new TypeError(sprintf('[sprintf] expecting number but found %T', arg))
                }

                if (re.number.test(ph.type)) {
                    is_positive = arg >= 0
                }

                switch (ph.type) {
                    case 'b':
                        arg = parseInt(arg, 10).toString(2)
                        break
                    case 'c':
                        arg = String.fromCharCode(parseInt(arg, 10))
                        break
                    case 'd':
                    case 'i':
                        arg = parseInt(arg, 10)
                        break
                    case 'j':
                        arg = JSON.stringify(arg, null, ph.width ? parseInt(ph.width) : 0)
                        break
                    case 'e':
                        arg = ph.precision ? parseFloat(arg).toExponential(ph.precision) : parseFloat(arg).toExponential()
                        break
                    case 'f':
                        arg = ph.precision ? parseFloat(arg).toFixed(ph.precision) : parseFloat(arg)
                        break
                    case 'g':
                        arg = ph.precision ? String(Number(arg.toPrecision(ph.precision))) : parseFloat(arg)
                        break
                    case 'o':
                        arg = (parseInt(arg, 10) >>> 0).toString(8)
                        break
                    case 's':
                        arg = String(arg)
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 't':
                        arg = String(!!arg)
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'T':
                        arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase()
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'u':
                        arg = parseInt(arg, 10) >>> 0
                        break
                    case 'v':
                        arg = arg.valueOf()
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'x':
                        arg = (parseInt(arg, 10) >>> 0).toString(16)
                        break
                    case 'X':
                        arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase()
                        break
                }
                if (re.json.test(ph.type)) {
                    output += arg
                }
                else {
                    if (re.number.test(ph.type) && (!is_positive || ph.sign)) {
                        sign = is_positive ? '+' : '-'
                        arg = arg.toString().replace(re.sign, '')
                    }
                    else {
                        sign = ''
                    }
                    pad_character = ph.pad_char ? ph.pad_char === '0' ? '0' : ph.pad_char.charAt(1) : ' '
                    pad_length = ph.width - (sign + arg).length
                    pad = ph.width ? (pad_length > 0 ? pad_character.repeat(pad_length) : '') : ''
                    output += ph.align ? sign + arg + pad : (pad_character === '0' ? sign + pad + arg : pad + sign + arg)
                }
            }
        }
        return output
    }

    var sprintf_cache = Object.create(null)

    function sprintf_parse(fmt) {
        if (sprintf_cache[fmt]) {
            return sprintf_cache[fmt]
        }

        var _fmt = fmt, match, parse_tree = [], arg_names = 0
        while (_fmt) {
            if ((match = re.text.exec(_fmt)) !== null) {
                parse_tree.push(match[0])
            }
            else if ((match = re.modulo.exec(_fmt)) !== null) {
                parse_tree.push('%')
            }
            else if ((match = re.placeholder.exec(_fmt)) !== null) {
                if (match[2]) {
                    arg_names |= 1
                    var field_list = [], replacement_field = match[2], field_match = []
                    if ((field_match = re.key.exec(replacement_field)) !== null) {
                        field_list.push(field_match[1])
                        while ((replacement_field = replacement_field.substring(field_match[0].length)) !== '') {
                            if ((field_match = re.key_access.exec(replacement_field)) !== null) {
                                field_list.push(field_match[1])
                            }
                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) {
                                field_list.push(field_match[1])
                            }
                            else {
                                throw new SyntaxError('[sprintf] failed to parse named argument key')
                            }
                        }
                    }
                    else {
                        throw new SyntaxError('[sprintf] failed to parse named argument key')
                    }
                    match[2] = field_list
                }
                else {
                    arg_names |= 2
                }
                if (arg_names === 3) {
                    throw new Error('[sprintf] mixing positional and named placeholders is not (yet) supported')
                }

                parse_tree.push(
                    {
                        placeholder: match[0],
                        param_no:    match[1],
                        keys:        match[2],
                        sign:        match[3],
                        pad_char:    match[4],
                        align:       match[5],
                        width:       match[6],
                        precision:   match[7],
                        type:        match[8]
                    }
                )
            }
            else {
                throw new SyntaxError('[sprintf] unexpected placeholder')
            }
            _fmt = _fmt.substring(match[0].length)
        }
        return sprintf_cache[fmt] = parse_tree
    }

    /**
     * export to either browser or node.js
     */
    /* eslint-disable quote-props */
    if (true) {
        exports['sprintf'] = sprintf
        exports['vsprintf'] = vsprintf
    }
    if (typeof window !== 'undefined') {
        window['sprintf'] = sprintf
        window['vsprintf'] = vsprintf

        if (true) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
                return {
                    'sprintf': sprintf,
                    'vsprintf': vsprintf
                }
            }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
        }
    }
    /* eslint-enable quote-props */
}(); // eslint-disable-line


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSelf = isSelf;
exports.isModerator = isModerator;
exports.parseParticipantDialString = parseParticipantDialString;
exports.parseParticipantName = parseParticipantName;
exports.callParticipants = callParticipants;
exports.isIVR = isIVR;
exports.isConnected = isConnected;
exports.getConferenceName = getConferenceName;
exports.getFriendlyCallGalaxyState = getFriendlyCallGalaxyState;
exports.galaxyActiveCallUtil = galaxyActiveCallUtil;
exports.galaxyConferenceParticipants = galaxyConferenceParticipants;
exports.galaxyConferenceParticipant = galaxyConferenceParticipant;
exports.galaxyMapSelfParticipant = galaxyMapSelfParticipant;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var c = _interopRequireWildcard(__webpack_require__(3));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _uniqWith = _interopRequireDefault(__webpack_require__(411));

function isSelf(participant) {
  return participant.dialstring === 'contact:self';
}

function isModerator(contact, currentUserId) {
  var contactModeratorId = (0, _safeAccess.default)(contact, 'moderatorID') || (0, _safeAccess.default)(contact, 'moderator.id');
  return !!(currentUserId && (0, _safeAccess.default)(contact, 'isMeeting') && contactModeratorId === currentUserId);
}

function parseParticipantDialString(displayName) {
  // displayname could be of the form 'DisplayName (extension) and extension is optional
  // DisplayName will be the name of the participant and extension the dial string
  // there are a couple of cases wehere we will not have the dialString filled up.
  // 1. When its a guest - we will mark a flag if its guest
  // 2. When its a third party device - we will mark a flag in this case as well. In this case
  //    the displayName we receive sometimes is weird and hence not trying to parse it. Something like
  //    sip:h323:10.10.25.222@184.173.172.130;callmgrtag=oiCq_LEG_201610271648411155;cssconfid=null;csspartid=oiCq_P_01189
  // I have added the isGuest and is3rdParty purely to deal with missing dialString
  var matches = (displayName || '').match(/\((\d*)\)*$/); // return the value inside the last set of parenthesis
  // the first value in the matched set includes parenthesis, the last does not

  return (0, _safeAccess.default)(matches, 'pop()') || '';
}

function parseParticipantName(name) {
  return name ? name.split(' (')[0] : '';
}
/**
 * callParticipants, used for determining users who are in the call in the contact selector
 * strips out self participant, provides very little information
 */


function callParticipants(conference) {
  var conferenceParticipants = (0, _safeAccess.default)(conference, 'participants') || [];
  conferenceParticipants = (0, _uniqWith.default)(conferenceParticipants, function (arrVal, othVal) {
    return arrVal.uuid && arrVal.uuid === othVal.uuid;
  });
  var participants = [];
  conferenceParticipants.forEach(function (participant) {
    if (isSelf(participant)) return; // do not add current user as participant

    if (isIVR(participant)) return; // what are IVR participants?

    if (!isConnected(participant)) return; // do not add participants not yet connected

    participants.push({
      id: participant.id,
      name: parseParticipantName((0, _safeAccess.default)(participant, 'displayName') || (0, _safeAccess.default)(participant, 'dialstring') || ''),
      dialString: parseParticipantDialString((0, _safeAccess.default)(participant, 'displayName')),
      isGuest: !!participant.isGuest
    });
  });
  return participants;
}

function isIVR(participant) {
  return !!(participant && participant.context && participant.context.REPID === c.PARTICIPANT_IVR);
}

function isConnected(participant) {
  return participant.status === c.PARTICIPANT_CONNECTED;
}

function getConferenceName(galaxyConference, participants, remoteContact, localizeWithCode, activeCall) {
  var state = (0, _safeAccess.default)(galaxyConference, 'state');
  var type = (0, _safeAccess.default)(galaxyConference, 'type');

  if (type === c.GALAXY_CONFERENCE_TYPE_ADHOC && (state === c.GALAXY_CONFERENCE_STATE_ESCALATED || participants.length > 2)) {
    return localizeWithCode('conference');
  }

  return (0, _safeAccess.default)(remoteContact, 'name') || (0, _safeAccess.default)(activeCall, 'dialString') || 'default';
}

function getFriendlyCallGalaxyState(hasRemoteStream, activeCall) {
  // calculate client - friendly call state, default to disconnected
  var friendlyState = c.CALL_STATE_DISCONNECTED;
  var state = (0, _safeAccess.default)(activeCall, 'state');
  var reason = (0, _safeAccess.default)(activeCall, 'reason'); // if we're end+answering. stay in connected state

  if ((0, _safeAccess.default)(activeCall, 'isAnsweringGalaxy')) {
    friendlyState = c.CALL_STATE_CONNECTED;
  } // dialing & ringing == calling
  else if (state === c.GALAXY_CALL_STATE_BEGIN || state === c.GALAXY_CALL_STATE_TRYING || state === c.GALAXY_CALL_STATE_CALLING || state === c.GALAXY_CALL_STATE_RINGING || state === c.GALAXY_CALL_STATE_INCOMING) {
      friendlyState = c.CALL_STATE_CALLING;
    } else if (state === c.GALAXY_CALL_STATE_CONNECTED) {
      friendlyState = c.CALL_STATE_CONNECTED;
    } // call is starting to answer
    else if (state === c.GALAXY_CALL_STATE_ANSWERING) {
        friendlyState = c.CALL_STATE_CONNECTING;
      } // call disconnected, but end call not initiated by a client (!ended)
      else if (state === c.GALAXY_CALL_STATE_DISCONNECTED && (reason !== c.GALAXY_REASON_DEFAULT || reason !== c.GALAXY_REASON_HANGUP)) {
          if ([c.GALAXY_REASON_BAD_INITIAL_DIAL_STATE, c.GALAXY_REASON_NETWORK_ERROR, c.GALAXY_REASON_BUSY, c.GALAXY_REASON_REJECTED, c.GALAXY_REASON_NO_ANSWER, c.GALAXY_REASON_TIMED_OUT, c.GALAXY_REASON_SERVER_ERROR, c.GALAXY_REASON_WAMP_DISCONNECTED, c.GALAXY_REASON_UNREACHABLE, c.GALAXY_REASON_USER_NOT_FOUND, c.GALAXY_REASON_NO_MEDIA].indexOf(reason) > -1) {
            friendlyState = c.CALL_STATE_FAILED;
          }
        }

  return friendlyState;
}

var getRemoteContact = function getRemoteContact(reducerContact, callContact) {
  if (reducerContact) return reducerContact;
  if (callContact && typeof callContact !== 'string') return callContact;
  return undefined;
};

function galaxyActiveCallUtil(activeCall, galaxyConference, galaxyParticipants, invited, contactByUuidFinder, contactFinder, rtc, presentation, currentUser, nucleusMedia, accountSettings, locale, recording, isCurrentUserModerator) {
  var friendlyState = getFriendlyCallGalaxyState(nucleusMedia.hasRemoteStream, activeCall);
  var remoteContact = getRemoteContact(contactFinder((0, _safeAccess.default)(activeCall, 'dialString')), (0, _safeAccess.default)(activeCall, 'contact'));
  var presentationState = (0, _safeAccess.default)(presentation, 'state');
  var awaitingPresentationAnswer = (0, _safeAccess.default)(presentation, 'isAwaitingAnswer') || (0, _safeAccess.default)(presentation, 'isRequestingToken');
  var isPresenting = !awaitingPresentationAnswer && presentationState === c.GALAXY_PRESENTATION_STATE_TX_STARTING || presentationState === c.GALAXY_PRESENTATION_STATE_TX_STARTED;
  var hasIncomingPresentation = presentationState === c.GALAXY_PRESENTATION_STATE_RX_STARTING || presentationState === c.GALAXY_PRESENTATION_STATE_RX_STARTED; // TODO: remove this mapping when galaxy conference notifications are complete
  // the service should eventually return all necessary information, and activeCallSelector should be broken up to not include participants.

  var participants = galaxyConferenceParticipants(galaxyParticipants, contactByUuidFinder, currentUser, remoteContact, isPresenting, nucleusMedia);
  var canPresent = (0, _safeAccess.default)(activeCall, 'state') === c.GALAXY_CALL_STATE_CONNECTED && (0, _safeAccess.default)(presentation, 'state') === c.GALAXY_PRESENTATION_STATE_STOPPED;
  var currentUserId = (0, _safeAccess.default)(currentUser, 'userUuid');
  var selfParticipant = participants.find(function (p) {
    return (0, _safeAccess.default)(p, 'uuid') === currentUserId;
  });
  var invitees = [];
  var failedInvitees = [];
  var invitedRecord = Object.assign({}, invited); // if invitee was just a dialString, try to find their contact

  if (!(0, _safeAccess.default)(invited, 'id')) {
    var invitedContact = contactFinder((0, _safeAccess.default)(invited, 'dialString'));

    if (invitedContact) {
      // merge their contact record with the invited record (to maintain state)
      invitedRecord = Object.assign({}, invitedContact, invited);
    }
  } // failed state invitees go in one array


  if (invited.state === c.GALAXY_INVITEE_STATE_FAILED) {
    failedInvitees.push(invitedRecord);
  } // invitees not yet connected go in the invitees array
  // connected invitees are left out
  else if (invited.state && invited.state !== c.GALAXY_INVITEE_STATE_CONNECTED) {
      invitees.push(invitedRecord);
    } // override friendly call state when end and answering


  if ((0, _safeAccess.default)(activeCall, 'isAnsweringLegacy') || (0, _safeAccess.default)(activeCall, 'isMigrating')) {
    friendlyState = c.CALL_STATE_CONNECTED;
  }

  var canMuteAll = isCurrentUserModerator && (0, _safeAccess.default)(galaxyConference, 'state') === c.GALAXY_CONFERENCE_STATE_ESCALATED;
  var currentMcuLayout = (0, _safeAccess.default)(activeCall, 'currentMcuLayout');
  var name = getConferenceName(galaxyConference, participants, remoteContact, locale, activeCall);
  var isRecording = recording.state === c.GALAXY_RECORDING_STATE_STARTED;
  var recorder = (0, _safeAccess.default)(recording, 'startedBy');
  if (recorder) recorder.name = (0, _safeAccess.default)(recorder, 'displayName'); // polyfill for legacy

  if ((0, _safeAccess.default)(recorder, 'uuid') === (0, _safeAccess.default)(selfParticipant, 'uuid')) {
    recorder = selfParticipant;
  }

  var recordingEnabled = (0, _safeAccess.default)(accountSettings, 'recordingEnabled'); // user can stop recording if they started the recording, or are the owner of the recording

  var canStopRecording = isRecording && ((0, _safeAccess.default)(recording, 'owner.uuid') === (0, _safeAccess.default)(selfParticipant, 'uuid') || (0, _safeAccess.default)(recorder, 'isSelf'));
  var remoteCameraCapabilities = (0, _safeAccess.default)(activeCall, 'remoteCameraCapabilities');
  return {
    id: activeCall.callId,
    conferenceId: activeCall.conferenceId,
    isIncomingCall: (0, _safeAccess.default)(activeCall, 'isIncomingCall'),
    isModerator: isCurrentUserModerator,
    participants: participants,
    isEscalating: activeCall.isEscalating,
    isMigrating: activeCall.isMigrating,
    invitees: invitees,
    failedInvitees: failedInvitees,
    state: friendlyState,
    dialString: (0, _safeAccess.default)(activeCall, 'dialString'),
    remoteContact: remoteContact,
    hasIvr: false,
    callFullyConnected: friendlyState === c.CALL_STATE_CONNECTED,
    mediaProcessingInProgress: rtc.mediaProcessingInProgress,
    isMeeting: (0, _safeAccess.default)(galaxyConference, 'type') !== c.GALAXY_CONFERENCE_TYPE_ADHOC,
    name: name,
    wasKicked: false,
    startTime: activeCall.startTime,
    // TODO: localize?
    endTime: activeCall.endTime,
    // TODO: localize?
    reason: (0, _safeAccess.default)(activeCall, 'reason'),
    isManualDial: false,
    // ensure we only report true when we have an active call
    canPresent: canPresent,
    isPresenting: isPresenting,
    isAudioMuted: !!nucleusMedia.isAudioMuted || !nucleusMedia.hasOutgoingAudio,
    isVideoMuted: !!nucleusMedia.isVideoMuted || !nucleusMedia.hasOutgoingVideo,
    isWaitingForPin: activeCall.pinRequested,
    isSendingPin: false,
    //!!activeCall.isSendingPin,
    invalidPin: false,
    //!!activeCall.invalidPin,
    isMutedByServer: !!(0, _safeAccess.default)(selfParticipant, 'serverMuteState'),
    muteAll: (0, _safeAccess.default)(galaxyConference, 'serverMuteState'),
    canMuteAll: canMuteAll,
    isRecording: isRecording || !!activeCall.startRecordingOnMigration,
    canRecord: recordingEnabled && friendlyState === c.CALL_STATE_CONNECTED && !(0, _safeAccess.default)(selfParticipant, 'guest'),
    canStopRecording: canStopRecording,
    recorder: recorder,
    recordingEnabled: recordingEnabled,
    remoteCameraCapabilities: remoteCameraCapabilities,
    canAddParticipants: true,
    isWebConferencing: activeCall.isWebConferencing,
    hasIncomingVideo: !!nucleusMedia.hasRemoteStream,
    hasOutgoingVideo: !!nucleusMedia.hasOutgoingVideo,
    hasOutgoingAudio: !!nucleusMedia.hasOutgoingAudio,
    hasIncomingPresentation: hasIncomingPresentation,
    // TODO: consolidate with isPresenting
    hasOutgoingPresentation: isPresenting,
    presentationSourceId: (0, _safeAccess.default)(presentation, 'presentationSourceId'),
    presentationSourceName: (0, _safeAccess.default)(presentation, 'presentationSourceName'),
    isGalaxyCall: true,
    isRedirectingToLegacy: (0, _safeAccess.default)(activeCall, 'isRedirectingToLegacy'),
    currentMcuLayout: currentMcuLayout
  };
} // Super temporary hack here. Galaxy conference manager is going to render this insanity moot.


function galaxyConferenceParticipants() {
  var galaxyParticipants = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var contactByUuidFinder = arguments.length > 1 ? arguments[1] : undefined;
  var currentUser = arguments.length > 2 ? arguments[2] : undefined;
  var remoteContact = arguments.length > 3 ? arguments[3] : undefined;
  var isPresenting = arguments.length > 4 ? arguments[4] : undefined;
  var nucleusMedia = arguments.length > 5 ? arguments[5] : undefined;
  var participants = [];
  var currentUserId = (0, _safeAccess.default)(currentUser, 'userUuid'); // handle no galaxy conference notifications
  // TODO: remove

  if (!galaxyParticipants.length) {
    if (currentUser) participants.push(galaxyMapSelfParticipant({}, currentUser, nucleusMedia, isPresenting));
    if (remoteContact && !(0, _safeAccess.default)(remoteContact, 'isMeeting')) participants.push(galaxyConferenceParticipant({}, remoteContact));
    return participants;
  }

  galaxyParticipants.forEach(function (p) {
    if ((0, _safeAccess.default)(p, 'uuid') === currentUserId) {
      participants.unshift(galaxyMapSelfParticipant(p, currentUser, nucleusMedia, isPresenting));
    } else if ((0, _safeAccess.default)(p, 'uuid') === (0, _safeAccess.default)(remoteContact, 'uuid')) {
      participants.push(galaxyConferenceParticipant(p, remoteContact));
    } else {
      var contact = contactByUuidFinder((0, _safeAccess.default)(p, 'uuid'));
      participants.push(galaxyConferenceParticipant(p, contact || p));
    }
  });
  participants = (0, _uniqWith.default)(participants, function (arrVal, othVal) {
    return arrVal.uuid && arrVal.uuid === othVal.uuid;
  });
  return participants;
}

function galaxyConferenceParticipant(participant, contact) {
  var contactUuid = (0, _safeAccess.default)(contact, 'uuid');
  return (0, _objectSpread2.default)({}, participant, {
    id: (0, _safeAccess.default)(contact, 'id') || contactUuid,
    uuid: contactUuid,
    name: (0, _safeAccess.default)(contact, 'name'),
    isSelf: false,
    contact: contact,
    isAudioMuted: !!((0, _safeAccess.default)(participant, 'localMuteState') || (0, _safeAccess.default)(participant, 'serverMuteState')),
    isVideoMuted: false,
    isMutedByServer: !!(0, _safeAccess.default)(participant, 'serverMuteState'),
    timeConnected: '',
    // TODO: localize?
    dialString: (0, _safeAccess.default)(contact, 'dialString') || 'default',
    isRecorder: false,
    //!!isRecorder,
    canStopPresentation: (0, _safeAccess.default)(participant, 'isPresenting'),
    isGuest: !!(0, _safeAccess.default)(participant, 'guest'),
    is3rdParty: false,
    isAudioOnly: false
  });
}

function galaxyMapSelfParticipant(participant, currentUser, nucleusMedia, isPresenting) {
  return (0, _objectSpread2.default)({}, participant, {
    id: currentUser.id,
    uuid: currentUser.userUuid,
    name: (0, _safeAccess.default)(currentUser, 'name') || 'guest',
    isSelf: true,
    contact: null,
    // arbitrary decision: don't add self participant myInfo here
    isAudioMuted: !!nucleusMedia.isAudioMuted,
    isVideoMuted: !!nucleusMedia.isVideoMuted,
    isMutedByServer: !!(0, _safeAccess.default)(participant, 'serverMuteState'),
    timeConnected: '',
    // TODO: localize?
    dialString: currentUser.dialString,
    isRecorder: false,
    isPresenting: isPresenting,
    canStopPresentation: isPresenting,
    // TODO: this will become a new property in the coference notification from CSS
    isGuest: !!(0, _safeAccess.default)(participant, 'guest'),
    is3rdParty: false,
    isAudioOnly: false
  });
}

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(222),
    arrayIncludes = __webpack_require__(412),
    arrayIncludesWith = __webpack_require__(416),
    cacheHas = __webpack_require__(223),
    createSet = __webpack_require__(417),
    setToArray = __webpack_require__(183);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 238 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var createAggregator = __webpack_require__(422);

/**
 * Creates an array of elements split into two groups, the first of which
 * contains elements `predicate` returns truthy for, the second of which
 * contains elements `predicate` returns falsey for. The predicate is
 * invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of grouped elements.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': false },
 *   { 'user': 'fred',    'age': 40, 'active': true },
 *   { 'user': 'pebbles', 'age': 1,  'active': false }
 * ];
 *
 * _.partition(users, function(o) { return o.active; });
 * // => objects for [['fred'], ['barney', 'pebbles']]
 *
 * // The `_.matches` iteratee shorthand.
 * _.partition(users, { 'age': 1, 'active': false });
 * // => objects for [['pebbles'], ['barney', 'fred']]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.partition(users, ['active', false]);
 * // => objects for [['barney', 'pebbles'], ['fred']]
 *
 * // The `_.property` iteratee shorthand.
 * _.partition(users, 'active');
 * // => objects for [['fred'], ['barney', 'pebbles']]
 */
var partition = createAggregator(function(result, value, key) {
  result[key ? 0 : 1].push(value);
}, function() { return [[], []]; });

module.exports = partition;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(241),
    createBaseEach = __webpack_require__(427);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(425),
    keys = __webpack_require__(102);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pstnNumbersWithCountryName = exports.pstnNumbers = void 0;

var _get2 = _interopRequireDefault(__webpack_require__(11));

var _reselect = __webpack_require__(23);

var _localization = __webpack_require__(125);

var _pstnNumbers = __webpack_require__(245);

/** @module selectors/pstnNumbers */
var pstnNumbers = function pstnNumbers(state) {
  return (0, _get2.default)(state, 'nucleus.pstnNumbers', []);
};

exports.pstnNumbers = pstnNumbers;
var pstnNumbersWithCountryName = (0, _reselect.createSelector)(pstnNumbers, _localization.localeCode, function (pstnNumbers, localeCode) {
  return (0, _pstnNumbers.addCountryNames)(pstnNumbers, localeCode);
});
exports.pstnNumbersWithCountryName = pstnNumbersWithCountryName;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var localization_1 = __webpack_require__(430);
exports.Localization = localization_1.default;
var localization_2 = __webpack_require__(189);
exports.localizationConstants = localization_2.default;
var localization_3 = __webpack_require__(244);
exports.localizationUtils = localization_3.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(82);
var localization_1 = __webpack_require__(189);
exports.getCookieCompliance = function (id) {
    return lodash_1.get(localization_1.complianceLinks, id + ".cookie") || localization_1.complianceLinks[localization_1.defaultLanguageId].cookie;
};
exports.getHelpPage = function (id) {
    return lodash_1.get(localization_1.complianceLinks, id + ".help") || localization_1.complianceLinks[localization_1.defaultLanguageId].help;
};
exports.getHelpPageGuest = function (id) {
    return lodash_1.get(localization_1.complianceLinks, id + ".helpGuest") || localization_1.complianceLinks[localization_1.defaultLanguageId].helpGuest;
};
exports.getLanguage = function (id) {
    return lodash_1.get(exports.getLanguageObj(id), 'language');
};
exports.getLanguageDisplayName = function (id) {
    return lodash_1.get(exports.getLanguageObj(id), 'displayName');
};
exports.getLanguageId = function (code, approvedLanguages) {
    if (code === void 0) { code = ''; }
    var lcCode = code.toLowerCase().replace('_', '-');
    var language = lcCode.split('-')[0];
    var languages = approvedLanguages || localization_1.supportedLanguages;
    var supportedLanguage = lodash_1.find(languages, function (languageObj) {
        return (languageObj.id.toLowerCase() === lcCode) || (languageObj.aliases && languageObj.aliases.includes(lcCode));
    });
    return lodash_1.get(supportedLanguage, 'id')
        || lodash_1.get(lodash_1.find(languages, ['language', language]), 'id')
        || localization_1.defaultLanguageId;
};
exports.getLanguageIdForPlatform = function (id, platform) {
    return lodash_1.get(exports.getLanguageObj(id), "platform['" + platform + "']") || id;
};
exports.getLanguageObj = function (id) {
    return lodash_1.find(localization_1.supportedLanguages, ['id', id]);
};
exports.getLanguageOptions = function () {
    return lodash_1.sortBy(localization_1.supportedLanguages.map(function (language) { return lodash_1.pick(language, ['id', 'displayName']); }), ['displayName']);
};
exports.getLegacyLanguageId = function (id) {
    if (id === void 0) { id = ''; }
    var language = id.split('-')[0] || exports.getLanguage(localization_1.defaultLanguageId) || localization_1.defaultLanguageId.split('-')[0];
    return (language === 'zh') ? id : language;
};
exports.getPrivacyPolicy = function (id) {
    return lodash_1.get(localization_1.complianceLinks, id + ".privacy") || localization_1.complianceLinks[localization_1.defaultLanguageId].privacy;
};
exports.getTermsOfService = function (id) {
    return lodash_1.get(localization_1.complianceLinks, id + ".tos") || localization_1.complianceLinks[localization_1.defaultLanguageId].tos;
};
exports.default = {
    getCookieCompliance: exports.getCookieCompliance,
    getHelpPage: exports.getHelpPage,
    getHelpPageGuest: exports.getHelpPageGuest,
    getLanguage: exports.getLanguage,
    getLanguageDisplayName: exports.getLanguageDisplayName,
    getLanguageId: exports.getLanguageId,
    getLanguageIdForPlatform: exports.getLanguageIdForPlatform,
    getLanguageObj: exports.getLanguageObj,
    getLanguageOptions: exports.getLanguageOptions,
    getLegacyLanguageId: exports.getLegacyLanguageId,
    getPrivacyPolicy: exports.getPrivacyPolicy,
    getTermsOfService: exports.getTermsOfService
};
//# sourceMappingURL=localization.js.map

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addCountryNames = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _get = _interopRequireDefault(__webpack_require__(11));

var _localize = _interopRequireDefault(__webpack_require__(190));

var addCountryNames = function addCountryNames(numbers, localeCode) {
  var length = (0, _get.default)(numbers, 'length', 0);
  if (length === 0) return numbers;
  return numbers.map(function (n) {
    return (0, _objectSpread2.default)({}, n, {
      countryName: (0, _localize.default)(localeCode, n.countryCode)
    });
  });
};

exports.addCountryNames = addCountryNames;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectRemoteModeratorsMap = selectRemoteModeratorsMap;
exports.selectRemoteModeratorList = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _get = _interopRequireDefault(__webpack_require__(11));

var _reselect = __webpack_require__(23);

var selectRemoteModeratorList = (0, _reselect.createSelector)(selectRemoteModeratorsMap, selectRemoteModeratorsFromMap);
exports.selectRemoteModeratorList = selectRemoteModeratorList;

function selectRemoteModeratorsMap(state) {
  return (0, _get.default)(state, 'nucleus.conference.remoteModerators');
}

function selectRemoteModeratorsFromMap(map) {
  var remoteModerators = [];

  if (map) {
    Map.prototype.forEach.call(map, function (remoteModerator) {
      remoteModerators.push((0, _objectSpread2.default)({}, remoteModerator, {
        isRemoteModerator: true
      }));
    });
  }

  return remoteModerators;
}

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(58),
    now = __webpack_require__(450),
    toNumber = __webpack_require__(248);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(58),
    isSymbol = __webpack_require__(120);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallHistoryFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallHistory"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"UUID"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"remoteParty"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contact"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallableFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MeetingFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"remoteIsGuest"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"direction"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"durationSeconds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"callStartTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"callEndTime"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":341}};
    doc.loc.source = {"body":"#import \"./callable-fragments.gql\"\n#import \"./meeting-fragments.gql\"\n#import \"./user-fragments.gql\"\n\nfragment CallHistoryFields on CallHistory {\n  id: UUID\n  remoteParty\n  contact {\n    ...IdFields\n    ...UserFields\n    ...CallableFields\n    ...MeetingFields\n  }\n  remoteIsGuest\n  direction\n  durationSeconds\n  callStartTime\n  callEndTime\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(38).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(54).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(250).definitions));


      module.exports = doc;
    


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallableFields"},"directives":[]}]}}],"loc":{"start":0,"end":102}};
    doc.loc.source = {"body":"#import \"./callable-fragments.gql\"\n\nfragment UserFields on User {\n  ...IdFields\n  ...CallableFields\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(38).definitions));


      module.exports = doc;
    


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCallCameraCapabilities = getCallCameraCapabilities;

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var c = _interopRequireWildcard(__webpack_require__(3));

function getCallCameraCapabilities(state) {
  var featureFlags = (0, _safeAccess.default)(state, 'nucleus.featureFlags');
  var feccEnabled = (0, _safeAccess.default)(featureFlags, c.FEATUREFLAG_ENABLE_FECC);
  if (!feccEnabled) return null;
  return (0, _safeAccess.default)(state, 'nucleus.device.cameraCapabilities');
}

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCallHistory = getCallHistory;
exports.callHistoryDeleteOne = callHistoryDeleteOne;
exports.callHistoryDelete = callHistoryDelete;
exports.callHistoryDeleteAll = callHistoryDeleteAll;
exports.callHistoryBatchDelete = callHistoryBatchDelete;
exports.callHistoryAddExternalEntry = callHistoryAddExternalEntry;
exports.initialize = initialize;
exports.markCallHistoryAsViewed = exports.updateCallHistoryLastViewed = exports.gqlRefreshCallHistory = exports.callHistoryQuery = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _taggedTemplateLiteral2 = _interopRequireDefault(__webpack_require__(253));

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _callHistoryUtils = __webpack_require__(126);

var _graphqlTag = _interopRequireDefault(__webpack_require__(254));

var _proxy = __webpack_require__(21);

var _directory = __webpack_require__(84);

var c = _interopRequireWildcard(__webpack_require__(3));

var _callHistory = __webpack_require__(263);

var _currentUser = __webpack_require__(37);

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n        mutation setCallHistoryLastViewed($UUID: UUID!, $now: DateTime!) {\n          updateUser(user: { uuid: $UUID, callHistoryLastReadAt: $now }) {\n            UUID\n            missedCalls: callHistory(viewed: false, callDirectionTypes: MISSED) {\n              total: totalRecordCount\n            }\n          }\n        }\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  query webCallHistory {\n    me {\n      UUID\n      missedCalls: callHistory(callDirectionTypes: MISSED, viewed: false) {\n        total: totalRecordCount\n      }\n      callHistory {\n        __typename\n        records {\n          __typename\n          UUID\n          callStartTime\n          hasBeenViewed\n          remoteParty: remotePartyCallable {\n            __typename\n            ... on Record {\n              UUID\n            }\n            type: __typename\n            displayName\n            isCurrentlyCallable\n            ... on User {\n              isChattable\n            }\n            ... on Meeting {\n              isChattable\n            }\n          }\n          direction\n          durationSeconds\n        }\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var callHistoryQuery = (0, _graphqlTag.default)(_templateObject());
exports.callHistoryQuery = callHistoryQuery;

var gqlRefreshCallHistory = function gqlRefreshCallHistory() {
  return {
    type: c.GQL_QUERY,
    payload: {
      query: callHistoryQuery,
      fetchPolicy: 'network-only'
    }
  };
};

exports.gqlRefreshCallHistory = gqlRefreshCallHistory;

var updateCallHistoryLastViewed = function updateCallHistoryLastViewed() {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch, getState) {
        var _myInfo, userUUID;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _myInfo = (0, _currentUser.myInfo)(getState()), userUUID = _myInfo.userUUID;
                return _context.abrupt("return", dispatch({
                  type: c.GQL_MUTATION,
                  payload: {
                    mutation: (0, _graphqlTag.default)(_templateObject2()),
                    variables: {
                      UUID: userUUID,
                      now: new Date()
                    }
                  }
                }));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};
/** @module actions/callHistory */

/**
 * load call history
 */


exports.updateCallHistoryLastViewed = updateCallHistoryLastViewed;

function getCallHistory() {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch, getState) {
        var state, userUuid, result, records;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                state = getState();
                userUuid = (0, _safeAccess.default)(state, 'nucleus.userProfile.uuid');

                if (userUuid) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                dispatch({
                  type: c.CALLHISTORY_LOAD_BEGIN,
                  payload: userUuid
                });
                _context2.prev = 5;
                _context2.next = 8;
                return dispatch((0, _proxy.proxyApiCall)(c.CALLHISTORY_RPC_ENDPOINT, "".concat(c.CALLHISTORY_URL_SUFFIX, "/").concat(userUuid), 'GET'));

              case 8:
                result = _context2.sent;
                records = (0, _safeAccess.default)(JSON.parse(result), 'results') || [];
                dispatch({
                  type: c.CALLHISTORY_LOAD_SUCCESS,
                  payload: records.map(_callHistoryUtils.mapCallHistoryRecord)
                });
                return _context2.abrupt("return", records);

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](5);
                dispatch({
                  type: c.CALLHISTORY_LOAD_FAILURE,
                  payload: _context2.t0
                });
                throw _context2.t0;

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[5, 14]]);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}
/**
 * mark all call history recent records as "viewed" (new == false)
 */


var markCallHistoryAsViewed = function markCallHistoryAsViewed() {
  return function (dispatch) {
    dispatch({
      type: c.CALL_HISTORY_VIEWED
    }); // I'm commenting this call for now as it is causing self to be added to the contact records in the redux store.
    // Need to revisit when implementing reading/writing call history viewed.
    // dispatch(updateCallHistoryLastViewed());
  };
};

exports.markCallHistoryAsViewed = markCallHistoryAsViewed;

function callHistoryDeleteOne(userUuid, id) {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(dispatch) {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                dispatch({
                  type: c.CALLHISTORY_DELETE_BEGIN
                });
                _context3.next = 4;
                return dispatch((0, _proxy.proxyApiCall)(c.CALLHISTORY_RPC_ENDPOINT, "".concat(c.CALLHISTORY_URL_SUFFIX, "/").concat(userUuid, "/").concat(id), 'DELETE'));

              case 4:
                dispatch({
                  type: c.CALLHISTORY_DELETE_SUCCESS,
                  payload: id
                });
                _context3.next = 11;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                dispatch({
                  type: c.CALLHISTORY_DELETE_FAILURE,
                  payload: _context3.t0
                });
                throw _context3.t0;

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 7]]);
      }));

      return function (_x5) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
}
/**
 * delete call history record by id or ids
 * @param {mixed} param - param could either be a string id that identifies the recent record or a call history group object. if id is a string it will delete a single record and if its a group object will delete the entire group of records
 */


function callHistoryDelete(param) {
  return (
    /*#__PURE__*/
    function () {
      var _ref4 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(dispatch, getState) {
        var state, userUuid, recents, singleId;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                state = getState();
                userUuid = (0, _safeAccess.default)(state, 'nucleus.userProfile.uuid');

                if (userUuid) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt("return");

              case 4:
                recents = (0, _safeAccess.default)(param, 'recents') || [];

                if (!recents.length) {
                  _context4.next = 7;
                  break;
                }

                return _context4.abrupt("return", dispatch(callHistoryBatchDelete(recents, userUuid)));

              case 7:
                singleId = typeof param === 'string' ? param : (0, _safeAccess.default)(param, 'id');

                if (!singleId) {
                  _context4.next = 10;
                  break;
                }

                return _context4.abrupt("return", dispatch(callHistoryDeleteOne(userUuid, singleId)));

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x6, _x7) {
        return _ref4.apply(this, arguments);
      };
    }()
  );
}
/**
 * delete all call history recordings
 */


function callHistoryDeleteAll() {
  return (
    /*#__PURE__*/
    function () {
      var _ref5 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(dispatch, getState) {
        var state, userUuid;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                state = getState();
                userUuid = (0, _safeAccess.default)(state, 'nucleus.userProfile.uuid');

                if (userUuid) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt("return");

              case 4:
                dispatch({
                  type: c.CALLHISTORY_DELETEALL_BEGIN,
                  payload: userUuid
                });
                _context5.prev = 5;
                _context5.next = 8;
                return dispatch((0, _proxy.proxyApiCall)(c.CALLHISTORY_RPC_ENDPOINT, "".concat(c.CALLHISTORY_URL_SUFFIX, "/").concat(userUuid), 'DELETE'));

              case 8:
                dispatch({
                  type: c.CALLHISTORY_DELETEALL_SUCCESS
                });
                _context5.next = 15;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5["catch"](5);
                dispatch({
                  type: c.CALLHISTORY_DELETEALL_FAILURE,
                  payload: _context5.t0
                });
                throw _context5.t0;

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[5, 11]]);
      }));

      return function (_x8, _x9) {
        return _ref5.apply(this, arguments);
      };
    }()
  );
}
/**
 * delete a call history item group
 */


function callHistoryBatchDelete(recents, userUuid) {
  return (
    /*#__PURE__*/
    function () {
      var _ref6 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(dispatch) {
        var promises;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                dispatch({
                  type: c.CALL_HISTORY_BATCH_DELETE_BEGIN
                });
                promises = recents.map(function (r) {
                  return dispatch(callHistoryDeleteOne(userUuid, r.id));
                });
                _context6.next = 5;
                return Promise.all(promises);

              case 5:
                dispatch({
                  type: c.CALL_HISTORY_BATCH_DELETE_SUCCESS
                });
                _context6.next = 11;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6["catch"](0);
                dispatch({
                  type: c.CALL_HISTORY_BATCH_DELETE_FAILED,
                  payload: _context6.t0
                });

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[0, 8]]);
      }));

      return function (_x10) {
        return _ref6.apply(this, arguments);
      };
    }()
  );
}

function callHistoryAddExternalEntry(payload) {
  return (
    /*#__PURE__*/
    function () {
      var _ref7 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(dispatch, getState) {
        var state, userUuid, groupUUID, inputParams, response, _JSON$parse, returnStatus, results;

        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                state = getState();
                userUuid = (0, _safeAccess.default)(state, 'nucleus.userProfile.uuid');

                if (userUuid) {
                  _context7.next = 4;
                  break;
                }

                return _context7.abrupt("return");

              case 4:
                _context7.prev = 4;
                dispatch({
                  type: c.CALLHISTORY_ADD_EXTERNAL_ENTRY_REQUEST
                });
                groupUUID = (0, _safeAccess.default)(state, 'nucleus.userProfile.groupUuid');
                inputParams = (0, _objectSpread2.default)({}, payload, {
                  groupUUID: groupUUID
                });
                _context7.next = 10;
                return dispatch((0, _proxy.proxyApiCall)(c.CALLHISTORY_RPC_ENDPOINT, "".concat(c.CALLHISTORY_URL_SUFFIX, "/").concat(userUuid), 'POST', inputParams));

              case 10:
                response = _context7.sent;
                _JSON$parse = JSON.parse(response), returnStatus = _JSON$parse.returnStatus, results = _JSON$parse.results;

                if (returnStatus) {
                  dispatch({
                    type: c.CALLHISTORY_ADD_EXTERNAL_ENTRY_SUCCESS,
                    payload: results
                  });
                } else {
                  dispatch({
                    type: c.CALLHISTORY_ADD_EXTERNAL_ENTRY_FAILURE,
                    payload: response
                  });
                }

                _context7.next = 18;
                break;

              case 15:
                _context7.prev = 15;
                _context7.t0 = _context7["catch"](4);
                dispatch({
                  type: c.CALLHISTORY_ADD_EXTERNAL_ENTRY_FAILURE,
                  payload: _context7.t0
                });

              case 18:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[4, 15]]);
      }));

      return function (_x11, _x12) {
        return _ref7.apply(this, arguments);
      };
    }()
  );
}

function initialize() {
  return (
    /*#__PURE__*/
    function () {
      var _ref8 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee8(dispatch, getState) {
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if ((0, _callHistory.selectCallHistoryEnabled)(getState())) {
                  _context8.next = 3;
                  break;
                }

                _jsLogger.default.info('call history: disabled. skipping subscription.');

                return _context8.abrupt("return");

              case 3:
                _context8.prev = 3;
                _context8.next = 6;
                return dispatch((0, _directory.getMe)());

              case 6:
                _context8.next = 8;
                return dispatch((0, _proxy.subscribe)(c.CALLHISTORY_TOPIC));

              case 8:
                _context8.next = 13;
                break;

              case 10:
                _context8.prev = 10;
                _context8.t0 = _context8["catch"](3);

                _jsLogger.default.warn('call history: load/subscription failed.', _context8.t0);

              case 13:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[3, 10]]);
      }));

      return function (_x13, _x14) {
        return _ref8.apply(this, arguments);
      };
    }()
  );
}

/***/ }),
/* 253 */
/***/ (function(module, exports) {

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

module.exports = _taggedTemplateLiteral;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var parser = __webpack_require__(462);

var parse = parser.parse;

// Strip insignificant whitespace
// Note that this could do a lot more, such as reorder fields etc.
function normalize(string) {
  return string.replace(/[\s,]+/g, ' ').trim();
}

// A map docString -> graphql document
var docCache = {};

// A map fragmentName -> [normalized source]
var fragmentSourceMap = {};

function cacheKeyFromLoc(loc) {
  return normalize(loc.source.body.substring(loc.start, loc.end));
}

// For testing.
function resetCaches() {
  docCache = {};
  fragmentSourceMap = {};
}

// Take a unstripped parsed document (query/mutation or even fragment), and
// check all fragment definitions, checking for name->source uniqueness.
// We also want to make sure only unique fragments exist in the document.
var printFragmentWarnings = true;
function processFragments(ast) {
  var astFragmentMap = {};
  var definitions = [];

  for (var i = 0; i < ast.definitions.length; i++) {
    var fragmentDefinition = ast.definitions[i];

    if (fragmentDefinition.kind === 'FragmentDefinition') {
      var fragmentName = fragmentDefinition.name.value;
      var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);

      // We know something about this fragment
      if (fragmentSourceMap.hasOwnProperty(fragmentName) && !fragmentSourceMap[fragmentName][sourceKey]) {

        // this is a problem because the app developer is trying to register another fragment with
        // the same name as one previously registered. So, we tell them about it.
        if (printFragmentWarnings) {
          console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
            + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
            + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
        }

        fragmentSourceMap[fragmentName][sourceKey] = true;

      } else if (!fragmentSourceMap.hasOwnProperty(fragmentName)) {
        fragmentSourceMap[fragmentName] = {};
        fragmentSourceMap[fragmentName][sourceKey] = true;
      }

      if (!astFragmentMap[sourceKey]) {
        astFragmentMap[sourceKey] = true;
        definitions.push(fragmentDefinition);
      }
    } else {
      definitions.push(fragmentDefinition);
    }
  }

  ast.definitions = definitions;
  return ast;
}

function disableFragmentWarnings() {
  printFragmentWarnings = false;
}

function stripLoc(doc, removeLocAtThisLevel) {
  var docType = Object.prototype.toString.call(doc);

  if (docType === '[object Array]') {
    return doc.map(function (d) {
      return stripLoc(d, removeLocAtThisLevel);
    });
  }

  if (docType !== '[object Object]') {
    throw new Error('Unexpected input.');
  }

  // We don't want to remove the root loc field so we can use it
  // for fragment substitution (see below)
  if (removeLocAtThisLevel && doc.loc) {
    delete doc.loc;
  }

  // https://github.com/apollographql/graphql-tag/issues/40
  if (doc.loc) {
    delete doc.loc.startToken;
    delete doc.loc.endToken;
  }

  var keys = Object.keys(doc);
  var key;
  var value;
  var valueType;

  for (key in keys) {
    if (keys.hasOwnProperty(key)) {
      value = doc[keys[key]];
      valueType = Object.prototype.toString.call(value);

      if (valueType === '[object Object]' || valueType === '[object Array]') {
        doc[keys[key]] = stripLoc(value, true);
      }
    }
  }

  return doc;
}

var experimentalFragmentVariables = false;
function parseDocument(doc) {
  var cacheKey = normalize(doc);

  if (docCache[cacheKey]) {
    return docCache[cacheKey];
  }

  var parsed = parse(doc, { experimentalFragmentVariables: experimentalFragmentVariables });
  if (!parsed || parsed.kind !== 'Document') {
    throw new Error('Not a valid GraphQL document.');
  }

  // check that all "new" fragments inside the documents are consistent with
  // existing fragments of the same name
  parsed = processFragments(parsed);
  parsed = stripLoc(parsed, false);
  docCache[cacheKey] = parsed;

  return parsed;
}

function enableExperimentalFragmentVariables() {
  experimentalFragmentVariables = true;
}

function disableExperimentalFragmentVariables() {
  experimentalFragmentVariables = false;
}

// XXX This should eventually disallow arbitrary string interpolation, like Relay does
function gql(/* arguments */) {
  var args = Array.prototype.slice.call(arguments);

  var literals = args[0];

  // We always get literals[0] and then matching post literals for each arg given
  var result = (typeof(literals) === "string") ? literals : literals[0];

  for (var i = 1; i < args.length; i++) {
    if (args[i] && args[i].kind && args[i].kind === 'Document') {
      result += args[i].loc.source.body;
    } else {
      result += args[i];
    }

    result += literals[i];
  }

  return parseDocument(result);
}

// Support typescript, which isn't as nice as Babel about default exports
gql.default = gql;
gql.resetCaches = resetCaches;
gql.disableFragmentWarnings = disableFragmentWarnings;
gql.enableExperimentalFragmentVariables = enableExperimentalFragmentVariables;
gql.disableExperimentalFragmentVariables = disableExperimentalFragmentVariables;

module.exports = gql;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = inspect;

var _nodejsCustomInspectSymbol = _interopRequireDefault(__webpack_require__(256));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var MAX_ARRAY_LENGTH = 10;
var MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (_typeof(value)) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? "[function ".concat(value.name, "]") : '[function]';

    case 'object':
      if (value === null) {
        return 'null';
      }

      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (previouslySeenValues.indexOf(value) !== -1) {
    return '[Circular]';
  }

  var seenValues = [].concat(previouslySeenValues, [value]);
  var customInspectFn = getCustomFn(value);

  if (customInspectFn !== undefined) {
    // $FlowFixMe(>=0.90.0)
    var customValue = customInspectFn.call(value); // check for infinite recursion

    if (customValue !== value) {
      return typeof customValue === 'string' ? customValue : formatValue(customValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function formatObject(object, seenValues) {
  var keys = Object.keys(object);

  if (keys.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  var properties = keys.map(function (key) {
    var value = formatValue(object[key], seenValues);
    return key + ': ' + value;
  });
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  var len = Math.min(MAX_ARRAY_LENGTH, array.length);
  var remaining = array.length - len;
  var items = [];

  for (var i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push("... ".concat(remaining, " more items"));
  }

  return '[' + items.join(', ') + ']';
}

function getCustomFn(object) {
  var customInspectFn = object[String(_nodejsCustomInspectSymbol.default)];

  if (typeof customInspectFn === 'function') {
    return customInspectFn;
  }

  if (typeof object.inspect === 'function') {
    return object.inspect;
  }
}

function getObjectTag(object) {
  var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    var name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var _default = nodejsCustomInspectSymbol;
exports.default = _default;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = devAssert;

function devAssert(condition, message) {
  var booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(message);
  }
}


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defineToJSON;

var _nodejsCustomInspectSymbol = _interopRequireDefault(__webpack_require__(256));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The `defineToJSON()` function defines toJSON() and inspect() prototype
 * methods, if no function provided they become aliases for toString().
 */
function defineToJSON(classObject) {
  var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : classObject.prototype.toString;
  classObject.prototype.toJSON = fn;
  classObject.prototype.inspect = fn;

  if (_nodejsCustomInspectSymbol.default) {
    classObject.prototype[_nodejsCustomInspectSymbol.default] = fn;
  }
}


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.syntaxError = syntaxError;

var _GraphQLError = __webpack_require__(463);

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */
function syntaxError(source, position, description) {
  return new _GraphQLError.GraphQLError("Syntax Error: ".concat(description), undefined, source, [position]);
}


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocation = getLocation;

/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  var lineRegexp = /\r\n|[\n\r]/g;
  var line = 1;
  var column = position + 1;
  var match;

  while ((match = lineRegexp.exec(source.body)) && match.index < position) {
    line += 1;
    column = position + 1 - (match.index + match[0].length);
  }

  return {
    line: line,
    column: column
  };
}


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dedentBlockStringValue = dedentBlockStringValue;
exports.getBlockStringIndentation = getBlockStringIndentation;
exports.printBlockString = printBlockString;

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 */
function dedentBlockStringValue(rawString) {
  // Expand a block string's raw value into independent lines.
  var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.

  var commonIndent = getBlockStringIndentation(lines);

  if (commonIndent !== 0) {
    for (var i = 1; i < lines.length; i++) {
      lines[i] = lines[i].slice(commonIndent);
    }
  } // Remove leading and trailing blank lines.


  while (lines.length > 0 && isBlank(lines[0])) {
    lines.shift();
  }

  while (lines.length > 0 && isBlank(lines[lines.length - 1])) {
    lines.pop();
  } // Return a string of the lines joined with U+000A.


  return lines.join('\n');
} // @internal


function getBlockStringIndentation(lines) {
  var commonIndent = null;

  for (var i = 1; i < lines.length; i++) {
    var line = lines[i];
    var indent = leadingWhitespace(line);

    if (indent === line.length) {
      continue; // skip empty lines
    }

    if (commonIndent === null || indent < commonIndent) {
      commonIndent = indent;

      if (commonIndent === 0) {
        break;
      }
    }
  }

  return commonIndent === null ? 0 : commonIndent;
}

function leadingWhitespace(str) {
  var i = 0;

  while (i < str.length && (str[i] === ' ' || str[i] === '\t')) {
    i++;
  }

  return i;
}

function isBlank(str) {
  return leadingWhitespace(str) === str.length;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 */


function printBlockString(value) {
  var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isSingleLine = value.indexOf('\n') === -1;
  var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
  var hasTrailingQuote = value[value.length - 1] === '"';
  var printAsMultipleLines = !isSingleLine || hasTrailingQuote || preferMultipleLines;
  var result = ''; // Format a multi-line block quote to account for leading space.

  if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) {
    result += '\n' + indentation;
  }

  result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;

  if (printAsMultipleLines) {
    result += '\n';
  }

  return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TokenKind = void 0;

/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var TokenKind = Object.freeze({
  SOF: '<SOF>',
  EOF: '<EOF>',
  BANG: '!',
  DOLLAR: '$',
  AMP: '&',
  PAREN_L: '(',
  PAREN_R: ')',
  SPREAD: '...',
  COLON: ':',
  EQUALS: '=',
  AT: '@',
  BRACKET_L: '[',
  BRACKET_R: ']',
  BRACE_L: '{',
  PIPE: '|',
  BRACE_R: '}',
  NAME: 'Name',
  INT: 'Int',
  FLOAT: 'Float',
  STRING: 'String',
  BLOCK_STRING: 'BlockString',
  COMMENT: 'Comment'
});
/**
 * The enum type representing the token kinds values.
 */

exports.TokenKind = TokenKind;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.missedCalls = exports.callHistorySelector = exports.callHistoryMobile = exports.callHistoryWeb = exports.totalNewMissedCalls = exports.callHistoryLastViewed = exports.selectCallHistoryEnabled = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reselect = __webpack_require__(23);

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _callHistoryUtils = __webpack_require__(126);

var _browserUtils = __webpack_require__(44);

var _contacts = __webpack_require__(35);

var C = _interopRequireWildcard(__webpack_require__(3));

var _auth = __webpack_require__(31);

var _localization = __webpack_require__(125);

/** @module selectors/callHistory */
var selectCallHistoryEnabled = function selectCallHistoryEnabled(state) {
  return (0, _safeAccess.default)(state, 'nucleus.callHistory.callHistoryEnabled');
};

exports.selectCallHistoryEnabled = selectCallHistoryEnabled;

var callHistoryRecords = function callHistoryRecords(state) {
  return (0, _safeAccess.default)(state, 'nucleus.callHistory.records') || [];
};

var callHistoryLastViewed = function callHistoryLastViewed(state) {
  return (0, _safeAccess.default)(state, 'nucleus.callHistory.lastViewed') || null;
};

exports.callHistoryLastViewed = callHistoryLastViewed;

var recordsRevision = function recordsRevision(state) {
  return (0, _safeAccess.default)(state, 'nucleus.callHistory.recordsRevision') || 0;
};

var minutesElapsed = function minutesElapsed(state) {
  return (0, _safeAccess.default)(state, 'nucleus.timer.minutesElapsed') || 0;
};
/**
 * Selects the total number of new (unviewed), missed calls from the redux store
 * @example
 * Returns...
 *  42
 */


var totalNewMissedCalls = (0, _reselect.createSelector)(callHistoryRecords, callHistoryLastViewed, recordsRevision, function (records, lastViewed) {
  var newMissedCalls = records.filter(function (r) {
    return (0, _callHistoryUtils.mapCallType)(r.direction) === C.CALL_HISTORY_MISSED && new Date(+r.startTimestamp) > lastViewed;
  });
  return newMissedCalls.length;
});
exports.totalNewMissedCalls = totalNewMissedCalls;

/**
 * Selects the callHistory from the redux store sorted by endTimestamp descending for web
 * (no grouping)
 * @example
 * Returns...
 *  [
 *    { callHistoryObject },
 *    { callHistoryObject },
 *    { callHistoryObject }
 *  ]
 */
var callHistoryWeb = (0, _reselect.createSelector)(callHistoryRecords, callHistoryLastViewed, _contacts.contactsSelector, _localization.languageId, recordsRevision, minutesElapsed, function (records, lastViewed, contacts, languageId) {
  var callHistory = records.map(function (recentRecord) {
    var callHistoryItem = (0, _callHistoryUtils.mapCallHistoryItem)(recentRecord, recentRecord.contact);
    return (0, _objectSpread2.default)({}, callHistoryItem, (0, _callHistoryUtils.recentCalculatedProperties)(recentRecord, languageId, lastViewed));
  });
  return callHistory.sort(function (a, b) {
    return b.start - a.start;
  });
});
exports.callHistoryWeb = callHistoryWeb;

/**
 * Selects the callHistory from the redux store sorted by endTimestamp descending.
 * @example
 * Returns...
 *  [
 *    { callHistoryObject },
 *    { callHistoryObject },
 *    { callHistoryObject }
 *  ]
 */
var callHistoryMobile = (0, _reselect.createSelector)(callHistoryRecords, callHistoryLastViewed, _contacts.contactsSelector, _localization.languageId, _auth.getPlatform, recordsRevision, minutesElapsed, function (records, lastViewed, contacts, languageId, platform) {
  return (0, _callHistoryUtils.groupCallHistoryRecords)(records, contacts, languageId, lastViewed, (0, _browserUtils.isMobile)(platform));
});
exports.callHistoryMobile = callHistoryMobile;

/**
 * Selects the callHistory from the redux store sorted by endTimestamp descending.
 * @example
 * Returns...
 *  [
 *    { callHistoryObject },
 *    { callHistoryObject },
 *    { callHistoryObject }
 *  ]
 */
var callHistorySelector = (0, _reselect.createSelector)(callHistoryRecords, callHistoryLastViewed, _contacts.contactsSelector, _localization.languageId, _auth.getPlatform, recordsRevision, minutesElapsed, function (records, lastViewed, contacts, languageId, platform) {
  return (0, _callHistoryUtils.groupCallHistoryRecords)(records, contacts, languageId, lastViewed, (0, _browserUtils.isMobile)(platform));
});
exports.callHistorySelector = callHistorySelector;

/**
 * returns all the call history records that are of type "missed"
 * @example
 * Returns...
 * [
 *  { id: X, name: 'A' },
 *  { id: Y, name: 'B' },
 *  { id: Z, name: 'C' }
 * ]
 */
var missedCalls = (0, _reselect.createSelector)(callHistoryRecords, callHistoryLastViewed, _contacts.contactsSelector, _localization.languageId, _auth.getPlatform, recordsRevision, minutesElapsed, function (records, lastViewed, contacts, languageId, platform) {
  var filteredRecords = records.filter(function (r) {
    return (0, _callHistoryUtils.mapCallType)(r.direction) === C.CALL_HISTORY_MISSED;
  });
  return (0, _callHistoryUtils.groupCallHistoryRecords)(filteredRecords, contacts, languageId, lastViewed, (0, _browserUtils.isMobile)(platform));
});
exports.missedCalls = missedCalls;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messageSortByTimestamp = messageSortByTimestamp;
exports.groupMessagesForWeb = groupMessagesForWeb;
exports.groupMessagesForMobile = groupMessagesForMobile;
exports.findUnreadMessages = exports.findRoomsWithUnreadMessages = exports.getRoomByContact = exports.convertToLegacyMessageFormat = exports.convertToLegacyChatFormat = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var DateUtils = _interopRequireWildcard(__webpack_require__(124));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var WEB_GROUPING_DURATION = 90000;
var MOBILE_GROUPING_DURATION = 90000; // GQL

var convertToLegacyChatFormat = function convertToLegacyChatFormat(userUuid, chatRoom, messages) {
  var _chatRoom$members;

  var participants = (_chatRoom$members = chatRoom.members) === null || _chatRoom$members === void 0 ? void 0 : _chatRoom$members.filter(function (m) {
    return (m === null || m === void 0 ? void 0 : m.uuid) !== userUuid;
  });
  var contact = chatRoom.isMeeting ? (0, _objectSpread2.default)({}, chatRoom.meeting, {
    isMeeting: true
  }) : participants[0];
  var unreadMessages = findUnreadMessages(userUuid, chatRoom, messages);
  if (!contact) return null;
  return {
    contact: contact,
    participants: participants,
    conversation: chatRoom,
    conversationId: chatRoom.uuid,
    unreadMessageCount: unreadMessages.length,
    lastUpdated: chatRoom.lastUpdated
  };
};

exports.convertToLegacyChatFormat = convertToLegacyChatFormat;

var convertToLegacyMessageFormat = function convertToLegacyMessageFormat(userUuid, message, lastReadAt) {
  var _message$sender, _message$sender2, _message$sender3;

  return (0, _objectSpread2.default)({}, message, {
    hasBeenRead: ((_message$sender = message.sender) === null || _message$sender === void 0 ? void 0 : _message$sender.uuid) !== userUuid && new Date(message.createdAt) > new Date(lastReadAt),
    // TODO
    id: message.uuid,
    archivedId: message.uuid,
    body: message.message,
    timestamp: new Date(message.createdAt),
    senderName: (_message$sender2 = message.sender) === null || _message$sender2 === void 0 ? void 0 : _message$sender2.displayName,
    isSenderSelf: ((_message$sender3 = message.sender) === null || _message$sender3 === void 0 ? void 0 : _message$sender3.uuid) === userUuid
  });
};

exports.convertToLegacyMessageFormat = convertToLegacyMessageFormat;

var getRoomByContact = function getRoomByContact(contact) {
  var rooms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var dialString = typeof contact === 'string' ? contact : (0, _safeAccess.default)(contact, 'dialString');
  return rooms.find(function (r) {
    var _r$meeting, _r$members;

    return ((_r$meeting = r.meeting) === null || _r$meeting === void 0 ? void 0 : _r$meeting.dialString) === dialString || !r.meeting && ((_r$members = r.members) === null || _r$members === void 0 ? void 0 : _r$members.find(function (m) {
      return (m === null || m === void 0 ? void 0 : m.dialString) === dialString;
    }));
  });
};

exports.getRoomByContact = getRoomByContact;

var findRoomsWithUnreadMessages = function findRoomsWithUnreadMessages(userUuid, rooms, messages) {
  return rooms.map(function (r) {
    var unreadMessages = findUnreadMessages(userUuid, r, messages[r.uuid]);
    return {
      room: r,
      unreadMessageCount: unreadMessages.length
    };
  });
};

exports.findRoomsWithUnreadMessages = findRoomsWithUnreadMessages;

var findUnreadMessages = function findUnreadMessages(userUuid, room) {
  var messages = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  if (!room.lastReadAt) return messages;
  return messages.filter(function (m) {
    var _m$sender;

    return ((_m$sender = m.sender) === null || _m$sender === void 0 ? void 0 : _m$sender.uuid) !== userUuid && new Date(m.createdAt) > new Date(room.lastReadAt);
  });
};

exports.findUnreadMessages = findUnreadMessages;

function messageSortByTimestamp(a, b) {
  return a.timestamp < b.timestamp ? -1 : 1;
}

function groupMessagesForWeb(messages, localeCode) {
  var groupedMessages = [];
  var currentMessageGrouping = {
    timestamp: new Date(),
    senderName: ''
  }; // sort messages by timestamp

  messages.sort(messageSortByTimestamp);
  messages.forEach(function (message) {
    // rules for breaking up groups on the web:
    // new sender or time difference too large
    if (message.senderName !== currentMessageGrouping.senderName || message.timestamp.getTime() - currentMessageGrouping.timestamp.getTime() > WEB_GROUPING_DURATION) {
      // push the current message grouping onto the array
      // checking formattedTimestamp handles the "first message group" condition
      if (currentMessageGrouping.formattedTimestamp) {
        groupedMessages.push(Object.assign({}, currentMessageGrouping));
      } // create a new message grouping


      currentMessageGrouping = {
        timestamp: message.timestamp,
        formattedTimestamp: DateUtils.formatTSForChats(message.timestamp, localeCode),
        senderName: message.senderName,
        isSenderSelf: message.isSenderSelf,
        messages: [message],
        isNewDate: message.timestamp.toDateString() !== currentMessageGrouping.timestamp.toDateString()
      };
    } else {
      currentMessageGrouping.messages.push(message);
    }
  }); // push final message grouping if it exists

  if (currentMessageGrouping.formattedTimestamp) groupedMessages.push(Object.assign({}, currentMessageGrouping));
  return groupedMessages;
}

function groupMessagesForMobile(messages) {
  var groupedMessages = [];
  var currentMessageGrouping = {
    timestamp: new Date(),
    senderName: ''
  }; // sort messages by timestamp

  messages.sort(messageSortByTimestamp);
  messages.forEach(function (message) {
    // rules for breaking up groups on the web:
    // new sender or time difference too large
    if (message.senderName !== currentMessageGrouping.senderName || message.timestamp.getTime() - currentMessageGrouping.timestamp.getTime() > MOBILE_GROUPING_DURATION) {
      // push the current message grouping onto the array
      // checking messages (an uninitialized key) handles the "first message group" condition
      if (currentMessageGrouping.messages) {
        groupedMessages.push(Object.assign({}, currentMessageGrouping));
      } // create a new message grouping


      currentMessageGrouping = {
        timestamp: message.timestamp,
        senderName: message.senderName,
        isSenderSelf: message.isSenderSelf,
        messages: [message],
        isNewDate: message.timestamp.toDateString() !== currentMessageGrouping.timestamp.toDateString(),
        isNewTime: message.timestamp.getTime() - currentMessageGrouping.timestamp.getTime() > MOBILE_GROUPING_DURATION
      };
    } else {
      currentMessageGrouping.messages.push(message);
    }
  }); // push final message grouping if it exists

  if (currentMessageGrouping.messages) groupedMessages.push(Object.assign({}, currentMessageGrouping));
  return groupedMessages;
}

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChatForWebGenerator = exports.getChatForMobileGenerator = exports.groupedConversations = exports.groupedConversationsWithUnread = exports.gqlChatRooms = exports.selectGqlChatEnabled = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reselect = __webpack_require__(23);

var ChatUtils = _interopRequireWildcard(__webpack_require__(264));

var _currentUser = __webpack_require__(37);

var _localization = __webpack_require__(125);

var _orderBy2 = _interopRequireDefault(__webpack_require__(472));

var access = __webpack_require__(8);
/** @module selectors/chat */


var selectGqlChatEnabled = function selectGqlChatEnabled(state) {
  return access(state, 'nucleus.gqlChat.enabled');
};

exports.selectGqlChatEnabled = selectGqlChatEnabled;

var gqlChatRoomState = function gqlChatRoomState(state) {
  return access(state, 'nucleus.gqlChat.rooms') || {};
};

var gqlChatRoomMessageState = function gqlChatRoomMessageState(state) {
  return access(state, 'nucleus.gqlChat.roomMessages') || {};
};

var gqlChatRoomOutgoingMessages = function gqlChatRoomOutgoingMessages(state) {
  return access(state, 'nucleus.gqlChat.outgoingMessages') || {};
};

var gqlChatRoomCursors = function gqlChatRoomCursors(state) {
  return access(state, 'nucleus.gqlChat.roomCursors') || {};
};

var gqlChatRevision = function gqlChatRevision(state) {
  return access(state, 'nucleus.gqlChat.revision') || 0;
};

var gqlChatRooms = (0, _reselect.createSelector)(gqlChatRoomState, gqlChatRevision, function (rooms) {
  return Object.values(rooms);
});
exports.gqlChatRooms = gqlChatRooms;
var gqlChatRoomMessages = (0, _reselect.createSelector)(gqlChatRoomMessageState, gqlChatRoomOutgoingMessages, gqlChatRevision, function (roomMessages, outgoingMessages) {
  var formattedRoomMessages = {};
  Object.keys(roomMessages).forEach(function (roomUUID) {
    var outgoingForRoom = Object.values(outgoingMessages).filter(function (m) {
      return m.roomUUID === roomUUID;
    });
    formattedRoomMessages[roomUUID] = Object.values(roomMessages[roomUUID]).concat(outgoingForRoom);
  });
  return formattedRoomMessages;
});
/**
 * This function breaks all subscribed chat conversations into three distinct lists.<br>
 * Each of these lists are alpha sorted by the main contact name for the
 * conversation(user or VMR) with locale in mind via a call to localeCompare.
 * <ul>
 * <li> Conversations with Unread Messages: Any conversation that contains unread
 * messages. Can be either users or meetings. Sorted by name.</li>
 * <li> Conversations in Meetings (VMR)</li>
 * <li> Conversations with Users (P2P)</li>
 * <li> Total unread message count</li>
 * </ul>
 * @type {object}
 */

var groupedConversationsWithUnread = (0, _reselect.createSelector)(_currentUser.myInfo, gqlChatRooms, gqlChatRoomMessages, gqlChatRevision, function (currentUser, chatRooms, chatRoomMessages) {
  var totalUnreadMessageCount = 0;
  var unreadMessageConversations = [];
  ChatUtils.findRoomsWithUnreadMessages(currentUser === null || currentUser === void 0 ? void 0 : currentUser.userUuid, chatRooms, chatRoomMessages).forEach(function (u) {
    totalUnreadMessageCount += u.unreadMessageCount;

    if (u.unreadMessageCount > 0) {
      unreadMessageConversations.push(ChatUtils.convertToLegacyChatFormat(currentUser === null || currentUser === void 0 ? void 0 : currentUser.userUuid, u.room, chatRoomMessages[u.room.uuid]));
    }
  });
  return {
    totalUnreadMessageCount: totalUnreadMessageCount,
    unreadMessageConversations: unreadMessageConversations.filter(function (c) {
      return !!c;
    }),
    meetingConversations: (0, _orderBy2.default)(chatRooms.filter(function (r) {
      return r.isMeeting;
    }).map(function (r) {
      return ChatUtils.convertToLegacyChatFormat(currentUser === null || currentUser === void 0 ? void 0 : currentUser.userUuid, r, chatRoomMessages[r.uuid]);
    }).filter(function (c) {
      return !!c;
    }), ['lastUpdated'], ['desc']),
    userConversations: (0, _orderBy2.default)(chatRooms.filter(function (r) {
      return !r.isMeeting;
    }).map(function (r) {
      return ChatUtils.convertToLegacyChatFormat(currentUser === null || currentUser === void 0 ? void 0 : currentUser.userUuid, r, chatRoomMessages[r.uuid]);
    }).filter(function (c) {
      return !!c;
    }), ['lastUpdated'], ['desc'])
  };
});
exports.groupedConversationsWithUnread = groupedConversationsWithUnread;

/**
 * This function breaks all subscribed chat conversations into two distinct lists.<br>
 * Each of these lists are alpha sorted by the main contact name for the
 * conversation(user or VMR) with locale in mind via a call to localeCompare.
 * <ul>
 * <li> Conversations in Meetings (VMR)</li>
 * <li> Conversations with Users (P2P)</li>
 * <li> Total unread message count</li>
 * </ul>
 * @type {object}
 */
var groupedConversations = (0, _reselect.createSelector)(_currentUser.myInfo, gqlChatRooms, gqlChatRoomMessages, gqlChatRevision, function (currentUser, chatRooms, chatRoomMessages) {
  var totalUnreadMessageCount = 0;
  ChatUtils.findRoomsWithUnreadMessages(currentUser === null || currentUser === void 0 ? void 0 : currentUser.userUuid, chatRooms, chatRoomMessages).forEach(function (u) {
    totalUnreadMessageCount += u.unreadMessageCount;
  });
  return {
    totalUnreadMessageCount: totalUnreadMessageCount,
    meetingConversations: (0, _orderBy2.default)(chatRooms.filter(function (r) {
      return r.isMeeting;
    }).map(function (r) {
      return ChatUtils.convertToLegacyChatFormat(currentUser === null || currentUser === void 0 ? void 0 : currentUser.userUuid, r, chatRoomMessages[r.uuid]);
    }).filter(function (c) {
      return !!c;
    }), ['lastUpdated'], ['desc']),
    userConversations: (0, _orderBy2.default)(chatRooms.filter(function (r) {
      return !r.isMeeting;
    }).map(function (r) {
      return ChatUtils.convertToLegacyChatFormat(currentUser === null || currentUser === void 0 ? void 0 : currentUser.userUuid, r, chatRoomMessages[r.uuid]);
    }).filter(function (c) {
      return !!c;
    }), ['lastUpdated'], ['desc'])
  };
});
exports.groupedConversations = groupedConversations;

/**
 * <h2>getChatForMobileGenerator</h2> <br/>
 * Returns a function which accepts a contact, which returns your chat with that contact, formatted for Mobile Clients.<br/>
 * The conversation contains:<br/>
 * <ul>
 * <li> The original conversation object as it is stored inside of the reducer</li>
 * <li> The main contact for the conversation be it a user(P2P) or meeting(VMR)</li>
 * <li> The participants for the conversation is an array of contacts.
 *  <ul>
 *   <li>If it is a P2P, this contact is the same as the main contact. </li>
 *   <li>If the conversation is a VMR, this is a list of users that are
 *   subscribed to this VMR conversation.</li></ul></li>
 *  <li> Messages grouped by timestamp. After the first message in a group, any message received in the next 45 minutes and any message received within 20 minutes interval thereafter is grouped together</li>
 *  <li> The timestamp of the most recent message.</li>
 *  <li> The number of unread messages for this conversation.</li>
 *  <li> The conversation jid.</li>
 * </ul>
 * @example
 *
 * import { chatSelectors, contactSelectors } from 'lifesize-sky-nucleus'
 * function mapStateToProps(state) {
 *   // get your contact from a selector Id
 *   const selectedContact = getChatByIdGenerator(state)('contactId');
 *   // get your conversation selector for your current state;
 *   const getChatForMobile = getChatForMobileGenerator(state);
 *   // select your chat
 *   const chat = getChatForMobileGenerator(selectedContact);
 *
 *   // or use the shorthand:
 *   const chat = getChatForMobileGenerator(state)(selectedContact);
 * }
 */
var getChatForMobileGenerator = (0, _reselect.createSelector)(_currentUser.myInfo, gqlChatRooms, gqlChatRoomMessages, gqlChatRoomCursors, _localization.languageId, gqlChatRevision, function (currentUser, chatRooms, chatRoomMessages, chatRoomCursors, languageId) {
  return (0, _reselect.defaultMemoize)( // eslint-disable-line no-unused-vars
  function (dialString) {
    var _chatRoomCursors$room, _chatRoomCursors$room2;

    var room = ChatUtils.getRoomByContact(dialString, chatRooms);
    if (!room) return null;
    var messages = (chatRoomMessages[room.uuid] || []).map(function (m) {
      return ChatUtils.convertToLegacyMessageFormat(currentUser === null || currentUser === void 0 ? void 0 : currentUser.userUuid, m, room.lastReadAt);
    });
    var conversation = ChatUtils.convertToLegacyChatFormat(currentUser === null || currentUser === void 0 ? void 0 : currentUser.userUuid, room, messages);
    var groupedMessages = ChatUtils.groupMessagesForMobile(messages, languageId);
    return (0, _objectSpread2.default)({}, conversation, {
      isLoading: !!((_chatRoomCursors$room = chatRoomCursors[room.uuid]) === null || _chatRoomCursors$room === void 0 ? void 0 : _chatRoomCursors$room.loading),
      hasMoreMessages: !!((_chatRoomCursors$room2 = chatRoomCursors[room.uuid]) === null || _chatRoomCursors$room2 === void 0 ? void 0 : _chatRoomCursors$room2.cursor),
      groupedMessages: groupedMessages
    });
  });
});
exports.getChatForMobileGenerator = getChatForMobileGenerator;

/**
 * <h2>getChatForWebGenerator</h2> <br/>
 * Returns a function which accepts a contact, which returns your chat with that contact, formatted for Web Clients.<br/>
 * The conversation contains:<br/>
 * <ul>
 * <li> The original conversation object as it is stored inside of the reducer</li>
 * <li> The main contact for the conversation be it a user(P2P) or meeting(VMR)</li>
 * <li> The participants for the conversation is an array of contacts.
 *  <ul>
 *   <li>If it is a P2P, this contact is the same as the main contact. </li>
 *   <li>If the conversation is a VMR, this is a list of users that are
 *   subscribed to this VMR conversation.</li></ul></li>
 *  <li> Messages grouped by timestamp. After the first message in a group, any message received in the next 45 minutes and any message received within 20 minutes interval thereafter is grouped together</li>
 *  <li> The timestamp of the most recent message.</li>
 *  <li> The number of unread messages for this conversation.</li>
 *  <li> The conversation jid.</li>
 * </ul>
 * @example
 * import { chatSelectors, contactSelectors } from 'lifesize-sky-nucleus'
 *
 * function mapStateToProps(state) {
 *   // get your contact from a selector Id
 *   const selectedContact = getChatByIdGenerator(state)('contactId');
 *   // get your conversation selector for your current state;
 *   const getChatForMobile = getChatForMobileGenerator(state);
 *   // select your chat
 *   const chat = getChatForMobileGenerator(selectedContact);
 *
 *   // or use the shorthand:
 *   const chat = getChatForMobileGenerator(state)(selectedContact);
 * }
 */
var getChatForWebGenerator = (0, _reselect.createSelector)(_currentUser.myInfo, gqlChatRooms, gqlChatRoomMessages, gqlChatRoomCursors, _localization.languageId, gqlChatRevision, function (currentUser, chatRooms, chatRoomMessages, chatRoomCursors, languageId) {
  return (0, _reselect.defaultMemoize)( // eslint-disable-line no-unused-vars
  function (dialString) {
    var _chatRoomCursors$room3;

    var room = ChatUtils.getRoomByContact(dialString, chatRooms);
    if (!room) return null;
    var messages = (chatRoomMessages[room.uuid] || []).map(function (m) {
      return ChatUtils.convertToLegacyMessageFormat(currentUser === null || currentUser === void 0 ? void 0 : currentUser.userUuid, m, room.lastReadAt);
    });
    var conversation = ChatUtils.convertToLegacyChatFormat(currentUser === null || currentUser === void 0 ? void 0 : currentUser.userUuid, room, messages);
    var groupedMessages = ChatUtils.groupMessagesForWeb(messages, languageId);
    return (0, _objectSpread2.default)({}, conversation, {
      isLoading: !!((_chatRoomCursors$room3 = chatRoomCursors[room.uuid]) === null || _chatRoomCursors$room3 === void 0 ? void 0 : _chatRoomCursors$room3.loading),
      hasMoreMessages: !!chatRoomCursors[room.uuid],
      groupedMessages: groupedMessages
    });
  });
});
exports.getChatForWebGenerator = getChatForWebGenerator;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contactSetFavorite = contactSetFavorite;
exports.contactLoadAllMeetings = exports.contactLoadAllUsers = exports.contactLoadAll = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var c = _interopRequireWildcard(__webpack_require__(3));

var _favorite = __webpack_require__(146);

var _contacts = __webpack_require__(35);

var _directory = __webpack_require__(84);

/** @module actions/api */

/**
 * Load any contacts
 * @param {object} params - query parameters (userLogin and token are automatically included)
 */
var contactLoadAll = function contactLoadAll() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : c.CONTACTS_DEFAULT_PAGE_SIZE;
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch, getState) {
        var _state$nucleus, _state$nucleus$contac;

        var state;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                state = getState();

                if (!(state === null || state === void 0 ? void 0 : (_state$nucleus = state.nucleus) === null || _state$nucleus === void 0 ? void 0 : (_state$nucleus$contac = _state$nucleus.contacts) === null || _state$nucleus$contac === void 0 ? void 0 : _state$nucleus$contac.contactsLoaded)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", (0, _contacts.contactsSelector)(state));

              case 3:
                _context.next = 5;
                return dispatch((0, _directory.loadAll)(filters, pageSize));

              case 5:
                return _context.abrupt("return", (0, _contacts.contactsSelector)(getState()));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};
/**
 * Load User contacts
 */


exports.contactLoadAll = contactLoadAll;

var contactLoadAllUsers = function contactLoadAllUsers() {
  var pageSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : c.CONTACTS_DEFAULT_PAGE_SIZE;
  return contactLoadAll(['USER'], pageSize);
};
/**
 * Load Meeting contacts
 */


exports.contactLoadAllUsers = contactLoadAllUsers;

var contactLoadAllMeetings = function contactLoadAllMeetings() {
  var pageSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : c.CONTACTS_DEFAULT_PAGE_SIZE;
  return contactLoadAll(['MEETING'], pageSize);
};
/**
 * set favorite contact
 * @param {string} id
 * @param {bool} favorite - boolean value, true if the contact is a favorite
 */


exports.contactLoadAllMeetings = contactLoadAllMeetings;

function contactSetFavorite(id, favorite, argContact) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch, getState) {
        var state, contact, type;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                state = getState();
                contact = argContact || (0, _contacts.getContactByUuidGenerator)(state)(id);

                if (contact) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 5;
                return dispatch((0, _directory.loadByUUID)(id));

              case 5:
                contact = _context2.sent;

              case 6:
                if (!favorite) {
                  _context2.next = 12;
                  break;
                }

                // add favorite
                type = 'CONTACT';

                if (contact.isUser) {
                  type = 'USER';
                } else if (contact.isMeeting) {
                  type = 'MEETING';
                }

                return _context2.abrupt("return", dispatch((0, _favorite.addFavorite)(type, contact.uuid)));

              case 12:
                return _context2.abrupt("return", dispatch((0, _favorite.deleteFavorite)(contact.uuid)));

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribeToCallManager = subscribeToCallManager;
exports.subscribeToTurnManager = subscribeToTurnManager;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _proxy = __webpack_require__(21);

var _constants = __webpack_require__(3);

/**
 * subscribeToCallManager
 * Subscribe to the Galaxy Call Manager.
 */
function subscribeToCallManager() {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return dispatch((0, _proxy.subscribe)(_constants.GALAXY_SUBSCRIPTION_CALL_MANAGER));

              case 3:
                _context.next = 9;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);

                _jsLogger.default.error('Unable to subscribe to call manager topic:', _context.t0);

                throw _context.t0;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 5]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}
/**
 * subscribeToTurnManager
 * Subscribe to the Galaxy Turn Manager.
 */


function subscribeToTurnManager() {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return dispatch((0, _proxy.subscribe)(_constants.GALAXY_SUBSCRIPTION_TURN_SERVER));

              case 3:
                _context2.next = 9;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2["catch"](0);

                _jsLogger.default.error('Unable to subscribe to turn manager topic:', _context2.t0);

                throw _context2.t0;

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 5]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialize = initialize;
exports.subscribe = subscribe;
exports.unsubscribe = unsubscribe;
exports.getPhoneHDCustomization = getPhoneHDCustomization;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _get = _interopRequireDefault(__webpack_require__(11));

var c = _interopRequireWildcard(__webpack_require__(3));

var proxyActions = _interopRequireWildcard(__webpack_require__(21));

/** @module actions/phoneHD */
function initialize() {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch, getState) {
        var state, phoneHDEnabled;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                state = getState();
                phoneHDEnabled = (0, _get.default)(state, 'nucleus.phoneHD.enabled');

                if (phoneHDEnabled) {
                  _context.next = 5;
                  break;
                }

                _jsLogger.default.info('phone hd customization: phone hd not enabled. skipping subscription.');

                return _context.abrupt("return");

              case 5:
                // Fetch the current customization
                dispatch(getPhoneHDCustomization()); // Subscribe to any phoneHD customization changes

                dispatch(subscribeToTopic());

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}

function subscribe() {
  return proxyActions.subscribe(c.PHONEHD_CUSTOMIZATION_TOPIC);
}

function unsubscribe() {
  return proxyActions.unsubscribe(c.PHONEHD_CUSTOMIZATION_TOPIC);
}
/**
 * getPhoneHDCustomization
 */


function getPhoneHDCustomization() {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch) {
        var response;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return dispatch(proxyActions.proxyApiCall(c.PHONEHD_CUSTOMIZATION_ENDPOINT, 'customization/phonehd/extension/', 'GET'));

              case 3:
                response = _context2.sent;
                dispatch({
                  type: c.WAMP_SUBSCRIPTION_PHONEHD_CUSTOMIZATION_EVENT,
                  payload: response
                });
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);

                _jsLogger.default.error('PhoneHD Customization request failed', _context2.t0);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 7]]);
      }));

      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}

function subscribeToTopic() {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(dispatch) {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return dispatch(proxyActions.subscribe(c.PHONEHD_CUSTOMIZATION_TOPIC));

              case 3:
                _context3.next = 8;
                break;

              case 5:
                _context3.prev = 5;
                _context3.t0 = _context3["catch"](0);

                _jsLogger.default.info('phone hd: subscription failed:', _context3.t0);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 5]]);
      }));

      return function (_x4) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
}

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectCanRefreshToken = selectCanRefreshToken;
exports.selectRefreshableToken = selectRefreshableToken;
exports.getTokenUpdateError = exports.getTokenUpdating = exports.selectOneTimeJwt = exports.selectHasSuccessfullyConnected = exports.selectHasAttemptedRefresh = void 0;

var _lodash = __webpack_require__(82);

var _auth = __webpack_require__(31);

var selectToken = function selectToken(state) {
  return (0, _lodash.get)(state, 'nucleus.token');
};

var selectHasAttemptedRefresh = function selectHasAttemptedRefresh(state) {
  return (0, _lodash.get)(selectToken(state), 'hasAttemptedRefresh');
};

exports.selectHasAttemptedRefresh = selectHasAttemptedRefresh;

var selectHasSuccessfullyConnected = function selectHasSuccessfullyConnected(state) {
  return (0, _lodash.get)(selectToken(state), 'hasSuccessfullyConnected');
};

exports.selectHasSuccessfullyConnected = selectHasSuccessfullyConnected;

var selectOneTimeJwt = function selectOneTimeJwt(state) {
  return (0, _lodash.get)(selectToken(state), 'oneTimeJwt');
};

exports.selectOneTimeJwt = selectOneTimeJwt;

var getTokenUpdating = function getTokenUpdating(state) {
  return (0, _lodash.get)(selectToken(state), 'updating');
};

exports.getTokenUpdating = getTokenUpdating;

var getTokenUpdateError = function getTokenUpdateError(state) {
  return (0, _lodash.get)(selectToken(state), 'error');
};

exports.getTokenUpdateError = getTokenUpdateError;

function selectCanRefreshToken(state) {
  // If an attempt to refresh the token has been made, and connection has not succeeded
  // the token can no longer be refreshed
  if (selectHasAttemptedRefresh(state)) return false; // refreshable token exists

  if (selectRefreshableToken(state)) return true; // evaluate if connection was established using a legacy cookie

  return selectHasSuccessfullyConnected(state) && !selectOneTimeJwt(state);
}

function selectRefreshableToken(state) {
  return (0, _auth.aToken)(state) || (0, _auth.cnucJwt)(state);
}

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClientIdByPlatform = exports.getGuestTokenUri = exports.getLoginServiceTokenRefreshUri = exports.getLoginServiceTokenUri = exports.addNextUrl = exports.getEmailCheckUri = void 0;

var c = _interopRequireWildcard(__webpack_require__(3));

var _browserUtils = __webpack_require__(44);

var getEmailCheckUri = function getEmailCheckUri(domain, email) {
  return "https://login.".concat(domain, "/ls/emailcheck/?email=").concat(encodeURIComponent(email));
};

exports.getEmailCheckUri = getEmailCheckUri;

var getSourceString = function getSourceString(platform) {
  if ((0, _browserUtils.isMobile)(platform)) return 'nucleus.mobile';
  if ((0, _browserUtils.isDesktop)(platform)) return 'nucleus.desktop';
  if (platform === c.PLATFORM_WEB) return 'nucleus.webclient';
  if ((0, _browserUtils.isGems)(platform)) return 'nucleus.gems';
  return null;
};

var getNextUriParam = function getNextUriParam(nextUrl, platform) {
  var sourceString = getSourceString(platform);
  return encodeURIComponent("".concat(nextUrl, "?source=").concat(sourceString, "&response_type=code"));
};

var addNextUrl = function addNextUrl(loginServiceUri, nextUrl, platform) {
  // if no nextUrl provided, do not add one
  // (currently, the webclient does this logic on its own)
  if (!nextUrl) return loginServiceUri;
  return "".concat(loginServiceUri, "&next=").concat(getNextUriParam(nextUrl, platform));
};

exports.addNextUrl = addNextUrl;

var getLoginServiceTokenUri = function getLoginServiceTokenUri(domain) {
  return "https://login.".concat(domain, "/ls/token/");
};

exports.getLoginServiceTokenUri = getLoginServiceTokenUri;

var getLoginServiceTokenRefreshUri = function getLoginServiceTokenRefreshUri(domain) {
  return "https://login.".concat(domain, "/ls/refresh/");
};

exports.getLoginServiceTokenRefreshUri = getLoginServiceTokenRefreshUri;

var getGuestTokenUri = function getGuestTokenUri(domain) {
  return "https://login.".concat(domain, "/ls/login/guest/");
};

exports.getGuestTokenUri = getGuestTokenUri;

var getClientIdByPlatform = function getClientIdByPlatform(platform) {
  switch (platform) {
    case c.PLATFORM_DASH:
      return c.CLIENT_ID_DASH_DISPLAY;

    case c.PLATFORM_OSX:
      return c.CLIENT_ID_ELECTRON_MAC;

    case c.PLATFORM_WINDOWS:
      return c.CLIENT_ID_ELECTRON_WINDOWS;

    case c.PLATFORM_IOS:
      return c.CLIENT_ID_MOBILE_IOS;

    case c.PLATFORM_ANDROID:
      return c.CLIENT_ID_MOBILE_ANDROID;

    case c.PLATFORM_ICON_300:
    case c.PLATFORM_ICON_500:
    case c.PLATFORM_ICON_700:
    case c.PLATFORM_ICON_900:
      return c.CLIENT_ID_GEMS;

    default:
      return null;
  }
};

exports.getClientIdByPlatform = getClientIdByPlatform;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkin = checkin;
exports.change = change;
exports.getGroupSettings = getGroupSettings;
exports.putGroupSettings = putGroupSettings;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var c = _interopRequireWildcard(__webpack_require__(3));

var _proxy = __webpack_require__(21);

var _pick = _interopRequireDefault(__webpack_require__(122));

/**
 * Monitoring - Checkin
 * Supplies the current state of a device. Replaces any previous state known for the device.
 * @param {object} metrics - metrics
 */
function checkin(metrics) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                dispatch({
                  type: c.MONITORING_CHECKIN_BEGIN,
                  payload: metrics
                });
                _context.next = 4;
                return dispatch((0, _proxy.proxyApiCall)(c.MONITORING_SERVICE_ENDPOINT, c.MONITORING_CHECKIN_URL_SUFFIX, c.HTTP_POST, metrics));

              case 4:
                dispatch({
                  type: c.MONITORING_CHECKIN_SUCCESS,
                  payload: metrics
                });
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                dispatch({
                  type: c.MONITORING_CHECKIN_FAILURE,
                  payload: {
                    metrics: metrics,
                    error: _context.t0
                  }
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}
/**
 * Monitoring - Change
 * Adjusts specific metrics of the device's current state.
 * @param {object} metrics - metrics
 */


function change(metrics) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                dispatch({
                  type: c.MONITORING_CHANGE_BEGIN,
                  payload: metrics
                });
                _context2.next = 4;
                return dispatch((0, _proxy.proxyApiCall)(c.MONITORING_SERVICE_ENDPOINT, c.MONITORING_CHANGE_URL_SUFFIX, c.HTTP_POST, metrics));

              case 4:
                dispatch({
                  type: c.MONITORING_CHANGE_SUCCESS,
                  payload: metrics
                });
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                dispatch({
                  type: c.MONITORING_CHANGE_FAILURE,
                  payload: {
                    metrics: metrics,
                    error: _context2.t0
                  }
                });

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 7]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}
/**
 * Get Group Settings
 * Gets the current device health monitoring preferences (including Icon Event Alerts notifications)
 * for the Lifesize group associated with this Nucleus Services session.
 */


function getGroupSettings() {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(dispatch) {
        var response, jsonParsed;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dispatch({
                  type: c.MONITORING_GET_GROUP_SETTINGS_BEGIN
                });
                _context3.prev = 1;
                _context3.next = 4;
                return dispatch((0, _proxy.proxyApiCall)(c.MONITORING_SERVICE_ENDPOINT, c.MONITORING_GROUP_SETTINGS_URL_SUFFIX, c.HTTP_GET));

              case 4:
                response = _context3.sent;
                jsonParsed = JSON.parse(response);
                dispatch({
                  type: c.MONITORING_GET_GROUP_SETTINGS_SUCCESS,
                  payload: jsonParsed
                });
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](1);
                dispatch({
                  type: c.MONITORING_GET_GROUP_SETTINGS_FAILURE,
                  payload: _context3.t0
                });

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 9]]);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
}
/**
 * Put Group Settings
 * Sets the current device health monitoring preferences (including Icon Event Alerts notifications)
 * for the Lifesize group associated with this Nucleus Services session.
 * @param {object} settings - settings: properties are...
 *   alertNotificationsEnabled
 *   alertNotificationsEmail
 *   alertNotificationsLocale
 */


function putGroupSettings(settings) {
  return (
    /*#__PURE__*/
    function () {
      var _ref4 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(dispatch, getState) {
        var oldSettings, newSettings, response, jsonParsed;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                oldSettings = (0, _pick.default)(getState().nucleus.groupSettings, ['alertNotificationsEmail', 'alertNotificationsEnabled', 'alertNotificationsLocale']); // note: all settings must be specified or they will be reset

                newSettings = (0, _objectSpread2.default)({}, oldSettings, settings);
                dispatch({
                  type: c.MONITORING_PUT_GROUP_SETTINGS_BEGIN,
                  payload: newSettings
                });
                _context4.prev = 3;
                _context4.next = 6;
                return dispatch((0, _proxy.proxyApiCall)(c.MONITORING_SERVICE_ENDPOINT, c.MONITORING_GROUP_SETTINGS_URL_SUFFIX, c.HTTP_PUT, newSettings));

              case 6:
                response = _context4.sent;
                jsonParsed = JSON.parse(response);
                dispatch({
                  type: c.MONITORING_PUT_GROUP_SETTINGS_SUCCESS,
                  payload: jsonParsed
                });
                _context4.next = 14;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](3);
                dispatch({
                  type: c.MONITORING_PUT_GROUP_SETTINGS_FAILURE,
                  payload: {
                    newSettings: newSettings,
                    error: _context4.t0
                  }
                });

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[3, 11]]);
      }));

      return function (_x4, _x5) {
        return _ref4.apply(this, arguments);
      };
    }()
  );
}

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usersGroupByMinutesRooms = exports.usersGroupByMinutesPersonal = exports.usersGroupByCallsRoom = exports.usersGroupByCallsPersonal = exports.usersFilteredByActiveTotal = exports.usageDetailsForUser = exports.usageDetailsForRoom = exports.streamSettings = exports.streamHistory = exports.streamDetails = exports.streamsByUsage = exports.streamsByList = exports.streamsAll = exports.conferences = exports.summaryDataSelector = exports.callsByPlanSelector = exports.callsByDaysDevicesSelector = exports.callsByDaySelector = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reselect = __webpack_require__(23);

var _dataWarehouse = __webpack_require__(273);

var access = __webpack_require__(8);

var dataWarehouseCallsByDay = function dataWarehouseCallsByDay(state) {
  return access(state, 'nucleus.dataWarehouse.callsByDay') || _dataWarehouse.initialState;
};

var callsByDaySelector = (0, _reselect.createSelector)(dataWarehouseCallsByDay, function (data) {
  return data;
});
exports.callsByDaySelector = callsByDaySelector;

var dataWarehouseCallsByDaysDevices = function dataWarehouseCallsByDaysDevices(state) {
  return access(state, 'nucleus.dataWarehouse.callsByDaysDevices') || _dataWarehouse.initialState;
};

var callsByDaysDevicesSelector = (0, _reselect.createSelector)(dataWarehouseCallsByDaysDevices, function (data) {
  return data;
});
exports.callsByDaysDevicesSelector = callsByDaysDevicesSelector;

var dataWarehouseCallsByPlan = function dataWarehouseCallsByPlan(state) {
  return access(state, 'nucleus.dataWarehouse.callsByPlan') || _dataWarehouse.initialState;
};

var callsByPlanSelector = (0, _reselect.createSelector)(dataWarehouseCallsByPlan, function (data) {
  return data;
});
exports.callsByPlanSelector = callsByPlanSelector;

var dataWarehouseSummaryData = function dataWarehouseSummaryData(state) {
  return access(state, 'nucleus.dataWarehouse.summaryData') || _dataWarehouse.initialState;
};

var summaryDataSelector = (0, _reselect.createSelector)(dataWarehouseSummaryData, function (data) {
  return data;
});
exports.summaryDataSelector = summaryDataSelector;

var dataWarehouseConferences = function dataWarehouseConferences(state) {
  return access(state, 'nucleus.dataWarehouse.conferences') || _dataWarehouse.initialState;
};

var conferences = (0, _reselect.createSelector)(dataWarehouseConferences, function (data) {
  return data;
});
exports.conferences = conferences;

var dataWarehouseStreamsAll = function dataWarehouseStreamsAll(state) {
  return access(state, 'nucleus.dataWarehouse.streamsAll') || _dataWarehouse.streamsInitialState;
};

var streamsAll = (0, _reselect.createSelector)(dataWarehouseStreamsAll, function (data) {
  return data;
});
exports.streamsAll = streamsAll;

var dataWarehouseStreamsByList = function dataWarehouseStreamsByList(state) {
  return access(state, 'nucleus.dataWarehouse.streamsByList') || _dataWarehouse.initialState;
};

var streamsByList = (0, _reselect.createSelector)(dataWarehouseStreamsByList, function (data) {
  return data;
});
exports.streamsByList = streamsByList;

var dataWarehouseStreamsByUsage = function dataWarehouseStreamsByUsage(state) {
  return access(state, 'nucleus.dataWarehouse.streamsByUsage') || _dataWarehouse.initialState;
};

var streamsByUsage = (0, _reselect.createSelector)(dataWarehouseStreamsByUsage, function (data) {
  return data;
});
exports.streamsByUsage = streamsByUsage;

var dataWarehouseStreamDetails = function dataWarehouseStreamDetails(state) {
  return access(state, 'nucleus.dataWarehouse.streamDetails') || _dataWarehouse.streamDetailsInitialState;
};

var streamDetails = (0, _reselect.createSelector)(dataWarehouseStreamDetails, function (data) {
  return data;
});
exports.streamDetails = streamDetails;

var dataWarehouseStreamHistory = function dataWarehouseStreamHistory(state) {
  return access(state, 'nucleus.dataWarehouse.streamHistory') || _dataWarehouse.streamsInitialState;
};

var streamHistory = (0, _reselect.createSelector)(dataWarehouseStreamHistory, function (data) {
  return data;
});
exports.streamHistory = streamHistory;

var dataWarehouseStreamSettings = function dataWarehouseStreamSettings(state) {
  return access(state, 'nucleus.dataWarehouse.streamSettings') || _dataWarehouse.streamSettingsInitialState;
};

var streamSettings = (0, _reselect.createSelector)(dataWarehouseStreamSettings, function (data) {
  return data;
});
exports.streamSettings = streamSettings;

var usersGroupByCallsPersonalState = function usersGroupByCallsPersonalState(state) {
  return access(state, 'nucleus.dataWarehouse.usersGroupByCallsPersonal') || _dataWarehouse.initialState;
};

var usersGroupByCallsPersonal = (0, _reselect.createSelector)(usersGroupByCallsPersonalState, function (data) {
  return data;
});
exports.usersGroupByCallsPersonal = usersGroupByCallsPersonal;

var usersGroupByCallsRoomState = function usersGroupByCallsRoomState(state) {
  return access(state, 'nucleus.dataWarehouse.usersGroupByCallsRooms') || _dataWarehouse.initialState;
};

var usersGroupByCallsRoom = (0, _reselect.createSelector)(usersGroupByCallsRoomState, function (data) {
  return data;
});
exports.usersGroupByCallsRoom = usersGroupByCallsRoom;

var usersGroupByMinutesPersonalState = function usersGroupByMinutesPersonalState(state) {
  return access(state, 'nucleus.dataWarehouse.usersGroupByMinutesPersonal') || _dataWarehouse.initialState;
};

var usersGroupByMinutesPersonal = (0, _reselect.createSelector)(usersGroupByMinutesPersonalState, function (data) {
  return data;
});
exports.usersGroupByMinutesPersonal = usersGroupByMinutesPersonal;

var usersGroupByMinutesRoomsState = function usersGroupByMinutesRoomsState(state) {
  return access(state, 'nucleus.dataWarehouse.usersGroupByMinutesRooms') || _dataWarehouse.initialState;
};

var usersGroupByMinutesRooms = (0, _reselect.createSelector)(usersGroupByMinutesRoomsState, function (data) {
  return data;
});
exports.usersGroupByMinutesRooms = usersGroupByMinutesRooms;

var usersFilteredByActiveTotalState = function usersFilteredByActiveTotalState(state) {
  return access(state, 'nucleus.dataWarehouse.usersFilterByActiveTotal') || _dataWarehouse.initialState;
};

var usersFilteredByActiveTotal = (0, _reselect.createSelector)(usersFilteredByActiveTotalState, function (data) {
  return data;
});
exports.usersFilteredByActiveTotal = usersFilteredByActiveTotal;

var usageDetailsForRoomState = function usageDetailsForRoomState(state) {
  return access(state, 'nucleus.dataWarehouse.usageDetailsForRoom') || {};
};

var usageDetailsForRoom = (0, _reselect.createSelector)(usageDetailsForRoomState, function (usageDetails) {
  return (0, _objectSpread2.default)({}, usageDetails, {
    data: access(usageDetails, 'data.data') || [],
    recordsFiltered: access(usageDetails, 'data.recordsFiltered') || 0,
    recordsTotal: access(usageDetails, 'data.recordsTotal') || 0
  });
});
exports.usageDetailsForRoom = usageDetailsForRoom;

var usageDetailsForUserState = function usageDetailsForUserState(state) {
  return access(state, 'nucleus.dataWarehouse.usageDetailsForUser') || {};
};

var usageDetailsForUser = (0, _reselect.createSelector)(usageDetailsForUserState, function (usageDetails) {
  return (0, _objectSpread2.default)({}, usageDetails, {
    data: access(usageDetails, 'data.data') || [],
    recordsFiltered: access(usageDetails, 'data.recordsFiltered') || 0,
    recordsTotal: access(usageDetails, 'data.recordsTotal') || 0
  });
});
exports.usageDetailsForUser = usageDetailsForUser;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usageDetailsForRoom = exports.usageDetailsForUser = exports.usersFilterByActiveTotalReducer = exports.usersGroupByMinutesRoomsReducer = exports.usersGroupByMinutesPersonalReducer = exports.usersGroupByCallsRoomsReducer = exports.usersGroupByCallsPersonalReducer = exports.streamHistory = exports.streamSettings = exports.streamSettingsInitialState = exports.streamDetails = exports.streamDetailsInitialState = exports.streamsAll = exports.streamsInitialState = exports.streamsByUsageReducer = exports.streamsByListReducer = exports.conferencesReducer = exports.summaryDataReducer = exports.callsByPlanReducer = exports.callsByDaysDevicesReducer = exports.callsByDaysReducer = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _isString = _interopRequireDefault(__webpack_require__(274));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer, _createReducer2, _createReducer3, _createReducer4, _createReducer5, _createReducer6, _createReducer7, _createReducer8, _createReducer9, _createReducer10, _createReducer11, _createReducer12, _createReducer13, _createReducer14, _createReducer15, _createReducer16, _createReducer17, _createReducer18;

var initialState = {
  data: {},
  error: null,
  isFetching: false
};
exports.initialState = initialState;
var callsByDaysReducer = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.DWH_FETCH_CALLS_BEGIN_DAYS, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.DWH_FETCH_CALLS_SUCCESS_DAYS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    data: action.payload,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.DWH_FETCH_CALLS_FAILED_DAYS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    error: action.payload
  });
}), _createReducer));
exports.callsByDaysReducer = callsByDaysReducer;
var callsByDaysDevicesReducer = (0, _reduxUtils.createReducer)(initialState, (_createReducer2 = {}, (0, _defineProperty2.default)(_createReducer2, c.DWH_FETCH_CALLS_BEGIN_DAYS_DEVICES, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer2, c.DWH_FETCH_CALLS_SUCCESS_DAYS_DEVICES, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    data: action.payload,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer2, c.DWH_FETCH_CALLS_FAILED_DAYS_DEVICES, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    error: action.payload
  });
}), _createReducer2));
exports.callsByDaysDevicesReducer = callsByDaysDevicesReducer;
var callsByPlanReducer = (0, _reduxUtils.createReducer)(initialState, (_createReducer3 = {}, (0, _defineProperty2.default)(_createReducer3, c.DWH_FETCH_CALLS_BEGIN_PLAN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer3, c.DWH_FETCH_CALLS_SUCCESS_PLAN, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    data: action.payload,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer3, c.DWH_FETCH_CALLS_FAILED_PLAN, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    error: action.payload
  });
}), _createReducer3));
exports.callsByPlanReducer = callsByPlanReducer;
var summaryDataReducer = (0, _reduxUtils.createReducer)(initialState, (_createReducer4 = {}, (0, _defineProperty2.default)(_createReducer4, c.DWH_FETCH_SUMMARY_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer4, c.DWH_FETCH_SUMMARY_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    data: action.payload,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer4, c.DWH_FETCH_SUMMARY_FAILED, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    error: action.payload
  });
}), _createReducer4));
exports.summaryDataReducer = summaryDataReducer;
var conferencesReducer = (0, _reduxUtils.createReducer)(initialState, (_createReducer5 = {}, (0, _defineProperty2.default)(_createReducer5, c.DWH_FETCH_CONFERENCES_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer5, c.DWH_FETCH_CONFERENCES_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    data: action.payload || {},
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer5, c.DWH_FETCH_CONFERENCES_FAILED, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    error: action.payload
  });
}), _createReducer5));
exports.conferencesReducer = conferencesReducer;
var streamsByListReducer = (0, _reduxUtils.createReducer)(initialState, (_createReducer6 = {}, (0, _defineProperty2.default)(_createReducer6, c.DWH_FETCH_STREAMS_BEGIN_LIST, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer6, c.DWH_FETCH_STREAMS_SUCCESS_LIST, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    data: action.payload,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer6, c.DWH_FETCH_STREAMS_FAILED_LIST, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    error: action.payload
  });
}), _createReducer6));
exports.streamsByListReducer = streamsByListReducer;
var streamsByUsageReducer = (0, _reduxUtils.createReducer)(initialState, (_createReducer7 = {}, (0, _defineProperty2.default)(_createReducer7, c.DWH_FETCH_STREAMS_BEGIN_USAGE, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer7, c.DWH_FETCH_STREAMS_SUCCESS_USAGE, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    data: action.payload,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer7, c.DWH_FETCH_STREAMS_FAILED_USAGE, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    error: action.payload
  });
}), _createReducer7));
exports.streamsByUsageReducer = streamsByUsageReducer;
var streamsInitialState = {
  data: [],
  error: null,
  isFetching: false
};
exports.streamsInitialState = streamsInitialState;
var streamsAll = (0, _reduxUtils.createReducer)(streamsInitialState, (_createReducer8 = {}, (0, _defineProperty2.default)(_createReducer8, c.DWH_ALL_STREAMS_REQUEST, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer8, c.DWH_ALL_STREAMS_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    data: action.payload || [],
    // [{ auth_type, is_live, is_published, link, meeting_id, viewer_count }]
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer8, c.DWH_ALL_STREAMS_FAILURE, function (state, action) {
  // error is expected to be a string
  var payload = (0, _safeAccess.default)(action, 'payload') || '';
  var errorString = (0, _isString.default)(payload) ? payload : (0, _safeAccess.default)(payload, 'message') || '';
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    error: errorString
  });
}), _createReducer8));
exports.streamsAll = streamsAll;
var streamDetailsInitialState = {
  metadata: {
    startDate: null,
    durationSeconds: 0,
    recordingUUID: '',
    streamName: '',
    viewerCount: 0
  },
  metadataError: null,
  metadataIsFetching: false,
  questions: [],
  questionsError: null,
  questionsIsFetching: false,
  viewers: [],
  viewersError: null,
  viewersIsFetching: false
};
exports.streamDetailsInitialState = streamDetailsInitialState;
var streamDetails = (0, _reduxUtils.createReducer)(streamDetailsInitialState, (_createReducer9 = {}, (0, _defineProperty2.default)(_createReducer9, c.DWH_STREAM_METADATA_REQUEST, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    metadataIsFetching: true,
    metadataError: null
  });
}), (0, _defineProperty2.default)(_createReducer9, c.DWH_STREAM_METADATA_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    metadataIsFetching: false,
    metadata: (0, _safeAccess.default)(action, 'payload.data[0]') || streamDetailsInitialState.metadata,
    metadataError: null
  });
}), (0, _defineProperty2.default)(_createReducer9, c.DWH_STREAM_METADATA_FAILURE, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    metadataIsFetching: false,
    metadataError: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer9, c.DWH_STREAM_QUESTIONS_REQUEST, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    questionsIsFetching: true,
    questionsError: null
  });
}), (0, _defineProperty2.default)(_createReducer9, c.DWH_STREAM_QUESTIONS_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    questionsIsFetching: false,
    questions: (0, _safeAccess.default)(action, 'payload') || [],
    // [{ author, index, message, role, time }]
    questionsError: null
  });
}), (0, _defineProperty2.default)(_createReducer9, c.DWH_STREAM_QUESTIONS_FAILURE, function (state, action) {
  // questionsError is expected to be a string
  var payload = (0, _safeAccess.default)(action, 'payload') || '';
  var errorString = (0, _isString.default)(payload) ? payload : (0, _safeAccess.default)(payload, 'message') || '';
  return (0, _objectSpread2.default)({}, state, {
    questionsIsFetching: false,
    questionsError: errorString
  });
}), (0, _defineProperty2.default)(_createReducer9, c.DWH_STREAM_VIEWERS_REQUEST, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    viewersIsFetching: true,
    viewersError: null
  });
}), (0, _defineProperty2.default)(_createReducer9, c.DWH_STREAM_VIEWERS_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    viewersIsFetching: false,
    viewers: (0, _safeAccess.default)(action, 'payload.data') || [],
    // [{ role, viewerName }]
    viewersError: null
  });
}), (0, _defineProperty2.default)(_createReducer9, c.DWH_STREAM_VIEWERS_FAILURE, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    viewersIsFetching: false,
    viewersError: action.payload
  });
}), _createReducer9));
exports.streamDetails = streamDetails;
var streamSettingsInitialState = {
  getError: null,
  setError: null,
  isFetching: false,
  isSetting: false,
  streamingEnabled: false,
  // is_live
  streamingPermissions: 'public',
  // auth_type (viewing permissions)
  streamingQuestionsAutoApprove: false,
  // auto_approve (auto-approve all incoming questions)
  streamingPermissionsPasscode: '',
  // pin
  streamingQuestionsEnabled: false,
  // qna
  streamingToken: '',
  // the client-generated token for the streaming url
  streamingUrl: '',
  // url
  extension: '',
  meeting_id: '',
  // uuid of the meeting
  org: ''
};
exports.streamSettingsInitialState = streamSettingsInitialState;
var streamSettings = (0, _reduxUtils.createReducer)(streamSettingsInitialState, (_createReducer10 = {}, (0, _defineProperty2.default)(_createReducer10, c.DWH_STREAM_SETTINGS_REQUEST, function () {
  return (0, _objectSpread2.default)({}, streamSettingsInitialState, {
    isFetching: true
  });
}), (0, _defineProperty2.default)(_createReducer10, c.DWH_STREAM_SETTINGS_SUCCESS, function (state, action) {
  var payload = (0, _safeAccess.default)(action, 'payload');
  var settings = {
    streamingEnabled: !!parseInt(payload.is_live),
    streamingPermissions: payload.auth_type,
    streamingQuestionsAutoApprove: !!parseInt(payload.auto_approve),
    streamingPermissionsPasscode: payload.pin || '',
    streamingQuestionsEnabled: !!parseInt(payload.qna),
    streamingToken: payload.token,
    streamingUrl: payload.url,
    extension: payload.extension,
    meeting_id: payload.meeting_id,
    org: payload.org
  };
  return (0, _objectSpread2.default)({}, streamSettingsInitialState, settings);
}), (0, _defineProperty2.default)(_createReducer10, c.DWH_STREAM_SETTINGS_FAILURE, function (state, action) {
  return (0, _objectSpread2.default)({}, streamSettingsInitialState, {
    getError: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer10, c.DWH_STREAM_SETTINGS_SET_REQUEST, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isSetting: true,
    setError: null
  });
}), (0, _defineProperty2.default)(_createReducer10, c.DWH_STREAM_SETTINGS_SET_SUCCESS, function (state, action) {
  var payload = (0, _safeAccess.default)(action, 'payload');
  var settings = {
    streamingEnabled: !!parseInt(payload.is_live),
    streamingPermissions: payload.auth_type,
    streamingQuestionsAutoApprove: !!parseInt(payload.auto_approve),
    streamingPermissionsPasscode: payload.pin || '',
    streamingQuestionsEnabled: !!parseInt(payload.qna),
    streamingToken: payload.token,
    streamingUrl: payload.url,
    extension: payload.extension,
    meeting_id: payload.meeting_id,
    org: payload.org
  };
  return (0, _objectSpread2.default)({}, state, settings, {
    isSetting: false,
    setError: null
  });
}), (0, _defineProperty2.default)(_createReducer10, c.DWH_STREAM_SETTINGS_SET_FAILURE, function (state, action) {
  // setError is expected to be a string
  var payload = (0, _safeAccess.default)(action, 'payload') || '';
  var errorString = (0, _isString.default)(payload) ? payload : (0, _safeAccess.default)(payload, 'message') || '';
  return (0, _objectSpread2.default)({}, state, {
    isSetting: false,
    setError: errorString
  });
}), _createReducer10));
exports.streamSettings = streamSettings;
var streamHistory = (0, _reduxUtils.createReducer)(streamsInitialState, (_createReducer11 = {}, (0, _defineProperty2.default)(_createReducer11, c.DWH_STREAM_HISTORY_REQUEST, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer11, c.DWH_STREAM_HISTORY_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    data: (0, _safeAccess.default)(action, 'payload.data') || [],
    // [{ durationSeconds, recordingUUID, startDate, streamName, viewerCount }]
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer11, c.DWH_STREAM_HISTORY_FAILURE, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    error: action.payload
  });
}), _createReducer11));
exports.streamHistory = streamHistory;
var usersGroupByCallsPersonalReducer = (0, _reduxUtils.createReducer)(initialState, (_createReducer12 = {}, (0, _defineProperty2.default)(_createReducer12, c.DWH_FETCH_USERS_GROUP_CALLS_PERSONAL_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer12, c.DWH_FETCH_USERS_GROUP_CALLS_PERSONAL_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    data: action.payload || {},
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer12, c.DWH_FETCH_USERS_GROUP_CALLS_PERSONAL_FAILED, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    error: action.payload
  });
}), _createReducer12));
exports.usersGroupByCallsPersonalReducer = usersGroupByCallsPersonalReducer;
var usersGroupByCallsRoomsReducer = (0, _reduxUtils.createReducer)(initialState, (_createReducer13 = {}, (0, _defineProperty2.default)(_createReducer13, c.DWH_FETCH_USERS_GROUP_CALLS_ROOMS_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer13, c.DWH_FETCH_USERS_GROUP_CALLS_ROOMS_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    data: action.payload || {},
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer13, c.DWH_FETCH_USERS_GROUP_CALLS_ROOMS_FAILED, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    error: action.payload
  });
}), _createReducer13));
exports.usersGroupByCallsRoomsReducer = usersGroupByCallsRoomsReducer;
var usersGroupByMinutesPersonalReducer = (0, _reduxUtils.createReducer)(initialState, (_createReducer14 = {}, (0, _defineProperty2.default)(_createReducer14, c.DWH_FETCH_USERS_GROUP_MINUTES_PERSONAL_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer14, c.DWH_FETCH_USERS_GROUP_MINUTES_PERSONAL_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    data: action.payload || {},
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer14, c.DWH_FETCH_USERS_GROUP_MINUTES_PERSONAL_FAILED, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    error: action.payload
  });
}), _createReducer14));
exports.usersGroupByMinutesPersonalReducer = usersGroupByMinutesPersonalReducer;
var usersGroupByMinutesRoomsReducer = (0, _reduxUtils.createReducer)(initialState, (_createReducer15 = {}, (0, _defineProperty2.default)(_createReducer15, c.DWH_FETCH_USERS_GROUP_MINUTES_ROOMS_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer15, c.DWH_FETCH_USERS_GROUP_MINUTES_ROOMS_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    data: action.payload || {},
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer15, c.DWH_FETCH_USERS_GROUP_MINUTES_ROOMS_FAILED, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    error: action.payload
  });
}), _createReducer15));
exports.usersGroupByMinutesRoomsReducer = usersGroupByMinutesRoomsReducer;
var usersFilterByActiveTotalReducer = (0, _reduxUtils.createReducer)(initialState, (_createReducer16 = {}, (0, _defineProperty2.default)(_createReducer16, c.DWH_FETCH_USERS_FILTER_ACTIVE_TOTAL_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer16, c.DWH_FETCH_USERS_FILTER_ACTIVE_TOTAL_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    data: action.payload || {},
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer16, c.DWH_FETCH_USERS_FILTER_ACTIVE_TOTAL_FAILED, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    error: action.payload
  });
}), _createReducer16));
exports.usersFilterByActiveTotalReducer = usersFilterByActiveTotalReducer;
var usageDetailsInitialState = {
  data: {},
  // { recordsFiltered: #, data: [{},...], draw: #, recordsTotal: # }
  dateEnd: null,
  dateStart: null,
  error: null,
  isFetching: false,
  selectedId: null // currently a name string, but hopefully we can move to UUID

};
var usageDetailsForUser = (0, _reduxUtils.createReducer)(usageDetailsInitialState, (_createReducer17 = {}, (0, _defineProperty2.default)(_createReducer17, c.AUTH_LOGOUT, function () {
  return usageDetailsInitialState;
}), (0, _defineProperty2.default)(_createReducer17, c.DWH_USAGEDETAILS_USER_REQUEST, function (state, action) {
  var _ref = (0, _safeAccess.default)(action, 'payload') || {},
      isNewRequest = _ref.isNewRequest,
      dateEnd = _ref.dateEnd,
      dateStart = _ref.dateStart,
      selectedId = _ref.selectedId;

  return (0, _objectSpread2.default)({}, state, {
    dateEnd: dateEnd,
    dateStart: dateStart,
    error: null,
    isFetching: true,
    data: isNewRequest ? {} : state.data,
    // don't clear on pagination request
    selectedId: selectedId
  });
}), (0, _defineProperty2.default)(_createReducer17, c.DWH_USAGEDETAILS_USER_SUCCESS, function (state, action) {
  var payload = (0, _safeAccess.default)(action, 'payload') || [];
  return (0, _objectSpread2.default)({}, state, {
    error: null,
    isFetching: false,
    data: payload
  });
}), (0, _defineProperty2.default)(_createReducer17, c.DWH_USAGEDETAILS_USER_FAILURE, function (state, action) {
  var payload = (0, _safeAccess.default)(action, 'payload') || '';
  return (0, _objectSpread2.default)({}, state, {
    error: payload,
    isFetching: false
  });
}), _createReducer17));
exports.usageDetailsForUser = usageDetailsForUser;
var usageDetailsForRoom = (0, _reduxUtils.createReducer)(usageDetailsInitialState, (_createReducer18 = {}, (0, _defineProperty2.default)(_createReducer18, c.AUTH_LOGOUT, function () {
  return usageDetailsInitialState;
}), (0, _defineProperty2.default)(_createReducer18, c.DWH_USAGEDETAILS_ROOM_REQUEST, function (state, action) {
  var _ref2 = (0, _safeAccess.default)(action, 'payload') || {},
      isNewRequest = _ref2.isNewRequest,
      dateEnd = _ref2.dateEnd,
      dateStart = _ref2.dateStart,
      selectedId = _ref2.selectedId;

  return (0, _objectSpread2.default)({}, state, {
    dateEnd: dateEnd,
    dateStart: dateStart,
    error: null,
    isFetching: true,
    data: isNewRequest ? {} : state.data,
    // don't clear on pagination request
    selectedId: selectedId
  });
}), (0, _defineProperty2.default)(_createReducer18, c.DWH_USAGEDETAILS_ROOM_SUCCESS, function (state, action) {
  var payload = (0, _safeAccess.default)(action, 'payload') || [];
  return (0, _objectSpread2.default)({}, state, {
    error: null,
    isFetching: false,
    data: payload
  });
}), (0, _defineProperty2.default)(_createReducer18, c.DWH_USAGEDETAILS_ROOM_FAILURE, function (state, action) {
  var payload = (0, _safeAccess.default)(action, 'payload') || '';
  return (0, _objectSpread2.default)({}, state, {
    error: payload,
    isFetching: false
  });
}), _createReducer18));
exports.usageDetailsForRoom = usageDetailsForRoom;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(88),
    isArray = __webpack_require__(43),
    isObjectLike = __webpack_require__(70);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.meetingShareProperties = exports.shareUpdate = exports.shareProperties = exports.videoProperties = exports.likeVideo = exports.addToWatchList = exports.deleteRecording = exports.relatedRecordings = exports.singleRecording = exports.myRecordings = exports.recordingWatchList = exports.selectFeedRequestIndex = exports.recordingsFeed = void 0;

var _reselect = __webpack_require__(23);

var _isEqual = _interopRequireDefault(__webpack_require__(180));

var createDeepEqualSelector = (0, _reselect.createSelectorCreator)(_reselect.defaultMemoize, _isEqual.default);

var access = __webpack_require__(8);
/** Non-exported utility function
 * Returns standardized selector for several recording API results.
 * @param stateData - Result data of call to cloudvideos API s
 */


var createRecordingSelector = function createRecordingSelector(stateData) {
  return (0, _reselect.createSelector)(stateData, function (r) {
    return r;
  });
};

var recordingsCarouselFeedResult = function recordingsCarouselFeedResult(state) {
  return access(state, 'nucleus.recordings.recordingsFeed') || {};
};

var recordingsFeed = createRecordingSelector(recordingsCarouselFeedResult);
exports.recordingsFeed = recordingsFeed;

var selectFeedRequestIndex = function selectFeedRequestIndex(state) {
  return access(state, 'nucleus.recordings.recordingsFeed.requestIndex');
};

exports.selectFeedRequestIndex = selectFeedRequestIndex;

var watchListResult = function watchListResult(state) {
  return access(state, 'nucleus.recordings.recordingWatchList') || {};
};

var recordingWatchList = createRecordingSelector(watchListResult);
exports.recordingWatchList = recordingWatchList;

var myRecordingsResult = function myRecordingsResult(state) {
  return access(state, 'nucleus.recordings.myRecordings') || {};
};

var myRecordings = createRecordingSelector(myRecordingsResult);
exports.myRecordings = myRecordings;

var singleRecordingResult = function singleRecordingResult(state) {
  return access(state, 'nucleus.recordings.recordingsSingle') || {};
};

var singleRecording = createDeepEqualSelector(singleRecordingResult, function (r) {
  return r;
});
exports.singleRecording = singleRecording;

var relatedRecordingsResult = function relatedRecordingsResult(state) {
  return access(state, 'nucleus.recordings.recordingsRelated') || {};
};

var relatedRecordings = createRecordingSelector(relatedRecordingsResult);
exports.relatedRecordings = relatedRecordings;

var deleteRecordingResult = function deleteRecordingResult(state) {
  return access(state, 'nucleus.recordings.recordingsDelete') || {};
};

var deleteRecording = (0, _reselect.createSelector)(deleteRecordingResult, function (r) {
  return r;
});
exports.deleteRecording = deleteRecording;

var addToWatchListResult = function addToWatchListResult(state) {
  return access(state, 'nucleus.recordings.recordingsAdd') || {};
};

var addToWatchList = (0, _reselect.createSelector)(addToWatchListResult, function (r) {
  return r;
});
exports.addToWatchList = addToWatchList;

var likeVideoResult = function likeVideoResult(state) {
  return access(state, 'nucleus.recordings.videoLike') || {};
};

var likeVideo = (0, _reselect.createSelector)(likeVideoResult, function (r) {
  return r;
});
exports.likeVideo = likeVideo;

var videoPropertiesState = function videoPropertiesState(state) {
  return access(state, 'nucleus.recordings.videoProperties') || {};
};

var videoProperties = (0, _reselect.createSelector)(videoPropertiesState, function (r) {
  return r;
});
exports.videoProperties = videoProperties;

var shareActionsResult = function shareActionsResult(state) {
  return access(state, 'nucleus.recordings.videoSharing') || {};
};

var shareProperties = (0, _reselect.createSelector)(shareActionsResult, function (r) {
  return r;
});
exports.shareProperties = shareProperties;

var updateShareResult = function updateShareResult(state) {
  return access(state, 'nucleus.recordings.videoSharing.updateShareProps') || {};
};

var shareUpdate = (0, _reselect.createSelector)(updateShareResult, function (r) {
  return r;
});
exports.shareUpdate = shareUpdate;

var meetingShareResult = function meetingShareResult(state) {
  return access(state, 'nucleus.recordings.meetingSharing') || {};
};

var meetingShareProperties = (0, _reselect.createSelector)(meetingShareResult, function (r) {
  return r;
});
exports.meetingShareProperties = meetingShareProperties;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectIsActive = selectIsActive;
exports.selectCanCurrentUserRemoteModerate = selectCanCurrentUserRemoteModerate;
exports.selectExtension = selectExtension;
exports.selectRevoked = selectRevoked;

var _get = _interopRequireDefault(__webpack_require__(11));

var C = _interopRequireWildcard(__webpack_require__(3));

var _userProfile = __webpack_require__(52);

var _contacts = __webpack_require__(35);

var _currentUser = __webpack_require__(37);

function selectIsActive(state) {
  return (0, _get.default)(selectRoot(state), 'isActive');
}

function selectCanCurrentUserRemoteModerate(state, props) {
  // get the current user role
  var currentUserRole = (0, _userProfile.selectRole)(state); // get the contact associated to the provided extension

  var contact = (0, _contacts.getContactByDialStringGenerator)(state)((0, _get.default)(props, 'extension')); // if the contact is not a MEETING, it cannot be remote moderated

  if ((0, _get.default)(contact, 'contactType') !== C.CONTACT_TYPE_MEETING) return false; // if admin or super user, they can remote moderate any MEETING in their group

  if (currentUserRole === C.USER_ROLE_ADMIN || currentUserRole === C.USER_ROLE_SUPER_USER) return true; // obtain the current user uuid

  var currentUserUUID = (0, _currentUser.getUserUUID)(state); // obtain meeting moderator uuid

  var moderatorUUID = (0, _get.default)(contact, 'moderator.uuid');
  return currentUserUUID === moderatorUUID;
}

function selectExtension(state) {
  return (0, _get.default)(selectRoot(state), 'extension');
}

function selectRevoked(state) {
  return (0, _get.default)(selectRoot(state), 'revoked');
}

function selectRoot(state) {
  return (0, _get.default)(state, 'nucleus.conference.remoteModeration');
}

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.userSettingsError = void 0;

var _reselect = __webpack_require__(23);

var access = __webpack_require__(8);
/** @module selectors/userSettings */


var userSettingsState = function userSettingsState(state) {
  return access(state, 'nucleus.userSettings') || {};
};

var userSettingsError = function userSettingsError(state) {
  return access(state, 'nucleus.userSettings.error');
};

exports.userSettingsError = userSettingsError;
var userSettings = (0, _reselect.createSelector)(userSettingsState, function (userSettings) {
  if (userSettings && userSettings.error) {
    return {
      name: null,
      email: null,
      localeCode: 'en',
      error: userSettings.error
    };
  }

  return {
    name: userSettings.name || null,
    email: userSettings.email || null,
    localeCode: access(userSettings, 'localeCode') || 'en',
    error: userSettings.error || null
  };
});
var _default = {
  userSettings: userSettings
};
exports.default = _default;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(34));

var _createClass2 = _interopRequireDefault(__webpack_require__(36));

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var AsyncQueue =
/*#__PURE__*/
function () {
  function AsyncQueue() {
    (0, _classCallCheck2.default)(this, AsyncQueue);
    this.isProcessing = false;
    this.queue = [];
  }

  (0, _createClass2.default)(AsyncQueue, [{
    key: "addToQueue",
    value: function () {
      var _addToQueue = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(func) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.queue.push(func);

                if (!this.isProcessing) {
                  this.processQueue();
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function addToQueue(_x) {
        return _addToQueue.apply(this, arguments);
      }

      return addToQueue;
    }()
  }, {
    key: "addToQueueWithResponse",
    value: function () {
      var _addToQueueWithResponse = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(func) {
        var _this = this;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", new Promise(function (resolve, reject) {
                  var handler =
                  /*#__PURE__*/
                  function () {
                    var _ref = (0, _asyncToGenerator2.default)(
                    /*#__PURE__*/
                    _regenerator.default.mark(function _callee2() {
                      return _regenerator.default.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              _context2.prev = 0;
                              _context2.t0 = resolve;
                              _context2.next = 4;
                              return func();

                            case 4:
                              _context2.t1 = _context2.sent;
                              (0, _context2.t0)(_context2.t1);
                              _context2.next = 11;
                              break;

                            case 8:
                              _context2.prev = 8;
                              _context2.t2 = _context2["catch"](0);
                              reject(_context2.t2);

                            case 11:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee2, null, [[0, 8]]);
                    }));

                    return function handler() {
                      return _ref.apply(this, arguments);
                    };
                  }();

                  _this.queue.push(handler);

                  if (!_this.isProcessing) {
                    _this.processQueue();
                  }
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function addToQueueWithResponse(_x2) {
        return _addToQueueWithResponse.apply(this, arguments);
      }

      return addToQueueWithResponse;
    }()
  }, {
    key: "processQueue",
    value: function () {
      var _processQueue = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4() {
        var toProcess;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                this.isProcessing = true;
                toProcess = this.queue.shift();

                if (!toProcess) {
                  _context4.next = 12;
                  break;
                }

                _context4.prev = 4;
                _context4.next = 7;
                return toProcess();

              case 7:
                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](4);

                _jsLogger.default.info('Exception processing queue', _context4.t0, toProcess);

              case 12:
                if (!this.queue.length) {
                  _context4.next = 16;
                  break;
                }

                _context4.next = 15;
                return this.processQueue();

              case 15:
                return _context4.abrupt("return", _context4.sent);

              case 16:
                this.isProcessing = false;
                _context4.next = 24;
                break;

              case 19:
                _context4.prev = 19;
                _context4.t1 = _context4["catch"](0);

                _jsLogger.default.info('Error in processQueue', _context4.t1, toProcess, this.queue);

                this.queue = [];
                this.isProcessing = false;

              case 24:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 19], [4, 9]]);
      }));

      function processQueue() {
        return _processQueue.apply(this, arguments);
      }

      return processQueue;
    }()
  }]);
  return AsyncQueue;
}();

exports.default = AsyncQueue;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(CONFIG) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mediaStatsUrl = void 0;

var _reselect = __webpack_require__(23);

var _account = __webpack_require__(91);

var mediaStatsUrl = (0, _reselect.createSelector)(_account.getAccountSettings, function (accountSettings) {
  if (accountSettings.mediaStatsUrl) return "".concat(accountSettings.mediaStatsUrl, "/v1/stats"); // default URL if media stats is overriden to be turned on, but we don't have a url provided by checkin.

  return CONFIG.calls.collectMediaStats ? "https://mediastats.".concat(CONFIG.environment, "/v1/stats") : null;
});
exports.mediaStatsUrl = mediaStatsUrl;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(29)["default"]))

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(228),
    baseKeysIn = __webpack_require__(555),
    isArrayLike = __webpack_require__(104);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(176),
    getPrototype = __webpack_require__(282),
    getSymbols = __webpack_require__(184),
    stubArray = __webpack_require__(227);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(230);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(34));

var _createClass2 = _interopRequireDefault(__webpack_require__(36));

var _createMediaStream = __webpack_require__(203);

function toggleMute(tracks) {
  var mute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  tracks.forEach(function (track) {
    // force all tracks to the inverse of the first if mute not specified
    if (mute === null) {
      mute = track.enabled;
    }

    track.enabled = !mute;
  }); // all tracks end up to the same state

  return mute;
}
/**
 * StreamHolder is a convenience class to keep track of the various media streams
 * and the dom elements associated with it.
 * @param {object} stream  This is the media stream that we are tracking
 * @param {Array} elements This is an array of VideoElement objects that are
 * associated with this stream.
 */


var StreamHolder =
/*#__PURE__*/
function () {
  function StreamHolder() {
    var stream = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var elements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    (0, _classCallCheck2.default)(this, StreamHolder);
    this.stream = stream;
    this.elements = elements;
    this.overlays = [];
  }

  (0, _createClass2.default)(StreamHolder, [{
    key: "attachTrack",
    value: function attachTrack(track, store) {
      var _this = this;

      if (!this.elements || !this.elements.length) return;
      (0, _createMediaStream.createMediaStream)().then(function (stream) {
        stream.addTrack(track);

        _this.updateStreamAndAttach(stream, store);
      });
    }
    /**
     * This toggles the video tracks 'enabled' setting.
     * If not mute argument is provided, it will invert the enabled setting the tracks.
     * If there are multiple tracks with different settings, and mute is not provided,
     * it will set all tracks enabled property to the same way it sets the first track.
     * @param {Boolean} mute - set to true if the video tracks should be disabled.
     */

  }, {
    key: "toggleVideoMute",
    value: function toggleVideoMute(mute) {
      if (!this.stream) return false;
      return toggleMute(this.stream.getVideoTracks(), mute);
    }
    /**
     * This toggles the audio tracks 'enabled' setting.
     * If not mute argument is provided, it will invert the enabled setting the tracks.
     * If there are multiple tracks with different settings, and mute is not provided,
     * it will set all tracks enabled property to the same way it sets the first track.
     * @param {Boolean} mute - set to true if the audio tracks should be disabled.
     */

  }, {
    key: "toggleAudioMute",
    value: function toggleAudioMute(mute) {
      if (!this.stream) return false;
      return toggleMute(this.stream.getAudioTracks(), mute);
    }
    /**
     * This toggles the mute setting of the video elements associated with this stream
     */

  }, {
    key: "toggleElementMute",
    value: function toggleElementMute(mute) {
      // now mute and unmute related video elements
      if (Array.isArray(this.elements)) {
        this.elements.forEach(function (e) {
          return e.setMute(mute);
        });
      }

      this.toggleAudioMute(mute);
    }
  }, {
    key: "setElementOutputDevice",
    value: function setElementOutputDevice(deviceId) {
      if (Array.isArray(this.elements)) {
        this.elements.forEach(function (e) {
          return e.setOutputDevice(deviceId);
        });
      }
    }
    /**
     * This adds the stream object to the StreamHolder. Also attempts to attach the
     * stream to all of it's consistuent elements.
     */

  }, {
    key: "updateStreamAndAttach",
    value: function updateStreamAndAttach() {
      var stream = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var store = arguments.length > 1 ? arguments[1] : undefined;
      if (!this.elements || !this.elements.length) return;
      this.stream = stream;
      this.attachElements(store);
    }
    /**
     * Attach the MediaStream object to the specified DOM video element.
     * Will repeatedly attempt to attach the stream to the element
     */

  }, {
    key: "attachStreamToElement",
    value: function attachStreamToElement(element, store) {
      var _this2 = this;

      // do not attempt to attach (or loop any more)
      // if we no longer have a stream or the video-element object has been removed
      if (!this.stream || !element) return;

      if (!element.attachToStream(this.stream, store)) {
        setTimeout(function () {
          _this2.attachStreamToElement(element, store);

          if (element.isMuted()) {
            _this2.toggleAudioMute(true);
          }
        }, 200);
      }
    }
    /**
     * Add element objects to the elements array and then attempt to attach it
     * to the stream.
     */

  }, {
    key: "addElements",
    value: function addElements(elements, store) {
      var _this3 = this;

      if (Array.isArray(elements) && Array.isArray(this.elements)) {
        elements.forEach(function (element) {
          if (!_this3.elements.find(function (e) {
            return e.elementId === element.elementId;
          })) {
            _this3.elements.push(element);
          }
        });
        this.elements.map(function (element) {
          return _this3.attachStreamToElement(element, store);
        });
      }
    }
    /**
     * Add an element object to the elements array and then attempt to attach it
     * to the stream.
     */

  }, {
    key: "addElement",
    value: function addElement(element, store) {
      if (element && Array.isArray(this.elements)) {
        if (!this.elements.find(function (e) {
          return e.elementId === element.elementId;
        })) {
          this.elements.push(element);
        }

        this.attachStreamToElement(this.elements[this.elements.length - 1], store);
      }
    }
    /**
     * If the stream media object exists, and there are VideoElements in the elements
     * array, iterate through and attempt to attach the stream to each video element.
     */

  }, {
    key: "attachElements",
    value: function attachElements(store) {
      var _this4 = this;

      if (this.stream && Array.isArray(this.elements) && this.elements.length > 0) {
        this.elements.map(function (element) {
          return _this4.attachStreamToElement(element, store);
        });
      }
    }
    /**
     * First detach the video elements from this stream.
     * Then, if stop is true, stop playing all of the tracks on the stream.
     * Lastly, set the stream to be null.
     */

  }, {
    key: "detachElements",
    value: function detachElements() {
      if (Array.isArray(this.elements) && this.elements.length > 0) {
        this.elements.map(function (element) {
          return element.detachFromStream();
        });
      }

      this.stream = null;
    }
  }, {
    key: "reAttachToOutputDevice",
    value: function reAttachToOutputDevice() {
      if (this.stream && Array.isArray(this.elements) && this.elements.length > 0) {
        this.elements.map(function (element) {
          return element.reAttachToOutputDevice();
        });
      }
    }
  }]);
  return StreamHolder;
}();

var _default = StreamHolder;
exports.default = _default;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(34));

var _createClass2 = _interopRequireDefault(__webpack_require__(36));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _stream = __webpack_require__(80);

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

function attachOutputDevice(element, sinkId) {
  if (element && sinkId && element.sinkId !== undefined) {
    return element.setSinkId(sinkId).catch(function (err) {
      // just log issues for now
      _jsLogger.default.warn('Unable to set output source:', err);
    });
  }

  return Promise.resolve();
}
/**
 * VideoElement
 * An object with the following params
 * @param {String} elementId The string id of the video element that we want to
 * attach a stream to.
 * @param {bool} videoMuted  Flag to indicate whether this stream should have
 * it's audio muted at all times, or not.
 */


var VideoElement =
/*#__PURE__*/
function () {
  function VideoElement() {
    var elementId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var videoMuted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    (0, _classCallCheck2.default)(this, VideoElement);
    this.isAttached = false;
    this.trackId = null;
    this.elementId = elementId;
    this.videoMuted = videoMuted;
  }

  (0, _createClass2.default)(VideoElement, [{
    key: "isMuted",
    value: function isMuted() {
      return this.videoMuted;
    }
    /**
     * Will mute or unmute the video element based on the passed in value
     */

  }, {
    key: "setMute",
    value: function setMute(mute) {
      this.videoMuted = mute;
      var video = document.getElementById(this.elementId);

      if (video) {
        video.muted = mute;
      }
    }
  }, {
    key: "setOutputDevice",
    value: function setOutputDevice(deviceId) {
      this.outputDeviceId = deviceId;
      var element = document.getElementById(this.elementId);
      attachOutputDevice(element, deviceId);
    }
    /**
     * Attach the MediaStream object to this DOM video element.
     * Will only attempt to attach if the stream object is not null, if there is
     * an elementId and also if the video element is not already attached to a stream.
     */

  }, {
    key: "attachToStream",
    value: function attachToStream(stream, store) {
      var tracks = stream.getVideoTracks();
      var video = document.getElementById(this.elementId);
      if (!video) return false;
      this.isAttached = !!tracks.length;
      this.trackId = (0, _safeAccess.default)(tracks, '[0].id');
      attachMediaStream(video, stream); // eslint-disable-line no-undef

      attachOutputDevice(video, this.outputDeviceId);
      video.muted = this.videoMuted;
      video.onloadedmetadata =
      /*#__PURE__*/
      (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return video.play();

              case 3:
                if (store) {
                  store.dispatch((0, _stream.videoPlaying)(video));
                }

                _context.next = 10;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);

                _jsLogger.default.warn('Unable to play video:', _context.t0);

                if (store) {
                  store.dispatch((0, _stream.videoBlocked)(video));
                }

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 6]]);
      }));
      return true;
    }
    /**
     * Detatch the stream from the DOM element if it exists.
     * Always set isAttached to false as we know we want to indicate that this DOM
     * element (if it exists in the DOM at the time or not) has no media stream
     * associated with it.
     */

  }, {
    key: "detachFromStream",
    value: function detachFromStream() {
      if (this.isAttached && this.elementId) {
        var video = document.getElementById(this.elementId);

        if (video) {
          video.removeAttribute('src');
        }
      }

      this.isAttached = false;
      this.trackId = null;
    }
  }, {
    key: "reAttachToOutputDevice",
    value: function reAttachToOutputDevice() {
      var _this = this;

      var video = document.getElementById(this.elementId);
      if (!video) return false;
      attachOutputDevice(video, 'default').then(function () {
        return attachOutputDevice(video, _this.outputDeviceId);
      });
    }
  }]);
  return VideoElement;
}();

var _default = VideoElement;
exports.default = _default;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actions = __webpack_require__(286);

exports['default'] = function (engine) {
    return function (store) {
        var dispatchLoad = function dispatchLoad(state) {
            return store.dispatch((0, _actions.load)(state));
        };
        return engine.load().then(function (newState) {
            dispatchLoad(newState);
            return newState;
        });
    };
};

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.save = exports.load = undefined;

var _reduxActions = __webpack_require__(630);

var _constants = __webpack_require__(129);

var constants = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var load = exports.load = (0, _reduxActions.createAction)(constants.LOAD);
var save = exports.save = (0, _reduxActions.createAction)(constants.SAVE);

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = handleAction;
function isFunction(val) {
  return typeof val === 'function';
}

function handleAction(type, reducers, defaultState) {
  var typeValue = isFunction(type) ? type.toString() : type;

  return function () {
    var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
    var action = arguments[1];

    // If action type does not match, return previous state
    if (action.type !== typeValue) return state;

    var handlerKey = action.error === true ? 'throw' : 'next';

    // If function is passed instead of map, use as reducer
    if (isFunction(reducers)) {
      reducers.next = reducers.throw = reducers;
    }

    // Otherwise, assume an action map was passed
    var reducer = reducers[handlerKey];

    return isFunction(reducer) ? reducer(state, action) : state;
  };
}

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(289);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(205);

var _lodash4 = _interopRequireDefault(_lodash3);

var _actions = __webpack_require__(286);

var _constants = __webpack_require__(129);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function swallow() {}

function warnAboutConfusingFiltering(blacklist, whitelist) {
    blacklist.filter(function (item) {
        return whitelist.indexOf(item) !== -1;
    }).forEach(function (item) {
        console.warn( // eslint-disable-line no-console
        '[redux-storage] Action ' + item + ' is on BOTH black- and whitelist.' + ' This is most likely a mistake!');
    });
}

function isValidAction(action) {
    var isFunc = (0, _lodash2['default'])(action);
    var isObj = (0, _lodash4['default'])(action);
    var hasType = isObj && action.hasOwnProperty('type');

    if (!isFunc && isObj && hasType) {
        return true;
    }

    if (false) {}

    return false;
}

function handleWhitelist(action, actionWhitelist) {
    if (Array.isArray(actionWhitelist)) {
        return actionWhitelist.length === 0 ? true // Don't filter if the whitelist is empty
        : actionWhitelist.indexOf(action.type) !== -1;
    }

    // actionWhitelist is a function that returns true or false
    return actionWhitelist(action);
}

exports['default'] = function (engine) {
    var actionBlacklist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var actionWhitelist = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    // Also don't save if we process our own actions
    var blacklistedActions = [].concat(_toConsumableArray(actionBlacklist), [_constants.LOAD, _constants.SAVE]);

    if (false) {}

    return function (_ref) {
        var dispatch = _ref.dispatch,
            getState = _ref.getState;

        return function (next) {
            return function (action) {
                var result = next(action);

                if (!isValidAction(action)) {
                    return result;
                }

                var isOnBlacklist = blacklistedActions.indexOf(action.type) !== -1;
                var isOnWhitelist = handleWhitelist(action, actionWhitelist);

                // Skip blacklisted actions
                if (!isOnBlacklist && isOnWhitelist) {
                    (function () {
                        var saveState = getState();
                        var saveAction = (0, _actions.save)(saveState);

                        if (false) {}

                        var dispatchSave = function dispatchSave() {
                            return dispatch(saveAction);
                        };
                        engine.save(saveState).then(dispatchSave)['catch'](swallow);
                    })();
                }

                return result;
            };
        };
    };
};

/***/ }),
/* 289 */
/***/ (function(module, exports) {

/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    nullTag = '[object Null]',
    proxyTag = '[object Proxy]',
    undefinedTag = '[object Undefined]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isFunction;


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reduxStorageMergerSimple = __webpack_require__(635);

var _reduxStorageMergerSimple2 = _interopRequireDefault(_reduxStorageMergerSimple);

var _constants = __webpack_require__(129);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = function (reducer) {
    var merger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _reduxStorageMergerSimple2['default'];

    return function (state, action) {
        return reducer(action.type === _constants.LOAD ? merger(state, action.payload) : state, action);
    };
};

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.galaxyReportLocalMute = galaxyReportLocalMute;
exports.galaxyReportLocalVideoMute = galaxyReportLocalVideoMute;
exports.activeConferenceNotificationHandler = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var c = _interopRequireWildcard(__webpack_require__(3));

var _guid = _interopRequireDefault(__webpack_require__(72));

var proxyActions = _interopRequireWildcard(__webpack_require__(21));

var _call = __webpack_require__(50);

function galaxyReportLocalMute(muted) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch, getState) {
        var conferenceId, participantId, data;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                conferenceId = (0, _safeAccess.default)(getState(), 'nucleus.galaxy.call.conferenceId');
                participantId = (0, _safeAccess.default)(getState(), 'nucleus.galaxy.call.callId');
                data = {
                  messageId: _guid.default.create(),
                  event: muted ? c.GALAXY_COMMAND_LOCAL_MUTE : c.GALAXY_COMMAND_LOCAL_UN_MUTE,
                  participantId: participantId,
                  conferenceId: conferenceId
                };
                return _context.abrupt("return", dispatch(proxyActions.proxyApiCall(c.GALAXY_TOPIC_USER_ACTIONS, c.GALAXY_WAMP_URI_SUFFIX_DEFAULT, c.GALAXY_HTTP_METHOD_DEFAULT, data)));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
} // pass through to MCU :(


function galaxyReportLocalVideoMute(muted) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch, getState) {
        var state, sourceId, callId, data;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                state = getState();
                sourceId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.sourceId');
                callId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.callId');
                data = {
                  callId: callId,
                  command: c.GALAXY_COMMAND_PASSTHROUGH,
                  passThroughType: muted ? c.GALAXY_PASSTHROUGH_LOCAL_VIDEO_MUTE : c.GALAXY_PASSTHROUGH_LOCAL_VIDEO_UNMUTE,
                  sourceId: sourceId
                };
                return _context2.abrupt("return", dispatch((0, _call.postCallCommandGalaxy)(data)));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}

var activeConferenceNotificationHandler = function activeConferenceNotificationHandler(_ref3) {
  var eventType = _ref3.event,
      events = _ref3.events;
  return function (dispatch) {
    return Promise.all(events.map(
    /*#__PURE__*/
    function () {
      var _ref4 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(e) {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.t0 = eventType;
                _context3.next = _context3.t0 === c.ACTIVE_CONFERENCE_NOTIFICATION ? 3 : 4;
                break;

              case 3:
                return _context3.abrupt("return", dispatch({
                  type: c.CONTACT_PARTICIPANT_COUNT_UPDATE,
                  payload: e
                }));

              case 4:
                _jsLogger.default.warn('Unknown Conf Notice Event: ', eventType);

                return _context3.abrupt("return");

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x5) {
        return _ref4.apply(this, arguments);
      };
    }()));
  };
};

exports.activeConferenceNotificationHandler = activeConferenceNotificationHandler;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(CONFIG) {

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClientAndPersistor = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _apolloClient = __webpack_require__(679);

var _apolloCacheInmemory = __webpack_require__(698);

var _apolloLinkBatchHttp = __webpack_require__(699);

var _apolloLinkError = __webpack_require__(681);

var _apolloLink = __webpack_require__(40);

var _apolloCachePersist = __webpack_require__(697);

var _apolloLinkLogger = _interopRequireDefault(__webpack_require__(682));

var _proxy = __webpack_require__(21);

var _fragmentTypes = _interopRequireDefault(__webpack_require__(685));

var _localforage = _interopRequireDefault(__webpack_require__(686));

var fragmentMatcher = new _apolloCacheInmemory.IntrospectionFragmentMatcher({
  introspectionQueryResultData: _fragmentTypes.default
});
var cache = new _apolloCacheInmemory.InMemoryCache({
  fragmentMatcher: fragmentMatcher,
  dataIdFromObject: function dataIdFromObject(o) {
    if (o.__typename === 'ChatRoom') return "ChatRoom:".concat(o.uuid);
    return o.uuid || o.UUID || o.serialNumber || o.deviceUUID;
  }
});
/**
 * This func constructs a new client using the nucleus dispatch and storage
 * options. Nucleus does this internally to handle gql actions. If you
 * need the nucleus apollo client in your client app, you should probably
 * use the getClient below;
 */

var initClient =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee2(dispatch, storage) {
    var _ref5;

    var gqlMetaHeaderOverride, gqlOverride, localHttpLinkConfig, client, noop, fakePersist, storageMethod, persistor;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            gqlMetaHeaderOverride = CONFIG.graphql.metaHeaderOverride;
            gqlOverride = CONFIG.graphql.URLOverride || !!gqlMetaHeaderOverride;
            localHttpLinkConfig = gqlOverride && {
              uri: gqlOverride === true ? 'http://local.lifesizecloudbeta.com:4000' : gqlOverride,
              credentials: 'include',
              headers: (0, _objectSpread2.default)({}, gqlMetaHeaderOverride ? {
                'X-Lifesize-Meta': gqlMetaHeaderOverride
              } : {})
            };
            client = new _apolloClient.ApolloClient({
              link: _apolloLink.ApolloLink.from((CONFIG.graphql.logging ? [_apolloLinkLogger.default] : []).concat([(0, _apolloLinkError.onError)(function (_ref2) {
                var graphQLErrors = _ref2.graphQLErrors,
                    networkError = _ref2.networkError;

                if (graphQLErrors) {
                  graphQLErrors.map(function (_ref3) {
                    var message = _ref3.message,
                        locations = _ref3.locations,
                        path = _ref3.path;
                    return _jsLogger.default.error('[GraphQL error]: Message:', message, 'Location:', locations, 'Path:', path);
                  });
                }

                if (networkError) {
                  _jsLogger.default.error('[Network error]:', networkError);
                }
              }), new _apolloLinkBatchHttp.BatchHttpLink(localHttpLinkConfig || {
                fetch: (0, _proxy.proxyGqlFetch)(dispatch)
              })])),
              cache: cache
            });

            noop =
            /*#__PURE__*/
            function () {
              var _ref4 = (0, _asyncToGenerator2.default)(
              /*#__PURE__*/
              _regenerator.default.mark(function _callee() {
                return _regenerator.default.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function noop() {
                return _ref4.apply(this, arguments);
              };
            }();

            fakePersist = {
              restore: noop,
              persist: noop,
              purge: noop
            };

            if (!((storage === null || storage === void 0 ? void 0 : storage.storageApolloCache) === null)) {
              _context2.next = 8;
              break;
            }

            return _context2.abrupt("return", [client, fakePersist]);

          case 8:
            storageMethod = (storage === null || storage === void 0 ? void 0 : storage.storageApolloCache) || _localforage.default;
            persistor = new _apolloCachePersist.CachePersistor({
              cache: client.cache,
              storage: storageMethod,
              maxSize: (_ref5 = storage === null || storage === void 0 ? void 0 : storage.cacheSize) !== null && _ref5 !== void 0 ? _ref5 : 1024 * 1024 * 5 // 5mb cache limit.

            });
            _context2.prev = 10;
            _context2.next = 13;
            return persistor.restore();

          case 13:
            return _context2.abrupt("return", [client, persistor]);

          case 16:
            _context2.prev = 16;
            _context2.t0 = _context2["catch"](10);
            persistor.remove();

            _jsLogger.default.warn('Apollo Caching has been disabled:', _context2.t0);

            return _context2.abrupt("return", [client, fakePersist]);

          case 21:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[10, 16]]);
  }));

  return function initClient(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var clientArray;
/**
 * Creates, and caches an apollo client for use both within and outside of
 * nucleus.
 */

var getClientAndPersistor =
/*#__PURE__*/
function () {
  var _ref6 = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee3(dispatch, storage) {
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!clientArray) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return", clientArray);

          case 2:
            clientArray = initClient(dispatch, storage);
            return _context3.abrupt("return", clientArray);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getClientAndPersistor(_x3, _x4) {
    return _ref6.apply(this, arguments);
  };
}();

exports.getClientAndPersistor = getClientAndPersistor;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(29)["default"]))

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var utils_namespaceObject = {};
__webpack_require__.r(utils_namespaceObject);
__webpack_require__.d(utils_namespaceObject, "TASK", function() { return utils["e" /* TASK */]; });
__webpack_require__.d(utils_namespaceObject, "SAGA_ACTION", function() { return utils["c" /* SAGA_ACTION */]; });
__webpack_require__.d(utils_namespaceObject, "noop", function() { return utils["u" /* noop */]; });
__webpack_require__.d(utils_namespaceObject, "is", function() { return utils["q" /* is */]; });
__webpack_require__.d(utils_namespaceObject, "deferred", function() { return utils["l" /* deferred */]; });
__webpack_require__.d(utils_namespaceObject, "arrayOfDeffered", function() { return utils["g" /* arrayOfDeffered */]; });
__webpack_require__.d(utils_namespaceObject, "createMockTask", function() { return utils["j" /* createMockTask */]; });
__webpack_require__.d(utils_namespaceObject, "cloneableGenerator", function() { return utils["i" /* cloneableGenerator */]; });
__webpack_require__.d(utils_namespaceObject, "asEffect", function() { return io["d" /* asEffect */]; });
__webpack_require__.d(utils_namespaceObject, "CHANNEL_END", function() { return CHANNEL_END; });

// EXTERNAL MODULE: ./node_modules/redux-saga/es/internal/utils.js
var utils = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/redux-saga/es/internal/channel.js
var internal_channel = __webpack_require__(32);

// EXTERNAL MODULE: ./node_modules/redux-saga/es/internal/scheduler.js
var scheduler = __webpack_require__(118);

// EXTERNAL MODULE: ./node_modules/redux-saga/es/internal/io.js
var io = __webpack_require__(18);

// EXTERNAL MODULE: ./node_modules/redux-saga/es/internal/buffers.js
var buffers = __webpack_require__(76);

// CONCATENATED MODULE: ./node_modules/redux-saga/es/internal/proc.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }







var NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';

var CHANNEL_END = {
  toString: function toString() {
    return '@@redux-saga/CHANNEL_END';
  }
};
var TASK_CANCEL = {
  toString: function toString() {
    return '@@redux-saga/TASK_CANCEL';
  }
};

var matchers = {
  wildcard: function wildcard() {
    return utils["r" /* kTrue */];
  },
  default: function _default(pattern) {
    return (typeof pattern === 'undefined' ? 'undefined' : _typeof(pattern)) === 'symbol' ? function (input) {
      return input.type === pattern;
    } : function (input) {
      return input.type === String(pattern);
    };
  },
  array: function array(patterns) {
    return function (input) {
      return patterns.some(function (p) {
        return matcher(p)(input);
      });
    };
  },
  predicate: function predicate(_predicate) {
    return function (input) {
      return _predicate(input);
    };
  }
};

function matcher(pattern) {
  // prettier-ignore
  return (pattern === '*' ? matchers.wildcard : utils["q" /* is */].array(pattern) ? matchers.array : utils["q" /* is */].stringableFunc(pattern) ? matchers.default : utils["q" /* is */].func(pattern) ? matchers.predicate : matchers.default)(pattern);
}

/**
  Used to track a parent task and its forks
  In the new fork model, forked tasks are attached by default to their parent
  We model this using the concept of Parent task && main Task
  main task is the main flow of the current Generator, the parent tasks is the
  aggregation of the main tasks + all its forked tasks.
  Thus the whole model represents an execution tree with multiple branches (vs the
  linear execution tree in sequential (non parallel) programming)

  A parent tasks has the following semantics
  - It completes if all its forks either complete or all cancelled
  - If it's cancelled, all forks are cancelled as well
  - It aborts if any uncaught error bubbles up from forks
  - If it completes, the return value is the one returned by the main task
**/
function forkQueue(name, mainTask, cb) {
  var tasks = [],
      result = void 0,
      completed = false;
  addTask(mainTask);

  function abort(err) {
    cancelAll();
    cb(err, true);
  }

  function addTask(task) {
    tasks.push(task);
    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      Object(utils["w" /* remove */])(tasks, task);
      task.cont = utils["u" /* noop */];
      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }
        if (!tasks.length) {
          completed = true;
          cb(result);
        }
      }
    };
    // task.cont.cancel = task.cancel
  }

  function cancelAll() {
    if (completed) {
      return;
    }
    completed = true;
    tasks.forEach(function (t) {
      t.cont = utils["u" /* noop */];
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: function getTasks() {
      return tasks;
    },
    taskNames: function taskNames() {
      return tasks.map(function (t) {
        return t.name;
      });
    }
  };
}

function createTaskIterator(_ref) {
  var context = _ref.context,
      fn = _ref.fn,
      args = _ref.args;

  if (utils["q" /* is */].iterator(fn)) {
    return fn;
  }

  // catch synchronous failures; see #152 and #441
  var result = void 0,
      error = void 0;
  try {
    result = fn.apply(context, args);
  } catch (err) {
    error = err;
  }

  // i.e. a generator function returns an iterator
  if (utils["q" /* is */].iterator(result)) {
    return result;
  }

  // do not bubble up synchronous failures for detached forks
  // instead create a failed task. See #152 and #441
  return error ? Object(utils["t" /* makeIterator */])(function () {
    throw error;
  }) : Object(utils["t" /* makeIterator */])(function () {
    var pc = void 0;
    var eff = { done: false, value: result };
    var ret = function ret(value) {
      return { done: true, value: value };
    };
    return function (arg) {
      if (!pc) {
        pc = true;
        return eff;
      } else {
        return ret(arg);
      }
    };
  }());
}

var wrapHelper = function wrapHelper(helper) {
  return { fn: helper };
};

function proc(iterator) {
  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return utils["u" /* noop */];
  };
  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : utils["u" /* noop */];
  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : utils["u" /* noop */];
  var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';
  var cont = arguments[8];

  Object(utils["h" /* check */])(iterator, utils["q" /* is */].iterator, NOT_ITERATOR_ERROR);

  var effectsString = '[...effects]';
  var runParallelEffect = Object(utils["n" /* deprecate */])(runAllEffect, Object(utils["z" /* updateIncentive */])(effectsString, 'all(' + effectsString + ')'));

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;

  var log = logger || utils["s" /* log */];
  var logError = function logError(err) {
    var message = err.sagaStack;

    if (!message && err.stack) {
      message = err.stack.split('\n')[0].indexOf(err.message) !== -1 ? err.stack : 'Error: ' + err.message + '\n' + err.stack;
    }

    log('error', 'uncaught at ' + name, message || err.message || err);
  };
  var stdChannel = Object(internal_channel["f" /* stdChannel */])(subscribe);
  var taskContext = Object.create(parentContext);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/
  next.cancel = utils["u" /* noop */];

  /**
    Creates a new task descriptor for this generator, We'll also create a main task
    to track the main flow (besides other forked tasks)
  **/
  var task = newTask(parentEffectId, name, iterator, cont);
  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
  var taskQueue = forkQueue(name, mainTask, end);

  /**
    cancellation of the main task. We'll simply resume the Generator with a Cancel
  **/
  function cancelMain() {
    if (mainTask.isRunning && !mainTask.isCancelled) {
      mainTask.isCancelled = true;
      next(TASK_CANCEL);
    }
  }

  /**
    This may be called by a parent generator to trigger/propagate cancellation
    cancel all pending tasks (including the main task), then end the current task.
     Cancellation propagates down to the whole execution tree holded by this Parent task
    It's also propagated to all joiners of this task and their execution tree/joiners
     Cancellation is noop for terminated/Cancelled tasks tasks
  **/
  function cancel() {
    /**
      We need to check both Running and Cancelled status
      Tasks can be Cancelled but still Running
    **/
    if (iterator._isRunning && !iterator._isCancelled) {
      iterator._isCancelled = true;
      taskQueue.cancelAll();
      /**
        Ending with a Never result will propagate the Cancellation to all joiners
      **/
      end(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/
  cont && (cont.cancel = cancel);

  // tracks the running status
  iterator._isRunning = true;

  // kicks up the generator
  next();

  // then return the task descriptor to the caller
  return task;

  /**
    This is the generator driver
    It's a recursive async/continuation function which calls itself
    until the generator terminates or throws
  **/
  function next(arg, isErr) {
    // Preventive measure. If we end up here, then there is really something wrong
    if (!mainTask.isRunning) {
      throw new Error('Trying to resume an already finished generator');
    }

    try {
      var result = void 0;
      if (isErr) {
        result = iterator.throw(arg);
      } else if (arg === TASK_CANCEL) {
        /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.isCancelled = true;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/
        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/
        result = utils["q" /* is */].func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
      } else if (arg === CHANNEL_END) {
        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = utils["q" /* is */].func(iterator.return) ? iterator.return() : { done: true };
      } else {
        result = iterator.next(arg);
      }

      if (!result.done) {
        runEffect(result.value, parentEffectId, '', next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        mainTask.isMainRunning = false;
        mainTask.cont && mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.isCancelled) {
        logError(error);
      }
      mainTask.isMainRunning = false;
      mainTask.cont(error, true);
    }
  }

  function end(result, isErr) {
    iterator._isRunning = false;
    stdChannel.close();
    if (!isErr) {
      iterator._result = result;
      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
    } else {
      if (result instanceof Error) {
        Object.defineProperty(result, 'sagaStack', {
          value: 'at ' + name + ' \n ' + (result.sagaStack || result.stack),
          configurable: true
        });
      }
      if (!task.cont) {
        if (result instanceof Error && onError) {
          onError(result);
        } else {
          logError(result);
        }
      }
      iterator._error = result;
      iterator._isAborted = true;
      iterator._deferredEnd && iterator._deferredEnd.reject(result);
    }
    task.cont && task.cont(result, isErr);
    task.joiners.forEach(function (j) {
      return j.cb(result, isErr);
    });
    task.joiners = null;
  }

  function runEffect(effect, parentEffectId) {
    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var cb = arguments[3];

    var effectId = Object(utils["y" /* uid */])();
    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });

    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/
    var effectSettled = void 0;

    // Completion callback passed to the appropriate effect runner
    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = utils["u" /* noop */]; // defensive measure
      if (sagaMonitor) {
        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
      }
      cb(res, isErr);
    }
    // tracks down the current cancel
    currCb.cancel = utils["u" /* noop */];

    // setup cancellation logic on the parent cb
    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      /**
        propagates cancel downward
        catch uncaught cancellations errors; since we can no longer call the completion
        callback, log errors raised during cancellations into the console
      **/
      try {
        currCb.cancel();
      } catch (err) {
        logError(err);
      }
      currCb.cancel = utils["u" /* noop */]; // defensive measure

      sagaMonitor && sagaMonitor.effectCancelled(effectId);
    };

    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      for completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    var data = void 0;
    // prettier-ignore
    return (
      // Non declarative effect
      utils["q" /* is */].promise(effect) ? resolvePromise(effect, currCb) : utils["q" /* is */].helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : utils["q" /* is */].iterator(effect) ? resolveIterator(effect, effectId, name, currCb)

      // declarative effects
      : utils["q" /* is */].array(effect) ? runParallelEffect(effect, effectId, currCb) : (data = io["d" /* asEffect */].take(effect)) ? runTakeEffect(data, currCb) : (data = io["d" /* asEffect */].put(effect)) ? runPutEffect(data, currCb) : (data = io["d" /* asEffect */].all(effect)) ? runAllEffect(data, effectId, currCb) : (data = io["d" /* asEffect */].race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = io["d" /* asEffect */].call(effect)) ? runCallEffect(data, effectId, currCb) : (data = io["d" /* asEffect */].cps(effect)) ? runCPSEffect(data, currCb) : (data = io["d" /* asEffect */].fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = io["d" /* asEffect */].join(effect)) ? runJoinEffect(data, currCb) : (data = io["d" /* asEffect */].cancel(effect)) ? runCancelEffect(data, currCb) : (data = io["d" /* asEffect */].select(effect)) ? runSelectEffect(data, currCb) : (data = io["d" /* asEffect */].actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = io["d" /* asEffect */].flush(effect)) ? runFlushEffect(data, currCb) : (data = io["d" /* asEffect */].cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = io["d" /* asEffect */].getContext(effect)) ? runGetContextEffect(data, currCb) : (data = io["d" /* asEffect */].setContext(effect)) ? runSetContextEffect(data, currCb) : /* anything else returned as is */currCb(effect)
    );
  }

  function resolvePromise(promise, cb) {
    var cancelPromise = promise[utils["a" /* CANCEL */]];
    if (utils["q" /* is */].func(cancelPromise)) {
      cb.cancel = cancelPromise;
    } else if (utils["q" /* is */].func(promise.abort)) {
      cb.cancel = function () {
        return promise.abort();
      };
      // TODO: add support for the fetch API, whenever they get around to
      // adding cancel support
    }
    promise.then(cb, function (error) {
      return cb(error, true);
    });
  }

  function resolveIterator(iterator, effectId, name, cb) {
    proc(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
  }

  function runTakeEffect(_ref2, cb) {
    var channel = _ref2.channel,
        pattern = _ref2.pattern,
        maybe = _ref2.maybe;

    channel = channel || stdChannel;
    var takeCb = function takeCb(inp) {
      return inp instanceof Error ? cb(inp, true) : Object(internal_channel["e" /* isEnd */])(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
    };
    try {
      channel.take(takeCb, matcher(pattern));
    } catch (err) {
      return cb(err, true);
    }
    cb.cancel = takeCb.cancel;
  }

  function runPutEffect(_ref3, cb) {
    var channel = _ref3.channel,
        action = _ref3.action,
        resolve = _ref3.resolve;

    /**
      Schedule the put in case another saga is holding a lock.
      The put will be executed atomically. ie nested puts will execute after
      this put has terminated.
    **/
    Object(scheduler["a" /* asap */])(function () {
      var result = void 0;
      try {
        result = (channel ? channel.put : dispatch)(action);
      } catch (error) {
        // If we have a channel or `put.resolve` was used then bubble up the error.
        if (channel || resolve) return cb(error, true);
        logError(error);
      }

      if (resolve && utils["q" /* is */].promise(result)) {
        resolvePromise(result, cb);
      } else {
        return cb(result);
      }
    });
    // Put effects are non cancellables
  }

  function runCallEffect(_ref4, effectId, cb) {
    var context = _ref4.context,
        fn = _ref4.fn,
        args = _ref4.args;

    var result = void 0;
    // catch synchronous failures; see #152
    try {
      result = fn.apply(context, args);
    } catch (error) {
      return cb(error, true);
    }
    return utils["q" /* is */].promise(result) ? resolvePromise(result, cb) : utils["q" /* is */].iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
  }

  function runCPSEffect(_ref5, cb) {
    var context = _ref5.context,
        fn = _ref5.fn,
        args = _ref5.args;

    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb

    // catch synchronous failures; see #152
    try {
      var cpsCb = function cpsCb(err, res) {
        return utils["q" /* is */].undef(err) ? cb(res) : cb(err, true);
      };
      fn.apply(context, args.concat(cpsCb));
      if (cpsCb.cancel) {
        cb.cancel = function () {
          return cpsCb.cancel();
        };
      }
    } catch (error) {
      return cb(error, true);
    }
  }

  function runForkEffect(_ref6, effectId, cb) {
    var context = _ref6.context,
        fn = _ref6.fn,
        args = _ref6.args,
        detached = _ref6.detached;

    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });

    try {
      Object(scheduler["c" /* suspend */])();
      var _task = proc(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : utils["u" /* noop */]);

      if (detached) {
        cb(_task);
      } else {
        if (taskIterator._isRunning) {
          taskQueue.addTask(_task);
          cb(_task);
        } else if (taskIterator._error) {
          taskQueue.abort(taskIterator._error);
        } else {
          cb(_task);
        }
      }
    } finally {
      Object(scheduler["b" /* flush */])();
    }
    // Fork effects are non cancellables
  }

  function runJoinEffect(t, cb) {
    if (t.isRunning()) {
      var joiner = { task: task, cb: cb };
      cb.cancel = function () {
        return Object(utils["w" /* remove */])(t.joiners, joiner);
      };
      t.joiners.push(joiner);
    } else {
      t.isAborted() ? cb(t.error(), true) : cb(t.result());
    }
  }

  function runCancelEffect(taskToCancel, cb) {
    if (taskToCancel === utils["d" /* SELF_CANCELLATION */]) {
      taskToCancel = task;
    }
    if (taskToCancel.isRunning()) {
      taskToCancel.cancel();
    }
    cb();
    // cancel effects are non cancellables
  }

  function runAllEffect(effects, effectId, cb) {
    var keys = Object.keys(effects);

    if (!keys.length) {
      return cb(utils["q" /* is */].array(effects) ? [] : {});
    }

    var completedCount = 0;
    var completed = void 0;
    var results = {};
    var childCbs = {};

    function checkEffectEnd() {
      if (completedCount === keys.length) {
        completed = true;
        cb(utils["q" /* is */].array(effects) ? utils["f" /* array */].from(_extends({}, results, { length: keys.length })) : results);
      }
    }

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }
        if (isErr || Object(internal_channel["e" /* isEnd */])(res) || res === CHANNEL_END || res === TASK_CANCEL) {
          cb.cancel();
          cb(res, isErr);
        } else {
          results[key] = res;
          completedCount++;
          checkEffectEnd();
        }
      };
      chCbAtKey.cancel = utils["u" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };

    keys.forEach(function (key) {
      return runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runRaceEffect(effects, effectId, cb) {
    var completed = void 0;
    var keys = Object.keys(effects);
    var childCbs = {};

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }

        if (isErr) {
          // Race Auto cancellation
          cb.cancel();
          cb(res, true);
        } else if (!Object(internal_channel["e" /* isEnd */])(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
          var _response;

          cb.cancel();
          completed = true;
          var response = (_response = {}, _response[key] = res, _response);
          cb(utils["q" /* is */].array(effects) ? [].slice.call(_extends({}, response, { length: keys.length })) : response);
        }
      };
      chCbAtKey.cancel = utils["u" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      // prevents unnecessary cancellation
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };
    keys.forEach(function (key) {
      if (completed) {
        return;
      }
      runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runSelectEffect(_ref7, cb) {
    var selector = _ref7.selector,
        args = _ref7.args;

    try {
      var state = selector.apply(undefined, [getState()].concat(args));
      cb(state);
    } catch (error) {
      cb(error, true);
    }
  }

  function runChannelEffect(_ref8, cb) {
    var pattern = _ref8.pattern,
        buffer = _ref8.buffer;

    var match = matcher(pattern);
    match.pattern = pattern;
    cb(Object(internal_channel["d" /* eventChannel */])(subscribe, buffer || buffers["a" /* buffers */].fixed(), match));
  }

  function runCancelledEffect(data, cb) {
    cb(!!mainTask.isCancelled);
  }

  function runFlushEffect(channel, cb) {
    channel.flush(cb);
  }

  function runGetContextEffect(prop, cb) {
    cb(taskContext[prop]);
  }

  function runSetContextEffect(props, cb) {
    utils["v" /* object */].assign(taskContext, props);
    cb();
  }

  function newTask(id, name, iterator, cont) {
    var _done, _ref9, _mutatorMap;

    iterator._deferredEnd = null;
    return _ref9 = {}, _ref9[utils["e" /* TASK */]] = true, _ref9.id = id, _ref9.name = name, _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
      if (iterator._deferredEnd) {
        return iterator._deferredEnd.promise;
      } else {
        var def = Object(utils["l" /* deferred */])();
        iterator._deferredEnd = def;
        if (!iterator._isRunning) {
          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
        }
        return def.promise;
      }
    }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
      return iterator._isRunning;
    }, _ref9.isCancelled = function isCancelled() {
      return iterator._isCancelled;
    }, _ref9.isAborted = function isAborted() {
      return iterator._isAborted;
    }, _ref9.result = function result() {
      return iterator._result;
    }, _ref9.error = function error() {
      return iterator._error;
    }, _ref9.setContext = function setContext(props) {
      Object(utils["h" /* check */])(props, utils["q" /* is */].object, Object(utils["k" /* createSetContextWarning */])('task', props));
      utils["v" /* object */].assign(taskContext, props);
    }, _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
  }
}
// CONCATENATED MODULE: ./node_modules/redux-saga/es/internal/runSaga.js



var RUN_SAGA_SIGNATURE = 'runSaga(storeInterface, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ': saga argument must be a Generator function!';

function runSaga(storeInterface, saga) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var iterator = void 0;

  if (utils["q" /* is */].iterator(storeInterface)) {
    if (false) {}
    iterator = storeInterface;
    storeInterface = saga;
  } else {
    Object(utils["h" /* check */])(saga, utils["q" /* is */].func, NON_GENERATOR_ERR);
    iterator = saga.apply(undefined, args);
    Object(utils["h" /* check */])(iterator, utils["q" /* is */].iterator, NON_GENERATOR_ERR);
  }

  var _storeInterface = storeInterface,
      subscribe = _storeInterface.subscribe,
      dispatch = _storeInterface.dispatch,
      getState = _storeInterface.getState,
      context = _storeInterface.context,
      sagaMonitor = _storeInterface.sagaMonitor,
      logger = _storeInterface.logger,
      onError = _storeInterface.onError;


  var effectId = Object(utils["y" /* uid */])();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || utils["u" /* noop */];
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || utils["u" /* noop */];
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || utils["u" /* noop */];
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || utils["u" /* noop */];
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || utils["u" /* noop */];

    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
  }

  var task = proc(iterator, subscribe, Object(utils["A" /* wrapSagaDispatch */])(dispatch), getState, context, { sagaMonitor: sagaMonitor, logger: logger, onError: onError }, effectId, saga.name);

  if (sagaMonitor) {
    sagaMonitor.effectResolved(effectId, task);
  }

  return task;
}
// CONCATENATED MODULE: ./node_modules/redux-saga/es/internal/middleware.js
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






function sagaMiddlewareFactory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref$context = _ref.context,
      context = _ref$context === undefined ? {} : _ref$context,
      options = _objectWithoutProperties(_ref, ['context']);

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;


  if (utils["q" /* is */].func(options)) {
    if (true) {
      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
    } else {}
  }

  if (logger && !utils["q" /* is */].func(logger)) {
    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
  }

  if (false) {}

  if (onError && !utils["q" /* is */].func(onError)) {
    throw new Error('`options.onError` passed to the Saga middleware is not a function!');
  }

  if (options.emitter && !utils["q" /* is */].func(options.emitter)) {
    throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
  }

  function sagaMiddleware(_ref2) {
    var getState = _ref2.getState,
        dispatch = _ref2.dispatch;

    var sagaEmitter = Object(internal_channel["c" /* emitter */])();
    sagaEmitter.emit = (options.emitter || utils["o" /* ident */])(sagaEmitter.emit);

    sagaMiddleware.run = runSaga.bind(null, {
      context: context,
      subscribe: sagaEmitter.subscribe,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor,
      logger: logger,
      onError: onError
    });

    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }
        var result = next(action); // hit reducers
        sagaEmitter.emit(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
  };

  sagaMiddleware.setContext = function (props) {
    Object(utils["h" /* check */])(props, utils["q" /* is */].object, Object(utils["k" /* createSetContextWarning */])('sagaMiddleware', props));
    utils["v" /* object */].assign(context, props);
  };

  return sagaMiddleware;
}
// EXTERNAL MODULE: ./node_modules/redux-saga/es/internal/sagaHelpers/index.js + 4 modules
var sagaHelpers = __webpack_require__(87);

// EXTERNAL MODULE: ./node_modules/redux-saga/es/effects.js + 1 modules
var es_effects = __webpack_require__(148);

// CONCATENATED MODULE: ./node_modules/redux-saga/es/utils.js



// CONCATENATED MODULE: ./node_modules/redux-saga/es/index.js
/* concated harmony reexport runSaga */__webpack_require__.d(__webpack_exports__, "runSaga", function() { return runSaga; });
/* concated harmony reexport END */__webpack_require__.d(__webpack_exports__, "END", function() { return internal_channel["a" /* END */]; });
/* concated harmony reexport eventChannel */__webpack_require__.d(__webpack_exports__, "eventChannel", function() { return internal_channel["d" /* eventChannel */]; });
/* concated harmony reexport channel */__webpack_require__.d(__webpack_exports__, "channel", function() { return internal_channel["b" /* channel */]; });
/* concated harmony reexport buffers */__webpack_require__.d(__webpack_exports__, "buffers", function() { return buffers["a" /* buffers */]; });
/* concated harmony reexport takeEvery */__webpack_require__.d(__webpack_exports__, "takeEvery", function() { return sagaHelpers["a" /* takeEvery */]; });
/* concated harmony reexport takeLatest */__webpack_require__.d(__webpack_exports__, "takeLatest", function() { return sagaHelpers["c" /* takeLatest */]; });
/* concated harmony reexport throttle */__webpack_require__.d(__webpack_exports__, "throttle", function() { return sagaHelpers["e" /* throttle */]; });
/* concated harmony reexport delay */__webpack_require__.d(__webpack_exports__, "delay", function() { return utils["m" /* delay */]; });
/* concated harmony reexport CANCEL */__webpack_require__.d(__webpack_exports__, "CANCEL", function() { return utils["a" /* CANCEL */]; });
/* concated harmony reexport detach */__webpack_require__.d(__webpack_exports__, "detach", function() { return io["i" /* detach */]; });
/* concated harmony reexport effects */__webpack_require__.d(__webpack_exports__, "effects", function() { return es_effects; });
/* concated harmony reexport utils */__webpack_require__.d(__webpack_exports__, "utils", function() { return utils_namespaceObject; });

/* harmony default export */ var es = __webpack_exports__["default"] = (sagaMiddlewareFactory);













/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return symbolObservablePonyfill; });
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(680).Observable;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = { cmp: opts };
    var cycles = (typeof opts.cycles === 'boolean') ? opts.cycles : false;

    var cmp = opts.cmp && (function (f) {
        return function (node) {
            return function (a, b) {
                var aobj = { key: a, value: node[a] };
                var bobj = { key: b, value: node[b] };
                return f(aobj, bobj);
            };
        };
    })(opts.cmp);

    var seen = [];
    return (function stringify (node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') {
            node = node.toJSON();
        }

        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);

        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for (i = 0; i < node.length; i++) {
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }

        if (node === null) return 'null';

        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }

        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for (i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = stringify(node[key]);

            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    })(data);
};


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.print = print;

var _visitor = __webpack_require__(49);

var _blockString = __webpack_require__(261);

/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */
function print(ast) {
  return (0, _visitor.visit)(ast, {
    leave: printDocASTReducer
  });
} // TODO: provide better type coverage in future


var printDocASTReducer = {
  Name: function Name(node) {
    return node.value;
  },
  Variable: function Variable(node) {
    return '$' + node.name;
  },
  // Document
  Document: function Document(node) {
    return join(node.definitions, '\n\n') + '\n';
  },
  OperationDefinition: function OperationDefinition(node) {
    var op = node.operation;
    var name = node.name;
    var varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
    var directives = join(node.directives, ' ');
    var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
    // the query short form.

    return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], ' ');
  },
  VariableDefinition: function VariableDefinition(_ref) {
    var variable = _ref.variable,
        type = _ref.type,
        defaultValue = _ref.defaultValue,
        directives = _ref.directives;
    return variable + ': ' + type + wrap(' = ', defaultValue) + wrap(' ', join(directives, ' '));
  },
  SelectionSet: function SelectionSet(_ref2) {
    var selections = _ref2.selections;
    return block(selections);
  },
  Field: function Field(_ref3) {
    var alias = _ref3.alias,
        name = _ref3.name,
        args = _ref3.arguments,
        directives = _ref3.directives,
        selectionSet = _ref3.selectionSet;
    return join([wrap('', alias, ': ') + name + wrap('(', join(args, ', '), ')'), join(directives, ' '), selectionSet], ' ');
  },
  Argument: function Argument(_ref4) {
    var name = _ref4.name,
        value = _ref4.value;
    return name + ': ' + value;
  },
  // Fragments
  FragmentSpread: function FragmentSpread(_ref5) {
    var name = _ref5.name,
        directives = _ref5.directives;
    return '...' + name + wrap(' ', join(directives, ' '));
  },
  InlineFragment: function InlineFragment(_ref6) {
    var typeCondition = _ref6.typeCondition,
        directives = _ref6.directives,
        selectionSet = _ref6.selectionSet;
    return join(['...', wrap('on ', typeCondition), join(directives, ' '), selectionSet], ' ');
  },
  FragmentDefinition: function FragmentDefinition(_ref7) {
    var name = _ref7.name,
        typeCondition = _ref7.typeCondition,
        variableDefinitions = _ref7.variableDefinitions,
        directives = _ref7.directives,
        selectionSet = _ref7.selectionSet;
    return (// Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(name).concat(wrap('(', join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat(wrap('', join(directives, ' '), ' ')) + selectionSet
    );
  },
  // Value
  IntValue: function IntValue(_ref8) {
    var value = _ref8.value;
    return value;
  },
  FloatValue: function FloatValue(_ref9) {
    var value = _ref9.value;
    return value;
  },
  StringValue: function StringValue(_ref10, key) {
    var value = _ref10.value,
        isBlockString = _ref10.block;
    return isBlockString ? (0, _blockString.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
  },
  BooleanValue: function BooleanValue(_ref11) {
    var value = _ref11.value;
    return value ? 'true' : 'false';
  },
  NullValue: function NullValue() {
    return 'null';
  },
  EnumValue: function EnumValue(_ref12) {
    var value = _ref12.value;
    return value;
  },
  ListValue: function ListValue(_ref13) {
    var values = _ref13.values;
    return '[' + join(values, ', ') + ']';
  },
  ObjectValue: function ObjectValue(_ref14) {
    var fields = _ref14.fields;
    return '{' + join(fields, ', ') + '}';
  },
  ObjectField: function ObjectField(_ref15) {
    var name = _ref15.name,
        value = _ref15.value;
    return name + ': ' + value;
  },
  // Directive
  Directive: function Directive(_ref16) {
    var name = _ref16.name,
        args = _ref16.arguments;
    return '@' + name + wrap('(', join(args, ', '), ')');
  },
  // Type
  NamedType: function NamedType(_ref17) {
    var name = _ref17.name;
    return name;
  },
  ListType: function ListType(_ref18) {
    var type = _ref18.type;
    return '[' + type + ']';
  },
  NonNullType: function NonNullType(_ref19) {
    var type = _ref19.type;
    return type + '!';
  },
  // Type System Definitions
  SchemaDefinition: function SchemaDefinition(_ref20) {
    var directives = _ref20.directives,
        operationTypes = _ref20.operationTypes;
    return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
  },
  OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
    var operation = _ref21.operation,
        type = _ref21.type;
    return operation + ': ' + type;
  },
  ScalarTypeDefinition: addDescription(function (_ref22) {
    var name = _ref22.name,
        directives = _ref22.directives;
    return join(['scalar', name, join(directives, ' ')], ' ');
  }),
  ObjectTypeDefinition: addDescription(function (_ref23) {
    var name = _ref23.name,
        interfaces = _ref23.interfaces,
        directives = _ref23.directives,
        fields = _ref23.fields;
    return join(['type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),
  FieldDefinition: addDescription(function (_ref24) {
    var name = _ref24.name,
        args = _ref24.arguments,
        type = _ref24.type,
        directives = _ref24.directives;
    return name + (hasMultilineItems(args) ? wrap('(\n', indent(join(args, '\n')), '\n)') : wrap('(', join(args, ', '), ')')) + ': ' + type + wrap(' ', join(directives, ' '));
  }),
  InputValueDefinition: addDescription(function (_ref25) {
    var name = _ref25.name,
        type = _ref25.type,
        defaultValue = _ref25.defaultValue,
        directives = _ref25.directives;
    return join([name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')], ' ');
  }),
  InterfaceTypeDefinition: addDescription(function (_ref26) {
    var name = _ref26.name,
        directives = _ref26.directives,
        fields = _ref26.fields;
    return join(['interface', name, join(directives, ' '), block(fields)], ' ');
  }),
  UnionTypeDefinition: addDescription(function (_ref27) {
    var name = _ref27.name,
        directives = _ref27.directives,
        types = _ref27.types;
    return join(['union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  }),
  EnumTypeDefinition: addDescription(function (_ref28) {
    var name = _ref28.name,
        directives = _ref28.directives,
        values = _ref28.values;
    return join(['enum', name, join(directives, ' '), block(values)], ' ');
  }),
  EnumValueDefinition: addDescription(function (_ref29) {
    var name = _ref29.name,
        directives = _ref29.directives;
    return join([name, join(directives, ' ')], ' ');
  }),
  InputObjectTypeDefinition: addDescription(function (_ref30) {
    var name = _ref30.name,
        directives = _ref30.directives,
        fields = _ref30.fields;
    return join(['input', name, join(directives, ' '), block(fields)], ' ');
  }),
  DirectiveDefinition: addDescription(function (_ref31) {
    var name = _ref31.name,
        args = _ref31.arguments,
        repeatable = _ref31.repeatable,
        locations = _ref31.locations;
    return 'directive @' + name + (hasMultilineItems(args) ? wrap('(\n', indent(join(args, '\n')), '\n)') : wrap('(', join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + join(locations, ' | ');
  }),
  SchemaExtension: function SchemaExtension(_ref32) {
    var directives = _ref32.directives,
        operationTypes = _ref32.operationTypes;
    return join(['extend schema', join(directives, ' '), block(operationTypes)], ' ');
  },
  ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
    var name = _ref33.name,
        directives = _ref33.directives;
    return join(['extend scalar', name, join(directives, ' ')], ' ');
  },
  ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
    var name = _ref34.name,
        interfaces = _ref34.interfaces,
        directives = _ref34.directives,
        fields = _ref34.fields;
    return join(['extend type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },
  InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
    var name = _ref35.name,
        directives = _ref35.directives,
        fields = _ref35.fields;
    return join(['extend interface', name, join(directives, ' '), block(fields)], ' ');
  },
  UnionTypeExtension: function UnionTypeExtension(_ref36) {
    var name = _ref36.name,
        directives = _ref36.directives,
        types = _ref36.types;
    return join(['extend union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  },
  EnumTypeExtension: function EnumTypeExtension(_ref37) {
    var name = _ref37.name,
        directives = _ref37.directives,
        values = _ref37.values;
    return join(['extend enum', name, join(directives, ' '), block(values)], ' ');
  },
  InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
    var name = _ref38.name,
        directives = _ref38.directives,
        fields = _ref38.fields;
    return join(['extend input', name, join(directives, ' '), block(fields)], ' ');
  }
};

function addDescription(cb) {
  return function (node) {
    return join([node.description, cb(node)], '\n');
  };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */


function join(maybeArray, separator) {
  return maybeArray ? maybeArray.filter(function (x) {
    return x;
  }).join(separator || '') : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */


function block(array) {
  return array && array.length !== 0 ? '{\n' + indent(join(array, '\n')) + '\n}' : '';
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise
 * print an empty string.
 */


function wrap(start, maybeString, end) {
  return maybeString ? start + maybeString + (end || '') : '';
}

function indent(maybeString) {
  return maybeString && '  ' + maybeString.replace(/\n/g, '\n  ');
}

function isMultiline(string) {
  return string.indexOf('\n') !== -1;
}

function hasMultilineItems(maybeArray) {
  return maybeArray && maybeArray.some(isMultiline);
}


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "proxyGqlFetch", {
  enumerable: true,
  get: function get() {
    return proxyActions.proxyGqlFetch;
  }
});
Object.defineProperty(exports, "servicesActions", {
  enumerable: true,
  get: function get() {
    return _services.servicesActions;
  }
});
Object.defineProperty(exports, "iconActions", {
  enumerable: true,
  get: function get() {
    return _icon.default;
  }
});
Object.defineProperty(exports, "loggerActions", {
  enumerable: true,
  get: function get() {
    return _logger.default;
  }
});
Object.defineProperty(exports, "availabilityActions", {
  enumerable: true,
  get: function get() {
    return _availability.default;
  }
});
Object.defineProperty(exports, "environmentSelectors", {
  enumerable: true,
  get: function get() {
    return _environment.default;
  }
});
Object.defineProperty(exports, "ssoSelectors", {
  enumerable: true,
  get: function get() {
    return _sso.default;
  }
});
Object.defineProperty(exports, "userSettingsSelectors", {
  enumerable: true,
  get: function get() {
    return _userSettings2.default;
  }
});
Object.defineProperty(exports, "createRtcMiddleware", {
  enumerable: true,
  get: function get() {
    return _rtc.createRtcMiddleware;
  }
});
Object.defineProperty(exports, "createReduxStore", {
  enumerable: true,
  get: function get() {
    return _createReduxStore.default;
  }
});
Object.defineProperty(exports, "loadPersistentStore", {
  enumerable: true,
  get: function get() {
    return _createReduxStore.loadPersistentStore;
  }
});
Object.defineProperty(exports, "getApolloClient", {
  enumerable: true,
  get: function get() {
    return _client.getClientAndPersistor;
  }
});
exports.pluginActions = exports.nucleusConstants = exports.contactModels = exports.DateUtils = exports.moderatorSelectors = exports.usersSelectors = exports.userProfileSelectors = exports.servicesSelectors = exports.searchSelectors = exports.schedulingSelectors = exports.recordingsSelectors = exports.recordingsAuthSelectors = exports.pstnNumbersSelectors = exports.proxySelectors = exports.pairedDevicesSelectors = exports.networkSelectors = exports.meetingsSelectors = exports.mediaSelectors = exports.localizationSelectors = exports.groupSettingsSelectors = exports.featureSelectors = exports.endpointSelectors = exports.dataWarehouseSelectors = exports.currentUserSelectors = exports.contactSelectors = exports.contactCRUDSelectors = exports.conferenceRemoteModeratorsSelectors = exports.remoteModerationSelectors = exports.conferenceRemoteModerationSelectors = exports.conferenceParticipantsSelectors = exports.conferenceSelectors = exports.cloudInfoSelectors = exports.chatSelectors = exports.callSelectors = exports.callHistorySelectors = exports.authSelectors = exports.activeCallSelectors = exports.accountSelectors = exports.userProfileActions = exports.usersActions = exports.userSettingsActions = exports.tokenActions = exports.streamActions = exports.remoteModeratorActions = exports.recordingsAuthActions = exports.recordingActions = exports.pushActions = exports.pstnNumbersActions = exports.proxyActions = exports.presentationActions = exports.phoneHDActions = exports.persistenceActions = exports.pairedDevicesActions = exports.networkActions = exports.monitoringActions = exports.moderatorActions = exports.vcApiActions = exports.mmsApiActions = exports.meetingsActions = exports.localizationActions = exports.initActions = exports.groupSettingsActions = exports.galaxyActions = exports.feccActions = exports.favoriteActions = exports.directoryActions = exports.deviceActions = exports.dataWarehouseActions = exports.customInviteActions = exports.contactActions = exports.chatActions = exports.callHistoryActions = exports.callActions = exports.calendarActions = exports.authActions = exports.appActions = exports.apiActions = exports.alexaActions = void 0;

var alexaActions = _interopRequireWildcard(__webpack_require__(299));

exports.alexaActions = alexaActions;

var apiActions = _interopRequireWildcard(__webpack_require__(266));

exports.apiActions = apiActions;

var appActions = _interopRequireWildcard(__webpack_require__(494));

exports.appActions = appActions;

var authActions = _interopRequireWildcard(__webpack_require__(495));

exports.authActions = authActions;

var calendarActions = _interopRequireWildcard(__webpack_require__(220));

exports.calendarActions = calendarActions;

var callActions = _interopRequireWildcard(__webpack_require__(50));

exports.callActions = callActions;

var callHistoryActions = _interopRequireWildcard(__webpack_require__(252));

exports.callHistoryActions = callHistoryActions;

var chatActions = _interopRequireWildcard(__webpack_require__(194));

exports.chatActions = chatActions;

var contactActions = _interopRequireWildcard(__webpack_require__(195));

exports.contactActions = contactActions;

var customInviteActions = _interopRequireWildcard(__webpack_require__(496));

exports.customInviteActions = customInviteActions;

var dataWarehouseActions = _interopRequireWildcard(__webpack_require__(497));

exports.dataWarehouseActions = dataWarehouseActions;

var deviceActions = _interopRequireWildcard(__webpack_require__(498));

exports.deviceActions = deviceActions;

var directoryActions = _interopRequireWildcard(__webpack_require__(84));

exports.directoryActions = directoryActions;

var favoriteActions = _interopRequireWildcard(__webpack_require__(146));

exports.favoriteActions = favoriteActions;

var feccActions = _interopRequireWildcard(__webpack_require__(499));

exports.feccActions = feccActions;

var galaxyActions = _interopRequireWildcard(__webpack_require__(267));

exports.galaxyActions = galaxyActions;

var groupSettingsActions = _interopRequireWildcard(__webpack_require__(500));

exports.groupSettingsActions = groupSettingsActions;

var initActions = _interopRequireWildcard(__webpack_require__(506));

exports.initActions = initActions;

var localizationActions = _interopRequireWildcard(__webpack_require__(512));

exports.localizationActions = localizationActions;

var meetingsActions = _interopRequireWildcard(__webpack_require__(513));

exports.meetingsActions = meetingsActions;

var mmsApiActions = _interopRequireWildcard(__webpack_require__(516));

exports.mmsApiActions = mmsApiActions;

var vcApiActions = _interopRequireWildcard(__webpack_require__(517));

exports.vcApiActions = vcApiActions;

var moderatorActions = _interopRequireWildcard(__webpack_require__(192));

exports.moderatorActions = moderatorActions;

var monitoringActions = _interopRequireWildcard(__webpack_require__(271));

exports.monitoringActions = monitoringActions;

var networkActions = _interopRequireWildcard(__webpack_require__(518));

exports.networkActions = networkActions;

var pairedDevicesActions = _interopRequireWildcard(__webpack_require__(519));

exports.pairedDevicesActions = pairedDevicesActions;

var persistenceActions = _interopRequireWildcard(__webpack_require__(199));

exports.persistenceActions = persistenceActions;

var phoneHDActions = _interopRequireWildcard(__webpack_require__(268));

exports.phoneHDActions = phoneHDActions;

var presentationActions = _interopRequireWildcard(__webpack_require__(191));

exports.presentationActions = presentationActions;

var proxyActions = _interopRequireWildcard(__webpack_require__(21));

exports.proxyActions = proxyActions;

var pstnNumbersActions = _interopRequireWildcard(__webpack_require__(520));

exports.pstnNumbersActions = pstnNumbersActions;

var pushActions = _interopRequireWildcard(__webpack_require__(521));

exports.pushActions = pushActions;

var recordingActions = _interopRequireWildcard(__webpack_require__(522));

exports.recordingActions = recordingActions;

var recordingsAuthActions = _interopRequireWildcard(__webpack_require__(524));

exports.recordingsAuthActions = recordingsAuthActions;

var remoteModeratorActions = _interopRequireWildcard(__webpack_require__(85));

exports.remoteModeratorActions = remoteModeratorActions;

var _services = __webpack_require__(179);

var streamActions = _interopRequireWildcard(__webpack_require__(80));

exports.streamActions = streamActions;

var tokenActions = _interopRequireWildcard(__webpack_require__(196));

exports.tokenActions = tokenActions;

var userSettingsActions = _interopRequireWildcard(__webpack_require__(525));

exports.userSettingsActions = userSettingsActions;

var usersActions = _interopRequireWildcard(__webpack_require__(526));

exports.usersActions = usersActions;

var userProfileActions = _interopRequireWildcard(__webpack_require__(197));

exports.userProfileActions = userProfileActions;

var _icon = _interopRequireDefault(__webpack_require__(527));

var _logger = _interopRequireDefault(__webpack_require__(528));

var _availability = _interopRequireDefault(__webpack_require__(219));

var accountSelectors = _interopRequireWildcard(__webpack_require__(91));

exports.accountSelectors = accountSelectors;

var activeCallSelectors = _interopRequireWildcard(__webpack_require__(529));

exports.activeCallSelectors = activeCallSelectors;

var authSelectors = _interopRequireWildcard(__webpack_require__(31));

exports.authSelectors = authSelectors;

var callHistorySelectors = _interopRequireWildcard(__webpack_require__(263));

exports.callHistorySelectors = callHistorySelectors;

var callSelectors = _interopRequireWildcard(__webpack_require__(51));

exports.callSelectors = callSelectors;

var chatSelectors = _interopRequireWildcard(__webpack_require__(265));

exports.chatSelectors = chatSelectors;

var cloudInfoSelectors = _interopRequireWildcard(__webpack_require__(530));

exports.cloudInfoSelectors = cloudInfoSelectors;

var conferenceSelectors = _interopRequireWildcard(__webpack_require__(53));

exports.conferenceSelectors = conferenceSelectors;

var conferenceParticipantsSelectors = _interopRequireWildcard(__webpack_require__(92));

exports.conferenceParticipantsSelectors = conferenceParticipantsSelectors;

var conferenceRemoteModerationSelectors = _interopRequireWildcard(__webpack_require__(276));

var remoteModerationSelectors = conferenceRemoteModerationSelectors;
exports.conferenceRemoteModerationSelectors = conferenceRemoteModerationSelectors;
exports.remoteModerationSelectors = conferenceRemoteModerationSelectors;

var conferenceRemoteModeratorsSelectors = _interopRequireWildcard(__webpack_require__(246));

exports.conferenceRemoteModeratorsSelectors = conferenceRemoteModeratorsSelectors;

var contactCRUDSelectors = _interopRequireWildcard(__webpack_require__(531));

exports.contactCRUDSelectors = contactCRUDSelectors;

var contactSelectors = _interopRequireWildcard(__webpack_require__(35));

exports.contactSelectors = contactSelectors;

var currentUserSelectors = _interopRequireWildcard(__webpack_require__(37));

exports.currentUserSelectors = currentUserSelectors;

var dataWarehouseSelectors = _interopRequireWildcard(__webpack_require__(272));

exports.dataWarehouseSelectors = dataWarehouseSelectors;

var endpointSelectors = _interopRequireWildcard(__webpack_require__(532));

exports.endpointSelectors = endpointSelectors;

var featureSelectors = _interopRequireWildcard(__webpack_require__(74));

exports.featureSelectors = featureSelectors;

var groupSettingsSelectors = _interopRequireWildcard(__webpack_require__(533));

exports.groupSettingsSelectors = groupSettingsSelectors;

var localizationSelectors = _interopRequireWildcard(__webpack_require__(125));

exports.localizationSelectors = localizationSelectors;

var mediaSelectors = _interopRequireWildcard(__webpack_require__(143));

exports.mediaSelectors = mediaSelectors;

var meetingsSelectors = _interopRequireWildcard(__webpack_require__(534));

exports.meetingsSelectors = meetingsSelectors;

var networkSelectors = _interopRequireWildcard(__webpack_require__(535));

exports.networkSelectors = networkSelectors;

var pairedDevicesSelectors = _interopRequireWildcard(__webpack_require__(536));

exports.pairedDevicesSelectors = pairedDevicesSelectors;

var proxySelectors = _interopRequireWildcard(__webpack_require__(537));

exports.proxySelectors = proxySelectors;

var pstnNumbersSelectors = _interopRequireWildcard(__webpack_require__(242));

exports.pstnNumbersSelectors = pstnNumbersSelectors;

var recordingsAuthSelectors = _interopRequireWildcard(__webpack_require__(538));

exports.recordingsAuthSelectors = recordingsAuthSelectors;

var recordingsSelectors = _interopRequireWildcard(__webpack_require__(275));

exports.recordingsSelectors = recordingsSelectors;

var schedulingSelectors = _interopRequireWildcard(__webpack_require__(539));

exports.schedulingSelectors = schedulingSelectors;

var searchSelectors = _interopRequireWildcard(__webpack_require__(540));

exports.searchSelectors = searchSelectors;

var servicesSelectors = _interopRequireWildcard(__webpack_require__(83));

exports.servicesSelectors = servicesSelectors;

var userProfileSelectors = _interopRequireWildcard(__webpack_require__(52));

exports.userProfileSelectors = userProfileSelectors;

var usersSelectors = _interopRequireWildcard(__webpack_require__(543));

exports.usersSelectors = usersSelectors;

var moderatorSelectors = _interopRequireWildcard(__webpack_require__(93));

exports.moderatorSelectors = moderatorSelectors;

var _environment = _interopRequireDefault(__webpack_require__(193));

var _sso = _interopRequireDefault(__webpack_require__(544));

var _userSettings2 = _interopRequireDefault(__webpack_require__(277));

var _rtc = __webpack_require__(545);

var _createReduxStore = _interopRequireWildcard(__webpack_require__(581));

var DateUtils = _interopRequireWildcard(__webpack_require__(124));

exports.DateUtils = DateUtils;

var _client = __webpack_require__(292);

var contactModels = _interopRequireWildcard(__webpack_require__(695));

exports.contactModels = contactModels;

var nucleusConstants = _interopRequireWildcard(__webpack_require__(3));

exports.nucleusConstants = nucleusConstants;

var _pluginActions = _interopRequireWildcard(__webpack_require__(696));

exports.pluginActions = _pluginActions;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribeToEvents = subscribeToEvents;
exports.setUserCode = setUserCode;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var c = _interopRequireWildcard(__webpack_require__(3));

var proxyActions = _interopRequireWildcard(__webpack_require__(21));

function subscribeToEvents() {
  return proxyActions.subscribe(c.ALEXA_TOPIC);
}
/**
 * setUserCode
 * @param {string} usercode - Icon's unique usercode for alexa authorization/registration
 */


function setUserCode(usercode) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch) {
        var params, result;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  userCode: usercode
                };
                _context.prev = 1;
                _context.next = 4;
                return dispatch(proxyActions.proxyApiCall(c.ALEXA_ENDPOINT, 'setUserCode', c.HTTP_POST, params, null));

              case 4:
                result = _context.sent;
                return _context.abrupt("return", result);

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                return _context.abrupt("return", _context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 8]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() {
  return this || (typeof self === "object" && self);
})() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(301);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 301 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() {
    return this || (typeof self === "object" && self);
  })() || Function("return this")()
);


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(99);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 303 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(305);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(306);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(168);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(308),
    ListCache = __webpack_require__(134),
    Map = __webpack_require__(170);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(309),
    hashDelete = __webpack_require__(314),
    hashGet = __webpack_require__(315),
    hashHas = __webpack_require__(316),
    hashSet = __webpack_require__(317);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(133);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(209),
    isMasked = __webpack_require__(311),
    isObject = __webpack_require__(58),
    toSource = __webpack_require__(210);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(312);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(57);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 313 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 314 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(133);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(133);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(133);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 318 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(135);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(135);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(135);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(135);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(136);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 324 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(136);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(136);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(136);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(329);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(99),
    arrayMap = __webpack_require__(211),
    isArray = __webpack_require__(43),
    isSymbol = __webpack_require__(120);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ __webpack_exports__["default"] = (deepmerge_1);


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(171);
var formats = __webpack_require__(213);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    formatter,
    encodeValuesOnly,
    charset
) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = obj.join(',');
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key') : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key');
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value'))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        if (isArray(obj)) {
            pushToArray(values, stringify(
                obj[key],
                typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix,
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly,
                charset
            ));
        } else {
            pushToArray(values, stringify(
                obj[key],
                prefix + (allowDots ? '.' + key : '[' + key + ']'),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly,
                charset
            ));
        }
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && opts.encoder !== undefined && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.formatter,
            options.encodeValuesOnly,
            options.charset
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(171);

var has = Object.prototype.hasOwnProperty;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = options.decoder(part.slice(pos + 1), defaults.decoder, charset, 'value');
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (val && options.comma && val.indexOf(',') > -1) {
            val = val.split(',');
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options) {
    var leaf = val;

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new Error('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options);
        obj = utils.merge(obj, newObj, options);
    }

    return utils.compact(obj);
};


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof2 = _interopRequireDefault(__webpack_require__(98));

/* eslint-env browser */

/**
 * This is the web browser implementation of `debug()`.
 */
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
/**
 * Colors.
 */

exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */
// eslint-disable-next-line complexity

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
    return true;
  } // Internet Explorer and Edge do not support colors.


  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  } // Is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632


  return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
  typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
  // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */


function formatArgs(args) {
  args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);

  if (!this.useColors) {
    return;
  }

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit'); // The final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into

  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function (match) {
    if (match === '%%') {
      return;
    }

    index++;

    if (match === '%c') {
      // We only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });
  args.splice(lastC, 0, c);
}
/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */


function log() {
  var _console;

  // This hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return (typeof console === "undefined" ? "undefined" : (0, _typeof2.default)(console)) === 'object' && console.log && (_console = console).log.apply(_console, arguments);
}
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */


function save(namespaces) {
  try {
    if (namespaces) {
      exports.storage.setItem('debug', namespaces);
    } else {
      exports.storage.removeItem('debug');
    }
  } catch (error) {// Swallow
    // XXX (@Qix-) should we be logging these?
  }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */


function load() {
  var r;

  try {
    r = exports.storage.getItem('debug');
  } catch (error) {} // Swallow
  // XXX (@Qix-) should we be logging these?
  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG


  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */


function localstorage() {
  try {
    // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
    // The Browser also has localStorage in the global context.
    return localStorage;
  } catch (error) {// Swallow
    // XXX (@Qix-) should we be logging these?
  }
}

module.exports = __webpack_require__(334)(exports);
var formatters = module.exports.formatters;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

formatters.j = function (v) {
  try {
    return JSON.stringify(v);
  } catch (error) {
    return '[UnexpectedJSONParseError]: ' + error.message;
  }
};

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(71));

/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */
function setup(env) {
  createDebug.debug = createDebug;
  createDebug.default = createDebug;
  createDebug.coerce = coerce;
  createDebug.disable = disable;
  createDebug.enable = enable;
  createDebug.enabled = enabled;
  createDebug.humanize = __webpack_require__(338);
  Object.keys(env).forEach(function (key) {
    createDebug[key] = env[key];
  });
  /**
  * Active `debug` instances.
  */

  createDebug.instances = [];
  /**
  * The currently active debug mode names, and names to skip.
  */

  createDebug.names = [];
  createDebug.skips = [];
  /**
  * Map of special "%n" handling functions, for the debug "format" argument.
  *
  * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
  */

  createDebug.formatters = {};
  /**
  * Selects a color for a debug namespace
  * @param {String} namespace The namespace string for the for the debug instance to be colored
  * @return {Number|String} An ANSI color code for the given namespace
  * @api private
  */

  function selectColor(namespace) {
    var hash = 0;

    for (var i = 0; i < namespace.length; i++) {
      hash = (hash << 5) - hash + namespace.charCodeAt(i);
      hash |= 0; // Convert to 32bit integer
    }

    return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
  }

  createDebug.selectColor = selectColor;
  /**
  * Create a debugger with the given `namespace`.
  *
  * @param {String} namespace
  * @return {Function}
  * @api public
  */

  function createDebug(namespace) {
    var prevTime;

    function debug() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      // Disabled?
      if (!debug.enabled) {
        return;
      }

      var self = debug; // Set `diff` timestamp

      var curr = Number(new Date());
      var ms = curr - (prevTime || curr);
      self.diff = ms;
      self.prev = prevTime;
      self.curr = curr;
      prevTime = curr;
      args[0] = createDebug.coerce(args[0]);

      if (typeof args[0] !== 'string') {
        // Anything else let's inspect with %O
        args.unshift('%O');
      } // Apply any `formatters` transformations


      var index = 0;
      args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
        // If we encounter an escaped % then don't increase the array index
        if (match === '%%') {
          return match;
        }

        index++;
        var formatter = createDebug.formatters[format];

        if (typeof formatter === 'function') {
          var val = args[index];
          match = formatter.call(self, val); // Now we need to remove `args[index]` since it's inlined in the `format`

          args.splice(index, 1);
          index--;
        }

        return match;
      }); // Apply env-specific formatting (colors, etc.)

      createDebug.formatArgs.call(self, args);
      var logFn = self.log || createDebug.log;
      logFn.apply(self, args);
    }

    debug.namespace = namespace;
    debug.enabled = createDebug.enabled(namespace);
    debug.useColors = createDebug.useColors();
    debug.color = selectColor(namespace);
    debug.destroy = destroy;
    debug.extend = extend; // Debug.formatArgs = formatArgs;
    // debug.rawLog = rawLog;
    // env-specific initialization logic for debug instances

    if (typeof createDebug.init === 'function') {
      createDebug.init(debug);
    }

    createDebug.instances.push(debug);
    return debug;
  }

  function destroy() {
    var index = createDebug.instances.indexOf(this);

    if (index !== -1) {
      createDebug.instances.splice(index, 1);
      return true;
    }

    return false;
  }

  function extend(namespace, delimiter) {
    var newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
    newDebug.log = this.log;
    return newDebug;
  }
  /**
  * Enables a debug mode by namespaces. This can include modes
  * separated by a colon and wildcards.
  *
  * @param {String} namespaces
  * @api public
  */


  function enable(namespaces) {
    createDebug.save(namespaces);
    createDebug.names = [];
    createDebug.skips = [];
    var i;
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;

    for (i = 0; i < len; i++) {
      if (!split[i]) {
        // ignore empty strings
        continue;
      }

      namespaces = split[i].replace(/\*/g, '.*?');

      if (namespaces[0] === '-') {
        createDebug.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
      } else {
        createDebug.names.push(new RegExp('^' + namespaces + '$'));
      }
    }

    for (i = 0; i < createDebug.instances.length; i++) {
      var instance = createDebug.instances[i];
      instance.enabled = createDebug.enabled(instance.namespace);
    }
  }
  /**
  * Disable debug output.
  *
  * @return {String} namespaces
  * @api public
  */


  function disable() {
    var namespaces = [].concat((0, _toConsumableArray2.default)(createDebug.names.map(toNamespace)), (0, _toConsumableArray2.default)(createDebug.skips.map(toNamespace).map(function (namespace) {
      return '-' + namespace;
    }))).join(',');
    createDebug.enable('');
    return namespaces;
  }
  /**
  * Returns true if the given mode name is enabled, false otherwise.
  *
  * @param {String} name
  * @return {Boolean}
  * @api public
  */


  function enabled(name) {
    if (name[name.length - 1] === '*') {
      return true;
    }

    var i;
    var len;

    for (i = 0, len = createDebug.skips.length; i < len; i++) {
      if (createDebug.skips[i].test(name)) {
        return false;
      }
    }

    for (i = 0, len = createDebug.names.length; i < len; i++) {
      if (createDebug.names[i].test(name)) {
        return true;
      }
    }

    return false;
  }
  /**
  * Convert regexp to namespace
  *
  * @param {RegExp} regxep
  * @return {String} namespace
  * @api private
  */


  function toNamespace(regexp) {
    return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, '*');
  }
  /**
  * Coerce `val`.
  *
  * @param {Mixed} val
  * @return {Mixed}
  * @api private
  */


  function coerce(val) {
    if (val instanceof Error) {
      return val.stack || val.message;
    }

    return val;
  }

  createDebug.enable(createDebug.load());
  return createDebug;
}

module.exports = setup;

/***/ }),
/* 335 */
/***/ (function(module, exports) {

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

module.exports = _arrayWithoutHoles;

/***/ }),
/* 336 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

module.exports = _iterableToArray;

/***/ }),
/* 337 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

module.exports = _nonIterableSpread;

/***/ }),
/* 338 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'weeks':
    case 'week':
    case 'w':
      return n * w;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }
  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }
  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }
  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }
  return ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2018 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not
 * use this file except in compliance with the License. You may obtain a copy of
 * the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */


(function (scope) {
  if (scope['Proxy']) {
    return;
  }

  scope.Proxy = __webpack_require__(340)();
  scope.Proxy['revocable'] = scope.Proxy.revocable;
})('undefined' !== typeof process && '[object process]' === {}.toString.call(process) || 'undefined' !== typeof navigator && navigator.product === 'ReactNative' ? global : self);

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof2 = _interopRequireDefault(__webpack_require__(98));

/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not
 * use this file except in compliance with the License. You may obtain a copy of
 * the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */
module.exports = function proxyPolyfill() {
  var lastRevokeFn = null;
  var ProxyPolyfill;
  /**
   * @param {*} o
   * @return {boolean} whether this is probably a (non-null) Object
   */

  function isObject(o) {
    return o ? (0, _typeof2.default)(o) === 'object' || typeof o === 'function' : false;
  }
  /**
   * @constructor
   * @param {!Object} target
   * @param {{apply, construct, get, set}} handler
   */


  ProxyPolyfill = function ProxyPolyfill(target, handler) {
    if (!isObject(target) || !isObject(handler)) {
      throw new TypeError('Cannot create proxy with a non-object as target or handler');
    } // Construct revoke function, and set lastRevokeFn so that Proxy.revocable can steal it.
    // The caller might get the wrong revoke function if a user replaces or wraps scope.Proxy
    // to call itself, but that seems unlikely especially when using the polyfill.


    var throwRevoked = function throwRevoked() {};

    lastRevokeFn = function lastRevokeFn() {
      throwRevoked = function throwRevoked(trap) {
        throw new TypeError("Cannot perform '".concat(trap, "' on a proxy that has been revoked"));
      };
    }; // Fail on unsupported traps: Chrome doesn't do this, but ensure that users of the polyfill
    // are a bit more careful. Copy the internal parts of handler to prevent user changes.


    var unsafeHandler = handler;
    handler = {
      'get': null,
      'set': null,
      'apply': null,
      'construct': null
    };

    for (var k in unsafeHandler) {
      if (!(k in handler)) {
        throw new TypeError("Proxy polyfill does not support trap '".concat(k, "'"));
      }

      handler[k] = unsafeHandler[k];
    }

    if (typeof unsafeHandler === 'function') {
      // Allow handler to be a function (which has an 'apply' method). This matches what is
      // probably a bug in native versions. It treats the apply call as a trap to be configured.
      handler.apply = unsafeHandler.apply.bind(unsafeHandler);
    } // Define proxy as this, or a Function (if either it's callable, or apply is set).
    // TODO(samthor): Closure compiler doesn't know about 'construct', attempts to rename it.


    var proxy = this;
    var isMethod = false;
    var isArray = false;

    if (typeof target === 'function') {
      proxy = function ProxyPolyfill() {
        var usingNew = this && this.constructor === proxy;
        var args = Array.prototype.slice.call(arguments);
        throwRevoked(usingNew ? 'construct' : 'apply');

        if (usingNew && handler['construct']) {
          return handler['construct'].call(this, target, args);
        } else if (!usingNew && handler.apply) {
          return handler.apply(target, this, args);
        } // since the target was a function, fallback to calling it directly.


        if (usingNew) {
          // inspired by answers to https://stackoverflow.com/q/1606797
          args.unshift(target); // pass class as first arg to constructor, although irrelevant
          // nb. cast to convince Closure compiler that this is a constructor

          var f =
          /** @type {!Function} */
          target.bind.apply(target, args);
          return new f();
        }

        return target.apply(this, args);
      };

      isMethod = true;
    } else if (target instanceof Array) {
      proxy = [];
      isArray = true;
    } // Create default getters/setters. Create different code paths as handler.get/handler.set can't
    // change after creation.


    var getter = handler.get ? function (prop) {
      throwRevoked('get');
      return handler.get(this, prop, proxy);
    } : function (prop) {
      throwRevoked('get');
      return this[prop];
    };
    var setter = handler.set ? function (prop, value) {
      throwRevoked('set');
      var status = handler.set(this, prop, value, proxy); // TODO(samthor): If the calling code is in strict mode, throw TypeError.
      // if (!status) {
      // It's (sometimes) possible to work this out, if this code isn't strict- try to load the
      // callee, and if it's available, that code is non-strict. However, this isn't exhaustive.
      // }
    } : function (prop, value) {
      throwRevoked('set');
      this[prop] = value;
    }; // Clone direct properties (i.e., not part of a prototype).

    var propertyNames = Object.getOwnPropertyNames(target);
    var propertyMap = {};
    propertyNames.forEach(function (prop) {
      if ((isMethod || isArray) && prop in proxy) {
        return; // ignore properties already here, e.g. 'bind', 'prototype' etc
      }

      var real = Object.getOwnPropertyDescriptor(target, prop);
      var desc = {
        enumerable: !!real.enumerable,
        get: getter.bind(target, prop),
        set: setter.bind(target, prop)
      };
      Object.defineProperty(proxy, prop, desc);
      propertyMap[prop] = true;
    }); // Set the prototype, or clone all prototype methods (always required if a getter is provided).
    // TODO(samthor): We don't allow prototype methods to be set. It's (even more) awkward.
    // An alternative here would be to _just_ clone methods to keep behavior consistent.

    var prototypeOk = true;

    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(proxy, Object.getPrototypeOf(target));
    } else if (proxy.__proto__) {
      proxy.__proto__ = target.__proto__;
    } else {
      prototypeOk = false;
    }

    if (handler.get || !prototypeOk) {
      for (var _k in target) {
        if (propertyMap[_k]) {
          continue;
        }

        Object.defineProperty(proxy, _k, {
          get: getter.bind(target, _k)
        });
      }
    } // The Proxy polyfill cannot handle adding new properties. Seal the target and proxy.


    Object.seal(target);
    Object.seal(proxy);
    return proxy; // nb. if isMethod is true, proxy != this
  };

  ProxyPolyfill.revocable = function (target, handler) {
    var p = new ProxyPolyfill(target, handler);
    return {
      'proxy': p,
      'revoke': lastRevokeFn
    };
  };

  return ProxyPolyfill;
};

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enableConnect = exports.initialize = void 0;
var clients_connect_1 = __webpack_require__(342);
var operators_1 = __webpack_require__(62);
var connection_1 = __importDefault(__webpack_require__(178));
var EventBus_1 = __importDefault(__webpack_require__(101));
function initialize() {
    EventBus_1.default.initialize();
}
exports.initialize = initialize;
function enableConnect(wampClient, config) {
    clients_connect_1.initialize(wampClient, EventBus_1.default.Subject, config);
    enableHandlers();
}
exports.enableConnect = enableConnect;
function enableHandlers() {
    EventBus_1.default.Subject.pipe(operators_1.filter(function (e) { return e.type === 'CONNECTION_OPENED'; })).subscribe(function (e) {
        if (connection_1.default.onOpen)
            connection_1.default.onOpen(e.payload);
    });
    EventBus_1.default.Subject.pipe(operators_1.filter(function (e) { return e.type === 'CONNECTION_DISPOSED'; })).subscribe(function (e) {
        if (connection_1.default.onDispose)
            connection_1.default.onDispose(e.payload);
    });
}


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var listeners_1 = __webpack_require__(343);
var EventBus_1 = __importDefault(__webpack_require__(79));
var wampConnection_1 = __importDefault(__webpack_require__(121));
var defaultConfig = {
    enableSleepMonitor: false,
};
function initialize(wampClient, subject, config) {
    var mergedConfig = config ? __assign(__assign({}, defaultConfig), config) : defaultConfig;
    wampConnection_1.default.initialize(wampClient, mergedConfig.enableSleepMonitor);
    EventBus_1.default.initialize(subject);
    listeners_1.addCommandListeners();
}
exports.initialize = initialize;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = __webpack_require__(62);
var EventBus_1 = __importDefault(__webpack_require__(79));
var checkin_1 = __webpack_require__(344);
var connection_1 = __webpack_require__(348);
var guest_1 = __webpack_require__(365);
var rpc_1 = __webpack_require__(367);
var subscription_1 = __webpack_require__(368);
function addCommandListeners() {
    EventBus_1.default.Subject.pipe(operators_1.filter(function (e) { return e.type === 'CONNECTION_OPEN_REQUEST'; })).subscribe(connection_1.handleOpenRequest);
    EventBus_1.default.Subject.pipe(operators_1.filter(function (e) { return e.type === 'CONNECTION_CLOSE_REQUEST'; })).subscribe(connection_1.handleCloseRequest);
    EventBus_1.default.Subject.pipe(operators_1.filter(function (e) { return e.type === 'CONNECTION_FORCE_CLOSE_REQUEST'; })).subscribe(connection_1.handleForceCloseRequest);
    EventBus_1.default.Subject.pipe(operators_1.filter(function (e) { return e.type === 'CONNECTION_SET_AUTO_RETRY_REQUEST'; })).subscribe(connection_1.handleSetAutoRetry);
    EventBus_1.default.Subject.pipe(operators_1.filter(function (e) { return e.type === 'RPC_REQUEST'; })).subscribe(rpc_1.handleRpcRequest);
    EventBus_1.default.Subject.pipe(operators_1.filter(function (e) { return e.type === 'ECHO_REQUEST'; })).subscribe(rpc_1.handleEchoRequest);
    EventBus_1.default.Subject.pipe(operators_1.filter(function (e) { return e.type === 'SUBSCRIBE_REQUEST'; })).subscribe(subscription_1.handleSubscribeRequest);
    EventBus_1.default.Subject.pipe(operators_1.filter(function (e) { return e.type === 'UNSUBSCRIBE_REQUEST'; })).subscribe(subscription_1.handleUnsubscribeRequest);
    EventBus_1.default.Subject.pipe(operators_1.filter(function (e) { return e.type === 'GUEST_OBTAIN_TOKEN_REQUEST'; })).subscribe(guest_1.handleGuestObtainTokenRequest);
    EventBus_1.default.Subject.pipe(operators_1.filter(function (e) { return e.type === 'CHECKIN_REQUEST'; })).subscribe(checkin_1.handleCheckinRequest);
}
exports.addCommandListeners = addCommandListeners;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = __webpack_require__(63);
var checkin_1 = __webpack_require__(345);
var EventBus_1 = __importStar(__webpack_require__(79));
function handleCheckinRequest() {
    return __awaiter(this, void 0, void 0, function () {
        var response, disposed;
        return __generator(this, function (_a) {
            response = rxjs_1.from(checkin_1.checkin());
            disposed = EventBus_1.throwOnEvent(EventBus_1.default.Subject, 'CONNECTION_DISPOSED');
            rxjs_1.race(response, disposed).subscribe(function (e) { return EventBus_1.default.Subject.next({ type: 'CHECKIN_SUCCESS', payload: e }); }, function (e) { return EventBus_1.default.Subject.next({ type: 'CHECKIN_FAILURE', payload: { error: e } }); });
            return [2 /*return*/];
        });
    });
}
exports.handleCheckinRequest = handleCheckinRequest;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var get_1 = __importDefault(__webpack_require__(11));
var constants_1 = __webpack_require__(214);
var wampConnection_1 = __importDefault(__webpack_require__(121));
function checkin() {
    return __awaiter(this, void 0, void 0, function () {
        var params, rawResponse, parsedResponse, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = {
                        procedure: constants_1.CHECKIN,
                        args: [JSON.stringify({ method: constants_1.POST })],
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, wampConnection_1.default.Instance.call(params)];
                case 2:
                    rawResponse = _a.sent();
                    parsedResponse = JSON.parse(rawResponse);
                    if (!parsedResponse.statusCode || parsedResponse.statusCode >= 400) {
                        throw parsedResponse;
                    }
                    return [2 /*return*/, get_1.default(parsedResponse, 'body')];
                case 3:
                    error_1 = _a.sent();
                    throw error_1;
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.checkin = checkin;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var intervalId = null;
var lastActiveTime = null;
exports.default = { start: start, stop: stop };
function start(handler, interval, maxDiff) {
    if (intervalId)
        throw Error('sleep monitor already running.');
    lastActiveTime = Date.now();
    intervalId = setInterval(function () { return monitor(handler, maxDiff); }, interval);
}
function stop() {
    if (!intervalId)
        return;
    clearInterval(intervalId);
    intervalId = null;
    lastActiveTime = null;
}
function monitor(handler, maxDiff) {
    var currentTime = Date.now();
    if (!lastActiveTime)
        throw Error('last active time cannot be null on running monitor.');
    var diff = Math.abs(currentTime - lastActiveTime);
    var shouldInvokeHandler = diff > maxDiff;
    lastActiveTime = currentTime;
    if (!shouldInvokeHandler)
        return;
    handler();
}


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function createTimeoutPromise(timeout) {
    var promise = new Promise(function (_, reject) { return setTimeout(function () { return reject('timeout'); }, timeout); });
    return promise;
}
exports.createTimeoutPromise = createTimeoutPromise;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var get_1 = __importDefault(__webpack_require__(11));
var pick_1 = __importDefault(__webpack_require__(122));
var rxjs_1 = __webpack_require__(63);
var operators_1 = __webpack_require__(62);
var EventBus_1 = __importStar(__webpack_require__(79));
var wampConnection_1 = __importDefault(__webpack_require__(121));
function handleOpenRequest(event) {
    if (wampConnection_1.default.Instance.hasConnection) {
        EventBus_1.default.Subject.next({ type: 'CONNECTION_OPEN_FAILURE', payload: { event: 'CONNECTION_ALREADY_EXISTS' } });
        return;
    }
    var options = pick_1.default(event.payload, ['url', 'realm']);
    var opened = EventBus_1.default.Subject.pipe(operators_1.find(function (e) { return e.type === 'CONNECTION_OPENED'; }));
    var disposed = EventBus_1.throwOnEvent(EventBus_1.default.Subject, 'CONNECTION_DISPOSED');
    wampConnection_1.default.Instance.open(options);
    rxjs_1.race(opened, disposed).subscribe(function (e) { return EventBus_1.default.Subject.next({ type: 'CONNECTION_OPEN_SUCCESS', payload: get_1.default(e, 'payload') }); }, function (e) { return EventBus_1.default.Subject.next({ type: 'CONNECTION_OPEN_FAILURE', payload: e }); });
}
exports.handleOpenRequest = handleOpenRequest;
function handleCloseRequest() {
    if (!wampConnection_1.default.Instance.hasConnection) {
        EventBus_1.default.Subject.next({ type: 'CONNECTION_CLOSE_FAILURE', payload: { message: 'NO_CONNECTION_FOUND' } });
        return;
    }
    wampConnection_1.default.Instance.close();
    EventBus_1.default.Subject.next({ type: 'CONNECTION_CLOSE_SUCCESS' });
}
exports.handleCloseRequest = handleCloseRequest;
function handleForceCloseRequest() {
    if (!wampConnection_1.default.Instance.hasConnection) {
        EventBus_1.default.Subject.next({ type: 'CONNECTION_FORCE_CLOSE_FAILURE', payload: { message: 'NO_CONNECTION_FOUND' } });
        return;
    }
    wampConnection_1.default.Instance.forceClose();
    EventBus_1.default.Subject.next({ type: 'CONNECTION_FORCE_CLOSE_SUCCESS' });
}
exports.handleForceCloseRequest = handleForceCloseRequest;
function handleSetAutoRetry(event) {
    wampConnection_1.default.Instance.autoRetry = event.payload.autoRetry;
    EventBus_1.default.Subject.next({ type: 'CONNECTION_SET_AUTO_RETRY_SUCCESS', payload: event.payload });
}
exports.handleSetAutoRetry = handleSetAutoRetry;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(350),
    hasIn = __webpack_require__(216);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(132),
    baseSet = __webpack_require__(351),
    castPath = __webpack_require__(119);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(173),
    castPath = __webpack_require__(119),
    isIndex = __webpack_require__(138),
    isObject = __webpack_require__(58),
    toKey = __webpack_require__(100);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 352 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(119),
    isArguments = __webpack_require__(139),
    isArray = __webpack_require__(43),
    isIndex = __webpack_require__(138),
    isLength = __webpack_require__(175),
    toKey = __webpack_require__(100);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(88),
    isObjectLike = __webpack_require__(70);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(356),
    overRest = __webpack_require__(359),
    setToString = __webpack_require__(361);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(357);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(176),
    isFlattenable = __webpack_require__(358);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(99),
    isArguments = __webpack_require__(139),
    isArray = __webpack_require__(43);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(360);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 360 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(362),
    shortOut = __webpack_require__(364);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(363),
    defineProperty = __webpack_require__(215),
    identity = __webpack_require__(177);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 363 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 364 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var get_1 = __importDefault(__webpack_require__(11));
var token_1 = __webpack_require__(366);
var EventBus_1 = __importDefault(__webpack_require__(79));
function handleGuestObtainTokenRequest(event) {
    return __awaiter(this, void 0, void 0, function () {
        var payload, displayName, domain, email, extension, token, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = get_1.default(event, 'payload');
                    displayName = get_1.default(payload, 'displayName', 'Guest');
                    domain = get_1.default(payload, 'domain');
                    email = get_1.default(payload, 'email');
                    extension = get_1.default(payload, 'extension');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, token_1.fetchNewGuestToken({ displayName: displayName, domain: domain, email: email, extension: extension })];
                case 2:
                    token = _a.sent();
                    EventBus_1.default.Subject.next({ type: 'GUEST_OBTAIN_TOKEN_SUCCESS', payload: { token: token } });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    EventBus_1.default.Subject.next({ type: 'GUEST_OBTAIN_TOKEN_FAILURE', payload: { error: error_1 } });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.handleGuestObtainTokenRequest = handleGuestObtainTokenRequest;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var get_1 = __importDefault(__webpack_require__(11));
function fetchNewGuestToken(params) {
    return __awaiter(this, void 0, void 0, function () {
        var requestBody, url, fetchResult, response, error, token;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    requestBody = (_a = {},
                        _a['call_extension'] = params.extension,
                        _a['display_name'] = params.displayName,
                        _a);
                    if (params.email) {
                        requestBody['email'] = params.email;
                    }
                    url = "https://login." + params.domain + "/ls/login/guest/";
                    return [4 /*yield*/, fetch(url, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(requestBody),
                        })];
                case 1:
                    fetchResult = _b.sent();
                    return [4 /*yield*/, fetchResult.json()];
                case 2:
                    response = _b.sent();
                    error = get_1.default(response, 'ERROR');
                    if (error)
                        throw error;
                    token = get_1.default(response, 'A');
                    if (!token)
                        throw new Error("Token not found in property 'A' of response. " + JSON.stringify(response));
                    return [2 /*return*/, token];
            }
        });
    });
}
exports.fetchNewGuestToken = fetchNewGuestToken;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var get_1 = __importDefault(__webpack_require__(11));
var pick_1 = __importDefault(__webpack_require__(122));
var rxjs_1 = __webpack_require__(63);
var EventBus_1 = __importStar(__webpack_require__(79));
var wampConnection_1 = __importDefault(__webpack_require__(121));
function handleEchoRequest(event) {
    return __awaiter(this, void 0, void 0, function () {
        var timeout, response, closed;
        return __generator(this, function (_a) {
            timeout = get_1.default(event.payload, 'timeout');
            response = rxjs_1.from(wampConnection_1.default.Instance.echo(timeout));
            closed = EventBus_1.throwOnEvent(EventBus_1.default.Subject, 'CONNECTION_DISPOSED');
            rxjs_1.race(response, closed).subscribe(function (e) { return EventBus_1.default.Subject.next({ type: 'ECHO_SUCCESS' }); }, function (e) { return EventBus_1.default.Subject.next({ type: 'ECHO_FAILURE' }); });
            return [2 /*return*/];
        });
    });
}
exports.handleEchoRequest = handleEchoRequest;
function handleRpcRequest(event) {
    var requestId = get_1.default(event, 'requestId');
    var params = pick_1.default(event.payload, ['procedure', 'args']);
    var timeout = get_1.default(event.payload, 'timeout');
    var response = rxjs_1.from(wampConnection_1.default.Instance.call(params, timeout));
    var closed = EventBus_1.throwOnEvent(EventBus_1.default.Subject, 'CONNECTION_DISPOSED');
    rxjs_1.race(response, closed).subscribe(function (e) { return EventBus_1.default.Subject.next({ type: 'RPC_SUCCESS', payload: e, requestId: requestId }); }, function (e) { return EventBus_1.default.Subject.next({ type: 'RPC_FAILURE', payload: e, requestId: requestId }); });
}
exports.handleRpcRequest = handleRpcRequest;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var get_1 = __importDefault(__webpack_require__(11));
var rxjs_1 = __webpack_require__(63);
var EventBus_1 = __importStar(__webpack_require__(79));
var wampConnection_1 = __importDefault(__webpack_require__(121));
function handleSubscribeRequest(event) {
    var requestId = get_1.default(event, 'requestId');
    var topic = get_1.default(event.payload, 'topic');
    var response = rxjs_1.from(wampConnection_1.default.Instance.subscribe(topic));
    var disposed = EventBus_1.throwOnEvent(EventBus_1.default.Subject, 'CONNECTION_DISPOSED');
    rxjs_1.race(response, disposed).subscribe(function (e) { return EventBus_1.default.Subject.next({ type: 'SUBSCRIBE_SUCCESS', payload: e, requestId: requestId }); }, function (e) { return EventBus_1.default.Subject.next({ type: 'SUBSCRIBE_FAILURE', payload: e, requestId: requestId }); });
}
exports.handleSubscribeRequest = handleSubscribeRequest;
function handleUnsubscribeRequest(event) {
    var requestId = get_1.default(event, 'requestId');
    var topic = get_1.default(event.payload, 'topic');
    var response = rxjs_1.from(wampConnection_1.default.Instance.unsubscribe(topic));
    var disposed = EventBus_1.throwOnEvent(EventBus_1.default.Subject, 'CONNECTION_DISPOSED');
    rxjs_1.race(response, disposed).subscribe(function (e) { return EventBus_1.default.Subject.next({ type: 'UNSUBSCRIBE_SUCCESS', payload: e, requestId: requestId }); }, function (e) { return EventBus_1.default.Subject.next({ type: 'UNSUBSCRIBE_FAILURE', payload: e, requestId: requestId }); });
}
exports.handleUnsubscribeRequest = handleUnsubscribeRequest;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.establishNewSession = exports.fetchNewToken = void 0;
var rxjs_1 = __webpack_require__(63);
var operators_1 = __webpack_require__(62);
var connection_1 = __importDefault(__webpack_require__(178));
var checkin_1 = __webpack_require__(217);
var EventBus_1 = __importStar(__webpack_require__(101));
function fetchNewToken(params) {
    return __awaiter(this, void 0, void 0, function () {
        var success, failure, promise, event;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    success = EventBus_1.default.Subject.pipe(operators_1.find(function (e) { return e.type === 'GUEST_OBTAIN_TOKEN_SUCCESS'; }));
                    failure = EventBus_1.throwOnEvent(EventBus_1.default.Subject, 'GUEST_OBTAIN_TOKEN_FAILURE');
                    promise = rxjs_1.race(success, failure).toPromise();
                    EventBus_1.default.Subject.next({ type: 'GUEST_OBTAIN_TOKEN_REQUEST', payload: params });
                    return [4 /*yield*/, promise];
                case 1:
                    event = _a.sent();
                    return [2 /*return*/, event.payload.token];
            }
        });
    });
}
exports.fetchNewToken = fetchNewToken;
function establishNewSession(tokenParams, openParams) {
    return __awaiter(this, void 0, void 0, function () {
        var token, url;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchNewToken(tokenParams)];
                case 1:
                    token = _a.sent();
                    url = openParams.url.concat("/?j=" + token);
                    return [4 /*yield*/, connection_1.default.open({ url: url, realm: openParams.realm })];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, checkin_1.checkin()];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.establishNewSession = establishNewSession;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.send = exports.echo = void 0;
var rxjs_1 = __webpack_require__(63);
var operators_1 = __webpack_require__(62);
var EventBus_1 = __importStar(__webpack_require__(101));
var guid_1 = __importDefault(__webpack_require__(218));
function echo(timeout) {
    return __awaiter(this, void 0, void 0, function () {
        var success, failure, promise;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    success = EventBus_1.default.Subject.pipe(operators_1.find(function (e) { return e.type === 'ECHO_SUCCESS'; }));
                    failure = EventBus_1.throwOnEvent(EventBus_1.default.Subject, 'ECHO_FAILURE');
                    promise = rxjs_1.race(success, failure).toPromise();
                    EventBus_1.default.Subject.next({ type: 'ECHO_REQUEST', payload: { timeout: timeout } });
                    return [4 /*yield*/, promise];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.echo = echo;
function send(procedure, args, timeout) {
    return __awaiter(this, void 0, void 0, function () {
        var requestId, payload, filtered, success, failure, promise, event;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestId = guid_1.default();
                    payload = { args: args, procedure: procedure, timeout: timeout };
                    filtered = EventBus_1.default.Subject.pipe(operators_1.filter(function (e) { return e.requestId === requestId; }));
                    success = filtered.pipe(operators_1.find(function (e) { return e.type === 'RPC_SUCCESS'; }));
                    failure = EventBus_1.throwOnEvent(filtered, 'RPC_FAILURE');
                    promise = rxjs_1.race(success, failure).toPromise();
                    EventBus_1.default.Subject.next({ type: 'RPC_REQUEST', payload: payload, requestId: requestId });
                    return [4 /*yield*/, promise];
                case 1:
                    event = _a.sent();
                    return [2 /*return*/, event.payload];
            }
        });
    });
}
exports.send = send;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.remove = exports.add = void 0;
var rxjs_1 = __webpack_require__(63);
var operators_1 = __webpack_require__(62);
var EventBus_1 = __importStar(__webpack_require__(101));
var guid_1 = __importDefault(__webpack_require__(218));
function add(topic, handler) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var requestId, requestPayload, filtered, success, failure, promise, event, subscription;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    requestId = guid_1.default();
                    requestPayload = { topic: topic };
                    filtered = EventBus_1.default.Subject.pipe(operators_1.filter(function (e) { return e.requestId === requestId; }));
                    success = filtered.pipe(operators_1.find(function (e) { return e.type === 'SUBSCRIBE_SUCCESS'; }));
                    failure = EventBus_1.throwOnEvent(filtered, 'SUBSCRIBE_FAILURE');
                    promise = rxjs_1.race(success, failure).toPromise();
                    EventBus_1.default.Subject.next({ type: 'SUBSCRIBE_REQUEST', payload: requestPayload, requestId: requestId });
                    return [4 /*yield*/, promise];
                case 1:
                    event = _b.sent();
                    configureHandler(topic, handler);
                    subscription = (_a = event.payload) === null || _a === void 0 ? void 0 : _a.subscription;
                    return [2 /*return*/, { topic: topic, subscription: subscription }];
            }
        });
    });
}
exports.add = add;
function remove(topic) {
    return __awaiter(this, void 0, void 0, function () {
        var requestId, requestPayload, filtered, success, failure, promise;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestId = guid_1.default();
                    requestPayload = { topic: topic };
                    filtered = EventBus_1.default.Subject.pipe(operators_1.filter(function (e) { return e.requestId === requestId; }));
                    success = filtered.pipe(operators_1.find(function (e) { return e.type === 'UNSUBSCRIBE_SUCCESS'; }));
                    failure = EventBus_1.throwOnEvent(filtered, 'UNSUBSCRIBE_FAILURE');
                    promise = rxjs_1.race(success, failure).toPromise();
                    EventBus_1.default.Subject.next({ type: 'UNSUBSCRIBE_REQUEST', payload: requestPayload, requestId: requestId });
                    return [4 /*yield*/, promise];
                case 1:
                    _a.sent();
                    return [2 /*return*/, { topic: topic }];
            }
        });
    });
}
exports.remove = remove;
function configureHandler(topic, handler) {
    var subscriptionEvents = EventBus_1.default.Subject.pipe(operators_1.filter(function (e) { return e.type === 'SUBSCRIPTION_EVENT'; }), operators_1.filter(function (e) { return e.payload.topic === topic; }));
    var dispose = EventBus_1.default.Subject.pipe(operators_1.find(function (e) { return e.type === 'CONNECTION_DISPOSED'; }));
    var unsubscribeEvent = EventBus_1.default.Subject.pipe(operators_1.filter(function (e) { return e.type === 'UNSUBSCRIBE_REQUEST'; }), operators_1.find(function (e) { return e.payload.topic === topic; }));
    var stop = rxjs_1.race(dispose, unsubscribeEvent);
    subscriptionEvents.pipe(operators_1.takeUntil(stop)).subscribe(function (e) { return handler(e.payload); });
}


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribeToTopic = subscribeToTopic;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _proxy = __webpack_require__(21);

var _constants = __webpack_require__(3);

function subscribeToTopic() {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return dispatch((0, _proxy.subscribe)(_constants.ACTIVE_CONFERENCE_TOPIC));

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);

                _jsLogger.default.warn('active conferences topic: subscription failed:', _context.t0);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 5]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var BrowserInfo = /** @class */ (function () {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
    }
    return BrowserInfo;
}());
exports.BrowserInfo = BrowserInfo;
var NodeInfo = /** @class */ (function () {
    function NodeInfo(version) {
        this.version = version;
        this.name = 'node';
        this.os = process.platform;
    }
    return NodeInfo;
}());
exports.NodeInfo = NodeInfo;
var BotInfo = /** @class */ (function () {
    function BotInfo() {
        this.bot = true; // NOTE: deprecated test name instead
        this.name = 'bot';
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}());
exports.BotInfo = BotInfo;
// tslint:disable-next-line:max-line-length
var SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var SEARCHBOT_OS_REGEX = /(nuhk)|(Googlebot)|(Yammybot)|(Openbot)|(Slurp)|(MSNBot)|(Ask Jeeves\/Teoma)|(ia_archiver)/;
var REQUIRED_VERSION_PARTS = 3;
var userAgentRules = [
    ['aol', /AOLShield\/([0-9\._]+)/],
    ['edge', /Edge\/([0-9\._]+)/],
    ['edge-ios', /EdgiOS\/([0-9\._]+)/],
    ['yandexbrowser', /YaBrowser\/([0-9\._]+)/],
    ['vivaldi', /Vivaldi\/([0-9\.]+)/],
    ['kakaotalk', /KAKAOTALK\s([0-9\.]+)/],
    ['samsung', /SamsungBrowser\/([0-9\.]+)/],
    ['silk', /\bSilk\/([0-9._-]+)\b/],
    ['miui', /MiuiBrowser\/([0-9\.]+)$/],
    ['beaker', /BeakerBrowser\/([0-9\.]+)/],
    ['edge-chromium', /Edg\/([0-9\.]+)/],
    [
        'chromium-webview',
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/,
    ],
    ['chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
    ['phantomjs', /PhantomJS\/([0-9\.]+)(:?\s|$)/],
    ['crios', /CriOS\/([0-9\.]+)(:?\s|$)/],
    ['firefox', /Firefox\/([0-9\.]+)(?:\s|$)/],
    ['fxios', /FxiOS\/([0-9\.]+)/],
    ['opera-mini', /Opera Mini.*Version\/([0-9\.]+)/],
    ['opera', /Opera\/([0-9\.]+)(?:\s|$)/],
    ['opera', /OPR\/([0-9\.]+)(:?\s|$)/],
    ['ie', /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/],
    ['ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],
    ['ie', /MSIE\s(7\.0)/],
    ['bb10', /BB10;\sTouch.*Version\/([0-9\.]+)/],
    ['android', /Android\s([0-9\.]+)/],
    ['ios', /Version\/([0-9\._]+).*Mobile.*Safari.*/],
    ['safari', /Version\/([0-9\._]+).*Safari/],
    ['facebook', /FBAV\/([0-9\.]+)/],
    ['instagram', /Instagram\s([0-9\.]+)/],
    ['ios-webview', /AppleWebKit\/([0-9\.]+).*Mobile/],
    ['ios-webview', /AppleWebKit\/([0-9\.]+).*Gecko\)$/],
    ['searchbot', SEARCHBOX_UA_REGEX],
];
var operatingSystemRules = [
    ['iOS', /iP(hone|od|ad)/],
    ['Android OS', /Android/],
    ['BlackBerry OS', /BlackBerry|BB10/],
    ['Windows Mobile', /IEMobile/],
    ['Amazon OS', /Kindle/],
    ['Windows 3.11', /Win16/],
    ['Windows 95', /(Windows 95)|(Win95)|(Windows_95)/],
    ['Windows 98', /(Windows 98)|(Win98)/],
    ['Windows 2000', /(Windows NT 5.0)|(Windows 2000)/],
    ['Windows XP', /(Windows NT 5.1)|(Windows XP)/],
    ['Windows Server 2003', /(Windows NT 5.2)/],
    ['Windows Vista', /(Windows NT 6.0)/],
    ['Windows 7', /(Windows NT 6.1)/],
    ['Windows 8', /(Windows NT 6.2)/],
    ['Windows 8.1', /(Windows NT 6.3)/],
    ['Windows 10', /(Windows NT 10.0)/],
    ['Windows ME', /Windows ME/],
    ['Open BSD', /OpenBSD/],
    ['Sun OS', /SunOS/],
    ['Chrome OS', /CrOS/],
    ['Linux', /(Linux)|(X11)/],
    ['Mac OS', /(Mac_PowerPC)|(Macintosh)/],
    ['QNX', /QNX/],
    ['BeOS', /BeOS/],
    ['OS/2', /OS\/2/],
    ['Search Bot', SEARCHBOT_OS_REGEX],
];
function detect(userAgent) {
    if (!!userAgent) {
        return parseUserAgent(userAgent);
    }
    if (typeof navigator !== 'undefined') {
        return parseUserAgent(navigator.userAgent);
    }
    return getNodeVersion();
}
exports.detect = detect;
function parseUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    var matchedRule = ua !== '' &&
        userAgentRules.reduce(function (matched, _a) {
            var browser = _a[0], regex = _a[1];
            if (matched) {
                return matched;
            }
            var uaMatch = regex.exec(ua);
            return !!uaMatch && [browser, uaMatch];
        }, false);
    if (!matchedRule) {
        return null;
    }
    var name = matchedRule[0], match = matchedRule[1];
    if (name === 'searchbot') {
        return new BotInfo();
    }
    var versionParts = match[1] && match[1].split(/[._]/).slice(0, 3);
    if (versionParts) {
        if (versionParts.length < REQUIRED_VERSION_PARTS) {
            versionParts = __spreadArrays(versionParts, createVersionParts(REQUIRED_VERSION_PARTS - versionParts.length));
        }
    }
    else {
        versionParts = [];
    }
    return new BrowserInfo(name, versionParts.join('.'), detectOS(ua));
}
exports.parseUserAgent = parseUserAgent;
function detectOS(ua) {
    for (var ii = 0, count = operatingSystemRules.length; ii < count; ii++) {
        var _a = operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.test(ua);
        if (match) {
            return os;
        }
    }
    return null;
}
exports.detectOS = detectOS;
function getNodeVersion() {
    var isNode = typeof process !== 'undefined' && process.version;
    return isNode ? new NodeInfo(process.version.slice(1)) : null;
}
exports.getNodeVersion = getNodeVersion;
function createVersionParts(count) {
    var output = [];
    for (var ii = 0; ii < count; ii++) {
        output.push('0');
    }
    return output;
}


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(34));

var _createClass2 = _interopRequireDefault(__webpack_require__(36));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _isEqual = _interopRequireDefault(__webpack_require__(180));

var c = _interopRequireWildcard(__webpack_require__(3));

var _remove = _interopRequireDefault(__webpack_require__(395));

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var transform = __webpack_require__(408);

var GalaxySdp =
/*#__PURE__*/
function () {
  // constructor takes an SDP string and stores it as a parsed sdp object
  // for format of the sdp object refer to documentation in the following
  // link https://github.com/clux/sdp-transform
  function GalaxySdp(sdpStr) {
    var isRemoteSdp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    (0, _classCallCheck2.default)(this, GalaxySdp);
    this.sdp = transform.parse(sdpStr);
    this.isRemoteSdp = isRemoteSdp; // check if the sdp is well formed. If not throw an exception

    if ((0, _isEqual.default)(this.sdp, {
      media: []
    })) {
      throw 'invalid sdp';
    }
  } // It will encode the sdp object back into an sdp string that
  // can be transported to the server and set on the browser through the rtp
  // apis


  (0, _createClass2.default)(GalaxySdp, [{
    key: "toString",
    value: function toString() {
      return transform.write(this.sdp);
    } // function returns the call BW. Technically there could be multiple BW
    // parameters in the SDP and we will be concerned only about the AS which
    // specifies the application specific session bandwidth

  }, {
    key: "getBandwidth",
    value: function getBandwidth() {
      var video = this.getVideoMedia();
      var bwList = (0, _safeAccess.default)(video, 'bandwidth') || [];
      var defaultBandwidth = c.GALAXY_DEFAULT_CALL_BANDWIDTH_KBPS; // Prefer media level bw parameter over the session level one.

      if (!bwList.length) {
        bwList = (0, _safeAccess.default)(this.sdp, 'bandwidth') || [];
      }

      var selectedBw = bwList.find(function (bw) {
        return bw.type === 'AS';
      });
      return selectedBw ? selectedBw.limit : defaultBandwidth;
    } // Removes any existing bandwidth values and sets the limit thats passed.
    // The limit should be in Kbps. Ideally we won't need anything other than
    // the AS modifier and hence removing any other bw modifier should be fine.

  }, {
    key: "limitBandwidth",
    value: function limitBandwidth(limit) {
      var video = this.getVideoMedia();

      if (video) {
        video.bandwidth = [{
          limit: limit,
          type: 'AS'
        }];
      }
    }
  }, {
    key: "getVideoMedia",
    value: function getVideoMedia() {
      // Find the video media
      return this.getMedia('video');
    }
  }, {
    key: "getMedia",
    value: function getMedia(mediaType) {
      // Find the media type passed
      return this.sdp.media.find(function (media) {
        return media.type === mediaType;
      });
    }
  }, {
    key: "getRtpMap",
    value: function getRtpMap(mediaObj, codec) {
      return mediaObj.rtp.find(function (rtpmap) {
        return rtpmap.codec === codec;
      });
    }
  }, {
    key: "getAllRtpMaps",
    value: function getAllRtpMaps(mediaObj, codec) {
      return mediaObj.rtp.filter(function (rtpmap) {
        return rtpmap.codec === codec;
      });
    }
  }, {
    key: "getFmtpConfig",
    value: function getFmtpConfig(media, payload) {
      var fmtp = (0, _safeAccess.default)(media, 'fmtp') || [];
      return fmtp.find(function (entry) {
        return entry.payload === payload && entry.config;
      });
    }
  }, {
    key: "getPayloadForMappedCodec",
    value: function getPayloadForMappedCodec(payloadKey) {
      var videoMedia = this.getVideoMedia();
      var pt;

      if (videoMedia) {
        pt = this.getRtpMap(videoMedia, payloadKey);
      }

      return (0, _safeAccess.default)(pt, 'payload') || -1;
    }
    /**
     * getRtxForPayload
     * Check for presence of rtx payload is by going through the fmtp lines for the media
     * @param {String} codecPayload - codec map to search for
     */

  }, {
    key: "getRtxForPayload",
    value: function getRtxForPayload(codecPayload) {
      var videoMedia = this.getVideoMedia();
      var fmtpRtx;

      if ((0, _safeAccess.default)(videoMedia, 'fmtp.length') && codecPayload !== -1) {
        fmtpRtx = videoMedia.fmtp.find(function (fmtpElem) {
          return codecPayload ? transform.parseFmtpConfig(fmtpElem.config).apt === codecPayload : transform.parseFmtpConfig(fmtpElem.config).apt;
        });
      }

      return (0, _safeAccess.default)(fmtpRtx, 'payload') || -1;
    }
    /**
     * getPayloadsForCodec
     * Associate the rtp and fmtp rtx payload maps into one object.
     * @param {String} payloadKey - mapped payload
     */

  }, {
    key: "getPayloadsForCodec",
    value: function getPayloadsForCodec(payloadKey) {
      var rtpPayload = this.getPayloadForMappedCodec(payloadKey);
      var fmtpRtxPayload = this.getRtxForPayload(rtpPayload);
      return {
        rtpPayload: rtpPayload,
        fmtpRtxPayload: fmtpRtxPayload
      };
    }
    /**
     * preferH264
     * Move VP8 and VP9 to back of priority list. Leave h264 ordering as is.
     */

  }, {
    key: "preferH264",
    value: function preferH264() {
      var _this = this;

      var payloadFilter = ['VP8', 'VP9'].map(function (codec) {
        return _this.getPayloadsForCodec(codec);
      }).filter(function (payload) {
        return (0, _safeAccess.default)(payload, 'rtpPayload') !== -1;
      });
      var videoMedia = this.getVideoMedia();
      if (!videoMedia) return;
      var payloads = transform.parsePayloads(videoMedia.payloads.toString()); // let sortedPayloads = ;

      payloadFilter.forEach(function (payload) {
        if ((0, _safeAccess.default)(payload, 'rtpPayload') !== -1) {
          payloads = payloads.concat(payloads.splice(payloads.indexOf((0, _safeAccess.default)(payload, 'rtpPayload')), 1));
        }

        if ((0, _safeAccess.default)(payload, 'fmtpRtxPayload') !== -1) {
          payloads = payloads.concat(payloads.splice(payloads.indexOf((0, _safeAccess.default)(payload, 'fmtpRtxPayload')), 1));
        }
      }); // Set the re-arranged list back into the sdp object as a string

      videoMedia.payloads = payloads.join(' ');
    }
    /**
     * modifyBandwidth
     * @param {object} options - options for setting the max bandwidth.
     */

  }, {
    key: "modifyBandwidth",
    value: function modifyBandwidth(options) {
      var maxBandwidth = (0, _safeAccess.default)(options, 'maxBandwidth') || c.GALAXY_DEFAULT_CALL_BANDWIDTH_KBPS;

      if (this.isRemoteSdp) {
        maxBandwidth = Math.min(maxBandwidth, this.getBandwidth());
      } // SIG-152 - Chrome has a bug where it does not split the BW between
      // the two video tracks when the second one gets added. It however
      // does that if there is a change in BW. To overcome the actual
      // chrome bug we will exploit this. We will force a BW change while
      // starting the presentation. There are two ways we can force it
      // 1. Locally do it at the presenting end. Change the bitrate in the
      //    answer received from the far end (presentee).
      // 2. Remotely do it at the presentee end. Change the bitrate in the
      //    answer before sending it out. But also set it locally at the
      //    presentee for having consistency both the sender and the
      //    receiver.
      // Whether we go with solution 1 or 2 should really not matter.
      // Because, it needs to be done on any webrtc enabled endpoint like
      // MP, Icon etc. This is not something that can be solved only
      // through a webclient fix. Each endpoint acts as presenter and
      // presentee both. I have chosen option 1 because it ensures
      // it does not impact the remote's advertised BW. If we change that
      // then the presentor end may not know it was done purposefully
      // for this hack which could lead more complications. For example,
      // while stopping the presentation the BW offered by presentor will
      // choose a BW which is lower of local and remote BW and end up
      // picking up the hacked BW. Multiple such iterations could lead
      // to degradation in the BW negotiated, though its not practical
      // theoretically its feasible and we need to introduce a different
      // hack deal with it. Given that option is safer.


      var isTxPresentationActive = [c.GALAXY_PRESENTATION_STATE_TX_STARTING, c.GALAXY_PRESENTATION_STATE_TX_STARTED].includes((0, _safeAccess.default)(options, 'presentationState'));

      if (this.isRemoteSdp && isTxPresentationActive && (0, _safeAccess.default)(options, 'splitBandwidth')) {
        var bwPercentage = (0, _safeAccess.default)(options, 'bwPercentage');
        maxBandwidth = Math.floor(maxBandwidth * bwPercentage);

        _jsLogger.default.info('Splitting BW', maxBandwidth);
      }

      this.limitBandwidth(maxBandwidth);
    }
    /**
     * getH264PayloadType
     * Get all of the h264 rtp payload maps.
     */

  }, {
    key: "getH264PayloadType",
    value: function getH264PayloadType() {
      var videoMedia = this.getVideoMedia();
      var h264RtpMaps;
      var h264;

      if (videoMedia) {
        h264RtpMaps = this.getAllRtpMaps(videoMedia, 'H264');
      }

      if (h264RtpMaps) {
        h264 = h264RtpMaps.map(function (rtpmap) {
          return (0, _safeAccess.default)(rtpmap, 'payload') || -1;
        });
      }

      return (0, _safeAccess.default)(h264, 'length') ? h264 : [];
    }
    /**
     * Remove the rtx payload associated with the codec.
     * @param {Object} media - the media object to traverse and modify
     * @param {String} codec - the codec and payload to search for
     */

  }, {
    key: "removeRtxPayload",
    value: function removeRtxPayload(media, codec) {
      // The way to check for presence of rtx payload is by going through the fmtp
      // lines for the media
      if ((0, _safeAccess.default)(media, 'fmtp.length')) {
        var fmtpRtx = media.fmtp.find(function (fmtpElem) {
          return codec && codec.payload ? transform.parseFmtpConfig(fmtpElem.config).apt === codec.payload : transform.parseFmtpConfig(fmtpElem.config).apt;
        });

        if (fmtpRtx) {
          this.removeCodec(media, {
            codec: 'rtx',
            payload: fmtpRtx.payload
          });
        }
      }
    }
    /**
     * removeCodec
     * Remove the codec and associated attributes from the sdp/
     * @param {Object} media - the media object to traverse and modify
     * @param {String} codec - the codec and payload to search for
     */

  }, {
    key: "removeCodec",
    value: function removeCodec(media, codec) {
      var payloads = transform.parsePayloads(media.payloads.toString());
      payloads.splice(payloads.indexOf(codec.payload), 1); // The payloads parameter is a string if there are multiple payload types
      // and an integer if there is only one

      if (payloads.length > 1) {
        media.payloads = payloads.join(' ');
      } else {
        media.payloads = parseInt(payloads[0]);
      }
      /* istanbul ignore else */


      if ((0, _safeAccess.default)(media, 'rtp.length')) {
        // Remove all the rtpmap lines
        (0, _remove.default)(media.rtp, function (rtpMap) {
          return rtpMap.payload === codec.payload;
        });
      }

      if ((0, _safeAccess.default)(media, 'fmtp.length')) {
        // Remove all the fmtp lines
        (0, _remove.default)(media.fmtp, function (fmtpElem) {
          return fmtpElem.payload === codec.payload;
        });
      } // TBD: Check for presence of any retransmission payload types and remove them
      // as well. Need to attempt that during unit test
      // A retransmission payload fmtp would look like the one below. Where 99 is the payload type
      // for the retransmitted packet and it carries retransmission of payload type 98
      // If we have removed 98 from the sdp we also need to remove 99 as it is related to
      // 98.
      // a=fmtp:99 apt=98;rtx-time=3000


      this.removeRtxPayload(media, codec);

      if ((0, _safeAccess.default)(media, 'rtcpFb.length')) {
        // Remove all the rtcpfb lines
        (0, _remove.default)(media.rtcpFb, function (rtcpFbElem) {
          return rtcpFbElem.payload === codec.payload;
        });
      }
    }
    /**
     * removeVideoProfile
     * Remove any h264 profiles that don't match the passed in profile from the sdp
     */

  }, {
    key: "removeAllButThisProfile",
    value: function removeAllButThisProfile() {
      var _this2 = this;

      var profilePrefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var videoMedia = this.getVideoMedia();
      if (!videoMedia) return;
      var h264Payloads = this.getH264PayloadType();
      h264Payloads.forEach(function (h264Payload) {
        var fmtp = _this2.getFmtpConfig(videoMedia, h264Payload);

        var fmtpConfig = transform.parseFmtpConfig((0, _safeAccess.default)(fmtp, 'config'));
        var level = (0, _safeAccess.default)(fmtpConfig, 'profile-level-id').toString();

        if (profilePrefix && !level.startsWith(profilePrefix)) {
          _this2.removeCodec(videoMedia, {
            codec: 'H264',
            payload: h264Payload
          });
        }
      });
    } // Given the media object and the rtpmap object of the codec this function will set the
    // given codec as the default codec in the media line

  }, {
    key: "setDefaultCodec",
    value: function setDefaultCodec(media, codec) {
      var payloads = transform.parsePayloads(media.payloads.toString());
      payloads.splice(0, 0, payloads.splice(payloads.indexOf(codec.payload), 1)[0]); // Set the re-arranged list back into the sdp object as a string

      media.payloads = payloads.join(' ');
    }
    /**
     */

  }, {
    key: "preferProfile",
    value: function preferProfile() {
      var _this3 = this;

      var profileId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var videoMedia = this.getVideoMedia();
      if (!videoMedia) return;
      var h264Payloads = this.getH264PayloadType();
      h264Payloads.forEach(function (h264Payload) {
        var fmtp = _this3.getFmtpConfig(videoMedia, h264Payload);

        var fmtpConfig = transform.parseFmtpConfig((0, _safeAccess.default)(fmtp, 'config'));
        var level = (0, _safeAccess.default)(fmtpConfig, 'profile-level-id').toString();
        var packetizationMode = (0, _safeAccess.default)(fmtpConfig, 'packetization-mode');
        var levelPrefix = level.substring(0, 3); // Match on the first three characters to allow for profile sub variants

        if (profileId.toLowerCase().indexOf(levelPrefix) != -1 && packetizationMode) {
          //Don't use profiles with packetization-mode=0
          _this3.setDefaultCodec(videoMedia, {
            codec: 'H264',
            payload: h264Payload
          });
        }
      });
    }
  }, {
    key: "serializeConfig",
    value: function serializeConfig(config) {
      var arr = [];
      var keys = Object.keys(config);
      keys.forEach(function (key) {
        /* istanbul ignore else */
        if (Object.hasOwnProperty.call(config, key)) {
          arr.push(key + '=' + config[key]);
        }
      });
      return arr.join(';');
    }
    /**
     *
     */

  }, {
    key: "upgradeProfile",
    value: function upgradeProfile() {
      var _this4 = this;

      var videoMedia = this.getVideoMedia();
      if (!videoMedia) return;
      var h264Payloads = this.getH264PayloadType();
      h264Payloads.forEach(function (h264Payload) {
        var fmtp = _this4.getFmtpConfig(videoMedia, h264Payload);

        var fmtpConfig = transform.parseFmtpConfig((0, _safeAccess.default)(fmtp, 'config'));
        var level = (0, _safeAccess.default)(fmtpConfig, 'profile-level-id').toString();

        if (level.toLowerCase().endsWith('1f')) {
          var pos = videoMedia.fmtp.indexOf(fmtp);
          fmtpConfig['profile-level-id'] = level.slice(0, -2).concat('2a');
          videoMedia.fmtp[pos] = {
            config: _this4.serializeConfig(fmtpConfig),
            payload: h264Payload
          };
        }
      });
    }
  }]);
  return GalaxySdp;
}();

var _default = GalaxySdp;
exports.default = _default;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(182),
    equalArrays = __webpack_require__(221),
    equalByTag = __webpack_require__(384),
    equalObjects = __webpack_require__(386),
    getTag = __webpack_require__(123),
    isArray = __webpack_require__(43),
    isBuffer = __webpack_require__(140),
    isTypedArray = __webpack_require__(185);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(134);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 377 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 378 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 379 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(134),
    Map = __webpack_require__(170),
    MapCache = __webpack_require__(168);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 381 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 382 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 383 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(99),
    Uint8Array = __webpack_require__(224),
    eq = __webpack_require__(169),
    equalArrays = __webpack_require__(221),
    mapToArray = __webpack_require__(385),
    setToArray = __webpack_require__(183);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 385 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(225);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 387 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 388 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 389 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(88),
    isLength = __webpack_require__(175),
    isObjectLike = __webpack_require__(70);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(230);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(89),
    root = __webpack_require__(57);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(89),
    root = __webpack_require__(57);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(89),
    root = __webpack_require__(57);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(90),
    basePullAt = __webpack_require__(403);

/**
 * Removes all elements from `array` that `predicate` returns truthy for
 * and returns an array of the removed elements. The predicate is invoked
 * with three arguments: (value, index, array).
 *
 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
 * to pull elements from an array by value.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = [1, 2, 3, 4];
 * var evens = _.remove(array, function(n) {
 *   return n % 2 == 0;
 * });
 *
 * console.log(array);
 * // => [1, 3]
 *
 * console.log(evens);
 * // => [2, 4]
 */
function remove(array, predicate) {
  var result = [];
  if (!(array && array.length)) {
    return result;
  }
  var index = -1,
      indexes = [],
      length = array.length;

  predicate = baseIteratee(predicate, 3);
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result.push(value);
      indexes.push(index);
    }
  }
  basePullAt(array, indexes);
  return result;
}

module.exports = remove;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(397),
    getMatchData = __webpack_require__(398),
    matchesStrictComparable = __webpack_require__(233);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(182),
    baseIsEqual = __webpack_require__(181);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(232),
    keys = __webpack_require__(102);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(181),
    get = __webpack_require__(11),
    hasIn = __webpack_require__(216),
    isKey = __webpack_require__(167),
    isStrictComparable = __webpack_require__(232),
    matchesStrictComparable = __webpack_require__(233),
    toKey = __webpack_require__(100);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(401),
    basePropertyDeep = __webpack_require__(402),
    isKey = __webpack_require__(167),
    toKey = __webpack_require__(100);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 401 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(132);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var baseUnset = __webpack_require__(404),
    isIndex = __webpack_require__(138);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAt` without support for individual
 * indexes or capturing the removed elements.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {number[]} indexes The indexes of elements to remove.
 * @returns {Array} Returns `array`.
 */
function basePullAt(array, indexes) {
  var length = array ? indexes.length : 0,
      lastIndex = length - 1;

  while (length--) {
    var index = indexes[length];
    if (length == lastIndex || index !== previous) {
      var previous = index;
      if (isIndex(index)) {
        splice.call(array, index, 1);
      } else {
        baseUnset(array, index);
      }
    }
  }
  return array;
}

module.exports = basePullAt;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(119),
    last = __webpack_require__(405),
    parent = __webpack_require__(406),
    toKey = __webpack_require__(100);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 405 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(132),
    baseSlice = __webpack_require__(407);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 407 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var parser = __webpack_require__(409);
var writer = __webpack_require__(410);

exports.write = writer;
exports.parse = parser.parse;
exports.parseFmtpConfig = parser.parseFmtpConfig;
exports.parseParams = parser.parseParams;
exports.parsePayloads = parser.parsePayloads;
exports.parseRemoteCandidates = parser.parseRemoteCandidates;
exports.parseImageAttributes = parser.parseImageAttributes;
exports.parseSimulcastStreamList = parser.parseSimulcastStreamList;


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var toIntIfInt = function (v) {
  return String(Number(v)) === v ? Number(v) : v;
};

var attachProperties = function (match, location, names, rawName) {
  if (rawName && !names) {
    location[rawName] = toIntIfInt(match[1]);
  }
  else {
    for (var i = 0; i < names.length; i += 1) {
      if (match[i+1] != null) {
        location[names[i]] = toIntIfInt(match[i+1]);
      }
    }
  }
};

var parseReg = function (obj, location, content) {
  var needsBlank = obj.name && obj.names;
  if (obj.push && !location[obj.push]) {
    location[obj.push] = [];
  }
  else if (needsBlank && !location[obj.name]) {
    location[obj.name] = {};
  }
  var keyLocation = obj.push ?
    {} :  // blank object that will be pushed
    needsBlank ? location[obj.name] : location; // otherwise, named location or root

  attachProperties(content.match(obj.reg), keyLocation, obj.names, obj.name);

  if (obj.push) {
    location[obj.push].push(keyLocation);
  }
};

var grammar = __webpack_require__(234);
var validLine = RegExp.prototype.test.bind(/^([a-z])=(.*)/);

exports.parse = function (sdp) {
  var session = {}
    , media = []
    , location = session; // points at where properties go under (one of the above)

  // parse lines we understand
  sdp.split(/(\r\n|\r|\n)/).filter(validLine).forEach(function (l) {
    var type = l[0];
    var content = l.slice(2);
    if (type === 'm') {
      media.push({rtp: [], fmtp: []});
      location = media[media.length-1]; // point at latest media line
    }

    for (var j = 0; j < (grammar[type] || []).length; j += 1) {
      var obj = grammar[type][j];
      if (obj.reg.test(content)) {
        return parseReg(obj, location, content);
      }
    }
  });

  session.media = media; // link it up
  return session;
};

var paramReducer = function (acc, expr) {
  var s = expr.split(/=(.+)/, 2);
  if (s.length === 2) {
    acc[s[0]] = toIntIfInt(s[1]);
  } else if (s.length === 1 && expr.length > 1) {
    acc[s[0]] = undefined;
  }
  return acc;
};

exports.parseParams = function (str) {
  return str.split(/\;\s?/).reduce(paramReducer, {});
};

// For backward compatibility - alias will be removed in 3.0.0
exports.parseFmtpConfig = exports.parseParams;

exports.parsePayloads = function (str) {
  return str.split(' ').map(Number);
};

exports.parseRemoteCandidates = function (str) {
  var candidates = [];
  var parts = str.split(' ').map(toIntIfInt);
  for (var i = 0; i < parts.length; i += 3) {
    candidates.push({
      component: parts[i],
      ip: parts[i + 1],
      port: parts[i + 2]
    });
  }
  return candidates;
};

exports.parseImageAttributes = function (str) {
  return str.split(' ').map(function (item) {
    return item.substring(1, item.length-1).split(',').reduce(paramReducer, {});
  });
};

exports.parseSimulcastStreamList = function (str) {
  return str.split(';').map(function (stream) {
    return stream.split(',').map(function (format) {
      var scid, paused = false;

      if (format[0] !== '~') {
        scid = toIntIfInt(format);
      } else {
        scid = toIntIfInt(format.substring(1, format.length));
        paused = true;
      }

      return {
        scid: scid,
        paused: paused
      };
    });
  });
};


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var grammar = __webpack_require__(234);

// customized util.format - discards excess arguments and can void middle ones
var formatRegExp = /%[sdv%]/g;
var format = function (formatStr) {
  var i = 1;
  var args = arguments;
  var len = args.length;
  return formatStr.replace(formatRegExp, function (x) {
    if (i >= len) {
      return x; // missing argument
    }
    var arg = args[i];
    i += 1;
    switch (x) {
    case '%%':
      return '%';
    case '%s':
      return String(arg);
    case '%d':
      return Number(arg);
    case '%v':
      return '';
    }
  });
  // NB: we discard excess arguments - they are typically undefined from makeLine
};

var makeLine = function (type, obj, location) {
  var str = obj.format instanceof Function ?
    (obj.format(obj.push ? location : location[obj.name])) :
    obj.format;

  var args = [type + '=' + str];
  if (obj.names) {
    for (var i = 0; i < obj.names.length; i += 1) {
      var n = obj.names[i];
      if (obj.name) {
        args.push(location[obj.name][n]);
      }
      else { // for mLine and push attributes
        args.push(location[obj.names[i]]);
      }
    }
  }
  else {
    args.push(location[obj.name]);
  }
  return format.apply(null, args);
};

// RFC specified order
// TODO: extend this with all the rest
var defaultOuterOrder = [
  'v', 'o', 's', 'i',
  'u', 'e', 'p', 'c',
  'b', 't', 'r', 'z', 'a'
];
var defaultInnerOrder = ['i', 'c', 'b', 'a'];


module.exports = function (session, opts) {
  opts = opts || {};
  // ensure certain properties exist
  if (session.version == null) {
    session.version = 0; // 'v=0' must be there (only defined version atm)
  }
  if (session.name == null) {
    session.name = ' '; // 's= ' must be there if no meaningful name set
  }
  session.media.forEach(function (mLine) {
    if (mLine.payloads == null) {
      mLine.payloads = '';
    }
  });

  var outerOrder = opts.outerOrder || defaultOuterOrder;
  var innerOrder = opts.innerOrder || defaultInnerOrder;
  var sdp = [];

  // loop through outerOrder for matching properties on session
  outerOrder.forEach(function (type) {
    grammar[type].forEach(function (obj) {
      if (obj.name in session && session[obj.name] != null) {
        sdp.push(makeLine(type, obj, session));
      }
      else if (obj.push in session && session[obj.push] != null) {
        session[obj.push].forEach(function (el) {
          sdp.push(makeLine(type, obj, el));
        });
      }
    });
  });

  // then for each media line, follow the innerOrder
  session.media.forEach(function (mLine) {
    sdp.push(makeLine('m', grammar.m[0], mLine));

    innerOrder.forEach(function (type) {
      grammar[type].forEach(function (obj) {
        if (obj.name in mLine && mLine[obj.name] != null) {
          sdp.push(makeLine(type, obj, mLine));
        }
        else if (obj.push in mLine && mLine[obj.push] != null) {
          mLine[obj.push].forEach(function (el) {
            sdp.push(makeLine(type, obj, el));
          });
        }
      });
    });
  });

  return sdp.join('\r\n') + '\r\n';
};


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(237);

/**
 * This method is like `_.uniq` except that it accepts `comparator` which
 * is invoked to compare elements of `array`. The order of result values is
 * determined by the order they occur in the array.The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.uniqWith(objects, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
 */
function uniqWith(array, comparator) {
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
}

module.exports = uniqWith;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(413);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(238),
    baseIsNaN = __webpack_require__(414),
    strictIndexOf = __webpack_require__(415);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 414 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 415 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 416 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(231),
    noop = __webpack_require__(418),
    setToArray = __webpack_require__(183);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 418 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 419 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;

/***/ }),
/* 420 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;

/***/ }),
/* 421 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

module.exports = _nonIterableRest;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(423),
    baseAggregator = __webpack_require__(424),
    baseIteratee = __webpack_require__(90),
    isArray = __webpack_require__(43);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),
/* 423 */
/***/ (function(module, exports) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(240);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(426);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 426 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(104);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.additionalNumbersPrefix = void 0;

var _reselect = __webpack_require__(23);

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _phonesUtils = __webpack_require__(429);

var domain = function domain(state) {
  return (0, _safeAccess.default)(state, 'nucleus.cluster.url') || '';
};

var groupUuid = function groupUuid(state) {
  return (0, _safeAccess.default)(state, 'nucleus.userProfile.groupUuid') || '';
};

var additionalNumbersPrefix = (0, _reselect.createSelector)(domain, groupUuid, function (domain, groupUuid) {
  return (0, _phonesUtils.getAdditionalNumbersUrlPrefix)(domain, groupUuid);
});
exports.additionalNumbersPrefix = additionalNumbersPrefix;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAdditionalNumbersUrlPrefix = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var c = _interopRequireWildcard(__webpack_require__(3));

var _additionalNumbersUrl;

var additionalNumbersUrlPrefixMap = (_additionalNumbersUrl = {}, (0, _defineProperty2.default)(_additionalNumbersUrl, c.PROD_CLUSTER_URL, {
  '585c6f3a-89a1-43e7-8a41-c17c1cfd3735': 'bam',
  '95375af9-5f7e-43ca-ab8a-da4df6ac8e49': 'mlb'
}), (0, _defineProperty2.default)(_additionalNumbersUrl, c.STAGING_CLUSTER_URL, {
  'a63dbc63-e6ac-4f3a-b144-32b80a04db4c': 'bam',
  '65750908-f81c-419f-a81c-d0914c1e894e': 'mlb'
}), _additionalNumbersUrl); // TODO: This will come from checkin service / account customizations soon.

var getAdditionalNumbersUrlPrefix = function getAdditionalNumbersUrlPrefix(domain, groupUuid) {
  // get from this 2 level deep map, without throwing an exception
  // will return undefined if domain or groupUuid is not found
  return (additionalNumbersUrlPrefixMap[domain] || {})[groupUuid];
};

exports.getAdditionalNumbersUrlPrefix = getAdditionalNumbersUrlPrefix;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(82);
var localization_1 = __webpack_require__(244);
var localization_2 = __webpack_require__(189);
var Localization = (function () {
    function Localization(config) {
        if (config === void 0) { config = {}; }
        this.supportedLanguages = localization_2.supportedLanguages;
        var whitelistLanguageIds = lodash_1.isArray(config.includedIds) ? config.includedIds : [];
        var filteredLanguageIds = lodash_1.isArray(config.excludedIds) ? config.excludedIds : [];
        var ls = typeof localStorage === 'undefined' ? {} : localStorage;
        var unfilteredIds = (lodash_1.invoke(ls, 'getItem', 'unfilteredLocales') || '').split(',');
        if (whitelistLanguageIds.length) {
            whitelistLanguageIds = whitelistLanguageIds.map(function (id) { return localization_1.default.getLanguageId(id); });
            if (unfilteredIds.length) {
                unfilteredIds.forEach(function (id) {
                    var languageId = localization_1.default.getLanguageId(id);
                    if (!whitelistLanguageIds.includes(languageId)) {
                        whitelistLanguageIds.push(languageId);
                    }
                });
            }
            this.supportedLanguages = this.supportedLanguages.filter(function (option) {
                return whitelistLanguageIds.includes(option.id);
            });
        }
        if (filteredLanguageIds.length) {
            filteredLanguageIds = filteredLanguageIds.map(function (id) { return localization_1.default.getLanguageId(id); });
            if (unfilteredIds.length) {
                filteredLanguageIds = lodash_1.reject(filteredLanguageIds, function (id) {
                    return unfilteredIds.includes(id);
                });
            }
            this.supportedLanguages = lodash_1.reject(this.supportedLanguages, function (option) {
                return filteredLanguageIds.includes(option.id);
            });
        }
        var languageId = localization_1.default.getLanguageId(config.id, this.supportedLanguages);
        this.selectedLocale = localization_1.default.getLanguageObj(languageId);
    }
    Object.defineProperty(Localization.prototype, "cookieCompliance", {
        get: function () {
            var languageId = lodash_1.get(this.selectedLocale, 'id');
            return localization_1.default.getCookieCompliance(languageId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Localization.prototype, "helpPage", {
        get: function () {
            var languageId = lodash_1.get(this.selectedLocale, 'id');
            return localization_1.default.getHelpPage(languageId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Localization.prototype, "helpPageGuest", {
        get: function () {
            var languageId = lodash_1.get(this.selectedLocale, 'id');
            return localization_1.default.getHelpPageGuest(languageId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Localization.prototype, "language", {
        get: function () {
            return lodash_1.get(this.selectedLocale, 'language');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Localization.prototype, "languageDisplayName", {
        get: function () {
            return lodash_1.get(this.selectedLocale, 'displayName');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Localization.prototype, "languageId", {
        get: function () {
            return lodash_1.get(this.selectedLocale, 'id');
        },
        set: function (id) {
            var languageId = localization_1.default.getLanguageId(id, this.supportedLanguages);
            this.selectedLocale = localization_1.default.getLanguageObj(languageId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Localization.prototype, "languageOptions", {
        get: function () {
            var _this = this;
            return localization_1.default.getLanguageOptions().filter(function (option) {
                return !!_this.supportedLanguages.find(function (language) { return language.id === option.id; });
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Localization.prototype, "privacyPolicy", {
        get: function () {
            var languageId = lodash_1.get(this.selectedLocale, 'id');
            return localization_1.default.getPrivacyPolicy(languageId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Localization.prototype, "termsOfService", {
        get: function () {
            var languageId = lodash_1.get(this.selectedLocale, 'id');
            return localization_1.default.getTermsOfService(languageId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Localization.prototype, "locale", {
        get: function () {
            return this.selectedLocale;
        },
        enumerable: true,
        configurable: true
    });
    return Localization;
}());
exports.default = Localization;
//# sourceMappingURL=localization.js.map

/***/ }),
/* 431 */
/***/ (function(module) {

module.exports = JSON.parse("[{\"displayName\":\"Čeština\",\"englishName\":\"Czech as used in Czechia (Czech Republic)\",\"id\":\"cs-CZ\",\"language\":\"cs\"},{\"displayName\":\"Deutsch\",\"englishName\":\"German as used in Germany\",\"id\":\"de-DE\",\"language\":\"de\"},{\"displayName\":\"English\",\"englishName\":\"English as used in United States of America\",\"id\":\"en-US\",\"language\":\"en\"},{\"displayName\":\"Español\",\"englishName\":\"Spanish as used in Spain\",\"id\":\"es-ES\",\"language\":\"es\"},{\"displayName\":\"Suomi\",\"englishName\":\"Finnish as used in Finland\",\"id\":\"fi-FI\",\"language\":\"fi\"},{\"displayName\":\"Français\",\"englishName\":\"French as used in France\",\"id\":\"fr-FR\",\"language\":\"fr\"},{\"displayName\":\"Italiano\",\"englishName\":\"Italian as used in Italy\",\"id\":\"it-IT\",\"language\":\"it\"},{\"displayName\":\"日本語\",\"englishName\":\"Japanese as used in Japan\",\"id\":\"ja-JP\",\"language\":\"ja\"},{\"displayName\":\"한국어\",\"englishName\":\"Korean as used in Republic of Korea (South Korea)\",\"id\":\"ko-KR\",\"language\":\"ko\"},{\"displayName\":\"Nederlands\",\"englishName\":\"Dutch as used in Netherlands\",\"id\":\"nl-NL\",\"language\":\"nl\"},{\"aliases\":[\"nb-no\",\"nn-no\",\"nb\",\"nn\"],\"displayName\":\"Norsk\",\"englishName\":\"Norwegian as used in Norway\",\"id\":\"no-NO\",\"language\":\"no\",\"platform\":{\"microsoft\":\"nb-NO\"}},{\"displayName\":\"Polski\",\"englishName\":\"Polish as used in Poland\",\"id\":\"pl-PL\",\"language\":\"pl\"},{\"displayName\":\"Português-Brasil\",\"englishName\":\"Portuguese as used in Brazil\",\"id\":\"pt-BR\",\"language\":\"pt\"},{\"displayName\":\"русский\",\"englishName\":\"Russian as used in Russian Federation (Russia)\",\"id\":\"ru-RU\",\"language\":\"ru\"},{\"displayName\":\"Svenska\",\"englishName\":\"Swedish as used in Sweden\",\"id\":\"sv-SE\",\"language\":\"sv\"},{\"aliases\":[\"zh-cn\",\"zh-sg\",\"zh-chs\"],\"displayName\":\"简体中文\",\"englishName\":\"Simplified Chinese\",\"id\":\"zh-Hans\",\"language\":\"zh\",\"platform\":{\"google\":\"zh-CN\",\"microsoft\":\"zh-CN\",\"smartling\":\"zh-CN\"}},{\"aliases\":[\"zh-tw\",\"zh-hk\",\"zh-mo\",\"zh-cht\"],\"displayName\":\"繁體中文\",\"englishName\":\"Traditional Chinese\",\"id\":\"zh-Hant\",\"language\":\"zh\",\"platform\":{\"google\":\"zh-TW\",\"microsoft\":\"zh-TW\",\"smartling\":\"zh-TW\"}}]");

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'cs-CZ': {
        cookie: 'https://www.lifesize.com/en/company/legal-notices/cookie-compliance',
        help: 'https://www.lifesize.com/cs/app-help',
        helpGuest: 'https://www.lifesize.com/cs/app-help/guest',
        privacy: 'https://www.lifesize.com/en/company/legal-notices/privacy',
        tos: 'https://www.lifesize.com/en/company/legal-notices/terms-of-service'
    },
    'de-DE': {
        cookie: 'https://www.lifesize.com/de/Firma/Rechtliches/cookie-compliance',
        help: 'https://www.lifesize.com/de/app-help',
        helpGuest: 'https://www.lifesize.com/de/app-help/guest',
        privacy: 'https://www.lifesize.com/de/Firma/Rechtliches/Datenschutz',
        tos: 'https://www.lifesize.com/de/Firma/Rechtliches/terms-of-service'
    },
    'en-US': {
        cookie: 'https://www.lifesize.com/en/company/legal-notices/cookie-compliance',
        help: 'https://www.lifesize.com/en/app-help',
        helpGuest: 'https://www.lifesize.com/en/app-help/guest',
        privacy: 'https://www.lifesize.com/en/company/legal-notices/privacy',
        tos: 'https://www.lifesize.com/en/company/legal-notices/terms-of-service'
    },
    'es-ES': {
        cookie: 'https://www.lifesize.com/es/empresa/asuntos-legales/cookie-compliance',
        help: 'https://www.lifesize.com/es/app-help',
        helpGuest: 'https://www.lifesize.com/es/app-help/guest',
        privacy: 'https://www.lifesize.com/es/empresa/asuntos-legales/privacidad',
        tos: 'https://www.lifesize.com/es/empresa/asuntos-legales/terms-of-service'
    },
    'fi-FI': {
        cookie: 'https://www.lifesize.com/en/company/legal-notices/cookie-compliance',
        help: 'https://www.lifesize.com/fi/app-help',
        helpGuest: 'https://www.lifesize.com/fi/app-help/guest',
        privacy: 'https://www.lifesize.com/en/company/legal-notices/privacy',
        tos: 'https://www.lifesize.com/en/company/legal-notices/terms-of-service'
    },
    'fr-FR': {
        cookie: 'https://www.lifesize.com/fr/soci%C3%A9t%C3%A9/mentions-l%C3%A9gales/cookie-compliance',
        help: 'https://www.lifesize.com/fr/app-help',
        helpGuest: 'https://www.lifesize.com/fr/app-help/guest',
        privacy: 'https://www.lifesize.com/fr/soci%C3%A9t%C3%A9/mentions-l%C3%A9gales/confidentialit%C3%A9',
        tos: 'https://www.lifesize.com/fr/soci%C3%A9t%C3%A9/mentions-l%C3%A9gales/terms-of-service'
    },
    'it-IT': {
        cookie: 'https://www.lifesize.com/it/azienda/note-legali/cookie-compliance',
        help: 'https://www.lifesize.com/it/app-help',
        helpGuest: 'https://www.lifesize.com/it/app-help/guest',
        privacy: 'https://www.lifesize.com/it/azienda/note-legali/privacy',
        tos: 'https://www.lifesize.com/it/azienda/note-legali/terms-of-service'
    },
    'ja-JP': {
        cookie: 'https://www.lifesize.com/ja/company/legal-notices/cookie-compliance',
        help: 'https://www.lifesize.com/ja/app-help',
        helpGuest: 'https://www.lifesize.com/ja/app-help/guest',
        privacy: 'https://www.lifesize.com/en/company/legal-notices/privacy',
        tos: 'https://www.lifesize.com/en/company/legal-notices/terms-of-service'
    },
    'ko-KR': {
        cookie: 'https://www.lifesize.com/ko/company/legal-notices/cookie-compliance',
        help: 'https://www.lifesize.com/en/app-help',
        helpGuest: 'https://www.lifesize.com/ko/app-help/guest',
        privacy: 'https://www.lifesize.com/en/company/legal-notices/privacy',
        tos: 'https://www.lifesize.com/en/company/legal-notices/terms-of-service'
    },
    'nl-NL': {
        cookie: 'https://www.lifesize.com/nl/company/legal-notices/cookie-compliance',
        help: 'https://www.lifesize.com/nl/app-help',
        helpGuest: 'https://www.lifesize.com/nl/app-help/guest',
        privacy: 'https://www.lifesize.com/en/company/legal-notices/privacy',
        tos: 'https://www.lifesize.com/en/company/legal-notices/terms-of-service'
    },
    'no-NO': {
        cookie: 'https://www.lifesize.com/en/company/legal-notices/cookie-compliance',
        help: 'https://www.lifesize.com/no/app-help',
        helpGuest: 'https://www.lifesize.com/no/app-help/guest',
        privacy: 'https://www.lifesize.com/en/company/legal-notices/privacy',
        tos: 'https://www.lifesize.com/en/company/legal-notices/terms-of-service'
    },
    'pl-PL': {
        cookie: 'https://www.lifesize.com/en/company/legal-notices/cookie-compliance',
        help: 'https://www.lifesize.com/pl/app-help',
        helpGuest: 'https://www.lifesize.com/pl/app-help/guest',
        privacy: 'https://www.lifesize.com/en/company/legal-notices/privacy',
        tos: 'https://www.lifesize.com/en/company/legal-notices/terms-of-service'
    },
    'pt-BR': {
        cookie: 'https://www.lifesize.com/pt/empresa/avisos-legais/cookie-compliance',
        help: 'https://www.lifesize.com/pt/app-help',
        helpGuest: 'https://www.lifesize.com/pt/app-help/guest',
        privacy: 'https://www.lifesize.com/pt/empresa/avisos-legais/privacy',
        tos: 'https://www.lifesize.com/pt/empresa/avisos-legais/terms-of-service'
    },
    'ru-RU': {
        cookie: 'https://www.lifesize.com/en/company/legal-notices/cookie-compliance',
        help: 'https://www.lifesize.com/ru/app-help',
        helpGuest: 'https://www.lifesize.com/ru/app-help/guest',
        privacy: 'https://www.lifesize.com/en/company/legal-notices/privacy',
        tos: 'https://www.lifesize.com/en/company/legal-notices/terms-of-service'
    },
    'sv-SE': {
        cookie: 'https://www.lifesize.com/sv/company/legal-notices/cookie-compliance',
        help: 'https://www.lifesize.com/sv/app-help',
        helpGuest: 'https://www.lifesize.com/sv/app-help/guest',
        privacy: 'https://www.lifesize.com/en/company/legal-notices/privacy',
        tos: 'https://www.lifesize.com/en/company/legal-notices/terms-of-service'
    },
    'zh-Hans': {
        cookie: 'https://www.lifesize.com/zh-Hans/company/legal-notices/cookie-compliance',
        help: 'https://www.lifesize.com/zh-Hans/app-help',
        helpGuest: 'https://www.lifesize.com/zh-Hans/app-help/guest',
        privacy: 'https://www.lifesize.com/en/company/legal-notices/privacy',
        tos: 'https://www.lifesize.com/en/company/legal-notices/terms-of-service'
    },
    'zh-Hant': {
        cookie: 'https://www.lifesize.com/zh-Hans/company/legal-notices/cookie-compliance',
        help: 'https://www.lifesize.com/zh-Hans/app-help',
        helpGuest: 'https://www.lifesize.com/zh-Hans/app-help/guest',
        privacy: 'https://www.lifesize.com/en/company/legal-notices/privacy',
        tos: 'https://www.lifesize.com/en/company/legal-notices/terms-of-service'
    }
};
//# sourceMappingURL=compliance.js.map

/***/ }),
/* 433 */
/***/ (function(module) {

module.exports = JSON.parse("{\"conference\":\"Konference\",\"extension\":\"Linka\",\"validation_error_meeting_validate_duplicate_name\":\"Tento název schůzky je již obsazený.\",\"validation_error_meeting_validate_pattern_pin\":\"Zadané slovo obsahuje neplatné znaky.\",\"AF\":\"Afghánistán\",\"AL\":\"Albánie\",\"DZ\":\"Alžírsko\",\"AS\":\"Americká Samoa\",\"AD\":\"Andorra\",\"AO\":\"Angola\",\"AI\":\"Anguilla\",\"AG\":\"Antigua a Barbuda\",\"AR\":\"Argentina\",\"AM\":\"Arménie\",\"AW\":\"Aruba\",\"AU\":\"Austrálie\",\"AT\":\"Rakousko\",\"AZ\":\"Ázerbájdžán\",\"BS\":\"Bahamy\",\"BH\":\"Bahrajn\",\"BD\":\"Bangladéš\",\"BB\":\"Barbados\",\"BY\":\"Bělorusko\",\"BE\":\"Belgie\",\"BZ\":\"Belize\",\"BJ\":\"Benin\",\"BM\":\"Bermudy\",\"BT\":\"Bhútán\",\"BO\":\"Bolívie\",\"BA\":\"Bosna a Hercegovina\",\"BW\":\"Botswana\",\"BR\":\"Brazílie\",\"BN\":\"Brunej\",\"BG\":\"Bulharsko\",\"BF\":\"Burkina Faso\",\"BI\":\"Burundi\",\"KH\":\"Kambodža\",\"CM\":\"Kamerun\",\"CA\":\"Kanada\",\"CV\":\"Kapverdy\",\"KY\":\"Kajmanské ostrovy\",\"CF\":\"Středoafrická republika\",\"TD\":\"Čad\",\"CL\":\"Chile\",\"CN\":\"Čína\",\"CX\":\"Vánoční ostrov\",\"CC\":\"Kokosové (Keelingovy) ostrovy\",\"CO\":\"Kolumbie\",\"KM\":\"Komory\",\"CG\":\"Republika Kongo\",\"CD\":\"Demokratická republika Kongo\",\"CK\":\"Cookovy ostrovy\",\"CR\":\"Kostarika\",\"CI\":\"Pobřeží slonoviny\",\"HR\":\"Chorvatsko\",\"CU\":\"Kuba\",\"CY\":\"Kypr\",\"CZ\":\"Česká republika\",\"DK\":\"Dánsko\",\"DJ\":\"Džibutsko\",\"DM\":\"Dominika\",\"DO\":\"Dominikánská republika\",\"EC\":\"Ekvádor\",\"EG\":\"Egypt\",\"SV\":\"Salvador\",\"GQ\":\"Rovníková Guinea\",\"ER\":\"Eritrea\",\"EE\":\"Estonsko\",\"ET\":\"Etiopie\",\"EU\":\"Evropská unie\",\"FK\":\"Falklandské ostrovy (Malvíny)\",\"FO\":\"Faerské ostrovy\",\"FJ\":\"Fidži\",\"FI\":\"Finsko\",\"FR\":\"Francie\",\"GF\":\"Francouzská Guyana\",\"PF\":\"Francouzská Polynésie\",\"GA\":\"Gabon\",\"GM\":\"Gambie\",\"GE\":\"Gruzie\",\"DE\":\"Německo\",\"GH\":\"Ghana\",\"GI\":\"Gibraltar\",\"GR\":\"Řecko\",\"GL\":\"Grónsko\",\"GD\":\"Grenada\",\"GP\":\"Guadeloupe\",\"GU\":\"Guam\",\"GT\":\"Guatemala\",\"GG\":\"Guernsey\",\"GN\":\"Guinea\",\"GW\":\"Guinea-Bissau\",\"GY\":\"Guyana\",\"GZ\":\"Pásmo Gazy\",\"HT\":\"Haiti\",\"VA\":\"Svatý stolec (Městský stát Vatikán)\",\"HN\":\"Honduras\",\"HK\":\"Hongkong\",\"HU\":\"Maďarsko\",\"IS\":\"Island\",\"IN\":\"Indie\",\"ID\":\"Indonésie\",\"IQ\":\"Irák\",\"IE\":\"Irsko\",\"IM\":\"Ostrov Man\",\"IL\":\"Izrael\",\"IT\":\"Itálie\",\"JM\":\"Jamajka\",\"JP\":\"Japonsko\",\"JE\":\"Jersey\",\"JO\":\"Jordánsko\",\"KZ\":\"Kazachstán\",\"KE\":\"Keňa\",\"KI\":\"Kiribati\",\"KR\":\"Jižní Korea\",\"KW\":\"Kuvajt\",\"KG\":\"Kyrgyzstán\",\"LA\":\"Laos\",\"LV\":\"Lotyšsko\",\"LB\":\"Libanon\",\"LS\":\"Lesotho\",\"LR\":\"Libérie\",\"LY\":\"Libye\",\"LI\":\"Lichtenštejnsko\",\"LT\":\"Litva\",\"LU\":\"Lucembursko\",\"MO\":\"Macao\",\"MK\":\"Makedonie\",\"MG\":\"Madagaskar\",\"MW\":\"Malawi\",\"MY\":\"Malajsie\",\"MV\":\"Maledivy\",\"ML\":\"Mali\",\"MT\":\"Malta\",\"MH\":\"Marshallovy ostrovy\",\"MQ\":\"Martinik\",\"MR\":\"Mauretánie\",\"MU\":\"Mauricius\",\"YT\":\"Mayotte\",\"MX\":\"Mexiko\",\"FM\":\"Federativní státy Mikronésie\",\"MD\":\"Moldavsko\",\"MC\":\"Monako\",\"MN\":\"Mongolsko\",\"ME\":\"Černá Hora\",\"MS\":\"Montserrat\",\"MA\":\"Maroko\",\"MZ\":\"Mosambik\",\"MM\":\"Myanmar\",\"NA\":\"Namibie\",\"NR\":\"Nauru\",\"NP\":\"Nepál\",\"NL\":\"Nizozemsko\",\"NC\":\"Nová Kaledonie\",\"NZ\":\"Nový Zéland\",\"NI\":\"Nikaragua\",\"NE\":\"Niger\",\"NG\":\"Nigérie\",\"NU\":\"Niue\",\"NF\":\"Ostrov Norfolk\",\"MP\":\"Severní Mariany\",\"NO\":\"Norsko\",\"OM\":\"Omán\",\"PK\":\"Pákistán\",\"PW\":\"Palau\",\"PA\":\"Panama\",\"PG\":\"Papua-Nová Guinea\",\"PY\":\"Paraguay\",\"PE\":\"Peru\",\"PH\":\"Filipíny\",\"PN\":\"Pitcairnovy ostrovy\",\"PL\":\"Polsko\",\"PT\":\"Portugalsko\",\"PR\":\"Portoriko\",\"QA\":\"Katar\",\"RE\":\"Réunion\",\"RO\":\"Rumunsko\",\"RU\":\"Rusko\",\"RW\":\"Rwanda\",\"SH\":\"Svatá Helena\",\"KN\":\"Svatý Kryštof a Nevis\",\"LC\":\"Svatá Lucie\",\"PM\":\"Saint Pierre a Miquelon\",\"VC\":\"Svatý Vincenc a Grenadiny\",\"WS\":\"Samoa\",\"SM\":\"San Marino\",\"ST\":\"Svatý Tomáš a Princův ostrov\",\"SA\":\"Saúdská Arábie\",\"SN\":\"Senegal\",\"RS\":\"Srbsko\",\"SC\":\"Seychely\",\"SL\":\"Sierra Leone\",\"SG\":\"Singapur\",\"SK\":\"Slovensko\",\"SI\":\"Slovinsko\",\"SB\":\"Šalamounovy ostrovy\",\"SO\":\"Somálsko\",\"ZA\":\"Jihoafrická republika\",\"ES\":\"Španělsko\",\"LK\":\"Srí Lanka\",\"SD\":\"Súdán\",\"SR\":\"Surinam\",\"SJ\":\"Svalbard\",\"SZ\":\"Svazijsko\",\"SE\":\"Švédsko\",\"CH\":\"Švýcarsko\",\"TW\":\"Tchaj-wan\",\"TJ\":\"Tádžikistán\",\"TZ\":\"Tanzánie\",\"TH\":\"Thajsko\",\"TL\":\"Východní Timor\",\"TG\":\"Togo\",\"TK\":\"Tokelau\",\"TO\":\"Tonga\",\"TT\":\"Trinidad a Tobago\",\"TN\":\"Tunisko\",\"TR\":\"Turecko\",\"TM\":\"Turkmenistán\",\"TC\":\"Ostrovy Turks a Caicos\",\"TV\":\"Tuvalu\",\"UG\":\"Uganda\",\"UA\":\"Ukrajina\",\"AE\":\"Spojené arabské emiráty\",\"GB\":\"Velká Británie\",\"US\":\"USA\",\"UY\":\"Uruguay\",\"UZ\":\"Uzbekistán\",\"VU\":\"Vanuatu\",\"VE\":\"Venezuela\",\"VN\":\"Vietnam\",\"VG\":\"Britské Panenské ostrovy\",\"VI\":\"Panenské ostrovy\",\"EH\":\"Západní Sahara\",\"YE\":\"Jemen\",\"ZM\":\"Zambie\",\"ZW\":\"Zimbabwe\"}");

/***/ }),
/* 434 */
/***/ (function(module) {

module.exports = JSON.parse("{\"conference\":\"Konferenz\",\"extension\":\"Nebenstelle\",\"validation_error_meeting_validate_duplicate_name\":\"Dieser Meetingname ist bereits vergeben.\",\"validation_error_meeting_validate_pattern_pin\":\"Eintrag enthält ungültige Zeichen.\",\"AF\":\"Afghanistan\",\"AL\":\"Albanien\",\"DZ\":\"Algerien\",\"AS\":\"Amerikanisch-Samoa\",\"AD\":\"Andorra\",\"AO\":\"Angola\",\"AI\":\"Anguilla\",\"AG\":\"Antigua und Barbuda\",\"AR\":\"Argentinien\",\"AM\":\"Armenien\",\"AW\":\"Aruba\",\"AU\":\"Australien\",\"AT\":\"Österreich\",\"AZ\":\"Aserbaidschan\",\"BS\":\"Bahamas\",\"BH\":\"Bahrain\",\"BD\":\"Bangladesch\",\"BB\":\"Barbados\",\"BY\":\"Weißrussland\",\"BE\":\"Belgien\",\"BZ\":\"Belize\",\"BJ\":\"Benin\",\"BM\":\"Bermuda\",\"BT\":\"Bhutan\",\"BO\":\"Bolivien\",\"BA\":\"Bosnien und Herzegowina\",\"BW\":\"Botsuana\",\"BR\":\"Brasilien\",\"BN\":\"Brunei Darussalam\",\"BG\":\"Bulgarien\",\"BF\":\"Burkina Faso\",\"BI\":\"Burundi\",\"KH\":\"Kambodscha\",\"CM\":\"Kamerun\",\"CA\":\"Kanada\",\"CV\":\"Kap Verde\",\"KY\":\"Kaimaninseln\",\"CF\":\"Zentralafrikanische Republik\",\"TD\":\"Tschad\",\"CL\":\"Chile\",\"CN\":\"China\",\"CX\":\"Weihnachtsinseln\",\"CC\":\"Kokosinseln (Keelinginseln)\",\"CO\":\"Kolumbien\",\"KM\":\"Komoren\",\"CG\":\"Republik Kongo\",\"CD\":\"Demokratische Republik Kongo\",\"CK\":\"Cookinseln\",\"CR\":\"Costa Rica\",\"CI\":\"Elfenbeinküste\",\"HR\":\"Kroatien\",\"CU\":\"Kuba\",\"CY\":\"Zypern\",\"CZ\":\"Tschechische Republik\",\"DK\":\"Dänemark\",\"DJ\":\"Dschibuti\",\"DM\":\"Dominica\",\"DO\":\"Dominikanische Republik\",\"EC\":\"Ecuador\",\"EG\":\"Ägypten\",\"SV\":\"El Salvador\",\"GQ\":\"Äquatorialguinea\",\"ER\":\"Eritrea\",\"EE\":\"Estland\",\"ET\":\"Äthiopien\",\"EU\":\"Europäische Union\",\"FK\":\"Falklandinseln (Malwinen)\",\"FO\":\"Färöer\",\"FJ\":\"Fidschi\",\"FI\":\"Finnland\",\"FR\":\"Frankreich\",\"GF\":\"Französisch-Guayana\",\"PF\":\"Französisch-Polynesien\",\"GA\":\"Gabun\",\"GM\":\"Gambia\",\"GE\":\"Georgien\",\"DE\":\"Deutschland\",\"GH\":\"Ghana\",\"GI\":\"Gibraltar\",\"GR\":\"Griechenland\",\"GL\":\"Grönland\",\"GD\":\"Grenada\",\"GP\":\"Guadeloupe\",\"GU\":\"Guam\",\"GT\":\"Guatemala\",\"GG\":\"Guernsey\",\"GN\":\"Guinea\",\"GW\":\"Guinea-Bissau\",\"GY\":\"Guyana\",\"GZ\":\"Gazastreifen\",\"HT\":\"Haiti\",\"VA\":\"Heiliger Stuhl (Vatikanstadt)\",\"HN\":\"Honduras\",\"HK\":\"Hongkong\",\"HU\":\"Ungarn\",\"IS\":\"Island\",\"IN\":\"Indien\",\"ID\":\"Indonesien\",\"IQ\":\"Irak\",\"IE\":\"Irland\",\"IM\":\"Insel Man\",\"IL\":\"Israel\",\"IT\":\"Italien\",\"JM\":\"Jamaika\",\"JP\":\"Japan\",\"JE\":\"Jersey\",\"JO\":\"Jordanien\",\"KZ\":\"Kasachstan\",\"KE\":\"Kenia\",\"KI\":\"Kiribati\",\"KR\":\"Südkorea\",\"KW\":\"Kuwait\",\"KG\":\"Kirgisistan\",\"LA\":\"Laos\",\"LV\":\"Lettland\",\"LB\":\"Libanon\",\"LS\":\"Lesotho\",\"LR\":\"Liberia\",\"LY\":\"Libyen\",\"LI\":\"Liechtenstein\",\"LT\":\"Litauen\",\"LU\":\"Luxemburg\",\"MO\":\"Macau\",\"MK\":\"Mazedonien\",\"MG\":\"Madagaskar\",\"MW\":\"Malawi\",\"MY\":\"Malaysia\",\"MV\":\"Malediven\",\"ML\":\"Mali\",\"MT\":\"Malta\",\"MH\":\"Marshallinseln\",\"MQ\":\"Martinique\",\"MR\":\"Mauretanien\",\"MU\":\"Mauritius\",\"YT\":\"Mayotte\",\"MX\":\"Mexiko\",\"FM\":\"Mikronesien, Föderierte Staaten von\",\"MD\":\"Moldau\",\"MC\":\"Monaco\",\"MN\":\"Mongolei\",\"ME\":\"Montenegro\",\"MS\":\"Montserrat\",\"MA\":\"Marokko\",\"MZ\":\"Mosambik\",\"MM\":\"Myanmar\",\"NA\":\"Namibia\",\"NR\":\"Nauru\",\"NP\":\"Nepal\",\"NL\":\"Niederlande\",\"NC\":\"Neukaledonien\",\"NZ\":\"Neuseeland\",\"NI\":\"Nicaragua\",\"NE\":\"Niger\",\"NG\":\"Nigeria\",\"NU\":\"Niue\",\"NF\":\"Norfolkinsel\",\"MP\":\"Nördliche Marianen\",\"NO\":\"Norwegen\",\"OM\":\"Oman\",\"PK\":\"Pakistan\",\"PW\":\"Palau\",\"PA\":\"Panama\",\"PG\":\"Papua-Neuguinea\",\"PY\":\"Paraguay\",\"PE\":\"Peru\",\"PH\":\"Philippinen\",\"PN\":\"Pitcairninseln\",\"PL\":\"Polen\",\"PT\":\"Portugal\",\"PR\":\"Puerto Rico\",\"QA\":\"Katar\",\"RE\":\"Réunion\",\"RO\":\"Rumänien\",\"RU\":\"Russland\",\"RW\":\"Ruanda\",\"SH\":\"St. Helena\",\"KN\":\"St. Kitts und Nevis\",\"LC\":\"St. Lucia\",\"PM\":\"St. Pierre und Miquelon\",\"VC\":\"St. Vincent und die Grenadinen\",\"WS\":\"Samoa\",\"SM\":\"San Marino\",\"ST\":\"São Tomé und Príncipe\",\"SA\":\"Saudi-Arabien\",\"SN\":\"Senegal\",\"RS\":\"Serbien\",\"SC\":\"Seychellen\",\"SL\":\"Sierra Leone\",\"SG\":\"Singapur\",\"SK\":\"Slowakei\",\"SI\":\"Slowenien\",\"SB\":\"Salomonen\",\"SO\":\"Somalia\",\"ZA\":\"Südafrika\",\"ES\":\"Spanien\",\"LK\":\"Sri Lanka\",\"SD\":\"Sudan\",\"SR\":\"Suriname\",\"SJ\":\"Svalbard\",\"SZ\":\"Swasiland\",\"SE\":\"Schweden\",\"CH\":\"Schweiz\",\"TW\":\"Taiwan\",\"TJ\":\"Tadschikistan\",\"TZ\":\"Tansania\",\"TH\":\"Thailand\",\"TL\":\"Timor-Leste\",\"TG\":\"Togo\",\"TK\":\"Tokelau\",\"TO\":\"Tonga\",\"TT\":\"Trinidad und Tobago\",\"TN\":\"Tunesien\",\"TR\":\"Türkei\",\"TM\":\"Turkmenistan\",\"TC\":\"Turks- und Caicosinseln\",\"TV\":\"Tuvalu\",\"UG\":\"Uganda\",\"UA\":\"Ukraine\",\"AE\":\"Vereinigte Arabische Emirate\",\"GB\":\"Großbritannien\",\"US\":\"USA\",\"UY\":\"Uruguay\",\"UZ\":\"Usbekistan\",\"VU\":\"Vanuatu\",\"VE\":\"Venezuela\",\"VN\":\"Vietnam\",\"VG\":\"Britische Jungferninseln\",\"VI\":\"Jungferninseln\",\"EH\":\"Westsahara\",\"YE\":\"Jemen\",\"ZM\":\"Sambia\",\"ZW\":\"Simbabwe\"}");

/***/ }),
/* 435 */
/***/ (function(module) {

module.exports = JSON.parse("{\"conference\":\"Conference\",\"extension\":\"Extension\",\"validation_error_meeting_validate_duplicate_name\":\"This meeting name is already taken.\",\"validation_error_meeting_validate_pattern_pin\":\"Entry contains invalid characters.\",\"AF\":\"Afghanistan\",\"AL\":\"Albania\",\"DZ\":\"Algeria\",\"AS\":\"American Samoa\",\"AD\":\"Andorra\",\"AO\":\"Angola\",\"AI\":\"Anguilla\",\"AG\":\"Antigua And Barbuda\",\"AR\":\"Argentina\",\"AM\":\"Armenia\",\"AW\":\"Aruba\",\"AU\":\"Australia\",\"AT\":\"Austria\",\"AZ\":\"Azerbaijan\",\"BS\":\"Bahamas\",\"BH\":\"Bahrain\",\"BD\":\"Bangladesh\",\"BB\":\"Barbados\",\"BY\":\"Belarus\",\"BE\":\"Belgium\",\"BZ\":\"Belize\",\"BJ\":\"Benin\",\"BM\":\"Bermuda\",\"BT\":\"Bhutan\",\"BO\":\"Bolivia\",\"BA\":\"Bosnia And Herzegovina\",\"BW\":\"Botswana\",\"BR\":\"Brazil\",\"BN\":\"Brunei\",\"BG\":\"Bulgaria\",\"BF\":\"Burkina Faso\",\"BI\":\"Burundi\",\"KH\":\"Cambodia\",\"CM\":\"Cameroon\",\"CA\":\"Canada\",\"CV\":\"Cape Verde\",\"KY\":\"Cayman Islands\",\"CF\":\"Central African Republic\",\"TD\":\"Chad\",\"CL\":\"Chile\",\"CN\":\"China\",\"CX\":\"Christmas Island\",\"CC\":\"Cocos (Keeling) Islands\",\"CO\":\"Colombia\",\"KM\":\"Comoros\",\"CG\":\"Repubic of Congo\",\"CD\":\"Democratic Republic of Congo\",\"CK\":\"Cook Islands\",\"CR\":\"Costa Rica\",\"CI\":\"Cote D\\\"Ivoire\",\"HR\":\"Croatia\",\"CU\":\"Cuba\",\"CY\":\"Cyprus\",\"CZ\":\"Czech Republic\",\"DK\":\"Denmark\",\"DJ\":\"Djibouti\",\"DM\":\"Dominica\",\"DO\":\"Dominican Republic\",\"EC\":\"Ecuador\",\"EG\":\"Egypt\",\"SV\":\"El Salvador\",\"GQ\":\"Equatorial Guinea\",\"ER\":\"Eritrea\",\"EE\":\"Estonia\",\"ET\":\"Ethiopia\",\"EU\":\"European Union\",\"FK\":\"Falkland Islands (Malvinas)\",\"FO\":\"Faroe Islands\",\"FJ\":\"Fiji\",\"FI\":\"Finland\",\"FR\":\"France\",\"GF\":\"French Guiana\",\"PF\":\"French Polynesia\",\"GA\":\"Gabon\",\"GM\":\"Gambia\",\"GE\":\"Georgia\",\"DE\":\"Germany\",\"GH\":\"Ghana\",\"GI\":\"Gibraltar\",\"GR\":\"Greece\",\"GL\":\"Greenland\",\"GD\":\"Grenada\",\"GP\":\"Guadeloupe\",\"GU\":\"Guam\",\"GT\":\"Guatemala\",\"GG\":\"Guernsey\",\"GN\":\"Guinea\",\"GW\":\"Guinea-Bissau\",\"GY\":\"Guyana\",\"GZ\":\"Gaza Strip\",\"HT\":\"Haiti\",\"VA\":\"Holy See (Vatican City)\",\"HN\":\"Honduras\",\"HK\":\"Hong Kong\",\"HU\":\"Hungary\",\"IS\":\"Iceland\",\"IN\":\"India\",\"ID\":\"Indonesia\",\"IQ\":\"Iraq\",\"IE\":\"Ireland\",\"IM\":\"Isle Of Man\",\"IL\":\"Israel\",\"IT\":\"Italy\",\"JM\":\"Jamaica\",\"JP\":\"Japan\",\"JE\":\"Jersey\",\"JO\":\"Jordan\",\"KZ\":\"Kazakhstan\",\"KE\":\"Kenya\",\"KI\":\"Kiribati\",\"KR\":\"South Korea\",\"KW\":\"Kuwait\",\"KG\":\"Kyrgyzstan\",\"LA\":\"Laos\",\"LV\":\"Latvia\",\"LB\":\"Lebanon\",\"LS\":\"Lesotho\",\"LR\":\"Liberia\",\"LY\":\"Libya\",\"LI\":\"Liechtenstein\",\"LT\":\"Lithuania\",\"LU\":\"Luxembourg\",\"MO\":\"Macao\",\"MK\":\"Macedonia\",\"MG\":\"Madagascar\",\"MW\":\"Malawi\",\"MY\":\"Malaysia\",\"MV\":\"Maldives\",\"ML\":\"Mali\",\"MT\":\"Malta\",\"MH\":\"Marshall Islands\",\"MQ\":\"Martinique\",\"MR\":\"Mauritania\",\"MU\":\"Mauritius\",\"YT\":\"Mayotte\",\"MX\":\"Mexico\",\"FM\":\"Micronesia, Federated States Of\",\"MD\":\"Moldova\",\"MC\":\"Monaco\",\"MN\":\"Mongolia\",\"ME\":\"Montenegro\",\"MS\":\"Montserrat\",\"MA\":\"Morocco\",\"MZ\":\"Mozambique\",\"MM\":\"Myanmar\",\"NA\":\"Namibia\",\"NR\":\"Nauru\",\"NP\":\"Nepal\",\"NL\":\"Netherlands\",\"NC\":\"New Caledonia\",\"NZ\":\"New Zealand\",\"NI\":\"Nicaragua\",\"NE\":\"Niger\",\"NG\":\"Nigeria\",\"NU\":\"Niue\",\"NF\":\"Norfolk Island\",\"MP\":\"Northern Mariana Islands\",\"NO\":\"Norway\",\"OM\":\"Oman\",\"PK\":\"Pakistan\",\"PW\":\"Palau\",\"PA\":\"Panama\",\"PG\":\"Papua New Guinea\",\"PY\":\"Paraguay\",\"PE\":\"Peru\",\"PH\":\"Philippines\",\"PN\":\"Pitcairn Islands\",\"PL\":\"Poland\",\"PT\":\"Portugal\",\"PR\":\"Puerto Rico\",\"QA\":\"Qatar\",\"RE\":\"Reunion\",\"RO\":\"Romania\",\"RU\":\"Russia\",\"RW\":\"Rwanda\",\"SH\":\"Saint Helena\",\"KN\":\"Saint Kitts And Nevis\",\"LC\":\"Saint Lucia\",\"PM\":\"Saint Pierre And Miquelon\",\"VC\":\"Saint Vincent And Grenadines\",\"WS\":\"Samoa\",\"SM\":\"San Marino\",\"ST\":\"Sao Tome And Principe\",\"SA\":\"Saudi Arabia\",\"SN\":\"Senegal\",\"RS\":\"Serbia\",\"SC\":\"Seychelles\",\"SL\":\"Sierra Leone\",\"SG\":\"Singapore\",\"SK\":\"Slovakia\",\"SI\":\"Slovenia\",\"SB\":\"Solomon Islands\",\"SO\":\"Somalia\",\"ZA\":\"South Africa\",\"ES\":\"Spain\",\"LK\":\"Sri Lanka\",\"SD\":\"Sudan\",\"SR\":\"Suriname\",\"SJ\":\"Svalbard\",\"SZ\":\"Swaziland\",\"SE\":\"Sweden\",\"CH\":\"Switzerland\",\"TW\":\"Taiwan\",\"TJ\":\"Tajikistan\",\"TZ\":\"Tanzania\",\"TH\":\"Thailand\",\"TL\":\"East-Timor\",\"TG\":\"Togo\",\"TK\":\"Tokelau\",\"TO\":\"Tonga\",\"TT\":\"Trinidad And Tobago\",\"TN\":\"Tunisia\",\"TR\":\"Turkey\",\"TM\":\"Turkmenistan\",\"TC\":\"Turks And Caicos Islands\",\"TV\":\"Tuvalu\",\"UG\":\"Uganda\",\"UA\":\"Ukraine\",\"AE\":\"United Arab Emirates\",\"GB\":\"United Kingdom\",\"US\":\"United States\",\"UY\":\"Uruguay\",\"UZ\":\"Uzbekistan\",\"VU\":\"Vanuatu\",\"VE\":\"Venezuela\",\"VN\":\"Vietnam\",\"VG\":\"British Virgin Islands\",\"VI\":\"Virgin Islands\",\"EH\":\"Western Sahara\",\"YE\":\"Yemen\",\"ZM\":\"Zambia\",\"ZW\":\"Zimbabwe\"}");

/***/ }),
/* 436 */
/***/ (function(module) {

module.exports = JSON.parse("{\"conference\":\"Conferencia\",\"extension\":\"Extensión\",\"validation_error_meeting_validate_duplicate_name\":\"Este nombre de reunión ya está ocupado.\",\"validation_error_meeting_validate_pattern_pin\":\"La entrada contiene caracteres no válidos.\",\"AF\":\"Afganistán\",\"AL\":\"Albania\",\"DZ\":\"Argelia\",\"AS\":\"Samoa Americana\",\"AD\":\"Andorra\",\"AO\":\"Angola\",\"AI\":\"Anguilla\",\"AG\":\"Antigua y Barbuda\",\"AR\":\"Argentina\",\"AM\":\"Armenia\",\"AW\":\"Aruba\",\"AU\":\"Australia\",\"AT\":\"Austria\",\"AZ\":\"Azerbaiyán\",\"BS\":\"Bahamas\",\"BH\":\"Bahréin\",\"BD\":\"Bangladesh\",\"BB\":\"Barbados\",\"BY\":\"Bielorrusia\",\"BE\":\"Bélgica\",\"BZ\":\"Belice\",\"BJ\":\"Benín\",\"BM\":\"Bermudas\",\"BT\":\"Bután\",\"BO\":\"Bolivia\",\"BA\":\"Bosnia y Herzegovina\",\"BW\":\"Botsuana\",\"BR\":\"Brasil\",\"BN\":\"Brunei\",\"BG\":\"Bulgaria\",\"BF\":\"Burkina Faso\",\"BI\":\"Burundi\",\"KH\":\"Camboya\",\"CM\":\"Camerún\",\"CA\":\"Canadá\",\"CV\":\"Cabo Verde\",\"KY\":\"Islas Caimán\",\"CF\":\"República Centroafricana\",\"TD\":\"Chad\",\"CL\":\"Chile\",\"CN\":\"China\",\"CX\":\"Isla Christmas\",\"CC\":\"Islas Cocos\",\"CO\":\"Colombia\",\"KM\":\"Comores\",\"CG\":\"República del Congo\",\"CD\":\"República Democrática del Congo\",\"CK\":\"Islas Cook\",\"CR\":\"Costa Rica\",\"CI\":\"Costa de Marfil\",\"HR\":\"Croacia\",\"CU\":\"Cuba\",\"CY\":\"Chipre\",\"CZ\":\"República Checa\",\"DK\":\"Dinamarca\",\"DJ\":\"Yibuti\",\"DM\":\"Dominica\",\"DO\":\"República Dominicana\",\"EC\":\"Ecuador\",\"EG\":\"Egipto\",\"SV\":\"El Salvador\",\"GQ\":\"Guinea Ecuatorial\",\"ER\":\"Eritrea\",\"EE\":\"Estonia\",\"ET\":\"Etiopía\",\"EU\":\"Comunidad Europea\",\"FK\":\"Islas Malvinas\",\"FO\":\"Islas Feroe\",\"FJ\":\"Fiyi\",\"FI\":\"Finlandia\",\"FR\":\"Francia\",\"GF\":\"Guayana Francesa\",\"PF\":\"Polinesia Francesa\",\"GA\":\"Gabón\",\"GM\":\"Gambia\",\"GE\":\"Georgia\",\"DE\":\"Alemania\",\"GH\":\"Ghana\",\"GI\":\"Gibraltar\",\"GR\":\"Grecia\",\"GL\":\"Groenlandia\",\"GD\":\"Granada\",\"GP\":\"Guadalupe\",\"GU\":\"Guam\",\"GT\":\"Guatemala\",\"GG\":\"Guernsey\",\"GN\":\"Guinea\",\"GW\":\"Guinea-Bissau\",\"GY\":\"Guayana\",\"GZ\":\"Franja de Gaza\",\"HT\":\"Haití\",\"VA\":\"Santa Sede (Ciudad del Vaticano)\",\"HN\":\"Honduras\",\"HK\":\"Hong Kong\",\"HU\":\"Hungría\",\"IS\":\"Islandia\",\"IN\":\"India\",\"ID\":\"Indonesia\",\"IQ\":\"Irak\",\"IE\":\"Irlanda\",\"IM\":\"Isla de Man\",\"IL\":\"Israel\",\"IT\":\"Italia\",\"JM\":\"Jamaica\",\"JP\":\"Japón\",\"JE\":\"Jersey\",\"JO\":\"Jordania\",\"KZ\":\"Kazajistán\",\"KE\":\"Kenia\",\"KI\":\"Kiribati\",\"KR\":\"Corea del Sur\",\"KW\":\"Kuwait\",\"KG\":\"Kirguistán\",\"LA\":\"Laos\",\"LV\":\"Letonia\",\"LB\":\"Líbano\",\"LS\":\"Lesoto\",\"LR\":\"Liberia\",\"LY\":\"Libia\",\"LI\":\"Liechtenstein\",\"LT\":\"Lituania\",\"LU\":\"Luxemburgo\",\"MO\":\"Macao\",\"MK\":\"Macedonia\",\"MG\":\"Madagascar\",\"MW\":\"Malawi\",\"MY\":\"Malasia\",\"MV\":\"Maldivas\",\"ML\":\"Malí\",\"MT\":\"Malta\",\"MH\":\"Islas Marshall\",\"MQ\":\"Martinica\",\"MR\":\"Mauritania\",\"MU\":\"Mauricio\",\"YT\":\"Mayotte\",\"MX\":\"México\",\"FM\":\"Micronesia\",\"MD\":\"Moldavia\",\"MC\":\"Mónaco\",\"MN\":\"Mongolia\",\"ME\":\"Montenegro\",\"MS\":\"Montserrat\",\"MA\":\"Marruecos\",\"MZ\":\"Mozambique\",\"MM\":\"Birmania\",\"NA\":\"Namibia\",\"NR\":\"Nauru\",\"NP\":\"Nepal\",\"NL\":\"Países Bajos\",\"NC\":\"Nueva Caledonia\",\"NZ\":\"Nueva Zelanda\",\"NI\":\"Nicaragua\",\"NE\":\"Níger\",\"NG\":\"Nigeria\",\"NU\":\"Niue\",\"NF\":\"Isla Norfolk\",\"MP\":\"Islas Marianas del Norte\",\"NO\":\"Noruega\",\"OM\":\"Omán\",\"PK\":\"Pakistán\",\"PW\":\"Palaos\",\"PA\":\"Panamá\",\"PG\":\"Papúa Nueva Guinea\",\"PY\":\"Paraguay\",\"PE\":\"Perú\",\"PH\":\"Filipinas\",\"PN\":\"Islas Pitcairn\",\"PL\":\"Polonia\",\"PT\":\"Portugal\",\"PR\":\"Puerto Rico\",\"QA\":\"Qatar\",\"RE\":\"Reunión\",\"RO\":\"Rumanía\",\"RU\":\"Rusia\",\"RW\":\"Ruanda\",\"SH\":\"Santa Elena\",\"KN\":\"San Cristóbal y Nieves\",\"LC\":\"Santa Lucía\",\"PM\":\"San Pedro y Miquelón\",\"VC\":\"San Vicente y las Granadinas\",\"WS\":\"Samoa\",\"SM\":\"San Marino\",\"ST\":\"Santo Tomé y Príncipe\",\"SA\":\"Arabia Saudí\",\"SN\":\"Senegal\",\"RS\":\"Serbia\",\"SC\":\"Seychelles\",\"SL\":\"Sierra Leona\",\"SG\":\"Singapur\",\"SK\":\"Eslovaquia\",\"SI\":\"Eslovenia\",\"SB\":\"Islas Salomón\",\"SO\":\"Somalia\",\"ZA\":\"Sudáfrica\",\"ES\":\"España\",\"LK\":\"Sri Lanka\",\"SD\":\"Sudán\",\"SR\":\"Surinam\",\"SJ\":\"Svalbard\",\"SZ\":\"Suazilandia\",\"SE\":\"Suecia\",\"CH\":\"Suiza\",\"TW\":\"Taiwán\",\"TJ\":\"Tayikistán\",\"TZ\":\"Tanzania\",\"TH\":\"Tailandia\",\"TL\":\"Timor Oriental\",\"TG\":\"Togo\",\"TK\":\"Tokelau\",\"TO\":\"Tonga\",\"TT\":\"Trinidad y Tobago\",\"TN\":\"Túnez\",\"TR\":\"Turquía\",\"TM\":\"Turkmenistán\",\"TC\":\"Islas Turks y Caicos\",\"TV\":\"Tuvalu\",\"UG\":\"Uganda\",\"UA\":\"Ucrania\",\"AE\":\"Emiratos Árabes Unidos\",\"GB\":\"Reino Unido\",\"US\":\"Estados Unidos\",\"UY\":\"Uruguay\",\"UZ\":\"Uzbekistán\",\"VU\":\"Vanuatu\",\"VE\":\"Venezuela\",\"VN\":\"Vietnam\",\"VG\":\"Islas Vírgenes Británicas\",\"VI\":\"Islas Vírgenes\",\"EH\":\"Sáhara Occidental\",\"YE\":\"Yemen\",\"ZM\":\"Zambia\",\"ZW\":\"Zimbabue\"}");

/***/ }),
/* 437 */
/***/ (function(module) {

module.exports = JSON.parse("{\"conference\":\"Konferenssi\",\"extension\":\"Alanumero\",\"validation_error_meeting_validate_duplicate_name\":\"Tämä kokousnimi ei ole vapaa.\",\"validation_error_meeting_validate_pattern_pin\":\"Sisältää merkkejä, joita ei hyväksytä.\",\"AF\":\"Afganistan\",\"AL\":\"Albania\",\"DZ\":\"Algeria\",\"AS\":\"Amerikan Samoa\",\"AD\":\"Andorra\",\"AO\":\"Angola\",\"AI\":\"Anguilla\",\"AG\":\"Antigua ja Barbuda\",\"AR\":\"Argentiina\",\"AM\":\"Armenia\",\"AW\":\"Aruba\",\"AU\":\"Australia\",\"AT\":\"Itävalta\",\"AZ\":\"Azerbaidžan\",\"BS\":\"Bahama\",\"BH\":\"Bahrain\",\"BD\":\"Bangladesh\",\"BB\":\"Barbados\",\"BY\":\"Valko-Venäjä\",\"BE\":\"Belgia\",\"BZ\":\"Belize\",\"BJ\":\"Benin\",\"BM\":\"Bermuda\",\"BT\":\"Bhutan\",\"BO\":\"Bolivia\",\"BA\":\"Bosnia ja Hertsegovina\",\"BW\":\"Botswana\",\"BR\":\"Brasilia\",\"BN\":\"Brunei\",\"BG\":\"Bulgaria\",\"BF\":\"Burkina Faso\",\"BI\":\"Burundi\",\"KH\":\"Kambodža\",\"CM\":\"Kamerun\",\"CA\":\"Kanada\",\"CV\":\"Kap Verde\",\"KY\":\"Caymansaaret\",\"CF\":\"Keski-Afrikan tasavalta\",\"TD\":\"Tšad\",\"CL\":\"Chile\",\"CN\":\"Kiina\",\"CX\":\"Joulusaari\",\"CC\":\"Kookossaaret (Keelingsaaret)\",\"CO\":\"Kolumbia\",\"KM\":\"Komorit\",\"CG\":\"Kongon tasavalta\",\"CD\":\"Kongon demokraattinen tasavalta\",\"CK\":\"Cookinsaaret\",\"CR\":\"Costa Rica\",\"CI\":\" Côte d'Ivoire\",\"HR\":\"Kroatia\",\"CU\":\"Kuuba\",\"CY\":\"Kypros\",\"CZ\":\"Tšekin tasavalta\",\"DK\":\"Tanska\",\"DJ\":\"Djibouti\",\"DM\":\"Dominica\",\"DO\":\"Dominikaaninen tasavalta\",\"EC\":\"Ecuador\",\"EG\":\"Egypti\",\"SV\":\"El Salvador\",\"GQ\":\"Päiväntasaajan Guinea\",\"ER\":\"Eritrea\",\"EE\":\"Viro\",\"ET\":\"Etiopia\",\"EU\":\"Euroopan unioni\",\"FK\":\"Falklandinsaaret (Malvinassaaret)\",\"FO\":\"Färsaaret\",\"FJ\":\"Fidži\",\"FI\":\"Suomi\",\"FR\":\"Ranska\",\"GF\":\"Ranskan Guayana\",\"PF\":\"Ranskan Polynesia\",\"GA\":\"Gabon\",\"GM\":\"Gambia\",\"GE\":\"Georgia\",\"DE\":\"Saksa\",\"GH\":\"Ghana\",\"GI\":\"Gibraltar\",\"GR\":\"Kreikka\",\"GL\":\"Grönlanti\",\"GD\":\"Grenada\",\"GP\":\"Guadeloupe\",\"GU\":\"Guam\",\"GT\":\"Guatemala\",\"GG\":\"Guernsey\",\"GN\":\"Guinea\",\"GW\":\"Guinea-Bissau\",\"GY\":\"Guyana\",\"GZ\":\"Gazan alue\",\"HT\":\"Haiti\",\"VA\":\"Vatikaani\",\"HN\":\"Honduras\",\"HK\":\"Hongkong\",\"HU\":\"Unkari\",\"IS\":\"Islanti\",\"IN\":\"Intia\",\"ID\":\"Indonesia\",\"IQ\":\"Irak\",\"IE\":\"Irlanti\",\"IM\":\"Mansaari\",\"IL\":\"Israel\",\"IT\":\"Italia\",\"JM\":\"Jamaika\",\"JP\":\"Japani\",\"JE\":\"Jersey\",\"JO\":\"Jordania\",\"KZ\":\"Kazakstan\",\"KE\":\"Kenia\",\"KI\":\"Kiribati\",\"KR\":\"Etelä-Korea\",\"KW\":\"Kuwait\",\"KG\":\"Kirgisia\",\"LA\":\"Laos\",\"LV\":\"Latvia\",\"LB\":\"Libanon\",\"LS\":\"Lesotho\",\"LR\":\"Liberia\",\"LY\":\"Libya\",\"LI\":\"Liechtenstein\",\"LT\":\"Liettua\",\"LU\":\"Luxemburg\",\"MO\":\"Macao\",\"MK\":\"Makedonia\",\"MG\":\"Madagaskar\",\"MW\":\"Malawi\",\"MY\":\"Malesia\",\"MV\":\"Malediivit\",\"ML\":\"Mali\",\"MT\":\"Malta\",\"MH\":\"Marshallinsaaret\",\"MQ\":\"Martinique\",\"MR\":\"Mauritania\",\"MU\":\"Mauritius\",\"YT\":\"Mayotte\",\"MX\":\"Meksiko\",\"FM\":\"Mikronesian liittovaltio\",\"MD\":\"Moldova\",\"MC\":\"Monaco\",\"MN\":\"Mongolia\",\"ME\":\"Montenegro\",\"MS\":\"Montserrat\",\"MA\":\"Marokko\",\"MZ\":\"Mosambik\",\"MM\":\"Myanmar\",\"NA\":\"Namibia\",\"NR\":\"Nauru\",\"NP\":\"Nepal\",\"NL\":\"Alankomaat\",\"NC\":\"Uusi-Kaledonia\",\"NZ\":\"Uusi-Seelanti\",\"NI\":\"Nicaragua\",\"NE\":\"Niger\",\"NG\":\"Nigeria\",\"NU\":\"Niue\",\"NF\":\"Norfolkinsaari\",\"MP\":\"Pohjois-Mariaanit\",\"NO\":\"Norja\",\"OM\":\"Oman\",\"PK\":\"Pakistan\",\"PW\":\"Palau\",\"PA\":\"Panama\",\"PG\":\"Papua-Uusi-Guinea\",\"PY\":\"Paraguay\",\"PE\":\"Peru\",\"PH\":\"Filippiinit\",\"PN\":\"Pitcairn\",\"PL\":\"Puola\",\"PT\":\"Portugali\",\"PR\":\"Puerto Rico\",\"QA\":\"Qatar\",\"RE\":\"Réunion\",\"RO\":\"Romania\",\"RU\":\"Venäjä\",\"RW\":\"Ruanda\",\"SH\":\"Saint Helena\",\"KN\":\"Saint Kitts ja Nevis\",\"LC\":\"Saint Lucia\",\"PM\":\"Saint-Pierre ja Miquelon\",\"VC\":\"Saint Vincent ja Grenadiinit\",\"WS\":\"Samoa\",\"SM\":\"San Marino\",\"ST\":\"São Tomé ja Príncipe\",\"SA\":\"Saudi-Arabia\",\"SN\":\"Senegal\",\"RS\":\"Serbia\",\"SC\":\"Seychellit\",\"SL\":\"Sierra Leone\",\"SG\":\"Singapore\",\"SK\":\"Slovakia\",\"SI\":\"Slovenia\",\"SB\":\"Salomonsaaret\",\"SO\":\"Somalia\",\"ZA\":\"Etelä-Afrikka\",\"ES\":\"Espanja\",\"LK\":\"Sri Lanka\",\"SD\":\"Sudan\",\"SR\":\"Suriname\",\"SJ\":\"Huippuvuoret\",\"SZ\":\"Swazimaa\",\"SE\":\"Ruotsi\",\"CH\":\"Sveitsi\",\"TW\":\"Taiwan\",\"TJ\":\"Tadžikistan\",\"TZ\":\"Tansania\",\"TH\":\"Thaimaa\",\"TL\":\"Itä-Timor\",\"TG\":\"Togo\",\"TK\":\"Tokelau\",\"TO\":\"Tonga\",\"TT\":\"Trinidad ja Tobago\",\"TN\":\"Tunisia\",\"TR\":\"Turkki\",\"TM\":\"Turkmenistan\",\"TC\":\"Turks- ja Caicossaaret\",\"TV\":\"Tuvalu\",\"UG\":\"Uganda\",\"UA\":\"Ukraina\",\"AE\":\"Yhdistyneet Arabiemiirikunnat\",\"GB\":\"Yhdistynyt kuningaskunta\",\"US\":\"Yhdysvallat\",\"UY\":\"Uruguay\",\"UZ\":\"Uzbekistan\",\"VU\":\"Vanuatu\",\"VE\":\"Venezuela\",\"VN\":\"Vietnam\",\"VG\":\"Brittiläiset Neitsytsaaret\",\"VI\":\"Neitsytsaaret\",\"EH\":\"Länsi-Sahara\",\"YE\":\"Jemen\",\"ZM\":\"Sambia\",\"ZW\":\"Zimbabwe\"}");

/***/ }),
/* 438 */
/***/ (function(module) {

module.exports = JSON.parse("{\"conference\":\"Conférence\",\"extension\":\"Poste\",\"validation_error_meeting_validate_duplicate_name\":\"Ce nom de réunion est déjà pris.\",\"validation_error_meeting_validate_pattern_pin\":\"Le contenu saisi contient des caractères non valides.\",\"AF\":\"Afghanistan\",\"AL\":\"Albanie\",\"DZ\":\"Algérie\",\"AS\":\"Samoa américaines\",\"AD\":\"Andorre\",\"AO\":\"Angola\",\"AI\":\"Anguilla\",\"AG\":\"Antigua-et-Barbuda\",\"AR\":\"Argentine\",\"AM\":\"Arménie\",\"AW\":\"Aruba\",\"AU\":\"Australie\",\"AT\":\"Autriche\",\"AZ\":\"Azerbaïdjan\",\"BS\":\"Bahamas\",\"BH\":\"Bahreïn\",\"BD\":\"Bangladesh\",\"BB\":\"Barbade\",\"BY\":\"Biélorussie\",\"BE\":\"Belgique\",\"BZ\":\"Belize\",\"BJ\":\"Bénin\",\"BM\":\"Bermudes\",\"BT\":\"Bhoutan\",\"BO\":\"Bolivie\",\"BA\":\"Bosnie-Herzégovine\",\"BW\":\"Botswana\",\"BR\":\"Brésil\",\"BN\":\"Brunei\",\"BG\":\"Bulgarie\",\"BF\":\"Burkina Faso\",\"BI\":\"Burundi\",\"KH\":\"Cambodge\",\"CM\":\"Cameroun\",\"CA\":\"Canada\",\"CV\":\"Cap-Vert\",\"KY\":\"Îles Caïmans\",\"CF\":\"République centrafricaine\",\"TD\":\"Tchad\",\"CL\":\"Chili\",\"CN\":\"Chine\",\"CX\":\"Île Christmas\",\"CC\":\"Îles Cocos (Keeling)\",\"CO\":\"Colombie\",\"KM\":\"Comores\",\"CG\":\"République du Congo\",\"CD\":\"République démocratique du Congo\",\"CK\":\"Îles Cook\",\"CR\":\"Costa Rica\",\"CI\":\"Côte d'Ivoire\",\"HR\":\"Croatie\",\"CU\":\"Cuba\",\"CY\":\"Chypre\",\"CZ\":\"République tchèque\",\"DK\":\"Danemark\",\"DJ\":\"Djibouti\",\"DM\":\"Dominique\",\"DO\":\"République dominicaine\",\"EC\":\"Équateur\",\"EG\":\"Égypte\",\"SV\":\"Salvador\",\"GQ\":\"Guinée équatoriale\",\"ER\":\"Érythrée\",\"EE\":\"Estonie\",\"ET\":\"Éthiopie\",\"EU\":\"Union européenne\",\"FK\":\"Îles Malouines\",\"FO\":\"Îles Féroé\",\"FJ\":\"Îles Fidji\",\"FI\":\"Finlande\",\"FR\":\"France\",\"GF\":\"Guyane française\",\"PF\":\"Polynésie française\",\"GA\":\"Gabon\",\"GM\":\"Gambie\",\"GE\":\"Géorgie\",\"DE\":\"Allemagne\",\"GH\":\"Ghana\",\"GI\":\"Gibraltar\",\"GR\":\"Grèce\",\"GL\":\"Groenland\",\"GD\":\"Grenade\",\"GP\":\"Guadeloupe\",\"GU\":\"Guam\",\"GT\":\"Guatemala\",\"GG\":\"Guernesey\",\"GN\":\"Guinée\",\"GW\":\"Guinée-Bissau\",\"GY\":\"Guyana\",\"GZ\":\"Bande de Gaza\",\"HT\":\"Haïti\",\"VA\":\"Saint-Siège (Vatican)\",\"HN\":\"Honduras\",\"HK\":\"Hong Kong\",\"HU\":\"Hongrie\",\"IS\":\"Islande\",\"IN\":\"Inde\",\"ID\":\"Indonésie\",\"IQ\":\"Irak\",\"IE\":\"Irlande\",\"IM\":\"Île de Man\",\"IL\":\"Israël\",\"IT\":\"Italie\",\"JM\":\"Jamaïque\",\"JP\":\"Japon\",\"JE\":\"Jersey\",\"JO\":\"Jordanie\",\"KZ\":\"Kazakhstan\",\"KE\":\"Kenya\",\"KI\":\"Kiribati\",\"KR\":\"Corée du Sud\",\"KW\":\"Koweït\",\"KG\":\"Kirghizistan\",\"LA\":\"Laos\",\"LV\":\"Lettonie\",\"LB\":\"Liban\",\"LS\":\"Lesotho\",\"LR\":\"Liberia\",\"LY\":\"Libye\",\"LI\":\"Liechtenstein\",\"LT\":\"Lituanie\",\"LU\":\"Luxembourg\",\"MO\":\"Macao\",\"MK\":\"Macédoine\",\"MG\":\"Madagascar\",\"MW\":\"Malawi\",\"MY\":\"Malaisie\",\"MV\":\"Maldives\",\"ML\":\"Mali\",\"MT\":\"Malte\",\"MH\":\"Îles Marshall\",\"MQ\":\"Martinique\",\"MR\":\"Mauritanie\",\"MU\":\"Maurice\",\"YT\":\"Mayotte\",\"MX\":\"Mexique\",\"FM\":\"États fédérés de Micronésie\",\"MD\":\"Moldavie\",\"MC\":\"Monaco\",\"MN\":\"Mongolie\",\"ME\":\"Monténégro\",\"MS\":\"Montserrat\",\"MA\":\"Maroc\",\"MZ\":\"Mozambique\",\"MM\":\"Birmanie\",\"NA\":\"Namibie\",\"NR\":\"Nauru\",\"NP\":\"Népal\",\"NL\":\"Pays-Bas\",\"NC\":\"Nouvelle-Calédonie\",\"NZ\":\"Nouvelle-Zélande\",\"NI\":\"Nicaragua\",\"NE\":\"Niger\",\"NG\":\"Nigeria\",\"NU\":\"Niue\",\"NF\":\"Île Norfolk\",\"MP\":\"Îles Mariannes du Nord\",\"NO\":\"Norvège\",\"OM\":\"Oman\",\"PK\":\"Pakistan\",\"PW\":\"Palau\",\"PA\":\"Panama\",\"PG\":\"Papouasie-Nouvelle-Guinée\",\"PY\":\"Paraguay\",\"PE\":\"Pérou\",\"PH\":\"Philippines\",\"PN\":\"Île Pitcairn\",\"PL\":\"Pologne\",\"PT\":\"Portugal\",\"PR\":\"Porto Rico\",\"QA\":\"Qatar\",\"RE\":\"Réunion\",\"RO\":\"Roumanie\",\"RU\":\"Russie\",\"RW\":\"Rwanda\",\"SH\":\"Sainte-Hélène\",\"KN\":\"Saint-Christophe-et-Niévès\",\"LC\":\"Sainte-Lucie\",\"PM\":\"Saint-Pierre-et-Miquelon\",\"VC\":\"Saint-Vincent-et-les-Grenadines\",\"WS\":\"Samoa\",\"SM\":\"Saint-Marin\",\"ST\":\"Sao Tomé-et-Príncipe\",\"SA\":\"Arabie saoudite\",\"SN\":\"Sénégal\",\"RS\":\"Serbie\",\"SC\":\"Seychelles\",\"SL\":\"Sierra Leone\",\"SG\":\"Singapour\",\"SK\":\"Slovaquie\",\"SI\":\"Slovénie\",\"SB\":\"Îles Salomon\",\"SO\":\"Somalie\",\"ZA\":\"Afrique du Sud\",\"ES\":\"Espagne\",\"LK\":\"Sri Lanka\",\"SD\":\"Soudan\",\"SR\":\"Suriname\",\"SJ\":\"Îles de Svalbard\",\"SZ\":\"Swaziland\",\"SE\":\"Suède\",\"CH\":\"Suisse\",\"TW\":\"Taiwan\",\"TJ\":\"Tadjikistan\",\"TZ\":\"Tanzanie\",\"TH\":\"Thaïlande\",\"TL\":\"Timor oriental\",\"TG\":\"Togo\",\"TK\":\"Tokelau\",\"TO\":\"Tonga\",\"TT\":\"Trinité-et-Tobago\",\"TN\":\"Tunisie\",\"TR\":\"Turquie\",\"TM\":\"Turkménistan\",\"TC\":\"Îles Turks-et-Caïcos\",\"TV\":\"Tuvalu\",\"UG\":\"Ouganda\",\"UA\":\"Ukraine\",\"AE\":\"Émirats arabes unis\",\"GB\":\"Royaume-Uni\",\"US\":\"États-Unis\",\"UY\":\"Uruguay\",\"UZ\":\"Ouzbékistan\",\"VU\":\"Vanuatu\",\"VE\":\"Venezuela\",\"VN\":\"Vietnam\",\"VG\":\"Îles Vierges britanniques\",\"VI\":\"Îles Vierges\",\"EH\":\"Sahara occidental\",\"YE\":\"Yémen\",\"ZM\":\"Zambie\",\"ZW\":\"Zimbabwe\"}");

/***/ }),
/* 439 */
/***/ (function(module) {

module.exports = JSON.parse("{\"conference\":\"Conferenza\",\"extension\":\"Estensione\",\"validation_error_meeting_validate_duplicate_name\":\"Nome del meeting già in uso.\",\"validation_error_meeting_validate_pattern_pin\":\"La voce inserita contiene caratteri non validi.\",\"AF\":\"Afghanistan\",\"AL\":\"Albania\",\"DZ\":\"Algeria\",\"AS\":\"Samoa Americane\",\"AD\":\"Andorra\",\"AO\":\"Angola\",\"AI\":\"Anguilla\",\"AG\":\"Antigua e Barbuda\",\"AR\":\"Argentina\",\"AM\":\"Armenia\",\"AW\":\"Aruba\",\"AU\":\"Australia\",\"AT\":\"Austria\",\"AZ\":\"Azerbaigian\",\"BS\":\"Bahamas\",\"BH\":\"Bahrain\",\"BD\":\"Bangladesh\",\"BB\":\"Barbados\",\"BY\":\"Bielorussia\",\"BE\":\"Belgio\",\"BZ\":\"Belize\",\"BJ\":\"Benin\",\"BM\":\"Bermuda\",\"BT\":\"Bhutan\",\"BO\":\"Bolivia\",\"BA\":\"Bosnia ed Erzegovina\",\"BW\":\"Botswana\",\"BR\":\"Brasile\",\"BN\":\"Brunei\",\"BG\":\"Bulgaria\",\"BF\":\"Burkina Faso\",\"BI\":\"Burundi\",\"KH\":\"Cambogia\",\"CM\":\"Camerun\",\"CA\":\"Canada\",\"CV\":\"Capo Verde\",\"KY\":\"Isole Cayman\",\"CF\":\"Repubblica Centrafricana\",\"TD\":\"Ciad\",\"CL\":\"Cile\",\"CN\":\"Cina\",\"CX\":\"Isola di Natale\",\"CC\":\"Isole Cocos (Keeling)\",\"CO\":\"Colombia\",\"KM\":\"Comoros\",\"CG\":\"Repubblica del Congo\",\"CD\":\"Repubblica Democratica del Congo\",\"CK\":\"Isole Cook\",\"CR\":\"Costa Rica\",\"CI\":\"Costa D'Avorio\",\"HR\":\"Croazia\",\"CU\":\"Cuba\",\"CY\":\"Cipro\",\"CZ\":\"Repubblica Ceca\",\"DK\":\"Danimarca\",\"DJ\":\"Gibuti\",\"DM\":\"Dominica\",\"DO\":\"Repubblica Dominicana\",\"EC\":\"Ecuador\",\"EG\":\"Egitto\",\"SV\":\"El Salvador\",\"GQ\":\"Guinea Equatoriale\",\"ER\":\"Eritrea\",\"EE\":\"Estonia\",\"ET\":\"Etiopia\",\"EU\":\"Unione Europea\",\"FK\":\"Isole Falkland (Malvine)\",\"FO\":\"Fær Øer\",\"FJ\":\"Fiji\",\"FI\":\"Finlandia\",\"FR\":\"Francia\",\"GF\":\"Guiana Francese\",\"PF\":\"Polinesia Francese\",\"GA\":\"Gabon\",\"GM\":\"Gambia\",\"GE\":\"Georgia\",\"DE\":\"Germania\",\"GH\":\"Ghana\",\"GI\":\"Gibilterra\",\"GR\":\"Grecia\",\"GL\":\"Groenlandia\",\"GD\":\"Grenada\",\"GP\":\"Guadalupa\",\"GU\":\"Guam\",\"GT\":\"Guatemala\",\"GG\":\"Guernsey\",\"GN\":\"Guinea\",\"GW\":\"Guinea-Bissau\",\"GY\":\"Guyana\",\"GZ\":\"Striscia di Gaza\",\"HT\":\"Haiti\",\"VA\":\"Santa Sede (Città del Vaticano)\",\"HN\":\"Honduras\",\"HK\":\"Hong Kong\",\"HU\":\"Ungheria\",\"IS\":\"Islanda\",\"IN\":\"India\",\"ID\":\"Indonesia\",\"IQ\":\"Iraq\",\"IE\":\"Irlanda\",\"IM\":\"Isola di Man\",\"IL\":\"Israele\",\"IT\":\"Italia\",\"JM\":\"Giamaica\",\"JP\":\"Giappone\",\"JE\":\"Jersey\",\"JO\":\"Giordania\",\"KZ\":\"Kazakistan\",\"KE\":\"Kenya\",\"KI\":\"Kiribati\",\"KR\":\"Corea del Sud\",\"KW\":\"Kuwait\",\"KG\":\"Kirghizistan\",\"LA\":\"Laos\",\"LV\":\"Lettonia\",\"LB\":\"Libano\",\"LS\":\"Lesotho\",\"LR\":\"Liberia\",\"LY\":\"Libia\",\"LI\":\"Liechtenstein\",\"LT\":\"Lituania\",\"LU\":\"Lussemburgo\",\"MO\":\"Macao\",\"MK\":\"Macedonia\",\"MG\":\"Madagascar\",\"MW\":\"Malawi\",\"MY\":\"Malesia\",\"MV\":\"Maldive\",\"ML\":\"Mali\",\"MT\":\"Malta\",\"MH\":\"Isole Marshall\",\"MQ\":\"Martinica\",\"MR\":\"Mauritania\",\"MU\":\"Mauritius\",\"YT\":\"Mayotte\",\"MX\":\"Messico\",\"FM\":\"Micronesia, Stati Federati di\",\"MD\":\"Moldavia\",\"MC\":\"Monaco\",\"MN\":\"Mongolia\",\"ME\":\"Montenegro\",\"MS\":\"Montserrat\",\"MA\":\"Marocco\",\"MZ\":\"Mozambico\",\"MM\":\"Myanmar\",\"NA\":\"Namibia\",\"NR\":\"Nauru\",\"NP\":\"Nepal\",\"NL\":\"Paesi Bassi\",\"NC\":\"Nuova Caledonia\",\"NZ\":\"Nuova Zelanda\",\"NI\":\"Nicaragua\",\"NE\":\"Niger\",\"NG\":\"Nigeria\",\"NU\":\"Niue\",\"NF\":\"Isola Norfolk\",\"MP\":\"Isole Marianne Settentrionali\",\"NO\":\"Norvegia\",\"OM\":\"Oman\",\"PK\":\"Pakistan\",\"PW\":\"Palau\",\"PA\":\"Panama\",\"PG\":\"Papua Nuova Guinea\",\"PY\":\"Paraguay\",\"PE\":\"Perù\",\"PH\":\"Filippine\",\"PN\":\"Isole Pitcairn\",\"PL\":\"Polonia\",\"PT\":\"Portogallo\",\"PR\":\"Portorico\",\"QA\":\"Qatar\",\"RE\":\"Riunione\",\"RO\":\"Romania\",\"RU\":\"Russia\",\"RW\":\"Ruanda\",\"SH\":\"Sant'Elena\",\"KN\":\"Saint Kitts e Nevis\",\"LC\":\"Santa Lucia\",\"PM\":\"Saint-Pierre e Miquelon\",\"VC\":\"Saint Vincent e Grenadine\",\"WS\":\"Samoa\",\"SM\":\"San Marino\",\"ST\":\"São Tomé e Principe\",\"SA\":\"Arabia Saudita\",\"SN\":\"Senegal\",\"RS\":\"Serbia\",\"SC\":\"Seychelles\",\"SL\":\"Sierra Leone\",\"SG\":\"Singapore\",\"SK\":\"Slovacchia\",\"SI\":\"Slovenia\",\"SB\":\"Isole Salomone\",\"SO\":\"Somalia\",\"ZA\":\"Sud Africa\",\"ES\":\"Spagna\",\"LK\":\"Sri Lanka\",\"SD\":\"Sudan\",\"SR\":\"Suriname\",\"SJ\":\"Svalbard\",\"SZ\":\"Swaziland\",\"SE\":\"Svezia\",\"CH\":\"Svizzera\",\"TW\":\"Taiwan\",\"TJ\":\"Tagikistan\",\"TZ\":\"Tanzania\",\"TH\":\"Tailandia\",\"TL\":\"Timor Est\",\"TG\":\"Togo\",\"TK\":\"Tokelau\",\"TO\":\"Tonga\",\"TT\":\"Trinidad e Tobago\",\"TN\":\"Tunisia\",\"TR\":\"Turchia\",\"TM\":\"Turkmenistan\",\"TC\":\"Isole Turks e Caicos\",\"TV\":\"Tuvalu\",\"UG\":\"Uganda\",\"UA\":\"Ucraina\",\"AE\":\"Emirati Arabi Uniti\",\"GB\":\"Regno Unito\",\"US\":\"Stati Uniti\",\"UY\":\"Uruguay\",\"UZ\":\"Uzbekistan\",\"VU\":\"Vanuatu\",\"VE\":\"Venezuela\",\"VN\":\"Vietnam\",\"VG\":\"Isole Vergini Britanniche\",\"VI\":\"Isole Vergini\",\"EH\":\"Sahara Occidentale\",\"YE\":\"Yemen\",\"ZM\":\"Zambia\",\"ZW\":\"Zimbabwe\"}");

/***/ }),
/* 440 */
/***/ (function(module) {

module.exports = JSON.parse("{\"conference\":\"会議\",\"extension\":\"内線番号\",\"validation_error_meeting_validate_duplicate_name\":\"この会議名は、すでに使われています。\",\"validation_error_meeting_validate_pattern_pin\":\"エントリに無効な文字が含まれています。\",\"AF\":\"アフガニスタン\",\"AL\":\"アルバニア\",\"DZ\":\"アルジェリア\",\"AS\":\"米領サモア\",\"AD\":\"アンドラ\",\"AO\":\"アンゴラ\",\"AI\":\"アングィラ\",\"AG\":\"アンチグアバーブーダ\",\"AR\":\"アルゼンチン\",\"AM\":\"アルメニア\",\"AW\":\"アルバ\",\"AU\":\"オーストラリア\",\"AT\":\"オーストリア\",\"AZ\":\"アゼルバイジャン\",\"BS\":\"バハマ\",\"BH\":\"バーレーン\",\"BD\":\"バングラデシュ\",\"BB\":\"バルバドス\",\"BY\":\"ベラルーシ\",\"BE\":\"ベルギー\",\"BZ\":\"ベリーズ\",\"BJ\":\"ベニン\",\"BM\":\"バミューダ\",\"BT\":\"ブータン\",\"BO\":\"ボリビア\",\"BA\":\"ボスニアヘルツェゴビナ\",\"BW\":\"ボツワナ\",\"BR\":\"ブラジル\",\"BN\":\"ブルネイ\",\"BG\":\"ブルガリア\",\"BF\":\"ブルキナファソ\",\"BI\":\"ブルンジ\",\"KH\":\"カンボジア\",\"CM\":\"カメルーン\",\"CA\":\"カナダ\",\"CV\":\"ケープベルデ\",\"KY\":\"ケイマン諸島\",\"CF\":\"中央アフリカ共和国\",\"TD\":\"チャド\",\"CL\":\"チリ\",\"CN\":\"中国\",\"CX\":\"クリスマス島\",\"CC\":\"ココス（キーリング）諸島\",\"CO\":\"コロンビア\",\"KM\":\"コモロ\",\"CG\":\"コンゴ共和国\",\"CD\":\"コンゴ民主共和国\",\"CK\":\"クック諸島\",\"CR\":\"コスタリカ\",\"CI\":\"コートジボワール\",\"HR\":\"クロアチア\",\"CU\":\"キューバ\",\"CY\":\"キプロス\",\"CZ\":\"チェコ共和国\",\"DK\":\"デンマーク\",\"DJ\":\"ジブチ\",\"DM\":\"ドミニカ\",\"DO\":\"ドミニカ共和国\",\"EC\":\"エクアドル\",\"EG\":\"エジプト\",\"SV\":\"エルサルバドル\",\"GQ\":\"赤道ギニア\",\"ER\":\"エリトリア\",\"EE\":\"エストニア\",\"ET\":\"エチオピア\",\"EU\":\"欧州連合\",\"FK\":\"フォークランド諸島（マルビナス諸島）\",\"FO\":\"フェロー諸島\",\"FJ\":\"フィジー\",\"FI\":\"フィンランド\",\"FR\":\"フランス\",\"GF\":\"仏領ギアナ\",\"PF\":\"仏領ポリネシア\",\"GA\":\"ガボン\",\"GM\":\"ガンビア\",\"GE\":\"ジョージア州\",\"DE\":\"ドイツ\",\"GH\":\"ガーナ\",\"GI\":\"ジブラルタル\",\"GR\":\"ギリシャ\",\"GL\":\"グリーンランド\",\"GD\":\"グレナダ\",\"GP\":\"グアドループ\",\"GU\":\"グアム\",\"GT\":\"グアテマラ\",\"GG\":\"ガーンジー\",\"GN\":\"ギニア\",\"GW\":\"ギニアビサウ\",\"GY\":\"ガイアナ\",\"GZ\":\"ガザ地区\",\"HT\":\"ハイチ\",\"VA\":\"ローマ教皇庁（バチカン市国）\",\"HN\":\"ホンジュラス\",\"HK\":\"香港\",\"HU\":\"ハンガリー\",\"IS\":\"アイスランド\",\"IN\":\"インド\",\"ID\":\"インドネシア\",\"IQ\":\"イラク\",\"IE\":\"アイルランド\",\"IM\":\"マン島\",\"IL\":\"イスラエル\",\"IT\":\"イタリア\",\"JM\":\"ジャマイカ\",\"JP\":\"日本\",\"JE\":\"ジャージー\",\"JO\":\"ヨルダン\",\"KZ\":\"カザフスタン\",\"KE\":\"ケニア\",\"KI\":\"キリバス\",\"KR\":\"韓国\",\"KW\":\"クウェート\",\"KG\":\"キルギスタン\",\"LA\":\"ラオス\",\"LV\":\"ラトビア\",\"LB\":\"レバノン\",\"LS\":\"レソト\",\"LR\":\"リベリア\",\"LY\":\"リビア\",\"LI\":\"リヒテンシュタイン\",\"LT\":\"リトアニア\",\"LU\":\"ルクセンブルグ\",\"MO\":\"マカオ\",\"MK\":\"マケドニア\",\"MG\":\"マダガスカル\",\"MW\":\"マラウィ\",\"MY\":\"マレーシア\",\"MV\":\"モルディブ\",\"ML\":\"マリ\",\"MT\":\"マルタ\",\"MH\":\"マーシャル諸島\",\"MQ\":\"マルティニーク\",\"MR\":\"モーリタニア\",\"MU\":\"モーリシャス\",\"YT\":\"マヨット\",\"MX\":\"メキシコ\",\"FM\":\"ミクロネシア連邦\",\"MD\":\"モルドバ\",\"MC\":\"モナコ\",\"MN\":\"モンゴル\",\"ME\":\"モンテネグロ\",\"MS\":\"モントセラト\",\"MA\":\"モロッコ\",\"MZ\":\"モザンビーク\",\"MM\":\"ミャンマー\",\"NA\":\"ナミビア\",\"NR\":\"ナウル\",\"NP\":\"ネパール\",\"NL\":\"オランダ\",\"NC\":\"ニューカレドニア\",\"NZ\":\"ニュージーランド\",\"NI\":\"ニカラグア\",\"NE\":\"ニジェール\",\"NG\":\"ナイジェリア\",\"NU\":\"ニウエ\",\"NF\":\"ノーフォーク島\",\"MP\":\"北マリアナ諸島\",\"NO\":\"ノルウェー\",\"OM\":\"オマーン\",\"PK\":\"パキスタン\",\"PW\":\"パラオ\",\"PA\":\"パナマ\",\"PG\":\"パプアニューギニア\",\"PY\":\"パラグアイ\",\"PE\":\"ペルー\",\"PH\":\"フィリピン\",\"PN\":\"ピトケアン諸島\",\"PL\":\"ポーランド\",\"PT\":\"ポルトガル\",\"PR\":\"プエルトリコ\",\"QA\":\"カタール\",\"RE\":\"レユニオン\",\"RO\":\"ルーマニア\",\"RU\":\"ロシア\",\"RW\":\"ルワンダ\",\"SH\":\"セントヘレナ\",\"KN\":\"セントキッツおよびネイビス島\",\"LC\":\"セントルシア\",\"PM\":\"サンピエールおよびミクロン島\",\"VC\":\"セントビンセントおよびグレナディーン諸島\",\"WS\":\"サモア\",\"SM\":\"サンマリノ\",\"ST\":\"サントメプリンシペ\",\"SA\":\"サウジアラビア\",\"SN\":\"セネガル\",\"RS\":\"セルビア\",\"SC\":\"セーシェル\",\"SL\":\"シエラレオネ\",\"SG\":\"シンガポール\",\"SK\":\"スロバキア\",\"SI\":\"スロベニア\",\"SB\":\"ソロモン諸島\",\"SO\":\"ソマリア\",\"ZA\":\"南アフリカ共和国\",\"ES\":\"スペイン\",\"LK\":\"スリランカ\",\"SD\":\"スーダン\",\"SR\":\"スリナム\",\"SJ\":\"スバールバル諸島\",\"SZ\":\"スワジランド\",\"SE\":\"スウェーデン\",\"CH\":\"スイス\",\"TW\":\"台湾\",\"TJ\":\"タジキスタン\",\"TZ\":\"タンザニア\",\"TH\":\"タイ\",\"TL\":\"東チモール\",\"TG\":\"トーゴ\",\"TK\":\"トケラウ\",\"TO\":\"トンガ\",\"TT\":\"トリニダード トバゴ\",\"TN\":\"チュニジア\",\"TR\":\"トルコ\",\"TM\":\"トルクメニスタン\",\"TC\":\"タークス カイコス諸島\",\"TV\":\"ツバル\",\"UG\":\"ウガンダ\",\"UA\":\"ウクライナ\",\"AE\":\"アラブ首長国連邦\",\"GB\":\"イギリス\",\"US\":\"アメリカ合衆国\",\"UY\":\"ウルグアイ\",\"UZ\":\"ウズベキスタン\",\"VU\":\"バヌアツ\",\"VE\":\"ベネズエラ\",\"VN\":\"ベトナム\",\"VG\":\"英領ヴァージン諸島\",\"VI\":\"ヴァージン諸島\",\"EH\":\"西サハラ\",\"YE\":\"イエメン\",\"ZM\":\"ザンビア\",\"ZW\":\"ジンバブエ\"}");

/***/ }),
/* 441 */
/***/ (function(module) {

module.exports = JSON.parse("{\"conference\":\"컨퍼런스\",\"extension\":\"확장\",\"validation_error_meeting_validate_duplicate_name\":\"이미 사용 중인 회의 이름입니다.\",\"validation_error_meeting_validate_pattern_pin\":\"입력 항목에 잘못된 문자가 포함되어 있습니다.\",\"AF\":\"아프가니스탄\",\"AL\":\"알바니아\",\"DZ\":\"알제리\",\"AS\":\"미국령 사모아\",\"AD\":\"안도라\",\"AO\":\"앙골라\",\"AI\":\"앵귈라\",\"AG\":\"앤티가 바부다\",\"AR\":\"아르헨티나\",\"AM\":\"아르메니아\",\"AW\":\"아루바\",\"AU\":\"오스트레일리아\",\"AT\":\"오스트리아\",\"AZ\":\"아제르바이잔\",\"BS\":\"바하마\",\"BH\":\"바레인\",\"BD\":\"방글라데시\",\"BB\":\"바베이도스\",\"BY\":\"벨로루시\",\"BE\":\"벨기에\",\"BZ\":\"벨리즈\",\"BJ\":\"베닌\",\"BM\":\"버뮤다\",\"BT\":\"부탄\",\"BO\":\"볼리비아\",\"BA\":\"보스니아 헤르체고비나\",\"BW\":\"보츠와나\",\"BR\":\"브라질\",\"BN\":\"브루나이\",\"BG\":\"불가리아\",\"BF\":\"부르키나파소\",\"BI\":\"부룬디\",\"KH\":\"캄보디아\",\"CM\":\"카메룬\",\"CA\":\"캐나다\",\"CV\":\"카보베르데\",\"KY\":\"케이맨 제도\",\"CF\":\"중앙 아프리카 공화국\",\"TD\":\"차드\",\"CL\":\"칠레\",\"CN\":\"중국\",\"CX\":\"크리스마스 제도\",\"CC\":\"코코스 제도\",\"CO\":\"콜롬비아\",\"KM\":\"코모로\",\"CG\":\"콩고\",\"CD\":\"콩고 민주 공화국\",\"CK\":\"쿡 제도\",\"CR\":\"코스타리카\",\"CI\":\"코트디부아르\",\"HR\":\"크로아티아\",\"CU\":\"쿠바\",\"CY\":\"키프로스\",\"CZ\":\"체코\",\"DK\":\"덴마크\",\"DJ\":\"지부티\",\"DM\":\"도미니카\",\"DO\":\"도미니카 공화국\",\"EC\":\"에콰도르\",\"EG\":\"이집트\",\"SV\":\"엘살바도르\",\"GQ\":\"적도 기니\",\"ER\":\"에리트레아\",\"EE\":\"에스토니아\",\"ET\":\"에티오피아\",\"EU\":\"유럽 연합\",\"FK\":\"포클랜드 제도\",\"FO\":\"페로 제도\",\"FJ\":\"피지\",\"FI\":\"핀란드\",\"FR\":\"프랑스\",\"GF\":\"프랑스령 기아나\",\"PF\":\"프랑스령 폴리네시아\",\"GA\":\"가봉\",\"GM\":\"감비아\",\"GE\":\"그루지야\",\"DE\":\"독일\",\"GH\":\"가나\",\"GI\":\"지브롤터\",\"GR\":\"그리스\",\"GL\":\"그린란드\",\"GD\":\"그레나다\",\"GP\":\"과들루프\",\"GU\":\"괌\",\"GT\":\"과테말라\",\"GG\":\"건지\",\"GN\":\"기니\",\"GW\":\"기니비사우\",\"GY\":\"가이아나\",\"GZ\":\"가자 지대\",\"HT\":\"아이티\",\"VA\":\"바티칸(바티칸 시국)\",\"HN\":\"온두라스\",\"HK\":\"홍콩\",\"HU\":\"헝가리\",\"IS\":\"아이슬란드\",\"IN\":\"인도\",\"ID\":\"인도네시아\",\"IQ\":\"이라크\",\"IE\":\"아일랜드\",\"IM\":\"맨 섬\",\"IL\":\"이스라엘\",\"IT\":\"이탈리아\",\"JM\":\"자메이카\",\"JP\":\"일본\",\"JE\":\"저지\",\"JO\":\"요르단\",\"KZ\":\"카자흐스탄\",\"KE\":\"케냐\",\"KI\":\"키리바시\",\"KR\":\"한국\",\"KW\":\"쿠웨이트\",\"KG\":\"키르기스스탄\",\"LA\":\"라오스\",\"LV\":\"라트비아\",\"LB\":\"레바논\",\"LS\":\"레소토\",\"LR\":\"베리아\",\"LY\":\"리비아\",\"LI\":\"리히텐슈타인\",\"LT\":\"리투아니아\",\"LU\":\"룩셈부르크\",\"MO\":\"마카오\",\"MK\":\"마케도니아\",\"MG\":\"마다가스카르\",\"MW\":\"말라위\",\"MY\":\"말레이시아\",\"MV\":\"몰디브\",\"ML\":\"말리\",\"MT\":\"몰타\",\"MH\":\"마샬 군도\",\"MQ\":\"마르티니크\",\"MR\":\"모리타니아\",\"MU\":\"모리셔스\",\"YT\":\"마요트\",\"MX\":\"멕시코\",\"FM\":\"미크로네시아 연방\",\"MD\":\"몰도바\",\"MC\":\"모나코\",\"MN\":\"몽골\",\"ME\":\"몬테네그로\",\"MS\":\"몬트세라트\",\"MA\":\"모로코\",\"MZ\":\"모잠비크\",\"MM\":\"미얀마\",\"NA\":\"나미비아\",\"NR\":\"나우루\",\"NP\":\"네팔\",\"NL\":\"네덜란드\",\"NC\":\"뉴 칼레도니아\",\"NZ\":\"뉴질랜드\",\"NI\":\"니카라과\",\"NE\":\"니제르\",\"NG\":\"나이지리아\",\"NU\":\"니우에\",\"NF\":\"노퍽 섬\",\"MP\":\"북마리아나 제도\",\"NO\":\"노르웨이\",\"OM\":\"오만\",\"PK\":\"파키스탄\",\"PW\":\"팔라우\",\"PA\":\"파나마\",\"PG\":\"파푸아뉴기니\",\"PY\":\"파라과이\",\"PE\":\"페루\",\"PH\":\"필리핀\",\"PN\":\"핏케언 제도\",\"PL\":\"폴란드\",\"PT\":\"포르투갈\",\"PR\":\"푸에르토리코\",\"QA\":\"카타르\",\"RE\":\"재결합\",\"RO\":\"루마니아\",\"RU\":\"러시아\",\"RW\":\"르완다\",\"SH\":\"세인트 헬레나\",\"KN\":\"세인트 크리스토퍼 네비스\",\"LC\":\"세인트 루시아\",\"PM\":\"생피에르앤드미클롱\",\"VC\":\"세인트 빈센트 그레나딘\",\"WS\":\"사모아\",\"SM\":\"산마리노\",\"ST\":\"상투메 프린시페\",\"SA\":\"사우디아라비아\",\"SN\":\"세네갈\",\"RS\":\"세르비아\",\"SC\":\"세이셸\",\"SL\":\"시에라리온\",\"SG\":\"싱가포르\",\"SK\":\"슬로바키아\",\"SI\":\"슬로베니아\",\"SB\":\"솔로몬 제도\",\"SO\":\"소말리아\",\"ZA\":\"남아프리카 공화국\",\"ES\":\"스페인\",\"LK\":\"스리랑카\",\"SD\":\"수단\",\"SR\":\"수리남\",\"SJ\":\"스발바르\",\"SZ\":\"스와질랜드\",\"SE\":\"스웨덴\",\"CH\":\"스위스\",\"TW\":\"대만\",\"TJ\":\"타지키스탄\",\"TZ\":\"탄자니아\",\"TH\":\"태국\",\"TL\":\"동티모르\",\"TG\":\"토고\",\"TK\":\"토켈라우\",\"TO\":\"통가\",\"TT\":\"트리니다드 토바고\",\"TN\":\"튀니지\",\"TR\":\"터키\",\"TM\":\"투르크메니스탄\",\"TC\":\"터크스 케이커스 제도\",\"TV\":\"투발루\",\"UG\":\"우간다\",\"UA\":\"우크라이나\",\"AE\":\"아랍에미리트\",\"GB\":\"영국\",\"US\":\"미국\",\"UY\":\"우루과이\",\"UZ\":\"우즈베키스탄\",\"VU\":\"바누아투\",\"VE\":\"베네수엘라\",\"VN\":\"베트남\",\"VG\":\"영국령 버진 아일랜드\",\"VI\":\"버진 아일랜드\",\"EH\":\"서사하라\",\"YE\":\"예멘\",\"ZM\":\"잠비아\",\"ZW\":\"짐바브웨\"}");

/***/ }),
/* 442 */
/***/ (function(module) {

module.exports = JSON.parse("{\"conference\":\"Vergadering\",\"extension\":\"Extensie\",\"validation_error_meeting_validate_duplicate_name\":\"Deze vergadernaam is al in gebruik.\",\"validation_error_meeting_validate_pattern_pin\":\"Invoer bevat ongeldige tekens.\",\"AF\":\"Afghanistan\",\"AL\":\"Albanië\",\"DZ\":\"Algerije\",\"AS\":\"Amerikaans-Samoa\",\"AD\":\"Andorra\",\"AO\":\"Angola\",\"AI\":\"Anguilla\",\"AG\":\"Antigua en Barbuda\",\"AR\":\"Argentinië\",\"AM\":\"Armenië\",\"AW\":\"Aruba\",\"AU\":\"Australië\",\"AT\":\"Oostenrijk\",\"AZ\":\"Azerbeidzjan\",\"BS\":\"Bahama's\",\"BH\":\"Bahrein\",\"BD\":\"Bangladesh\",\"BB\":\"Barbados\",\"BY\":\"Wit-Rusland\",\"BE\":\"België\",\"BZ\":\"Belize\",\"BJ\":\"Benin\",\"BM\":\"Bermuda\",\"BT\":\"Bhutan\",\"BO\":\"Bolivia\",\"BA\":\"Bosnië en Herzegovina\",\"BW\":\"Botswana\",\"BR\":\"Brazilië\",\"BN\":\"Brunei\",\"BG\":\"Bulgarije\",\"BF\":\"Burkina Faso\",\"BI\":\"Burundi\",\"KH\":\"Cambodja\",\"CM\":\"Kameroen\",\"CA\":\"Canada\",\"CV\":\"Kaapverdië\",\"KY\":\"Kaaimaneilanden\",\"CF\":\"Centraal-Afrikaanse Republiek\",\"TD\":\"Tsjaad\",\"CL\":\"Chili\",\"CN\":\"China\",\"CX\":\"Kersteiland\",\"CC\":\"Cocoseilanden\",\"CO\":\"Colombia\",\"KM\":\"Comoren\",\"CG\":\"Republiek Congo\",\"CD\":\"Democratische Republiek Congo\",\"CK\":\"Cookeilanden\",\"CR\":\"Costa Rica\",\"CI\":\"Ivoorkust\",\"HR\":\"Kroatië\",\"CU\":\"Cuba\",\"CY\":\"Cyprus\",\"CZ\":\"Tsjechië\",\"DK\":\"Denemarken\",\"DJ\":\"Djibouti\",\"DM\":\"Dominica\",\"DO\":\"Dominicaanse Republiek\",\"EC\":\"Ecuador\",\"EG\":\"Egypte\",\"SV\":\"El Salvador\",\"GQ\":\"Equatoriaal-Guinea\",\"ER\":\"Eritrea\",\"EE\":\"Estland\",\"ET\":\"Ethiopië\",\"EU\":\"Europese Unie\",\"FK\":\"Falklandeilanden\",\"FO\":\"Faeröer\",\"FJ\":\"Fiji\",\"FI\":\"Finland\",\"FR\":\"Frankrijk\",\"GF\":\"Frans-Guyana\",\"PF\":\"Frans-Polynesië\",\"GA\":\"Gabon\",\"GM\":\"Gambia\",\"GE\":\"Georgië\",\"DE\":\"Duitsland\",\"GH\":\"Ghana\",\"GI\":\"Gibraltar\",\"GR\":\"Griekenland\",\"GL\":\"Groenland\",\"GD\":\"Grenada\",\"GP\":\"Guadeloupe\",\"GU\":\"Guam\",\"GT\":\"Guatemala\",\"GG\":\"Guernsey\",\"GN\":\"Guinee\",\"GW\":\"Guinee-Bissau\",\"GY\":\"Guyana\",\"GZ\":\"Gazastrook\",\"HT\":\"Haïti\",\"VA\":\"Vaticaanstad\",\"HN\":\"Honduras\",\"HK\":\"Hongkong\",\"HU\":\"Hongarije\",\"IS\":\"IJsland\",\"IN\":\"India\",\"ID\":\"Indonesië\",\"IQ\":\"Irak\",\"IE\":\"Ierland\",\"IM\":\"Man (eiland)\",\"IL\":\"Israël\",\"IT\":\"Italië\",\"JM\":\"Jamaica\",\"JP\":\"Japan\",\"JE\":\"Jersey\",\"JO\":\"Jordanië\",\"KZ\":\"Kazachstan\",\"KE\":\"Kenia\",\"KI\":\"Kiribati\",\"KR\":\"Zuid-Korea\",\"KW\":\"Koeweit\",\"KG\":\"Kirgizië\",\"LA\":\"Laos\",\"LV\":\"Letland\",\"LB\":\"Libanon\",\"LS\":\"Lesotho\",\"LR\":\"Liberia\",\"LY\":\"Libië\",\"LI\":\"Liechtenstein\",\"LT\":\"Litouwen\",\"LU\":\"Luxemburg\",\"MO\":\"Macau\",\"MK\":\"Macedonië\",\"MG\":\"Madagaskar\",\"MW\":\"Malawi\",\"MY\":\"Maleisië\",\"MV\":\"Maldiven\",\"ML\":\"Mali\",\"MT\":\"Malta\",\"MH\":\"Marshalleilanden\",\"MQ\":\"Martinique\",\"MR\":\"Mauritanië\",\"MU\":\"Mauritius\",\"YT\":\"Mayotte\",\"MX\":\"Mexico\",\"FM\":\"Federale Staten van Micronesia\",\"MD\":\"Moldavië\",\"MC\":\"Monaco\",\"MN\":\"Mongolië\",\"ME\":\"Montenegro\",\"MS\":\"Montserrat\",\"MA\":\"Marokko\",\"MZ\":\"Mozambique\",\"MM\":\"Myanmar\",\"NA\":\"Namibië\",\"NR\":\"Nauru\",\"NP\":\"Nepal\",\"NL\":\"Nederland\",\"NC\":\"Nieuw-Caledonië\",\"NZ\":\"Nieuw-Zeeland\",\"NI\":\"Nicaragua\",\"NE\":\"Niger\",\"NG\":\"Nigeria\",\"NU\":\"Niue\",\"NF\":\"Norfolk (eiland)\",\"MP\":\"Noordelijke Marianen\",\"NO\":\"Noorwegen\",\"OM\":\"Oman\",\"PK\":\"Pakistan\",\"PW\":\"Palau\",\"PA\":\"Panama\",\"PG\":\"Papoea-Nieuw-Guinea\",\"PY\":\"Paraguay\",\"PE\":\"Peru\",\"PH\":\"Filippijnen\",\"PN\":\"Pitcairneilanden\",\"PL\":\"Polen\",\"PT\":\"Portugal\",\"PR\":\"Puerto Rico\",\"QA\":\"Qatar\",\"RE\":\"Réunion\",\"RO\":\"Roemenië\",\"RU\":\"Rusland\",\"RW\":\"Rwanda\",\"SH\":\"Sint-Helena\",\"KN\":\"Saint Kitts en Nevis\",\"LC\":\"Saint Lucia\",\"PM\":\"Saint-Pierre en Miquelon\",\"VC\":\"Saint Vincent en de Grenadines\",\"WS\":\"Samoa\",\"SM\":\"San Marino\",\"ST\":\"Sao Tomé en Principe\",\"SA\":\"Saoedi-Arabië\",\"SN\":\"Senegal\",\"RS\":\"Servië\",\"SC\":\"Seychellen\",\"SL\":\"Sierra Leone\",\"SG\":\"Singapore\",\"SK\":\"Slowakije\",\"SI\":\"Slovenië\",\"SB\":\"Salomonseilanden\",\"SO\":\"Somalië\",\"ZA\":\"Zuid-Afrika\",\"ES\":\"Spanje\",\"LK\":\"Sri Lanka\",\"SD\":\"Soedan\",\"SR\":\"Suriname\",\"SJ\":\"Spitsbergen\",\"SZ\":\"Swaziland\",\"SE\":\"Zweden\",\"CH\":\"Zwitserland\",\"TW\":\"Taiwan\",\"TJ\":\"Tadzjikistan\",\"TZ\":\"Tanzania\",\"TH\":\"Thailand\",\"TL\":\"Oost-Timor\",\"TG\":\"Togo\",\"TK\":\"Tokelau\",\"TO\":\"Tonga\",\"TT\":\"Trinidad en Tobago\",\"TN\":\"Tunesië\",\"TR\":\"Turkije\",\"TM\":\"Turkmenistan\",\"TC\":\"Turks- en Caicoseilanden\",\"TV\":\"Tuvalu\",\"UG\":\"Oeganda\",\"UA\":\"Oekraïne\",\"AE\":\"Verenigde Arabische Emiraten\",\"GB\":\"Verenigd Koninkrijk\",\"US\":\"Verenigde Staten\",\"UY\":\"Uruguay\",\"UZ\":\"Oezbekistan\",\"VU\":\"Vanuatu\",\"VE\":\"Venezuela\",\"VN\":\"Vietnam\",\"VG\":\"Britse Maagdeneilanden\",\"VI\":\"Maagdeneilanden\",\"EH\":\"Westelijke Sahara\",\"YE\":\"Jemen\",\"ZM\":\"Zambia\",\"ZW\":\"Zimbabwe\"}");

/***/ }),
/* 443 */
/***/ (function(module) {

module.exports = JSON.parse("{\"conference\":\"Konferanse\",\"extension\":\"Direktenummer\",\"validation_error_meeting_validate_duplicate_name\":\"Dette møtenavnet er allerede i bruk.\",\"validation_error_meeting_validate_pattern_pin\":\"Oppføringen inneholder ugyldige tegn.\",\"AF\":\"Afghanistan\",\"AL\":\"Albania\",\"DZ\":\"Algerie\",\"AS\":\"Amerikansk Samoa\",\"AD\":\"Andorra\",\"AO\":\"Angola\",\"AI\":\"Anguilla\",\"AG\":\"Antigua og Barbuda\",\"AR\":\"Argentina\",\"AM\":\"Armenia\",\"AW\":\"Aruba\",\"AU\":\"Australia\",\"AT\":\"Østerrike\",\"AZ\":\"Aserbajdsjan\",\"BS\":\"Bahamas\",\"BH\":\"Bahrain\",\"BD\":\"Bangladesh\",\"BB\":\"Barbados\",\"BY\":\"Hviterussland\",\"BE\":\"Belgia\",\"BZ\":\"Belize\",\"BJ\":\"Benin\",\"BM\":\"Bermuda\",\"BT\":\"Bhutan\",\"BO\":\"Bolivia\",\"BA\":\"Bosnia-Hercegovina\",\"BW\":\"Botswana\",\"BR\":\"Brasil\",\"BN\":\"Brunei\",\"BG\":\"Bulgaria\",\"BF\":\"Burkina Faso\",\"BI\":\"Burundi\",\"KH\":\"Kambodsja\",\"CM\":\"Kamerun\",\"CA\":\"Canada\",\"CV\":\"Kapp Verde\",\"KY\":\"Caymanøyene\",\"CF\":\"Den sentralafrikanske republikk\",\"TD\":\"Tsjad\",\"CL\":\"Chile\",\"CN\":\"Kina\",\"CX\":\"Christmasøya\",\"CC\":\"Kokos-(Keeling) øyene\",\"CO\":\"Colombia\",\"KM\":\"Komorene\",\"CG\":\"Republikken Kongo\",\"CD\":\"Den demokratiske republikken Kongo\",\"CK\":\"Cookøyene\",\"CR\":\"Costa Rica\",\"CI\":\"Elfenbenskysten\",\"HR\":\"Kroatia\",\"CU\":\"Cuba\",\"CY\":\"Kypros\",\"CZ\":\"Tsjekkia\",\"DK\":\"Danmark\",\"DJ\":\"Djibouti\",\"DM\":\"Dominica\",\"DO\":\"Den dominikanske republikk\",\"EC\":\"Ecuador\",\"EG\":\"Egypt\",\"SV\":\"El Salvador\",\"GQ\":\"Ekvatorial-Guinea\",\"ER\":\"Eritrea\",\"EE\":\"Estland\",\"ET\":\"Etiopia\",\"EU\":\"Den Europeiske Union\",\"FK\":\"Falklandsøyene (Malvinas)\",\"FO\":\"Færøyene\",\"FJ\":\"Fiji\",\"FI\":\"Finland\",\"FR\":\"Frankrike\",\"GF\":\"Fransk Guyana\",\"PF\":\"Fransk Polynesia\",\"GA\":\"Gabon\",\"GM\":\"Gambia\",\"GE\":\"Georgia\",\"DE\":\"Tyskland\",\"GH\":\"Ghana\",\"GI\":\"Gibraltar\",\"GR\":\"Hellas\",\"GL\":\"Grønland\",\"GD\":\"Grenada\",\"GP\":\"Guadeloupe\",\"GU\":\"Guam\",\"GT\":\"Guatemala\",\"GG\":\"Guernsey\",\"GN\":\"Guinea\",\"GW\":\"Guinea-Bissau\",\"GY\":\"Guyana\",\"GZ\":\"Gazastripen\",\"HT\":\"Haiti\",\"VA\":\"Pavestolen (Vatikanstaten)\",\"HN\":\"Honduras\",\"HK\":\"Hong Kong\",\"HU\":\"Ungarn\",\"IS\":\"Island\",\"IN\":\"India\",\"ID\":\"Indonesia\",\"IQ\":\"Irak\",\"IE\":\"Irland\",\"IM\":\"Man\",\"IL\":\"Israel\",\"IT\":\"Italia\",\"JM\":\"Jamaica\",\"JP\":\"Japan\",\"JE\":\"Jersey\",\"JO\":\"Jordan\",\"KZ\":\"Kasakhstan\",\"KE\":\"Kenya\",\"KI\":\"Kiribati\",\"KR\":\"Sør-Korea\",\"KW\":\"Kuwait\",\"KG\":\"Kirgisistan\",\"LA\":\"Laos\",\"LV\":\"Latvia\",\"LB\":\"Libanon\",\"LS\":\"Lesotho\",\"LR\":\"Liberia\",\"LY\":\"Libya\",\"LI\":\"Liechtenstein\",\"LT\":\"Litauen\",\"LU\":\"Luxembourg\",\"MO\":\"Macao\",\"MK\":\"Makedonia\",\"MG\":\"Madagaskar\",\"MW\":\"Malawi\",\"MY\":\"Malaysia\",\"MV\":\"Maldivene\",\"ML\":\"Mali\",\"MT\":\"Malta\",\"MH\":\"Marshalløyene\",\"MQ\":\"Martinique\",\"MR\":\"Mauritania\",\"MU\":\"Mauritius\",\"YT\":\"Mayotte\",\"MX\":\"Mexico\",\"FM\":\"Mikronesia, føderasjonen av\",\"MD\":\"Moldova\",\"MC\":\"Monaco\",\"MN\":\"Mongolia\",\"ME\":\"Montenegro\",\"MS\":\"Montserrat\",\"MA\":\"Marokko\",\"MZ\":\"Mosambik\",\"MM\":\"Myanmar\",\"NA\":\"Namibia\",\"NR\":\"Nauru\",\"NP\":\"Nepal\",\"NL\":\"Nederland\",\"NC\":\"Ny-Caledonia\",\"NZ\":\"New Zealand\",\"NI\":\"Nicaragua\",\"NE\":\"Niger\",\"NG\":\"Nigeria\",\"NU\":\"Niue\",\"NF\":\"Norfolkøya\",\"MP\":\"Nord-Marianene\",\"NO\":\"Norge\",\"OM\":\"Oman\",\"PK\":\"Pakistan\",\"PW\":\"Palau\",\"PA\":\"Panama\",\"PG\":\"Papua Ny-Guinea\",\"PY\":\"Paraguay\",\"PE\":\"Peru\",\"PH\":\"Filippinene\",\"PN\":\"Pitcairnøyene\",\"PL\":\"Polen\",\"PT\":\"Portugal\",\"PR\":\"Puerto Rico\",\"QA\":\"Qatar\",\"RE\":\"Réunion\",\"RO\":\"Romania\",\"RU\":\"Russland\",\"RW\":\"Rwanda\",\"SH\":\"Saint Helena\",\"KN\":\"Saint Kitts og Nevis\",\"LC\":\"Saint Lucia\",\"PM\":\"Saint Pierre og Miquelon\",\"VC\":\"Saint Vincent og Grenadines\",\"WS\":\"Samoa\",\"SM\":\"San Marino\",\"ST\":\"São Tomé og Príncipe\",\"SA\":\"Saudi-Arabia\",\"SN\":\"Senegal\",\"RS\":\"Serbia\",\"SC\":\"Seychellene\",\"SL\":\"Sierra Leone\",\"SG\":\"Singapore\",\"SK\":\"Slovakia\",\"SI\":\"Slovenia\",\"SB\":\"Salomonøyene\",\"SO\":\"Somalia\",\"ZA\":\"Sør-Afrika\",\"ES\":\"Spania\",\"LK\":\"Sri Lanka\",\"SD\":\"Sudan\",\"SR\":\"Surinam\",\"SJ\":\"Svalbard\",\"SZ\":\"Swaziland\",\"SE\":\"Sverige\",\"CH\":\"Sveits\",\"TW\":\"Taiwan\",\"TJ\":\"Tadsjikistan\",\"TZ\":\"Tanzania\",\"TH\":\"Thailand\",\"TL\":\"Øst-Timor\",\"TG\":\"Togo\",\"TK\":\"Tokelau\",\"TO\":\"Tonga\",\"TT\":\"Trinidad og Tobago\",\"TN\":\"Tunisia\",\"TR\":\"Tyrkia\",\"TM\":\"Turkmenistan\",\"TC\":\"Turks- og Caicosøyene\",\"TV\":\"Tuvalu\",\"UG\":\"Uganda\",\"UA\":\"Ukraina\",\"AE\":\"De forente arabiske emirater\",\"GB\":\"Storbritannia og Nord-Irland\",\"US\":\"USA\",\"UY\":\"Uruguay\",\"UZ\":\"Usbekistan\",\"VU\":\"Vanuatu\",\"VE\":\"Venezuela\",\"VN\":\"Vietnam\",\"VG\":\"De britiske jomfruøyene\",\"VI\":\"Jomfruøyene\",\"EH\":\"Vest-Sahara\",\"YE\":\"Jemen\",\"ZM\":\"Zambia\",\"ZW\":\"Zimbabwe\"}");

/***/ }),
/* 444 */
/***/ (function(module) {

module.exports = JSON.parse("{\"conference\":\"Konferencja\",\"extension\":\"Nr wewnętrzny\",\"validation_error_meeting_validate_duplicate_name\":\"Ta nazwa spotkania jest już zajęta.\",\"validation_error_meeting_validate_pattern_pin\":\"Wpis zawiera nieprawidłowe znaki.\",\"AF\":\"Afganistan\",\"AL\":\"Albania\",\"DZ\":\"Algieria\",\"AS\":\"Samoa Amerykańskie\",\"AD\":\"Andora\",\"AO\":\"Angola\",\"AI\":\"Anguilla\",\"AG\":\"Antigua i Barbuda\",\"AR\":\"Argentyna\",\"AM\":\"Armenia\",\"AW\":\"Aruba\",\"AU\":\"Australia\",\"AT\":\"Austria\",\"AZ\":\"Azerbejdżan\",\"BS\":\"Bahamy\",\"BH\":\"Bahrajn\",\"BD\":\"Bangladesz\",\"BB\":\"Barbados\",\"BY\":\"Białoruś\",\"BE\":\"Belgia\",\"BZ\":\"Belize\",\"BJ\":\"Benin\",\"BM\":\"Bermudy\",\"BT\":\"Bhutan\",\"BO\":\"Boliwia\",\"BA\":\"Bośnia i Hercegowina\",\"BW\":\"Botswana\",\"BR\":\"Brazylia\",\"BN\":\"Brunei\",\"BG\":\"Bułgaria\",\"BF\":\"Burkina Faso\",\"BI\":\"Burundi\",\"KH\":\"Kambodża\",\"CM\":\"Kamerun\",\"CA\":\"Kanada\",\"CV\":\"Republika Zielonego Przylądka\",\"KY\":\"Kajmany\",\"CF\":\"Republika Środkowoafrykańska\",\"TD\":\"Czad\",\"CL\":\"Chile\",\"CN\":\"Chiny\",\"CX\":\"Wyspa Bożego Narodzenia\",\"CC\":\"Wyspy Kokosowe (Keelinga)\",\"CO\":\"Kolumbia\",\"KM\":\"Komory\",\"CG\":\"Republika Konga\",\"CD\":\"Demokratyczna Republika Konga\",\"CK\":\"Wyspy Cooka\",\"CR\":\"Kostaryka\",\"CI\":\"Wybrzeże Kości Słoniowej\",\"HR\":\"Chorwacja\",\"CU\":\"Kuba\",\"CY\":\"Cypr\",\"CZ\":\"Republika Czeska\",\"DK\":\"Dania\",\"DJ\":\"Dżibuti\",\"DM\":\"Dominika\",\"DO\":\"Dominikana\",\"EC\":\"Ekwador\",\"EG\":\"Egipt\",\"SV\":\"Salwador\",\"GQ\":\"Gwinea Równikowa\",\"ER\":\"Erytrea\",\"EE\":\"Estonia\",\"ET\":\"Etiopia\",\"EU\":\"Unia Europejska\",\"FK\":\"Falklandy (Malwiny)\",\"FO\":\"Wyspy Owcze\",\"FJ\":\"Fidżi\",\"FI\":\"Finlandia\",\"FR\":\"Francja\",\"GF\":\"Gujana Francuska\",\"PF\":\"Polinezja Francuska\",\"GA\":\"Gabon\",\"GM\":\"Gambia\",\"GE\":\"Gruzja\",\"DE\":\"Niemcy\",\"GH\":\"Ghana\",\"GI\":\"Gibraltar\",\"GR\":\"Grecja\",\"GL\":\"Grenlandia\",\"GD\":\"Grenada\",\"GP\":\"Gwadelupa\",\"GU\":\"Guam\",\"GT\":\"Gwatemala\",\"GG\":\"Guernsey\",\"GN\":\"Gwinea\",\"GW\":\"Gwinea Bissau\",\"GY\":\"Gujana\",\"GZ\":\"Strefa Gazy\",\"HT\":\"Haiti\",\"VA\":\"Stolica Apostolska (Państwo Watykańskie)\",\"HN\":\"Honduras\",\"HK\":\"Hongkong\",\"HU\":\"Węgry\",\"IS\":\"Islandia\",\"IN\":\"Indie\",\"ID\":\"Indonezja\",\"IQ\":\"Irak\",\"IE\":\"Irlandia\",\"IM\":\"Wyspa Man\",\"IL\":\"Izrael\",\"IT\":\"Włochy\",\"JM\":\"Jamajka\",\"JP\":\"Japonia\",\"JE\":\"Jersey\",\"JO\":\"Jordania\",\"KZ\":\"Kazachstan\",\"KE\":\"Kenia\",\"KI\":\"Kiribati\",\"KR\":\"Korea Południowa\",\"KW\":\"Kuwejt\",\"KG\":\"Kirgistan\",\"LA\":\"Laos\",\"LV\":\"Łotwa\",\"LB\":\"Liban\",\"LS\":\"Lesoto\",\"LR\":\"Liberia\",\"LY\":\"Libia\",\"LI\":\"Liechtenstein\",\"LT\":\"Litwa\",\"LU\":\"Luksemburg\",\"MO\":\"Makao\",\"MK\":\"Macedonia\",\"MG\":\"Madagaskar\",\"MW\":\"Malawi\",\"MY\":\"Malezja\",\"MV\":\"Malediwy\",\"ML\":\"Mali\",\"MT\":\"Malta\",\"MH\":\"Wyspy Marshalla\",\"MQ\":\"Martynika\",\"MR\":\"Mauretania\",\"MU\":\"Mauritius\",\"YT\":\"Majotta\",\"MX\":\"Meksyk\",\"FM\":\"Mikronezja (Sfederowane Stany Mikronezji)\",\"MD\":\"Mołdawia\",\"MC\":\"Monako\",\"MN\":\"Mongolia\",\"ME\":\"Czarnogóra\",\"MS\":\"Montserrat\",\"MA\":\"Maroko\",\"MZ\":\"Mozambik\",\"MM\":\"Myanma\",\"NA\":\"Namibia\",\"NR\":\"Nauru\",\"NP\":\"Nepal\",\"NL\":\"Holandia\",\"NC\":\"Nowa Kaledonia\",\"NZ\":\"Nowa Zelandia\",\"NI\":\"Nikaragua\",\"NE\":\"Niger\",\"NG\":\"Nigeria\",\"NU\":\"Niue\",\"NF\":\"Norfolk\",\"MP\":\"Mariany Północne\",\"NO\":\"Norwegia\",\"OM\":\"Oman\",\"PK\":\"Pakistan\",\"PW\":\"Palau\",\"PA\":\"Panama\",\"PG\":\"Papua-Nowa Gwinea\",\"PY\":\"Paragwaj\",\"PE\":\"Peru\",\"PH\":\"Filipiny\",\"PN\":\"Pitcairn\",\"PL\":\"Polska\",\"PT\":\"Portugalia\",\"PR\":\"Portoryko\",\"QA\":\"Katar\",\"RE\":\"Reunion\",\"RO\":\"Rumunia\",\"RU\":\"Rosja\",\"RW\":\"Rwanda\",\"SH\":\"Wyspa Świętej Heleny\",\"KN\":\"Saint Kitts i Nevis\",\"LC\":\"Saint Lucia\",\"PM\":\"Saint-Pierre i Miquelon\",\"VC\":\"Saint Vincent i Grenadyny\",\"WS\":\"Samoa\",\"SM\":\"San Marino\",\"ST\":\"Wyspy Świętego Tomasza i Książęca\",\"SA\":\"Arabia Saudyjska\",\"SN\":\"Senegal\",\"RS\":\"Serbia\",\"SC\":\"Seszele\",\"SL\":\"Sierra Leone\",\"SG\":\"Singapur\",\"SK\":\"Słowacja\",\"SI\":\"Słowenia\",\"SB\":\"Wyspy Salomona\",\"SO\":\"Somalia\",\"ZA\":\"Republika Południowej Afryki\",\"ES\":\"Hiszpania\",\"LK\":\"Sri Lanka\",\"SD\":\"Sudan\",\"SR\":\"Surinam\",\"SJ\":\"Svalbard\",\"SZ\":\"Suazi\",\"SE\":\"Szwecja\",\"CH\":\"Szwajcaria\",\"TW\":\"Tajwan\",\"TJ\":\"Tadżykistan\",\"TZ\":\"Tanzania\",\"TH\":\"Tajlandia\",\"TL\":\"Timor Wschodni\",\"TG\":\"Togo\",\"TK\":\"Tokelau\",\"TO\":\"Tonga\",\"TT\":\"Trynidad i Tobago\",\"TN\":\"Tunezja\",\"TR\":\"Turcja\",\"TM\":\"Turkmenistan\",\"TC\":\"Turks i Caicos\",\"TV\":\"Tuvalu\",\"UG\":\"Uganda\",\"UA\":\"Ukraina\",\"AE\":\"Zjednoczone Emiraty Arabskie\",\"GB\":\"Wielka Brytania\",\"US\":\"Stany Zjednoczone\",\"UY\":\"Urugwaj\",\"UZ\":\"Uzbekistan\",\"VU\":\"Vanuatu\",\"VE\":\"Wenezuela\",\"VN\":\"Wietnam\",\"VG\":\"Brytyjskie Wyspy Dziewicze\",\"VI\":\"Wyspy Dziewicze Stanów Zjednoczonych\",\"EH\":\"Sahara Zachodnia\",\"YE\":\"Jemen\",\"ZM\":\"Zambia\",\"ZW\":\"Zimbabwe\"}");

/***/ }),
/* 445 */
/***/ (function(module) {

module.exports = JSON.parse("{\"conference\":\"Conferência\",\"extension\":\"Extensão\",\"validation_error_meeting_validate_duplicate_name\":\"Este nome de reunião já foi usado.\",\"validation_error_meeting_validate_pattern_pin\":\"A entrada contém caracteres inválidos.\",\"AF\":\"Afeganistão\",\"AL\":\"Albânia\",\"DZ\":\"Argélia\",\"AS\":\"Samoa Americana\",\"AD\":\"Andorra\",\"AO\":\"Angola\",\"AI\":\"Anguilla\",\"AG\":\"Antígua e Barbuda\",\"AR\":\"Argentina\",\"AM\":\"Armênia\",\"AW\":\"Aruba\",\"AU\":\"Austrália\",\"AT\":\"Áustria\",\"AZ\":\"Azerbaijão\",\"BS\":\"Bahamas\",\"BH\":\"Bahrein\",\"BD\":\"Bangladesh\",\"BB\":\"Barbados\",\"BY\":\"Belarus\",\"BE\":\"Bélgica\",\"BZ\":\"Belize\",\"BJ\":\"Benin\",\"BM\":\"Bermuda\",\"BT\":\"Butão\",\"BO\":\"Bolívia\",\"BA\":\"Bósnia e Herzegovina\",\"BW\":\"Botswana\",\"BR\":\"Brasil\",\"BN\":\"Brunei\",\"BG\":\"Bulgária\",\"BF\":\"Burkina Faso\",\"BI\":\"Burundi\",\"KH\":\"Camboja\",\"CM\":\"República dos Camarões\",\"CA\":\"Canadá\",\"CV\":\"Cabo Verde\",\"KY\":\"Ilhas Cayman\",\"CF\":\"República Centro-Africana\",\"TD\":\"Chade\",\"CL\":\"Chile\",\"CN\":\"China\",\"CX\":\"Ilhas Christmas\",\"CC\":\"Ilhas Cocos (Keeling)\",\"CO\":\"Colômbia\",\"KM\":\"Comores\",\"CG\":\"República do Congo\",\"CD\":\"República Democrática do Congo\",\"CK\":\"Ilhas Cook\",\"CR\":\"Costa Rica\",\"CI\":\"Costa do Marfim\",\"HR\":\"Croácia\",\"CU\":\"Cuba\",\"CY\":\"Chipre\",\"CZ\":\"República Tcheca\",\"DK\":\"Dinamarca\",\"DJ\":\"Djibuti\",\"DM\":\"Dominica\",\"DO\":\"República Dominicana\",\"EC\":\"Equador\",\"EG\":\"Egito\",\"SV\":\"El Salvador\",\"GQ\":\"Guiné Equatorial\",\"ER\":\"Eritreia\",\"EE\":\"Estônia\",\"ET\":\"Etiópia\",\"EU\":\"União Europeia\",\"FK\":\"Ilhas Falkland (Malvinas)\",\"FO\":\"Ilhas Faroe\",\"FJ\":\"Fiji\",\"FI\":\"Finlândia\",\"FR\":\"França\",\"GF\":\"Guiana Francesa\",\"PF\":\"Polinésia Francesa\",\"GA\":\"Gabão\",\"GM\":\"Gâmbia\",\"GE\":\"Geórgia\",\"DE\":\"Alemanha\",\"GH\":\"Gana\",\"GI\":\"Gibraltar\",\"GR\":\"Grécia\",\"GL\":\"Groenlândia\",\"GD\":\"Grenada\",\"GP\":\"Guadalupe\",\"GU\":\"Guam\",\"GT\":\"Guatemala\",\"GG\":\"Guernsey\",\"GN\":\"Guiné\",\"GW\":\"Guiné-Bissau\",\"GY\":\"Guiana\",\"GZ\":\"Faixa de Gaza\",\"HT\":\"Haiti\",\"VA\":\"Santa Sé (Cidade do Vaticano)\",\"HN\":\"Honduras\",\"HK\":\"Hong Kong\",\"HU\":\"Hungria\",\"IS\":\"Islândia\",\"IN\":\"Índia\",\"ID\":\"Indonésia\",\"IQ\":\"Iraque\",\"IE\":\"Irlanda\",\"IM\":\"Ilha de Man\",\"IL\":\"Israel\",\"IT\":\"Itália\",\"JM\":\"Jamaica\",\"JP\":\"Japão\",\"JE\":\"Jersey\",\"JO\":\"Jordânia\",\"KZ\":\"Cazaquistão\",\"KE\":\"Quênia\",\"KI\":\"Kiribati\",\"KR\":\"Coreia do Sul\",\"KW\":\"Kuwait\",\"KG\":\"Quirguistão\",\"LA\":\"Laos\",\"LV\":\"Letônia\",\"LB\":\"Líbano\",\"LS\":\"Lesoto\",\"LR\":\"Libéria\",\"LY\":\"Líbia\",\"LI\":\"Liechtenstein\",\"LT\":\"Lituânia\",\"LU\":\"Luxemburgo\",\"MO\":\"Macau\",\"MK\":\"Macedônia\",\"MG\":\"Madagascar\",\"MW\":\"Malawi\",\"MY\":\"Malásia\",\"MV\":\"Maldivas\",\"ML\":\"Mali\",\"MT\":\"Malta\",\"MH\":\"Ilhas Marshall\",\"MQ\":\"Martinica\",\"MR\":\"Mauritânia\",\"MU\":\"Maurício\",\"YT\":\"Mayotte\",\"MX\":\"México\",\"FM\":\"Micronésia, Estados Federados da\",\"MD\":\"Moldávia\",\"MC\":\"Mônaco\",\"MN\":\"Mongólia\",\"ME\":\"Montenegro\",\"MS\":\"Montserrat\",\"MA\":\"Marrocos\",\"MZ\":\"Moçambique\",\"MM\":\"Myanmar\",\"NA\":\"Namíbia\",\"NR\":\"Nauru\",\"NP\":\"Nepal\",\"NL\":\"Holanda\",\"NC\":\"Nova Caledônia\",\"NZ\":\"Nova Zelândia\",\"NI\":\"Nicarágua\",\"NE\":\"Níger\",\"NG\":\"Nigéria\",\"NU\":\"Niue\",\"NF\":\"Ilha Norfolk\",\"MP\":\"Ilhas Marianas Setentrionais\",\"NO\":\"Noruega\",\"OM\":\"Omã\",\"PK\":\"Paquistão\",\"PW\":\"Palau\",\"PA\":\"Panamá\",\"PG\":\"Papua Nova Guiné\",\"PY\":\"Paraguai\",\"PE\":\"Peru\",\"PH\":\"Filipinas\",\"PN\":\"Ilhas Pitcairn\",\"PL\":\"Polônia\",\"PT\":\"Portugal\",\"PR\":\"Porto Rico\",\"QA\":\"Catar\",\"RE\":\"Reunião\",\"RO\":\"Romênia\",\"RU\":\"Rússia\",\"RW\":\"Ruanda\",\"SH\":\"Santa Helena\",\"KN\":\"São Cristóvão e Névis\",\"LC\":\"Santa Lúcia\",\"PM\":\"Saint Pierre e Miquelon\",\"VC\":\"São Vicente e Granadinas\",\"WS\":\"Samoa\",\"SM\":\"San Marino\",\"ST\":\"São Tomé e Príncipe\",\"SA\":\"Arábia Saudita\",\"SN\":\"Senegal\",\"RS\":\"Sérvia e Montenegro\",\"SC\":\"Seicheles\",\"SL\":\"Serra Leoa\",\"SG\":\"CINGAPURA\",\"SK\":\"Eslováquia\",\"SI\":\"Eslovênia\",\"SB\":\"Ilhas Salomão\",\"SO\":\"Somália\",\"ZA\":\"África do Sul\",\"ES\":\"Espanha\",\"LK\":\"Sri Lanka\",\"SD\":\"Sudão\",\"SR\":\"Suriname\",\"SJ\":\"Svalbard\",\"SZ\":\"Suazilândia\",\"SE\":\"Suécia\",\"CH\":\"Suíça\",\"TW\":\"Taiwan\",\"TJ\":\"Tajiquistão\",\"TZ\":\"Tanzânia\",\"TH\":\"Tailândia\",\"TL\":\"Timor-Leste\",\"TG\":\"Togo\",\"TK\":\"Tokelau\",\"TO\":\"Tonga\",\"TT\":\"Trindade e Tobago\",\"TN\":\"Tunísia\",\"TR\":\"Turquia\",\"TM\":\"Turcomenistão\",\"TC\":\"Ilhas Turcas e Caicos\",\"TV\":\"Tuvalu\",\"UG\":\"Uganda\",\"UA\":\"Ucrânia\",\"AE\":\"Emirados Árabes Unidos\",\"GB\":\"Reino Unido\",\"US\":\"Estados Unidos\",\"UY\":\"Uruguai\",\"UZ\":\"Uzbequistão\",\"VU\":\"Vanuatu\",\"VE\":\"Venezuela\",\"VN\":\"Vietnã\",\"VG\":\"Ilhas Virgens Britânicas\",\"VI\":\"Ilhas Virgens\",\"EH\":\"Saara Ocidental\",\"YE\":\"Iêmen\",\"ZM\":\"Zâmbia\",\"ZW\":\"Zimbábue\"}");

/***/ }),
/* 446 */
/***/ (function(module) {

module.exports = JSON.parse("{\"conference\":\"Konferens\",\"extension\":\"Anknytning\",\"validation_error_meeting_validate_duplicate_name\":\"Det här mötesnamnet är upptaget.\",\"validation_error_meeting_validate_pattern_pin\":\"Inlägget innehåller ogiltiga tecken.\",\"AF\":\"Afghanistan\",\"AL\":\"Albanien\",\"DZ\":\"Algeriet\",\"AS\":\"Amerikanska Samoa\",\"AD\":\"Andorra\",\"AO\":\"Angola\",\"AI\":\"Anguilla\",\"AG\":\"Antigua och Barbuda\",\"AR\":\"Argentina\",\"AM\":\"Armenien\",\"AW\":\"Aruba\",\"AU\":\"Australien\",\"AT\":\"Österrike\",\"AZ\":\"Azerbajdzjan\",\"BS\":\"Bahamas\",\"BH\":\"Bahrain\",\"BD\":\"Bangladesh\",\"BB\":\"Barbados\",\"BY\":\"Vitryssland\",\"BE\":\"Belgien\",\"BZ\":\"Belize\",\"BJ\":\"Benin\",\"BM\":\"Bermuda\",\"BT\":\"Bhutan\",\"BO\":\"Bolivia\",\"BA\":\"Bosnien och Hercegovina\",\"BW\":\"Botswana\",\"BR\":\"Brasilien\",\"BN\":\"Brunei\",\"BG\":\"Bulgarien\",\"BF\":\"Burkina Faso\",\"BI\":\"Burundi\",\"KH\":\"Kambodja\",\"CM\":\"Kamerun\",\"CA\":\"Kanada\",\"CV\":\"Kap Verde\",\"KY\":\"Caymanöarna\",\"CF\":\"Centralafrikanska republiken\",\"TD\":\"Tchad\",\"CL\":\"Chile\",\"CN\":\"Kina\",\"CX\":\"Julön\",\"CC\":\"Kokosöarna\",\"CO\":\"Colombia\",\"KM\":\"Komorerna\",\"CG\":\"Republiken Kongo\",\"CD\":\"Demokratiska republiken Kongo\",\"CK\":\"Cooköarna\",\"CR\":\"Costa Rica\",\"CI\":\"Elfenbenskusten\",\"HR\":\"Kroatien\",\"CU\":\"Kuba\",\"CY\":\"Cypern\",\"CZ\":\"Tjeckien\",\"DK\":\"Danmark\",\"DJ\":\"Djibouti\",\"DM\":\"Dominica\",\"DO\":\"Dominikanska republiken\",\"EC\":\"Ecuador\",\"EG\":\"Egypten\",\"SV\":\"El Salvador\",\"GQ\":\"Ekvatorialguinea\",\"ER\":\"Eritrea\",\"EE\":\"Estland\",\"ET\":\"Etiopien\",\"EU\":\"EU\",\"FK\":\"Falklandsöarna (Malvinerna)\",\"FO\":\"Färöarna\",\"FJ\":\"Fiji\",\"FI\":\"Finland\",\"FR\":\"Frankrike\",\"GF\":\"Franska Guyana\",\"PF\":\"Franska Polynesien\",\"GA\":\"Gabon\",\"GM\":\"Gambia\",\"GE\":\"Georgien\",\"DE\":\"Tyskland\",\"GH\":\"Ghana\",\"GI\":\"Gibraltar\",\"GR\":\"Grekland\",\"GL\":\"Grönland\",\"GD\":\"Grenada\",\"GP\":\"Guadeloupe\",\"GU\":\"Guam\",\"GT\":\"Guatemala\",\"GG\":\"Guernsey\",\"GN\":\"Guinea\",\"GW\":\"Guinea-Bissau\",\"GY\":\"Guyana\",\"GZ\":\"Gaza\",\"HT\":\"Haiti\",\"VA\":\"Vatikanstaten\",\"HN\":\"Honduras\",\"HK\":\"Hongkong\",\"HU\":\"Ungern\",\"IS\":\"Island\",\"IN\":\"Indien\",\"ID\":\"Indonesien\",\"IQ\":\"Irak\",\"IE\":\"Irland\",\"IM\":\"Isle of Man\",\"IL\":\"Israel\",\"IT\":\"Italien\",\"JM\":\"Jamaica\",\"JP\":\"Japan\",\"JE\":\"Jersey\",\"JO\":\"Jordanien\",\"KZ\":\"Kazakstan\",\"KE\":\"Kenya\",\"KI\":\"Kiribati\",\"KR\":\"Sydkorea\",\"KW\":\"Kuwait\",\"KG\":\"Kirgizistan\",\"LA\":\"Laos\",\"LV\":\"Lettland\",\"LB\":\"Libanon\",\"LS\":\"Lesotho\",\"LR\":\"Liberia\",\"LY\":\"Libyen\",\"LI\":\"Liechtenstein\",\"LT\":\"Litauen\",\"LU\":\"Luxemburg\",\"MO\":\"Macao\",\"MK\":\"Makedonien\",\"MG\":\"Madagaskar\",\"MW\":\"Malawi\",\"MY\":\"Malaysia\",\"MV\":\"Maldiverna\",\"ML\":\"Mali\",\"MT\":\"Malta\",\"MH\":\"Marshallöarna\",\"MQ\":\"Martinique\",\"MR\":\"Mauretanien\",\"MU\":\"Mauritius\",\"YT\":\"Mayotte\",\"MX\":\"Mexiko\",\"FM\":\"Mikronesien\",\"MD\":\"Moldavien\",\"MC\":\"Monaco\",\"MN\":\"Mongoliet\",\"ME\":\"Montenegro\",\"MS\":\"Montserrat\",\"MA\":\"Marocko\",\"MZ\":\"Moçambique\",\"MM\":\"Myanmar\",\"NA\":\"Namibia\",\"NR\":\"Nauru\",\"NP\":\"Nepal\",\"NL\":\"Nederländerna\",\"NC\":\"Nya Kaledonien\",\"NZ\":\"Nya Zeeland\",\"NI\":\"Nicaragua\",\"NE\":\"Niger\",\"NG\":\"Nigeria\",\"NU\":\"Niue\",\"NF\":\"Norfolkön\",\"MP\":\"Nordmarianerna\",\"NO\":\"Norge\",\"OM\":\"Oman\",\"PK\":\"Pakistan\",\"PW\":\"Palau\",\"PA\":\"Panama\",\"PG\":\"Papua Nya Guinea\",\"PY\":\"Paraguay\",\"PE\":\"Peru\",\"PH\":\"Filippinerna\",\"PN\":\"Pitcairnöarna\",\"PL\":\"Polen\",\"PT\":\"Portugal\",\"PR\":\"Puerto Rico\",\"QA\":\"Qatar\",\"RE\":\"Réunion\",\"RO\":\"Rumänien\",\"RU\":\"Ryssland\",\"RW\":\"Rwanda\",\"SH\":\"Sankta Helena\",\"KN\":\"Saint Kitts och Nevis\",\"LC\":\"Saint Lucia\",\"PM\":\"Saint-Pierre och Miquelon\",\"VC\":\"Saint Vincent och Grenadinerna\",\"WS\":\"Samoa\",\"SM\":\"San Marino\",\"ST\":\"São Tomé och Príncipe\",\"SA\":\"Saudiarabien\",\"SN\":\"Senegal\",\"RS\":\"Serbien\",\"SC\":\"Seychellerna\",\"SL\":\"Sierra Leone\",\"SG\":\"Singapore\",\"SK\":\"Slovakien\",\"SI\":\"Slovenien\",\"SB\":\"Salomonöarna\",\"SO\":\"Somalia\",\"ZA\":\"Sydafrika\",\"ES\":\"Spanien\",\"LK\":\"Sri Lanka\",\"SD\":\"Sudan\",\"SR\":\"Surinam\",\"SJ\":\"Svalbard\",\"SZ\":\"Swaziland\",\"SE\":\"Sverige\",\"CH\":\"Schweiz\",\"TW\":\"Taiwan\",\"TJ\":\"Tadzjikistan\",\"TZ\":\"Tanzania\",\"TH\":\"Thailand\",\"TL\":\"Östtimor\",\"TG\":\"Togo\",\"TK\":\"Tokelauöarna\",\"TO\":\"Tonga\",\"TT\":\"Trinidad och Tobago\",\"TN\":\"Tunisien\",\"TR\":\"Turkiet\",\"TM\":\"Turkmenistan\",\"TC\":\"Turks- och Caicosöarna\",\"TV\":\"Tuvalu\",\"UG\":\"Uganda\",\"UA\":\"Ukraina\",\"AE\":\"Förenade Arabemiraten\",\"GB\":\"Storbritannien\",\"US\":\"USA\",\"UY\":\"Uruguay\",\"UZ\":\"Uzbekistan\",\"VU\":\"Vanuatu\",\"VE\":\"Venezuela\",\"VN\":\"Vietnam\",\"VG\":\"Brittiska Jungfruöarna\",\"VI\":\"Jungfruöarna\",\"EH\":\"Västsahara\",\"YE\":\"Jemen\",\"ZM\":\"Zambia\",\"ZW\":\"Zimbabwe\"}");

/***/ }),
/* 447 */
/***/ (function(module) {

module.exports = JSON.parse("{\"conference\":\"会议\",\"extension\":\"扩展\",\"validation_error_meeting_validate_duplicate_name\":\"该会议名称已被使用。\",\"validation_error_meeting_validate_pattern_pin\":\"输入包含无效字符。\",\"AF\":\"阿富汗\",\"AL\":\"阿尔巴尼亚\",\"DZ\":\"阿尔及利亚\",\"AS\":\"美属萨摩亚\",\"AD\":\"安道尔\",\"AO\":\"安哥拉\",\"AI\":\"安圭拉\",\"AG\":\"安提瓜和巴布达\",\"AR\":\"阿根廷\",\"AM\":\"亚美尼亚\",\"AW\":\"阿鲁巴\",\"AU\":\"澳大利亚\",\"AT\":\"奥地利\",\"AZ\":\"阿塞拜疆\",\"BS\":\"巴哈马\",\"BH\":\"巴林\",\"BD\":\"孟加拉国\",\"BB\":\"巴巴多斯\",\"BY\":\"白俄罗斯\",\"BE\":\"比利时\",\"BZ\":\"伯利兹\",\"BJ\":\"贝宁\",\"BM\":\"百慕大\",\"BT\":\"不丹\",\"BO\":\"玻利维亚\",\"BA\":\"波斯尼亚和黑塞哥维那\",\"BW\":\"博茨瓦纳\",\"BR\":\"巴西\",\"BN\":\"文莱\",\"BG\":\"保加利亚\",\"BF\":\"布基纳法索\",\"BI\":\"布隆迪\",\"KH\":\"柬埔寨\",\"CM\":\"喀麦隆\",\"CA\":\"加拿大\",\"CV\":\"佛得角\",\"KY\":\"开曼群岛\",\"CF\":\"中非共和国\",\"TD\":\"乍得\",\"CL\":\"智利\",\"CN\":\"中国\",\"CX\":\"圣诞岛\",\"CC\":\"科科斯（基林）群岛\",\"CO\":\"哥伦比亚\",\"KM\":\"科摩罗\",\"CG\":\"刚果共和国\",\"CD\":\"刚果民主共和国\",\"CK\":\"库克群岛\",\"CR\":\"哥斯达黎加\",\"CI\":\"科特迪瓦\",\"HR\":\"克罗地亚\",\"CU\":\"古巴\",\"CY\":\"塞浦路斯\",\"CZ\":\"捷克共和国\",\"DK\":\"丹麦\",\"DJ\":\"吉布提\",\"DM\":\"多米尼加\",\"DO\":\"多米尼加共和国\",\"EC\":\"厄瓜多尔\",\"EG\":\"埃及\",\"SV\":\"萨尔瓦多\",\"GQ\":\"赤道几内亚\",\"ER\":\"厄立特里亚\",\"EE\":\"爱沙尼亚\",\"ET\":\"埃塞俄比亚\",\"EU\":\"欧盟\",\"FK\":\"福克兰群岛（马尔维纳斯）\",\"FO\":\"法罗群岛\",\"FJ\":\"斐济\",\"FI\":\"芬兰\",\"FR\":\"法国\",\"GF\":\"法属圭亚那\",\"PF\":\"法属波利尼西亚\",\"GA\":\"加蓬\",\"GM\":\"冈比亚\",\"GE\":\"乔治亚州\",\"DE\":\"德国\",\"GH\":\"加纳\",\"GI\":\"直布罗陀\",\"GR\":\"希腊\",\"GL\":\"格陵兰岛\",\"GD\":\"格林纳达\",\"GP\":\"瓜德罗普岛\",\"GU\":\"关岛\",\"GT\":\"危地马拉\",\"GG\":\"格恩西岛\",\"GN\":\"几内亚\",\"GW\":\"几内亚比绍\",\"GY\":\"圭亚那\",\"GZ\":\"加沙地带\",\"HT\":\"海地\",\"VA\":\"罗马教廷（梵蒂冈城国）\",\"HN\":\"洪都拉斯\",\"HK\":\"香港\",\"HU\":\"匈牙利\",\"IS\":\"冰岛\",\"IN\":\"印度\",\"ID\":\"印度尼西亚\",\"IQ\":\"伊拉克\",\"IE\":\"爱尔兰\",\"IM\":\"马恩岛\",\"IL\":\"以色列\",\"IT\":\"意大利\",\"JM\":\"牙买加\",\"JP\":\"日本\",\"JE\":\"泽西岛\",\"JO\":\"约旦\",\"KZ\":\"哈萨克斯坦\",\"KE\":\"肯尼亚\",\"KI\":\"基里巴斯\",\"KR\":\"韩国\",\"KW\":\"科威特\",\"KG\":\"吉尔吉斯斯坦\",\"LA\":\"老挝\",\"LV\":\"拉脱维亚\",\"LB\":\"黎巴嫩\",\"LS\":\"莱索托\",\"LR\":\"利比里亚\",\"LY\":\"利比亚\",\"LI\":\"列支敦士登\",\"LT\":\"立陶宛\",\"LU\":\"卢森堡\",\"MO\":\"澳门\",\"MK\":\"马其顿\",\"MG\":\"马达加斯加\",\"MW\":\"马拉维\",\"MY\":\"马来西亚\",\"MV\":\"马尔代夫\",\"ML\":\"马里\",\"MT\":\"马耳他\",\"MH\":\"马绍尔群岛\",\"MQ\":\"马提尼克\",\"MR\":\"毛里塔尼亚\",\"MU\":\"毛里求斯\",\"YT\":\"马约特岛\",\"MX\":\"墨西哥\",\"FM\":\"密克罗尼西亚（联邦）\",\"MD\":\"摩尔多瓦\",\"MC\":\"摩纳哥\",\"MN\":\"蒙古\",\"ME\":\"黑山\",\"MS\":\"蒙特塞拉特岛\",\"MA\":\"摩洛哥\",\"MZ\":\"莫桑比克\",\"MM\":\"缅甸\",\"NA\":\"纳米比亚\",\"NR\":\"瑙鲁\",\"NP\":\"尼泊尔\",\"NL\":\"荷兰\",\"NC\":\"新喀里多尼亚\",\"NZ\":\"新西兰\",\"NI\":\"尼加拉瓜\",\"NE\":\"尼日尔\",\"NG\":\"尼日利亚\",\"NU\":\"纽埃岛\",\"NF\":\"诺福克岛\",\"MP\":\"北马里亚纳群岛\",\"NO\":\"挪威\",\"OM\":\"阿曼\",\"PK\":\"巴基斯坦\",\"PW\":\"帕劳群岛\",\"PA\":\"巴拿马\",\"PG\":\"巴布亚新几内亚\",\"PY\":\"巴拉圭\",\"PE\":\"秘鲁\",\"PH\":\"菲律宾\",\"PN\":\"皮特克恩岛\",\"PL\":\"波兰\",\"PT\":\"葡萄牙\",\"PR\":\"波多黎各\",\"QA\":\"卡塔尔\",\"RE\":\"留尼汪岛\",\"RO\":\"罗马尼亚\",\"RU\":\"俄罗斯\",\"RW\":\"卢旺达\",\"SH\":\"圣赫勒拿岛\",\"KN\":\"圣基茨和尼维斯\",\"LC\":\"圣卢西亚岛\",\"PM\":\"圣皮埃尔岛和密克隆岛\",\"VC\":\"圣文森特和格林纳丁斯\",\"WS\":\"萨摩亚\",\"SM\":\"圣马力诺\",\"ST\":\"圣多美与普林希比民主共和国\",\"SA\":\"沙特阿拉伯\",\"SN\":\"塞内加尔\",\"RS\":\"塞尔维亚\",\"SC\":\"塞舌尔\",\"SL\":\"塞拉利昂\",\"SG\":\"新加坡\",\"SK\":\"斯洛伐克\",\"SI\":\"斯洛文尼亚\",\"SB\":\"所罗门群岛\",\"SO\":\"索马里\",\"ZA\":\"南非\",\"ES\":\"西班牙\",\"LK\":\"斯里兰卡\",\"SD\":\"苏丹\",\"SR\":\"苏里南\",\"SJ\":\"斯瓦尔巴特群岛\",\"SZ\":\"斯威士兰\",\"SE\":\"瑞典\",\"CH\":\"瑞士\",\"TW\":\"台湾\",\"TJ\":\"塔吉克斯坦\",\"TZ\":\"坦桑尼亚\",\"TH\":\"泰国\",\"TL\":\"东帝汶\",\"TG\":\"多哥\",\"TK\":\"托克劳群岛\",\"TO\":\"汤加\",\"TT\":\"特立尼达和多巴哥\",\"TN\":\"突尼斯\",\"TR\":\"土耳其\",\"TM\":\"土库曼斯坦\",\"TC\":\"特克斯和凯科斯群岛\",\"TV\":\"图瓦卢\",\"UG\":\"乌干达\",\"UA\":\"乌克兰\",\"AE\":\"阿拉伯联合酋长国\",\"GB\":\"英国\",\"US\":\"美国\",\"UY\":\"乌拉圭\",\"UZ\":\"乌兹别克斯坦\",\"VU\":\"瓦努阿图\",\"VE\":\"委内瑞拉\",\"VN\":\"越南\",\"VG\":\"维尔京群岛（英属）\",\"VI\":\"维尔京群岛\",\"EH\":\"西撒哈拉\",\"YE\":\"也门\",\"ZM\":\"赞比亚\",\"ZW\":\"津巴布韦\"}");

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendConferenceCommand = sendConferenceCommand;
exports.sendModeratorCommand = sendModeratorCommand;

var C = _interopRequireWildcard(__webpack_require__(3));

var _proxy = __webpack_require__(21);

var _conference = __webpack_require__(53);

var _guid = _interopRequireDefault(__webpack_require__(72));

var _moderator = __webpack_require__(93);

function sendConferenceCommand(command, participantId) {
  return function (dispatch, getState) {
    var state = getState(); // Obtain galaxy conferenceId

    var conferenceId = (0, _conference.selectConferenceId)(state);

    if (!conferenceId) {
      throw new Error('Cannot send participant command: No conference.');
    }

    var params = {
      messageId: _guid.default.create(),
      event: command,
      conferenceId: conferenceId,
      participantId: participantId
    };
    dispatch(sendModeratorCommand(params));
  };
}

function sendModeratorCommand(params) {
  return function (dispatch, getState) {
    var state = getState(); // Check if invoking user is moderator

    var isModerator = (0, _moderator.selectIsCurrentUserModerator)(state);

    if (!isModerator) {
      throw new Error('Cannot send participant command: Current user is not moderator.');
    }

    dispatch((0, _proxy.proxyApiCall)(C.GALAXY_TOPIC_MODERATOR_ACTIONS, C.GALAXY_WAMP_URI_SUFFIX_DEFAULT, C.GALAXY_HTTP_METHOD_DEFAULT, params));
  };
}

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createAbortError = function createAbortError() {
  var error = new Error('Delay aborted');
  error.name = 'AbortError';
  return error;
};

var createDelay = function createDelay(_ref) {
  var _ref$clearTimeout = _ref.clearTimeout,
      clear = _ref$clearTimeout === void 0 ? clearTimeout : _ref$clearTimeout,
      _ref$setTimeout = _ref.setTimeout,
      set = _ref$setTimeout === void 0 ? setTimeout : _ref$setTimeout,
      willResolve = _ref.willResolve;
  return function (ms) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        value = _ref2.value,
        signal = _ref2.signal;

    if (signal && signal.aborted) {
      return Promise.reject(createAbortError());
    }

    var timeoutId;
    var settle;
    var rejectFn;

    var signalListener = function signalListener() {
      clear(timeoutId);
      rejectFn(createAbortError());
    };

    var cleanup = function cleanup() {
      if (signal) {
        signal.removeEventListener('abort', signalListener);
      }
    };

    var delayPromise = new Promise(function (resolve, reject) {
      settle = function settle() {
        cleanup();

        if (willResolve) {
          resolve(value);
        } else {
          reject(value);
        }
      };

      rejectFn = reject;
      timeoutId = set(settle, ms);
    });

    if (signal) {
      signal.addEventListener('abort', signalListener, {
        once: true
      });
    }

    delayPromise.clear = function () {
      clear(timeoutId);
      timeoutId = null;
      cleanup();
      settle();
    };

    return delayPromise;
  };
};

var delay = createDelay({
  willResolve: true
});
delay.reject = createDelay({
  willResolve: false
});

delay.createWithTimers = function (_ref3) {
  var clearTimeout = _ref3.clearTimeout,
      setTimeout = _ref3.setTimeout;
  var delay = createDelay({
    clearTimeout: clearTimeout,
    setTimeout: setTimeout,
    willResolve: true
  });
  delay.reject = createDelay({
    clearTimeout: clearTimeout,
    setTimeout: setTimeout,
    willResolve: false
  });
  return delay;
};

module.exports = delay;
module.exports.default = delay;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(57);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"meQuery"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uuid"},"name":{"kind":"Name","value":"UUID"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"favorites"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"favorited"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallableFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MeetingFields"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"callHistory"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallHistoryFields"},"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":401}};
    doc.loc.source = {"body":"#import \"./callable-fragments.gql\"\n#import \"./call-history-fragment.gql\"\n#import \"./meeting-fragments.gql\"\n#import \"./user-fragments.gql\"\n\nquery meQuery {\n  me {\n    uuid: UUID\n    favorites {\n      favorited {\n        ...IdFields\n        ...UserFields\n        ...CallableFields\n        ...MeetingFields\n      }\n    }\n    callHistory {\n      records {\n        ...CallHistoryFields\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(38).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(249).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(54).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(250).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["meQuery"] = oneQuery(doc, "meQuery");
        


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"nucleusLoadAllContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DirectoryResultFilter"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directoryList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasMoreRecords"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalRecordCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"records"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallableFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MeetingFields"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":376}};
    doc.loc.source = {"body":"#import \"./callable-fragments.gql\"\n#import \"./meeting-fragments.gql\"\n\nquery nucleusLoadAllContacts($cursor: String, $limit: Int, $filter: [DirectoryResultFilter]) {\n  directoryList(cursor: $cursor, limit: $limit, filter: $filter) {\n    cursor,\n    hasMoreRecords,\n    totalRecordCount\n    records {\n      ...IdFields\n      ...CallableFields\n      ...MeetingFields\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(38).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(54).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["nucleusLoadAllContacts"] = oneQuery(doc, "nucleusLoadAllContacts");
        


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"nucleusContactByUUID"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"contact"},"name":{"kind":"Name","value":"directoryByUUID"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallableFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MeetingFields"},"directives":[]}]}}]}}],"loc":{"start":0,"end":220}};
    doc.loc.source = {"body":"#import \"./callable-fragments.gql\"\n#import \"./meeting-fragments.gql\"\n\nquery nucleusContactByUUID($uuid: UUID!) {\n  contact: directoryByUUID(uuid: $uuid) {\n    ...IdFields\n    ...CallableFields\n    ...MeetingFields\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(38).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(54).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["nucleusContactByUUID"] = oneQuery(doc, "nucleusContactByUUID");
        


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"directoryByUUIDsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directoryByUUIDs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uuids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuids"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallableFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MeetingFields"},"directives":[]}]}}]}}],"loc":{"start":0,"end":217}};
    doc.loc.source = {"body":"#import \"./callable-fragments.gql\"\n#import \"./meeting-fragments.gql\"\n\nquery directoryByUUIDsQuery($uuids: [UUID]!) {\n  directoryByUUIDs(uuids:$uuids) {\n    ...IdFields\n    ...CallableFields\n    ...MeetingFields\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(38).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(54).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["directoryByUUIDsQuery"] = oneQuery(doc, "directoryByUUIDsQuery");
        


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"directoryByExtensionsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"extensions"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directoryByExtensions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"extensions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"extensions"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallableFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MeetingFields"},"directives":[]}]}}]}}],"loc":{"start":0,"end":244}};
    doc.loc.source = {"body":"#import \"./callable-fragments.gql\"\n#import \"./meeting-fragments.gql\"\n\nquery directoryByExtensionsQuery($extensions: [String]!) {\n  directoryByExtensions(extensions:$extensions) {\n    ...IdFields\n    ...CallableFields\n    ...MeetingFields\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(38).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(54).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["directoryByExtensionsQuery"] = oneQuery(doc, "directoryByExtensionsQuery");
        


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"search"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DirectoryResultFilter"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directoryList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"75"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"excludeSelf"},"value":{"kind":"BooleanValue","value":true}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalRecordCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"records"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallableFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MeetingFields"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":328}};
    doc.loc.source = {"body":"#import \"./callable-fragments.gql\"\n#import \"./meeting-fragments.gql\"\n\nquery search($query: String!, $filter: [DirectoryResultFilter]) {\n  directoryList(query: $query, limit: 75, filter: $filter, excludeSelf: true) {\n    totalRecordCount\n    records {\n      ...IdFields\n      ...CallableFields\n      ...MeetingFields\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(38).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(54).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["search"] = oneQuery(doc, "search");
        


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeMeetings"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallableFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MeetingFields"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":232}};
    doc.loc.source = {"body":"#import \"../../actions/directory/callable-fragments.gql\"\n#import \"../../actions/directory/meeting-fragments.gql\"\n\nquery {\n  activeMeetings {\n    records {\n      ...IdFields\n      ...CallableFields\n      ...MeetingFields\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(38).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(54).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userMeetings"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallableFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MeetingFields"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":230}};
    doc.loc.source = {"body":"#import \"../../actions/directory/callable-fragments.gql\"\n#import \"../../actions/directory/meeting-fragments.gql\"\n\nquery {\n  userMeetings {\n    records {\n      ...IdFields\n      ...CallableFields\n      ...MeetingFields\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(38).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(54).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findByUuidGenerator = exports.selectSequenceNumber = exports.selectSearchResults = void 0;

var _get = _interopRequireDefault(__webpack_require__(11));

var selectSearchResults = function selectSearchResults(state) {
  return (0, _get.default)(state, 'nucleus.directory.searchResults');
};

exports.selectSearchResults = selectSearchResults;

var selectSequenceNumber = function selectSequenceNumber(state) {
  return (0, _get.default)(state, 'nucleus.directory.sequenceNumber');
};

exports.selectSequenceNumber = selectSequenceNumber;

var findByUuidGenerator = function findByUuidGenerator(state) {
  return function (uuid) {
    var searchResults = selectSearchResults(state);
    return searchResults.find(function (c) {
      return c.uuid === uuid;
    });
  };
};

exports.findByUuidGenerator = findByUuidGenerator;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serverPushDeleteCallHistory = serverPushDeleteCallHistory;
exports.serverPushAddCallHistory = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(81));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var c = _interopRequireWildcard(__webpack_require__(3));

var _callHistoryQuery = _interopRequireDefault(__webpack_require__(461));

var _callHistoryUtils = __webpack_require__(126);

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

/**
 * Server Add Call History
 */
var serverPushAddCallHistory = function serverPushAddCallHistory(record) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch, getState) {
        var _result$data;

        var _ref2, _ref3, result;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (record === null || record === void 0 ? void 0 : record.id) {
                  _context.next = 3;
                  break;
                }

                _jsLogger.default.warn('Callhistory push without an UUID', record);

                return _context.abrupt("return");

              case 3:
                _context.next = 5;
                return dispatch({
                  type: c.GQL_QUERY,
                  payload: {
                    query: _callHistoryQuery.default,
                    variables: {
                      UUID: record.id
                    }
                  }
                });

              case 5:
                _ref2 = _context.sent;
                _ref3 = (0, _slicedToArray2.default)(_ref2, 1);
                result = _ref3[0];

                if (result === null || result === void 0 ? void 0 : (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.record) {
                  _context.next = 11;
                  break;
                }

                _jsLogger.default.warn('Failed to fetch a callhistory by uuid');

                return _context.abrupt("return");

              case 11:
                dispatch({
                  type: c.SERVER_PUSH_ADD_CALLHISTORY,
                  payload: {
                    record: (0, _callHistoryUtils.mapToLegacyCallHistory)(getState())(result.data.record)
                  }
                });

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};
/**
 * Server Delete Call History
 */


exports.serverPushAddCallHistory = serverPushAddCallHistory;

function serverPushDeleteCallHistory(record) {
  return {
    type: c.SERVER_PUSH_DELETE_CALLHISTORY,
    payload: {
      record: record
    }
  };
}

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"callHistoryByUUID"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"UUID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"record"},"name":{"kind":"Name","value":"callHistoryByUUID"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"UUID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"UUID"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallHistoryFields"},"directives":[]}]}}]}}],"loc":{"start":0,"end":152}};
    doc.loc.source = {"body":"#import \"./call-history-fragment.gql\"\n\nquery callHistoryByUUID($UUID: UUID!) {\n  record: callHistoryByUUID(UUID: $UUID){\n    ...CallHistoryFields\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(249).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["callHistoryByUUID"] = oneQuery(doc, "callHistoryByUUID");
        


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parse = parse;
exports.parseValue = parseValue;
exports.parseType = parseType;

var _inspect = _interopRequireDefault(__webpack_require__(255));

var _devAssert = _interopRequireDefault(__webpack_require__(257));

var _defineToJSON = _interopRequireDefault(__webpack_require__(258));

var _syntaxError = __webpack_require__(259);

var _kinds = __webpack_require__(466);

var _source = __webpack_require__(467);

var _lexer = __webpack_require__(469);

var _directiveLocation = __webpack_require__(470);

var _tokenKind = __webpack_require__(262);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  var parser = new Parser(source, options);
  return parser.parseDocument();
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */


function parseValue(source, options) {
  var parser = new Parser(source, options);
  parser.expectToken(_tokenKind.TokenKind.SOF);
  var value = parser.parseValueLiteral(false);
  parser.expectToken(_tokenKind.TokenKind.EOF);
  return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */


function parseType(source, options) {
  var parser = new Parser(source, options);
  parser.expectToken(_tokenKind.TokenKind.SOF);
  var type = parser.parseTypeReference();
  parser.expectToken(_tokenKind.TokenKind.EOF);
  return type;
}

var Parser =
/*#__PURE__*/
function () {
  function Parser(source, options) {
    var sourceObj = typeof source === 'string' ? new _source.Source(source) : source;
    sourceObj instanceof _source.Source || (0, _devAssert.default)(0, "Must provide Source. Received: ".concat((0, _inspect.default)(sourceObj)));
    this._lexer = (0, _lexer.createLexer)(sourceObj);
    this._options = options || {};
  }
  /**
   * Converts a name lex token into a name parse node.
   */


  var _proto = Parser.prototype;

  _proto.parseName = function parseName() {
    var token = this.expectToken(_tokenKind.TokenKind.NAME);
    return {
      kind: _kinds.Kind.NAME,
      value: token.value,
      loc: this.loc(token)
    };
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */
  ;

  _proto.parseDocument = function parseDocument() {
    var start = this._lexer.token;
    return {
      kind: _kinds.Kind.DOCUMENT,
      definitions: this.many(_tokenKind.TokenKind.SOF, this.parseDefinition, _tokenKind.TokenKind.EOF),
      loc: this.loc(start)
    };
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */
  ;

  _proto.parseDefinition = function parseDefinition() {
    if (this.peek(_tokenKind.TokenKind.NAME)) {
      switch (this._lexer.token.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();

        case 'schema':
        case 'scalar':
        case 'type':
        case 'interface':
        case 'union':
        case 'enum':
        case 'input':
        case 'directive':
          return this.parseTypeSystemDefinition();

        case 'extend':
          return this.parseTypeSystemExtension();
      }
    } else if (this.peek(_tokenKind.TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } else if (this.peekDescription()) {
      return this.parseTypeSystemDefinition();
    }

    throw this.unexpected();
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  ;

  _proto.parseOperationDefinition = function parseOperationDefinition() {
    var start = this._lexer.token;

    if (this.peek(_tokenKind.TokenKind.BRACE_L)) {
      return {
        kind: _kinds.Kind.OPERATION_DEFINITION,
        operation: 'query',
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }

    var operation = this.parseOperationType();
    var name;

    if (this.peek(_tokenKind.TokenKind.NAME)) {
      name = this.parseName();
    }

    return {
      kind: _kinds.Kind.OPERATION_DEFINITION,
      operation: operation,
      name: name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * OperationType : one of query mutation subscription
   */
  ;

  _proto.parseOperationType = function parseOperationType() {
    var operationToken = this.expectToken(_tokenKind.TokenKind.NAME);

    switch (operationToken.value) {
      case 'query':
        return 'query';

      case 'mutation':
        return 'mutation';

      case 'subscription':
        return 'subscription';
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  ;

  _proto.parseVariableDefinitions = function parseVariableDefinitions() {
    return this.optionalMany(_tokenKind.TokenKind.PAREN_L, this.parseVariableDefinition, _tokenKind.TokenKind.PAREN_R);
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  ;

  _proto.parseVariableDefinition = function parseVariableDefinition() {
    var start = this._lexer.token;
    return {
      kind: _kinds.Kind.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(_tokenKind.TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(_tokenKind.TokenKind.EQUALS) ? this.parseValueLiteral(true) : undefined,
      directives: this.parseDirectives(true),
      loc: this.loc(start)
    };
  }
  /**
   * Variable : $ Name
   */
  ;

  _proto.parseVariable = function parseVariable() {
    var start = this._lexer.token;
    this.expectToken(_tokenKind.TokenKind.DOLLAR);
    return {
      kind: _kinds.Kind.VARIABLE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  }
  /**
   * SelectionSet : { Selection+ }
   */
  ;

  _proto.parseSelectionSet = function parseSelectionSet() {
    var start = this._lexer.token;
    return {
      kind: _kinds.Kind.SELECTION_SET,
      selections: this.many(_tokenKind.TokenKind.BRACE_L, this.parseSelection, _tokenKind.TokenKind.BRACE_R),
      loc: this.loc(start)
    };
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  ;

  _proto.parseSelection = function parseSelection() {
    return this.peek(_tokenKind.TokenKind.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  ;

  _proto.parseField = function parseField() {
    var start = this._lexer.token;
    var nameOrAlias = this.parseName();
    var alias;
    var name;

    if (this.expectOptionalToken(_tokenKind.TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return {
      kind: _kinds.Kind.FIELD,
      alias: alias,
      name: name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(_tokenKind.TokenKind.BRACE_L) ? this.parseSelectionSet() : undefined,
      loc: this.loc(start)
    };
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  ;

  _proto.parseArguments = function parseArguments(isConst) {
    var item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(_tokenKind.TokenKind.PAREN_L, item, _tokenKind.TokenKind.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  ;

  _proto.parseArgument = function parseArgument() {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(_tokenKind.TokenKind.COLON);
    return {
      kind: _kinds.Kind.ARGUMENT,
      name: name,
      value: this.parseValueLiteral(false),
      loc: this.loc(start)
    };
  };

  _proto.parseConstArgument = function parseConstArgument() {
    var start = this._lexer.token;
    return {
      kind: _kinds.Kind.ARGUMENT,
      name: this.parseName(),
      value: (this.expectToken(_tokenKind.TokenKind.COLON), this.parseValueLiteral(true)),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  ;

  _proto.parseFragment = function parseFragment() {
    var start = this._lexer.token;
    this.expectToken(_tokenKind.TokenKind.SPREAD);
    var hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(_tokenKind.TokenKind.NAME)) {
      return {
        kind: _kinds.Kind.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
        loc: this.loc(start)
      };
    }

    return {
      kind: _kinds.Kind.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  ;

  _proto.parseFragmentDefinition = function parseFragmentDefinition() {
    var start = this._lexer.token;
    this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (this._options.experimentalFragmentVariables) {
      return {
        kind: _kinds.Kind.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }

    return {
      kind: _kinds.Kind.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * FragmentName : Name but not `on`
   */
  ;

  _proto.parseFragmentName = function parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  ;

  _proto.parseValueLiteral = function parseValueLiteral(isConst) {
    var token = this._lexer.token;

    switch (token.kind) {
      case _tokenKind.TokenKind.BRACKET_L:
        return this.parseList(isConst);

      case _tokenKind.TokenKind.BRACE_L:
        return this.parseObject(isConst);

      case _tokenKind.TokenKind.INT:
        this._lexer.advance();

        return {
          kind: _kinds.Kind.INT,
          value: token.value,
          loc: this.loc(token)
        };

      case _tokenKind.TokenKind.FLOAT:
        this._lexer.advance();

        return {
          kind: _kinds.Kind.FLOAT,
          value: token.value,
          loc: this.loc(token)
        };

      case _tokenKind.TokenKind.STRING:
      case _tokenKind.TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();

      case _tokenKind.TokenKind.NAME:
        if (token.value === 'true' || token.value === 'false') {
          this._lexer.advance();

          return {
            kind: _kinds.Kind.BOOLEAN,
            value: token.value === 'true',
            loc: this.loc(token)
          };
        } else if (token.value === 'null') {
          this._lexer.advance();

          return {
            kind: _kinds.Kind.NULL,
            loc: this.loc(token)
          };
        }

        this._lexer.advance();

        return {
          kind: _kinds.Kind.ENUM,
          value: token.value,
          loc: this.loc(token)
        };

      case _tokenKind.TokenKind.DOLLAR:
        if (!isConst) {
          return this.parseVariable();
        }

        break;
    }

    throw this.unexpected();
  };

  _proto.parseStringLiteral = function parseStringLiteral() {
    var token = this._lexer.token;

    this._lexer.advance();

    return {
      kind: _kinds.Kind.STRING,
      value: token.value,
      block: token.kind === _tokenKind.TokenKind.BLOCK_STRING,
      loc: this.loc(token)
    };
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  ;

  _proto.parseList = function parseList(isConst) {
    var _this = this;

    var start = this._lexer.token;

    var item = function item() {
      return _this.parseValueLiteral(isConst);
    };

    return {
      kind: _kinds.Kind.LIST,
      values: this.any(_tokenKind.TokenKind.BRACKET_L, item, _tokenKind.TokenKind.BRACKET_R),
      loc: this.loc(start)
    };
  }
  /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */
  ;

  _proto.parseObject = function parseObject(isConst) {
    var _this2 = this;

    var start = this._lexer.token;

    var item = function item() {
      return _this2.parseObjectField(isConst);
    };

    return {
      kind: _kinds.Kind.OBJECT,
      fields: this.any(_tokenKind.TokenKind.BRACE_L, item, _tokenKind.TokenKind.BRACE_R),
      loc: this.loc(start)
    };
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  ;

  _proto.parseObjectField = function parseObjectField(isConst) {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(_tokenKind.TokenKind.COLON);
    return {
      kind: _kinds.Kind.OBJECT_FIELD,
      name: name,
      value: this.parseValueLiteral(isConst),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */
  ;

  _proto.parseDirectives = function parseDirectives(isConst) {
    var directives = [];

    while (this.peek(_tokenKind.TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }
  /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */
  ;

  _proto.parseDirective = function parseDirective(isConst) {
    var start = this._lexer.token;
    this.expectToken(_tokenKind.TokenKind.AT);
    return {
      kind: _kinds.Kind.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  ;

  _proto.parseTypeReference = function parseTypeReference() {
    var start = this._lexer.token;
    var type;

    if (this.expectOptionalToken(_tokenKind.TokenKind.BRACKET_L)) {
      type = this.parseTypeReference();
      this.expectToken(_tokenKind.TokenKind.BRACKET_R);
      type = {
        kind: _kinds.Kind.LIST_TYPE,
        type: type,
        loc: this.loc(start)
      };
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(_tokenKind.TokenKind.BANG)) {
      return {
        kind: _kinds.Kind.NON_NULL_TYPE,
        type: type,
        loc: this.loc(start)
      };
    }

    return type;
  }
  /**
   * NamedType : Name
   */
  ;

  _proto.parseNamedType = function parseNamedType() {
    var start = this._lexer.token;
    return {
      kind: _kinds.Kind.NAMED_TYPE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Type Definition section.

  /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  ;

  _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
    // Many definitions begin with a description and require a lookahead.
    var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;

    if (keywordToken.kind === _tokenKind.TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }
    }

    throw this.unexpected(keywordToken);
  };

  _proto.peekDescription = function peekDescription() {
    return this.peek(_tokenKind.TokenKind.STRING) || this.peek(_tokenKind.TokenKind.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  ;

  _proto.parseDescription = function parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * SchemaDefinition : schema Directives[Const]? { OperationTypeDefinition+ }
   */
  ;

  _proto.parseSchemaDefinition = function parseSchemaDefinition() {
    var start = this._lexer.token;
    this.expectKeyword('schema');
    var directives = this.parseDirectives(true);
    var operationTypes = this.many(_tokenKind.TokenKind.BRACE_L, this.parseOperationTypeDefinition, _tokenKind.TokenKind.BRACE_R);
    return {
      kind: _kinds.Kind.SCHEMA_DEFINITION,
      directives: directives,
      operationTypes: operationTypes,
      loc: this.loc(start)
    };
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  ;

  _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
    var start = this._lexer.token;
    var operation = this.parseOperationType();
    this.expectToken(_tokenKind.TokenKind.COLON);
    var type = this.parseNamedType();
    return {
      kind: _kinds.Kind.OPERATION_TYPE_DEFINITION,
      operation: operation,
      type: type,
      loc: this.loc(start)
    };
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  ;

  _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('scalar');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: _kinds.Kind.SCALAR_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  ;

  _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('type');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: _kinds.Kind.OBJECT_TYPE_DEFINITION,
      description: description,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  ;

  _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
    var types = [];

    if (this.expectOptionalKeyword('implements')) {
      // Optional leading ampersand
      this.expectOptionalToken(_tokenKind.TokenKind.AMP);

      do {
        types.push(this.parseNamedType());
      } while (this.expectOptionalToken(_tokenKind.TokenKind.AMP) || // Legacy support for the SDL?
      this._options.allowLegacySDLImplementsInterfaces && this.peek(_tokenKind.TokenKind.NAME));
    }

    return types;
  }
  /**
   * FieldsDefinition : { FieldDefinition+ }
   */
  ;

  _proto.parseFieldsDefinition = function parseFieldsDefinition() {
    // Legacy support for the SDL?
    if (this._options.allowLegacySDLEmptyFields && this.peek(_tokenKind.TokenKind.BRACE_L) && this._lexer.lookahead().kind === _tokenKind.TokenKind.BRACE_R) {
      this._lexer.advance();

      this._lexer.advance();

      return [];
    }

    return this.optionalMany(_tokenKind.TokenKind.BRACE_L, this.parseFieldDefinition, _tokenKind.TokenKind.BRACE_R);
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  ;

  _proto.parseFieldDefinition = function parseFieldDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    this.expectToken(_tokenKind.TokenKind.COLON);
    var type = this.parseTypeReference();
    var directives = this.parseDirectives(true);
    return {
      kind: _kinds.Kind.FIELD_DEFINITION,
      description: description,
      name: name,
      arguments: args,
      type: type,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  ;

  _proto.parseArgumentDefs = function parseArgumentDefs() {
    return this.optionalMany(_tokenKind.TokenKind.PAREN_L, this.parseInputValueDef, _tokenKind.TokenKind.PAREN_R);
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  ;

  _proto.parseInputValueDef = function parseInputValueDef() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    this.expectToken(_tokenKind.TokenKind.COLON);
    var type = this.parseTypeReference();
    var defaultValue;

    if (this.expectOptionalToken(_tokenKind.TokenKind.EQUALS)) {
      defaultValue = this.parseValueLiteral(true);
    }

    var directives = this.parseDirectives(true);
    return {
      kind: _kinds.Kind.INPUT_VALUE_DEFINITION,
      description: description,
      name: name,
      type: type,
      defaultValue: defaultValue,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  ;

  _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('interface');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: _kinds.Kind.INTERFACE_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  ;

  _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('union');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();
    return {
      kind: _kinds.Kind.UNION_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      types: types,
      loc: this.loc(start)
    };
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  ;

  _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
    var types = [];

    if (this.expectOptionalToken(_tokenKind.TokenKind.EQUALS)) {
      // Optional leading pipe
      this.expectOptionalToken(_tokenKind.TokenKind.PIPE);

      do {
        types.push(this.parseNamedType());
      } while (this.expectOptionalToken(_tokenKind.TokenKind.PIPE));
    }

    return types;
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  ;

  _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('enum');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();
    return {
      kind: _kinds.Kind.ENUM_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      values: values,
      loc: this.loc(start)
    };
  }
  /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */
  ;

  _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
    return this.optionalMany(_tokenKind.TokenKind.BRACE_L, this.parseEnumValueDefinition, _tokenKind.TokenKind.BRACE_R);
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */
  ;

  _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: _kinds.Kind.ENUM_VALUE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  ;

  _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('input');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();
    return {
      kind: _kinds.Kind.INPUT_OBJECT_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */
  ;

  _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
    return this.optionalMany(_tokenKind.TokenKind.BRACE_L, this.parseInputValueDef, _tokenKind.TokenKind.BRACE_R);
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  ;

  _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
    var keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === _tokenKind.TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */
  ;

  _proto.parseSchemaExtension = function parseSchemaExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    var directives = this.parseDirectives(true);
    var operationTypes = this.optionalMany(_tokenKind.TokenKind.BRACE_L, this.parseOperationTypeDefinition, _tokenKind.TokenKind.BRACE_R);

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: _kinds.Kind.SCHEMA_EXTENSION,
      directives: directives,
      operationTypes: operationTypes,
      loc: this.loc(start)
    };
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  ;

  _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    var name = this.parseName();
    var directives = this.parseDirectives(true);

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: _kinds.Kind.SCALAR_TYPE_EXTENSION,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  ;

  _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();

    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: _kinds.Kind.OBJECT_TYPE_EXTENSION,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * InterfaceTypeExtension :
   *   - extend interface Name Directives[Const]? FieldsDefinition
   *   - extend interface Name Directives[Const]
   */
  ;

  _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: _kinds.Kind.INTERFACE_TYPE_EXTENSION,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  ;

  _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: _kinds.Kind.UNION_TYPE_EXTENSION,
      name: name,
      directives: directives,
      types: types,
      loc: this.loc(start)
    };
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  ;

  _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: _kinds.Kind.ENUM_TYPE_EXTENSION,
      name: name,
      directives: directives,
      values: values,
      loc: this.loc(start)
    };
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  ;

  _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: _kinds.Kind.INPUT_OBJECT_TYPE_EXTENSION,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */
  ;

  _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(_tokenKind.TokenKind.AT);
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    var repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    var locations = this.parseDirectiveLocations();
    return {
      kind: _kinds.Kind.DIRECTIVE_DEFINITION,
      description: description,
      name: name,
      arguments: args,
      repeatable: repeatable,
      locations: locations,
      loc: this.loc(start)
    };
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  ;

  _proto.parseDirectiveLocations = function parseDirectiveLocations() {
    // Optional leading pipe
    this.expectOptionalToken(_tokenKind.TokenKind.PIPE);
    var locations = [];

    do {
      locations.push(this.parseDirectiveLocation());
    } while (this.expectOptionalToken(_tokenKind.TokenKind.PIPE));

    return locations;
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  ;

  _proto.parseDirectiveLocation = function parseDirectiveLocation() {
    var start = this._lexer.token;
    var name = this.parseName();

    if (_directiveLocation.DirectiveLocation[name.value] !== undefined) {
      return name;
    }

    throw this.unexpected(start);
  } // Core parsing utility functions

  /**
   * Returns a location object, used to identify the place in
   * the source that created a given parsed object.
   */
  ;

  _proto.loc = function loc(startToken) {
    if (!this._options.noLocation) {
      return new Loc(startToken, this._lexer.lastToken, this._lexer.source);
    }
  }
  /**
   * Determines if the next token is of a given kind
   */
  ;

  _proto.peek = function peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing
   * the lexer. Otherwise, do not change the parser state and throw an error.
   */
  ;

  _proto.expectToken = function expectToken(kind) {
    var token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    throw (0, _syntaxError.syntaxError)(this._lexer.source, token.start, "Expected ".concat(kind, ", found ").concat(getTokenDesc(token)));
  }
  /**
   * If the next token is of the given kind, return that token after advancing
   * the lexer. Otherwise, do not change the parser state and return undefined.
   */
  ;

  _proto.expectOptionalToken = function expectOptionalToken(kind) {
    var token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    return undefined;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  ;

  _proto.expectKeyword = function expectKeyword(value) {
    var token = this._lexer.token;

    if (token.kind === _tokenKind.TokenKind.NAME && token.value === value) {
      this._lexer.advance();
    } else {
      throw (0, _syntaxError.syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat(getTokenDesc(token)));
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing
   * the lexer. Otherwise, do not change the parser state and return "false".
   */
  ;

  _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
    var token = this._lexer.token;

    if (token.kind === _tokenKind.TokenKind.NAME && token.value === value) {
      this._lexer.advance();

      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token
   * is encountered.
   */
  ;

  _proto.unexpected = function unexpected(atToken) {
    var token = atToken || this._lexer.token;
    return (0, _syntaxError.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat(getTokenDesc(token)));
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by
   * the parseFn. This list begins with a lex token of openKind
   * and ends with a lex token of closeKind. Advances the parser
   * to the next lex token after the closing token.
   */
  ;

  _proto.any = function any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always
   * return non-empty list that begins with a lex token of openKind and ends
   * with a lex token of closeKind. Advances the parser to the next lex token
   * after the closing token.
   */
  ;

  _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      var nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by
   * the parseFn. This list begins with a lex token of openKind
   * and ends with a lex token of closeKind. Advances the parser
   * to the next lex token after the closing token.
   */
  ;

  _proto.many = function many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  };

  return Parser;
}();

function Loc(startToken, endToken, source) {
  this.start = startToken.start;
  this.end = endToken.end;
  this.startToken = startToken;
  this.endToken = endToken;
  this.source = source;
} // Print a simplified form when appearing in JSON/util.inspect.


(0, _defineToJSON.default)(Loc, function () {
  return {
    start: this.start,
    end: this.end
  };
});
/**
 * A helper function to describe a token as a string for debugging
 */

function getTokenDesc(token) {
  var value = token.value;
  return value ? "".concat(token.kind, " \"").concat(value, "\"") : token.kind;
}


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GraphQLError = GraphQLError;
exports.printError = printError;

var _isObjectLike = _interopRequireDefault(__webpack_require__(464));

var _location = __webpack_require__(260);

var _printLocation = __webpack_require__(465);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function GraphQLError( // eslint-disable-line no-redeclare
message, nodes, source, positions, path, originalError, extensions) {
  // Compute list of blame nodes.
  var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : undefined : nodes ? [nodes] : undefined; // Compute locations in the source for the given nodes/positions.


  var _source = source;

  if (!_source && _nodes) {
    var node = _nodes[0];
    _source = node && node.loc && node.loc.source;
  }

  var _positions = positions;

  if (!_positions && _nodes) {
    _positions = _nodes.reduce(function (list, node) {
      if (node.loc) {
        list.push(node.loc.start);
      }

      return list;
    }, []);
  }

  if (_positions && _positions.length === 0) {
    _positions = undefined;
  }

  var _locations;

  if (positions && source) {
    _locations = positions.map(function (pos) {
      return (0, _location.getLocation)(source, pos);
    });
  } else if (_nodes) {
    _locations = _nodes.reduce(function (list, node) {
      if (node.loc) {
        list.push((0, _location.getLocation)(node.loc.source, node.loc.start));
      }

      return list;
    }, []);
  }

  var _extensions = extensions;

  if (_extensions == null && originalError != null) {
    var originalExtensions = originalError.extensions;

    if ((0, _isObjectLike.default)(originalExtensions)) {
      _extensions = originalExtensions;
    }
  }

  Object.defineProperties(this, {
    message: {
      value: message,
      // By being enumerable, JSON.stringify will include `message` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: true,
      writable: true
    },
    locations: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: _locations || undefined,
      // By being enumerable, JSON.stringify will include `locations` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: Boolean(_locations)
    },
    path: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: path || undefined,
      // By being enumerable, JSON.stringify will include `path` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: Boolean(path)
    },
    nodes: {
      value: _nodes || undefined
    },
    source: {
      value: _source || undefined
    },
    positions: {
      value: _positions || undefined
    },
    originalError: {
      value: originalError
    },
    extensions: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: _extensions || undefined,
      // By being enumerable, JSON.stringify will include `path` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: Boolean(_extensions)
    }
  }); // Include (non-enumerable) stack trace.

  if (originalError && originalError.stack) {
    Object.defineProperty(this, 'stack', {
      value: originalError.stack,
      writable: true,
      configurable: true
    });
  } else if (Error.captureStackTrace) {
    Error.captureStackTrace(this, GraphQLError);
  } else {
    Object.defineProperty(this, 'stack', {
      value: Error().stack,
      writable: true,
      configurable: true
    });
  }
}

GraphQLError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: GraphQLError
  },
  name: {
    value: 'GraphQLError'
  },
  toString: {
    value: function toString() {
      return printError(this);
    }
  }
});
/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */

function printError(error) {
  var output = error.message;

  if (error.nodes) {
    for (var _i2 = 0, _error$nodes2 = error.nodes; _i2 < _error$nodes2.length; _i2++) {
      var node = _error$nodes2[_i2];

      if (node.loc) {
        output += '\n\n' + (0, _printLocation.printLocation)(node.loc);
      }
    }
  } else if (error.source && error.locations) {
    for (var _i4 = 0, _error$locations2 = error.locations; _i4 < _error$locations2.length; _i4++) {
      var location = _error$locations2[_i4];
      output += '\n\n' + (0, _printLocation.printSourceLocation)(error.source, location);
    }
  }

  return output;
}


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isObjectLike;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return _typeof(value) == 'object' && value !== null;
}


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.printLocation = printLocation;
exports.printSourceLocation = printSourceLocation;

var _location = __webpack_require__(260);

/**
 * Render a helpful description of the location in the GraphQL Source document.
 */
function printLocation(location) {
  return printSourceLocation(location.source, (0, _location.getLocation)(location.source, location.start));
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */


function printSourceLocation(source, sourceLocation) {
  var firstLineColumnOffset = source.locationOffset.column - 1;
  var body = whitespace(firstLineColumnOffset) + source.body;
  var lineIndex = sourceLocation.line - 1;
  var lineOffset = source.locationOffset.line - 1;
  var lineNum = sourceLocation.line + lineOffset;
  var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  var columnNum = sourceLocation.column + columnOffset;
  var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
  var lines = body.split(/\r\n|[\n\r]/g);
  var locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    var sublineIndex = Math.floor(columnNum / 80);
    var sublineColumnNum = columnNum % 80;
    var sublines = [];

    for (var i = 0; i < locationLine.length; i += 80) {
      sublines.push(locationLine.slice(i, i + 80));
    }

    return locationStr + printPrefixedLines([["".concat(lineNum), sublines[0]]].concat(sublines.slice(1, sublineIndex + 1).map(function (subline) {
      return ['', subline];
    }), [[' ', whitespace(sublineColumnNum - 1) + '^'], ['', sublines[sublineIndex + 1]]]));
  }

  return locationStr + printPrefixedLines([// Lines specified like this: ["prefix", "string"],
  ["".concat(lineNum - 1), lines[lineIndex - 1]], ["".concat(lineNum), locationLine], ['', whitespace(columnNum - 1) + '^'], ["".concat(lineNum + 1), lines[lineIndex + 1]]]);
}

function printPrefixedLines(lines) {
  var existingLines = lines.filter(function (_ref) {
    var _ = _ref[0],
        line = _ref[1];
    return line !== undefined;
  });
  var padLen = Math.max.apply(Math, existingLines.map(function (_ref2) {
    var prefix = _ref2[0];
    return prefix.length;
  }));
  return existingLines.map(function (_ref3) {
    var prefix = _ref3[0],
        line = _ref3[1];
    return lpad(padLen, prefix) + (line ? ' | ' + line : ' |');
  }).join('\n');
}

function whitespace(len) {
  return Array(len + 1).join(' ');
}

function lpad(len, str) {
  return whitespace(len - str.length) + str;
}


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Kind = void 0;

/**
 * The set of allowed kind values for AST nodes.
 */
var Kind = Object.freeze({
  // Name
  NAME: 'Name',
  // Document
  DOCUMENT: 'Document',
  OPERATION_DEFINITION: 'OperationDefinition',
  VARIABLE_DEFINITION: 'VariableDefinition',
  SELECTION_SET: 'SelectionSet',
  FIELD: 'Field',
  ARGUMENT: 'Argument',
  // Fragments
  FRAGMENT_SPREAD: 'FragmentSpread',
  INLINE_FRAGMENT: 'InlineFragment',
  FRAGMENT_DEFINITION: 'FragmentDefinition',
  // Values
  VARIABLE: 'Variable',
  INT: 'IntValue',
  FLOAT: 'FloatValue',
  STRING: 'StringValue',
  BOOLEAN: 'BooleanValue',
  NULL: 'NullValue',
  ENUM: 'EnumValue',
  LIST: 'ListValue',
  OBJECT: 'ObjectValue',
  OBJECT_FIELD: 'ObjectField',
  // Directives
  DIRECTIVE: 'Directive',
  // Types
  NAMED_TYPE: 'NamedType',
  LIST_TYPE: 'ListType',
  NON_NULL_TYPE: 'NonNullType',
  // Type System Definitions
  SCHEMA_DEFINITION: 'SchemaDefinition',
  OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
  // Type Definitions
  SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
  OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
  FIELD_DEFINITION: 'FieldDefinition',
  INPUT_VALUE_DEFINITION: 'InputValueDefinition',
  INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
  UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
  ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
  ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
  INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
  // Directive Definitions
  DIRECTIVE_DEFINITION: 'DirectiveDefinition',
  // Type System Extensions
  SCHEMA_EXTENSION: 'SchemaExtension',
  // Type Extensions
  SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
  OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
  INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
  UNION_TYPE_EXTENSION: 'UnionTypeExtension',
  ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
  INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
});
/**
 * The enum type representing the possible kind values of AST nodes.
 */

exports.Kind = Kind;


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Source = void 0;

var _devAssert = _interopRequireDefault(__webpack_require__(257));

var _defineToStringTag = _interopRequireDefault(__webpack_require__(468));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A representation of source input to GraphQL.
 * `name` and `locationOffset` are optional. They are useful for clients who
 * store GraphQL documents in source files; for example, if the GraphQL input
 * starts at line 40 in a file named Foo.graphql, it might be useful for name to
 * be "Foo.graphql" and location to be `{ line: 40, column: 0 }`.
 * line and column in locationOffset are 1-indexed
 */
var Source = function Source(body, name, locationOffset) {
  this.body = body;
  this.name = name || 'GraphQL request';
  this.locationOffset = locationOffset || {
    line: 1,
    column: 1
  };
  this.locationOffset.line > 0 || (0, _devAssert.default)(0, 'line in locationOffset is 1-indexed and must be positive');
  this.locationOffset.column > 0 || (0, _devAssert.default)(0, 'column in locationOffset is 1-indexed and must be positive');
}; // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported


exports.Source = Source;
(0, _defineToStringTag.default)(Source);


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defineToStringTag;

/**
 * The `defineToStringTag()` function checks first to see if the runtime
 * supports the `Symbol` class and then if the `Symbol.toStringTag` constant
 * is defined as a `Symbol` instance. If both conditions are met, the
 * Symbol.toStringTag property is defined as a getter that returns the
 * supplied class constructor's name.
 *
 * @method defineToStringTag
 *
 * @param {Class<any>} classObject a class such as Object, String, Number but
 * typically one of your own creation through the class keyword; `class A {}`,
 * for example.
 */
function defineToStringTag(classObject) {
  if (typeof Symbol === 'function' && Symbol.toStringTag) {
    Object.defineProperty(classObject.prototype, Symbol.toStringTag, {
      get: function get() {
        return this.constructor.name;
      }
    });
  }
}


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLexer = createLexer;
exports.isPunctuatorToken = isPunctuatorToken;

var _defineToJSON = _interopRequireDefault(__webpack_require__(258));

var _syntaxError = __webpack_require__(259);

var _blockString = __webpack_require__(261);

var _tokenKind = __webpack_require__(262);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Given a Source object, this returns a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */
function createLexer(source, options) {
  var startOfFileToken = new Tok(_tokenKind.TokenKind.SOF, 0, 0, 0, 0, null);
  var lexer = {
    source: source,
    options: options,
    lastToken: startOfFileToken,
    token: startOfFileToken,
    line: 1,
    lineStart: 0,
    advance: advanceLexer,
    lookahead: lookahead
  };
  return lexer;
}

function advanceLexer() {
  this.lastToken = this.token;
  var token = this.token = this.lookahead();
  return token;
}

function lookahead() {
  var token = this.token;

  if (token.kind !== _tokenKind.TokenKind.EOF) {
    do {
      // Note: next is only mutable during parsing, so we cast to allow this.
      token = token.next || (token.next = readToken(this, token));
    } while (token.kind === _tokenKind.TokenKind.COMMENT);
  }

  return token;
}
/**
 * The return type of createLexer.
 */


// @internal
function isPunctuatorToken(token) {
  var kind = token.kind;
  return kind === _tokenKind.TokenKind.BANG || kind === _tokenKind.TokenKind.DOLLAR || kind === _tokenKind.TokenKind.AMP || kind === _tokenKind.TokenKind.PAREN_L || kind === _tokenKind.TokenKind.PAREN_R || kind === _tokenKind.TokenKind.SPREAD || kind === _tokenKind.TokenKind.COLON || kind === _tokenKind.TokenKind.EQUALS || kind === _tokenKind.TokenKind.AT || kind === _tokenKind.TokenKind.BRACKET_L || kind === _tokenKind.TokenKind.BRACKET_R || kind === _tokenKind.TokenKind.BRACE_L || kind === _tokenKind.TokenKind.PIPE || kind === _tokenKind.TokenKind.BRACE_R;
}
/**
 * Helper function for constructing the Token object.
 */


function Tok(kind, start, end, line, column, prev, value) {
  this.kind = kind;
  this.start = start;
  this.end = end;
  this.line = line;
  this.column = column;
  this.value = value;
  this.prev = prev;
  this.next = null;
} // Print a simplified form when appearing in JSON/util.inspect.


(0, _defineToJSON.default)(Tok, function () {
  return {
    kind: this.kind,
    value: this.value,
    line: this.line,
    column: this.column
  };
});

function printCharCode(code) {
  return (// NaN/undefined represents access beyond the end of the file.
    isNaN(code) ? _tokenKind.TokenKind.EOF : // Trust JSON for ASCII.
    code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : // Otherwise print the escaped form.
    "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"")
  );
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */


function readToken(lexer, prev) {
  var source = lexer.source;
  var body = source.body;
  var bodyLength = body.length;
  var pos = positionAfterWhitespace(body, prev.end, lexer);
  var line = lexer.line;
  var col = 1 + pos - lexer.lineStart;

  if (pos >= bodyLength) {
    return new Tok(_tokenKind.TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
  }

  var code = body.charCodeAt(pos); // SourceCharacter

  switch (code) {
    // !
    case 33:
      return new Tok(_tokenKind.TokenKind.BANG, pos, pos + 1, line, col, prev);
    // #

    case 35:
      return readComment(source, pos, line, col, prev);
    // $

    case 36:
      return new Tok(_tokenKind.TokenKind.DOLLAR, pos, pos + 1, line, col, prev);
    // &

    case 38:
      return new Tok(_tokenKind.TokenKind.AMP, pos, pos + 1, line, col, prev);
    // (

    case 40:
      return new Tok(_tokenKind.TokenKind.PAREN_L, pos, pos + 1, line, col, prev);
    // )

    case 41:
      return new Tok(_tokenKind.TokenKind.PAREN_R, pos, pos + 1, line, col, prev);
    // .

    case 46:
      if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) {
        return new Tok(_tokenKind.TokenKind.SPREAD, pos, pos + 3, line, col, prev);
      }

      break;
    // :

    case 58:
      return new Tok(_tokenKind.TokenKind.COLON, pos, pos + 1, line, col, prev);
    // =

    case 61:
      return new Tok(_tokenKind.TokenKind.EQUALS, pos, pos + 1, line, col, prev);
    // @

    case 64:
      return new Tok(_tokenKind.TokenKind.AT, pos, pos + 1, line, col, prev);
    // [

    case 91:
      return new Tok(_tokenKind.TokenKind.BRACKET_L, pos, pos + 1, line, col, prev);
    // ]

    case 93:
      return new Tok(_tokenKind.TokenKind.BRACKET_R, pos, pos + 1, line, col, prev);
    // {

    case 123:
      return new Tok(_tokenKind.TokenKind.BRACE_L, pos, pos + 1, line, col, prev);
    // |

    case 124:
      return new Tok(_tokenKind.TokenKind.PIPE, pos, pos + 1, line, col, prev);
    // }

    case 125:
      return new Tok(_tokenKind.TokenKind.BRACE_R, pos, pos + 1, line, col, prev);
    // A-Z _ a-z

    case 65:
    case 66:
    case 67:
    case 68:
    case 69:
    case 70:
    case 71:
    case 72:
    case 73:
    case 74:
    case 75:
    case 76:
    case 77:
    case 78:
    case 79:
    case 80:
    case 81:
    case 82:
    case 83:
    case 84:
    case 85:
    case 86:
    case 87:
    case 88:
    case 89:
    case 90:
    case 95:
    case 97:
    case 98:
    case 99:
    case 100:
    case 101:
    case 102:
    case 103:
    case 104:
    case 105:
    case 106:
    case 107:
    case 108:
    case 109:
    case 110:
    case 111:
    case 112:
    case 113:
    case 114:
    case 115:
    case 116:
    case 117:
    case 118:
    case 119:
    case 120:
    case 121:
    case 122:
      return readName(source, pos, line, col, prev);
    // - 0-9

    case 45:
    case 48:
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57:
      return readNumber(source, pos, code, line, col, prev);
    // "

    case 34:
      if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) {
        return readBlockString(source, pos, line, col, prev, lexer);
      }

      return readString(source, pos, line, col, prev);
  }

  throw (0, _syntaxError.syntaxError)(source, pos, unexpectedCharacterMessage(code));
}
/**
 * Report a message that an unexpected character was encountered.
 */


function unexpectedCharacterMessage(code) {
  if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
    return "Cannot contain the invalid character ".concat(printCharCode(code), ".");
  }

  if (code === 39) {
    // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
  }

  return "Cannot parse the unexpected character ".concat(printCharCode(code), ".");
}
/**
 * Reads from body starting at startPosition until it finds a non-whitespace
 * character, then returns the position of that character for lexing.
 */


function positionAfterWhitespace(body, startPosition, lexer) {
  var bodyLength = body.length;
  var position = startPosition;

  while (position < bodyLength) {
    var code = body.charCodeAt(position); // tab | space | comma | BOM

    if (code === 9 || code === 32 || code === 44 || code === 0xfeff) {
      ++position;
    } else if (code === 10) {
      // new line
      ++position;
      ++lexer.line;
      lexer.lineStart = position;
    } else if (code === 13) {
      // carriage return
      if (body.charCodeAt(position + 1) === 10) {
        position += 2;
      } else {
        ++position;
      }

      ++lexer.line;
      lexer.lineStart = position;
    } else {
      break;
    }
  }

  return position;
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */


function readComment(source, start, line, col, prev) {
  var body = source.body;
  var code;
  var position = start;

  do {
    code = body.charCodeAt(++position);
  } while (!isNaN(code) && ( // SourceCharacter but not LineTerminator
  code > 0x001f || code === 0x0009));

  return new Tok(_tokenKind.TokenKind.COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */


function readNumber(source, start, firstCode, line, col, prev) {
  var body = source.body;
  var code = firstCode;
  var position = start;
  var isFloat = false;

  if (code === 45) {
    // -
    code = body.charCodeAt(++position);
  }

  if (code === 48) {
    // 0
    code = body.charCodeAt(++position);

    if (code >= 48 && code <= 57) {
      throw (0, _syntaxError.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat(printCharCode(code), "."));
    }
  } else {
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }

  if (code === 46) {
    // .
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }

  if (code === 69 || code === 101) {
    // E e
    isFloat = true;
    code = body.charCodeAt(++position);

    if (code === 43 || code === 45) {
      // + -
      code = body.charCodeAt(++position);
    }

    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or e


  if (code === 46 || code === 69 || code === 101) {
    throw (0, _syntaxError.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
  }

  return new Tok(isFloat ? _tokenKind.TokenKind.FLOAT : _tokenKind.TokenKind.INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */


function readDigits(source, start, firstCode) {
  var body = source.body;
  var position = start;
  var code = firstCode;

  if (code >= 48 && code <= 57) {
    // 0 - 9
    do {
      code = body.charCodeAt(++position);
    } while (code >= 48 && code <= 57); // 0 - 9


    return position;
  }

  throw (0, _syntaxError.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */


function readString(source, start, line, col, prev) {
  var body = source.body;
  var position = start + 1;
  var chunkStart = position;
  var code = 0;
  var value = '';

  while (position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
  code !== 0x000a && code !== 0x000d) {
    // Closing Quote (")
    if (code === 34) {
      value += body.slice(chunkStart, position);
      return new Tok(_tokenKind.TokenKind.STRING, start, position + 1, line, col, prev, value);
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009) {
      throw (0, _syntaxError.syntaxError)(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    ++position;

    if (code === 92) {
      // \
      value += body.slice(chunkStart, position - 1);
      code = body.charCodeAt(position);

      switch (code) {
        case 34:
          value += '"';
          break;

        case 47:
          value += '/';
          break;

        case 92:
          value += '\\';
          break;

        case 98:
          value += '\b';
          break;

        case 102:
          value += '\f';
          break;

        case 110:
          value += '\n';
          break;

        case 114:
          value += '\r';
          break;

        case 116:
          value += '\t';
          break;

        case 117:
          {
            // uXXXX
            var charCode = uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));

            if (charCode < 0) {
              var invalidSequence = body.slice(position + 1, position + 5);
              throw (0, _syntaxError.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
            }

            value += String.fromCharCode(charCode);
            position += 4;
            break;
          }

        default:
          throw (0, _syntaxError.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
      }

      ++position;
      chunkStart = position;
    }
  }

  throw (0, _syntaxError.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */


function readBlockString(source, start, line, col, prev, lexer) {
  var body = source.body;
  var position = start + 3;
  var chunkStart = position;
  var code = 0;
  var rawValue = '';

  while (position < body.length && !isNaN(code = body.charCodeAt(position))) {
    // Closing Triple-Quote (""")
    if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
      rawValue += body.slice(chunkStart, position);
      return new Tok(_tokenKind.TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, (0, _blockString.dedentBlockStringValue)(rawValue));
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
      throw (0, _syntaxError.syntaxError)(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    if (code === 10) {
      // new line
      ++position;
      ++lexer.line;
      lexer.lineStart = position;
    } else if (code === 13) {
      // carriage return
      if (body.charCodeAt(position + 1) === 10) {
        position += 2;
      } else {
        ++position;
      }

      ++lexer.line;
      lexer.lineStart = position;
    } else if ( // Escape Triple-Quote (\""")
    code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
      rawValue += body.slice(chunkStart, position) + '"""';
      position += 4;
      chunkStart = position;
    } else {
      ++position;
    }
  }

  throw (0, _syntaxError.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */


function uniCharCode(a, b, c, d) {
  return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */


function char2hex(a) {
  return a >= 48 && a <= 57 ? a - 48 // 0-9
  : a >= 65 && a <= 70 ? a - 55 // A-F
  : a >= 97 && a <= 102 ? a - 87 // a-f
  : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */


function readName(source, start, line, col, prev) {
  var body = source.body;
  var bodyLength = body.length;
  var position = start + 1;
  var code = 0;

  while (position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
  code >= 48 && code <= 57 || // 0-9
  code >= 65 && code <= 90 || // A-Z
  code >= 97 && code <= 122) // a-z
  ) {
    ++position;
  }

  return new Tok(_tokenKind.TokenKind.NAME, start, position, line, col, prev, body.slice(start, position));
}


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DirectiveLocation = void 0;

/**
 * The set of allowed directive location values.
 */
var DirectiveLocation = Object.freeze({
  // Request Definitions
  QUERY: 'QUERY',
  MUTATION: 'MUTATION',
  SUBSCRIPTION: 'SUBSCRIPTION',
  FIELD: 'FIELD',
  FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
  FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
  INLINE_FRAGMENT: 'INLINE_FRAGMENT',
  VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
  // Type System Definitions
  SCHEMA: 'SCHEMA',
  SCALAR: 'SCALAR',
  OBJECT: 'OBJECT',
  FIELD_DEFINITION: 'FIELD_DEFINITION',
  ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
  INTERFACE: 'INTERFACE',
  UNION: 'UNION',
  ENUM: 'ENUM',
  ENUM_VALUE: 'ENUM_VALUE',
  INPUT_OBJECT: 'INPUT_OBJECT',
  INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
});
/**
 * The enum type representing the directive location values.
 */

exports.DirectiveLocation = DirectiveLocation;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAccountFeatureFlags = fetchAccountFeatureFlags;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _proxy = __webpack_require__(21);

var c = _interopRequireWildcard(__webpack_require__(3));

var _browserUtils = __webpack_require__(44);

var _httpUtils = __webpack_require__(127);

var _auth = __webpack_require__(31);

function fetchAccountFeatureFlags() {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch, getState) {
        var state, platform, version, groupUUID, queryParams, queryString, rawResponse, parsedResponse, body, statusCode;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // initialize feature flags with group and extension for future checks
                state = getState();
                platform = (0, _auth.getPlatform)(state);
                version = (0, _safeAccess.default)(state, 'nucleus.auth.version'); // NOTE: groupUUID is passed to this service specifically for taking care of guest users
                // where we are currently setting the groupUUID they are calling via the callme page
                // and passing it into CNUC. eventually this should be handled via the login JWT
                //  and Nucleus Proxy directly

                groupUUID = (0, _safeAccess.default)(state, 'nucleus.userProfile.groupUuid');
                queryParams = {
                  platform: platform,
                  version: version,
                  groupUUID: groupUUID
                };

                if (platform === c.PLATFORM_WEB) {
                  queryParams.browser = (0, _browserUtils.isIE11)() ? 'IE11' : 'CHROME';
                }

                queryString = "feature_flags".concat((0, _httpUtils.objectToUrlParameters)(queryParams));
                _context.prev = 7;
                _context.next = 10;
                return dispatch((0, _proxy.proxyApiCall)('lifesize.featureFlags.v2', queryString, 'GET'));

              case 10:
                rawResponse = _context.sent;
                parsedResponse = rawResponse ? JSON.parse(rawResponse) : {};
                body = parsedResponse.body, statusCode = parsedResponse.statusCode;

                if (!(statusCode && statusCode !== 200)) {
                  _context.next = 15;
                  break;
                }

                throw parsedResponse;

              case 15:
                dispatch({
                  type: c.SET_FEATURE_FLAGS,
                  payload: body
                });
                _context.next = 23;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](7);

                _jsLogger.default.warn('Unable to retrieve feature flags.', _context.t0);

                dispatch({
                  type: c.GET_ACCOUNT_FEATURE_FLAGS_FAILURE,
                  payload: _context.t0
                });
                throw _context.t0;

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[7, 18]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var baseOrderBy = __webpack_require__(473),
    isArray = __webpack_require__(43);

/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */
function orderBy(collection, iteratees, orders, guard) {
  if (collection == null) {
    return [];
  }
  if (!isArray(iteratees)) {
    iteratees = iteratees == null ? [] : [iteratees];
  }
  orders = guard ? undefined : orders;
  if (!isArray(orders)) {
    orders = orders == null ? [] : [orders];
  }
  return baseOrderBy(collection, iteratees, orders);
}

module.exports = orderBy;


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(211),
    baseIteratee = __webpack_require__(90),
    baseMap = __webpack_require__(474),
    baseSortBy = __webpack_require__(475),
    baseUnary = __webpack_require__(141),
    compareMultiple = __webpack_require__(476),
    identity = __webpack_require__(177);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(240),
    isArrayLike = __webpack_require__(104);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 475 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(477);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(120);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markLastReadAt = exports.getMessages = exports.roomsForCurrentUser = exports.leaveRoom = exports.postMessage = exports.joinRoom = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(81));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var c = _interopRequireWildcard(__webpack_require__(3));

var _joinRoom = _interopRequireDefault(__webpack_require__(479));

var _leaveRoom = _interopRequireDefault(__webpack_require__(480));

var _postMessage = _interopRequireDefault(__webpack_require__(481));

var _roomsForCurrentUser = _interopRequireDefault(__webpack_require__(482));

var _getMessages = _interopRequireDefault(__webpack_require__(483));

var _markLastRead = _interopRequireDefault(__webpack_require__(484));

var joinRoom = function joinRoom(uuid) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch) {
        var _response$data;

        var _ref2, _ref3, response;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return dispatch({
                  type: c.GQL_MUTATION,
                  payload: {
                    mutation: _joinRoom.default,
                    variables: {
                      uuid: uuid
                    }
                  }
                });

              case 2:
                _ref2 = _context.sent;
                _ref3 = (0, _slicedToArray2.default)(_ref2, 1);
                response = _ref3[0];
                return _context.abrupt("return", response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.joinRoom);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

exports.joinRoom = joinRoom;

var postMessage = function postMessage(roomUUID, optimisticUUID, message) {
  return (
    /*#__PURE__*/
    function () {
      var _ref4 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch) {
        var _response$data2;

        var _ref5, _ref6, response;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return dispatch({
                  type: c.GQL_MUTATION,
                  payload: {
                    mutation: _postMessage.default,
                    variables: {
                      roomUUID: roomUUID,
                      optimisticUUID: optimisticUUID,
                      message: message
                    }
                  }
                });

              case 2:
                _ref5 = _context2.sent;
                _ref6 = (0, _slicedToArray2.default)(_ref5, 1);
                response = _ref6[0];
                return _context2.abrupt("return", response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.postMessage);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }()
  );
};

exports.postMessage = postMessage;

var leaveRoom = function leaveRoom(uuid) {
  return (
    /*#__PURE__*/
    function () {
      var _ref7 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(dispatch) {
        var _ref8, _ref9, response;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return dispatch({
                  type: c.GQL_MUTATION,
                  payload: {
                    mutation: _leaveRoom.default,
                    variables: {
                      uuid: uuid
                    }
                  }
                });

              case 2:
                _ref8 = _context3.sent;
                _ref9 = (0, _slicedToArray2.default)(_ref8, 1);
                response = _ref9[0];
                return _context3.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3) {
        return _ref7.apply(this, arguments);
      };
    }()
  );
};

exports.leaveRoom = leaveRoom;

var roomsForCurrentUser = function roomsForCurrentUser() {
  return (
    /*#__PURE__*/
    function () {
      var _ref10 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(dispatch) {
        var _response$data3;

        var _ref11, _ref12, response;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return dispatch({
                  type: c.GQL_QUERY,
                  payload: {
                    query: _roomsForCurrentUser.default,
                    fetchPolicy: 'network-only'
                  }
                });

              case 2:
                _ref11 = _context4.sent;
                _ref12 = (0, _slicedToArray2.default)(_ref11, 1);
                response = _ref12[0];
                return _context4.abrupt("return", response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.roomsForCurrentUser);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x4) {
        return _ref10.apply(this, arguments);
      };
    }()
  );
};

exports.roomsForCurrentUser = roomsForCurrentUser;

var getMessages = function getMessages(uuid) {
  var cursor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return (
    /*#__PURE__*/
    function () {
      var _ref13 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(dispatch) {
        var _response$data4;

        var variables, _ref14, _ref15, response;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                variables = {
                  uuid: uuid
                };

                if (cursor) {
                  variables.cursor = cursor;
                }

                _context5.next = 4;
                return dispatch({
                  type: c.GQL_QUERY,
                  payload: {
                    query: _getMessages.default,
                    variables: variables,
                    fetchPolicy: 'no-cache'
                  }
                });

              case 4:
                _ref14 = _context5.sent;
                _ref15 = (0, _slicedToArray2.default)(_ref14, 1);
                response = _ref15[0];
                return _context5.abrupt("return", response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.getMessages);

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x5) {
        return _ref13.apply(this, arguments);
      };
    }()
  );
};

exports.getMessages = getMessages;

var markLastReadAt = function markLastReadAt(uuid, lastReadAt) {
  return (
    /*#__PURE__*/
    function () {
      var _ref16 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(dispatch) {
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return dispatch({
                  type: c.GQL_MUTATION,
                  payload: {
                    mutation: _markLastRead.default,
                    variables: {
                      uuid: uuid,
                      lastReadAt: lastReadAt
                    }
                  }
                });

              case 2:
                return _context6.abrupt("return", lastReadAt);

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x6) {
        return _ref16.apply(this, arguments);
      };
    }()
  );
};

exports.markLastReadAt = markLastReadAt;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"joinRoom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"joinRoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallableFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"isMeeting"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"meeting"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallableFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MeetingFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"lastReadAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastUpdated"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":359}};
    doc.loc.source = {"body":"#import \"../directory/callable-fragments.gql\"\n#import \"../directory/meeting-fragments.gql\"\n\nmutation joinRoom($uuid:String!) {\n  joinRoom(uuid:$uuid) {\n    uuid\n    members {\n      ...IdFields\n      ...CallableFields\n    }\n    isMeeting\n    meeting {\n      ...IdFields\n      ...CallableFields\n      ...MeetingFields\n    }\n    lastReadAt\n    lastUpdated\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(38).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(54).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["joinRoom"] = oneQuery(doc, "joinRoom");
        


/***/ }),
/* 480 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"leaveRoom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leaveRoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}],"directives":[]}]}}],"loc":{"start":0,"end":62}};
    doc.loc.source = {"body":"mutation leaveRoom($uuid:String!) {\n  leaveRoom(uuid:$uuid)\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["leaveRoom"] = oneQuery(doc, "leaveRoom");
        


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"postMessageMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomUUID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"optimisticUUID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"roomUUID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomUUID"}}},{"kind":"Argument","name":{"kind":"Name","value":"optimisticUUID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"optimisticUUID"}}},{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"roomUUID"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sender"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallableFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":342}};
    doc.loc.source = {"body":"#import \"../directory/callable-fragments.gql\"\n\nmutation postMessageMutation ($roomUUID:String!, $optimisticUUID:String!, $message:String!) {\n  postMessage(roomUUID:$roomUUID, optimisticUUID:$optimisticUUID, message:$message) {\n    uuid\n    roomUUID\n    sender {\n      ...IdFields\n      ...CallableFields\n    }\n    createdAt\n    message\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(38).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["postMessageMutation"] = oneQuery(doc, "postMessageMutation");
        


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"roomsForCurrentUser"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roomsForCurrentUser"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallableFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"isMeeting"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"meeting"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallableFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MeetingFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"lastReadAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastUpdated"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":351}};
    doc.loc.source = {"body":"#import \"../directory/callable-fragments.gql\"\n#import \"../directory/meeting-fragments.gql\"\n\nquery roomsForCurrentUser {\n  roomsForCurrentUser {\n    uuid\n    members {\n      ...IdFields\n      ...CallableFields\n    }\n    isMeeting\n    meeting {\n      ...IdFields\n      ...CallableFields\n      ...MeetingFields\n    }\n    lastReadAt\n    lastUpdated\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(38).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(54).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["roomsForCurrentUser"] = oneQuery(doc, "roomsForCurrentUser");
        


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMessages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"messages"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"roomUUID"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sender"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallableFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":306}};
    doc.loc.source = {"body":"#import \"../directory/callable-fragments.gql\"\n\nquery getMessages($uuid:String!, $cursor:String) {\n  getMessages(uuid:$uuid, cursor:$cursor) {\n    cursor,\n    messages {\n      uuid\n      roomUUID\n      sender {\n        ...IdFields\n        ...CallableFields\n      }\n      createdAt\n      message\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(38).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getMessages"] = oneQuery(doc, "getMessages");
        


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"markLastReadAtMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastReadAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markLastReadAt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastReadAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastReadAt"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallableFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"isMeeting"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"meeting"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallableFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MeetingFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"lastReadAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastUpdated"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":423}};
    doc.loc.source = {"body":"#import \"../directory/callable-fragments.gql\"\n#import \"../directory/meeting-fragments.gql\"\n\nmutation markLastReadAtMutation($uuid:String!, $lastReadAt:String) {\n  markLastReadAt(uuid:$uuid, lastReadAt:$lastReadAt) {\n    uuid\n    members {\n      ...IdFields\n      ...CallableFields\n    }\n    isMeeting\n    meeting {\n      ...IdFields\n      ...CallableFields\n      ...MeetingFields\n    }\n    lastReadAt\n    lastUpdated\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(38).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(54).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["markLastReadAtMutation"] = oneQuery(doc, "markLastReadAtMutation");
        


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(34));

var _createClass2 = _interopRequireDefault(__webpack_require__(36));

var c = _interopRequireWildcard(__webpack_require__(3));

/**
 * Validation for string validation
 *
 * Usage for a single field:
 * let v = new Validator(data).max(10).required();
 * v.errors = [] OR [{errorObj}...]
 * v.value = data
 *
 * Usage for validating an object:
 * let draft = {
 *  name: 'Sally',
 *  sipUri: '333'
 * }
 * let schema = {
 *  name: new Validator(draft.name).max(10).invalid(['Bob', 'John']).required(),
 *  sipUri: new Validator(draft.sipUri).max(10).invalid(['12345678', '111111111']).regex(/^[0-9]*$/).required()
 * }
 * let result = new Validation().validate(schema);
 * result.errors = null OR [{errorObj}...]
 * result.obj = draft
 *
 * Error Object looks like:
 * {
 *  type: String (type of error)
 *  context: {
 *    value: value being tested
 *    key: object key (if validating object)
 *    additional validation rule parameters
 *  }
 * }
 *
 * Example string length failure
 * {
 *  type: 'VALIDATE_MAXLENGTH',
 *  context: {
 *    value: '1234',
 *    key: 'extension',
 *    limit: 2
 *  }
 * }
 */
var Validation =
/*#__PURE__*/
function () {
  function Validation(value) {
    (0, _classCallCheck2.default)(this, Validation);
    this.value = value;
    this.errors = [];
  }

  (0, _createClass2.default)(Validation, [{
    key: "validate",
    value: function validate(schema) {
      var obj = {};
      var keys = Object.keys(schema);
      var len = keys.length;

      for (var i = 0; i < len; i++) {
        obj[keys[i]] = schema[keys[i]].value;

        if (schema[keys[i]].errors.length) {
          for (var x = 0; x < schema[keys[i]].errors.length; x++) {
            var context = Object.assign({}, schema[keys[i]].errors[x].context, {
              key: keys[i]
            });
            var error = Object.assign({}, schema[keys[i]].errors[x], {
              context: context
            });
            this.errors.push(error);
          }
        }
      }

      return {
        obj: obj,
        errors: this.errors
      };
    }
  }, {
    key: "required",
    value: function required() {
      if (this.value === '' || this.value === undefined || this.value === null) {
        this.errors.push({
          type: c.VALIDATE_REQUIRED,
          context: {
            value: this.value
          }
        });
      }

      return this;
    }
  }, {
    key: "duplicate",
    value: function duplicate(duplicates) {
      // Escape user input that is to be treated as a literal string within a regular expression
      // developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
      var escapeRegExp = function escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
      };

      if (this.value) {
        var regex = new RegExp('^' + escapeRegExp(this.value) + '$', 'i');

        if (duplicates.some(function (d) {
          return regex.test(d);
        })) {
          this.errors.push({
            type: c.VALIDATE_DUPLICATE,
            context: {
              value: this.value
            }
          });
        }
      }

      return this;
    }
  }, {
    key: "maxLength",
    value: function maxLength(limit) {
      if (this.value && this.value.length > limit) {
        this.errors.push({
          type: c.VALIDATE_MAXLENGTH,
          context: {
            value: this.value,
            limit: limit
          }
        });
      }

      return this;
    }
  }, {
    key: "minLength",
    value: function minLength(limit) {
      if (this.value && this.value.length < limit) {
        this.errors.push({
          type: c.VALIDATE_MINLENGTH,
          context: {
            value: this.value,
            limit: limit
          }
        });
      }

      return this;
    }
  }, {
    key: "pattern",
    value: function pattern(_pattern) {
      if (this.value && _pattern.test(this.value) === false) {
        this.errors.push({
          type: c.VALIDATE_PATTERN,
          context: {
            value: this.value,
            pattern: _pattern
          }
        });
      }

      return this;
    }
  }]);
  return Validation;
}();

var _default = Validation;
exports.default = _default;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBaseParams = exports.getCreateMeetingParams = exports.removeFromFavorites = exports.addToFavorites = exports.deleteMeeting = exports.updateMeeting = exports.createMeeting = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _get = _interopRequireDefault(__webpack_require__(11));

var _proxy = __webpack_require__(21);

var _favorite = __webpack_require__(146);

var C = _interopRequireWildcard(__webpack_require__(3));

var createMeeting = function createMeeting(params) {
  return function (dispatch) {
    var apiCall = (0, _proxy.proxyApiCall)(C.MEETING_HANDLER_ENDPOINT, "meeting/create", C.HTTP_POST, params);
    return dispatch(apiCall);
  };
};

exports.createMeeting = createMeeting;

var updateMeeting = function updateMeeting(params) {
  return function (dispatch) {
    var apiCall = (0, _proxy.proxyApiCall)(C.MEETING_HANDLER_ENDPOINT, "meeting/update", C.HTTP_PUT, params);
    return dispatch(apiCall);
  };
};

exports.updateMeeting = updateMeeting;

var deleteMeeting = function deleteMeeting(uuid) {
  return function (dispatch) {
    var params = {
      uuid: uuid
    };
    var apiCall = (0, _proxy.proxyApiCall)(C.MEETING_HANDLER_ENDPOINT, 'meeting/delete', C.HTTP_DELETE, params);
    return dispatch(apiCall);
  };
};

exports.deleteMeeting = deleteMeeting;

var addToFavorites = function addToFavorites(uuid) {
  return function (dispatch) {
    return dispatch((0, _favorite.addFavorite)('MEETING', uuid));
  };
};

exports.addToFavorites = addToFavorites;

var removeFromFavorites = function removeFromFavorites(uuid) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", dispatch((0, _favorite.deleteFavorite)(uuid)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

exports.removeFromFavorites = removeFromFavorites;

var getCreateMeetingParams = function getCreateMeetingParams(meeting, owner) {
  var baseParams = getBaseParams(meeting, owner);
  var tempMeeting = (0, _get.default)(meeting, 'meetingType') === C.MEETING_TYPE_ONE_TIME;
  var hiddenMeeting = (0, _get.default)(meeting, 'meetingType') === C.MEETING_TYPE_ONE_TIME;
  var params = (0, _objectSpread2.default)({}, baseParams, {
    tempMeeting: tempMeeting,
    hiddenMeeting: hiddenMeeting
  });
  return params;
};

exports.getCreateMeetingParams = getCreateMeetingParams;

var getBaseParams = function getBaseParams(meeting, owner) {
  var pin = (0, _get.default)(meeting, 'pin', undefined);
  var moderatorExtension = (0, _get.default)(meeting, 'moderatorExtension', undefined);
  var lecturerExtension = (0, _get.default)(meeting, 'lecturerExtension', undefined);
  var params = {
    uuid: meeting.uuid,
    displayName: meeting.name,
    description: meeting.description,
    ownerExtension: owner.dialString,
    moderatorExtension: moderatorExtension,
    lecturerExtension: lecturerExtension,
    pin: pin
  };
  return params;
};

exports.getBaseParams = getBaseParams;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setFavorite = exports.deleteExternalContact = exports.saveExternalContact = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var c = _interopRequireWildcard(__webpack_require__(3));

var _favorite = __webpack_require__(146);

var _groupContactsApi = __webpack_require__(488);

var _personalContactsApi = __webpack_require__(489);

var saveExternalContact = function saveExternalContact(externalContact) {
  return function (dispatch) {
    var contactToSave = (0, _objectSpread2.default)({}, externalContact, {
      displayName: externalContact.name,
      dialString: externalContact.sipUri
    });

    if (contactToSave.contactType === c.CONTACT_TYPE_GROUP_CONTACT) {
      return dispatch((0, _groupContactsApi.saveGroupContact)(contactToSave));
    }

    return dispatch((0, _personalContactsApi.savePersonalContact)(contactToSave));
  };
};

exports.saveExternalContact = saveExternalContact;

var deleteExternalContact = function deleteExternalContact(contact) {
  return function (dispatch) {
    if (contact.contactType === c.CONTACT_TYPE_GROUP_CONTACT) {
      return dispatch((0, _groupContactsApi.deleteGroupContact)(contact.uuid));
    }

    return dispatch((0, _personalContactsApi.deletePersonalContact)(contact.uuid));
  };
};

exports.deleteExternalContact = deleteExternalContact;

var setFavorite = function setFavorite(uuid, favorite) {
  return function (dispatch) {
    if (favorite) {
      return dispatch((0, _favorite.addFavorite)('CONTACT', uuid));
    }

    return dispatch((0, _favorite.deleteFavorite)(uuid));
  };
};

exports.setFavorite = setFavorite;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveGroupContact = saveGroupContact;
exports.deleteGroupContact = deleteGroupContact;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var c = _interopRequireWildcard(__webpack_require__(3));

var _proxy = __webpack_require__(21);

/**
 * Group Contacts - Save
 * Saves the group contact using either the create or update interface
 * @param {object} contact - contact: requires properties 'displayName' and 'dialString'
 */
function saveGroupContact(contact) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch) {
        var response;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                dispatch({
                  type: contact.uuid ? c.UPDATE_GROUP_CONTACT_BEGIN : c.CREATE_GROUP_CONTACT_BEGIN,
                  payload: contact
                });
                _context.next = 4;
                return dispatch((0, _proxy.proxyApiCall)(c.GROUP_CONTACTS_HANDLER_ENDPOINT, contact.uuid ? c.UPDATE_GROUP_CONTACT_URL_SUFFIX : c.CREATE_GROUP_CONTACT_URL_SUFFIX, c.HTTP_POST, contact));

              case 4:
                response = _context.sent;
                dispatch({
                  type: contact.uuid ? c.UPDATE_GROUP_CONTACT_SUCCESS : c.CREATE_GROUP_CONTACT_SUCCESS,
                  payload: {
                    contact: contact,
                    response: response
                  }
                });
                return _context.abrupt("return", Promise.resolve(response.body));

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                dispatch({
                  type: contact.uuid ? c.UPDATE_GROUP_CONTACT_FAILURE : c.CREATE_GROUP_CONTACT_FAILURE,
                  payload: {
                    contact: contact,
                    error: _context.t0
                  }
                });
                return _context.abrupt("return", Promise.reject(_context.t0));

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}
/**
 * Group Contacts - Delete
 * Deletes the contact with provided uuid
 * @param {string} uuid - uuid of contact to delete
 */


function deleteGroupContact(uuid) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                dispatch({
                  type: c.DELETE_GROUP_CONTACT_BEGIN,
                  payload: uuid
                });
                _context2.next = 4;
                return dispatch((0, _proxy.proxyApiCall)(c.GROUP_CONTACTS_HANDLER_ENDPOINT, c.DELETE_GROUP_CONTACT_URL_SUFFIX, c.HTTP_DELETE, {
                  uuid: uuid
                }));

              case 4:
                dispatch({
                  type: c.DELETE_GROUP_CONTACT_SUCCESS,
                  payload: uuid
                });
                return _context2.abrupt("return", Promise.resolve());

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                dispatch({
                  type: c.DELETE_GROUP_CONTACT_FAILURE,
                  payload: {
                    uuid: uuid,
                    error: _context2.t0
                  }
                });
                return _context2.abrupt("return", Promise.reject(_context2.t0));

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 8]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.savePersonalContact = savePersonalContact;
exports.deletePersonalContact = deletePersonalContact;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var c = _interopRequireWildcard(__webpack_require__(3));

var _proxy = __webpack_require__(21);

/**
 * Personal Contacts - Save
 * Saves the personal contact using either the create or update interface
 * @param {object} contact - contact: requires properties 'displayName' and 'dialString'
 */
function savePersonalContact(contact) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch) {
        var response;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                dispatch({
                  type: contact.uuid ? c.UPDATE_PERSONAL_CONTACT_BEGIN : c.CREATE_PERSONAL_CONTACT_BEGIN,
                  payload: contact
                });
                _context.next = 4;
                return dispatch((0, _proxy.proxyApiCall)(c.PERSONAL_CONTACTS_HANDLER_ENDPOINT, contact.uuid ? c.UPDATE_PERSONAL_CONTACT_URL_SUFFIX : c.CREATE_PERSONAL_CONTACT_URL_SUFFIX, c.HTTP_POST, contact));

              case 4:
                response = _context.sent;
                dispatch({
                  type: contact.uuid ? c.UPDATE_PERSONAL_CONTACT_SUCCESS : c.CREATE_PERSONAL_CONTACT_SUCCESS,
                  payload: {
                    contact: contact,
                    response: response
                  }
                });
                return _context.abrupt("return", Promise.resolve(response.body));

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                dispatch({
                  type: contact.uuid ? c.UPDATE_PERSONAL_CONTACT_FAILURE : c.CREATE_PERSONAL_CONTACT_FAILURE,
                  payload: {
                    contact: contact,
                    error: _context.t0
                  }
                });
                return _context.abrupt("return", Promise.reject(_context.t0));

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}
/**
 * Personal Contacts - Delete
 * Deletes the contact with provided uuid
 * @param {string} uuid - uuid of contact to delete
 */


function deletePersonalContact(uuid) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                dispatch({
                  type: c.DELETE_PERSONAL_CONTACT_BEGIN,
                  payload: uuid
                });
                _context2.next = 4;
                return dispatch((0, _proxy.proxyApiCall)(c.PERSONAL_CONTACTS_HANDLER_ENDPOINT, c.DELETE_PERSONAL_CONTACT_URL_SUFFIX, c.HTTP_DELETE, {
                  uuid: uuid
                }));

              case 4:
                dispatch({
                  type: c.DELETE_PERSONAL_CONTACT_SUCCESS,
                  payload: uuid
                });
                return _context2.abrupt("return", Promise.resolve());

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                dispatch({
                  type: c.DELETE_PERSONAL_CONTACT_FAILURE,
                  payload: {
                    uuid: uuid,
                    error: _context2.t0
                  }
                });
                return _context2.abrupt("return", Promise.reject(_context2.t0));

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 8]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseContactFromNotification = parseContactFromNotification;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _get = _interopRequireDefault(__webpack_require__(11));

var c = _interopRequireWildcard(__webpack_require__(3));

var _contacts = __webpack_require__(35);

var _currentUser = __webpack_require__(37);

var _schedulingUtils = __webpack_require__(188);

function parseContactFromNotification(payload, state) {
  var object = (0, _get.default)(payload, 'object');
  var objectType = (0, _get.default)(payload, 'objectType');
  var upperCaseObjectType = typeof objectType === 'string' ? objectType.toUpperCase() : '';

  switch (upperCaseObjectType) {
    case 'GROUPCONTACT':
      return parseGroupContact(object, state);

    case 'MEETING':
      return parseMeeting(object, state);

    case 'PERSONALCONTACT':
      return parsePersonalContact(object, state);

    case 'ROOM':
      return parseRoom(object, state);

    case 'USER':
      return parseUser(object, state);

    default:
      return null;
  }
}

function commonFields(displayName, domain, extension, uuid) {
  return {
    dialString: extension,
    displayName: displayName,
    extension: extension,
    id: uuid,
    inCall: false,
    isCallable: true,
    inviteURL: (0, _schedulingUtils.getCallLink)(domain, extension),
    isFavoritable: true,
    name: displayName,
    otherWaysToCallURL: (0, _schedulingUtils.getOtherWaysToCallLink)(domain, extension),
    uuid: uuid
  };
}

function parseGroupContact(src, state) {
  var contactByUuid = (0, _contacts.getContactByUuidGenerator)(state);
  var uuid = (0, _get.default)(src, 'uuid') || (0, _get.default)(src, 'UUID');
  var prevContact = contactByUuid(uuid);
  var displayName = (0, _get.default)(src, 'displayName');
  var domain = (0, _contacts.getDomain)(state);
  var extension = (0, _get.default)(src, 'extension');
  var typeFields = getContactTypeFields(c.CONTACT_TYPE_GROUP_CONTACT);
  return (0, _objectSpread2.default)({
    availability: {
      status: 'AVAILABLE'
    },
    contactType: 'GROUPCONTACT',
    favorite: (0, _get.default)(prevContact, 'favorite', null),
    isChattable: false,
    isCloudAccount: false,
    isDeletable: false,
    isEditable: false,
    isMyMeeting: false,
    isOnline: true,
    isPinProtected: false,
    jid: '',
    lecturer: null,
    moderator: null,
    owner: null,
    ownerID: null,
    participantsCount: 0,
    presence: 'AVAILABLE',
    sipUri: extension,
    type: 'GroupContact'
  }, commonFields(displayName, domain, extension, uuid), typeFields);
}

function parseMeeting(src, state) {
  var contactByUuid = (0, _contacts.getContactByUuidGenerator)(state);
  var uuid = (0, _get.default)(src, 'uuid') || (0, _get.default)(src, 'UUID');
  var prevContact = contactByUuid(uuid);
  var displayName = (0, _get.default)(src, 'displayName');
  var domain = (0, _contacts.getDomain)(state);
  var extension = (0, _get.default)(src, 'extension');
  var typeFields = getContactTypeFields(c.CONTACT_TYPE_MEETING);
  var ownerUUID = (0, _get.default)(src, 'ownerUUID');
  var moderatorUUID = (0, _get.default)(src, 'moderatorUUID');
  var lecturerUUID = (0, _get.default)(src, 'lecturerUUID');
  var isPinProtected = (0, _get.default)(src, 'pinRequired');
  var participants = (0, _get.default)(prevContact, 'participants');
  var userUUID = (0, _currentUser.getUserUUID)(state);
  var isUserOwner = ownerUUID === userUUID;
  return (0, _objectSpread2.default)({
    availability: {
      status: 'AVAILABLE'
    },
    contactType: 'MEETING',
    description: (0, _get.default)(src, 'description'),
    favorite: (0, _get.default)(prevContact, 'favorite', null),
    isChattable: !isPinProtected,
    isCloudAccount: true,
    isDeletable: isUserOwner,
    isEditable: isUserOwner,
    isMyMeeting: isUserOwner,
    isOnline: true,
    isPinProtected: isPinProtected,
    jid: (0, _get.default)(src, 'tempMeeting') ? '' : "".concat(uuid, "@conference.").concat(domain),
    lecturer: lecturerUUID ? getContactFromState(lecturerUUID, state) : null,
    lecturerID: lecturerUUID,
    lecturerUUID: lecturerUUID,
    meetingType: (0, _get.default)(src, 'tempMeeting') ? c.MEETING_TYPE_ONE_TIME : c.MEETING_TYPE_VMR,
    moderator: moderatorUUID ? getContactFromState(moderatorUUID, state) : null,
    moderatorID: moderatorUUID,
    moderatorUUID: moderatorUUID,
    owner: ownerUUID ? getContactFromState(ownerUUID, state) : null,
    ownerID: ownerUUID,
    ownerUUID: ownerUUID,
    participants: participants,
    participantsCount: (0, _get.default)(participants, 'total', 0),
    pin: null,
    presence: 'AVAILABLE',
    sipUri: "".concat(extension, "@").concat(domain),
    type: 'Meeting'
  }, commonFields(displayName, domain, extension, uuid), typeFields);
}

function parsePersonalContact(src, state) {
  var contactByUuid = (0, _contacts.getContactByUuidGenerator)(state);
  var uuid = (0, _get.default)(src, 'uuid') || (0, _get.default)(src, 'UUID');
  var prevContact = contactByUuid(uuid);
  var dialString = (0, _get.default)(src, 'dialString');
  var displayName = (0, _get.default)(src, 'displayName');
  var domain = (0, _contacts.getDomain)(state);
  var typeFields = getContactTypeFields(c.CONTACT_TYPE_PERSONAL_CONTACT);
  return (0, _objectSpread2.default)({
    availability: {
      status: 'AVAILABLE'
    },
    contactType: 'PERSONALCONTACT',
    favorite: (0, _get.default)(prevContact, 'favorite', null),
    isChattable: false,
    isCloudAccount: false,
    isDeletable: true,
    isEditable: true,
    isMyMeeting: false,
    isOnline: true,
    isPinProtected: false,
    jid: '',
    lecturer: null,
    moderator: null,
    owner: null,
    ownerID: null,
    participantsCount: 0,
    presence: 'AVAILABLE',
    sipUri: dialString,
    type: 'PersonalContact'
  }, commonFields(displayName, domain, dialString, uuid), typeFields);
}

function parseRoom(src, state) {
  var contactByUuid = (0, _contacts.getContactByUuidGenerator)(state);
  var uuid = (0, _get.default)(src, 'uuid') || (0, _get.default)(src, 'UUID');
  var prevContact = contactByUuid(uuid);
  var displayName = (0, _get.default)(src, 'displayName');
  var domain = (0, _contacts.getDomain)(state);
  var extension = (0, _get.default)(src, 'extension');
  var typeFields = getContactTypeFields(c.CONTACT_TYPE_ROOMSYSTEM);
  var availability = (0, _get.default)(prevContact, 'availability') || {
    status: 'UNAVAILABLE'
  };
  return (0, _objectSpread2.default)({
    availability: availability,
    contactType: 'ROOMSYSTEM',
    favorite: (0, _get.default)(prevContact, 'favorite', null),
    isChattable: false,
    isCloudAccount: true,
    isDeletable: false,
    isEditable: false,
    isMyMeeting: false,
    isOnline: (0, _get.default)(availability, 'status') === 'AVAILABLE',
    isPinProtected: false,
    jid: '',
    lecturer: null,
    moderator: null,
    owner: null,
    ownerID: null,
    participantsCount: (0, _get.default)(prevContact, 'participantsCount', 0),
    presence: (0, _get.default)(availability, 'status') === 'UNAVAILABLE' ? 'NOT_AVAILABLE' : (0, _get.default)(availability, 'status'),
    sipUri: "".concat(extension, "@").concat(domain),
    type: 'RoomSystem'
  }, commonFields(displayName, domain, extension, uuid), typeFields);
}

function parseUser(src, state) {
  var contactByUuid = (0, _contacts.getContactByUuidGenerator)(state);
  var uuid = (0, _get.default)(src, 'uuid') || (0, _get.default)(src, 'UUID');
  var prevContact = contactByUuid(uuid);
  var displayName = (0, _get.default)(src, 'displayName');
  var domain = (0, _contacts.getDomain)(state);
  var extension = (0, _get.default)(src, 'extension');
  var typeFields = getContactTypeFields(c.CONTACT_TYPE_USER);
  var availability = (0, _get.default)(prevContact, 'availability') || {
    status: 'UNAVAILABLE'
  };
  return (0, _objectSpread2.default)({
    availability: availability,
    contactType: 'USER',
    favorite: (0, _get.default)(prevContact, 'favorite', null),
    isChattable: true,
    isCloudAccount: true,
    isDeletable: false,
    isEditable: false,
    isMyMeeting: false,
    isOnline: (0, _get.default)(availability, 'status') === 'AVAILABLE',
    isPinProtected: false,
    jid: "".concat(uuid, "@").concat(domain),
    lecturer: null,
    moderator: null,
    owner: null,
    ownerID: null,
    participantsCount: (0, _get.default)(prevContact, 'participantsCount', 0),
    presence: (0, _get.default)(availability, 'status') === 'UNAVAILABLE' ? 'NOT_AVAILABLE' : (0, _get.default)(availability, 'status'),
    sipUri: "".concat(extension, "@").concat(domain),
    type: 'User'
  }, commonFields(displayName, domain, extension, uuid), typeFields);
}

function getContactFromState(uuid, state) {
  var currentUserUUID = (0, _currentUser.getUserUUID)(state);
  if (currentUserUUID === uuid) return getContactFromUserProfile(state);
  var contactByUuid = (0, _contacts.getContactByUuidGenerator)(state);
  return contactByUuid(uuid);
}

function getContactFromUserProfile(state) {
  var userProfile = (0, _currentUser.selectUserProfile)(state);
  var displayName = (0, _get.default)(userProfile, 'name');
  var extension = (0, _get.default)(userProfile, 'extension');
  return {
    dialString: extension,
    displayName: displayName,
    extension: extension,
    name: displayName,
    uuid: (0, _get.default)(userProfile, 'uuid')
  };
}

function getContactTypeFields(type) {
  return {
    isMeeting: type === c.CONTACT_TYPE_MEETING,
    isUser: type === c.CONTACT_TYPE_USER,
    isRoomSystem: type === c.CONTACT_TYPE_ROOMSYSTEM,
    isGroupContact: type === c.CONTACT_TYPE_GROUP_CONTACT,
    isPersonalContact: type === c.CONTACT_TYPE_PERSONAL_CONTACT
  };
}

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialize = initialize;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _constants = __webpack_require__(3);

var _proxy = __webpack_require__(21);

var _environment = __webpack_require__(193);

function initialize() {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch, getState) {
        var state, platform;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                state = getState();
                platform = (0, _environment.platform)(state);

                if (platform.isGems) {
                  _context.next = 5;
                  break;
                }

                _jsLogger.default.info('gems software update: platform not gems. skipping subscription.');

                return _context.abrupt("return");

              case 5:
                _context.prev = 5;
                _context.next = 8;
                return dispatch((0, _proxy.subscribe)(_constants.GEMS_SOFTWARE_UPDATE_TOPIC));

              case 8:
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](5);

                _jsLogger.default.info('gems software update: subscription failed.', _context.t0);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 10]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verifyCanConnect = verifyCanConnect;

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _services = __webpack_require__(83);

function verifyCanConnect(state) {
  if (!(0, _services.selectCanConnect)(state)) {
    _jsLogger.default.error('cannot attempt to connect services.', JSON.stringify((0, _services.selectServices)(state)));

    throw Error('cannot attempt to connect services');
  }
}

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(CONFIG) {

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUrl = getUrl;
exports.verifyHealthyDispose = verifyHealthyDispose;
exports.verifyJwtDispose = verifyJwtDispose;

var _get = _interopRequireDefault(__webpack_require__(11));

var _constants = __webpack_require__(3);

function getUrl(jwt, domain, clientType) {
  var proxyUri = CONFIG.wampConnectOptions.proxyUri;
  var environment = CONFIG.environment; // add jwt to wamp connect url if one exists.

  var url = "".concat(proxyUri).concat(environment || domain).concat(jwt ? "?j=".concat(jwt) : ''); // if client inited nucleus with clientInfo, append it to the query string

  if (!clientType) return url;
  var encodedClientType = encodeURIComponent(clientType);
  var suffix = url.includes('?') ? "&clientType=".concat(encodedClientType) : "?clientType=".concat(encodedClientType);
  return url.concat(suffix);
}

function verifyHealthyDispose(payload) {
  return (0, _get.default)(payload, 'reason') === 'wamp.goodbye_and_out';
}

function verifyJwtDispose(payload) {
  return (0, _get.default)(payload, 'reason') === _constants.WAMP_JWT_ERROR_REASON;
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(29)["default"]))

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.foreground = foreground;
exports.background = background;

var c = _interopRequireWildcard(__webpack_require__(3));

function foreground() {
  return {
    type: c.APP_FOREGROUNDED
  };
}

function background() {
  return {
    type: c.APP_BACKGROUNDED
  };
}

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ssoEmailCheck = ssoEmailCheck;
exports.logout = logout;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _get = _interopRequireDefault(__webpack_require__(11));

var _services = __webpack_require__(179);

var c = _interopRequireWildcard(__webpack_require__(3));

var _ssoUtils = __webpack_require__(270);

var _auth = __webpack_require__(31);

/** @module actions/auth */

/**
 * Single Sign-On (SSO) email check
 * Dispatches SSO_CHECK_BEGIN followed by SSO_CHECK_SUCCESS or SSO_CHECK_FAILURE
 * @param {String} email - email address to check
 * @param {String} nextUrl - Default: null. The url to redirect to after logging in.
 */
function ssoEmailCheck(email) {
  var nextUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch, getState) {
        var state, domain, uri, response;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                state = getState();
                domain = (0, _get.default)(state, 'nucleus.cluster.url');
                uri = (0, _ssoUtils.getEmailCheckUri)(domain, email); // signal that we're sending the SSO check request

                dispatch({
                  type: c.SSO_CHECK_BEGIN,
                  payload: uri
                });
                _context.prev = 4;
                _context.next = 7;
                return fetch(uri);

              case 7:
                _context.next = 9;
                return _context.sent.json();

              case 9:
                response = _context.sent;

                if (!(response.res !== 'OK')) {
                  _context.next = 12;
                  break;
                }

                throw response;

              case 12:
                // modify response url, if necessary, based on platform.
                // adding a 'next' param
                if (response.loginSupportType === '1' && response.loginServiceURL) {
                  response.loginServiceURL = (0, _ssoUtils.addNextUrl)(response.loginServiceURL, nextUrl, (0, _auth.getPlatform)(state));
                }

                dispatch({
                  type: c.SSO_CHECK_SUCCESS,
                  payload: response
                });
                return _context.abrupt("return", response);

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](4);
                dispatch({
                  type: c.SSO_CHECK_FAILURE,
                  payload: _context.t0
                });
                throw _context.t0;

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 17]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}

function logout() {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dispatch({
                  type: c.LOGOUT_BEGIN
                });
                _context2.next = 3;
                return dispatch((0, _services.disconnect)());

              case 3:
                dispatch({
                  type: c.AUTH_LOGOUT
                });
                dispatch({
                  type: c.LOGOUT_FINISHED
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInvitationPreview = exports.getExtensionInviteText = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _get2 = _interopRequireDefault(__webpack_require__(11));

var c = _interopRequireWildcard(__webpack_require__(3));

var proxyActions = _interopRequireWildcard(__webpack_require__(21));

/**
 * Thunk that retrieves the invite text for the provided extension.
 * @param {string} extension The extension to generate the invite text for
 * @param {'email'|'emailShort'|'textMessage'} type Flag to indicate the invite type
 * @returns {string} Invite text
 */
var getExtensionInviteText = function getExtensionInviteText(extension) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'email';
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch, getState) {
        var language, queryParams, apiCall, response, payload;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (extension) {
                  _context.next = 2;
                  break;
                }

                throw new Error("Invalid argument extension: ".concat(extension));

              case 2:
                language = (0, _get2.default)(getState(), 'nucleus.localization.localeCode', 'en');
                queryParams = {
                  extension: extension,
                  language: language,
                  type: type
                };
                apiCall = proxyActions.proxyApiCall(c.ACCOUNT_SETTINGS_ENDPOINT, c.GET_EXTENSION_INVITE_TEXT_URI, c.HTTP_GET, null, JSON.stringify(queryParams));
                _context.next = 7;
                return dispatch(apiCall);

              case 7:
                response = _context.sent;
                payload = (0, _get2.default)(response, 'body');

                if (payload) {
                  _context.next = 11;
                  break;
                }

                throw new Error("Extension Invite Service: Undefined body in response");

              case 11:
                return _context.abrupt("return", payload);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

exports.getExtensionInviteText = getExtensionInviteText;

var getInvitationPreview = function getInvitationPreview(config) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch) {
        var parsedResponse, text;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dispatch({
                  type: c.GET_CUSTOMINVITE_PREVIEW_REQUEST,
                  payload: config
                });
                _context2.prev = 1;
                _context2.next = 4;
                return dispatch(proxyActions.proxyApiCall(c.ACCOUNT_SETTINGS_ENDPOINT, c.GET_CUSTOMINVITE_PREVIEW_URI_SUFFIX, c.HTTP_GET, null, JSON.stringify(config)));

              case 4:
                parsedResponse = _context2.sent;
                text = (0, _get2.default)(parsedResponse, 'body');

                if (text) {
                  _context2.next = 8;
                  break;
                }

                throw new Error("Invite Preview Service: Undefined body in response");

              case 8:
                dispatch({
                  type: c.GET_CUSTOMINVITE_PREVIEW_SUCCESS,
                  payload: {
                    html: '',
                    text: text
                  }
                });
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](1);
                dispatch({
                  type: c.GET_CUSTOMINVITE_PREVIEW_FAILURE,
                  payload: _context2.t0
                });

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 11]]);
      }));

      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
};

exports.getInvitationPreview = getInvitationPreview;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchUsageDetailsRoom = exports.fetchUsageDetailsUser = exports.fetchStreamMetaData = exports.fetchStreamViewers = exports.fetchStreamHistoryByName = exports.fetchStreamsFilteredByUsage = exports.fetchStreamsFilteredByList = exports.fetchSummaryData = exports.fetchConferenceData = exports.fetchUsersFilteredByActiveTotal = exports.fetchUsersGroupByMinutesRooms = exports.fetchUsersGroupByMinutesPersonal = exports.fetchUsersGroupByCallsRoom = exports.fetchUsersGroupByCallsPersonal = exports.fetchCallsGroupedByPlan = exports.fetchCallsGroupedByDaysDevices = exports.fetchCallsGroupedByDays = void 0;

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _dateUtils = __webpack_require__(124);

var HttpUtils = _interopRequireWildcard(__webpack_require__(127));

var _userProfile = __webpack_require__(52);

var c = _interopRequireWildcard(__webpack_require__(3));

/**
 * @param type - The Redux action constant name
 * @param error - The error object
 * @return {{type: *, payload: string}}
 */
var getErrorAction = function getErrorAction(type, error) {
  return {
    type: type,
    payload: error
  };
};

var objectToQuerystring = function objectToQuerystring(obj) {
  return Object.keys(obj).map(function (key) {
    return "".concat(key, "=").concat(encodeURI(obj[key]));
  }).join('&');
};

var buildCallURL = function buildCallURL(startDate, endDate, groupByArray) {
  return "calls?dateEnd=".concat(endDate, "&dateStart=").concat(startDate, "&group=").concat(groupByArray.join(','));
};

var buildConferenceURL = function buildConferenceURL(startDate, endDate) {
  return "conferences?dateEnd=".concat(endDate, "&dateStart=").concat(startDate);
};

var buildSummaryURL = function buildSummaryURL(startDate, endDate) {
  return "summary?dateEnd=".concat(endDate, "&dateStart=").concat(startDate);
};

var buildStreamURL = function buildStreamURL(startDate, endDate, filterByArray) {
  if (startDate && endDate) {
    return "streams?dateEnd=".concat(endDate, "&dateStart=").concat(startDate, "&filter=").concat(filterByArray.join(','));
  } else {
    return "streams?filter=".concat(filterByArray.join(','));
  }
};

var buildViewerURL = function buildViewerURL() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return "viewers?".concat(objectToQuerystring(params));
};

var buildUserUrl = function buildUserUrl(startDate, endDate, groupByArray, filterArray) {
  if (groupByArray && groupByArray.length) {
    return encodeURI("users?dateEnd=".concat(endDate, "&dateStart=").concat(startDate, "&group=").concat(groupByArray.join(',')));
  }

  if (filterArray && filterArray.length) {
    return encodeURI("users?dateEnd=".concat(endDate, "&dateStart=").concat(startDate, "&filter=").concat(filterArray.join(',')));
  } // Fallback default


  return "users?dateEnd=".concat(endDate, "&dateStart=").concat(startDate);
};
/**
 * Do API call to dataWarehouse,
 * and redux actions to dispatch at various points in process
 * @param uri - the query string part of the url.
 * @param beginActionType - action to dispatch when fetch has started.
 * @param successActionType - action to dispatch when fetch has succeeded.
 * @param errorActionType - action to dispatch when fetch has failed.
 */


var doDWHFetch = function doDWHFetch(uri, beginActionType, successActionType, errorActionType) {
  return function (dispatch, getState) {
    var state = getState();
    var endpoint = (0, _safeAccess.default)(state, 'nucleus.cluster.url') === c.PROD_CLUSTER_URL ? c.DATA_WAREHOUSE_PRODUCTION_ENDPOINT : c.DATA_WAREHOUSE_STAGING_ENDPOINT;
    var url = encodeURI("".concat(endpoint, "/").concat(uri));
    dispatch({
      type: beginActionType
    });

    if ((0, _userProfile.selectIsGuest)(state)) {
      dispatch(getErrorAction(errorActionType, {
        message: 'Guest user cannot fetch recordings'
      }));
      return;
    }

    fetch(url, {
      credentials: 'include'
    }).then(HttpUtils.checkHttpStatus).then(function (response) {
      var responseJSON = {
        data: {}
      };

      try {
        responseJSON = response.json();
      } catch (e) {// eat the parsing error
      }

      return responseJSON;
    }).then(function (response) {
      dispatch({
        type: successActionType,
        payload: response
      });
    }).catch(function (error) {
      dispatch(getErrorAction(errorActionType, error));
    });
  };
};

var fetchCallsGroupedByDays = function fetchCallsGroupedByDays(startDate, endDate) {
  var uri = "".concat(buildCallURL(startDate, endDate, ['days']));
  return doDWHFetch(uri, c.DWH_FETCH_CALLS_BEGIN_DAYS, c.DWH_FETCH_CALLS_SUCCESS_DAYS, c.DWH_FETCH_CALLS_FAILED_DAYS);
};

exports.fetchCallsGroupedByDays = fetchCallsGroupedByDays;

var fetchCallsGroupedByDaysDevices = function fetchCallsGroupedByDaysDevices(startDate, endDate) {
  var uri = "".concat(buildCallURL(startDate, endDate, ['days,devices']));
  return doDWHFetch(uri, c.DWH_FETCH_CALLS_BEGIN_DAYS_DEVICES, c.DWH_FETCH_CALLS_SUCCESS_DAYS_DEVICES, c.DWH_FETCH_CALLS_FAILED_DAYS_DEVICES);
};

exports.fetchCallsGroupedByDaysDevices = fetchCallsGroupedByDaysDevices;

var fetchCallsGroupedByPlan = function fetchCallsGroupedByPlan(startDate, endDate) {
  var uri = "".concat(buildCallURL(startDate, endDate, ['plan']));
  return doDWHFetch(uri, c.DWH_FETCH_CALLS_BEGIN_PLAN, c.DWH_FETCH_CALLS_SUCCESS_PLAN, c.DWH_FETCH_CALLS_FAILED_PLAN);
};

exports.fetchCallsGroupedByPlan = fetchCallsGroupedByPlan;

var fetchUsersGroupByCallsPersonal = function fetchUsersGroupByCallsPersonal(startDate, endDate) {
  var uri = "".concat(buildUserUrl(startDate, endDate, ['calls', 'personal']));
  return doDWHFetch(uri, c.DWH_FETCH_USERS_GROUP_CALLS_PERSONAL_BEGIN, c.DWH_FETCH_USERS_GROUP_CALLS_PERSONAL_SUCCESS, c.DWH_FETCH_USERS_GROUP_CALLS_PERSONAL_FAILED);
};

exports.fetchUsersGroupByCallsPersonal = fetchUsersGroupByCallsPersonal;

var fetchUsersGroupByCallsRoom = function fetchUsersGroupByCallsRoom(startDate, endDate) {
  var uri = "".concat(buildUserUrl(startDate, endDate, ['calls', 'rooms']));
  return doDWHFetch(uri, c.DWH_FETCH_USERS_GROUP_CALLS_ROOMS_BEGIN, c.DWH_FETCH_USERS_GROUP_CALLS_ROOMS_SUCCESS, c.DWH_FETCH_USERS_GROUP_CALLS_ROOMS_FAILED);
};

exports.fetchUsersGroupByCallsRoom = fetchUsersGroupByCallsRoom;

var fetchUsersGroupByMinutesPersonal = function fetchUsersGroupByMinutesPersonal(startDate, endDate) {
  var uri = "".concat(buildUserUrl(startDate, endDate, ['minutes', 'personal']));
  return doDWHFetch(uri, c.DWH_FETCH_USERS_GROUP_MINUTES_PERSONAL_BEGIN, c.DWH_FETCH_USERS_GROUP_MINUTES_PERSONAL_SUCCESS, c.DWH_FETCH_USERS_GROUP_MINUTES_PERSONAL_FAILED);
};

exports.fetchUsersGroupByMinutesPersonal = fetchUsersGroupByMinutesPersonal;

var fetchUsersGroupByMinutesRooms = function fetchUsersGroupByMinutesRooms(startDate, endDate) {
  var uri = "".concat(buildUserUrl(startDate, endDate, ['minutes', 'rooms']));
  return doDWHFetch(uri, c.DWH_FETCH_USERS_GROUP_MINUTES_ROOMS_BEGIN, c.DWH_FETCH_USERS_GROUP_MINUTES_ROOMS_SUCCESS, c.DWH_FETCH_USERS_GROUP_MINUTES_ROOMS_FAILED);
};

exports.fetchUsersGroupByMinutesRooms = fetchUsersGroupByMinutesRooms;

var fetchUsersFilteredByActiveTotal = function fetchUsersFilteredByActiveTotal(startDate, endDate) {
  var uri = "".concat(buildUserUrl(startDate, endDate, null, ['active', 'total']));
  return doDWHFetch(uri, c.DWH_FETCH_USERS_FILTER_ACTIVE_TOTAL_BEGIN, c.DWH_FETCH_USERS_FILTER_ACTIVE_TOTAL_SUCCESS, c.DWH_FETCH_USERS_FILTER_ACTIVE_TOTAL_FAILED);
};

exports.fetchUsersFilteredByActiveTotal = fetchUsersFilteredByActiveTotal;

var fetchConferenceData = function fetchConferenceData(startDate, endDate) {
  var uri = buildConferenceURL(startDate, endDate);
  return doDWHFetch(uri, c.DWH_FETCH_CONFERENCES_BEGIN, c.DWH_FETCH_CONFERENCES_SUCCESS, c.DWH_FETCH_CONFERENCES_FAILED);
};

exports.fetchConferenceData = fetchConferenceData;

var fetchSummaryData = function fetchSummaryData(startDate, endDate) {
  var uri = "".concat(buildSummaryURL(startDate, endDate));
  return doDWHFetch(uri, c.DWH_FETCH_SUMMARY_BEGIN, c.DWH_FETCH_SUMMARY_SUCCESS, c.DWH_FETCH_SUMMARY_FAILED);
};

exports.fetchSummaryData = fetchSummaryData;

var fetchStreamsFilteredByList = function fetchStreamsFilteredByList(startDate, endDate) {
  var uri = "".concat(buildStreamURL(startDate, endDate, ['list']));
  return doDWHFetch(uri, c.DWH_FETCH_STREAMS_BEGIN_LIST, c.DWH_FETCH_STREAMS_SUCCESS_LIST, c.DWH_FETCH_STREAMS_FAILED_LIST);
};

exports.fetchStreamsFilteredByList = fetchStreamsFilteredByList;

var fetchStreamsFilteredByUsage = function fetchStreamsFilteredByUsage() {
  var uri = "".concat(buildStreamURL(null, null, ['usage']));
  return doDWHFetch(uri, c.DWH_FETCH_STREAMS_BEGIN_USAGE, c.DWH_FETCH_STREAMS_SUCCESS_USAGE, c.DWH_FETCH_STREAMS_FAILED_USAGE);
};

exports.fetchStreamsFilteredByUsage = fetchStreamsFilteredByUsage;

var fetchStreamHistoryByName = function fetchStreamHistoryByName(startDate, endDate, meetingName) {
  var uri = "".concat(buildStreamURL(startDate, endDate, ['list']), "&name=").concat(meetingName);
  return doDWHFetch(uri, c.DWH_STREAM_HISTORY_REQUEST, c.DWH_STREAM_HISTORY_SUCCESS, c.DWH_STREAM_HISTORY_FAILURE);
};

exports.fetchStreamHistoryByName = fetchStreamHistoryByName;

var fetchStreamViewers = function fetchStreamViewers(recordingUUID) {
  var uri = buildViewerURL({
    recordingID: recordingUUID
  });
  return doDWHFetch(uri, c.DWH_STREAM_VIEWERS_REQUEST, c.DWH_STREAM_VIEWERS_SUCCESS, c.DWH_STREAM_VIEWERS_FAILURE);
};

exports.fetchStreamViewers = fetchStreamViewers;

var fetchStreamMetaData = function fetchStreamMetaData(recordingUUID) {
  var uri = "".concat(buildStreamURL(null, null, ['list']), "&").concat(objectToQuerystring({
    recordingUUID: recordingUUID
  }));
  return doDWHFetch(uri, c.DWH_STREAM_METADATA_REQUEST, c.DWH_STREAM_METADATA_SUCCESS, c.DWH_STREAM_METADATA_FAILURE);
};
/* TODO: This needs to be replaced with a call based on uuid (not a name string) that can output (name, start date,
 * device, source, destination, & duration). Also, the call should support pagination */


exports.fetchStreamMetaData = fetchStreamMetaData;

var fetchUsageDetails = function fetchUsageDetails(type, _ref) {
  var newDateEnd = _ref.dateEnd,
      newDateStart = _ref.dateStart,
      id = _ref.id;
  return function (dispatch, getState) {
    var state = getState();
    var clusterUrl = (0, _safeAccess.default)(state, 'nucleus.cluster.url');
    var dwhReducer = type === c.DWH_USAGEDETAILS_TYPES.USER ? 'usageDetailsForUser' : 'usageDetailsForRoom';

    var _ref2 = (0, _safeAccess.default)(state, "nucleus.dataWarehouse.".concat(dwhReducer)) || {},
        dateEnd = _ref2.dateEnd,
        dateStart = _ref2.dateStart,
        selectedId = _ref2.selectedId;

    var payload = {
      isNewRequest: !(newDateEnd === dateEnd && newDateStart === dateStart && id === selectedId),
      dateEnd: (0, _dateUtils.toISODate)(newDateEnd || dateEnd),
      dateStart: (0, _dateUtils.toISODate)(newDateStart || dateStart),
      selectedId: id || selectedId
    };
    var userParam = encodeURIComponent(payload.selectedId);
    var dateRangeParam = encodeURIComponent("".concat(payload.dateStart, ",").concat(payload.dateEnd));
    var url = "https://manage.".concat(clusterUrl, "/DWH/accounts/userStats/").concat(userParam, "/").concat(dateRangeParam, "/search");
    if (!payload.selectedId) return;
    dispatch({
      type: c["DWH_USAGEDETAILS_".concat(type, "_REQUEST")],
      payload: payload
    });
    fetch(url, {
      credentials: 'include',
      method: c.HTTP_GET
    }).then(HttpUtils.checkHttpStatus).then(function (response) {
      //To handle potential empty responses from GET requests
      var _parseJSON = function _parseJSON(response) {
        return response.text().then(function (text) {
          return text ? JSON.parse(text) : {};
        });
      };

      return _parseJSON(response);
    }).then(function (response) {
      dispatch({
        type: c["DWH_USAGEDETAILS_".concat(type, "_SUCCESS")],
        payload: response
      });
    }).catch(function (error) {
      dispatch({
        type: c["DWH_USAGEDETAILS_".concat(type, "_FAILURE")],
        payload: error
      });
    });
  };
};

var fetchUsageDetailsUser = function fetchUsageDetailsUser(_ref3) {
  var dateEnd = _ref3.dateEnd,
      dateStart = _ref3.dateStart,
      id = _ref3.id;
  return fetchUsageDetails(c.DWH_USAGEDETAILS_TYPES.USER, {
    dateEnd: dateEnd,
    dateStart: dateStart,
    id: id
  });
};

exports.fetchUsageDetailsUser = fetchUsageDetailsUser;

var fetchUsageDetailsRoom = function fetchUsageDetailsRoom(_ref4) {
  var dateEnd = _ref4.dateEnd,
      dateStart = _ref4.dateStart,
      id = _ref4.id;
  return fetchUsageDetails(c.DWH_USAGEDETAILS_TYPES.ROOM, {
    dateEnd: dateEnd,
    dateStart: dateStart,
    id: id
  });
};

exports.fetchUsageDetailsRoom = fetchUsageDetailsRoom;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setScreenCount = setScreenCount;
exports.setCameraCapabilities = setCameraCapabilities;
exports.setDeviceInfo = setDeviceInfo;
exports.getUploadUrl = getUploadUrl;
exports.subscribeToEvents = subscribeToEvents;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var c = _interopRequireWildcard(__webpack_require__(3));

var proxyActions = _interopRequireWildcard(__webpack_require__(21));

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

/**
 * Update device (GEMS) screen count
 * @param {string} count - number of screens
 */
function setScreenCount(count) {
  return {
    type: c.SET_DEVICE_SCREEN_COUNT,
    payload: count
  };
}
/**
 * Update device (GEMS) screen count
 * @param {object}  capabilities  - camera capabilites
 */


function setCameraCapabilities(capabilities) {
  return {
    type: c.SET_DEVICE_CAMERA_CAPABILITIES,
    payload: capabilities
  };
}
/**
 * Update device (GEMS) device info
 * @param {object} client info
 * @param {string} [client.clientType] ICON_900|ICON_700|ICON_500|ICON_300
 * @param {string} [client.clientVersion] version
 * @param {string} [client.version] same as version
 * @param {string} [client.localIPAddr] device ip address
 * @param {string} [client.serialNumber] device serial number
 * @param {string} [client.platform] same as client type
 * @param {string} [client.phoneModelNumber] phone hd model number
 * @param {string} [client.language] language code
 */


function setDeviceInfo(info) {
  return {
    type: c.SET_DEVICE_INFO,
    payload: info
  };
}
/**
 * Request presigned post url from health s3 bucket
 * @param {object} payload info
 * @param {string} [payload.filename] Name of file to upload
 * @param {string} [payload.identifier] The identifier of the device uploading (Serialnumber for example)
 */


function getUploadUrl(payload) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch) {
        var response;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch({
                  type: c.SEND_CORONER_URL_BEGIN
                });
                _context.prev = 1;
                response = dispatch((0, proxyActions.proxyApiCall)(c.SEND_CORONER_URL_ENDPOINT, c.SEND_CORONER_URL_SUFFIX, c.HTTP_GET, payload, null));
                dispatch({
                  type: c.SEND_CORONER_URL_SUCCESS,
                  response: response
                });
                return _context.abrupt("return", response);

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](1);

                _jsLogger.default.info('Upload api call failed:', _context.t0);

                dispatch({
                  type: c.SEND_CORONER_URL_FAILURE,
                  payload: _context.t0
                });
                throw _context.t0;

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 7]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}

function subscribeToEvents() {
  return function (dispatch) {
    return dispatch(proxyActions.subscribe(c.DEVICE_TOPIC));
  };
}

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.panLeft = panLeft;
exports.panLeftStop = panLeftStop;
exports.panRight = panRight;
exports.panRightStop = panRightStop;
exports.tiltDown = tiltDown;
exports.tiltDownStop = tiltDownStop;
exports.tiltUp = tiltUp;
exports.tiltUpStop = tiltUpStop;
exports.zoomOut = zoomOut;
exports.zoomOutStop = zoomOutStop;
exports.zoomIn = zoomIn;
exports.zoomInStop = zoomInStop;
exports.focusOut = focusOut;
exports.focusOutStop = focusOutStop;
exports.focusIn = focusIn;
exports.focusInStop = focusInStop;
exports.preset = preset;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var c = _interopRequireWildcard(__webpack_require__(3));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _call = __webpack_require__(50);

/** @module actions/fecc */
function sendStart(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch, getState) {
        var state, sourceId, callId, data;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                state = getState();
                sourceId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.sourceId');
                callId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.callId');
                data = {
                  command: c.GALAXY_COMMAND_PASSTHROUGH,
                  sourceId: sourceId,
                  callId: callId,
                  passThroughType: c.GALAXY_PASSTHROUGH_FECC,
                  // GICON uses passThroughType instead of reason
                  fecc: {
                    action: (0, _safeAccess.default)(params, 'action'),
                    actionType: c.FECC_ACTION_TYPE_START,
                    timeout: 10,
                    type: c.FECC_TYPE_CAMERA_CONTROL
                  }
                }; // tell the other side to call us

                return _context.abrupt("return", dispatch((0, _call.postCallCommandGalaxy)(data)));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}

function sendStop(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch, getState) {
        var state, sourceId, callId, data;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                state = getState();
                sourceId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.sourceId');
                callId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.callId');
                data = {
                  command: c.GALAXY_COMMAND_PASSTHROUGH,
                  sourceId: sourceId,
                  callId: callId,
                  passThroughType: c.GALAXY_PASSTHROUGH_FECC,
                  // GICON uses passThroughType instead of reason
                  fecc: {
                    action: (0, _safeAccess.default)(params, 'action'),
                    actionType: c.FECC_ACTION_TYPE_STOP,
                    timeout: 10,
                    type: c.FECC_TYPE_CAMERA_CONTROL
                  }
                }; // tell the other side to call us

                return _context2.abrupt("return", dispatch((0, _call.postCallCommandGalaxy)(data)));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}
/**
 * Far End Camera Controls - Pan Left
 * @param {object} params - query parameters (userLogin and token are automatically included)
 * @description It is expected that the client will call the 'panLeft' on key down and call
 * the 'panLeftStop' on key up. Nucleus will send 'continue' actions automatically between the
 * two calls.
 */


function panLeft() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return sendStart(Object.assign({}, params, {
    action: c.FECC_ACTION_PAN_LEFT
  }));
}
/**
 * Far End Camera Controls - Pan Left stop
 */


function panLeftStop() {
  return sendStop({
    action: c.FECC_ACTION_PAN_LEFT
  });
}
/**
 * Far End Camera Controls - Pan Right
 * @param {object} params - query parameters (userLogin and token are automatically included)
 * @description It is expected that the client will call the 'panRight' on key down and call
 * the 'panRightStop' on key up. Nucleus will send 'continue' actions automatically between the
 * two calls.
 */


function panRight() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return sendStart(Object.assign({}, params, {
    action: c.FECC_ACTION_PAN_RIGHT
  }));
}
/**
 * Far End Camera Controls - Pan Right stop
 */


function panRightStop() {
  return sendStop({
    action: c.FECC_ACTION_PAN_RIGHT
  });
}
/**
 * Far End Camera Controls - Tilt Down
 * @param {object} params - query parameters (userLogin and token are automatically included)
 * @description It is expected that the client will call the 'tiltDown' on key down and call
 * the 'tiltDownStop' on key up. Nucleus will send 'continue' actions automatically between the
 * two calls.
 */


function tiltDown() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return sendStart(Object.assign({}, params, {
    action: c.FECC_ACTION_TILT_DOWN
  }));
}
/**
 * Far End Camera Controls - Tilt Down stop
 */


function tiltDownStop() {
  return sendStop({
    action: c.FECC_ACTION_TILT_DOWN
  });
}
/**
 * Far End Camera Controls - Tilt Up
 * @param {object} params - query parameters (userLogin and token are automatically included)
 * @description It is expected that the client will call the 'tiltUp' on key down and call
 * the 'tiltUpStop' on key up. Nucleus will send 'continue' actions automatically between the
 * two calls.
 */


function tiltUp() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return sendStart(Object.assign({}, params, {
    action: c.FECC_ACTION_TILT_UP
  }));
}
/**
 * Far End Camera Controls - Tilt Up stop
 */


function tiltUpStop() {
  return sendStop({
    action: c.FECC_ACTION_TILT_UP
  });
}
/**
 * Far End Camera Controls - Zoom Out
 * @param {object} params - query parameters (userLogin and token are automatically included)
 * @description It is expected that the client will call the 'zoomOut' on key down and call
 * the 'zoomOutStop' on key up. Nucleus will send 'continue' actions automatically between the
 * two calls.
 */


function zoomOut() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return sendStart(Object.assign({}, params, {
    action: c.FECC_ACTION_ZOOM_OUT
  }));
}
/**
 * Far End Camera Controls - Zoom Out stop
 */


function zoomOutStop() {
  return sendStop({
    action: c.FECC_ACTION_ZOOM_OUT
  });
}
/**
 * Far End Camera Controls - Zoom In
 * @param {object} params - query parameters (userLogin and token are automatically included)
 * @description It is expected that the client will call the 'zoomIn' on key down and call
 * the 'zoomInStop' on key up. Nucleus will send 'continue' actions automatically between the
 * two calls.
 */


function zoomIn() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return sendStart(Object.assign({}, params, {
    action: c.FECC_ACTION_ZOOM_IN
  }));
}
/**
 * Far End Camera Controls - Zoom In stop
 */


function zoomInStop() {
  return sendStop({
    action: c.FECC_ACTION_ZOOM_IN
  });
}
/**
 * Far End Camera Controls - Focus Out
 * @param {object} params - query parameters (userLogin and token are automatically included)
 * @description It is expected that the client will call the 'focusOut' on key down and call
 * the 'focusOutStop' on key up. Nucleus will send 'continue' actions automatically between the
 * two calls.
 */


function focusOut() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return sendStart(Object.assign({}, params, {
    action: c.FECC_ACTION_FOCUS_OUT
  }));
}
/**
 * Far End Camera Controls - Focus Out stop
 */


function focusOutStop() {
  return sendStop({
    action: c.FECC_ACTION_FOCUS_OUT
  });
}
/**
 * Far End Camera Controls - Focus In
 * @param {object} params - query parameters (userLogin and token are automatically included)
 * @description It is expected that the client will call the 'focusIn' on key down and call
 * the 'focusInStop' on key up. Nucleus will send 'continue' actions automatically between the
 * two calls.
 */


function focusIn() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return sendStart(Object.assign({}, params, {
    action: c.FECC_ACTION_FOCUS_IN
  }));
}
/**
 * Far End Camera Controls - Focus In stop
 */


function focusInStop() {
  return sendStop({
    action: c.FECC_ACTION_FOCUS_IN
  });
}
/**
 * Far End Camera Controls - Move to preset position of RX endpoint.
 * @param {ojbect} params - Should just contain the number for the preset and the command, cameraMoveToPreset|cameraSetPreset.
 */


function preset() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(dispatch, getState) {
        var state, sourceId, callId, data;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                state = getState();
                sourceId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.sourceId');
                callId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.callId');
                data = {
                  command: c.GALAXY_COMMAND_PASSTHROUGH,
                  sourceId: sourceId,
                  callId: callId,
                  passThroughType: c.GALAXY_PASSTHROUGH_FECC,
                  // GICON uses passThroughType instead of reason
                  fecc: {
                    preset: (0, _safeAccess.default)(params, 'preset'),
                    type: (0, _safeAccess.default)(params, 'command') //'cameraMoveToPreset' or  'cameraSetPreset'

                  }
                }; // tell the other side to call us

                return _context3.abrupt("return", dispatch((0, _call.postCallCommandGalaxy)(data)));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
}

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGroupSettings = getGroupSettings;
exports.setGroupLocale = setGroupLocale;
exports.setRecording = exports.setMeetingLayout = exports.setMeetingInvites = exports.setDomainsFilter = exports.setChatEnabled = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _find = _interopRequireDefault(__webpack_require__(501));

var _pick = _interopRequireDefault(__webpack_require__(122));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var c = _interopRequireWildcard(__webpack_require__(3));

var _proxy = __webpack_require__(21);

var _monitoring = __webpack_require__(271);

function getGroupSettings() {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch) {
        var parsedResponse;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch({
                  type: c.GET_ACCOUNT_SETTINGS_REQUEST
                });
                _context.prev = 1;
                _context.next = 4;
                return dispatch((0, _proxy.proxyApiCall)(c.ACCOUNT_SETTINGS_ENDPOINT, c.ACCOUNT_SETTINGS_URI_SUFFIX, c.HTTP_GET));

              case 4:
                parsedResponse = _context.sent;
                // note: the response is parsed and its status_code is checked in the wamp-client middleware
                // if there is an error it will throw { errorDescription, errorID, statusCode }
                dispatch({
                  type: c.GET_ACCOUNT_SETTINGS_SUCCESS,
                  payload: (0, _safeAccess.default)(parsedResponse, 'body') || {}
                });
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                dispatch({
                  type: c.GET_ACCOUNT_SETTINGS_FAILURE,
                  payload: _context.t0
                });

              case 11:
                dispatch((0, _monitoring.getGroupSettings)());

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 8]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}

function setGroupSettings(newSettings) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch) {
        var parsedResponse;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dispatch({
                  type: c.SET_ACCOUNT_SETTINGS_REQUEST
                });
                _context2.prev = 1;
                _context2.next = 4;
                return dispatch((0, _proxy.proxyApiCall)(c.ACCOUNT_SETTINGS_ENDPOINT, c.ACCOUNT_SETTINGS_URI_SUFFIX, c.HTTP_POST, newSettings));

              case 4:
                parsedResponse = _context2.sent;
                // note: the response is parsed and its status_code is checked in the wamp-client middleware
                // if there is an error it will throw { errorDescription, errorID, statusCode }
                dispatch({
                  type: c.SET_ACCOUNT_SETTINGS_SUCCESS,
                  payload: (0, _safeAccess.default)(parsedResponse, 'body') || {}
                });
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);
                dispatch({
                  type: c.SET_ACCOUNT_SETTINGS_FAILURE,
                  payload: _context2.t0
                });

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 8]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}

function setGroupLocale(locale) {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(dispatch) {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return dispatch(setGroupSettings({
                  language: locale
                }));

              case 2:
                _context3.next = 4;
                return dispatch((0, _monitoring.putGroupSettings)({
                  alertNotificationsLocale: locale
                }));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
}

var setChatEnabled = function setChatEnabled() {
  var isEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return setGroupSettings({
    chatEnabled: !!isEnabled
  });
};

exports.setChatEnabled = setChatEnabled;

var setDomainsFilter = function setDomainsFilter() {
  var domains = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  // domains should be a semicolon-separated list of domains
  // note: the api does not accept '', do fallback to null if all values have been removed
  return setGroupSettings({
    selfSignupDomainFilter: domains || null
  });
};

exports.setDomainsFilter = setDomainsFilter;

var setMeetingInvites = function setMeetingInvites() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return setGroupSettings((0, _pick.default)(settings, ['customInviteShowAdditionalNumbers', 'customInviteShowConference', 'customInviteShowOtherWays', 'customInviteShowPin', 'customInviteShowSkype']));
};

exports.setMeetingInvites = setMeetingInvites;

var setMeetingLayout = function setMeetingLayout() {
  var layout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;

  if (!(0, _find.default)(c.MEETING_LAYOUT_TYPES, function (value) {
    return layout === value;
  })) {
    return (
      /*#__PURE__*/
      function () {
        var _ref4 = (0, _asyncToGenerator2.default)(
        /*#__PURE__*/
        _regenerator.default.mark(function _callee4(dispatch) {
          return _regenerator.default.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  dispatch({
                    type: c.SET_ACCOUNT_SETTINGS_FAILURE,
                    payload: 'INVALID_LAYOUT_SPECIFIED'
                  });

                case 1:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        return function (_x4) {
          return _ref4.apply(this, arguments);
        };
      }()
    );
  }

  return setGroupSettings({
    mcuLayout: layout
  });
};

exports.setMeetingLayout = setMeetingLayout;

var setRecording = function setRecording() {
  var recordingEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return setGroupSettings({
    recordingEnabled: recordingEnabled
  });
};

exports.setRecording = setRecording;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(502),
    findIndex = __webpack_require__(503);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(90),
    isArrayLike = __webpack_require__(104),
    keys = __webpack_require__(102);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(238),
    baseIteratee = __webpack_require__(90),
    toInteger = __webpack_require__(504);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(505);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(248);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialize = initialize;

var c = _interopRequireWildcard(__webpack_require__(3));

var _constants2 = __webpack_require__(507);

var _cascadeConfig = __webpack_require__(29);

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

/**
 * Initialize
 * This action will initialize the nucleus for specific client environment
 * the selected node.
 * @param {object} options - Its a dictionary of config parameters
 * @param {string} [options.environment] - can be used to set the backend environment to use.
 *                                       The app does not have to set this through the initial
 *                                       state any longer. Default will be any state set through
 *                                       initial state and null otherwise.
 * @param {string} [options.version] - the application software version. Default 1.0.0
 * @param {object} [options.defaultUserSettings] - Default user settings
 * @param {object} [options.ipAddress] - Override default server parameters node selection logic.
 *                                     Lock the node to the given ip address. Default is null
 * @param {presentationMode} [options.presentationMode] - the type of presentation mode to use in the client
 * @param {string} [options.localeCode] - the language to be used by nucleus. If none is provided it will
 *                                  default to the one given by the CSS server and 'en' otherwise
 * @param {string} [options.platform] - the client local environment. WEB (Browser clients), IOS, ANDROID
 *                                    Windows or OSX. Default WEB
 * @param {boolean} [options.enableH264] - Flag that controls support for H264. defaults to false
 * @param {boolean} [options.preferH264] - Flag indicate that calls prefer H264.
 * @param {boolean} [options.forceTcpTunneling] - Force tcp tunnel media
 * @param {boolean} [options.enableFarEndCameraControls] - Override far end camera control from feature flag service
 *
 * @param {array} [options.localPrimaryElementIds] - an array of strings corresponding to the ids of the
 *                                                 video elements to attach your local webcam stream to
 * @param {array} [options.localSecondaryElementIds] - an array of strings corresponding to the ids of the
 *                                                 video elements to attach your local presentation stream to
 * @param {array} [options.remotePrimaryElementIds] - an array of strings corresponding to the ids of the
 *                                                 video elements to attach the remote main video stream to
 * @param {array} [options.remoteSecondaryElementIds] - an array of strings corresponding to the ids of the
 *                                                 video elements to attach the remote presentation stream to
 * @param {boolean} [options.video] - tells nucleus to attempt to capture the webcam track on calling acquireLocalPrimaryStream
 * @param {boolean} [options.audio] - tells nucleus to attempt to capture the microphone track on calling acquireLocalPrimaryStream
 * @param {string} [options.videoMuteSlide] - tells nucleus that there is a WebM video slide to be sourced to play when the output video stream is muted.
 * @param {string} [options.userAgent] - set userAgent
 * @param {boolean} [options.sortFavoritesFirst] - should favorites be sorted to the top in contact selectors (defaults to true)
 * @param {boolean} [options.directMediaEnabled] - Use Galaxy Direct Media if true. Default is false.
 * @param {boolean} [options.enableTransportCC] - If true, disable striping of ext-maps in the SDP.
 * @param {string} [options.desktopChannel]
 * @param {boolean} [options.calendarEnabled] - Do we subscribe to calendar events (default is false)
 * @param {string} [options.deviceScreenCount] - Number of screens attached to the device
 * @param {object} [options.deviceCameraCapabilities] - Device (GEMS) camera capabilites
 * @param {boolean} [options.callHistoryEnabled] Indicates whether to get the call history at login and subscribe to its events. Defaults to true.\
 * @param {boolean} {options.gqlChatEnabled} Indicates whether or not to initialize and use gql-based chat in the application for this user.
 * @param {boolean} [options.callsEnabled]
 * Indicates whether to register with the call manager and to post capabilities, so galaxy calls can be made.
 * Disable it for clients that will not make calls. Requires Galaxy/Direct Media. Defaults to true.
 * @param {boolean} [options.getAccountFeaturesOnLogin] Indicates whether to get account features after log-in. This is not awaited during log in. Defaults to true.
 * @param {boolean} [options.loadContactsOnLogin] Indicates whether to load contacts after log-in. This is not awaited during log in. Defaults to true.
 * @param {number} [options.loadContactsPageSize] Indicates the size of each page when fetching the paginated list of contacts.
 * @param {object} options.clientInfo Information about the specific client connecting. Will be passed on to NucleusProxy/Checkin
 * @param {ClientTypes} options.clientInfo.clientType The type of client connecting. (i.e. 'ADMIN'|'WEBAPP'|'GUEST'|'ACTIVATE'|'DESKTOP.OSX'|'DESKTOP.WINDOWS'|
 * 'DASH_DISPLAY'|'DASH_TABLET.IOS'|'DASH_TABLET.ANDROID'|'MOBILE.IOS'|'MOBILE.ANDROID'|'CHROME_EXTENSION'|'OUTLOOK'|'LS_220'|'ICON_600'|'ICON_700'|'GICON'|'SHARE')
 * @param {string} options.clientInfo.version Client build version number.
 * @param {object} [options.defaultVideoConstraints] default video constraints to use when no other video constraints have been selected by the user.
 * @example
 * // Regular login
 * import { createReduxStore, authActions } from 'lifesize-sky-nucleus';
 * let reduxStore = createReduxStore();
 * reduxStore.dispatch(initActions.initialize({environment: 'lifesizecloudbeta.com', version: '2.2.3', platform: 'IOS', localeCode: 'fr'}));
 * reduxStore.dispatch(authActions.login({sso: true}));
 */
function initialize(options) {
  var _options$clientInfo, _options$clientInfo2, _options$clientInfo3;

  var clientType = options === null || options === void 0 ? void 0 : (_options$clientInfo = options.clientInfo) === null || _options$clientInfo === void 0 ? void 0 : _options$clientInfo.clientType;

  if (!Object.values(_constants2.ClientTypes).includes(clientType)) {
    _jsLogger.default.error("\u26A0\uFE0F Nucleus Init Error: Please pass a options.clientInfo.clientType from @lifesize/constants {ClientTypes}; (You passed: ".concat(clientType, ")."));
  } // We do some config mapping here to ease backwards compatibility,
  // but really most of these could probably be merged in during createReduxStore


  (0, _cascadeConfig.setRuntimeConfig)({
    clientType: options === null || options === void 0 ? void 0 : (_options$clientInfo2 = options.clientInfo) === null || _options$clientInfo2 === void 0 ? void 0 : _options$clientInfo2.clientType,
    clientVersion: (options === null || options === void 0 ? void 0 : (_options$clientInfo3 = options.clientInfo) === null || _options$clientInfo3 === void 0 ? void 0 : _options$clientInfo3.version) || (options === null || options === void 0 ? void 0 : options.version),
    environment: options === null || options === void 0 ? void 0 : options.environment,
    platform: options === null || options === void 0 ? void 0 : options.platform
  });
  return {
    type: c.INIT_NUCLEUS,
    payload: options
  };
}

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(508));
__export(__webpack_require__(509));
__export(__webpack_require__(510));
__export(__webpack_require__(511));


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ClientTypes;
(function (ClientTypes) {
    ClientTypes["ADMIN"] = "ADMIN";
    ClientTypes["WEBAPP"] = "WEBAPP";
    ClientTypes["GUEST"] = "GUEST";
    ClientTypes["ACTIVATE"] = "ACTIVATE";
    ClientTypes["GO"] = "GO";
    ClientTypes["DESKTOP_OSX"] = "DESKTOP.OSX";
    ClientTypes["DESKTOP_WINDOWS"] = "DESKTOP.WINDOWS";
    ClientTypes["DASH_DISPLAY"] = "DASH_DISPLAY";
    ClientTypes["DASH_PRESENTER"] = "DASH_PRESENTER";
    ClientTypes["DASH_TABLET_IOS"] = "DASH_TABLET.IOS";
    ClientTypes["DASH_TABLET_ANDROID"] = "DASH_TABLET.ANDROID";
    ClientTypes["MOBILE_IOS"] = "MOBILE.IOS";
    ClientTypes["MOBILE_ANDROID"] = "MOBILE.ANDROID";
    ClientTypes["CHROME_EXTENSION"] = "CHROME_EXTENSION";
    ClientTypes["OUTLOOK"] = "OUTLOOK";
    ClientTypes["LS_220"] = "LS_220";
    ClientTypes["ICON_300"] = "ICON_300";
    ClientTypes["ICON_500"] = "ICON_500";
    ClientTypes["ICON_600"] = "ICON_600";
    ClientTypes["ICON_700"] = "ICON_700";
    ClientTypes["ICON_900"] = "ICON_900";
    ClientTypes["GICON"] = "GICON";
    ClientTypes["SHARE"] = "SHARE";
})(ClientTypes = exports.ClientTypes || (exports.ClientTypes = {}));


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Correspond to the 'types' of entities in the directory service
 * that can be called.
 */
var CallableTypes;
(function (CallableTypes) {
    CallableTypes["USER"] = "user";
    CallableTypes["MEETING"] = "meeting";
    CallableTypes["ROOM"] = "room";
    CallableTypes["PERSONAL"] = "personal";
    CallableTypes["GROUP"] = "group";
})(CallableTypes = exports.CallableTypes || (exports.CallableTypes = {}));


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Correspond to the 'usageType' property defined in devicePairing in the device service
 * services.lifesize_device/devicePairing/src/deviceConstants.ts
 */
var DeviceUsageTypes;
(function (DeviceUsageTypes) {
    DeviceUsageTypes["PERSONAL"] = "PERSONAL";
    DeviceUsageTypes["SHARED"] = "SHARED";
})(DeviceUsageTypes = exports.DeviceUsageTypes || (exports.DeviceUsageTypes = {}));
/**
 * Correspond to the 'pairingStatus' property defined in devicePairingStatus in the device service
 * services.lifesize_device/devicePairing/src/devicePairingStatus/devicePairingStatus.ts
 */
var DevicePairingStatusTypes;
(function (DevicePairingStatusTypes) {
    DevicePairingStatusTypes["BLOCKED"] = "BLOCKED";
    DevicePairingStatusTypes["COMPLETE"] = "COMPLETE";
    DevicePairingStatusTypes["DEFAULT"] = "DEFAULT";
    DevicePairingStatusTypes["DELETED"] = "DELETED";
    DevicePairingStatusTypes["NEW"] = "NEW";
})(DevicePairingStatusTypes = exports.DevicePairingStatusTypes || (exports.DevicePairingStatusTypes = {}));


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LicenseTypes;
(function (LicenseTypes) {
    LicenseTypes["LICENSE_TYPE_TRIAL"] = "TRIAL";
})(LicenseTypes = exports.LicenseTypes || (exports.LicenseTypes = {}));


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLocale = setLocale;
exports.setLocalization = setLocalization;

var c = _interopRequireWildcard(__webpack_require__(3));

/** @module actions/localization */

/**
 * Set Locale for nucleus localizations
 * @param {String} localeCode - one of [de,en,es,fr,it,no,pl,fi,sv,ja]
 */
// TODO: REMOVE. This is a legacy reference (goal is to use standardized languageId instead)
function setLocale(localeCode) {
  return {
    type: c.SET_LOCALE,
    payload: {
      localeCode: localeCode
    }
  };
}
/**
 * Set Localization
 * @param {String} languageId - one of the supported languageId codes in @lifesize/clients.localization
 */


function setLocalization(languageId) {
  return {
    type: c.SET_LOCALE,
    payload: {
      languageId: languageId
    }
  };
}

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMeeting = createMeeting;
exports.updateMeeting = updateMeeting;
exports.deleteMeeting = deleteMeeting;
exports.deleteMeetingList = deleteMeetingList;
exports.resetMeetingErrorState = resetMeetingErrorState;
exports.putMeetingsMaxInactiveDaysOTM = exports.putMeetingsMaxInactiveDays = exports.getMeetingsMaxInactiveDays = exports.getMeetingSettings = void 0;

var m = _interopRequireWildcard(__webpack_require__(3));

var _meetingsApi = __webpack_require__(514);

/**
 * Create Meeting
 * lifesize.meeting > meeting/create
 *
 * Meeting shape is as follows:
 *
 *  displayName: string;
 *  pin: string;
 *  sipUri: string;
 *  description?: string; // Optional
 *  tempMeeting: boolean;
 *  hiddenMeeting: boolean;
 *  moderatorExtension: string;
 *  ownerUserExtension: string;
 *  lecturerExtension: string;
 */
function createMeeting(meeting) {
  return (0, _meetingsApi.doMeetingsApiRequest)(meeting, m.MEETINGS_ENDPOINT, m.CREATE_MEETING_BEGIN, m.CREATE_MEETING_SUCCESS, m.CREATE_MEETING_FAILURE, m.HTTP_POST, m.CREATE_MEETING_SUFFIX);
}
/**
 * Update Meeting
 * lifesize.meeting > meeting/update
 */


function updateMeeting(payload) {
  return (0, _meetingsApi.doMeetingsApiRequest)(payload, m.MEETINGS_ENDPOINT, m.UPDATE_MEETING_BEGIN, m.UPDATE_MEETING_SUCCESS, m.UPDATE_MEETING_FAILURE, m.HTTP_POST, m.UPDATE_MEETING_SUFFIX);
}
/**
 * Delete Meeting
 * lifesize.meeting > meeting/delete
 */


function deleteMeeting(uuid) {
  return (0, _meetingsApi.doMeetingsApiRequest)(uuid, m.MEETINGS_ENDPOINT, m.DELETE_MEETING_BEGIN, m.DELETE_MEETING_SUCCESS, m.DELETE_MEETING_FAILURE, m.HTTP_POST, m.DELETE_MEETING_SUFFIX);
}
/**
 * Delete Meeting
 * lifesize.meeting > meeting/deletelist
 */


function deleteMeetingList(uuidArray) {
  return (0, _meetingsApi.doMeetingsApiRequest)(uuidArray, m.MEETINGS_ENDPOINT, m.DELETE_MEETING_BEGIN, m.DELETE_MEETING_SUCCESS, m.DELETE_MEETING_FAILURE, m.HTTP_POST, m.DELETE_MEETING_LIST_SUFFIX);
}
/**
 * Meeting settings
 */


var getMeetingSettings = function getMeetingSettings() {
  return (0, _meetingsApi.doMeetingsApiRequest)(null, m.MEETING_SETTINGS_ENDPOINT, m.GET_MEETING_SETTINGS_BEGIN, m.GET_MEETING_SETTINGS_SUCCESS, m.GET_MEETING_SETTINGS_FAILURE, m.HTTP_GET);
};
/**
 * Meeting settings
 * Max days inactive - get
 * return days - An integer of 0 to 365
 * '0' acts as 'no expiration'
 */


exports.getMeetingSettings = getMeetingSettings;

var getMeetingsMaxInactiveDays = function getMeetingsMaxInactiveDays() {
  return (0, _meetingsApi.doMeetingsApiRequest)(null, m.MEETING_SETTINGS_ENDPOINT, m.GET_MEETING_INACTIVE_DAYS_BEGIN, m.GET_MEETING_INACTIVE_DAYS_SUCCESS, m.GET_MEETING_INACTIVE_DAYS_FAILURE, m.HTTP_GET);
};
/**
 * Meeting settings
 * Max days inactive - set
 * @param days - An integer of 0 to 365
 * '0' acts as 'no expiration'
 */


exports.getMeetingsMaxInactiveDays = getMeetingsMaxInactiveDays;

var putMeetingsMaxInactiveDays = function putMeetingsMaxInactiveDays(days) {
  return (0, _meetingsApi.doMeetingsApiRequest)({
    maxInactiveDays: days
  }, m.MEETING_SETTINGS_ENDPOINT, m.SET_MEETING_INACTIVE_DAYS_BEGIN, m.SET_MEETING_INACTIVE_DAYS_SUCCESS, m.SET_MEETING_INACTIVE_DAYS_FAILURE, m.HTTP_POST);
};
/**
 * Meeting settings
 * Max days inactive for one-time meetings - set
 * @param days - An integer of 0 to 365
 * '0' acts as 'no expiration'
 */


exports.putMeetingsMaxInactiveDays = putMeetingsMaxInactiveDays;

var putMeetingsMaxInactiveDaysOTM = function putMeetingsMaxInactiveDaysOTM(days) {
  return (0, _meetingsApi.doMeetingsApiRequest)({
    maxInactiveDaysOTM: days
  }, m.MEETING_SETTINGS_ENDPOINT, m.SET_MEETING_INACTIVE_DAYS_OTM_BEGIN, m.SET_MEETING_INACTIVE_DAYS_OTM_SUCCESS, m.SET_MEETING_INACTIVE_DAYS_OTM_FAILURE, m.HTTP_POST);
};

exports.putMeetingsMaxInactiveDaysOTM = putMeetingsMaxInactiveDaysOTM;

function resetMeetingErrorState() {
  return function (dispatch) {
    dispatch({
      type: m.RESET_MEETING_ERROR_STATE
    });
  };
}

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.doMeetingsApiRequest = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _userProfile = __webpack_require__(52);

var c = _interopRequireWildcard(__webpack_require__(3));

var _proxy = __webpack_require__(21);

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _isEmpty = _interopRequireDefault(__webpack_require__(515));

var _isObject = _interopRequireDefault(__webpack_require__(58));

/**
 * Do API call with request object,
 * and redux actions to dispatch at various points in process.
 * The httpMethod argument, will treat request as string if GET,
 * or object if POST.
 * @param request - Request object used in POST to cloudvideos API
 * @param endpointUrl - Defaults to meetings endpoint, but can be overidden
 * @param actionBeginName - Action constant string for process start
 * @param actionSuccessName - Action constant string for process success
 * @param actionFailureName - Action constant string for process fail
 * @param httpMethod - is one of GET or POST
 * @param uriSuffix - (optional) As described in API docs for some operations
 */
var doMeetingsApiRequest = function doMeetingsApiRequest(request) {
  var endpointUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : c.MEETINGS_ENDPOINT;
  var actionBeginName = arguments.length > 2 ? arguments[2] : undefined;
  var actionSuccessName = arguments.length > 3 ? arguments[3] : undefined;
  var actionFailureName = arguments.length > 4 ? arguments[4] : undefined;
  var httpMethod = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : c.HTTP_GET;
  var uriSuffix = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
  var queryParams = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch, getState) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(0, _userProfile.selectIsGuest)(getState())) {
                  _context.next = 3;
                  break;
                }

                dispatch({
                  type: actionFailureName,
                  payload: {
                    message: 'Guest user cannot modify meetings'
                  }
                });
                return _context.abrupt("return");

              case 3:
                dispatch({
                  type: actionBeginName
                });
                return _context.abrupt("return", dispatch((0, _proxy.proxyApiCall)(endpointUrl, uriSuffix, httpMethod, request, queryParams)).then(function (response) {
                  // if the response is an empty object, respond with the request so the reducer can update the state
                  // (this is helpful for putMeetingsMaxInactiveDays since the WAMP response is {})
                  var payload = (0, _isObject.default)(response) && (0, _isEmpty.default)(response) ? request : response;
                  dispatch({
                    type: actionSuccessName,
                    payload: payload
                  });
                  return Promise.resolve(payload);
                }).catch(function (err) {
                  _jsLogger.default.info('Meetings api call failed:', err);

                  dispatch({
                    type: actionFailureName,
                    payload: err
                  });
                  return Promise.reject(err);
                }));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

exports.doMeetingsApiRequest = doMeetingsApiRequest;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(229),
    getTag = __webpack_require__(123),
    isArguments = __webpack_require__(139),
    isArray = __webpack_require__(43),
    isArrayLike = __webpack_require__(104),
    isBuffer = __webpack_require__(140),
    isPrototype = __webpack_require__(142),
    isTypedArray = __webpack_require__(185);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPairingCode = getPairingCode;
exports.getPairingStatusAndDetails = getPairingStatusAndDetails;
exports.getInvitationLink = getInvitationLink;
exports.mmsApiRequest = mmsApiRequest;
exports.mmsApiResponse = mmsApiResponse;
exports.mmsApiFailure = mmsApiFailure;
exports.mmsApiBegin = mmsApiBegin;

var c = _interopRequireWildcard(__webpack_require__(3));

var HttpUtils = _interopRequireWildcard(__webpack_require__(127));

var _pairedDevicesApi = __webpack_require__(198);

var _auth = __webpack_require__(31);

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

/** @module actions/mmsApi */

/**
 * getPairingCode (NOTE: will use values set in nucleus initialize action as default)
 * @param {string} serialNumber
 * @param {string} platform
 * @param {string} firmwareVersion
 */
function getPairingCode(serialNumber, platform, firmwareVersion) {
  return function (dispatch, getState) {
    var state = getState();
    var params = {};
    params.command = c.GET_PAIRING_CODE;
    params.queryParams = {
      serialNumber: serialNumber || (0, _safeAccess.default)(state, 'nucleus.device.serialNumber'),
      platform: platform || (0, _auth.getPlatform)(state),
      firmwareVersion: firmwareVersion || (0, _safeAccess.default)(state, 'nucleus.auth.version')
    };
    return dispatch(mmsApiRequest(params));
  };
}
/**
 * getPairingStatusAndDetails
 * @param {string} serialNumber
 * @param {string} sessionID
 */


function getPairingStatusAndDetails(serialNumber, sessionID) {
  return function (dispatch, getState) {
    var state = getState();
    var params = {};
    params.command = c.GET_PAIRING_STATUS_AND_DETAILS;
    params.queryParams = {
      serialNumber: serialNumber || (0, _safeAccess.default)(state, 'nucleus.device.serialNumber'),
      sessionID: sessionID || (0, _safeAccess.default)(state, 'nucleus.device.sessionID')
    };
    return dispatch(mmsApiRequest(params)).then(function () {
      return dispatch({
        type: c.PAIRING_SUCCESSFUL
      });
    });
  };
}
/**
 * MMS api request
 * getInvitationLink
 */


function getInvitationLink(isRenew) {
  return function (dispatch) {
    return dispatch((0, _pairedDevicesApi.doSimpleAPIRequest)(c.USER_INVITE_TOKEN_BEGIN, c.USER_INVITE_TOKEN_SUCCESS, c.USER_INVITE_TOKEN_FAILURE, c.USER_INVITE_TOKEN_ENDPOINT, c.HTTP_GET, undefined, {
      renew: isRenew
    }));
  };
}
/**
 * MMS api request
 * @param {object} params - query parameters
 */


function mmsApiRequest(params) {
  return function (dispatch, getState) {
    var state = getState().nucleus; // signal that we're beginning the api request

    dispatch(mmsApiBegin(params));
    var queryParams = HttpUtils.objectToUrlParameters(params.queryParams);
    var url = 'https://manage.' + state.cluster.url + '/api/' + params.command + queryParams;
    var fetchParams = {
      headers: {
        Accept: 'text/plain; charset=utf-8'
      },
      credentials: 'include'
    };

    if (params.requestMethod) {
      fetchParams.method = params.requestMethod;
    }

    if (params.contentType) {
      fetchParams.headers['Content-Type'] = params.contentType;
    }

    if (params.payload) {
      fetchParams.body = params.payload;
    } // issue request


    return fetch(url, fetchParams).then(HttpUtils.checkHttpStatus).then(function (response) {
      return response.text(); // DELETE requests do not return a json body
    }).then(function (resp) {
      var response = resp ? JSON.parse(resp) : {}; // note: this was originally returning a 403 for anything other than (response.RES && response.RES === 'OK'),
      // but our apis are inconsistent and .RES is not always available for successful api calls

      if (!(response.RES && response.RES !== 'OK')) {
        dispatch(mmsApiResponse(params, response));
        return Promise.resolve(response);
      } else {
        throw {
          message: response.MSG,
          response: {
            statusText: response.COD,
            status: 403
          }
        };
      }
    }).catch(function (err) {
      dispatch(mmsApiFailure(params, err));
      return Promise.reject(err);
    });
  };
}

function mmsApiResponse(params, response) {
  return {
    type: c.MMS_API_SUCCESS,
    payload: {
      params: params,
      response: response
    }
  };
}

function mmsApiFailure(params, error) {
  return {
    type: c.MMS_API_FAILURE,
    payload: {
      params: params,
      error: error
    }
  };
}

function mmsApiBegin(params) {
  return {
    type: c.MMS_API_BEGIN,
    payload: {
      params: params
    }
  };
}

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllStreams = getAllStreams;
exports.getQnATranscript = getQnATranscript;
exports.getStreamingSettings = getStreamingSettings;
exports.setStreamingSettings = setStreamingSettings;
exports.vcApiRequest = vcApiRequest;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var c = _interopRequireWildcard(__webpack_require__(3));

var HttpUtils = _interopRequireWildcard(__webpack_require__(127));

var _contacts = __webpack_require__(35);

var _currentUser = __webpack_require__(37);

var _dataWarehouse = __webpack_require__(272);

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

/** @module actions/vcApi */

/**
 * getAllStreams
 * @param {string} groupUUID
 */
function getAllStreams(groupUUID) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch, getState) {
        var state, domain, currentUser, uuid, params, resp;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                state = getState();
                domain = (0, _contacts.getDomain)(state);
                currentUser = (0, _currentUser.myInfo)(state);
                uuid = groupUUID || currentUser.groupId;
                params = {
                  command: "".concat(c.GET_ALL_STREAMS).concat(uuid)
                };
                dispatch({
                  type: c.DWH_ALL_STREAMS_REQUEST
                });
                _context.next = 9;
                return vcApiRequest(domain, params);

              case 9:
                resp = _context.sent;
                return _context.abrupt("return", dispatch({
                  type: c.DWH_ALL_STREAMS_SUCCESS,
                  payload: resp
                }));

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", dispatch({
                  type: c.DWH_ALL_STREAMS_FAILURE,
                  payload: _context.t0
                }));

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 13]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}
/**
 * getQnATranscript
 * @param {string} recordingUUID
 */


function getQnATranscript(recordingUUID) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch, getState) {
        var params, resp;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                params = {
                  command: "".concat(c.GET_QNA_TRANSCRIPT).concat(recordingUUID).concat(c.GET_QNA_TRANSCRIPT_SUFFIX)
                };
                dispatch({
                  type: c.DWH_STREAM_QUESTIONS_REQUEST
                });
                _context2.next = 5;
                return vcApiRequest((0, _contacts.getDomain)(getState()), params);

              case 5:
                resp = _context2.sent;
                return _context2.abrupt("return", dispatch({
                  type: c.DWH_STREAM_QUESTIONS_SUCCESS,
                  payload: resp
                }));

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", dispatch({
                  type: c.DWH_STREAM_QUESTIONS_FAILURE,
                  payload: _context2.t0
                }));

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 9]]);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}
/**
 * getStreamingSettings
 * @param {string} meetingUUID
 */


function getStreamingSettings(meetingUUID) {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(dispatch, getState) {
        var params, resp;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                params = {
                  command: "".concat(c.API_STREAMING_SETTINGS).concat(meetingUUID).concat(c.API_STREAMING_SETTINGS_SUFFIX)
                };
                dispatch({
                  type: c.DWH_STREAM_SETTINGS_REQUEST
                });
                _context3.next = 5;
                return vcApiRequest((0, _contacts.getDomain)(getState()), params);

              case 5:
                resp = _context3.sent;
                return _context3.abrupt("return", dispatch({
                  type: c.DWH_STREAM_SETTINGS_SUCCESS,
                  payload: resp
                }));

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", dispatch({
                  type: c.DWH_STREAM_SETTINGS_FAILURE,
                  payload: _context3.t0
                }));

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 9]]);
      }));

      return function (_x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
}
/**
 * setStreamingSettings
 * @param {string} meetingUUID
 * @param {object} settings
 */


function setStreamingSettings(meetingUUID, settings) {
  return (
    /*#__PURE__*/
    function () {
      var _ref4 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(dispatch, getState) {
        var params, state, domain, currentUser, streamSettingsObj, currentUUID, payload, resp;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                params = {
                  command: "".concat(c.API_STREAMING_SETTINGS).concat(meetingUUID).concat(c.API_STREAMING_SETTINGS_SUFFIX)
                };
                state = getState();
                domain = (0, _contacts.getDomain)(state);
                currentUser = (0, _currentUser.myInfo)(state);
                streamSettingsObj = (0, _dataWarehouse.streamSettings)(state);
                currentUUID = (0, _safeAccess.default)(streamSettingsObj, 'meeting_id');

                if (settings.streamingEnabled) {
                  _context4.next = 15;
                  break;
                }

                if (!(currentUUID === meetingUUID)) {
                  _context4.next = 12;
                  break;
                }

                params.requestMethod = c.HTTP_DELETE;
                _context4.next = 13;
                break;

              case 12:
                throw Error('Stream settings meeting UUID does not match meeting UUID being set');

              case 13:
                _context4.next = 19;
                break;

              case 15:
                // updating streaming
                payload = {
                  auth_type: settings.streamingPermissions,
                  auto_approve: settings.streamingQuestionsAutoApprove ? '1' : '0',
                  extension: (0, _safeAccess.default)(streamSettingsObj, 'extension') || settings.extension,
                  org: (0, _safeAccess.default)(streamSettingsObj, 'org') || currentUser.groupId,
                  pin: settings.streamingPermissionsPasscode,
                  qna: settings.streamingQuestionsEnabled ? '1' : '0',
                  token: settings.streamingToken
                };
                params.requestMethod = c.HTTP_POST;
                params.contentType = 'application/json; charset=utf-8';
                params.payload = JSON.stringify(payload);

              case 19:
                dispatch({
                  type: c.DWH_STREAM_SETTINGS_SET_REQUEST
                });
                _context4.next = 22;
                return vcApiRequest(domain, params);

              case 22:
                resp = _context4.sent;
                return _context4.abrupt("return", dispatch({
                  type: c.DWH_STREAM_SETTINGS_SET_SUCCESS,
                  payload: resp
                }));

              case 26:
                _context4.prev = 26;
                _context4.t0 = _context4["catch"](0);
                return _context4.abrupt("return", dispatch({
                  type: c.DWH_STREAM_SETTINGS_SET_FAILURE,
                  payload: _context4.t0
                }));

              case 29:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 26]]);
      }));

      return function (_x7, _x8) {
        return _ref4.apply(this, arguments);
      };
    }()
  );
}
/**
 * VC api request
 * @param {string} domain - cluster URL
 * @param {object} params - query parameters
 */


function vcApiRequest(_x9, _x10) {
  return _vcApiRequest.apply(this, arguments);
}

function _vcApiRequest() {
  _vcApiRequest = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee5(domain, params) {
    var queryParams, url, fetchParams, response;
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            queryParams = HttpUtils.objectToUrlParameters(params.queryParams);
            url = new URL("https://vc.".concat(domain, "/api/").concat(params.command).concat(queryParams));
            fetchParams = {
              headers: {
                Accept: 'text/plain; charset=utf-8'
              },
              credentials: 'include'
            };

            if (params.requestMethod) {
              fetchParams.method = params.requestMethod;
            }

            if (params.contentType) {
              fetchParams.headers['Content-Type'] = params.contentType;
            }

            if (params.payload) {
              fetchParams.body = params.payload;
            }

            _context5.next = 8;
            return fetch(url, fetchParams);

          case 8:
            response = _context5.sent;
            _context5.next = 11;
            return HttpUtils.checkHttpStatus(response);

          case 11:
            response = _context5.sent;
            _context5.next = 14;
            return response.text();

          case 14:
            response = _context5.sent;
            // DELETE requests do not return a json body
            response = response ? JSON.parse(response) : {}; // note: this was originally returning a 403 for anything other than (response.RES && response.RES === 'OK'),
            // but our apis are inconsistent and .RES is not always available for successful api calls

            if (response.RES && response.RES !== 'OK') {
              _context5.next = 20;
              break;
            }

            return _context5.abrupt("return", response);

          case 20:
            throw {
              message: response.MSG,
              response: {
                statusText: response.COD,
                status: 403
              }
            };

          case 21:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _vcApiRequest.apply(this, arguments);
}

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.online = online;
exports.offline = offline;

var c = _interopRequireWildcard(__webpack_require__(3));

function online() {
  return {
    type: c.NETWORK_ONLINE
  };
}

function offline() {
  return {
    type: c.NETWORK_OFFLINE
  };
}

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPairedDevices = getPairedDevices;
exports.createDevicePairing = createDevicePairing;
exports.createSharedDevicePairing = createSharedDevicePairing;
exports.renameDevice = renameDevice;
exports.deleteDevicePairing = deleteDevicePairing;
exports.removeDevice = removeDevice;
exports.getDashLicenses = getDashLicenses;
exports.resetPairedDevicesErrorState = resetPairedDevicesErrorState;

var c = _interopRequireWildcard(__webpack_require__(3));

var _pairedDevicesApi = __webpack_require__(198);

/** @module actions/pairedDevices */
function getPairedDevices() {
  return (0, _pairedDevicesApi.doDeviceApiRequest)(null, c.GET_PAIRED_DEVICES_BEGIN, c.GET_PAIRED_DEVICES_SUCCESS, c.GET_PAIRED_DEVICES_FAILURE, c.PAIRED_DEVICES_ENDPOINT, c.HTTP_GET, c.GET_PAIRED_DEVICES_SUFFIX);
}
/**
 * Add the device to cloud
 * @param pairingCode - pairing code
 * @param connectionsID - connectionsID
 */


function createDevicePairing(pairingCode, connectionsID) {
  return (0, _pairedDevicesApi.doDeviceApiRequest)(null, c.DEVICE_PAIRING_BEGIN, c.DEVICE_PAIRING_SUCCESS, c.DEVICE_PAIRING_FAILURE, c.PAIRED_DEVICES_ENDPOINT, c.HTTP_POST, c.DEVICE_PAIRING_SUFFIX, {
    pairingCode: pairingCode,
    connectionsID: connectionsID
  });
}
/**
 * Add the device to cloud
 * @param pairingCode - pairing code
 * @param systemName - systemName
 * @param email - email
 */


function createSharedDevicePairing(pairingCode, systemName, email) {
  var payload = {
    pairingCode: pairingCode,
    systemName: systemName
  };

  if (email) {
    payload.email = email;
  }

  return (0, _pairedDevicesApi.doDeviceApiRequest)(null, c.DEVICE_PAIRING_BEGIN, c.DEVICE_PAIRING_SUCCESS, c.DEVICE_PAIRING_FAILURE, c.PAIRED_DEVICES_ENDPOINT, c.HTTP_POST, c.DEVICE_SHARED_PAIRING_SUFFIX, payload);
}
/**
 /**
 * rename the device from cloud
 * @param serialNumber
 * @param systemName
 */


function renameDevice(serialNumber, systemName) {
  return (0, _pairedDevicesApi.doDeviceApiRequest)(null, c.RENAME_DEVICE_BEGIN, c.RENAME_DEVICE_SUCCESS, c.RENAME_DEVICE_FAILURE, c.PAIRED_DEVICES_ENDPOINT, c.HTTP_POST, c.RENAME_DEVICE_SUFFIX, {
    serialNumber: serialNumber,
    systemName: systemName
  });
}
/**
 * Remove the device from cloud
 * @param payload - payload
 */


function deleteDevicePairing(payload) {
  return (0, _pairedDevicesApi.doDeviceApiRequest)(null, c.DELETE_DEVICE_PAIRING_BEGIN, c.DELETE_DEVICE_PAIRING_SUCCESS, c.DELETE_DEVICE_PAIRING_FAILURE, c.PAIRED_DEVICES_ENDPOINT, c.HTTP_POST, c.DELETE_DEVICE_PAIRING_SUFFIX, payload);
}
/**
 * Remove the device from cloud
 * @param payload - payload
 */


function removeDevice(payload) {
  return (0, _pairedDevicesApi.doDeviceApiRequest)(null, c.REMOVE_DEVICE_BEGIN, c.REMOVE_DEVICE_SUCCESS, c.REMOVE_DEVICE_FAILURE, c.PAIRED_DEVICES_ENDPOINT, c.HTTP_POST, c.REMOVE_DEVICE_SUFFIX, payload);
}
/**
 * Get the number of licenses available and consumed for dash
 */


function getDashLicenses() {
  return (0, _pairedDevicesApi.doLicenseApiRequest)(c.GET_PAIRED_DEVICE_LICENSE_COUNT_BEGIN, c.GET_PAIRED_DEVICE_LICENSE_COUNT_SUCCESS, c.GET_PAIRED_DEVICE_LICENSE_COUNT_FAILURE, c.PAIRED_DEVICE_LICENSES_ENDPOINT + c.PAIRED_DEVICE_LICENSES_COUNT_SUFFIX, c.HTTP_GET, '/');
}

function resetPairedDevicesErrorState() {
  return function (dispatch) {
    dispatch({
      type: c.DEVICE_PAIRING_RESET_ERROR_STATE
    });
  };
}

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePreferredPstnNumbers = exports.getAll = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var c = _interopRequireWildcard(__webpack_require__(3));

var _get2 = _interopRequireDefault(__webpack_require__(11));

var proxyActions = _interopRequireWildcard(__webpack_require__(21));

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _pstnNumbers = __webpack_require__(245);

/**
 * Thunk that retrieves the full list of PSTN numbers.
 * @returns {Array} Array containing all the PSTN number records.
 */
var getAll = function getAll() {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch, getState) {
        var state, groupUUID, apiCall, response, payload, localeCode, result;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                state = getState();
                groupUUID = (0, _get2.default)(state, 'nucleus.userProfile.groupUuid');
                apiCall = proxyActions.proxyApiCall(c.PSTN_SERVICE_ENDPOINT, 'all', c.HTTP_GET, {
                  groupUUID: groupUUID,
                  galaxy: true
                });
                _context.prev = 3;
                _context.next = 6;
                return dispatch(apiCall);

              case 6:
                response = _context.sent;

                if (!(response.statusCode === 200)) {
                  _context.next = 14;
                  break;
                }

                payload = (0, _get2.default)(response, 'body.list', []);
                localeCode = (0, _get2.default)(state, 'nucleus.localization.localeCode');
                result = (0, _pstnNumbers.addCountryNames)(payload, localeCode);
                return _context.abrupt("return", result);

              case 14:
                throw response;

              case 15:
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](3);

                _jsLogger.default.error(_context.t0);

                throw _context.t0;

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 17]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};
/**
 * Thunk that updates the preferred PSTN numbers for the account.
 * @param {string[]} ids
 */


exports.getAll = getAll;

var updatePreferredPstnNumbers = function updatePreferredPstnNumbers(ids) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch) {
        var queryParams, apiCall, response, parsedResponse;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (ids) {
                  _context2.next = 2;
                  break;
                }

                throw new Error("Invalid argument ids = ".concat(ids));

              case 2:
                queryParams = JSON.stringify({
                  ids: ids
                });
                apiCall = proxyActions.proxyApiCall(c.PSTN_SERVICE_ADMIN_ENDPOINT, 'phoneNumbers/set', c.HTTP_PUT, undefined, queryParams);
                _context2.prev = 4;
                _context2.next = 7;
                return dispatch(apiCall);

              case 7:
                response = _context2.sent;
                // The response comes back as a string for some reason, so we need to parse
                parsedResponse = JSON.parse(response);

                if (!((0, _get2.default)(parsedResponse, 'statusCode') === 200)) {
                  _context2.next = 13;
                  break;
                }

                return _context2.abrupt("return", parsedResponse);

              case 13:
                throw response;

              case 14:
                _context2.next = 20;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](4);

                _jsLogger.default.error('Error updating preferred PSTN numbers', _context2.t0);

                throw _context2.t0;

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[4, 16]]);
      }));

      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
};

exports.updatePreferredPstnNumbers = updatePreferredPstnNumbers;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.invite = invite;

var proxyActions = _interopRequireWildcard(__webpack_require__(21));

var c = _interopRequireWildcard(__webpack_require__(3));

/**
 * send an sms text or email invite to a list of users
 * @param {array} list - The list of people to invite (email addresses)
 * @param {string} url - The url to send to the invitees
 * @param {string} name - The name of the person sending the invitations
 * @param {string} message - A custom message to pass along in the invite
 */
function invite(list, url, name, message) {
  return function (dispatch) {
    return dispatch(proxyActions.proxyApiCall(c.PUSH_SERVICE_ENDPOINT, c.PUSH_INVITATION_PATH, c.GALAXY_HTTP_METHOD_DEFAULT, {
      invite: {
        list: list,
        url: url,
        name: name,
        message: message
      }
    }));
  };
}

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchVideoWatchList = fetchVideoWatchList;
exports.fetchMyRecordings = fetchMyRecordings;
exports.fetchSingleRecording = fetchSingleRecording;
exports.fetchRelatedRecordings = fetchRelatedRecordings;
exports.addToWatchList = addToWatchList;
exports.removeFromWatchList = removeFromWatchList;
exports.deleteRecording = deleteRecording;
exports.likeVideo = likeVideo;
exports.getShareLinksForCloudGroup = getShareLinksForCloudGroup;
exports.getShareLinksGlobal = getShareLinksGlobal;
exports.getShareProperties = getShareProperties;
exports.setShareProperties = setShareProperties;
exports.getVideoProperties = getVideoProperties;
exports.setVideoProperties = setVideoProperties;
exports.searchCloudUsers = searchCloudUsers;
exports.searchCloudMeetings = searchCloudMeetings;
exports.getMeetingShareProperties = getMeetingShareProperties;
exports.setMeetingShareProperties = setMeetingShareProperties;
exports.resetVideoPropsErrorState = resetVideoPropsErrorState;
exports.resetRecordingsDeleteErrorState = resetRecordingsDeleteErrorState;
exports.fetchFeed = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _get = _interopRequireDefault(__webpack_require__(11));

var r = _interopRequireWildcard(__webpack_require__(3));

var _recordingsApi = __webpack_require__(523);

var _userProfile = __webpack_require__(52);

var _recordings = __webpack_require__(275);

/**
 * Returns a list of videos that are marked as 'watch later'
 * @param request - the 'feed' param is set to 'wlater'
 */
function fetchVideoWatchList(request) {
  return (0, _recordingsApi.doRecordingsApiRequest)(request, r.RECORDINGS_FETCH_WATCH_LIST_BEGIN, r.RECORDINGS_FETCH_WATCH_LIST_SUCCESS, r.RECORDINGS_FETCH_WATCH_LIST_FAILED, r.RECORDINGS_FETCH_ENDPOINT, r.HTTP_POST);
}

var fetchFeed = function fetchFeed(request) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch, getState) {
        var state, apiUrl, requestIndex, response;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                state = getState();
                apiUrl = (0, _recordingsApi.getApiUrl)((0, _get.default)(state, 'nucleus.cluster.url'));
                requestIndex = (0, _recordings.selectFeedRequestIndex)(state) + 1;
                dispatch({
                  type: r.RECORDINGS_FETCH_FEED_BEGIN,
                  payload: {
                    requestIndex: requestIndex
                  }
                });
                _context.prev = 4;

                if (!(0, _userProfile.selectIsGuest)(state)) {
                  _context.next = 7;
                  break;
                }

                throw {
                  message: 'Guest user cannot fetch recordings'
                };

              case 7:
                _context.next = 9;
                return (0, _recordingsApi.recordingsApiPost)(apiUrl, JSON.stringify(request));

              case 9:
                response = _context.sent;
                dispatch({
                  type: r.RECORDINGS_FETCH_FEED_SUCCESS,
                  payload: (0, _objectSpread2.default)({}, response, {
                    requestIndex: requestIndex
                  })
                });
                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](4);
                dispatch({
                  type: r.RECORDINGS_FETCH_FEED_FAILED,
                  payload: (0, _objectSpread2.default)({}, _context.t0, {
                    requestIndex: requestIndex
                  })
                });
                Promise.reject(_context.t0);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 13]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};
/**
 * Returns a list of videos that are marked as 'My Recordings'
 * @param request - the 'feed' param is set to 'owned'
 */


exports.fetchFeed = fetchFeed;

function fetchMyRecordings(request) {
  return (0, _recordingsApi.doRecordingsApiRequest)(request, r.RECORDINGS_FETCH_MY_RECORDINGS_BEGIN, r.RECORDINGS_FETCH_MY_RECORDINGS_SUCCESS, r.RECORDINGS_FETCH_MY_RECORDINGS_FAILED, r.RECORDINGS_FETCH_ENDPOINT, r.HTTP_POST);
}
/**
 * Fetch a single recording
 * @param request - string of unique recording identifier
 */


function fetchSingleRecording(request, shareToken) {
  var endpoint = shareToken ? "".concat(r.RECORDINGS_FETCH_SINGLE_ENDPOINT).concat(request, "?sharetoken=").concat(shareToken) : "".concat(r.RECORDINGS_FETCH_SINGLE_ENDPOINT).concat(request);
  return (0, _recordingsApi.doRecordingsApiRequest)(request, r.RECORDINGS_FETCH_SINGLE_BEGIN, r.RECORDINGS_FETCH_SINGLE_SUCCESS, r.RECORDINGS_FETCH_SINGLE_FAILED, endpoint, r.HTTP_GET);
}
/**
 * Fetch related recordings
 * @param request - string of unique recording identifier
 */


function fetchRelatedRecordings(request) {
  return (0, _recordingsApi.doRecordingsApiRequest)(request, r.RECORDINGS_FETCH_RELATED_BEGIN, r.RECORDINGS_FETCH_RELATED_SUCCESS, r.RECORDINGS_FETCH_RELATED_FAILED, "".concat(r.RECORDINGS_FETCH_RELATED_ENDPOINT).concat(request, "/in/all"), r.HTTP_GET);
}
/**
 * Add a single recording to the watch later list
 * @param request - string of unique recording identifier
 */


function addToWatchList(request) {
  return (0, _recordingsApi.doRecordingsApiRequest)(request, r.RECORDINGS_ADD_TO_WATCHLIST_BEGIN, r.RECORDINGS_ADD_TO_WATCHLIST_SUCCESS, r.RECORDINGS_ADD_TO_WATCHLIST_FAILED, "".concat(r.RECORDINGS_ADD_TO_WATCH_ENDPOINT).concat(request), r.HTTP_GET);
}
/**
 * Remove a single recording from the watch later list
 * @param request - string of unique recording identifier
 */


function removeFromWatchList(request) {
  return (0, _recordingsApi.doRecordingsApiRequest)(request, r.RECORDINGS_REMOVE_FROM_WATCHLIST_BEGIN, r.RECORDINGS_REMOVE_FROM_WATCHLIST_SUCCESS, r.RECORDINGS_REMOVE_FROM_WATCHLIST_FAILED, "".concat(r.RECORDINGS_ADD_TO_WATCH_ENDPOINT).concat(request), r.HTTP_DELETE);
}
/**
 * Delete a single recording
 * @param request - string of unique recording identifier
 */


function deleteRecording(request) {
  return (0, _recordingsApi.doRecordingsApiRequest)(request, r.RECORDINGS_DELETE_RECORDING_BEGIN, r.RECORDINGS_DELETE_RECORDING_SUCCESS, r.RECORDINGS_DELETE_RECORDING_FAILED, "".concat(r.RECORDINGS_DELETE_ENDPOINT).concat(request), r.HTTP_GET);
}
/**
 * Like a particular recording
 * @param request - String for HTTP Get - recording id
 */


function likeVideo(request) {
  return (0, _recordingsApi.doRecordingsApiRequest)(request, r.VIDEO_LIKE_BEGIN, r.VIDEO_LIKE_SUCCESS, r.VIDEO_LIKE_FAILED, "".concat(r.VIDEO_LIKE_ENDPOINT).concat(request), r.HTTP_GET);
}
/**
 * Generate a new shareable URL for use within a cloud group
 * @param request - String for HTTP Get
 */


function getShareLinksForCloudGroup(request) {
  return (0, _recordingsApi.doRecordingsApiRequest)({
    refreshurls: []
  }, r.VIDEO_GET_SHARE_LINK_GROUP_BEGIN, r.VIDEO_GET_SHARE_LINK_GROUP_SUCCESS, r.VIDEO_GET_SHARE_LINK_GROUP_FAILED, "".concat(r.SHARE_URLS_ENDPOINT).concat(request), r.HTTP_POST);
}
/**
 * Generate a new shareable URL for public use
 * @param request - String for HTTP Get
 */


function getShareLinksGlobal(request) {
  return (0, _recordingsApi.doRecordingsApiRequest)({
    refreshPublicUrls: []
  }, r.VIDEO_GET_SHARE_LINK_GLOBAL_BEGIN, r.VIDEO_GET_SHARE_LINK_GLOBAL_SUCCESS, r.VIDEO_GET_SHARE_LINK_GLOBAL_FAILED, "".concat(r.SHARE_URLS_ENDPOINT).concat(request), r.HTTP_POST);
}
/**
 * Get the share properties particular video,
 * Includes share URLs
 * @param request - String for HTTP Get - Video ID
 */


function getShareProperties(request) {
  return (0, _recordingsApi.doRecordingsApiRequest)(request, r.VIDEO_GET_SHARE_PROPS_BEGIN, r.VIDEO_GET_SHARE_PROPS_SUCCESS, r.VIDEO_GET_SHARE_PROPS_FAILED, "".concat(r.SHARE_URLS_ENDPOINT).concat(request), r.HTTP_GET);
}
/**
 * Update the share properties of a particular video
 * @param request - Object for HTTP Post
 */


function setShareProperties(request, post_data) {
  return (0, _recordingsApi.doRecordingsApiRequest)(post_data, r.VIDEO_UPDATE_SHARE_PROPS_BEGIN, r.VIDEO_UPDATE_SHARE_PROPS_SUCCESS, r.VIDEO_UPDATE_SHARE_PROPS_FAILED, "".concat(r.SHARE_URLS_ENDPOINT).concat(request), r.HTTP_POST);
}
/**
 * Get the properties for a specific video
 * @param request - string of unique recording identifier
 */


function getVideoProperties(request) {
  return (0, _recordingsApi.doRecordingsApiRequest)(request, r.VIDEO_GET_PROPS_BEGIN, r.VIDEO_GET_PROPS_SUCCESS, r.VIDEO_GET_PROPS_FAILED, "".concat(r.VIDEO_PROPERTIES_ENDPOINT).concat(request), r.HTTP_GET);
}
/**
 * Set (update) the properties for a specific video
 * @param request - Object for HTTP Post
 */


function setVideoProperties(request, post_data) {
  return (0, _recordingsApi.doRecordingsApiRequest)(post_data, r.VIDEO_SET_PROPS_BEGIN, r.VIDEO_SET_PROPS_SUCCESS, r.VIDEO_SET_PROPS_FAILED, "".concat(r.VIDEO_PROPERTIES_ENDPOINT).concat(request), r.HTTP_POST);
}

function searchCloudUsers(request) {
  return (0, _recordingsApi.doRecordingsApiRequest)(request, r.VIDEO_GET_CLOUD_USERS_BEGIN, r.VIDEO_GET_CLOUD_USERS_SUCCESS, r.VIDEO_GET_CLOUD_USERS_FAILED, "".concat(r.SEARCH_CLOUD_USERS_ENDPOINT).concat(request), r.HTTP_GET);
}

function searchCloudMeetings(request) {
  return (0, _recordingsApi.doRecordingsApiRequest)(request, r.VIDEO_GET_CLOUD_MEETINGS_BEGIN, r.VIDEO_GET_CLOUD_MEETINGS_SUCCESS, r.VIDEO_GET_CLOUD_MEETINGS_FAILED, "".concat(r.SEARCH_CLOUD_MEETINGS_ENDPOINT).concat(request), r.HTTP_GET);
}
/**
 * Get the properties for a meeting
 * @param request - string of unique recording identifier
 */


function getMeetingShareProperties(request) {
  return (0, _recordingsApi.doRecordingsApiRequest)(request, r.VIDEO_GET_MEETING_SHARE_PROPS_BEGIN, r.VIDEO_GET_MEETING_SHARE_PROPS_SUCCESS, r.VIDEO_GET_MEETING_SHARE_PROPS_FAILED, "".concat(r.MEETING_RECORDING_PROPS_ENDPOINT).concat(request), r.HTTP_GET);
}
/**
 * Post the properties for a meeting
 * @param request - string of unique recording identifier
 * @param post_data - object of properties to set
 */


function setMeetingShareProperties(request, post_data) {
  return (0, _recordingsApi.doRecordingsApiRequest)(post_data, r.VIDEO_POST_MEETING_SHARE_PROPS_BEGIN, r.VIDEO_POST_MEETING_SHARE_PROPS_SUCCESS, r.VIDEO_POST_MEETING_SHARE_PROPS_FAILED, "".concat(r.MEETING_RECORDING_PROPS_ENDPOINT).concat(request), r.HTTP_POST);
}

function resetVideoPropsErrorState() {
  return function (dispatch) {
    dispatch({
      type: r.RESET_VIDEO_PROPS_ERROR_STATE
    });
  };
}

function resetRecordingsDeleteErrorState() {
  return function (dispatch) {
    dispatch({
      type: r.RESET_RECORDINGS_DELETE_ERROR_STATE
    });
  };
}

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getApiUrl = exports.recordingsApiPost = exports.doRecordingsApiRequest = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _userProfile = __webpack_require__(52);

var r = _interopRequireWildcard(__webpack_require__(3));

var HttpUtils = _interopRequireWildcard(__webpack_require__(127));

/**
 * @param type - The Redux action constant name
 * @param error - The error object
 * @return {{type: *, payload: object}}
 */
var getErrorAction = function getErrorAction(type, error) {
  return {
    type: type,
    payload: error
  };
};
/**
 * Do API call to cloudvideos, with request object,
 * and redux actions to dispatch at various points in process.
 * Last argument, will treat request as string if GET,
 * or object if POST.
 * @param request - Request object used in POST to cloudvideos API
 * @param actionBeginName - Action constant string for process start
 * @param actionSuccessName - Action constant string for process success
 * @param actionFailureName - Action constant string for process fail
 * @param httpMethod - is one of GET or POST
 */


var doRecordingsApiRequest = function doRecordingsApiRequest(request, actionBeginName, actionSuccessName, actionFailureName) {
  var endpointUrl = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : r.RECORDINGS_FETCH_ENDPOINT;
  var httpMethod = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : r.HTTP_POST;
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch, getState) {
        var doFetch, processHttpStatus, processResponse, fetchResult, checkStatusResult, processStatusResult;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dispatch({
                  type: actionBeginName
                });

                if (!(0, _userProfile.selectIsGuest)(getState())) {
                  _context2.next = 4;
                  break;
                }

                dispatch(getErrorAction(actionFailureName, {
                  message: 'Guest user cannot fetch recordings'
                }));
                return _context2.abrupt("return");

              case 4:
                doFetch =
                /*#__PURE__*/
                function () {
                  var _ref2 = (0, _asyncToGenerator2.default)(
                  /*#__PURE__*/
                  _regenerator.default.mark(function _callee() {
                    var endpoint, url, isPostRequest;
                    return _regenerator.default.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            endpoint = r.VC_HOST_ENDPOINT_NON_PROD;

                            if ((0, _safeAccess.default)(getState(), 'nucleus.cluster.url') === r.PROD_CLUSTER_URL) {
                              endpoint = r.VC_HOST_ENDPOINT_PROD;
                            } // Use the response to now call to get the feed


                            url = "https://".concat(endpoint).concat(endpointUrl);
                            isPostRequest = httpMethod === r.HTTP_POST;
                            _context.next = 6;
                            return fetch(url, {
                              credentials: 'include',
                              headers: {
                                Accept: 'text/plain; charset=utf-8',
                                'Content-Type': 'application/json'
                              },
                              method: httpMethod,
                              body: isPostRequest ? JSON.stringify(request) : null
                            });

                          case 6:
                            return _context.abrupt("return", _context.sent);

                          case 7:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function doFetch() {
                    return _ref2.apply(this, arguments);
                  };
                }();

                processHttpStatus = function processHttpStatus(response) {
                  //To handle potential empty responses from GET requests
                  var _parseJSON = function _parseJSON(response) {
                    return response.text().then(function (text) {
                      return text ? JSON.parse(text) : {};
                    });
                  };

                  return _parseJSON(response);
                };

                processResponse = function processResponse(response) {
                  dispatch({
                    type: actionSuccessName,
                    payload: response
                  });
                };

                _context2.prev = 7;
                _context2.next = 10;
                return doFetch();

              case 10:
                fetchResult = _context2.sent;
                _context2.next = 13;
                return HttpUtils.checkHttpStatus(fetchResult);

              case 13:
                checkStatusResult = _context2.sent;
                _context2.next = 16;
                return processHttpStatus(checkStatusResult);

              case 16:
                processStatusResult = _context2.sent;
                _context2.next = 19;
                return processResponse(processStatusResult);

              case 19:
                _context2.next = 25;
                break;

              case 21:
                _context2.prev = 21;
                _context2.t0 = _context2["catch"](7);
                dispatch(getErrorAction(actionFailureName, _context2.t0));
                return _context2.abrupt("return", Promise.reject(_context2.t0));

              case 25:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[7, 21]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

exports.doRecordingsApiRequest = doRecordingsApiRequest;

var recordingsApiPost =
/*#__PURE__*/
function () {
  var _ref3 = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee3(url, body) {
    var responseStream, data;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return fetch(url, {
              credentials: 'include',
              headers: {
                Accept: 'text/plain; charset=utf-8',
                'Content-Type': 'application/json'
              },
              method: r.HTTP_POST,
              body: body
            });

          case 2:
            responseStream = _context3.sent;
            _context3.next = 5;
            return HttpUtils.checkHttpStatus(responseStream);

          case 5:
            _context3.next = 7;
            return responseStream.json();

          case 7:
            data = _context3.sent;
            return _context3.abrupt("return", data || {});

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function recordingsApiPost(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();

exports.recordingsApiPost = recordingsApiPost;

var getApiUrl = function getApiUrl(clusterUrl) {
  var prod = clusterUrl === r.PROD_CLUSTER_URL;
  var endpoint = prod ? r.VC_HOST_ENDPOINT_PROD : r.VC_HOST_ENDPOINT_NON_PROD;
  return "https://".concat(endpoint).concat(r.RECORDINGS_FETCH_ENDPOINT);
};

exports.getApiUrl = getApiUrl;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setVCSettings = exports.getVCSettings = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var m = _interopRequireWildcard(__webpack_require__(3));

var c = m;

var _userProfile = __webpack_require__(52);

var _proxy = __webpack_require__(21);

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

/**
 * Do API call with request object,
 * and redux actions to dispatch at various points in process.
 * @param request - Request object used in POST call
 * @param endpointUrl - Defaults to recordings auth endpoint, but can be overidden
 * @param actionBeginName - Action constant string for process start
 * @param actionSuccessName - Action constant string for process success
 * @param actionFailureName - Action constant string for process fail
 * @param httpMethod - is one of GET or POST
 * @param uriSuffix - (optional) As described in API docs for some operations
 */
var doRecordingsAuthApiRequest = function doRecordingsAuthApiRequest(request) {
  var endpointUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : c.RECORDING_AUTH_ENDPOINT;
  var actionBeginName = arguments.length > 2 ? arguments[2] : undefined;
  var actionSuccessName = arguments.length > 3 ? arguments[3] : undefined;
  var actionFailureName = arguments.length > 4 ? arguments[4] : undefined;
  var httpMethod = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : c.HTTP_GET;
  var uriSuffix = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : c.RECORDING_AUTH_URI_SUFFIX;
  var queryParams = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch, getState) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(0, _userProfile.selectIsGuest)(getState())) {
                  _context.next = 3;
                  break;
                }

                dispatch({
                  type: actionFailureName,
                  payload: {
                    message: 'Guest user cannot access RecordingsAuth settings'
                  }
                });
                return _context.abrupt("return");

              case 3:
                dispatch({
                  type: actionBeginName
                });
                return _context.abrupt("return", dispatch((0, _proxy.proxyApiCall)(endpointUrl, uriSuffix, httpMethod, request, queryParams)).then(function (response) {
                  dispatch({
                    type: actionSuccessName,
                    payload: response
                  });
                }).catch(function (err) {
                  _jsLogger.default.info('RecordingsAuth api call failed:', err);

                  dispatch({
                    type: actionFailureName,
                    payload: err
                  });
                }));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};
/**
 * Get Video VC settings
 * Includes recordings token in response
 */


var getVCSettings = function getVCSettings() {
  return doRecordingsAuthApiRequest({}, m.RECORDING_AUTH_ENDPOINT, m.VC_SETTINGS_FETCH_BEGIN, m.VC_SETTINGS_FETCH_SUCCESS, m.VC_SETTINGS_FETCH_FAILED);
};
/**
 * Set Video VC settings
 * Includes recordings token in response
 */


exports.getVCSettings = getVCSettings;

var setVCSettings = function setVCSettings(post) {
  return doRecordingsAuthApiRequest(post, m.RECORDING_AUTH_ENDPOINT, m.VC_SETTINGS_UPDATE_BEGIN, m.VC_SETTINGS_UPDATE_SUCCESS, m.VC_SETTINGS_UPDATE_FAILED, c.HTTP_PUT, c.RECORDING_AUTH_SET_URI_SUFFIX);
};

exports.setVCSettings = setVCSettings;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentUserSettings = getCurrentUserSettings;
exports.updateCurrentUserSettings = updateCurrentUserSettings;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _proxy = __webpack_require__(21);

var c = _interopRequireWildcard(__webpack_require__(3));

var _currentUser = __webpack_require__(37);

var _userProfile = __webpack_require__(52);

var _feature = __webpack_require__(74);

/** @module actions/userSettings */
function getCurrentUserSettings() {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch, getState) {
        var userSettingsService, isGuest, response;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                userSettingsService = (0, _feature.getFeatureFlag)(getState())(c.FEATUREFLAG_USE_USER_SETTINGS_SERVICE);
                isGuest = (0, _userProfile.selectIsGuest)(getState());

                if (!(!userSettingsService || isGuest)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", Promise.resolve());

              case 4:
                dispatch({
                  type: c.GET_CURRENT_USER_SETTINGS_BEGIN
                });
                _context.prev = 5;
                _context.next = 8;
                return dispatch((0, _proxy.proxyApiCall)(c.USER_SETTINGS_ENDPOINT, '', 'GET'));

              case 8:
                response = _context.sent;
                dispatch({
                  type: c.GET_CURRENT_USER_SETTINGS_SUCCESS,
                  payload: {
                    response: JSON.parse(response)
                  }
                });
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](5);
                dispatch({
                  type: c.GET_CURRENT_USER_SETTINGS_FAILURE,
                  payload: {
                    error: _context.t0
                  }
                });
                throw _context.t0;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 12]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}

function updateCurrentUserSettings(settings) {
  return function (dispatch, getState) {
    var userSettingsService = (0, _feature.getFeatureFlag)(getState())(c.FEATUREFLAG_USE_USER_SETTINGS_SERVICE);
    var currentUser = (0, _currentUser.myInfo)(getState());
    var isGuest = (0, _userProfile.selectIsGuest)(getState());
    var currentSettings = (0, _safeAccess.default)(currentUser, 'userSettings');
    var newSettings = Object.assign({}, currentSettings, settings);
    dispatch({
      type: c.UPDATE_CURRENT_USER_SETTINGS_BEGIN,
      payload: {
        response: {
          userSettings: newSettings
        }
      }
    });

    if (!userSettingsService || isGuest) {
      dispatch({
        type: c.UPDATE_CURRENT_USER_SETTINGS_SUCCESS,
        payload: {
          response: {
            userSettings: newSettings
          }
        }
      });
      return Promise.resolve();
    } // No ID required, this is retrieved from Nucleus Proxy header


    return dispatch((0, _proxy.proxyApiCall)(c.USER_SETTINGS_ENDPOINT, '', 'POST', {
      settings: newSettings
    })).then(function (result) {
      dispatch({
        type: c.UPDATE_CURRENT_USER_SETTINGS_SUCCESS,
        payload: {
          response: JSON.parse(result)
        }
      });
    }).catch(function (error) {
      dispatch({
        type: c.UPDATE_CURRENT_USER_SETTINGS_FAILURE,
        payload: {
          error: error
        }
      });
    });
  };
}

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUser = createUser;
exports.deleteUser = deleteUser;
exports.deleteUserList = deleteUserList;
exports.updateUser = updateUser;
exports.resetUserErrorState = resetUserErrorState;
exports.lowerOwnHand = exports.raiseHand = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var c = _interopRequireWildcard(__webpack_require__(3));

var _guid = _interopRequireDefault(__webpack_require__(72));

var _userProfile = __webpack_require__(52);

var _proxy = __webpack_require__(21);

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _participants = __webpack_require__(92);

var _conference = __webpack_require__(53);

var _awaitAction = __webpack_require__(145);

var _get = _interopRequireDefault(__webpack_require__(11));

/**
 * Do API call with request object,
 * and redux actions to dispatch at various points in process.
 * The httpMethod argument, will treat request as string if GET,
 * or object if POST.
 * @param inputParams - Request object used in POST to cloudvideos API
 * @param serviceName - Defaults to meetings endpoint, but can be overidden
 * @param actionNameRequest - Action constant string for process start
 * @param actionNameSuccess - Action constant string for process success
 * @param actionNameFailure - Action constant string for process failure
 * @param httpMethod - is one of GET or POST
 * @param uriSuffix - (optional) As described in API docs for some operations
 */
var makeApiRequest = function makeApiRequest() {
  var serviceName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : c.USER_SERVICE_NAME;
  var uriSuffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var httpMethod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : c.HTTP_GET;
  var inputParams = arguments.length > 3 ? arguments[3] : undefined;
  var actionNameRequest = arguments.length > 4 ? arguments[4] : undefined;
  var actionNameSuccess = arguments.length > 5 ? arguments[5] : undefined;
  var actionNameFailure = arguments.length > 6 ? arguments[6] : undefined;
  var queryParams = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch, getState) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(0, _userProfile.selectIsGuest)(getState())) {
                  _context.next = 3;
                  break;
                }

                dispatch({
                  type: actionNameFailure,
                  payload: {
                    message: 'Guest user cannot modify users'
                  }
                });
                return _context.abrupt("return");

              case 3:
                dispatch({
                  type: actionNameRequest
                });
                return _context.abrupt("return", dispatch((0, _proxy.proxyApiCall)(serviceName, uriSuffix, httpMethod, inputParams, queryParams)).then(function (response) {
                  dispatch({
                    type: actionNameSuccess,
                    payload: response
                  });
                  return Promise.resolve(response);
                }).catch(function (err) {
                  _jsLogger.default.info('Meetings api call failed:', err);

                  dispatch({
                    type: actionNameFailure,
                    payload: err
                  });
                  return Promise.reject(err);
                }));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};
/**
 * Create User
 * lifesize.user > user/create
 *
 * User shape is as follows:
 *  displayName: string;
 *  description?: string; // Optional
 *  email?: string; // Optional
 *  language?: string; // Optional
 *  usageType?: string // Optional (PERSONAL or SHARED)
 */


function createUser(user) {
  return makeApiRequest(c.USER_SERVICE_NAME, c.USER_SERVICE_URI_SUFFIX_CREATE, c.HTTP_POST, user, c.USER_SERVICE_CREATE_REQUEST, c.USER_SERVICE_CREATE_SUCCESS, c.USER_SERVICE_CREATE_FAILURE);
}
/**
 * Delete Single User
 * lifesize.user > user/delete
 */


function deleteUser(uuid) {
  return makeApiRequest(c.USER_SERVICE_NAME, c.USER_SERVICE_URI_SUFFIX_DELETE, c.HTTP_POST, uuid, c.USER_SERVICE_DELETE_REQUEST, c.USER_SERVICE_DELETE_SUCCESS, c.USER_SERVICE_DELETE_FAILURE);
}
/**
 * Delete User List
 * lifesize.user > user/deletelist
 */


function deleteUserList(uuidObjArray) {
  // [{ uuid: '' }, ...]
  return makeApiRequest(c.USER_SERVICE_NAME, c.USER_SERVICE_URI_SUFFIX_DELETE_LIST, c.HTTP_POST, uuidObjArray, c.USER_SERVICE_DELETE_LIST_REQUEST, c.USER_SERVICE_DELETE_LIST_SUCCESS, c.USER_SERVICE_DELETE_LIST_FAILURE);
}
/**
 * Update User
 * lifesize.user > user/update
 *
 * User shape is as follows:
 *  uuid: string;
 *  displayName: string;
 *  description?: string; // Optional
 *  email?: string; // Optional
 *  language?: string; // Optional
 */


function updateUser(user) {
  return makeApiRequest(c.USER_SERVICE_NAME, c.USER_SERVICE_URI_SUFFIX_UPDATE, c.HTTP_POST, user, c.USER_SERVICE_UPDATE_REQUEST, c.USER_SERVICE_UPDATE_SUCCESS, c.USER_SERVICE_UPDATE_FAILURE);
}

function resetUserErrorState() {
  return function (dispatch) {
    dispatch({
      type: c.USER_SERVICE_ERROR_RESET
    });
  };
} // raise hand
// Any user can raise only their own hand


var raiseHand = function raiseHand() {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch, getState) {
        var state, conferenceId, participantId, data, handPromise;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                state = getState();
                conferenceId = (0, _conference.selectConferenceId)(getState()); // validation checks

                if (conferenceId) {
                  _context2.next = 4;
                  break;
                }

                throw new Error('Cannot raise hand: No conferenceId.');

              case 4:
                if (!(0, _conference.selectIsProcessingHandCommand)(state)) {
                  _context2.next = 7;
                  break;
                }

                _jsLogger.default.warn('Already processing another hand action.');

                return _context2.abrupt("return");

              case 7:
                participantId = (0, _get.default)((0, _participants.selectCurrentUserParticipant)(state), 'participantId');
                data = {
                  messageId: _guid.default.create(),
                  event: c.GALAXY_COMMAND_RAISE_HAND,
                  participantId: participantId,
                  conferenceId: conferenceId
                };
                dispatch({
                  type: c.SELF_RAISE_HAND_REQUEST
                });
                _context2.prev = 10;
                handPromise = dispatch((0, _awaitAction.awaitAction)(function (a) {
                  return a.type === c.GALAXY_ACTION_CONFERENCE_PARTICIPANT_HAND_RAISED && (0, _get.default)(a, 'payload.conferenceId') === conferenceId && (0, _get.default)(a, 'payload.participant.participantId') === participantId;
                }));
                dispatch(sendParticipantCommand(data));
                _context2.next = 15;
                return handPromise;

              case 15:
                dispatch({
                  type: c.SELF_RAISE_HAND_SUCCESS
                });
                _context2.next = 21;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](10);
                dispatch({
                  type: c.SELF_RAISE_HAND_FAILURE,
                  payload: {
                    error: _context2.t0
                  }
                });

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[10, 18]]);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}; // Non-moderators are allowed to lower their own hand.


exports.raiseHand = raiseHand;

var lowerOwnHand = function lowerOwnHand() {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(dispatch, getState) {
        var state, conferenceId, participantId, data, handPromise;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                state = getState();
                conferenceId = (0, _conference.selectConferenceId)(state); // validation checks

                if (conferenceId) {
                  _context3.next = 4;
                  break;
                }

                throw new Error('Cannot lower hand: No conferenceId.');

              case 4:
                if (!(0, _conference.selectIsProcessingHandCommand)(state)) {
                  _context3.next = 7;
                  break;
                }

                _jsLogger.default.warn('Already processing another hand action.');

                return _context3.abrupt("return");

              case 7:
                participantId = (0, _get.default)((0, _participants.selectCurrentUserParticipant)(state), 'participantId');
                data = {
                  messageId: _guid.default.create(),
                  event: c.GALAXY_COMMAND_LOWER_HAND,
                  participantId: participantId,
                  conferenceId: conferenceId
                };
                dispatch({
                  type: c.SELF_LOWER_HAND_REQUEST
                });
                _context3.prev = 10;
                handPromise = dispatch((0, _awaitAction.awaitAction)(function (a) {
                  return a.type === c.GALAXY_ACTION_CONFERENCE_PARTICIPANT_HAND_LOWERED && (0, _get.default)(a, 'payload.conferenceId') === conferenceId && (0, _get.default)(a, 'payload.participant.participantId') === participantId;
                }));
                dispatch(sendParticipantCommand(data));
                _context3.next = 15;
                return handPromise;

              case 15:
                dispatch({
                  type: c.SELF_LOWER_HAND_SUCCESS
                });
                _context3.next = 21;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t0 = _context3["catch"](10);
                dispatch({
                  type: c.SELF_LOWER_HAND_FAILURE,
                  payload: {
                    error: _context3.t0
                  }
                });

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[10, 18]]);
      }));

      return function (_x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
};

exports.lowerOwnHand = lowerOwnHand;

function sendParticipantCommand(params) {
  return function (dispatch) {
    dispatch((0, _proxy.proxyApiCall)(c.GALAXY_TOPIC_USER_ACTIONS, c.GALAXY_WAMP_URI_SUFFIX_DEFAULT, c.GALAXY_HTTP_METHOD_DEFAULT, params));
  };
}

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUploadWallpaperUrl = getUploadWallpaperUrl;
exports.getExistingWallpaperUrl = getExistingWallpaperUrl;
exports.sendWallPaperURL = sendWallPaperURL;
exports.default = void 0;

var c = _interopRequireWildcard(__webpack_require__(3));

var _pairedDevicesApi = __webpack_require__(198);

/** @module actions/icon */
function getUploadWallpaperUrl() {
  return (0, _pairedDevicesApi.doSimpleAPIRequest)(c.GET_UPLOAD_WALLPAPER_URL_BEGIN, c.GET_UPLOAD_WALLPAPER_URL_SUCCESS, c.GET_UPLOAD_WALLPAPER_URL_FAILURE, c.GET_UPLOAD_WALLPAPER_URL_ENDPOINT, c.HTTP_GET, c.GET_UPLOAD_WALLPAPER_URL_SUFFIX);
}

function getExistingWallpaperUrl() {
  return (0, _pairedDevicesApi.doSimpleAPIRequest)(c.GET_EXISTING_WALLPAPER_URL_BEGIN, c.GET_EXISTING_WALLPAPER_URL_SUCCESS, c.GET_EXISTING_WALLPAPER_URL_FAILURE, c.GET_EXISTING_WALLPAPER_URL_ENDPOINT, c.HTTP_GET, c.GET_EXISTING_WALLPAPER_URL_SUFFIX);
}

function sendWallPaperURL(imageUrl) {
  return (0, _pairedDevicesApi.doSimpleAPIRequest)(c.SEND_WALLPAPER_URL_BEGIN, c.SEND_WALLPAPER_URL_SUCCESS, c.SEND_WALLPAPER_URL_FAILURE, c.SEND_WALLPAPER_URL_ENDPOINT, c.HTTP_GET, c.SEND_WALLPAPER_URL_SUFFIX, {
    imageUrl: imageUrl
  });
}

var _default = {
  getUploadWallpaperUrl: getUploadWallpaperUrl,
  getExistingWallpaperUrl: getExistingWallpaperUrl,
  sendWallPaperURL: sendWallPaperURL
};
exports.default = _default;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _logger = _interopRequireDefault(__webpack_require__(165));

function setLevel(level) {
  return {
    type: _logger.default.actions.setLevel,
    payload: level
  };
}

var _default = {
  setLevel: setLevel
};
exports.default = _default;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canControlFarEndCamera = void 0;

var _get = _interopRequireDefault(__webpack_require__(11));

var c = _interopRequireWildcard(__webpack_require__(3));

var _feature = __webpack_require__(74);

var _call = __webpack_require__(51);

var canControlFarEndCamera = function canControlFarEndCamera(state) {
  var featureFlags = (0, _feature.getFeatureFlags)(state);
  var accountFeccEnabled = (0, _get.default)(featureFlags, c.FEATUREFLAG_ENABLE_FECC) || false;
  if (!accountFeccEnabled) return false;
  var call = (0, _call.activeGalaxyCall)(state);
  if ((0, _get.default)(call, 'state') !== c.GALAXY_CALL_STATE_CONNECTED) return false;
  var remoteCameraCapabilities = (0, _get.default)(call, 'remoteCameraCapabilities');
  var feccCount = (0, _get.default)(remoteCameraCapabilities, 'cameras.length') || 0;
  return feccCount !== 0;
};

exports.canControlFarEndCamera = canControlFarEndCamera;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloudMeetings = exports.cloudUsers = void 0;

var _reselect = __webpack_require__(23);

var access = __webpack_require__(8);

var createCloudUsersSelector = function createCloudUsersSelector(stateData) {
  return (0, _reselect.createSelector)(stateData, function (r) {
    return r.cloudUsers || [];
  });
};

var createCloudMeetingsSelector = function createCloudMeetingsSelector(stateData) {
  return (0, _reselect.createSelector)(stateData, function (r) {
    return r.cloudMeetings || [];
  });
};

var cloudInfo = function cloudInfo(state) {
  return access(state, 'nucleus.recordings.cloudInfo', {}) || {};
};

var cloudUsers = createCloudUsersSelector(cloudInfo);
exports.cloudUsers = cloudUsers;
var cloudMeetings = createCloudMeetingsSelector(cloudInfo);
exports.cloudMeetings = cloudMeetings;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveContactSelector = exports.validationErrors = void 0;

var _reselect = __webpack_require__(23);

var _localize = _interopRequireDefault(__webpack_require__(190));

var access = __webpack_require__(8);
/** @module selectors/contactCRUD */


var localeCode = function localeCode(state) {
  return access(state, 'nucleus.localization.localeCode');
};

var contactType = function contactType(state) {
  return access(state, 'nucleus.contactCRUD.contactType.toLowerCase()');
};

var validationErrorsState = function validationErrorsState(state) {
  return access(state, 'nucleus.contactCRUD.validationErrors') || [];
};

var contactCRUD = function contactCRUD(state) {
  return access(state, 'nucleus.contactCRUD') || {};
};
/**
 * Selects the localized validationErrors
 * @example
 * Returns...
 * [ {
 *  key: 'name',
 *  message: 'This extension is already in use.'
 * }, {
 *  key: 'description',
 *  message: 'Description cannot be greater than 250 characters'
 * }]
 */


var validationErrors = (0, _reselect.createSelector)(validationErrorsState, contactType, localeCode, function (errors, contactType, localeCode) {
  return errors.map(function (error) {
    var key = access(error, 'context.key.toLowerCase()');
    var errorType = access(error, 'type.toLowerCase()');
    var localizationKey = "validation_error_".concat(contactType, "_").concat(errorType, "_").concat(key);
    return {
      key: key,
      message: (0, _localize.default)(localeCode, localizationKey)
    };
  });
});
exports.validationErrors = validationErrors;

/**
 * Selects the current state of saving a contact by inspecting the contactCRUD reducer
 * This is essentially a convenience function for looking into the state tree that
 * will be enhanced over time (e.g. adding localized server errors)
 * @example
 * Returns...
 * {
 *   isSaved: true, // was the record was saved successfully?
 *   isSaving: false, // are we in the process of saving a record
 *   errors: null, // server errors returned when attempting to save
 *   validationErrors: [ { // client side validation errors
 *     key: 'name',
 *     message: 'This extension is already in use.'
 *   }, {
 *    key: 'description',
 *    message: 'Description cannot be greater than 250 characters'
 *  }]
 */
var saveContactSelector = (0, _reselect.createSelector)(contactCRUD, validationErrors, function (contactCRUD, validationErrorSelector) {
  return {
    isSaving: !!contactCRUD.isSaving,
    isSaved: !!contactCRUD.isSaved,
    errors: contactCRUD.errors,
    validationErrors: validationErrorSelector
  };
});
exports.saveContactSelector = saveContactSelector;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEndpointDisplayBackground = exports.getEndpointLicenseStatus = exports.getEndpointSoftwareVersions = exports.getEndpointInfo = void 0;

var _reselect = __webpack_require__(23);

var _lodash = __webpack_require__(82);

/**
 * Returns device endpoint info from the checkin service. (Or null if it's not there or undefined);
 */
var getEndpointInfo = (0, _reselect.createSelector)(function (state) {
  return (0, _lodash.get)(state, 'nucleus.endpoint', null);
}, function (i) {
  return i;
});
/**
 * Specifically returns the software min/current versions from the checkin service endpoint info.
 */

exports.getEndpointInfo = getEndpointInfo;
var getEndpointSoftwareVersions = (0, _reselect.createSelector)(getEndpointInfo, function (endpoint) {
  return (0, _lodash.get)(endpoint, 'software', null);
});
/**
 * Specifically returns the licenseStatus from the checkin service endpoint info.
 */

exports.getEndpointSoftwareVersions = getEndpointSoftwareVersions;
var getEndpointLicenseStatus = (0, _reselect.createSelector)(getEndpointInfo, function (endpoint) {
  return (0, _lodash.get)(endpoint, 'licenseStatus', null);
});
/**
 * Specifically returns the display background from the checkin service endpoint info.
 */

exports.getEndpointLicenseStatus = getEndpointLicenseStatus;
var getEndpointDisplayBackground = (0, _reselect.createSelector)(getEndpointInfo, function (endpoint) {
  return (0, _lodash.get)(endpoint, 'displayBackground', null);
});
exports.getEndpointDisplayBackground = getEndpointDisplayBackground;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupSettings = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reselect = __webpack_require__(23);

var access = __webpack_require__(8);

var getGroupSettings = function getGroupSettings(state) {
  return access(state, 'nucleus.groupSettings') || {};
};

var groupSettings = (0, _reselect.createSelector)(getGroupSettings, function (stateData) {
  return (0, _objectSpread2.default)({}, stateData);
});
exports.groupSettings = groupSettings;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getErrorSelector = exports.isBusySelector = exports.maxInactiveDaysOTMSelector = exports.maxInactiveDaysSelector = exports.meetingSettingsSelector = exports.selectDirectoryMyMeetings = exports.selectDirectoryActiveMeetings = exports.selectDirectoryMeetings = void 0;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(71));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(81));

var _partition5 = _interopRequireDefault(__webpack_require__(239));

var _reselect = __webpack_require__(23);

var C = _interopRequireWildcard(__webpack_require__(3));

var _contacts = __webpack_require__(35);

var _currentUser = __webpack_require__(37);

var access = __webpack_require__(8);

var meetingsState = function meetingsState(state) {
  return access(state, 'nucleus.meetings') || {};
};

var meetingSettingsSelector = (0, _reselect.createSelector)(meetingsState, function (r) {
  return r;
});
exports.meetingSettingsSelector = meetingSettingsSelector;
var maxInactiveDaysSelector = (0, _reselect.createSelector)(meetingsState, function (r) {
  if (r && r.maxInactiveDaysError) {
    // Return defaults along with error item
    return {
      isMaxInactiveDaysBusy: false,
      error: r.maxInactiveDaysError
    };
  }

  return {
    maxInactiveDays: r.maxInactiveDays,
    isMaxInactiveDaysBusy: r.isMaxInactiveDaysBusy || false
  };
});
exports.maxInactiveDaysSelector = maxInactiveDaysSelector;
var maxInactiveDaysOTMSelector = (0, _reselect.createSelector)(meetingsState, function (r) {
  if (r && r.maxInactiveDaysOTMError) {
    // Return defaults along with error item
    return {
      isMaxInactiveDaysOTMBusy: false,
      error: r.maxInactiveDaysOTMError
    };
  }

  return {
    maxInactiveDaysOTM: r.maxInactiveDaysOTM,
    isMaxInactiveDaysOTMBusy: r.isMaxInactiveDaysOTMBusy || false
  };
});
/**
 * Find the error attribute on state
 */

exports.maxInactiveDaysOTMSelector = maxInactiveDaysOTMSelector;
var getErrorSelector = (0, _reselect.createSelector)(meetingsState, function (r) {
  return r && r.error ? r.error : null;
});
/**
 * This busy flag is for CRUD operations on meetings
 * @See maxInactiveDaysSelector for busy indicator on
 * get/set of maxInactiveDays
 */

exports.getErrorSelector = getErrorSelector;
var isBusySelector = (0, _reselect.createSelector)(meetingsState, function (r) {
  return !!(r && r.isBusy);
});
exports.isBusySelector = isBusySelector;
var selectDirectoryMeetings = (0, _reselect.createSelector)(_contacts.meetingsSelector, _currentUser.getUserUUID, function (meetings, userUUID) {
  var directoryMeetings = excludeNonVisibleMeetings(meetings, userUUID);
  return directoryMeetings;
});
exports.selectDirectoryMeetings = selectDirectoryMeetings;
var selectDirectoryActiveMeetings = (0, _reselect.createSelector)(_contacts.meetingsSelector, _currentUser.getUserUUID, function (meetings, userUUID) {
  // filter meetings with participants
  var meetingsWithParticipants = meetings.filter(function (m) {
    return m.participantsCount > 0;
  }); // filter original meetings based on set (this is done to keep original order)

  var directoryMeetings = excludeNonVisibleMeetings(meetingsWithParticipants, userUUID);
  return directoryMeetings;
});
exports.selectDirectoryActiveMeetings = selectDirectoryActiveMeetings;
var selectDirectoryMyMeetings = (0, _reselect.createSelector)(_contacts.meetingsSelector, function (meetings) {
  return meetings.filter(function (m) {
    return m.isMyMeeting;
  });
});
exports.selectDirectoryMyMeetings = selectDirectoryMyMeetings;

function excludeNonVisibleMeetings(meetings, userUUID) {
  // filter permanent meetings
  var permanentMeetings = meetings.filter(function (m) {
    return m.meetingType === C.MEETING_TYPE_VMR;
  }); // filter visible/hidden permanent meetings

  var _partition = (0, _partition5.default)(permanentMeetings, function (m) {
    return !m.hidden;
  }),
      _partition2 = (0, _slicedToArray2.default)(_partition, 2),
      permanentVisible = _partition2[0],
      permanentHidden = _partition2[1]; // filter owned hidden


  var ownedPermanentHidden = permanentHidden.filter(function (m) {
    return m.isMyMeeting;
  }); // filter moderated hidden

  var moderatedPermanentHidden = permanentHidden.filter(function (m) {
    return m.moderatorID === userUUID;
  }); // filter one time meetings

  var oneTimeMeetings = meetings.filter(function (m) {
    return m.meetingType === C.MEETING_TYPE_ONE_TIME;
  }); // filter visible/hidden one time meetings

  var _partition3 = (0, _partition5.default)(oneTimeMeetings, function (m) {
    return !m.hidden;
  }),
      _partition4 = (0, _slicedToArray2.default)(_partition3, 2),
      oneTimeVisible = _partition4[0],
      oneTimeHidden = _partition4[1]; // filter owned one time meetings


  var ownedOneTimeMeetings = oneTimeHidden.filter(function (m) {
    return m.isMyMeeting;
  }); // filter moderated one time meetings

  var moderatedOneTimeMeetings = oneTimeHidden.filter(function (m) {
    return m.moderatorID === userUUID;
  }); // create set for O(1) lookups

  var set = buildUuidSetFromMeetings([].concat((0, _toConsumableArray2.default)(permanentVisible), (0, _toConsumableArray2.default)(ownedPermanentHidden), (0, _toConsumableArray2.default)(moderatedPermanentHidden), (0, _toConsumableArray2.default)(oneTimeVisible), (0, _toConsumableArray2.default)(ownedOneTimeMeetings), (0, _toConsumableArray2.default)(moderatedOneTimeMeetings))); // filter original meetings based on set (this is done to keep original sorting)

  var directoryMeetings = meetings.filter(function (m) {
    return set.has(m.uuid);
  });
  return directoryMeetings;
}

function buildUuidSetFromMeetings(meetings) {
  var set = new Set();
  meetings.forEach(function (m) {
    return set.add(m.uuid);
  });
  return set;
}

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectivity = exports.isOffline = exports.isOnline = exports.getState = exports.getInFlightWampSends = exports.getPresIceState = exports.getIceState = exports.getNetworkState = exports.getIsAppBackgrounded = void 0;

var _get = _interopRequireDefault(__webpack_require__(11));

var _reselect = __webpack_require__(23);

var _call = __webpack_require__(51);

var c = _interopRequireWildcard(__webpack_require__(3));

/** @module selectors/network */
var getIsAppBackgrounded = function getIsAppBackgrounded(state) {
  return (0, _get.default)(state, 'nucleus.app.isBackgrounded') || false;
};

exports.getIsAppBackgrounded = getIsAppBackgrounded;

var getNetworkState = function getNetworkState(state) {
  return (0, _get.default)(state, 'nucleus.network.state') || null;
};

exports.getNetworkState = getNetworkState;

var getIceState = function getIceState(state) {
  return (0, _get.default)(state, 'nucleus.galaxy.rtc.iceConnectionState') || null;
};

exports.getIceState = getIceState;

var getPresIceState = function getPresIceState(state) {
  return (0, _get.default)(state, 'nucleus.galaxy.rtc.presIceConnectionState') || null;
};

exports.getPresIceState = getPresIceState;

var getInFlightWampSends = function getInFlightWampSends(state) {
  return (0, _get.default)(state, 'nucleus.proxy.inFlightSends') || {};
};
/**
 * Selects the state of the network
 * @example
 * Returns...
 * 'NETWORK_STATUS_ONLINE'
 */


exports.getInFlightWampSends = getInFlightWampSends;
var getState = (0, _reselect.createSelector)(getNetworkState, function (networkState) {
  return networkState;
});
/**
 * Selects and returns true if network is online
 * @example
 * Returns...
 * true
 */

exports.getState = getState;
var isOnline = (0, _reselect.createSelector)(getNetworkState, function (networkState) {
  return networkState === c.NETWORK_STATUS_ONLINE;
});
/**
 * Selects and returns true if network is offline
 * @example
 * Returns...
 * true
 */

exports.isOnline = isOnline;
var isOffline = (0, _reselect.createSelector)(getNetworkState, function (networkState) {
  return networkState === c.NETWORK_STATUS_OFFLINE;
});
exports.isOffline = isOffline;
var connectivity = (0, _reselect.createSelector)(getInFlightWampSends, getIceState, getPresIceState, _call.activeGalaxyCallState, function (wampSends, iceState, presIceState, callState) {
  var now = Date.now();
  var longRunningRequests = !!Object.keys(wampSends).find(function (key) {
    if (key === 'revision') return false;
    return now - wampSends[key] > 5000;
  });
  var iceRestarting = callState === c.GALAXY_CALL_STATE_CONNECTED && (iceState === c.GALAXY_ICE_STATE_DISCONNECTED || iceState === c.GALAXY_ICE_STATE_FAILED || presIceState === c.GALAXY_ICE_STATE_DISCONNECTED || presIceState === c.GALAXY_ICE_STATE_FAILED);
  return {
    longRunningRequests: longRunningRequests,
    iceRestarting: iceRestarting
  };
});
exports.connectivity = connectivity;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pairedDevicesSelector = void 0;

var _reselect = __webpack_require__(23);

var access = __webpack_require__(8);
/** Non-exported utility function
 * Returns standardized selector for several paired device API results.
 * @param stateData - Result data of call to cloudvideos API s
 */


var createPairedDevicesSelector = function createPairedDevicesSelector(stateData) {
  return (0, _reselect.createSelector)(stateData, function (r) {
    if (r && r.error) {
      // Return defaults along with error item
      return {
        data: null,
        isFetching: false,
        isDeleting: false,
        isRemovingDevice: false,
        error: r.error,
        removePairingError: null
      };
    }

    if (r && r.removePairingError) {
      // Return defaults along with un-pairing error item
      // Do not clear view data on an un-pairing exception
      return {
        data: r.data || null,
        isFetching: false,
        isDeleting: false,
        isRemovingDevice: false,
        error: null,
        removePairingError: r.removePairingError
      };
    }

    if (r && r.removeDeviceError) {
      // Return defaults along with remove device error item
      return {
        data: r.data || null,
        isFetching: false,
        isDeleting: false,
        isRemovingDevice: false,
        error: null,
        removeDeviceError: r.removeDeviceError
      };
    }

    return {
      data: r.data || null,
      isFetching: r.isFetching || false,
      error: r.error || null,
      isDeleting: r.isDeleting || false,
      isRemovingDevice: r.isRemovingDevice || false,
      removePairingError: r.removePairingError || null,
      licenseCountObject: r.licenseCountObject || null
    };
  });
};

var pairedDevices = function pairedDevices(state) {
  return access(state, 'nucleus.pairedDevices') || {};
};

var pairedDevicesSelector = createPairedDevicesSelector(pairedDevices);
exports.pairedDevicesSelector = pairedDevicesSelector;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConnectionError = exports.userProfileError = void 0;

var _userSettings = __webpack_require__(277);

var _auth = __webpack_require__(31);

var _get = _interopRequireDefault(__webpack_require__(11));

var userProfileError = function userProfileError(state) {
  return (0, _get.default)(state, 'nucleus.userProfile.error');
}; // Get the error set by a failing getUserProfile(),
// or getCurrentUserSettings() call (respsectively)


exports.userProfileError = userProfileError;

var getConnectionError = function getConnectionError(state) {
  return userProfileError(state) || (0, _auth.authError)(state) || (0, _userSettings.userSettingsError)(state);
};

exports.getConnectionError = getConnectionError;

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.liveStreamUsageSelector = exports.accessTokenSelector = exports.vcSettingsSelector = void 0;

var _reselect = __webpack_require__(23);

var _get2 = _interopRequireDefault(__webpack_require__(11));

var access = __webpack_require__(8);

var vcSettingsRecordingResult = function vcSettingsRecordingResult(state) {
  return access(state, 'nucleus.recordings.recordingsAuth') || {};
};

var accountFeatures = function accountFeatures(state) {
  return (0, _get2.default)(state, 'nucleus.account.features') || {};
};
/**
 * The recordings service returns a JSON object.
 * But it may return a stringified JSON body in the data attribute.
 * This function handles both json and string responses.
 * @param r - object from selector payload
 * @return {*|{}}
 */


var parseVcSettingsRecordingResult = function parseVcSettingsRecordingResult(r) {
  var data = r.data || {};

  if (typeof r.data === 'string') {
    try {
      data = JSON.parse(r.data);
    } catch (e) {
      data = {};
    }
  }

  return data;
};
/**
 * Returns recordings authorization
 * Error message returned on exception state
 */


var vcSettingsSelector = (0, _reselect.createSelector)(vcSettingsRecordingResult, function (r) {
  return {
    data: parseVcSettingsRecordingResult(r),
    isFetching: r.isFetching || false,
    error: r.error || null
  };
});
/**
 * Returns recordings access token used to call API
 */

exports.vcSettingsSelector = vcSettingsSelector;
var accessTokenSelector = (0, _reselect.createSelector)(vcSettingsRecordingResult, function (r) {
  var data = parseVcSettingsRecordingResult(r);
  return {
    accessToken: (0, _get2.default)(data, 'accessToken', null),
    accessTokenExpireAt: (0, _get2.default)(data, 'accessTokenExpireAt', null)
  };
});
/**
 * Live stream usage data required along with vcSettingsSelector
 */

exports.accessTokenSelector = accessTokenSelector;
var liveStreamUsageSelector = (0, _reselect.createSelector)(accountFeatures, function (ls) {
  return {
    streamHours: (0, _get2.default)(ls, 'strmHours', 0),
    streamViewers: (0, _get2.default)(ls, 'strmViewers', 0)
  };
});
exports.liveStreamUsageSelector = liveStreamUsageSelector;

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.meetingInvitePreview = void 0;

var _reselect = __webpack_require__(23);

var access = __webpack_require__(8);
/** @module selectors/scheduling */


var invitation = function invitation(state) {
  return access(state, 'nucleus.invitation') || {};
};
/**
 * meetingInvitePreview
 * Returns a function which selects the formatted, localized meeting invitation text
 * @function
 * @param {object} state - the state of the store
 * @example
 * import { schedulingSelectors } from 'lifesize-sky-nucleus';
 * // get scheduling object for that contact/meeting
 * const schedulingObject = schedulingSelectors.meetingInvitePreview(state);
 *
 * // schedulingObject is...
 * {
 *   error: null,
 *   html: 'TODO: localized, formatted html email body',
 *   isFetching: boolean,
 *   text: 'localized, formatted text email body'
 * }
 */


var meetingInvitePreview = (0, _reselect.createSelector)(invitation, function (invitation) {
  return invitation.preview;
});
exports.meetingInvitePreview = meetingInvitePreview;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchMeetings = exports.searchFavorites = exports.searchNonFavorites = exports.searchRoomSystemsAndMeetings = exports.searchUsers = exports.searchUsersAndRoomSystems = exports.searchChattableContacts = exports.searchAvailableUsersAndRoomSystems = exports.searchAvailableUsers = exports.searchAvailableContacts = exports.searchModerators = exports.searchLecturers = exports.searchUsersAndRoomSystemsOutsideCall = exports.searchContacts = void 0;

var _fuse = _interopRequireDefault(__webpack_require__(541));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _reselect = __webpack_require__(23);

var _searchUtils = __webpack_require__(542);

var _galaxyUtils = __webpack_require__(73);

var contactSelectors = _interopRequireWildcard(__webpack_require__(35));

var callSelectors = _interopRequireWildcard(__webpack_require__(51));

var _feature = __webpack_require__(74);

var C = _interopRequireWildcard(__webpack_require__(3));

var _services = __webpack_require__(83);

/** @module selectors/search */
var fuseSearchOptions = {
  shouldSort: true,
  threshold: 0.2,
  location: 0,
  distance: 255,
  maxPatternLength: 64,
  keys: ['name']
};

var directorySearchResults = function directorySearchResults(state) {
  return (0, _safeAccess.default)(state, 'nucleus.directory.searchResults') || [];
};

var recordsRevision = function recordsRevision(state) {
  return (0, _safeAccess.default)(state, 'nucleus.contacts.recordsRevision') || 0;
};

var inCallStatusRevision = function inCallStatusRevision(state) {
  return (0, _safeAccess.default)(state, 'nucleus.contacts.inCallStatusRevision') || 0;
}; // use the directory service if connected and have the flag set in the state to use the service


var useDirectoryService = function useDirectoryService(state) {
  return (0, _services.selectConnected)(state) && !!(0, _feature.getFeatureFlag)(state)(C.FEATUREFLAG_USE_DIRECTORY_SERVICE);
};

var directorySearchString = function directorySearchString(state) {
  return (0, _safeAccess.default)(state, 'nucleus.directory.searchString') || '';
};

var searchSelectorGenerator = (0, _reselect.createSelector)(directorySearchResults, directorySearchString, inCallStatusRevision, recordsRevision, function (results, directorySearchString) {
  return (0, _reselect.defaultMemoize)(function (filter) {
    var search = directorySearchString.trim();
    if (!search) return [];
    return results.filter(filter).map(function (r) {
      return (0, _searchUtils.generateMatchResult)(r, ['name'], search);
    });
  });
});
var outsideCallSearchSelector = (0, _reselect.createSelector)(directorySearchResults, directorySearchString, callSelectors.usersAndRoomSystemsOutsideCallSelector, inCallStatusRevision, recordsRevision, function (results, directorySearchString, filteredCallParticipants) {
  return (0, _reselect.defaultMemoize)(function () {
    var search = directorySearchString.trim();
    if (!search) return [];
    return filteredCallParticipants.map(function (r) {
      return (0, _searchUtils.generateMatchResult)(r, ['name'], search);
    });
  });
});
var fuzeSearchGenerator = (0, _reselect.createSelector)(directorySearchString, inCallStatusRevision, recordsRevision, function (directorySearchString) {
  return (0, _reselect.defaultMemoize)(function (contacts, keys) {
    // consolidate searchStrings, early exit
    var searchString = directorySearchString.trim();
    if (!searchString) return []; // limit search string length

    if (searchString.length > fuseSearchOptions.maxPatternLength) {
      searchString = searchString.substring(0, fuseSearchOptions.maxPatternLength);
    }

    keys = keys || ['name'];
    var searchOptions = Object.assign({}, fuseSearchOptions, {
      keys: keys
    });
    var fuse = new _fuse.default(contacts, searchOptions);
    var fuseMatches = fuse.search(searchString);
    return fuseMatches.map(function (item) {
      return (0, _searchUtils.generateMatchResult)(item, keys, searchString);
    });
  });
});

var searchContacts = function searchContacts(state) {
  return useDirectoryService(state) ? searchSelectorGenerator(state)(function () {
    return true;
  }) : fuzeSearchGenerator(state)(contactSelectors.contactsSelector(state));
};
/**
 * Search Users and Room systems outside call
 */


exports.searchContacts = searchContacts;

var searchUsersAndRoomSystemsOutsideCall = function searchUsersAndRoomSystemsOutsideCall(state) {
  var directorySearchSelector;

  if ((0, _galaxyUtils.isGalaxyCallConnected)(state)) {
    directorySearchSelector = outsideCallSearchSelector(state)();
  } else {
    directorySearchSelector = searchSelectorGenerator(state)(contactSelectors.usersAndRoomSystemsOutsideCallSelectorFilter);
  }

  return useDirectoryService(state) ? directorySearchSelector : fuzeSearchGenerator(state)(contactSelectors.usersAndRoomSystemsOutsideCallSelector(state));
};
/**
 * Search for users who can be lecturers of a VMR
 */


exports.searchUsersAndRoomSystemsOutsideCall = searchUsersAndRoomSystemsOutsideCall;

var searchLecturers = function searchLecturers(state) {
  return useDirectoryService(state) ? searchSelectorGenerator(state)(contactSelectors.potentialLecturersFilter) : fuzeSearchGenerator(state)(contactSelectors.potentialLecturers(state));
};
/**
 * Search for users who can be moderators of a VMR
 */


exports.searchLecturers = searchLecturers;

var searchModerators = function searchModerators(state) {
  return useDirectoryService(state) ? searchSelectorGenerator(state)(contactSelectors.potentialModeratorsFilter) : fuzeSearchGenerator(state)(contactSelectors.potentialModerators(state));
};
/**
 * Search all contacts available for calling
 */


exports.searchModerators = searchModerators;

var searchAvailableContacts = function searchAvailableContacts(state) {
  return useDirectoryService(state) ? searchSelectorGenerator(state)(contactSelectors.availableContactsFilter) : fuzeSearchGenerator(state)(contactSelectors.availableContacts(state));
};
/**
 * Search users available for calling
 */


exports.searchAvailableContacts = searchAvailableContacts;

var searchAvailableUsers = function searchAvailableUsers(state) {
  return useDirectoryService(state) ? searchSelectorGenerator(state)(contactSelectors.availableUsersFilter) : fuzeSearchGenerator(state)(contactSelectors.availableUsers(state));
};
/**
 * Search users and room systems available for calling
 */


exports.searchAvailableUsers = searchAvailableUsers;

var searchAvailableUsersAndRoomSystems = function searchAvailableUsersAndRoomSystems(state) {
  return useDirectoryService(state) ? searchSelectorGenerator(state)(contactSelectors.availableUsersAndRoomSystemsFilter) : fuzeSearchGenerator(state)(contactSelectors.availableUsersAndRoomSystems(state));
};
/**
 * Search contacts available for chat
 */


exports.searchAvailableUsersAndRoomSystems = searchAvailableUsersAndRoomSystems;

var searchChattableContacts = function searchChattableContacts(state) {
  return useDirectoryService(state) ? searchSelectorGenerator(state)(contactSelectors.chattableUsersFilter) : fuzeSearchGenerator(state)(contactSelectors.chattableUsers(state));
};
/**
 * Search Users and Room systems
 */


exports.searchChattableContacts = searchChattableContacts;

var searchUsersAndRoomSystems = function searchUsersAndRoomSystems(state) {
  return useDirectoryService(state) ? searchSelectorGenerator(state)(contactSelectors.usersAndRoomSystemsFilter) : fuzeSearchGenerator(state)(contactSelectors.usersAndRoomSystemsSelector(state));
};
/**
 * Search Users and Room systems
 */


exports.searchUsersAndRoomSystems = searchUsersAndRoomSystems;

var searchUsers = function searchUsers(state) {
  return useDirectoryService(state) ? searchSelectorGenerator(state)(contactSelectors.usersFilter) : fuzeSearchGenerator(state)(contactSelectors.usersSelector(state));
};
/**
 * Search Room systems and meetings
 */


exports.searchUsers = searchUsers;

var searchRoomSystemsAndMeetings = function searchRoomSystemsAndMeetings(state) {
  return useDirectoryService(state) ? searchSelectorGenerator(state)(contactSelectors.roomSystemsAndMeetingsFilter) : fuzeSearchGenerator(state)(contactSelectors.roomSystemsAndMeetingsSelector(state));
};
/**
 * search Non Favorite Contacts
 */


exports.searchRoomSystemsAndMeetings = searchRoomSystemsAndMeetings;

var searchNonFavorites = function searchNonFavorites(state) {
  return useDirectoryService(state) ? searchSelectorGenerator(state)(contactSelectors.nonFavoritesFilter) : fuzeSearchGenerator(state)(contactSelectors.nonFavoritesSelector(state));
};
/**
 * search Favorite Contacts
 */


exports.searchNonFavorites = searchNonFavorites;

var searchFavorites = function searchFavorites(state) {
  return useDirectoryService(state) ? searchSelectorGenerator(state)(contactSelectors.favoritesFilter) : fuzeSearchGenerator(state)(contactSelectors.favoritesSelector(state));
};
/**
 * search Meetings
 */


exports.searchFavorites = searchFavorites;

var searchMeetings = function searchMeetings(state) {
  return useDirectoryService(state) ? searchSelectorGenerator(state)(contactSelectors.meetingsFilter) : fuzeSearchGenerator(state)(contactSelectors.meetingsSelector(state));
};

exports.searchMeetings = searchMeetings;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Fuse.js v3.4.5 - Lightweight fuzzy-search (http://fusejs.io)
 * 
 * Copyright (c) 2012-2017 Kirollos Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 * 
 * http://www.apache.org/licenses/LICENSE-2.0
 */
!function(e,t){ true?module.exports=t():undefined}(this,function(){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=1)}([function(e,t){e.exports=function(e){return Array.isArray?Array.isArray(e):"[object Array]"===Object.prototype.toString.call(e)}},function(e,t,n){function r(e){return(r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function o(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var i=n(2),a=n(8),s=n(0),c=function(){function e(t,n){var r=n.location,o=void 0===r?0:r,i=n.distance,s=void 0===i?100:i,c=n.threshold,h=void 0===c?.6:c,l=n.maxPatternLength,u=void 0===l?32:l,f=n.caseSensitive,d=void 0!==f&&f,v=n.tokenSeparator,p=void 0===v?/ +/g:v,g=n.findAllMatches,y=void 0!==g&&g,m=n.minMatchCharLength,k=void 0===m?1:m,S=n.id,x=void 0===S?null:S,b=n.keys,M=void 0===b?[]:b,_=n.shouldSort,L=void 0===_||_,w=n.getFn,A=void 0===w?a:w,C=n.sortFn,I=void 0===C?function(e,t){return e.score-t.score}:C,O=n.tokenize,j=void 0!==O&&O,P=n.matchAllTokens,F=void 0!==P&&P,T=n.includeMatches,z=void 0!==T&&T,E=n.includeScore,K=void 0!==E&&E,$=n.verbose,J=void 0!==$&&$;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.options={location:o,distance:s,threshold:h,maxPatternLength:u,isCaseSensitive:d,tokenSeparator:p,findAllMatches:y,minMatchCharLength:k,id:x,keys:M,includeMatches:z,includeScore:K,shouldSort:L,getFn:A,sortFn:I,verbose:J,tokenize:j,matchAllTokens:F},this.setCollection(t)}var t,n,c;return t=e,(n=[{key:"setCollection",value:function(e){return this.list=e,e}},{key:"search",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{limit:!1};this._log('---------\nSearch pattern: "'.concat(e,'"'));var n=this._prepareSearchers(e),r=n.tokenSearchers,o=n.fullSearcher,i=this._search(r,o),a=i.weights,s=i.results;return this._computeScore(a,s),this.options.shouldSort&&this._sort(s),t.limit&&"number"==typeof t.limit&&(s=s.slice(0,t.limit)),this._format(s)}},{key:"_prepareSearchers",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=[];if(this.options.tokenize)for(var n=e.split(this.options.tokenSeparator),r=0,o=n.length;r<o;r+=1)t.push(new i(n[r],this.options));return{tokenSearchers:t,fullSearcher:new i(e,this.options)}}},{key:"_search",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1?arguments[1]:void 0,n=this.list,r={},o=[];if("string"==typeof n[0]){for(var i=0,a=n.length;i<a;i+=1)this._analyze({key:"",value:n[i],record:i,index:i},{resultMap:r,results:o,tokenSearchers:e,fullSearcher:t});return{weights:null,results:o}}for(var s={},c=0,h=n.length;c<h;c+=1)for(var l=n[c],u=0,f=this.options.keys.length;u<f;u+=1){var d=this.options.keys[u];if("string"!=typeof d){if(s[d.name]={weight:1-d.weight||1},d.weight<=0||d.weight>1)throw new Error("Key weight has to be > 0 and <= 1");d=d.name}else s[d]={weight:1};this._analyze({key:d,value:this.options.getFn(l,d),record:l,index:c},{resultMap:r,results:o,tokenSearchers:e,fullSearcher:t})}return{weights:s,results:o}}},{key:"_analyze",value:function(e,t){var n=e.key,r=e.arrayIndex,o=void 0===r?-1:r,i=e.value,a=e.record,c=e.index,h=t.tokenSearchers,l=void 0===h?[]:h,u=t.fullSearcher,f=void 0===u?[]:u,d=t.resultMap,v=void 0===d?{}:d,p=t.results,g=void 0===p?[]:p;if(null!=i){var y=!1,m=-1,k=0;if("string"==typeof i){this._log("\nKey: ".concat(""===n?"-":n));var S=f.search(i);if(this._log('Full text: "'.concat(i,'", score: ').concat(S.score)),this.options.tokenize){for(var x=i.split(this.options.tokenSeparator),b=[],M=0;M<l.length;M+=1){var _=l[M];this._log('\nPattern: "'.concat(_.pattern,'"'));for(var L=!1,w=0;w<x.length;w+=1){var A=x[w],C=_.search(A),I={};C.isMatch?(I[A]=C.score,y=!0,L=!0,b.push(C.score)):(I[A]=1,this.options.matchAllTokens||b.push(1)),this._log('Token: "'.concat(A,'", score: ').concat(I[A]))}L&&(k+=1)}m=b[0];for(var O=b.length,j=1;j<O;j+=1)m+=b[j];m/=O,this._log("Token score average:",m)}var P=S.score;m>-1&&(P=(P+m)/2),this._log("Score average:",P);var F=!this.options.tokenize||!this.options.matchAllTokens||k>=l.length;if(this._log("\nCheck Matches: ".concat(F)),(y||S.isMatch)&&F){var T=v[c];T?T.output.push({key:n,arrayIndex:o,value:i,score:P,matchedIndices:S.matchedIndices}):(v[c]={item:a,output:[{key:n,arrayIndex:o,value:i,score:P,matchedIndices:S.matchedIndices}]},g.push(v[c]))}}else if(s(i))for(var z=0,E=i.length;z<E;z+=1)this._analyze({key:n,arrayIndex:z,value:i[z],record:a,index:c},{resultMap:v,results:g,tokenSearchers:l,fullSearcher:f})}}},{key:"_computeScore",value:function(e,t){this._log("\n\nComputing score:\n");for(var n=0,r=t.length;n<r;n+=1){for(var o=t[n].output,i=o.length,a=1,s=1,c=0;c<i;c+=1){var h=e?e[o[c].key].weight:1,l=(1===h?o[c].score:o[c].score||.001)*h;1!==h?s=Math.min(s,l):(o[c].nScore=l,a*=l)}t[n].score=1===s?a:s,this._log(t[n])}}},{key:"_sort",value:function(e){this._log("\n\nSorting...."),e.sort(this.options.sortFn)}},{key:"_format",value:function(e){var t=[];if(this.options.verbose){var n=[];this._log("\n\nOutput:\n\n",JSON.stringify(e,function(e,t){if("object"===r(t)&&null!==t){if(-1!==n.indexOf(t))return;n.push(t)}return t})),n=null}var o=[];this.options.includeMatches&&o.push(function(e,t){var n=e.output;t.matches=[];for(var r=0,o=n.length;r<o;r+=1){var i=n[r];if(0!==i.matchedIndices.length){var a={indices:i.matchedIndices,value:i.value};i.key&&(a.key=i.key),i.hasOwnProperty("arrayIndex")&&i.arrayIndex>-1&&(a.arrayIndex=i.arrayIndex),t.matches.push(a)}}}),this.options.includeScore&&o.push(function(e,t){t.score=e.score});for(var i=0,a=e.length;i<a;i+=1){var s=e[i];if(this.options.id&&(s.item=this.options.getFn(s.item,this.options.id)[0]),o.length){for(var c={item:s.item},h=0,l=o.length;h<l;h+=1)o[h](s,c);t.push(c)}else t.push(s.item)}return t}},{key:"_log",value:function(){var e;this.options.verbose&&(e=console).log.apply(e,arguments)}}])&&o(t.prototype,n),c&&o(t,c),e}();e.exports=c},function(e,t,n){function r(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var o=n(3),i=n(4),a=n(7),s=function(){function e(t,n){var r=n.location,o=void 0===r?0:r,i=n.distance,s=void 0===i?100:i,c=n.threshold,h=void 0===c?.6:c,l=n.maxPatternLength,u=void 0===l?32:l,f=n.isCaseSensitive,d=void 0!==f&&f,v=n.tokenSeparator,p=void 0===v?/ +/g:v,g=n.findAllMatches,y=void 0!==g&&g,m=n.minMatchCharLength,k=void 0===m?1:m;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.options={location:o,distance:s,threshold:h,maxPatternLength:u,isCaseSensitive:d,tokenSeparator:p,findAllMatches:y,minMatchCharLength:k},this.pattern=this.options.isCaseSensitive?t:t.toLowerCase(),this.pattern.length<=u&&(this.patternAlphabet=a(this.pattern))}var t,n,s;return t=e,(n=[{key:"search",value:function(e){if(this.options.isCaseSensitive||(e=e.toLowerCase()),this.pattern===e)return{isMatch:!0,score:0,matchedIndices:[[0,e.length-1]]};var t=this.options,n=t.maxPatternLength,r=t.tokenSeparator;if(this.pattern.length>n)return o(e,this.pattern,r);var a=this.options,s=a.location,c=a.distance,h=a.threshold,l=a.findAllMatches,u=a.minMatchCharLength;return i(e,this.pattern,this.patternAlphabet,{location:s,distance:c,threshold:h,findAllMatches:l,minMatchCharLength:u})}}])&&r(t.prototype,n),s&&r(t,s),e}();e.exports=s},function(e,t){var n=/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g;e.exports=function(e,t){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:/ +/g,o=new RegExp(t.replace(n,"\\$&").replace(r,"|")),i=e.match(o),a=!!i,s=[];if(a)for(var c=0,h=i.length;c<h;c+=1){var l=i[c];s.push([e.indexOf(l),l.length-1])}return{score:a?.5:1,isMatch:a,matchedIndices:s}}},function(e,t,n){var r=n(5),o=n(6);e.exports=function(e,t,n,i){for(var a=i.location,s=void 0===a?0:a,c=i.distance,h=void 0===c?100:c,l=i.threshold,u=void 0===l?.6:l,f=i.findAllMatches,d=void 0!==f&&f,v=i.minMatchCharLength,p=void 0===v?1:v,g=s,y=e.length,m=u,k=e.indexOf(t,g),S=t.length,x=[],b=0;b<y;b+=1)x[b]=0;if(-1!==k){var M=r(t,{errors:0,currentLocation:k,expectedLocation:g,distance:h});if(m=Math.min(M,m),-1!==(k=e.lastIndexOf(t,g+S))){var _=r(t,{errors:0,currentLocation:k,expectedLocation:g,distance:h});m=Math.min(_,m)}}k=-1;for(var L=[],w=1,A=S+y,C=1<<S-1,I=0;I<S;I+=1){for(var O=0,j=A;O<j;){r(t,{errors:I,currentLocation:g+j,expectedLocation:g,distance:h})<=m?O=j:A=j,j=Math.floor((A-O)/2+O)}A=j;var P=Math.max(1,g-j+1),F=d?y:Math.min(g+j,y)+S,T=Array(F+2);T[F+1]=(1<<I)-1;for(var z=F;z>=P;z-=1){var E=z-1,K=n[e.charAt(E)];if(K&&(x[E]=1),T[z]=(T[z+1]<<1|1)&K,0!==I&&(T[z]|=(L[z+1]|L[z])<<1|1|L[z+1]),T[z]&C&&(w=r(t,{errors:I,currentLocation:E,expectedLocation:g,distance:h}))<=m){if(m=w,(k=E)<=g)break;P=Math.max(1,2*g-k)}}if(r(t,{errors:I+1,currentLocation:g,expectedLocation:g,distance:h})>m)break;L=T}return{isMatch:k>=0,score:0===w?.001:w,matchedIndices:o(x,p)}}},function(e,t){e.exports=function(e,t){var n=t.errors,r=void 0===n?0:n,o=t.currentLocation,i=void 0===o?0:o,a=t.expectedLocation,s=void 0===a?0:a,c=t.distance,h=void 0===c?100:c,l=r/e.length,u=Math.abs(s-i);return h?l+u/h:u?1:l}},function(e,t){e.exports=function(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,n=[],r=-1,o=-1,i=0,a=e.length;i<a;i+=1){var s=e[i];s&&-1===r?r=i:s||-1===r||((o=i-1)-r+1>=t&&n.push([r,o]),r=-1)}return e[i-1]&&i-r>=t&&n.push([r,i-1]),n}},function(e,t){e.exports=function(e){for(var t={},n=e.length,r=0;r<n;r+=1)t[e.charAt(r)]=0;for(var o=0;o<n;o+=1)t[e.charAt(o)]|=1<<n-o-1;return t}},function(e,t,n){var r=n(0);e.exports=function(e,t){return function e(t,n,o){if(n){var i=n.indexOf("."),a=n,s=null;-1!==i&&(a=n.slice(0,i),s=n.slice(i+1));var c=t[a];if(null!=c)if(s||"string"!=typeof c&&"number"!=typeof c)if(r(c))for(var h=0,l=c.length;h<l;h+=1)e(c[h],s,o);else s&&e(c,s,o);else o.push(c.toString())}else o.push(t);return o}(e,t,[])}}])});

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.escapeSearchString = escapeSearchString;
exports.generateMatchResult = generateMatchResult;

function escapeSearchString(str) {
  return str.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
}

function generateMatchResult(item, keys, searchString) {
  var re = new RegExp(escapeSearchString(searchString), 'gi'); // build our own search result matches of type: { key: [matchArray] }
  // where matchArray are objects of type { string: 'string part', match: boolean }
  //
  // fusejs search match strings are hard to use for clients.
  // and matched indices are misleading, per product.
  // we will build the string matches for the clients

  var result = {
    contact: Object.assign({}, item),
    matches: {}
  }; // for each key matched on

  keys.forEach(function (key) {
    result.matches[key] = [];
    var lastIndex = 0;
    var m; // test regex of the entire search string against the matched result

    while ((m = re.exec(item[key])) !== null) {
      // grab unmatched parts of the string before this first regex match
      if (m.index > lastIndex) result.matches[key].push({
        string: item[key].slice(lastIndex, m.index),
        match: false
      }); // now push the matched part of the string

      result.matches[key].push({
        string: item[key].slice(m.index, m.index + searchString.length),
        match: true
      }); // update our last matching index

      lastIndex = m.index + searchString.length;
    } // add the remaining unmatched part of the string


    if (lastIndex < item[key].length) result.matches[key].push({
      string: item[key].slice(lastIndex, item[key].length),
      match: false
    });
  });
  return result;
}

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userService = void 0;

var _reselect = __webpack_require__(23);

var _get = _interopRequireDefault(__webpack_require__(11));

var getUsersState = function getUsersState(state) {
  return (0, _get.default)(state, 'nucleus.users') || {};
};

var userService = (0, _reselect.createSelector)(getUsersState, function (userState) {
  return userState;
});
exports.userService = userService;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reselect = __webpack_require__(23);

var access = __webpack_require__(8);
/** @module selectors/sso */


var ssoState = function ssoState(state) {
  return access(state, 'nucleus.sso') || {};
};
/**
 * Returns the SSO status of a user based on supplied email address.
 * Possible values are:
 * LOGIN_SUPPORT_TYPE_PASSWORD = 'password';
 * LOGIN_SUPPORT_TYPE_SSO = 'sso';
 * LOGIN_SUPPORT_TYPE_BOTH = 'both';
 * or null
 *
 * If error condition, state is no longer valid,
 * and loginSupportType is set to null
 */


var ssoStatus = (0, _reselect.createSelector)(ssoState, function (sso) {
  if (sso && sso.error) {
    return {
      loginSupportType: null,
      isFetching: false,
      error: sso.error
    };
  }

  return {
    loginSupportType: sso.loginSupportType || null,
    isFetching: sso.isFetching || false,
    error: sso.error || null
  };
});
var _default = {
  ssoStatus: ssoStatus
};
exports.default = _default;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(CONFIG) {

var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearDeviceCheckInterval = clearDeviceCheckInterval;
exports.createRtcMiddleware = createRtcMiddleware;
exports.default = exports.awaitingPresentationAnswerTimeout = exports.deviceCheckInterval = exports.presStreamReceiver = exports.presStreamTransmitter = exports.streamReceiver = exports.streamTransmitter = exports.rtcPeerManager = exports.windowGenerateCertificate = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var c = _interopRequireWildcard(__webpack_require__(3));

var _rtcUtils = __webpack_require__(200);

var mediaUtils = _interopRequireWildcard(__webpack_require__(201));

var _call = __webpack_require__(50);

var _stream = __webpack_require__(80);

var _presentation = __webpack_require__(191);

var _call2 = __webpack_require__(51);

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _rtcPeerManager = _interopRequireDefault(__webpack_require__(546));

var _streamTransmitter = _interopRequireDefault(__webpack_require__(575));

var _streamReceiver = _interopRequireDefault(__webpack_require__(580));

var _galaxyUtils = __webpack_require__(73);

var _deviceUtils = __webpack_require__(251);

var _conference = __webpack_require__(53);

var _galaxyActionMap;

var windowGenerateCertificate;
exports.windowGenerateCertificate = windowGenerateCertificate;
var rtcPeerManager;
exports.rtcPeerManager = rtcPeerManager;
var streamTransmitter;
exports.streamTransmitter = streamTransmitter;
var streamReceiver;
exports.streamReceiver = streamReceiver;
var presStreamTransmitter;
exports.presStreamTransmitter = presStreamTransmitter;
var presStreamReceiver;
exports.presStreamReceiver = presStreamReceiver;
var deviceCheckInterval = null;
exports.deviceCheckInterval = deviceCheckInterval;
var awaitingPresentationAnswerTimeout = null;
exports.awaitingPresentationAnswerTimeout = awaitingPresentationAnswerTimeout;

function clearDeviceCheckInterval() {
  clearInterval(deviceCheckInterval);
  exports.deviceCheckInterval = deviceCheckInterval = null;
}

function updateMediaDevices(store) {
  var currentDevices = (0, _safeAccess.default)(store.getState(), 'nucleus.media.devices');
  return mediaUtils.enumerateDevices().then(function (devices) {
    devices = devices.filter(function (d) {
      return !!d.label;
    });

    if (mediaUtils.mediaDevicesChanged(currentDevices, devices)) {
      store.dispatch({
        type: c.MEDIA_DEVICES_UPDATED,
        payload: devices
      });
    }
  });
}

function setupDeviceMonitor(store) {
  // TODO: when chrome or someone implements ondevicechange, change this code to use it.

  /* istanbul ignore else */
  if (!deviceCheckInterval) {
    updateMediaDevices(store);
    exports.deviceCheckInterval = deviceCheckInterval = setInterval(function () {
      // Skip a beat when some media processing is in progress
      if (!(0, _safeAccess.default)(store.getState(), 'nucleus.galaxy.rtc.mediaProcessingInProgress')) {
        updateMediaDevices(store);
      }
    }, 2000);
  }
}

var rtcMiddleware = function rtcMiddleware(store) {
  return function (next) {
    return function (action) {
      var state = store.getState();

      if (action.type === c.NETWORK_OFFLINE) {
        // disconnect any incoming calls
        var galaxyIncomingQueue = (0, _safeAccess.default)(state, 'nucleus.galaxy.incoming') || [];
        galaxyIncomingQueue.forEach(function (call) {
          store.dispatch((0, _call.ignoreCallGalaxy)({
            callId: call.callId
          }));
        });
      }

      var res = next(action);
      var nextState = store.getState(); // create stream holders on init
      // set up device monitor

      if (action.type === c.INIT_NUCLEUS) {
        setupDeviceMonitor(store);
        streamTransmitter.addPrimaryElements((0, _safeAccess.default)(action.payload, 'localPrimaryElementIds') || [], store); // TBD: This can be removed from the stream transmitter. Keeping it for the time being
        // so that no assumptions are borken

        streamTransmitter.addPresentationElements((0, _safeAccess.default)(action.payload, 'localSecondaryElementIds') || [], store);
        streamReceiver.addPrimaryElements((0, _safeAccess.default)(action.payload, 'remotePrimaryElementIds') || [], store); // TBD: This can be removed from the stream transmitter. Keeping it for the time being
        // so that no assumptions are borken

        streamReceiver.addPresentationElements((0, _safeAccess.default)(action.payload, 'remoteSecondaryElementIds') || [], store);
        presStreamTransmitter.addPresentationElements((0, _safeAccess.default)(action.payload, 'localSecondaryElementIds') || [], store);
        presStreamReceiver.addPresentationElements((0, _safeAccess.default)(action.payload, 'remoteSecondaryElementIds') || [], store);
        return res;
      }

      if (action.type === c.REATTACH_PRESENTATION) {
        if ((0, _galaxyUtils.isGalaxyCallConnected)(state)) rtcPeerManager.reattachPresentation(action.payload, store);
        return res;
      }

      if (action.type === c.END_LOCAL_STREAM) {
        return rtcPeerManager.endPrimary(store).then(function () {
          return store.dispatch({
            type: c.LOCAL_STREAM_ENDED
          });
        });
      }

      if (action.type === c.MEDIA_DEVICES_UPDATED) {
        var shouldAcquireLocalPrimary = (0, mediaUtils.shouldReacquireOnMediaDevicesChanged)(nextState, action);

        if (shouldAcquireLocalPrimary) {
          store.dispatch((0, _stream.acquireLocalPrimaryStream)());
        } // CNUC-478 - find new audio output device as needed


        var availableOutputDevices = ((0, _safeAccess.default)(action, 'payload') || []).filter(function (d) {
          return d.kind === 'audiooutput';
        }); // now check if our current outputId is no longer available

        if (streamReceiver.outputId && availableOutputDevices.length && !availableOutputDevices.find(function (d) {
          return d.deviceId === streamReceiver.outputId;
        })) {
          // find out preferred output id, and select it (or first in the list if it's not there)
          var preferredOutputId = (0, _safeAccess.default)(nextState, 'nucleus.media.primaryAudioOutputId');
          var newOutputDevice = availableOutputDevices.find(function (d) {
            return d.deviceId === preferredOutputId;
          }) || availableOutputDevices[0];
          streamReceiver.setOutputDeviceId(newOutputDevice.deviceId);
        }

        return res;
      }

      if (action.type === c.SET_PRIMARY_AUDIO_OUTPUT_ID) {
        streamReceiver.setOutputDeviceId(action.payload);
        return res;
      } // create stream holders on acquiring stream


      if (action.type === c.ACQUIRE_LOCAL_PRIMARY_STREAM_BEGIN) {
        return rtcPeerManager.startPrimary(store, action.payload).then(function (result) {
          if ((0, _safeAccess.default)(state, 'nucleus.media.devices.length')) return result;
          return updateMediaDevices(store).then(function () {
            return result;
          });
        }).then(function (result) {
          var updatePromise = (0, _galaxyUtils.isGalaxyCallConnected)(state) ? store.dispatch((0, _stream.updatePrimarySourceGalaxy)()) : Promise.resolve();
          return updatePromise.then(function () {
            return result;
          });
        }).catch(function (err) {
          _jsLogger.default.warn('Unable to acquire primary stream:', err.name, err.message);
        });
      } // end the local stream if end was triggered while in the process of acquiring.


      if (action.type === c.ACQUIRE_LOCAL_PRIMARY_STREAM_SUCCESS && (0, _safeAccess.default)(nextState, 'nucleus.media.endAfterAcquirePrimaryStream')) {
        store.dispatch((0, _stream.endLocalStream)());
      }

      if (action.type === c.SWITCH_VIDEO_CAMERA) {
        rtcPeerManager.switchVideoCamera();
        return res;
      }

      if (action.type === c.TOGGLE_AUDIO_MUTE) {
        rtcPeerManager.toggleAudioMute(store, action.payload.mute).then(function (sourceId) {
          var audioMuted = streamTransmitter.isAudioMuted();
          store.dispatch({
            type: audioMuted ? c.LOCAL_AUDIO_MUTED : c.LOCAL_AUDIO_UNMUTED,
            payload: sourceId
          });
        });
        return res;
      } // hacky web conference mode


      if (action.type === c.ENABLE_WEB_CONFERENCE_MODE) {
        streamReceiver.primaryStreamHolder.toggleElementMute(true);
        streamReceiver.presentationStreamHolder.toggleElementMute(true);
        rtcPeerManager.toggleAudioMute(store, true).then(function (sourceId) {
          var audioMuted = streamTransmitter.isAudioMuted();
          store.dispatch({
            type: audioMuted ? c.LOCAL_AUDIO_MUTED : c.LOCAL_AUDIO_UNMUTED,
            payload: sourceId
          });
        });
        return res;
      }

      if (action.type === c.DISABLE_WEB_CONFERENCE_MODE) {
        streamReceiver.primaryStreamHolder.toggleElementMute(false);
        streamReceiver.presentationStreamHolder.toggleElementMute(false);
        return res;
      }

      if (action.type === c.WIRELESS_PRESENTATION_ON_STREAM) {
        _jsLogger.default.info('wireless-presentation: Adding external presentation stream to transmitters.');

        presStreamTransmitter.addExternalPresentationStream(action.payload);
        streamTransmitter.addExternalPresentationStream(action.payload);
        var inCall = (0, _call2.activeCallSelector)(store.getState()).state === c.CALL_STATE_CONNECTED;

        _jsLogger.default.info("wireless-presentation: checking if we need to start presentation after getting wireless presentation stream. inCall: ".concat(inCall));

        if (inCall) {
          store.dispatch((0, _stream.startPresentation)('', ''));
        }
      }

      if (action.type === c.WIRELESS_PRESENTATION_STREAM_ENDED) {
        _jsLogger.default.info('wireless-presentation: Removing external presentation');

        presStreamTransmitter.addExternalPresentationStream(null);
        streamTransmitter.addExternalPresentationStream(null);

        var _inCall = (0, _call2.activeCallSelector)(state).state === c.CALL_STATE_CONNECTED;

        if (_inCall) {
          _jsLogger.default.info('wireless-presentation: stopping presentation after getting external stream in a call');

          store.dispatch((0, _stream.stopPresentation)());
        }
      }
      /**
       * Handle Galaxy Actions
       **/


      var galaxyActionResult = handleGalaxyActions(store, action); // result exists, we handled a galaxy action, return the result

      if (galaxyActionResult) return galaxyActionResult;
      return res;
    };
  };
};

var onUpdateSdpAnswerReceived =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee(store, action) {
    var awaitingPresentationAnswer, sdp, presSdp, reason;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            awaitingPresentationAnswer = (0, _safeAccess.default)(store.getState(), 'nucleus.galaxy.presentation.isAwaitingAnswer');
            sdp = (0, _safeAccess.default)(action, 'payload.capability.sdp');
            presSdp = (0, _safeAccess.default)(action, 'payload.capability.presSdp');
            reason = (0, _safeAccess.default)(action, 'payload.reason');

            if (awaitingPresentationAnswer && (0, _safeAccess.default)(action, 'payload.reason') === c.GALAXY_REASON_PRESENTATION_RECEIVE) {
              store.dispatch({
                type: c.GALAXY_ACTION_PRESENTATION_ANSWER
              });
              clearTimeout(awaitingPresentationAnswerTimeout);
            }

            _context.next = 7;
            return rtcPeerManager.handleGalaxyAnswer(store, sdp, presSdp, reason);

          case 7:
            return _context.abrupt("return", _context.sent);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function onUpdateSdpAnswerReceived(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var createGalaxyAnswer =
/*#__PURE__*/
function () {
  var _ref2 = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee2(store, action) {
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return rtcPeerManager.createGalaxyAnswer(store, action.payload);

          case 2:
            return _context2.abrupt("return", _context2.sent);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function createGalaxyAnswer(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var handleGalaxyCallEnded =
/*#__PURE__*/
function () {
  var _ref3 = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee3(store, action) {
    var state;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            state = store.getState();

            if (!((0, _safeAccess.default)(state, 'nucleus.galaxy.call.callId') !== (0, _safeAccess.default)(action, 'payload.callId'))) {
              _context3.next = 3;
              break;
            }

            return _context3.abrupt("return", Promise.resolve());

          case 3:
            rtcPeerManager.shutdownSunsettedPeerConnections();
            _context3.next = 6;
            return rtcPeerManager.shutdownGalaxyPeerConnection(store);

          case 6:
            return _context3.abrupt("return", _context3.sent);

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function handleGalaxyCallEnded(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();

var handleGalaxyUpdatePrimarySource =
/*#__PURE__*/
function () {
  var _ref4 = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee4(store) {
    var result;
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return rtcPeerManager.updateVideoOfferGalaxy(store);

          case 3:
            result = _context4.sent;

            if (result) {
              _context4.next = 6;
              break;
            }

            return _context4.abrupt("return");

          case 6:
            _context4.next = 8;
            return store.dispatch((0, _stream.sendUpdateSdpGalaxy)(c.WEBRTC_SDP_TYPE_OFFER, c.GALAXY_REASON_SDP_UPDATE, result.sdp, null, null, result.priority));

          case 8:
            return _context4.abrupt("return", _context4.sent);

          case 11:
            _context4.prev = 11;
            _context4.t0 = _context4["catch"](0);

            _jsLogger.default.error('error in handleGalaxyUpdatePrimarySource', _context4.t0);

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 11]]);
  }));

  return function handleGalaxyUpdatePrimarySource(_x7) {
    return _ref4.apply(this, arguments);
  };
}();

var handleGalaxyToggleVideoMute =
/*#__PURE__*/
function () {
  var _ref5 = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee5(store, action) {
    var videoMuted, reason, result;
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return rtcPeerManager.toggleVideoMuteGalaxy(store, (0, _safeAccess.default)(action, 'payload.mute'));

          case 3:
            videoMuted = streamTransmitter.isVideoMuted();
            reason = videoMuted ? c.GALAXY_REASON_VIDEO_MUTE_UPDATE : c.GALAXY_REASON_VIDEO_UNMUTE_UPDATE;
            store.dispatch({
              type: videoMuted ? c.LOCAL_VIDEO_MUTED : c.LOCAL_VIDEO_UNMUTED,
              payload: streamTransmitter.stream
            });
            rtcPeerManager.sendLocalVideoMuteGalaxy(store);

            if (CONFIG.calls.useVideoMuteSlide) {
              _context5.next = 9;
              break;
            }

            return _context5.abrupt("return");

          case 9:
            _context5.next = 11;
            return rtcPeerManager.updateVideoOfferGalaxy(store);

          case 11:
            result = _context5.sent;

            if (result) {
              _context5.next = 14;
              break;
            }

            return _context5.abrupt("return");

          case 14:
            _context5.next = 16;
            return store.dispatch((0, _stream.sendUpdateSdpGalaxy)(c.WEBRTC_SDP_TYPE_OFFER, reason, result.sdp, null, null, result.priority));

          case 16:
            return _context5.abrupt("return", _context5.sent);

          case 19:
            _context5.prev = 19;
            _context5.t0 = _context5["catch"](0);

            _jsLogger.default.error('Error in handleGalaxyToggleVideoMute', _context5.t0);

          case 22:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 19]]);
  }));

  return function handleGalaxyToggleVideoMute(_x8, _x9) {
    return _ref5.apply(this, arguments);
  };
}();

var onUpdateSdpOfferReceived =
/*#__PURE__*/
function () {
  var _ref6 = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee6(store, action) {
    var sdp, presSdp, priority, result, updateResult;
    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            sdp = (0, _safeAccess.default)(action, 'payload.capability.sdp');
            presSdp = (0, _safeAccess.default)(action, 'payload.capability.presSdp');
            priority = (0, _safeAccess.default)(action, 'payload.capability.priority');

            if ((0, _safeAccess.default)(action, 'payload.reason') === c.GALAXY_REASON_PRESENTATION_STOP) {
              rtcPeerManager.onRemoveGalaxyPresStream(store, {});
              store.dispatch({
                type: c.GALAXY_ACTION_RX_STOPPED_PRESENTATION
              });
            }

            _context6.next = 7;
            return rtcPeerManager.handleGalaxyUpdateOffer(store, sdp, presSdp, priority);

          case 7:
            result = _context6.sent;

            if (result) {
              _context6.next = 10;
              break;
            }

            return _context6.abrupt("return");

          case 10:
            _context6.next = 12;
            return store.dispatch((0, _stream.sendUpdateSdpGalaxy)(c.WEBRTC_SDP_TYPE_ANSWER, (0, _galaxyUtils.getSdpUpdateReasonResponse)((0, _safeAccess.default)(action, 'payload.reason')), (0, _safeAccess.default)(result, 'sdp'), null, (0, _safeAccess.default)(result, 'presSdp')));

          case 12:
            updateResult = _context6.sent;
            // notify the reducers that we've answered the offer (mediaprocessing = false)
            store.dispatch({
              type: c.GALAXY_ACTION_UPDATE_SDP_ANSWERED,
              payload: {
                remoteStream: streamReceiver.primaryStream,
                remotePresentationStream: presStreamReceiver.presentationStream
              }
            });
            return _context6.abrupt("return", updateResult);

          case 17:
            _context6.prev = 17;
            _context6.t0 = _context6["catch"](0);

            _jsLogger.default.error('Error handling Sdp Offer', _context6.t0);

          case 20:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 17]]);
  }));

  return function onUpdateSdpOfferReceived(_x10, _x11) {
    return _ref6.apply(this, arguments);
  };
}();

var handleGalaxyCreateOffer =
/*#__PURE__*/
function () {
  var _ref7 = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee7(store, action) {
    var useDataChannel, offers, callId, sourceId, sdp, presSdp, capability, cameraCapabilities, data, error;
    return _regenerator.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            rtcPeerManager.sunsetGalaxyPeerConnections(); // CNUC-1618
            // if we're headed to the IVR, we must manually stop the remote side presentation

            if ((0, _safeAccess.default)(action, 'payload.reason') === c.GALAXY_REASON_REDIRECT_IVR || (0, _safeAccess.default)(action, 'payload.reason') === c.GALAXY_REASON_PARTICIPANT_EJECTED) {
              store.dispatch({
                type: c.GALAXY_ACTION_RX_STOPPED_PRESENTATION
              });
            }

            useDataChannel = false;

            if (CONFIG.calls.useDataChannel && (0, _safeAccess.default)(action, 'payload.reason') === 'mediaJoin') {
              useDataChannel = true;
            }

            _context7.next = 7;
            return rtcPeerManager.createGalaxyOffer(store, useDataChannel);

          case 7:
            offers = _context7.sent;
            callId = (0, _safeAccess.default)(action, 'payload.callId');
            sourceId = (0, _safeAccess.default)(action, 'payload.sourceId');
            sdp = (0, _safeAccess.default)(offers, '[0].sdp');
            presSdp = (0, _safeAccess.default)(offers, '[1].sdp');
            capability = {
              type: c.WEBRTC_SDP_TYPE_OFFER,
              sdp: sdp,
              presSdp: presSdp
            };
            cameraCapabilities = (0, _deviceUtils.getCallCameraCapabilities)(store.getState());

            if (cameraCapabilities) {
              capability.cameraCapabilities = cameraCapabilities;
            }

            data = {
              command: c.GALAXY_COMMAND_OFFER_CREATED,
              capability: capability,
              callId: callId,
              sourceId: sourceId
            };
            _context7.next = 18;
            return store.dispatch((0, _call.postCallCommandGalaxy)(data));

          case 18:
            return _context7.abrupt("return", _context7.sent);

          case 21:
            _context7.prev = 21;
            _context7.t0 = _context7["catch"](0);
            error = {
              callId: (0, _safeAccess.default)(action, 'payload.callId'),
              error: _context7.t0,
              reason: c.GALAXY_REASON_SERVER_ERROR
            };
            store.dispatch((0, _call.failedCallGalaxy)(error));
            return _context7.abrupt("return", error);

          case 26:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 21]]);
  }));

  return function handleGalaxyCreateOffer(_x12, _x13) {
    return _ref7.apply(this, arguments);
  };
}();

var handleGalaxyInCallOffer =
/*#__PURE__*/
function () {
  var _ref8 = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee8(store, action) {
    var answers, callId, sourceId, sdp, presSdp, capability, cameraCapabilities, data, callCommandResult, error;
    return _regenerator.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            rtcPeerManager.sunsetGalaxyPeerConnections();
            _context8.next = 4;
            return rtcPeerManager.createGalaxyAnswer(store, action.payload);

          case 4:
            answers = _context8.sent;
            callId = (0, _safeAccess.default)(action, 'payload.callId');
            sourceId = (0, _safeAccess.default)(action, 'payload.sourceId');
            sdp = (0, _safeAccess.default)(answers, '[0].sdp');
            presSdp = (0, _safeAccess.default)(answers, '[1].sdp');
            capability = {
              type: c.WEBRTC_SDP_TYPE_ANSWER,
              sdp: sdp,
              presSdp: presSdp
            };
            cameraCapabilities = (0, _deviceUtils.getCallCameraCapabilities)(store.getState());

            if (cameraCapabilities) {
              capability.cameraCapabilities = cameraCapabilities;
            }

            data = {
              command: c.GALAXY_COMMAND_IN_CALL_ANSWER,
              capability: capability,
              callId: callId,
              sourceId: sourceId
            };
            _context8.next = 15;
            return store.dispatch((0, _call.postCallCommandGalaxy)(data));

          case 15:
            callCommandResult = _context8.sent;
            rtcPeerManager.shutdownSunsettedPeerConnections();
            return _context8.abrupt("return", callCommandResult);

          case 20:
            _context8.prev = 20;
            _context8.t0 = _context8["catch"](0);
            error = {
              callId: (0, _safeAccess.default)(action, 'payload.callId'),
              error: _context8.t0,
              reason: c.GALAXY_REASON_SERVER_ERROR
            };
            store.dispatch((0, _call.failedCallGalaxy)(error));
            return _context8.abrupt("return", error);

          case 25:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 20]]);
  }));

  return function handleGalaxyInCallOffer(_x14, _x15) {
    return _ref8.apply(this, arguments);
  };
}();

var stopPresentationDueToEndAndAnswer =
/*#__PURE__*/
function () {
  var _ref9 = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee9(store) {
    var state, isPresenting, receivingPresentation;
    return _regenerator.default.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            state = store.getState();
            isPresenting = (0, _safeAccess.default)(state, 'nucleus.galaxy.presentation.state') === c.GALAXY_PRESENTATION_STATE_TX_STARTED;
            receivingPresentation = (0, _safeAccess.default)(state, 'nucleus.galaxy.presentation.state') === c.GALAXY_PRESENTATION_STATE_RX_STARTED;

            if (!isPresenting) {
              _context9.next = 10;
              break;
            }

            _context9.next = 6;
            return presStreamTransmitter.endPresentation(store, false);

          case 6:
            _context9.next = 8;
            return store.dispatch((0, _presentation.sendPresentationTokenReleaseGalaxy)());

          case 8:
            _context9.next = 10;
            return store.dispatch((0, _stream.galaxyLocalPresentationStopped)());

          case 10:
            if (!receivingPresentation) {
              _context9.next = 13;
              break;
            }

            _context9.next = 13;
            return store.dispatch({
              type: c.GALAXY_ACTION_RX_STOPPED_PRESENTATION
            });

          case 13:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function stopPresentationDueToEndAndAnswer(_x16) {
    return _ref9.apply(this, arguments);
  };
}();

var handleReplaceCall =
/*#__PURE__*/
function () {
  var _ref10 = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee10(store, action) {
    var answers, conferenceId, callId, sourceId, sdp, presSdp, capability, data, callCommandResult, error;
    return _regenerator.default.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            rtcPeerManager.sunsetGalaxyPeerConnections(); // stop any presentation when user end+answer's

            _context10.next = 4;
            return stopPresentationDueToEndAndAnswer(store);

          case 4:
            _context10.next = 6;
            return rtcPeerManager.createGalaxyAnswer(store, action.payload);

          case 6:
            answers = _context10.sent;
            conferenceId = (0, _safeAccess.default)(action, 'payload.conferenceId');
            callId = (0, _safeAccess.default)(action, 'payload.callId');
            sourceId = (0, _safeAccess.default)(action, 'payload.sourceId');
            sdp = (0, _safeAccess.default)(answers, '[0].sdp');
            presSdp = (0, _safeAccess.default)(answers, '[1].sdp');
            capability = {
              type: c.WEBRTC_SDP_TYPE_ANSWER,
              sdp: sdp,
              presSdp: presSdp
            };
            data = {
              command: c.GALAXY_COMMAND_CALL_REPLACED,
              capability: capability,
              callId: callId,
              sourceId: sourceId,
              conferenceId: conferenceId
            };
            _context10.next = 16;
            return store.dispatch((0, _call.postCallCommandGalaxy)(data));

          case 16:
            callCommandResult = _context10.sent;
            rtcPeerManager.shutdownSunsettedPeerConnections();
            return _context10.abrupt("return", callCommandResult);

          case 21:
            _context10.prev = 21;
            _context10.t0 = _context10["catch"](0);
            error = {
              callId: (0, _safeAccess.default)(action, 'payload.callId'),
              error: _context10.t0,
              reason: c.GALAXY_REASON_SERVER_ERROR
            };
            store.dispatch((0, _call.failedCallGalaxy)(error));
            return _context10.abrupt("return", error);

          case 26:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[0, 21]]);
  }));

  return function handleReplaceCall(_x17, _x18) {
    return _ref10.apply(this, arguments);
  };
}();

var handleGalaxyOfferAnswered =
/*#__PURE__*/
function () {
  var _ref11 = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee11(store, action) {
    return _regenerator.default.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            rtcPeerManager.shutdownSunsettedPeerConnections();
            _context11.next = 3;
            return onUpdateSdpAnswerReceived(store, action);

          case 3:
            return _context11.abrupt("return", _context11.sent);

          case 4:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));

  return function handleGalaxyOfferAnswered(_x19, _x20) {
    return _ref11.apply(this, arguments);
  };
}();

var awaitPresentationAnswer = function awaitPresentationAnswer(store) {
  store.dispatch({
    type: c.GALAXY_ACTION_AWAIT_PRESENTATION_ANSWER
  });
};

var handlePresentationConnect = function handlePresentationConnect(store) {
  var awaitingPresentationAnswer = (0, _safeAccess.default)(store.getState(), 'nucleus.galaxy.presentation.isAwaitingAnswer');
  exports.awaitingPresentationAnswerTimeout = awaitingPresentationAnswerTimeout = setTimeout(function () {
    if (awaitingPresentationAnswer) {
      var error = 'No presentation answer';

      _jsLogger.default.error(error);

      return store.dispatch({
        type: c.GALAXY_ACTION_STOP_PRESENTATION,
        payload: error
      });
    }
  }, c.GALAXY_ACTION_AWAIT_PRESENTATION_TIMEOUT);
};

var handlePresentationTokenGranted =
/*#__PURE__*/
function () {
  var _ref12 = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee12(store) {
    var state, result, localPresentationStream, trackId, tracks, videoResult;
    return _regenerator.default.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.prev = 0;
            state = store.getState();
            _context12.next = 4;
            return rtcPeerManager.startPresentationGalaxy(store, (0, _safeAccess.default)(state, 'nucleus.galaxy.presentation.presentationSourceId'));

          case 4:
            result = _context12.sent;
            localPresentationStream = (0, _safeAccess.default)(state, 'nucleus.media.localPresentationStream');
            trackId = (0, _safeAccess.default)(state, 'nucleus.galaxy.presentation.trackId');
            tracks = {
              presentation: trackId || localPresentationStream && localPresentationStream.getTracks()[0]
            };
            _context12.next = 10;
            return store.dispatch((0, _stream.sendUpdateSdpGalaxy)(c.WEBRTC_SDP_TYPE_OFFER, c.GALAXY_REASON_PRESENTATION_SEND, null, tracks, result.sdp, result.priority));

          case 10:
            store.dispatch({
              type: c.GALAXY_ACTION_PRESENTATION_CONNECTED
            });

            if ((0, _safeAccess.default)(state, 'nucleus.galaxy.options.updateVideoBandwidth')) {
              _context12.next = 13;
              break;
            }

            return _context12.abrupt("return");

          case 13:
            _context12.next = 15;
            return rtcPeerManager.updateVideoOfferGalaxy(store);

          case 15:
            videoResult = _context12.sent;

            if (videoResult) {
              _context12.next = 18;
              break;
            }

            return _context12.abrupt("return");

          case 18:
            _context12.next = 20;
            return store.dispatch((0, _stream.sendUpdateSdpGalaxy)(c.WEBRTC_SDP_TYPE_OFFER, c.GALAXY_REASON_VIDEO_BANDWIDTH_UPDATE, videoResult.sdp, null, null, videoResult.priority));

          case 20:
            return _context12.abrupt("return", _context12.sent);

          case 23:
            _context12.prev = 23;
            _context12.t0 = _context12["catch"](0);

            _jsLogger.default.error('Error starting presentation', _context12.t0);

            _context12.next = 28;
            return store.dispatch((0, _presentation.sendPresentationTokenReleaseGalaxy)());

          case 28:
            return _context12.abrupt("return", _context12.sent);

          case 29:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, null, [[0, 23]]);
  }));

  return function handlePresentationTokenGranted(_x21) {
    return _ref12.apply(this, arguments);
  };
}();

var handleStopPresentation =
/*#__PURE__*/
function () {
  var _ref13 = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee13(store) {
    var state, result, trackId, tracks, videoResult;
    return _regenerator.default.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.prev = 0;
            state = store.getState();
            _context13.next = 4;
            return rtcPeerManager.endPresentationGalaxy(store);

          case 4:
            result = _context13.sent;
            trackId = (0, _safeAccess.default)(state, 'nucleus.galaxy.presentation.trackId');
            tracks = {
              presentation: trackId
            };
            _context13.next = 9;
            return store.dispatch((0, _stream.sendUpdateSdpGalaxy)(c.WEBRTC_SDP_TYPE_OFFER, c.GALAXY_REASON_PRESENTATION_STOP, null, tracks, result.sdp, result.priority));

          case 9:
            _context13.next = 11;
            return store.dispatch((0, _presentation.sendPresentationTokenReleaseGalaxy)());

          case 11:
            if ((0, _safeAccess.default)(state, 'nucleus.galaxy.options.updateVideoBandwidth')) {
              _context13.next = 13;
              break;
            }

            return _context13.abrupt("return");

          case 13:
            _context13.next = 15;
            return rtcPeerManager.updateVideoOfferGalaxy(store);

          case 15:
            videoResult = _context13.sent;

            if (videoResult) {
              _context13.next = 18;
              break;
            }

            return _context13.abrupt("return");

          case 18:
            _context13.next = 20;
            return store.dispatch((0, _stream.sendUpdateSdpGalaxy)(c.WEBRTC_SDP_TYPE_OFFER, c.GALAXY_REASON_VIDEO_BANDWIDTH_UPDATE, videoResult.sdp, null, null, videoResult.priority));

          case 20:
            return _context13.abrupt("return", _context13.sent);

          case 23:
            _context13.prev = 23;
            _context13.t0 = _context13["catch"](0);

            _jsLogger.default.error('Error stopping presentation', _context13.t0);

            _context13.next = 28;
            return store.dispatch((0, _presentation.sendPresentationTokenReleaseGalaxy)());

          case 28:
            return _context13.abrupt("return", _context13.sent);

          case 29:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, null, [[0, 23]]);
  }));

  return function handleStopPresentation(_x22) {
    return _ref13.apply(this, arguments);
  };
}();

var handleRevokePresentation =
/*#__PURE__*/
function () {
  var _ref14 = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee14(store) {
    var state, isPresenting, result, trackId, tracks, videoResult;
    return _regenerator.default.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.prev = 0;
            state = store.getState();
            isPresenting = (0, _safeAccess.default)(state, 'nucleus.galaxy.presentation.state') === c.GALAXY_PRESENTATION_STATE_TX_STARTED; // If the presentation is active stop that and also initiate a reneg

            if (!isPresenting) {
              _context14.next = 25;
              break;
            }

            _context14.next = 6;
            return presStreamTransmitter.endPresentation(store, false);

          case 6:
            _context14.next = 8;
            return rtcPeerManager.endPresentationGalaxy(store);

          case 8:
            result = _context14.sent;
            trackId = (0, _safeAccess.default)(state, 'nucleus.galaxy.presentation.trackId');
            tracks = {
              presentation: trackId
            };
            _context14.next = 13;
            return store.dispatch((0, _stream.galaxyLocalPresentationStopped)());

          case 13:
            _context14.next = 15;
            return store.dispatch((0, _stream.sendUpdateSdpGalaxy)(c.WEBRTC_SDP_TYPE_OFFER, c.GALAXY_REASON_PRESENTATION_STOP, null, tracks, result.sdp, result.priority));

          case 15:
            if ((0, _safeAccess.default)(state, 'nucleus.galaxy.options.updateVideoBandwidth')) {
              _context14.next = 17;
              break;
            }

            return _context14.abrupt("return");

          case 17:
            _context14.next = 19;
            return rtcPeerManager.updateVideoOfferGalaxy(store);

          case 19:
            videoResult = _context14.sent;

            if (videoResult) {
              _context14.next = 22;
              break;
            }

            return _context14.abrupt("return");

          case 22:
            _context14.next = 24;
            return store.dispatch((0, _stream.sendUpdateSdpGalaxy)(c.WEBRTC_SDP_TYPE_OFFER, c.GALAXY_REASON_VIDEO_BANDWIDTH_UPDATE, videoResult.sdp, null, null, videoResult.priority));

          case 24:
            return _context14.abrupt("return", _context14.sent);

          case 25:
            _context14.next = 30;
            break;

          case 27:
            _context14.prev = 27;
            _context14.t0 = _context14["catch"](0);

            _jsLogger.default.error('Error stopping presentation', _context14.t0);

          case 30:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, null, [[0, 27]]);
  }));

  return function handleRevokePresentation(_x23) {
    return _ref14.apply(this, arguments);
  };
}();

var handleRemoteIceCandidates =
/*#__PURE__*/
function () {
  var _ref15 = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee15(store, action) {
    var iceCandidates, presIceCandidates;
    return _regenerator.default.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            iceCandidates = (0, _safeAccess.default)(action, 'payload.iceCandidates');
            presIceCandidates = (0, _safeAccess.default)(action, 'payload.presIceCandidates');
            _context15.next = 4;
            return rtcPeerManager.handleRemoteIceCandidates(store, iceCandidates, presIceCandidates);

          case 4:
            return _context15.abrupt("return", _context15.sent);

          case 5:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));

  return function handleRemoteIceCandidates(_x24, _x25) {
    return _ref15.apply(this, arguments);
  };
}();

var handleParticipantAction =
/*#__PURE__*/
function () {
  var _ref16 = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee16(store, action) {
    var state, activeConferenceId, conferenceId, participantCount;
    return _regenerator.default.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            // Check if the notification is for the active conference. If so check the number
            // of participants in the conference. If the number of participants is 3 then
            // downscale the resolution. If its 2 then upscale the resolution back to HD
            state = store.getState();

            if ((0, _galaxyUtils.isAutoResolutionChangeEnabled)(state)) {
              _context16.next = 3;
              break;
            }

            return _context16.abrupt("return");

          case 3:
            activeConferenceId = (0, _conference.selectConferenceId)(state);
            conferenceId = (0, _safeAccess.default)(action, 'payload.conferenceId');
            participantCount = ((0, _safeAccess.default)(state, 'nucleus.galaxy.conference.participants') || []).length;

            if (!(activeConferenceId === conferenceId)) {
              _context16.next = 17;
              break;
            }

            if (!(participantCount >= c.RESOLUTION_DOWNSCALE_THRESHOLD)) {
              _context16.next = 13;
              break;
            }

            _context16.next = 10;
            return rtcPeerManager.downScaleVideoResolution(store);

          case 10:
            return _context16.abrupt("return", _context16.sent);

          case 13:
            if (!(participantCount <= c.RESOLUTION_UPSCALE_THRESHOLD)) {
              _context16.next = 17;
              break;
            }

            _context16.next = 16;
            return rtcPeerManager.upScaleVideoResolution(store);

          case 16:
            return _context16.abrupt("return", _context16.sent);

          case 17:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));

  return function handleParticipantAction(_x26, _x27) {
    return _ref16.apply(this, arguments);
  };
}();

var galaxyActionMap = (_galaxyActionMap = {}, (0, _defineProperty2.default)(_galaxyActionMap, c.WAMP_CONNECT_SUCCESS, function (store) {
  return rtcPeerManager.handleReconnected(store);
}), (0, _defineProperty2.default)(_galaxyActionMap, c.WAMP_CONNECT_ERROR, function () {
  return rtcPeerManager.abortIceRestarts();
}), (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_TOGGLE_VIDEO_MUTE, handleGalaxyToggleVideoMute), (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_RX_STOPPED_PRESENTATION, function () {
  return presStreamReceiver.removePresentation();
}), (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_END, handleGalaxyCallEnded), (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_FAILED, handleGalaxyCallEnded), (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_CREATE_OFFER, handleGalaxyCreateOffer), (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_IN_CALL_OFFER, handleGalaxyInCallOffer), (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_OFFER_ANSWERED, handleGalaxyOfferAnswered), (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_BEGIN_CALL_OFFER, function (store) {
  return rtcPeerManager.createGalaxyOffer(store);
}), (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_CALL_CONNECTED, onUpdateSdpAnswerReceived), (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_ON_UPDATE_SDP_OFFER, onUpdateSdpOfferReceived), (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_ON_UPDATE_SDP_ANSWER, onUpdateSdpAnswerReceived), (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_BEGIN_ANSWER, createGalaxyAnswer), (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_PRESENTATION_TOKEN_GRANTED, handlePresentationTokenGranted), (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_STOP_PRESENTATION, handleStopPresentation), (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_PRESENTATION_TOKEN_REVOKED, handleRevokePresentation), (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_UPDATE_PRIMARY_SOURCE, handleGalaxyUpdatePrimarySource), (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_TRICKLE_ICE, handleRemoteIceCandidates), (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_REPLACE_CALL, handleReplaceCall), (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_BEGIN_PRESENTATION, awaitPresentationAnswer), (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_PRESENTATION_CONNECTED, handlePresentationConnect), (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_PARTICIPANT_JOINED, handleParticipantAction), (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_PARTICIPANT_LEFT, handleParticipantAction), (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_CONFERENCE_JOINED, handleParticipantAction), (0, _defineProperty2.default)(_galaxyActionMap, c.LOCAL_AUDIO_UNMUTED, function (store, action) {
  return action.payload ? handleGalaxyUpdatePrimarySource(store, action) : Promise.resolve();
}), _galaxyActionMap);

var handleGalaxyActions = function handleGalaxyActions(store, action) {
  var galaxyActionHandler = galaxyActionMap[(0, _safeAccess.default)(action, 'type')];

  if (galaxyActionHandler) {
    return galaxyActionHandler(store, action);
  }

  return null;
};
/**
 * createRtcMiddleware
 * This function creates middleware for handling RTC calls in a browser environment.
 */


function createRtcMiddleware() {
  exports.windowGenerateCertificate = windowGenerateCertificate = (0, _rtcUtils.getGenerateCertificate)();
  exports.streamTransmitter = streamTransmitter = new _streamTransmitter.default();
  exports.streamReceiver = streamReceiver = new _streamReceiver.default();
  exports.presStreamTransmitter = presStreamTransmitter = new _streamTransmitter.default();
  exports.presStreamReceiver = presStreamReceiver = new _streamReceiver.default();
  exports.rtcPeerManager = rtcPeerManager = new _rtcPeerManager.default(windowGenerateCertificate, streamTransmitter, streamReceiver, presStreamTransmitter, presStreamReceiver);

  if (!window.attachMediaStream) {
    window.attachMediaStream = function (video, stream) {
      if (!video) return;
      video.srcObject = stream;
    };
  }

  return rtcMiddleware;
}

var _default = rtcMiddleware;
exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(29)["default"]))

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(CONFIG) {

var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(34));

var _createClass2 = _interopRequireDefault(__webpack_require__(36));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _galaxyPeerConnection = _interopRequireDefault(__webpack_require__(547));

var _call = __webpack_require__(50);

var c = _interopRequireWildcard(__webpack_require__(3));

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _browserUtils = __webpack_require__(44);

var _streamUtils = __webpack_require__(105);

var _mediaStats = __webpack_require__(279);

var _mediaStatsService = _interopRequireDefault(__webpack_require__(548));

var _auth = __webpack_require__(31);

var _callHeartbeatService = _interopRequireDefault(__webpack_require__(574));

var _call2 = __webpack_require__(51);

var RTCPeerManager =
/*#__PURE__*/
function () {
  function RTCPeerManager(windowGenerateCertificate, streamTransmitter, streamReceiver, transmitPresStream, receivePresStream) {
    (0, _classCallCheck2.default)(this, RTCPeerManager);

    if (!windowGenerateCertificate || !streamReceiver || !streamTransmitter) {
      throw 'Error creating RTCPeerManager, missing param';
    }

    this.windowGenerateCertificate = windowGenerateCertificate;
    this.galaxyPeerConnection = new _galaxyPeerConnection.default(this.onTrackGalaxy.bind(this), this.onGalaxyRemoveStream.bind(this), this.startIceCandidateTimer.bind(this));
    this.galaxyPresPeerConnection = new _galaxyPeerConnection.default(this.onTrackGalaxyPresentation.bind(this), this.onRemoveGalaxyPresStream.bind(this), this.startIceCandidateTimer.bind(this), true);
    this.sunsettedPeerConnections = [];
    this.transmitStream = streamTransmitter;
    this.receiveStream = streamReceiver;
    this.transmitPresStream = transmitPresStream;
    this.receivePresStream = receivePresStream;
    this.isPinnedMode = false;
    this.includeAudio = true;
    this.includeVideo = true;
    this.iceCandidateTimer = null;
    this.mediaStats = null;
    this.heartBeatService = new _callHeartbeatService.default();
  }

  (0, _createClass2.default)(RTCPeerManager, [{
    key: "reattachPresentation",
    value: function reattachPresentation(id, store) {
      this.receivePresStream.addPresentationElements([id], store);
    }
  }, {
    key: "onGalaxyRemoveStream",
    value: function onGalaxyRemoveStream(store, evt) {
      this.receiveStream.handleRemoveStream(store, evt, true); // Check if all the remote streams have been removed and if so fire the
      // remote stream removed event

      if (!this.galaxyPeerConnection || !this.galaxyPeerConnection.getRemoteStreams().length) {
        store.dispatch({
          type: c.RTC_REMOTE_STREAM_REMOVED
        });
      }
    }
  }, {
    key: "sunsetGalaxyPeerConnections",
    value: function sunsetGalaxyPeerConnections() {
      if (this.mediaStats) this.mediaStats.stop();
      this.galaxyPeerConnection.sunsetConnection();
      this.galaxyPresPeerConnection.sunsetConnection();
      this.sunsettedPeerConnections.push(this.galaxyPeerConnection);
      this.sunsettedPeerConnections.push(this.galaxyPresPeerConnection);
      this.galaxyPeerConnection = new _galaxyPeerConnection.default(this.onTrackGalaxy.bind(this), this.onGalaxyRemoveStream.bind(this), this.startIceCandidateTimer.bind(this));
      this.galaxyPresPeerConnection = new _galaxyPeerConnection.default(this.onTrackGalaxyPresentation.bind(this), this.onRemoveGalaxyPresStream.bind(this), this.startIceCandidateTimer.bind(this), true);
    }
  }, {
    key: "shutdownSunsettedPeerConnections",
    value: function shutdownSunsettedPeerConnections() {
      this.sunsettedPeerConnections.forEach(function (pc) {
        return pc.shutdown();
      });
      this.sunsettedPeerConnections = [];
    }
  }, {
    key: "shutdownGalaxyPeerConnection",
    value: function shutdownGalaxyPeerConnection(store) {
      if (this.mediaStats) this.mediaStats.stop(); // Clean up the presentation stream

      this.shutdownGalaxyPresPeerConnection(store);
      this.galaxyPeerConnection.shutdown();
      this.transmitStream.endPresentation(store);
      this.resetIceCandidateTimer();
      var state = store.getState(); // clean up streams if not answering a new galaxy call

      if (!(0, _safeAccess.default)(state, 'nucleus.galaxy.call.isAnsweringGalaxy')) {
        this.cleanUpStreams(store);
      }
    }
  }, {
    key: "shutdownGalaxyPresPeerConnection",
    value: function shutdownGalaxyPresPeerConnection(store) {
      this.galaxyPresPeerConnection.shutdown();
      this.transmitPresStream.endPresentation(store);
      var state = store.getState(); // clean up streams if not in a psems call, or answering a new galaxy call

      if (!(0, _safeAccess.default)(state, 'nucleus.galaxy.call.isAnsweringGalaxy')) {
        this.cleanUpPresStreams();
      }
    }
  }, {
    key: "cleanUpPresStreams",
    value: function cleanUpPresStreams() {
      this.receivePresStream.end();
    }
  }, {
    key: "cleanUpStreams",
    value: function cleanUpStreams(store) {
      this.receiveStream.end();
      store.dispatch({
        type: c.RTC_REMOTE_STREAM_REMOVED
      });
      this.transmitStream.endWebcam();
      store.dispatch({
        type: c.LOCAL_STREAM_ENDED
      });
      store.dispatch({
        type: c.RESET_LOCAL_SSRCS
      });
    }
  }, {
    key: "setGalaxySdpOptions",
    value: function setGalaxySdpOptions(store, pc) {
      var state = store.getState();
      var preferredProfile = !pc.isPresentation ? (0, _safeAccess.default)(state, 'nucleus.galaxy.options.primaryProfile') : (0, _safeAccess.default)(state, 'nucleus.galaxy.options.secondaryProfile');
      var enable1080Rx = !pc.isPresentation ? (0, _safeAccess.default)(state, 'nucleus.galaxy.options.enablePrimary1080Rx') : (0, _safeAccess.default)(state, 'nucleus.galaxy.options.enableSecondary1080Rx');
      var presBwPercentage = (0, _safeAccess.default)(state, 'nucleus.galaxy.options.presBwPercentage');
      var bwPercentage = !pc.isPresentation ? 1 - presBwPercentage : presBwPercentage;
      pc.setSdpOptions((0, _safeAccess.default)(state, 'nucleus.galaxy.options.maxBandwidth'), (0, _safeAccess.default)(state, 'nucleus.galaxy.presentation.state'), (0, _safeAccess.default)(state, 'nucleus.galaxy.options.preferH264'), preferredProfile, enable1080Rx, bwPercentage, (0, _safeAccess.default)(state, 'nucleus.galaxy.options.splitBandwidth'));
    }
  }, {
    key: "createPeerConnection",
    value: function () {
      var _createPeerConnection = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(store, pc) {
        var peerConnection;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.store = store;
                pc.shutdown();
                _context.next = 4;
                return pc.createPeerConnection(store, this.transmitStream.stream);

              case 4:
                peerConnection = _context.sent;

                // if we are collecting stats (config) and this is a galaxy peer connection, turn on stats
                if ((0, _mediaStats.mediaStatsUrl)(store.getState()) && pc.galaxySdpOptions) {
                  if (!this.mediaStats) {
                    this.mediaStats = new _mediaStatsService.default(store);
                  }

                  this.mediaStats.start(pc);
                }

                return _context.abrupt("return", peerConnection);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createPeerConnection(_x, _x2) {
        return _createPeerConnection.apply(this, arguments);
      }

      return createPeerConnection;
    }()
  }, {
    key: "createPresPeerConnection",
    value: function () {
      var _createPresPeerConnection = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(store) {
        var stream, peerConnection;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.galaxyPresPeerConnection.shutdown();
                stream = this.transmitPresStream.stream;
                _context2.next = 4;
                return this.galaxyPresPeerConnection.createPeerConnection(store, stream);

              case 4:
                peerConnection = _context2.sent;

                if ((0, _mediaStats.mediaStatsUrl)(store.getState())) {
                  if (!this.mediaStats) {
                    this.mediaStats = new _mediaStatsService.default(store);
                  }

                  this.mediaStats.start(this.galaxyPresPeerConnection);
                }

                return _context2.abrupt("return", peerConnection);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function createPresPeerConnection(_x3) {
        return _createPresPeerConnection.apply(this, arguments);
      }

      return createPresPeerConnection;
    }()
  }, {
    key: "startPrimary",
    value: function () {
      var _startPrimary = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(store) {
        var media,
            tracks,
            _args3 = arguments;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                media = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};

                if (media.primaryAudioOutputId) {
                  this.receiveStream.setOutputDeviceId(media.primaryAudioOutputId);
                }

                this.includeAudio = !!media.audio;
                this.includeVideo = !!media.video;
                _context3.prev = 4;
                _context3.next = 7;
                return this.transmitStream.acquireWebcam(store, this.includeVideo, true, // CNUC-1232: always capture audio
                media.primaryVideoSourceId, media.primaryAudioSourceId, media.width, media.height, media.frameRate);

              case 7:
                tracks = _context3.sent;

                if (tracks.videoTrack) {
                  _context3.next = 11;
                  break;
                }

                _context3.next = 11;
                return this.startVideoMuteSlide(store);

              case 11:
                // mute audio if we don't want it
                if (!this.includeAudio) {
                  this.transmitStream.disableAudio();
                  tracks.isAudioMuted = true;
                }

                return _context3.abrupt("return", tracks);

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](4);
                _context3.next = 19;
                return this.startVideoMuteSlide(store);

              case 19:
                throw _context3.t0;

              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 15]]);
      }));

      function startPrimary(_x4) {
        return _startPrimary.apply(this, arguments);
      }

      return startPrimary;
    }()
  }, {
    key: "endPrimary",
    value: function endPrimary() {
      return this.transmitStream.endWebcam();
    }
  }, {
    key: "startAudio",
    value: function startAudio(store) {
      var state = store.getState();
      var sourceId = (0, _safeAccess.default)(state, 'nucleus.media.selectedAudioSourceId');
      return this.transmitStream.acquireAudio(state, sourceId).then(function () {
        return sourceId;
      });
    }
  }, {
    key: "endAudio",
    value: function endAudio() {
      return this.transmitStream.endAudio();
    }
  }, {
    key: "startVideoMuteSlide",
    value: function () {
      var _startVideoMuteSlide = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(store) {
        var state, videoMuteSlide;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                state = store.getState();
                videoMuteSlide = (0, _safeAccess.default)(state, 'nucleus.media.videoMuteSlide'); // Note: IE does not support HTMLCanvasElement.captureStream(). Do not use a slide.
                // Also, do not use slide in pinned mode or on webrtc native client (gems and mobile)
                // Also do not use the slide when toggled off in the config.

                if (!(0, _browserUtils.isGems)((0, _auth.getPlatform)(state))) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt("return", Promise.resolve());

              case 4:
                _context4.next = 6;
                return this.transmitStream.acquireVideoMute(store, videoMuteSlide);

              case 6:
                return _context4.abrupt("return", _context4.sent);

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function startVideoMuteSlide(_x5) {
        return _startVideoMuteSlide.apply(this, arguments);
      }

      return startVideoMuteSlide;
    }()
  }, {
    key: "_toggleVideoMuteGems",
    value: function _toggleVideoMuteGems(shouldMute) {
      if (shouldMute) {
        this.transmitStream.disableVideo();
      } else {
        this.transmitStream.enableVideo();
      }

      return Promise.resolve();
    }
  }, {
    key: "switchVideoCamera",
    value: function switchVideoCamera() {
      this.transmitStream.switchVideoCamera();
    }
  }, {
    key: "toggleAudioMute",
    value: function toggleAudioMute(store, shouldMute) {
      // handle default toggle case, determine shouldMute state
      if (shouldMute === null) {
        shouldMute = !this.transmitStream.isAudioMuted();
      } // mute case: disable any existing track


      if (shouldMute) {
        this.transmitStream.disableAudio();
        return Promise.resolve();
      }

      var state = store.getState(); // check for mobile case

      if ((0, _browserUtils.isWebRtcNative)((0, _auth.getPlatform)(state))) {
        this.transmitStream.enableAudio();
        return Promise.resolve();
      } // check audio sources
      // if we have an audio track and the source is the same as we have selected, just re-enable


      var selectedAudioSourceId = (0, _safeAccess.default)(state, 'nucleus.media.selectedAudioSourceId');

      if (this.transmitStream.hasAudioTrack() && this.transmitStream.audioSourceId === selectedAudioSourceId) {
        this.transmitStream.enableAudio();
        return Promise.resolve();
      } // otherwise we want to acquire with the new source and update the sdp


      return this.startAudio(store).catch(function (err) {
        return err;
      });
    } // Galaxy Functions

  }, {
    key: "createGalaxyOffer",
    value: function () {
      var _createGalaxyOffer = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(store) {
        var useDataChannel,
            offer,
            presentationOffer,
            presentationSend,
            callId,
            _args5 = arguments;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                useDataChannel = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : false;
                _context5.prev = 1;

                if (this.galaxyPeerConnection.isOpen()) {
                  _context5.next = 5;
                  break;
                }

                _context5.next = 5;
                return this.createPeerConnection(store, this.galaxyPeerConnection, null, true);

              case 5:
                if (useDataChannel) {
                  try {
                    this.galaxyPeerConnection.createDataChannel(store);
                  } catch (ex) {
                    _jsLogger.default.info('Unable to open data channel:', ex);
                  }
                }

                this.setGalaxySdpOptions(store, this.galaxyPeerConnection);
                _context5.next = 9;
                return this.galaxyPeerConnection.createOffer(false, {
                  offerToReceiveAudio: true
                });

              case 9:
                offer = _context5.sent;
                _context5.next = 16;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5["catch"](1);

                _jsLogger.default.error('error creating galaxy peerconnection or offer', _context5.t0);

                throw _context5.t0;

              case 16:
                _context5.prev = 16;

                if (this.galaxyPresPeerConnection.isOpen()) {
                  _context5.next = 20;
                  break;
                }

                _context5.next = 20;
                return this.createPresPeerConnection(store);

              case 20:
                this.setGalaxySdpOptions(store, this.galaxyPresPeerConnection);
                presentationSend = Boolean(this.transmitPresStream.stream.getVideoTracks().length);
                _context5.next = 24;
                return this.galaxyPresPeerConnection.createOffer(false, {
                  offerToReceiveVideo: !presentationSend,
                  offerToReceiveAudio: false
                });

              case 24:
                presentationOffer = _context5.sent;
                _context5.next = 31;
                break;

              case 27:
                _context5.prev = 27;
                _context5.t1 = _context5["catch"](16);

                _jsLogger.default.error('error creating galaxy presentation peerconnection or offer', _context5.t1);

                throw _context5.t1;

              case 31:
                callId = (0, _call2.activeGalaxyCallId)(store.getState());

                if (callId) {
                  this.heartBeatService.startHeartBeat(store, callId, this.galaxyPeerConnection.peerConnection, this.galaxyPresPeerConnection.peerConnection);
                } else {
                  _jsLogger.default.info('Not starting offer heartbeat; no callId in state');
                }

                return _context5.abrupt("return", [offer, presentationOffer]);

              case 34:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[1, 12], [16, 27]]);
      }));

      function createGalaxyOffer(_x6) {
        return _createGalaxyOffer.apply(this, arguments);
      }

      return createGalaxyOffer;
    }()
  }, {
    key: "createGalaxyAnswer",
    value: function () {
      var _createGalaxyAnswer = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(store, payload) {
        var answer, presentationAnswer, sdp, presSdp, offer, presOffer;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                sdp = (0, _safeAccess.default)(payload, 'capability.sdp');
                presSdp = (0, _safeAccess.default)(payload, 'capability.presSdp');

                if (!sdp) {
                  _context6.next = 18;
                  break;
                }

                _context6.prev = 3;

                if (this.galaxyPeerConnection.isOpen()) {
                  _context6.next = 7;
                  break;
                }

                _context6.next = 7;
                return this.createPeerConnection(store, this.galaxyPeerConnection, (0, _safeAccess.default)(payload, 'conferenceId'), true);

              case 7:
                offer = {
                  type: 'offer',
                  sdp: sdp
                };
                this.setGalaxySdpOptions(store, this.galaxyPeerConnection);
                _context6.next = 11;
                return this.galaxyPeerConnection.createAnswer(offer);

              case 11:
                answer = _context6.sent;
                _context6.next = 18;
                break;

              case 14:
                _context6.prev = 14;
                _context6.t0 = _context6["catch"](3);

                _jsLogger.default.error('error creating galaxy peerconnection or answer', _context6.t0);

                throw _context6.t0;

              case 18:
                if (!presSdp) {
                  _context6.next = 34;
                  break;
                }

                _context6.prev = 19;

                if (this.galaxyPresPeerConnection.isOpen()) {
                  _context6.next = 23;
                  break;
                }

                _context6.next = 23;
                return this.createPresPeerConnection(store, (0, _safeAccess.default)(payload, 'conferenceId'));

              case 23:
                presOffer = {
                  type: 'offer',
                  sdp: presSdp
                };
                this.setGalaxySdpOptions(store, this.galaxyPresPeerConnection);
                _context6.next = 27;
                return this.galaxyPresPeerConnection.createAnswer(presOffer);

              case 27:
                presentationAnswer = _context6.sent;
                _context6.next = 34;
                break;

              case 30:
                _context6.prev = 30;
                _context6.t1 = _context6["catch"](19);

                _jsLogger.default.error('error creating galaxy presentation peerconnection or answer', _context6.t1);

                throw _context6.t1;

              case 34:
                this.heartBeatService.startHeartBeat(store, (0, _safeAccess.default)(payload, 'callId'), this.galaxyPeerConnection.peerConnection, this.galaxyPresPeerConnection.peerConnection);
                return _context6.abrupt("return", [answer, presentationAnswer]);

              case 36:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[3, 14], [19, 30]]);
      }));

      function createGalaxyAnswer(_x7, _x8) {
        return _createGalaxyAnswer.apply(this, arguments);
      }

      return createGalaxyAnswer;
    }()
  }, {
    key: "handleGalaxyAnswer",
    value: function () {
      var _handleGalaxyAnswer = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(store, sdp, presSdp, reason) {
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (sdp) {
                  try {
                    this.setGalaxySdpOptions(store, this.galaxyPeerConnection);
                    this.galaxyPeerConnection.handleAnswer(sdp, reason);
                  } catch (ex) {
                    _jsLogger.default.info('exception handling answer', ex);
                  }
                }

                if (presSdp) {
                  try {
                    this.setGalaxySdpOptions(store, this.galaxyPresPeerConnection);
                    this.galaxyPresPeerConnection.handleAnswer(presSdp, reason);
                  } catch (ex) {
                    _jsLogger.default.info('exception handling presentation answer', ex);
                  }
                }

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function handleGalaxyAnswer(_x9, _x10, _x11, _x12) {
        return _handleGalaxyAnswer.apply(this, arguments);
      }

      return handleGalaxyAnswer;
    }()
  }, {
    key: "handleGalaxyUpdateOffer",
    value: function () {
      var _handleGalaxyUpdateOffer = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee8(store, sdp, presSdp, priority) {
        var result, presentation, video;
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                // handle presentation
                result = null;

                if (!presSdp) {
                  _context8.next = 7;
                  break;
                }

                this.setGalaxySdpOptions(store, this.galaxyPresPeerConnection);
                _context8.next = 5;
                return this.galaxyPresPeerConnection.handleUpdateOffer(presSdp, priority);

              case 5:
                presentation = _context8.sent;

                if (presentation) {
                  result = {
                    presSdp: presentation.sdp
                  };
                }

              case 7:
                if (!sdp) {
                  _context8.next = 13;
                  break;
                }

                this.setGalaxySdpOptions(store, this.galaxyPeerConnection);
                _context8.next = 11;
                return this.galaxyPeerConnection.handleUpdateOffer(sdp, priority);

              case 11:
                video = _context8.sent;

                if (video) {
                  result = (0, _objectSpread2.default)({}, result || {}, {
                    sdp: video.sdp
                  });
                }

              case 13:
                return _context8.abrupt("return", result);

              case 14:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function handleGalaxyUpdateOffer(_x13, _x14, _x15, _x16) {
        return _handleGalaxyUpdateOffer.apply(this, arguments);
      }

      return handleGalaxyUpdateOffer;
    }()
  }, {
    key: "getGalaxyLocalDescription",
    value: function getGalaxyLocalDescription() {
      return this.galaxyPeerConnection.getLocalDescription();
    }
  }, {
    key: "popLocalIceCandidiatesGalaxy",
    value: function popLocalIceCandidiatesGalaxy() {
      if (this.galaxyPeerConnection.isOpen() || this.galaxyPresPeerConnection.isOpen()) {
        this.store.dispatch((0, _call.sendTrickleIceCandidates)(this.galaxyPeerConnection.popLocalIceCandidates(), this.galaxyPresPeerConnection.popLocalIceCandidates()));
      }
    }
  }, {
    key: "startIceCandidateTimer",
    value: function startIceCandidateTimer() {
      var _this = this;

      var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 250;
      if (this.iceCandidateTimer) return;
      clearInterval(this.iceCandidateTimer);
      this.iceCandidateTimer = setInterval(function () {
        _this.popLocalIceCandidiatesGalaxy(); // stop timer if we are no longer checking for ice candidates


        if (!_this.galaxyPeerConnection.isCheckingIce() && !_this.galaxyPresPeerConnection.isCheckingIce()) {
          _this.resetIceCandidateTimer();
        }
      }, timeout);
    }
  }, {
    key: "resetIceCandidateTimer",
    value: function resetIceCandidateTimer() {
      clearInterval(this.iceCandidateTimer);
      this.iceCandidateTimer = null;
    }
  }, {
    key: "startPresentationGalaxy",
    value: function () {
      var _startPresentationGalaxy = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee9(store, presentationSourceId) {
        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (this.galaxyPeerConnection.isOpen()) {
                  _context9.next = 2;
                  break;
                }

                return _context9.abrupt("return");

              case 2:
                _context9.next = 4;
                return this.transmitPresStream.acquirePresentation(store, false, presentationSourceId);

              case 4:
                this.setGalaxySdpOptions(store, this.galaxyPresPeerConnection);
                _context9.next = 7;
                return this.galaxyPresPeerConnection.createUpdateOffer({
                  offerToReceiveVideo: false,
                  offerToReceiveAudio: false
                }, c.GALAXY_PRESENTATION_START_OFFER_PRIORITY);

              case 7:
                return _context9.abrupt("return", _context9.sent);

              case 8:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function startPresentationGalaxy(_x17, _x18) {
        return _startPresentationGalaxy.apply(this, arguments);
      }

      return startPresentationGalaxy;
    }()
  }, {
    key: "endPresentationGalaxy",
    value: function () {
      var _endPresentationGalaxy = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee10(store) {
        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.transmitPresStream.endPresentation(store, this.isPinnedMode);

              case 2:
                this.setGalaxySdpOptions(store, this.galaxyPresPeerConnection);
                _context10.next = 5;
                return this.galaxyPresPeerConnection.createUpdateOffer({
                  offerToReceiveVideo: true,
                  offerToReceiveAudio: false
                }, c.GALAXY_PRESENTATION_STOP_OFFER_PRIORITY);

              case 5:
                return _context10.abrupt("return", _context10.sent);

              case 6:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function endPresentationGalaxy(_x19) {
        return _endPresentationGalaxy.apply(this, arguments);
      }

      return endPresentationGalaxy;
    }()
  }, {
    key: "onTrackGalaxy",
    value: function onTrackGalaxy(store, stream, track) {
      if (!stream) return; // if we haven't gotten the stream yet, add it
      // or (CNUC-2032) the stream we have is now inactive (p2p with icon?)
      // or if we don't have a track, support the legacy method of retrieving the stream

      if (!this.receiveStream.primaryStream || stream.id !== this.receiveStream.id || !track) {
        this.receiveStream.addPrimaryStream(stream, store);
      } else if (track) {
        var hasTrack = this.receiveStream.primaryStream.getTracks().find(function (t) {
          return t.id === track.id;
        });

        if (!hasTrack) {
          this.receiveStream.primaryStream.addTrack(track);
        }

        (0, _streamUtils.cleanUpTracks)(this.receiveStream.primaryStream, track);
      }

      store.dispatch({
        type: c.RTC_REMOTE_STREAM_ADDED,
        payload: this.receiveStream.primaryStream
      });
    }
  }, {
    key: "onTrackGalaxyPresentation",
    value: function onTrackGalaxyPresentation(store, stream) {
      if (!stream) return this.onRemoveGalaxyPresStream(store, {}); // ensure we actually have a presentation by checking out signaling state (if using onTrack methods)

      if (CONFIG.calls.useOnTrack && (0, _safeAccess.default)(store.getState(), 'nucleus.galaxy.presentation.state') !== c.GALAXY_PRESENTATION_STATE_RX_STARTING) {
        return;
      } // TODO: I am sure we don't need two actions for the same trigger,
      // however I am leaving it intact to probably understand and migrate
      // applications to use one of them and then remove the other.


      this.receivePresStream.removePresentation();
      store.dispatch({
        type: c.RTC_REMOTE_PRESENTATION_STREAM_ADDED,
        payload: stream
      });
      this.receivePresStream.addPresentationStream(stream, true);
      store.dispatch({
        type: c.GALAXY_ACTION_INCOMING_PRESENTATION
      });
      this.receivePresStream.displayPresentation(true, store);
    }
  }, {
    key: "handleRemoteIceCandidates",
    value: function () {
      var _handleRemoteIceCandidates = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee11(store) {
        var iceCandidates,
            presIceCandidates,
            _args11 = arguments;
        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                iceCandidates = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : null;
                presIceCandidates = _args11.length > 2 && _args11[2] !== undefined ? _args11[2] : null;

                if (!iceCandidates) {
                  _context11.next = 5;
                  break;
                }

                _context11.next = 5;
                return this.galaxyPeerConnection.addRemoteIceCandidates(iceCandidates);

              case 5:
                if (!presIceCandidates) {
                  _context11.next = 8;
                  break;
                }

                _context11.next = 8;
                return this.galaxyPresPeerConnection.addRemoteIceCandidates(presIceCandidates);

              case 8:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function handleRemoteIceCandidates(_x20) {
        return _handleRemoteIceCandidates.apply(this, arguments);
      }

      return handleRemoteIceCandidates;
    }()
  }, {
    key: "onRemoveGalaxyPresStream",
    value: function onRemoveGalaxyPresStream(store, evt) {
      this.receivePresStream.handleRemoveStream(store, evt, true); // For presentation stream we will not fire RTC_REMOTE_STREAM_REMOVED

      store.dispatch({
        type: c.RTC_REMOTE_PRESENTATION_STREAM_REMOVED
      }); // TODO: I am sure we don't need two actions for the same trigger,
      // however I am leaving it intact to probably understand and migrate
      // applications to use one of them and then remove the other.

      store.dispatch({
        type: c.GALAXY_ACTION_RX_STOPPED_PRESENTATION
      });
    }
  }, {
    key: "sendLocalVideoMuteGalaxy",
    value: function sendLocalVideoMuteGalaxy(store) {
      var videoMuteEvent = (0, _call.generateSelfLocalVideoEvent)(store.getState(), this.transmitStream.isVideoMuted());
      this.galaxyPeerConnection.sendDataChannelMessage(videoMuteEvent);
    }
  }, {
    key: "toggleVideoMuteGalaxy",
    value: function () {
      var _toggleVideoMuteGalaxy = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee12(store, shouldMute) {
        var state;
        return _regenerator.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;

                if (shouldMute === null) {
                  shouldMute = !this.transmitStream.isVideoMuted();
                }

                state = store.getState();

                if (!((0, _browserUtils.isGems)((0, _auth.getPlatform)(state)) || !CONFIG.calls.useVideoMuteSlide)) {
                  _context12.next = 8;
                  break;
                }

                _jsLogger.default.info('Toggling video mute gems style');

                _context12.next = 7;
                return this._toggleVideoMuteGems(shouldMute);

              case 7:
                return _context12.abrupt("return", _context12.sent);

              case 8:
                if (!shouldMute) {
                  _context12.next = 16;
                  break;
                }

                _context12.next = 11;
                return this.transmitStream.disableVideo();

              case 11:
                _context12.next = 13;
                return this.transmitStream.endVideo();

              case 13:
                _context12.next = 15;
                return this.startVideoMuteSlide(store);

              case 15:
                return _context12.abrupt("return", _context12.sent);

              case 16:
                _context12.next = 18;
                return this.startVideoGalaxy(store);

              case 18:
                return _context12.abrupt("return", _context12.sent);

              case 21:
                _context12.prev = 21;
                _context12.t0 = _context12["catch"](0);

                _jsLogger.default.info('error in toggleVideoMuteGalaxy', _context12.t0);

                _context12.next = 26;
                return this.startVideoMuteSlide(store);

              case 26:
                return _context12.abrupt("return", _context12.sent);

              case 27:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[0, 21]]);
      }));

      function toggleVideoMuteGalaxy(_x21, _x22) {
        return _toggleVideoMuteGalaxy.apply(this, arguments);
      }

      return toggleVideoMuteGalaxy;
    }()
  }, {
    key: "startVideoGalaxy",
    value: function startVideoGalaxy(store) {
      // TODO: if pinned mode && presenting  return false
      var sourceId = (0, _safeAccess.default)(store.getState(), 'nucleus.media.selectedVideoSourceId');
      return this.transmitStream.acquireVideoHD(store, sourceId);
    }
  }, {
    key: "updateVideoOfferGalaxy",
    value: function () {
      var _updateVideoOfferGalaxy = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee13(store) {
        return _regenerator.default.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (this.galaxyPeerConnection.isOpen()) {
                  _context13.next = 2;
                  break;
                }

                return _context13.abrupt("return");

              case 2:
                this.setGalaxySdpOptions(store, this.galaxyPeerConnection);
                return _context13.abrupt("return", this.galaxyPeerConnection.createUpdateOffer());

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function updateVideoOfferGalaxy(_x23) {
        return _updateVideoOfferGalaxy.apply(this, arguments);
      }

      return updateVideoOfferGalaxy;
    }()
  }, {
    key: "downScaleVideoResolution",
    value: function () {
      var _downScaleVideoResolution = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee14(store) {
        return _regenerator.default.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (this.galaxyPeerConnection.isOpen()) {
                  _context14.next = 2;
                  break;
                }

                return _context14.abrupt("return");

              case 2:
                _context14.next = 4;
                return this.galaxyPeerConnection.downScaleVideoResolution(store);

              case 4:
                return _context14.abrupt("return", _context14.sent);

              case 5:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function downScaleVideoResolution(_x24) {
        return _downScaleVideoResolution.apply(this, arguments);
      }

      return downScaleVideoResolution;
    }()
  }, {
    key: "upScaleVideoResolution",
    value: function () {
      var _upScaleVideoResolution = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee15(store) {
        return _regenerator.default.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (this.galaxyPeerConnection.isOpen()) {
                  _context15.next = 2;
                  break;
                }

                return _context15.abrupt("return");

              case 2:
                return _context15.abrupt("return", this.galaxyPeerConnection.upScaleVideoResolution(store));

              case 3:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function upScaleVideoResolution(_x25) {
        return _upScaleVideoResolution.apply(this, arguments);
      }

      return upScaleVideoResolution;
    }()
  }, {
    key: "abortIceRestarts",
    value: function () {
      var _abortIceRestarts = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee16() {
        return _regenerator.default.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                if (!(!this.galaxyPeerConnection || !this.galaxyPresPeerConnection)) {
                  _context16.next = 2;
                  break;
                }

                return _context16.abrupt("return");

              case 2:
                this.galaxyPeerConnection.clearIceRetryTimer();
                this.galaxyPresPeerConnection.clearIceRetryTimer();
                this.galaxyPeerConnection.clearOfferTimer();
                this.galaxyPresPeerConnection.clearOfferTimer();

              case 6:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function abortIceRestarts() {
        return _abortIceRestarts.apply(this, arguments);
      }

      return abortIceRestarts;
    }()
  }, {
    key: "handleReconnected",
    value: function () {
      var _handleReconnected = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee17(store) {
        var state, callId, sourceId, callState;
        return _regenerator.default.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (!(!this.galaxyPeerConnection || !this.galaxyPresPeerConnection)) {
                  _context17.next = 2;
                  break;
                }

                return _context17.abrupt("return");

              case 2:
                state = store.getState();
                callId = (0, _call2.activeGalaxyCallId)(state);
                sourceId = (0, _call2.activeGalaxySourceId)(state);
                callState = (0, _call2.activeGalaxyCallState)(state);

                if (!(callState !== c.GALAXY_CALL_STATE_CONNECTED)) {
                  _context17.next = 8;
                  break;
                }

                return _context17.abrupt("return", _jsLogger.default.info('Wamp reconnected but call was not connected, returning.', callId, callState));

              case 8:
                if (!(this.heartBeatService && callId && sourceId)) {
                  _context17.next = 13;
                  break;
                }

                _context17.next = 11;
                return this.heartBeatService.sendHeartBeat(callId, this.galaxyPeerConnection.peerConnection, this.galaxyPresPeerConnection.peerConnection);

              case 11:
                _context17.next = 14;
                break;

              case 13:
                _jsLogger.default.info('Not sending heartbeat on reconnect due to missing info', this.heartBeatService, callId, sourceId);

              case 14:
                return _context17.abrupt("return", Promise.all([this.galaxyPeerConnection.handleIceRestart(store), this.galaxyPresPeerConnection.handleIceRestart(store)]));

              case 15:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function handleReconnected(_x26) {
        return _handleReconnected.apply(this, arguments);
      }

      return handleReconnected;
    }()
  }]);
  return RTCPeerManager;
}();

var _default = RTCPeerManager;
exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(29)["default"]))

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(CONFIG) {

var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(34));

var _createClass2 = _interopRequireDefault(__webpack_require__(36));

var browserUtils = _interopRequireWildcard(__webpack_require__(44));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var c = _interopRequireWildcard(__webpack_require__(3));

var _rtcUtils = __webpack_require__(200);

var _stream = __webpack_require__(80);

var _call = __webpack_require__(50);

var _RTCDataChannelState = _interopRequireDefault(__webpack_require__(164));

var _galaxyUtils = __webpack_require__(73);

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _asyncQueue = _interopRequireDefault(__webpack_require__(278));

var _streamUtils = __webpack_require__(105);

var _auth = __webpack_require__(31);

var _services = __webpack_require__(83);

var _mediaUtils = __webpack_require__(201);

var _conference = __webpack_require__(53);

var isRTCRtpSenderParamsSupported = typeof RTCRtpSender !== 'undefined' && typeof RTCRtpSender.prototype.getParameters === 'function' && typeof RTCRtpSender.prototype.setParameters === 'function';

var GalaxyPeerConnectionHolder =
/*#__PURE__*/
function () {
  function GalaxyPeerConnectionHolder(onTrack, onRemoveStream, onIceCandidate) {
    var _this = this;

    var isPresentation = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    (0, _classCallCheck2.default)(this, GalaxyPeerConnectionHolder);
    this.peerConnection = null;
    this.onTrack = onTrack;
    this.onRemoveStream = onRemoveStream;
    this.onIceCandidate = onIceCandidate;
    this.cachedLocalIceCandidates = [];
    this.cachedRemoteIceCandidates = [];
    this.isSunsetted = false;
    this.inFlightOffer = null;
    this.inFlightOfferPriority = 0;
    this.dataChannel = null;
    this.offerTimer = null;
    this.galaxySdpOptions = {
      maxBandwidth: c.GALAXY_DEFAULT_CALL_BANDWIDTH_KBPS,
      presentationState: c.GALAXY_PRESENTATION_STATE_STOPPED,
      preferH264: false,
      preferredProfile: null,
      enable1080Rx: false,
      bwPercentage: c.GALAXY_DEFAULT_PRESENTATION_BW_PERCENTAGE,
      splitBandwidth: true
    }; // Because we now dispatch the ice restart offer directly from this util class,
    // we need to know whether to send out the offer as a presentation or video offer

    this.isPresentation = isPresentation;
    this.offerQueue = new _asyncQueue.default(); // CNUC-263 For SQA and automated tests

    if (isPresentation) {
      window.getNucleusGalaxyPresentationPeerConnection = function () {
        return _this.peerConnection;
      };
    } else {
      window.getNucleusGalaxyPeerConnection = function () {
        return _this.peerConnection;
      };
    }

    this.iceRetryTimer = null;
    this.store = null;
    this.downScaleInForce = false;
    this.originalHeight = 0;
    this.originalWidth = 0;
  }

  (0, _createClass2.default)(GalaxyPeerConnectionHolder, [{
    key: "clearIceRetryTimer",
    value: function clearIceRetryTimer() {
      if (this.iceRetryTimer) {
        clearTimeout(this.iceRetryTimer);
        this.iceRetryTimer = null;
      }
    }
  }, {
    key: "hasAudioTrack",
    value: function hasAudioTrack() {
      return (0, _safeAccess.default)(this, 'getAudioTransceiver().sender.track.readyState') === 'live';
    }
  }, {
    key: "hasVideoTrack",
    value: function hasVideoTrack() {
      return (0, _safeAccess.default)(this, 'getVideoTransceiver().sender.track.readyState') === 'live';
    }
  }, {
    key: "getVideoTrack",
    value: function getVideoTrack() {
      return (0, _safeAccess.default)(this, 'getVideoTransceiver().sender.track');
    }
  }, {
    key: "getAudioTrack",
    value: function getAudioTrack() {
      return (0, _safeAccess.default)(this, 'getAudioTransceiver().sender.track');
    }
  }, {
    key: "stopTracks",
    value: function stopTracks() {
      var audioTrack = this.getAudioTrack();
      if (audioTrack) audioTrack.stop();
      var videoTrack = this.getVideoTrack();
      if (videoTrack) videoTrack.stop();
    }
  }, {
    key: "removeTrackFromTransceiver",
    value: function () {
      var _removeTrackFromTransceiver = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(transceiver) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (transceiver) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.next = 4;
                return transceiver.sender.replaceTrack(null);

              case 4:
                // eslint-disable-next-line require-atomic-updates
                if (this.isPresentation) transceiver.direction = 'inactive';

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function removeTrackFromTransceiver(_x) {
        return _removeTrackFromTransceiver.apply(this, arguments);
      }

      return removeTrackFromTransceiver;
    }()
  }, {
    key: "removeVideoTrack",
    value: function () {
      var _removeVideoTrack = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.removeTrackFromTransceiver(this.getVideoTransceiver());

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function removeVideoTrack() {
        return _removeVideoTrack.apply(this, arguments);
      }

      return removeVideoTrack;
    }()
  }, {
    key: "removeAudioTrack",
    value: function () {
      var _removeAudioTrack = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3() {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.removeTrackFromTransceiver(this.getAudioTransceiver());

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function removeAudioTrack() {
        return _removeAudioTrack.apply(this, arguments);
      }

      return removeAudioTrack;
    }()
  }, {
    key: "getTransceiverByType",
    value: function getTransceiverByType(type) {
      return ((0, _safeAccess.default)(this, 'peerConnection.getTransceivers()') || []).find(function (t) {
        return !(0, _safeAccess.default)(t, 'stopped') && ((0, _safeAccess.default)(t, 'sender.track.kind') === type || (0, _safeAccess.default)(t, 'receiver.track.kind') === type);
      });
    }
  }, {
    key: "getAudioTransceiver",
    value: function getAudioTransceiver() {
      return this.getTransceiverByType('audio');
    }
  }, {
    key: "getVideoTransceiver",
    value: function getVideoTransceiver() {
      return this.getTransceiverByType('video');
    } // private method

  }, {
    key: "updateTrackOnTransceiver",
    value: function () {
      var _updateTrackOnTransceiver = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(transceiver, track, stream) {
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(!this.peerConnection || !track)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                if (!transceiver || !transceiver.sender) {
                  this.peerConnection.addTrack(track, stream);
                  transceiver = this.getTransceiverByType(track.kind);
                } else {
                  transceiver.sender.replaceTrack(track);
                }

                if (transceiver) {
                  transceiver.direction = this.isPresentation ? 'sendonly' : 'sendrecv';
                }

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function updateTrackOnTransceiver(_x2, _x3, _x4) {
        return _updateTrackOnTransceiver.apply(this, arguments);
      }

      return updateTrackOnTransceiver;
    }()
    /**
     * @param {RTCPeerConnection} peerConnection
     */

  }, {
    key: "updateEncodingParameters",
    value: function () {
      var _updateEncodingParameters = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(peerConnection) {
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(!isRTCRtpSenderParamsSupported || !CONFIG.calls.rtcRtpSenderEncodingParams)) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return");

              case 2:
                _context6.next = 4;
                return Promise.all(peerConnection.getSenders().filter(function (sender) {
                  return sender.track;
                }).map(
                /*#__PURE__*/
                function () {
                  var _ref = (0, _asyncToGenerator2.default)(
                  /*#__PURE__*/
                  _regenerator.default.mark(function _callee5(sender) {
                    var params;
                    return _regenerator.default.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            params = sender.getParameters();

                            if (!(params.encodings.length > 0)) {
                              _context5.next = 11;
                              break;
                            }

                            params.encodings[0] = (0, _objectSpread2.default)({}, params.encodings[0], CONFIG.calls.rtcRtpSenderEncodingParams);
                            _context5.prev = 3;
                            _context5.next = 6;
                            return sender.setParameters(params);

                          case 6:
                            _context5.next = 11;
                            break;

                          case 8:
                            _context5.prev = 8;
                            _context5.t0 = _context5["catch"](3);

                            _jsLogger.default.warn("Error while setting encodings parameters for ".concat(sender.track.kind), "Track ".concat(sender.track.id, ": ").concat(_context5.t0.message || _context5.t0.name));

                          case 11:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5, null, [[3, 8]]);
                  }));

                  return function (_x6) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function updateEncodingParameters(_x5) {
        return _updateEncodingParameters.apply(this, arguments);
      }

      return updateEncodingParameters;
    }()
  }, {
    key: "updateVideoTrack",
    value: function () {
      var _updateVideoTrack = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(track, stream) {
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (track) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return", this.removeVideoTrack());

              case 2:
                _context7.next = 4;
                return this.updateTrackOnTransceiver(this.getVideoTransceiver(), track, stream);

              case 4:
                return _context7.abrupt("return", _context7.sent);

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function updateVideoTrack(_x7, _x8) {
        return _updateVideoTrack.apply(this, arguments);
      }

      return updateVideoTrack;
    }()
  }, {
    key: "updateAudioTrack",
    value: function () {
      var _updateAudioTrack = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee8(track, stream) {
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (track) {
                  _context8.next = 2;
                  break;
                }

                return _context8.abrupt("return", this.removeAudioTrack());

              case 2:
                _context8.next = 4;
                return this.updateTrackOnTransceiver(this.getAudioTransceiver(), track, stream);

              case 4:
                return _context8.abrupt("return", _context8.sent);

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function updateAudioTrack(_x9, _x10) {
        return _updateAudioTrack.apply(this, arguments);
      }

      return updateAudioTrack;
    }()
  }, {
    key: "sendDataChannelMessage",
    value: function sendDataChannelMessage(message) {
      if ((0, _safeAccess.default)(this.dataChannel, 'readyState') !== _RTCDataChannelState.default.open) {
        return _jsLogger.default.info('data channel is closed, unable to send data channel message.');
      }

      try {
        return this.dataChannel.send(JSON.stringify(message));
      } catch (ex) {
        _jsLogger.default.warn('error sending data channel message', ex);
      }
    }
  }, {
    key: "getDataChannelAction",
    value: function getDataChannelAction(event) {
      var _eventMap;

      var eventMap = (_eventMap = {}, (0, _defineProperty2.default)(_eventMap, c.GALAXY_EVENT_PARTICIPANT_LOCAL_VIDEO_MUTED, _call.participantLocalVideoMuted), (0, _defineProperty2.default)(_eventMap, c.GALAXY_EVENT_PARTICIPANT_LOCAL_VIDEO_UNMUTED, _call.participantLocalUnmuted), _eventMap);
      return eventMap[event];
    }
  }, {
    key: "setDataChannelEvents",
    value: function setDataChannelEvents(store) {
      var _this2 = this;

      this.dataChannel.onmessage = function (evt) {
        try {
          if (!evt || !evt.data) return;
          var data = JSON.parse(evt.data);

          var action = _this2.getDataChannelAction((0, _safeAccess.default)(data, 'event'));

          if (action) store.dispatch(action(data));
        } catch (ex) {
          _jsLogger.default.warn('Error processing data channel message', evt, ex);
        }
      };
    }
    /**
     * setSdpOptions
     * Convenience to update the options for galaxy sdp manipulation.
     * @param {Number} maxBandwidth - max bandwidth in kbps
     * @param {String} presentationState - presentation state
     * @param {boolean} preferH264 - put h264 profiles at the front of the list.
     * @param {String} preferredProfile - Preferred h264 profile
     * @param {boolean} enable1080Rx - Override h264 1f profile to 2a.
     * @param {boolean} bwPercentage - BW split percentage during presentation active
     */

  }, {
    key: "setSdpOptions",
    value: function setSdpOptions() {
      var maxBandwidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : c.GALAXY_DEFAULT_CALL_BANDWIDTH_KBPS;
      var presentationState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : c.GALAXY_PRESENTATION_STATE_STOPPED;
      var preferH264 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var preferredProfile = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var enable1080Rx = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var bwPercentage = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : c.GALAXY_DEFAULT_PRESENTATION_BW_PERCENTAGE;
      var splitBandwidth = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
      this.galaxySdpOptions = {
        maxBandwidth: maxBandwidth,
        presentationState: presentationState,
        preferH264: preferH264,
        preferredProfile: preferredProfile,
        enable1080Rx: enable1080Rx,
        bwPercentage: bwPercentage,
        splitBandwidth: splitBandwidth
      };
    }
  }, {
    key: "clearOfferTimer",
    value: function clearOfferTimer() {
      if (this.offerTimer) {
        clearTimeout(this.offerTimer);
      }

      this.offerTimer = null;
    }
  }, {
    key: "handleUpdateOffer",
    value: function () {
      var _handleUpdateOffer2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee9(sdp, priority) {
        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.offerQueue.addToQueueWithResponse(this._handleUpdateOffer.bind(this, sdp, priority));

              case 2:
                return _context9.abrupt("return", _context9.sent);

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function handleUpdateOffer(_x11, _x12) {
        return _handleUpdateOffer2.apply(this, arguments);
      }

      return handleUpdateOffer;
    }()
  }, {
    key: "_handleUpdateOffer",
    value: function () {
      var _handleUpdateOffer3 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee10(sdp, priority) {
        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (this.peerConnection) {
                  _context10.next = 2;
                  break;
                }

                return _context10.abrupt("return");

              case 2:
                if (!(0, _galaxyUtils.shouldIgnoreOffer)(this.inFlightOffer, this.inFlightOfferPriority, priority)) {
                  _context10.next = 4;
                  break;
                }

                return _context10.abrupt("return");

              case 4:
                // clear our inflight offer status
                this.inFlightOffer = null;
                this.inFlightOfferPriority = 0;
                this.clearOfferTimer(); // If we have initiated an ice reneg and if the far end initiates one as well
                // then we end up processing the far end's offer the timer should be cleared

                this.clearIceRetryTimer(); // otherwise we are creating an answer to this offer

                _context10.next = 10;
                return this.createUpdateAnswer({
                  type: 'offer',
                  sdp: sdp
                }, this.galaxySdpOptions);

              case 10:
                return _context10.abrupt("return", _context10.sent);

              case 11:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function _handleUpdateOffer(_x13, _x14) {
        return _handleUpdateOffer3.apply(this, arguments);
      }

      return _handleUpdateOffer;
    }()
  }, {
    key: "closeDataChannel",
    value: function closeDataChannel() {
      if (this.dataChannel && (0, _safeAccess.default)(this.dataChannel, 'readyState') !== _RTCDataChannelState.default.closing && (0, _safeAccess.default)(this.dataChannel, 'readyState') !== _RTCDataChannelState.default.closed) {
        this.dataChannel.close();
        this.dataChannel = null;
      }
    }
  }, {
    key: "sunsetConnection",
    value: function sunsetConnection() {
      if (this.peerConnection) {
        this.peerConnection.oniceconnectionstatechange = null;
        this.peerConnection.onicecandidate = null;
        this.peerConnection.ontrack = null;
        this.peerConnection.onaddstream = null;
        this.peerConnection.onremovestream = null;
        this.closeDataChannel();
        this.isSunsetted = true;
        this.clearOfferTimer();
      }
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      return this.peerConnection && this.peerConnection.signalingState !== 'closed';
    } // Queue up the local candidates for peer manager to transmit and send whenever it is ready.

  }, {
    key: "onLocalIceCandidate",
    value: function onLocalIceCandidate(event) {
      if (event.candidate) {
        this.cachedLocalIceCandidates.push(event.candidate);
        this.onIceCandidate();
      }
    }
  }, {
    key: "handleIceRestart",
    value: function () {
      var _handleIceRestart = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee12(store) {
        var _this3 = this;

        return _regenerator.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                this.iceRetryTimer = setTimeout(
                /*#__PURE__*/
                (0, _asyncToGenerator2.default)(
                /*#__PURE__*/
                _regenerator.default.mark(function _callee11() {
                  var state, signalingState, iceState, isConnected, shouldRestart, retryCount, tracks, trackId, options, result;
                  return _regenerator.default.wrap(function _callee11$(_context11) {
                    while (1) {
                      switch (_context11.prev = _context11.next) {
                        case 0:
                          _this3.iceRetryTimer = null; // double check we need to still do an ice restart

                          if (!(!_this3.peerConnection || _this3.isSunsetted)) {
                            _context11.next = 3;
                            break;
                          }

                          return _context11.abrupt("return");

                        case 3:
                          state = store.getState();
                          signalingState = (0, _safeAccess.default)(_this3.peerConnection, 'signalingState');
                          iceState = (0, _safeAccess.default)(_this3.peerConnection, 'iceConnectionState');
                          isConnected = (0, _services.selectConnected)(state);
                          shouldRestart = isConnected && signalingState === c.GALAXY_PC_SIGNALING_STATE_STABLE && (iceState === c.GALAXY_ICE_STATE_FAILED || iceState === c.GALAXY_ICE_STATE_DISCONNECTED);

                          if (shouldRestart) {
                            _context11.next = 10;
                            break;
                          }

                          return _context11.abrupt("return");

                        case 10:
                          // Check if we have exceeded the max retries if not retry ice and also we are
                          // in a state to reneg. If we are in the middle of an offer answer just wait
                          // for that to complete to see if ice recovers. If not retry when we receive
                          // failed at that point
                          retryCount = _this3.isPresentation ? (0, _safeAccess.default)(state, 'nucleus.galaxy.rtc.presIceRetryCount') : (0, _safeAccess.default)(state, 'nucleus.galaxy.rtc.iceRetryCount');

                          if (!(retryCount > c.GALAXY_MAX_ICE_RETRIES)) {
                            _context11.next = 13;
                            break;
                          }

                          return _context11.abrupt("return", store.dispatch((0, _call.endGalaxy)(c.GALAXY_REASON_NETWORK_ERROR, 'Max ice retries reached')));

                        case 13:
                          _context11.prev = 13;
                          tracks = null;
                          trackId = (0, _safeAccess.default)(state, 'nucleus.galaxy.presentation.trackId');

                          if (_this3.isPresentation && _this3.trackId) {
                            tracks = {
                              presentation: trackId
                            };
                          }

                          options = {
                            iceRestart: true
                          }; // CNUC-1941: make sure to force offerToReceiveAudio: false on presentation peer connections
                          // also make sure offerToReceiveVideo is false if we have a sender / true if we do not have a sender

                          if (_this3.isPresentation) {
                            options.offerToReceiveVideo = !(0, _safeAccess.default)(_this3.peerConnection, 'getSenders()[0]');
                            options.offerToReceiveAudio = false;
                          }

                          _context11.next = 21;
                          return _this3.createUpdateOffer(options);

                        case 21:
                          result = _context11.sent;
                          _context11.next = 24;
                          return store.dispatch((0, _stream.sendUpdateSdpGalaxy)(c.WEBRTC_SDP_TYPE_OFFER, c.GALAXY_REASON_ICE_RESTART, _this3.isPresentation ? null : result.sdp, tracks, _this3.isPresentation ? result.sdp : null, result.priority));

                        case 24:
                          _context11.next = 29;
                          break;

                        case 26:
                          _context11.prev = 26;
                          _context11.t0 = _context11["catch"](13);

                          _jsLogger.default.error('Ice reneg failed. Offer timeout should kill the call', _context11.t0);

                        case 29:
                        case "end":
                          return _context11.stop();
                      }
                    }
                  }, _callee11, null, [[13, 26]]);
                })), Math.floor(Math.random() * 2000) + 1000);

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function handleIceRestart(_x15) {
        return _handleIceRestart.apply(this, arguments);
      }

      return handleIceRestart;
    }()
  }, {
    key: "onIceConnectionStateChange",
    value: function onIceConnectionStateChange(store) {
      if (!this.peerConnection || this.isSunsetted) return; // Will have some reconnect logic here.

      var state = store.getState();
      var oldIceState = this.isPresentation ? (0, _safeAccess.default)(state, 'nucleus.galaxy.rtc.presIceConnectionState') : (0, _safeAccess.default)(state, 'nucleus.galaxy.rtc.iceConnectionState');
      var currIceState = (0, _safeAccess.default)(this.peerConnection, 'iceConnectionState'); // Notify of changed ice states

      var iceChangedStates = {
        previous: oldIceState,
        next: currIceState
      }; // If we're already in the call, notify state changes

      if ((0, _conference.selectConferenceId)(state)) {
        store.dispatch((0, _call.reportIceStateChange)(iceChangedStates, this.isPresentation));
      } else {
        _jsLogger.default.debug('Not notifying ICE state change since not in call yet', JSON.stringify({
          states: iceChangedStates,
          isPresentation: this.isPresentation
        }));
      } // If ice state changes, just see if there are some unprocessed remote candidates dangling around to be added.


      this.addRemoteIceCandidates(); // Fire the ice state change action and get the retry count updated

      store.dispatch({
        type: c.GALAXY_ACTION_ICE_STATE_UPDATED,
        payload: {
          isPresentation: this.isPresentation,
          state: this.peerConnection.iceConnectionState
        }
      }); // call connected, clear any ice retry timer at this time

      if ((0, _galaxyUtils.isIceStateConnected)(currIceState)) {
        this.clearIceRetryTimer();
        return;
      } // if wamp is disconnected, do not do anything related to ice restart


      if (!(0, _services.selectConnected)(state)) {
        return;
      }

      if (!this.offerTimer && !this.iceRetryTimer && (0, _galaxyUtils.shouldRetryIce)(oldIceState, currIceState)) {
        this.handleIceRestart(store);
      } // CNUC-2148 do not end call if an ice restart is in progress even when we move to failed state
      else if (this.peerConnection && (0, _galaxyUtils.isIceStateFailed)(currIceState) && !this.iceRetryTimer && !this.offerTimer) {
          var detail = "Ice restart would not help in this case."; // Reached a point where retry is not possible. Disconnect the call

          store.dispatch((0, _call.endGalaxy)(c.GALAXY_REASON_NETWORK_ERROR, detail));
        }
    }
  }, {
    key: "shutdown",
    value: function shutdown() {
      this.closeDataChannel();

      if (this.isOpen()) {
        this.peerConnection.close();
        this.cachedRemoteIceCandidates = [];
        this.cachedLocalIceCandidates = [];
      }

      this.peerConnection = null;
      this.isSunsetted = false;
      this.clearOfferTimer();
    }
    /**
     * addRemoteIceCandidates
     * This function takes an array of remote candidates and appends it to the cached list of remote candidates.
     * If a peer connection is ready to accept remote candidates by detecting if a remotedescription has a type,
     * the function will then process the array of remote candidates by adding them to the peer connection.
     * The function clones and clears the cached array when it process the candidates.
     * @param {Array} remoteCandidates
     */

  }, {
    key: "addRemoteIceCandidates",
    value: function () {
      var _addRemoteIceCandidates = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee13() {
        var _this4 = this;

        var remoteCandidates,
            clonedRemoteIceCandidates,
            addIceCandidatePromises,
            _args13 = arguments;
        return _regenerator.default.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                remoteCandidates = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : [];
                this.cachedRemoteIceCandidates = this.cachedRemoteIceCandidates.concat(remoteCandidates);

                if (!(!(0, _safeAccess.default)(this.peerConnection, 'remoteDescription.type') || !this.cachedRemoteIceCandidates.length || this.inFlightOffer)) {
                  _context13.next = 4;
                  break;
                }

                return _context13.abrupt("return");

              case 4:
                clonedRemoteIceCandidates = JSON.parse(JSON.stringify(this.cachedRemoteIceCandidates));
                this.cachedRemoteIceCandidates = [];
                addIceCandidatePromises = [];
                clonedRemoteIceCandidates.forEach(function (candidate) {
                  addIceCandidatePromises.push(_this4.peerConnection.addIceCandidate(new window.RTCIceCandidate(candidate)));
                });
                _context13.next = 10;
                return Promise.all(addIceCandidatePromises);

              case 10:
                return _context13.abrupt("return", _context13.sent);

              case 11:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function addRemoteIceCandidates() {
        return _addRemoteIceCandidates.apply(this, arguments);
      }

      return addRemoteIceCandidates;
    }()
  }, {
    key: "createDataChannel",
    value: function createDataChannel(store) {
      if (!this.peerConnection) throw new Error('Cannot open data channel: No active peer connection.');

      if (this.dataChannel) {
        _jsLogger.default.info('Data channel status:', this.dataChannel);

        throw new Error('Cannot open data channel: Data channel is already open or being set up.');
      }

      this.dataChannel = this.peerConnection.createDataChannel('actions');
      this.setDataChannelEvents(store);
    }
  }, {
    key: "createPeerConnection",
    value: function () {
      var _createPeerConnection = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee14(store) {
        var _this5 = this;

        var transmitStream,
            state,
            iceServers,
            options,
            _args14 = arguments;
        return _regenerator.default.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                transmitStream = _args14.length > 1 && _args14[1] !== undefined ? _args14[1] : null;
                state = store.getState();
                this.inFlightOffer = null;
                this.inFlightOfferPriority = 0;
                this.offerTimer = null;
                iceServers = (0, _safeAccess.default)(state, 'nucleus.galaxy.capabilities.iceServers') || [];
                options = {
                  iceServers: (0, _rtcUtils.getIceServers)(state, iceServers),
                  iceTransportPolicy: (0, _rtcUtils.getIceTransportPolicy)(state)
                };

                if (CONFIG.calls.enforcePlanB && !this.isPresentation || CONFIG.calls.enforcePlanBPresentation && this.isPresentation) {
                  options.sdpSemantics = c.WEBRTC_SDP_SEMANTICS_PLAN_B;
                } // TODO: can we / do we need to add constraints?
                // i.e. new RTCPeerConnection(config, constraints);


                if (!this.peerConnection || this.peerConnection.signalingState === 'closed') {
                  if (CONFIG.calls.rtcPeerConnectionEnableChromiumDscp && (0, _safeAccess.default)(state, 'nucleus.account.settings.enableQOS')) {
                    this.peerConnection = new window.RTCPeerConnection(options, {
                      optional: [{
                        googDscp: true
                      }]
                    });
                  } else {
                    this.peerConnection = new window.RTCPeerConnection(options);
                  }
                }

                if (browserUtils.isGems((0, _auth.getPlatform)(state))) {
                  this.peerConnection.onaddstream = function (e) {
                    _this5.onTrack(store, (0, _safeAccess.default)(e, 'stream'));
                  };
                } else {
                  this.peerConnection.ontrack = function (e) {
                    _jsLogger.default.info("Got ontrack in ".concat(_this5.isPresentation ? 'presentation' : 'main'), e);

                    var track = (0, _safeAccess.default)(e, 'track');
                    var stream = (0, _safeAccess.default)(e, 'streams[0]');

                    if (_this5.isPresentation) {
                      // we can't use the transceiver in the event due to a Safari issue.
                      // but retrieving the transceiver from the peer connection works in all browsers
                      var t = _this5.getTransceiverByType(track && track.kind);

                      if (t) {
                        _jsLogger.default.info('setting direction on transceiver to recvonly', t);

                        t.direction = 'recvonly';
                      }
                    }

                    stream = (0, _streamUtils.convertTrackToStream)(stream, track);

                    _this5.onTrack(store, stream, track);
                  };
                }

                this.peerConnection.onicecandidate = function (evt) {
                  return _this5.onLocalIceCandidate(evt);
                };

                this.peerConnection.oniceconnectionstatechange = this.onIceConnectionStateChange.bind(this, store);

                this.peerConnection.ondatachannel = function (event) {
                  _jsLogger.default.info('data channel in galaxy-peer-connection fired ondatachannel');

                  if (event && event.channel) {
                    _this5.dataChannel = event.channel;

                    _this5.setDataChannelEvents(store);
                  }
                };

                if (this.onRemoveStream) {
                  this.peerConnection.onremovestream = function (evt) {
                    return _this5.onRemoveStream(store, evt);
                  };
                }

                if (transmitStream) {
                  this.peerConnection.addStream(transmitStream);
                }

                this.store = store;
                return _context14.abrupt("return", this.peerConnection);

              case 17:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function createPeerConnection(_x16) {
        return _createPeerConnection.apply(this, arguments);
      }

      return createPeerConnection;
    }()
  }, {
    key: "getRemoteStreams",
    value: function getRemoteStreams() {
      return this.peerConnection && this.peerConnection.getRemoteStreams ? this.peerConnection.getRemoteStreams() : [];
    }
  }, {
    key: "createOffer",
    value: function () {
      var _createOffer = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee15() {
        var iceRestart,
            offerOptions,
            rtcOfferOptions,
            offer,
            _args15 = arguments;
        return _regenerator.default.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                iceRestart = _args15.length > 0 && _args15[0] !== undefined ? _args15[0] : false;
                offerOptions = _args15.length > 1 && _args15[1] !== undefined ? _args15[1] : {};
                rtcOfferOptions = offerOptions;

                if (iceRestart) {
                  rtcOfferOptions.iceRestart = true;
                }

                _context15.next = 6;
                return this.peerConnection.createOffer(rtcOfferOptions);

              case 6:
                offer = _context15.sent;
                // Limit the call BW based on the group settings
                offer.sdp = (0, _galaxyUtils.modifyGalaxyCallSdp)(offer, false, this.galaxySdpOptions); // Will defer adding the sdp locally until we get an answer.

                this.inFlightOffer = offer.sdp;
                this.offerTimer = this.startOfferTimer();
                return _context15.abrupt("return", {
                  sdp: offer.sdp
                });

              case 11:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function createOffer() {
        return _createOffer.apply(this, arguments);
      }

      return createOffer;
    }()
  }, {
    key: "createAnswer",
    value: function () {
      var _createAnswer2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee16(offer) {
        return _regenerator.default.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.offerQueue.addToQueueWithResponse(this._createAnswer.bind(this, offer));

              case 2:
                return _context16.abrupt("return", _context16.sent);

              case 3:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function createAnswer(_x17) {
        return _createAnswer2.apply(this, arguments);
      }

      return createAnswer;
    }()
  }, {
    key: "_createAnswer",
    value: function () {
      var _createAnswer3 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee17(offer) {
        var answer;
        return _regenerator.default.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                // Limit the call BW based on the group settings
                offer.sdp = (0, _galaxyUtils.modifyGalaxyCallSdp)(offer, true, this.galaxySdpOptions);
                _context17.next = 3;
                return this.peerConnection.setRemoteDescription(new window.RTCSessionDescription(offer));

              case 3:
                _context17.next = 5;
                return this.peerConnection.createAnswer();

              case 5:
                answer = _context17.sent;
                answer.sdp = (0, _galaxyUtils.modifyGalaxyCallSdp)(answer, false, this.galaxySdpOptions);
                _context17.next = 9;
                return this.peerConnection.setLocalDescription(new window.RTCSessionDescription(answer));

              case 9:
                _context17.next = 11;
                return this.updateEncodingParameters(this.peerConnection);

              case 11:
                return _context17.abrupt("return", {
                  sdp: this.peerConnection.localDescription.sdp
                });

              case 12:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function _createAnswer(_x18) {
        return _createAnswer3.apply(this, arguments);
      }

      return _createAnswer;
    }()
  }, {
    key: "handleAnswer",
    value: function () {
      var _handleAnswer2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee18(sdp, reason) {
        return _regenerator.default.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                if (sdp) {
                  _context18.next = 2;
                  break;
                }

                return _context18.abrupt("return");

              case 2:
                _context18.next = 4;
                return this.offerQueue.addToQueueWithResponse(this._handleAnswer.bind(this, sdp, reason));

              case 4:
                return _context18.abrupt("return", _context18.sent);

              case 5:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function handleAnswer(_x19, _x20) {
        return _handleAnswer2.apply(this, arguments);
      }

      return handleAnswer;
    }()
  }, {
    key: "_handleAnswer",
    value: function () {
      var _handleAnswer3 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee19(sdp, reason) {
        var answer, offer, exceptionText;
        return _regenerator.default.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;

                if (!(!this.peerConnection || !this.inFlightOffer)) {
                  _context19.next = 3;
                  break;
                }

                return _context19.abrupt("return");

              case 3:
                // Stop any retry timer that is currently going on and abandon the attempt
                if (reason === c.GALAXY_REASON_ICE_RESTART) {
                  this.clearIceRetryTimer();
                }

                answer = {
                  type: 'answer',
                  sdp: sdp
                }; // Limit the call BW based on the group settings

                answer.sdp = (0, _galaxyUtils.modifyGalaxyCallSdp)(answer, true, this.galaxySdpOptions);
                offer = {
                  type: 'offer',
                  sdp: this.inFlightOffer
                };
                _context19.next = 9;
                return this.peerConnection.setLocalDescription(new window.RTCSessionDescription(offer));

              case 9:
                _context19.next = 11;
                return this.peerConnection.setRemoteDescription(new window.RTCSessionDescription(answer));

              case 11:
                this.inFlightOffer = null;
                this.inFlightOfferPriority = 0;
                this.clearOfferTimer();
                _context19.next = 16;
                return this.addRemoteIceCandidates();

              case 16:
                _context19.next = 18;
                return this.updateEncodingParameters(this.peerConnection);

              case 18:
                _context19.next = 24;
                break;

              case 20:
                _context19.prev = 20;
                _context19.t0 = _context19["catch"](0);
                exceptionText = "".concat((0, _safeAccess.default)(_context19.t0, 'name'), " ").concat((0, _safeAccess.default)(_context19.t0, 'message'));

                _jsLogger.default.warn("caught exception in handleanswer in galaxy ".concat(this.isPresentation ? "presentation " : "", "peerConnection"), exceptionText);

              case 24:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this, [[0, 20]]);
      }));

      function _handleAnswer(_x21, _x22) {
        return _handleAnswer3.apply(this, arguments);
      }

      return _handleAnswer;
    }()
  }, {
    key: "getLocalDescription",
    value: function getLocalDescription() {
      return this.peerConnection.localDescription;
    }
    /**
     * popLocalIceCandidates
     * Function used to pop the local candidates for this peer connection to then transmit to the other client.
     * Clones and clears the array before returning.
     */

  }, {
    key: "popLocalIceCandidates",
    value: function popLocalIceCandidates() {
      var clonedLocalIceCandidates = JSON.parse(JSON.stringify(this.cachedLocalIceCandidates));
      this.cachedLocalIceCandidates = [];
      return clonedLocalIceCandidates;
    }
    /**
     * isCheckingIce
     * Determines if peerconnection is accepting and checking new ice candidates.
     */

  }, {
    key: "isCheckingIce",
    value: function isCheckingIce() {
      return this.peerConnection && (this.peerConnection.iceConnectionState === 'new' || this.peerConnection.iceConnectionState === 'checking');
    } // TODO: do we need to process remote candidates here (and cache them)?

  }, {
    key: "createUpdateAnswer",
    value: function () {
      var _createUpdateAnswer = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee20(offer) {
        var answer, sdp;
        return _regenerator.default.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                // TODO: check ice retry timer
                // Limit the call BW based on the group settings
                offer.sdp = (0, _galaxyUtils.modifyGalaxyCallSdp)(offer, true, this.galaxySdpOptions);
                _context20.next = 3;
                return this.peerConnection.setRemoteDescription(new window.RTCSessionDescription(offer));

              case 3:
                _context20.next = 5;
                return this.peerConnection.createAnswer();

              case 5:
                answer = _context20.sent;
                // Limit the call BW based on the group settings
                answer.sdp = (0, _galaxyUtils.modifyGalaxyCallSdp)(answer, false, this.galaxySdpOptions);
                sdp = answer.sdp;
                _context20.next = 10;
                return this.peerConnection.setLocalDescription(new window.RTCSessionDescription(answer));

              case 10:
                _context20.next = 12;
                return this.updateEncodingParameters(this.peerConnection);

              case 12:
                return _context20.abrupt("return", {
                  sdp: sdp
                });

              case 13:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function createUpdateAnswer(_x23) {
        return _createUpdateAnswer.apply(this, arguments);
      }

      return createUpdateAnswer;
    }()
  }, {
    key: "createUpdateOffer",
    value: function () {
      var _createUpdateOffer2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee21() {
        var options,
            priority,
            _args21 = arguments;
        return _regenerator.default.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                options = _args21.length > 0 && _args21[0] !== undefined ? _args21[0] : {};
                priority = _args21.length > 1 && _args21[1] !== undefined ? _args21[1] : null;
                _context21.next = 4;
                return this.offerQueue.addToQueueWithResponse(this._createUpdateOffer.bind(this, options, priority));

              case 4:
                return _context21.abrupt("return", _context21.sent);

              case 5:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function createUpdateOffer() {
        return _createUpdateOffer2.apply(this, arguments);
      }

      return createUpdateOffer;
    }()
  }, {
    key: "_createUpdateOffer",
    value: function () {
      var _createUpdateOffer3 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee22() {
        var options,
            priority,
            offer,
            sdp,
            _args22 = arguments;
        return _regenerator.default.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                options = _args22.length > 0 && _args22[0] !== undefined ? _args22[0] : {};
                priority = _args22.length > 1 && _args22[1] !== undefined ? _args22[1] : null;
                _context22.next = 4;
                return this.peerConnection.createOffer(options);

              case 4:
                offer = _context22.sent;
                // Limit the call BW based on the group settings
                offer.sdp = (0, _galaxyUtils.modifyGalaxyCallSdp)(offer, false, this.galaxySdpOptions);
                sdp = offer.sdp;

                if (!priority) {
                  priority = (0, _galaxyUtils.generateOfferPriority)();
                }

                this.inFlightOffer = sdp;
                this.inFlightOfferPriority = priority;
                this.clearOfferTimer();
                this.offerTimer = this.startOfferTimer();
                return _context22.abrupt("return", {
                  sdp: sdp,
                  priority: priority
                });

              case 13:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function _createUpdateOffer() {
        return _createUpdateOffer3.apply(this, arguments);
      }

      return _createUpdateOffer;
    }()
  }, {
    key: "startOfferTimer",
    value: function startOfferTimer() {
      var _this6 = this;

      return setTimeout(
      /*#__PURE__*/
      (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee23() {
        var detail;
        return _regenerator.default.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _this6.offerTimer = null; // double check we need treat this timeout as an error

                if (!(!_this6.peerConnection || _this6.isSunsetted || !_this6.inFlightOffer)) {
                  _context23.next = 3;
                  break;
                }

                return _context23.abrupt("return");

              case 3:
                if ((0, _galaxyUtils.isIceStateFailed)(_this6.peerConnection.iceConnectionState) || (0, _galaxyUtils.isIceStateDisconnected)(_this6.peerConnection.iceConnectionState)) {
                  detail = 'No answer received for the last SDP offer';

                  _jsLogger.default.error(detail);

                  _this6.store.dispatch((0, _call.endGalaxy)(c.GALAXY_REASON_NETWORK_ERROR, detail));
                }

              case 4:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23);
      })), c.GALAXY_OFFER_TIMER);
    }
  }, {
    key: "getLocalVideoTrack",
    value: function getLocalVideoTrack() {
      var trackPresent = this.hasVideoTrack();
      var track = null;

      if (trackPresent) {
        // The peer connection has video transceivers and the track can be picked
        // from that
        track = this.getVideoTrack();
      } else {
        // Before we give up account for plan-b and other clients that may not
        // support transceivers. Look for senders or getLocalStreams
        if (typeof this.peerConnection.getSenders === 'function') {
          var videoSender = ((0, _safeAccess.default)(this, 'peerConnection.getSenders()') || []).find(function (s) {
            return (0, _safeAccess.default)(s, 'track.kind') === 'video' && (0, _safeAccess.default)(s, 'track.enabled');
          });

          if (videoSender) {
            track = videoSender.track;
          }
        } else {
          // getSenders support not found, as a last resort look for getLocalStreams
          track = ((0, _safeAccess.default)(this, 'peerConnection.getLocalStreams().getVideoTracks()') || [])[0];
        }
      }

      return track;
    }
  }, {
    key: "downScaleVideoResolution",
    value: function () {
      var _downScaleVideoResolution = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee24(store) {
        var state, track, downScaleWidth, downScaleHeight, constraints;
        return _regenerator.default.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                state = store.getState();

                if (!(!this.peerConnection || this.isSunsetted || (0, _safeAccess.default)(state, 'nucleus.galaxy.rtc.downScaleInForce'))) {
                  _context24.next = 3;
                  break;
                }

                return _context24.abrupt("return");

              case 3:
                track = this.getLocalVideoTrack();
                downScaleWidth = (0, _safeAccess.default)(state, 'nucleus.galaxy.rtc.downScaleWidth');
                downScaleHeight = (0, _safeAccess.default)(state, 'nucleus.galaxy.rtc.downScaleHeight');

                if ((0, _mediaUtils.compareConstraints)(track, downScaleHeight, downScaleWidth) === 1) {
                  // Update the reducer with the scaling parameters so that if we switch
                  // peer connection due to createOffer from the service, we can refer back
                  // to this state and apply/reset the constraints
                  constraints = track.getConstraints();
                  store.dispatch({
                    type: c.GALAXY_SET_SCALED_RESOLUTION,
                    payload: {
                      originalHeight: (0, _mediaUtils.getHeightFromConstraints)(constraints),
                      originalWidth: (0, _mediaUtils.getWidthFromConstraints)(constraints)
                    }
                  });
                  (0, _mediaUtils.setTrackConstraints)(track, downScaleHeight, downScaleWidth);
                }

              case 7:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function downScaleVideoResolution(_x24) {
        return _downScaleVideoResolution.apply(this, arguments);
      }

      return downScaleVideoResolution;
    }()
  }, {
    key: "upScaleVideoResolution",
    value: function () {
      var _upScaleVideoResolution = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee25(store) {
        var state, track, originalHeight, originalWidth;
        return _regenerator.default.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                state = store.getState();

                if (!(!this.peerConnection || this.isSunsetted || !(0, _safeAccess.default)(state, 'nucleus.galaxy.rtc.scaledResolution.downScaleInForce'))) {
                  _context25.next = 3;
                  break;
                }

                return _context25.abrupt("return");

              case 3:
                track = this.getLocalVideoTrack();
                originalHeight = (0, _safeAccess.default)(state, 'nucleus.galaxy.rtc.scaledResolution.originalHeight');
                originalWidth = (0, _safeAccess.default)(state, 'nucleus.galaxy.rtc.scaledResolution.originalWidth');
                (0, _mediaUtils.setTrackConstraints)(track, originalHeight, originalWidth); // Reset the reducer state

                store.dispatch({
                  type: c.GALAXY_RESET_SCALED_RESOLUTION,
                  payload: {}
                });

              case 8:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function upScaleVideoResolution(_x25) {
        return _upScaleVideoResolution.apply(this, arguments);
      }

      return upScaleVideoResolution;
    }()
  }]);
  return GalaxyPeerConnectionHolder;
}();

var _default = GalaxyPeerConnectionHolder;
exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(29)["default"]))

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(34));

var _createClass2 = _interopRequireDefault(__webpack_require__(36));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _rtcStatsSampler = _interopRequireDefault(__webpack_require__(549));

var _mediaStats = __webpack_require__(279);

var _auth = __webpack_require__(31);

var MediaStatsService =
/*#__PURE__*/
function () {
  function MediaStatsService(store) {
    (0, _classCallCheck2.default)(this, MediaStatsService);
    this.store = store;
    this.primaryStatsSampler = null;
    this.presentationStatsSampler = null;
    this.statsInterval = null;
    this.url = (0, _mediaStats.mediaStatsUrl)(store.getState());
  }

  (0, _createClass2.default)(MediaStatsService, [{
    key: "start",
    value: function start(galaxyPeerConnection) {
      var _this = this;

      if (!this.url || !galaxyPeerConnection) return;
      var sampler = new _rtcStatsSampler.default(galaxyPeerConnection.peerConnection);

      if (galaxyPeerConnection.isPresentation) {
        if (this.presentationStatsSampler) this.presentationStatsSampler.stop();
        this.presentationStatsSampler = sampler;
      } else {
        if (this.primaryStatsSampler) this.primaryStatsSampler.stop();
        this.primaryStatsSampler = sampler;
      }

      sampler.start();
      if (this.statsInterval) return;
      this.statsInterval = setInterval(function () {
        _this.reportStats();
      }, 30000);
    }
  }, {
    key: "stop",
    value: function () {
      var _stop = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.primaryStatsSampler) this.primaryStatsSampler.stop();
                if (this.presentationStatsSampler) this.presentationStatsSampler.stop();
                if (this.statsInterval) clearInterval(this.statsInterval);
                this.statsInterval = null;
                _context.next = 6;
                return this.reportStats();

              case 6:
                this.primaryStatsSampler = null;
                this.presentationStatsSampler = null;

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function stop() {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
  }, {
    key: "sendStats",
    value: function sendStats(a, stats) {
      if (!this.url || !stats || !stats.length) return;
      var payload = {
        stats: stats
      };

      if (a) {
        payload['A'] = a;
      }

      navigator.sendBeacon(this.url, JSON.stringify(payload));
    }
  }, {
    key: "reportStats",
    value: function () {
      var _reportStats = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2() {
        var collectedSamplesPrimary, collectedSamplesPresentation, state, stats, aToken;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                try {
                  collectedSamplesPrimary = (0, _safeAccess.default)(this, 'primaryStatsSampler.flushStats()') || {};
                  collectedSamplesPresentation = (0, _safeAccess.default)(this, 'presentationStatsSampler.flushStats()') || {};
                  state = this.store.getState();
                  stats = Object.keys(collectedSamplesPrimary).map(function (key) {
                    return {
                      timestamp: key,
                      primary: collectedSamplesPrimary[key],
                      presentation: collectedSamplesPresentation[key] || {},
                      meta: {
                        call_id: (0, _safeAccess.default)(state, 'nucleus.galaxy.call.callId'),
                        conference_id: (0, _safeAccess.default)(state, 'nucleus.galaxy.call.conferenceId'),
                        user_id: (0, _safeAccess.default)(state, 'nucleus.userProfile.uuid'),
                        username: (0, _safeAccess.default)(state, 'nucleus.userProfile.name'),
                        dialstring: (0, _safeAccess.default)(state, 'nucleus.userProfile.extension')
                      }
                    };
                  });
                  aToken = (0, _auth.getPrimaryJwt)(state);
                  this.sendStats(aToken, stats);
                } catch (ex) {
                  _jsLogger.default.info('Could not report stats:', ex);
                }

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function reportStats() {
        return _reportStats.apply(this, arguments);
      }

      return reportStats;
    }()
  }]);
  return MediaStatsService;
}();

exports.default = MediaStatsService;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(34));

var _createClass2 = _interopRequireDefault(__webpack_require__(36));

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _cloneDeep = _interopRequireDefault(__webpack_require__(550));

var _rtcUtils = __webpack_require__(200);

var defaultConfig = [{
  period: 1,
  duration: 10
}, {
  period: 2,
  duration: 10
}, {
  period: 10,
  duration: 0 // infinite duration

}];

var RTCStatsSampler =
/*#__PURE__*/
function () {
  function RTCStatsSampler(peerConnection) {
    (0, _classCallCheck2.default)(this, RTCStatsSampler);
    this.peerConnection = peerConnection;
    this.init();
  }

  (0, _createClass2.default)(RTCStatsSampler, [{
    key: "init",
    value: function init() {
      this.config = this.loadConfigFromLocalStorage();
      this.stopped = true;
      this.sampleInterval = null;
      this.samples = {};
      this.prevStats = {};
    }
  }, {
    key: "loadConfigFromLocalStorage",
    value: function loadConfigFromLocalStorage() {
      if (window && window.localStorage) {
        try {
          var savedConfig = JSON.parse(window.localStorage.getItem('mediaStatsConfig'));
          if (savedConfig && savedConfig.length) return savedConfig;
        } catch (ex) {
          _jsLogger.default.info('Could not parse media stats config on load. using default.', ex);
        }

        this.saveConfigToLocalStorage(defaultConfig);
      }

      return defaultConfig;
    }
  }, {
    key: "saveConfigToLocalStorage",
    value: function saveConfigToLocalStorage(config) {
      if (!window || !window.localStorage) return;

      try {
        window.localStorage.setItem('mediaStatsConfig', JSON.stringify(config));
      } catch (ex) {
        _jsLogger.default.info('Could not save media stats config', ex);
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      this.stopped = true;
      this.checkStopped();
    }
  }, {
    key: "clearSampleInterval",
    value: function clearSampleInterval() {
      if (this.sampleInterval) {
        clearInterval(this.sampleInterval);
        this.sampleInterval = null;
      }
    }
  }, {
    key: "checkStopped",
    value: function checkStopped() {
      var closed = !this.peerConnection || this.peerConnection.connectionState === 'closed';

      if (!this.stopped && !closed) {
        return false;
      }

      this.clearSampleInterval();
      return true;
    }
  }, {
    key: "start",
    value: function () {
      var _start = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee() {
        var i;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.stopped = false;
                this.startTime = Date.now();
                _context.prev = 2;
                i = 0;

              case 4:
                if (!(i < this.config.length)) {
                  _context.next = 12;
                  break;
                }

                if (!this.checkStopped()) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("break", 12);

              case 7:
                _context.next = 9;
                return this.run(this.config[i]);

              case 9:
                i++;
                _context.next = 4;
                break;

              case 12:
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](2);

                _jsLogger.default.info('unable to start stats collection:', _context.t0);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 14]]);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "run",
    value: function () {
      var _run = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(rate) {
        var _this = this;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", new Promise(function (resolve) {
                  var i = 0;

                  _this.clearSampleInterval();

                  _this.sampleInterval = setInterval(function () {
                    if (_this.checkStopped()) return resolve();
                    i += rate.period;

                    if (rate.duration && i >= rate.duration) {
                      _this.clearSampleInterval();

                      return resolve();
                    }

                    _this.sample();
                  }, rate.period * 1000);
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function run(_x) {
        return _run.apply(this, arguments);
      }

      return run;
    }()
  }, {
    key: "sample",
    value: function () {
      var _sample = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3() {
        var stats, result;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.checkStopped()) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                _context3.prev = 2;
                _context3.next = 5;
                return this.peerConnection.getStats();

              case 5:
                stats = _context3.sent;
                result = (0, _rtcUtils.formatStats)(this.prevStats, stats, this.startTime);

                if (result) {
                  _context3.next = 9;
                  break;
                }

                return _context3.abrupt("return");

              case 9:
                this.prevStats = result.objStats;
                this.samples[result.timestamp] = result.formattedStats;
                _context3.next = 16;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](2);

                _jsLogger.default.info('Exception processing stats', _context3.t0);

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 13]]);
      }));

      function sample() {
        return _sample.apply(this, arguments);
      }

      return sample;
    }()
  }, {
    key: "flushStats",
    value: function flushStats() {
      var samples = (0, _cloneDeep.default)(this.samples);
      this.samples = {};
      return samples;
    }
  }]);
  return RTCStatsSampler;
}();

exports.default = RTCStatsSampler;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(551);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(182),
    arrayEach = __webpack_require__(552),
    assignValue = __webpack_require__(173),
    baseAssign = __webpack_require__(553),
    baseAssignIn = __webpack_require__(554),
    cloneBuffer = __webpack_require__(557),
    copyArray = __webpack_require__(558),
    copySymbols = __webpack_require__(559),
    copySymbolsIn = __webpack_require__(560),
    getAllKeys = __webpack_require__(225),
    getAllKeysIn = __webpack_require__(561),
    getTag = __webpack_require__(123),
    initCloneArray = __webpack_require__(562),
    initCloneByTag = __webpack_require__(563),
    initCloneObject = __webpack_require__(568),
    isArray = __webpack_require__(43),
    isBuffer = __webpack_require__(140),
    isMap = __webpack_require__(570),
    isObject = __webpack_require__(58),
    isSet = __webpack_require__(572),
    keys = __webpack_require__(102);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 552 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(147),
    keys = __webpack_require__(102);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(147),
    keysIn = __webpack_require__(280);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(58),
    isPrototype = __webpack_require__(142),
    nativeKeysIn = __webpack_require__(556);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 556 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(57);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(103)(module)))

/***/ }),
/* 558 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(147),
    getSymbols = __webpack_require__(184);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(147),
    getSymbolsIn = __webpack_require__(281);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(226),
    getSymbolsIn = __webpack_require__(281),
    keysIn = __webpack_require__(280);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 562 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(202),
    cloneDataView = __webpack_require__(564),
    cloneRegExp = __webpack_require__(565),
    cloneSymbol = __webpack_require__(566),
    cloneTypedArray = __webpack_require__(567);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(202);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 565 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(99);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(202);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(569),
    getPrototype = __webpack_require__(282),
    isPrototype = __webpack_require__(142);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(58);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(571),
    baseUnary = __webpack_require__(141),
    nodeUtil = __webpack_require__(186);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(123),
    isObjectLike = __webpack_require__(70);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(573),
    baseUnary = __webpack_require__(141),
    nodeUtil = __webpack_require__(186);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(123),
    isObjectLike = __webpack_require__(70);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(34));

var _createClass2 = _interopRequireDefault(__webpack_require__(36));

var _constants = __webpack_require__(3);

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _call = __webpack_require__(50);

var _call2 = __webpack_require__(51);

// NOTE: this is effectively the same as clients.call-signaling's service of the same name and
// can be removed when we migrate to using call-sig
var CallHeartBeatService =
/*#__PURE__*/
function () {
  function CallHeartBeatService() {
    var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 120000;
    (0, _classCallCheck2.default)(this, CallHeartBeatService);
    this.heartBeats = {};
    this.store;
    this.duration = duration;
  }
  /**
   * shouldClearHeartBeat
   * If the current call does not match with the old call, kill the heartbeat.
   * If the current call is not connected, kill the heartbeat.
   * @param {Object} storedCallId - The callId that is in the redux store.
   * @param {Object} callState - The call state that is in the redux store.
   * @param {Object} callId - call id
   */


  (0, _createClass2.default)(CallHeartBeatService, [{
    key: "shouldClearHeartBeat",
    value: function shouldClearHeartBeat(storedCallId, callState, callId) {
      return storedCallId !== callId || callState !== _constants.GALAXY_CALL_STATE_CONNECTED;
    }
  }, {
    key: "getConnectionStats",
    value: function () {
      var _getConnectionStats = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(peerConnection) {
        var preferredTypes, stats, statsMap;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (peerConnection) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.prev = 2;
                // Names from RTCStatsType: https://www.w3.org/TR/webrtc-stats/#rtcstatstype-str*
                preferredTypes = ['candidate-pair', 'local-candidate', 'remote-candidate'];
                _context.next = 6;
                return peerConnection.getStats();

              case 6:
                stats = _context.sent;
                statsMap = new Map();
                stats.forEach(function (stat) {
                  if (preferredTypes.find(function (type) {
                    return stat.type === type;
                  })) {
                    statsMap.set(stat.type, stat);
                  }
                });
                return _context.abrupt("return", {
                  selectedCandidatePairId: statsMap.get('candidate-pair.id'),
                  local: statsMap.get('local-candidate'),
                  remote: statsMap.get('remote-candidate')
                });

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](2);

                _jsLogger.default.info('Could not capture connection stats for heartbeat', _context.t0);

                return _context.abrupt("return", {});

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 12]]);
      }));

      function getConnectionStats(_x) {
        return _getConnectionStats.apply(this, arguments);
      }

      return getConnectionStats;
    }()
  }, {
    key: "sendHeartBeat",
    value: function () {
      var _sendHeartBeat = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(callId, peerConnection, presentationPeerConnection) {
        var state, storedCallId, storedSourceId, callState, primaryStats, presentationStats, iceStats;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                state = this.store.getState();
                storedCallId = (0, _call2.activeGalaxyCallId)(state);
                storedSourceId = (0, _call2.activeGalaxySourceId)(state);
                callState = (0, _call2.activeGalaxyCallState)(state);

                if (!this.shouldClearHeartBeat(storedCallId, callState, callId)) {
                  _context2.next = 8;
                  break;
                }

                clearInterval(this.heartBeats[callId]);
                delete this.heartBeats[callId];
                return _context2.abrupt("return");

              case 8:
                if (!(!peerConnection || !presentationPeerConnection)) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt("return");

              case 10:
                _context2.next = 12;
                return this.getConnectionStats(peerConnection);

              case 12:
                primaryStats = _context2.sent;
                _context2.next = 15;
                return this.getConnectionStats(presentationPeerConnection);

              case 15:
                presentationStats = _context2.sent;
                iceStats = {
                  primary: (0, _objectSpread2.default)({
                    iceState: peerConnection.iceConnectionState
                  }, primaryStats),
                  presentation: (0, _objectSpread2.default)({
                    iceState: presentationPeerConnection.iceConnectionState
                  }, presentationStats)
                };
                this.store.dispatch((0, _call.sendHeartBeatGalaxy)(storedSourceId, storedCallId, false, iceStats));

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function sendHeartBeat(_x2, _x3, _x4) {
        return _sendHeartBeat.apply(this, arguments);
      }

      return sendHeartBeat;
    }()
  }, {
    key: "startHeartBeat",
    value: function startHeartBeat(store, callId, peerConnection, presentationPeerConnection) {
      var _this = this;

      this.store = store;
      if (!callId) return; // replace current heartbeat with latest peer connections if necessary

      if (this.heartBeats[callId]) {
        clearInterval(this.heartBeats[callId]);
        delete this.heartBeats[callId];
      }

      this.heartBeats[callId] = setInterval(
      /*#__PURE__*/
      (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3() {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", _this.sendHeartBeat(callId, peerConnection, presentationPeerConnection));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })).bind(this), this.duration);
    }
  }]);
  return CallHeartBeatService;
}();

var _default = CallHeartBeatService;
exports.default = _default;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(34));

var _createClass2 = _interopRequireDefault(__webpack_require__(36));

var c = _interopRequireWildcard(__webpack_require__(3));

var _streamHolder = _interopRequireDefault(__webpack_require__(283));

var _webcamMedia = _interopRequireDefault(__webpack_require__(576));

var _videoMuteMedia = _interopRequireDefault(__webpack_require__(577));

var _presentationMedia = _interopRequireDefault(__webpack_require__(579));

var _videoElement = _interopRequireDefault(__webpack_require__(284));

var _streamUtils = __webpack_require__(105);

var _createMediaStream = __webpack_require__(203);

var _browserUtils = __webpack_require__(44);

var _media = __webpack_require__(143);

var _auth = __webpack_require__(31);

var _mediaUtils = __webpack_require__(201);

var _galaxyUtils = __webpack_require__(73);

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var StreamTransmitter =
/*#__PURE__*/
function () {
  function StreamTransmitter() {
    var _this = this;

    (0, _classCallCheck2.default)(this, StreamTransmitter);
    this.stream = null;
    this.streamTimer = null;

    if (!(0, _browserUtils.isIE11)()) {
      (0, _createMediaStream.createMediaStream)().then(function (stream) {
        _this.stream = stream;
      });
    } else {
      this.streamTimer = setInterval(function () {
        if (window.MediaStream) {
          clearInterval(_this.streamTimer);
          _this.streamTimer = null;
          (0, _createMediaStream.createMediaStream)().then(function (stream) {
            _this.stream = stream;
          });
        }
      }, 1000);
    } // media to attach to the stream


    this.webcamMedia = new _webcamMedia.default();
    this.videoMuteMedia = new _videoMuteMedia.default();
    this.presentationMedia = new _presentationMedia.default(); // helper info

    this.videoSourceId = null;
    this.audioSourceId = null;
    this.presentationTrackId = null;
    this.videoTrackId = null; // StreamHolders for attaching to video elements

    this.primaryStreamHolder = new _streamHolder.default();
    this.presentationStreamHolder = new _streamHolder.default();
  }

  (0, _createClass2.default)(StreamTransmitter, [{
    key: "addExternalPresentationStream",
    value: function addExternalPresentationStream(stream, store) {
      if (this.presentationMedia.hasExternalTrack) {
        this.stream.removeTrack(this.presentationMedia.track);
        this.presentationMedia.stop();
        this.presentationStreamHolder.detachElements();
      } // put external stream into presentationmedia class
      // returns the presentation track if it exists


      var track = this.presentationMedia.addExternalMedia(stream); // attach to elements as though we just caputred it

      if (track) {
        this.presentationStreamHolder.attachTrack(track, store);
        this.presentationTrackId = track.id; // update track ids for both galaxy and psems?
      }
    }
  }, {
    key: "addPrimaryElements",
    value: function addPrimaryElements(ids, store) {
      this.primaryStreamHolder.addElements(ids.map(function (id) {
        return new _videoElement.default(id, false);
      }), store);
    }
  }, {
    key: "addPresentationElements",
    value: function addPresentationElements(ids, store) {
      this.presentationStreamHolder.addElements(ids.map(function (id) {
        return new _videoElement.default(id, false);
      }), store);
    }
  }, {
    key: "isAudioMuted",
    value: function isAudioMuted() {
      return this.webcamMedia.audioTrack ? !this.webcamMedia.audioTrack.enabled : true;
    }
  }, {
    key: "hasVideoTrack",
    value: function hasVideoTrack() {
      return !!this.webcamMedia.videoTrack;
    }
  }, {
    key: "isVideoMuted",
    value: function isVideoMuted() {
      return this.webcamMedia.videoTrack ? !this.webcamMedia.videoTrack.enabled : true;
    }
  }, {
    key: "hasAudioTrack",
    value: function hasAudioTrack() {
      return !!this.webcamMedia.audioTrack;
    }
  }, {
    key: "hasPresentation",
    value: function hasPresentation() {
      return !!this.presentationMedia.track;
    }
  }, {
    key: "acquireWebcam",
    value: function () {
      var _acquireWebcam = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(store, includeVideo, includeAudio) {
        var videoSourceId,
            audioSourceId,
            width,
            height,
            frameRate,
            state,
            platform,
            videoConstraints,
            audioConstraints,
            audioTrack,
            _audioSource,
            _videoSource,
            result,
            audioSource,
            videoSource,
            _args = arguments;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                videoSourceId = _args.length > 3 && _args[3] !== undefined ? _args[3] : this.videoSourceId;
                audioSourceId = _args.length > 4 && _args[4] !== undefined ? _args[4] : this.audioSourceId;
                width = _args.length > 5 ? _args[5] : undefined;
                height = _args.length > 6 ? _args[6] : undefined;
                frameRate = _args.length > 7 ? _args[7] : undefined;
                state = store.getState();
                platform = (0, _auth.getPlatform)(state);
                videoConstraints = !(0, _safeAccess.default)(state, 'nucleus.media.selectedVideoConstraints') ? (0, _safeAccess.default)(state, 'nucleus.media.defaultVideoConstraints') || (0, _safeAccess.default)(state, 'nucleus.media.videoConstraints') : (0, _safeAccess.default)(state, 'nucleus.media.selectedVideoConstraints');

                if (width) {
                  videoConstraints.width = width;
                }

                if (height) {
                  videoConstraints.height = height;
                }

                if (frameRate) {
                  videoConstraints.frameRate = frameRate;
                }

                audioConstraints = true;

                if (!includeVideo) {
                  videoConstraints = false;
                } else if (videoSourceId) {
                  Object.assign(videoConstraints, {
                    deviceId: videoSourceId
                  });
                  this.videoSourceId = videoSourceId;
                }

                if (!includeAudio) {
                  audioConstraints = false;
                } else if (audioSourceId) {
                  audioConstraints = {
                    deviceId: {
                      ideal: audioSourceId
                    }
                  };
                  this.audioSourceId = audioSourceId;
                }

                audioConstraints = (0, _mediaUtils.applyNoiseSuppressionConstraint)(state, audioConstraints); // webrtc native cannot handle quick recaptures of the camera
                // if we need to include video, let's use what we already have, if we have it
                // TODO: can this be removed?

                if (!(includeVideo && (0, _browserUtils.isWebRtcNative)(platform) && this.webcamMedia.videoTrack)) {
                  _context.next = 27;
                  break;
                }

                if (!(includeAudio && !this.hasAudioTrack())) {
                  _context.next = 22;
                  break;
                }

                _context.next = 19;
                return this.acquireAudio(state);

              case 19:
                _context.t0 = _context.sent;
                _context.next = 23;
                break;

              case 22:
                _context.t0 = this.webcamMedia.audioTrack;

              case 23:
                audioTrack = _context.t0;
                _audioSource = this.setAudioSource(state, audioTrack);
                _videoSource = this.setVideoSource(state, this.webcamMedia.videoTrack);
                return _context.abrupt("return", {
                  videoTrack: this.webcamMedia.videoTrack,
                  audioTrack: audioTrack,
                  stream: this.stream,
                  audioSource: _audioSource,
                  videoSource: _videoSource
                });

              case 27:
                _context.next = 29;
                return this.endWebcam();

              case 29:
                _context.next = 31;
                return this.webcamMedia.acquire({
                  video: videoConstraints,
                  audio: audioConstraints
                });

              case 31:
                result = _context.sent;

                if (result.videoTrack) {
                  this.addVideoTrack(result.videoTrack); // display video if it exists

                  this.primaryStreamHolder.attachTrack(result.videoTrack, store);
                }

                if (result.audioTrack) {
                  this.addAudioTrack(result.audioTrack);
                }

                audioSource = this.setAudioSource(state, (0, _safeAccess.default)(result, 'audioTrack'));
                videoSource = this.setVideoSource(state, (0, _safeAccess.default)(result, 'videoTrack'));
                return _context.abrupt("return", (0, _objectSpread2.default)({}, result, {
                  stream: this.stream,
                  audioSource: audioSource,
                  videoSource: videoSource
                }));

              case 37:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function acquireWebcam(_x, _x2, _x3) {
        return _acquireWebcam.apply(this, arguments);
      }

      return acquireWebcam;
    }()
  }, {
    key: "setVideoSource",
    value: function setVideoSource(state, track) {
      if (!track) return null;
      var videoSource = (0, _media.videoDevices)(state).find(function (d) {
        return d.label === (0, _safeAccess.default)(track, 'label');
      });

      if (videoSource) {
        this.videoSourceId = (0, _safeAccess.default)(videoSource, 'deviceId');
        return videoSource;
      }

      return null;
    }
  }, {
    key: "setAudioSource",
    value: function setAudioSource(state, track) {
      if (!track) return null;
      var audioSource = (0, _media.audioDevices)(state).find(function (d) {
        return d.label === (0, _safeAccess.default)(track, 'label');
      });

      if (audioSource) {
        this.audioSourceId = (0, _safeAccess.default)(audioSource, 'deviceId');
        return audioSource;
      }

      return null;
    }
  }, {
    key: "switchVideoCamera",
    value: function switchVideoCamera() {
      this.webcamMedia.switchVideoCamera();
    }
  }, {
    key: "disableAudio",
    value: function disableAudio() {
      this.webcamMedia.disableAudio();
    }
  }, {
    key: "enableAudio",
    value: function enableAudio() {
      this.webcamMedia.enableAudio();
    }
  }, {
    key: "disableVideo",
    value: function disableVideo() {
      return this.webcamMedia.disableVideo();
    }
  }, {
    key: "enableVideo",
    value: function enableVideo() {
      this.webcamMedia.enableVideo();
    }
  }, {
    key: "endWebcam",
    value: function endWebcam() {
      var _this2 = this;

      return this.endAudio().then(function () {
        return _this2.endVideo();
      });
    }
  }, {
    key: "endAudio",
    value: function endAudio() {
      var _this3 = this;

      if (this.stream) {
        var tracks = this.stream.getAudioTracks();
        tracks.forEach(function (t) {
          _this3.stream.removeTrack(t);

          t.stop();
        });
      }

      this.webcamMedia.stopAudio();
      return Promise.resolve();
    }
  }, {
    key: "endVideo",
    value: function endVideo() {
      var _this4 = this;

      if (this.stream) {
        var tracks = this.stream.getVideoTracks();
        tracks.forEach(function (t) {
          _this4.stream.removeTrack(t);

          t.stop();
        });
      }

      if (this.videoMuteMedia.videoTrack) {
        this.videoMuteMedia.stopVideo();
      }

      this.videoTrackId = null;
      this.primaryStreamHolder.detachElements();
      this.webcamMedia.stopVideo();
      return Promise.resolve();
    }
  }, {
    key: "acquireAudio",
    value: function acquireAudio(state, sourceId) {
      var _this5 = this;

      this.endAudio();
      var constraints = true;

      if (sourceId) {
        this.audioSourceId = sourceId;
      }

      if (this.audioSourceId) {
        constraints = {
          deviceId: {
            ideal: this.audioSourceId
          }
        };
      }

      constraints = (0, _mediaUtils.applyNoiseSuppressionConstraint)(state, constraints);
      return this.webcamMedia.acquireAudio(constraints).then(function (result) {
        _this5.addAudioTrack(result.audioTrack);

        _this5.setAudioSource(state, (0, _safeAccess.default)(result, 'audioTrack'));

        return Promise.resolve(result.audioTrack);
      });
    }
  }, {
    key: "addAudioTrack",
    value: function addAudioTrack(track) {
      var _this6 = this;

      if (!this.stream) return;
      this.stream.getAudioTracks().forEach(function (t) {
        _this6.stream.removeTrack(t);

        t.stop();
      });
      this.stream.addTrack(track);
    }
  }, {
    key: "addVideoTrack",
    value: function addVideoTrack(track) {
      var _this7 = this;

      // We need to ensure video/mute track gets added as the first track in the stream
      // If the presentation track exists, remove it and add it back.
      // stop all other superfluous tracks that may be lurking
      var presentationTrack = null;
      this.stream.getVideoTracks().forEach(function (t) {
        _this7.stream.removeTrack(t); // only save the presentation track to add back


        if (t.id === _this7.presentationTrackId) {
          presentationTrack = t;
        } else {
          // stop all other tracks
          t.onended = null;
          t.stop();
        }
      });
      this.stream.addTrack(track);
      this.videoTrackId = track.id;

      if (this.presentationTrackId && presentationTrack) {
        this.stream.addTrack(presentationTrack);
      }
    }
  }, {
    key: "acquireVideoMute",
    value: function acquireVideoMute(store, videoMuteSlide) {
      var _this8 = this;

      this.endVideo();
      var state = store.getState();
      var videoConstraints = (0, _safeAccess.default)(state, 'nucleus.media.videoConstraints');
      var platform = (0, _auth.getPlatform)(state);
      var downScaleWidth = (0, _safeAccess.default)(state, 'nucleus.galaxy.rtc.downScaleWidth');
      var downScaleHeight = (0, _safeAccess.default)(state, 'nucleus.galaxy.rtc.downScaleHeight');
      return this.videoMuteMedia.acquire(videoMuteSlide, platform).then(
      /*#__PURE__*/
      function () {
        var _ref = (0, _asyncToGenerator2.default)(
        /*#__PURE__*/
        _regenerator.default.mark(function _callee2(result) {
          var tmpConstraints;
          return _regenerator.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  // Track object returned by the canvas does not have the getConstraints
                  // api shim it
                  if ((0, _galaxyUtils.isAutoResolutionChangeEnabled)()) {
                    tmpConstraints = (0, _objectSpread2.default)({}, videoConstraints);

                    result.videoTrack.getConstraints = function () {
                      return tmpConstraints;
                    };

                    result.videoTrack.applyConstraints = function () {
                      return Promise.resolve();
                    };
                  }

                  if (!((0, _safeAccess.default)(state, 'nucleus.galaxy.rtc.scaledResolution.downScaleInForce') && (0, _mediaUtils.compareConstraints)(result.videoTrack, downScaleHeight, downScaleWidth) === 1)) {
                    _context2.next = 4;
                    break;
                  }

                  _context2.next = 4;
                  return (0, _mediaUtils.setTrackConstraints)(result.videoTrack, downScaleHeight, downScaleWidth);

                case 4:
                  _this8.addVideoTrack(result.videoTrack);

                  _this8.primaryStreamHolder.attachTrack(result.videoTrack, store);

                  return _context2.abrupt("return", Promise.resolve(result.videoTrack));

                case 7:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x4) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "acquireVideo",
    value: function acquireVideo(constraints, store) {
      var _this9 = this;

      this.endVideo();

      if (this.videoSourceId) {
        Object.assign(constraints, {
          deviceId: this.videoSourceId
        });
      }

      return this.webcamMedia.acquireVideo(constraints).then(function (result) {
        _this9.addVideoTrack(result.videoTrack);

        _this9.setVideoSource(store.getState(), (0, _safeAccess.default)(result, 'videoTrack'));

        _this9.primaryStreamHolder.attachTrack(result.videoTrack, store);

        return Promise.resolve(result.videoTrack);
      });
    }
  }, {
    key: "acquireVideoHD",
    value: function acquireVideoHD(store, sourceId) {
      var state = store.getState();
      var constraints = (0, _safeAccess.default)(state, 'nucleus.media.videoConstraints');
      var downScaleWidth = (0, _safeAccess.default)(state, 'nucleus.galaxy.rtc.downScaleWidth');
      var downScaleHeight = (0, _safeAccess.default)(state, 'nucleus.galaxy.rtc.downScaleHeight');

      if (sourceId) {
        this.videoSourceId = sourceId;
      }

      return this.acquireVideo(constraints, store).then(
      /*#__PURE__*/
      function () {
        var _ref2 = (0, _asyncToGenerator2.default)(
        /*#__PURE__*/
        _regenerator.default.mark(function _callee3(track) {
          return _regenerator.default.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!((0, _safeAccess.default)(state, 'nucleus.galaxy.rtc.scaledResolution.downScaleInForce') && (0, _mediaUtils.compareConstraints)(track, downScaleHeight, downScaleWidth) === 1)) {
                    _context3.next = 3;
                    break;
                  }

                  _context3.next = 3;
                  return (0, _mediaUtils.setTrackConstraints)(track, downScaleHeight, downScaleWidth);

                case 3:
                  return _context3.abrupt("return", Promise.resolve(track));

                case 4:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x5) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "acquirePresentation",
    value: function acquirePresentation(store, isPinnedMode, sourceId) {
      var _this10 = this;

      if (!this.presentationMedia.hasExternalTrack) {
        this.endPresentation(store);
      }

      return this.presentationMedia.acquire(store, sourceId).then(function (result) {
        if (!result.track) {
          throw (0, _streamUtils.streamAcquisitionError)(c.MISSING_PRESENTATION_TRACK);
        }

        _this10.stream.addTrack(result.track);

        if (isPinnedMode && _this10.webcamMedia.videoTrack) {
          _this10.stream.removeTrack(_this10.webcamMedia.videoTrack);
        } // attach to stream holder to display on screen


        _this10.presentationStreamHolder.attachTrack(result.track, store);

        _this10.presentationTrackId = result.track.id;
        store.dispatch({
          type: c.GALAXY_ACTION_UPDATE_PRESENTATION_TRACKID,
          payload: result.track.id
        });
        return Promise.resolve(result.track);
      }).catch(function (e) {
        throw (0, _streamUtils.streamAcquisitionError)(c.MISSING_PRESENTATION_TRACK, e);
      });
    }
  }, {
    key: "endPresentation",
    value: function endPresentation(store, isPinnedMode) {
      if (this.presentationMedia.track && this.stream) {
        this.stream.removeTrack(this.presentationMedia.track);
      }

      this.presentationTrackId = null;
      store.dispatch({
        type: c.GALAXY_ACTION_UPDATE_PRESENTATION_TRACKID,
        payload: null
      });

      if (!this.presentationMedia.hasExternalTrack) {
        this.presentationMedia.stop();
        this.presentationStreamHolder.detachElements();
      }

      if (this.stream && isPinnedMode && this.webcamMedia.videoTrack) {
        this.stream.addTrack(this.webcamMedia.videoTrack);
      }

      return Promise.resolve();
    }
  }]);
  return StreamTransmitter;
}();

var _default = StreamTransmitter;
exports.default = _default;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(34));

var _createClass2 = _interopRequireDefault(__webpack_require__(36));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var c = _interopRequireWildcard(__webpack_require__(3));

var _browserUtils = __webpack_require__(44);

var _streamUtils = __webpack_require__(105);

var WebcamMedia =
/*#__PURE__*/
function () {
  function WebcamMedia() {
    (0, _classCallCheck2.default)(this, WebcamMedia);
    this.videoTrack = null;
    this.audioTrack = null;
  }

  (0, _createClass2.default)(WebcamMedia, [{
    key: "switchVideoCamera",
    value: function switchVideoCamera() {
      (0, _safeAccess.default)(this, 'videoTrack._switchCamera()');
    }
  }, {
    key: "enableVideo",
    value: function enableVideo() {
      if (this.videoTrack) this.videoTrack.enabled = true;
    }
  }, {
    key: "disableVideo",
    value: function disableVideo() {
      if (this.videoTrack) this.videoTrack.enabled = false;
      return new Promise(function (resolve) {
        if ((0, _browserUtils.isIE11)()) {
          // DCM: need to wait 500ms for video to be disabled in IE11
          setTimeout(function () {
            return resolve();
          }, 500);
        } else {
          resolve();
        }
      });
    }
  }, {
    key: "enableAudio",
    value: function enableAudio() {
      if (this.audioTrack) this.audioTrack.enabled = true;
    }
  }, {
    key: "disableAudio",
    value: function disableAudio() {
      if (this.audioTrack) this.audioTrack.enabled = false;
    }
  }, {
    key: "acquireAudio",
    value: function acquireAudio(constraints) {
      var _this = this;

      this.stopAudio();
      return navigator.mediaDevices.getUserMedia({
        video: false,
        audio: constraints
      }).then(function (stream) {
        // prevent leaving a stale tracks around if 2 getUserMedia's are fired in quick succession
        _this.stopAudio();

        _this.audioTrack = stream.getAudioTracks()[0];
        if (!_this.audioTrack) throw (0, _streamUtils.streamAcquisitionError)(c.MISSING_AUDIO_TRACK);
        return {
          audioTrack: _this.audioTrack,
          stream: stream
        };
      });
    }
  }, {
    key: "acquireVideo",
    value: function acquireVideo(constraints) {
      var _this2 = this;

      this.stopVideo();
      return navigator.mediaDevices.getUserMedia({
        video: constraints,
        audio: false
      }).then(function (stream) {
        // prevent leaving a stale tracks around if 2 getUserMedia's are fired in quick succession
        _this2.stopVideo();

        _this2.videoTrack = stream.getVideoTracks()[0];
        if (!_this2.videoTrack) throw (0, _streamUtils.streamAcquisitionError)(c.MISSING_VIDEO_TRACK);
        return {
          videoTrack: _this2.videoTrack,
          stream: stream
        };
      });
    }
  }, {
    key: "acquire",
    value: function acquire(constraints) {
      var _this3 = this;

      this.stop();

      if (!constraints.audio && !constraints.video) {
        return Promise.resolve({
          audioTrack: null,
          videoTrack: null
        });
      }

      return navigator.mediaDevices.getUserMedia({
        audio: constraints.audio,
        video: constraints.video
      }).then(function (stream) {
        var audioTracks = stream.getAudioTracks();
        var videoTracks = stream.getVideoTracks(); // prevent leaving a stale tracks around if 2 getUserMedia's are fired in quick succession

        _this3.stop();

        if (audioTracks && audioTracks.length) {
          _this3.audioTrack = audioTracks[0];
        }

        if (videoTracks && videoTracks.length) {
          _this3.videoTrack = videoTracks[0];
        }

        return {
          videoTrack: _this3.videoTrack,
          audioTrack: _this3.audioTrack,
          stream: stream
        };
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      this.stopVideo();
      this.stopAudio();
    }
  }, {
    key: "stopAudio",
    value: function stopAudio() {
      if (this.audioTrack) {
        this.audioTrack.stop();
        this.audioTrack = null;
      }
    }
  }, {
    key: "stopVideo",
    value: function stopVideo() {
      if (this.videoTrack) {
        this.videoTrack.stop();
        this.videoTrack = null;
      }
    }
  }]);
  return WebcamMedia;
}();

var _default = WebcamMedia;
exports.default = _default;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(34));

var _createClass2 = _interopRequireDefault(__webpack_require__(36));

var c = _interopRequireWildcard(__webpack_require__(3));

var _frank = _interopRequireDefault(__webpack_require__(578));

var _streamUtils = __webpack_require__(105);

var _browserUtils = __webpack_require__(44);

var TOILET_MAN_CANVAS = 'canvasMuteElement';
var TOILET_MAN_IMAGE = 'videoMuteElement';
/**
 * This class is a convenience for generating a source stream for a video mute slide.
 * Pass in the file location via a string paramenter. Then attempt to render it inside
 * of a canvas element and then generate a media stream from it.
 */

var VideoMuteSlide =
/*#__PURE__*/
function () {
  function VideoMuteSlide() {
    (0, _classCallCheck2.default)(this, VideoMuteSlide);
    this.videoTrack = null;
    this.previousTimestamp = null;
    this.animationCallbackID = null;
    this.blockRequestLoop = false;
    this.isMobile = false;
  }

  (0, _createClass2.default)(VideoMuteSlide, [{
    key: "enableVideo",
    value: function enableVideo() {
      if (this.videoTrack) this.videoTrack.enabled = true;
    }
  }, {
    key: "disableVideo",
    value: function disableVideo() {
      if (this.videoTrack) this.videoTrack.enabled = false;
    }
    /**
     * This function creates the canvas inside the body for png "slide" file to be rendered to.
     * We are ensuring that the canvas is not visible (0px x 0px styling).
     * We've located it in the top left corner, and it is at a very low zIndex to ensure
     * no one sees this thing.
     */

  }, {
    key: "createCanvas",
    value: function createCanvas() {
      var body = document.getElementsByTagName('body')[0];
      var canvas = document.createElement('canvas');
      canvas.id = TOILET_MAN_CANVAS;
      canvas.width = 1280; // width of frank

      canvas.height = 720; // height of frank

      canvas.style.position = 'absolute';
      canvas.style.left = '0px';
      canvas.style.top = '0px';
      canvas.style.zIndex = '-100000';
      canvas.style.width = '0px';
      canvas.style.height = '0px';
      body.appendChild(canvas);
      return canvas;
    }
    /**
     * Add the image to the document body.
     */

  }, {
    key: "createImage",
    value: function createImage() {
      var body = document.getElementsByTagName('body')[0];
      var image = document.createElement('img'); // use DOM HTMLImageElement

      image.id = TOILET_MAN_IMAGE;
      image.style.display = 'none';
      body.appendChild(image);
      return image;
    }
    /**
     * Destroy this canvas element. Don't let it hang around.
     */

  }, {
    key: "stopCanvas",
    value: function stopCanvas() {
      var canvas = document.getElementById(TOILET_MAN_CANVAS);
      var body = document.getElementsByTagName('body')[0];

      if (canvas) {
        body.removeChild(canvas);
      }

      window.cancelAnimationFrame(this.animationCallbackID); // If for some reason the cancelAnimation ID has a race condition, blockRequestLoop will block the invocation of the next request.

      this.blockRequestLoop = true;
      this.previousTimestamp = null;
      this.animationCallbackID = null;
    }
    /**
     * Destroy this image element. Don't let it hang around.
     */

  }, {
    key: "removeImage",
    value: function removeImage() {
      var image = document.getElementById(TOILET_MAN_IMAGE);
      var body = document.getElementsByTagName('body')[0];

      if (image) {
        body.removeChild(image);
      }
    }
    /**
     * fitImageToCanvas calculates how to center and/or resize an image
     * to draw onto the canvas output stream. The canvas dimensions are determined
     * by the constraints passed in via updateCanvas, usually from stream-transmitter.
     *
     * @param {integer} canvasWidth - The width of the canvas to draw to.
     * @param {integer} canvasHeight - The height of the canvas to draw to.
     * @param {integer} imageWidth - The width of the image to draw on the canvas.
     * @param {integer} imageHeight - The height of the image to draw on the canvas.
     */

  }, {
    key: "fitImageToCanvas",
    value: function fitImageToCanvas(canvasWidth, canvasHeight, imageWidth, imageHeight) {
      var dX,
          dY,
          width,
          height = 0;

      if (canvasWidth && canvasHeight && imageWidth && imageHeight) {
        var canvasAspect = canvasWidth / canvasHeight;
        var imageAspect = imageWidth / imageHeight;
        height = canvasHeight;
        width = height * imageAspect;
        dX = (canvasWidth - width) / 2;
        dY = 0;

        if (canvasAspect < imageAspect) {
          width = canvasWidth;
          height = width / imageAspect;
          dX = 0;
          dY = (canvasHeight - height) / 2;
        }
      }

      return {
        height: height,
        width: width,
        dX: dX,
        dY: dY
      };
    }
    /**
     * Update the canvas.
     * When invoked, and there is an image and a canvas, this is an infinte loop.
     * The loop can only be broken if image or canvas are removed from the body.
     * We clear the image, calculate the image dimensions to be drawn onto the canvas,
     * and then draw onto the canvas.
     */

  }, {
    key: "updateCanvas",
    value: function updateCanvas(timestamp) {
      var _this = this;

      var canvas = document.getElementById(TOILET_MAN_CANVAS);
      var image = document.getElementById(TOILET_MAN_IMAGE);
      if (!this.previousTimestamp) this.previousTimestamp = timestamp;
      var deltaTime = timestamp - this.previousTimestamp; // Arbitrary throttle period. This will generate roughly 5fps due to inaccuracies in the timestamp precision.

      if (image && canvas && deltaTime > 200) {
        this.previousTimestamp = timestamp;
        var ctx = canvas.getContext('2d');
        var fit = this.fitImageToCanvas(canvas.width, canvas.height, image.naturalWidth, image.naturalHeight);
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(image, fit.dX, fit.dY, fit.width, fit.height);
      }

      if (!this.blockRequestLoop) {
        this.animationCallbackID = window.requestAnimationFrame(function (timestamp) {
          return _this.updateCanvas(timestamp);
        });
      }
    }
    /**
     * Acquire the video mute slide. First ensure that the video element exists. If not, create it.
     * Then attempt to create the video element stream by adding the source path for the video.
     * Once the video is playable, capture the stream. Apparently you don't need to play it.
     * Pass up the video track once it's ben acquired.
     * @param {string} videoMuteSlide - Path to the image to be loaded.
     */

  }, {
    key: "acquire",
    value: function acquire(videoMuteSlide) {
      var _this2 = this;

      var platform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : c.PLATFORM_WEB;

      if ((0, _browserUtils.isMobile)(platform)) {
        this.isMobile = true;
        return navigator.mediaDevices.getUserMedia((0, _browserUtils.getMobileVideoMuteConstraints)()).then(function (stream) {
          _this2.videoTrack = stream.getVideoTracks()[0];
          return {
            videoTrack: _this2.videoTrack,
            stream: stream
          };
        });
      }

      this.stopVideo();
      this.blockRequestLoop = false;
      return new Promise(function (resolve, reject) {
        try {
          var canvas = document.getElementById(TOILET_MAN_CANVAS);
          var img = document.getElementById(TOILET_MAN_IMAGE);
          if (!canvas) canvas = _this2.createCanvas();
          if (!img) img = _this2.createImage();

          img.onload = function () {
            _this2.animationCallbackID = window.requestAnimationFrame(function (timestamp) {
              return _this2.updateCanvas(timestamp);
            });
            var stream = canvas.captureStream();

            if (!stream || !stream.getVideoTracks()[0]) {
              reject((0, _streamUtils.streamAcquisitionError)(c.MISSING_VIDEO_TRACK));
            }

            _this2.videoTrack = stream.getVideoTracks()[0];
            resolve({
              videoTrack: _this2.videoTrack,
              stream: stream
            });
          };

          img.onerror = function () {
            reject((0, _streamUtils.streamAcquisitionError)(c.MISSING_VIDEO_TRACK));
          };

          img.src = videoMuteSlide || _frank.default;
        } catch (e) {
          return reject(e);
        }
      });
    }
    /**
     * Stop the mute slide. Removes the canvas element and the image element from the document body.
     * Stops the video Track output.
     */

  }, {
    key: "stopVideo",
    value: function stopVideo() {
      if (!this.isMobile) {
        this.stopCanvas();
        this.removeImage();
      }

      if (this.videoTrack) {
        this.videoTrack.stop();
        this.videoTrack = null;
      }
    }
  }]);
  return VideoMuteSlide;
}();

var _default = VideoMuteSlide;
exports.default = _default;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = 'data:image/png;base64,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';
exports.default = _default;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(34));

var _createClass2 = _interopRequireDefault(__webpack_require__(36));

var browserUtils = _interopRequireWildcard(__webpack_require__(44));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _stream = __webpack_require__(80);

var PresentationMedia =
/*#__PURE__*/
function () {
  function PresentationMedia() {
    (0, _classCallCheck2.default)(this, PresentationMedia);
    this.track = null;
    this.hasExternalTrack = false;
  }

  (0, _createClass2.default)(PresentationMedia, [{
    key: "addExternalMedia",
    value: function addExternalMedia(stream) {
      if (!stream || !stream.getVideoTracks()) {
        this.stop();
        this.hasExternalTrack = false;
        return null;
      }

      this.track = stream.getVideoTracks()[0];
      this.hasExternalTrack = true;
      return this.track;
    }
  }, {
    key: "acquire",
    value: function () {
      var _acquire = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(store, sourceId) {
        var state, localPresentationStream, constraints, acquireFunction, stream;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.hasExternalTrack) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", Promise.resolve({
                  track: this.track
                }));

              case 2:
                this.stop();
                state = store.getState();
                localPresentationStream = (0, _safeAccess.default)(state, 'nucleus.media.localPresentationStream');
                constraints = browserUtils.getChromeDesktopConstraints(sourceId);
                acquireFunction = localPresentationStream ?
                /*#__PURE__*/
                (0, _asyncToGenerator2.default)(
                /*#__PURE__*/
                _regenerator.default.mark(function _callee() {
                  return _regenerator.default.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          return _context.abrupt("return", localPresentationStream);

                        case 1:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })) :
                /*#__PURE__*/
                function () {
                  var _ref2 = (0, _asyncToGenerator2.default)(
                  /*#__PURE__*/
                  _regenerator.default.mark(function _callee2(constraints) {
                    return _regenerator.default.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            return _context2.abrupt("return", navigator.mediaDevices.getUserMedia(constraints));

                          case 1:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x3) {
                    return _ref2.apply(this, arguments);
                  };
                }();
                _context3.next = 9;
                return acquireFunction(constraints);

              case 9:
                stream = _context3.sent;
                this.track = stream.getVideoTracks()[0];
                this.track.onended = this.ended.bind(this, store);
                return _context3.abrupt("return", {
                  track: this.track,
                  stream: stream
                });

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function acquire(_x, _x2) {
        return _acquire.apply(this, arguments);
      }

      return acquire;
    }()
  }, {
    key: "ended",
    value: function ended(store) {
      if (store) {
        store.dispatch((0, _stream.stopPresentation)());
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.track) {
        this.track.onended = null;
        this.track.stop();
        this.track = null;
        this.hasExternalTrack = false;
      }
    }
  }]);
  return PresentationMedia;
}();

var _default = PresentationMedia;
exports.default = _default;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(34));

var _createClass2 = _interopRequireDefault(__webpack_require__(36));

var _streamHolder = _interopRequireDefault(__webpack_require__(283));

var _videoElement = _interopRequireDefault(__webpack_require__(284));

var browserUtils = _interopRequireWildcard(__webpack_require__(44));

var _createMediaStream = __webpack_require__(203);

var c = _interopRequireWildcard(__webpack_require__(3));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var StreamReceiver =
/*#__PURE__*/
function () {
  function StreamReceiver() {
    (0, _classCallCheck2.default)(this, StreamReceiver);
    this.primaryStream = null;
    this.presentationStream = null; // StreamHolders for attaching to video elements

    this.primaryStreamHolder = new _streamHolder.default();
    this.presentationStreamHolder = new _streamHolder.default();
    this.outputId = null;
    this.slideRemovalTimeout = null;
    this.hasExternalPresentation = false;
    this.presentationActive = false;
  }

  (0, _createClass2.default)(StreamReceiver, [{
    key: "end",
    value: function end() {
      if (this.primaryStream) {
        this.primaryStream.onaddtrack = null;
        this.primaryStream.onremovetrack = null;
      }

      this.primaryStream = null;
      this.presentationStream = null;
      this.primaryStreamHolder.detachElements();
      if (this.hasExternalPresentation) return;
      this.presentationActive = false;
    }
  }, {
    key: "addExternalPresentationStream",
    value: function addExternalPresentationStream(store, stream) {
      if (!stream) {
        this.hasExternalPresentation = false;
        return;
      }

      this.hasExternalPresentation = true;
      this.presentationStream = stream;
      this.presentationStreamHolder.updateStreamAndAttach(this.presentationStream, store);
    }
  }, {
    key: "addPrimaryElements",
    value: function addPrimaryElements(ids, store) {
      this.primaryStreamHolder.addElements(ids.map(function (id) {
        return new _videoElement.default(id, false);
      }), store);
    }
  }, {
    key: "addPresentationElements",
    value: function addPresentationElements(ids, store) {
      this.presentationStreamHolder.addElements(ids.map(function (id) {
        return new _videoElement.default(id, false);
      }), store);
    }
  }, {
    key: "setOutputDeviceId",
    value: function setOutputDeviceId(id) {
      this.outputId = id;
      this.primaryStreamHolder.setElementOutputDevice(id);
    }
  }, {
    key: "addPresentationStream",
    value: function addPresentationStream(stream) {
      var _this = this;

      var isGalaxy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var presentationTrack;
      var videoTracks = stream.getVideoTracks();
      videoTracks.forEach(function (track) {
        if (track.id.toLowerCase() === c.PRESENTATION_LABEL) {
          presentationTrack = track;
        }
      });

      if (presentationTrack || isGalaxy) {
        if (stream.id !== c.NUCLEUS_PRESENTATION_STREAM_LABEL && !isGalaxy) {
          // CNUC-543 - We haven't tweaked the presentation stream id. So
          // do the track manipulation. Basically leave whats working on
          // chrome undisturbed. Fix it only for IE11 and mobile
          stream.removeTrack(presentationTrack);
          (0, _createMediaStream.createMediaStream)().then(function (newStream) {
            _this.presentationStream = newStream;

            _this.presentationStream.addTrack(presentationTrack);
          });
        } else {
          // CNUC-1102 - in galaxy since we use second peer connection
          // we will always use the same stream given by the peerconnection.
          this.presentationStream = stream;
        }

        if (this.primaryStream && browserUtils.isWindows() && !browserUtils.isIE11()) {
          this.primaryStreamHolder.reAttachToOutputDevice();
        }
      }
    }
  }, {
    key: "addPrimaryStream",
    value: function addPrimaryStream(stream, store) {
      // TODO: refactor, do we need to handle this case here?
      // Or can we handle this in onRemovePrimaryStream
      if (!stream) {
        // Just to make sure we don't receive any callbacks after we stop
        // tracking the stream
        this.primaryStream.onaddtrack = null;
        this.primaryStream.onremovetrack = null;
        this.primaryStream = null;
        this.primaryStreamHolder.detachElements();
        return;
      }

      store.dispatch({
        type: c.RTC_REMOTE_STREAM_UPDATED,
        payload: stream
      });
      this.primaryStream = stream;
      this.primaryStream.onaddtrack = this.onTrackAdded.bind(this, stream, store);
      this.primaryStream.onremovetrack = this.onTrackRemoved.bind(this, stream, store);
      this.primaryStreamHolder.updateStreamAndAttach(stream, store);
    }
  }, {
    key: "removePresentation",
    value: function removePresentation() {
      this.presentationStreamHolder.detachElements(); // CNUC-856 - Since chrome 63 (most likely) chrome started doing
      // something wierd in changing the audio output when we start
      // presentation. Truely wierd as we don't do anything with respect
      // to the main video receive stream. To overcome this nasty behavior
      // we have this hack to reattach the audio only for windows chrome

      if (this.primaryStream && browserUtils.isWindows() && !browserUtils.isIE11()) {
        this.primaryStreamHolder.reAttachToOutputDevice();
      }

      this.presentationStream = null;
      this.presentationActive = false;
      return;
    }
  }, {
    key: "onTrackAdded",
    value: function onTrackAdded(stream, store, track) {
      if (track.track.id.toLowerCase() === c.PRESENTATION_LABEL) {
        this.addPresentationStream(stream);
      } // otherwise, we may be getting a new stream all together
      else {
          this.addPrimaryStream(stream, store);
        }
    }
  }, {
    key: "onTrackRemoved",
    value: function onTrackRemoved(stream, store, track) {
      if (track.track.id.toLowerCase() === c.PRESENTATION_LABEL) {
        this.removePresentation();
        return;
      } // otherwise, check if the track being removed is a part of the current primary stream,
      // if so simply reattach
      // TODO: refactor:
      // Which of these checks do we need. Do we even want to handle this event?


      if (this.primaryStream && stream && this.primaryStream.id === stream.id && stream.active) {
        this.primaryStreamHolder.detachElements();
        this.primaryStreamHolder.updateStreamAndAttach(this.primaryStream, store);
      }
    }
  }, {
    key: "displayPresentation",
    value: function displayPresentation(isGalaxy, store) {
      // CNUC-1102 - In galaxy when we switch presentation source, it causes a flicker
      // because the presentation is already active and we try to re-attach the stream
      // to element. Just to avoid that we have a new state. In the video element we
      // did have a similar flag earlier which we don't use anymore to deal with a chrome
      // issue on mac.
      if (isGalaxy && this.presentationActive) {
        return;
      }

      if (this.presentationStream) {
        this.presentationStreamHolder.updateStreamAndAttach(this.presentationStream, store);
        store.dispatch({
          type: c.REMOTE_PRESENTATION_STREAM_AVAILABLE,
          payload: this.presentationStream
        });
      }

      this.presentationActive = true;
    }
  }, {
    key: "handleRemoveStream",
    value: function handleRemoveStream(store, evt) {
      var _this2 = this;

      // Its either the nucleus tweaked video or presentation streams. We need to convert this
      // as track removal action
      if ((0, _safeAccess.default)(evt, 'stream.id') === c.NUCLEUS_VIDEO_STREAM_LABEL) {
        this.primaryStreamHolder.detachElements();
        this.primaryStream.getVideoTracks().forEach(function (track) {
          if (track.id === c.VIDEO_LABEL) {
            // Wrap the track object like how its done in onaddtrack and onremovetrack callbacks
            _this2.primaryStream.removeTrack(track);

            _this2.handleTrackUpdate(_this2.primaryStream, store, {
              track: track
            });
          }
        });
      } else {
        // Incase of presentation just detach the elements and set the stream to null
        this.presentationStreamHolder.detachElements();
        this.presentationStream = null;
        this.presentationActive = false;
      }
    }
  }]);
  return StreamReceiver;
}();

var _default = StreamReceiver;
exports.default = _default;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(CONFIG) {

var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createReduxStore;
Object.defineProperty(exports, "loadPersistentStore", {
  enumerable: true,
  get: function get() {
    return _persistence.loadPersistentStore;
  }
});

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(71));

var _typeof2 = _interopRequireDefault(__webpack_require__(98));

var _redux = __webpack_require__(128);

var _reduxThunk = _interopRequireDefault(__webpack_require__(583));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _index = _interopRequireDefault(__webpack_require__(584));

var _wampClient = __webpack_require__(665);

var _awaitAction = _interopRequireDefault(__webpack_require__(666));

var _callHistory = _interopRequireDefault(__webpack_require__(667));

var _timer = _interopRequireDefault(__webpack_require__(668));

var _logger = _interopRequireDefault(__webpack_require__(669));

var _availability = _interopRequireDefault(__webpack_require__(670));

var _galaxyCall = _interopRequireDefault(__webpack_require__(672));

var _dataChannel = _interopRequireDefault(__webpack_require__(673));

var _sagas = _interopRequireDefault(__webpack_require__(676));

var _middleware = _interopRequireDefault(__webpack_require__(678));

var storage = _interopRequireWildcard(__webpack_require__(204));

var _reduxSaga = _interopRequireDefault(__webpack_require__(293));

var _persistence = __webpack_require__(687);

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _cascadeConfig = __webpack_require__(29);

var defaultInitialState = {
  nucleus: {
    cluster: {
      url: CONFIG.clusterUrl || 'lifesizecloud.com'
    }
  }
};
/**
 * Create Redux Store
 * By default, nucleus instantiates the redux store with 'thunk' middleware.
 *
 * @module utils/createReduxStore
 * @param {Object} reducers - Object of application specific reducers OR output from combineReducers
 * @param {Array} middlewares - Appends application middlewares to nucleus middleware (thunk)
 * @param {Object} initialState - Initial state for the store to merge with the default initial state of { nucleus: { cluster: { url: 'lifesizecloud.com' } } }
 * @param {Object} persistentStore - If this exists, it is used to load previous state. This is the object that contains the store engine and the store processed middleware. This object should be generated by createPersistentStore utility function.
 * @param {Object} wampClient - If this exists, it is used in the wampClientMiddleware. Autobahnjs is currently supported.
 * @param {Object} rtcMiddleware - If this exists, it is used as the WebRTC Middleware. No WebRTC middleware is instantiated otherwise.
 * @param {Object} clientConfig - See /config/README.md. This object will be merged in and overwrite nuc's config.
 * @example
 * import { createReduxStore } from 'lifesize-sky-nucleus';
 * let reduxStore = createReduxStore();
 * @example
 * // Add application specific reducers to the redux store
 * import { createReduxStore } from 'lifesize-sky-nucleus';
 * import myAppReducers from './reducers';
 * let reduxStore = createReduxStore(myAppReducers);
 * @example
 * // Add application middleware (in addition to default 'thunk'). Middleware
 * // is always appended to the end of the array of middleware
 * import { createReduxStore } from 'lifesize-sky-nucleus';
 * import createLogger from 'redux-logger';
 * const logger = createLogger();
 * let reduxStore = createReduxStore(null, [logger]);
 * @example
 * // Point nucleus to beta cluster upon start up
 * import { createReduxStore } from 'lifesize-sky-nucleus';
 * import createLogger from 'redux-logger';
 * const logger = createLogger();
 * let reduxStore = createReduxStore(null, null, { nucleus: { cluster: { url: 'lifesizecloudbeta.com ' } } });
 * @example
 * // Point nucleus to beta cluster upon start up. Load the previous state.
 * import { createReduxStore } from 'lifesize-sky-nucleus';
 * import createLogger from 'redux-logger';
 * const logger = createLogger();
 * const engine = createEngine('my-save-key');
 * const persistentStorage = { engine: engine, blacklist: [], whitelist: [], whitelistFilter = [], blacklistFilter = [], manualLoad: false, cacheSize: 1024 * 1024 * 5 (5mb) };
 * let reduxStore = createReduxStore(null, [], { nucleus: { cluster: { url: 'lifesizecloudbeta.com ' } } }, persistentStore);
 * @example
 * // Create with WebRTC middleware
 * import { createReduxStore, createRtcMiddleware } from 'lifesize-sky-nucleus';
 * const rtcMiddleware = createRtcMiddleware(window.RTCPeerConnection, window.RTCSessionDescription, window.RTCIceCandidate);
 * let reduxStore = createReduxStore(null, [], {}, null, io, autobahnjs, rtcMiddelware);
 * @return {Object} Redux store
 */

function createReduxStore() {
  var reducers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var middlewares = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var initialState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var persistentStorage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var wampClient = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var rtcMiddleware = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var clientConfig = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};

  _jsLogger.default.useDefaults();

  (0, _cascadeConfig.setClientConfig)(clientConfig);

  _jsLogger.default.info("Nucleus version: ".concat("7.0.1"));

  _jsLogger.default.info("UserAgent: ".concat((0, _safeAccess.default)(navigator, 'userAgent')));

  if (!Array.isArray(middlewares)) {
    throw new Error('createReduxStore requires middlewares argument to be an array');
  }
  /* istanbul ignore next  */


  if (initialState && (0, _typeof2.default)(initialState) !== 'object') {
    throw new Error('createReduxStore requires initialState argument to be an object, or null');
  } // expect reducers to be null or object, both will return typeof object

  /* istanbul ignore next  */


  if ((0, _typeof2.default)(reducers) !== 'object' && typeof reducers !== 'function') {
    throw new Error('createReduxStore requires reducers argument to be an object, function, or null');
  }
  /* istanbul ignore next  */


  if (persistentStorage && (0, _typeof2.default)(persistentStorage) !== 'object') {
    throw new Error('createReduxStore requires storage argument to be an object or null');
  } // Utilize default initial state and merge in initial state from client
  // eslint-disable-next-line no-param-reassign


  initialState = Object.assign({}, defaultInitialState, initialState);
  var sagaMiddleware = (0, _reduxSaga.default)();
  var nucleusMiddleware = [sagaMiddleware, _reduxThunk.default];
  nucleusMiddleware = nucleusMiddleware.concat([(0, _wampClient.createWampClientMiddleware)(wampClient), (0, _middleware.default)(persistentStorage)]);

  if (rtcMiddleware) {
    nucleusMiddleware = nucleusMiddleware.concat([rtcMiddleware, _galaxyCall.default]);
  }

  nucleusMiddleware = nucleusMiddleware.concat([_availability.default, _awaitAction.default, _callHistory.default, _dataChannel.default, _timer.default, _logger.default]); // Append application middleware to nucleus middleware

  var allMiddleware = nucleusMiddleware.concat(middlewares); // persistence

  var _createPersistentStor = (0, _persistence.createPersistentStoreMiddleware)((0, _safeAccess.default)(persistentStorage, 'engine'), (0, _safeAccess.default)(persistentStorage, 'blacklist'), (0, _safeAccess.default)(persistentStorage, 'whitelist'), (0, _safeAccess.default)(persistentStorage, 'whitelistFilter'), (0, _safeAccess.default)(persistentStorage, 'blacklistFilter')),
      persistenceMiddleware = _createPersistentStor.persistenceMiddleware,
      persistenceEngine = _createPersistentStor.persistenceEngine;

  allMiddleware.push(persistenceMiddleware);

  var createStoreWithMiddleware = _redux.applyMiddleware.apply(void 0, (0, _toConsumableArray2.default)(allMiddleware))(_redux.createStore); // Merge the reducers into a single root reducer


  var rootReducer;

  if (reducers) {
    // if there are application specific reducers
    rootReducer = (0, _redux.combineReducers)({
      app: typeof reducers === 'function' ? reducers : (0, _redux.combineReducers)(reducers),
      nucleus: _index.default
    });
  } else {
    rootReducer = (0, _redux.combineReducers)({
      nucleus: _index.default
    });
  } // Wrap the reducers with the storage reducer if the client is persisting data.


  rootReducer = storage.reducer(rootReducer);
  var store = createStoreWithMiddleware(rootReducer, initialState, CONFIG.reduxDevtoolsEnabled && (typeof window === "undefined" ? "undefined" : (0, _typeof2.default)(window)) !== undefined ? window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__({
    maxAge: 500
  }) : undefined);
  sagaMiddleware.run(_sagas.default); // load persistent state unless client wishes to do so manually.

  if (!(0, _safeAccess.default)(persistentStorage, 'manualLoad')) {
    (0, _persistence.loadPersistentStore)(persistenceEngine)(store);
  }

  return store;
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(29)["default"]))

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if (!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["default"] = (thunk);

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = __webpack_require__(128);

var _account = _interopRequireDefault(__webpack_require__(585));

var _app = _interopRequireDefault(__webpack_require__(586));

var _auth = _interopRequireDefault(__webpack_require__(587));

var _calendar = _interopRequireDefault(__webpack_require__(588));

var _callHistory = _interopRequireDefault(__webpack_require__(589));

var _cluster = _interopRequireDefault(__webpack_require__(590));

var _conference = _interopRequireDefault(__webpack_require__(591));

var _contactCRUD = _interopRequireDefault(__webpack_require__(597));

var _contacts = _interopRequireDefault(__webpack_require__(598));

var _dataChannel = _interopRequireDefault(__webpack_require__(600));

var _dataWarehouse = _interopRequireDefault(__webpack_require__(601));

var _device = _interopRequireDefault(__webpack_require__(602));

var _directory = _interopRequireDefault(__webpack_require__(603));

var _doNotDisturb = _interopRequireDefault(__webpack_require__(604));

var _endpoint = _interopRequireDefault(__webpack_require__(605));

var _featureFlags = _interopRequireDefault(__webpack_require__(606));

var _favorites = _interopRequireDefault(__webpack_require__(607));

var _galaxy = _interopRequireDefault(__webpack_require__(608));

var _gqlChat = _interopRequireDefault(__webpack_require__(620));

var _groupSettings = _interopRequireDefault(__webpack_require__(621));

var _invitation = _interopRequireDefault(__webpack_require__(623));

var _localization = _interopRequireDefault(__webpack_require__(624));

var _media = _interopRequireDefault(__webpack_require__(625));

var _meetings = _interopRequireDefault(__webpack_require__(626));

var _network = _interopRequireDefault(__webpack_require__(627));

var _pairedDevices = _interopRequireDefault(__webpack_require__(628));

var _persistence = _interopRequireDefault(__webpack_require__(629));

var _phoneHD = _interopRequireDefault(__webpack_require__(637));

var _provisioning = _interopRequireDefault(__webpack_require__(638));

var _proxy = _interopRequireDefault(__webpack_require__(639));

var _pstnNumbers = _interopRequireDefault(__webpack_require__(640));

var _recordings = _interopRequireDefault(__webpack_require__(641));

var _services = _interopRequireDefault(__webpack_require__(656));

var _sso = _interopRequireDefault(__webpack_require__(657));

var _timer = _interopRequireDefault(__webpack_require__(658));

var _token = _interopRequireDefault(__webpack_require__(659));

var _userProfile = _interopRequireDefault(__webpack_require__(660));

var _userSettings = _interopRequireDefault(__webpack_require__(663));

var _users = _interopRequireDefault(__webpack_require__(664));

var _default = (0, _redux.combineReducers)({
  account: _account.default,
  app: _app.default,
  auth: _auth.default,
  calendar: _calendar.default,
  callHistory: _callHistory.default,
  cluster: _cluster.default,
  conference: _conference.default,
  contactCRUD: _contactCRUD.default,
  contacts: _contacts.default,
  dataChannel: _dataChannel.default,
  dataWarehouse: _dataWarehouse.default,
  device: _device.default,
  directory: _directory.default,
  doNotDisturb: _doNotDisturb.default,
  endpoint: _endpoint.default,
  featureFlags: _featureFlags.default,
  favorites: _favorites.default,
  galaxy: _galaxy.default,
  gqlChat: _gqlChat.default,
  groupSettings: _groupSettings.default,
  invitation: _invitation.default,
  localization: _localization.default,
  media: _media.default,
  meetings: _meetings.default,
  network: _network.default,
  pairedDevices: _pairedDevices.default,
  persistence: _persistence.default,
  phoneHD: _phoneHD.default,
  provisioning: _provisioning.default,
  proxy: _proxy.default,
  pstnNumbers: _pstnNumbers.default,
  recordings: _recordings.default,
  services: _services.default,
  sso: _sso.default,
  timer: _timer.default,
  token: _token.default,
  userProfile: _userProfile.default,
  userSettings: _userSettings.default,
  users: _users.default
});

exports.default = _default;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _get = _interopRequireDefault(__webpack_require__(11));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

/** @module state/nucleus/account */

/**
 * @constant {Object}
 * @description Initial state
 * @default
 */
var initialState = {
  features: {
    recording: false
  }
};
/* notes:
 * - the use of account.features.unlimitedVMR with account.features.purchasedMeetingRooms is deprecated;
 *   account.features.purchasedMeetingRooms does not even exist in the api return or the db;
 *   use groupSettings.maxMeetings instead
 */

/**
 * Stores account feature related data, populated via nucleus proxy calls.
 * @example
 * store
 *   +-- nucleus
 *     +-- account
 *       +-- features
 *         +-- recording: false
 * @example
 * store
 * +-- nucleus
 *     +-- account
 *       +-- features
 *         +-- recording: false
 */

exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.GET_SESSION_SUCCESS, function (state, action) {
  var account = (0, _get.default)(action, 'payload.account') || {};
  return (0, _objectSpread2.default)({}, state, account);
}), (0, _defineProperty2.default)(_createReducer, c.USER_INVITE_TOKEN_SUCCESS, function (state, action) {
  var token = (0, _get.default)(action, 'payload.token') || {};
  return (0, _objectSpread2.default)({}, state, {
    token: token
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

/** @module state/nucleus/app */

/**
 * @constant {Object}
 * @description Initial state
 * @default
 */
var initialState = {
  isBackgrounded: false,
  desktopChannel: null
};
/**
 * Stores 'app' related data.
 * @example
 * store
 *   +-- nucleus
 *     +-- app
 *       +-- isBackgrounded: bool
 * @example
 * store
 * +-- nucleus
 *     +-- app
 *       +-- isBackgrounded: false
 *       +-- sipIncomingCall
 *          +-- { id: '123', canAnswer: true, canAdd: false, canEndAndAnswer: false, dialString: '123@sip.com', displayString: 'Bob' }
 *       +-- sipActiveCall
 *          +-- { id: '123', state: 'connectected', dialString: '123@sip.com', displayString: 'Bob', startTime: int, endTime: int, .. }
 */

exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.APP_FOREGROUNDED, function (state) {
  return Object.assign({}, state, {
    isBackgrounded: false
  });
}), (0, _defineProperty2.default)(_createReducer, c.APP_BACKGROUNDED, function (state) {
  return Object.assign({}, state, {
    isBackgrounded: true
  });
}), (0, _defineProperty2.default)(_createReducer, c.INIT_NUCLEUS, function (state, action) {
  var desktopChannel = action.payload.desktopChannel;
  return (0, _objectSpread2.default)({}, state, {
    desktopChannel: desktopChannel
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _createReducer;

/** @module state/nucleus/auth */

/**
 * @constant {Object}
 * @description Initial state
 * @default
 */
var initialState = {
  isAuthenticating: false,
  isAuthenticated: false,
  error: null,
  platform: 'WEB',
  isChatSupported: true,
  // Could become configurable later. For especially
  version: '1.0.0.0'
};
/**
 * Stores 'auth' related data.
 * @example
 * store
 *   +-- nucleus
 *     +-- auth
 *       |-- isAuthenticating: bool
 *       |-- isAuthenticated: bool
 *       +-- error: null
 * @example
 * store
 * +-- nucleus
 *     +-- auth
 *       |-- isAuthenticating: false
 *       |-- isAuthenticated: true
 *       +-- error: null
 */

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.AUTH_LOGOUT, function (state) {
  // don't clear error, version, or platform on logout,
  // since we now logout after a login failure
  // and version and platform are init settings
  var error = state.error,
      version = state.version,
      platform = state.platform;
  return Object.assign({}, initialState, {
    error: error,
    version: version,
    platform: platform
  });
}), (0, _defineProperty2.default)(_createReducer, c.GET_ACCOUNT_FEATURE_FLAGS_FAILURE, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    error: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.INIT_NUCLEUS, function (state, action) {
  // some clients pass in a version with a postfix '-' + build number which currently
  // causes CSS to choke.  the get call below strips off that -build number portion before
  // putting it in the state
  var nextState = (0, _objectSpread2.default)({}, state, {
    platform: (0, _safeAccess.default)(action, 'payload.platform') || state.platform,
    version: (0, _safeAccess.default)(action, 'payload.version') || state.version
  });
  return nextState;
}), _createReducer));

exports.default = _default;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

/** @module state/nucleus/calendar */

/**
 * @constant {Object}
 * @description Initial state
 * @default
 */
var initialState = {
  enabled: false,
  events: []
};
/**
 * Stores directory service related data.
 */

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.AUTH_LOGOUT, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.INIT_NUCLEUS, function (state, action) {
  var nextState = Object.assign({}, state);

  if (Object.hasOwnProperty.call(action.payload, 'calendarEnabled')) {
    nextState.enabled = !!action.payload.calendarEnabled;
  }

  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.WAMP_SUBSCRIPTION_ACTION_CALENDAR_TOPIC, function (state, action) {
  return Object.assign({}, state, {
    events: action.payload
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

/** @module state/nucleus/callHistory */
var initialState = {
  isFetching: false,
  recordsRevision: 0,
  batchDeleteInProgress: false,
  records: [],
  lastViewed: null,
  error: null,
  callHistoryEnabled: true
};
/**
 * Stores 'contact' related data.
 * @example
 * store
 *   +-- nucleus
 *     +-- callHistory
 *       |-- isFetching: bool
 *       |-- recordsRevision: int
 *       |-- error: null or mix
 *       |-- lastViewed: date
 *       +-- records
 *         +-- id: record
 * @example
 * store
 * +-- nucleus
 *     +- callHistory
 *           |-- isFetching: false
 *           |-- recordsRevision: 3
 *           |-- error: null
 *           |-- lastViewed:
 *           +-- records
 *                |-- 1234: { id: 1234, name: 'test meeting' }
 *                |-- 1237: { id: 1237, name: 'another meeting' }
 *                +-- 37: { id: 37, name: 'John Doe' }
 */

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.INIT_NUCLEUS, function (state, action) {
  var nextState = (0, _objectSpread2.default)({}, state);

  if (Object.hasOwnProperty.call(action.payload, 'callHistoryEnabled')) {
    nextState.callHistoryEnabled = !!action.payload.callHistoryEnabled;
  }

  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.AUTH_LOGOUT, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.CALLHISTORY_LOAD_BEGIN, function (state) {
  return Object.assign({}, state, {
    isFetching: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.CALLHISTORY_LOAD_SUCCESS, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.isFetching = false;
  nextState.records = action.payload;
  nextState.recordsRevision++;
  nextState.error = null;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.CALLHISTORY_LOAD_FAILURE, function (state, action) {
  return Object.assign({}, state, {
    isFetching: false,
    error: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.CALLHISTORY_DELETE_BEGIN, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.isFetching = true;
  nextState.records = state.records.filter(function (r) {
    return r.id !== action.payload;
  });

  if (!nextState.batchDeleteInProgress) {
    nextState.recordsRevision++;
  }

  nextState.error = null;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.CALLHISTORY_DELETE_SUCCESS, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.isFetching = false;
  nextState.records = state.records.filter(function (r) {
    return r.id !== action.payload;
  });

  if (!nextState.batchDeleteInProgress) {
    nextState.recordsRevision++;
  }

  nextState.error = null;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.CALLHISTORY_DELETE_FAILURE, function (state, action) {
  return Object.assign({}, state, {
    isFetching: false,
    error: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.CALLHISTORY_DELETEALL_BEGIN, function (state) {
  var nextState = Object.assign({}, state);
  nextState.isFetching = true;
  nextState.records = [];
  nextState.recordsRevision++;
  nextState.error = null;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.CALLHISTORY_DELETEALL_SUCCESS, function (state) {
  var nextState = Object.assign({}, state);
  nextState.isFetching = false;
  nextState.records = [];
  nextState.recordsRevision++;
  nextState.error = null;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.CALLHISTORY_DELETEALL_FAILURE, function (state, action) {
  return Object.assign({}, state, {
    isFetching: false,
    error: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.SERVER_PUSH_ADD_CALLHISTORY, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.records.push(action.payload.record);
  nextState.recordsRevision++;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.SERVER_PUSH_DELETE_CALLHISTORY, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.records = state.records.filter(function (r) {
    return r.id !== action.payload.record.id;
  });

  if (!nextState.batchDeleteInProgress) {
    nextState.recordsRevision++;
  }

  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.CALL_HISTORY_VIEWED, function (state) {
  return Object.assign({}, state, {
    lastViewed: Date.now()
  });
}), (0, _defineProperty2.default)(_createReducer, c.CALL_HISTORY_BATCH_DELETE_BEGIN, function (state) {
  var nextState = Object.assign({}, state);
  nextState.batchDeleteInProgress = true;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.CALL_HISTORY_BATCH_DELETE_SUCCESS, function (state) {
  var nextState = Object.assign({}, state);
  nextState.batchDeleteInProgress = false;
  nextState.recordsRevision++;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.CALL_HISTORY_BATCH_DELETE_FAILED, function (state) {
  var nextState = Object.assign({}, state);
  nextState.batchDeleteInProgress = false;
  nextState.recordsRevision++;
  return nextState;
}), _createReducer));

exports.default = _default;

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

/** @module state/nucleus/cluster */
var initialState = {};
/**
 * Stores 'cluster' related data.
 * @example
 * store
 *   +-- nucleus
 *     +-- cluster
 *       |-- url
 * @example
 * store
 * +-- nucleus
 *     +-- cluster
 *       |-- url: 'lifesizecloudbeta.com',
 */

var _default = (0, _reduxUtils.createReducer)(initialState, (0, _defineProperty2.default)({}, c.INIT_NUCLEUS, function (state, action) {
  if (action.payload.environment) {
    var nextState = Object.assign({}, state);

    if (action.payload.environment) {
      nextState.url = action.payload.environment;
    }

    return nextState;
  }

  return state;
}));

exports.default = _default;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = __webpack_require__(128);

var _info = _interopRequireDefault(__webpack_require__(592));

var _moderators = _interopRequireDefault(__webpack_require__(593));

var _participants = _interopRequireDefault(__webpack_require__(594));

var _remoteModeration = _interopRequireDefault(__webpack_require__(595));

var _remoteModerators = _interopRequireDefault(__webpack_require__(596));

var conferenceReducer = (0, _redux.combineReducers)({
  info: _info.default,
  moderators: _moderators.default,
  participants: _participants.default,
  remoteModeration: _remoteModeration.default,
  remoteModerators: _remoteModerators.default
});
var _default = conferenceReducer;
exports.default = _default;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _get = _interopRequireDefault(__webpack_require__(11));

var C = _interopRequireWildcard(__webpack_require__(3));

var _moderator = __webpack_require__(192);

var _remoteModerator = __webpack_require__(85);

var _reduxUtils = __webpack_require__(13);

var _createReducer;

var initialState = {
  id: null,
  displayName: null,
  isLocked: false,
  // Tracks state of lock/unlock commands sent to conference manager
  isProcessingLock: false,
  isProcessingHandCommand: false,
  ownerUuid: null,
  lecturerUuid: null,
  serverMuteState: false,
  state: null,
  type: null
};
var infoReducer = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_REPLACE_CALL, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_CONFERENCE_JOINED, handleConferenceUpdate), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_CONFERENCE_ESCALATED, handleConferenceUpdate), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_END, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_FAILED, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_CONFERENCE_MUTED, handleMuteStateChanged), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_CONFERENCE_UNMUTED, handleMuteStateChanged), (0, _defineProperty2.default)(_createReducer, _remoteModerator.REMOTE_MOD_JOIN_REQUEST, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, _remoteModerator.REMOTE_MOD_JOIN_SUCCESS, handleRemoteModJoinSuccess), (0, _defineProperty2.default)(_createReducer, _remoteModerator.REMOTE_MOD_JOIN_FAILURE, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, _remoteModerator.REMOTE_MOD_LEAVE_REQUEST, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_CONFERENCE_LOCKED, handleConferenceLocked), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_CONFERENCE_UNLOCKED, handleConferenceUnlocked), (0, _defineProperty2.default)(_createReducer, _moderator.LOCK_CONFERENCE_REQUEST, handleLockCommandRequest), (0, _defineProperty2.default)(_createReducer, _moderator.LOCK_CONFERENCE_SUCCESS, handleLockCommandResponse), (0, _defineProperty2.default)(_createReducer, _moderator.LOCK_CONFERENCE_FAILURE, handleLockCommandResponse), (0, _defineProperty2.default)(_createReducer, _moderator.UNLOCK_CONFERENCE_REQUEST, handleLockCommandRequest), (0, _defineProperty2.default)(_createReducer, _moderator.UNLOCK_CONFERENCE_SUCCESS, handleLockCommandResponse), (0, _defineProperty2.default)(_createReducer, _moderator.UNLOCK_CONFERENCE_FAILURE, handleLockCommandResponse), (0, _defineProperty2.default)(_createReducer, C.SELF_RAISE_HAND_REQUEST, handleHandRequest), (0, _defineProperty2.default)(_createReducer, C.SELF_RAISE_HAND_FAILURE, handleHandResponse), (0, _defineProperty2.default)(_createReducer, C.SELF_RAISE_HAND_SUCCESS, handleHandResponse), (0, _defineProperty2.default)(_createReducer, C.SELF_LOWER_HAND_REQUEST, handleHandRequest), (0, _defineProperty2.default)(_createReducer, C.SELF_LOWER_HAND_FAILURE, handleHandResponse), (0, _defineProperty2.default)(_createReducer, C.SELF_LOWER_HAND_SUCCESS, handleHandResponse), _createReducer));
var _default = infoReducer;
exports.default = _default;

function handleHandRequest(prevState) {
  return (0, _objectSpread2.default)({}, prevState, {
    isProcessingHandCommand: true
  });
}

function handleHandResponse(prevState) {
  return (0, _objectSpread2.default)({}, prevState, {
    isProcessingHandCommand: false
  });
}

function handleConferenceUpdate(prevState, action) {
  return (0, _objectSpread2.default)({}, prevState, {
    id: (0, _get.default)(action, 'payload.conferenceId'),
    displayName: (0, _get.default)(action, 'payload.conferenceState.displayName'),
    isLocked: (0, _get.default)(action, 'payload.conferenceState.isLocked', false),
    ownerUuid: (0, _get.default)(action, 'payload.conferenceState.owner'),
    lecturerUuid: (0, _get.default)(action, 'payload.conferenceState.lecturer'),
    serverMuteState: (0, _get.default)(action, 'payload.conferenceState.serverMuteState', false),
    state: (0, _get.default)(action, 'payload.conferenceState.state'),
    type: (0, _get.default)(action, 'payload.conferenceState.type')
  });
}

function handleMuteStateChanged(prevState, action) {
  return (0, _objectSpread2.default)({}, prevState, {
    serverMuteState: (0, _get.default)(action, 'payload.conferenceState.serverMuteState', false)
  });
}

function handleRemoteModJoinSuccess(prevState, action) {
  return (0, _objectSpread2.default)({}, prevState, {
    id: (0, _get.default)(action, 'payload.conferenceId')
  });
}

function handleConferenceLocked(prevState) {
  return (0, _objectSpread2.default)({}, prevState, {
    isLocked: true
  });
}

function handleConferenceUnlocked(prevState) {
  return (0, _objectSpread2.default)({}, prevState, {
    isLocked: false
  });
}

function handleLockCommandRequest(prevState) {
  return (0, _objectSpread2.default)({}, prevState, {
    isProcessingLock: true
  });
}

function handleLockCommandResponse(prevState) {
  return (0, _objectSpread2.default)({}, prevState, {
    isProcessingLock: false
  });
}

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _get = _interopRequireDefault(__webpack_require__(11));

var C = _interopRequireWildcard(__webpack_require__(3));

var _reduxUtils = __webpack_require__(13);

var _remoteModerator = __webpack_require__(85);

var _createReducer;

var initialState = new Map();
exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_REPLACE_CALL, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_CONFERENCE_JOINED, handleConferenceUpdate), (0, _defineProperty2.default)(_createReducer, C.MODERATOR_JOINED, handleConferenceUpdate), (0, _defineProperty2.default)(_createReducer, C.MODERATOR_LEFT, handleConferenceUpdate), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_END, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_FAILED, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, _remoteModerator.REMOTE_MOD_LEAVE_REQUEST, function () {
  return initialState;
}), _createReducer));

exports.default = _default;

function handleConferenceUpdate(prevState, action) {
  var nextState = new Map();
  var moderators = (0, _get.default)(action, 'payload.conferenceState.moderators', []);
  Array.prototype.forEach.call(moderators, function (mod) {
    var uuid = (0, _get.default)(mod, 'uuid');
    nextState.set(uuid, mod);
  });
  return nextState;
}

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleLowerAllRaisedHands = handleLowerAllRaisedHands;
exports.default = exports.initialState = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(71));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _get = _interopRequireDefault(__webpack_require__(11));

var C = _interopRequireWildcard(__webpack_require__(3));

var _reduxUtils = __webpack_require__(13);

var _remoteModerator = __webpack_require__(85);

var _createReducer;

var initialState = new Map();
exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_REPLACE_CALL, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_CONFERENCE_JOINED, handleParticipantUpdate), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_END, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_FAILED, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_FIRST_PARTICIPANT_READY_IN_IVR, handleParticipantUpdate), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_PARTICIPANT_JOINED, handleParticipantUpdate), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_PARTICIPANT_LOCAL_MUTED, handleParticipantUpdate), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_PARTICIPANT_LOCAL_UNMUTED, handleParticipantUpdate), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_PARTICIPANT_LOCAL_VIDEO_MUTED, handleParticipantUpdate), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_PARTICIPANT_LOCAL_VIDEO_UNMUTED, handleParticipantUpdate), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_PARTICIPANT_MUTED, handleParticipantUpdate), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_PARTICIPANT_UNMUTED, handleParticipantUpdate), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_PRESENTATION_FLOOR_GRANTED, handleParticipantUpdate), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_PRESENTATION_FLOOR_RELEASED, handleParticipantUpdate), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_PARTICIPANT_LEFT, handleParticipantLeft), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_CONFERENCE_MUTED, handleConferenceMuted), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_CONFERENCE_UNMUTED, handleConferenceUnmuted), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_CONFERENCE_PARTICIPANT_HAND_RAISED, handleParticipantUpdate), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_CONFERENCE_PARTICIPANT_HAND_LOWERED, handleParticipantUpdate), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_CONFERENCE_ALL_HANDS_LOWERED, handleLowerAllRaisedHands), (0, _defineProperty2.default)(_createReducer, C.LOWER_HAND_REQUEST, handleHandRequest), (0, _defineProperty2.default)(_createReducer, C.LOWER_HAND_FAILURE, handleHandResponse), (0, _defineProperty2.default)(_createReducer, C.LOWER_HAND_SUCCESS, handleHandResponse), (0, _defineProperty2.default)(_createReducer, _remoteModerator.REMOTE_MOD_LEAVE_REQUEST, function () {
  return initialState;
}), _createReducer));

exports.default = _default;

function handleParticipantUpdate(prevState, action) {
  var nextState = new Map((0, _toConsumableArray2.default)(prevState));
  var participants = (0, _get.default)(action, 'payload.participants') || [(0, _get.default)(action, 'payload.participant')];
  Array.prototype.forEach.call(participants, function (p) {
    var participantId = (0, _get.default)(p, 'participantId'); // Preserve moderator processing status

    var processingInfo = getProcessingInfo(prevState.get(participantId));
    nextState.set(participantId, (0, _objectSpread2.default)({}, p, getHandRaisedInfo(p), processingInfo));
  });
  return nextState;
}

function getHandRaisedInfo(participant) {
  if (!participant) return;
  var handRaisedTimestamp = (0, _get.default)(participant, 'handRaised');
  return {
    handRaised: !!handRaisedTimestamp,
    handRaisedTimestamp: handRaisedTimestamp
  };
}

function getProcessingInfo(participant) {
  if (!participant) return {
    processingModeratorHandCommand: false
  };
  var prevProcessingStatus = (0, _get.default)(participant, 'processingModeratorHandCommand');
  return {
    processingModeratorHandCommand: prevProcessingStatus
  };
}

function handleHandRequest(prevState, action) {
  var nextState = new Map((0, _toConsumableArray2.default)(prevState));
  var participantId = (0, _get.default)(action, 'payload.participantId');
  var prevParticipant = prevState.get(participantId);
  nextState.set(participantId, (0, _objectSpread2.default)({}, prevParticipant, {
    processingModeratorHandCommand: true
  }));
  return nextState;
}

function handleHandResponse(prevState, action) {
  var participantId = (0, _get.default)(action, 'payload.participantId');
  var prevParticipant = prevState.get(participantId); // If participant left, don't try to set anything

  if (!prevParticipant) {
    return prevState;
  }

  var nextState = new Map((0, _toConsumableArray2.default)(prevState));
  nextState.set(participantId, (0, _objectSpread2.default)({}, prevParticipant, {
    processingModeratorHandCommand: false
  }));
  return nextState;
} // FYI: triggered by a moderator action, not a participant action,
// but all participants will call this when the noticiation is received.


function handleLowerAllRaisedHands(prevState) {
  var nextState = new Map();
  prevState.forEach(function (participant, participantId) {
    nextState.set(participantId, (0, _objectSpread2.default)({}, participant, {
      handRaised: false,
      handRaisedTimestamp: 0
    }));
  });
  return nextState;
}

function handleParticipantLeft(prevState, action) {
  var nextState = new Map((0, _toConsumableArray2.default)(prevState));
  var participantId = (0, _get.default)(action, 'payload.participant.participantId');
  nextState.delete(participantId);
  return nextState;
}

function handleConferenceMuted(prevState, action) {
  var nextState = new Map();
  var initiatedBy = (0, _get.default)(action.payload, 'initiatedBy.uuid');
  prevState.forEach(function (participant, participantId) {
    // everyone is server muted except for the mute initiator
    var uuid = (0, _get.default)(participant, 'uuid');
    var serverMuteState = initiatedBy !== uuid ? true : false;
    nextState.set(participantId, (0, _objectSpread2.default)({}, participant, {
      serverMuteState: serverMuteState
    }));
  });
  return nextState;
}

function handleConferenceUnmuted(prevState) {
  var nextState = new Map();
  prevState.forEach(function (participant, participantId) {
    nextState.set(participantId, (0, _objectSpread2.default)({}, participant, {
      serverMuteState: false
    }));
  });
  return nextState;
}

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _get = _interopRequireDefault(__webpack_require__(11));

var _reduxUtils = __webpack_require__(13);

var C = _interopRequireWildcard(__webpack_require__(3));

var _remoteModerator = __webpack_require__(85);

var _createReducer;

var initialState = {
  extension: null,
  isActive: false,
  revoked: false
};

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_END, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, _remoteModerator.REMOTE_MOD_CLEAR_SESSION, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, _remoteModerator.REMOTE_MOD_JOIN_REQUEST, handleRemoteModJoinRequest), (0, _defineProperty2.default)(_createReducer, _remoteModerator.REMOTE_MOD_JOIN_SUCCESS, handleRemoteModJoinSuccess), (0, _defineProperty2.default)(_createReducer, _remoteModerator.REMOTE_MOD_JOIN_FAILURE, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, _remoteModerator.REMOTE_MOD_LEAVE_REQUEST, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, _remoteModerator.REMOTE_MOD_REVOKED, handleRevoked), _createReducer));

exports.default = _default;

function handleRemoteModJoinRequest(_, action) {
  return (0, _objectSpread2.default)({}, initialState, {
    extension: (0, _get.default)(action, 'payload.extension')
  });
}

function handleRemoteModJoinSuccess(prevState) {
  return (0, _objectSpread2.default)({}, prevState, {
    isActive: true
  });
}

function handleRevoked(prevState) {
  return (0, _objectSpread2.default)({}, prevState, {
    isActive: false,
    revoked: true
  });
}

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _get = _interopRequireDefault(__webpack_require__(11));

var C = _interopRequireWildcard(__webpack_require__(3));

var _reduxUtils = __webpack_require__(13);

var _remoteModerator = __webpack_require__(85);

var _createReducer;

var initialState = new Map();
exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_REPLACE_CALL, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_CONFERENCE_JOINED, handleConferenceUpdate), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_REMOTE_MODERATOR_JOINED, handleConferenceUpdate), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_REMOTE_MODERATOR_LEFT, handleConferenceUpdate), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_END, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, C.GALAXY_ACTION_FAILED, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, _remoteModerator.REMOTE_MOD_LEAVE_REQUEST, function () {
  return initialState;
}), _createReducer));

exports.default = _default;

function handleConferenceUpdate(prevState, action) {
  var nextState = new Map();
  var remoteModerators = (0, _get.default)(action, 'payload.conferenceState.remoteModerators', []);
  Array.prototype.forEach.call(remoteModerators, function (remoteMod) {
    var uuid = (0, _get.default)(remoteMod, 'uuid');
    nextState.set(uuid, remoteMod);
  });
  return nextState;
}

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

/** @module state/nucleus/contactCRUD */
var initialState = {
  isSaving: false,
  isSaved: false,
  errors: null,
  validationErrors: null,
  contactType: null
};
/**
 * Stores data related to saving and updating Contacts
 * @example
 * store
 *   +-- nucleus
 *     +-- contactCRUD
 *       +-- isSaving: boolean
 *       +-- validationErrors: object
 *       +-- errors: object
 */

exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.AUTH_LOGOUT, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.SAVE_CONTACT_BEGIN, function (state) {
  var nextState = Object.assign({}, state);
  nextState.isSaving = true;
  nextState.isSaved = false;
  nextState.errors = null;
  nextState.validationErrors = null;
  nextState.contactType = null;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.SAVE_CONTACT_SUCCESS, function (state) {
  var nextState = Object.assign({}, state);
  nextState.isSaving = false;
  nextState.isSaved = true;
  nextState.errors = null;
  nextState.validationErrors = null;
  nextState.contactType = null;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.SAVE_CONTACT_ERROR, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.isSaving = false;
  nextState.isSaved = false;
  nextState.errors = action.payload;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.VALIDATE_CONTACT_SUCCESS, function (state) {
  var nextState = Object.assign({}, state);
  nextState.validationErrors = null;
  nextState.contactType = null;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.VALIDATE_CONTACT_ERROR, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.isSaving = false;
  nextState.isSaved = false;
  nextState.contactType = action.payload.contactType;
  nextState.validationErrors = action.payload.errors;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.RESET_CONTACT_ERROR_STATE, function (state) {
  var nextState = Object.assign({}, state);
  nextState.isSaving = false;
  nextState.validationErrors = null;
  nextState.errors = null;
  return nextState;
}), _createReducer));

exports.default = _default;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _contactUtils = __webpack_require__(144);

var _localeUtils = __webpack_require__(187);

var _uniqBy = _interopRequireDefault(__webpack_require__(599));

var _createReducer;

function contactsSort(contacts, sortFavoritesFirst) {
  return sortFavoritesFirst ? (0, _contactUtils.favoritesFirstLocaleSort)(contacts) : (0, _localeUtils.localeSort)(contacts);
}
/** @module state/nucleus/contacts */


var initialState = {
  errorFetching: false,
  loadingAll: false,
  contactsLoaded: false,
  isFetching: false,
  recordsRevision: 0,
  inCallStatusRevision: 0,
  records: [],
  sortFavoritesFirst: true,
  loadContactsOnLogin: true,
  loadContactsPageSize: c.CONTACTS_DEFAULT_PAGE_SIZE,
  tempRecords: [],
  pagedLoads: {}
};
/**
 * Stores 'contact' related data.
 * @example
 * store
 *   +-- nucleus
 *     +-- contacts
 *       |-- recordsRevision: int
 *       +-- records
 *         +-- id: record
 * @example
 * store
 * +-- nucleus
 *     +- contacts
 *           |-- recordsRevision: 2
 *           +-- records
 *                |-- 1234: { id: 1234, name: 'test meeting' }
 *                |-- 1237: { id: 1237, name: 'another meeting' }
 *                +-- 37: { id: 37, name: 'John Doe' }
 */

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.AUTH_LOGOUT, function (state) {
  return Object.assign({}, initialState, {
    loadContactsPageSize: state.loadContactsPageSize,
    sortFavoritesFirst: state.sortFavoritesFirst
  });
}), (0, _defineProperty2.default)(_createReducer, c.INIT_NUCLEUS, function (state, action) {
  var nextState = Object.assign({}, state);

  if (Object.hasOwnProperty.call(action.payload, 'sortFavoritesFirst')) {
    nextState.sortFavoritesFirst = !!action.payload.sortFavoritesFirst;
  }

  if (Object.hasOwnProperty.call(action.payload, 'loadContactsOnLogin')) {
    nextState.loadContactsOnLogin = !!action.payload.loadContactsOnLogin;
  }

  if (Object.hasOwnProperty.call(action.payload, 'loadContactsPageSize')) {
    nextState.loadContactsPageSize = action.payload.loadContactsPageSize;
  }

  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.CONTACTS_FETCH_NEXT_BEGIN, function (state, action) {
  var filterKey = action.payload.filterKey;
  var pagedLoads = (0, _objectSpread2.default)({}, state.pagedLoads);
  pagedLoads[filterKey] = (0, _objectSpread2.default)({}, pagedLoads[filterKey], {
    isFetching: true
  });
  return (0, _objectSpread2.default)({}, state, {
    pagedLoads: pagedLoads,
    recordsRevision: state.recordsRevision + 1
  });
}), (0, _defineProperty2.default)(_createReducer, c.CONTACTS_FETCH_NEXT_FAILED, function (state, action) {
  var filterKey = action.payload.filterKey;
  var pagedLoads = (0, _objectSpread2.default)({}, state.pagedLoads);
  pagedLoads[filterKey] = (0, _objectSpread2.default)({}, pagedLoads[filterKey], {
    isFetching: false
  });
  return (0, _objectSpread2.default)({}, state, {
    pagedLoads: pagedLoads,
    recordsRevision: state.recordsRevision + 1
  });
}), (0, _defineProperty2.default)(_createReducer, c.CONTACTS_FETCH_NEXT_RESULT, function (state, action) {
  var records = contactsSort((0, _uniqBy.default)((action.payload.records || []).concat(state.records), 'uuid'), state.sortFavoritesFirst);
  var _action$payload = action.payload,
      done = _action$payload.done,
      filterKey = _action$payload.filterKey,
      cursor = _action$payload.cursor;
  var pagedLoads = (0, _objectSpread2.default)({}, state.pagedLoads);
  pagedLoads[filterKey] = {
    done: done,
    cursor: cursor,
    isFetching: false
  };
  return (0, _objectSpread2.default)({}, state, {
    records: records,
    pagedLoads: pagedLoads,
    recordsRevision: state.recordsRevision + 1
  });
}), (0, _defineProperty2.default)(_createReducer, c.GET_FAVORITES_SUCCESS, function (state, action) {
  var favorites = (0, _safeAccess.default)(action, 'payload') || [];
  var records = state.records.map(function (c) {
    if (favorites.find(function (f) {
      return f.favoriteUUID === c.uuid;
    })) {
      return (0, _objectSpread2.default)({}, c, {
        favorite: true
      });
    }

    return (0, _objectSpread2.default)({}, c, {
      favorite: false
    });
  });
  return (0, _objectSpread2.default)({}, state, {
    recordsRevision: state.recordsRevision + 1,
    records: contactsSort(records, state.sortFavoritesFirst)
  });
}), (0, _defineProperty2.default)(_createReducer, c.ADD_FAVORITES_BEGIN, function (state, action) {
  // optimistically add favorite if contact already exists
  var contactId = (0, _safeAccess.default)(action, 'payload.favoriteUUID');
  var existingContact = state.records.find(function (c) {
    return c.uuid === contactId;
  });
  if (!existingContact) return state;
  var updatedContact = (0, _objectSpread2.default)({}, existingContact, {
    favorite: true
  });
  var records = state.records.filter(function (c) {
    return c.uuid !== contactId;
  }).concat([updatedContact]);
  return (0, _objectSpread2.default)({}, state, {
    recordsRevision: state.recordsRevision + 1,
    records: contactsSort(records, state.sortFavoritesFirst)
  });
}), (0, _defineProperty2.default)(_createReducer, c.ADD_FAVORITES_FAILURE, function (state, action) {
  // undo optimistically add favorite
  var contactId = (0, _safeAccess.default)(action, 'payload.params.favoriteUUID');
  var updatedContact = Object.assign({}, {
    uuid: contactId
  }, state.records.find(function (c) {
    return c.uuid === contactId;
  }), {
    favorite: false
  });
  var records = state.records.filter(function (c) {
    return c.uuid !== contactId;
  }).concat([updatedContact]);
  return (0, _objectSpread2.default)({}, state, {
    recordsRevision: state.recordsRevision + 1,
    records: contactsSort(records, state.sortFavoritesFirst)
  });
}), (0, _defineProperty2.default)(_createReducer, c.DELETE_FAVORITES_BEGIN, function (state, action) {
  // optimistically delete favorite
  var contactId = (0, _safeAccess.default)(action, 'payload.favoriteUUID');
  var updatedContact = Object.assign({}, {
    uuid: contactId
  }, state.records.find(function (c) {
    return c.uuid === contactId;
  }), {
    favorite: false
  });
  var records = state.records.filter(function (c) {
    return c.uuid !== contactId;
  }).concat([updatedContact]);
  return (0, _objectSpread2.default)({}, state, {
    recordsRevision: state.recordsRevision + 1,
    records: contactsSort(records, state.sortFavoritesFirst)
  });
}), (0, _defineProperty2.default)(_createReducer, c.DELETE_FAVORITES_FAILURE, function (state, action) {
  // undo optimistically delete favorite
  var contactId = (0, _safeAccess.default)(action, 'payload.params.favoriteUUID');
  var updatedContact = Object.assign({}, {
    uuid: contactId
  }, state.records.find(function (c) {
    return c.uuid === contactId;
  }), {
    favorite: true
  });
  var records = state.records.filter(function (c) {
    return c.uuid !== contactId;
  }).concat([updatedContact]);
  return (0, _objectSpread2.default)({}, state, {
    recordsRevision: state.recordsRevision + 1,
    records: contactsSort(records, state.sortFavoritesFirst)
  });
}), (0, _defineProperty2.default)(_createReducer, c.CONTACTS_FETCH_PAGINATED_REQUEST, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    errorFetching: false,
    isFetching: true,
    loadingAll: true
  });
}), (0, _defineProperty2.default)(_createReducer, c.CONTACTS_FETCH_PAGINATED_SUCCESS, function (state) {
  var records = contactsSort(state.tempRecords, state.sortFavoritesFirst);
  return (0, _objectSpread2.default)({}, state, {
    contactsLoaded: true,
    errorFetching: false,
    isFetching: false,
    loadingAll: false,
    records: records,
    recordsRevision: state.recordsRevision + 1,
    // once the records are fully loaded, the tempRecords array is cleared
    tempRecords: []
  });
}), (0, _defineProperty2.default)(_createReducer, c.CONTACTS_FETCH_PAGINATED_FAILURE, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    errorFetching: true,
    isFetching: false,
    loadingAll: false
  });
}), (0, _defineProperty2.default)(_createReducer, c.CONTACTS_PAGE_FETCHED, function (state, action) {
  // the records from each page are appended to the end of the tempRecords array
  var tempRecords = state.tempRecords.concat(action.payload.records);
  var cacheLoaded = (0, _safeAccess.default)(action.payload, 'cacheLoaded'); // if a page is fetched but the cache has not loaded (because it is empty)
  // the page records are also appended to the records in the state
  // this allows client applications to see the contacts as they load
  // instead of waiting until the end of the load to display the contacts

  var records = cacheLoaded ? state.records : (0, _uniqBy.default)(state.records.concat(action.payload.records), 'uuid');
  return (0, _objectSpread2.default)({}, state, {
    records: records,
    tempRecords: tempRecords
  });
}), (0, _defineProperty2.default)(_createReducer, c.CONTACT_MANUAL_LOAD, function (state, action) {
  var contact = (0, _safeAccess.default)(action, 'payload.contact');
  if (!contact) return state;
  var uniqueRecords = (0, _uniqBy.default)([action.payload.contact].concat(state.records), 'uuid');
  var records = contactsSort(uniqueRecords, state.sortFavoritesFirst);
  return (0, _objectSpread2.default)({}, state, {
    records: records,
    recordsRevision: state.recordsRevision + 1
  });
}), (0, _defineProperty2.default)(_createReducer, c.CONTACT_RECORDS_PARTIAL_LOAD, function (state, action) {
  var records = contactsSort((0, _uniqBy.default)(action.payload.concat(state.records), 'uuid'), state.sortFavoritesFirst);
  return (0, _objectSpread2.default)({}, state, {
    records: records,
    recordsRevision: state.recordsRevision + 1
  });
}), (0, _defineProperty2.default)(_createReducer, c.CONTACTS_LOADED_FROM_CACHE, function (state, action) {
  var records = (0, _uniqBy.default)(state.records.concat(action.payload), 'uuid');
  return Object.assign({}, state, {
    contactsLoaded: true,
    records: records,
    recordsRevision: state.recordsRevision + 1
  });
}), (0, _defineProperty2.default)(_createReducer, c.DELETE_CONTACT, function (state, action) {
  var nextState = Object.assign({}, state);
  var contactUUID = (0, _safeAccess.default)(action, 'payload.uuid');
  nextState.records = state.records.filter(function (c) {
    return c.uuid !== contactUUID;
  });
  nextState.recordsRevision++;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.CONTACT_NOTIFICATION_CREATED, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    records: contactsSort(state.records.filter(function (c) {
      return c.uuid !== (0, _safeAccess.default)(action, 'payload.uuid');
    }).concat(action.payload), state.sortFavoritesFirst),
    recordsRevision: state.recordsRevision + 1
  });
}), (0, _defineProperty2.default)(_createReducer, c.CONTACT_NOTIFICATION_UPDATED, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    records: contactsSort(state.records.filter(function (c) {
      return c.uuid !== (0, _safeAccess.default)(action, 'payload.uuid');
    }).concat(action.payload), state.sortFavoritesFirst),
    recordsRevision: state.recordsRevision + 1
  });
}), (0, _defineProperty2.default)(_createReducer, c.CONTACT_PARTICIPANT_COUNT_UPDATE, function (state, _ref) {
  var payload = _ref.payload;
  return (0, _objectSpread2.default)({}, state, {
    records: contactsSort(state.records.map(function (c) {
      return c.uuid !== payload.uuid ? c : (0, _objectSpread2.default)({}, c, {
        participants: (0, _objectSpread2.default)({}, c.participants, {
          total: payload.participants || payload.activeParticipants
        }),
        participantsCount: payload.participants || payload.activeParticipants
      });
    }), state.sortFavoritesFirst),
    recordsRevision: state.recordsRevision + 1
  });
}), (0, _defineProperty2.default)(_createReducer, c.CONTACT_NOTIFICATION_DELETED, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    records: state.records.filter(function (c) {
      return c.uuid !== (0, _safeAccess.default)(action, 'payload');
    }),
    recordsRevision: state.recordsRevision + 1
  });
}), (0, _defineProperty2.default)(_createReducer, c.BATCHED_USER_PRESENCE_UPDATE, function (state, _ref2) {
  var _ref2$batchedUpdates = _ref2.batchedUpdates,
      batchedUpdates = _ref2$batchedUpdates === void 0 ? {} : _ref2$batchedUpdates;
  return (0, _objectSpread2.default)({}, state, {
    recordsRevision: state.recordsRevision + 1,
    records: (0, _contactUtils.userPresenceUpdate)(state.records, batchedUpdates)
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(90),
    baseUniq = __webpack_require__(237);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _reduxUtils = __webpack_require__(13);

var _dataChannel = __webpack_require__(166);

var _createReducer;

var initialState = {
  open: false,
  negotiating: false,
  error: null
};
exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, _dataChannel.actions.DATA_CHANNEL_OPENED, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    open: true,
    negotiating: false
  });
}), (0, _defineProperty2.default)(_createReducer, _dataChannel.actions.DATA_CHANNEL_CLOSING, function (state, action) {
  var error = (0, _safeAccess.default)(action, 'payload.error') || null;
  return (0, _objectSpread2.default)({}, state, {
    error: error
  });
}), (0, _defineProperty2.default)(_createReducer, _dataChannel.actions.DATA_CHANNEL_CLOSED, function (state, action) {
  var error = (0, _safeAccess.default)(action, 'payload.error') || null;
  return (0, _objectSpread2.default)({}, state, {
    open: false,
    negotiating: false,
    error: error
  });
}), (0, _defineProperty2.default)(_createReducer, _dataChannel.actions.DATA_CHANNEL_CREATE_OFFER, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    open: false,
    negotiating: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, _dataChannel.actions.DATA_CHANNEL_OFFER_RECEIVED, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    open: false,
    negotiating: true,
    error: null
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = __webpack_require__(128);

var _dataWarehouse = __webpack_require__(273);

var _default = (0, _redux.combineReducers)({
  callsByDay: _dataWarehouse.callsByDaysReducer,
  callsByDaysDevices: _dataWarehouse.callsByDaysDevicesReducer,
  callsByPlan: _dataWarehouse.callsByPlanReducer,
  streamsAll: _dataWarehouse.streamsAll,
  streamsByList: _dataWarehouse.streamsByListReducer,
  streamsByUsage: _dataWarehouse.streamsByUsageReducer,
  streamDetails: _dataWarehouse.streamDetails,
  streamHistory: _dataWarehouse.streamHistory,
  streamSettings: _dataWarehouse.streamSettings,
  conferences: _dataWarehouse.conferencesReducer,
  summaryData: _dataWarehouse.summaryDataReducer,
  usageDetailsForRoom: _dataWarehouse.usageDetailsForRoom,
  usageDetailsForUser: _dataWarehouse.usageDetailsForUser,
  usersFilterByActiveTotal: _dataWarehouse.usersFilterByActiveTotalReducer,
  usersGroupByCallsPersonal: _dataWarehouse.usersGroupByCallsPersonalReducer,
  usersGroupByCallsRooms: _dataWarehouse.usersGroupByCallsRoomsReducer,
  usersGroupByMinutesPersonal: _dataWarehouse.usersGroupByMinutesPersonalReducer,
  usersGroupByMinutesRooms: _dataWarehouse.usersGroupByMinutesRoomsReducer
});

exports.default = _default;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _createReducer;

/** @module state/nucleus/device */

/**
 * @constant {Object}
 * @description Initial state
 * @default
 */
var initialState = {
  hasError: false,
  isFetching: false,
  nonAESEndpoint: null,
  ipAddress: null,
  serialNumber: null,
  screenCount: 0,
  cameraCapabilities: null
};
/**
 * Stores 'device' related data.
 * @example
 * store
 *   +-- nucleus
 *     +-- device
 *       |-- serialNumber: string
 *       |-- ipAddress: string
 *       |-- RES - last response code. either OK or KO (error)
 *       |-- MSG - error message (if last response was an error)
 *       |-- COD - error code (if last response was an error)
 *       |-- QRCode
 *       |-- adminConsoleUri
 *       |-- pairingCode
 *       |-- CSSserverAddress
 *       |-- pairingToken
 *       +-- sessionID
 * @example
 * store
 * +-- nucleus
 *     +-- device
 *       |-- serialNumber: 'dfasdasdfas'
 *       |-- ipAddress: '10.10.10.10'
 *       |-- RES: 'OK'
 *       |-- QRCode: 'dfasdfasdfasdf'
 *       |-- adminConsoleUri: 'https://manage.lifesizecloudbeta.com/activate'
 *       |-- pairingCode: '123456'
 *       |-- CSSserverAddress: 'lifesizecloudbeta.com'
 *       |-- pairingToken: 'asdfasd-adsfasdf-adfasdf'
 *       +-- sessionID: 'adsfasdfasdfasdf'
 */

exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.AUTH_LOGOUT, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.INIT_NUCLEUS, function (state, action) {
  var nextState = Object.assign({}, state);

  if (Object.hasOwnProperty.call(action.payload, 'nonAESEndpoint')) {
    nextState.nonAESEndpoint = action.payload.nonAESEndpoint;
  }

  nextState.serialNumber = (0, _safeAccess.default)(action, 'payload.clientInfo.serialNumber');
  nextState.ipAddress = (0, _safeAccess.default)(action, 'payload.clientInfo.localIPAddr');

  if (Object.hasOwnProperty.call(action.payload, 'deviceScreenCount')) {
    nextState.screenCount = action.payload.deviceScreenCount;
  }

  if (Object.hasOwnProperty.call(action.payload, 'deviceCameraCapabilities')) {
    nextState.cameraCapabilities = action.payload.deviceCameraCapabilities;
  }

  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.MMS_API_BEGIN, function (state, action) {
  switch (action.payload.params.command) {
    case c.GET_PAIRING_CODE:
    case c.GET_PAIRING_STATUS_AND_DETAILS:
    case c.GET_INVITATION_LINK:
      return Object.assign({}, state, {
        hasError: false,
        isFetching: true
      });
  }

  return state;
}), (0, _defineProperty2.default)(_createReducer, c.MMS_API_SUCCESS, function (state, action) {
  switch (action.payload.params.command) {
    case c.GET_PAIRING_CODE:
    case c.GET_PAIRING_STATUS_AND_DETAILS:
    case c.GET_INVITATION_LINK:
      return Object.assign({}, state, action.payload.response, {
        hasError: false,
        isFetching: false,
        error: null
      });
  }

  return state;
}), (0, _defineProperty2.default)(_createReducer, c.MMS_API_FAILURE, function (state, action) {
  switch (action.payload.params.command) {
    case c.GET_PAIRING_CODE:
    case c.GET_PAIRING_STATUS_AND_DETAILS:
    case c.GET_INVITATION_LINK:
      return Object.assign({}, state, {
        hasError: true,
        isFetching: false,
        error: action.payload.error
      });
  }

  return state;
}), (0, _defineProperty2.default)(_createReducer, c.SET_DEVICE_SCREEN_COUNT, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.screenCount = (0, _safeAccess.default)(action, 'payload');
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.SET_DEVICE_CAMERA_CAPABILITIES, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.cameraCapabilities = (0, _safeAccess.default)(action, 'payload');
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.SET_DEVICE_INFO, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    ipAddress: (0, _safeAccess.default)(action, 'payload.localIPAddr') || state.ipAddress,
    serialNumber: (0, _safeAccess.default)(action, 'payload.serialNumber') || state.serialNumber
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _reduxUtils = __webpack_require__(13);

var _contactUtils = __webpack_require__(144);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

/** @module state/nucleus/directory */

/**
 * @constant {Object}
 * @description Initial state
 * @default
 */
var initialState = {
  error: null,
  isSearching: false,
  searchResults: [],
  searchString: null,
  sequenceNumber: 0
};
/**
 * Stores directory service related data.
 */

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.AUTH_LOGOUT, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.SEARCHSTRING_UPDATE, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    searchString: action.payload,
    sequenceNumber: state.sequenceNumber + 1
  });
}), (0, _defineProperty2.default)(_createReducer, c.DIRECTORY_SEARCH_RESULTS, function (state, action) {
  return Object.assign({}, state, {
    error: null,
    isSearching: false,
    searchResults: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.WAMP_SEND_BEGIN, function (state, action) {
  var wampCommand = (0, _safeAccess.default)(action, 'payload.command');
  if (wampCommand !== 'lifesize.directory') return state;
  return Object.assign({}, state, {
    error: null,
    isSearching: true
  });
}), (0, _defineProperty2.default)(_createReducer, c.WAMP_SEND_ERROR, function (state, action) {
  var wampCommand = (0, _safeAccess.default)(action, 'payload.request.command');
  if (wampCommand !== 'lifesize.directory') return state;
  return Object.assign({}, state, {
    error: action.payload.error,
    isSearching: false
  });
}), (0, _defineProperty2.default)(_createReducer, c.CONTACT_PRESENCE_UPDATE, function (state, action) {
  var nextState = Object.assign({}, state);
  var contactId = (0, _safeAccess.default)(action, 'payload.id');
  nextState.searchResults = state.searchResults.map(function (c) {
    if (c.uuid === contactId) {
      return action.payload;
    }

    return c;
  });
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.BATCHED_USER_PRESENCE_UPDATE, function (state, _ref) {
  var _ref$batchedUpdates = _ref.batchedUpdates,
      batchedUpdates = _ref$batchedUpdates === void 0 ? {} : _ref$batchedUpdates;
  return (0, _objectSpread2.default)({}, state, {
    searchResults: (0, _contactUtils.userPresenceUpdate)(state.searchResults, batchedUpdates)
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var get = __webpack_require__(8);
/** @module state/nucleus/doNotDisturb */

/**
 * @constant {bool}
 * @description Initial state
 * @default
 */


var initialState = false;
/**
 * Stores 'call/doNotDisturb' state.
 * @example
 * store
 *   +-- nucleus
 *     +-- doNotDisturb: bool
 *
 */

exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (0, _defineProperty2.default)({}, c.TOGGLE_DO_NOT_DISTURB, function (state, action) {
  var nextState = get(action, 'payload') !== undefined ? !!action.payload : !state;
  return nextState;
}));

exports.default = _default;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

/** @module state/nucleus/endpoint */
var initialState = null;
exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.GET_SESSION_SUCCESS, function (state, action) {
  var _action$payload;

  var endpoint = (action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.endpoint) || null;
  return endpoint && (0, _objectSpread2.default)({}, endpoint);
}), (0, _defineProperty2.default)(_createReducer, c.GEMS_SOFTWARE_UPDATE, function (state, action) {
  var _action$payload2;

  return (0, _objectSpread2.default)({}, state, {
    software: (0, _objectSpread2.default)({}, (state === null || state === void 0 ? void 0 : state.software) || {}, ((_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.body) || {})
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

/** @module state/nucleus/featureFlags */

/**
 * @constant {Object}
 * @description Initial state
 * @default
 */
var initialState = {};
/**
 * Stores feature flag related data.
 */

exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.AUTH_LOGOUT, function (state) {
  return Object.assign({}, initialState, (0, _defineProperty2.default)({}, c.FEATUREFLAG_FORCE_TCP_TUNNELING, state[c.FEATUREFLAG_FORCE_TCP_TUNNELING]));
}), (0, _defineProperty2.default)(_createReducer, c.INIT_NUCLEUS, function (state, action) {
  var nextState = Object.assign({}, state);

  if (Object.hasOwnProperty.call(action.payload, 'forceTcpTunneling')) {
    nextState[c.FEATUREFLAG_FORCE_TCP_TUNNELING] = action.payload.forceTcpTunneling;
  }

  if (Object.hasOwnProperty.call(action.payload, 'enableFarEndCameraControls')) {
    nextState[c.FEATUREFLAG_ENABLE_FECC] = action.payload.enableFarEndCameraControls;
  }

  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.SET_FEATURE_FLAGS, function (state, action) {
  var nextState = Object.assign({}, state, action.payload); // Allow setting this flag through INIT_NUCLEUS to take precedence over SplitIO
  // Webapp always checks localstorage for this setting and will pass true/false
  // in the INIT_NUCLEUS action.  So if SplitIO is true, there isn't a way to
  // override this value to false. You can only override the SplitIO=false to true.

  if (state[c.FEATUREFLAG_FORCE_TCP_TUNNELING]) {
    nextState[c.FEATUREFLAG_FORCE_TCP_TUNNELING] = state[c.FEATUREFLAG_FORCE_TCP_TUNNELING];
  }

  return nextState;
}), _createReducer));

exports.default = _default;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var _contactUtils = __webpack_require__(144);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

/** @module state/nucleus/favorites */
var initialState = {
  isFetching: false,
  recordsRevision: 0,
  records: [],
  optimisticAdd: [],
  optimisticDelete: [],
  error: null
};
/**
 * Stores 'contact' related data.
 * @example
 * store
 *   +-- nucleus
 *     +-- favorites
 *       |-- isFetching: bool
 *       |-- recordsRevision: int
 *       |-- error: null or mix
 *       +-- records
 *         +-- id: record
 * @example
 * store
 * +-- nucleus
 *     +- favorites
 *           |-- isFetching: false
 *           |-- recordsRevision: 3
 *           |-- error: null
 *           +-- records (array): [
 *                |-- { favoriteType: 'USER', favoriteUUID: 3333 }
 *                |-- { favoriteType: 'MEETING', favoriteUUID: 4444 }
 *                +-- { favoriteType: 'CONTACT', favoriteUUID: 5555 }
 */

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.AUTH_LOGOUT, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GET_FAVORITES_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.GET_FAVORITES_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    error: null,
    records: action.payload,
    recordsRevision: state.recordsRevision + 1
  });
}), (0, _defineProperty2.default)(_createReducer, c.GET_FAVORITES_FAILURE, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    error: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.ADD_FAVORITES_BEGIN, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: true,
    error: null,
    recordsRevision: state.recordsRevision + 1,
    optimisticAdd: state.optimisticAdd.concat([action.payload])
  });
}), (0, _defineProperty2.default)(_createReducer, c.ADD_FAVORITES_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    recordsRevision: state.recordsRevision + 1,
    records: state.records.concat([action.payload]),
    optimisticAdd: state.optimisticAdd.filter(function (r) {
      return r.favoriteUUID !== action.payload.favoriteUUID;
    }),
    isFetching: false
  });
}), (0, _defineProperty2.default)(_createReducer, c.ADD_FAVORITES_FAILURE, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    recordsRevision: state.recordsRevision + 1,
    optimisticAdd: state.optimisticAdd.filter(function (r) {
      return r.favoriteUUID !== action.payload.params.favoriteUUID;
    }),
    error: action.payload.error
  });
}), (0, _defineProperty2.default)(_createReducer, c.DELETE_FAVORITES_BEGIN, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: true,
    recordsRevision: state.recordsRevision + 1,
    optimisticDelete: state.optimisticDelete.concat([action.payload]),
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.DELETE_FAVORITES_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    recordsRevision: state.recordsRevision + 1,
    records: state.records.filter(function (r) {
      return r.favoriteUUID !== action.payload.favoriteUUID;
    }),
    optimisticDelete: state.optimisticDelete.filter(function (r) {
      return r.favoriteUUID !== action.payload.favoriteUUID;
    })
  });
}), (0, _defineProperty2.default)(_createReducer, c.DELETE_FAVORITES_FAILURE, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    recordsRevision: state.recordsRevision + 1,
    error: action.payload.error,
    optimisticDelete: state.optimisticDelete.filter(function (r) {
      return r.favoriteUUID !== action.payload.params.favoriteUUID;
    })
  });
}), (0, _defineProperty2.default)(_createReducer, c.BATCHED_USER_PRESENCE_UPDATE, function (state, _ref) {
  var _ref$batchedUpdates = _ref.batchedUpdates,
      batchedUpdates = _ref$batchedUpdates === void 0 ? {} : _ref$batchedUpdates;
  return (0, _objectSpread2.default)({}, state, {
    recordsRevision: state.recordsRevision + 1,
    records: (0, _contactUtils.userPresenceUpdate)(state.records, batchedUpdates)
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _call = _interopRequireDefault(__webpack_require__(609));

var _callWaiting = _interopRequireDefault(__webpack_require__(610));

var _capabilities = _interopRequireDefault(__webpack_require__(611));

var _conference = _interopRequireDefault(__webpack_require__(612));

var _incoming = _interopRequireDefault(__webpack_require__(613));

var _invited = _interopRequireDefault(__webpack_require__(614));

var _options = _interopRequireDefault(__webpack_require__(615));

var _presentation = _interopRequireDefault(__webpack_require__(616));

var _pushService = _interopRequireDefault(__webpack_require__(617));

var _recording = _interopRequireDefault(__webpack_require__(618));

var _rtc = _interopRequireDefault(__webpack_require__(619));

var galaxy = function galaxy() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return {
    call: (0, _call.default)(state.call, action),
    callWaiting: (0, _callWaiting.default)(state.callWaiting, action),
    capabilities: (0, _capabilities.default)(state.capabilities, action),
    conference: (0, _conference.default)(state.conference, action),
    incoming: (0, _incoming.default)(state.incoming, action),
    invited: (0, _invited.default)(state.invited, action),
    options: (0, _options.default)(state.options, action),
    presentation: (0, _presentation.default)(state.presentation, action),
    pushService: (0, _pushService.default)(state.pushService, action),
    recording: (0, _recording.default)(state.recording, action),
    rtc: (0, _rtc.default)(state.rtc, action)
  };
};

var _default = galaxy;
exports.default = _default;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _get2 = _interopRequireDefault(__webpack_require__(11));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

/** @module state/nucleus/galaxy/call */

/**
 * @constant {Object}
 * @description Initial state
 * @default
 */
var initialState = {
  callId: null,
  conferenceId: null,
  sourceId: null,
  endpointInfo: null,
  contact: null,
  dialString: null,
  state: c.GALAXY_CALL_STATE_DISCONNECTED,
  reason: c.GALAXY_REASON_DEFAULT,
  error: null,
  isCaller: false,
  isIncomingCall: false,
  isEscalating: false,
  isBeingEscalated: false,
  isMigrating: false,
  startRecordingOnMigration: false,
  isRedirectingToLegacy: false,
  isAnsweringLegacy: false,
  isAnsweringGalaxy: false,
  cancelQueued: false,
  startTime: null,
  endTime: null,
  preferredMediaServers: [],
  pinRequested: false,
  currentMcuLayout: null,
  remoteCameraCapabilities: null,
  isWebConferencing: false
};
exports.initialState = initialState;

var galaxyActionOnUpdateSdpOfferHandler = function galaxyActionOnUpdateSdpOfferHandler(state, action) {
  var currentMcuLayout = (0, _get2.default)(action, 'payload.capability.currentLayout') || null;
  var nextState = (0, _objectSpread2.default)({}, state, {
    currentMcuLayout: currentMcuLayout
  });
  return nextState;
};

var galaxyActionOnUpdateSdpAnswerHandler = function galaxyActionOnUpdateSdpAnswerHandler(state, action) {
  var currentMcuLayout = (0, _get2.default)(action, 'payload.capability.currentLayout') || null;
  var nextState = (0, _objectSpread2.default)({}, state, {
    currentMcuLayout: currentMcuLayout
  });
  return nextState;
};

var galaxyActionInCallOfferHandler = function galaxyActionInCallOfferHandler(state, action) {
  var remoteCameraCapabilities = (0, _get2.default)(action, 'payload.capability.cameraCapabilities') || null;
  var nextState = (0, _objectSpread2.default)({}, state, {
    remoteCameraCapabilities: remoteCameraCapabilities
  });
  return nextState;
};

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_REPLACE_CALL, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    callId: (0, _safeAccess.default)(action, 'payload.callId'),
    conferenceId: (0, _safeAccess.default)(action, 'payload.conferenceId'),
    dialString: (0, _safeAccess.default)(action, 'payload.from'),
    startTime: Date.now(),
    remoteCameraCapabilities: (0, _safeAccess.default)(action, 'payload.capability.cameraCapabilities')
  });
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_CLEAR_CALL, function (state) {
  var nextState = Object.assign({}, initialState); // CNUC-1040: Reset all state except to indicate that we are migrating for recording.

  nextState.startRecordingOnMigration = state.startRecordingOnMigration;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_QUEUE_CANCEL_CALL, function (state) {
  var nextState = Object.assign({}, state);
  nextState.cancelQueued = true;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_BEGIN_CALL, function (state, action) {
  var nextState = Object.assign({}, initialState);
  nextState.state = c.GALAXY_CALL_STATE_BEGIN;
  nextState.isCaller = true;
  nextState.isIncomingCall = false;
  nextState.dialString = (0, _safeAccess.default)(action, 'payload.dialString') || state.dialString;
  nextState.callId = (0, _safeAccess.default)(action, 'payload.callId');
  nextState.contact = (0, _safeAccess.default)(action, 'payload.contact');
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_CALLING, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.callId = (0, _safeAccess.default)(action, 'payload.data.callId') || state.callId;
  nextState.dialString = (0, _safeAccess.default)(action, 'payload.data.to') || state.dialString;
  nextState.sourceId = (0, _safeAccess.default)(action, 'payload.data.sourceId') || state.sourceId;
  nextState.endpointInfo = (0, _safeAccess.default)(action, 'payload.data.endpointInfo') || state.endpointInfo;
  nextState.contact = (0, _safeAccess.default)(action, 'payload.contact' || false);
  nextState.media = (0, _safeAccess.default)(action, 'payload.media');
  nextState.state = c.GALAXY_CALL_STATE_CALLING;
  nextState.reason = c.GALAXY_REASON_DEFAULT;
  nextState.isIncomingCall = false;
  nextState.isCaller = true;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_TRYING, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.sourceId = (0, _safeAccess.default)(action, 'payload.sourceId') || state.sourceId;
  nextState.conferenceId = (0, _safeAccess.default)(action, 'payload.conferenceId') || state.conferenceId;
  nextState.state = c.GALAXY_CALL_STATE_TRYING;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_RINGING, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.sourceId = (0, _safeAccess.default)(action, 'payload.sourceId') || state.sourceId;
  nextState.conferenceId = (0, _safeAccess.default)(action, 'payload.conferenceId') || state.conferenceId;
  nextState.state = c.GALAXY_CALL_STATE_RINGING;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_BEGIN_ANSWER, function (state, action) {
  var nextState = Object.assign({}, initialState, {
    isAnsweringGalaxy: state.isAnsweringGalaxy
  });
  nextState.state = c.GALAXY_CALL_STATE_ANSWERING;
  nextState.isIncomingCall = true;
  nextState.isCaller = false;
  nextState.callId = (0, _safeAccess.default)(action, 'payload.callId') || state.callId;
  nextState.conferenceId = (0, _safeAccess.default)(action, 'payload.conferenceId') || state.conferenceId;
  nextState.dialString = (0, _safeAccess.default)(action, 'payload.dialString') || state.dialString;
  nextState.sourceId = (0, _safeAccess.default)(action, 'payload.sourceId') || state.sourceId;
  nextState.endpointInfo = (0, _safeAccess.default)(action, 'payload.endpointInfo') || state.endpointInfo;
  nextState.contact = (0, _safeAccess.default)(action, 'payload.contact' || false);
  nextState.preferredMediaServers = (0, _safeAccess.default)(action, 'payload.preferredMediaServers' || false);
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_ANSWER, function (state, action) {
  var nextState = Object.assign({}, state);

  if ((0, _safeAccess.default)(action, 'payload.data.callId') === state.callId && !state.error) {
    nextState.state = c.GALAXY_CALL_STATE_CONNECTED;
    nextState.startTime = Date.now();
    nextState.endTime = null;
    nextState.isAnsweringLegacy = false;
    nextState.isAnsweringGalaxy = false;
  }

  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_CALL_CONNECTED, function (state, action) {
  var nextState = Object.assign({}, state);

  if ((0, _safeAccess.default)(action, 'payload.callId') === state.callId && !state.error) {
    nextState.state = c.GALAXY_CALL_STATE_CONNECTED;
    nextState.conferenceId = (0, _safeAccess.default)(action, 'payload.conferenceId') || state.conferenceId;
    nextState.startTime = Date.now();
    nextState.endTime = null;
    nextState.isAnsweringLegacy = false;
    nextState.isAnsweringGalaxy = false;
    nextState.currentMcuLayout = (0, _safeAccess.default)(action, 'payload.capability.currentLayout') || null;
    nextState.remoteCameraCapabilities = (0, _safeAccess.default)(action, 'payload.capability.cameraCapabilities') || null;
  }

  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_FAILED, function (state, action) {
  var nextState = Object.assign({}, state);
  var srcReason = (0, _safeAccess.default)(action, 'payload.reason');
  var reason = srcReason === c.GALAXY_EVENT_REDIRECT_TO_LEGACY ? c.GALAXY_REASON_UNREACHABLE : srcReason;

  if ((0, _safeAccess.default)(action, 'payload.callId') === state.callId) {
    nextState.state = c.GALAXY_CALL_STATE_DISCONNECTED;
    nextState.endTime = Date.now();
    nextState.reason = reason || c.GALAXY_REASON_DEFAULT;
    nextState.error = (0, _safeAccess.default)(action, 'payload.error') || c.GALAXY_ERROR_DEFAULT;
    nextState.isEscalating = false;
    nextState.isAnsweringLegacy = false;
    nextState.isAnsweringGalaxy = false;
    nextState.isMigrating = false;
    nextState.cancelQueued = false;
    nextState.pinRequested = false;
    nextState.isWebConferencing = false;
    nextState.currentMcuLayout = null;
    nextState.remoteCameraCapabilities = null;
  }

  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_END, function (state, action) {
  var nextState = Object.assign({}, state);

  if ((0, _safeAccess.default)(action, 'payload.callId') === state.callId) {
    nextState.state = c.GALAXY_CALL_STATE_DISCONNECTED;
    nextState.endTime = Date.now();
    nextState.reason = (0, _safeAccess.default)(action, 'payload.reason') || c.GALAXY_REASON_DEFAULT;
    nextState.isEscalating = false;
    nextState.isMigrating = false;
    nextState.cancelQueued = false;
    nextState.pinRequested = false;
    nextState.isWebConferencing = false;
    nextState.isRedirectingToLegacy = false;
    nextState.currentMcuLayout = null;
    nextState.remoteCameraCapabilities = null;
  }

  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_PIN_REQUESTED, function (state, action) {
  if ((0, _safeAccess.default)(action, 'payload.callId') !== state.callId) return state;
  return (0, _objectSpread2.default)({}, state, {
    pinRequested: true
  });
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_PIN_SENT, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    pinRequested: false
  });
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_INCOMING_CALL, function (state, action) {
  var nextState = state.state === c.GALAXY_CALL_STATE_DISCONNECTED ? initialState : state;
  nextState.remoteCameraCapabilities = (0, _safeAccess.default)(action, 'payload.capability.cameraCapabilities') || null;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_ON_UPDATE_SDP_OFFER, galaxyActionOnUpdateSdpOfferHandler), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_ON_UPDATE_SDP_ANSWER, galaxyActionOnUpdateSdpAnswerHandler), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_OFFER_ANSWERED, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.currentMcuLayout = (0, _safeAccess.default)(action, 'payload.capability.currentLayout') || null;
  nextState.remoteCameraCapabilities = (0, _safeAccess.default)(action, 'payload.capability.cameraCapabilities') || null;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_IN_CALL_OFFER, galaxyActionInCallOfferHandler), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_CHANGE_LAYOUT_RESPONSE, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.currentMcuLayout = (0, _safeAccess.default)(action, 'payload.currentLayout');
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.ENABLE_WEB_CONFERENCE_MODE, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isWebConferencing: true
  });
}), (0, _defineProperty2.default)(_createReducer, c.DISABLE_WEB_CONFERENCE_MODE, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isWebConferencing: false
  });
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_CREATE_OFFER, function (state, action) {
  if ((0, _safeAccess.default)(action, 'payload.reason') === c.GALAXY_REASON_REPLACE_CALL) {
    return (0, _objectSpread2.default)({}, state, {
      callId: (0, _safeAccess.default)(action, 'payload.callId'),
      conferenceId: (0, _safeAccess.default)(action, 'payload.conferenceId'),
      dialString: (0, _safeAccess.default)(action, 'payload.from'),
      remoteCameraCapabilities: (0, _safeAccess.default)(action, 'payload.capability.cameraCapabilities')
    });
  }

  return state;
}), _createReducer));

exports.default = _default;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

/** @module state/nucleus/galaxy/callWaiting */

/**
 * @constant {Object}
 * @description Initial state
 * @default
 */
var initialState = {};
/**
 * Stores queue of calls waiting (incoming calls while in a call).
 * @example
 * store
 *   +-- nucleus
 *     +-- galaxy
 *       +-- callWaiting
 *         +-- [{ id: '123', displayString: 'Bob' }]
 */

exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_END, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_FAILED, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_CALL_WAITING_RESPONSE, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_CALL_WAITING_CANCELLED, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_CALL_WAITING, function (state, action) {
  return action.payload;
}), _createReducer));

exports.default = _default;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _createReducer;

/** @module state/nucleus/galaxy/capabilities */
var initialState = {
  isRegistered: false,
  isRegistering: false,
  iceServers: [],
  clientRegion: null,
  relayAccessible: false,
  data: null,
  error: null,
  callsEnabled: true
};

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.INIT_NUCLEUS, function (state, action) {
  var nextState = (0, _objectSpread2.default)({}, state);

  if (action.payload.hasOwnProperty('callsEnabled')) {
    nextState.callsEnabled = !!action.payload.callsEnabled;
  }

  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_POST_CAPABILITIES_BEGIN, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.isRegistered = false;
  nextState.isRegistering = true;
  nextState.data = (0, _safeAccess.default)(action, 'payload') || null;
  nextState.error = null;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_POST_CAPABILITIES_SUCCESS, function (state) {
  var nextState = Object.assign({}, state);
  nextState.isRegistered = true;
  nextState.isRegistering = false;
  nextState.error = null;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_POST_CAPABILITIES_FAILED, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.isRegistered = false;
  nextState.isRegistering = false;
  nextState.error = (0, _safeAccess.default)(action, 'payload') || c.GALAXY_POST_CAPABILITIES_FAILED_REASON_DEFAULT;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_GET_RELAY_SERVERS_SUCCESS, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.iceServers = (0, _safeAccess.default)(action, 'payload.iceServers') || [];
  nextState.clientRegion = (0, _safeAccess.default)(action, 'payload.clientRegion');
  return nextState;
}), _createReducer));

exports.default = _default;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _remoteModerator = __webpack_require__(85);

var _createReducer;

/** @module state/nucleus/galaxy/conference */

/**
 * @constant {Object}
 * @description Initial state
 * @default
 */
var initialState = {
  revision: 0,
  participants: [],
  sequenceNumber: null,
  conferenceId: null
};
exports.initialState = initialState;

function upsertParticipants() {
  var participants = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var newParticipants = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  newParticipants.forEach(function (participant) {
    var index = participants.findIndex(function (p) {
      return participant && (0, _safeAccess.default)(p, 'participantId') === (0, _safeAccess.default)(participant, 'participantId');
    });
    if (index > -1) participants.splice(index, 1, participant);else participants.push(participant);
  });
  return participants;
}

var updateParticipant = function updateParticipant(state, action) {
  var participants = (0, _safeAccess.default)(action, 'payload.participants') || [(0, _safeAccess.default)(action, 'payload.participant')];
  return (0, _objectSpread2.default)({}, state, {
    participants: upsertParticipants(state.participants.slice(), participants),
    revision: state.revision++
  });
};

var updateConference = function updateConference(state, action) {
  var _action$payload = action.payload,
      conferenceId = _action$payload.conferenceId,
      sequenceNumber = _action$payload.sequenceNumber;
  return (0, _objectSpread2.default)({}, state, {
    conferenceId: conferenceId,
    sequenceNumber: sequenceNumber
  }, (0, _safeAccess.default)(action, 'payload.conferenceState') || {}, {
    revision: state.revision++
  });
};

var removeParticipant = function removeParticipant(state) {
  var payloadParticipantId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DND';
  return (0, _objectSpread2.default)({}, state, {
    participants: state.participants.slice().filter(function (p) {
      return (0, _safeAccess.default)(p, 'participantId') !== payloadParticipantId;
    }),
    revision: state.revision++
  });
};

var ejectSuccess = function ejectSuccess(state, action) {
  return removeParticipant(state, (0, _safeAccess.default)(action, 'payload.participantId'));
};

var participantLeft = function participantLeft(state, action) {
  return removeParticipant(state, (0, _safeAccess.default)(action, 'payload.participant.participantId'));
};
/**
 * Stores queue of calls waiting (incoming calls while in a call).
 * @example
 * store
 *   +-- nucleus
 *     +-- galaxy
 *       +-- callWaiting
 *         +-- [{ id: '123', displayString: 'Bob' }]
 */


var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_END, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_FAILED, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_CONFERENCE_MUTED, function (state, action) {
  var updatedState = updateConference(state, action);
  var initiatedBy = (0, _safeAccess.default)(action.payload, 'initiatedBy.uuid');
  var participants = state.participants.map(function (p) {
    // everyone is server muted except for the mute initiator
    var serverMuteState = initiatedBy !== (0, _safeAccess.default)(p, 'uuid') ? true : false;
    return (0, _objectSpread2.default)({}, p, {
      serverMuteState: serverMuteState
    });
  });
  return (0, _objectSpread2.default)({}, updatedState, {
    participants: participants
  });
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_CONFERENCE_ESCALATED, function (state, action) {
  return updateConference(state, action);
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_CONFERENCE_UNMUTED, function (state, action) {
  var updatedState = updateConference(state, action);
  return (0, _objectSpread2.default)({}, updatedState, {
    // everyone unmuted
    participants: state.participants.map(function (p) {
      return (0, _objectSpread2.default)({}, p, {
        serverMuteState: false
      });
    })
  });
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_CONFERENCE_JOINED, function (state, action) {
  var updatedState = updateConference(state, action);
  return (0, _objectSpread2.default)({}, updatedState, {
    participants: (0, _safeAccess.default)(action, 'payload.participants') || []
  });
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_PARTICIPANT_JOINED, updateParticipant), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_PARTICIPANT_LOCAL_MUTED, updateParticipant), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_PARTICIPANT_LOCAL_UNMUTED, updateParticipant), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_PARTICIPANT_LOCAL_VIDEO_MUTED, updateParticipant), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_PARTICIPANT_LOCAL_VIDEO_UNMUTED, updateParticipant), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_PARTICIPANT_MUTED, updateParticipant), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_PARTICIPANT_UNMUTED, updateParticipant), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_PRESENTATION_FLOOR_GRANTED, updateParticipant), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_PRESENTATION_FLOOR_RELEASED, updateParticipant), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_EJECT_SUCCESS, ejectSuccess), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_PARTICIPANT_LEFT, participantLeft), (0, _defineProperty2.default)(_createReducer, _remoteModerator.REMOTE_MOD_JOIN_REQUEST, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, _remoteModerator.REMOTE_MOD_JOIN_SUCCESS, handleRemoteModJoinSuccess), (0, _defineProperty2.default)(_createReducer, _remoteModerator.REMOTE_MOD_JOIN_FAILURE, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, _remoteModerator.REMOTE_MOD_LEAVE_REQUEST, function () {
  return initialState;
}), _createReducer));

exports.default = _default;

function handleRemoteModJoinSuccess(prevState, action) {
  return (0, _objectSpread2.default)({}, prevState, {
    conferenceId: (0, _safeAccess.default)(action, 'payload.conferenceId'),
    conferenceRoutingKey: (0, _safeAccess.default)(action, 'payload.sourceId')
  });
}

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(71));

var _get = _interopRequireDefault(__webpack_require__(11));

var c = _interopRequireWildcard(__webpack_require__(3));

/** @module state/nucleus/galaxy/incoming */

/**
 * @constant {Object}
 * @description Initial state
 * @default
 */
var initialState = [];
exports.initialState = initialState;

var incoming = function incoming() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case c.AUTH_LOGOUT:
    case c.NETWORK_OFFLINE:
    case c.WAMP_CONNECTION_DISPOSED_HEALTHY:
    case c.WAMP_CONNECTION_DISPOSED_JWT_ERROR:
    case c.WAMP_CONNECTION_DISPOSED_UNEXPECTED:
      return initialState;

    case c.GALAXY_ACTION_INCOMING_CALL:
      return [].concat((0, _toConsumableArray2.default)(state), [(0, _objectSpread2.default)({}, action.payload, {
        dialString: (0, _get.default)(action, 'payload.from')
      })]);
    // Remove the incoming call if the id matches the payload.

    case c.GALAXY_ACTION_BEGIN_ANSWER:
    case c.GALAXY_ACTION_IGNORE:
    case c.GALAXY_ACTION_INCOMING_CALL_ENDED:
      return state.filter(function (i) {
        return (0, _get.default)(i, 'callId') !== (0, _get.default)(action, 'payload.callId');
      });

    default:
      return state;
  }
};

var _default = incoming;
exports.default = _default;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _createReducer;

/** @module state/nucleus/galaxy/invited */

/**
 * @constant {Object}
 * @description Initial state
 * @default
 */
var initialState = {};
/**
 * Stores the state of calling out to someone over galaxy, while in a galaxy call. (invite+add)
 * @example
 * store
 *   +-- nucleus
 *     +-- galaxy
 *       +-- invited
 *         +-- [{ id: '123', displayString: 'Bob' }]
 */

exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_END, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_FAILED, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_CLEAR_INVITED, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_ADD_SUCCESS, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    state: c.GALAXY_INVITEE_STATE_CONNECTED
  });
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_ADD_FAILED, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    state: c.GALAXY_INVITEE_STATE_FAILED,
    reason: (0, _safeAccess.default)(action, 'payload.reason')
  });
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_ADD_RINGING, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    state: c.GALAXY_INVITEE_STATE_RINGING
  });
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_ADD_TO_CALL, function (state, action) {
  var invitedId = (0, _safeAccess.default)(action, 'payload.invitedId');
  var contact = (0, _safeAccess.default)(action, 'payload.contact');

  if (typeof contact === 'string') {
    contact = {
      dialString: contact,
      name: contact
    };
  }

  return Object.assign({}, {
    invitedId: invitedId
  }, contact, {
    state: c.GALAXY_INVITEE_STATE_TRYING
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _reduxUtils = __webpack_require__(13);

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

/** @module state/nucleus/galaxy/options */

/**
 * @constant {Object}
 * @description Initial state
 * @default
 */
var initialState = {
  maxBandwidth: c.GALAXY_DEFAULT_CALL_BANDWIDTH_KBPS,
  //In kbps
  preferH264: false,
  primaryProfile: null,
  secondaryProfile: null,
  enable1080Rx: false,
  presBwPercentage: c.GALAXY_DEFAULT_PRESENTATION_BW_PERCENTAGE,
  splitBandwidth: true,
  updateVideoBandwidth: true,
  supportRelayMode: false,
  supportV3: false
};

function parseBooleanFlag(value) {
  if (value === true || value === 'true' || value === 1) return true;else if (value === false || value === 'false' || value === 0) return false;
  return null;
}

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.INIT_NUCLEUS, function (state, action) {
  var nextState = Object.assign({}, state); // This allows for an H264 default bandwidth to be set if H264 is preferred.

  if (action.payload.hasOwnProperty('primaryProfile') || action.payload.hasOwnProperty('secondaryProfile') || (0, _safeAccess.default)(action, 'payload.preferH264')) {
    nextState.maxBandwidth = c.GALAXY_DEFAULT_H264_BANDWIDTH_KBPS;
  }

  if (action.payload.hasOwnProperty('preferH264')) {
    nextState.preferH264 = action.payload.preferH264;
  }

  if (action.payload.hasOwnProperty('enablePrimary1080Rx')) {
    nextState.enablePrimary1080Rx = action.payload.enablePrimary1080Rx;
  }

  if (action.payload.hasOwnProperty('enableSecondary1080Rx')) {
    nextState.enableSecondary1080Rx = action.payload.enableSecondary1080Rx;
  }

  if ((0, _safeAccess.default)(action, 'payload.maxBandwidth')) {
    nextState.maxBandwidth = Number(action.payload.maxBandwidth);
  }

  if (action.payload.hasOwnProperty('primaryProfile')) {
    nextState.primaryProfile = action.payload.primaryProfile;
  }

  if (action.payload.hasOwnProperty('secondaryProfile')) {
    nextState.secondaryProfile = action.payload.secondaryProfile;
  }

  if (action.payload.hasOwnProperty('splitBandwidth')) {
    nextState.splitBandwidth = parseBooleanFlag(action.payload.splitBandwidth);
  }

  if (action.payload.hasOwnProperty('updateVideoBandwidth')) {
    nextState.updateVideoBandwidth = parseBooleanFlag(action.payload.updateVideoBandwidth);
  }

  if (action.payload.hasOwnProperty('supportRelayMode')) {
    nextState.supportRelayMode = parseBooleanFlag(action.payload.supportRelayMode);
  }

  if (action.payload.hasOwnProperty('supportV3')) {
    nextState.supportV3 = parseBooleanFlag(action.payload.supportV3);
  }

  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.SET_CUSTOM_CALL_BANDWIDTH, function (state, action) {
  var nextState = Object.assign({}, state);

  if ((0, _safeAccess.default)(action, 'payload') !== -1) {
    nextState.maxBandwidth = (0, _safeAccess.default)(action, 'payload');
  }

  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.SET_CUSTOM_PRESENTATION_BW_PERCENTAGE, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.presBwPercentage = (0, _safeAccess.default)(action, 'payload');
  return nextState;
}), _createReducer));

exports.default = _default;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _createReducer;

/** @module state/nucleus/galaxy/presentation */

/**
 * @type {PresentationState}
 * @description Initial state
 * @default
 */
var initialState = {
  state: c.GALAXY_PRESENTATION_STATE_STOPPED,
  bitRate: 1024,
  error: null,
  trackId: null,
  presentationSourceId: null,
  sourceName: null,
  isRequestingToken: false,
  isTokenOwnerSelf: false,
  isAwaitingAnswer: false
};
/**
 * Stores 'presentation' related data.
 * @example
 * store
 *   +-- nucleus
 *     +-- presentation
 *       |-- state: string
 *       |-- type: string
 *       +-- error: mixed
 * @example
 * store
 * +-- nucleus
 *     +-- presentation
 *       |-- state: 'GALAXY_PRESENTATION_STATE_STOPPED'
 *       +-- error: null
 */

exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_FAILED, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_END, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_STOP_PRESENTATION, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_PRESENTATION_TOKEN_RELEASE, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_BEGIN_PRESENTATION, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.presentationSourceId = action.payload.presentationSourceId;
  nextState.presentationSourceName = action.payload.presentationSourceName;
  nextState.isRequestingToken = false;
  nextState.isTokenOwnerSelf = false;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_ON_UPDATE_SDP_OFFER, function (state, action) {
  if ((0, _safeAccess.default)(action, 'payload.reason') === c.GALAXY_REASON_PRESENTATION_SEND) {
    return (0, _objectSpread2.default)({}, state, {
      state: c.GALAXY_PRESENTATION_STATE_RX_STARTING
    });
  }

  return state;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_AWAIT_PRESENTATION_ANSWER, function (state) {
  var nextState = Object.assign({}, state);
  nextState.isAwaitingAnswer = true;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_PRESENTATION_ANSWER, function (state) {
  var nextState = Object.assign({}, state);
  nextState.isAwaitingAnswer = false;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_LOCAL_PRESENTATION_STOPPED, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_PRESENTATION_TOKEN_REQUEST, function (state) {
  var nextState = Object.assign({}, state);
  nextState.isRequestingToken = true;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_PRESENTATION_TOKEN_GRANTED, function (state) {
  var nextState = Object.assign({}, state);
  nextState.state = c.GALAXY_PRESENTATION_STATE_TX_STARTING;
  nextState.isRequestingToken = false;
  nextState.isTokenOwnerSelf = true;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_PRESENTATION_TOKEN_DENIED, function (state) {
  var nextState = Object.assign({}, state);
  nextState.isRequestingToken = false;
  nextState.isTokenOwnerSelf = false;
  nextState.error = c.GALAXY_REASON_PRESENTATION_TOKEN_DENIED;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_UPDATE_PRESENTATION_TRACKID, function (state, action) {
  var nextState = Object.assign({}, state);

  if (action.payload !== nextState.trackId) {
    nextState.trackId = action.payload;
  }

  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_INCOMING_PRESENTATION, function (state) {
  var nextState = Object.assign({}, state);
  nextState.state = c.GALAXY_PRESENTATION_STATE_RX_STARTED;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_PRESENTATION_CONNECTED, function (state) {
  var nextState = Object.assign({}, state);
  nextState.state = c.GALAXY_PRESENTATION_STATE_TX_STARTED;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_RX_STOPPED_PRESENTATION, function (state) {
  /* there is an edge case where an attempt to start a remote presentation may be stopped while/because a presentation
   * is already being transmitted */
  if (state.state === c.GALAXY_PRESENTATION_STATE_TX_STARTED) return (0, _objectSpread2.default)({}, state);
  return Object.assign({}, initialState);
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_PRESENTATION_FAILED, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.error = (0, _safeAccess.default)(action, 'payload.error');
  return nextState;
}), _createReducer));

exports.default = _default;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var c = _interopRequireWildcard(__webpack_require__(3));

var _reduxUtils = __webpack_require__(13);

var _createReducer;

/** @module state/nucleus/galaxy/pushService */

/**
 * @constant {Object}
 * @description Initial state
 * @default
 */
var initialState = {
  callId: null,
  sourceId: null
};
/**
 * Stores queue of calls waiting (incoming calls while in a call).
 * @example
 * store
 *   +-- nucleus
 *     +-- galaxy
 *       +-- pushService
 *         +-- [{ callId: '123', sourceId: 'Bob' }]
 */

exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.AUTH_LOGOUT, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.NETWORK_OFFLINE, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.WAMP_CONNECTION_DISPOSED_HEALTHY, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.WAMP_CONNECTION_DISPOSED_JWT_ERROR, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.WAMP_CONNECTION_DISPOSED_UNEXPECTED, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_BEGIN_ANSWER, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_BEGIN_CALL, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_END, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_FAILED, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_IGNORE, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_CALL_PICKUP_FAILED, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_PUSH_CALL_CANCELLED, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_CALL_PICKUP, function (state, action) {
  return action.payload;
}), _createReducer));

exports.default = _default;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _createReducer;

/** @module state/nucleus/galaxy/recording */

/**
 * @constant {Object}
 * @description Initial state
 * @default
 */
var initialState = {
  state: c.GALAXY_RECORDING_STATE_STOPPED,
  startedBy: null,
  owner: null,
  error: null
};
/**
 * Stores the state of calling out to someone over galaxy, while in a galaxy call. (invite+add)
 * @example
 * store
 *   +-- nucleus
 *     +-- galaxy
 *       +-- recording
 *         +-- [{ startedBy: { name: 'username' } },  state: 'started' }]
 */

exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_END, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_FAILED, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_RECORDING_STOPPED, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_RECORDING_START, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    state: c.GALAXY_RECORDING_STATE_STARTING
  });
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_RECORDING_START_ERROR, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    state: c.GALAXY_RECORDING_STATE_STOPPED,
    error: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_RECORDING_STOP, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    state: c.GALAXY_RECORDING_STATE_STOPPING
  });
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_RECORDING_STOP_ERROR, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    state: c.GALAXY_RECORDING_STATE_STARTED,
    error: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_RECORDING_STARTED, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    state: c.GALAXY_RECORDING_STATE_STARTED,
    startedBy: action.payload.startedBy,
    owner: action.payload.owner,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_RECORDING_UPDATED, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    state: c.GALAXY_RECORDING_STATE_STARTED,
    startedBy: action.payload.startedBy,
    owner: action.payload.owner
  });
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_CONFERENCE_JOINED, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    state: (0, _safeAccess.default)(action, 'payload.recording') ? c.GALAXY_RECORDING_STATE_STARTED : c.GALAXY_RECORDING_STATE_STOPPED,
    startedBy: (0, _safeAccess.default)(action, 'payload.conferenceState.recordingProperties.startedBy'),
    owner: (0, _safeAccess.default)(action, 'payload.conferenceState.recordingProperties.owner')
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

/** @module state/nucleus/galaxy/rtc */

/**
 * @constant {Object}
 * @description Initial state
 * @default
 */
var initialState = {
  iceConnectionState: c.GALAXY_ICE_STATE_CLOSED,
  presIceConnectionState: c.GALAXY_ICE_STATE_CLOSED,
  iceRetryCount: 0,
  presIceRetryCount: 0,
  offerError: null,
  mediaProcessingInProgress: false,
  localCapabilities: {
    iceCandidates: [],
    sdp: null,
    type: null,
    tracks: {
      presentation: null
    }
  },
  remoteCapabilities: {
    iceCandidates: [],
    sdp: null,
    type: null,
    tracks: {
      presentation: null
    }
  },
  previousLocalCapabilities: {
    iceCandidates: [],
    sdp: null,
    type: null,
    tracks: {
      presentation: null
    }
  },
  scaledResolution: {
    downScaleInForce: false,
    originalHeight: 0,
    originalWidth: 0
  },
  downScaleHeight: c.DOWNSCALE_HEIGHT,
  downScaleWidth: c.DOWNSCALE_WIDTH
};

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_ICE_STATE_UPDATED, function (state, action) {
  // For now, only worry about the main peer connection for counting ice restart attempts.
  // TODO: do we need 2 rtc reducers, one for primary, one of presentation?
  var nextState = Object.assign({}, state);

  if ((0, _safeAccess.default)(action, 'payload.isPresentation')) {
    nextState.presIceConnectionState = (0, _safeAccess.default)(action, 'payload.state'); // Right now we are just interested in these three states

    if (nextState.presIceConnectionState === c.GALAXY_ICE_STATE_CONNECTED) {
      nextState.presIceRetryCount = 0;
    } else if (nextState.presIceConnectionState === c.GALAXY_ICE_STATE_FAILED) {
      nextState.presIceRetryCount++;
    }
  } else {
    nextState.iceConnectionState = (0, _safeAccess.default)(action, 'payload.state'); // Right now we are just interested in these three states

    if (nextState.iceConnectionState === c.GALAXY_ICE_STATE_CONNECTED) {
      nextState.iceRetryCount = 0;
    } else if (nextState.iceConnectionState === c.GALAXY_ICE_STATE_FAILED) {
      nextState.iceRetryCount++;
    }
  }

  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_CALLING, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.previousLocalCapabilities = state.localCapabilities;
  nextState.localCapabilities = (0, _safeAccess.default)(action, 'payload.data.capability') || state.localCapabilities;
  nextState.mediaProcessingInProgress = true;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_ANSWER, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.previousLocalCapabilities = state.localCapabilities;
  nextState.localCapabilities = (0, _safeAccess.default)(action, 'payload.data.capability') || state.localCapabilities;
  nextState.mediaProcessingInProgress = false;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_BEGIN_ANSWER, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.remoteCapabilities = (0, _safeAccess.default)(action, 'payload.capability');
  nextState.mediaProcessingInProgress = true;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_CALL_CONNECTED, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.remoteCapabilities = (0, _safeAccess.default)(action, 'payload.capability') || state.remoteCapabilities;
  nextState.mediaProcessingInProgress = false;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_END, function (state) {
  return (0, _objectSpread2.default)({}, initialState, {
    downScaleHeight: state.downScaleHeight,
    downScaleWidth: state.downScaleWidth
  });
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_FAILED, function (state) {
  return (0, _objectSpread2.default)({}, initialState, {
    downScaleHeight: state.downScaleHeight,
    downScaleWidth: state.downScaleWidth
  });
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_UPDATE_SDP_SUCCESS, function (state) {
  var nextState = Object.assign({}, state);
  nextState.mediaProcessingInProgress = true;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_UPDATE_SDP_FAILURE, function (state) {
  var nextState = Object.assign({}, state);
  nextState.mediaProcessingInProgress = false;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_ON_UPDATE_SDP_OFFER, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.remoteCapabilities = (0, _safeAccess.default)(action, 'payload.capability') || state.remoteCapabilities;
  nextState.mediaProcessingInProgress = true;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_ON_UPDATE_SDP_ANSWER, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.remoteCapabilities = Object.assign({}, state.remoteCapabilities, (0, _safeAccess.default)(action, 'payload.capability'));
  nextState.mediaProcessingInProgress = false;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_UPDATE_SDP_ANSWERED, function (state) {
  var nextState = Object.assign({}, state);
  nextState.mediaProcessingInProgress = false;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_OFFER_ANSWERED, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.remoteCapabilities = Object.assign({}, state.remoteCapabilities, (0, _safeAccess.default)(action, 'payload.capability'));
  nextState.mediaProcessingInProgress = false;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_SET_SCALED_RESOLUTION, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.scaledResolution.downScaleInForce = true;
  nextState.scaledResolution.originalHeight = (0, _safeAccess.default)(action, 'payload.originalHeight');
  nextState.scaledResolution.originalWidth = (0, _safeAccess.default)(action, 'payload.originalWidth');
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_RESET_SCALED_RESOLUTION, function (state) {
  var nextState = Object.assign({}, state);
  nextState.scaledResolution.downScaleInForce = false;
  nextState.scaledResolution.originalHeight = 0;
  nextState.scaledResolution.originalWidth = 0;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.INIT_NUCLEUS, function (state, action) {
  var nextState = Object.assign({}, state);

  if (action.payload.hasOwnProperty('downScaleHeight') && action.payload.hasOwnProperty('downScaleWidth')) {
    nextState.downScaleWidth = action.payload.downScaleWidth || c.DOWNSCALE_WIDTH;
    nextState.downScaleHeight = action.payload.downScaleHeight || c.DOWNSCALE_HEIGHT;
  }

  return nextState;
}), _createReducer));

exports.default = _default;

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(71));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread12 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _lodash = __webpack_require__(82);

var _createReducer;

/** @module state/nucleus/gqlChat */

/**
 * @constant {Object}
 * @description Initial state
 * @default
 */
var initialState = {
  rooms: {},
  roomCursors: {},
  roomMessages: {},
  outgoingMessages: {},
  revision: 0,
  enabled: true
};
/**
 * Stores directory service related data.
 */

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.INIT_NUCLEUS, function (state, action) {
  var nextState = (0, _objectSpread12.default)({}, state);

  if (Object.hasOwnProperty.call(action.payload, 'gqlChatEnabled')) {
    nextState.enabled = !!action.payload.gqlChatEnabled;
  }

  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GET_SESSION_SUCCESS, function (state, action) {
  var nextState = (0, _objectSpread12.default)({}, state); // checkin service can disable chat, but not enable it

  if ((0, _lodash.has)(action, 'payload.account.settings.chatEnabled')) {
    nextState.enabled = state.enabled && !!(0, _lodash.get)(action, 'payload.account.settings.chatEnabled');
  }

  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.AUTH_LOGOUT, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.CHAT_GET_ROOMS_SUCCESS, function (state, action) {
  var revision = state.revision + 1;
  return (0, _objectSpread12.default)({}, state, {
    revision: revision,
    rooms: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.CHAT_RECEIVED_MESSAGE, function (state, action) {
  var revision = state.revision + 1;
  var roomUUID = action.payload.roomUUID;
  var messages = (0, _objectSpread12.default)({}, state.roomMessages[roomUUID], (0, _defineProperty2.default)({}, action.payload.uuid, action.payload));
  var room = state.rooms[roomUUID];
  var rooms = (0, _objectSpread12.default)({}, state.rooms); // delete this message from our outgoing messages if we sent it

  var outgoingMessages = (0, _objectSpread12.default)({}, state.outgoingMessages);
  delete outgoingMessages[action.payload.optimisticUUID]; // we may not have room information at this time

  if (room) {
    var newRoom = (0, _objectSpread12.default)({}, room, {
      lastUpdated: action.payload.createdAt
    });
    rooms[room.uuid] = newRoom;
  }

  return (0, _objectSpread12.default)({}, state, {
    revision: revision,
    rooms: rooms,
    outgoingMessages: outgoingMessages,
    roomMessages: (0, _objectSpread12.default)({}, state.roomMessages, (0, _defineProperty2.default)({}, action.payload.roomUUID, messages))
  });
}), (0, _defineProperty2.default)(_createReducer, c.CHAT_GET_MESSAGES_BEGIN, function (state, action) {
  var _state$roomCursors$ac;

  var revision = state.revision + 1;
  return (0, _objectSpread12.default)({}, state, {
    revision: revision,
    roomCursors: (0, _objectSpread12.default)({}, state.roomCursors, (0, _defineProperty2.default)({}, action.payload.uuid, {
      cursor: (_state$roomCursors$ac = state.roomCursors[action.payload.uuid]) === null || _state$roomCursors$ac === void 0 ? void 0 : _state$roomCursors$ac.cursor,
      loading: true
    }))
  });
}), (0, _defineProperty2.default)(_createReducer, c.CHAT_GET_MESSAGES_SUCCESS, function (state, action) {
  var revision = state.revision + 1;
  var messages = (0, _objectSpread12.default)({}, state.roomMessages[action.payload.roomUUID], action.payload.messages);
  return (0, _objectSpread12.default)({}, state, {
    revision: revision,
    roomCursors: (0, _objectSpread12.default)({}, state.roomCursors, (0, _defineProperty2.default)({}, action.payload.roomUUID, {
      loading: false,
      cursor: action.payload.cursor
    })),
    roomMessages: (0, _objectSpread12.default)({}, state.roomMessages, (0, _defineProperty2.default)({}, action.payload.roomUUID, messages))
  });
}), (0, _defineProperty2.default)(_createReducer, c.CHAT_LEFT_ROOM, function (state, action) {
  var roomMessages = (0, _objectSpread12.default)({}, state.roomMessages);
  delete roomMessages[action.payload];
  var rooms = (0, _objectSpread12.default)({}, state.rooms);
  delete rooms[action.payload];
  return (0, _objectSpread12.default)({}, state, {
    roomMessages: roomMessages,
    rooms: rooms
  });
}), (0, _defineProperty2.default)(_createReducer, c.CHAT_JOINED_ROOM, function (state, action) {
  if (!action.payload) return state;
  return (0, _objectSpread12.default)({}, state, {
    rooms: (0, _objectSpread12.default)({}, state.rooms, (0, _defineProperty2.default)({}, action.payload.uuid, action.payload))
  });
}), (0, _defineProperty2.default)(_createReducer, c.CHAT_USER_LEFT_ROOM, function (state, action) {
  if (!action.payload) return state;
  var room = state.rooms[action.payload.room.uuid];
  if (!room) return state;
  var members = room.members.filter(function (m) {
    return m.uuid !== action.payload.user.uuid;
  });
  var newRoom = (0, _objectSpread12.default)({}, room, {
    members: members
  });
  return (0, _objectSpread12.default)({}, state, {
    rooms: (0, _objectSpread12.default)({}, state.rooms, (0, _defineProperty2.default)({}, action.payload.room.uuid, newRoom))
  });
}), (0, _defineProperty2.default)(_createReducer, c.CHAT_USER_JOINED_ROOM, function (state, action) {
  if (!action.payload) return state;
  var room = state.rooms[action.payload.room.uuid];
  if (!room) return state;
  var newRoom = (0, _objectSpread12.default)({}, room, {
    members: [].concat((0, _toConsumableArray2.default)(room.members), [action.payload.user])
  });
  return (0, _objectSpread12.default)({}, state, {
    rooms: (0, _objectSpread12.default)({}, state.rooms, (0, _defineProperty2.default)({}, action.payload.room.uuid, newRoom))
  });
}), (0, _defineProperty2.default)(_createReducer, c.CHAT_POST_MESSAGE_BEGIN, function (state, action) {
  var revision = state.revision + 1;
  return (0, _objectSpread12.default)({}, state, {
    revision: revision,
    outgoingMessages: (0, _objectSpread12.default)({}, state.outgoingMessages, (0, _defineProperty2.default)({}, action.payload.optimisticUUID, action.payload))
  });
}), (0, _defineProperty2.default)(_createReducer, c.CHAT_POST_MESSAGE_SUCCESS, function (state, action) {
  var revision = state.revision + 1;
  var outgoingMessages = (0, _objectSpread12.default)({}, state.outgoingMessages);
  delete outgoingMessages[action.payload.optimisticUUID];
  return (0, _objectSpread12.default)({}, state, {
    revision: revision,
    outgoingMessages: outgoingMessages
  });
}), (0, _defineProperty2.default)(_createReducer, c.CHAT_POST_MESSAGE_FAILURE, function (state, action) {
  var revision = state.revision + 1;
  var outgoingMessages = (0, _objectSpread12.default)({}, state.outgoingMessages);
  delete outgoingMessages[action.payload.optimisticUUID];
  return (0, _objectSpread12.default)({}, state, {
    revision: revision,
    outgoingMessages: outgoingMessages
  });
}), (0, _defineProperty2.default)(_createReducer, c.CHAT_LAST_READ_AT, function (state, action) {
  if (!action.payload) return state;
  var revision = state.revision + 1;
  var room = (0, _objectSpread12.default)({}, state.rooms[action.payload.roomUUID], {
    lastReadAt: action.payload.lastReadAt || Date.now()
  });
  return (0, _objectSpread12.default)({}, state, {
    revision: revision,
    rooms: (0, _objectSpread12.default)({}, state.rooms, (0, _defineProperty2.default)({}, action.payload.roomUUID, room))
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _mapKeys2 = _interopRequireDefault(__webpack_require__(622));

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

/** @module state/nucleus/groupSettings */
var initialState = {
  alertNotificationsEmail: '',
  alertNotificationsEnabled: false,
  alertNotificationsLocale: '',
  chatEnabled: false,
  customInviteShowAdditionalNumbers: null,
  // absence from the payload indicates that the feature is not enabled on the account
  customInviteShowConference: null,
  customInviteShowOtherWays: null,
  customInviteShowPin: null,
  customInviteShowSkype: null,
  // absence from the payload indicates that the feature is not enabled on the account
  domainsFilter: '',
  error: null,
  groupUUID: '',
  layout: c.MEETING_LAYOUT_TYPES.ALTERNATIVE,
  locale: '',
  maxMeetings: 0,
  maxUsers: 0,
  recordingEnabled: true,
  sso: false
};
/* notes:
 * - the use of account.features.unlimitedVMR with account.features.purchasedMeetingRooms is deprecated;
 *   account.features.purchasedMeetingRooms does not even exist in the api return or the db;
 *   use groupSettings.maxMeetings instead
 */

/* FYI: Other settings returned but not currently used
 * enabled: true
 * epBackgroundPreference: "SELF_VIEW"
 * epOnscreenPreference: "DEFAULT"
 * favoritesEnabled: true
 * h323RegistrationsEnabled: false
 * lecturerModeEnabled: true
 * loginSupport: "LOCAL_CREDENTIALS_ONLY"
 * maxBitrateDL: 2048
 * maxBitrateUL: 2048
 * moderatorModeEnabled: true
 * roomMaxParticipants: 50
 */

/**
 * Stores 'groupSettings'
 * @example
 * store
 *  +-- nucleus
 *    +-- groupSettings:
 *      +-- alertNotificationsEmail: {String}
 *      +-- alertNotificationsEnabled: {Boolean}
 *      +-- alertNotificationsLocale: {String}
 *      +-- chatEnabled: {Boolean}
 *      +-- customInviteShowAdditionalNumbers: {Boolean}
 *      +-- customInviteShowConference: {Boolean}
 *      +-- customInviteShowOtherWays: {Boolean}
 *      +-- customInviteShowPin: {Boolean}
 *      +-- customInviteShowSkype: {Boolean}
 *      +-- domainsFilter: {String}
 *      +-- error: {Object}
 *      +-- groupUUID: {String}
 *      +-- layout: {Number}
 *      +-- locale: {String}
 *      +-- maxMeetings: {Number} // maximum number of VMRs that can be created for an account (0 indicates unlimited)
 *      +-- maxUsers: {Number}
 *      +-- recordingEnabled: {Boolean}
 *      +-- sso: {Boolean}
 * @example
 * store
 *  +-- nucleus
 *    +-- groupSettings:
 *      +-- alertNotificationsEmail: 'test1@mikeblair.com',
 *      +-- alertNotificationsEnabled: true,
 *      +-- alertNotificationsLocale: 'en',
 *      +-- chatEnabled: true,
 *      +-- customInviteShowAdditionalNumbers: true,
 *      +-- customInviteShowConference: true,
 *      +-- customInviteShowOtherWays: true,
 *      +-- customInviteShowPin: true,
 *      +-- customInviteShowSkype: false,
 *      +-- domainsFilter: 'lifesize.com;lifesizecloud.com',
 *      +-- error: null,
 *      +-- groupUUID: 'a63dbc63-e6ac-4f3a-b144-32b80a04db4c',
 *      +-- layout: 2,
 *      +-- locale: 'en',
 *      +-- maxMeetings: 0,
 *      +-- maxUsers: 1000,
 *      +-- recordingEnabled: true,
 *      +-- sso: false
 */
// map the keynames we wish to change from the api response

exports.initialState = initialState;
var keyMap = {
  language: 'locale',
  mcuLayout: 'layout',
  selfSignupDomainFilter: 'domainsFilter'
};

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.GET_ACCOUNT_SETTINGS_REQUEST, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.GET_ACCOUNT_SETTINGS_SUCCESS, function (state, action) {
  var settings = (0, _mapKeys2.default)((0, _safeAccess.default)(action, 'payload'), function (value, key) {
    return keyMap[key] || key;
  });
  return (0, _objectSpread2.default)({}, state, settings, {
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.GET_ACCOUNT_SETTINGS_FAILURE, function (state, action) {
  var error = (0, _safeAccess.default)(action, 'payload') || c.GET_ACCOUNT_SETTINGS_FAILURE;
  return (0, _objectSpread2.default)({}, state, {
    error: error
  });
}), (0, _defineProperty2.default)(_createReducer, c.SET_ACCOUNT_SETTINGS_REQUEST, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.SET_ACCOUNT_SETTINGS_SUCCESS, function (state, action) {
  var settings = (0, _mapKeys2.default)((0, _safeAccess.default)(action, 'payload'), function (value, key) {
    return keyMap[key] || key;
  });
  return (0, _objectSpread2.default)({}, state, settings, {
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.SET_ACCOUNT_SETTINGS_FAILURE, function (state, action) {
  var error = (0, _safeAccess.default)(action, 'payload') || c.SET_ACCOUNT_SETTINGS_FAILURE;
  return (0, _objectSpread2.default)({}, state, {
    error: error
  });
}), (0, _defineProperty2.default)(_createReducer, c.MONITORING_GET_GROUP_SETTINGS_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.MONITORING_GET_GROUP_SETTINGS_SUCCESS, function (state, action) {
  var settings = (0, _safeAccess.default)(action, 'payload') || {};
  return (0, _objectSpread2.default)({}, state, settings, {
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.MONITORING_GET_GROUP_SETTINGS_FAILURE, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    error: (0, _safeAccess.default)(action, 'payload')
  });
}), (0, _defineProperty2.default)(_createReducer, c.MONITORING_PUT_GROUP_SETTINGS_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.MONITORING_PUT_GROUP_SETTINGS_SUCCESS, function (state, action) {
  var settings = (0, _safeAccess.default)(action, 'payload') || {};
  return (0, _objectSpread2.default)({}, state, settings, {
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.MONITORING_PUT_GROUP_SETTINGS_FAILURE, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    error: (0, _safeAccess.default)(action, 'payload.error')
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(174),
    baseForOwn = __webpack_require__(241),
    baseIteratee = __webpack_require__(90);

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

module.exports = mapKeys;


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

/** @module state/nucleus/invitation */

/**
 * @constant {Object}
 * @description Initial state
 * @default
 */
var initialState = {
  notOwnerWithPin: {},
  ownerWithPin: {},
  preview: {
    error: null,
    html: '',
    isFetching: false,
    text: ''
  },
  standard: {}
};
/**
 * Stores custom invitation service related data.
 */

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.AUTH_LOGOUT, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GET_CUSTOMINVITE_PREVIEW_FAILURE, function (state, action) {
  var preview = (0, _objectSpread2.default)({}, state.preview, {
    error: action.payload,
    isFetching: false
  });
  return (0, _objectSpread2.default)({}, state, {
    preview: preview
  });
}), (0, _defineProperty2.default)(_createReducer, c.GET_CUSTOMINVITE_PREVIEW_REQUEST, function (state) {
  var preview = (0, _objectSpread2.default)({}, state.preview, {
    error: null,
    isFetching: true
  });
  return (0, _objectSpread2.default)({}, state, {
    preview: preview
  });
}), (0, _defineProperty2.default)(_createReducer, c.GET_CUSTOMINVITE_PREVIEW_SUCCESS, function (state, action) {
  var preview = (0, _objectSpread2.default)({}, state.preview, {
    error: null,
    isFetching: false
  }, action.payload);
  return (0, _objectSpread2.default)({}, state, {
    preview: preview
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _clients = __webpack_require__(243);

var c = _interopRequireWildcard(__webpack_require__(3));

var _reduxUtils = __webpack_require__(13);

var _lodash = __webpack_require__(82);

var _createReducer;

/** @module state/nucleus/localization */
var initialState = {
  displayName: '',
  // language name in the specified language
  language: '',
  // language designator (macrolanguage): ISO 639-1 Code, two-characters, lowercase
  languageId: '',
  // BCP-47 language tag (examples: en-US, zh-Hans)
  localeCode: '' // TODO: REMOVE. This is a legacy reference (goal is to use languageId instead)

};
/**
 * Stores 'localization' related data.
 * @example
 * store
 *   +-- nucleus
 *     +-- localization
 *       |-- displayName: string
 *       |-- language: string
 *       |-- languageId: string
 */

exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.INIT_NUCLEUS, handleSetLocale), (0, _defineProperty2.default)(_createReducer, c.SET_LOCALE, handleSetLocale), _createReducer));

exports.default = _default;

function handleSetLocale(state, action) {
  var payload = (0, _lodash.pick)(action.payload, ['languageId', 'localeCode']);
  if (!payload.localeCode && !payload.languageId) return state;

  var languageId = _clients.localizationUtils.getLanguageId(payload.languageId || payload.localeCode);

  var languageObj = _clients.localizationUtils.getLanguageObj(languageId);

  return {
    displayName: languageObj.displayName,
    language: languageObj.language,
    languageId: languageObj.id,
    localeCode: languageObj.language
  };
}

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(CONFIG) {

var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _pick = _interopRequireDefault(__webpack_require__(122));

var _createReducer;

/** @module state/nucleus/media */

/**
 * @constant {Object}
 * @description Initial state of media settings
 * @default
 */
var initialState = {
  video: true,
  audio: true,
  devices: [],
  endAfterAcquirePrimaryStream: false,
  isAcquiringPrimaryStream: false,
  isPendingPermissions: false,
  primaryVideoSourceId: null,
  primaryAudioSourceId: null,
  primaryAudioOutputId: null,
  selectedVideoSourceId: null,
  selectedAudioSourceId: null,
  secondarySourceId: null,
  localPrimaryElementIds: [],
  remotePrimaryElementIds: [],
  localSecondaryElementIds: [],
  remoteSecondaryElementIds: [],
  localPrimaryStream: null,
  localPresentationStream: null,
  localPrimaryStreamAcquisitionError: null,
  localSecondaryStreamAcquisitionError: null,
  videoMuteSlide: null,
  hasOutgoingVideo: false,
  hasOutgoingAudio: false,
  togglingAudioMute: false,
  togglingVideoMute: false,
  isVideoMuted: false,
  isAudioMuted: false,
  hasRemoteStream: false,
  remoteStream: null,
  hasRemotePresentationStream: false,
  remotePresentationStream: null,
  videoNeeded: true,
  audioNeeded: true,
  playbackBlocked: false,
  videoConstraints: {
    width: 1280,
    height: 720
  },
  defaultVideoConstraints: undefined,
  selectedVideoConstraints: undefined
};
/**
 * Stores 'media' state.
 * @example
 * store
 *   +-- nucleus
 *     +-- media
 *       +-- video: bool
 *       +-- audio: bool
 *       +-- devices: array
 *       +-- primaryVideoSourceId: string
 *       +-- primaryAudioSourceId: string
 *       +-- secondarySourceId: string
 *       +-- localPrimaryElementIds: string
 *       +-- localSecondaryElementIds: string
 *       +-- remotePrimaryElementIds: string
 *       +-- remoteSecondaryElementIds: string
 */

exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.INIT_NUCLEUS, function (state, action) {
  var payload = (0, _pick.default)(action.payload, ['video', 'audio', 'localPrimaryElementIds', 'remotePrimaryElementIds', 'localSecondaryElementIds', 'remoteSecondaryElementIds', 'primaryVideoSourceId', 'primaryAudioSourceId', 'primaryAudioOutputId', 'secondarySourceId', 'videoMuteSlide', 'videoConstraints', 'defaultVideoConstraints']);
  return Object.assign({}, state, payload);
}), (0, _defineProperty2.default)(_createReducer, c.MEDIA_DEVICES_UPDATED, function (state, action) {
  var nextState = Object.assign({}, state, {
    devices: action.payload
  }); // If the selected source not longer exists, then set the source to null

  if (!action.payload.find(function (d) {
    return d.deviceId === state.selectedVideoSourceId;
  })) {
    nextState.selectedVideoSourceId = null;
  }

  var selectedAudioSource = state.devices.find(function (d) {
    return d.kind === 'audioinput' && d.deviceId === state.selectedAudioSourceId;
  });

  if (!action.payload.find(function (d) {
    return d.deviceId === state.selectedAudioSourceId && d.label === selectedAudioSource.label;
  })) {
    nextState.selectedAudioSourceId = null;
  }

  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.SET_DEFAULT_VIDEO, function (state, action) {
  return Object.assign({}, state, {
    video: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.SET_DEFAULT_AUDIO, function (state, action) {
  return Object.assign({}, state, {
    audio: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.SET_PRIMARY_VIDEO_SOURCE_ID, function (state, action) {
  return Object.assign({}, state, {
    primaryVideoSourceId: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.SET_VIDEO_SOURCE_QUALITY, function (state, action) {
  var _action$payload = action.payload,
      width = _action$payload.width,
      height = _action$payload.height,
      frameRate = _action$payload.frameRate;
  return Object.assign({}, state, {
    selectedVideoConstraints: {
      width: width,
      height: height,
      frameRate: frameRate
    },
    videoConstraints: {
      width: width,
      height: height,
      frameRate: frameRate
    }
  });
}), (0, _defineProperty2.default)(_createReducer, c.SET_PRIMARY_AUDIO_SOURCE_ID, function (state, action) {
  return Object.assign({}, state, {
    primaryAudioSourceId: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.SET_PRIMARY_AUDIO_OUTPUT_ID, function (state, action) {
  return Object.assign({}, state, {
    primaryAudioOutputId: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.SET_SELECTED_VIDEO_SOURCE_ID, function (state, action) {
  return Object.assign({}, state, {
    selectedVideoSourceId: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.SET_SELECTED_AUDIO_SOURCE_ID, function (state, action) {
  return Object.assign({}, state, {
    selectedAudioSourceId: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.GETUSERMEDIA_PENDING_PERMISSIONS, function (state) {
  if (!state.isAcquiringPrimaryStream) return state;
  return Object.assign({}, state, {
    isPendingPermissions: true
  });
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_UPDATE_SDP_ANSWERED, function (state, action) {
  if (CONFIG.calls.useGalaxySignalingMiddleware) return state;
  return (0, _objectSpread2.default)({}, state, {
    remoteStream: action.payload.remoteStream,
    remotePresentationStream: action.payload.remotePresentationStream
  });
}), (0, _defineProperty2.default)(_createReducer, c.END_LOCAL_STREAM, function (state) {
  if (state.isAcquiringPrimaryStream) {
    return Object.assign({}, state, {
      endAfterAcquirePrimaryStream: true
    });
  }

  return state;
}), (0, _defineProperty2.default)(_createReducer, c.ACQUIRE_LOCAL_PRIMARY_STREAM_BEGIN, function (state) {
  return Object.assign({}, state, {
    localPrimaryStreamAcquisitionError: null,
    endAfterAcquirePrimaryStream: false,
    isPendingPermissions: false,
    isAcquiringPrimaryStream: true,
    hasOutgoingAudio: false,
    hasOutgoingVideo: false
  });
}), (0, _defineProperty2.default)(_createReducer, c.ACQUIRE_LOCAL_PRIMARY_STREAM_SUCCESS, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.isPendingPermissions = false;
  nextState.isAcquiringPrimaryStream = false; // save the acquired device Id, IF:
  //   1) we don't already have a saved selection,

  if (!state.primaryVideoSourceId) {
    nextState.primaryVideoSourceId = (0, _safeAccess.default)(action, 'payload.videoSource.deviceId') || null;
  }

  if (!state.primaryAudioSourceId) {
    nextState.primaryAudioSourceId = (0, _safeAccess.default)(action, 'payload.audioSource.deviceId') || null;
  } // If we don't already have a selected source OR acquired source is different


  if (!state.selectedVideoSourceId || state.selectedVideoSourceId !== (0, _safeAccess.default)(action, 'payload.videoSource.deviceId')) {
    nextState.selectedVideoSourceId = (0, _safeAccess.default)(action, 'payload.videoSource.deviceId') || null;
  }

  if (!state.selectedAudioSourceId || state.selectedAudioSourceId !== (0, _safeAccess.default)(action, 'payload.audioSource.deviceId')) {
    nextState.selectedAudioSourceId = (0, _safeAccess.default)(action, 'payload.audioSource.deviceId') || null;
  }

  nextState.hasOutgoingVideo = !!action.payload.hasVideoTrack;
  nextState.hasOutgoingAudio = !!action.payload.hasAudioTrack;
  nextState.isVideoMuted = !action.payload.hasVideoTrack;
  nextState.isAudioMuted = !!action.payload.isAudioMuted;
  nextState.localPrimaryStream = action.payload.stream;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.LOCAL_STREAM_ENDED, function (state) {
  return Object.assign({}, state, {
    hasOutgoingVideo: false,
    hasOutgoingAudio: false,
    isVideoMuted: true,
    isAudioMuted: true,
    localPrimaryStream: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.LOCAL_PRESENTATION_STREAM_ACQUIRED, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    localPresentationStream: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.LOCAL_PRESENTATION_STREAM_UPDATED, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    localPresentationStream: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.LOCAL_PRESENTATION_STREAM_ENDED, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    localPresentationStream: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.LOCAL_STREAM_UPDATED, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    localPrimaryStream: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_STOP_PRESENTATION, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    localPresentationStream: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.RTC_REMOTE_STREAM_ADDED, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    hasRemoteStream: true,
    remoteStream: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.RTC_REMOTE_STREAM_UPDATED, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    hasRemoteStream: true,
    remoteStream: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.RTC_REMOTE_STREAM_REMOVED, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    hasRemoteStream: false,
    remoteStream: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.RTC_REMOTE_PRESENTATION_STREAM_ADDED, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    hasRemotePresentationStream: true,
    remotePresentationStream: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.REMOTE_PRESENTATION_STREAM_AVAILABLE, function (state, action) {
  if (!state.hasRemotePresentationStream) {
    return (0, _objectSpread2.default)({}, state, {
      hasRemotePresentationStream: true,
      remotePresentationStream: action.payload
    });
  }

  return state;
}), (0, _defineProperty2.default)(_createReducer, c.RTC_REMOTE_PRESENTATION_STREAM_REMOVED, function (state) {
  if (state.hasRemotePresentationStream) {
    return (0, _objectSpread2.default)({}, state, {
      hasRemotePresentationStream: false,
      remotePresentationStream: null
    });
  }

  return state;
}), (0, _defineProperty2.default)(_createReducer, c.ACQUIRE_LOCAL_SECONDARY_STREAM_BEGIN, function (state) {
  return Object.assign({}, state, {
    localSecondaryStreamAcquisitionError: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.ACQUIRE_LOCAL_PRIMARY_STREAM_FAILURE, function (state, action) {
  return Object.assign({}, state, {
    localPrimaryStreamAcquisitionError: action.payload,
    isPendingPermissions: false,
    isAcquiringPrimaryStream: false,
    hasOutgoingAudio: false,
    hasOutgoingVideo: false,
    isVideoMuted: true,
    isAudioMuted: true
  });
}), (0, _defineProperty2.default)(_createReducer, c.ACQUIRE_LOCAL_SECONDARY_STREAM_FAILURE, function (state, action) {
  return Object.assign({}, state, {
    localSecondaryStreamAcquisitionError: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.GALAXY_ACTION_TOGGLE_VIDEO_MUTE, function (state, action) {
  var actionMute = (0, _safeAccess.default)(action, 'payload.mute');
  var muted = actionMute === null ? !state.isVideoMuted : actionMute;
  return Object.assign({}, state, {
    isVideoMuted: muted,
    hasOutgoingVideo: !muted,
    togglingVideoMute: true
  });
}), (0, _defineProperty2.default)(_createReducer, c.TOGGLE_AUDIO_MUTE, function (state, action) {
  var actionMute = (0, _safeAccess.default)(action, 'payload.mute');
  var muted = actionMute === null ? !state.isAudioMuted : actionMute;
  return Object.assign({}, state, {
    isAudioMuted: muted,
    togglingAudioMute: true,
    audioNeeded: !muted
  });
}), (0, _defineProperty2.default)(_createReducer, c.LOCAL_VIDEO_MUTED, function (state, action) {
  var localPrimaryStream = action.payload || state.localPrimaryStream;
  return Object.assign({}, state, {
    localPrimaryStream: localPrimaryStream,
    hasOutgoingVideo: false,
    isVideoMuted: true,
    togglingVideoMute: false
  });
}), (0, _defineProperty2.default)(_createReducer, c.LOCAL_VIDEO_UNMUTED, function (state, action) {
  var localPrimaryStream = action.payload || state.localPrimaryStream;
  return Object.assign({}, state, {
    localPrimaryStream: localPrimaryStream,
    hasOutgoingVideo: true,
    isVideoMuted: false,
    togglingVideoMute: false
  });
}), (0, _defineProperty2.default)(_createReducer, c.LOCAL_AUDIO_MUTED, function (state) {
  return Object.assign({}, state, {
    isAudioMuted: true,
    togglingAudioMute: false
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_PLAYBACK_STARTED, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    playbackBlocked: false
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_PLAYBACK_BLOCKED, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    playbackBlocked: true
  });
}), (0, _defineProperty2.default)(_createReducer, c.LOCAL_AUDIO_UNMUTED, function (state) {
  return Object.assign({}, state, {
    hasOutgoingAudio: true,
    isAudioMuted: false,
    togglingAudioMute: false
  });
}), _createReducer));

exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(29)["default"]))

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _get2 = _interopRequireDefault(__webpack_require__(11));

var _createReducer;

/** @module state/nucleus/meetings */

/**
 * @constant {Object}
 * @description Initial state
 * @default
 */
var initialState = {
  isBusy: false,
  data: null,
  error: null,
  meetingSettingsBusy: false,
  meetingSettingsError: null,
  maxInactiveDays: 0,
  maxInactiveDaysError: null,
  isMaxInactiveDaysBusy: false,
  maxInactiveDaysOTM: 0,
  maxInactiveDaysOTMError: null,
  isMaxInactiveDaysOTMBusy: false
};

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.GET_MEETING_SETTINGS_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    meetingSettingsBusy: true,
    meetingSettingsError: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.GET_MEETING_SETTINGS_SUCCESS, function (state, action) {
  var maxInactiveDays = (0, _get2.default)(action.payload, 'maxInactiveDays', 0);
  return (0, _objectSpread2.default)({}, state, {
    meetingSettingsBusy: false,
    maxInactiveDays: (0, _get2.default)(action.payload, 'maxInactiveDays', 0),
    maxInactiveDaysOTM: (0, _get2.default)(action.payload, 'maxInactiveDaysOTM') || maxInactiveDays
  });
}), (0, _defineProperty2.default)(_createReducer, c.GET_MEETING_SETTINGS_FAILURE, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    meetingSettingsBusy: false,
    maxInactiveDays: 0,
    maxInactiveDaysOTM: 0,
    meetingSettingsError: (0, _get2.default)(action.payload, 'error', null)
  });
}), (0, _defineProperty2.default)(_createReducer, c.GET_MEETING_INACTIVE_DAYS_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isMaxInactiveDaysBusy: true
  });
}), (0, _defineProperty2.default)(_createReducer, c.GET_MEETING_INACTIVE_DAYS_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isMaxInactiveDaysBusy: false,
    maxInactiveDays: (0, _get2.default)(action.payload, 'maxInactiveDays', 0)
  });
}), (0, _defineProperty2.default)(_createReducer, c.GET_MEETING_INACTIVE_DAYS_FAILURE, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isMaxInactiveDaysBusy: false,
    maxInactiveDays: 0,
    maxInactiveDaysError: (0, _get2.default)(action.payload, 'error', null)
  });
}), (0, _defineProperty2.default)(_createReducer, c.SET_MEETING_INACTIVE_DAYS_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isMaxInactiveDaysBusy: true
  });
}), (0, _defineProperty2.default)(_createReducer, c.SET_MEETING_INACTIVE_DAYS_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isMaxInactiveDaysBusy: false,
    maxInactiveDays: (0, _get2.default)(action.payload, 'maxInactiveDays', 0)
  });
}), (0, _defineProperty2.default)(_createReducer, c.SET_MEETING_INACTIVE_DAYS_FAILURE, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isMaxInactiveDaysBusy: false,
    maxInactiveDaysError: (0, _get2.default)(action.payload, 'error', null)
  });
}), (0, _defineProperty2.default)(_createReducer, c.SET_MEETING_INACTIVE_DAYS_OTM_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isMaxInactiveDaysOTMBusy: true
  });
}), (0, _defineProperty2.default)(_createReducer, c.SET_MEETING_INACTIVE_DAYS_OTM_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isMaxInactiveDaysOTMBusy: false,
    maxInactiveDaysOTM: (0, _get2.default)(action.payload, 'maxInactiveDaysOTM', 0)
  });
}), (0, _defineProperty2.default)(_createReducer, c.SET_MEETING_INACTIVE_DAYS_OTM_FAILURE, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isMaxInactiveDaysOTMBusy: false,
    maxInactiveDaysOTMError: (0, _get2.default)(action.payload, 'error', null)
  });
}), (0, _defineProperty2.default)(_createReducer, c.CREATE_MEETING_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isBusy: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.CREATE_MEETING_FAILURE, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isBusy: false,
    error: (0, _get2.default)(action, 'payload', null)
  });
}), (0, _defineProperty2.default)(_createReducer, c.CREATE_MEETING_SUCCESS, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isBusy: false,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.DELETE_MEETING_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isBusy: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.DELETE_MEETING_FAILURE, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isBusy: false,
    error: (0, _get2.default)(action, 'payload', null)
  });
}), (0, _defineProperty2.default)(_createReducer, c.DELETE_MEETING_SUCCESS, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isBusy: false,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.UPDATE_MEETING_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isBusy: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.UPDATE_MEETING_FAILURE, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isBusy: false,
    error: (0, _get2.default)(action, 'payload', null)
  });
}), (0, _defineProperty2.default)(_createReducer, c.UPDATE_MEETING_SUCCESS, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isBusy: false,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.RESET_MEETING_ERROR_STATE, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isBusy: false,
    error: null,
    isMaxInactiveDaysBusy: false,
    maxInactiveDaysError: null,
    isMaxInactiveDaysOTMBusy: false,
    maxInactiveDaysOTMError: null
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

/** @module state/nucleus/network */

/**
 * @constant {Object}
 * @description Initial state
 * @default
 */
var initialState = {
  state: c.NETWORK_STATUS_OFFLINE
};
/**
 * Stores 'network' related data.
 * @example
 * store
 *   +-- nucleus
 *     +-- network
 *       +-- state: string
 * @example
 * store
 * +-- nucleus
 *     +-- network
 *       +-- state: 'NETWORK_STATUS_ONLINE'
 */

exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.NETWORK_ONLINE, function (state) {
  return Object.assign({}, state, {
    state: c.NETWORK_STATUS_ONLINE
  });
}), (0, _defineProperty2.default)(_createReducer, c.NETWORK_OFFLINE, function (state) {
  return Object.assign({}, state, {
    state: c.NETWORK_STATUS_OFFLINE
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var _get2 = _interopRequireDefault(__webpack_require__(11));

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

/** @module state/nucleus/pairedDevices */

/**
 * @constant {Object}
 * @description Initial state
 * @default
 */
var initialState = {
  isFetching: false,
  isDeleting: false,
  isPairing: false,
  data: null,
  error: null,
  removePairingError: null,
  addPairingError: null,
  removeDeviceError: null,
  isFetchingLicenseCount: false,
  getLicenseCountError: null,
  licenseCountObject: null
};
/**
 * Stores directory service related data.
 */

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.AUTH_LOGOUT, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GET_PAIRED_DEVICES_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: true,
    error: null,
    addPairingError: null,
    removePairingError: null,
    removeDeviceError: null,
    data: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.GET_PAIRED_DEVICES_FAILURE, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    error: action.payload,
    addPairingError: null,
    removePairingError: null,
    removeDeviceError: null,
    data: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.GET_PAIRED_DEVICES_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    error: null,
    addPairingError: null,
    removePairingError: null,
    removeDeviceError: null,
    data: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.DELETE_DEVICE_PAIRING_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isDeleting: true,
    error: null,
    addPairingError: null,
    removePairingError: null,
    removeDeviceError: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.DELETE_DEVICE_PAIRING_FAILURE, function (state, action) {
  // Do not clear view data on an un-pairing exception
  return (0, _objectSpread2.default)({}, state, {
    isDeleting: false,
    error: null,
    addPairingError: null,
    removePairingError: action.payload,
    removeDeviceError: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.DELETE_DEVICE_PAIRING_SUCCESS, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isDeleting: false,
    error: null,
    addPairingError: null,
    removePairingError: null,
    removeDeviceError: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.DEVICE_PAIRING_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isPairing: true,
    error: null,
    addPairingError: null,
    removePairingError: null,
    removeDeviceError: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.DEVICE_PAIRING_FAILURE, function (state, action) {
  // Do not clear view data on an un-pairing exception
  return (0, _objectSpread2.default)({}, state, {
    isPairing: false,
    error: null,
    addPairingError: action.payload,
    removePairingError: null,
    removeDeviceError: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.DEVICE_PAIRING_SUCCESS, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isPairing: false,
    error: null,
    addPairingError: null,
    removePairingError: null,
    removeDeviceError: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.GET_PAIRED_DEVICE_LICENSE_COUNT_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isFetchingLicenseCount: true,
    getLicenseCountError: null,
    licenseCountObject: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.GET_PAIRED_DEVICE_LICENSE_COUNT_FAILURE, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetchingLicenseCount: false,
    getLicenseCountError: action.payload,
    licenseCountObject: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.GET_PAIRED_DEVICE_LICENSE_COUNT_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isFetchingLicenseCount: false,
    getLicenseCountError: null,
    licenseCountObject: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.RENAME_DEVICE_SUCCESS, function (state, action) {
  var record = (0, _get2.default)(action, 'payload.ITEM', {});

  if (record.serialNumber && state.data) {
    var nextState = (0, _objectSpread2.default)({}, state);
    nextState.data.deviceList = (0, _get2.default)(nextState, 'data.deviceList', []).filter(function (d) {
      return d.serialNumber !== record.serialNumber;
    }).concat([record]);
    return nextState;
  }

  return state;
}), (0, _defineProperty2.default)(_createReducer, c.REMOVE_DEVICE_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isRemovingDevice: true,
    removePairingError: null,
    addPairingError: null,
    removeDeviceError: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.REMOVE_DEVICE_FAILURE, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isRemovingDevice: false,
    removePairingError: null,
    addPairingError: null,
    removeDeviceError: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.REMOVE_DEVICE_SUCCESS, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isRemovingDevice: false,
    removePairingError: null,
    addPairingError: null,
    removeDeviceError: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.DEVICE_PAIRING_RESET_ERROR_STATE, function (state) {
  // reset the error states only
  return (0, _objectSpread2.default)({}, state, {
    error: null,
    removePairingError: null,
    addPairingError: null,
    removeDeviceError: null,
    getLicenseCountError: null
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(CONFIG) {

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var _reduxStorage = __webpack_require__(204);

var _persistence = __webpack_require__(199);

var _createReducer;

/** @module state/nucleus/persistence */
var initialState = {
  enabled: CONFIG.persistence.enabled,
  isLoaded: false,
  mostRecentSave: 0
};
/**
 * Stores 'persistence' related data.
 * @example
 * store
 *   +-- nucleus
 *     +-- persistence
 *       |-- isLoaded: true //Loaded saved data
 *       +-- mostRecentSave: 0 //No Saves
 * @example
 * store
 *   +-- nucleus
 *     +-- persistence
 *       |-- isLoaded: true //Loaded saved data
 *       +-- mostRecentSave:  //1457981724 Timestamp generated by most recent save.
 */

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, _persistence.PERSISTENCE_DISABLED, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    enabled: false
  });
}), (0, _defineProperty2.default)(_createReducer, _persistence.PERSISTENCE_ENABLED, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    enabled: true
  });
}), (0, _defineProperty2.default)(_createReducer, _reduxStorage.LOAD, function (state) {
  var nextState = Object.assign({}, state);
  nextState.isLoaded = true;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, _reduxStorage.SAVE, function (state) {
  var nextState = Object.assign({}, state);
  nextState.mostRecentSave = Date.now();
  return nextState;
}), _createReducer));

exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(29)["default"]))

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleActions = exports.handleAction = exports.createAction = undefined;

var _createAction = __webpack_require__(631);

var _createAction2 = _interopRequireDefault(_createAction);

var _handleAction = __webpack_require__(287);

var _handleAction2 = _interopRequireDefault(_handleAction);

var _handleActions = __webpack_require__(632);

var _handleActions2 = _interopRequireDefault(_handleActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.createAction = _createAction2.default;
exports.handleAction = _handleAction2.default;
exports.handleActions = _handleActions2.default;

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createAction;
function identity(t) {
  return t;
}

function createAction(type, actionCreator, metaCreator) {
  var finalActionCreator = typeof actionCreator === 'function' ? actionCreator : identity;

  var actionHandler = function actionHandler() {
    var hasError = (arguments.length <= 0 ? undefined : arguments[0]) instanceof Error;

    var action = {
      type: type
    };

    var payload = hasError ? arguments.length <= 0 ? undefined : arguments[0] : finalActionCreator.apply(undefined, arguments);
    if (!(payload === null || payload === undefined)) {
      action.payload = payload;
    }

    if (hasError) {
      // Handle FSA errors where the payload is an Error object. Set error.
      action.error = true;
    }

    if (typeof metaCreator === 'function') {
      action.meta = metaCreator.apply(undefined, arguments);
    }

    return action;
  };

  actionHandler.toString = function () {
    return type;
  };

  return actionHandler;
}

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = handleActions;

var _handleAction = __webpack_require__(287);

var _handleAction2 = _interopRequireDefault(_handleAction);

var _ownKeys = __webpack_require__(633);

var _ownKeys2 = _interopRequireDefault(_ownKeys);

var _reduceReducers = __webpack_require__(634);

var _reduceReducers2 = _interopRequireDefault(_reduceReducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function handleActions(handlers, defaultState) {
  var reducers = (0, _ownKeys2.default)(handlers).map(function (type) {
    return (0, _handleAction2.default)(type, handlers[type]);
  });
  var reducer = _reduceReducers2.default.apply(undefined, _toConsumableArray(reducers));

  return typeof defaultState !== 'undefined' ? function () {
    var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
    var action = arguments[1];
    return reducer(state, action);
  } : reducer;
}

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ownKeys;
function ownKeys(object) {
  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
    return Reflect.ownKeys(object);
  }

  var keys = Object.getOwnPropertyNames(object);

  if (typeof Object.getOwnPropertySymbols === 'function') {
    keys = keys.concat(Object.getOwnPropertySymbols(object));
  }

  return keys;
}

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  for (var _len = arguments.length, reducers = Array(_len), _key = 0; _key < _len; _key++) {
    reducers[_key] = arguments[_key];
  }

  return function (previous, current) {
    return reducers.reduce(function (p, r) {
      return r(p, current);
    }, previous);
  };
};

module.exports = exports["default"];

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(205);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(636);

var _lodash4 = _interopRequireDefault(_lodash3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = function (oldState, newState) {
    var result = _extends({}, oldState);

    for (var key in newState) {
        if (!newState.hasOwnProperty(key)) {
            continue;
        }
        var value = newState[key];

        // Assign if we don't need to merge at all
        if (!result.hasOwnProperty(key)) {
            result[key] = (0, _lodash2['default'])(value) && !Array.isArray(value) ? (0, _lodash4['default'])({}, value) : value;
            continue;
        }

        var oldValue = result[key];

        if ((0, _lodash2['default'])(value) && !Array.isArray(value)) {
            result[key] = (0, _lodash4['default'])({}, oldValue, value);
        } else {
            result[key] = value;
        }
    }

    return result;
};

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeMax = Math.max,
    nativeNow = Date.now;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = merge;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(103)(module)))

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _createReducer;

/** @module state/nucleus/phoneHD */

/**
 * @constant {Object}
 * @description Initial state
 * @default
 */
var initialState = {
  enabled: false,
  customization: null
};
/**
 * Stores directory service related data.
 */

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.AUTH_LOGOUT, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.INIT_NUCLEUS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    enabled: !!(0, _safeAccess.default)(action, 'payload.clientInfo.phoneModelNumber')
  });
}), (0, _defineProperty2.default)(_createReducer, c.SET_DEVICE_INFO, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    enabled: !!(0, _safeAccess.default)(action, 'payload.phoneModelNumber')
  });
}), (0, _defineProperty2.default)(_createReducer, c.WAMP_SUBSCRIPTION_PHONEHD_CUSTOMIZATION_EVENT, function (state, action) {
  return Object.assign({}, state, {
    customization: action.payload
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(CONFIG) {

var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _get = _interopRequireDefault(__webpack_require__(11));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

/** @module state/nucleus/provisioning */
var initialState = {
  changePasswordURL: null,
  vcRecordingURL: null
};
/**
 * Stores 'provisioning' related data returned after successful authentication.
 * @example
 * store
 *   +-- nucleus
 *     +-- provisioning: {Object}
 * @example
 * store
 * +-- nucleus
 *     +-- provisioning:
 *       +-- key: value
 */

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.AUTH_LOGOUT, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GET_SESSION_SUCCESS, function (state, action) {
  var extension = (0, _get.default)(action, 'payload.session.extension');
  if (!extension) return state;
  return {
    changePasswordURL: "https://login.".concat(CONFIG.environment, "/ls/forgotpassword/"),
    vcRecordingURL: (0, _get.default)(action, 'payload.account.settings.recordingUrl')
  };
}), _createReducer));

exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(29)["default"]))

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread5 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

/** @module state/nucleus/proxy */

/**
 * @constant {Object}
 * @description Initial state
 * @default
 */
var initialState = {
  error: null,
  realm: null,
  sessionId: null,
  url: null,
  subscriptions: {},
  inFlightSends: {}
};
/**
 * Stores 'proxy' service related data.
 * @example
 * store
 *   +-- nucleus
 *     +-- proxy
 *       |-- url: string
 *       |-- realm: string
 *       +-- error: mixed
 * @example
 * store
 * +-- nucleus
 *     +-- proxy
 *       |-- url: 'x55733050-lan.lifesizecloudbeta.com'
 *       |-- realm: 'lifesize'
 *       +-- error: null
 */

exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.WAMP_CONNECT_BEGIN, function (state, action) {
  return (0, _objectSpread5.default)({}, initialState, {
    realm: (0, _safeAccess.default)(action, 'payload.realm'),
    url: (0, _safeAccess.default)(action, 'payload.url')
  });
}), (0, _defineProperty2.default)(_createReducer, c.WAMP_CONNECT_SUCCESS, function (state, action) {
  return (0, _objectSpread5.default)({}, state, {
    sessionId: (0, _safeAccess.default)(action, 'payload.sessionId'),
    subscriptions: {}
  });
}), (0, _defineProperty2.default)(_createReducer, c.WAMP_CONNECT_ERROR, function (_, action) {
  return (0, _objectSpread5.default)({}, initialState, {
    error: (0, _safeAccess.default)(action, 'payload.error')
  });
}), (0, _defineProperty2.default)(_createReducer, c.WAMP_SEND_BEGIN, function (state, action) {
  return (0, _objectSpread5.default)({}, state, {
    inFlightSends: (0, _objectSpread5.default)({}, state.inFlightSends, (0, _defineProperty2.default)({}, action.payload.id, Date.now()))
  });
}), (0, _defineProperty2.default)(_createReducer, c.WAMP_SEND_ERROR, function (state, action) {
  var _action$payload, _action$payload$reque;

  var nextState = (0, _objectSpread5.default)({}, state);
  delete nextState.inFlightSends[(_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : (_action$payload$reque = _action$payload.request) === null || _action$payload$reque === void 0 ? void 0 : _action$payload$reque.id];
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.WAMP_SEND_SUCCESS, function (state, action) {
  var _action$payload2, _action$payload2$requ;

  var nextState = (0, _objectSpread5.default)({}, state);
  delete nextState.inFlightSends[(_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : (_action$payload2$requ = _action$payload2.request) === null || _action$payload2$requ === void 0 ? void 0 : _action$payload2$requ.id];
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.WAMP_CONNECTION_DISPOSED_HEALTHY, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.WAMP_CONNECTION_DISPOSED_JWT_ERROR, function (_, action) {
  return (0, _objectSpread5.default)({}, initialState, {
    error: (0, _safeAccess.default)(action, 'payload')
  });
}), (0, _defineProperty2.default)(_createReducer, c.WAMP_CONNECTION_DISPOSED_UNEXPECTED, function (_, action) {
  return (0, _objectSpread5.default)({}, initialState, {
    error: (0, _safeAccess.default)(action, 'payload')
  });
}), (0, _defineProperty2.default)(_createReducer, c.WAMP_SUBSCRIBE_ERROR, function (state, action) {
  return (0, _objectSpread5.default)({}, state, {
    subscriptions: (0, _objectSpread5.default)({}, state.subscriptions, (0, _defineProperty2.default)({}, action.payload.topic, false))
  });
}), (0, _defineProperty2.default)(_createReducer, c.WAMP_SUBSCRIBE_SUCCESS, function (state, action) {
  return (0, _objectSpread5.default)({}, state, {
    subscriptions: (0, _objectSpread5.default)({}, state.subscriptions, (0, _defineProperty2.default)({}, action.payload.topic, action.payload.subscription))
  });
}), (0, _defineProperty2.default)(_createReducer, c.WAMP_UNSUBSCRIBE_SUCCESS, function (state, action) {
  var subscriptions = (0, _objectSpread5.default)({}, state.subscriptions);
  delete subscriptions[action.payload.topic];
  return (0, _objectSpread5.default)({}, state, {
    subscriptions: subscriptions
  });
}), (0, _defineProperty2.default)(_createReducer, c.WAMP_UNSUBSCRIBE_ERROR, function (state, action) {
  var subscriptions = (0, _objectSpread5.default)({}, state.subscriptions);
  delete subscriptions[action.payload.topic];
  return (0, _objectSpread5.default)({}, state, {
    subscriptions: subscriptions
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _get2 = _interopRequireDefault(__webpack_require__(11));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

var initialState = [];

var handleGetSessionSuccess = function handleGetSessionSuccess(state, action) {
  var pstnNumbers = (0, _get2.default)(action, 'payload.account.settings.pstnNumbers', []);
  return pstnNumbers;
};

var reducer = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.AUTH_LOGOUT, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GET_SESSION_SUCCESS, function (state, action) {
  return handleGetSessionSuccess(state, action);
}), _createReducer));
var _default = reducer;
exports.default = _default;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = __webpack_require__(128);

var _cloudInfo = _interopRequireDefault(__webpack_require__(642));

var _recordingsMine = _interopRequireDefault(__webpack_require__(643));

var _recordingsFeed = _interopRequireDefault(__webpack_require__(644));

var _recordingWatchList = _interopRequireDefault(__webpack_require__(645));

var _recordingsAdd = _interopRequireDefault(__webpack_require__(646));

var _recordingsDelete = _interopRequireDefault(__webpack_require__(647));

var _recordingsSingle = _interopRequireDefault(__webpack_require__(648));

var _recordingsRelated = _interopRequireDefault(__webpack_require__(649));

var _videoLike = _interopRequireDefault(__webpack_require__(650));

var _videoProperties = _interopRequireDefault(__webpack_require__(651));

var _videoSharing = _interopRequireDefault(__webpack_require__(652));

var _recordingsAuth = _interopRequireDefault(__webpack_require__(653));

var _meetingSharing = _interopRequireDefault(__webpack_require__(655));

var _default = (0, _redux.combineReducers)({
  myRecordings: _recordingsMine.default,
  recordingsFeed: _recordingsFeed.default,
  recordingWatchList: _recordingWatchList.default,
  recordingsAdd: _recordingsAdd.default,
  recordingsDelete: _recordingsDelete.default,
  recordingsSingle: _recordingsSingle.default,
  recordingsRelated: _recordingsRelated.default,
  cloudInfo: _cloudInfo.default,
  videoLike: _videoLike.default,
  videoProperties: _videoProperties.default,
  videoSharing: _videoSharing.default,
  meetingSharing: _meetingSharing.default,
  recordingsAuth: _recordingsAuth.default
});

exports.default = _default;

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

var initialState = {
  cloudUsers: [],
  cloudMeetings: [],
  isFetching: false,
  error: null
};
exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.VIDEO_GET_CLOUD_USERS_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_GET_CLOUD_USERS_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    cloudUsers: action.payload,
    isFetching: false,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_GET_CLOUD_USERS_FAILED, function (state, action) {
  return (0, _objectSpread2.default)({}, initialState, {
    cloudUsers: [],
    isFetching: false,
    error: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_GET_CLOUD_MEETINGS_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_GET_CLOUD_MEETINGS_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    cloudMeetings: action.payload,
    isFetching: false,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_GET_CLOUD_MEETINGS_FAILED, function (state, action) {
  return (0, _objectSpread2.default)({}, initialState, {
    cloudMeetings: [],
    isFetching: false,
    error: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.RECORDINGS_LOOKUP_USER_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.RECORDINGS_LOOKUP_USER_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, action.payload, {
    isFetching: false,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.RECORDINGS_LOOKUP_USER_FAILED, function (state, action) {
  return (0, _objectSpread2.default)({}, initialState, {
    isFetching: false,
    error: action.payload
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

/**
 * The structure of the post data response
 * /api/v1/cloud-api/cloudvideos/
 */
var initialState = {
  count: 0,
  data: [],
  pageno: 1,
  limit: 5,
  offset: 0,
  isFetching: false,
  error: null
};
exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.RECORDINGS_FETCH_MY_RECORDINGS_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.RECORDINGS_FETCH_MY_RECORDINGS_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, action.payload, {
    isFetching: false,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.RECORDINGS_FETCH_MY_RECORDINGS_FAILED, function (state, action) {
  return (0, _objectSpread2.default)({}, initialState, {
    isFetching: false,
    error: action.payload
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _get = _interopRequireDefault(__webpack_require__(11));

var _createReducer;

/**
 * The structure of the post data response
 * /api/v1/cloud-api/cloudvideos/
 */
var initialState = {
  count: 0,
  data: [],
  error: null,
  isFetching: false,
  limit: 24,
  offset: 0,
  pageno: 1,
  requestIndex: 0
};
exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.RECORDINGS_FETCH_FEED_BEGIN, function (state, action) {
  var requestIndex = (0, _get.default)(action, 'payload.requestIndex');
  return (0, _objectSpread2.default)({}, state, {
    isFetching: true,
    error: null,
    requestIndex: requestIndex
  });
}), (0, _defineProperty2.default)(_createReducer, c.RECORDINGS_FETCH_FEED_SUCCESS, function (state, action) {
  if ((0, _get.default)(action, 'payload.requestIndex', 0) !== state.requestIndex) return state;
  return (0, _objectSpread2.default)({}, state, action.payload, {
    isFetching: false,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.RECORDINGS_FETCH_FEED_FAILED, function (state, action) {
  if ((0, _get.default)(action, 'payload.requestIndex', 0) !== state.requestIndex) return state;
  return (0, _objectSpread2.default)({}, initialState, {
    isFetching: false,
    error: action.payload
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

/**
 * The structure of the post data response
 * /api/v1/cloud-api/cloudvideos/
 * @constant {Object}
 * @description Initial state
 * @defaultgit
 */
var initialState = {
  count: 0,
  data: [],
  pageno: 1,
  limit: 5,
  offset: 0,
  isFetching: false,
  error: null
};
exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.RECORDINGS_FETCH_WATCH_LIST_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.RECORDINGS_FETCH_WATCH_LIST_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, action.payload, {
    isFetching: false,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.RECORDINGS_FETCH_WATCH_LIST_FAILED, function (state, action) {
  return (0, _objectSpread2.default)({}, initialState, {
    isFetching: false,
    error: action.payload
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

/**
 * The structure of the delete/get response
 * /api/v1/cloud-api/wlater/?identifier
 */
var initialState = {
  isAdding: false,
  hasBeenAdded: false,
  error: null
};
exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.RECORDINGS_ADD_TO_WATCHLIST_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isAdding: true,
    hasBeenAdded: false,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.RECORDINGS_ADD_TO_WATCHLIST_SUCCESS, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isAdding: false,
    hasBeenAdded: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.RECORDINGS_ADD_TO_WATCHLIST_FAILED, function (state, action) {
  return (0, _objectSpread2.default)({}, initialState, {
    isAdding: false,
    hasBeenAdded: false,
    error: action.payload
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

/**
 * The structure of the delete/get response
 * /api/v1/cloud-api/clouddelete/?identifier
 */
var initialState = {
  isDeleting: false,
  hasBeenDeleted: false,
  error: null
};
exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.RECORDINGS_DELETE_RECORDING_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isDeleting: true,
    hasBeenDeleted: false,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.RECORDINGS_DELETE_RECORDING_SUCCESS, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isDeleting: false,
    hasBeenDeleted: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.RECORDINGS_DELETE_RECORDING_FAILED, function (state, action) {
  return (0, _objectSpread2.default)({}, initialState, {
    isDeleting: false,
    hasBeenDeleted: false,
    error: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.RESET_RECORDINGS_DELETE_ERROR_STATE, function () {
  return initialState;
}), _createReducer));

exports.default = _default;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _createReducer;

/**
 * The structure of the single video response
 * /api/v1/cloud-api/cloudvideo/
 */
var initialState = {
  data: {},
  isFetching: false,
  notFound: false,
  error: null
};
exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.RECORDINGS_FETCH_SINGLE_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: true,
    notFound: false,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.RECORDINGS_FETCH_SINGLE_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, action.payload, {
    isFetching: false,
    notFound: false,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.RECORDINGS_FETCH_SINGLE_FAILED, function (state, action) {
  var notFound = (0, _safeAccess.default)(action, 'payload.message') === 'NOT FOUND';
  return (0, _objectSpread2.default)({}, initialState, {
    isFetching: false,
    notFound: notFound,
    error: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.RECORDINGS_ADD_TO_WATCHLIST_SUCCESS, function (state) {
  var nextState = (0, _objectSpread2.default)({}, state);
  nextState.data.wlater_done = true;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.RECORDINGS_REMOVE_FROM_WATCHLIST_SUCCESS, function (state) {
  var nextState = (0, _objectSpread2.default)({}, state);
  nextState.data.wlater_done = false;
  return nextState;
}), _createReducer));

exports.default = _default;

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

/**
 * The structure of related video response (collection)
 * /api/v1/cloud-api/cloudrelated/?identifier/in/all
 */
var initialState = {
  data: [],
  isFetching: false,
  error: null
};
exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.RECORDINGS_FETCH_RELATED_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.RECORDINGS_FETCH_RELATED_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, action.payload, {
    isFetching: false,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.RECORDINGS_FETCH_RELATED_FAILED, function (state, action) {
  return (0, _objectSpread2.default)({}, initialState, {
    isFetching: false,
    error: action.payload
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

var initialState = {
  data: [],
  isUpdating: false,
  hasBeenLiked: false,
  error: null
};
exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.VIDEO_LIKE_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isUpdating: true,
    hasBeenLiked: false,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_LIKE_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, action.payload, {
    isUpdating: false,
    hasBeenLiked: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_LIKE_FAILED, function (state, action) {
  return (0, _objectSpread2.default)({}, initialState, {
    isUpdating: false,
    hasBeenLiked: false,
    error: action.payload
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

var initialState = {
  data: {},
  isFetching: false,
  hasFetchCompleted: false,
  isUpdating: false,
  hasUpdateCompleted: false,
  error: null
};
exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.VIDEO_GET_PROPS_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    data: null,
    isFetching: true,
    hasFetchCompleted: false,
    isUpdating: false,
    hasUpdateCompleted: false,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_GET_PROPS_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, action.payload, {
    data: (0, _objectSpread2.default)({}, action.payload),
    isFetching: false,
    hasFetchCompleted: true,
    isUpdating: false,
    hasUpdateCompleted: false,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_GET_PROPS_FAILED, function (state, action) {
  return (0, _objectSpread2.default)({}, initialState, {
    data: null,
    isFetching: false,
    hasFetchCompleted: true,
    isUpdating: false,
    hasUpdateCompleted: false,
    error: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_SET_PROPS_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    hasFetchCompleted: false,
    isUpdating: true,
    hasUpdateCompleted: false,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_SET_PROPS_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, action.payload, {
    isFetching: false,
    hasFetchCompleted: false,
    isUpdating: false,
    hasUpdateCompleted: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_SET_PROPS_FAILED, function (state, action) {
  return (0, _objectSpread2.default)({}, initialState, {
    isFetching: false,
    hasFetchCompleted: false,
    isUpdating: false,
    hasUpdateCompleted: true,
    error: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.RESET_VIDEO_PROPS_ERROR_STATE, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: false,
    isUpdating: false,
    error: null
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _get = _interopRequireDefault(__webpack_require__(11));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

var initialState = {
  data: [],
  isFetching: false,
  isUpdating: false,
  isFetchingPublicUrl: false,
  isFetchingGroupUrl: false,
  error: null
};
exports.initialState = initialState;

var getPublicUrl = function getPublicUrl(auth, noAuth) {
  return "".concat((0, _get.default)(window, 'location.protocol', ''), "//").concat((0, _get.default)(window, 'location.hostname', ''), "/#/publicvideo/").concat(auth, "?vcpubtoken=").concat(noAuth);
};

var getGroupUrl = function getGroupUrl(auth, noAuth) {
  return "".concat((0, _get.default)(window, 'location.protocol', ''), "//").concat((0, _get.default)(window, 'location.hostname', ''), "/#/singlevideo/").concat(auth, "?vcsharetoken=").concat(noAuth);
};

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.VIDEO_GET_SHARE_PROPS_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    error: null,
    isFetching: true
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_GET_SHARE_PROPS_SUCCESS, function (state, action) {
  var data = (0, _objectSpread2.default)({}, action.payload);
  data.publicUrl = (0, _get.default)(action, 'payload.public_allowed') ? getPublicUrl((0, _get.default)(action, 'payload.public_share_urls.auth', ''), (0, _get.default)(action, 'payload.public_share_urls.noAuth', '')) : null;
  data.groupUrl = getGroupUrl((0, _get.default)(action, 'payload.share_urls.auth', ''), (0, _get.default)(action, 'payload.share_urls.noAuth', ''));
  return (0, _objectSpread2.default)({}, state, {
    data: data,
    error: null,
    isFetching: false
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_GET_SHARE_PROPS_FAILED, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    error: action.payload,
    isFetching: false
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_GET_SHARE_LINK_GROUP_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    error: null,
    isFetchingGroupUrl: true
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_GET_SHARE_LINK_GROUP_SUCCESS, function (state, action) {
  var data = (0, _objectSpread2.default)({}, state.data);
  data.groupUrl = getGroupUrl((0, _get.default)(action, 'payload.auth', ''), (0, _get.default)(action, 'payload.noAuth', ''));
  data.share_urls = action.payload;
  return (0, _objectSpread2.default)({}, state, {
    data: data,
    error: null,
    isFetchingGroupUrl: false
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_GET_SHARE_LINK_GROUP_FAILED, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    error: action.payload,
    isFetchingGroupUrl: false
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_GET_SHARE_LINK_GLOBAL_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    error: null,
    isFetchingPublicUrl: true
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_GET_SHARE_LINK_GLOBAL_SUCCESS, function (state, action) {
  var data = (0, _objectSpread2.default)({}, state.data);
  data.publicUrl = getPublicUrl((0, _get.default)(action, 'payload.auth', ''), (0, _get.default)(action, 'payload.noAuth', ''));
  return (0, _objectSpread2.default)({}, state, {
    data: data,
    error: null,
    isFetchingPublicUrl: false
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_GET_SHARE_LINK_GLOBAL_FAILED, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    error: action.payload,
    isFetchingPublicUrl: false
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_UPDATE_SHARE_PROPS_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    error: null,
    isUpdating: true
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_UPDATE_SHARE_PROPS_SUCCESS, function (state) {
  // update doesn't return anything
  return (0, _objectSpread2.default)({}, state, {
    error: null,
    isUpdating: false
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_UPDATE_SHARE_PROPS_FAILED, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    error: action.payload,
    isUpdating: false
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _isString2 = _interopRequireDefault(__webpack_require__(274));

var _isNumber2 = _interopRequireDefault(__webpack_require__(654));

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _createReducer;

var initialState = {
  data: {},
  isFetching: false,
  isUpdating: false,
  error: null
};
/** @module state/nucleus/recordings/recordingsAuth */

exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.VC_SETTINGS_FETCH_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isFetching: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.VC_SETTINGS_FETCH_SUCCESS, function (state, action) {
  var body = (0, _safeAccess.default)(action.payload, 'body', {});
  var responseCode = (0, _safeAccess.default)(body, 'RES', (0, _safeAccess.default)(action.payload, 'statusCode', ''));

  if ((0, _isString2.default)(responseCode) && responseCode.toUpperCase() !== 'OK' || (0, _isNumber2.default)(responseCode) && responseCode !== 200) {
    _jsLogger.default.info("VC Settings call failed with response code: ".concat(responseCode));

    return (0, _objectSpread2.default)({}, initialState, {
      isFetching: false,
      error: responseCode
    });
  }

  return (0, _objectSpread2.default)({}, state, {
    data: body,
    isFetching: false,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.VC_SETTINGS_FETCH_FAILED, function (state, action) {
  return (0, _objectSpread2.default)({}, initialState, {
    isFetching: false,
    error: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.VC_SETTINGS_UPDATE_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    isUpdating: true,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.VC_SETTINGS_UPDATE_SUCCESS, function (state, action) {
  var body = (0, _safeAccess.default)(action.payload, 'body', {});
  return (0, _objectSpread2.default)({}, state, {
    data: body,
    isUpdating: false,
    error: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.VC_SETTINGS_UPDATE_FAILED, function (state, action) {
  return (0, _objectSpread2.default)({}, initialState, {
    isUpdating: false,
    error: action.payload
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(88),
    isObjectLike = __webpack_require__(70);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

var initialState = {
  data: null,
  isFetching: false,
  isUpdating: false,
  error: null
};
exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.VIDEO_GET_MEETING_SHARE_PROPS_BEGIN, function () {
  return (0, _objectSpread2.default)({}, initialState, {
    isFetching: true
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_GET_MEETING_SHARE_PROPS_SUCCESS, function (state, action) {
  var data = (0, _objectSpread2.default)({}, action.payload);
  return (0, _objectSpread2.default)({}, state, {
    data: data,
    error: null,
    isFetching: false
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_GET_MEETING_SHARE_PROPS_FAILED, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    error: action.payload,
    isFetching: false
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_POST_MEETING_SHARE_PROPS_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    error: null,
    isUpdating: true
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_POST_MEETING_SHARE_PROPS_SUCCESS, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    error: null,
    isUpdating: false
  });
}), (0, _defineProperty2.default)(_createReducer, c.VIDEO_POST_MEETING_SHARE_PROPS_FAILED, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    error: action.payload,
    isUpdating: false
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _get = _interopRequireDefault(__webpack_require__(11));

var _constants = __webpack_require__(3);

var _reduxUtils = __webpack_require__(13);

var _createReducer;

var initialState = {
  proxyStatus: _constants.SERVICE_STATUS_DISCONNECTED,
  requiredServicesStatus: _constants.SERVICE_STATUS_DISCONNECTED,
  willRetry: false
};
var servicesReducer = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, _constants.WAMP_CONNECT_BEGIN, function () {
  return (0, _objectSpread2.default)({}, initialState, {
    proxyStatus: _constants.SERVICE_STATUS_CONNECTING
  });
}), (0, _defineProperty2.default)(_createReducer, _constants.WAMP_CONNECT_SUCCESS, function () {
  return (0, _objectSpread2.default)({}, initialState, {
    proxyStatus: _constants.SERVICE_STATUS_CONNECTED
  });
}), (0, _defineProperty2.default)(_createReducer, _constants.WAMP_CONNECT_ERROR, function (_, action) {
  return (0, _objectSpread2.default)({}, initialState, {
    willRetry: (0, _get.default)(action, 'payload.willRetry')
  });
}), (0, _defineProperty2.default)(_createReducer, _constants.VERIFY_WAMP_REQUEST, function (prevState) {
  return (0, _objectSpread2.default)({}, prevState, {
    proxyStatus: _constants.SERVICE_STATUS_VERIFYING
  });
}), (0, _defineProperty2.default)(_createReducer, _constants.VERIFY_WAMP_SUCCESS, function (prevState) {
  return (0, _objectSpread2.default)({}, prevState, {
    proxyStatus: _constants.SERVICE_STATUS_CONNECTED
  });
}), (0, _defineProperty2.default)(_createReducer, _constants.VERIFY_WAMP_FAILURE, function () {
  return (0, _objectSpread2.default)({}, initialState, {
    willRetry: true
  });
}), (0, _defineProperty2.default)(_createReducer, _constants.TOKEN_REFRESH_FAILURE, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, _constants.INITIALIZE_SERVICES_REQUEST, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    requiredServicesStatus: _constants.SERVICE_STATUS_CONNECTING
  });
}), (0, _defineProperty2.default)(_createReducer, _constants.INITIALIZE_SERVICES_SUCCESS, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    requiredServicesStatus: _constants.SERVICE_STATUS_CONNECTED
  });
}), (0, _defineProperty2.default)(_createReducer, _constants.INITIALIZE_SERVICES_FAILURE, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    requiredServicesStatus: _constants.SERVICE_STATUS_DISCONNECTED
  });
}), (0, _defineProperty2.default)(_createReducer, _constants.WAMP_CONNECTION_DISPOSED_HEALTHY, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, _constants.WAMP_CONNECTION_DISPOSED_JWT_ERROR, function (_, action) {
  return (0, _objectSpread2.default)({}, initialState, {
    willRetry: (0, _get.default)(action, 'payload.willRefreshToken')
  });
}), (0, _defineProperty2.default)(_createReducer, _constants.WAMP_CONNECTION_DISPOSED_UNEXPECTED, function (state, action) {
  return (0, _objectSpread2.default)({}, initialState, {
    willRetry: (0, _get.default)(action, 'payload.willRetry')
  });
}), _createReducer));
var _default = servicesReducer;
exports.default = _default;

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

/** @module state/nucleus/sso */

/**
 * @constant {Object}
 * @description Initial state
 * @default
 */
var initialState = {
  loginSupportType: null,
  isFetching: false,
  error: null
};
/**
 * Stores 'sso' related data.
 * @example
 * store
 *   +-- nucleus
 *     +-- sso
 *       |-- isFetching: bool
 *       |-- loginServiceURL: string
 *       |-- loginSupportType: int
 *       |-- checkEmailUrl: string
 *       +-- error: mixed
 * @example
 * store
 * +-- nucleus
 *     +-- sso
 *       |-- isFetching: false,
 *       |-- loginServiceURL: https://login.lifesizecloud.com/ls/?sso&ent=abcxyz',
 *       |-- loginSupportType: 1,
 *       |-- checkEmailUrl: https://lifesizecloud.com/MirialCarrierServer/useragentapi?api=emailCheck&email=abc@xyz.com
 *       +-- error: null
 */

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.AUTH_LOGOUT, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.SSO_CHECK_BEGIN, function (state, action) {
  var output = {
    isFetching: true,
    checkEmailUrl: action.payload,
    error: null
  };
  return output;
}), (0, _defineProperty2.default)(_createReducer, c.SSO_CHECK_SUCCESS, function (state, action) {
  var nextState = Object.assign({}, state, action.payload);

  if (nextState.loginSupportType === '0') {
    nextState.loginSupportType = c.LOGIN_SUPPORT_TYPE_PASSWORD;
  } else if (nextState.loginSupportType === '1') {
    nextState.loginSupportType = c.LOGIN_SUPPORT_TYPE_SSO;
  } else if (nextState.loginSupportType === '2') {
    nextState.loginSupportType = c.LOGIN_SUPPORT_TYPE_BOTH;
  }

  nextState.isFetching = false;
  nextState.error = null;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.SSO_CHECK_FAILURE, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.isFetching = false;
  nextState.error = action.payload ? action.payload : {
    message: 'Unknown SSO error'
  };
  return nextState;
}), _createReducer));

exports.default = _default;

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

/** @module state/nucleus/timer */

/**
 * @constant {Object}
 * @description Initial state
 * @default
 */
var initialState = {
  minutesElapsed: 0,
  secondsElapsed: 0
};
/**
 * Stores 'timer' related data.
 * @example
 * store
 *   +-- nucleus
 *     +-- timer
 *       +-- minutesElapsed: number
 *       +-- secondsElapsed: number
 * @example
 * store
 * +-- nucleus
 *     +-- timer
 *       +-- minutesElapsed: 120
 *       +-- secondsElapsed: 150
 */

exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.AUTH_LOGOUT, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.CLOCK_TICK_MIN, function (state) {
  var nextState = Object.assign({}, state);
  nextState.minutesElapsed++;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.CLOCK_TICK_SEC, function (state) {
  var nextState = Object.assign({}, state);
  nextState.secondsElapsed++;
  return nextState;
}), _createReducer));

exports.default = _default;

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _get = _interopRequireDefault(__webpack_require__(11));

var c = _interopRequireWildcard(__webpack_require__(3));

var _reduxUtils = __webpack_require__(13);

var _createReducer;

/** @module state/nucleus/token */

/**
 * @constant {Object}
 * @description Initial state
 * @default
 */
var initialState = {
  isFetching: false,
  error: null,
  A: null,
  oneTimeJwt: null,
  // * This flag allows to determine if there has been a previous attempt to refresh the token without a successful connection.
  // * If that's the case, there should not be further attempts to refresh the token.
  hasAttemptedRefresh: false,
  // * This flag indicates if an attempt to connect to NP with the current token (or legacy cookie) has succeeded.
  hasSuccessfullyConnected: false,
  updating: false
};
/**
 * Stores 'token' related data.
 * Note: ensure that any messages which change the token value are whitelisted in utils/persistence.js.
 * @example
 * store
 *   +-- nucleus
 *     +-- token
 *       |-- isFetching: bool
 *       |-- A: string
 *       |-- CLIENT: string
 *       +-- error: mixed
 */

exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.AUTH_LOGOUT, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.WAMP_CONNECT_SUCCESS, function (prevState) {
  return (0, _objectSpread2.default)({}, prevState, {
    // * If a token refresh was previously attempted and a connection was established the flag needs to be cleared
    // * This will allow to attempt new refreshes in the future when needed.
    hasAttemptedRefresh: false,
    hasSuccessfullyConnected: true
  });
}), (0, _defineProperty2.default)(_createReducer, c.NEW_TOKEN_OBTAINED, function (state, action) {
  var isOneTime = (0, _get.default)(action, 'payload.isOneTime', false);
  var jwt = (0, _get.default)(action, 'payload.jwt');
  return (0, _objectSpread2.default)({}, state, {
    error: null,
    A: isOneTime ? null : jwt,
    oneTimeJwt: isOneTime ? jwt : null,
    hasSuccessfullyConnected: false,
    updating: false
  });
}), (0, _defineProperty2.default)(_createReducer, c.TOKEN_REFRESH_BEGIN, function (state) {
  return (0, _objectSpread2.default)({}, state, {
    hasAttemptedRefresh: true,
    updating: true
  });
}), (0, _defineProperty2.default)(_createReducer, c.TOKEN_REFRESH_FAILURE, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    updating: false,
    error: (0, _get.default)(action, 'payload.error') || c.TOKEN_REFRESH_FAILURE
  });
}), (0, _defineProperty2.default)(_createReducer, c.WAMP_CONNECTION_DISPOSED_JWT_ERROR, function (state, action) {
  var willRefreshToken = (0, _get.default)(action, 'payload.willRefreshToken');
  return (0, _objectSpread2.default)({}, state, {
    A: willRefreshToken ? state.A : null,
    hasSuccessfullyConnected: willRefreshToken ? state.hasSuccessfullyConnected : false,
    oneTimeJwt: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.LOGOUT_FINISHED, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.TOKEN_REQUEST_BEGIN, function () {
  return (0, _objectSpread2.default)({}, initialState, {
    isFetching: true
  });
}), (0, _defineProperty2.default)(_createReducer, c.TOKEN_REQUEST_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, initialState, {
    A: action.payload.A
  });
}), (0, _defineProperty2.default)(_createReducer, c.TOKEN_REQUEST_FAILURE, function (state, action) {
  return (0, _objectSpread2.default)({}, initialState, {
    error: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.GET_DEVICE_LOGIN_SUCCESS, function (state, action) {
  return {
    A: action.payload.A,
    error: null,
    isFetching: false,
    hasSuccessfullyConnected: true
  };
}), _createReducer));

exports.default = _default;

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(661));

var _get = _interopRequireDefault(__webpack_require__(11));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

/** @module state/nucleus/userProfile */
var initialState = {
  context: '',
  error: null,
  groupUuid: null,
  localeCode: 'en',
  role: '',
  uuid: null,
  name: '',
  extension: '',
  joinedAt: null,
  clientInfo: {}
};
/**
 * Stores 'userProfile'
 * Note: display_name (defSIP_displayName), email (userEMail), extension (defExtension)
 * are stored in provisioning and revealed to our apps in currentUserSelectors.myInfo()
 * Note: TODO localeCode is included here because the localization reducer depends on MMS and needs to be updated or replaced
 * @example
 * store
 *   +-- nucleus
 *     +-- userProfile: {Object}
 * @example
 * store
 * +-- nucleus
 *     +-- userProfile:
 *       +-- context: 'USER/DEVICE' // could be used to determine if the display is logged in as a 'graphite-display'
 *       +-- error: null
 *       +-- localeCode: 'en'
 *       +-- role: 'ADMIN/SUPER_USER/USER/DEVICE'
 */

exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.AUTH_LOGOUT, function () {
  return initialState;
}), (0, _defineProperty2.default)(_createReducer, c.GET_SESSION_SUCCESS, function (state, action) {
  var session = (0, _get.default)(action, 'payload.session');
  var sessionContext = session.sessionContext,
      displayName = session.displayName,
      sessionProperties = (0, _objectWithoutProperties2.default)(session, ["sessionContext", "displayName"]);
  return (0, _objectSpread2.default)({}, state, {
    context: sessionContext,
    error: null,
    name: displayName
  }, sessionProperties);
}), (0, _defineProperty2.default)(_createReducer, c.GET_SESSION_FAILURE, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    error: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.SET_CUSTOM_GROUP_UUID, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    groupUuid: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, c.INIT_NUCLEUS, function (state, action) {
  var _state$clientInfo, _state$clientInfo2, _action$payload;

  var _ref = action.payload || {},
      platform = _ref.platform,
      version = _ref.version,
      _ref$clientInfo = _ref.clientInfo,
      clientInfo = _ref$clientInfo === void 0 ? {} : _ref$clientInfo;

  return (0, _objectSpread2.default)({}, state, {
    clientInfo: (0, _objectSpread2.default)({}, state.clientInfo, {
      clientType: clientInfo.clientType || platform || ((_state$clientInfo = state.clientInfo) === null || _state$clientInfo === void 0 ? void 0 : _state$clientInfo.clientType),
      clientVersion: clientInfo.version || version || ((_state$clientInfo2 = state.clientInfo) === null || _state$clientInfo2 === void 0 ? void 0 : _state$clientInfo2.version),
      nucleusVersion: "7.0.1"
    }, ((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.clientInfo) || {})
  });
}), (0, _defineProperty2.default)(_createReducer, c.NAME_UPDATED, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    name: (0, _get.default)(action, 'payload', state.name)
  });
}), (0, _defineProperty2.default)(_createReducer, c.SET_DEVICE_INFO, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    clientInfo: (0, _objectSpread2.default)({}, state.clientInfo, action.payload || {})
  });
}), _createReducer));

exports.default = _default;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(662);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 662 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _reduxUtils = __webpack_require__(13);

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var c = _interopRequireWildcard(__webpack_require__(3));

var _createReducer;

/** @module state/nucleus/userSettings */
var initialState = {
  error: null
};
/**
 * Stores 'userSettings'
 * @example
 * store
 *   +-- nucleus
 *     +-- userSettings:
 *      +-- locale: {String}
 *      +-- muteAudio: {Boolean}
 *      +-- error: null
 * @example
 * store
 * +-- nucleus
 *     +-- userSettings:
 *       +-- locale: 'en',
 *       +-- muteAudio: true
 *       +-- error: null
 */

exports.initialState = initialState;

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.GET_CURRENT_USER_SETTINGS_BEGIN, function (state) {
  var nextState = Object.assign({}, state);
  nextState.error = null;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GET_CURRENT_USER_SETTINGS_SUCCESS, function (state, action) {
  var nextState = Object.assign({}, state, (0, _safeAccess.default)(action, 'payload.response.userSettings'));
  nextState.error = null;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.GET_CURRENT_USER_SETTINGS_FAILURE, function (state, action) {
  var nextState = Object.assign({}, state, (0, _safeAccess.default)(action, 'payload.settings'));
  nextState.error = (0, _safeAccess.default)(action, 'payload.error');
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.UPDATE_CURRENT_USER_SETTINGS_BEGIN, function (state, action) {
  var nextState = Object.assign({}, state, (0, _safeAccess.default)(action, 'payload.response.userSettings'));
  nextState.error = null;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.UPDATE_CURRENT_USER_SETTINGS_SUCCESS, function (state, action) {
  var nextState = Object.assign({}, state, (0, _safeAccess.default)(action, 'payload.response.userSettings'));
  nextState.error = null;
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.UPDATE_CURRENT_USER_SETTINGS_FAILURE, function (state, action) {
  var nextState = Object.assign({}, state);
  nextState.error = (0, _safeAccess.default)(action, 'payload.error');
  return nextState;
}), (0, _defineProperty2.default)(_createReducer, c.INIT_NUCLEUS, function (state, action) {
  var payload = (0, _safeAccess.default)(action, 'payload') || {};

  if (Object.hasOwnProperty.call(payload, 'defaultUserSettings')) {
    return Object.assign({}, (0, _safeAccess.default)(action, 'payload.defaultUserSettings'), state);
  }

  return state;
}), _createReducer));

exports.default = _default;

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _reduxUtils = __webpack_require__(13);

var c = _interopRequireWildcard(__webpack_require__(3));

var _get = _interopRequireDefault(__webpack_require__(11));

var _createReducer;

/** @module state/nucleus/users */
var initialState = {
  data: null,
  // response data
  error: null,
  // response error
  isPending: false // response is pending

};

var _default = (0, _reduxUtils.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, c.USER_SERVICE_CREATE_REQUEST, function () {
  return (0, _objectSpread2.default)({}, initialState, {
    isPending: true
  });
}), (0, _defineProperty2.default)(_createReducer, c.USER_SERVICE_DELETE_REQUEST, function () {
  return (0, _objectSpread2.default)({}, initialState, {
    isPending: true
  });
}), (0, _defineProperty2.default)(_createReducer, c.USER_SERVICE_DELETE_LIST_REQUEST, function () {
  return (0, _objectSpread2.default)({}, initialState, {
    isPending: true
  });
}), (0, _defineProperty2.default)(_createReducer, c.USER_SERVICE_UPDATE_REQUEST, function () {
  return (0, _objectSpread2.default)({}, initialState, {
    isPending: true
  });
}), (0, _defineProperty2.default)(_createReducer, c.USER_SERVICE_CREATE_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isPending: false,
    data: (0, _get.default)(action, 'payload', null),
    responseError: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.USER_SERVICE_DELETE_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isPending: false,
    data: (0, _get.default)(action, 'payload', null),
    responseError: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.USER_SERVICE_DELETE_LIST_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isPending: false,
    data: (0, _get.default)(action, 'payload', null),
    responseError: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.USER_SERVICE_UPDATE_SUCCESS, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isPending: false,
    data: (0, _get.default)(action, 'payload', null),
    responseError: null
  });
}), (0, _defineProperty2.default)(_createReducer, c.USER_SERVICE_CREATE_FAILURE, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isPending: false,
    data: null,
    responseError: (0, _get.default)(action, 'payload', null)
  });
}), (0, _defineProperty2.default)(_createReducer, c.USER_SERVICE_DELETE_FAILURE, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isPending: false,
    data: null,
    responseError: (0, _get.default)(action, 'payload', null)
  });
}), (0, _defineProperty2.default)(_createReducer, c.USER_SERVICE_DELETE_LIST_FAILURE, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isPending: false,
    data: null,
    responseError: (0, _get.default)(action, 'payload', null)
  });
}), (0, _defineProperty2.default)(_createReducer, c.USER_SERVICE_UPDATE_FAILURE, function (state, action) {
  return (0, _objectSpread2.default)({}, state, {
    isPending: false,
    data: null,
    responseError: (0, _get.default)(action, 'payload', null)
  });
}), (0, _defineProperty2.default)(_createReducer, c.USER_SERVICE_ERROR_RESET, function () {
  return initialState;
}), _createReducer));

exports.default = _default;

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(CONFIG) {

var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createWampClientMiddleware = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _clients = __webpack_require__(172);

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _get = _interopRequireDefault(__webpack_require__(11));

var _chat = __webpack_require__(194);

var _conference = __webpack_require__(291);

var _contact = __webpack_require__(195);

var C = _interopRequireWildcard(__webpack_require__(3));

var _topicActionMap;

var topicActionMap = (_topicActionMap = {}, (0, _defineProperty2.default)(_topicActionMap, C.GALAXY_SUBSCRIPTION_CALL_MANAGER, C.GALAXY_WAMP_SUBSCRIPTION_EVENT_CALL), (0, _defineProperty2.default)(_topicActionMap, C.GALAXY_TOPIC_TURN_SERVER, C.GALAXY_WAMP_SUBSCRIPTION_EVENT_TURN), (0, _defineProperty2.default)(_topicActionMap, C.CALENDAR_TOPIC, C.WAMP_SUBSCRIPTION_ACTION_CALENDAR_TOPIC), (0, _defineProperty2.default)(_topicActionMap, C.PHONEHD_CUSTOMIZATION_TOPIC, C.WAMP_SUBSCRIPTION_PHONEHD_CUSTOMIZATION_EVENT), (0, _defineProperty2.default)(_topicActionMap, C.GRAPHITE_TOPIC, C.GRAPHITE_EVENT_RECEIVED), (0, _defineProperty2.default)(_topicActionMap, C.CALLHISTORY_TOPIC, C.WAMP_SUBSCRIPTION_CALLHISTORY_EVENT), (0, _defineProperty2.default)(_topicActionMap, C.ME_TOPIC, C.WAMP_SUBSCRIPTION_ACTION_ME_TOPIC), (0, _defineProperty2.default)(_topicActionMap, C.AVAILABILITY_TOPIC, C.AVAILABILITY_UPDATE), (0, _defineProperty2.default)(_topicActionMap, C.PAIRING_TOPIC, C.WAMP_SUBSCRIPTION_LINKING_EVENT), (0, _defineProperty2.default)(_topicActionMap, C.CONTACT_TOPIC, _contact.contactNotificationHandler), (0, _defineProperty2.default)(_topicActionMap, C.ACCOUNT_TOPIC, C.ACCOUNT_SETTING_UPDATED), (0, _defineProperty2.default)(_topicActionMap, C.GEMS_SOFTWARE_UPDATE_TOPIC, C.GEMS_SOFTWARE_UPDATE), (0, _defineProperty2.default)(_topicActionMap, C.ACTIVE_CONFERENCE_TOPIC, _conference.activeConferenceNotificationHandler), (0, _defineProperty2.default)(_topicActionMap, C.CHAT_TOPIC, _chat.chatEventHandler), (0, _defineProperty2.default)(_topicActionMap, C.DEVICE_TOPIC, C.WAMP_SUBSCRIPTION_DEVICE_EVENT), (0, _defineProperty2.default)(_topicActionMap, C.ALEXA_TOPIC, C.WAMP_ALEXA_DEVICE_EVENT), _topicActionMap);
var conferenceTopicActionSet = new Set();

var wampClientMiddleware = function wampClientMiddleware(store) {
  return function (next) {
    return function (action) {
      var result = next(action);
      var actionHandler = wampActionsMap.get(action.type);

      if (actionHandler) {
        var actionResult = actionHandler(store, action);

        if (actionResult) {
          return actionResult;
        }
      }

      return result;
    };
  };
};

var createWampClientMiddleware = function createWampClientMiddleware(client) {
  if (!client) {
    var error = 'No WAMP client found. Cannot initialize CNUC.';

    _jsLogger.default.info(error);

    throw error;
  }

  var enableSleepMonitor = CONFIG.wampConnectOptions.enableSleepMonitor;

  _clients.sdk.initialize();

  _clients.sdk.enableConnect(client, {
    enableSleepMonitor: enableSleepMonitor
  });

  return wampClientMiddleware;
};

exports.createWampClientMiddleware = createWampClientMiddleware;

function handleSendBegin(_x, _x2) {
  return _handleSendBegin.apply(this, arguments);
}

function _handleSendBegin() {
  _handleSendBegin = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee(store, action) {
    var procedure, args, timeout, rawResponse, response, status, statusCode;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            procedure = (0, _get.default)(action.payload, 'command');
            args = (0, _get.default)(action.payload, 'args');
            _context.prev = 2;
            timeout = procedure === CONFIG.graphql.rpc ? 30000 : 12000;
            _context.next = 6;
            return _clients.rpc.send(procedure, args, timeout);

          case 6:
            rawResponse = _context.sent;
            response = jsonCommands.has(procedure) ? JSON.parse(rawResponse) : rawResponse;
            status = (0, _get.default)(response, 'status');
            statusCode = (0, _get.default)(response, 'statusCode'); // Check status

            if (!(status && status >= 300 || statusCode && statusCode >= 300)) {
              _context.next = 12;
              break;
            }

            throw response;

          case 12:
            store.dispatch({
              type: C.WAMP_SEND_SUCCESS,
              payload: {
                request: action.payload,
                response: response
              }
            });
            return _context.abrupt("return", response);

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](2);
            store.dispatch({
              type: C.WAMP_SEND_ERROR,
              payload: {
                request: action.payload,
                error: _context.t0
              }
            });
            throw _context.t0;

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 16]]);
  }));
  return _handleSendBegin.apply(this, arguments);
}

function handleSubscribeBegin(_x3, _x4) {
  return _handleSubscribeBegin.apply(this, arguments);
}

function _handleSubscribeBegin() {
  _handleSubscribeBegin = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee2(store, action) {
    var topic, handler, response;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            topic = action.payload;
            handler = generateSubscriptionEventHandler(store);
            _context2.prev = 2;
            _context2.next = 5;
            return _clients.subscription.add(topic, handler);

          case 5:
            response = _context2.sent;
            store.dispatch({
              type: C.WAMP_SUBSCRIBE_SUCCESS,
              payload: response
            });
            _context2.next = 12;
            break;

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](2);
            store.dispatch({
              type: C.WAMP_SUBSCRIBE_ERROR,
              payload: _context2.t0
            });

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 9]]);
  }));
  return _handleSubscribeBegin.apply(this, arguments);
}

var generateSubscriptionEventHandler = function generateSubscriptionEventHandler(store) {
  return function (event) {
    var topic = (0, _get.default)(event, 'topic');
    var args = (0, _get.default)(event, 'args', []);
    args.forEach(function (rawItem) {
      try {
        var action = conferenceTopicActionSet.has(topic) ? C.GALAXY_WAMP_SUBSCRIPTION_EVENT_CALL : topicActionMap[topic];
        var payload = JSON.parse(rawItem);

        if (!action) {
          _jsLogger.default.info('Unhandled WAMP subscription event', event);

          return;
        }

        if (typeof action === 'function') {
          store.dispatch(action(payload));
          return;
        }

        store.dispatch({
          type: action,
          payload: payload
        });
      } catch (error) {
        _jsLogger.default.warn('Unable to parse WAMP Subscription Event', error);
      }
    });
  };
};

function handleUnsubscribeBegin(_x5, _x6) {
  return _handleUnsubscribeBegin.apply(this, arguments);
}

function _handleUnsubscribeBegin() {
  _handleUnsubscribeBegin = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee3(store, action) {
    var topic;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            topic = action.payload;
            _context3.prev = 1;
            _context3.next = 4;
            return _clients.subscription.remove(topic);

          case 4:
            store.dispatch({
              type: C.WAMP_UNSUBSCRIBE_SUCCESS,
              payload: {
                topic: topic
              }
            });
            _context3.next = 10;
            break;

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](1);
            store.dispatch({
              type: C.WAMP_UNSUBSCRIBE_ERROR,
              payload: _context3.t0
            });

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 7]]);
  }));
  return _handleUnsubscribeBegin.apply(this, arguments);
}

function handleAddConferenceTopic(store, action) {
  var topic = (0, _get.default)(action, 'payload');
  if (conferenceTopicActionSet.has(topic)) return;
  conferenceTopicActionSet.add(topic);
}

function handleRemoveConferenceTopic(store, action) {
  var topic = (0, _get.default)(action, 'payload');
  if (!conferenceTopicActionSet.has(topic)) return;
  conferenceTopicActionSet.delete(topic);
}

var wampActionsMap = new Map([[C.WAMP_SEND_BEGIN, handleSendBegin], [C.WAMP_SUBSCRIBE_BEGIN, handleSubscribeBegin], [C.WAMP_UNSUBSCRIBE_BEGIN, handleUnsubscribeBegin], [C.WAMP_ADD_CONFERENCE_TOPIC, handleAddConferenceTopic], [C.WAMP_REMOVE_CONFERENCE_TOPIC, handleRemoveConferenceTopic]]);
var jsonCommands = new Set([C.ACCOUNT_SETTINGS_ENDPOINT, C.CALENDAR_ENDPOINT, C.DIRECTORY_SERVICE_ENDPOINT, C.FAVORITE_HANDLER_ENDPOINT, C.FEATURE_SERVICE_ENDPOINT, C.GROUP_CONTACTS_HANDLER_ENDPOINT, C.MEETINGS_ENDPOINT, C.MEETING_HANDLER_ENDPOINT, C.MEETING_SETTINGS_ENDPOINT, C.PAIRED_DEVICES_ENDPOINT, C.PERSONAL_CONTACTS_HANDLER_ENDPOINT, C.PHONEHD_CUSTOMIZATION_ENDPOINT, C.PSTN_SERVICE_ENDPOINT, C.RECORDING_AUTH_ENDPOINT]);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(29)["default"]))

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _guid = _interopRequireDefault(__webpack_require__(72));

var _constants = __webpack_require__(3);

var middleware = function middleware(store) {
  return function (next) {
    return (
      /*#__PURE__*/
      function () {
        var _ref = (0, _asyncToGenerator2.default)(
        /*#__PURE__*/
        _regenerator.default.mark(function _callee(action) {
          var nextResult;
          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  nextResult = next(action);

                  if (!(action.type === _constants.AWAIT_ACTION)) {
                    _context.next = 3;
                    break;
                  }

                  return _context.abrupt("return", processAwaitAction(action));

                case 3:
                  checkAwaiting(store, action);
                  return _context.abrupt("return", nextResult);

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()
    );
  };
};

var awaitingMap = new Map();

function processAwaitAction(action) {
  // Create a UUID for the pending object
  var uuid = _guid.default.create(); // Create a promise that will reject if the timeout is reached, or resolve if a matching action is received


  var promise = new Promise(function (resolve, reject) {
    var _action$payload = action.payload,
        shouldResolve = _action$payload.shouldResolve,
        shouldReject = _action$payload.shouldReject,
        timeout = _action$payload.timeout; // Start the timeout to reject the promise

    var timeoutId = setTimeout(function () {
      reject({
        errorDescription: _constants.AWAIT_ACTION_TIMEOUT
      }); // If the promise is rejected, delete the pending item from the pending map

      awaitingMap.delete(uuid);
    }, timeout);
    var awaiting = {
      shouldResolve: shouldResolve,
      shouldReject: shouldReject,
      resolve: resolve,
      reject: reject,
      timeoutId: timeoutId,
      uuid: uuid
    }; // Add the pending object to the pending map

    awaitingMap.set(uuid, awaiting);
  });
  return promise;
}

function checkAwaiting(store, action) {
  // Exit early if nothing is pending
  if (awaitingMap.size === 0) return;
  var processed = []; // Iterate through every pending object, and determine if they should resolve or reject

  awaitingMap.forEach(function (awaiting) {
    if (awaiting.shouldResolve(action)) {
      // If they should resolve, clear timeout, resolve and add to the processed array
      clearTimeout(awaiting.timeoutId);
      awaiting.resolve(action.payload);
      processed.push(awaiting);
    } else if (awaiting.shouldReject(action)) {
      // If they should reject, clear timeout, reject and add to the processed array
      clearTimeout(awaiting.timeoutId);
      awaiting.reject(action.payload);
      processed.push(awaiting);
    }
  });

  for (var _i = 0, _processed = processed; _i < _processed.length; _i++) {
    var awaiting = _processed[_i];
    // Delete the item from the awaiting map
    awaitingMap.delete(awaiting.uuid);
  }
}

var _default = middleware;
exports.default = _default;

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var c = _interopRequireWildcard(__webpack_require__(3));

var _callHistoryUtils = __webpack_require__(126);

var callHistoryMiddleware = function callHistoryMiddleware(store) {
  return function (next) {
    return function (action) {
      var result = next(action);

      if (action.type === c.WAMP_SUBSCRIPTION_CALLHISTORY_EVENT) {
        var actions = (0, _callHistoryUtils.mapCallHistoryEventToActions)(action.payload);
        actions.forEach(function (a) {
          return store.dispatch(a);
        });
      }

      return result;
    };
  };
};

var _default = callHistoryMiddleware;
exports.default = _default;

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var c = _interopRequireWildcard(__webpack_require__(3));

var minuteHand,
    secondHand = null;

var clearTimer = function clearTimer(timer) {
  if (timer) clearInterval(timer);
  timer = null;
};

var timerMiddleware = function timerMiddleware(store) {
  return function (next) {
    return function (action) {
      if (action.type === c.AUTH_LOGOUT) {
        clearTimer(minuteHand);
        clearTimer(secondHand);
      }

      if (action.type === c.GALAXY_ACTION_ANSWER) {
        clearTimer(secondHand);
        secondHand = setInterval(function () {
          return store.dispatch({
            type: c.CLOCK_TICK_SEC
          });
        }, 1000);
      }

      if (action.type === c.GALAXY_ACTION_FAILED || action.type === c.GALAXY_ACTION_END) {
        clearTimer(secondHand);
      }

      return next(action);
    };
  };
};

var _default = timerMiddleware;
exports.default = _default;

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _logger = _interopRequireDefault(__webpack_require__(165));

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var loggerMiddleware = function loggerMiddleware() {
  return function (next) {
    return function (action) {
      var result = next(action);

      if (action.type === _logger.default.actions.setLevel) {
        _jsLogger.default.setLevel(action.payload);
      }

      return result;
    };
  };
};

var _default = loggerMiddleware;
exports.default = _default;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(71));

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _taggedTemplateLiteral2 = _interopRequireDefault(__webpack_require__(253));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(81));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread3 = _interopRequireDefault(__webpack_require__(7));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var c = _interopRequireWildcard(__webpack_require__(3));

var _throttle = _interopRequireDefault(__webpack_require__(671));

var _graphqlTag = _interopRequireDefault(__webpack_require__(254));

var _browserUtils = __webpack_require__(44);

var _auth = __webpack_require__(31);

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n            fragment callable on Callable {\n              availability {\n                status\n              }\n            }\n          "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
 * This func returns a throttled dispatch func that will release any pending
 * status updates.
 */
var setupBatchedDispatch = function setupBatchedDispatch(store, batchedUpdates) {
  var platform = (0, _auth.getPlatform)(store.getState());
  var presenceDelay = (0, _browserUtils.isMobile)(platform) ? c.AVAILABILITY_BATCH_DELAY_MOBILE : c.AVAILABILITY_BATCH_DELAY_WEB;
  return (0, _throttle.default)(
  /*#__PURE__*/
  (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee() {
    var client, updateMap;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return store.dispatch({
              type: c.GQL_GET_CLIENT
            });

          case 2:
            client = _context.sent;
            updateMap = batchedUpdates // Clear out everything batched so far.
            .splice(0).filter(Boolean) // dispatch a map of uuid => most recent status.
            .reduce(function (acc, _ref2) {
              var uuid = _ref2.uuid,
                  status = _ref2.status;
              return (0, _objectSpread3.default)({}, acc, (0, _defineProperty2.default)({}, uuid, status));
            }, {});
            Object.entries(updateMap).forEach(function (_ref3) {
              var _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
                  uuid = _ref4[0],
                  newStatus = _ref4[1];

              client.writeFragment({
                uuid: uuid,
                fragment: (0, _graphqlTag.default)(_templateObject()),
                data: {
                  __typename: 'Callable',
                  availability: {
                    __typename: 'Availability',
                    status: newStatus === 'unavailable' ? 'NOT_AVAILABLE' : newStatus.toUpperCase()
                  }
                }
              });
            });
            store.dispatch({
              type: c.BATCHED_USER_PRESENCE_UPDATE,
              batchedUpdates: updateMap
            });

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), presenceDelay, {
    leading: false
  });
};

var releaseBatch;
var batchedUpdates = [];

var availability = function availability(store) {
  return function (next) {
    return function (action) {
      if (!releaseBatch) releaseBatch = setupBatchedDispatch(store, batchedUpdates);

      if (action.type === c.AVAILABILITY_UPDATE) {
        var _action$payload;

        batchedUpdates.push.apply(batchedUpdates, (0, _toConsumableArray2.default)((action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.av) || []));
        return releaseBatch();
      }

      return next(action);
    };
  };
};

var _default = availability;
exports.default = _default;

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(247),
    isObject = __webpack_require__(58);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var c = _interopRequireWildcard(__webpack_require__(3));

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _call = __webpack_require__(50);

var _stream = __webpack_require__(80);

var _conference = __webpack_require__(291);

var _directory = __webpack_require__(84);

var _galaxyUtils = __webpack_require__(73);

var _call2 = __webpack_require__(51);

var _contacts = __webpack_require__(35);

var _asyncQueue = _interopRequireDefault(__webpack_require__(278));

var _conference2 = __webpack_require__(53);

var _currentUser = __webpack_require__(37);

var _remoteModerator = __webpack_require__(85);

var _conferenceNotificati, _eventActionMap, _eventIgnoreMap, _galaxyActionMap, _timeoutMap;

// for processing of galaxy call events synchronously
var asyncQueue = new _asyncQueue.default();
var offlineTimeout;
/** Wamp Event Handlers
 *
 * Functions for handling when things go bad with the wamp connection.
 * Generally while a call is in the middle of connecting.
 */
// When a wamp connect is disposed, if we're mid-starting a galaxy call, fail the call.
// If we're in a call, or out of a call, do nothing

function handleConnectionDisposed(store, action) {
  var state = store.getState();
  var galaxyCallState = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.state');
  var callId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.callId');

  if (callId && galaxyCallState !== c.GALAXY_CALL_STATE_CONNECTED && galaxyCallState !== c.GALAXY_CALL_STATE_DISCONNECTED) {
    store.dispatch((0, _call.failedCallGalaxy)({
      callId: callId,
      error: action.type,
      reason: c.GALAXY_REASON_WAMP_DISCONNECTED
    }));
  }
}
/**
 * If we get a wamp connect event but already have call state,
 * force re-subscription
 */


function handleWampConnected(store) {
  handleExistingCall(store);
}
/**
 * Function to handle pre-existing call after successfully reconnecting to WAMP
 */


function handleExistingCall(store) {
  var state = store.getState();
  var callState = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.state'); // If pre-existing call is disconnected, there is no need to do anything

  if (callState === c.GALAXY_CALL_STATE_DISCONNECTED) return;
  var storedConferenceId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.conferenceId'); // Re-subscribe to conference and report local mute state

  if (storedConferenceId) {
    store.dispatch((0, _call.subscribeToConference)(storedConferenceId));
    handleReportLocalMute(store);
  }
}
/**
 * Call Event Handlers
 *
 * These functions are used to dispatch galaxy call events that are incoming
 * from the WAMP middleware as actions out to redux.
 * All of these functions have an "interface" of handler(store, payload).
 * If we migrate to typescript, we will check that there.
 * For now, there is no checking of the function "inferfaces"
 */


function handleFailedEvent(payload) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return dispatch((0, _call.failedCallGalaxy)(payload));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}

function handleEndEvent(payload) {
  return function (dispatch, getState) {
    var state = getState();
    var currentCallId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.callId');

    if ((0, _safeAccess.default)(payload, 'callId') === currentCallId) {
      return dispatch((0, _call.endCallGalaxy)(payload));
    }

    return dispatch((0, _call.incomingCallEndedGalaxy)(payload));
  };
}
/**
 * handleUpdateEvent
 *
 * These are sdp update requests sent to the client. There are multiple subtypes
 * associated with the 'reason' in the payload: presentationSend, presentationRcv,
 * and presentationStop. There will be more as we have reasons for changing video
 * sources and other scenarios that require a WebRTC sdp renegotation.
 *
 * @param {Object} payload - The payload received from WAMP.
 */


function handleUpdateEvent(payload) {
  return function (dispatch) {
    var type = (0, _safeAccess.default)(payload, 'capability.type');

    if (type === c.WEBRTC_SDP_TYPE_OFFER) {
      dispatch({
        type: c.GALAXY_ACTION_ON_UPDATE_SDP_OFFER,
        payload: payload
      });
    } else if (type === c.WEBRTC_SDP_TYPE_ANSWER) {
      dispatch({
        type: c.GALAXY_ACTION_ON_UPDATE_SDP_ANSWER,
        payload: payload
      });
    } else {
      _jsLogger.default.info('unknown update sdp type', payload);
    }
  };
}
/**
 * Handle any incoming FECC messages for the current call and dispatch the FECC payload as an FECC action.
 * @param {object} payload The payload received from NP. Contains necessary FECC payload.
 */


function handleFECC(payload) {
  return function (dispatch, getState) {
    var state = getState();
    var callId = (0, _safeAccess.default)(payload, 'callId');
    var storedCallId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.callId');

    if (callId === storedCallId) {
      dispatch((0, _call.incomingFECC)((0, _safeAccess.default)(payload, 'fecc')));
    }
  };
}

function handlePassthroughEvent(payload) {
  return function (dispatch) {
    var reason = (0, _safeAccess.default)(payload, 'reason');
    var passThroughType = (0, _safeAccess.default)(payload, 'passThroughType');
    reason = reason ? reason : passThroughType; // This is here due to how GICON handles and sends FECC commands.

    var handler = passThroughActionMap[reason];
    if (handler) return dispatch(handler(payload));

    _jsLogger.default.warn("Passthrough with reason ".concat(reason, " not handled."));
  };
}
/**
 * handleIncomingGalaxyCall
 *
 * The client is receiving an incoming call from galaxy and we need to correctly process it.
 * If the client is currently calling out to another client but is not yet connected, is in do not disturb mode,
 * or has another incoming call, reject this incoming galaxy call.
 * Otherwise, add it to the incoming call queue. In the future, we may be able to handle multiple incoming
 * calls, but while we have a split world with both psems and galaxy, we are going to avoid handling
 * those cases.
 * @param {Object} payload
 */


function handleIncomingGalaxyCall(payload) {
  return function (dispatch, getState) {
    var state = getState();
    var activeCall = (0, _call2.activeCallSelector)(state);
    var hasAOutgoingCall = (0, _galaxyUtils.isGalaxyCallOutgoing)(state);
    var doNotDisturb = (0, _safeAccess.default)(state, 'nucleus.doNotDisturb') || false;
    var galaxyIncoming = (0, _safeAccess.default)(state, 'nucleus.galaxy.incoming.length') > 0;
    var galaxyPushServiceCall = (0, _safeAccess.default)(state, 'nucleus.galaxy.pushService.callId');
    var inGalaxyCall = (0, _safeAccess.default)(activeCall, 'isGalaxyCall') && ((0, _galaxyUtils.isGalaxyCallConnected)(state) || (0, _safeAccess.default)(activeCall, 'state') === c.CALL_STATE_CONNECTING); // load contact if not loaded

    var from = (0, _safeAccess.default)(payload, 'from');
    if (!(0, _contacts.getContactByDialStringGenerator)(state)(from)) dispatch((0, _directory.loadByExtensions)([from])); // Handle the case of a push service call coming in.
    // Format the incomingCall to look as the action creator wants, and answer it (without ever dispatch incomingCall)

    if (galaxyPushServiceCall && galaxyPushServiceCall === (0, _safeAccess.default)(payload, 'callId')) {
      return dispatch((0, _call.answerGalaxy)({
        galaxyCall: payload
      }));
    } // If we can handle the incoming call


    if (!(hasAOutgoingCall || doNotDisturb || galaxyIncoming || inGalaxyCall)) {
      return dispatch((0, _call.incomingCallGalaxy)(payload));
    } // Otherwise, take the payload, and nest it in a galaxyCall object as the ignoreGalaxy action handler expects the data in this way.


    var incomingCall = {
      galaxyCall: payload
    };

    _jsLogger.default.info('We have this callId, but we are not able to handle any incoming calls at this time, ', incomingCall);

    dispatch((0, _call.ignoreGalaxy)(incomingCall));
  };
}
/**
 * handleBeginCall
 * Handler for an the galaxy begin call action. Only creating a timeout in the initial use case, but leaving it wrapped
 * so more can be added later.
 * @param {Object} store - Redux store
 * @param {Object} action - Action that has the context for the createTimeout
 */


function handleBeginCall(store, action) {
  var callId = (0, _safeAccess.default)(action, 'payload.callId');
  createTimeout(store, action, callId, (0, _call.endGalaxy)(c.GALAXY_REASON_TIMED_OUT), shouldCallTimeout, 40000);
}
/**
 * handleBeginAnswer
 * Handler for an the galaxy begin answer action. Only creating a timeout in the initial use case, but leaving it wrapped
 * so more can be added later.
 * @param {Object} store - Redux store
 * @param {Object} action - Action that has the context for the createTimeout
 */


function handleBeginAnswer(store, action) {
  var callId = (0, _safeAccess.default)(action, 'payload.callId');
  createTimeout(store, action, callId, (0, _call.endGalaxy)(c.GALAXY_REASON_TIMED_OUT), shouldCallTimeout, 20000);
} // set timeout for adding a person to a call


function handleAddToCall(store, action) {
  var timeoutAction = {
    type: c.GALAXY_ACTION_ADD_FAILED,
    payload: {
      reason: c.GALAXY_ADD_RESPONSE_ACTION_TIMEOUT
    }
  };

  var conditionTest = function conditionTest(store, action) {
    var state = store.getState();
    var invitedState = (0, _safeAccess.default)(state, 'nucleus.galaxy.invited.state');
    var invitedId = (0, _safeAccess.default)(state, 'nucleus.galaxy.invited.invitedId');
    var actionInvitedId = (0, _safeAccess.default)(action, 'payload.invitedId'); // no invitee or wrong invitee,
    // they have already connected or failed, and have been cleared from the state by the client

    if (!invitedState || invitedId !== actionInvitedId) return false; // timeout should fire if invitee is not connected or failed by now

    return invitedState !== c.GALAXY_INVITEE_STATE_CONNECTED && invitedState !== c.GALAXY_INVITEE_STATE_FAILED;
  };

  createTimeout(store, action, (0, _safeAccess.default)(action, 'payload.invitedId'), timeoutAction, conditionTest, 30000);
}

var timeouts = {};
/**
 * createTimeout
 * Generic timer convenience for galaxy timeout generation.
 * It is intended to ingest both an action to dispatch if a passed in conditional function tests to true.
 * Otherwise, the timer will do nothing but clean itself up.
 * Timers are stored in a global timeouts object by id.
 * @param {Object} store - Redux store
 * @param {Object} action - Action that has the context for the createTimeout
 * @param {String} id - The id to tag to use as the key for time timeout value.
 * @param {Object} timeoutAction - The action to dispatch if the condition tests to true
 * @param {Function} conditionTest - The conditional statement that will determine whether to dispatch an action at the end of the timeout.
 * @param {Number} duration - Duration in milliseconds for the timer
 */

function createTimeout(store, action, id, timeoutAction) {
  var conditionTest = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {
    return false;
  };
  var duration = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 25000;
  if (!id) return; // No callId, invalid invocation.

  timeouts[id] = setTimeout(function () {
    if (conditionTest(store, action)) store.dispatch(timeoutAction);
    delete timeouts[id];
  }, duration);
}
/**
 * shouldCallTimeout
 * Set the timer for this new call event. At creation, this is being used for timers on beginning a call and answering a call.
 * We want to only test to true if the passed in callId from the action matches the call in the reducer AND we are not connected or disconnected.
 * @param {Object} store - Redux store
 * @param {Object} action - Action that has the context for the createTimeout
 */


function shouldCallTimeout(store, action) {
  var state = store.getState();
  var callId = (0, _safeAccess.default)(action, 'payload.callId') || 'noCallId';
  var storedCallId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.callId');
  var callState = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.state');
  var iceConnectionState = (0, _safeAccess.default)(state, 'nucleus.galaxy.rtc.iceConnectionState'); // we should not timeout an old call (if the call Id's don't match)

  if (storedCallId !== callId) return false; // if we're already in a disconnected state, no need to timeout the call

  if (callState === c.GALAXY_CALL_STATE_DISCONNECTED) return false; // but, since we're not disconnected, if the ice state is still closed, timeout -- peerConnection couldn't connect

  if (iceConnectionState === c.GALAXY_ICE_STATE_CLOSED) return true; // otherwise, if the call isn't yet in the connected state, time out the call
  //   -- this allows the iceConnection state to continue trying to connect or restart if it's in the process.

  return callState !== c.GALAXY_CALL_STATE_CONNECTED;
}
/**
 * handleAutoCancel
 * Sends a cancellation message to call manager if we queued up a cancel earlier in the call process
 * @param {*} store
 * @param {*} action
 */


function handleAutoCancel(store, action) {
  var state = store.getState();
  var callId = (0, _safeAccess.default)(action, 'payload.callId');
  var storedCallId = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.callId');
  var cancelQueued = (0, _safeAccess.default)(state, 'nucleus.galaxy.call.cancelQueued');

  if (callId === storedCallId && cancelQueued) {
    store.dispatch((0, _call.endGalaxy)());
  }
}

function handleCallWaiting(payload, state) {
  var cwState = (0, _safeAccess.default)(payload, 'from');
  var is_v3_enabled = (0, _galaxyUtils.isGalaxyV3Enabled)(state);

  if (is_v3_enabled && Object.hasOwnProperty.call(payload, 'canAdd')) {
    cwState.canAdd = (0, _safeAccess.default)(payload, 'canAdd');
  } else {
    cwState.canAdd = true;
  }

  var doNotDisturb = (0, _safeAccess.default)(state, 'nucleus.doNotDisturb') || false;

  if (doNotDisturb) {
    return (0, _call.callWaitingResponse)(c.GALAXY_COMMAND_CALL_WAITING_IGNORE);
  }

  return function (dispatch) {
    dispatch({
      type: c.GALAXY_ACTION_CALL_WAITING,
      payload: cwState
    });
    dispatch((0, _call.callRingingResponse)());
  };
}

function handleCallWaitingCancelled(payload) {
  return {
    type: c.GALAXY_ACTION_CALL_WAITING_CANCELLED,
    payload: (0, _safeAccess.default)(payload, 'from')
  };
}

function handleReplaceCall(payload) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch, getState) {
        var state, currentConferenceId;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                state = getState();
                currentConferenceId = (0, _conference2.selectConferenceId)(state);

                if (!currentConferenceId) {
                  _context2.next = 12;
                  break;
                }

                _context2.prev = 3;
                _context2.next = 6;
                return dispatch((0, _call.unsubscribeFromConference)(currentConferenceId));

              case 6:
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](3);

                _jsLogger.default.warn("Error unsubscribing from ".concat(currentConferenceId, "."), _context2.t0);

                _jsLogger.default.warn("You may still receive notifications for this conference.");

              case 12:
                dispatch({
                  type: c.GALAXY_ACTION_REPLACE_CALL,
                  payload: payload
                });

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[3, 8]]);
      }));

      return function (_x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}

function handleAddResponse(payload) {
  if ((0, _safeAccess.default)(payload, 'action') === c.GALAXY_ADD_RESPONSE_ACTION_CONNECTED) {
    return {
      type: c.GALAXY_ACTION_ADD_SUCCESS
    };
  }

  if ((0, _safeAccess.default)(payload, 'action') === c.GALAXY_REASON_HUNGUP) {
    return {
      type: c.GALAXY_ACTION_ADD_HUNGUP
    };
  }

  return {
    type: c.GALAXY_ACTION_ADD_FAILED,
    payload: {
      reason: (0, _safeAccess.default)(payload, 'action')
    }
  };
}

function handleFirstParticipantReadyInIVR(payload) {
  return function (dispatch) {
    dispatch({
      type: c.GALAXY_ACTION_FIRST_PARTICIPANT_READY_IN_IVR,
      payload: payload
    });
  };
}

function handleModeratorJoined(payload) {
  return function (dispatch) {
    dispatch({
      type: c.MODERATOR_JOINED,
      payload: payload
    });
  };
}

function handleModeratorLeft(payload) {
  return function (dispatch) {
    dispatch({
      type: c.MODERATOR_LEFT,
      payload: payload
    });
  };
}

function handleRemoteModeratorJoined(payload) {
  return function (dispatch) {
    dispatch({
      type: c.GALAXY_ACTION_REMOTE_MODERATOR_JOINED,
      payload: payload
    });
  };
}

function handleRemoteModeratorLeft(payload) {
  return function (dispatch) {
    dispatch({
      type: c.GALAXY_ACTION_REMOTE_MODERATOR_LEFT,
      payload: payload
    });
  };
}

function handleConferenceEnded(payload) {
  return function (dispatch) {
    dispatch({
      type: c.GALAXY_ACTION_END,
      payload: (0, _objectSpread2.default)({}, payload, {
        reason: c.GALAXY_EVENT_CONFERENCE_ENDED
      })
    });
  };
}

function handleConferenceJoined(payload) {
  return function (dispatch) {
    dispatch((0, _call.conferenceJoined)(payload));
    dispatch((0, _call.subscribeToConference)((0, _safeAccess.default)(payload, 'conferenceId')));
  };
}

function handleGalaxyCallEnded(store, action, preState) {
  var conferenceId = (0, _safeAccess.default)(preState, 'nucleus.galaxy.call.conferenceId');
  var callIdMatches = (0, _safeAccess.default)(preState, 'nucleus.galaxy.call.callId') === (0, _safeAccess.default)(action, 'payload.callId');
  var conferenceIdMatches = (0, _safeAccess.default)(action, 'payload.conferenceId') === conferenceId;

  if ((callIdMatches || conferenceIdMatches) && conferenceId) {
    store.dispatch((0, _call.unsubscribeFromConference)(conferenceId));
  }
}

function handleConferenceNotification(payload) {
  return function (dispatch, getState) {
    var state = getState();
    var conferenceId = (0, _conference2.selectConferenceId)(state);
    if (conferenceId !== (0, _safeAccess.default)(payload, 'conferenceId')) return;
    var events = (0, _safeAccess.default)(payload, 'events') || [];
    events.forEach(function (e) {
      var action = conferenceNotificationMap[(0, _safeAccess.default)(e, 'event')];
      if (!action) return;
      dispatch(action(e));
    });
  };
}

function handleChangeLayoutResponse(payload) {
  return function (dispatch, getState) {
    var state = getState();

    if ((0, _galaxyUtils.isGalaxyCallConnected)(state)) {
      dispatch({
        type: c.GALAXY_ACTION_CHANGE_LAYOUT_RESPONSE,
        payload: payload
      });
    }
  };
}

function handleReportLocalMute(store) {
  var state = store.getState();
  var muted = (0, _safeAccess.default)(state, 'nucleus.media.isAudioMuted') || !(0, _safeAccess.default)(state, 'nucleus.media.hasOutgoingAudio');

  if ((0, _galaxyUtils.isGalaxyCallConnected)(state)) {
    store.dispatch((0, _conference.galaxyReportLocalMute)(muted));
  }
}

function handleReportLocalVideoMute(store) {
  var state = store.getState();
  var muted = (0, _safeAccess.default)(state, 'nucleus.media.isVideoMuted') || !(0, _safeAccess.default)(state, 'nucleus.media.hasOutgoingVideo');

  if ((0, _galaxyUtils.isGalaxyCallConnected)(state)) {
    store.dispatch((0, _conference.galaxyReportLocalVideoMute)(muted));
  }
}

function reportLocalMuteStates(store) {
  handleReportLocalMute(store);
  handleReportLocalVideoMute(store); // const state = store.getState();
  // const isAudioMuted = get(state, 'nucleus.media.isAudioMuted') || !get(state, 'nucleus.media.hasOutgoingAudio');
  // const isVideoMuted = get(state, 'nucleus.media.isVideoMuted') || !get(state, 'nucleus.media.hasOutgoingVideo');
  // // report only if muted
  // if(isAudioMuted) {
  //   handleReportLocalMute(store);
  // }
  // if(isVideoMuted) {
  //   handleReportLocalVideoMute(store);
  // }
}
/**
 * Invoked when a "meetingLocked" event is received from Conference Manager.
 */


function handleConferenceLockedEvent() {
  return function (dispatch) {
    dispatch({
      type: c.GALAXY_ACTION_CONFERENCE_LOCKED
    });
  };
}
/**
 * Invoked when a "meetingUnlocked" event is received from Conference Manager.
 */


function handleConferenceUnlockedEvent() {
  return function (dispatch) {
    dispatch({
      type: c.GALAXY_ACTION_CONFERENCE_UNLOCKED
    });
  };
}

function handleConferenceHandRaisedEvent(data) {
  return {
    type: c.GALAXY_ACTION_CONFERENCE_PARTICIPANT_HAND_RAISED,
    payload: data
  };
}

function handleConferenceHandLoweredEvent(data) {
  return function (dispatch, getState) {
    var currentUserId = (0, _currentUser.getUserUUID)(getState());
    var initiatorUserId = (0, _safeAccess.default)(data, 'initiatedBy.uuid');
    var isSelfLowered = currentUserId === initiatorUserId;
    dispatch({
      type: c.GALAXY_ACTION_CONFERENCE_PARTICIPANT_HAND_LOWERED,
      payload: (0, _objectSpread2.default)({}, data, {
        isSelfLowered: isSelfLowered
      })
    });
  };
}

function handleConferenceAllHandsLoweredEvent(data) {
  return {
    type: c.GALAXY_ACTION_CONFERENCE_ALL_HANDS_LOWERED,
    payload: data
  };
}
/**
 * Function Maps
 *
 * Mapping conveniences to assocate a constant with a function.
 * All of these functions have an "interface" of handler(store, payload).
 * If we migrate to typescript, we will check that there.
 * For now, there is no checking of the function "inferfaces"
 */


var passThroughActionMap = (0, _defineProperty2.default)({}, c.GALAXY_PASSTHROUGH_FECC, handleFECC);
var conferenceNotificationMap = (_conferenceNotificati = {}, (0, _defineProperty2.default)(_conferenceNotificati, c.GALAXY_EVENT_FIRST_PARTICIPANT_READY_IN_IVR, handleFirstParticipantReadyInIVR), (0, _defineProperty2.default)(_conferenceNotificati, c.GALAXY_EVENT_MODERATOR_JOINED, handleModeratorJoined), (0, _defineProperty2.default)(_conferenceNotificati, c.GALAXY_EVENT_MODERATOR_LEFT, handleModeratorLeft), (0, _defineProperty2.default)(_conferenceNotificati, c.GALAXY_EVENT_REMOTE_MODERATOR_JOINED, handleRemoteModeratorJoined), (0, _defineProperty2.default)(_conferenceNotificati, c.GALAXY_EVENT_REMOTE_MODERATOR_LEFT, handleRemoteModeratorLeft), (0, _defineProperty2.default)(_conferenceNotificati, c.GALAXY_EVENT_CONFERENCE_ENDED, handleConferenceEnded), (0, _defineProperty2.default)(_conferenceNotificati, c.GALAXY_EVENT_PARTICIPANT_JOINED, _call.participantJoined), (0, _defineProperty2.default)(_conferenceNotificati, c.GALAXY_EVENT_CONFERENCE_ESCALATED, _call.conferenceEscalated), (0, _defineProperty2.default)(_conferenceNotificati, c.GALAXY_EVENT_PARTICIPANT_LEFT, _call.participantLeft), (0, _defineProperty2.default)(_conferenceNotificati, c.GALAXY_EVENT_PARTICIPANT_LOCAL_MUTE, _call.participantLocalMuted), (0, _defineProperty2.default)(_conferenceNotificati, c.GALAXY_EVENT_PARTICIPANT_LOCAL_UN_MUTE, _call.participantLocalUnmuted), (0, _defineProperty2.default)(_conferenceNotificati, c.GALAXY_EVENT_MUTE_PARTICIPANT, _call.participantMuted), (0, _defineProperty2.default)(_conferenceNotificati, c.GALAXY_EVENT_UN_MUTE_PARTICIPANT, _call.participantUnmuted), (0, _defineProperty2.default)(_conferenceNotificati, c.GALAXY_EVENT_MUTE_ALL, _call.conferenceMuted), (0, _defineProperty2.default)(_conferenceNotificati, c.GALAXY_EVENT_UN_MUTE_ALL, _call.conferenceUnmuted), (0, _defineProperty2.default)(_conferenceNotificati, c.GALAXY_EVENT_PRESENTATION_FLOOR_GRANTED, _call.presentationFloorGranted), (0, _defineProperty2.default)(_conferenceNotificati, c.GALAXY_EVENT_PRESENTATION_FLOOR_RELEASED, _call.presentationFloorReleased), (0, _defineProperty2.default)(_conferenceNotificati, c.GALAXY_EVENT_RECORDING_STARTED, _call.recordingStartedNotification), (0, _defineProperty2.default)(_conferenceNotificati, c.GALAXY_EVENT_RECORDING_STOPPED, _call.recordingStopped), (0, _defineProperty2.default)(_conferenceNotificati, c.GALAXY_EVENT_CONFERENCE_LOCKED, handleConferenceLockedEvent), (0, _defineProperty2.default)(_conferenceNotificati, c.GALAXY_EVENT_CONFERENCE_UNLOCKED, handleConferenceUnlockedEvent), (0, _defineProperty2.default)(_conferenceNotificati, c.GALAXY_EVENT_HAND_RAISED, handleConferenceHandRaisedEvent), (0, _defineProperty2.default)(_conferenceNotificati, c.GALAXY_EVENT_HAND_LOWERED, handleConferenceHandLoweredEvent), (0, _defineProperty2.default)(_conferenceNotificati, c.GALAXY_EVENT_ALL_HANDS_LOWERED, handleConferenceAllHandsLoweredEvent), _conferenceNotificati);
var eventActionMap = (_eventActionMap = {}, (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_CALL, handleIncomingGalaxyCall), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_TRYING, _call.tryingCallGalaxy), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_RINGING, _call.ringingCallGalaxy), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_CONNECTED, _call.callAnsweredGalaxy), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_END, handleEndEvent), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_FAILED, handleFailedEvent), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_PRESENTATION_TOKEN_GRANTED, _stream.presentationTokenGrantedGalaxy), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_PRESENTATION_TOKEN_DENIED, _stream.presentationTokenDeniedGalaxy), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_PRESENTATION_TOKEN_REVOKED, _stream.presentationTokenRevoked), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_UPDATE, handleUpdateEvent), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_CALL_WAITING, handleCallWaiting), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_CALL_WAITING_CANCELLED, handleCallWaitingCancelled), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_REPLACE_CALL, handleReplaceCall), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_PASSTHROUGH, handlePassthroughEvent), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_CREATE_OFFER, _stream.createOfferEventGalaxy), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_IN_CALL_OFFER, _stream.inCallOfferEventGalaxy), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_OFFER_ANSWERED, _stream.offerAnsweredEventGalaxy), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_TRICKLE_ICE, _call.remoteIceCandidates), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_ADD_RESPONSE, handleAddResponse), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_CONFERENCE_JOINED, handleConferenceJoined), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_CONFERENCE_NOTIFICATION, handleConferenceNotification), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_REQUEST_PIN, _call.pinRequested), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_CHANGE_LAYOUT_RESPONSE, handleChangeLayoutResponse), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_CALL_PICKUP_FAILED, _call.callPickupFailed), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_ADD_RINGING, _call.addRinging), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_RECORDING_STARTED, _call.recordingStarted), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_RECORDING_STOPPED, _call.recordingStopped), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_RECORDING_FAILED, _call.recordingStartError), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_RECORDING_STOP_FAILED, _call.recordingStopError), (0, _defineProperty2.default)(_eventActionMap, c.GALAXY_EVENT_EJECT_SUCCESS, _call.ejectSuccess), (0, _defineProperty2.default)(_eventActionMap, _remoteModerator.REMOTE_MOD_REVOKED_EVENT, _remoteModerator.revoked), _eventActionMap);
var eventIgnoreMap = (_eventIgnoreMap = {}, (0, _defineProperty2.default)(_eventIgnoreMap, c.GALAXY_EVENT_RECORDING_INITIATED, true), (0, _defineProperty2.default)(_eventIgnoreMap, c.GALAXY_EVENT_RECORDING_STOP_INITIATED, true), _eventIgnoreMap);
var galaxyActionMap = (_galaxyActionMap = {}, (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_TRYING, handleAutoCancel), (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_RINGING, handleAutoCancel), (0, _defineProperty2.default)(_galaxyActionMap, c.WAMP_CONNECTION_DISPOSED_HEALTHY, handleConnectionDisposed), (0, _defineProperty2.default)(_galaxyActionMap, c.WAMP_CONNECTION_DISPOSED_JWT_ERROR, handleConnectionDisposed), (0, _defineProperty2.default)(_galaxyActionMap, c.WAMP_CONNECTION_DISPOSED_UNEXPECTED, handleConnectionDisposed), (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_END, handleGalaxyCallEnded), (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_FAILED, handleGalaxyCallEnded), (0, _defineProperty2.default)(_galaxyActionMap, c.WAMP_CONNECT_SUCCESS, handleWampConnected), (0, _defineProperty2.default)(_galaxyActionMap, c.LOCAL_AUDIO_MUTED, handleReportLocalMute), (0, _defineProperty2.default)(_galaxyActionMap, c.LOCAL_AUDIO_UNMUTED, handleReportLocalMute), (0, _defineProperty2.default)(_galaxyActionMap, c.LOCAL_VIDEO_MUTED, handleReportLocalVideoMute), (0, _defineProperty2.default)(_galaxyActionMap, c.LOCAL_VIDEO_UNMUTED, handleReportLocalVideoMute), (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_CONFERENCE_JOINED, reportLocalMuteStates), (0, _defineProperty2.default)(_galaxyActionMap, c.GALAXY_ACTION_CONFERENCE_ESCALATED, reportLocalMuteStates), _galaxyActionMap);
var timeoutMap = (_timeoutMap = {}, (0, _defineProperty2.default)(_timeoutMap, c.GALAXY_ACTION_BEGIN_CALL, handleBeginCall), (0, _defineProperty2.default)(_timeoutMap, c.GALAXY_ACTION_BEGIN_ANSWER, handleBeginAnswer), (0, _defineProperty2.default)(_timeoutMap, c.GALAXY_ACTION_ADD_TO_CALL, handleAddToCall), _timeoutMap);

function doesCallIdMatch(state, payload) {
  var callId = (0, _safeAccess.default)(payload, 'callId');
  var incomingCallQueue = (0, _safeAccess.default)(state, 'nucleus.galaxy.incoming') || [];
  var incomingExists = callId && incomingCallQueue.find(function (i) {
    return (0, _safeAccess.default)(i, 'callId') === callId;
  });
  var callIdMatches = callId && (0, _safeAccess.default)(state, 'nucleus.galaxy.call.callId') === callId;
  return incomingExists || callIdMatches || !callId // escalation may replace conferenceIds, and will not include a call Id
  ;
}
/**
 * galaxyCallMiddleware
 */


var galaxyCallMiddleware = function galaxyCallMiddleware(store) {
  return function (next) {
    return function (action) {
      var preState = store.getState();
      var galaxyCallState = (0, _safeAccess.default)(preState, 'nucleus.galaxy.call.state');

      if (action.type === c.NETWORK_OFFLINE) {
        if (galaxyCallState !== c.GALAXY_CALL_STATE_CONNECTED && galaxyCallState !== c.GALAXY_CALL_STATE_DISCONNECTED) {
          // End any outgoing calls
          store.dispatch((0, _call.endCallGalaxy)({
            callId: (0, _safeAccess.default)(preState, 'nucleus.galaxy.call.callId'),
            reason: c.NETWORK_OFFLINE
          }));
        } else if (galaxyCallState === c.GALAXY_CALL_STATE_CONNECTED) {
          // After ~2 min, the call is unrecoverable
          offlineTimeout = setTimeout(function () {
            offlineTimeout = null;
            store.dispatch((0, _call.endCallGalaxy)({
              callId: (0, _safeAccess.default)(preState, 'nucleus.galaxy.call.callId'),
              reason: c.NETWORK_OFFLINE
            }));
          }, c.NETWORK_OFFLINE_CALL_TIMEOUT_MS);
        }
      }

      if (action.type === c.NETWORK_ONLINE && offlineTimeout) {
        clearTimeout(offlineTimeout);
      }

      var result = next(action); // Add timeout handlers for galaxy call scenarios.

      var timeoutHandler = timeoutMap[action.type];

      if (timeoutHandler) {
        timeoutHandler(store, action);
        return result;
      }

      var galaxyActionHandler = galaxyActionMap[action.type];

      if (galaxyActionHandler) {
        galaxyActionHandler(store, action, preState);
        return result;
      }

      if (action.type !== c.GALAXY_WAMP_SUBSCRIPTION_EVENT_CALL) return result;
      var event = (0, _safeAccess.default)(action, 'payload.event');

      if (!event) {
        _jsLogger.default.warn('Received galaxy subscription event with no event name.');

        return result;
      } // event is ignored


      var ignored = eventIgnoreMap[event];

      if (ignored) {
        return result;
      } // handler is an action


      var handler = eventActionMap[event];

      if (!handler) {
        _jsLogger.default.info('Handler for event not found:', (0, _safeAccess.default)(action, 'payload'));

        return result;
      }

      var state = store.getState();
      var payload = (0, _safeAccess.default)(action, 'payload'); // Match the call id's for all events other than an incoming call

      if (event !== c.GALAXY_EVENT_CALL && !doesCallIdMatch(state, payload)) {
        _jsLogger.default.warn('Received galaxy subscription event with non matching call Id.');

        return result;
      }

      asyncQueue.addToQueue(
      /*#__PURE__*/
      (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3() {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return store.dispatch(handler(payload, state));

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
      return result;
    };
  };
};

var _default = galaxyCallMiddleware;
exports.default = _default;

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(CONFIG) {

var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var c = _interopRequireWildcard(__webpack_require__(166));

var _constants = __webpack_require__(3);

var _safeAccess = _interopRequireDefault(__webpack_require__(8));

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _RTCDataChannelState = _interopRequireDefault(__webpack_require__(164));

var _RTCSignalingState = _interopRequireDefault(__webpack_require__(207));

var _RTCIceConnectionState = _interopRequireDefault(__webpack_require__(206));

var _dataChannelUtils = _interopRequireDefault(__webpack_require__(674));

var _chunkedDc = __webpack_require__(675);

var _actionMap;

var maxMessageSize = 64000; // Subset of the actual max: 65536;
// Since product wont let us use a degraded state while the data channel is connecting we need to timeout and retry.
// discuss with ptownsend and/or mtimmens if this needs to change.

var DATA_CHANNEL_TIMEOUT_INTERVAL = 15 * 1000;
/** @type {RTCPeerConnection} */

var peerConnection = null;
var dataChannel = null;
var dataChannelConnectInterval = null;
var unchunker = null;
var dataChannelSeqN = 0;
/** @type {TextEncoder} */

var encoder;
/** @type {TextDecoder} */

var decoder;

var getEncoder = function getEncoder() {
  if (!encoder) {
    encoder = new TextEncoder();
  }

  return encoder;
};

var getDecoder = function getDecoder() {
  if (!decoder) {
    decoder = new TextDecoder();
  }

  return decoder;
};

var closeDataChannel = function closeDataChannel(dispatch, error) {
  //clear all callbacks
  if (dataChannel) {
    dataChannel.onopen = null;
    dataChannel.onclose = null;
    dataChannel.onerror = null;
    dataChannel.onmessage = null;
  }

  if (dataChannel && (0, _safeAccess.default)(dataChannel, 'readyState') !== _RTCDataChannelState.default.closing && (0, _safeAccess.default)(dataChannel, 'readyState') !== _RTCDataChannelState.default.closed) {
    _jsLogger.default.info('Closing data channel in clean up');

    dispatch({
      type: c.actions.DATA_CHANNEL_CLOSING,
      error: error
    });
    dataChannel.close();
  } // data channel could already be closed/failed and we need to ensure the state is reset


  dispatch({
    type: c.actions.DATA_CHANNEL_CLOSED
  });
  dataChannel = null;
};

var closePeerConnection = function closePeerConnection() {
  //clear all callbacks
  if (peerConnection) {
    peerConnection.onicecandidate = null;
    peerConnection.oniceconnectionstatechange = null;
    peerConnection.ondatachannel = null;
  }

  if (peerConnection && (0, _safeAccess.default)(peerConnection, 'signalingState') !== _RTCSignalingState.default.closed) {
    peerConnection.close();
  }

  peerConnection = null;
};

var handleOffer =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee(store, payload) {
    var answer;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            _jsLogger.default.info('handling new data channel offer');

            createPeerConnection(store);

            if (!peerConnection) {
              _context.next = 12;
              break;
            }

            _context.next = 6;
            return peerConnection.setRemoteDescription(new window.RTCSessionDescription(payload));

          case 6:
            _context.next = 8;
            return peerConnection.createAnswer();

          case 8:
            answer = _context.sent;
            _context.next = 11;
            return peerConnection.setLocalDescription(answer);

          case 11:
            store.dispatch(_dataChannelUtils.default.send(c.service.dataChannel.answer, peerConnection.localDescription));

          case 12:
            _context.next = 17;
            break;

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](0);

            _jsLogger.default.error(_context.t0);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 14]]);
  }));

  return function handleOffer(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var handleAnswer = function handleAnswer(store, payload) {
  if (peerConnection) peerConnection.setRemoteDescription(new window.RTCSessionDescription(payload));
};

var handleEnd = function handleEnd() {
  closePeerConnection();
};

var createPeerConnection = function createPeerConnection(store) {
  closeDataChannel(store.dispatch); // Grab ice servers from either Galaxy or PSEMS

  var state = store.getState();
  var iceServers = (0, _safeAccess.default)(state, 'nucleus.galaxy.capabilities.iceServers') || [];
  peerConnection = new window.RTCPeerConnection({
    iceServers: iceServers
  });

  peerConnection.onicecandidate = function (e) {
    if (e && e.candidate) {
      store.dispatch(_dataChannelUtils.default.send(c.service.dataChannel.ice, e.candidate));
    }
  };

  peerConnection.oniceconnectionstatechange = function () {
    var iceConnectionState = (0, _safeAccess.default)(peerConnection, 'iceConnectionState');

    _jsLogger.default.info('data channel peer connection ice state changed:', iceConnectionState);

    if (iceConnectionState === _RTCIceConnectionState.default.failed || iceConnectionState === _RTCIceConnectionState.default.disconnected) {
      closeDataChannel(store.dispatch, "ice connection state is ".concat(iceConnectionState));
    }
  };

  peerConnection.ondatachannel = function (event) {
    _jsLogger.default.info('data channel peer connection fired ondatachannel');

    if (event && event.channel) {
      dataChannel = event.channel;
      setDataChannelEvents(store, dataChannel);
    }
  };

  return peerConnection;
};

var initializeUnchunker = function initializeUnchunker(dispatch) {
  unchunker = new _chunkedDc.Unchunker();

  unchunker.onMessage = function (message) {
    // convert uint8 array back to string and send
    var data = getDecoder().decode(message);
    dispatch({
      type: _constants.GRAPHITE_EVENT_RECEIVED,
      payload: JSON.parse(data)
    });
  };
};

var sendDataChunked = function sendDataChunked(payload) {
  var data = JSON.stringify(payload); // convert string to uint8 array of unicode points (utf-8 encoding)

  var message = getEncoder().encode(data);
  dataChannelSeqN++;
  var chunker = new _chunkedDc.Chunker(dataChannelSeqN, message, maxMessageSize); // Chunker(messageId, message, chunkSize)

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = chunker[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var chunk = _step.value;

      try {
        dataChannel.send(chunk);
      } catch (e) {
        _jsLogger.default.warn('Data channel send error:', e);
      }
    } // cleanup any old unchunked messages that haven't been updated in the last 10 seconds (tune if necessary)

  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if (unchunker) {
    // https://github.com/saltyrtc/chunked-dc-js#cleanup
    unchunker.gc(10 * 1000);
  }
};

var setDataChannelEvents = function setDataChannelEvents(store, dataChannel) {
  initializeUnchunker(store.dispatch);

  dataChannel.onmessage = function (event) {
    var chunk = event.data;

    if (!unchunker) {
      initializeUnchunker(store.dispatch);
    }

    unchunker.add(chunk);
  };

  dataChannel.onopen = function () {
    _jsLogger.default.info('data channel fired onopen'); // if the data channel subsequently closes, it will attempt to reconnect using the interval.


    store.dispatch({
      type: c.actions.DATA_CHANNEL_OPENED
    });
  };

  dataChannel.onerror = function (e) {
    _jsLogger.default.info('data channel error:', e);
  };

  dataChannel.onclose = function () {
    _jsLogger.default.info('data channel fired onclose');

    store.dispatch({
      type: c.actions.DATA_CHANNEL_CLOSED
    });
  };
};

var handleIceCandidate = function handleIceCandidate(store, payload) {
  if (peerConnection) peerConnection.addIceCandidate(new window.RTCIceCandidate(payload));
};

var handleCreateOffer =
/*#__PURE__*/
function () {
  var _ref2 = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee2(store) {
    var _peerConnection, offer;

    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;

            _jsLogger.default.info('starting data channel setup');

            _peerConnection = createPeerConnection(store);

            if (!_peerConnection) {
              _context2.next = 12;
              break;
            }

            // global
            dataChannel = _peerConnection.createDataChannel('communication');
            setDataChannelEvents(store, dataChannel);
            _context2.next = 8;
            return _peerConnection.createOffer({
              offerToReceiveAudio: false,
              offerToReceiveVideo: false
            });

          case 8:
            offer = _context2.sent;
            _context2.next = 11;
            return _peerConnection.setLocalDescription(offer);

          case 11:
            store.dispatch(_dataChannelUtils.default.send(c.service.dataChannel.offer, _peerConnection.localDescription));

          case 12:
            _context2.next = 17;
            break;

          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](0);

            _jsLogger.default.error(_context2.t0);

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 14]]);
  }));

  return function handleCreateOffer(_x3) {
    return _ref2.apply(this, arguments);
  };
}();

var handleSendMessage = function handleSendMessage(store, payload) {
  if (!dataChannel) return _jsLogger.default.info('could not send message over data channel, data channel is null'); // RTCDataChannel.send is sync and blocks the UI

  setTimeout(function () {
    try {
      sendDataChunked(payload);
    } catch (ex) {
      _jsLogger.default.info('exception publishing message over data channel: ', ex);
    }
  }, 0);
};

var openDataChannel = function openDataChannel(store) {
  var state = store.getState();
  var isDisplay = CONFIG.remoting.isDisplay;
  var isDataChannelOpen = (0, _safeAccess.default)(state, 'nucleus.dataChannel.open');
  var isDataChannelNegotiating = (0, _safeAccess.default)(state, 'nucleus.dataChannel.negotiating'); // no need to reconnect in these states

  if (isDisplay || isDataChannelOpen || isDataChannelNegotiating) return;
  store.dispatch({
    type: c.actions.DATA_CHANNEL_CREATE_OFFER
  });
};

var handleStartUp = function handleStartUp(store) {
  // interval already started
  if (dataChannelConnectInterval) return;
  openDataChannel(store); // Set interval for future reconnection attempts

  dataChannelConnectInterval = setInterval(function () {
    return openDataChannel(store);
  }, DATA_CHANNEL_TIMEOUT_INTERVAL);
};

var handleReconnect = function handleReconnect(store) {
  openDataChannel(store);
};

var stopConnecting = function stopConnecting(store) {
  if (dataChannelConnectInterval) {
    _jsLogger.default.warn('Stopping data channel reconnection attempts');

    clearInterval(dataChannelConnectInterval);
    dataChannelConnectInterval = null;
  }

  closeDataChannel(store.dispatch);
};

var actionMap = (_actionMap = {}, (0, _defineProperty2.default)(_actionMap, c.actions.DATA_CHANNEL_ANSWER_RECEIVED, handleAnswer), (0, _defineProperty2.default)(_actionMap, c.actions.DATA_CHANNEL_CLOSED, handleEnd), (0, _defineProperty2.default)(_actionMap, c.actions.DATA_CHANNEL_CREATE_OFFER, handleCreateOffer), (0, _defineProperty2.default)(_actionMap, c.actions.DATA_CHANNEL_ICECANDIDATE, handleIceCandidate), (0, _defineProperty2.default)(_actionMap, c.actions.DATA_CHANNEL_OFFER_RECEIVED, handleOffer), (0, _defineProperty2.default)(_actionMap, c.actions.DATA_CHANNEL_SEND_MESSAGE, handleSendMessage), (0, _defineProperty2.default)(_actionMap, c.actions.DATA_CHANNEL_START_UP, handleStartUp), (0, _defineProperty2.default)(_actionMap, c.actions.DATA_CHANNEL_RECONNECT, handleReconnect), (0, _defineProperty2.default)(_actionMap, _constants.WAMP_CONNECTION_DISPOSED_HEALTHY, stopConnecting), (0, _defineProperty2.default)(_actionMap, _constants.WAMP_CONNECTION_DISPOSED_JWT_ERROR, stopConnecting), (0, _defineProperty2.default)(_actionMap, _constants.WAMP_CONNECTION_DISPOSED_UNEXPECTED, stopConnecting), (0, _defineProperty2.default)(_actionMap, _constants.LOGOUT_BEGIN, stopConnecting), (0, _defineProperty2.default)(_actionMap, _constants.NETWORK_OFFLINE, stopConnecting), _actionMap);

var dataChannelMiddleware = function dataChannelMiddleware(store) {
  return function (next) {
    return function (action) {
      var result = next(action);

      if (!_dataChannelUtils.default.shouldAllowDataChannel()) {
        return result;
      }

      var handler = actionMap[action.type];
      if (handler) handler(store, action.payload);
      return result;
    };
  };
};

var _default = dataChannelMiddleware;
exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(29)["default"]))

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(CONFIG) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// This should be enabled by the client in clientConfigs
function shouldAllowDataChannel() {
  return CONFIG.remoting.enableDataChannel;
} // This should be passed in by the client in clientConfigs


function send(action) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var sendMessage = CONFIG.remoting.send;

  if (sendMessage) {
    return sendMessage(action, payload);
  }
}

var _default = {
  shouldAllowDataChannel: shouldAllowDataChannel,
  send: send
};
exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(29)["default"]))

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Unchunker = exports.Chunker = exports.HEADER_LENGTH = void 0;

var _createClass2 = _interopRequireDefault(__webpack_require__(36));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(34));

/**
 * chunked-dc v1.1.1
 * Binary chunking for WebRTC data channels & more.
 * https://github.com/saltyrtc/chunked-dc-js#readme
 *
 * Copyright (C) 2016-2018 Threema GmbH
 *
 * Licensed under the Apache License, Version 2.0, <see LICENSE-APACHE file>
 * or the MIT license <see LICENSE-MIT file>, at your option. This file may not be
 * copied, modified, or distributed except according to those terms.
 */
var Common = function Common() {
  (0, _classCallCheck2.default)(this, Common);
};

Common.HEADER_LENGTH = 9;

var Chunker =
/*#__PURE__*/
function () {
  function Chunker(id, message, chunkSize) {
    (0, _classCallCheck2.default)(this, Chunker);
    this.chunkId = 0;

    if (chunkSize < Common.HEADER_LENGTH + 1) {
      throw new Error('Chunk size must be at least ' + (Common.HEADER_LENGTH + 1));
    }

    if (message.byteLength < 1) {
      throw new Error('Array may not be empty');
    }

    if (id < 0 || id >= Math.pow(2, 32)) {
      throw new Error('Message id must be between 0 and 2**32-1');
    }

    this.id = id;
    this.message = message;
    this.chunkDataSize = chunkSize - Common.HEADER_LENGTH;
  }

  (0, _createClass2.default)(Chunker, [{
    key: "next",
    value: function next() {
      if (!this.hasNext) {
        return {
          done: true,
          value: null
        };
      }

      var currentIndex = this.chunkId * this.chunkDataSize;
      var remaining = this.message.byteLength - currentIndex;
      var chunkBytes = remaining < this.chunkDataSize ? remaining : this.chunkDataSize;
      var chunk = new DataView(new ArrayBuffer(chunkBytes + Common.HEADER_LENGTH));
      var options = remaining > chunkBytes ? 0 : 1;
      var id = this.id;
      var serial = this.nextSerial();
      chunk.setUint8(0, options);
      chunk.setUint32(1, id);
      chunk.setUint32(5, serial);

      for (var i = 0; i < chunkBytes; i++) {
        var offset = Common.HEADER_LENGTH + i;
        chunk.setUint8(offset, this.message[currentIndex + i]);
      }

      return {
        done: false,
        value: new Uint8Array(chunk.buffer)
      };
    }
  }, {
    key: "nextSerial",
    value: function nextSerial() {
      return this.chunkId++;
    }
  }, {
    key: Symbol.iterator,
    value: function value() {
      return this;
    }
  }, {
    key: "hasNext",
    get: function get() {
      var currentIndex = this.chunkId * this.chunkDataSize;
      var remaining = this.message.byteLength - currentIndex;
      return remaining >= 1;
    }
  }]);
  return Chunker;
}();

exports.Chunker = Chunker;

var Chunk =
/*#__PURE__*/
function () {
  function Chunk(buf, context) {
    (0, _classCallCheck2.default)(this, Chunk);

    if (buf.byteLength < Common.HEADER_LENGTH) {
      throw new Error('Invalid chunk: Too short');
    }

    var reader = new DataView(buf);
    var options = reader.getUint8(0);
    this._endOfMessage = (options & 0x01) === 1;
    this._id = reader.getUint32(1);
    this._serial = reader.getUint32(5);
    this._data = new Uint8Array(buf.slice(Common.HEADER_LENGTH));
    this._context = context;
  }

  (0, _createClass2.default)(Chunk, [{
    key: "isEndOfMessage",
    get: function get() {
      return this._endOfMessage;
    }
  }, {
    key: "id",
    get: function get() {
      return this._id;
    }
  }, {
    key: "serial",
    get: function get() {
      return this._serial;
    }
  }, {
    key: "data",
    get: function get() {
      return this._data;
    }
  }, {
    key: "context",
    get: function get() {
      return this._context;
    }
  }]);
  return Chunk;
}();

var ChunkCollector =
/*#__PURE__*/
function () {
  function ChunkCollector() {
    (0, _classCallCheck2.default)(this, ChunkCollector);
    this.messageLength = null;
    this.chunks = [];
    this.lastUpdate = new Date().getTime();
  }

  (0, _createClass2.default)(ChunkCollector, [{
    key: "addChunk",
    value: function addChunk(chunk) {
      if (this.hasSerial(chunk.serial)) {
        return;
      }

      this.chunks.push(chunk);
      this.lastUpdate = new Date().getTime();

      if (chunk.isEndOfMessage) {
        this.endArrived = true;
        this.messageLength = chunk.serial + 1;
      }
    }
  }, {
    key: "hasSerial",
    value: function hasSerial(serial) {
      return this.chunks.find(function (chunk) {
        return chunk.serial === serial;
      }) !== undefined;
    }
  }, {
    key: "merge",
    value: function merge() {
      if (!this.isComplete) {
        throw new Error('Not all chunks for this message have arrived yet.');
      }

      this.chunks.sort(function (a, b) {
        if (a.serial < b.serial) {
          return -1;
        } else if (a.serial > b.serial) {
          return 1;
        }

        return 0;
      });
      var capacity = this.chunks[0].data.byteLength * this.messageLength;
      var buf = new Uint8Array(new ArrayBuffer(capacity));
      var offset = 0;
      var firstSize = this.chunks[0].data.byteLength;
      var contextList = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.chunks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var chunk = _step.value;

          if (chunk.data.byteLength > firstSize) {
            throw new Error('No chunk may be larger than the first chunk of that message.');
          }

          buf.set(chunk.data, offset);
          offset += chunk.data.length;

          if (chunk.context !== undefined) {
            contextList.push(chunk.context);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return {
        message: buf.slice(0, offset),
        context: contextList
      };
    }
  }, {
    key: "isOlderThan",
    value: function isOlderThan(maxAge) {
      var age = new Date().getTime() - this.lastUpdate;
      return age > maxAge;
    }
  }, {
    key: "isComplete",
    get: function get() {
      return this.endArrived && this.chunks.length === this.messageLength;
    }
  }, {
    key: "chunkCount",
    get: function get() {
      return this.chunks.length;
    }
  }]);
  return ChunkCollector;
}();

var Unchunker =
/*#__PURE__*/
function () {
  function Unchunker() {
    (0, _classCallCheck2.default)(this, Unchunker);
    this.chunks = new Map();
    this.onMessage = null;
  }

  (0, _createClass2.default)(Unchunker, [{
    key: "add",
    value: function add(buf, context) {
      var chunk = new Chunk(buf, context);

      if (this.chunks.has(chunk.id) && this.chunks.get(chunk.id).hasSerial(chunk.serial)) {
        return;
      }

      if (chunk.isEndOfMessage && chunk.serial === 0) {
        this.notifyListener(chunk.data, context === undefined ? [] : [context]);
        this.chunks.delete(chunk.id);
        return;
      }

      var collector;

      if (this.chunks.has(chunk.id)) {
        collector = this.chunks.get(chunk.id);
      } else {
        collector = new ChunkCollector();
        this.chunks.set(chunk.id, collector);
      }

      collector.addChunk(chunk);

      if (collector.isComplete) {
        var merged = collector.merge();
        this.notifyListener(merged.message, merged.context);
        this.chunks.delete(chunk.id);
      }
    }
  }, {
    key: "notifyListener",
    value: function notifyListener(message, context) {
      if (this.onMessage != null) {
        this.onMessage(message, context);
      }
    }
  }, {
    key: "gc",
    value: function gc(maxAge) {
      var removedItems = 0;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.chunks[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var entry = _step2.value;
          var msgId = entry[0];
          var collector = entry[1];

          if (collector.isOlderThan(maxAge)) {
            removedItems += collector.chunkCount;
            this.chunks.delete(msgId);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return removedItems;
    }
  }]);
  return Unchunker;
}();

exports.Unchunker = Unchunker;
var HEADER_LENGTH = Common.HEADER_LENGTH;
exports.HEADER_LENGTH = HEADER_LENGTH;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _effects = __webpack_require__(148);

var _accountRecheckin = _interopRequireDefault(__webpack_require__(677));

var sagas =
/*#__PURE__*/
_regenerator.default.mark(function sagas() {
  return _regenerator.default.wrap(function sagas$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.all)([(0, _effects.call)(_accountRecheckin.default)]);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, sagas);
});

var _default = sagas;
exports.default = _default;

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = accountRecheckin;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _reduxSaga = __webpack_require__(293);

var _effects = __webpack_require__(148);

var _jsLogger = _interopRequireDefault(__webpack_require__(19));

var _userProfile = __webpack_require__(197);

var _call = __webpack_require__(51);

var c = _interopRequireWildcard(__webpack_require__(3));

var _marked =
/*#__PURE__*/
_regenerator.default.mark(accountRecheckin);

var BASE_DELAY_TIME = 2000; // This examines the call state after every action and will return when the
// comparison func is true.

var takeUntilCallState = function takeUntilCallState(comparison) {
  return (
    /*#__PURE__*/
    _regenerator.default.mark(function _callee() {
      var _ref, callState, _ref2;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _effects.select)(_call.activeCallSelector);

            case 2:
              _ref = _context.sent;
              callState = _ref.state;

            case 4:
              if (comparison(callState)) {
                _context.next = 13;
                break;
              }

              _context.next = 7;
              return (0, _effects.take)('*');

            case 7:
              _context.next = 9;
              return (0, _effects.select)(_call.activeCallSelector);

            case 9:
              _ref2 = _context.sent;
              callState = _ref2.state;
              _context.next = 4;
              break;

            case 13:
              return _context.abrupt("return", true);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })
  );
}; // ie. actively answering OR answered


var takeUntilNotDisconnected = takeUntilCallState(function (cs) {
  return cs !== c.CALL_STATE_DISCONNECTED;
});
var takeUntilDisconnected = takeUntilCallState(function (cs) {
  return cs === c.CALL_STATE_DISCONNECTED;
}); // Watches for a an update on the account topic signaling we need to reestablish
// our wamp connection.

function accountRecheckin() {
  var _ref3, callAnswered, _ref4, settingUpdatedWhileOnCall, attempts, done, delayMs;

  return _regenerator.default.wrap(function accountRecheckin$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (false) {}

          _context2.next = 3;
          return (0, _effects.race)({
            settingsNotif: (0, _effects.take)(c.ACCOUNT_SETTING_UPDATED),
            callAnswered: takeUntilNotDisconnected()
          });

        case 3:
          _ref3 = _context2.sent;
          callAnswered = _ref3.callAnswered;

          if (!callAnswered) {
            _context2.next = 16;
            break;
          }

          _context2.next = 8;
          return (0, _effects.race)({
            callEnded: takeUntilDisconnected(),
            settingUpdatedWhileOnCall: (0, _effects.take)(c.ACCOUNT_SETTING_UPDATED)
          });

        case 8:
          _ref4 = _context2.sent;
          settingUpdatedWhileOnCall = _ref4.settingUpdatedWhileOnCall;

          if (!settingUpdatedWhileOnCall) {
            _context2.next = 15;
            break;
          }

          _context2.next = 13;
          return takeUntilDisconnected();

        case 13:
          _context2.next = 16;
          break;

        case 15:
          return _context2.abrupt("continue", 0);

        case 16:
          // We start with 1 attempt to prevent massive amounts of reconnects all at
          // once.  Initial attempt will be spread randomly between 0-2000 ms.
          attempts = 1;
          done = false;

        case 18:
          if (!(attempts < 6 && !done)) {
            _context2.next = 34;
            break;
          }

          _context2.prev = 19;
          delayMs = BASE_DELAY_TIME * Math.pow(2, attempts);
          _context2.next = 23;
          return (0, _effects.call)(_reduxSaga.delay, delayMs);

        case 23:
          _context2.next = 25;
          return _effects.put.resolve((0, _userProfile.getUserProfile)());

        case 25:
          done = true;
          _context2.next = 32;
          break;

        case 28:
          _context2.prev = 28;
          _context2.t0 = _context2["catch"](19);

          _jsLogger.default.error('Recheckin failure:  %O', _context2.t0);

          attempts += 1;

        case 32:
          _context2.next = 18;
          break;

        case 34:
          _context2.next = 0;
          break;

        case 36:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked, null, [[19, 28]]);
}

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(81));

var _client = __webpack_require__(292);

var c = _interopRequireWildcard(__webpack_require__(3));

var init;
var client; // let cachePersistor;

var middleware = function middleware(storage) {
  return function (store) {
    return function (next) {
      return function (action) {
        if (!init) {
          // Once the first action comes through, we try to init our client and cache.
          init = (0, _client.getClientAndPersistor)(store.dispatch, storage).then(function (initResult) {
            var _initResult = (0, _slicedToArray2.default)(initResult, 1);

            client = _initResult[0];
          });
        }

        if ([c.GQL_QUERY, c.GQL_MUTATION, c.GQL_GET_CLIENT].includes(action.type)) {
          // For any actions that require client/persistor, we await init before
          // continuing.  (The promise will immediately resolve after the first time
          // around);
          return init.then(
          /*#__PURE__*/
          (0, _asyncToGenerator2.default)(
          /*#__PURE__*/
          _regenerator.default.mark(function _callee() {
            var _action$payload, result, _result;

            return _regenerator.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.t0 = action.type;
                    _context.next = _context.t0 === c.GQL_GET_CLIENT ? 3 : _context.t0 === c.GQL_QUERY ? 4 : _context.t0 === c.GQL_MUTATION ? 13 : 17;
                    break;

                  case 3:
                    return _context.abrupt("return", client);

                  case 4:
                    if (!(((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.fetchPolicy) === 'cache-and-network')) {
                      _context.next = 8;
                      break;
                    }

                    _context.t1 = client.watchQuery(action.payload);
                    _context.next = 11;
                    break;

                  case 8:
                    _context.next = 10;
                    return client.query(action.payload);

                  case 10:
                    _context.t1 = _context.sent;

                  case 11:
                    result = _context.t1;
                    return _context.abrupt("return", [result, client]);

                  case 13:
                    _context.next = 15;
                    return client.mutate(action.payload);

                  case 15:
                    _result = _context.sent;
                    return _context.abrupt("return", [_result, client]);

                  case 17:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          })));
        }

        return next(action);
      };
    };
  };
};

var _default = middleware;
exports.default = _default;

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApolloClient", function() { return ApolloClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApolloError", function() { return ApolloError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FetchType", function() { return FetchType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NetworkStatus", function() { return NetworkStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObservableQuery", function() { return ObservableQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isApolloError", function() { return isApolloError; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var apollo_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var apollo_utilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78);
/* harmony import */ var apollo_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33);
/* harmony import */ var apollo_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40);
/* harmony import */ var symbol_observable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(131);
/* harmony import */ var ts_invariant__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17);
/* harmony import */ var graphql_language_visitor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49);
/* harmony import */ var graphql_language_visitor__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(graphql_language_visitor__WEBPACK_IMPORTED_MODULE_7__);







var NetworkStatus;
(function (NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})(NetworkStatus || (NetworkStatus = {}));
function isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}

var Observable = (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"])(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[symbol_observable__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"]] = function () {
        return this;
    };
    Observable.prototype['@@observable'] = function () {
        return this;
    };
    return Observable;
}(apollo_link__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"]));

function isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}

function isApolloError(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var generateErrorMessage = function (err) {
    var message = '';
    if (isNonEmptyArray(err.graphQLErrors)) {
        err.graphQLErrors.forEach(function (graphQLError) {
            var errorMessage = graphQLError
                ? graphQLError.message
                : 'Error message not found.';
            message += "GraphQL error: " + errorMessage + "\n";
        });
    }
    if (err.networkError) {
        message += 'Network error: ' + err.networkError.message + '\n';
    }
    message = message.replace(/\n$/, '');
    return message;
};
var ApolloError = (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"])(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) {
            _this.message = generateErrorMessage(_this);
        }
        else {
            _this.message = errorMessage;
        }
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error));

var FetchType;
(function (FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})(FetchType || (FetchType = {}));

var hasError = function (storeValue, policy) {
    if (policy === void 0) { policy = 'none'; }
    return storeValue && (storeValue.networkError ||
        (policy === 'none' && isNonEmptyArray(storeValue.graphQLErrors)));
};
var ObservableQuery = (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"])(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function (observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* getOperationDefinition */ "m"])(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var observer = {
                next: function (result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) {
                        _this.queryManager.removeQuery(_this.queryId);
                    }
                    setTimeout(function () {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject,
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function () {
        var result = this.getCurrentResult();
        if (result.data === undefined) {
            result.data = {};
        }
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function () {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: NetworkStatus.error,
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' ||
            fetchPolicy === 'no-cache';
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if (hasError(queryStoreValue, this.options.errorPolicy)) {
                return {
                    data: void 0,
                    loading: false,
                    networkStatus: networkStatus,
                    error: new ApolloError({
                        graphQLErrors: queryStoreValue.graphQLErrors,
                        networkError: queryStoreValue.networkError,
                    }),
                };
            }
            if (queryStoreValue.variables) {
                this.options.variables = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, this.options.variables, queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus,
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') {
                result.errors = queryStoreValue.graphQLErrors;
            }
        }
        else {
            var loading = isNetworkFetchPolicy ||
                (partial && fetchPolicy !== 'cache-only');
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? NetworkStatus.loading : NetworkStatus.ready,
            };
        }
        if (!partial) {
            this.updateLastResult(Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, result, { stale: false }));
        }
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, result, { partial: partial });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function (newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot &&
            newResult &&
            snapshot.networkStatus === newResult.networkStatus &&
            snapshot.stale === newResult.stale &&
            Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_2__[/* equal */ "a"])(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function () {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function () {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function () {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function () {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function (variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') {
            return Promise.reject( true ? new ts_invariant__WEBPACK_IMPORTED_MODULE_6__[/* InvariantError */ "a"](3) : undefined);
        }
        if (fetchPolicy !== 'no-cache' &&
            fetchPolicy !== 'cache-and-network') {
            fetchPolicy = 'network-only';
        }
        if (!Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_2__[/* equal */ "a"])(this.variables, variables)) {
            this.variables = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, this.variables, variables);
        }
        if (!Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_2__[/* equal */ "a"])(this.options.variables, this.variables)) {
            this.options.variables = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, this.options.variables, this.variables);
        }
        return this.queryManager.fetchQuery(this.queryId, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, this.options, { fetchPolicy: fetchPolicy }), FetchType.refetch);
    };
    ObservableQuery.prototype.fetchMore = function (fetchMoreOptions) {
        var _this = this;
         true ? Object(ts_invariant__WEBPACK_IMPORTED_MODULE_6__[/* invariant */ "b"])(fetchMoreOptions.updateQuery, 4) : undefined;
        var combinedOptions = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, (fetchMoreOptions.query ? fetchMoreOptions : Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, this.options, fetchMoreOptions, { variables: Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, this.variables, fetchMoreOptions.variables) })), { fetchPolicy: 'network-only' });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager
            .fetchQuery(qid, combinedOptions, FetchType.normal, this.queryId)
            .then(function (fetchMoreResult) {
            _this.updateQuery(function (previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables,
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function (error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function (options) {
        var _this = this;
        var subscription = this.queryManager
            .startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
        })
            .subscribe({
            next: function (subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) {
                    _this.updateQuery(function (previous, _a) {
                        var variables = _a.variables;
                        return updateQuery(previous, {
                            subscriptionData: subscriptionData,
                            variables: variables,
                        });
                    });
                }
            },
            error: function (err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                 true || false;
            },
        });
        this.subscriptions.add(subscription);
        return function () {
            if (_this.subscriptions.delete(subscription)) {
                subscription.unsubscribe();
            }
        };
    };
    ObservableQuery.prototype.setOptions = function (opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, this.options, opts);
        if (opts.pollInterval) {
            this.startPolling(opts.pollInterval);
        }
        else if (opts.pollInterval === 0) {
            this.stopPolling();
        }
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' ||
            oldFetchPolicy === 'standby' ||
            fetchPolicy === 'network-only'), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function (variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) { tryFetch = false; }
        if (fetchResults === void 0) { fetchResults = true; }
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_2__[/* equal */ "a"])(variables, this.variables)) {
            return this.observers.size && fetchResults
                ? this.result()
                : Promise.resolve();
        }
        this.variables = this.options.variables = variables;
        if (!this.observers.size) {
            return Promise.resolve();
        }
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function (mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* tryFunctionOrLogError */ "I"])(function () {
            return mapFn(previousResult, { variables: variables });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function () {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function (pollInterval) {
        assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function (newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults
            ? newResult
            : Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* cloneDeep */ "f"])(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function (observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) {
                subObserver.error = defaultSubscriptionObserverErrorCallback;
            }
        }
        catch (_a) { }
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult)
            observer.next(this.lastResult);
        if (observer.error && this.lastError)
            observer.error(this.lastError);
        if (first) {
            this.setUpQuery();
        }
        return function () {
            if (_this.observers.delete(observer) && !_this.observers.size) {
                _this.tearDownQuery();
            }
        };
    };
    ObservableQuery.prototype.setUpQuery = function () {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) {
            queryManager.addObservableQuery(queryId, this);
        }
        if (this.options.pollInterval) {
            assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function (error) {
            _this.updateLastResult(Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, _this.lastResult, { errors: error.graphQLErrors, networkStatus: NetworkStatus.error, loading: false }));
            iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function (result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) {
                        queryManager.getLocalState().addExportedVariables(query_1, variables).then(function (variables) {
                            var previousVariables = _this.variables;
                            _this.variables = _this.options.variables = variables;
                            if (!result.loading &&
                                previousResult_1 &&
                                fetchPolicy_1 !== 'cache-only' &&
                                queryManager.transform(query_1).serverQuery &&
                                !Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_2__[/* equal */ "a"])(previousVariables, variables)) {
                                _this.refetch();
                            }
                            else {
                                iterateObserversSafely(_this.observers, 'next', result);
                            }
                        });
                    }
                    else {
                        iterateObserversSafely(_this.observers, 'next', result);
                    }
                }
            },
            error: onError,
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function () {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}(Observable));
function defaultSubscriptionObserverErrorCallback(error) {
     true || false;
}
function iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function (obs) { return obs[method] && observersWithMethod.push(obs); });
    observersWithMethod.forEach(function (obs) { return obs[method](argument); });
}
function assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
     true ? Object(ts_invariant__WEBPACK_IMPORTED_MODULE_6__[/* invariant */ "b"])(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 5) : undefined;
}

var MutationStore = (function () {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function () {
        return this.store;
    };
    MutationStore.prototype.get = function (mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function (mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null,
        };
    };
    MutationStore.prototype.markMutationError = function (mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function (mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function () {
        this.store = {};
    };
    return MutationStore;
}());

var QueryStore = (function () {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function () {
        return this.store;
    };
    QueryStore.prototype.get = function (queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function (query) {
        var previousQuery = this.store[query.queryId];
         true ? Object(ts_invariant__WEBPACK_IMPORTED_MODULE_6__[/* invariant */ "b"])(!previousQuery ||
            previousQuery.document === query.document ||
            Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_2__[/* equal */ "a"])(previousQuery.document, query.document), 19) : undefined;
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables &&
            previousQuery &&
            previousQuery.networkStatus !== NetworkStatus.loading) {
            if (!Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_2__[/* equal */ "a"])(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) {
            networkStatus = NetworkStatus.setVariables;
        }
        else if (query.isPoll) {
            networkStatus = NetworkStatus.poll;
        }
        else if (query.isRefetch) {
            networkStatus = NetworkStatus.refetch;
        }
        else {
            networkStatus = NetworkStatus.loading;
        }
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) {
            graphQLErrors = previousQuery.graphQLErrors;
        }
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata,
        };
        if (typeof query.fetchMoreForQueryId === 'string' &&
            this.store[query.fetchMoreForQueryId]) {
            this.store[query.fetchMoreForQueryId].networkStatus =
                NetworkStatus.fetchMore;
        }
    };
    QueryStore.prototype.markQueryResult = function (queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId])
            return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = NetworkStatus.ready;
        if (typeof fetchMoreForQueryId === 'string' &&
            this.store[fetchMoreForQueryId]) {
            this.store[fetchMoreForQueryId].networkStatus = NetworkStatus.ready;
        }
    };
    QueryStore.prototype.markQueryError = function (queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId])
            return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = NetworkStatus.error;
        if (typeof fetchMoreForQueryId === 'string') {
            this.markQueryResultClient(fetchMoreForQueryId, true);
        }
    };
    QueryStore.prototype.markQueryResultClient = function (queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) {
                storeValue.networkStatus = NetworkStatus.ready;
            }
        }
    };
    QueryStore.prototype.stopQuery = function (queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function (observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function (queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) {
                _this.stopQuery(queryId);
            }
            else {
                _this.store[queryId].networkStatus = NetworkStatus.loading;
            }
        });
    };
    return QueryStore;
}());

function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

var LocalState = (function () {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) {
            this.client = client;
        }
        if (resolvers) {
            this.addResolvers(resolvers);
        }
        if (fragmentMatcher) {
            this.setFragmentMatcher(fragmentMatcher);
        }
    }
    LocalState.prototype.addResolvers = function (resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) {
            resolvers.forEach(function (resolverGroup) {
                _this.resolvers = Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* mergeDeep */ "A"])(_this.resolvers, resolverGroup);
            });
        }
        else {
            this.resolvers = Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* mergeDeep */ "A"])(this.resolvers, resolvers);
        }
    };
    LocalState.prototype.setResolvers = function (resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function () {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function (_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __awaiter */ "b"])(this, void 0, void 0, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __generator */ "d"])(this, function (_c) {
                if (document) {
                    return [2, this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function (localResult) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, remoteResult, { data: localResult.result })); })];
                }
                return [2, remoteResult];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function (fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function () {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function (document) {
        if (Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* hasDirectives */ "s"])(['client'], document)) {
            if (this.resolvers) {
                return document;
            }
             true || false;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function (document) {
        return this.resolvers ? Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* removeClientSetsFromDocument */ "C"])(document) : document;
    };
    LocalState.prototype.prepareContext = function (context) {
        if (context === void 0) { context = {}; }
        var cache = this.cache;
        var newContext = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, context, { cache: cache, getCacheKey: function (obj) {
                if (cache.config) {
                    return cache.config.dataIdFromObject(obj);
                }
                else {
                     true ? Object(ts_invariant__WEBPACK_IMPORTED_MODULE_6__[/* invariant */ "b"])(false, 6) : undefined;
                }
            } });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function (document, variables, context) {
        if (variables === void 0) { variables = {}; }
        if (context === void 0) { context = {}; }
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __awaiter */ "b"])(this, void 0, void 0, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __generator */ "d"])(this, function (_a) {
                if (document) {
                    return [2, this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function (data) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, variables, data.exportedVariables)); })];
                }
                return [2, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, variables)];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function (document) {
        var forceResolvers = false;
        Object(graphql_language_visitor__WEBPACK_IMPORTED_MODULE_7__["visit"])(document, {
            Directive: {
                enter: function (node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function (arg) {
                            return arg.name.value === 'always' &&
                                arg.value.kind === 'BooleanValue' &&
                                arg.value.value === true;
                        });
                        if (forceResolvers) {
                            return graphql_language_visitor__WEBPACK_IMPORTED_MODULE_7__["BREAK"];
                        }
                    }
                },
            },
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function (document, variables) {
        return this.cache.diff({
            query: Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* buildQueryFromSelectionSet */ "d"])(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false,
        }).result;
    };
    LocalState.prototype.resolveDocument = function (document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) { context = {}; }
        if (variables === void 0) { variables = {}; }
        if (fragmentMatcher === void 0) { fragmentMatcher = function () { return true; }; }
        if (onlyRunForcedResolvers === void 0) { onlyRunForcedResolvers = false; }
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __awaiter */ "b"])(this, void 0, void 0, function () {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __generator */ "d"])(this, function (_b) {
                mainDefinition = Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* getMainDefinition */ "l"])(document);
                fragments = Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* getFragmentDefinitions */ "j"])(document);
                fragmentMap = Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* createFragmentMap */ "g"])(fragments);
                definitionOperation = mainDefinition
                    .operation;
                defaultOperationType = definitionOperation
                    ? capitalizeFirstLetter(definitionOperation)
                    : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, context, { cache: cache,
                        client: client }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers,
                };
                return [2, this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function (result) { return ({
                        result: result,
                        exportedVariables: execContext.exportedVariables,
                    }); })];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function (selectionSet, rootValue, execContext) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __awaiter */ "b"])(this, void 0, void 0, function () {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __generator */ "d"])(this, function (_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [rootValue];
                execute = function (selection) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __awaiter */ "b"])(_this, void 0, void 0, function () {
                    var fragment, typeCondition;
                    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __generator */ "d"])(this, function (_a) {
                        if (!Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* shouldInclude */ "F"])(selection, variables)) {
                            return [2];
                        }
                        if (Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* isField */ "t"])(selection)) {
                            return [2, this.resolveField(selection, rootValue, execContext).then(function (fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') {
                                        resultsToMerge.push((_a = {},
                                            _a[Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* resultKeyNameFromField */ "E"])(selection)] = fieldResult,
                                            _a));
                                    }
                                })];
                        }
                        if (Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* isInlineFragment */ "v"])(selection)) {
                            fragment = selection;
                        }
                        else {
                            fragment = fragmentMap[selection.name.value];
                             true ? Object(ts_invariant__WEBPACK_IMPORTED_MODULE_6__[/* invariant */ "b"])(fragment, 7) : undefined;
                        }
                        if (fragment && fragment.typeCondition) {
                            typeCondition = fragment.typeCondition.name.value;
                            if (execContext.fragmentMatcher(rootValue, typeCondition, context)) {
                                return [2, this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function (fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })];
                            }
                        }
                        return [2];
                    });
                }); };
                return [2, Promise.all(selectionSet.selections.map(execute)).then(function () {
                        return Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* mergeDeepArray */ "B"])(resultsToMerge);
                    })];
            });
        });
    };
    LocalState.prototype.resolveField = function (field, rootValue, execContext) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __awaiter */ "b"])(this, void 0, void 0, function () {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __generator */ "d"])(this, function (_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* resultKeyNameFromField */ "E"])(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers ||
                    this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) {
                            resultPromise = Promise.resolve(resolve(rootValue, Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* argumentsObjectFromField */ "b"])(field, variables), execContext.context, { field: field }));
                        }
                    }
                }
                return [2, resultPromise.then(function (result) {
                        if (result === void 0) { result = defaultResult; }
                        if (field.directives) {
                            field.directives.forEach(function (directive) {
                                if (directive.name.value === 'export' && directive.arguments) {
                                    directive.arguments.forEach(function (arg) {
                                        if (arg.name.value === 'as' && arg.value.kind === 'StringValue') {
                                            execContext.exportedVariables[arg.value.value] = result;
                                        }
                                    });
                                }
                            });
                        }
                        if (!field.selectionSet) {
                            return result;
                        }
                        if (result == null) {
                            return result;
                        }
                        if (Array.isArray(result)) {
                            return _this.resolveSubSelectedArray(field, result, execContext);
                        }
                        if (field.selectionSet) {
                            return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                        }
                    })];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function (field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function (item) {
            if (item === null) {
                return null;
            }
            if (Array.isArray(item)) {
                return _this.resolveSubSelectedArray(field, item, execContext);
            }
            if (field.selectionSet) {
                return _this.resolveSelectionSet(field.selectionSet, item, execContext);
            }
        }));
    };
    return LocalState;
}());

function multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new Observable(function (observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function (value) {
                observers.forEach(function (obs) { return obs.next && obs.next(value); });
            },
            error: function (error) {
                observers.forEach(function (obs) { return obs.error && obs.error(error); });
            },
            complete: function () {
                observers.forEach(function (obs) { return obs.complete && obs.complete(); });
            },
        });
        return function () {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function asyncMap(observable, mapFn) {
    return new Observable(function (observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function (value) {
                ++activeNextCount;
                new Promise(function (resolve) {
                    resolve(mapFn(value));
                }).then(function (result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function (e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function (e) {
                error && error.call(observer, e);
            },
            complete: function () {
                completed = true;
                if (!activeNextCount) {
                    complete && complete.call(observer);
                }
            },
        };
        var sub = observable.subscribe(handler);
        return function () { return sub.unsubscribe(); };
    });
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
var QueryManager = (function () {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function () { return undefined; } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new MutationStore();
        this.queryStore = new QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new (apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* canUseWeakMap */ "e"] ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new LocalState({ cache: store.getCache() });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function () {
        var _this = this;
        this.queries.forEach(function (_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function (reject) {
            reject( true ? new ts_invariant__WEBPACK_IMPORTED_MODULE_6__[/* InvariantError */ "a"](8) : undefined);
        });
    };
    QueryManager.prototype.mutate = function (_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __awaiter */ "b"])(this, void 0, void 0, function () {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __generator */ "d"])(this, function (_f) {
                switch (_f.label) {
                    case 0:
                         true ? Object(ts_invariant__WEBPACK_IMPORTED_MODULE_6__[/* invariant */ "b"])(mutation, 9) : undefined;
                         true ? Object(ts_invariant__WEBPACK_IMPORTED_MODULE_6__[/* invariant */ "b"])(!fetchPolicy || fetchPolicy === 'no-cache', 10) : undefined;
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function () { return ({ document: mutation }); });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [3, 2];
                        return [4, this.localState.addExportedVariables(mutation, variables, context)];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function () {
                            var ret = {};
                            if (updateQueriesByName) {
                                _this.queries.forEach(function (_a, queryId) {
                                    var observableQuery = _a.observableQuery;
                                    if (observableQuery) {
                                        var queryName = observableQuery.queryName;
                                        if (queryName &&
                                            hasOwnProperty.call(updateQueriesByName, queryName)) {
                                            ret[queryId] = {
                                                updater: updateQueriesByName[queryName],
                                                query: _this.queryStore.get(queryId),
                                            };
                                        }
                                    }
                                });
                            }
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse,
                        });
                        this.broadcastQueries();
                        self = this;
                        return [2, new Promise(function (resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, context, { optimisticResponse: optimisticResponse }), variables, false).subscribe({
                                    next: function (result) {
                                        if (Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* graphQLResultHasError */ "q"])(result) && errorPolicy === 'none') {
                                            error = new ApolloError({
                                                graphQLErrors: result.errors,
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') {
                                            self.dataStore.markMutationResult({
                                                mutationId: mutationId,
                                                result: result,
                                                document: mutation,
                                                variables: variables,
                                                updateQueries: generateUpdateQueriesInfo(),
                                                update: updateWithProxyFn,
                                            });
                                        }
                                        storeResult = result;
                                    },
                                    error: function (err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse,
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function () { return ({ document: null }); });
                                        reject(new ApolloError({
                                            networkError: err,
                                        }));
                                    },
                                    complete: function () {
                                        if (error) {
                                            self.mutationStore.markMutationError(mutationId, error);
                                        }
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse,
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') {
                                            refetchQueries = refetchQueries(storeResult);
                                        }
                                        var refetchQueryPromises = [];
                                        if (isNonEmptyArray(refetchQueries)) {
                                            refetchQueries.forEach(function (refetchQuery) {
                                                if (typeof refetchQuery === 'string') {
                                                    self.queries.forEach(function (_a) {
                                                        var observableQuery = _a.observableQuery;
                                                        if (observableQuery &&
                                                            observableQuery.queryName === refetchQuery) {
                                                            refetchQueryPromises.push(observableQuery.refetch());
                                                        }
                                                    });
                                                }
                                                else {
                                                    var queryOptions = {
                                                        query: refetchQuery.query,
                                                        variables: refetchQuery.variables,
                                                        fetchPolicy: 'network-only',
                                                    };
                                                    if (refetchQuery.context) {
                                                        queryOptions.context = refetchQuery.context;
                                                    }
                                                    refetchQueryPromises.push(self.query(queryOptions));
                                                }
                                            });
                                        }
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function () {
                                            self.setQuery(mutationId, function () { return ({ document: null }); });
                                            if (errorPolicy === 'ignore' &&
                                                storeResult &&
                                                Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* graphQLResultHasError */ "q"])(storeResult)) {
                                                delete storeResult.errors;
                                            }
                                            resolve(storeResult);
                                        });
                                    },
                                });
                            })];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function (queryId, options, fetchType, fetchMoreForQueryId) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __awaiter */ "b"])(this, void 0, void 0, function () {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __generator */ "d"])(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [3, 2];
                        return [4, this.localState.addExportedVariables(query, variables, context)];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, options, { variables: variables });
                        isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false,
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if (Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* hasDirectives */ "s"])(['live'], query))
                            shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== 'no-cache'
                            ? this.updateQueryWatch(queryId, query, options)
                            : undefined;
                        this.setQuery(queryId, function () { return ({
                            document: query,
                            lastRequestId: requestId,
                            invalidated: true,
                            cancel: cancel,
                        }); });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === FetchType.poll,
                            isRefetch: fetchType === FetchType.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId,
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId,
                            }).catch(function (error) {
                                if (isApolloError(error)) {
                                    throw error;
                                }
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new ApolloError({ networkError: error });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') {
                                return [2, networkResult];
                            }
                            networkResult.catch(function () { });
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) {
                            return [2, this.localState.runResolvers({
                                    document: query,
                                    remoteResult: { data: storeResult },
                                    context: context,
                                    variables: variables,
                                    onlyRunForcedResolvers: true,
                                }).then(function (result) {
                                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                    _this.broadcastQueries();
                                    return result;
                                })];
                        }
                        this.broadcastQueries();
                        return [2, { data: storeResult }];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function (queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === 'no-cache') {
            this.setQuery(queryId, function () { return ({
                newData: { result: result.data, complete: true },
            }); });
        }
        else {
            this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
        }
    };
    QueryManager.prototype.queryListenerForObserver = function (queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) {
                try {
                    observer[method](argument);
                }
                catch (e) {
                     true || false;
                }
            }
            else if (method === 'error') {
                 true || false;
            }
        }
        return function (queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue)
                return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery
                ? observableQuery.options.fetchPolicy
                : options.fetchPolicy;
            if (fetchPolicy === 'standby')
                return;
            var loading = isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult &&
                lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData ||
                (!newData && queryStoreValue.previousVariables) ||
                (networkStatusChanged && options.notifyOnNetworkStatusChange) ||
                fetchPolicy === 'cache-only' ||
                fetchPolicy === 'cache-and-network';
            if (loading && !shouldNotifyIfLoading) {
                return;
            }
            var hasGraphQLErrors = isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery
                && observableQuery.options.errorPolicy
                || options.errorPolicy
                || 'none';
            if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) {
                return invoke('error', new ApolloError({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError,
                }));
            }
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') {
                        _this.setQuery(queryId, function () { return ({ newData: null }); });
                    }
                    data = newData.result;
                    isMissing = !newData.complete;
                }
                else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== 'none' &&
                        (lastError && lastError.graphQLErrors) !==
                            queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    }
                    else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables ||
                                queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true,
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData ||
                    fetchPolicy === 'cache-only');
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale,
                };
                if (errorPolicy === 'all' && hasGraphQLErrors) {
                    resultFromStore.errors = queryStoreValue.graphQLErrors;
                }
                invoke('next', resultFromStore);
            }
            catch (networkError) {
                invoke('error', new ApolloError({ networkError: networkError }));
            }
        };
    };
    QueryManager.prototype.transform = function (document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* removeConnectionDirectiveFromDocument */ "D"])(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* hasClientExports */ "r"])(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* getDefaultValues */ "h"])(Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* getOperationDefinition */ "m"])(transformed)),
            };
            var add = function (doc) {
                if (doc && !transformCache.has(doc)) {
                    transformCache.set(doc, cacheEntry_1);
                }
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function (document, variables) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, this.transform(document).defaultVars, variables);
    };
    QueryManager.prototype.watchQuery = function (options, shouldSubscribe) {
        if (shouldSubscribe === void 0) { shouldSubscribe = true; }
         true ? Object(ts_invariant__WEBPACK_IMPORTED_MODULE_6__[/* invariant */ "b"])(options.fetchPolicy !== 'standby', 11) : undefined;
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') {
            options.notifyOnNetworkStatusChange = false;
        }
        var transformedOptions = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, options);
        return new ObservableQuery({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe,
        });
    };
    QueryManager.prototype.query = function (options) {
        var _this = this;
         true ? Object(ts_invariant__WEBPACK_IMPORTED_MODULE_6__[/* invariant */ "b"])(options.query, 12) : undefined;
         true ? Object(ts_invariant__WEBPACK_IMPORTED_MODULE_6__[/* invariant */ "b"])(options.query.kind === 'Document', 13) : undefined;
         true ? Object(ts_invariant__WEBPACK_IMPORTED_MODULE_6__[/* invariant */ "b"])(!options.returnPartialData, 14) : undefined;
         true ? Object(ts_invariant__WEBPACK_IMPORTED_MODULE_6__[/* invariant */ "b"])(!options.pollInterval, 15) : undefined;
        return new Promise(function (resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery
                .result()
                .then(resolve, reject)
                .then(function () {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function () {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function (queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function (queryId, listener) {
        this.setQuery(queryId, function (_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return { invalidated: false };
        });
    };
    QueryManager.prototype.updateQueryWatch = function (queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel)
            cancel();
        var previousResult = function () {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) {
                    previousResult = lastResult.data;
                }
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function (newData) {
                _this.setQuery(queryId, function () { return ({ invalidated: true, newData: newData }); });
            },
        });
    };
    QueryManager.prototype.addObservableQuery = function (queryId, observableQuery) {
        this.setQuery(queryId, function () { return ({ observableQuery: observableQuery }); });
    };
    QueryManager.prototype.removeObservableQuery = function (queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function () { return ({ observableQuery: null }); });
        if (cancel)
            cancel();
    };
    QueryManager.prototype.clearStore = function () {
        this.fetchQueryRejectFns.forEach(function (reject) {
            reject( true ? new ts_invariant__WEBPACK_IMPORTED_MODULE_6__[/* InvariantError */ "a"](16) : undefined);
        });
        var resetIds = [];
        this.queries.forEach(function (_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery)
                resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function () {
        var _this = this;
        return this.clearStore().then(function () {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function (includeStandby) {
        var _this = this;
        if (includeStandby === void 0) { includeStandby = false; }
        var observableQueryPromises = [];
        this.queries.forEach(function (_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' &&
                    (includeStandby || fetchPolicy !== 'standby')) {
                    observableQueryPromises.push(observableQuery.refetch());
                }
                _this.setQuery(queryId, function () { return ({ newData: null }); });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function (queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function (queryId, options, listener) {
         true || false;
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options)
            .catch(function () { return undefined; });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function (_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function (variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function (result) {
                if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if (Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* graphQLResultHasError */ "q"])(result)) {
                    throw new ApolloError({
                        graphQLErrors: result.errors,
                    });
                }
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new Observable(function (observer) {
                var sub = null;
                observablePromise_1.then(function (observable) { return sub = observable.subscribe(observer); }, observer.error);
                return function () { return sub && sub.unsubscribe(); };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function (queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function (queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function (x) { return x.unsubscribe(); });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function (observableQuery, optimistic) {
        if (optimistic === void 0) { optimistic = true; }
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) {
            return { data: newData.result, partial: false };
        }
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') {
            return { data: undefined, partial: false };
        }
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic,
        }), result = _b.result, complete = _b.complete;
        return {
            data: (complete || returnPartialData) ? result : void 0,
            partial: !complete,
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function (queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
             true ? Object(ts_invariant__WEBPACK_IMPORTED_MODULE_6__[/* invariant */ "b"])(foundObserveableQuery, 17) : undefined;
            observableQuery = foundObserveableQuery;
        }
        else {
            observableQuery = queryIdOrObservable;
        }
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query,
        };
    };
    QueryManager.prototype.broadcastQueries = function () {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function (info, id) {
            if (info.invalidated) {
                info.listeners.forEach(function (listener) {
                    if (listener) {
                        listener(_this.queryStore.get(id), info.newData);
                    }
                });
            }
        });
    };
    QueryManager.prototype.getLocalState = function () {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function (query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) { deduplication = this.queryDeduplication; }
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* getOperationName */ "n"])(serverQuery) || void 0,
                context: this.prepareContext(Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, context, { forceFetch: !deduplication })),
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = multiplex(Object(apollo_link__WEBPACK_IMPORTED_MODULE_4__["execute"])(link, operation)));
                    var cleanup = function () {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size)
                            inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup,
                    });
                }
            }
            else {
                observable = multiplex(Object(apollo_link__WEBPACK_IMPORTED_MODULE_4__["execute"])(link, operation));
            }
        }
        else {
            observable = Observable.of({ data: {} });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) {
            observable = asyncMap(observable, function (result) {
                return _this.localState.runResolvers({
                    document: clientQuery,
                    remoteResult: result,
                    context: context,
                    variables: variables,
                });
            });
        }
        return observable;
    };
    QueryManager.prototype.fetchRequest = function (_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function (resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function () {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function (_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function (result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === 'none' && isNonEmptyArray(result.errors)) {
                    return reject(new ApolloError({
                        graphQLErrors: result.errors,
                    }));
                }
                if (errorPolicy === 'all') {
                    errorsFromStore = result.errors;
                }
                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') {
                    resultFromStore = result.data;
                }
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true,
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) {
                        resultFromStore = result_1;
                    }
                }
            }).subscribe({
                error: function (error) {
                    cleanup();
                    reject(error);
                },
                complete: function () {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: NetworkStatus.ready,
                        stale: false,
                    });
                },
            });
            _this.setQuery(queryId, function (_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function (queryId) {
        return (this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set(),
        });
    };
    QueryManager.prototype.setQuery = function (queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, prev, updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function (queryId, invalidated) {
        if (invalidated === void 0) { invalidated = true; }
        if (queryId) {
            this.setQuery(queryId, function () { return ({ invalidated: invalidated }); });
        }
    };
    QueryManager.prototype.prepareContext = function (context) {
        if (context === void 0) { context = {}; }
        var newContext = this.localState.prepareContext(context);
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, newContext, { clientAwareness: this.clientAwareness });
    };
    QueryManager.prototype.checkInFlight = function (queryId) {
        var query = this.queryStore.get(queryId);
        return (query &&
            query.networkStatus !== NetworkStatus.ready &&
            query.networkStatus !== NetworkStatus.error);
    };
    QueryManager.prototype.startPollingQuery = function (options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
         true ? Object(ts_invariant__WEBPACK_IMPORTED_MODULE_6__[/* invariant */ "b"])(pollInterval, 18) : undefined;
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) {
                this.pollingInfoByQueryId.set(queryId, (info = {}));
            }
            info.interval = pollInterval;
            info.options = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, options, { fetchPolicy: 'network-only' });
            var maybeFetch_1 = function () {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) {
                        poll_1();
                    }
                    else {
                        _this.fetchQuery(queryId, info.options, FetchType.poll).then(poll_1, poll_1);
                    }
                }
            };
            var poll_1 = function () {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) {
                this.addQueryListener(queryId, listener);
            }
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function (queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}());

var DataStore = (function () {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function () {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function (result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) { ignoreErrors = false; }
        var writeWithErrors = !Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* graphQLResultHasError */ "q"])(result);
        if (ignoreErrors && Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* graphQLResultHasError */ "q"])(result) && result.data) {
            writeWithErrors = true;
        }
        if (!fetchMoreForQueryId && writeWithErrors) {
            this.cache.write({
                result: result.data,
                dataId: 'ROOT_QUERY',
                query: document,
                variables: variables,
            });
        }
    };
    DataStore.prototype.markSubscriptionResult = function (result, document, variables) {
        if (!Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* graphQLResultHasError */ "q"])(result)) {
            this.cache.write({
                result: result.data,
                dataId: 'ROOT_SUBSCRIPTION',
                query: document,
                variables: variables,
            });
        }
    };
    DataStore.prototype.markMutationInit = function (mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') {
                optimistic_1 = mutation.optimisticResponse(mutation.variables);
            }
            else {
                optimistic_1 = mutation.optimisticResponse;
            }
            this.cache.recordOptimisticTransaction(function (c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: { data: optimistic_1 },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update,
                    });
                }
                finally {
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function (mutation) {
        var _this = this;
        if (!Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* graphQLResultHasError */ "q"])(mutation.result)) {
            var cacheWrites_1 = [{
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables,
                }];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) {
                Object.keys(updateQueries_1).forEach(function (id) {
                    var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                    var _b = _this.cache.diff({
                        query: query.document,
                        variables: query.variables,
                        returnPartialData: true,
                        optimistic: false,
                    }), currentQueryResult = _b.result, complete = _b.complete;
                    if (complete) {
                        var nextQueryResult = Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* tryFunctionOrLogError */ "I"])(function () {
                            return updater(currentQueryResult, {
                                mutationResult: mutation.result,
                                queryName: Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* getOperationName */ "n"])(query.document) || undefined,
                                queryVariables: query.variables,
                            });
                        });
                        if (nextQueryResult) {
                            cacheWrites_1.push({
                                result: nextQueryResult,
                                dataId: 'ROOT_QUERY',
                                query: query.document,
                                variables: query.variables,
                            });
                        }
                    }
                });
            }
            this.cache.performTransaction(function (c) {
                cacheWrites_1.forEach(function (write) { return c.write(write); });
                var update = mutation.update;
                if (update) {
                    Object(apollo_utilities__WEBPACK_IMPORTED_MODULE_1__[/* tryFunctionOrLogError */ "I"])(function () { return update(c, mutation.result); });
                }
            });
        }
    };
    DataStore.prototype.markMutationComplete = function (_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) {
            this.cache.removeOptimistic(mutationId);
        }
    };
    DataStore.prototype.markUpdateQueryResult = function (document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document,
        });
    };
    DataStore.prototype.reset = function () {
        return this.cache.reset();
    };
    return DataStore;
}());

var version = "2.6.4";

var hasSuggestedDevtools = false;
var ApolloClient = (function () {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) {
            link = apollo_link__WEBPACK_IMPORTED_MODULE_4__["ApolloLink"].empty();
        }
        if (!link || !cache) {
            throw  true ? new ts_invariant__WEBPACK_IMPORTED_MODULE_6__[/* InvariantError */ "a"](1) : undefined;
        }
        this.link = link;
        this.cache = cache;
        this.store = new DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) {
            setTimeout(function () { return (_this.disableNetworkFetches = false); }, ssrForceFetchDelay);
        }
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools =  false &&
            false;
        if (typeof connectToDevTools === 'undefined'
            ? defaultConnectToDevTools
            : connectToDevTools && typeof window !== 'undefined') {
            window.__APOLLO_CLIENT__ = this;
        }
        if (!hasSuggestedDevtools && "production" !== 'production') {
            hasSuggestedDevtools = true;
            if (typeof window !== 'undefined' &&
                window.document &&
                window.top === window.self) {
                if (typeof window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
                    if (window.navigator &&
                        window.navigator.userAgent &&
                        window.navigator.userAgent.indexOf('Chrome') > -1) {
                        console.debug('Download the Apollo DevTools ' +
                            'for a better development experience: ' +
                            'https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm');
                    }
                }
            }
        }
        this.version = version;
        this.localState = new LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher,
        });
        this.queryManager = new QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion,
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function () {
                if (_this.devToolsHookCb) {
                    _this.devToolsHookCb({
                        action: {},
                        state: {
                            queries: _this.queryManager.queryStore.getStore(),
                            mutations: _this.queryManager.mutationStore.getStore(),
                        },
                        dataWithOptimisticResults: _this.cache.extract(true),
                    });
                }
            },
        });
    }
    ApolloClient.prototype.stop = function () {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function (options) {
        if (this.defaultOptions.watchQuery) {
            options = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, this.defaultOptions.watchQuery, options);
        }
        if (this.disableNetworkFetches &&
            (options.fetchPolicy === 'network-only' ||
                options.fetchPolicy === 'cache-and-network')) {
            options = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, options, { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function (options) {
        if (this.defaultOptions.query) {
            options = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, this.defaultOptions.query, options);
        }
         true ? Object(ts_invariant__WEBPACK_IMPORTED_MODULE_6__[/* invariant */ "b"])(options.fetchPolicy !== 'cache-and-network', 2) : undefined;
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') {
            options = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, options, { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function (options) {
        if (this.defaultOptions.mutate) {
            options = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, this.defaultOptions.mutate, options);
        }
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function (options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function (options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function (options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function (options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function (cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function (payload) {
        return Object(apollo_link__WEBPACK_IMPORTED_MODULE_4__["execute"])(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function () {
         true || false;
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () { return _this.queryManager.clearStore(); })
            .then(function () { return Promise.all(_this.resetStoreCallbacks.map(function (fn) { return fn(); })); })
            .then(function () { return _this.reFetchObservableQueries(); });
    };
    ApolloClient.prototype.clearStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () { return _this.queryManager.clearStore(); })
            .then(function () { return Promise.all(_this.clearStoreCallbacks.map(function (fn) { return fn(); })); });
    };
    ApolloClient.prototype.onResetStore = function (cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function () {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    ApolloClient.prototype.onClearStore = function (cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function () {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function (includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function (optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function (serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function (resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function (resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function () {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function (fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}());

/* harmony default export */ __webpack_exports__["default"] = (ApolloClient);

//# sourceMappingURL=bundle.esm.js.map


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// === Symbol Support ===

var hasSymbols = function () {
  return typeof Symbol === 'function';
};
var hasSymbol = function (name) {
  return hasSymbols() && Boolean(Symbol[name]);
};
var getSymbol = function (name) {
  return hasSymbol(name) ? Symbol[name] : '@@' + name;
};

if (hasSymbols() && !hasSymbol('observable')) {
  Symbol.observable = Symbol('observable');
}

var SymbolIterator = getSymbol('iterator');
var SymbolObservable = getSymbol('observable');
var SymbolSpecies = getSymbol('species');

// === Abstract Operations ===

function getMethod(obj, key) {
  var value = obj[key];

  if (value == null) return undefined;

  if (typeof value !== 'function') throw new TypeError(value + ' is not a function');

  return value;
}

function getSpecies(obj) {
  var ctor = obj.constructor;
  if (ctor !== undefined) {
    ctor = ctor[SymbolSpecies];
    if (ctor === null) {
      ctor = undefined;
    }
  }
  return ctor !== undefined ? ctor : Observable;
}

function isObservable(x) {
  return x instanceof Observable; // SPEC: Brand check
}

function hostReportError(e) {
  if (hostReportError.log) {
    hostReportError.log(e);
  } else {
    setTimeout(function () {
      throw e;
    });
  }
}

function enqueue(fn) {
  Promise.resolve().then(function () {
    try {
      fn();
    } catch (e) {
      hostReportError(e);
    }
  });
}

function cleanupSubscription(subscription) {
  var cleanup = subscription._cleanup;
  if (cleanup === undefined) return;

  subscription._cleanup = undefined;

  if (!cleanup) {
    return;
  }

  try {
    if (typeof cleanup === 'function') {
      cleanup();
    } else {
      var unsubscribe = getMethod(cleanup, 'unsubscribe');
      if (unsubscribe) {
        unsubscribe.call(cleanup);
      }
    }
  } catch (e) {
    hostReportError(e);
  }
}

function closeSubscription(subscription) {
  subscription._observer = undefined;
  subscription._queue = undefined;
  subscription._state = 'closed';
}

function flushSubscription(subscription) {
  var queue = subscription._queue;
  if (!queue) {
    return;
  }
  subscription._queue = undefined;
  subscription._state = 'ready';
  for (var i = 0; i < queue.length; ++i) {
    notifySubscription(subscription, queue[i].type, queue[i].value);
    if (subscription._state === 'closed') break;
  }
}

function notifySubscription(subscription, type, value) {
  subscription._state = 'running';

  var observer = subscription._observer;

  try {
    var m = getMethod(observer, type);
    switch (type) {
      case 'next':
        if (m) m.call(observer, value);
        break;
      case 'error':
        closeSubscription(subscription);
        if (m) m.call(observer, value);else throw value;
        break;
      case 'complete':
        closeSubscription(subscription);
        if (m) m.call(observer);
        break;
    }
  } catch (e) {
    hostReportError(e);
  }

  if (subscription._state === 'closed') cleanupSubscription(subscription);else if (subscription._state === 'running') subscription._state = 'ready';
}

function onNotify(subscription, type, value) {
  if (subscription._state === 'closed') return;

  if (subscription._state === 'buffering') {
    subscription._queue.push({ type: type, value: value });
    return;
  }

  if (subscription._state !== 'ready') {
    subscription._state = 'buffering';
    subscription._queue = [{ type: type, value: value }];
    enqueue(function () {
      return flushSubscription(subscription);
    });
    return;
  }

  notifySubscription(subscription, type, value);
}

var Subscription = function () {
  function Subscription(observer, subscriber) {
    _classCallCheck(this, Subscription);

    // ASSERT: observer is an object
    // ASSERT: subscriber is callable

    this._cleanup = undefined;
    this._observer = observer;
    this._queue = undefined;
    this._state = 'initializing';

    var subscriptionObserver = new SubscriptionObserver(this);

    try {
      this._cleanup = subscriber.call(undefined, subscriptionObserver);
    } catch (e) {
      subscriptionObserver.error(e);
    }

    if (this._state === 'initializing') this._state = 'ready';
  }

  _createClass(Subscription, [{
    key: 'unsubscribe',
    value: function unsubscribe() {
      if (this._state !== 'closed') {
        closeSubscription(this);
        cleanupSubscription(this);
      }
    }
  }, {
    key: 'closed',
    get: function () {
      return this._state === 'closed';
    }
  }]);

  return Subscription;
}();

var SubscriptionObserver = function () {
  function SubscriptionObserver(subscription) {
    _classCallCheck(this, SubscriptionObserver);

    this._subscription = subscription;
  }

  _createClass(SubscriptionObserver, [{
    key: 'next',
    value: function next(value) {
      onNotify(this._subscription, 'next', value);
    }
  }, {
    key: 'error',
    value: function error(value) {
      onNotify(this._subscription, 'error', value);
    }
  }, {
    key: 'complete',
    value: function complete() {
      onNotify(this._subscription, 'complete');
    }
  }, {
    key: 'closed',
    get: function () {
      return this._subscription._state === 'closed';
    }
  }]);

  return SubscriptionObserver;
}();

var Observable = exports.Observable = function () {
  function Observable(subscriber) {
    _classCallCheck(this, Observable);

    if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');

    if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');

    this._subscriber = subscriber;
  }

  _createClass(Observable, [{
    key: 'subscribe',
    value: function subscribe(observer) {
      if (typeof observer !== 'object' || observer === null) {
        observer = {
          next: observer,
          error: arguments[1],
          complete: arguments[2]
        };
      }
      return new Subscription(observer, this._subscriber);
    }
  }, {
    key: 'forEach',
    value: function forEach(fn) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        if (typeof fn !== 'function') {
          reject(new TypeError(fn + ' is not a function'));
          return;
        }

        function done() {
          subscription.unsubscribe();
          resolve();
        }

        var subscription = _this.subscribe({
          next: function (value) {
            try {
              fn(value, done);
            } catch (e) {
              reject(e);
              subscription.unsubscribe();
            }
          },

          error: reject,
          complete: resolve
        });
      });
    }
  }, {
    key: 'map',
    value: function map(fn) {
      var _this2 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');

      var C = getSpecies(this);

      return new C(function (observer) {
        return _this2.subscribe({
          next: function (value) {
            try {
              value = fn(value);
            } catch (e) {
              return observer.error(e);
            }
            observer.next(value);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            observer.complete();
          }
        });
      });
    }
  }, {
    key: 'filter',
    value: function filter(fn) {
      var _this3 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');

      var C = getSpecies(this);

      return new C(function (observer) {
        return _this3.subscribe({
          next: function (value) {
            try {
              if (!fn(value)) return;
            } catch (e) {
              return observer.error(e);
            }
            observer.next(value);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            observer.complete();
          }
        });
      });
    }
  }, {
    key: 'reduce',
    value: function reduce(fn) {
      var _this4 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');

      var C = getSpecies(this);
      var hasSeed = arguments.length > 1;
      var hasValue = false;
      var seed = arguments[1];
      var acc = seed;

      return new C(function (observer) {
        return _this4.subscribe({
          next: function (value) {
            var first = !hasValue;
            hasValue = true;

            if (!first || hasSeed) {
              try {
                acc = fn(acc, value);
              } catch (e) {
                return observer.error(e);
              }
            } else {
              acc = value;
            }
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));

            observer.next(acc);
            observer.complete();
          }
        });
      });
    }
  }, {
    key: 'concat',
    value: function concat() {
      var _this5 = this;

      for (var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++) {
        sources[_key] = arguments[_key];
      }

      var C = getSpecies(this);

      return new C(function (observer) {
        var subscription = void 0;
        var index = 0;

        function startNext(next) {
          subscription = next.subscribe({
            next: function (v) {
              observer.next(v);
            },
            error: function (e) {
              observer.error(e);
            },
            complete: function () {
              if (index === sources.length) {
                subscription = undefined;
                observer.complete();
              } else {
                startNext(C.from(sources[index++]));
              }
            }
          });
        }

        startNext(_this5);

        return function () {
          if (subscription) {
            subscription.unsubscribe();
            subscription = undefined;
          }
        };
      });
    }
  }, {
    key: 'flatMap',
    value: function flatMap(fn) {
      var _this6 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');

      var C = getSpecies(this);

      return new C(function (observer) {
        var subscriptions = [];

        var outer = _this6.subscribe({
          next: function (value) {
            if (fn) {
              try {
                value = fn(value);
              } catch (e) {
                return observer.error(e);
              }
            }

            var inner = C.from(value).subscribe({
              next: function (value) {
                observer.next(value);
              },
              error: function (e) {
                observer.error(e);
              },
              complete: function () {
                var i = subscriptions.indexOf(inner);
                if (i >= 0) subscriptions.splice(i, 1);
                completeIfDone();
              }
            });

            subscriptions.push(inner);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            completeIfDone();
          }
        });

        function completeIfDone() {
          if (outer.closed && subscriptions.length === 0) observer.complete();
        }

        return function () {
          subscriptions.forEach(function (s) {
            return s.unsubscribe();
          });
          outer.unsubscribe();
        };
      });
    }
  }, {
    key: SymbolObservable,
    value: function () {
      return this;
    }
  }], [{
    key: 'from',
    value: function from(x) {
      var C = typeof this === 'function' ? this : Observable;

      if (x == null) throw new TypeError(x + ' is not an object');

      var method = getMethod(x, SymbolObservable);
      if (method) {
        var observable = method.call(x);

        if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');

        if (isObservable(observable) && observable.constructor === C) return observable;

        return new C(function (observer) {
          return observable.subscribe(observer);
        });
      }

      if (hasSymbol('iterator')) {
        method = getMethod(x, SymbolIterator);
        if (method) {
          return new C(function (observer) {
            enqueue(function () {
              if (observer.closed) return;
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var item = _step.value;

                  observer.next(item);
                  if (observer.closed) return;
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              observer.complete();
            });
          });
        }
      }

      if (Array.isArray(x)) {
        return new C(function (observer) {
          enqueue(function () {
            if (observer.closed) return;
            for (var i = 0; i < x.length; ++i) {
              observer.next(x[i]);
              if (observer.closed) return;
            }
            observer.complete();
          });
        });
      }

      throw new TypeError(x + ' is not observable');
    }
  }, {
    key: 'of',
    value: function of() {
      for (var _len2 = arguments.length, items = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        items[_key2] = arguments[_key2];
      }

      var C = typeof this === 'function' ? this : Observable;

      return new C(function (observer) {
        enqueue(function () {
          if (observer.closed) return;
          for (var i = 0; i < items.length; ++i) {
            observer.next(items[i]);
            if (observer.closed) return;
          }
          observer.complete();
        });
      });
    }
  }, {
    key: SymbolSpecies,
    get: function () {
      return this;
    }
  }]);

  return Observable;
}();

if (hasSymbols()) {
  Object.defineProperty(Observable, Symbol('extensions'), {
    value: {
      symbol: SymbolObservable,
      hostReportError: hostReportError
    },
    configurable: true
  });
}

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorLink", function() { return ErrorLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onError", function() { return onError; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var apollo_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40);
/* harmony import */ var apollo_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33);



function onError(errorHandler) {
    return new apollo_link__WEBPACK_IMPORTED_MODULE_1__["ApolloLink"](function (operation, forward) {
        return new apollo_link__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"](function (observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function (result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward,
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer),
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function (networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError &&
                                networkError.result &&
                                networkError.result.errors,
                            forward: forward,
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer),
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function () {
                        if (!retriedResult) {
                            observer.complete.bind(observer)();
                        }
                    },
                });
            }
            catch (e) {
                errorHandler({ networkError: e, operation: operation, forward: forward });
                observer.error(e);
            }
            return function () {
                if (sub)
                    sub.unsubscribe();
                if (retriedSub)
                    sub.unsubscribe();
            };
        });
    });
}
var ErrorLink = (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "c"])(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = onError(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function (operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}(apollo_link__WEBPACK_IMPORTED_MODULE_1__["ApolloLink"]));


//# sourceMappingURL=bundle.esm.js.map


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apolloLink = __webpack_require__(40);

var _formatMessage = __webpack_require__(683);

var _formatMessage2 = _interopRequireDefault(_formatMessage);

var _logging = __webpack_require__(684);

var _logging2 = _interopRequireDefault(_logging);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint-disable import/no-unresolved,import/extensions */


var loggerLink = new _apolloLink.ApolloLink(function (operation, forward) {
  var startTime = new Date().getTime();

  return forward(operation).map(function (result) {
    var operationType = operation.query.definitions[0].operation;
    var ellapsed = new Date().getTime() - startTime;

    var group = (0, _formatMessage2.default)(operationType, operation, ellapsed);

    _logging2.default.groupCollapsed.apply(_logging2.default, _toConsumableArray(group));

    _logging2.default.log('INIT', operation);
    _logging2.default.log('RESULT', result);

    _logging2.default.groupEnd.apply(_logging2.default, _toConsumableArray(group));
    return result;
  });
});

exports.default = loggerLink;

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var formatMessage = function formatMessage(operationType, operation, ellapsed) {
  var headerCss = ['color: gray; font-weight: lighter', // title
  'color: ' + (operationType === 'query' ? '#03A9F4' : 'red') + ';', // operationType
  'color: inherit;'];

  var parts = ['%c apollo', '%c' + operationType, '%c' + operation.operationName];

  if (operationType !== 'subscription') {
    parts.push('%c(in ' + ellapsed + ' ms)');
    headerCss.push('color: gray; font-weight: lighter;'); // time
  }

  return [parts.join(' ')].concat(headerCss);
};

exports.default = formatMessage;

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable no-console */
var bindToConsole = function bindToConsole(consoleMethod, polyfill) {
  return consoleMethod ? consoleMethod.bind(console) : polyfill;
};

var logging = function () {
  var prefix = '';

  var consoleLog = function consoleLog() {
    var _console;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    (_console = console).log.apply(_console, [prefix].concat(args));
  };

  var consoleError = function consoleError() {
    var _console2;

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    (_console2 = console).error.apply(_console2, [prefix].concat(args));
  };

  var consoleGroup = function consoleGroup() {
    consoleLog.apply(undefined, arguments);
    prefix += '> ';
  };

  var consoleGroupEnd = function consoleGroupEnd() {
    prefix = prefix.slice(0, -2);
  };

  return {
    log: consoleLog,
    error: consoleError,
    group: bindToConsole(console.group, consoleGroup),
    groupCollapsed: bindToConsole(console.groupCollapsed, consoleGroup),
    groupEnd: bindToConsole(console.groupEnd, consoleGroupEnd)
  };
}();

exports.default = logging;

/***/ }),
/* 685 */
/***/ (function(module) {

module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"INTERFACE\",\"name\":\"Collection\",\"possibleTypes\":[{\"name\":\"MeetingCollection\"},{\"name\":\"CallHistoryCollection\"},{\"name\":\"UserCollection\"},{\"name\":\"RecordCollection\"},{\"name\":\"RoomSystemCollection\"},{\"name\":\"LinkedDeviceCollection\"}]},{\"kind\":\"INTERFACE\",\"name\":\"Record\",\"possibleTypes\":[{\"name\":\"Meeting\"},{\"name\":\"User\"},{\"name\":\"Group\"},{\"name\":\"CallHistory\"},{\"name\":\"RoomSystem\"},{\"name\":\"LinkedDevice\"},{\"name\":\"PersonalContact\"},{\"name\":\"GroupContact\"}]},{\"kind\":\"INTERFACE\",\"name\":\"Callable\",\"possibleTypes\":[{\"name\":\"Meeting\"},{\"name\":\"User\"},{\"name\":\"RoomSystem\"},{\"name\":\"PersonalContact\"},{\"name\":\"GroupContact\"},{\"name\":\"UnknownCallable\"}]},{\"kind\":\"INTERFACE\",\"name\":\"Chattable\",\"possibleTypes\":[{\"name\":\"Meeting\"},{\"name\":\"User\"}]},{\"kind\":\"UNION\",\"name\":\"include\",\"possibleTypes\":[{\"name\":\"PersonalContact\"},{\"name\":\"GroupContact\"},{\"name\":\"RoomSystem\"},{\"name\":\"UnknownCallable\"}]}]}}");

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

var require;var require;/*!
    localForage -- Offline Storage, Improved
    Version 1.7.3
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/
(function(f){if(true){module.exports=f()}else { var g; }})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw (f.code="MODULE_NOT_FOUND", f)}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
(function (global){
'use strict';
var Mutation = global.MutationObserver || global.WebKitMutationObserver;

var scheduleDrain;

{
  if (Mutation) {
    var called = 0;
    var observer = new Mutation(nextTick);
    var element = global.document.createTextNode('');
    observer.observe(element, {
      characterData: true
    });
    scheduleDrain = function () {
      element.data = (called = ++called % 2);
    };
  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
    var channel = new global.MessageChannel();
    channel.port1.onmessage = nextTick;
    scheduleDrain = function () {
      channel.port2.postMessage(0);
    };
  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
    scheduleDrain = function () {

      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
      var scriptEl = global.document.createElement('script');
      scriptEl.onreadystatechange = function () {
        nextTick();

        scriptEl.onreadystatechange = null;
        scriptEl.parentNode.removeChild(scriptEl);
        scriptEl = null;
      };
      global.document.documentElement.appendChild(scriptEl);
    };
  } else {
    scheduleDrain = function () {
      setTimeout(nextTick, 0);
    };
  }
}

var draining;
var queue = [];
//named nextTick for less confusing stack traces
function nextTick() {
  draining = true;
  var i, oldQueue;
  var len = queue.length;
  while (len) {
    oldQueue = queue;
    queue = [];
    i = -1;
    while (++i < len) {
      oldQueue[i]();
    }
    len = queue.length;
  }
  draining = false;
}

module.exports = immediate;
function immediate(task) {
  if (queue.push(task) === 1 && !draining) {
    scheduleDrain();
  }
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],2:[function(_dereq_,module,exports){
'use strict';
var immediate = _dereq_(1);

/* istanbul ignore next */
function INTERNAL() {}

var handlers = {};

var REJECTED = ['REJECTED'];
var FULFILLED = ['FULFILLED'];
var PENDING = ['PENDING'];

module.exports = Promise;

function Promise(resolver) {
  if (typeof resolver !== 'function') {
    throw new TypeError('resolver must be a function');
  }
  this.state = PENDING;
  this.queue = [];
  this.outcome = void 0;
  if (resolver !== INTERNAL) {
    safelyResolveThenable(this, resolver);
  }
}

Promise.prototype["catch"] = function (onRejected) {
  return this.then(null, onRejected);
};
Promise.prototype.then = function (onFulfilled, onRejected) {
  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
    typeof onRejected !== 'function' && this.state === REJECTED) {
    return this;
  }
  var promise = new this.constructor(INTERNAL);
  if (this.state !== PENDING) {
    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
    unwrap(promise, resolver, this.outcome);
  } else {
    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
  }

  return promise;
};
function QueueItem(promise, onFulfilled, onRejected) {
  this.promise = promise;
  if (typeof onFulfilled === 'function') {
    this.onFulfilled = onFulfilled;
    this.callFulfilled = this.otherCallFulfilled;
  }
  if (typeof onRejected === 'function') {
    this.onRejected = onRejected;
    this.callRejected = this.otherCallRejected;
  }
}
QueueItem.prototype.callFulfilled = function (value) {
  handlers.resolve(this.promise, value);
};
QueueItem.prototype.otherCallFulfilled = function (value) {
  unwrap(this.promise, this.onFulfilled, value);
};
QueueItem.prototype.callRejected = function (value) {
  handlers.reject(this.promise, value);
};
QueueItem.prototype.otherCallRejected = function (value) {
  unwrap(this.promise, this.onRejected, value);
};

function unwrap(promise, func, value) {
  immediate(function () {
    var returnValue;
    try {
      returnValue = func(value);
    } catch (e) {
      return handlers.reject(promise, e);
    }
    if (returnValue === promise) {
      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
    } else {
      handlers.resolve(promise, returnValue);
    }
  });
}

handlers.resolve = function (self, value) {
  var result = tryCatch(getThen, value);
  if (result.status === 'error') {
    return handlers.reject(self, result.value);
  }
  var thenable = result.value;

  if (thenable) {
    safelyResolveThenable(self, thenable);
  } else {
    self.state = FULFILLED;
    self.outcome = value;
    var i = -1;
    var len = self.queue.length;
    while (++i < len) {
      self.queue[i].callFulfilled(value);
    }
  }
  return self;
};
handlers.reject = function (self, error) {
  self.state = REJECTED;
  self.outcome = error;
  var i = -1;
  var len = self.queue.length;
  while (++i < len) {
    self.queue[i].callRejected(error);
  }
  return self;
};

function getThen(obj) {
  // Make sure we only access the accessor once as required by the spec
  var then = obj && obj.then;
  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
    return function appyThen() {
      then.apply(obj, arguments);
    };
  }
}

function safelyResolveThenable(self, thenable) {
  // Either fulfill, reject or reject with error
  var called = false;
  function onError(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.reject(self, value);
  }

  function onSuccess(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.resolve(self, value);
  }

  function tryToUnwrap() {
    thenable(onSuccess, onError);
  }

  var result = tryCatch(tryToUnwrap);
  if (result.status === 'error') {
    onError(result.value);
  }
}

function tryCatch(func, value) {
  var out = {};
  try {
    out.value = func(value);
    out.status = 'success';
  } catch (e) {
    out.status = 'error';
    out.value = e;
  }
  return out;
}

Promise.resolve = resolve;
function resolve(value) {
  if (value instanceof this) {
    return value;
  }
  return handlers.resolve(new this(INTERNAL), value);
}

Promise.reject = reject;
function reject(reason) {
  var promise = new this(INTERNAL);
  return handlers.reject(promise, reason);
}

Promise.all = all;
function all(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var values = new Array(len);
  var resolved = 0;
  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    allResolver(iterable[i], i);
  }
  return promise;
  function allResolver(value, i) {
    self.resolve(value).then(resolveFromAll, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
    function resolveFromAll(outValue) {
      values[i] = outValue;
      if (++resolved === len && !called) {
        called = true;
        handlers.resolve(promise, values);
      }
    }
  }
}

Promise.race = race;
function race(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    resolver(iterable[i]);
  }
  return promise;
  function resolver(value) {
    self.resolve(value).then(function (response) {
      if (!called) {
        called = true;
        handlers.resolve(promise, response);
      }
    }, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
  }
}

},{"1":1}],3:[function(_dereq_,module,exports){
(function (global){
'use strict';
if (typeof global.Promise !== 'function') {
  global.Promise = _dereq_(2);
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"2":2}],4:[function(_dereq_,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getIDB() {
    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */
    try {
        if (typeof indexedDB !== 'undefined') {
            return indexedDB;
        }
        if (typeof webkitIndexedDB !== 'undefined') {
            return webkitIndexedDB;
        }
        if (typeof mozIndexedDB !== 'undefined') {
            return mozIndexedDB;
        }
        if (typeof OIndexedDB !== 'undefined') {
            return OIndexedDB;
        }
        if (typeof msIndexedDB !== 'undefined') {
            return msIndexedDB;
        }
    } catch (e) {
        return;
    }
}

var idb = getIDB();

function isIndexedDBValid() {
    try {
        // Initialize IndexedDB; fall back to vendor-prefixed versions
        // if needed.
        if (!idb) {
            return false;
        }
        // We mimic PouchDB here;
        //
        // We test for openDatabase because IE Mobile identifies itself
        // as Safari. Oh the lulz...
        var isSafari = typeof openDatabase !== 'undefined' && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);

        var hasFetch = typeof fetch === 'function' && fetch.toString().indexOf('[native code') !== -1;

        // Safari <10.1 does not meet our requirements for IDB support (#5572)
        // since Safari 10.1 shipped with fetch, we can use that to detect it
        return (!isSafari || hasFetch) && typeof indexedDB !== 'undefined' &&
        // some outdated implementations of IDB that appear on Samsung
        // and HTC Android devices <4.4 are missing IDBKeyRange
        // See: https://github.com/mozilla/localForage/issues/128
        // See: https://github.com/mozilla/localForage/issues/272
        typeof IDBKeyRange !== 'undefined';
    } catch (e) {
        return false;
    }
}

// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor. (i.e.
// old QtWebKit versions, at least).
// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor. (i.e.
// old QtWebKit versions, at least).
function createBlob(parts, properties) {
    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */
    parts = parts || [];
    properties = properties || {};
    try {
        return new Blob(parts, properties);
    } catch (e) {
        if (e.name !== 'TypeError') {
            throw e;
        }
        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
        var builder = new Builder();
        for (var i = 0; i < parts.length; i += 1) {
            builder.append(parts[i]);
        }
        return builder.getBlob(properties.type);
    }
}

// This is CommonJS because lie is an external dependency, so Rollup
// can just ignore it.
if (typeof Promise === 'undefined') {
    // In the "nopromises" build this will just throw if you don't have
    // a global promise object, but it would throw anyway later.
    _dereq_(3);
}
var Promise$1 = Promise;

function executeCallback(promise, callback) {
    if (callback) {
        promise.then(function (result) {
            callback(null, result);
        }, function (error) {
            callback(error);
        });
    }
}

function executeTwoCallbacks(promise, callback, errorCallback) {
    if (typeof callback === 'function') {
        promise.then(callback);
    }

    if (typeof errorCallback === 'function') {
        promise["catch"](errorCallback);
    }
}

function normalizeKey(key) {
    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    return key;
}

function getCallback() {
    if (arguments.length && typeof arguments[arguments.length - 1] === 'function') {
        return arguments[arguments.length - 1];
    }
}

// Some code originally from async_storage.js in
// [Gaia](https://github.com/mozilla-b2g/gaia).

var DETECT_BLOB_SUPPORT_STORE = 'local-forage-detect-blob-support';
var supportsBlobs = void 0;
var dbContexts = {};
var toString = Object.prototype.toString;

// Transaction Modes
var READ_ONLY = 'readonly';
var READ_WRITE = 'readwrite';

// Transform a binary string to an array buffer, because otherwise
// weird stuff happens when you try to work with the binary string directly.
// It is known.
// From http://stackoverflow.com/questions/14967647/ (continues on next line)
// encode-decode-image-with-base64-breaks-image (2013-04-21)
function _binStringToArrayBuffer(bin) {
    var length = bin.length;
    var buf = new ArrayBuffer(length);
    var arr = new Uint8Array(buf);
    for (var i = 0; i < length; i++) {
        arr[i] = bin.charCodeAt(i);
    }
    return buf;
}

//
// Blobs are not supported in all versions of IndexedDB, notably
// Chrome <37 and Android <5. In those versions, storing a blob will throw.
//
// Various other blob bugs exist in Chrome v37-42 (inclusive).
// Detecting them is expensive and confusing to users, and Chrome 37-42
// is at very low usage worldwide, so we do a hacky userAgent check instead.
//
// content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
// 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
// FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
//
// Code borrowed from PouchDB. See:
// https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
//
function _checkBlobSupportWithoutCaching(idb) {
    return new Promise$1(function (resolve) {
        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
        var blob = createBlob(['']);
        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, 'key');

        txn.onabort = function (e) {
            // If the transaction aborts now its due to not being able to
            // write to the database, likely due to the disk being full
            e.preventDefault();
            e.stopPropagation();
            resolve(false);
        };

        txn.oncomplete = function () {
            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
            var matchedEdge = navigator.userAgent.match(/Edge\//);
            // MS Edge pretends to be Chrome 42:
            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
        };
    })["catch"](function () {
        return false; // error, so assume unsupported
    });
}

function _checkBlobSupport(idb) {
    if (typeof supportsBlobs === 'boolean') {
        return Promise$1.resolve(supportsBlobs);
    }
    return _checkBlobSupportWithoutCaching(idb).then(function (value) {
        supportsBlobs = value;
        return supportsBlobs;
    });
}

function _deferReadiness(dbInfo) {
    var dbContext = dbContexts[dbInfo.name];

    // Create a deferred object representing the current database operation.
    var deferredOperation = {};

    deferredOperation.promise = new Promise$1(function (resolve, reject) {
        deferredOperation.resolve = resolve;
        deferredOperation.reject = reject;
    });

    // Enqueue the deferred operation.
    dbContext.deferredOperations.push(deferredOperation);

    // Chain its promise to the database readiness.
    if (!dbContext.dbReady) {
        dbContext.dbReady = deferredOperation.promise;
    } else {
        dbContext.dbReady = dbContext.dbReady.then(function () {
            return deferredOperation.promise;
        });
    }
}

function _advanceReadiness(dbInfo) {
    var dbContext = dbContexts[dbInfo.name];

    // Dequeue a deferred operation.
    var deferredOperation = dbContext.deferredOperations.pop();

    // Resolve its promise (which is part of the database readiness
    // chain of promises).
    if (deferredOperation) {
        deferredOperation.resolve();
        return deferredOperation.promise;
    }
}

function _rejectReadiness(dbInfo, err) {
    var dbContext = dbContexts[dbInfo.name];

    // Dequeue a deferred operation.
    var deferredOperation = dbContext.deferredOperations.pop();

    // Reject its promise (which is part of the database readiness
    // chain of promises).
    if (deferredOperation) {
        deferredOperation.reject(err);
        return deferredOperation.promise;
    }
}

function _getConnection(dbInfo, upgradeNeeded) {
    return new Promise$1(function (resolve, reject) {
        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();

        if (dbInfo.db) {
            if (upgradeNeeded) {
                _deferReadiness(dbInfo);
                dbInfo.db.close();
            } else {
                return resolve(dbInfo.db);
            }
        }

        var dbArgs = [dbInfo.name];

        if (upgradeNeeded) {
            dbArgs.push(dbInfo.version);
        }

        var openreq = idb.open.apply(idb, dbArgs);

        if (upgradeNeeded) {
            openreq.onupgradeneeded = function (e) {
                var db = openreq.result;
                try {
                    db.createObjectStore(dbInfo.storeName);
                    if (e.oldVersion <= 1) {
                        // Added when support for blob shims was added
                        db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                    }
                } catch (ex) {
                    if (ex.name === 'ConstraintError') {
                        console.warn('The database "' + dbInfo.name + '"' + ' has been upgraded from version ' + e.oldVersion + ' to version ' + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                    } else {
                        throw ex;
                    }
                }
            };
        }

        openreq.onerror = function (e) {
            e.preventDefault();
            reject(openreq.error);
        };

        openreq.onsuccess = function () {
            resolve(openreq.result);
            _advanceReadiness(dbInfo);
        };
    });
}

function _getOriginalConnection(dbInfo) {
    return _getConnection(dbInfo, false);
}

function _getUpgradedConnection(dbInfo) {
    return _getConnection(dbInfo, true);
}

function _isUpgradeNeeded(dbInfo, defaultVersion) {
    if (!dbInfo.db) {
        return true;
    }

    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
    var isDowngrade = dbInfo.version < dbInfo.db.version;
    var isUpgrade = dbInfo.version > dbInfo.db.version;

    if (isDowngrade) {
        // If the version is not the default one
        // then warn for impossible downgrade.
        if (dbInfo.version !== defaultVersion) {
            console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + ' to version ' + dbInfo.version + '.');
        }
        // Align the versions to prevent errors.
        dbInfo.version = dbInfo.db.version;
    }

    if (isUpgrade || isNewStore) {
        // If the store is new then increment the version (if needed).
        // This will trigger an "upgradeneeded" event which is required
        // for creating a store.
        if (isNewStore) {
            var incVersion = dbInfo.db.version + 1;
            if (incVersion > dbInfo.version) {
                dbInfo.version = incVersion;
            }
        }

        return true;
    }

    return false;
}

// encode a blob for indexeddb engines that don't support blobs
function _encodeBlob(blob) {
    return new Promise$1(function (resolve, reject) {
        var reader = new FileReader();
        reader.onerror = reject;
        reader.onloadend = function (e) {
            var base64 = btoa(e.target.result || '');
            resolve({
                __local_forage_encoded_blob: true,
                data: base64,
                type: blob.type
            });
        };
        reader.readAsBinaryString(blob);
    });
}

// decode an encoded blob
function _decodeBlob(encodedBlob) {
    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
    return createBlob([arrayBuff], { type: encodedBlob.type });
}

// is this one of our fancy encoded blobs?
function _isEncodedBlob(value) {
    return value && value.__local_forage_encoded_blob;
}

// Specialize the default `ready()` function by making it dependent
// on the current database operations. Thus, the driver will be actually
// ready when it's been initialized (default) *and* there are no pending
// operations on the database (initiated by some other instances).
function _fullyReady(callback) {
    var self = this;

    var promise = self._initReady().then(function () {
        var dbContext = dbContexts[self._dbInfo.name];

        if (dbContext && dbContext.dbReady) {
            return dbContext.dbReady;
        }
    });

    executeTwoCallbacks(promise, callback, callback);
    return promise;
}

// Try to establish a new db connection to replace the
// current one which is broken (i.e. experiencing
// InvalidStateError while creating a transaction).
function _tryReconnect(dbInfo) {
    _deferReadiness(dbInfo);

    var dbContext = dbContexts[dbInfo.name];
    var forages = dbContext.forages;

    for (var i = 0; i < forages.length; i++) {
        var forage = forages[i];
        if (forage._dbInfo.db) {
            forage._dbInfo.db.close();
            forage._dbInfo.db = null;
        }
    }
    dbInfo.db = null;

    return _getOriginalConnection(dbInfo).then(function (db) {
        dbInfo.db = db;
        if (_isUpgradeNeeded(dbInfo)) {
            // Reopen the database for upgrading.
            return _getUpgradedConnection(dbInfo);
        }
        return db;
    }).then(function (db) {
        // store the latest db reference
        // in case the db was upgraded
        dbInfo.db = dbContext.db = db;
        for (var i = 0; i < forages.length; i++) {
            forages[i]._dbInfo.db = db;
        }
    })["catch"](function (err) {
        _rejectReadiness(dbInfo, err);
        throw err;
    });
}

// FF doesn't like Promises (micro-tasks) and IDDB store operations,
// so we have to do it with callbacks
function createTransaction(dbInfo, mode, callback, retries) {
    if (retries === undefined) {
        retries = 1;
    }

    try {
        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
        callback(null, tx);
    } catch (err) {
        if (retries > 0 && (!dbInfo.db || err.name === 'InvalidStateError' || err.name === 'NotFoundError')) {
            return Promise$1.resolve().then(function () {
                if (!dbInfo.db || err.name === 'NotFoundError' && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                    // increase the db version, to create the new ObjectStore
                    if (dbInfo.db) {
                        dbInfo.version = dbInfo.db.version + 1;
                    }
                    // Reopen the database for upgrading.
                    return _getUpgradedConnection(dbInfo);
                }
            }).then(function () {
                return _tryReconnect(dbInfo).then(function () {
                    createTransaction(dbInfo, mode, callback, retries - 1);
                });
            })["catch"](callback);
        }

        callback(err);
    }
}

function createDbContext() {
    return {
        // Running localForages sharing a database.
        forages: [],
        // Shared database.
        db: null,
        // Database readiness (promise).
        dbReady: null,
        // Deferred operations on the database.
        deferredOperations: []
    };
}

// Open the IndexedDB database (automatically creates one if one didn't
// previously exist), using any options set in the config.
function _initStorage(options) {
    var self = this;
    var dbInfo = {
        db: null
    };

    if (options) {
        for (var i in options) {
            dbInfo[i] = options[i];
        }
    }

    // Get the current context of the database;
    var dbContext = dbContexts[dbInfo.name];

    // ...or create a new context.
    if (!dbContext) {
        dbContext = createDbContext();
        // Register the new context in the global container.
        dbContexts[dbInfo.name] = dbContext;
    }

    // Register itself as a running localForage in the current context.
    dbContext.forages.push(self);

    // Replace the default `ready()` function with the specialized one.
    if (!self._initReady) {
        self._initReady = self.ready;
        self.ready = _fullyReady;
    }

    // Create an array of initialization states of the related localForages.
    var initPromises = [];

    function ignoreErrors() {
        // Don't handle errors here,
        // just makes sure related localForages aren't pending.
        return Promise$1.resolve();
    }

    for (var j = 0; j < dbContext.forages.length; j++) {
        var forage = dbContext.forages[j];
        if (forage !== self) {
            // Don't wait for itself...
            initPromises.push(forage._initReady()["catch"](ignoreErrors));
        }
    }

    // Take a snapshot of the related localForages.
    var forages = dbContext.forages.slice(0);

    // Initialize the connection process only when
    // all the related localForages aren't pending.
    return Promise$1.all(initPromises).then(function () {
        dbInfo.db = dbContext.db;
        // Get the connection or open a new one without upgrade.
        return _getOriginalConnection(dbInfo);
    }).then(function (db) {
        dbInfo.db = db;
        if (_isUpgradeNeeded(dbInfo, self._defaultConfig.version)) {
            // Reopen the database for upgrading.
            return _getUpgradedConnection(dbInfo);
        }
        return db;
    }).then(function (db) {
        dbInfo.db = dbContext.db = db;
        self._dbInfo = dbInfo;
        // Share the final connection amongst related localForages.
        for (var k = 0; k < forages.length; k++) {
            var forage = forages[k];
            if (forage !== self) {
                // Self is already up-to-date.
                forage._dbInfo.db = dbInfo.db;
                forage._dbInfo.version = dbInfo.version;
            }
        }
    });
}

function getItem(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.get(key);

                    req.onsuccess = function () {
                        var value = req.result;
                        if (value === undefined) {
                            value = null;
                        }
                        if (_isEncodedBlob(value)) {
                            value = _decodeBlob(value);
                        }
                        resolve(value);
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Iterate over all items stored in database.
function iterate(iterator, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.openCursor();
                    var iterationNumber = 1;

                    req.onsuccess = function () {
                        var cursor = req.result;

                        if (cursor) {
                            var value = cursor.value;
                            if (_isEncodedBlob(value)) {
                                value = _decodeBlob(value);
                            }
                            var result = iterator(value, cursor.key, iterationNumber++);

                            // when the iterator callback retuns any
                            // (non-`undefined`) value, then we stop
                            // the iteration immediately
                            if (result !== void 0) {
                                resolve(result);
                            } else {
                                cursor["continue"]();
                            }
                        } else {
                            resolve();
                        }
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);

    return promise;
}

function setItem(key, value, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        var dbInfo;
        self.ready().then(function () {
            dbInfo = self._dbInfo;
            if (toString.call(value) === '[object Blob]') {
                return _checkBlobSupport(dbInfo.db).then(function (blobSupport) {
                    if (blobSupport) {
                        return value;
                    }
                    return _encodeBlob(value);
                });
            }
            return value;
        }).then(function (value) {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);

                    // The reason we don't _save_ null is because IE 10 does
                    // not support saving the `null` type in IndexedDB. How
                    // ironic, given the bug below!
                    // See: https://github.com/mozilla/localForage/issues/161
                    if (value === null) {
                        value = undefined;
                    }

                    var req = store.put(value, key);

                    transaction.oncomplete = function () {
                        // Cast to undefined so the value passed to
                        // callback/promise is the same as what one would get out
                        // of `getItem()` later. This leads to some weirdness
                        // (setItem('foo', undefined) will return `null`), but
                        // it's not my fault localStorage is our baseline and that
                        // it's weird.
                        if (value === undefined) {
                            value = null;
                        }

                        resolve(value);
                    };
                    transaction.onabort = transaction.onerror = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function removeItem(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    // We use a Grunt task to make this safe for IE and some
                    // versions of Android (including those used by Cordova).
                    // Normally IE won't like `.delete()` and will insist on
                    // using `['delete']()`, but we have a build step that
                    // fixes this for us now.
                    var req = store["delete"](key);
                    transaction.oncomplete = function () {
                        resolve();
                    };

                    transaction.onerror = function () {
                        reject(req.error);
                    };

                    // The request will be also be aborted if we've exceeded our storage
                    // space.
                    transaction.onabort = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function clear(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.clear();

                    transaction.oncomplete = function () {
                        resolve();
                    };

                    transaction.onabort = transaction.onerror = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function length(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.count();

                    req.onsuccess = function () {
                        resolve(req.result);
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function key(n, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        if (n < 0) {
            resolve(null);

            return;
        }

        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var advanced = false;
                    var req = store.openCursor();

                    req.onsuccess = function () {
                        var cursor = req.result;
                        if (!cursor) {
                            // this means there weren't enough keys
                            resolve(null);

                            return;
                        }

                        if (n === 0) {
                            // We have the first key, return it if that's what they
                            // wanted.
                            resolve(cursor.key);
                        } else {
                            if (!advanced) {
                                // Otherwise, ask the cursor to skip ahead n
                                // records.
                                advanced = true;
                                cursor.advance(n);
                            } else {
                                // When we get here, we've got the nth key.
                                resolve(cursor.key);
                            }
                        }
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function keys(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.openCursor();
                    var keys = [];

                    req.onsuccess = function () {
                        var cursor = req.result;

                        if (!cursor) {
                            resolve(keys);
                            return;
                        }

                        keys.push(cursor.key);
                        cursor["continue"]();
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function dropInstance(options, callback) {
    callback = getCallback.apply(this, arguments);

    var currentConfig = this.config();
    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        var isCurrentDb = options.name === currentConfig.name && self._dbInfo.db;

        var dbPromise = isCurrentDb ? Promise$1.resolve(self._dbInfo.db) : _getOriginalConnection(options).then(function (db) {
            var dbContext = dbContexts[options.name];
            var forages = dbContext.forages;
            dbContext.db = db;
            for (var i = 0; i < forages.length; i++) {
                forages[i]._dbInfo.db = db;
            }
            return db;
        });

        if (!options.storeName) {
            promise = dbPromise.then(function (db) {
                _deferReadiness(options);

                var dbContext = dbContexts[options.name];
                var forages = dbContext.forages;

                db.close();
                for (var i = 0; i < forages.length; i++) {
                    var forage = forages[i];
                    forage._dbInfo.db = null;
                }

                var dropDBPromise = new Promise$1(function (resolve, reject) {
                    var req = idb.deleteDatabase(options.name);

                    req.onerror = req.onblocked = function (err) {
                        var db = req.result;
                        if (db) {
                            db.close();
                        }
                        reject(err);
                    };

                    req.onsuccess = function () {
                        var db = req.result;
                        if (db) {
                            db.close();
                        }
                        resolve(db);
                    };
                });

                return dropDBPromise.then(function (db) {
                    dbContext.db = db;
                    for (var i = 0; i < forages.length; i++) {
                        var _forage = forages[i];
                        _advanceReadiness(_forage._dbInfo);
                    }
                })["catch"](function (err) {
                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
                    throw err;
                });
            });
        } else {
            promise = dbPromise.then(function (db) {
                if (!db.objectStoreNames.contains(options.storeName)) {
                    return;
                }

                var newVersion = db.version + 1;

                _deferReadiness(options);

                var dbContext = dbContexts[options.name];
                var forages = dbContext.forages;

                db.close();
                for (var i = 0; i < forages.length; i++) {
                    var forage = forages[i];
                    forage._dbInfo.db = null;
                    forage._dbInfo.version = newVersion;
                }

                var dropObjectPromise = new Promise$1(function (resolve, reject) {
                    var req = idb.open(options.name, newVersion);

                    req.onerror = function (err) {
                        var db = req.result;
                        db.close();
                        reject(err);
                    };

                    req.onupgradeneeded = function () {
                        var db = req.result;
                        db.deleteObjectStore(options.storeName);
                    };

                    req.onsuccess = function () {
                        var db = req.result;
                        db.close();
                        resolve(db);
                    };
                });

                return dropObjectPromise.then(function (db) {
                    dbContext.db = db;
                    for (var j = 0; j < forages.length; j++) {
                        var _forage2 = forages[j];
                        _forage2._dbInfo.db = db;
                        _advanceReadiness(_forage2._dbInfo);
                    }
                })["catch"](function (err) {
                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
                    throw err;
                });
            });
        }
    }

    executeCallback(promise, callback);
    return promise;
}

var asyncStorage = {
    _driver: 'asyncStorage',
    _initStorage: _initStorage,
    _support: isIndexedDBValid(),
    iterate: iterate,
    getItem: getItem,
    setItem: setItem,
    removeItem: removeItem,
    clear: clear,
    length: length,
    key: key,
    keys: keys,
    dropInstance: dropInstance
};

function isWebSQLValid() {
    return typeof openDatabase === 'function';
}

// Sadly, the best way to save binary data in WebSQL/localStorage is serializing
// it to Base64, so this is how we store it to prevent very strange errors with less
// verbose ways of binary <-> string data storage.
var BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

var BLOB_TYPE_PREFIX = '~~local_forage_type~';
var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;

var SERIALIZED_MARKER = '__lfsc__:';
var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;

// OMG the serializations!
var TYPE_ARRAYBUFFER = 'arbf';
var TYPE_BLOB = 'blob';
var TYPE_INT8ARRAY = 'si08';
var TYPE_UINT8ARRAY = 'ui08';
var TYPE_UINT8CLAMPEDARRAY = 'uic8';
var TYPE_INT16ARRAY = 'si16';
var TYPE_INT32ARRAY = 'si32';
var TYPE_UINT16ARRAY = 'ur16';
var TYPE_UINT32ARRAY = 'ui32';
var TYPE_FLOAT32ARRAY = 'fl32';
var TYPE_FLOAT64ARRAY = 'fl64';
var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;

var toString$1 = Object.prototype.toString;

function stringToBuffer(serializedString) {
    // Fill the string into a ArrayBuffer.
    var bufferLength = serializedString.length * 0.75;
    var len = serializedString.length;
    var i;
    var p = 0;
    var encoded1, encoded2, encoded3, encoded4;

    if (serializedString[serializedString.length - 1] === '=') {
        bufferLength--;
        if (serializedString[serializedString.length - 2] === '=') {
            bufferLength--;
        }
    }

    var buffer = new ArrayBuffer(bufferLength);
    var bytes = new Uint8Array(buffer);

    for (i = 0; i < len; i += 4) {
        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);

        /*jslint bitwise: true */
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return buffer;
}

// Converts a buffer to a string to store, serialized, in the backend
// storage library.
function bufferToString(buffer) {
    // base64-arraybuffer
    var bytes = new Uint8Array(buffer);
    var base64String = '';
    var i;

    for (i = 0; i < bytes.length; i += 3) {
        /*jslint bitwise: true */
        base64String += BASE_CHARS[bytes[i] >> 2];
        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64String += BASE_CHARS[bytes[i + 2] & 63];
    }

    if (bytes.length % 3 === 2) {
        base64String = base64String.substring(0, base64String.length - 1) + '=';
    } else if (bytes.length % 3 === 1) {
        base64String = base64String.substring(0, base64String.length - 2) + '==';
    }

    return base64String;
}

// Serialize a value, afterwards executing a callback (which usually
// instructs the `setItem()` callback/promise to be executed). This is how
// we store binary data with localStorage.
function serialize(value, callback) {
    var valueType = '';
    if (value) {
        valueType = toString$1.call(value);
    }

    // Cannot use `value instanceof ArrayBuffer` or such here, as these
    // checks fail when running the tests using casper.js...
    //
    // TODO: See why those tests fail and use a better solution.
    if (value && (valueType === '[object ArrayBuffer]' || value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]')) {
        // Convert binary arrays to a string and prefix the string with
        // a special marker.
        var buffer;
        var marker = SERIALIZED_MARKER;

        if (value instanceof ArrayBuffer) {
            buffer = value;
            marker += TYPE_ARRAYBUFFER;
        } else {
            buffer = value.buffer;

            if (valueType === '[object Int8Array]') {
                marker += TYPE_INT8ARRAY;
            } else if (valueType === '[object Uint8Array]') {
                marker += TYPE_UINT8ARRAY;
            } else if (valueType === '[object Uint8ClampedArray]') {
                marker += TYPE_UINT8CLAMPEDARRAY;
            } else if (valueType === '[object Int16Array]') {
                marker += TYPE_INT16ARRAY;
            } else if (valueType === '[object Uint16Array]') {
                marker += TYPE_UINT16ARRAY;
            } else if (valueType === '[object Int32Array]') {
                marker += TYPE_INT32ARRAY;
            } else if (valueType === '[object Uint32Array]') {
                marker += TYPE_UINT32ARRAY;
            } else if (valueType === '[object Float32Array]') {
                marker += TYPE_FLOAT32ARRAY;
            } else if (valueType === '[object Float64Array]') {
                marker += TYPE_FLOAT64ARRAY;
            } else {
                callback(new Error('Failed to get type for BinaryArray'));
            }
        }

        callback(marker + bufferToString(buffer));
    } else if (valueType === '[object Blob]') {
        // Conver the blob to a binaryArray and then to a string.
        var fileReader = new FileReader();

        fileReader.onload = function () {
            // Backwards-compatible prefix for the blob type.
            var str = BLOB_TYPE_PREFIX + value.type + '~' + bufferToString(this.result);

            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
        };

        fileReader.readAsArrayBuffer(value);
    } else {
        try {
            callback(JSON.stringify(value));
        } catch (e) {
            console.error("Couldn't convert value into a JSON string: ", value);

            callback(null, e);
        }
    }
}

// Deserialize data we've inserted into a value column/field. We place
// special markers into our strings to mark them as encoded; this isn't
// as nice as a meta field, but it's the only sane thing we can do whilst
// keeping localStorage support intact.
//
// Oftentimes this will just deserialize JSON content, but if we have a
// special marker (SERIALIZED_MARKER, defined above), we will extract
// some kind of arraybuffer/binary data/typed array out of the string.
function deserialize(value) {
    // If we haven't marked this string as being specially serialized (i.e.
    // something other than serialized JSON), we can just return it and be
    // done with it.
    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) {
        return JSON.parse(value);
    }

    // The following code deals with deserializing some kind of Blob or
    // TypedArray. First we separate out the type of data we're dealing
    // with from the data itself.
    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);

    var blobType;
    // Backwards-compatible blob type serialization strategy.
    // DBs created with older versions of localForage will simply not have the blob type.
    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
        blobType = matcher[1];
        serializedString = serializedString.substring(matcher[0].length);
    }
    var buffer = stringToBuffer(serializedString);

    // Return the right type based on the code/type set during
    // serialization.
    switch (type) {
        case TYPE_ARRAYBUFFER:
            return buffer;
        case TYPE_BLOB:
            return createBlob([buffer], { type: blobType });
        case TYPE_INT8ARRAY:
            return new Int8Array(buffer);
        case TYPE_UINT8ARRAY:
            return new Uint8Array(buffer);
        case TYPE_UINT8CLAMPEDARRAY:
            return new Uint8ClampedArray(buffer);
        case TYPE_INT16ARRAY:
            return new Int16Array(buffer);
        case TYPE_UINT16ARRAY:
            return new Uint16Array(buffer);
        case TYPE_INT32ARRAY:
            return new Int32Array(buffer);
        case TYPE_UINT32ARRAY:
            return new Uint32Array(buffer);
        case TYPE_FLOAT32ARRAY:
            return new Float32Array(buffer);
        case TYPE_FLOAT64ARRAY:
            return new Float64Array(buffer);
        default:
            throw new Error('Unkown type: ' + type);
    }
}

var localforageSerializer = {
    serialize: serialize,
    deserialize: deserialize,
    stringToBuffer: stringToBuffer,
    bufferToString: bufferToString
};

/*
 * Includes code from:
 *
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */

function createDbTable(t, dbInfo, callback, errorCallback) {
    t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' ' + '(id INTEGER PRIMARY KEY, key unique, value)', [], callback, errorCallback);
}

// Open the WebSQL database (automatically creates one if one didn't
// previously exist), using any options set in the config.
function _initStorage$1(options) {
    var self = this;
    var dbInfo = {
        db: null
    };

    if (options) {
        for (var i in options) {
            dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
        }
    }

    var dbInfoPromise = new Promise$1(function (resolve, reject) {
        // Open the database; the openDatabase API will automatically
        // create it for us if it doesn't exist.
        try {
            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
        } catch (e) {
            return reject(e);
        }

        // Create our key/value table if it doesn't exist.
        dbInfo.db.transaction(function (t) {
            createDbTable(t, dbInfo, function () {
                self._dbInfo = dbInfo;
                resolve();
            }, function (t, error) {
                reject(error);
            });
        }, reject);
    });

    dbInfo.serializer = localforageSerializer;
    return dbInfoPromise;
}

function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
    t.executeSql(sqlStatement, args, callback, function (t, error) {
        if (error.code === error.SYNTAX_ERR) {
            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name = ?", [dbInfo.storeName], function (t, results) {
                if (!results.rows.length) {
                    // if the table is missing (was deleted)
                    // re-create it table and retry
                    createDbTable(t, dbInfo, function () {
                        t.executeSql(sqlStatement, args, callback, errorCallback);
                    }, errorCallback);
                } else {
                    errorCallback(t, error);
                }
            }, errorCallback);
        } else {
            errorCallback(t, error);
        }
    }, errorCallback);
}

function getItem$1(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName + ' WHERE key = ? LIMIT 1', [key], function (t, results) {
                    var result = results.rows.length ? results.rows.item(0).value : null;

                    // Check to see if this is serialized content we need to
                    // unpack.
                    if (result) {
                        result = dbInfo.serializer.deserialize(result);
                    }

                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function iterate$1(iterator, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;

            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName, [], function (t, results) {
                    var rows = results.rows;
                    var length = rows.length;

                    for (var i = 0; i < length; i++) {
                        var item = rows.item(i);
                        var result = item.value;

                        // Check to see if this is serialized content
                        // we need to unpack.
                        if (result) {
                            result = dbInfo.serializer.deserialize(result);
                        }

                        result = iterator(result, item.key, i + 1);

                        // void(0) prevents problems with redefinition
                        // of `undefined`.
                        if (result !== void 0) {
                            resolve(result);
                            return;
                        }
                    }

                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function _setItem(key, value, callback, retriesLeft) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            // The localStorage API doesn't return undefined values in an
            // "expected" way, so undefined is always cast to null in all
            // drivers. See: https://github.com/mozilla/localForage/pull/42
            if (value === undefined) {
                value = null;
            }

            // Save the original value to pass to the callback.
            var originalValue = value;

            var dbInfo = self._dbInfo;
            dbInfo.serializer.serialize(value, function (value, error) {
                if (error) {
                    reject(error);
                } else {
                    dbInfo.db.transaction(function (t) {
                        tryExecuteSql(t, dbInfo, 'INSERT OR REPLACE INTO ' + dbInfo.storeName + ' ' + '(key, value) VALUES (?, ?)', [key, value], function () {
                            resolve(originalValue);
                        }, function (t, error) {
                            reject(error);
                        });
                    }, function (sqlError) {
                        // The transaction failed; check
                        // to see if it's a quota error.
                        if (sqlError.code === sqlError.QUOTA_ERR) {
                            // We reject the callback outright for now, but
                            // it's worth trying to re-run the transaction.
                            // Even if the user accepts the prompt to use
                            // more storage on Safari, this error will
                            // be called.
                            //
                            // Try to re-run the transaction.
                            if (retriesLeft > 0) {
                                resolve(_setItem.apply(self, [key, originalValue, callback, retriesLeft - 1]));
                                return;
                            }
                            reject(sqlError);
                        }
                    });
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function setItem$1(key, value, callback) {
    return _setItem.apply(this, [key, value, callback, 1]);
}

function removeItem$1(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName + ' WHERE key = ?', [key], function () {
                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Deletes every item in the table.
// TODO: Find out if this resets the AUTO_INCREMENT number.
function clear$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName, [], function () {
                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Does a simple `COUNT(key)` to get the number of items stored in
// localForage.
function length$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                // Ahhh, SQL makes this one soooooo easy.
                tryExecuteSql(t, dbInfo, 'SELECT COUNT(key) as c FROM ' + dbInfo.storeName, [], function (t, results) {
                    var result = results.rows.item(0).c;
                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Return the key located at key index X; essentially gets the key from a
// `WHERE id = ?`. This is the most efficient way I can think to implement
// this rarely-used (in my experience) part of the API, but it can seem
// inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
// the ID of each key will change every time it's updated. Perhaps a stored
// procedure for the `setItem()` SQL would solve this problem?
// TODO: Don't change ID on `setItem()`.
function key$1(n, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName + ' WHERE id = ? LIMIT 1', [n + 1], function (t, results) {
                    var result = results.rows.length ? results.rows.item(0).key : null;
                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function keys$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName, [], function (t, results) {
                    var keys = [];

                    for (var i = 0; i < results.rows.length; i++) {
                        keys.push(results.rows.item(i).key);
                    }

                    resolve(keys);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// https://www.w3.org/TR/webdatabase/#databases
// > There is no way to enumerate or delete the databases available for an origin from this API.
function getAllStoreNames(db) {
    return new Promise$1(function (resolve, reject) {
        db.transaction(function (t) {
            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function (t, results) {
                var storeNames = [];

                for (var i = 0; i < results.rows.length; i++) {
                    storeNames.push(results.rows.item(i).name);
                }

                resolve({
                    db: db,
                    storeNames: storeNames
                });
            }, function (t, error) {
                reject(error);
            });
        }, function (sqlError) {
            reject(sqlError);
        });
    });
}

function dropInstance$1(options, callback) {
    callback = getCallback.apply(this, arguments);

    var currentConfig = this.config();
    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        promise = new Promise$1(function (resolve) {
            var db;
            if (options.name === currentConfig.name) {
                // use the db reference of the current instance
                db = self._dbInfo.db;
            } else {
                db = openDatabase(options.name, '', '', 0);
            }

            if (!options.storeName) {
                // drop all database tables
                resolve(getAllStoreNames(db));
            } else {
                resolve({
                    db: db,
                    storeNames: [options.storeName]
                });
            }
        }).then(function (operationInfo) {
            return new Promise$1(function (resolve, reject) {
                operationInfo.db.transaction(function (t) {
                    function dropTable(storeName) {
                        return new Promise$1(function (resolve, reject) {
                            t.executeSql('DROP TABLE IF EXISTS ' + storeName, [], function () {
                                resolve();
                            }, function (t, error) {
                                reject(error);
                            });
                        });
                    }

                    var operations = [];
                    for (var i = 0, len = operationInfo.storeNames.length; i < len; i++) {
                        operations.push(dropTable(operationInfo.storeNames[i]));
                    }

                    Promise$1.all(operations).then(function () {
                        resolve();
                    })["catch"](function (e) {
                        reject(e);
                    });
                }, function (sqlError) {
                    reject(sqlError);
                });
            });
        });
    }

    executeCallback(promise, callback);
    return promise;
}

var webSQLStorage = {
    _driver: 'webSQLStorage',
    _initStorage: _initStorage$1,
    _support: isWebSQLValid(),
    iterate: iterate$1,
    getItem: getItem$1,
    setItem: setItem$1,
    removeItem: removeItem$1,
    clear: clear$1,
    length: length$1,
    key: key$1,
    keys: keys$1,
    dropInstance: dropInstance$1
};

function isLocalStorageValid() {
    try {
        return typeof localStorage !== 'undefined' && 'setItem' in localStorage &&
        // in IE8 typeof localStorage.setItem === 'object'
        !!localStorage.setItem;
    } catch (e) {
        return false;
    }
}

function _getKeyPrefix(options, defaultConfig) {
    var keyPrefix = options.name + '/';

    if (options.storeName !== defaultConfig.storeName) {
        keyPrefix += options.storeName + '/';
    }
    return keyPrefix;
}

// Check if localStorage throws when saving an item
function checkIfLocalStorageThrows() {
    var localStorageTestKey = '_localforage_support_test';

    try {
        localStorage.setItem(localStorageTestKey, true);
        localStorage.removeItem(localStorageTestKey);

        return false;
    } catch (e) {
        return true;
    }
}

// Check if localStorage is usable and allows to save an item
// This method checks if localStorage is usable in Safari Private Browsing
// mode, or in any other case where the available quota for localStorage
// is 0 and there wasn't any saved items yet.
function _isLocalStorageUsable() {
    return !checkIfLocalStorageThrows() || localStorage.length > 0;
}

// Config the localStorage backend, using options set in the config.
function _initStorage$2(options) {
    var self = this;
    var dbInfo = {};
    if (options) {
        for (var i in options) {
            dbInfo[i] = options[i];
        }
    }

    dbInfo.keyPrefix = _getKeyPrefix(options, self._defaultConfig);

    if (!_isLocalStorageUsable()) {
        return Promise$1.reject();
    }

    self._dbInfo = dbInfo;
    dbInfo.serializer = localforageSerializer;

    return Promise$1.resolve();
}

// Remove all keys from the datastore, effectively destroying all data in
// the app's key/value store!
function clear$2(callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var keyPrefix = self._dbInfo.keyPrefix;

        for (var i = localStorage.length - 1; i >= 0; i--) {
            var key = localStorage.key(i);

            if (key.indexOf(keyPrefix) === 0) {
                localStorage.removeItem(key);
            }
        }
    });

    executeCallback(promise, callback);
    return promise;
}

// Retrieve an item from the store. Unlike the original async_storage
// library in Gaia, we don't modify return values at all. If a key's value
// is `undefined`, we pass that value to the callback function.
function getItem$2(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var result = localStorage.getItem(dbInfo.keyPrefix + key);

        // If a result was found, parse it from the serialized
        // string into a JS object. If result isn't truthy, the key
        // is likely undefined and we'll pass it straight to the
        // callback.
        if (result) {
            result = dbInfo.serializer.deserialize(result);
        }

        return result;
    });

    executeCallback(promise, callback);
    return promise;
}

// Iterate over all items in the store.
function iterate$2(iterator, callback) {
    var self = this;

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var keyPrefix = dbInfo.keyPrefix;
        var keyPrefixLength = keyPrefix.length;
        var length = localStorage.length;

        // We use a dedicated iterator instead of the `i` variable below
        // so other keys we fetch in localStorage aren't counted in
        // the `iterationNumber` argument passed to the `iterate()`
        // callback.
        //
        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
        var iterationNumber = 1;

        for (var i = 0; i < length; i++) {
            var key = localStorage.key(i);
            if (key.indexOf(keyPrefix) !== 0) {
                continue;
            }
            var value = localStorage.getItem(key);

            // If a result was found, parse it from the serialized
            // string into a JS object. If result isn't truthy, the
            // key is likely undefined and we'll pass it straight
            // to the iterator.
            if (value) {
                value = dbInfo.serializer.deserialize(value);
            }

            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);

            if (value !== void 0) {
                return value;
            }
        }
    });

    executeCallback(promise, callback);
    return promise;
}

// Same as localStorage's key() method, except takes a callback.
function key$2(n, callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var result;
        try {
            result = localStorage.key(n);
        } catch (error) {
            result = null;
        }

        // Remove the prefix from the key, if a key is found.
        if (result) {
            result = result.substring(dbInfo.keyPrefix.length);
        }

        return result;
    });

    executeCallback(promise, callback);
    return promise;
}

function keys$2(callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var length = localStorage.length;
        var keys = [];

        for (var i = 0; i < length; i++) {
            var itemKey = localStorage.key(i);
            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) {
                keys.push(itemKey.substring(dbInfo.keyPrefix.length));
            }
        }

        return keys;
    });

    executeCallback(promise, callback);
    return promise;
}

// Supply the number of keys in the datastore to the callback function.
function length$2(callback) {
    var self = this;
    var promise = self.keys().then(function (keys) {
        return keys.length;
    });

    executeCallback(promise, callback);
    return promise;
}

// Remove an item from the store, nice and simple.
function removeItem$2(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        localStorage.removeItem(dbInfo.keyPrefix + key);
    });

    executeCallback(promise, callback);
    return promise;
}

// Set a key's value and run an optional callback once the value is set.
// Unlike Gaia's implementation, the callback function is passed the value,
// in case you want to operate on that value only after you're sure it
// saved, or something like that.
function setItem$2(key, value, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        // Convert undefined values to null.
        // https://github.com/mozilla/localForage/pull/42
        if (value === undefined) {
            value = null;
        }

        // Save the original value to pass to the callback.
        var originalValue = value;

        return new Promise$1(function (resolve, reject) {
            var dbInfo = self._dbInfo;
            dbInfo.serializer.serialize(value, function (value, error) {
                if (error) {
                    reject(error);
                } else {
                    try {
                        localStorage.setItem(dbInfo.keyPrefix + key, value);
                        resolve(originalValue);
                    } catch (e) {
                        // localStorage capacity exceeded.
                        // TODO: Make this a specific error/event.
                        if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                            reject(e);
                        }
                        reject(e);
                    }
                }
            });
        });
    });

    executeCallback(promise, callback);
    return promise;
}

function dropInstance$2(options, callback) {
    callback = getCallback.apply(this, arguments);

    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        var currentConfig = this.config();
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        promise = new Promise$1(function (resolve) {
            if (!options.storeName) {
                resolve(options.name + '/');
            } else {
                resolve(_getKeyPrefix(options, self._defaultConfig));
            }
        }).then(function (keyPrefix) {
            for (var i = localStorage.length - 1; i >= 0; i--) {
                var key = localStorage.key(i);

                if (key.indexOf(keyPrefix) === 0) {
                    localStorage.removeItem(key);
                }
            }
        });
    }

    executeCallback(promise, callback);
    return promise;
}

var localStorageWrapper = {
    _driver: 'localStorageWrapper',
    _initStorage: _initStorage$2,
    _support: isLocalStorageValid(),
    iterate: iterate$2,
    getItem: getItem$2,
    setItem: setItem$2,
    removeItem: removeItem$2,
    clear: clear$2,
    length: length$2,
    key: key$2,
    keys: keys$2,
    dropInstance: dropInstance$2
};

var sameValue = function sameValue(x, y) {
    return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
};

var includes = function includes(array, searchElement) {
    var len = array.length;
    var i = 0;
    while (i < len) {
        if (sameValue(array[i], searchElement)) {
            return true;
        }
        i++;
    }

    return false;
};

var isArray = Array.isArray || function (arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
};

// Drivers are stored here when `defineDriver()` is called.
// They are shared across all instances of localForage.
var DefinedDrivers = {};

var DriverSupport = {};

var DefaultDrivers = {
    INDEXEDDB: asyncStorage,
    WEBSQL: webSQLStorage,
    LOCALSTORAGE: localStorageWrapper
};

var DefaultDriverOrder = [DefaultDrivers.INDEXEDDB._driver, DefaultDrivers.WEBSQL._driver, DefaultDrivers.LOCALSTORAGE._driver];

var OptionalDriverMethods = ['dropInstance'];

var LibraryMethods = ['clear', 'getItem', 'iterate', 'key', 'keys', 'length', 'removeItem', 'setItem'].concat(OptionalDriverMethods);

var DefaultConfig = {
    description: '',
    driver: DefaultDriverOrder.slice(),
    name: 'localforage',
    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
    // we can use without a prompt.
    size: 4980736,
    storeName: 'keyvaluepairs',
    version: 1.0
};

function callWhenReady(localForageInstance, libraryMethod) {
    localForageInstance[libraryMethod] = function () {
        var _args = arguments;
        return localForageInstance.ready().then(function () {
            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
        });
    };
}

function extend() {
    for (var i = 1; i < arguments.length; i++) {
        var arg = arguments[i];

        if (arg) {
            for (var _key in arg) {
                if (arg.hasOwnProperty(_key)) {
                    if (isArray(arg[_key])) {
                        arguments[0][_key] = arg[_key].slice();
                    } else {
                        arguments[0][_key] = arg[_key];
                    }
                }
            }
        }
    }

    return arguments[0];
}

var LocalForage = function () {
    function LocalForage(options) {
        _classCallCheck(this, LocalForage);

        for (var driverTypeKey in DefaultDrivers) {
            if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                var driver = DefaultDrivers[driverTypeKey];
                var driverName = driver._driver;
                this[driverTypeKey] = driverName;

                if (!DefinedDrivers[driverName]) {
                    // we don't need to wait for the promise,
                    // since the default drivers can be defined
                    // in a blocking manner
                    this.defineDriver(driver);
                }
            }
        }

        this._defaultConfig = extend({}, DefaultConfig);
        this._config = extend({}, this._defaultConfig, options);
        this._driverSet = null;
        this._initDriver = null;
        this._ready = false;
        this._dbInfo = null;

        this._wrapLibraryMethodsWithReady();
        this.setDriver(this._config.driver)["catch"](function () {});
    }

    // Set any config values for localForage; can be called anytime before
    // the first API call (e.g. `getItem`, `setItem`).
    // We loop through options so we don't overwrite existing config
    // values.


    LocalForage.prototype.config = function config(options) {
        // If the options argument is an object, we use it to set values.
        // Otherwise, we return either a specified config value or all
        // config values.
        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
            // If localforage is ready and fully initialized, we can't set
            // any new configuration values. Instead, we return an error.
            if (this._ready) {
                return new Error("Can't call config() after localforage " + 'has been used.');
            }

            for (var i in options) {
                if (i === 'storeName') {
                    options[i] = options[i].replace(/\W/g, '_');
                }

                if (i === 'version' && typeof options[i] !== 'number') {
                    return new Error('Database version must be a number.');
                }

                this._config[i] = options[i];
            }

            // after all config options are set and
            // the driver option is used, try setting it
            if ('driver' in options && options.driver) {
                return this.setDriver(this._config.driver);
            }

            return true;
        } else if (typeof options === 'string') {
            return this._config[options];
        } else {
            return this._config;
        }
    };

    // Used to define a custom driver, shared across all instances of
    // localForage.


    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
        var promise = new Promise$1(function (resolve, reject) {
            try {
                var driverName = driverObject._driver;
                var complianceError = new Error('Custom driver not compliant; see ' + 'https://mozilla.github.io/localForage/#definedriver');

                // A driver name should be defined and not overlap with the
                // library-defined, default drivers.
                if (!driverObject._driver) {
                    reject(complianceError);
                    return;
                }

                var driverMethods = LibraryMethods.concat('_initStorage');
                for (var i = 0, len = driverMethods.length; i < len; i++) {
                    var driverMethodName = driverMethods[i];

                    // when the property is there,
                    // it should be a method even when optional
                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== 'function') {
                        reject(complianceError);
                        return;
                    }
                }

                var configureMissingMethods = function configureMissingMethods() {
                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
                        return function () {
                            var error = new Error('Method ' + methodName + ' is not implemented by the current driver');
                            var promise = Promise$1.reject(error);
                            executeCallback(promise, arguments[arguments.length - 1]);
                            return promise;
                        };
                    };

                    for (var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++) {
                        var optionalDriverMethod = OptionalDriverMethods[_i];
                        if (!driverObject[optionalDriverMethod]) {
                            driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                        }
                    }
                };

                configureMissingMethods();

                var setDriverSupport = function setDriverSupport(support) {
                    if (DefinedDrivers[driverName]) {
                        console.info('Redefining LocalForage driver: ' + driverName);
                    }
                    DefinedDrivers[driverName] = driverObject;
                    DriverSupport[driverName] = support;
                    // don't use a then, so that we can define
                    // drivers that have simple _support methods
                    // in a blocking manner
                    resolve();
                };

                if ('_support' in driverObject) {
                    if (driverObject._support && typeof driverObject._support === 'function') {
                        driverObject._support().then(setDriverSupport, reject);
                    } else {
                        setDriverSupport(!!driverObject._support);
                    }
                } else {
                    setDriverSupport(true);
                }
            } catch (e) {
                reject(e);
            }
        });

        executeTwoCallbacks(promise, callback, errorCallback);
        return promise;
    };

    LocalForage.prototype.driver = function driver() {
        return this._driver || null;
    };

    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error('Driver not found.'));

        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
        return getDriverPromise;
    };

    LocalForage.prototype.getSerializer = function getSerializer(callback) {
        var serializerPromise = Promise$1.resolve(localforageSerializer);
        executeTwoCallbacks(serializerPromise, callback);
        return serializerPromise;
    };

    LocalForage.prototype.ready = function ready(callback) {
        var self = this;

        var promise = self._driverSet.then(function () {
            if (self._ready === null) {
                self._ready = self._initDriver();
            }

            return self._ready;
        });

        executeTwoCallbacks(promise, callback, callback);
        return promise;
    };

    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
        var self = this;

        if (!isArray(drivers)) {
            drivers = [drivers];
        }

        var supportedDrivers = this._getSupportedDrivers(drivers);

        function setDriverToConfig() {
            self._config.driver = self.driver();
        }

        function extendSelfWithDriver(driver) {
            self._extend(driver);
            setDriverToConfig();

            self._ready = self._initStorage(self._config);
            return self._ready;
        }

        function initDriver(supportedDrivers) {
            return function () {
                var currentDriverIndex = 0;

                function driverPromiseLoop() {
                    while (currentDriverIndex < supportedDrivers.length) {
                        var driverName = supportedDrivers[currentDriverIndex];
                        currentDriverIndex++;

                        self._dbInfo = null;
                        self._ready = null;

                        return self.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                    }

                    setDriverToConfig();
                    var error = new Error('No available storage method found.');
                    self._driverSet = Promise$1.reject(error);
                    return self._driverSet;
                }

                return driverPromiseLoop();
            };
        }

        // There might be a driver initialization in progress
        // so wait for it to finish in order to avoid a possible
        // race condition to set _dbInfo
        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function () {
            return Promise$1.resolve();
        }) : Promise$1.resolve();

        this._driverSet = oldDriverSetDone.then(function () {
            var driverName = supportedDrivers[0];
            self._dbInfo = null;
            self._ready = null;

            return self.getDriver(driverName).then(function (driver) {
                self._driver = driver._driver;
                setDriverToConfig();
                self._wrapLibraryMethodsWithReady();
                self._initDriver = initDriver(supportedDrivers);
            });
        })["catch"](function () {
            setDriverToConfig();
            var error = new Error('No available storage method found.');
            self._driverSet = Promise$1.reject(error);
            return self._driverSet;
        });

        executeTwoCallbacks(this._driverSet, callback, errorCallback);
        return this._driverSet;
    };

    LocalForage.prototype.supports = function supports(driverName) {
        return !!DriverSupport[driverName];
    };

    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
        extend(this, libraryMethodsAndProperties);
    };

    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
        var supportedDrivers = [];
        for (var i = 0, len = drivers.length; i < len; i++) {
            var driverName = drivers[i];
            if (this.supports(driverName)) {
                supportedDrivers.push(driverName);
            }
        }
        return supportedDrivers;
    };

    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
        // Add a stub for each driver API method that delays the call to the
        // corresponding driver method until localForage is ready. These stubs
        // will be replaced by the driver methods as soon as the driver is
        // loaded, so there is no performance impact.
        for (var i = 0, len = LibraryMethods.length; i < len; i++) {
            callWhenReady(this, LibraryMethods[i]);
        }
    };

    LocalForage.prototype.createInstance = function createInstance(options) {
        return new LocalForage(options);
    };

    return LocalForage;
}();

// The actual localForage object that we expose as a module or via a
// global. It's extended by pulling in one of our other libraries.


var localforage_js = new LocalForage();

module.exports = localforage_js;

},{"3":3}]},{},[4])(4)
});


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(4);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadPersistentStore = loadPersistentStore;
exports.createPersistentStoreMiddleware = createPersistentStoreMiddleware;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(7));

var _typeof2 = _interopRequireDefault(__webpack_require__(98));

var storage = _interopRequireWildcard(__webpack_require__(204));

var _reduxStorageEngineLocalstorage = _interopRequireDefault(__webpack_require__(688));

var _reduxStorageDecoratorFilter = _interopRequireDefault(__webpack_require__(689));

var c = _interopRequireWildcard(__webpack_require__(3));

var _persistence = __webpack_require__(199);

var _persistence2 = __webpack_require__(694);

var nucleusWhitelist = [c.ACQUIRE_LOCAL_PRIMARY_STREAM_SUCCESS, c.CALL_HISTORY_VIEWED, c.SET_CUSTOM_CALL_BANDWIDTH, c.GET_CURRENT_USER_SETTINGS_FAILURE, c.GET_CURRENT_USER_SETTINGS_SUCCESS, c.PAIRING_SUCCESSFUL, c.SET_DEFAULT_AUDIO, c.SET_DEFAULT_VIDEO, c.SET_PRIMARY_AUDIO_OUTPUT_ID, c.SET_PRIMARY_AUDIO_SOURCE_ID, c.SET_PRIMARY_VIDEO_SOURCE_ID, c.SET_VIDEO_SOURCE_QUALITY, c.TOKEN_REQUEST_SUCCESS, c.NEW_TOKEN_OBTAINED, c.WAMP_CONNECT_ERROR, c.WAMP_CONNECTION_DISPOSED_HEALTHY, c.WAMP_CONNECTION_DISPOSED_JWT_ERROR, c.WAMP_CONNECTION_DISPOSED_UNEXPECTED, c.LOGOUT_FINISHED, c.UPDATE_CURRENT_USER_SETTINGS_FAILURE, c.UPDATE_CURRENT_USER_SETTINGS_SUCCESS, c.SET_LOCALE, _persistence.PERSISTENCE_DISABLED, _persistence.PERSISTENCE_ENABLED];
var nucleusBlacklist = [];
var nucleusWhitelistFilter = [['nucleus', 'callHistory', 'lastViewed'], ['nucleus', 'cluster'], ['nucleus', 'device'], ['nucleus', 'galaxy', 'options', 'maxBandwidth'], ['nucleus', 'token', 'A'], ['nucleus', 'media', 'primaryVideoSourceId'], ['nucleus', 'media', 'primaryAudioSourceId'], ['nucleus', 'media', 'primaryAudioOutputId'], ['nucleus', 'media', 'video'], ['nucleus', 'media', 'audio'], ['nucleus', 'media', 'selectedVideoConstraints'], ['nucleus', 'media', 'videoConstraints'], ['nucleus', 'userSettings'], ['nucleus', 'localization']];
var nucleusBlacklistFilter = [['nucleus', 'cluster', 'ipAddressOverride'], ['nucleus', 'token', 'oneTimeJwt']];
/**
 * loadPersistentStore
 * This is a pass through function that is sourced from the persistent store engine.
 *
 * @param  {Object} engine - REQUIRED. Object that must be passed in by the client to store data.
 *
 * @example
 * // Point nucleus to beta cluster upon start up. Load the previous state.
 * import { createReduxStore } from 'lifesize-sky-nucleus';
 * import createLogger from 'redux-logger';
 * const logger = createLogger();
 * const engine = createEngine('my-save-key');
 * const persistentStorage = { engine: engine, blacklist: [], whitelist: [] };
 * let reduxStore = createReduxStore(null, [], { nucleus: { cluster: { url: 'lifesizecloudbeta.com ' } } }, persistentStore);
 * const load = loadPersistentStore(engine);
 * load(reduxStore).then((newState) => console.log('Loaded state:', newState))
    .catch(() => console.log('Failed to load previous state'));
 * @return {Function} an ES2015 style Promise function that takes the redux store as an input and returns a merged current state + loaded state store.
 */

function loadPersistentStore() {
  var engine = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  /* istanbul ignore else  */
  if (!engine) {
    throw new Error('loadPersistentStore requires an engine argument');
  }
  /* istanbul ignore next  */


  if ((0, _typeof2.default)(engine) !== 'object') {
    throw new Error('loadPersistentStore requires engine argument to be an object');
  }

  return storage.createLoader(engine);
}
/**
 * Create Persistent Redux Storage Middleware
 * This utility function cleans up the required redux-storage requirements for createReduxStore. Uses redux-storage. For more details on how to use, see the readme here: https://github.com/michaelcontento/redux-storage
 *
 * @param  {Object} engine - REQUIRED. Object that must be passed in by the client to store data.
 * @param  {Array} blacklist - List of actions to NOT persist.
 * @param  {Array} whitelist - List of actions to persist.
 * @param  {Array} whitelistFilter - List of filter keys to persist.
 * @param  {Array} blacklistFilter - List of filter keys to NOT persist.
 * @return {Object} an object containing middleware object.
 */


function createPersistentStoreMiddleware() {
  var engine = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var blacklist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var whitelist = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var whitelistFilter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var blacklistFilter = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

  /* istanbul ignore else  */
  if (!engine) {
    engine = (0, _reduxStorageEngineLocalstorage.default)('lifesize.sky.nucleus');
  }
  /* istanbul ignore next  */


  if (engine && (0, _typeof2.default)(engine) !== 'object') {
    throw new Error('createPersistentStoreMiddleware engine must be an object');
  }
  /* istanbul ignore else  */


  if (blacklist && !Array.isArray(blacklist)) {
    throw new Error('createPersistentStoreMiddleware requires blacklist argument to be an array');
  }
  /* istanbul ignore else  */


  if (whitelist && !Array.isArray(whitelist)) {
    throw new Error('createPersistentStoreMiddleware requires whitelist argument to be an array');
  }
  /* istanbul ignore else  */


  if (whitelistFilter && !Array.isArray(whitelistFilter)) {
    throw new Error('createPersistentStoreMiddleware requires whitelistFilter argument to be an array');
  }
  /* istanbul ignore else  */


  if (blacklistFilter && !Array.isArray(blacklistFilter)) {
    throw new Error('createPersistentStoreMiddleware requires blacklistFilter argument to be an array');
  }

  whitelist = whitelist.concat(nucleusWhitelist);
  blacklist = blacklist.concat(nucleusBlacklist);
  whitelistFilter = whitelistFilter.concat(nucleusWhitelistFilter);
  blacklistFilter = blacklistFilter.concat(nucleusBlacklistFilter);
  engine = (0, _reduxStorageDecoratorFilter.default)(engine, whitelistFilter, blacklistFilter);
  engine = persistenceEnabledFilter(engine);
  var middleware = storage.createMiddleware(engine, blacklist, whitelist);
  return {
    persistenceMiddleware: middleware,
    persistenceEngine: engine
  };
}

function persistenceEnabledFilter(engine) {
  return (0, _objectSpread2.default)({}, engine, {
    save: function save(state) {
      if ((0, _persistence2.selectPersistenceEnabled)(state)) {
        return engine.save(state);
      }

      return engine.save({
        nucleus: undefined
      });
    }
  });
}

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function rejectWithMessage(error) {
    return Promise.reject(error.message);
}

exports["default"] = function (key, replacer, reviver) {
    return {
        load: function load() {
            return new Promise(function (resolve) {
                var jsonState = localStorage.getItem(key);
                resolve(JSON.parse(jsonState, reviver) || {});
            })["catch"](rejectWithMessage);
        },
        save: function save(state) {
            return new Promise(function (resolve) {
                var jsonState = JSON.stringify(state, replacer);
                localStorage.setItem(key, jsonState);
                resolve();
            })["catch"](rejectWithMessage);
        }
    };
};

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(690);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(691);

var _lodash4 = _interopRequireDefault(_lodash3);

var _lodash5 = __webpack_require__(289);

var _lodash6 = _interopRequireDefault(_lodash5);

var _lodash7 = __webpack_require__(205);

var _lodash8 = _interopRequireDefault(_lodash7);

var _lodash9 = __webpack_require__(692);

var _lodash10 = _interopRequireDefault(_lodash9);

var _lodash11 = __webpack_require__(693);

var _lodash12 = _interopRequireDefault(_lodash11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = function (engine) {
    var whitelist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var blacklist = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    whitelist = whitelist || []; // eslint-disable-line no-param-reassign

    return _extends({}, engine, {
        save: function save(state) {
            var saveState = {};

            // Copy the whole state if we're about to blacklist only
            if (whitelist.length === 0 && blacklist !== null) {
                saveState = _extends({}, state);
            }

            blacklist = blacklist || []; // eslint-disable-line no-param-reassign

            whitelist.forEach(function (key) {
                // Support strings for one-level paths
                if (typeof key === 'string') {
                    key = [key]; // eslint-disable-line no-param-reassign
                }

                var value = (0, _lodash4['default'])(key, function (result, keyPart) {
                    if (result) {
                        // Support immutable structures
                        if ((0, _lodash6['default'])(result.has) && (0, _lodash6['default'])(result.get)) {
                            return result.get(keyPart);
                        }

                        if (result.hasOwnProperty(keyPart)) {
                            return result[keyPart];
                        }
                    }
                }, state);

                if (value !== undefined) {
                    // done to support null values
                    (0, _lodash10['default'])(saveState, key, value);
                }
            });

            blacklist.forEach(function (key) {
                // Support strings for one-level paths
                if (typeof key === 'string') {
                    key = [key]; // eslint-disable-line no-param-reassign
                }

                // Support immutable structures
                var value = state[key[0]];
                var blacklistedState = saveState[key[0]] || value;

                if (blacklistedState && (0, _lodash6['default'])(blacklistedState.deleteIn)) {
                    // Handle multiple blacklist path with same key
                    saveState[key[0]] = blacklistedState.deleteIn(key.slice(1));
                    return;
                }

                // If we're a nested path ...
                if (key.length > 1) {
                    // ... and inside a object ...
                    var myKey = key.slice(0, -1);
                    var subValue = (0, _lodash2['default'])(saveState, myKey);
                    if ((0, _lodash8['default'])(subValue)) {
                        // ... clone it, as we don't want to change the state!
                        (0, _lodash10['default'])(saveState, myKey, _extends({}, subValue));
                    }
                }
                (0, _lodash12['default'])(saveState, key);
            });

            return engine.save(saveState);
        }
    });
};

/***/ }),
/* 690 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, bitmask, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = getTag(object);
    objTag = objTag == argsTag ? objectTag : objTag;
  }
  if (!othIsArr) {
    othTag = getTag(other);
    othTag = othTag == argsTag ? objectTag : othTag;
  }
  var objIsObj = objTag == objectTag && !isHostObject(object),
      othIsObj = othTag == objectTag && !isHostObject(other),
      isSameTag = objTag == othTag;

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
  }
  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!seen.has(othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
              return seen.add(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, customizer, bitmask, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= UNORDERED_COMPARE_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = isKey(path, object) ? [path] : castPath(path);

  var result,
      index = -1,
      length = path.length;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result) {
    return result;
  }
  var length = object ? object.length : 0;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = reduce;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(103)(module)))

/***/ }),
/* 692 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = isKey(path, object) ? [path] : castPath(path);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),
/* 693 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);
  object = parent(object, path);

  var key = toKey(last(path));
  return !(object != null && hasOwnProperty.call(object, key)) || delete object[key];
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array ? array.length : 0;
  return length ? array[length - 1] : undefined;
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Removes the property at `path` of `object`.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 7 } }] };
 * _.unset(object, 'a[0].b.c');
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 *
 * _.unset(object, ['a', '0', 'b', 'c']);
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 */
function unset(object, path) {
  return object == null ? true : baseUnset(object, path);
}

module.exports = unset;


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectPersistenceEnabled = void 0;

var _get = _interopRequireDefault(__webpack_require__(11));

var selectPersistenceEnabled = function selectPersistenceEnabled(state) {
  return (0, _get.default)(state, 'nucleus.persistence.enabled', false);
};

exports.selectPersistenceEnabled = selectPersistenceEnabled;

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Meeting = exports.User = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(34));

/**
 * User Class, used for creating users
 *
 */
var User = function User(name, sipUri) {
  (0, _classCallCheck2.default)(this, User);
  this.id = '-1';
  this.name = name ? name.trim() : '';
  this.sipUri = sipUri ? sipUri.trim() : '';
  this.contactType = 'STANDARD';
  this.category = 'PERSONAL';
  this.description = '';
};
/**
 * Meeting Class, used for creating meetings
 *
 */


exports.User = User;

var Meeting = function Meeting(name, description, pin, ownerID, lecturerID, moderatorID) {
  (0, _classCallCheck2.default)(this, Meeting);
  this.id = '-1';
  this.name = name ? name.trim() : '';
  this.pin = pin ? pin.trim() : '';
  this.contactType = 'MEETING';
  this.ownerID = ownerID ? ownerID.trim() : '';
  this.lecturerID = lecturerID ? lecturerID.trim() : '';
  this.moderatorID = moderatorID ? moderatorID.trim() : '';
  this.description = description ? description.trim() : '';
};

exports.Meeting = Meeting;

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPluginHashCode = fetchPluginHashCode;
exports.fetchPluginHashCodeFromExtension = fetchPluginHashCodeFromExtension;
exports.PLUGIN_CONTROL_URI = exports.PLUGIN_RPC_ENDPOINT = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(12));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(14));

var _get = _interopRequireDefault(__webpack_require__(11));

var _constants = __webpack_require__(3);

var _proxy = __webpack_require__(21);

var PLUGIN_RPC_ENDPOINT = 'lifesize.plugin';
exports.PLUGIN_RPC_ENDPOINT = PLUGIN_RPC_ENDPOINT;
var PLUGIN_CONTROL_URI = 'control';
exports.PLUGIN_CONTROL_URI = PLUGIN_CONTROL_URI;

function fetchPluginHashCode(meetingUUID) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch) {
        var params, response;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  meetingUUID: meetingUUID
                };
                _context.next = 3;
                return dispatch((0, _proxy.proxyApiCall)(PLUGIN_RPC_ENDPOINT, PLUGIN_CONTROL_URI, _constants.HTTP_POST, params));

              case 3:
                response = _context.sent;
                return _context.abrupt("return", (0, _get.default)(JSON.parse(response), 'hashCode'));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}

function fetchPluginHashCodeFromExtension(meetingExtension) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch) {
        var params, response;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = {
                  meetingExtension: meetingExtension
                };
                _context2.next = 3;
                return dispatch((0, _proxy.proxyApiCall)(PLUGIN_RPC_ENDPOINT, PLUGIN_CONTROL_URI, _constants.HTTP_POST, params));

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", (0, _get.default)(JSON.parse(response), 'hashCode'));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/apollo-cache-persist/Log.js
var Log = (function () {
    function Log(options) {
        var _a = options.debug, debug = _a === void 0 ? false : _a;
        this.debug = debug;
        this.lines = [];
    }
    Log.prototype.emit = function (level, message) {
        if (level in console) {
            var prefix = Log.prefix;
            console[level].apply(console, [prefix].concat(message));
        }
    };
    Log.prototype.tailLogs = function () {
        var _this = this;
        this.lines.forEach(function (_a) {
            var level = _a[0], message = _a[1];
            return _this.emit(level, message);
        });
    };
    Log.prototype.getLogs = function () {
        return this.lines;
    };
    Log.prototype.write = function (level, message) {
        var buffer = Log.buffer;
        this.lines = this.lines.slice(1 - buffer).concat([[level, message]]);
        if (this.debug || level !== 'log') {
            this.emit(level, message);
        }
    };
    Log.prototype.info = function () {
        var message = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            message[_i] = arguments[_i];
        }
        this.write('log', message);
    };
    Log.prototype.warn = function () {
        var message = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            message[_i] = arguments[_i];
        }
        this.write('warn', message);
    };
    Log.prototype.error = function () {
        var message = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            message[_i] = arguments[_i];
        }
        this.write('error', message);
    };
    Log.buffer = 30;
    Log.prefix = '[apollo-cache-persist]';
    return Log;
}());
/* harmony default export */ var apollo_cache_persist_Log = (Log);
//# sourceMappingURL=Log.js.map
// CONCATENATED MODULE: ./node_modules/apollo-cache-persist/Cache.js
var Cache = (function () {
    function Cache(options) {
        var cache = options.cache, _a = options.serialize, serialize = _a === void 0 ? true : _a;
        this.cache = cache;
        this.serialize = serialize;
    }
    Cache.prototype.extract = function () {
        var data = this.cache.extract();
        if (this.serialize) {
            data = JSON.stringify(data);
        }
        return data;
    };
    Cache.prototype.restore = function (data) {
        if (this.serialize && typeof data === 'string') {
            data = JSON.parse(data);
        }
        if (data != null) {
            this.cache.restore(data);
        }
    };
    return Cache;
}());
/* harmony default export */ var apollo_cache_persist_Cache = (Cache);
//# sourceMappingURL=Cache.js.map
// CONCATENATED MODULE: ./node_modules/apollo-cache-persist/Storage.js
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var Storage = (function () {
    function Storage(options) {
        var storage = options.storage, _a = options.key, key = _a === void 0 ? 'apollo-cache-persist' : _a;
        this.storage = storage;
        this.key = key;
    }
    Storage.prototype.read = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.storage.getItem(this.key)];
            });
        });
    };
    Storage.prototype.write = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.storage.setItem(this.key, data)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    Storage.prototype.purge = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.storage.removeItem(this.key)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    Storage.prototype.getSize = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.storage.getItem(this.key)];
                    case 1:
                        data = _a.sent();
                        if (data == null) {
                            return [2, 0];
                        }
                        else {
                            return [2, typeof data === 'string' ? data.length : null];
                        }
                        return [2];
                }
            });
        });
    };
    return Storage;
}());
/* harmony default export */ var apollo_cache_persist_Storage = (Storage);
//# sourceMappingURL=Storage.js.map
// CONCATENATED MODULE: ./node_modules/apollo-cache-persist/Persistor.js
var Persistor_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var Persistor_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var Persistor = (function () {
    function Persistor(_a, options) {
        var log = _a.log, cache = _a.cache, storage = _a.storage;
        var _b = options.maxSize, maxSize = _b === void 0 ? 1024 * 1024 : _b;
        this.log = log;
        this.cache = cache;
        this.storage = storage;
        this.paused = false;
        if (maxSize) {
            this.maxSize = maxSize;
        }
    }
    Persistor.prototype.persist = function () {
        return Persistor_awaiter(this, void 0, void 0, function () {
            var data, error_1;
            return Persistor_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        data = this.cache.extract();
                        if (!(this.maxSize != null &&
                            typeof data === 'string' &&
                            data.length > this.maxSize &&
                            !this.paused)) return [3, 2];
                        return [4, this.purge()];
                    case 1:
                        _a.sent();
                        this.paused = true;
                        return [2];
                    case 2:
                        if (this.paused) {
                            this.paused = false;
                        }
                        return [4, this.storage.write(data)];
                    case 3:
                        _a.sent();
                        this.log.info(typeof data === 'string'
                            ? "Persisted cache of size " + data.length
                            : 'Persisted cache');
                        return [3, 5];
                    case 4:
                        error_1 = _a.sent();
                        this.log.error('Error persisting cache', error_1);
                        throw error_1;
                    case 5: return [2];
                }
            });
        });
    };
    Persistor.prototype.restore = function () {
        return Persistor_awaiter(this, void 0, void 0, function () {
            var data, error_2;
            return Persistor_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        return [4, this.storage.read()];
                    case 1:
                        data = _a.sent();
                        if (!(data != null)) return [3, 3];
                        return [4, this.cache.restore(data)];
                    case 2:
                        _a.sent();
                        this.log.info(typeof data === 'string'
                            ? "Restored cache of size " + data.length
                            : 'Restored cache');
                        return [3, 4];
                    case 3:
                        this.log.info('No stored cache to restore');
                        _a.label = 4;
                    case 4: return [3, 6];
                    case 5:
                        error_2 = _a.sent();
                        this.log.error('Error restoring cache', error_2);
                        throw error_2;
                    case 6: return [2];
                }
            });
        });
    };
    Persistor.prototype.purge = function () {
        return Persistor_awaiter(this, void 0, void 0, function () {
            var error_3;
            return Persistor_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.storage.purge()];
                    case 1:
                        _a.sent();
                        this.log.info('Purged cache storage');
                        return [3, 3];
                    case 2:
                        error_3 = _a.sent();
                        this.log.error('Error purging cache storage', error_3);
                        throw error_3;
                    case 3: return [2];
                }
            });
        });
    };
    return Persistor;
}());
/* harmony default export */ var apollo_cache_persist_Persistor = (Persistor);
//# sourceMappingURL=Persistor.js.map
// CONCATENATED MODULE: ./node_modules/apollo-cache-persist/onCacheWrite.js
/* harmony default export */ var onCacheWrite = (function (_a) {
    var cache = _a.cache;
    return function (persist) {
        var write = cache.write;
        cache.write = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            write.apply(cache, args);
            persist();
        };
        return function () {
            cache.write = write;
        };
    };
});;
//# sourceMappingURL=onCacheWrite.js.map
// CONCATENATED MODULE: ./node_modules/apollo-cache-persist/onAppBackground.js

/* harmony default export */ var onAppBackground = (function (_a) {
    var log = _a.log, cache = _a.cache;
    return function (persist) {
        log.warn('Trigger option `background` not available on web; using `write` trigger');
        return onCacheWrite({ cache: cache })(persist);
    };
});;
//# sourceMappingURL=onAppBackground.js.map
// CONCATENATED MODULE: ./node_modules/apollo-cache-persist/Trigger.js


var Trigger_Trigger = (function () {
    function Trigger(_a, options) {
        var log = _a.log, persistor = _a.persistor;
        var _this = this;
        this.fire = function () {
            if (!_this.debounce) {
                _this.persist();
                return;
            }
            if (_this.timeout != null) {
                clearTimeout(_this.timeout);
            }
            _this.timeout = setTimeout(_this.persist, _this.debounce);
        };
        this.persist = function () {
            if (_this.paused) {
                return;
            }
            _this.persistor.persist();
        };
        var defaultDebounce = Trigger.defaultDebounce;
        var cache = options.cache, debounce = options.debounce, _b = options.trigger, trigger = _b === void 0 ? 'write' : _b;
        if (!trigger) {
            return;
        }
        this.debounce = debounce != null ? debounce : defaultDebounce;
        this.persistor = persistor;
        this.paused = false;
        switch (trigger) {
            case 'write':
                this.uninstall = onCacheWrite({ cache: cache })(this.fire);
                break;
            case 'background':
                if (debounce) {
                    log.warn('Debounce is not recommended with `background` trigger');
                }
                this.debounce = debounce;
                this.uninstall = onAppBackground({ cache: cache, log: log })(this.fire);
                break;
            default:
                if (typeof trigger === 'function') {
                    this.uninstall = trigger(this.fire);
                }
                else {
                    throw Error("Unrecognized trigger option: " + trigger);
                }
        }
    }
    Trigger.prototype.pause = function () {
        this.paused = true;
    };
    Trigger.prototype.resume = function () {
        this.paused = false;
    };
    Trigger.prototype.remove = function () {
        if (this.uninstall) {
            this.uninstall();
            this.uninstall = null;
            this.paused = true;
        }
    };
    Trigger.defaultDebounce = 1000;
    return Trigger;
}());
/* harmony default export */ var apollo_cache_persist_Trigger = (Trigger_Trigger);
//# sourceMappingURL=Trigger.js.map
// CONCATENATED MODULE: ./node_modules/apollo-cache-persist/CachePersistor.js





var CachePersistor_CachePersistor = (function () {
    function CachePersistor(options) {
        if (!options.cache) {
            throw new Error('In order to persist your Apollo Cache, you need to pass in a cache. ' +
                'Please see https://www.apollographql.com/docs/react/basics/caching.html for our default InMemoryCache.');
        }
        if (!options.storage) {
            throw new Error('In order to persist your Apollo Cache, you need to pass in an underlying storage provider. ' +
                'Please see https://github.com/apollographql/apollo-cache-persist#storage-providers');
        }
        var log = new apollo_cache_persist_Log(options);
        var cache = new apollo_cache_persist_Cache(options);
        var storage = new apollo_cache_persist_Storage(options);
        var persistor = new apollo_cache_persist_Persistor({ log: log, cache: cache, storage: storage }, options);
        var trigger = new apollo_cache_persist_Trigger({ log: log, persistor: persistor }, options);
        this.log = log;
        this.cache = cache;
        this.storage = storage;
        this.persistor = persistor;
        this.trigger = trigger;
    }
    CachePersistor.prototype.persist = function () {
        return this.persistor.persist();
    };
    CachePersistor.prototype.restore = function () {
        return this.persistor.restore();
    };
    CachePersistor.prototype.purge = function () {
        return this.persistor.purge();
    };
    CachePersistor.prototype.pause = function () {
        this.trigger.pause();
    };
    CachePersistor.prototype.resume = function () {
        this.trigger.resume();
    };
    CachePersistor.prototype.remove = function () {
        this.trigger.remove();
    };
    CachePersistor.prototype.getLogs = function (print) {
        if (print === void 0) { print = false; }
        if (print) {
            this.log.tailLogs();
        }
        else {
            return this.log.getLogs();
        }
    };
    CachePersistor.prototype.getSize = function () {
        return this.storage.getSize();
    };
    return CachePersistor;
}());
/* harmony default export */ var apollo_cache_persist_CachePersistor = (CachePersistor_CachePersistor);
//# sourceMappingURL=CachePersistor.js.map
// CONCATENATED MODULE: ./node_modules/apollo-cache-persist/persistCache.js

/* harmony default export */ var persistCache = (function (options) {
    var persistor = new apollo_cache_persist_CachePersistor(options);
    return persistor.restore();
});;
//# sourceMappingURL=persistCache.js.map
// CONCATENATED MODULE: ./node_modules/apollo-cache-persist/index.js
/* concated harmony reexport CachePersistor */__webpack_require__.d(__webpack_exports__, "CachePersistor", function() { return apollo_cache_persist_CachePersistor; });
/* concated harmony reexport persistCache */__webpack_require__.d(__webpack_exports__, "persistCache", function() { return persistCache; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(0);

// EXTERNAL MODULE: ./node_modules/apollo-utilities/lib/bundle.esm.js
var bundle_esm = __webpack_require__(6);

// CONCATENATED MODULE: ./node_modules/apollo-cache/lib/bundle.esm.js


function queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery',
        },
        selectionSet: selectionSetFromObj(obj),
    };
    var out = {
        kind: 'Document',
        definitions: [op],
    };
    return out;
}
function fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType',
            },
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery',
        },
        selectionSet: selectionSetFromObj(obj),
    };
    var out = {
        kind: 'Document',
        definitions: [frag],
    };
    return out;
}
function selectionSetFromObj(obj) {
    if (typeof obj === 'number' ||
        typeof obj === 'boolean' ||
        typeof obj === 'string' ||
        typeof obj === 'undefined' ||
        obj === null) {
        return null;
    }
    if (Array.isArray(obj)) {
        return selectionSetFromObj(obj[0]);
    }
    var selections = [];
    Object.keys(obj).forEach(function (key) {
        var nestedSelSet = selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key,
            },
            selectionSet: nestedSelSet || undefined,
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections,
    };
    return selectionSet;
}
var justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename',
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null,
                    },
                ],
            },
        },
    ],
};

var bundle_esm_ApolloCache = (function () {
    function ApolloCache() {
    }
    ApolloCache.prototype.transformDocument = function (document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function (document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic,
        });
    };
    ApolloCache.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.read({
            query: Object(bundle_esm["k" /* getFragmentQueryDocument */])(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic,
        });
    };
    ApolloCache.prototype.writeQuery = function (options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables,
        });
    };
    ApolloCache.prototype.writeFragment = function (options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: Object(bundle_esm["k" /* getFragmentQueryDocument */])(options.fragment, options.fragmentName),
        });
    };
    ApolloCache.prototype.writeData = function (_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: justTypenameQuery,
                });
            }
            catch (e) {
            }
            var __typename = (typenameResult && typenameResult.__typename) || '__ClientData';
            var dataToWrite = Object.assign({ __typename: __typename }, data);
            this.writeFragment({
                id: id,
                fragment: fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite,
            });
        }
        else {
            this.writeQuery({ query: queryFromPojo(data), data: data });
        }
    };
    return ApolloCache;
}());

var Cache;
(function (Cache) {
})(Cache || (Cache = {}));


//# sourceMappingURL=bundle.esm.js.map

// EXTERNAL MODULE: ./node_modules/@wry/equality/lib/equality.esm.js
var equality_esm = __webpack_require__(78);

// CONCATENATED MODULE: ./node_modules/@wry/context/lib/context.esm.js
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var MISSING_VALUE = {};
var idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var makeSlotClass = function () { return /** @class */ (function () {
    function Slot() {
        // If you have a Slot object, you can find out its slot.id, but you cannot
        // guess the slot.id of a Slot you don't have access to, thanks to the
        // randomized suffix.
        this.id = [
            "slot",
            idCounter++,
            Date.now(),
            Math.random().toString(36).slice(2),
        ].join(":");
    }
    Slot.prototype.hasValue = function () {
        for (var context_1 = currentContext; context_1; context_1 = context_1.parent) {
            // We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === MISSING_VALUE)
                    break;
                if (context_1 !== currentContext) {
                    // Cache the value in currentContext.slots so the next lookup will
                    // be faster. This caching is safe because the tree of contexts and
                    // the values of the slots are logically immutable.
                    currentContext.slots[this.id] = value;
                }
                return true;
            }
        }
        if (currentContext) {
            // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            currentContext.slots[this.id] = MISSING_VALUE;
        }
        return false;
    };
    Slot.prototype.getValue = function () {
        if (this.hasValue()) {
            return currentContext.slots[this.id];
        }
    };
    Slot.prototype.withValue = function (value, callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        var _a;
        var slots = (_a = {
                __proto__: null
            },
            _a[this.id] = value,
            _a);
        var parent = currentContext;
        currentContext = { parent: parent, slots: slots };
        try {
            // Function.prototype.apply allows the arguments array argument to be
            // omitted or undefined, so args! is fine here.
            return callback.apply(thisArg, args);
        }
        finally {
            currentContext = parent;
        }
    };
    // Capture the current context and wrap a callback function so that it
    // reestablishes the captured context when called.
    Slot.bind = function (callback) {
        var context = currentContext;
        return function () {
            var saved = currentContext;
            try {
                currentContext = context;
                return callback.apply(this, arguments);
            }
            finally {
                currentContext = saved;
            }
        };
    };
    // Immediately run a callback function without any captured context.
    Slot.noContext = function (callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        if (currentContext) {
            var saved = currentContext;
            try {
                currentContext = null;
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            }
            finally {
                currentContext = saved;
            }
        }
        else {
            return callback.apply(thisArg, args);
        }
    };
    return Slot;
}()); };
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var globalKey = "@wry/context:Slot";
var host = Array;
var Slot = host[globalKey] || function () {
    var Slot = makeSlotClass();
    try {
        Object.defineProperty(host, globalKey, {
            value: host[globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false,
        });
    }
    finally {
        return Slot;
    }
}();

var bind = Slot.bind, noContext = Slot.noContext;
function setTimeoutWithContext(callback, delay) {
    return setTimeout(bind(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function asyncFromGen(genFn) {
    return function () {
        var gen = genFn.apply(this, arguments);
        var boundNext = bind(gen.next);
        var boundThrow = bind(gen.throw);
        return new Promise(function (resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                }
                catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if (isPromiseLike(result.value)) {
                    result.value.then(next, result.done ? reject : invokeThrow);
                }
                else {
                    next(result.value);
                }
            }
            var invokeNext = function (value) { return invoke(boundNext, value); };
            var invokeThrow = function (error) { return invoke(boundThrow, error); };
            invokeNext();
        });
    };
}
function isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var wrappedFibers = [];
function wrapYieldingFiberMethods(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if (wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function (obj, method) {
            var fn = obj[method];
            obj[method] = function () {
                return noContext(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        wrappedFibers.push(Fiber);
    }
    return Fiber;
}


//# sourceMappingURL=context.esm.js.map

// CONCATENATED MODULE: ./node_modules/optimism/lib/bundle.esm.js



function defaultDispose() { }
var bundle_esm_Cache = /** @class */ (function () {
    function Cache(max, dispose) {
        if (max === void 0) { max = Infinity; }
        if (dispose === void 0) { dispose = defaultDispose; }
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function (key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function (key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function (key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) {
                newer.older = older;
            }
            if (older) {
                older.newer = newer;
            }
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) {
                this.oldest = newer;
            }
        }
        return entry;
    };
    Cache.prototype.set = function (key, value) {
        var entry = this.getEntry(key);
        if (entry) {
            return entry.value = value;
        }
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) {
            this.newest.newer = entry;
        }
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function () {
        while (this.oldest && this.map.size > this.max) {
            this.delete(this.oldest.key);
        }
    };
    Cache.prototype.delete = function (key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) {
                this.newest = entry.older;
            }
            if (entry === this.oldest) {
                this.oldest = entry.newer;
            }
            if (entry.newer) {
                entry.newer.older = entry.older;
            }
            if (entry.older) {
                entry.older.newer = entry.newer;
            }
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}());

var parentEntrySlot = new Slot();

var reusableEmptyArray = [];
var emptySetPool = [];
var POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function assert(condition, optionalMessage) {
    if (!condition) {
        throw new Error(optionalMessage || "assertion failure");
    }
}
function valueIs(a, b) {
    var len = a.length;
    return (
    // Unknown values are not equal to each other.
    len > 0 &&
        // Both values must be ordinary (or both exceptional) to be equal.
        len === b.length &&
        // The underlying value or exception must be the same.
        a[len - 1] === b[len - 1]);
}
function valueGet(value) {
    switch (value.length) {
        case 0: throw new Error("unknown value");
        case 1: return value[0];
        case 2: throw value[1];
    }
}
function valueCopy(value) {
    return value.slice(0);
}
var Entry = /** @class */ (function () {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function () {
        assert(!this.recomputing, "already recomputing");
        if (!rememberParent(this) && maybeReportOrphan(this)) {
            // The recipient of the entry.reportOrphan callback decided to dispose
            // of this orphan entry by calling entry.dispose(), so we don't need to
            // (and should not) proceed with the recomputation.
            return void 0;
        }
        return mightBeDirty(this)
            ? reallyRecompute(this)
            : valueGet(this.value);
    };
    Entry.prototype.setDirty = function () {
        if (this.dirty)
            return;
        this.dirty = true;
        this.value.length = 0;
        reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function () {
        var _this = this;
        forgetChildren(this).forEach(maybeReportOrphan);
        maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function (parent) {
            parent.setDirty();
            forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}());
function rememberParent(child) {
    var parent = parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) {
            parent.childValues.set(child, []);
        }
        if (mightBeDirty(child)) {
            reportDirtyChild(parent, child);
        }
        else {
            reportCleanChild(parent, child);
        }
        return parent;
    }
}
function reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    parentEntrySlot.withValue(entry, recomputeNewValue, [entry]);
    if (maybeSubscribe(entry)) {
        // If we successfully recomputed entry.value and did not fail to
        // (re)subscribe, then this Entry is no longer explicitly dirty.
        setClean(entry);
    }
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach(maybeReportOrphan);
    return valueGet(entry.value);
}
function recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    }
    catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function setClean(entry) {
    entry.dirty = false;
    if (mightBeDirty(entry)) {
        // This Entry may still have dirty children, in which case we can't
        // let our parents know we're clean just yet.
        return;
    }
    reportClean(entry);
}
function reportDirty(child) {
    child.parents.forEach(function (parent) { return reportDirtyChild(parent, child); });
}
function reportClean(child) {
    child.parents.forEach(function (parent) { return reportCleanChild(parent, child); });
}
// Let a parent Entry know that one of its children may be dirty.
function reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    assert(parent.childValues.has(child));
    assert(mightBeDirty(child));
    if (!parent.dirtyChildren) {
        parent.dirtyChildren = emptySetPool.pop() || new Set;
    }
    else if (parent.dirtyChildren.has(child)) {
        // If we already know this child is dirty, then we must have already
        // informed our own parents that we are dirty, so we can terminate
        // the recursion early.
        return;
    }
    parent.dirtyChildren.add(child);
    reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    assert(parent.childValues.has(child));
    assert(!mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) {
        parent.childValues.set(child, valueCopy(child.value));
    }
    else if (!valueIs(childValue, child.value)) {
        parent.setDirty();
    }
    removeDirtyChild(parent, child);
    if (mightBeDirty(parent)) {
        return;
    }
    reportClean(parent);
}
function removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if (emptySetPool.length < POOL_TARGET_SIZE) {
                emptySetPool.push(dc);
            }
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function maybeReportOrphan(entry) {
    return entry.parents.size === 0 &&
        typeof entry.reportOrphan === "function" &&
        entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function forgetChildren(parent) {
    var children = reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function (_value, child) {
            forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    assert(parent.dirtyChildren === null);
    return children;
}
function forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    removeDirtyChild(parent, child);
}
function maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") {
        try {
            maybeUnsubscribe(entry); // Prevent double subscriptions.
            entry.unsubscribe = entry.subscribe.apply(null, entry.args);
        }
        catch (e) {
            // If this Entry has a subscribe function and it threw an exception
            // (or an unsubscribe function it previously returned now throws),
            // return false to indicate that we were not able to subscribe (or
            // unsubscribe), and this Entry should remain dirty.
            entry.setDirty();
            return false;
        }
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}

// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var KeyTrie = /** @class */ (function () {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function () {
        var array = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            array[_i] = arguments[_i];
        }
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function (array) {
        var node = this;
        array.forEach(function (key) { return node = node.getChildTrie(key); });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function (key) {
        var map = this.weakness && isObjRef(key)
            ? this.weak || (this.weak = new WeakMap())
            : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child)
            map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}());
function isObjRef(value) {
    switch (typeof value) {
        case "object":
            if (value === null)
                break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}

// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var keyTrie = new KeyTrie(typeof WeakMap === "function");
function defaultMakeCacheKey() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return keyTrie.lookupArray(args);
}
var caches = new Set();
function wrap(originalFunction, options) {
    if (options === void 0) { options = Object.create(null); }
    var cache = new bundle_esm_Cache(options.max || Math.pow(2, 16), function (entry) { return entry.dispose(); });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || defaultMakeCacheKey;
    function optimistic() {
        if (disposable && !parentEntrySlot.hasValue()) {
            // If there's no current parent computation, and this wrapped
            // function is disposable (meaning we don't care about entry.value,
            // just dependency tracking), then we can short-cut everything else
            // in this function, because entry.recompute() is going to recycle
            // the entry object without recomputing anything, anyway.
            return void 0;
        }
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) {
            return originalFunction.apply(null, arguments);
        }
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) {
            entry.args = args;
        }
        else {
            entry = new Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) {
                entry.reportOrphan = function () { return cache.delete(key); };
            }
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!parentEntrySlot.hasValue()) {
            caches.forEach(function (cache) { return cache.clean(); });
            caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function () {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) {
            child.setDirty();
        }
    };
    return optimistic;
}


//# sourceMappingURL=bundle.esm.js.map

// EXTERNAL MODULE: ./node_modules/ts-invariant/lib/invariant.esm.js
var invariant_esm = __webpack_require__(17);

// CONCATENATED MODULE: ./node_modules/apollo-cache-inmemory/lib/bundle.esm.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HeuristicFragmentMatcher", function() { return HeuristicFragmentMatcher; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InMemoryCache", function() { return bundle_esm_InMemoryCache; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntrospectionFragmentMatcher", function() { return bundle_esm_IntrospectionFragmentMatcher; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObjectCache", function() { return ObjectCache; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StoreReader", function() { return bundle_esm_StoreReader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StoreWriter", function() { return bundle_esm_StoreWriter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WriteError", function() { return bundle_esm_WriteError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assertIdValue", function() { return assertIdValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultDataIdFromObject", function() { return defaultDataIdFromObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultNormalizedCacheFactory", function() { return defaultNormalizedCacheFactory$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enhanceErrorWithDocument", function() { return enhanceErrorWithDocument; });






var haveWarned = false;
function shouldWarn() {
    var answer = !haveWarned;
    if (!Object(bundle_esm["y" /* isTest */])()) {
        haveWarned = true;
    }
    return answer;
}
var HeuristicFragmentMatcher = (function () {
    function HeuristicFragmentMatcher() {
    }
    HeuristicFragmentMatcher.prototype.ensureReady = function () {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function () {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function (idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) {
            return isRootQuery;
        }
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            if (shouldWarn()) {
                 true || false;
                 true || false;
                 true || false;
            }
            return 'heuristic';
        }
        if (__typename === typeCondition) {
            return true;
        }
        if (shouldWarn()) {
             true || false;
        }
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}());
var bundle_esm_IntrospectionFragmentMatcher = (function () {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        }
        else {
            this.isReady = false;
        }
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function (idValue, typeCondition, context) {
         true ? Object(invariant_esm["b" /* invariant */])(this.isReady, 6) : undefined;
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) {
            return isRootQuery;
        }
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
         true ? Object(invariant_esm["b" /* invariant */])(__typename, 7) : undefined;
        if (__typename === typeCondition) {
            return true;
        }
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename &&
            implementingTypes &&
            implementingTypes.indexOf(__typename) > -1) {
            return true;
        }
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function (introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function (type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') {
                typeMap[type.name] = type.possibleTypes.map(function (implementingType) { return implementingType.name; });
            }
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}());

var hasOwn = Object.prototype.hasOwnProperty;
var bundle_esm_DepTrackingCache = (function () {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) { data = Object.create(null); }
        this.data = data;
        this.depend = wrap(function (dataId) { return _this.data[dataId]; }, {
            disposable: true,
            makeCacheKey: function (dataId) {
                return dataId;
            },
        });
    }
    DepTrackingCache.prototype.toObject = function () {
        return this.data;
    };
    DepTrackingCache.prototype.get = function (dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function (dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function (dataId) {
        if (hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function () {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function (newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function (dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function (dataId) {
                if (!hasOwn.call(newData, dataId)) {
                    _this.delete(dataId);
                }
            });
        }
        else {
            Object.keys(this.data).forEach(function (dataId) {
                _this.delete(dataId);
            });
        }
    };
    return DepTrackingCache;
}());
function defaultNormalizedCacheFactory(seed) {
    return new bundle_esm_DepTrackingCache(seed);
}

var bundle_esm_StoreReader = (function () {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new KeyTrie(bundle_esm["e" /* canUseWeakMap */]) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = wrap(function (options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function (_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof bundle_esm_DepTrackingCache) {
                    return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
                }
            }
        });
        this.executeSelectionSet = wrap(function (options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function (_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof bundle_esm_DepTrackingCache) {
                    return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
                }
            }
        });
        this.executeSubSelectedArray = wrap(function (options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function (_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof bundle_esm_DepTrackingCache) {
                    return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
                }
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function (options) {
        return this.diffQueryAgainstStore(Object(tslib_es6["a" /* __assign */])({}, options, { returnPartialData: false })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function (_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = Object(bundle_esm["o" /* getQueryDefinition */])(query);
        variables = Object(bundle_esm["c" /* assign */])({}, Object(bundle_esm["h" /* getDefaultValues */])(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: (config && config.cacheRedirects) || {},
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query',
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction,
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) {
            execResult.missing.forEach(function (info) {
                if (info.tolerable)
                    return;
                throw  true ? new invariant_esm["a" /* InvariantError */](8) : undefined;
            });
        }
        if (previousResult) {
            if (Object(equality_esm["a" /* equal */])(previousResult, execResult.result)) {
                execResult.result = previousResult;
            }
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields,
        };
    };
    StoreReader.prototype.executeStoreQuery = function (_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? defaultFragmentMatcher : _b;
        var mainDefinition = Object(bundle_esm["l" /* getMainDefinition */])(query);
        var fragments = Object(bundle_esm["j" /* getFragmentDefinitions */])(query);
        var fragmentMap = Object(bundle_esm["g" /* createFragmentMap */])(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher,
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext,
        });
    };
    StoreReader.prototype.executeSelectionSet = function (_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = { result: null };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = (object && object.__typename) ||
            (rootValue.id === 'ROOT_QUERY' && 'Query') ||
            void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function (selection) {
            var _a;
            if (!Object(bundle_esm["F" /* shouldInclude */])(selection, variables)) {
                return;
            }
            if (Object(bundle_esm["t" /* isField */])(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') {
                    objectsToMerge.push((_a = {},
                        _a[Object(bundle_esm["E" /* resultKeyNameFromField */])(selection)] = fieldResult,
                        _a));
                }
            }
            else {
                var fragment = void 0;
                if (Object(bundle_esm["v" /* isInlineFragment */])(selection)) {
                    fragment = selection;
                }
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) {
                        throw  true ? new invariant_esm["a" /* InvariantError */](9) : undefined;
                    }
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition ||
                    execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext,
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) {
                        fragmentExecResult = Object(tslib_es6["a" /* __assign */])({}, fragmentExecResult, { missing: fragmentExecResult.missing.map(function (info) {
                                return Object(tslib_es6["a" /* __assign */])({}, info, { tolerable: true });
                            }) });
                    }
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = Object(bundle_esm["B" /* mergeDeepArray */])(objectsToMerge);
        if (this.freezeResults && "production" !== 'production') {
            Object.freeze(finalResult.result);
        }
        return finalResult;
    };
    StoreReader.prototype.executeField = function (object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = Object(bundle_esm["b" /* argumentsObjectFromField */])(field, variables);
        var info = {
            resultKey: Object(bundle_esm["E" /* resultKeyNameFromField */])(field),
            directives: Object(bundle_esm["i" /* getDirectiveInfoFromField */])(field, variables),
        };
        var readStoreResult = readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) {
            return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
                field: field,
                array: readStoreResult.result,
                execContext: execContext,
            }));
        }
        if (!field.selectionSet) {
            assertSelectionSetForIdValue(field, readStoreResult.result);
            if (this.freezeResults && "production" !== 'production') {
                Object(bundle_esm["z" /* maybeDeepFreeze */])(readStoreResult);
            }
            return readStoreResult;
        }
        if (readStoreResult.result == null) {
            return readStoreResult;
        }
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext,
        }));
    };
    StoreReader.prototype.combineExecResults = function () {
        var execResults = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            execResults[_i] = arguments[_i];
        }
        var missing;
        execResults.forEach(function (execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing,
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function (_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function (item) {
            if (item === null) {
                return null;
            }
            if (Array.isArray(item)) {
                return handleMissing(_this.executeSubSelectedArray({
                    field: field,
                    array: item,
                    execContext: execContext,
                }));
            }
            if (field.selectionSet) {
                return handleMissing(_this.executeSelectionSet({
                    selectionSet: field.selectionSet,
                    rootValue: item,
                    execContext: execContext,
                }));
            }
            assertSelectionSetForIdValue(field, item);
            return item;
        });
        if (this.freezeResults && "production" !== 'production') {
            Object.freeze(array);
        }
        return { result: array, missing: missing };
    };
    return StoreReader;
}());
function assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && Object(bundle_esm["u" /* isIdValue */])(value)) {
        throw  true ? new invariant_esm["a" /* InvariantError */](10) : undefined;
    }
}
function defaultFragmentMatcher() {
    return true;
}
function assertIdValue(idValue) {
     true ? Object(invariant_esm["b" /* invariant */])(Object(bundle_esm["u" /* isIdValue */])(idValue), 11) : undefined;
}
function readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) {
        storeKeyName = Object(bundle_esm["p" /* getStoreKeyName */])(storeKeyName, args, directives);
    }
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' &&
            context.cacheRedirects &&
            typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) {
                    fieldValue = resolver(object, args, {
                        getCacheKey: function (storeObj) {
                            var id = context.dataIdFromObject(storeObj);
                            return id && Object(bundle_esm["H" /* toIdValue */])({
                                id: id,
                                typename: storeObj.__typename,
                            });
                        },
                    });
                }
            }
        }
    }
    if (typeof fieldValue === 'undefined') {
        return {
            result: fieldValue,
            missing: [{
                    object: object,
                    fieldName: storeKeyName,
                    tolerable: false,
                }],
        };
    }
    if (Object(bundle_esm["w" /* isJsonValue */])(fieldValue)) {
        fieldValue = fieldValue.json;
    }
    return {
        result: fieldValue,
    };
}

var ObjectCache = (function () {
    function ObjectCache(data) {
        if (data === void 0) { data = Object.create(null); }
        this.data = data;
    }
    ObjectCache.prototype.toObject = function () {
        return this.data;
    };
    ObjectCache.prototype.get = function (dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function (dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function (dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function () {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function (newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}());
function defaultNormalizedCacheFactory$1(seed) {
    return new ObjectCache(seed);
}

var bundle_esm_WriteError = (function (_super) {
    Object(tslib_es6["c" /* __extends */])(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error));
function enhanceErrorWithDocument(error, document) {
    var enhancedError = new bundle_esm_WriteError("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var bundle_esm_StoreWriter = (function () {
    function StoreWriter() {
    }
    StoreWriter.prototype.writeQueryToStore = function (_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction,
        });
    };
    StoreWriter.prototype.writeResultToStore = function (_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = Object(bundle_esm["m" /* getOperationDefinition */])(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: Object(bundle_esm["c" /* assign */])({}, Object(bundle_esm["h" /* getDefaultValues */])(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: Object(bundle_esm["g" /* createFragmentMap */])(Object(bundle_esm["j" /* getFragmentDefinitions */])(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction,
                },
            });
        }
        catch (e) {
            throw enhanceErrorWithDocument(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function (_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function (selection) {
            var _a;
            if (!Object(bundle_esm["F" /* shouldInclude */])(selection, variables)) {
                return;
            }
            if (Object(bundle_esm["t" /* isField */])(selection)) {
                var resultFieldKey = Object(bundle_esm["E" /* resultKeyNameFromField */])(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') {
                    _this.writeFieldToStore({
                        dataId: dataId,
                        value: value,
                        field: selection,
                        context: context,
                    });
                }
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function (directive) { return directive.name && directive.name.value === 'defer'; });
                        isClient = selection.directives.some(function (directive) { return directive.name && directive.name.value === 'client'; });
                    }
                    if (!isDefered && !isClient && context.fragmentMatcherFunction) {
                         true || false;
                    }
                }
            }
            else {
                var fragment = void 0;
                if (Object(bundle_esm["v" /* isInlineFragment */])(selection)) {
                    fragment = selection;
                }
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                     true ? Object(invariant_esm["b" /* invariant */])(fragment, 2) : undefined;
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = Object(bundle_esm["H" /* toIdValue */])({ id: id, typename: undefined });
                    var fakeContext = {
                        store: new ObjectCache((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {},
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    if (!Object(bundle_esm["x" /* isProduction */])() && match === 'heuristic') {
                         true || false;
                    }
                    matches = !!match;
                }
                if (matches) {
                    _this.writeSelectionSetToStore({
                        result: result,
                        selectionSet: fragment.selectionSet,
                        dataId: dataId,
                        context: context,
                    });
                }
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function (_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = Object(bundle_esm["G" /* storeKeyNameFromField */])(field, variables);
        if (!field.selectionSet || value === null) {
            storeValue =
                value != null && typeof value === 'object'
                    ?
                        { type: 'json', json: value }
                    :
                        value;
        }
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        }
        else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!isGeneratedId(valueDataId)) {
                valueDataId = '$' + valueDataId;
            }
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                 true ? Object(invariant_esm["b" /* invariant */])(!semanticId || !isGeneratedId(semanticId), 3) : undefined;
                if (semanticId ||
                    (typeof semanticId === 'number' && semanticId === 0)) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!isDataProcessed(valueDataId, field, context.processedData)) {
                this.writeSelectionSetToStore({
                    dataId: valueDataId,
                    result: value,
                    selectionSet: field.selectionSet,
                    context: context,
                });
            }
            var typename = value.__typename;
            storeValue = Object(bundle_esm["H" /* toIdValue */])({ id: valueDataId, typename: typename }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && Object(bundle_esm["u" /* isIdValue */])(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                 true ? Object(invariant_esm["b" /* invariant */])(!generated || escapedId.generated || typenameChanged, 4) : undefined;
                 true ? Object(invariant_esm["b" /* invariant */])(!hadTypename || hasTypename, 5) : undefined;
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) {
                            store.delete(escapedId.id);
                        }
                    }
                    else {
                        mergeWithGenerated(escapedId.id, storeValue.id, store);
                    }
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !Object(equality_esm["a" /* equal */])(storeValue, storeObject[storeFieldName])) {
            store.set(dataId, Object(tslib_es6["a" /* __assign */])({}, storeObject, (_b = {}, _b[storeFieldName] = storeValue, _b)));
        }
    };
    StoreWriter.prototype.processArrayValue = function (value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function (item, index) {
            if (item === null) {
                return null;
            }
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) {
                return _this.processArrayValue(item, itemDataId, selectionSet, context);
            }
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!isDataProcessed(itemDataId, selectionSet, context.processedData)) {
                _this.writeSelectionSetToStore({
                    dataId: itemDataId,
                    result: item,
                    selectionSet: selectionSet,
                    context: context,
                });
            }
            return Object(bundle_esm["H" /* toIdValue */])({ id: itemDataId, typename: item.__typename }, generated);
        });
    };
    return StoreWriter;
}());
function isGeneratedId(id) {
    return id[0] === '$';
}
function mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) {
        return false;
    }
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function (key) {
        var value = generated[key];
        var realValue = real[key];
        if (Object(bundle_esm["u" /* isIdValue */])(value) &&
            isGeneratedId(value.id) &&
            Object(bundle_esm["u" /* isIdValue */])(realValue) &&
            !Object(equality_esm["a" /* equal */])(value, realValue) &&
            mergeWithGenerated(value.id, realValue.id, cache)) {
            madeChanges = true;
        }
    });
    cache.delete(generatedKey);
    var newRealValue = Object(tslib_es6["a" /* __assign */])({}, generated, real);
    if (Object(equality_esm["a" /* equal */])(newRealValue, real)) {
        return madeChanges;
    }
    cache.set(realKey, newRealValue);
    return true;
}
function isDataProcessed(dataId, field, processedData) {
    if (!processedData) {
        return false;
    }
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) {
            return true;
        }
        else {
            processedData[dataId].push(field);
        }
    }
    else {
        processedData[dataId] = [field];
    }
    return false;
}

var defaultConfig = {
    fragmentMatcher: new HeuristicFragmentMatcher(),
    dataIdFromObject: defaultDataIdFromObject,
    addTypename: true,
    resultCaching: true,
    freezeResults: false,
};
function defaultDataIdFromObject(result) {
    if (result.__typename) {
        if (result.id !== undefined) {
            return result.__typename + ":" + result.id;
        }
        if (result._id !== undefined) {
            return result.__typename + ":" + result._id;
        }
    }
    return null;
}
var hasOwn$1 = Object.prototype.hasOwnProperty;
var bundle_esm_OptimisticCacheLayer = (function (_super) {
    Object(tslib_es6["c" /* __extends */])(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function () {
        return Object(tslib_es6["a" /* __assign */])({}, this.parent.toObject(), this.data);
    };
    OptimisticCacheLayer.prototype.get = function (dataId) {
        return hasOwn$1.call(this.data, dataId)
            ? this.data[dataId]
            : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}(ObjectCache));
var bundle_esm_InMemoryCache = (function (_super) {
    Object(tslib_es6["c" /* __extends */])(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new KeyTrie(bundle_esm["e" /* canUseWeakMap */]);
        _this.silenceBroadcast = false;
        _this.config = Object(tslib_es6["a" /* __assign */])({}, defaultConfig, config);
        if (_this.config.customResolvers) {
             true || false;
            _this.config.cacheRedirects = _this.config.customResolvers;
        }
        if (_this.config.cacheResolvers) {
             true || false;
            _this.config.cacheRedirects = _this.config.cacheResolvers;
        }
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching
            ? new bundle_esm_DepTrackingCache()
            : new ObjectCache();
        _this.optimisticData = _this.data;
        _this.storeWriter = new bundle_esm_StoreWriter();
        _this.storeReader = new bundle_esm_StoreReader({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults,
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = wrap(function (c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function (c) {
                if (c.optimistic) {
                    return;
                }
                if (c.previousResult) {
                    return;
                }
                if (cache.data instanceof bundle_esm_DepTrackingCache) {
                    return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
                }
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function (data) {
        if (data)
            this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function (optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function (options) {
        if (typeof options.rootId === 'string' &&
            typeof this.data.get(options.rootId) === 'undefined') {
            return null;
        }
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config,
        }) || null;
    };
    InMemoryCache.prototype.write = function (write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction,
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function (query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config,
        });
    };
    InMemoryCache.prototype.watch = function (watch) {
        var _this = this;
        this.watches.add(watch);
        return function () {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function (query) {
        throw  true ? new invariant_esm["a" /* InvariantError */](1) : undefined;
    };
    InMemoryCache.prototype.reset = function () {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function (idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while (layer instanceof bundle_esm_OptimisticCacheLayer) {
            if (layer.optimisticId === idToRemove) {
                ++removedCount;
            }
            else {
                toReapply.push(layer);
            }
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while (toReapply.length > 0) {
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function (transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') {
            this.data = this.optimisticData = new bundle_esm_OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        }
        try {
            transaction(this);
        }
        finally {
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function (transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function (document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = Object(bundle_esm["a" /* addTypenameToDocument */])(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function () {
        var _this = this;
        if (!this.silenceBroadcast) {
            this.watches.forEach(function (c) { return _this.maybeBroadcastWatch(c); });
        }
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function (c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic,
        }));
    };
    return InMemoryCache;
}(bundle_esm_ApolloCache));


//# sourceMappingURL=bundle.esm.js.map


/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(0);

// EXTERNAL MODULE: ./node_modules/apollo-link/lib/bundle.esm.js
var bundle_esm = __webpack_require__(40);

// EXTERNAL MODULE: ./node_modules/zen-observable-ts/lib/bundle.esm.js
var lib_bundle_esm = __webpack_require__(33);

// EXTERNAL MODULE: ./node_modules/graphql/language/printer.js
var printer = __webpack_require__(297);

// EXTERNAL MODULE: ./node_modules/ts-invariant/lib/invariant.esm.js
var invariant_esm = __webpack_require__(17);

// CONCATENATED MODULE: ./node_modules/apollo-link-http-common/lib/bundle.esm.js




var defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
};
var defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json',
};
var defaultOptions = {
    method: 'POST',
};
var fallbackHttpConfig = {
    http: defaultHttpOptions,
    headers: defaultHeaders,
    options: defaultOptions,
};
var throwServerError = function (response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var parseAndCheckHttpResponse = function (operations) { return function (response) {
    return (response
        .text()
        .then(function (bodyText) {
        try {
            return JSON.parse(bodyText);
        }
        catch (err) {
            var parseError = err;
            parseError.name = 'ServerParseError';
            parseError.response = response;
            parseError.statusCode = response.status;
            parseError.bodyText = bodyText;
            return Promise.reject(parseError);
        }
    })
        .then(function (result) {
        if (response.status >= 300) {
            throwServerError(response, result, "Response not successful: Received status code " + response.status);
        }
        if (!Array.isArray(result) &&
            !result.hasOwnProperty('data') &&
            !result.hasOwnProperty('errors')) {
            throwServerError(response, result, "Server response was missing for query '" + (Array.isArray(operations)
                ? operations.map(function (op) { return op.operationName; })
                : operations.operationName) + "'.");
        }
        return result;
    }));
}; };
var checkFetcher = function (fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined')
            library = 'node-fetch';
        throw  true ? new invariant_esm["a" /* InvariantError */](1) : undefined;
    }
};
var createSignalIfSupported = function () {
    if (typeof AbortController === 'undefined')
        return { controller: false, signal: false };
    var controller = new AbortController();
    var signal = controller.signal;
    return { controller: controller, signal: signal };
};
var selectHttpOptionsAndBody = function (operation, fallbackConfig) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    var options = Object(tslib_es6["a" /* __assign */])({}, fallbackConfig.options, { headers: fallbackConfig.headers, credentials: fallbackConfig.credentials });
    var http = fallbackConfig.http;
    configs.forEach(function (config) {
        options = Object(tslib_es6["a" /* __assign */])({}, options, config.options, { headers: Object(tslib_es6["a" /* __assign */])({}, options.headers, config.headers) });
        if (config.credentials)
            options.credentials = config.credentials;
        http = Object(tslib_es6["a" /* __assign */])({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = { operationName: operationName, variables: variables };
    if (http.includeExtensions)
        body.extensions = extensions;
    if (http.includeQuery)
        body.query = Object(printer["print"])(query);
    return {
        options: options,
        body: body,
    };
};
var serializeFetchParameter = function (p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    }
    catch (e) {
        var parseError =  true ? new invariant_esm["a" /* InvariantError */](2) : undefined;
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var selectURI = function (operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) {
        return contextURI;
    }
    else if (typeof fallbackURI === 'function') {
        return fallbackURI(operation);
    }
    else {
        return fallbackURI || '/graphql';
    }
};


//# sourceMappingURL=bundle.esm.js.map

// CONCATENATED MODULE: ./node_modules/apollo-link-batch/lib/bundle.esm.js



var bundle_esm_OperationBatcher = (function () {
    function OperationBatcher(_a) {
        var batchInterval = _a.batchInterval, batchMax = _a.batchMax, batchHandler = _a.batchHandler, batchKey = _a.batchKey;
        this.queuedRequests = new Map();
        this.batchInterval = batchInterval;
        this.batchMax = batchMax || 0;
        this.batchHandler = batchHandler;
        this.batchKey = batchKey || (function () { return ''; });
    }
    OperationBatcher.prototype.enqueueRequest = function (request) {
        var _this = this;
        var requestCopy = Object(tslib_es6["a" /* __assign */])({}, request);
        var queued = false;
        var key = this.batchKey(request.operation);
        if (!requestCopy.observable) {
            requestCopy.observable = new lib_bundle_esm["a" /* default */](function (observer) {
                if (!_this.queuedRequests.has(key)) {
                    _this.queuedRequests.set(key, []);
                }
                if (!queued) {
                    _this.queuedRequests.get(key).push(requestCopy);
                    queued = true;
                }
                requestCopy.next = requestCopy.next || [];
                if (observer.next)
                    requestCopy.next.push(observer.next.bind(observer));
                requestCopy.error = requestCopy.error || [];
                if (observer.error)
                    requestCopy.error.push(observer.error.bind(observer));
                requestCopy.complete = requestCopy.complete || [];
                if (observer.complete)
                    requestCopy.complete.push(observer.complete.bind(observer));
                if (_this.queuedRequests.get(key).length === 1) {
                    _this.scheduleQueueConsumption(key);
                }
                if (_this.queuedRequests.get(key).length === _this.batchMax) {
                    _this.consumeQueue(key);
                }
            });
        }
        return requestCopy.observable;
    };
    OperationBatcher.prototype.consumeQueue = function (key) {
        var requestKey = key || '';
        var queuedRequests = this.queuedRequests.get(requestKey);
        if (!queuedRequests) {
            return;
        }
        this.queuedRequests.delete(requestKey);
        var requests = queuedRequests.map(function (queuedRequest) { return queuedRequest.operation; });
        var forwards = queuedRequests.map(function (queuedRequest) { return queuedRequest.forward; });
        var observables = [];
        var nexts = [];
        var errors = [];
        var completes = [];
        queuedRequests.forEach(function (batchableRequest, index) {
            observables.push(batchableRequest.observable);
            nexts.push(batchableRequest.next);
            errors.push(batchableRequest.error);
            completes.push(batchableRequest.complete);
        });
        var batchedObservable = this.batchHandler(requests, forwards) || lib_bundle_esm["a" /* default */].of();
        var onError = function (error) {
            errors.forEach(function (rejecters) {
                if (rejecters) {
                    rejecters.forEach(function (e) { return e(error); });
                }
            });
        };
        batchedObservable.subscribe({
            next: function (results) {
                if (!Array.isArray(results)) {
                    results = [results];
                }
                if (nexts.length !== results.length) {
                    var error = new Error("server returned results with length " + results.length + ", expected length of " + nexts.length);
                    error.result = results;
                    return onError(error);
                }
                results.forEach(function (result, index) {
                    if (nexts[index]) {
                        nexts[index].forEach(function (next) { return next(result); });
                    }
                });
            },
            error: onError,
            complete: function () {
                completes.forEach(function (complete) {
                    if (complete) {
                        complete.forEach(function (c) { return c(); });
                    }
                });
            },
        });
        return observables;
    };
    OperationBatcher.prototype.scheduleQueueConsumption = function (key) {
        var _this = this;
        var requestKey = key || '';
        setTimeout(function () {
            if (_this.queuedRequests.get(requestKey) &&
                _this.queuedRequests.get(requestKey).length) {
                _this.consumeQueue(requestKey);
            }
        }, this.batchInterval);
    };
    return OperationBatcher;
}());

var bundle_esm_BatchLink = (function (_super) {
    Object(tslib_es6["c" /* __extends */])(BatchLink, _super);
    function BatchLink(fetchParams) {
        var _this = _super.call(this) || this;
        var _a = fetchParams || {}, _b = _a.batchInterval, batchInterval = _b === void 0 ? 10 : _b, _c = _a.batchMax, batchMax = _c === void 0 ? 0 : _c, _d = _a.batchHandler, batchHandler = _d === void 0 ? function () { return null; } : _d, _e = _a.batchKey, batchKey = _e === void 0 ? function () { return ''; } : _e;
        _this.batcher = new bundle_esm_OperationBatcher({
            batchInterval: batchInterval,
            batchMax: batchMax,
            batchHandler: batchHandler,
            batchKey: batchKey,
        });
        if (fetchParams.batchHandler.length <= 1) {
            _this.request = function (operation) { return _this.batcher.enqueueRequest({ operation: operation }); };
        }
        return _this;
    }
    BatchLink.prototype.request = function (operation, forward) {
        return this.batcher.enqueueRequest({
            operation: operation,
            forward: forward,
        });
    };
    return BatchLink;
}(bundle_esm["ApolloLink"]));


//# sourceMappingURL=bundle.esm.js.map

// CONCATENATED MODULE: ./node_modules/apollo-link-batch-http/lib/bundle.esm.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BatchHttpLink", function() { return bundle_esm_BatchHttpLink; });





var bundle_esm_BatchHttpLink = (function (_super) {
    Object(tslib_es6["c" /* __extends */])(BatchHttpLink, _super);
    function BatchHttpLink(fetchParams) {
        var _this = _super.call(this) || this;
        var _a = fetchParams || {}, _b = _a.uri, uri = _b === void 0 ? '/graphql' : _b, fetcher = _a.fetch, includeExtensions = _a.includeExtensions, batchInterval = _a.batchInterval, batchMax = _a.batchMax, batchKey = _a.batchKey, requestOptions = Object(tslib_es6["e" /* __rest */])(_a, ["uri", "fetch", "includeExtensions", "batchInterval", "batchMax", "batchKey"]);
        checkFetcher(fetcher);
        if (!fetcher) {
            fetcher = fetch;
        }
        var linkConfig = {
            http: { includeExtensions: includeExtensions },
            options: requestOptions.fetchOptions,
            credentials: requestOptions.credentials,
            headers: requestOptions.headers,
        };
        _this.batchInterval = batchInterval || 10;
        _this.batchMax = batchMax || 10;
        var batchHandler = function (operations) {
            var chosenURI = selectURI(operations[0], uri);
            var context = operations[0].getContext();
            var clientAwarenessHeaders = {};
            if (context.clientAwareness) {
                var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
                if (name_1) {
                    clientAwarenessHeaders['apollographql-client-name'] = name_1;
                }
                if (version) {
                    clientAwarenessHeaders['apollographql-client-version'] = version;
                }
            }
            var contextConfig = {
                http: context.http,
                options: context.fetchOptions,
                credentials: context.credentials,
                headers: Object(tslib_es6["a" /* __assign */])({}, clientAwarenessHeaders, context.headers),
            };
            var optsAndBody = operations.map(function (operation) {
                return selectHttpOptionsAndBody(operation, fallbackHttpConfig, linkConfig, contextConfig);
            });
            var loadedBody = optsAndBody.map(function (_a) {
                var body = _a.body;
                return body;
            });
            var options = optsAndBody[0].options;
            if (options.method === 'GET') {
                return Object(bundle_esm["fromError"])(new Error('apollo-link-batch-http does not support GET requests'));
            }
            try {
                options.body = serializeFetchParameter(loadedBody, 'Payload');
            }
            catch (parseError) {
                return Object(bundle_esm["fromError"])(parseError);
            }
            var controller;
            if (!options.signal) {
                var _b = createSignalIfSupported(), _controller = _b.controller, signal = _b.signal;
                controller = _controller;
                if (controller)
                    options.signal = signal;
            }
            return new lib_bundle_esm["a" /* default */](function (observer) {
                fetcher(chosenURI, options)
                    .then(function (response) {
                    operations.forEach(function (operation) { return operation.setContext({ response: response }); });
                    return response;
                })
                    .then(parseAndCheckHttpResponse(operations))
                    .then(function (result) {
                    observer.next(result);
                    observer.complete();
                    return result;
                })
                    .catch(function (err) {
                    if (err.name === 'AbortError')
                        return;
                    if (err.result && err.result.errors && err.result.data) {
                        observer.next(err.result);
                    }
                    observer.error(err);
                });
                return function () {
                    if (controller)
                        controller.abort();
                };
            });
        };
        batchKey =
            batchKey ||
                (function (operation) {
                    var context = operation.getContext();
                    var contextConfig = {
                        http: context.http,
                        options: context.fetchOptions,
                        credentials: context.credentials,
                        headers: context.headers,
                    };
                    return selectURI(operation, uri) + JSON.stringify(contextConfig);
                });
        _this.batcher = new bundle_esm_BatchLink({
            batchInterval: _this.batchInterval,
            batchMax: _this.batchMax,
            batchKey: batchKey,
            batchHandler: batchHandler,
        });
        return _this;
    }
    BatchHttpLink.prototype.request = function (operation) {
        return this.batcher.request(operation);
    };
    return BatchHttpLink;
}(bundle_esm["ApolloLink"]));


//# sourceMappingURL=bundle.esm.js.map


/***/ })
/******/ ]);
});
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lifesize/nucleus/dist/index.js
// module id = 12
// module chunks = 0